//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IArhivskaKnjigaClient {
    getSkladisneJediniceList(): Observable<ResultOfGetSkladisneJediniceResponse>;
    createSkladisnaJedinica(command: CreateSkladisnaJedinicaCommand): Observable<ResultOfSkladisnaJedinicaDto>;
    unlockArhivskeEdit(command: UnlockArhivskaEditCommand): Observable<ResultOfArhivskaTableResponse>;
    createKategorijaDokumentarnogMaterijala(command: CreateKategorijaMaterijalaCommand): Observable<ResultOfString>;
    updateKategorijaDokumentarnogMaterijala(command: UpdateKategorijaMaterijalaCommand): Observable<ResultOfString>;
    deleteKategorijaDokumentarnogMaterijala(id: number): Observable<ResultOfString>;
    getSkladisnaJedinica(id: number): Observable<ResultOfSkladisnaJedinicaDto>;
    update(command: UpdateSkladisnaJedinicaCommand): Observable<ResultOfSkladisnaJedinicaDto>;
    getForTree(): Observable<ResultOfFizickeLokacijeTreeVm>;
    getById(id: number): Observable<ResultOfFizickaLokacijaDto>;
    create(command: CreateFizickaLokacijaCommand): Observable<ResultOfString>;
    getForSearch(request: GetFizickaLokacijaAutocompleteQuery): Observable<ResultOfFizickaLokacijaSeachResponse>;
    updateLokacija(command: UpdateFizickaLokacijaCommand): Observable<ResultOfString>;
    delete(id: number): Observable<ResultOfString>;
    seedKategorijeDokumenata(): Observable<ResultOfString>;
    importKategorijeSablon(grupaKategorijeId?: number | undefined, file?: FileParameter | null | undefined): Observable<ResultOfString>;
    setArhivskaKnjigaExists(arhivskaExisted?: boolean | undefined, kategorijeAutomatskiCreated?: boolean | undefined): Observable<ResultOfString>;
    getArhivskaKnjigaExists(): Observable<ResultOfArhivskaExistsResponse>;
    getArhivskaZipedFiles(request: GetZipedDocumentsQuery): Observable<FileResponse>;
    getDopisArhivske(vrstaDopisa?: ArhivskaKnjigaDopisVrsta | undefined): Observable<FileResponse>;
    getArhivskaDokumentaForm(): Observable<ResultOfArhivskaDokumentaFormDto>;
    getArhivskaPodesavanja(): Observable<ResultOfArhivskaPodesavanjaResponse>;
    getOpstaPravilaArhivska(): Observable<ResultOfOpstaPravilaArhivskaDto>;
    getPodesavanjaArhivskeDokumentacija(): Observable<ResultOfPodesavanjaArhivskeDokumentacijeDto>;
    updateArhivskaPodesavanja(command: UpdateArhivskaPodesavanjaCommand): Observable<ResultOfString>;
    updateOpstaPravilaArhivska(command: UpdateOpstaPravilaArhivskaCommand): Observable<ResultOfOpstaPravilaArhivskaDto>;
    updatePodesavanjaArhivskeDokumentacije(command: UpdatePodesavanjaArhivskeDokumentacijeCommand): Observable<ResultOfPodesavanjaArhivskeDokumentacijeDto>;
    getGodinaNastankaDropdown(): Observable<ResultOfIEnumerableOfString>;
    getGrupeKategorijeDropdown(): Observable<ResultOfGrupeKategorijaDropdownResponse>;
    getKategorijeDropdown(request: GetKategorijeDropdownQuery): Observable<ResultOfKategorijeDropdownResponse>;
    getSkladisneJediniceDropdown(request: GetSkladisneJediniceDropdownQuery): Observable<ResultOfSkladisneJediniceDropdownResponse>;
    createArhivskaKnjiga(command: CreateArhivskaKnjigaCommand): Observable<ResultOfArhivskaKnjigaTableItemDto>;
    getArhivskaById(id?: number | undefined): Observable<ResultOfArhivskaKnjigaDto>;
    getArhivskaTable(req: GetArhivskaKnjigaTableQuery): Observable<PaginatedResultOfArhivskaKnjigaTableItemDto>;
    getKategorijeDokumentatnogMaterijala(request: GetKategorijeDokumentarnogMaterijalaQuery): Observable<PaginatedResultOfKategorijaTableDto>;
    updateArhivska(command: UpdateArhivskaCommand): Observable<ResultOfString>;
    getArhivskaPdf(request: GetArhivskaTablePdfQuery): Observable<FileResponse>;
    deleteArhivskaKnjiga(id: number): Observable<ResultOfString>;
    getMaxRedniBroj(): Observable<ResultOfInteger>;
}

@Injectable({
    providedIn: 'root'
})
export class ArhivskaKnjigaClient implements IArhivskaKnjigaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getSkladisneJediniceList(): Observable<ResultOfGetSkladisneJediniceResponse> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSkladisneJediniceList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSkladisneJediniceList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetSkladisneJediniceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetSkladisneJediniceResponse>;
        }));
    }

    protected processGetSkladisneJediniceList(response: HttpResponseBase): Observable<ResultOfGetSkladisneJediniceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetSkladisneJediniceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetSkladisneJediniceResponse>(null as any);
    }

    createSkladisnaJedinica(command: CreateSkladisnaJedinicaCommand): Observable<ResultOfSkladisnaJedinicaDto> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSkladisnaJedinica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSkladisnaJedinica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfSkladisnaJedinicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfSkladisnaJedinicaDto>;
        }));
    }

    protected processCreateSkladisnaJedinica(response: HttpResponseBase): Observable<ResultOfSkladisnaJedinicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfSkladisnaJedinicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfSkladisnaJedinicaDto>(null as any);
    }

    unlockArhivskeEdit(command: UnlockArhivskaEditCommand): Observable<ResultOfArhivskaTableResponse> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockArhivskeEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockArhivskeEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfArhivskaTableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfArhivskaTableResponse>;
        }));
    }

    protected processUnlockArhivskeEdit(response: HttpResponseBase): Observable<ResultOfArhivskaTableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfArhivskaTableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfArhivskaTableResponse>(null as any);
    }

    createKategorijaDokumentarnogMaterijala(command: CreateKategorijaMaterijalaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/kreiranje-kategorije-materijala";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateKategorijaDokumentarnogMaterijala(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateKategorijaDokumentarnogMaterijala(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreateKategorijaDokumentarnogMaterijala(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    updateKategorijaDokumentarnogMaterijala(command: UpdateKategorijaMaterijalaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/izmena-kategorije-materijala";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateKategorijaDokumentarnogMaterijala(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateKategorijaDokumentarnogMaterijala(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdateKategorijaDokumentarnogMaterijala(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    deleteKategorijaDokumentarnogMaterijala(id: number): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/brisanje-kategorije-materijala/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteKategorijaDokumentarnogMaterijala(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteKategorijaDokumentarnogMaterijala(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processDeleteKategorijaDokumentarnogMaterijala(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getSkladisnaJedinica(id: number): Observable<ResultOfSkladisnaJedinicaDto> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-skladisna-jedinica/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSkladisnaJedinica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSkladisnaJedinica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfSkladisnaJedinicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfSkladisnaJedinicaDto>;
        }));
    }

    protected processGetSkladisnaJedinica(response: HttpResponseBase): Observable<ResultOfSkladisnaJedinicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfSkladisnaJedinicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfSkladisnaJedinicaDto>(null as any);
    }

    update(command: UpdateSkladisnaJedinicaCommand): Observable<ResultOfSkladisnaJedinicaDto> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/id:long";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfSkladisnaJedinicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfSkladisnaJedinicaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultOfSkladisnaJedinicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfSkladisnaJedinicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfSkladisnaJedinicaDto>(null as any);
    }

    getForTree(): Observable<ResultOfFizickeLokacijeTreeVm> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-for-tree";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfFizickeLokacijeTreeVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfFizickeLokacijeTreeVm>;
        }));
    }

    protected processGetForTree(response: HttpResponseBase): Observable<ResultOfFizickeLokacijeTreeVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfFizickeLokacijeTreeVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfFizickeLokacijeTreeVm>(null as any);
    }

    getById(id: number): Observable<ResultOfFizickaLokacijaDto> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-by-id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfFizickaLokacijaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfFizickaLokacijaDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ResultOfFizickaLokacijaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfFizickaLokacijaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfFizickaLokacijaDto>(null as any);
    }

    create(command: CreateFizickaLokacijaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/post-fizicka-lokacija";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getForSearch(request: GetFizickaLokacijaAutocompleteQuery): Observable<ResultOfFizickaLokacijaSeachResponse> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-for-search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfFizickaLokacijaSeachResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfFizickaLokacijaSeachResponse>;
        }));
    }

    protected processGetForSearch(response: HttpResponseBase): Observable<ResultOfFizickaLokacijaSeachResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfFizickaLokacijaSeachResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfFizickaLokacijaSeachResponse>(null as any);
    }

    updateLokacija(command: UpdateFizickaLokacijaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/update-lokacija";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLokacija(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLokacija(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdateLokacija(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    delete(id: number): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/fizicka-lokacija-delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    seedKategorijeDokumenata(): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/seed-kategorije";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSeedKategorijeDokumenata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSeedKategorijeDokumenata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSeedKategorijeDokumenata(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    importKategorijeSablon(grupaKategorijeId?: number | undefined, file?: FileParameter | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/import-kategorije";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (grupaKategorijeId === null || grupaKategorijeId === undefined)
            throw new Error("The parameter 'grupaKategorijeId' cannot be null.");
        else
            content_.append("GrupaKategorijeId", grupaKategorijeId.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportKategorijeSablon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportKategorijeSablon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processImportKategorijeSablon(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    setArhivskaKnjigaExists(arhivskaExisted?: boolean | undefined, kategorijeAutomatskiCreated?: boolean | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/set-arhivska-exists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (arhivskaExisted === null || arhivskaExisted === undefined)
            throw new Error("The parameter 'arhivskaExisted' cannot be null.");
        else
            content_.append("ArhivskaExisted", arhivskaExisted.toString());
        if (kategorijeAutomatskiCreated === null || kategorijeAutomatskiCreated === undefined)
            throw new Error("The parameter 'kategorijeAutomatskiCreated' cannot be null.");
        else
            content_.append("KategorijeAutomatskiCreated", kategorijeAutomatskiCreated.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetArhivskaKnjigaExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetArhivskaKnjigaExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSetArhivskaKnjigaExists(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getArhivskaKnjigaExists(): Observable<ResultOfArhivskaExistsResponse> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-arhivska-exists";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArhivskaKnjigaExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArhivskaKnjigaExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfArhivskaExistsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfArhivskaExistsResponse>;
        }));
    }

    protected processGetArhivskaKnjigaExists(response: HttpResponseBase): Observable<ResultOfArhivskaExistsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfArhivskaExistsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfArhivskaExistsResponse>(null as any);
    }

    getArhivskaZipedFiles(request: GetZipedDocumentsQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-dokumenti-ziped";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArhivskaZipedFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArhivskaZipedFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetArhivskaZipedFiles(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getDopisArhivske(vrstaDopisa?: ArhivskaKnjigaDopisVrsta | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-dopis-arhivske?";
        if (vrstaDopisa === null)
            throw new Error("The parameter 'vrstaDopisa' cannot be null.");
        else if (vrstaDopisa !== undefined)
            url_ += "vrstaDopisa=" + encodeURIComponent("" + vrstaDopisa) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDopisArhivske(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDopisArhivske(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetDopisArhivske(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getArhivskaDokumentaForm(): Observable<ResultOfArhivskaDokumentaFormDto> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-arhivska-dokumenta-form";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArhivskaDokumentaForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArhivskaDokumentaForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfArhivskaDokumentaFormDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfArhivskaDokumentaFormDto>;
        }));
    }

    protected processGetArhivskaDokumentaForm(response: HttpResponseBase): Observable<ResultOfArhivskaDokumentaFormDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfArhivskaDokumentaFormDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfArhivskaDokumentaFormDto>(null as any);
    }

    getArhivskaPodesavanja(): Observable<ResultOfArhivskaPodesavanjaResponse> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-arhivska-podesavanja";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArhivskaPodesavanja(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArhivskaPodesavanja(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfArhivskaPodesavanjaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfArhivskaPodesavanjaResponse>;
        }));
    }

    protected processGetArhivskaPodesavanja(response: HttpResponseBase): Observable<ResultOfArhivskaPodesavanjaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfArhivskaPodesavanjaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfArhivskaPodesavanjaResponse>(null as any);
    }

    getOpstaPravilaArhivska(): Observable<ResultOfOpstaPravilaArhivskaDto> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-opsta-pravila-arhivska";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOpstaPravilaArhivska(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOpstaPravilaArhivska(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfOpstaPravilaArhivskaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfOpstaPravilaArhivskaDto>;
        }));
    }

    protected processGetOpstaPravilaArhivska(response: HttpResponseBase): Observable<ResultOfOpstaPravilaArhivskaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfOpstaPravilaArhivskaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfOpstaPravilaArhivskaDto>(null as any);
    }

    getPodesavanjaArhivskeDokumentacija(): Observable<ResultOfPodesavanjaArhivskeDokumentacijeDto> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-dokumentacija-podesavanja";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPodesavanjaArhivskeDokumentacija(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPodesavanjaArhivskeDokumentacija(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfPodesavanjaArhivskeDokumentacijeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfPodesavanjaArhivskeDokumentacijeDto>;
        }));
    }

    protected processGetPodesavanjaArhivskeDokumentacija(response: HttpResponseBase): Observable<ResultOfPodesavanjaArhivskeDokumentacijeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfPodesavanjaArhivskeDokumentacijeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfPodesavanjaArhivskeDokumentacijeDto>(null as any);
    }

    updateArhivskaPodesavanja(command: UpdateArhivskaPodesavanjaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/update-arhivska-podesavanja";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateArhivskaPodesavanja(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateArhivskaPodesavanja(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdateArhivskaPodesavanja(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    updateOpstaPravilaArhivska(command: UpdateOpstaPravilaArhivskaCommand): Observable<ResultOfOpstaPravilaArhivskaDto> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/update-opsta-pravila-arhivska";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOpstaPravilaArhivska(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOpstaPravilaArhivska(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfOpstaPravilaArhivskaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfOpstaPravilaArhivskaDto>;
        }));
    }

    protected processUpdateOpstaPravilaArhivska(response: HttpResponseBase): Observable<ResultOfOpstaPravilaArhivskaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfOpstaPravilaArhivskaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfOpstaPravilaArhivskaDto>(null as any);
    }

    updatePodesavanjaArhivskeDokumentacije(command: UpdatePodesavanjaArhivskeDokumentacijeCommand): Observable<ResultOfPodesavanjaArhivskeDokumentacijeDto> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/update-podesavanja-arhivske-dokumentacije";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePodesavanjaArhivskeDokumentacije(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePodesavanjaArhivskeDokumentacije(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfPodesavanjaArhivskeDokumentacijeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfPodesavanjaArhivskeDokumentacijeDto>;
        }));
    }

    protected processUpdatePodesavanjaArhivskeDokumentacije(response: HttpResponseBase): Observable<ResultOfPodesavanjaArhivskeDokumentacijeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfPodesavanjaArhivskeDokumentacijeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfPodesavanjaArhivskeDokumentacijeDto>(null as any);
    }

    getGodinaNastankaDropdown(): Observable<ResultOfIEnumerableOfString> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-godina-nastanka-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGodinaNastankaDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGodinaNastankaDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIEnumerableOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIEnumerableOfString>;
        }));
    }

    protected processGetGodinaNastankaDropdown(response: HttpResponseBase): Observable<ResultOfIEnumerableOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIEnumerableOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIEnumerableOfString>(null as any);
    }

    getGrupeKategorijeDropdown(): Observable<ResultOfGrupeKategorijaDropdownResponse> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-grupa-kategorije-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGrupeKategorijeDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGrupeKategorijeDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGrupeKategorijaDropdownResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGrupeKategorijaDropdownResponse>;
        }));
    }

    protected processGetGrupeKategorijeDropdown(response: HttpResponseBase): Observable<ResultOfGrupeKategorijaDropdownResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGrupeKategorijaDropdownResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGrupeKategorijaDropdownResponse>(null as any);
    }

    getKategorijeDropdown(request: GetKategorijeDropdownQuery): Observable<ResultOfKategorijeDropdownResponse> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-kategorije-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKategorijeDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKategorijeDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfKategorijeDropdownResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfKategorijeDropdownResponse>;
        }));
    }

    protected processGetKategorijeDropdown(response: HttpResponseBase): Observable<ResultOfKategorijeDropdownResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfKategorijeDropdownResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfKategorijeDropdownResponse>(null as any);
    }

    getSkladisneJediniceDropdown(request: GetSkladisneJediniceDropdownQuery): Observable<ResultOfSkladisneJediniceDropdownResponse> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-skladisne-jedinice-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSkladisneJediniceDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSkladisneJediniceDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfSkladisneJediniceDropdownResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfSkladisneJediniceDropdownResponse>;
        }));
    }

    protected processGetSkladisneJediniceDropdown(response: HttpResponseBase): Observable<ResultOfSkladisneJediniceDropdownResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfSkladisneJediniceDropdownResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfSkladisneJediniceDropdownResponse>(null as any);
    }

    createArhivskaKnjiga(command: CreateArhivskaKnjigaCommand): Observable<ResultOfArhivskaKnjigaTableItemDto> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/create-arhivska-knjiga";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateArhivskaKnjiga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateArhivskaKnjiga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfArhivskaKnjigaTableItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfArhivskaKnjigaTableItemDto>;
        }));
    }

    protected processCreateArhivskaKnjiga(response: HttpResponseBase): Observable<ResultOfArhivskaKnjigaTableItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfArhivskaKnjigaTableItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfArhivskaKnjigaTableItemDto>(null as any);
    }

    getArhivskaById(id?: number | undefined): Observable<ResultOfArhivskaKnjigaDto> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-arhivska-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArhivskaById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArhivskaById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfArhivskaKnjigaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfArhivskaKnjigaDto>;
        }));
    }

    protected processGetArhivskaById(response: HttpResponseBase): Observable<ResultOfArhivskaKnjigaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfArhivskaKnjigaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfArhivskaKnjigaDto>(null as any);
    }

    getArhivskaTable(req: GetArhivskaKnjigaTableQuery): Observable<PaginatedResultOfArhivskaKnjigaTableItemDto> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-arhivska-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArhivskaTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArhivskaTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfArhivskaKnjigaTableItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfArhivskaKnjigaTableItemDto>;
        }));
    }

    protected processGetArhivskaTable(response: HttpResponseBase): Observable<PaginatedResultOfArhivskaKnjigaTableItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfArhivskaKnjigaTableItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfArhivskaKnjigaTableItemDto>(null as any);
    }

    getKategorijeDokumentatnogMaterijala(request: GetKategorijeDokumentarnogMaterijalaQuery): Observable<PaginatedResultOfKategorijaTableDto> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-kategorije-materijala";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKategorijeDokumentatnogMaterijala(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKategorijeDokumentatnogMaterijala(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfKategorijaTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfKategorijaTableDto>;
        }));
    }

    protected processGetKategorijeDokumentatnogMaterijala(response: HttpResponseBase): Observable<PaginatedResultOfKategorijaTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfKategorijaTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfKategorijaTableDto>(null as any);
    }

    updateArhivska(command: UpdateArhivskaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/update-arhivska";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateArhivska(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateArhivska(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdateArhivska(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getArhivskaPdf(request: GetArhivskaTablePdfQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-arhivska-pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArhivskaPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArhivskaPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetArhivskaPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    deleteArhivskaKnjiga(id: number): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/delete-arhivsku-knjigu/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteArhivskaKnjiga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteArhivskaKnjiga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processDeleteArhivskaKnjiga(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getMaxRedniBroj(): Observable<ResultOfInteger> {
        let url_ = this.baseUrl + "/api/arhivskaknjiga/get-max-redni-broj";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaxRedniBroj(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaxRedniBroj(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfInteger>;
        }));
    }

    protected processGetMaxRedniBroj(response: HttpResponseBase): Observable<ResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfInteger>(null as any);
    }
}

export interface IAvansniRacuniClient {
    create(command: CreateAvansniRacunCommand): Observable<ResultOfCreateUpdateRacunResponse>;
    update(id: number, command: UpdateAvansniRacunCommand): Observable<ResultOfString>;
    get(request: GetAvansniRacunQuery): Observable<ResultOfAvansniRacunDto>;
    getNewForStranka(strankaId: string): Observable<ResultOfAvansniRacunDto>;
    getNewForTransakcijuIzvoda(request: GetNewAvansniRacunForTransakcijuIzvodaQuery): Observable<ResultOfAvansniRacunDto>;
    getNewForStopaPdv(request: GetNewAvansniForStopaPdvQuery): Observable<ResultOfAvansniRacunDto>;
    getAvansneUplateRacuna(request: GetAvansnaUplataRacunaTableQuery): Observable<ResultOfGetTableResponseOfAvansnaUplataRacunaTableDto>;
    getList(request: GetAvansniRacunTableQuery): Observable<ResultOfGetTableResponseOfAvansniRacunTableDto>;
    getEvidentiraneUplateRacuna(racunId?: number | undefined): Observable<ResultOfGetTableResponseOfAvansniRacunTableDto>;
    getAvansniForOtpremnica(predracunId: number): Observable<ResultOfAvansniRacunDto>;
    getAvansniForPredracunUplata(request: GetNewAvansniFromPredracunUplataQuery): Observable<ResultOfAvansniRacunDto>;
    getStrankaHasAvansniRacun(strankaId: number, vrstaRacuna: VrstaRacuna): Observable<ResultOfBoolean>;
}

@Injectable({
    providedIn: 'root'
})
export class AvansniRacuniClient implements IAvansniRacuniClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    create(command: CreateAvansniRacunCommand): Observable<ResultOfCreateUpdateRacunResponse> {
        let url_ = this.baseUrl + "/api/avansniracuni";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCreateUpdateRacunResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCreateUpdateRacunResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfCreateUpdateRacunResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCreateUpdateRacunResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCreateUpdateRacunResponse>(null as any);
    }

    update(id: number, command: UpdateAvansniRacunCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/avansniracuni/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    get(request: GetAvansniRacunQuery): Observable<ResultOfAvansniRacunDto> {
        let url_ = this.baseUrl + "/api/avansniracuni/get-avansni-racun";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfAvansniRacunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfAvansniRacunDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResultOfAvansniRacunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfAvansniRacunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfAvansniRacunDto>(null as any);
    }

    getNewForStranka(strankaId: string): Observable<ResultOfAvansniRacunDto> {
        let url_ = this.baseUrl + "/api/avansniracuni/new-for-stranka/{strankaId}";
        if (strankaId === undefined || strankaId === null)
            throw new Error("The parameter 'strankaId' must be defined.");
        url_ = url_.replace("{strankaId}", encodeURIComponent("" + strankaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewForStranka(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewForStranka(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfAvansniRacunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfAvansniRacunDto>;
        }));
    }

    protected processGetNewForStranka(response: HttpResponseBase): Observable<ResultOfAvansniRacunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfAvansniRacunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfAvansniRacunDto>(null as any);
    }

    getNewForTransakcijuIzvoda(request: GetNewAvansniRacunForTransakcijuIzvodaQuery): Observable<ResultOfAvansniRacunDto> {
        let url_ = this.baseUrl + "/api/avansniracuni/new-for-transakciju-izvoda";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewForTransakcijuIzvoda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewForTransakcijuIzvoda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfAvansniRacunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfAvansniRacunDto>;
        }));
    }

    protected processGetNewForTransakcijuIzvoda(response: HttpResponseBase): Observable<ResultOfAvansniRacunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfAvansniRacunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfAvansniRacunDto>(null as any);
    }

    getNewForStopaPdv(request: GetNewAvansniForStopaPdvQuery): Observable<ResultOfAvansniRacunDto> {
        let url_ = this.baseUrl + "/api/avansniracuni/new-for-stopa-pdv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewForStopaPdv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewForStopaPdv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfAvansniRacunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfAvansniRacunDto>;
        }));
    }

    protected processGetNewForStopaPdv(response: HttpResponseBase): Observable<ResultOfAvansniRacunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfAvansniRacunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfAvansniRacunDto>(null as any);
    }

    getAvansneUplateRacuna(request: GetAvansnaUplataRacunaTableQuery): Observable<ResultOfGetTableResponseOfAvansnaUplataRacunaTableDto> {
        let url_ = this.baseUrl + "/api/avansniracuni/get-avansne-uplate-racuna";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvansneUplateRacuna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvansneUplateRacuna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTableResponseOfAvansnaUplataRacunaTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTableResponseOfAvansnaUplataRacunaTableDto>;
        }));
    }

    protected processGetAvansneUplateRacuna(response: HttpResponseBase): Observable<ResultOfGetTableResponseOfAvansnaUplataRacunaTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTableResponseOfAvansnaUplataRacunaTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTableResponseOfAvansnaUplataRacunaTableDto>(null as any);
    }

    getList(request: GetAvansniRacunTableQuery): Observable<ResultOfGetTableResponseOfAvansniRacunTableDto> {
        let url_ = this.baseUrl + "/api/avansniracuni/get-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTableResponseOfAvansniRacunTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTableResponseOfAvansniRacunTableDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ResultOfGetTableResponseOfAvansniRacunTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTableResponseOfAvansniRacunTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTableResponseOfAvansniRacunTableDto>(null as any);
    }

    getEvidentiraneUplateRacuna(racunId?: number | undefined): Observable<ResultOfGetTableResponseOfAvansniRacunTableDto> {
        let url_ = this.baseUrl + "/api/avansniracuni/get-evidentirane-uplate-racuna?";
        if (racunId === null)
            throw new Error("The parameter 'racunId' cannot be null.");
        else if (racunId !== undefined)
            url_ += "racunId=" + encodeURIComponent("" + racunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvidentiraneUplateRacuna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvidentiraneUplateRacuna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTableResponseOfAvansniRacunTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTableResponseOfAvansniRacunTableDto>;
        }));
    }

    protected processGetEvidentiraneUplateRacuna(response: HttpResponseBase): Observable<ResultOfGetTableResponseOfAvansniRacunTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTableResponseOfAvansniRacunTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTableResponseOfAvansniRacunTableDto>(null as any);
    }

    getAvansniForOtpremnica(predracunId: number): Observable<ResultOfAvansniRacunDto> {
        let url_ = this.baseUrl + "/api/avansniracuni/new-for-predracun/{predracunId}";
        if (predracunId === undefined || predracunId === null)
            throw new Error("The parameter 'predracunId' must be defined.");
        url_ = url_.replace("{predracunId}", encodeURIComponent("" + predracunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvansniForOtpremnica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvansniForOtpremnica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfAvansniRacunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfAvansniRacunDto>;
        }));
    }

    protected processGetAvansniForOtpremnica(response: HttpResponseBase): Observable<ResultOfAvansniRacunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfAvansniRacunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfAvansniRacunDto>(null as any);
    }

    getAvansniForPredracunUplata(request: GetNewAvansniFromPredracunUplataQuery): Observable<ResultOfAvansniRacunDto> {
        let url_ = this.baseUrl + "/api/avansniracuni/new-for-predracun-uplata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvansniForPredracunUplata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvansniForPredracunUplata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfAvansniRacunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfAvansniRacunDto>;
        }));
    }

    protected processGetAvansniForPredracunUplata(response: HttpResponseBase): Observable<ResultOfAvansniRacunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfAvansniRacunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfAvansniRacunDto>(null as any);
    }

    getStrankaHasAvansniRacun(strankaId: number, vrstaRacuna: VrstaRacuna): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/avansniracuni/get-stranka-has-avansni-racun/{strankaId}/{vrstaRacuna}";
        if (strankaId === undefined || strankaId === null)
            throw new Error("The parameter 'strankaId' must be defined.");
        url_ = url_.replace("{strankaId}", encodeURIComponent("" + strankaId));
        if (vrstaRacuna === undefined || vrstaRacuna === null)
            throw new Error("The parameter 'vrstaRacuna' must be defined.");
        url_ = url_.replace("{vrstaRacuna}", encodeURIComponent("" + vrstaRacuna));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStrankaHasAvansniRacun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStrankaHasAvansniRacun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfBoolean>;
        }));
    }

    protected processGetStrankaHasAvansniRacun(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(null as any);
    }
}

export interface ICenovniciClient {
    getForTable(request: GetCenovniciTableQuery): Observable<ResultOfCenovniciTableVm>;
    getAktivni(): Observable<ResultOfListOfCenovnikTableDto>;
    getForList(strankaId?: number | undefined): Observable<ResultOfListOfCenovnikListDto>;
    getStavkeCenovnika(cenovnikId?: number | null | undefined): Observable<ResultOfCenovnikStavkeTableVm>;
    getById(id: number): Observable<ResultOfCenovnikDto>;
    getCenovnikStavke(request: GetCenovnikStavkeQuery): Observable<ResultOfGetCenovnikStavkeVm>;
    create(command: CreateCenovnikCommand): Observable<ResultOfCenovnikCreateUpdateResponse>;
    update(id: number, command: UpdateCenovnikCommand): Observable<ResultOfCenovnikCreateUpdateResponse>;
    delete(id: number): Observable<ResultOfString>;
    archive(id: number): Observable<ResultOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class CenovniciClient implements ICenovniciClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(request: GetCenovniciTableQuery): Observable<ResultOfCenovniciTableVm> {
        let url_ = this.baseUrl + "/api/cenovnici/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCenovniciTableVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCenovniciTableVm>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<ResultOfCenovniciTableVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCenovniciTableVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCenovniciTableVm>(null as any);
    }

    getAktivni(): Observable<ResultOfListOfCenovnikTableDto> {
        let url_ = this.baseUrl + "/api/cenovnici/aktivni";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAktivni(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAktivni(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfCenovnikTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfCenovnikTableDto>;
        }));
    }

    protected processGetAktivni(response: HttpResponseBase): Observable<ResultOfListOfCenovnikTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfCenovnikTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfCenovnikTableDto>(null as any);
    }

    getForList(strankaId?: number | undefined): Observable<ResultOfListOfCenovnikListDto> {
        let url_ = this.baseUrl + "/api/cenovnici/get-for-list?";
        if (strankaId === null)
            throw new Error("The parameter 'strankaId' cannot be null.");
        else if (strankaId !== undefined)
            url_ += "strankaId=" + encodeURIComponent("" + strankaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfCenovnikListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfCenovnikListDto>;
        }));
    }

    protected processGetForList(response: HttpResponseBase): Observable<ResultOfListOfCenovnikListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfCenovnikListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfCenovnikListDto>(null as any);
    }

    getStavkeCenovnika(cenovnikId?: number | null | undefined): Observable<ResultOfCenovnikStavkeTableVm> {
        let url_ = this.baseUrl + "/api/cenovnici/get-stavke-cenovnika?";
        if (cenovnikId !== undefined && cenovnikId !== null)
            url_ += "cenovnikId=" + encodeURIComponent("" + cenovnikId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStavkeCenovnika(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStavkeCenovnika(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCenovnikStavkeTableVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCenovnikStavkeTableVm>;
        }));
    }

    protected processGetStavkeCenovnika(response: HttpResponseBase): Observable<ResultOfCenovnikStavkeTableVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCenovnikStavkeTableVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCenovnikStavkeTableVm>(null as any);
    }

    getById(id: number): Observable<ResultOfCenovnikDto> {
        let url_ = this.baseUrl + "/api/cenovnici/by-id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCenovnikDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCenovnikDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ResultOfCenovnikDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCenovnikDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCenovnikDto>(null as any);
    }

    getCenovnikStavke(request: GetCenovnikStavkeQuery): Observable<ResultOfGetCenovnikStavkeVm> {
        let url_ = this.baseUrl + "/api/cenovnici/get-cenovnik-stavke";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCenovnikStavke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCenovnikStavke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetCenovnikStavkeVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetCenovnikStavkeVm>;
        }));
    }

    protected processGetCenovnikStavke(response: HttpResponseBase): Observable<ResultOfGetCenovnikStavkeVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetCenovnikStavkeVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetCenovnikStavkeVm>(null as any);
    }

    create(command: CreateCenovnikCommand): Observable<ResultOfCenovnikCreateUpdateResponse> {
        let url_ = this.baseUrl + "/api/cenovnici";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCenovnikCreateUpdateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCenovnikCreateUpdateResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfCenovnikCreateUpdateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCenovnikCreateUpdateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCenovnikCreateUpdateResponse>(null as any);
    }

    update(id: number, command: UpdateCenovnikCommand): Observable<ResultOfCenovnikCreateUpdateResponse> {
        let url_ = this.baseUrl + "/api/cenovnici/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCenovnikCreateUpdateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCenovnikCreateUpdateResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultOfCenovnikCreateUpdateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCenovnikCreateUpdateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCenovnikCreateUpdateResponse>(null as any);
    }

    delete(id: number): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/cenovnici/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    archive(id: number): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/cenovnici/archive/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processArchive(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }
}

export interface IDashboardClient {
    getPrometCards(): Observable<ResultOfGetDashboardPrometCardsResponse>;
    getPrometChart(): Observable<ResultOfGetPrometChartResponse>;
    getTopNStrankiDonut(vrstaStranke?: VrstaStranke | undefined, n?: number | undefined): Observable<ResultOfListOfGetTopNStrankiDonutResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class DashboardClient implements IDashboardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getPrometCards(): Observable<ResultOfGetDashboardPrometCardsResponse> {
        let url_ = this.baseUrl + "/api/dashboard/get-promet-cards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrometCards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrometCards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetDashboardPrometCardsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetDashboardPrometCardsResponse>;
        }));
    }

    protected processGetPrometCards(response: HttpResponseBase): Observable<ResultOfGetDashboardPrometCardsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetDashboardPrometCardsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetDashboardPrometCardsResponse>(null as any);
    }

    getPrometChart(): Observable<ResultOfGetPrometChartResponse> {
        let url_ = this.baseUrl + "/api/dashboard/get-promet-chart";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrometChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrometChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetPrometChartResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetPrometChartResponse>;
        }));
    }

    protected processGetPrometChart(response: HttpResponseBase): Observable<ResultOfGetPrometChartResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetPrometChartResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPrometChartResponse>(null as any);
    }

    getTopNStrankiDonut(vrstaStranke?: VrstaStranke | undefined, n?: number | undefined): Observable<ResultOfListOfGetTopNStrankiDonutResponse> {
        let url_ = this.baseUrl + "/api/dashboard/get-top-n-stranki?";
        if (vrstaStranke === null)
            throw new Error("The parameter 'vrstaStranke' cannot be null.");
        else if (vrstaStranke !== undefined)
            url_ += "vrstaStranke=" + encodeURIComponent("" + vrstaStranke) + "&";
        if (n === null)
            throw new Error("The parameter 'n' cannot be null.");
        else if (n !== undefined)
            url_ += "n=" + encodeURIComponent("" + n) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopNStrankiDonut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopNStrankiDonut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfGetTopNStrankiDonutResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfGetTopNStrankiDonutResponse>;
        }));
    }

    protected processGetTopNStrankiDonut(response: HttpResponseBase): Observable<ResultOfListOfGetTopNStrankiDonutResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfGetTopNStrankiDonutResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfGetTopNStrankiDonutResponse>(null as any);
    }
}

export interface IDelovodniciClient {
    createPravilo(command: CreatePraviloZaDelovodniDokumentCommand): Observable<ResultOfString>;
    updatePravilo(command: UpdatePraviloZaDelovodnikDokumentCommand): Observable<ResultOfString>;
    getPravilaZaBrojeve(): Observable<ResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaTableDto>;
    getPraviloZaBroj(id: number): Observable<ResultOfKonfiguracijaBrojaDelovodnogDokumentaDto>;
    getPravilaDropdown(): Observable<ResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaDto>;
    createDelovodnik(command: CreateDelovodnikCommand): Observable<ResultOfString>;
    getDelovodnikTable(request: GetDelovodnikTableQuery): Observable<PaginatedResultOfDelovodnikTableDto>;
    updateDelovodnik(command: UpdateDelovodnikCommand): Observable<ResultOfString>;
    getDelovodnik(id: number): Observable<ResultOfDelovodnikDto>;
    getDelovodnikInfo(id: number): Observable<ResultOfDelovodnikInfoDto>;
    getDelovodniDokument(id: number): Observable<ResultOfDelovodniDokumentDto>;
    getDelovodniDokumentTable(request: GetDelovodniDokumentTableQuery): Observable<PaginatedResultOfDelovodniDokumentTableDto>;
    createDelovodniDokument(command: CreateDelovodniDokumentCommand): Observable<ResultOfString>;
    deleteDelovodniDokumentFile(command: DeleteDelovodniDokumentFileCommand): Observable<ResultOfString>;
    updateDelovodniDokument(command: UpdateDelovodniDokumentCommand): Observable<ResultOfString>;
    getPresignedUrl(request: GetDelovodnikPresignedUrlQuery): Observable<ResultOfDelovodnikPresignedUrlResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class DelovodniciClient implements IDelovodniciClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createPravilo(command: CreatePraviloZaDelovodniDokumentCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/delovodnici/create-pravilo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePravilo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePravilo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreatePravilo(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    updatePravilo(command: UpdatePraviloZaDelovodnikDokumentCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/delovodnici/update-pravilo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePravilo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePravilo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdatePravilo(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getPravilaZaBrojeve(): Observable<ResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaTableDto> {
        let url_ = this.baseUrl + "/api/delovodnici/get-pravila";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPravilaZaBrojeve(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPravilaZaBrojeve(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaTableDto>;
        }));
    }

    protected processGetPravilaZaBrojeve(response: HttpResponseBase): Observable<ResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaTableDto>(null as any);
    }

    getPraviloZaBroj(id: number): Observable<ResultOfKonfiguracijaBrojaDelovodnogDokumentaDto> {
        let url_ = this.baseUrl + "/api/delovodnici/get-pravilo/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPraviloZaBroj(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPraviloZaBroj(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfKonfiguracijaBrojaDelovodnogDokumentaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfKonfiguracijaBrojaDelovodnogDokumentaDto>;
        }));
    }

    protected processGetPraviloZaBroj(response: HttpResponseBase): Observable<ResultOfKonfiguracijaBrojaDelovodnogDokumentaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfKonfiguracijaBrojaDelovodnogDokumentaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfKonfiguracijaBrojaDelovodnogDokumentaDto>(null as any);
    }

    getPravilaDropdown(): Observable<ResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaDto> {
        let url_ = this.baseUrl + "/api/delovodnici/get-pravila-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPravilaDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPravilaDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaDto>;
        }));
    }

    protected processGetPravilaDropdown(response: HttpResponseBase): Observable<ResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaDto>(null as any);
    }

    createDelovodnik(command: CreateDelovodnikCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/delovodnici/create-delovodnik";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDelovodnik(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDelovodnik(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreateDelovodnik(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getDelovodnikTable(request: GetDelovodnikTableQuery): Observable<PaginatedResultOfDelovodnikTableDto> {
        let url_ = this.baseUrl + "/api/delovodnici/get-delovodnik-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelovodnikTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelovodnikTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfDelovodnikTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfDelovodnikTableDto>;
        }));
    }

    protected processGetDelovodnikTable(response: HttpResponseBase): Observable<PaginatedResultOfDelovodnikTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfDelovodnikTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfDelovodnikTableDto>(null as any);
    }

    updateDelovodnik(command: UpdateDelovodnikCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/delovodnici/update-delovodnik";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDelovodnik(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDelovodnik(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdateDelovodnik(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getDelovodnik(id: number): Observable<ResultOfDelovodnikDto> {
        let url_ = this.baseUrl + "/api/delovodnici/get-delovodnik/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelovodnik(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelovodnik(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfDelovodnikDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfDelovodnikDto>;
        }));
    }

    protected processGetDelovodnik(response: HttpResponseBase): Observable<ResultOfDelovodnikDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfDelovodnikDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfDelovodnikDto>(null as any);
    }

    getDelovodnikInfo(id: number): Observable<ResultOfDelovodnikInfoDto> {
        let url_ = this.baseUrl + "/api/delovodnici/get-delovodnik-info/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelovodnikInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelovodnikInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfDelovodnikInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfDelovodnikInfoDto>;
        }));
    }

    protected processGetDelovodnikInfo(response: HttpResponseBase): Observable<ResultOfDelovodnikInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfDelovodnikInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfDelovodnikInfoDto>(null as any);
    }

    getDelovodniDokument(id: number): Observable<ResultOfDelovodniDokumentDto> {
        let url_ = this.baseUrl + "/api/delovodnici/get-delovodni-dokument/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelovodniDokument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelovodniDokument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfDelovodniDokumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfDelovodniDokumentDto>;
        }));
    }

    protected processGetDelovodniDokument(response: HttpResponseBase): Observable<ResultOfDelovodniDokumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfDelovodniDokumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfDelovodniDokumentDto>(null as any);
    }

    getDelovodniDokumentTable(request: GetDelovodniDokumentTableQuery): Observable<PaginatedResultOfDelovodniDokumentTableDto> {
        let url_ = this.baseUrl + "/api/delovodnici/get-delovodni-dokument-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelovodniDokumentTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelovodniDokumentTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfDelovodniDokumentTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfDelovodniDokumentTableDto>;
        }));
    }

    protected processGetDelovodniDokumentTable(response: HttpResponseBase): Observable<PaginatedResultOfDelovodniDokumentTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfDelovodniDokumentTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfDelovodniDokumentTableDto>(null as any);
    }

    createDelovodniDokument(command: CreateDelovodniDokumentCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/delovodnici/create-delovodni-dokument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDelovodniDokument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDelovodniDokument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreateDelovodniDokument(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    deleteDelovodniDokumentFile(command: DeleteDelovodniDokumentFileCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/delovodnici/delete-delovodni-dokument-file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDelovodniDokumentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDelovodniDokumentFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processDeleteDelovodniDokumentFile(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    updateDelovodniDokument(command: UpdateDelovodniDokumentCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/delovodnici/update-delovodni-dokument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDelovodniDokument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDelovodniDokument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdateDelovodniDokument(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getPresignedUrl(request: GetDelovodnikPresignedUrlQuery): Observable<ResultOfDelovodnikPresignedUrlResponse> {
        let url_ = this.baseUrl + "/api/delovodnici/get-presigned-url";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPresignedUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPresignedUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfDelovodnikPresignedUrlResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfDelovodnikPresignedUrlResponse>;
        }));
    }

    protected processGetPresignedUrl(response: HttpResponseBase): Observable<ResultOfDelovodnikPresignedUrlResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfDelovodnikPresignedUrlResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfDelovodnikPresignedUrlResponse>(null as any);
    }
}

export interface IDmsClient {
    getPreostaliProstor(): Observable<ResultOfGetPreostaliProstorVM>;
    getFolderLsit(): Observable<ResultOfListOfFolderListResponse>;
    create(command: CreateDatotekaCommand): Observable<ResultOfString>;
    uploadDokumente(files?: FileParameter[] | null | undefined, parentId?: number | null | undefined): Observable<ResultOfString>;
    getForTree(): Observable<ResultOfDatotekaTreeVm>;
    getDokumentForPreview(datotekaId?: number | undefined): Observable<ResultOfGetDokumentForPreviewResponse>;
    getDokumentContent(datotekaId?: number | undefined): Observable<FileResponse>;
    getFolderForPreview(datotekaId?: number | undefined): Observable<ResultOfDatotekaDto>;
    requestDmsActionsAcync(datotekaId?: number | undefined, actionType?: DmsActionType | undefined): Observable<ResultOfString>;
    getDmsActionLogHistoryTable(pageSize?: number | undefined): Observable<ResultOfListOfDmsAkcijaLogTableDto>;
    getPendingDmsActionLogs(pageSize?: number | undefined): Observable<ResultOfListOfDmsAkcijaLogTableDto>;
    acceptDmsAction(dmsAkcijaLogId?: number | undefined, file?: FileParameter | null | undefined): Observable<ResultOfString>;
    rejectDmsAction(command: RejectDmsActionCommand): Observable<ResultOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class DmsClient implements IDmsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getPreostaliProstor(): Observable<ResultOfGetPreostaliProstorVM> {
        let url_ = this.baseUrl + "/api/dms/get-preostali-prostor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreostaliProstor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreostaliProstor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetPreostaliProstorVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetPreostaliProstorVM>;
        }));
    }

    protected processGetPreostaliProstor(response: HttpResponseBase): Observable<ResultOfGetPreostaliProstorVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetPreostaliProstorVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPreostaliProstorVM>(null as any);
    }

    getFolderLsit(): Observable<ResultOfListOfFolderListResponse> {
        let url_ = this.baseUrl + "/api/dms/get-folder-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFolderLsit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFolderLsit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfFolderListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfFolderListResponse>;
        }));
    }

    protected processGetFolderLsit(response: HttpResponseBase): Observable<ResultOfListOfFolderListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfFolderListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfFolderListResponse>(null as any);
    }

    create(command: CreateDatotekaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/dms/create-datoteka";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    uploadDokumente(files?: FileParameter[] | null | undefined, parentId?: number | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/dms/upload-dokumente";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (parentId !== null && parentId !== undefined)
            content_.append("ParentId", parentId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDokumente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDokumente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUploadDokumente(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getForTree(): Observable<ResultOfDatotekaTreeVm> {
        let url_ = this.baseUrl + "/api/dms/get-for-tree";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfDatotekaTreeVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfDatotekaTreeVm>;
        }));
    }

    protected processGetForTree(response: HttpResponseBase): Observable<ResultOfDatotekaTreeVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfDatotekaTreeVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfDatotekaTreeVm>(null as any);
    }

    getDokumentForPreview(datotekaId?: number | undefined): Observable<ResultOfGetDokumentForPreviewResponse> {
        let url_ = this.baseUrl + "/api/dms/get-dokument-preview?";
        if (datotekaId === null)
            throw new Error("The parameter 'datotekaId' cannot be null.");
        else if (datotekaId !== undefined)
            url_ += "datotekaId=" + encodeURIComponent("" + datotekaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDokumentForPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDokumentForPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetDokumentForPreviewResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetDokumentForPreviewResponse>;
        }));
    }

    protected processGetDokumentForPreview(response: HttpResponseBase): Observable<ResultOfGetDokumentForPreviewResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetDokumentForPreviewResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetDokumentForPreviewResponse>(null as any);
    }

    getDokumentContent(datotekaId?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/dms/get-dokument-content?";
        if (datotekaId === null)
            throw new Error("The parameter 'datotekaId' cannot be null.");
        else if (datotekaId !== undefined)
            url_ += "datotekaId=" + encodeURIComponent("" + datotekaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDokumentContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDokumentContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetDokumentContent(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getFolderForPreview(datotekaId?: number | undefined): Observable<ResultOfDatotekaDto> {
        let url_ = this.baseUrl + "/api/dms/get-folder-preview?";
        if (datotekaId === null)
            throw new Error("The parameter 'datotekaId' cannot be null.");
        else if (datotekaId !== undefined)
            url_ += "datotekaId=" + encodeURIComponent("" + datotekaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFolderForPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFolderForPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfDatotekaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfDatotekaDto>;
        }));
    }

    protected processGetFolderForPreview(response: HttpResponseBase): Observable<ResultOfDatotekaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfDatotekaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfDatotekaDto>(null as any);
    }

    requestDmsActionsAcync(datotekaId?: number | undefined, actionType?: DmsActionType | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/dms/request-dms-action?";
        if (datotekaId === null)
            throw new Error("The parameter 'datotekaId' cannot be null.");
        else if (datotekaId !== undefined)
            url_ += "datotekaId=" + encodeURIComponent("" + datotekaId) + "&";
        if (actionType === null)
            throw new Error("The parameter 'actionType' cannot be null.");
        else if (actionType !== undefined)
            url_ += "actionType=" + encodeURIComponent("" + actionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestDmsActionsAcync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestDmsActionsAcync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processRequestDmsActionsAcync(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getDmsActionLogHistoryTable(pageSize?: number | undefined): Observable<ResultOfListOfDmsAkcijaLogTableDto> {
        let url_ = this.baseUrl + "/api/dms/get-dms-action-history?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDmsActionLogHistoryTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDmsActionLogHistoryTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfDmsAkcijaLogTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfDmsAkcijaLogTableDto>;
        }));
    }

    protected processGetDmsActionLogHistoryTable(response: HttpResponseBase): Observable<ResultOfListOfDmsAkcijaLogTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfDmsAkcijaLogTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfDmsAkcijaLogTableDto>(null as any);
    }

    getPendingDmsActionLogs(pageSize?: number | undefined): Observable<ResultOfListOfDmsAkcijaLogTableDto> {
        let url_ = this.baseUrl + "/api/dms/get-pending-dms-actions?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingDmsActionLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingDmsActionLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfDmsAkcijaLogTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfDmsAkcijaLogTableDto>;
        }));
    }

    protected processGetPendingDmsActionLogs(response: HttpResponseBase): Observable<ResultOfListOfDmsAkcijaLogTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfDmsAkcijaLogTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfDmsAkcijaLogTableDto>(null as any);
    }

    acceptDmsAction(dmsAkcijaLogId?: number | undefined, file?: FileParameter | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/dms/accept-dms-action";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (dmsAkcijaLogId === null || dmsAkcijaLogId === undefined)
            throw new Error("The parameter 'dmsAkcijaLogId' cannot be null.");
        else
            content_.append("DmsAkcijaLogId", dmsAkcijaLogId.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptDmsAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptDmsAction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processAcceptDmsAction(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    rejectDmsAction(command: RejectDmsActionCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/dms/reject-dms-action";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectDmsAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectDmsAction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processRejectDmsAction(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }
}

export interface IDokumentiOSmanjenjuClient {
    create(command: CreateDokumentOSmanjenjuCommand): Observable<ResultOfLong>;
    update(id: number, command: UpdateDokumentOSmanjenjuCommand): Observable<ResultOfString>;
    getNewForStranka(strankaId: string): Observable<ResultOfAvansniRacunDto>;
}

@Injectable({
    providedIn: 'root'
})
export class DokumentiOSmanjenjuClient implements IDokumentiOSmanjenjuClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    create(command: CreateDokumentOSmanjenjuCommand): Observable<ResultOfLong> {
        let url_ = this.baseUrl + "/api/dokumentiosmanjenju";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfLong>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfLong>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfLong> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfLong.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLong>(null as any);
    }

    update(id: number, command: UpdateDokumentOSmanjenjuCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/dokumentiosmanjenju/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getNewForStranka(strankaId: string): Observable<ResultOfAvansniRacunDto> {
        let url_ = this.baseUrl + "/api/dokumentiosmanjenju/new-for-stranka/{strankaId}";
        if (strankaId === undefined || strankaId === null)
            throw new Error("The parameter 'strankaId' must be defined.");
        url_ = url_.replace("{strankaId}", encodeURIComponent("" + strankaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewForStranka(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewForStranka(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfAvansniRacunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfAvansniRacunDto>;
        }));
    }

    protected processGetNewForStranka(response: HttpResponseBase): Observable<ResultOfAvansniRacunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfAvansniRacunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfAvansniRacunDto>(null as any);
    }
}

export interface IEmailClient {
    getEmailTable(request: GetEmailTableQuery): Observable<PaginatedResultOfPostmarkOutboundMessageDto>;
    getEmailDetails(messageId?: string | null | undefined): Observable<ResultOfPostmarkOutboundMessageDetailDto>;
    getEmailsForRacun(racunId?: number | undefined): Observable<ResultOfGetEmailsForRacunResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class EmailClient implements IEmailClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEmailTable(request: GetEmailTableQuery): Observable<PaginatedResultOfPostmarkOutboundMessageDto> {
        let url_ = this.baseUrl + "/api/email/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfPostmarkOutboundMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfPostmarkOutboundMessageDto>;
        }));
    }

    protected processGetEmailTable(response: HttpResponseBase): Observable<PaginatedResultOfPostmarkOutboundMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfPostmarkOutboundMessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfPostmarkOutboundMessageDto>(null as any);
    }

    getEmailDetails(messageId?: string | null | undefined): Observable<ResultOfPostmarkOutboundMessageDetailDto> {
        let url_ = this.baseUrl + "/api/email/get-email-details?";
        if (messageId !== undefined && messageId !== null)
            url_ += "messageId=" + encodeURIComponent("" + messageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfPostmarkOutboundMessageDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfPostmarkOutboundMessageDetailDto>;
        }));
    }

    protected processGetEmailDetails(response: HttpResponseBase): Observable<ResultOfPostmarkOutboundMessageDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfPostmarkOutboundMessageDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfPostmarkOutboundMessageDetailDto>(null as any);
    }

    getEmailsForRacun(racunId?: number | undefined): Observable<ResultOfGetEmailsForRacunResponse> {
        let url_ = this.baseUrl + "/api/email/get-emails-for-racun?";
        if (racunId === null)
            throw new Error("The parameter 'racunId' cannot be null.");
        else if (racunId !== undefined)
            url_ += "racunId=" + encodeURIComponent("" + racunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailsForRacun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailsForRacun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetEmailsForRacunResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetEmailsForRacunResponse>;
        }));
    }

    protected processGetEmailsForRacun(response: HttpResponseBase): Observable<ResultOfGetEmailsForRacunResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetEmailsForRacunResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetEmailsForRacunResponse>(null as any);
    }
}

export interface IEOtpremniceClient {
    create(command: CreateEOtpremnicaCommand): Observable<ResultOfLong>;
    createPrijemnica(command: CreateEPrijemnicaCommand): Observable<ResultOfLong>;
    parsirajPrijemnicuXml(fajl?: FileParameter | null | undefined): Observable<ResultOfEPrijemnicaDto>;
    parsirajOtpremnicuXml(fajl?: FileParameter | null | undefined): Observable<ResultOfEOtpremnicaDto>;
    getForTableEOtpremnica(request: GetEOtpremnicaTableQuery): Observable<PaginatedResultOfEOtpremnicaTableDto>;
    getForTableEPrijemnica(request: GetEPrijemnicaTableQuery): Observable<PaginatedResultOfEPrijemnicaTableDto>;
    akcijaOtpremnice(otpremnicaId?: number | undefined, tipIzmenePosiljke?: TipIzmenePosiljke | null | undefined, file?: FileParameter | null | undefined, komentar?: string | null | undefined): Observable<ResultOfString>;
    evidencijaPretovara(command: PretovarIsporukeCommand): Observable<ResultOfString>;
    promenaVozila(command: PromenaVozilaCommand): Observable<ResultOfString>;
    updateEOtpremnica(id: number, command: UpdateEOtpremnicaCommand): Observable<ResultOfString>;
    getNacinOtpreme(): Observable<ResultOfGetNaciniOtpremeResponse>;
    getTipOtpremnice(): Observable<ResultOfGetTipOtpremniceResponse>;
    getEOtpremnica(id?: number | undefined): Observable<ResultOfEOtpremnicaDto>;
    getNewEOtpremnicaForPredracun(predracunId: number): Observable<ResultOfEOtpremnicaDto>;
    getStavkeOtpremnice(id?: number | undefined): Observable<ResultOfICollectionOfStavkaOtpremniceDto>;
    getTipAkcizneKategorije(): Observable<ResultOfGetTipAkcizneKategorijeResponse>;
    getTipPakovanjaDuvana(): Observable<ResultOfGetTipPakovanjaDuvanaResponse>;
    searchMagacinAdreseIsporuke(searchValue: string): Observable<ResultOfListOfAdresaIsporukeDto>;
    getPdf(otpremnicaId: number, previewTitle: string): Observable<FileResponse>;
    getDokumentUrl(otpremnicaId: number): Observable<ResultOfString>;
    getVozacInicijalneFaze(id: number): Observable<ResultOfVozacFazeDto>;
    getEOtpremniceAutocomplete(searchValue?: string | null | undefined): Observable<ResultOfIEnumerableOfEOtpremnicaAutocompleteResponse>;
    getEotpremniceDropdown(tip?: TipDokumentaOtpremnica | undefined, racunId?: number | null | undefined): Observable<ResultOfListOfEOtpremnicaDropdownDto>;
    getStavkeRacunaZaEOtpremnicu(eOtpremnicaBaseId: number): Observable<ResultOfListOfStavkaRacunaDto>;
    getUlazneNotifications(notifications: PushNotificationDto[]): Observable<FileResponse>;
    sendToSef(otpremnicaId?: number | undefined, attachments?: FileParameter[] | null | undefined): Observable<ResultOfString>;
    syncSef(datum?: Date | undefined): Observable<ResultOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class EOtpremniceClient implements IEOtpremniceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    create(command: CreateEOtpremnicaCommand): Observable<ResultOfLong> {
        let url_ = this.baseUrl + "/api/eotpremnice/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfLong>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfLong>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfLong> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfLong.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLong>(null as any);
    }

    createPrijemnica(command: CreateEPrijemnicaCommand): Observable<ResultOfLong> {
        let url_ = this.baseUrl + "/api/eotpremnice/create-prijemnica";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePrijemnica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePrijemnica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfLong>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfLong>;
        }));
    }

    protected processCreatePrijemnica(response: HttpResponseBase): Observable<ResultOfLong> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfLong.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLong>(null as any);
    }

    parsirajPrijemnicuXml(fajl?: FileParameter | null | undefined): Observable<ResultOfEPrijemnicaDto> {
        let url_ = this.baseUrl + "/api/eotpremnice/parsiraj-prijemnicu-xml";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fajl !== null && fajl !== undefined)
            content_.append("fajl", fajl.data, fajl.fileName ? fajl.fileName : "fajl");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParsirajPrijemnicuXml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParsirajPrijemnicuXml(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfEPrijemnicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfEPrijemnicaDto>;
        }));
    }

    protected processParsirajPrijemnicuXml(response: HttpResponseBase): Observable<ResultOfEPrijemnicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfEPrijemnicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfEPrijemnicaDto>(null as any);
    }

    parsirajOtpremnicuXml(fajl?: FileParameter | null | undefined): Observable<ResultOfEOtpremnicaDto> {
        let url_ = this.baseUrl + "/api/eotpremnice/parsiraj-otpremnicu-xml";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fajl !== null && fajl !== undefined)
            content_.append("fajl", fajl.data, fajl.fileName ? fajl.fileName : "fajl");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParsirajOtpremnicuXml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParsirajOtpremnicuXml(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfEOtpremnicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfEOtpremnicaDto>;
        }));
    }

    protected processParsirajOtpremnicuXml(response: HttpResponseBase): Observable<ResultOfEOtpremnicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfEOtpremnicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfEOtpremnicaDto>(null as any);
    }

    getForTableEOtpremnica(request: GetEOtpremnicaTableQuery): Observable<PaginatedResultOfEOtpremnicaTableDto> {
        let url_ = this.baseUrl + "/api/eotpremnice/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTableEOtpremnica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTableEOtpremnica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfEOtpremnicaTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfEOtpremnicaTableDto>;
        }));
    }

    protected processGetForTableEOtpremnica(response: HttpResponseBase): Observable<PaginatedResultOfEOtpremnicaTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfEOtpremnicaTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfEOtpremnicaTableDto>(null as any);
    }

    getForTableEPrijemnica(request: GetEPrijemnicaTableQuery): Observable<PaginatedResultOfEPrijemnicaTableDto> {
        let url_ = this.baseUrl + "/api/eotpremnice/get-for-table-prijemnica";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTableEPrijemnica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTableEPrijemnica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfEPrijemnicaTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfEPrijemnicaTableDto>;
        }));
    }

    protected processGetForTableEPrijemnica(response: HttpResponseBase): Observable<PaginatedResultOfEPrijemnicaTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfEPrijemnicaTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfEPrijemnicaTableDto>(null as any);
    }

    akcijaOtpremnice(otpremnicaId?: number | undefined, tipIzmenePosiljke?: TipIzmenePosiljke | null | undefined, file?: FileParameter | null | undefined, komentar?: string | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/eotpremnice/akcije-otpremnice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (otpremnicaId === null || otpremnicaId === undefined)
            throw new Error("The parameter 'otpremnicaId' cannot be null.");
        else
            content_.append("OtpremnicaId", otpremnicaId.toString());
        if (tipIzmenePosiljke !== null && tipIzmenePosiljke !== undefined)
            content_.append("TipIzmenePosiljke", tipIzmenePosiljke.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (komentar !== null && komentar !== undefined)
            content_.append("Komentar", komentar.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAkcijaOtpremnice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAkcijaOtpremnice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processAkcijaOtpremnice(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    evidencijaPretovara(command: PretovarIsporukeCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/eotpremnice/evidencija-pretovara";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEvidencijaPretovara(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEvidencijaPretovara(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processEvidencijaPretovara(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    promenaVozila(command: PromenaVozilaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/eotpremnice/promena-vozila";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPromenaVozila(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPromenaVozila(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processPromenaVozila(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    updateEOtpremnica(id: number, command: UpdateEOtpremnicaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/eotpremnice/update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEOtpremnica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEOtpremnica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdateEOtpremnica(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getNacinOtpreme(): Observable<ResultOfGetNaciniOtpremeResponse> {
        let url_ = this.baseUrl + "/api/eotpremnice/get-nacin-otpreme";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNacinOtpreme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNacinOtpreme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetNaciniOtpremeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetNaciniOtpremeResponse>;
        }));
    }

    protected processGetNacinOtpreme(response: HttpResponseBase): Observable<ResultOfGetNaciniOtpremeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetNaciniOtpremeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetNaciniOtpremeResponse>(null as any);
    }

    getTipOtpremnice(): Observable<ResultOfGetTipOtpremniceResponse> {
        let url_ = this.baseUrl + "/api/eotpremnice/get-tip-otpremnice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipOtpremnice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipOtpremnice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTipOtpremniceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTipOtpremniceResponse>;
        }));
    }

    protected processGetTipOtpremnice(response: HttpResponseBase): Observable<ResultOfGetTipOtpremniceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTipOtpremniceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTipOtpremniceResponse>(null as any);
    }

    getEOtpremnica(id?: number | undefined): Observable<ResultOfEOtpremnicaDto> {
        let url_ = this.baseUrl + "/api/eotpremnice/otpremnica?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEOtpremnica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEOtpremnica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfEOtpremnicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfEOtpremnicaDto>;
        }));
    }

    protected processGetEOtpremnica(response: HttpResponseBase): Observable<ResultOfEOtpremnicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfEOtpremnicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfEOtpremnicaDto>(null as any);
    }

    getNewEOtpremnicaForPredracun(predracunId: number): Observable<ResultOfEOtpremnicaDto> {
        let url_ = this.baseUrl + "/api/eotpremnice/new-for-predracun/{predracunId}";
        if (predracunId === undefined || predracunId === null)
            throw new Error("The parameter 'predracunId' must be defined.");
        url_ = url_.replace("{predracunId}", encodeURIComponent("" + predracunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewEOtpremnicaForPredracun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewEOtpremnicaForPredracun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfEOtpremnicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfEOtpremnicaDto>;
        }));
    }

    protected processGetNewEOtpremnicaForPredracun(response: HttpResponseBase): Observable<ResultOfEOtpremnicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfEOtpremnicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfEOtpremnicaDto>(null as any);
    }

    getStavkeOtpremnice(id?: number | undefined): Observable<ResultOfICollectionOfStavkaOtpremniceDto> {
        let url_ = this.baseUrl + "/api/eotpremnice/stavke-otpremnice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStavkeOtpremnice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStavkeOtpremnice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfICollectionOfStavkaOtpremniceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfICollectionOfStavkaOtpremniceDto>;
        }));
    }

    protected processGetStavkeOtpremnice(response: HttpResponseBase): Observable<ResultOfICollectionOfStavkaOtpremniceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfICollectionOfStavkaOtpremniceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfICollectionOfStavkaOtpremniceDto>(null as any);
    }

    getTipAkcizneKategorije(): Observable<ResultOfGetTipAkcizneKategorijeResponse> {
        let url_ = this.baseUrl + "/api/eotpremnice/get-tip-akcizne-kategorije";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipAkcizneKategorije(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipAkcizneKategorije(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTipAkcizneKategorijeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTipAkcizneKategorijeResponse>;
        }));
    }

    protected processGetTipAkcizneKategorije(response: HttpResponseBase): Observable<ResultOfGetTipAkcizneKategorijeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTipAkcizneKategorijeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTipAkcizneKategorijeResponse>(null as any);
    }

    getTipPakovanjaDuvana(): Observable<ResultOfGetTipPakovanjaDuvanaResponse> {
        let url_ = this.baseUrl + "/api/eotpremnice/get-tip-pakovanja-duvana";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipPakovanjaDuvana(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipPakovanjaDuvana(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTipPakovanjaDuvanaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTipPakovanjaDuvanaResponse>;
        }));
    }

    protected processGetTipPakovanjaDuvana(response: HttpResponseBase): Observable<ResultOfGetTipPakovanjaDuvanaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTipPakovanjaDuvanaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTipPakovanjaDuvanaResponse>(null as any);
    }

    searchMagacinAdreseIsporuke(searchValue: string): Observable<ResultOfListOfAdresaIsporukeDto> {
        let url_ = this.baseUrl + "/api/eotpremnice/search-magacin-adresa/{searchValue}";
        if (searchValue === undefined || searchValue === null)
            throw new Error("The parameter 'searchValue' must be defined.");
        url_ = url_.replace("{searchValue}", encodeURIComponent("" + searchValue));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchMagacinAdreseIsporuke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchMagacinAdreseIsporuke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfAdresaIsporukeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfAdresaIsporukeDto>;
        }));
    }

    protected processSearchMagacinAdreseIsporuke(response: HttpResponseBase): Observable<ResultOfListOfAdresaIsporukeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfAdresaIsporukeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfAdresaIsporukeDto>(null as any);
    }

    getPdf(otpremnicaId: number, previewTitle: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/eotpremnice/get-pdf/{otpremnicaId}/{previewTitle}";
        if (otpremnicaId === undefined || otpremnicaId === null)
            throw new Error("The parameter 'otpremnicaId' must be defined.");
        url_ = url_.replace("{otpremnicaId}", encodeURIComponent("" + otpremnicaId));
        if (previewTitle === undefined || previewTitle === null)
            throw new Error("The parameter 'previewTitle' must be defined.");
        url_ = url_.replace("{previewTitle}", encodeURIComponent("" + previewTitle));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getDokumentUrl(otpremnicaId: number): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/eotpremnice/get-dokument-url/{otpremnicaId}";
        if (otpremnicaId === undefined || otpremnicaId === null)
            throw new Error("The parameter 'otpremnicaId' must be defined.");
        url_ = url_.replace("{otpremnicaId}", encodeURIComponent("" + otpremnicaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDokumentUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDokumentUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processGetDokumentUrl(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getVozacInicijalneFaze(id: number): Observable<ResultOfVozacFazeDto> {
        let url_ = this.baseUrl + "/api/eotpremnice/vozac-by-id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVozacInicijalneFaze(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVozacInicijalneFaze(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfVozacFazeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfVozacFazeDto>;
        }));
    }

    protected processGetVozacInicijalneFaze(response: HttpResponseBase): Observable<ResultOfVozacFazeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfVozacFazeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfVozacFazeDto>(null as any);
    }

    getEOtpremniceAutocomplete(searchValue?: string | null | undefined): Observable<ResultOfIEnumerableOfEOtpremnicaAutocompleteResponse> {
        let url_ = this.baseUrl + "/api/eotpremnice/get-eotpremnice-autocomplete?";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEOtpremniceAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEOtpremniceAutocomplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIEnumerableOfEOtpremnicaAutocompleteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIEnumerableOfEOtpremnicaAutocompleteResponse>;
        }));
    }

    protected processGetEOtpremniceAutocomplete(response: HttpResponseBase): Observable<ResultOfIEnumerableOfEOtpremnicaAutocompleteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIEnumerableOfEOtpremnicaAutocompleteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIEnumerableOfEOtpremnicaAutocompleteResponse>(null as any);
    }

    getEotpremniceDropdown(tip?: TipDokumentaOtpremnica | undefined, racunId?: number | null | undefined): Observable<ResultOfListOfEOtpremnicaDropdownDto> {
        let url_ = this.baseUrl + "/api/eotpremnice/get-eotpremnice-dropdown?";
        if (tip === null)
            throw new Error("The parameter 'tip' cannot be null.");
        else if (tip !== undefined)
            url_ += "tip=" + encodeURIComponent("" + tip) + "&";
        if (racunId !== undefined && racunId !== null)
            url_ += "racunId=" + encodeURIComponent("" + racunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEotpremniceDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEotpremniceDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfEOtpremnicaDropdownDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfEOtpremnicaDropdownDto>;
        }));
    }

    protected processGetEotpremniceDropdown(response: HttpResponseBase): Observable<ResultOfListOfEOtpremnicaDropdownDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfEOtpremnicaDropdownDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfEOtpremnicaDropdownDto>(null as any);
    }

    getStavkeRacunaZaEOtpremnicu(eOtpremnicaBaseId: number): Observable<ResultOfListOfStavkaRacunaDto> {
        let url_ = this.baseUrl + "/api/eotpremnice/get-stavke-racuna-za-eotpremnicu/{eOtpremnicaBaseId}";
        if (eOtpremnicaBaseId === undefined || eOtpremnicaBaseId === null)
            throw new Error("The parameter 'eOtpremnicaBaseId' must be defined.");
        url_ = url_.replace("{eOtpremnicaBaseId}", encodeURIComponent("" + eOtpremnicaBaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStavkeRacunaZaEOtpremnicu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStavkeRacunaZaEOtpremnicu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfStavkaRacunaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfStavkaRacunaDto>;
        }));
    }

    protected processGetStavkeRacunaZaEOtpremnicu(response: HttpResponseBase): Observable<ResultOfListOfStavkaRacunaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfStavkaRacunaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfStavkaRacunaDto>(null as any);
    }

    getUlazneNotifications(notifications: PushNotificationDto[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/eotpremnice/webhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notifications);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUlazneNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUlazneNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetUlazneNotifications(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    sendToSef(otpremnicaId?: number | undefined, attachments?: FileParameter[] | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/eotpremnice/posalji-na-sef";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (otpremnicaId === null || otpremnicaId === undefined)
            throw new Error("The parameter 'otpremnicaId' cannot be null.");
        else
            content_.append("OtpremnicaId", otpremnicaId.toString());
        if (attachments !== null && attachments !== undefined)
            attachments.forEach(item_ => content_.append("Attachments", item_.data, item_.fileName ? item_.fileName : "Attachments") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendToSef(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendToSef(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSendToSef(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    syncSef(datum?: Date | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/eotpremnice/sync-ulazne-otpremnice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (datum === null || datum === undefined)
            throw new Error("The parameter 'datum' cannot be null.");
        else
            content_.append("Datum", datum.toJSON());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncSef(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncSef(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSyncSef(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }
}

export interface IFiskalniRacuniClient {
    getForTable(request: GetFiskalniRacunTableQuery): Observable<PaginatedResultOfFiskalniRacunTableDto>;
    getFiskalniPrometDanas(period?: FiskalniPrometPeriod | undefined, datum?: Date | null | undefined): Observable<ResultOfFiskalniPrometDanasDto>;
    getFiskalniInfo(id: string): Observable<ResultOfFiskalniRacunInfoDto>;
    getKategorijaForList(): Observable<ResultOfListOfKategorijaListDto>;
    getArtikleByKategorija(kategorijaId?: number | undefined): Observable<PaginatedResultOfFiskalniArtikalDto>;
    getSertifikatiFiskalneKaseDropdown(): Observable<ResultOfListOfSertifikatFiskalneKaseDto>;
    getLicenceFiskalneKaseDropdown(): Observable<ResultOfListOfLpfrLicencaDropdownDto>;
    getArtikleByPretraga(request: GetArtikalListByPretragaQuery): Observable<PaginatedResultOfFiskalniArtikalDto>;
    getVrstaFiskalnogRacuna(): Observable<ResultOfGetVrstaFiskalnogRacunResponse>;
    getBuyerIdentification(): Observable<ResultOfGetBuyerIdentificationResponse>;
    getBuyerOptionalField(): Observable<ResultOfGetBuyerOptionalFieldResponse>;
    getStatusFiskalneKase(): Observable<ResultOfInvoiceStatusResponse>;
    getSubjectFiskalneKase(): Observable<ResultOfInvoiceSubjectResponse>;
    getBezbednosniElementiForTable(request: GetBezbednosniElementiTableQuery): Observable<PaginatedResultOfBezbednosniElementDto>;
    getLicenceForTable(request: GetLicenceZaFiskalnuTableQuery): Observable<PaginatedResultOfLpfrLicencaDto>;
    getBezbednosniElementInfo(id: number): Observable<ResultOfBezbednosniElementInfoDto>;
    verifikujPodatkeBezbednosnogElementa(): Observable<ResultOfString>;
    getAttention(): Observable<ResultOfEsdcCardStatus>;
    getDailyReport(print?: boolean | undefined, closeDay?: boolean | undefined): Observable<ResultOfInvoiceReportResponse>;
    getPeriodicReport(request: GetPeriodicReportQuery): Observable<ResultOfInvoiceReportResponse>;
    getStatusBezbednosnogElementa(): Observable<ResultOfGetStatusBezbednosnogElementaResponse>;
    getStatusSertifikataFiskalneKase(): Observable<ResultOfBoolean>;
    getReferentniFiskalniRacunAutocomplete(search?: string | null | undefined, invoiceType?: InvoiceType | undefined, transactionType?: TransactionType | undefined): Observable<ResultOfGetReferentniFiskalniRacunAutocompleteResponse>;
    getStavkeAvansnogFiskalnogRacuna(): Observable<ResultOfGetStavkeAvansnogFiskalnogVm>;
    getLastSignedInvoice(requestId?: string | null | undefined, shouldPrint?: boolean | undefined): Observable<ResultOfInvoiceResponse>;
    getStavkeRefundacijeFiskalnogRacuna(referentDocumentNumber?: string | null | undefined): Observable<ResultOfGetStavkeRefundacijeFiskalnogVm>;
    getReceiptAsImage(requestId?: string | null | undefined): Observable<ResultOfString>;
    getReferentniFiskalniRacun(id?: string | null | undefined, jeKreirajAvansRefundaciju?: boolean | undefined): Observable<ResultOfGetReferentniFiskalniRacunResponse>;
    getFiskalniPdf(invoiceResponseId: number, previewTitle: string): Observable<FileResponse>;
    getSpecifikacijaPdf(invoiceResponseId: number, previewTitle: string): Observable<FileResponse>;
    getPredefinisaniTekst(): Observable<ResultOfPredefinisaniTekstDto>;
    getOpstaPravilaFiskalna(): Observable<ResultOfOpstaPravilaFiskalniDto>;
    getVelicinaPapira(): Observable<ResultOfGetVelicinaPapiraResponse>;
    getTipPostFiskalizacija(): Observable<ResultOfGetTipAkcijeResponse>;
    getJidZaHeader(): Observable<ResultOfString>;
    getFiskalniIsecakStorage(invoiceResponseId: number): Observable<ResultOfRelevantniDokumentListItemUrlDto>;
    getStavkeZaAvanse(request: GetProizvodiZaAvanseListQuery): Observable<ResultOfListOfProizvodiZaAvanseMaloprodajaDto>;
    create(command: CreateFiskalniRacunCommand): Observable<ResultOfFiskalniIsecakPdfData>;
    createCopy(id: string): Observable<ResultOfLong>;
    sendFiskalniRacunToPos(invoiceRequestId?: string | null | undefined): Observable<ResultOfString>;
    verifyBezbednosniElement(pin?: string | null | undefined): Observable<ResultOfString>;
    initBezbednosniElementBezPoslovneJedinice(bezbednosniElementId?: number | undefined): Observable<ResultOfString>;
    initBezbednosniElementSaPoslovnomJedinicom(bezbednosniElementId?: number | undefined, poslovnaJedinicaId?: number | undefined): Observable<ResultOfString>;
    importSertifikatFiskalneKase(dtoCommand: ImportSertifikatFiskalneKaseDtoCommand): Observable<ResultOfLong>;
    uploadSertifikataFiskalneKase(bezbednosniElementId?: number | undefined, file?: FileParameter | null | undefined): Observable<ResultOfLong>;
    createEmptyLPFR(request: CreateEmptyBezbednosniElementLPFRCommand): Observable<ResultOfString>;
    updateBezbednosniElement(request: UpdateBezbednosniElementCommand): Observable<ResultOfString>;
    sendFiskalniElektronski(fromId?: string | undefined, to?: string[] | null | undefined, invoiceResponseId?: number | undefined): Observable<ResultOfString>;
    addPredefinisaniTekst(request: AddPredefinisaniTekstCommand): Observable<ResultOfString>;
    updateOpstaPravilaFiskalna(command: UpdateOpstaPravilaFiskalnaCommand): Observable<ResultOfOpstaPravilaFiskalniDto>;
    deleteSertifikat(id: number): Observable<ResultOfString>;
    getUlazniForTable(request: GetUlazniFiskalniRacunTableQuery): Observable<PaginatedResultOfUlazniFiskalniRacunTableDto>;
    getUlazniFiskalniIsecak(id: number): Observable<ResultOfRelevantniDokumentListItemUrlDto>;
    createUlazni(command: CreateUlazniFiskalniRacunCommand): Observable<ResultOfLong>;
}

@Injectable({
    providedIn: 'root'
})
export class FiskalniRacuniClient implements IFiskalniRacuniClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(request: GetFiskalniRacunTableQuery): Observable<PaginatedResultOfFiskalniRacunTableDto> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfFiskalniRacunTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfFiskalniRacunTableDto>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<PaginatedResultOfFiskalniRacunTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfFiskalniRacunTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfFiskalniRacunTableDto>(null as any);
    }

    getFiskalniPrometDanas(period?: FiskalniPrometPeriod | undefined, datum?: Date | null | undefined): Observable<ResultOfFiskalniPrometDanasDto> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/fiskalni-promet-danas?";
        if (period === null)
            throw new Error("The parameter 'period' cannot be null.");
        else if (period !== undefined)
            url_ += "period=" + encodeURIComponent("" + period) + "&";
        if (datum !== undefined && datum !== null)
            url_ += "datum=" + encodeURIComponent(datum ? "" + datum.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFiskalniPrometDanas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFiskalniPrometDanas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfFiskalniPrometDanasDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfFiskalniPrometDanasDto>;
        }));
    }

    protected processGetFiskalniPrometDanas(response: HttpResponseBase): Observable<ResultOfFiskalniPrometDanasDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfFiskalniPrometDanasDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfFiskalniPrometDanasDto>(null as any);
    }

    getFiskalniInfo(id: string): Observable<ResultOfFiskalniRacunInfoDto> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-info/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFiskalniInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFiskalniInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfFiskalniRacunInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfFiskalniRacunInfoDto>;
        }));
    }

    protected processGetFiskalniInfo(response: HttpResponseBase): Observable<ResultOfFiskalniRacunInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfFiskalniRacunInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfFiskalniRacunInfoDto>(null as any);
    }

    getKategorijaForList(): Observable<ResultOfListOfKategorijaListDto> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-kategorije-for-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKategorijaForList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKategorijaForList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfKategorijaListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfKategorijaListDto>;
        }));
    }

    protected processGetKategorijaForList(response: HttpResponseBase): Observable<ResultOfListOfKategorijaListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfKategorijaListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfKategorijaListDto>(null as any);
    }

    getArtikleByKategorija(kategorijaId?: number | undefined): Observable<PaginatedResultOfFiskalniArtikalDto> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-artikle-by-kategorija?";
        if (kategorijaId === null)
            throw new Error("The parameter 'kategorijaId' cannot be null.");
        else if (kategorijaId !== undefined)
            url_ += "kategorijaId=" + encodeURIComponent("" + kategorijaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArtikleByKategorija(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArtikleByKategorija(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfFiskalniArtikalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfFiskalniArtikalDto>;
        }));
    }

    protected processGetArtikleByKategorija(response: HttpResponseBase): Observable<PaginatedResultOfFiskalniArtikalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfFiskalniArtikalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfFiskalniArtikalDto>(null as any);
    }

    getSertifikatiFiskalneKaseDropdown(): Observable<ResultOfListOfSertifikatFiskalneKaseDto> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-sertifikati-fiskalne-kase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSertifikatiFiskalneKaseDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSertifikatiFiskalneKaseDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfSertifikatFiskalneKaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfSertifikatFiskalneKaseDto>;
        }));
    }

    protected processGetSertifikatiFiskalneKaseDropdown(response: HttpResponseBase): Observable<ResultOfListOfSertifikatFiskalneKaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfSertifikatFiskalneKaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfSertifikatFiskalneKaseDto>(null as any);
    }

    getLicenceFiskalneKaseDropdown(): Observable<ResultOfListOfLpfrLicencaDropdownDto> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-licence-fiskalne-kase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicenceFiskalneKaseDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicenceFiskalneKaseDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfLpfrLicencaDropdownDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfLpfrLicencaDropdownDto>;
        }));
    }

    protected processGetLicenceFiskalneKaseDropdown(response: HttpResponseBase): Observable<ResultOfListOfLpfrLicencaDropdownDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfLpfrLicencaDropdownDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfLpfrLicencaDropdownDto>(null as any);
    }

    getArtikleByPretraga(request: GetArtikalListByPretragaQuery): Observable<PaginatedResultOfFiskalniArtikalDto> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-artikle-by-pretraga";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArtikleByPretraga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArtikleByPretraga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfFiskalniArtikalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfFiskalniArtikalDto>;
        }));
    }

    protected processGetArtikleByPretraga(response: HttpResponseBase): Observable<PaginatedResultOfFiskalniArtikalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfFiskalniArtikalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfFiskalniArtikalDto>(null as any);
    }

    getVrstaFiskalnogRacuna(): Observable<ResultOfGetVrstaFiskalnogRacunResponse> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-vrsta-fiskalnog-racuna";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVrstaFiskalnogRacuna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVrstaFiskalnogRacuna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetVrstaFiskalnogRacunResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetVrstaFiskalnogRacunResponse>;
        }));
    }

    protected processGetVrstaFiskalnogRacuna(response: HttpResponseBase): Observable<ResultOfGetVrstaFiskalnogRacunResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetVrstaFiskalnogRacunResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetVrstaFiskalnogRacunResponse>(null as any);
    }

    getBuyerIdentification(): Observable<ResultOfGetBuyerIdentificationResponse> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-buyer-identification";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuyerIdentification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuyerIdentification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetBuyerIdentificationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetBuyerIdentificationResponse>;
        }));
    }

    protected processGetBuyerIdentification(response: HttpResponseBase): Observable<ResultOfGetBuyerIdentificationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetBuyerIdentificationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetBuyerIdentificationResponse>(null as any);
    }

    getBuyerOptionalField(): Observable<ResultOfGetBuyerOptionalFieldResponse> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-buyer-optional-field";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuyerOptionalField(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuyerOptionalField(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetBuyerOptionalFieldResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetBuyerOptionalFieldResponse>;
        }));
    }

    protected processGetBuyerOptionalField(response: HttpResponseBase): Observable<ResultOfGetBuyerOptionalFieldResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetBuyerOptionalFieldResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetBuyerOptionalFieldResponse>(null as any);
    }

    getStatusFiskalneKase(): Observable<ResultOfInvoiceStatusResponse> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-status-fiskalne-kase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatusFiskalneKase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatusFiskalneKase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfInvoiceStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfInvoiceStatusResponse>;
        }));
    }

    protected processGetStatusFiskalneKase(response: HttpResponseBase): Observable<ResultOfInvoiceStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfInvoiceStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfInvoiceStatusResponse>(null as any);
    }

    getSubjectFiskalneKase(): Observable<ResultOfInvoiceSubjectResponse> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-subject-fiskalne-kase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubjectFiskalneKase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubjectFiskalneKase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfInvoiceSubjectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfInvoiceSubjectResponse>;
        }));
    }

    protected processGetSubjectFiskalneKase(response: HttpResponseBase): Observable<ResultOfInvoiceSubjectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfInvoiceSubjectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfInvoiceSubjectResponse>(null as any);
    }

    getBezbednosniElementiForTable(request: GetBezbednosniElementiTableQuery): Observable<PaginatedResultOfBezbednosniElementDto> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-bezbednosni-elementi-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBezbednosniElementiForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBezbednosniElementiForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfBezbednosniElementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfBezbednosniElementDto>;
        }));
    }

    protected processGetBezbednosniElementiForTable(response: HttpResponseBase): Observable<PaginatedResultOfBezbednosniElementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfBezbednosniElementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfBezbednosniElementDto>(null as any);
    }

    getLicenceForTable(request: GetLicenceZaFiskalnuTableQuery): Observable<PaginatedResultOfLpfrLicencaDto> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-licence-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicenceForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicenceForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfLpfrLicencaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfLpfrLicencaDto>;
        }));
    }

    protected processGetLicenceForTable(response: HttpResponseBase): Observable<PaginatedResultOfLpfrLicencaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfLpfrLicencaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfLpfrLicencaDto>(null as any);
    }

    getBezbednosniElementInfo(id: number): Observable<ResultOfBezbednosniElementInfoDto> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-bezbednosni-element/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBezbednosniElementInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBezbednosniElementInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfBezbednosniElementInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfBezbednosniElementInfoDto>;
        }));
    }

    protected processGetBezbednosniElementInfo(response: HttpResponseBase): Observable<ResultOfBezbednosniElementInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBezbednosniElementInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBezbednosniElementInfoDto>(null as any);
    }

    verifikujPodatkeBezbednosnogElementa(): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/verifikuj-podatke-sa-bezbednosnog-elementa";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifikujPodatkeBezbednosnogElementa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifikujPodatkeBezbednosnogElementa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processVerifikujPodatkeBezbednosnogElementa(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getAttention(): Observable<ResultOfEsdcCardStatus> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-attention";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttention(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttention(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfEsdcCardStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfEsdcCardStatus>;
        }));
    }

    protected processGetAttention(response: HttpResponseBase): Observable<ResultOfEsdcCardStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfEsdcCardStatus.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfEsdcCardStatus>(null as any);
    }

    getDailyReport(print?: boolean | undefined, closeDay?: boolean | undefined): Observable<ResultOfInvoiceReportResponse> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-daily-report?";
        if (print === null)
            throw new Error("The parameter 'print' cannot be null.");
        else if (print !== undefined)
            url_ += "print=" + encodeURIComponent("" + print) + "&";
        if (closeDay === null)
            throw new Error("The parameter 'closeDay' cannot be null.");
        else if (closeDay !== undefined)
            url_ += "closeDay=" + encodeURIComponent("" + closeDay) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfInvoiceReportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfInvoiceReportResponse>;
        }));
    }

    protected processGetDailyReport(response: HttpResponseBase): Observable<ResultOfInvoiceReportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfInvoiceReportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfInvoiceReportResponse>(null as any);
    }

    getPeriodicReport(request: GetPeriodicReportQuery): Observable<ResultOfInvoiceReportResponse> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-periodic-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPeriodicReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPeriodicReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfInvoiceReportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfInvoiceReportResponse>;
        }));
    }

    protected processGetPeriodicReport(response: HttpResponseBase): Observable<ResultOfInvoiceReportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfInvoiceReportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfInvoiceReportResponse>(null as any);
    }

    getStatusBezbednosnogElementa(): Observable<ResultOfGetStatusBezbednosnogElementaResponse> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-status-bezbednosnog-elementa";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatusBezbednosnogElementa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatusBezbednosnogElementa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetStatusBezbednosnogElementaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetStatusBezbednosnogElementaResponse>;
        }));
    }

    protected processGetStatusBezbednosnogElementa(response: HttpResponseBase): Observable<ResultOfGetStatusBezbednosnogElementaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetStatusBezbednosnogElementaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetStatusBezbednosnogElementaResponse>(null as any);
    }

    getStatusSertifikataFiskalneKase(): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-status-sertifikata-fiskalne-kase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatusSertifikataFiskalneKase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatusSertifikataFiskalneKase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfBoolean>;
        }));
    }

    protected processGetStatusSertifikataFiskalneKase(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(null as any);
    }

    getReferentniFiskalniRacunAutocomplete(search?: string | null | undefined, invoiceType?: InvoiceType | undefined, transactionType?: TransactionType | undefined): Observable<ResultOfGetReferentniFiskalniRacunAutocompleteResponse> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-referentni-fiskalni-racuni-autocomplete?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (invoiceType === null)
            throw new Error("The parameter 'invoiceType' cannot be null.");
        else if (invoiceType !== undefined)
            url_ += "invoiceType=" + encodeURIComponent("" + invoiceType) + "&";
        if (transactionType === null)
            throw new Error("The parameter 'transactionType' cannot be null.");
        else if (transactionType !== undefined)
            url_ += "transactionType=" + encodeURIComponent("" + transactionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReferentniFiskalniRacunAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReferentniFiskalniRacunAutocomplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetReferentniFiskalniRacunAutocompleteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetReferentniFiskalniRacunAutocompleteResponse>;
        }));
    }

    protected processGetReferentniFiskalniRacunAutocomplete(response: HttpResponseBase): Observable<ResultOfGetReferentniFiskalniRacunAutocompleteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetReferentniFiskalniRacunAutocompleteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetReferentniFiskalniRacunAutocompleteResponse>(null as any);
    }

    getStavkeAvansnogFiskalnogRacuna(): Observable<ResultOfGetStavkeAvansnogFiskalnogVm> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-stavke-avansnog-fiskalnog-racuna";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStavkeAvansnogFiskalnogRacuna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStavkeAvansnogFiskalnogRacuna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetStavkeAvansnogFiskalnogVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetStavkeAvansnogFiskalnogVm>;
        }));
    }

    protected processGetStavkeAvansnogFiskalnogRacuna(response: HttpResponseBase): Observable<ResultOfGetStavkeAvansnogFiskalnogVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetStavkeAvansnogFiskalnogVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetStavkeAvansnogFiskalnogVm>(null as any);
    }

    getLastSignedInvoice(requestId?: string | null | undefined, shouldPrint?: boolean | undefined): Observable<ResultOfInvoiceResponse> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-last-signed-invoice?";
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (shouldPrint === null)
            throw new Error("The parameter 'shouldPrint' cannot be null.");
        else if (shouldPrint !== undefined)
            url_ += "shouldPrint=" + encodeURIComponent("" + shouldPrint) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastSignedInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastSignedInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfInvoiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfInvoiceResponse>;
        }));
    }

    protected processGetLastSignedInvoice(response: HttpResponseBase): Observable<ResultOfInvoiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfInvoiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfInvoiceResponse>(null as any);
    }

    getStavkeRefundacijeFiskalnogRacuna(referentDocumentNumber?: string | null | undefined): Observable<ResultOfGetStavkeRefundacijeFiskalnogVm> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-stavke-refundacije-fiskalnog-racuna?";
        if (referentDocumentNumber !== undefined && referentDocumentNumber !== null)
            url_ += "referentDocumentNumber=" + encodeURIComponent("" + referentDocumentNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStavkeRefundacijeFiskalnogRacuna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStavkeRefundacijeFiskalnogRacuna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetStavkeRefundacijeFiskalnogVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetStavkeRefundacijeFiskalnogVm>;
        }));
    }

    protected processGetStavkeRefundacijeFiskalnogRacuna(response: HttpResponseBase): Observable<ResultOfGetStavkeRefundacijeFiskalnogVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetStavkeRefundacijeFiskalnogVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetStavkeRefundacijeFiskalnogVm>(null as any);
    }

    getReceiptAsImage(requestId?: string | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-receipt-as-image?";
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceiptAsImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceiptAsImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processGetReceiptAsImage(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getReferentniFiskalniRacun(id?: string | null | undefined, jeKreirajAvansRefundaciju?: boolean | undefined): Observable<ResultOfGetReferentniFiskalniRacunResponse> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-referentni-fiskalni-racun?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (jeKreirajAvansRefundaciju === null)
            throw new Error("The parameter 'jeKreirajAvansRefundaciju' cannot be null.");
        else if (jeKreirajAvansRefundaciju !== undefined)
            url_ += "jeKreirajAvansRefundaciju=" + encodeURIComponent("" + jeKreirajAvansRefundaciju) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReferentniFiskalniRacun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReferentniFiskalniRacun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetReferentniFiskalniRacunResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetReferentniFiskalniRacunResponse>;
        }));
    }

    protected processGetReferentniFiskalniRacun(response: HttpResponseBase): Observable<ResultOfGetReferentniFiskalniRacunResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetReferentniFiskalniRacunResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetReferentniFiskalniRacunResponse>(null as any);
    }

    getFiskalniPdf(invoiceResponseId: number, previewTitle: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-fiskalni-pdf/{invoiceResponseId}/{previewTitle}";
        if (invoiceResponseId === undefined || invoiceResponseId === null)
            throw new Error("The parameter 'invoiceResponseId' must be defined.");
        url_ = url_.replace("{invoiceResponseId}", encodeURIComponent("" + invoiceResponseId));
        if (previewTitle === undefined || previewTitle === null)
            throw new Error("The parameter 'previewTitle' must be defined.");
        url_ = url_.replace("{previewTitle}", encodeURIComponent("" + previewTitle));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFiskalniPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFiskalniPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFiskalniPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getSpecifikacijaPdf(invoiceResponseId: number, previewTitle: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-specifikacija-fiskalni-pdf/{invoiceResponseId}/{previewTitle}";
        if (invoiceResponseId === undefined || invoiceResponseId === null)
            throw new Error("The parameter 'invoiceResponseId' must be defined.");
        url_ = url_.replace("{invoiceResponseId}", encodeURIComponent("" + invoiceResponseId));
        if (previewTitle === undefined || previewTitle === null)
            throw new Error("The parameter 'previewTitle' must be defined.");
        url_ = url_.replace("{previewTitle}", encodeURIComponent("" + previewTitle));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecifikacijaPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecifikacijaPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetSpecifikacijaPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getPredefinisaniTekst(): Observable<ResultOfPredefinisaniTekstDto> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-predefinisani-tekst";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPredefinisaniTekst(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPredefinisaniTekst(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfPredefinisaniTekstDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfPredefinisaniTekstDto>;
        }));
    }

    protected processGetPredefinisaniTekst(response: HttpResponseBase): Observable<ResultOfPredefinisaniTekstDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfPredefinisaniTekstDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfPredefinisaniTekstDto>(null as any);
    }

    getOpstaPravilaFiskalna(): Observable<ResultOfOpstaPravilaFiskalniDto> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/opsta-pravila-konfiguracija-fiskalna";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOpstaPravilaFiskalna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOpstaPravilaFiskalna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfOpstaPravilaFiskalniDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfOpstaPravilaFiskalniDto>;
        }));
    }

    protected processGetOpstaPravilaFiskalna(response: HttpResponseBase): Observable<ResultOfOpstaPravilaFiskalniDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfOpstaPravilaFiskalniDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfOpstaPravilaFiskalniDto>(null as any);
    }

    getVelicinaPapira(): Observable<ResultOfGetVelicinaPapiraResponse> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/velicina-papira-fiskalna";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVelicinaPapira(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVelicinaPapira(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetVelicinaPapiraResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetVelicinaPapiraResponse>;
        }));
    }

    protected processGetVelicinaPapira(response: HttpResponseBase): Observable<ResultOfGetVelicinaPapiraResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetVelicinaPapiraResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetVelicinaPapiraResponse>(null as any);
    }

    getTipPostFiskalizacija(): Observable<ResultOfGetTipAkcijeResponse> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/tip-akcije-fiskalizacija";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipPostFiskalizacija(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipPostFiskalizacija(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTipAkcijeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTipAkcijeResponse>;
        }));
    }

    protected processGetTipPostFiskalizacija(response: HttpResponseBase): Observable<ResultOfGetTipAkcijeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTipAkcijeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTipAkcijeResponse>(null as any);
    }

    getJidZaHeader(): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-jid-header";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJidZaHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJidZaHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processGetJidZaHeader(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getFiskalniIsecakStorage(invoiceResponseId: number): Observable<ResultOfRelevantniDokumentListItemUrlDto> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-fiskalni-storage/{invoiceResponseId}";
        if (invoiceResponseId === undefined || invoiceResponseId === null)
            throw new Error("The parameter 'invoiceResponseId' must be defined.");
        url_ = url_.replace("{invoiceResponseId}", encodeURIComponent("" + invoiceResponseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFiskalniIsecakStorage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFiskalniIsecakStorage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfRelevantniDokumentListItemUrlDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfRelevantniDokumentListItemUrlDto>;
        }));
    }

    protected processGetFiskalniIsecakStorage(response: HttpResponseBase): Observable<ResultOfRelevantniDokumentListItemUrlDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfRelevantniDokumentListItemUrlDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfRelevantniDokumentListItemUrlDto>(null as any);
    }

    getStavkeZaAvanse(request: GetProizvodiZaAvanseListQuery): Observable<ResultOfListOfProizvodiZaAvanseMaloprodajaDto> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/get-proizvode-za-avanse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStavkeZaAvanse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStavkeZaAvanse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfProizvodiZaAvanseMaloprodajaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfProizvodiZaAvanseMaloprodajaDto>;
        }));
    }

    protected processGetStavkeZaAvanse(response: HttpResponseBase): Observable<ResultOfListOfProizvodiZaAvanseMaloprodajaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfProizvodiZaAvanseMaloprodajaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfProizvodiZaAvanseMaloprodajaDto>(null as any);
    }

    create(command: CreateFiskalniRacunCommand): Observable<ResultOfFiskalniIsecakPdfData> {
        let url_ = this.baseUrl + "/api/fiskalniracuni";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfFiskalniIsecakPdfData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfFiskalniIsecakPdfData>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfFiskalniIsecakPdfData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfFiskalniIsecakPdfData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfFiskalniIsecakPdfData>(null as any);
    }

    createCopy(id: string): Observable<ResultOfLong> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/create-copy/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfLong>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfLong>;
        }));
    }

    protected processCreateCopy(response: HttpResponseBase): Observable<ResultOfLong> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfLong.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLong>(null as any);
    }

    sendFiskalniRacunToPos(invoiceRequestId?: string | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/send-fiskalni-racun-to-pos?";
        if (invoiceRequestId !== undefined && invoiceRequestId !== null)
            url_ += "invoiceRequestId=" + encodeURIComponent("" + invoiceRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendFiskalniRacunToPos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendFiskalniRacunToPos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSendFiskalniRacunToPos(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    verifyBezbednosniElement(pin?: string | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/verify-bezbednosni-element?";
        if (pin !== undefined && pin !== null)
            url_ += "pin=" + encodeURIComponent("" + pin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyBezbednosniElement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyBezbednosniElement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processVerifyBezbednosniElement(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    initBezbednosniElementBezPoslovneJedinice(bezbednosniElementId?: number | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/create-poslovna-jedinica-from-bezbednosni-element?";
        if (bezbednosniElementId === null)
            throw new Error("The parameter 'bezbednosniElementId' cannot be null.");
        else if (bezbednosniElementId !== undefined)
            url_ += "bezbednosniElementId=" + encodeURIComponent("" + bezbednosniElementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitBezbednosniElementBezPoslovneJedinice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitBezbednosniElementBezPoslovneJedinice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processInitBezbednosniElementBezPoslovneJedinice(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    initBezbednosniElementSaPoslovnomJedinicom(bezbednosniElementId?: number | undefined, poslovnaJedinicaId?: number | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/init-bezbednosni-element-sa-poslovnom-jedinicom?";
        if (bezbednosniElementId === null)
            throw new Error("The parameter 'bezbednosniElementId' cannot be null.");
        else if (bezbednosniElementId !== undefined)
            url_ += "bezbednosniElementId=" + encodeURIComponent("" + bezbednosniElementId) + "&";
        if (poslovnaJedinicaId === null)
            throw new Error("The parameter 'poslovnaJedinicaId' cannot be null.");
        else if (poslovnaJedinicaId !== undefined)
            url_ += "poslovnaJedinicaId=" + encodeURIComponent("" + poslovnaJedinicaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitBezbednosniElementSaPoslovnomJedinicom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitBezbednosniElementSaPoslovnomJedinicom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processInitBezbednosniElementSaPoslovnomJedinicom(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    importSertifikatFiskalneKase(dtoCommand: ImportSertifikatFiskalneKaseDtoCommand): Observable<ResultOfLong> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/import-sertifikat-fiskalne-kase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dtoCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportSertifikatFiskalneKase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportSertifikatFiskalneKase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfLong>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfLong>;
        }));
    }

    protected processImportSertifikatFiskalneKase(response: HttpResponseBase): Observable<ResultOfLong> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfLong.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLong>(null as any);
    }

    uploadSertifikataFiskalneKase(bezbednosniElementId?: number | undefined, file?: FileParameter | null | undefined): Observable<ResultOfLong> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/upload-sertifikat-fiskalne-kase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (bezbednosniElementId === null || bezbednosniElementId === undefined)
            throw new Error("The parameter 'bezbednosniElementId' cannot be null.");
        else
            content_.append("BezbednosniElementId", bezbednosniElementId.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSertifikataFiskalneKase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSertifikataFiskalneKase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfLong>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfLong>;
        }));
    }

    protected processUploadSertifikataFiskalneKase(response: HttpResponseBase): Observable<ResultOfLong> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfLong.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLong>(null as any);
    }

    createEmptyLPFR(request: CreateEmptyBezbednosniElementLPFRCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/create-empty-lpfr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEmptyLPFR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmptyLPFR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreateEmptyLPFR(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    updateBezbednosniElement(request: UpdateBezbednosniElementCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/update-bezbednosni-element";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBezbednosniElement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBezbednosniElement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdateBezbednosniElement(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sendFiskalniElektronski(fromId?: string | undefined, to?: string[] | null | undefined, invoiceResponseId?: number | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/posalji-fiskalni-elektronski";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fromId === null || fromId === undefined)
            throw new Error("The parameter 'fromId' cannot be null.");
        else
            content_.append("FromId", fromId.toString());
        if (to !== null && to !== undefined)
            to.forEach(item_ => content_.append("To", item_.toString()));
        if (invoiceResponseId === null || invoiceResponseId === undefined)
            throw new Error("The parameter 'invoiceResponseId' cannot be null.");
        else
            content_.append("InvoiceResponseId", invoiceResponseId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendFiskalniElektronski(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendFiskalniElektronski(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSendFiskalniElektronski(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    addPredefinisaniTekst(request: AddPredefinisaniTekstCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/predefinisani-tekst-fiskalni";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPredefinisaniTekst(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPredefinisaniTekst(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processAddPredefinisaniTekst(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    updateOpstaPravilaFiskalna(command: UpdateOpstaPravilaFiskalnaCommand): Observable<ResultOfOpstaPravilaFiskalniDto> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/update-opsta-pravila-fikalna";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOpstaPravilaFiskalna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOpstaPravilaFiskalna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfOpstaPravilaFiskalniDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfOpstaPravilaFiskalniDto>;
        }));
    }

    protected processUpdateOpstaPravilaFiskalna(response: HttpResponseBase): Observable<ResultOfOpstaPravilaFiskalniDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfOpstaPravilaFiskalniDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfOpstaPravilaFiskalniDto>(null as any);
    }

    deleteSertifikat(id: number): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/delete-bezbednosni-element/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSertifikat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSertifikat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processDeleteSertifikat(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getUlazniForTable(request: GetUlazniFiskalniRacunTableQuery): Observable<PaginatedResultOfUlazniFiskalniRacunTableDto> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/ulazni/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUlazniForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUlazniForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfUlazniFiskalniRacunTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfUlazniFiskalniRacunTableDto>;
        }));
    }

    protected processGetUlazniForTable(response: HttpResponseBase): Observable<PaginatedResultOfUlazniFiskalniRacunTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfUlazniFiskalniRacunTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfUlazniFiskalniRacunTableDto>(null as any);
    }

    getUlazniFiskalniIsecak(id: number): Observable<ResultOfRelevantniDokumentListItemUrlDto> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/ulazni/get-isecak/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUlazniFiskalniIsecak(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUlazniFiskalniIsecak(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfRelevantniDokumentListItemUrlDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfRelevantniDokumentListItemUrlDto>;
        }));
    }

    protected processGetUlazniFiskalniIsecak(response: HttpResponseBase): Observable<ResultOfRelevantniDokumentListItemUrlDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfRelevantniDokumentListItemUrlDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfRelevantniDokumentListItemUrlDto>(null as any);
    }

    createUlazni(command: CreateUlazniFiskalniRacunCommand): Observable<ResultOfLong> {
        let url_ = this.baseUrl + "/api/fiskalniracuni/ulazni";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUlazni(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUlazni(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfLong>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfLong>;
        }));
    }

    protected processCreateUlazni(response: HttpResponseBase): Observable<ResultOfLong> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfLong.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLong>(null as any);
    }
}

export interface IFizickaLicaClient {
    getForTable(request: GetFizickaLicaTableQuery): Observable<ResultOfGetTableResponseOfFizickoLiceTableDto>;
    getById(id: number): Observable<ResultOfFizickoLiceDto>;
    create(command: CreateFizickoLiceCommand): Observable<ResultOfFizickoLiceVm>;
    update(id: number, command: UpdateFizickoLiceCommand): Observable<ResultOfFizickoLiceVm>;
    delete(id: number): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class FizickaLicaClient implements IFizickaLicaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(request: GetFizickaLicaTableQuery): Observable<ResultOfGetTableResponseOfFizickoLiceTableDto> {
        let url_ = this.baseUrl + "/api/fizickalica/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTableResponseOfFizickoLiceTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTableResponseOfFizickoLiceTableDto>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<ResultOfGetTableResponseOfFizickoLiceTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTableResponseOfFizickoLiceTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTableResponseOfFizickoLiceTableDto>(null as any);
    }

    getById(id: number): Observable<ResultOfFizickoLiceDto> {
        let url_ = this.baseUrl + "/api/fizickalica/by-id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfFizickoLiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfFizickoLiceDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ResultOfFizickoLiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfFizickoLiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfFizickoLiceDto>(null as any);
    }

    create(command: CreateFizickoLiceCommand): Observable<ResultOfFizickoLiceVm> {
        let url_ = this.baseUrl + "/api/fizickalica";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfFizickoLiceVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfFizickoLiceVm>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfFizickoLiceVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfFizickoLiceVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfFizickoLiceVm>(null as any);
    }

    update(id: number, command: UpdateFizickoLiceCommand): Observable<ResultOfFizickoLiceVm> {
        let url_ = this.baseUrl + "/api/fizickalica/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfFizickoLiceVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfFizickoLiceVm>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultOfFizickoLiceVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfFizickoLiceVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfFizickoLiceVm>(null as any);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/fizickalica/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IInfoZgradaClient {
    getStanById(stanId?: number | undefined): Observable<ResultOfStanDto>;
    getStanList(strankaId?: number | undefined): Observable<ResultOfListOfListItemDtoOfLong>;
    createStan(command: CreateStanCommand): Observable<ResultOfString>;
    updateStan(command: UpdateStanCommand): Observable<ResultOfString>;
    deleteStan(id?: number | undefined): Observable<ResultOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class InfoZgradaClient implements IInfoZgradaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getStanById(stanId?: number | undefined): Observable<ResultOfStanDto> {
        let url_ = this.baseUrl + "/api/infozgrada/get-stan?";
        if (stanId === null)
            throw new Error("The parameter 'stanId' cannot be null.");
        else if (stanId !== undefined)
            url_ += "stanId=" + encodeURIComponent("" + stanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStanById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStanById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfStanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfStanDto>;
        }));
    }

    protected processGetStanById(response: HttpResponseBase): Observable<ResultOfStanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfStanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfStanDto>(null as any);
    }

    getStanList(strankaId?: number | undefined): Observable<ResultOfListOfListItemDtoOfLong> {
        let url_ = this.baseUrl + "/api/infozgrada/get-stan-list?";
        if (strankaId === null)
            throw new Error("The parameter 'strankaId' cannot be null.");
        else if (strankaId !== undefined)
            url_ += "strankaId=" + encodeURIComponent("" + strankaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStanList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStanList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfListItemDtoOfLong>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfListItemDtoOfLong>;
        }));
    }

    protected processGetStanList(response: HttpResponseBase): Observable<ResultOfListOfListItemDtoOfLong> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfListItemDtoOfLong.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfListItemDtoOfLong>(null as any);
    }

    createStan(command: CreateStanCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/infozgrada/create-stan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreateStan(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    updateStan(command: UpdateStanCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/infozgrada/update-stan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdateStan(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    deleteStan(id?: number | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/infozgrada/delete-stan?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteStan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteStan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processDeleteStan(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }
}

export interface IInitDataClient {
    init(): Observable<InitVm>;
    getMenuInit(): Observable<ResultOfGetMenuInitResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class InitDataClient implements IInitDataClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    init(): Observable<InitVm> {
        let url_ = this.baseUrl + "/api/initdata/init-test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InitVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InitVm>;
        }));
    }

    protected processInit(response: HttpResponseBase): Observable<InitVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InitVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InitVm>(null as any);
    }

    getMenuInit(): Observable<ResultOfGetMenuInitResponse> {
        let url_ = this.baseUrl + "/api/initdata/menu-init";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMenuInit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMenuInit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetMenuInitResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetMenuInitResponse>;
        }));
    }

    protected processGetMenuInit(response: HttpResponseBase): Observable<ResultOfGetMenuInitResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetMenuInitResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetMenuInitResponse>(null as any);
    }
}

export interface IIzlazneFaktureClient {
    create(command: CreateIzlaznaFakturaCommand): Observable<ResultOfLong>;
    update(id: number, command: UpdateIzlaznaFakturaCommand): Observable<FileResponse>;
    get(request: GetIzlaznaFakturaQuery): Observable<ResultOfIzlaznaFakturaDto>;
    getNewForStranka(strankaId: string): Observable<ResultOfIzlaznaFakturaDto>;
    getNewForPredracun(predracunId: number): Observable<ResultOfIzlaznaFakturaDto>;
    getNewForRadniNalog(racunId: number): Observable<ResultOfIzlaznaFakturaDto>;
    duplicateFaktura(id: number): Observable<ResultOfIzlaznaFakturaDto>;
    getNewForOtpremnice(request: GetNewIzlaznaFakturaForOtpremnicaQuery): Observable<ResultOfIzlaznaFakturaDto>;
    getNewForEPrijemnica(request: GetNewIzlaznaFakturaForPrijemnicaQuery): Observable<ResultOfIzlaznaFakturForPrijemnicaDto>;
    getNewForUplata(request: GetNewIzlaznaFakturaForUplataQuery): Observable<ResultOfIzlaznaFakturaDto>;
    getIzlaznaFakturaForPredracunUplata(request: CreateIzlaznaFakturaForPredracunUplataCommand): Observable<ResultOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class IzlazneFaktureClient implements IIzlazneFaktureClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    create(command: CreateIzlaznaFakturaCommand): Observable<ResultOfLong> {
        let url_ = this.baseUrl + "/api/izlaznefakture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfLong>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfLong>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfLong> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfLong.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLong>(null as any);
    }

    update(id: number, command: UpdateIzlaznaFakturaCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/izlaznefakture/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    get(request: GetIzlaznaFakturaQuery): Observable<ResultOfIzlaznaFakturaDto> {
        let url_ = this.baseUrl + "/api/izlaznefakture/get-izlazna-faktura";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIzlaznaFakturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIzlaznaFakturaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResultOfIzlaznaFakturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIzlaznaFakturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIzlaznaFakturaDto>(null as any);
    }

    getNewForStranka(strankaId: string): Observable<ResultOfIzlaznaFakturaDto> {
        let url_ = this.baseUrl + "/api/izlaznefakture/new-for-stranka/{strankaId}";
        if (strankaId === undefined || strankaId === null)
            throw new Error("The parameter 'strankaId' must be defined.");
        url_ = url_.replace("{strankaId}", encodeURIComponent("" + strankaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewForStranka(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewForStranka(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIzlaznaFakturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIzlaznaFakturaDto>;
        }));
    }

    protected processGetNewForStranka(response: HttpResponseBase): Observable<ResultOfIzlaznaFakturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIzlaznaFakturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIzlaznaFakturaDto>(null as any);
    }

    getNewForPredracun(predracunId: number): Observable<ResultOfIzlaznaFakturaDto> {
        let url_ = this.baseUrl + "/api/izlaznefakture/new-for-predracun/{predracunId}";
        if (predracunId === undefined || predracunId === null)
            throw new Error("The parameter 'predracunId' must be defined.");
        url_ = url_.replace("{predracunId}", encodeURIComponent("" + predracunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewForPredracun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewForPredracun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIzlaznaFakturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIzlaznaFakturaDto>;
        }));
    }

    protected processGetNewForPredracun(response: HttpResponseBase): Observable<ResultOfIzlaznaFakturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIzlaznaFakturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIzlaznaFakturaDto>(null as any);
    }

    getNewForRadniNalog(racunId: number): Observable<ResultOfIzlaznaFakturaDto> {
        let url_ = this.baseUrl + "/api/izlaznefakture/new-for-radni-nalog/{racunId}";
        if (racunId === undefined || racunId === null)
            throw new Error("The parameter 'racunId' must be defined.");
        url_ = url_.replace("{racunId}", encodeURIComponent("" + racunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewForRadniNalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewForRadniNalog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIzlaznaFakturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIzlaznaFakturaDto>;
        }));
    }

    protected processGetNewForRadniNalog(response: HttpResponseBase): Observable<ResultOfIzlaznaFakturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIzlaznaFakturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIzlaznaFakturaDto>(null as any);
    }

    duplicateFaktura(id: number): Observable<ResultOfIzlaznaFakturaDto> {
        let url_ = this.baseUrl + "/api/izlaznefakture/duplicate-faktura/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateFaktura(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateFaktura(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIzlaznaFakturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIzlaznaFakturaDto>;
        }));
    }

    protected processDuplicateFaktura(response: HttpResponseBase): Observable<ResultOfIzlaznaFakturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIzlaznaFakturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIzlaznaFakturaDto>(null as any);
    }

    getNewForOtpremnice(request: GetNewIzlaznaFakturaForOtpremnicaQuery): Observable<ResultOfIzlaznaFakturaDto> {
        let url_ = this.baseUrl + "/api/izlaznefakture/new-for-otpremnice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewForOtpremnice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewForOtpremnice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIzlaznaFakturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIzlaznaFakturaDto>;
        }));
    }

    protected processGetNewForOtpremnice(response: HttpResponseBase): Observable<ResultOfIzlaznaFakturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIzlaznaFakturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIzlaznaFakturaDto>(null as any);
    }

    getNewForEPrijemnica(request: GetNewIzlaznaFakturaForPrijemnicaQuery): Observable<ResultOfIzlaznaFakturForPrijemnicaDto> {
        let url_ = this.baseUrl + "/api/izlaznefakture/new-for-prijemnica";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewForEPrijemnica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewForEPrijemnica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIzlaznaFakturForPrijemnicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIzlaznaFakturForPrijemnicaDto>;
        }));
    }

    protected processGetNewForEPrijemnica(response: HttpResponseBase): Observable<ResultOfIzlaznaFakturForPrijemnicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIzlaznaFakturForPrijemnicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIzlaznaFakturForPrijemnicaDto>(null as any);
    }

    getNewForUplata(request: GetNewIzlaznaFakturaForUplataQuery): Observable<ResultOfIzlaznaFakturaDto> {
        let url_ = this.baseUrl + "/api/izlaznefakture/new-for-uplata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewForUplata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewForUplata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIzlaznaFakturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIzlaznaFakturaDto>;
        }));
    }

    protected processGetNewForUplata(response: HttpResponseBase): Observable<ResultOfIzlaznaFakturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIzlaznaFakturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIzlaznaFakturaDto>(null as any);
    }

    getIzlaznaFakturaForPredracunUplata(request: CreateIzlaznaFakturaForPredracunUplataCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/izlaznefakture/get-izlazna-faktura-for-predracun-uplata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIzlaznaFakturaForPredracunUplata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIzlaznaFakturaForPredracunUplata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processGetIzlaznaFakturaForPredracunUplata(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }
}

export interface IIzmeneOsnovicaClient {
    createDokumentOSmanjenju(command: CreateDokumentOSmanjenjuCommand): Observable<ResultOfCreateUpdateRacunResponse>;
    createDokumentOPovecanju(command: CreateDokumentOPovecanjuCommand): Observable<ResultOfCreateUpdateRacunResponse>;
    updateDokumentOSmanjenju(id: number, command: UpdateDokumentOSmanjenjuCommand): Observable<ResultOfCreateUpdateRacunResponse>;
    updateDokumentOPovecanju(id: number, command: UpdateDokumentOPovecanjuCommand): Observable<ResultOfCreateUpdateRacunResponse>;
    evidentirajDokumentOPromeni(command: EvidentirajDokumentOPromeniCommand): Observable<ResultOfCreateUpdateRacunResponse>;
    getDokumentOSmanjenju(request: GetDokumentOSmanjenjuQuery): Observable<ResultOfDokumentOSmanjenjuDto>;
    getDokumentOPovecanju(request: GetDokumentOPovecanjuQuery): Observable<ResultOfDokumentOPovecanjuDto>;
    getNewDokumentOSmanjenjuForStranka(strankaId: string, vrstaRacuna: VrstaRacuna): Observable<ResultOfDokumentOSmanjenjuDto>;
    getNewDokumentOPovecanjuForStranka(strankaId: string, vrstaRacuna: VrstaRacuna): Observable<ResultOfDokumentOPovecanjuDto>;
}

@Injectable({
    providedIn: 'root'
})
export class IzmeneOsnovicaClient implements IIzmeneOsnovicaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createDokumentOSmanjenju(command: CreateDokumentOSmanjenjuCommand): Observable<ResultOfCreateUpdateRacunResponse> {
        let url_ = this.baseUrl + "/api/izmeneosnovica/dokument-o-smanjenju";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDokumentOSmanjenju(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDokumentOSmanjenju(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCreateUpdateRacunResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCreateUpdateRacunResponse>;
        }));
    }

    protected processCreateDokumentOSmanjenju(response: HttpResponseBase): Observable<ResultOfCreateUpdateRacunResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCreateUpdateRacunResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCreateUpdateRacunResponse>(null as any);
    }

    createDokumentOPovecanju(command: CreateDokumentOPovecanjuCommand): Observable<ResultOfCreateUpdateRacunResponse> {
        let url_ = this.baseUrl + "/api/izmeneosnovica/dokument-o-povecanju";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDokumentOPovecanju(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDokumentOPovecanju(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCreateUpdateRacunResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCreateUpdateRacunResponse>;
        }));
    }

    protected processCreateDokumentOPovecanju(response: HttpResponseBase): Observable<ResultOfCreateUpdateRacunResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCreateUpdateRacunResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCreateUpdateRacunResponse>(null as any);
    }

    updateDokumentOSmanjenju(id: number, command: UpdateDokumentOSmanjenjuCommand): Observable<ResultOfCreateUpdateRacunResponse> {
        let url_ = this.baseUrl + "/api/izmeneosnovica/dokument-o-smanjenju/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDokumentOSmanjenju(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDokumentOSmanjenju(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCreateUpdateRacunResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCreateUpdateRacunResponse>;
        }));
    }

    protected processUpdateDokumentOSmanjenju(response: HttpResponseBase): Observable<ResultOfCreateUpdateRacunResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCreateUpdateRacunResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCreateUpdateRacunResponse>(null as any);
    }

    updateDokumentOPovecanju(id: number, command: UpdateDokumentOPovecanjuCommand): Observable<ResultOfCreateUpdateRacunResponse> {
        let url_ = this.baseUrl + "/api/izmeneosnovica/dokument-o-povecanju/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDokumentOPovecanju(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDokumentOPovecanju(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCreateUpdateRacunResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCreateUpdateRacunResponse>;
        }));
    }

    protected processUpdateDokumentOPovecanju(response: HttpResponseBase): Observable<ResultOfCreateUpdateRacunResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCreateUpdateRacunResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCreateUpdateRacunResponse>(null as any);
    }

    evidentirajDokumentOPromeni(command: EvidentirajDokumentOPromeniCommand): Observable<ResultOfCreateUpdateRacunResponse> {
        let url_ = this.baseUrl + "/api/izmeneosnovica/evidentiraj-dokument-o-promeni";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEvidentirajDokumentOPromeni(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEvidentirajDokumentOPromeni(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCreateUpdateRacunResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCreateUpdateRacunResponse>;
        }));
    }

    protected processEvidentirajDokumentOPromeni(response: HttpResponseBase): Observable<ResultOfCreateUpdateRacunResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCreateUpdateRacunResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCreateUpdateRacunResponse>(null as any);
    }

    getDokumentOSmanjenju(request: GetDokumentOSmanjenjuQuery): Observable<ResultOfDokumentOSmanjenjuDto> {
        let url_ = this.baseUrl + "/api/izmeneosnovica/get-dokument-o-smanjenju";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDokumentOSmanjenju(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDokumentOSmanjenju(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfDokumentOSmanjenjuDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfDokumentOSmanjenjuDto>;
        }));
    }

    protected processGetDokumentOSmanjenju(response: HttpResponseBase): Observable<ResultOfDokumentOSmanjenjuDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfDokumentOSmanjenjuDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfDokumentOSmanjenjuDto>(null as any);
    }

    getDokumentOPovecanju(request: GetDokumentOPovecanjuQuery): Observable<ResultOfDokumentOPovecanjuDto> {
        let url_ = this.baseUrl + "/api/izmeneosnovica/get-dokument-o-povecanju";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDokumentOPovecanju(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDokumentOPovecanju(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfDokumentOPovecanjuDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfDokumentOPovecanjuDto>;
        }));
    }

    protected processGetDokumentOPovecanju(response: HttpResponseBase): Observable<ResultOfDokumentOPovecanjuDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfDokumentOPovecanjuDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfDokumentOPovecanjuDto>(null as any);
    }

    getNewDokumentOSmanjenjuForStranka(strankaId: string, vrstaRacuna: VrstaRacuna): Observable<ResultOfDokumentOSmanjenjuDto> {
        let url_ = this.baseUrl + "/api/izmeneosnovica/new-dokument-o-smanjenju-for-stranka/{strankaId}/{vrstaRacuna}";
        if (strankaId === undefined || strankaId === null)
            throw new Error("The parameter 'strankaId' must be defined.");
        url_ = url_.replace("{strankaId}", encodeURIComponent("" + strankaId));
        if (vrstaRacuna === undefined || vrstaRacuna === null)
            throw new Error("The parameter 'vrstaRacuna' must be defined.");
        url_ = url_.replace("{vrstaRacuna}", encodeURIComponent("" + vrstaRacuna));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewDokumentOSmanjenjuForStranka(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewDokumentOSmanjenjuForStranka(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfDokumentOSmanjenjuDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfDokumentOSmanjenjuDto>;
        }));
    }

    protected processGetNewDokumentOSmanjenjuForStranka(response: HttpResponseBase): Observable<ResultOfDokumentOSmanjenjuDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfDokumentOSmanjenjuDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfDokumentOSmanjenjuDto>(null as any);
    }

    getNewDokumentOPovecanjuForStranka(strankaId: string, vrstaRacuna: VrstaRacuna): Observable<ResultOfDokumentOPovecanjuDto> {
        let url_ = this.baseUrl + "/api/izmeneosnovica/new-dokument-o-povecanju-for-stranka/{strankaId}/{vrstaRacuna}";
        if (strankaId === undefined || strankaId === null)
            throw new Error("The parameter 'strankaId' must be defined.");
        url_ = url_.replace("{strankaId}", encodeURIComponent("" + strankaId));
        if (vrstaRacuna === undefined || vrstaRacuna === null)
            throw new Error("The parameter 'vrstaRacuna' must be defined.");
        url_ = url_.replace("{vrstaRacuna}", encodeURIComponent("" + vrstaRacuna));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewDokumentOPovecanjuForStranka(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewDokumentOPovecanjuForStranka(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfDokumentOPovecanjuDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfDokumentOPovecanjuDto>;
        }));
    }

    protected processGetNewDokumentOPovecanjuForStranka(response: HttpResponseBase): Observable<ResultOfDokumentOPovecanjuDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfDokumentOPovecanjuDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfDokumentOPovecanjuDto>(null as any);
    }
}

export interface IIzvestajiClient {
    getForTable(pageSize?: number | null | undefined): Observable<ResultOfGetKpoTableResponse>;
    getKpoPdf(godina?: number | undefined): Observable<FileResponse>;
    getForTableIos(request: GetIosTableQuery): Observable<PaginatedResultOfIosRacunDto>;
    getIosPdf(godina?: number | undefined): Observable<FileResponse>;
    getDnevniIzvestajMaloprodaja(request: GetDnevniIzvestajMaloprodajaQuery): Observable<ResultOfMaloprodajaIzvestajDto>;
    getIzvestajPoArtiklimaMaloprodaja(request: GetIzvestajPoArtiklimaMaloprodajaQuery): Observable<ResultOfListOfIzvestajPoArtiklimaTableDto>;
    getIzvestajIzlaznihVeleprodaja(request: GetIzvestajIzlaznihDokumenataQuery): Observable<ResultOfListOfIzvestajIzlaznihDokumenataDto>;
    getIzvestajIzlaznihDokumenataPdf(request: GetIzvestajIzlaznihDokumenataPdfQuery): Observable<FileResponse>;
    getIzvestajPoNacinuPlacanjaPdf(request: GetDnevniIzvestajMaloprodajaPdfQuery): Observable<FileResponse>;
    getIzvestajPoArtiklimaPdf(request: GetIzvestajPoArtiklimaMaloprodajaPdfQuery): Observable<FileResponse>;
    getProdajaPoMagacinima(request: GetProdajaPoMagacinimaQuery): Observable<ResultOfProdajaPoMagacinimaDto>;
    getProdajaPoMagacinimaPdf(request: GetProdajaPoMagacinimaPdfQuery): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class IzvestajiClient implements IIzvestajiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(pageSize?: number | null | undefined): Observable<ResultOfGetKpoTableResponse> {
        let url_ = this.baseUrl + "/api/izvestaji/get-for-table?";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetKpoTableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetKpoTableResponse>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<ResultOfGetKpoTableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetKpoTableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetKpoTableResponse>(null as any);
    }

    getKpoPdf(godina?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/izvestaji/get-kpo-pdf?";
        if (godina === null)
            throw new Error("The parameter 'godina' cannot be null.");
        else if (godina !== undefined)
            url_ += "godina=" + encodeURIComponent("" + godina) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKpoPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKpoPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetKpoPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getForTableIos(request: GetIosTableQuery): Observable<PaginatedResultOfIosRacunDto> {
        let url_ = this.baseUrl + "/api/izvestaji/get-for-table-ios";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTableIos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTableIos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfIosRacunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfIosRacunDto>;
        }));
    }

    protected processGetForTableIos(response: HttpResponseBase): Observable<PaginatedResultOfIosRacunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfIosRacunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfIosRacunDto>(null as any);
    }

    getIosPdf(godina?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/izvestaji/get-ios-pdf?";
        if (godina === null)
            throw new Error("The parameter 'godina' cannot be null.");
        else if (godina !== undefined)
            url_ += "godina=" + encodeURIComponent("" + godina) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIosPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIosPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetIosPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getDnevniIzvestajMaloprodaja(request: GetDnevniIzvestajMaloprodajaQuery): Observable<ResultOfMaloprodajaIzvestajDto> {
        let url_ = this.baseUrl + "/api/izvestaji/get-izvestaj-maloprodaja";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDnevniIzvestajMaloprodaja(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDnevniIzvestajMaloprodaja(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfMaloprodajaIzvestajDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfMaloprodajaIzvestajDto>;
        }));
    }

    protected processGetDnevniIzvestajMaloprodaja(response: HttpResponseBase): Observable<ResultOfMaloprodajaIzvestajDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfMaloprodajaIzvestajDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfMaloprodajaIzvestajDto>(null as any);
    }

    getIzvestajPoArtiklimaMaloprodaja(request: GetIzvestajPoArtiklimaMaloprodajaQuery): Observable<ResultOfListOfIzvestajPoArtiklimaTableDto> {
        let url_ = this.baseUrl + "/api/izvestaji/get-izvestaj-maloprodaja-artikli";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIzvestajPoArtiklimaMaloprodaja(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIzvestajPoArtiklimaMaloprodaja(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfIzvestajPoArtiklimaTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfIzvestajPoArtiklimaTableDto>;
        }));
    }

    protected processGetIzvestajPoArtiklimaMaloprodaja(response: HttpResponseBase): Observable<ResultOfListOfIzvestajPoArtiklimaTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfIzvestajPoArtiklimaTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfIzvestajPoArtiklimaTableDto>(null as any);
    }

    getIzvestajIzlaznihVeleprodaja(request: GetIzvestajIzlaznihDokumenataQuery): Observable<ResultOfListOfIzvestajIzlaznihDokumenataDto> {
        let url_ = this.baseUrl + "/api/izvestaji/get-izvestaj-izlazni-veleprodaja";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIzvestajIzlaznihVeleprodaja(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIzvestajIzlaznihVeleprodaja(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfIzvestajIzlaznihDokumenataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfIzvestajIzlaznihDokumenataDto>;
        }));
    }

    protected processGetIzvestajIzlaznihVeleprodaja(response: HttpResponseBase): Observable<ResultOfListOfIzvestajIzlaznihDokumenataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfIzvestajIzlaznihDokumenataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfIzvestajIzlaznihDokumenataDto>(null as any);
    }

    getIzvestajIzlaznihDokumenataPdf(request: GetIzvestajIzlaznihDokumenataPdfQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/izvestaji/get-izvestaj-izlaznih-pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIzvestajIzlaznihDokumenataPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIzvestajIzlaznihDokumenataPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetIzvestajIzlaznihDokumenataPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getIzvestajPoNacinuPlacanjaPdf(request: GetDnevniIzvestajMaloprodajaPdfQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/izvestaji/get-izvestaj-po-nacinu-placanja-pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIzvestajPoNacinuPlacanjaPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIzvestajPoNacinuPlacanjaPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetIzvestajPoNacinuPlacanjaPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getIzvestajPoArtiklimaPdf(request: GetIzvestajPoArtiklimaMaloprodajaPdfQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/izvestaji/get-izvestaj-po-artiklima-pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIzvestajPoArtiklimaPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIzvestajPoArtiklimaPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetIzvestajPoArtiklimaPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getProdajaPoMagacinima(request: GetProdajaPoMagacinimaQuery): Observable<ResultOfProdajaPoMagacinimaDto> {
        let url_ = this.baseUrl + "/api/izvestaji/get-prodaja-po-magacinima";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProdajaPoMagacinima(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProdajaPoMagacinima(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfProdajaPoMagacinimaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfProdajaPoMagacinimaDto>;
        }));
    }

    protected processGetProdajaPoMagacinima(response: HttpResponseBase): Observable<ResultOfProdajaPoMagacinimaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfProdajaPoMagacinimaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfProdajaPoMagacinimaDto>(null as any);
    }

    getProdajaPoMagacinimaPdf(request: GetProdajaPoMagacinimaPdfQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/izvestaji/get-prodaja-po-magacinima-pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProdajaPoMagacinimaPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProdajaPoMagacinimaPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetProdajaPoMagacinimaPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IIzvodiClient {
    getForTable(request: GetIzvodTableQuery): Observable<ResultOfGetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto>;
    get(id: number): Observable<ResultOfIzvodDto>;
    getUplate(request: GetUplateQuery): Observable<PaginatedResultOfUplataTableDtoAndUplateIsplateSummaryDto>;
    getIsplate(request: GetIsplateQuery): Observable<PaginatedResultOfIsplataTableDtoAndUplateIsplateSummaryDto>;
    getIzvodFajlIzvorDropdown(): Observable<ResultOfGetIzvodFajlIzvorDropdownResponse>;
    obradiIzvod(id: number): Observable<ResultOfIzvodDto>;
    obradiTransakcijeIzvoda(request: ObradiTransakcijeIzvodaCommand): Observable<ResultOfString>;
    importXmlIzvode(files?: FileParameter[] | null | undefined, banka?: BankaIzvoda | null | undefined, brojIzvoda?: string | null | undefined, tekuciRacunId?: number | null | undefined, bankaId?: number | null | undefined): Observable<ResultOfString>;
    importCsvIzvode(files?: FileParameter[] | null | undefined, banka?: BankaIzvoda | null | undefined, brojIzvoda?: string | null | undefined, tekuciRacunId?: number | null | undefined, bankaId?: number | null | undefined): Observable<ResultOfString>;
    evidentirajUplatu(command: EvidentirajUplatuCommand): Observable<ResultOfUplataTableDto>;
    ponistiEvidentiranuUplatu(command: PonistiEvidentiranuUplatuCommand): Observable<ResultOfUplataTableDto>;
    evidentirajIsplatu(command: EvidentirajIsplatuCommand): Observable<ResultOfIsplataTableDto>;
    dodajIzvodManuelno(command: DodajIzvodManuelnoCommand): Observable<ResultOfString>;
    dodajTransakcijuManuelno(command: DodajTransakcijuManuelnoCommand): Observable<ResultOfDecimal>;
}

@Injectable({
    providedIn: 'root'
})
export class IzvodiClient implements IIzvodiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(request: GetIzvodTableQuery): Observable<ResultOfGetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto> {
        let url_ = this.baseUrl + "/api/izvodi/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<ResultOfGetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto>(null as any);
    }

    get(id: number): Observable<ResultOfIzvodDto> {
        let url_ = this.baseUrl + "/api/izvodi/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIzvodDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIzvodDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResultOfIzvodDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIzvodDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIzvodDto>(null as any);
    }

    getUplate(request: GetUplateQuery): Observable<PaginatedResultOfUplataTableDtoAndUplateIsplateSummaryDto> {
        let url_ = this.baseUrl + "/api/izvodi/get-uplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfUplataTableDtoAndUplateIsplateSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfUplataTableDtoAndUplateIsplateSummaryDto>;
        }));
    }

    protected processGetUplate(response: HttpResponseBase): Observable<PaginatedResultOfUplataTableDtoAndUplateIsplateSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfUplataTableDtoAndUplateIsplateSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfUplataTableDtoAndUplateIsplateSummaryDto>(null as any);
    }

    getIsplate(request: GetIsplateQuery): Observable<PaginatedResultOfIsplataTableDtoAndUplateIsplateSummaryDto> {
        let url_ = this.baseUrl + "/api/izvodi/get-isplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIsplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIsplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfIsplataTableDtoAndUplateIsplateSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfIsplataTableDtoAndUplateIsplateSummaryDto>;
        }));
    }

    protected processGetIsplate(response: HttpResponseBase): Observable<PaginatedResultOfIsplataTableDtoAndUplateIsplateSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfIsplataTableDtoAndUplateIsplateSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfIsplataTableDtoAndUplateIsplateSummaryDto>(null as any);
    }

    getIzvodFajlIzvorDropdown(): Observable<ResultOfGetIzvodFajlIzvorDropdownResponse> {
        let url_ = this.baseUrl + "/api/izvodi/get-izvod-fajl-izvor-drowpdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIzvodFajlIzvorDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIzvodFajlIzvorDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetIzvodFajlIzvorDropdownResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetIzvodFajlIzvorDropdownResponse>;
        }));
    }

    protected processGetIzvodFajlIzvorDropdown(response: HttpResponseBase): Observable<ResultOfGetIzvodFajlIzvorDropdownResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetIzvodFajlIzvorDropdownResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetIzvodFajlIzvorDropdownResponse>(null as any);
    }

    obradiIzvod(id: number): Observable<ResultOfIzvodDto> {
        let url_ = this.baseUrl + "/api/izvodi/obrada/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObradiIzvod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObradiIzvod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIzvodDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIzvodDto>;
        }));
    }

    protected processObradiIzvod(response: HttpResponseBase): Observable<ResultOfIzvodDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIzvodDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIzvodDto>(null as any);
    }

    obradiTransakcijeIzvoda(request: ObradiTransakcijeIzvodaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/izvodi/obrada-transakcija";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObradiTransakcijeIzvoda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObradiTransakcijeIzvoda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processObradiTransakcijeIzvoda(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    importXmlIzvode(files?: FileParameter[] | null | undefined, banka?: BankaIzvoda | null | undefined, brojIzvoda?: string | null | undefined, tekuciRacunId?: number | null | undefined, bankaId?: number | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/izvodi/import-xml";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (banka !== null && banka !== undefined)
            content_.append("Banka", banka.toString());
        if (brojIzvoda !== null && brojIzvoda !== undefined)
            content_.append("BrojIzvoda", brojIzvoda.toString());
        if (tekuciRacunId !== null && tekuciRacunId !== undefined)
            content_.append("TekuciRacunId", tekuciRacunId.toString());
        if (bankaId !== null && bankaId !== undefined)
            content_.append("BankaId", bankaId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportXmlIzvode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportXmlIzvode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processImportXmlIzvode(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    importCsvIzvode(files?: FileParameter[] | null | undefined, banka?: BankaIzvoda | null | undefined, brojIzvoda?: string | null | undefined, tekuciRacunId?: number | null | undefined, bankaId?: number | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/izvodi/import-csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (banka !== null && banka !== undefined)
            content_.append("Banka", banka.toString());
        if (brojIzvoda !== null && brojIzvoda !== undefined)
            content_.append("BrojIzvoda", brojIzvoda.toString());
        if (tekuciRacunId !== null && tekuciRacunId !== undefined)
            content_.append("TekuciRacunId", tekuciRacunId.toString());
        if (bankaId !== null && bankaId !== undefined)
            content_.append("BankaId", bankaId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportCsvIzvode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportCsvIzvode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processImportCsvIzvode(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    evidentirajUplatu(command: EvidentirajUplatuCommand): Observable<ResultOfUplataTableDto> {
        let url_ = this.baseUrl + "/api/izvodi/evidentiranje-uplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEvidentirajUplatu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEvidentirajUplatu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfUplataTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfUplataTableDto>;
        }));
    }

    protected processEvidentirajUplatu(response: HttpResponseBase): Observable<ResultOfUplataTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfUplataTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfUplataTableDto>(null as any);
    }

    ponistiEvidentiranuUplatu(command: PonistiEvidentiranuUplatuCommand): Observable<ResultOfUplataTableDto> {
        let url_ = this.baseUrl + "/api/izvodi/ponisti-evidentiranu-uplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPonistiEvidentiranuUplatu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPonistiEvidentiranuUplatu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfUplataTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfUplataTableDto>;
        }));
    }

    protected processPonistiEvidentiranuUplatu(response: HttpResponseBase): Observable<ResultOfUplataTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfUplataTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfUplataTableDto>(null as any);
    }

    evidentirajIsplatu(command: EvidentirajIsplatuCommand): Observable<ResultOfIsplataTableDto> {
        let url_ = this.baseUrl + "/api/izvodi/evidentiranje-isplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEvidentirajIsplatu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEvidentirajIsplatu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIsplataTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIsplataTableDto>;
        }));
    }

    protected processEvidentirajIsplatu(response: HttpResponseBase): Observable<ResultOfIsplataTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIsplataTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIsplataTableDto>(null as any);
    }

    dodajIzvodManuelno(command: DodajIzvodManuelnoCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/izvodi/create-izvod-manuelno";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDodajIzvodManuelno(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDodajIzvodManuelno(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processDodajIzvodManuelno(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    dodajTransakcijuManuelno(command: DodajTransakcijuManuelnoCommand): Observable<ResultOfDecimal> {
        let url_ = this.baseUrl + "/api/izvodi/create-transkacija-manuelno";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDodajTransakcijuManuelno(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDodajTransakcijuManuelno(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfDecimal>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfDecimal>;
        }));
    }

    protected processDodajTransakcijuManuelno(response: HttpResponseBase): Observable<ResultOfDecimal> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfDecimal.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfDecimal>(null as any);
    }
}

export interface IJediniceMeraClient {
    getForTable(): Observable<ResultOfGetJediniceMeraResponse>;
    get(id?: number | null | undefined): Observable<JediniceMeraVm>;
    create(command: CreateJedinicaMereCommand): Observable<JedinicaMereTableDto>;
    update(command: UpdateJedinicaMereCommand, id?: number | undefined): Observable<JedinicaMereTableDto>;
    delete(id?: number | undefined): Observable<FileResponse>;
    getJedinicaMereDropdown(): Observable<ResultOfGetJedinicaMereDropdownResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class JediniceMeraClient implements IJediniceMeraClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(): Observable<ResultOfGetJediniceMeraResponse> {
        let url_ = this.baseUrl + "/api/jedinicemera/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetJediniceMeraResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetJediniceMeraResponse>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<ResultOfGetJediniceMeraResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetJediniceMeraResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetJediniceMeraResponse>(null as any);
    }

    get(id?: number | null | undefined): Observable<JediniceMeraVm> {
        let url_ = this.baseUrl + "/api/jedinicemera?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JediniceMeraVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JediniceMeraVm>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<JediniceMeraVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JediniceMeraVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JediniceMeraVm>(null as any);
    }

    create(command: CreateJedinicaMereCommand): Observable<JedinicaMereTableDto> {
        let url_ = this.baseUrl + "/api/jedinicemera";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JedinicaMereTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JedinicaMereTableDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<JedinicaMereTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JedinicaMereTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JedinicaMereTableDto>(null as any);
    }

    update(command: UpdateJedinicaMereCommand, id?: number | undefined): Observable<JedinicaMereTableDto> {
        let url_ = this.baseUrl + "/api/jedinicemera?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JedinicaMereTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JedinicaMereTableDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<JedinicaMereTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JedinicaMereTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JedinicaMereTableDto>(null as any);
    }

    delete(id?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/jedinicemera?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getJedinicaMereDropdown(): Observable<ResultOfGetJedinicaMereDropdownResponse> {
        let url_ = this.baseUrl + "/api/jedinicemera/get-jm-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJedinicaMereDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJedinicaMereDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetJedinicaMereDropdownResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetJedinicaMereDropdownResponse>;
        }));
    }

    protected processGetJedinicaMereDropdown(response: HttpResponseBase): Observable<ResultOfGetJedinicaMereDropdownResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetJedinicaMereDropdownResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetJedinicaMereDropdownResponse>(null as any);
    }
}

export interface IKalkulacijeClient {
    getForTable(request: GetKalkulacijaTableQuery): Observable<PaginatedResultOfKalkulacijaTableDto>;
    getKalkulacijaPdf(kalkulacijaId: number, previewTitle: string): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class KalkulacijeClient implements IKalkulacijeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(request: GetKalkulacijaTableQuery): Observable<PaginatedResultOfKalkulacijaTableDto> {
        let url_ = this.baseUrl + "/api/kalkulacije/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfKalkulacijaTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfKalkulacijaTableDto>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<PaginatedResultOfKalkulacijaTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfKalkulacijaTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfKalkulacijaTableDto>(null as any);
    }

    getKalkulacijaPdf(kalkulacijaId: number, previewTitle: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/kalkulacije/get-kalkulacija-pdf/{kalkulacijaId}/{previewTitle}";
        if (kalkulacijaId === undefined || kalkulacijaId === null)
            throw new Error("The parameter 'kalkulacijaId' must be defined.");
        url_ = url_.replace("{kalkulacijaId}", encodeURIComponent("" + kalkulacijaId));
        if (previewTitle === undefined || previewTitle === null)
            throw new Error("The parameter 'previewTitle' must be defined.");
        url_ = url_.replace("{previewTitle}", encodeURIComponent("" + previewTitle));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKalkulacijaPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKalkulacijaPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetKalkulacijaPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IKompenzacijeClient {
    getForTable(request: GetKompenzacijaTableQuery): Observable<PaginatedResultOfKompenzacijaTableDto>;
    getKompenzacijaById(id: number): Observable<ResultOfKompenzacijaDto>;
    create(command: CreateKompenzacijuCommand): Observable<ResultOfKompenzacijaDto>;
    updateKompenzaciju(command: UpdateKompenzacijuCommand): Observable<ResultOfString>;
    getKompenzacijaPdf(kompenzacijaId: number, previewName: string): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class KompenzacijeClient implements IKompenzacijeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(request: GetKompenzacijaTableQuery): Observable<PaginatedResultOfKompenzacijaTableDto> {
        let url_ = this.baseUrl + "/api/kompenzacije/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfKompenzacijaTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfKompenzacijaTableDto>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<PaginatedResultOfKompenzacijaTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfKompenzacijaTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfKompenzacijaTableDto>(null as any);
    }

    getKompenzacijaById(id: number): Observable<ResultOfKompenzacijaDto> {
        let url_ = this.baseUrl + "/api/kompenzacije/by-id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKompenzacijaById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKompenzacijaById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfKompenzacijaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfKompenzacijaDto>;
        }));
    }

    protected processGetKompenzacijaById(response: HttpResponseBase): Observable<ResultOfKompenzacijaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfKompenzacijaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfKompenzacijaDto>(null as any);
    }

    create(command: CreateKompenzacijuCommand): Observable<ResultOfKompenzacijaDto> {
        let url_ = this.baseUrl + "/api/kompenzacije/create-kompenzacija";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfKompenzacijaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfKompenzacijaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfKompenzacijaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfKompenzacijaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfKompenzacijaDto>(null as any);
    }

    updateKompenzaciju(command: UpdateKompenzacijuCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/kompenzacije/update-kompenzacija";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateKompenzaciju(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateKompenzaciju(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdateKompenzaciju(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getKompenzacijaPdf(kompenzacijaId: number, previewName: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/kompenzacije/get-kompenzacija-pdf/{kompenzacijaId}/{previewName}";
        if (kompenzacijaId === undefined || kompenzacijaId === null)
            throw new Error("The parameter 'kompenzacijaId' must be defined.");
        url_ = url_.replace("{kompenzacijaId}", encodeURIComponent("" + kompenzacijaId));
        if (previewName === undefined || previewName === null)
            throw new Error("The parameter 'previewName' must be defined.");
        url_ = url_.replace("{previewName}", encodeURIComponent("" + previewName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKompenzacijaPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKompenzacijaPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetKompenzacijaPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IKontaktiClient {
    getForTable(strankaId?: number | null | undefined): Observable<ResultOfKontaktiTableVm>;
    getForList(strankaId?: number | undefined): Observable<ResultOfListOfListItemDtoOfLong>;
    getById(id: number): Observable<ResultOfKontaktDto>;
    getKontaktiByStrankaId(id?: number | undefined): Observable<ResultOfGetKontaktiOdStrankaResponse>;
    create(command: CreateKontaktCommand): Observable<ResultOfKontaktDto>;
    update(id: number, command: UpdateKontaktCommand): Observable<ResultOfKontaktDto>;
    delete(id: number): Observable<FileResponse>;
    createKontaktFromEmail(command: CreateKontaktFromEmailCommand): Observable<ResultOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class KontaktiClient implements IKontaktiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(strankaId?: number | null | undefined): Observable<ResultOfKontaktiTableVm> {
        let url_ = this.baseUrl + "/api/kontakti/get-for-table?";
        if (strankaId !== undefined && strankaId !== null)
            url_ += "strankaId=" + encodeURIComponent("" + strankaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfKontaktiTableVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfKontaktiTableVm>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<ResultOfKontaktiTableVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfKontaktiTableVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfKontaktiTableVm>(null as any);
    }

    getForList(strankaId?: number | undefined): Observable<ResultOfListOfListItemDtoOfLong> {
        let url_ = this.baseUrl + "/api/kontakti/get-for-list?";
        if (strankaId === null)
            throw new Error("The parameter 'strankaId' cannot be null.");
        else if (strankaId !== undefined)
            url_ += "strankaId=" + encodeURIComponent("" + strankaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfListItemDtoOfLong>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfListItemDtoOfLong>;
        }));
    }

    protected processGetForList(response: HttpResponseBase): Observable<ResultOfListOfListItemDtoOfLong> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfListItemDtoOfLong.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfListItemDtoOfLong>(null as any);
    }

    getById(id: number): Observable<ResultOfKontaktDto> {
        let url_ = this.baseUrl + "/api/kontakti/by-id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfKontaktDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfKontaktDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ResultOfKontaktDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfKontaktDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfKontaktDto>(null as any);
    }

    getKontaktiByStrankaId(id?: number | undefined): Observable<ResultOfGetKontaktiOdStrankaResponse> {
        let url_ = this.baseUrl + "/api/kontakti/get-kontakti-stranka?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKontaktiByStrankaId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKontaktiByStrankaId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetKontaktiOdStrankaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetKontaktiOdStrankaResponse>;
        }));
    }

    protected processGetKontaktiByStrankaId(response: HttpResponseBase): Observable<ResultOfGetKontaktiOdStrankaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetKontaktiOdStrankaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetKontaktiOdStrankaResponse>(null as any);
    }

    create(command: CreateKontaktCommand): Observable<ResultOfKontaktDto> {
        let url_ = this.baseUrl + "/api/kontakti";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfKontaktDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfKontaktDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfKontaktDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfKontaktDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfKontaktDto>(null as any);
    }

    update(id: number, command: UpdateKontaktCommand): Observable<ResultOfKontaktDto> {
        let url_ = this.baseUrl + "/api/kontakti/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfKontaktDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfKontaktDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultOfKontaktDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfKontaktDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfKontaktDto>(null as any);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/kontakti/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    createKontaktFromEmail(command: CreateKontaktFromEmailCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/kontakti/create-kontakt-from-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateKontaktFromEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateKontaktFromEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreateKontaktFromEmail(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }
}

export interface IKorisniciClient {
    update(id: string, command: UpdateKorisnikCommand): Observable<ResultOfKorisnikTableDto>;
    resetPassword(command: ResetPasswordKorisnikCommand): Observable<FileResponse>;
    createKorisnickaGrupa(command: CreateKorisnickaGrupaCommand): Observable<ResultOfString>;
    updateKorisnickaGrupa(id: string, command: UpdateKorisnickaGrupaCommand): Observable<ResultOfString>;
    deleteKorisnickaGrupa(id: string): Observable<ResultOfString>;
    getForTable(): Observable<ResultOfKorisnikTableDtoResponse>;
    getKorisnickaGrupaList(): Observable<ResultOfGetKorisnickaGrupaListResponse>;
    getKorisnikeZaGrupu(nazivGrupe: string): Observable<ResultOfGetKorisnickeZaGrupuResponse>;
    getKorisnikAutocomplete(searchValue: string, roleNames?: string[] | null | undefined): Observable<ResultOfGetKorisnikAutocompleteResponse>;
    get(request: GetKorisnikQuery): Observable<ResultOfKorisnikDto>;
    confirmEmail(userId?: string | null | undefined, code?: string | null | undefined, tenantKey?: string | null | undefined): Observable<FileResponse>;
    inviteUser(command: InviteKorisnikCommand): Observable<ResultOfString>;
    getKorisnikTenantAccesses(korisnikEmail?: string | null | undefined): Observable<ResultOfGetKorisnikTenantAccessResponse>;
    getKorisnickaGrupa(id?: string | null | undefined): Observable<ResultOfKorisnickaGrupaDto>;
    getOvlascenja(): Observable<ResultOfGetOvlascenjaResponse>;
    getKorisnickaGrupaDropdown(): Observable<ResultOfGetKorisnickaGrupaDropdownResponse>;
    getJePrviLogin(): Observable<ResultOfBoolean>;
    setRating(rating?: number | undefined): Observable<FileResponse>;
    checkIfRatingExists(): Observable<ResultOfBoolean>;
    sendVerificationEmail(command: SendVerificationEmailCommand): Observable<FileResponse>;
    changeActivity(command: ChangeActivityCommand): Observable<ResultOfString>;
    sendConfirmationCode(command: SendSmsConfirmationCodeKorisnikCommand): Observable<FileResponse>;
    confirmPhone(command: ConfirmPhoneCommand): Observable<FileResponse>;
    addKorisnikeToGrupa(command: AddKorisnikeToGrupaCommand): Observable<ResultOfString>;
    removeKorisnikFromGrupa(command: RemoveKorisnikFromGrupaCommand): Observable<ResultOfString>;
    prviLoginKorisnik(command: PrviLoginKorisnikCommand): Observable<ResultOfString>;
    logoutUser(sessionId?: string | null | undefined): Observable<ResultOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class KorisniciClient implements IKorisniciClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    update(id: string, command: UpdateKorisnikCommand): Observable<ResultOfKorisnikTableDto> {
        let url_ = this.baseUrl + "/api/korisnici/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfKorisnikTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfKorisnikTableDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultOfKorisnikTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfKorisnikTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfKorisnikTableDto>(null as any);
    }

    resetPassword(command: ResetPasswordKorisnikCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/korisnici/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    createKorisnickaGrupa(command: CreateKorisnickaGrupaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/korisnici/create-role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateKorisnickaGrupa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateKorisnickaGrupa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreateKorisnickaGrupa(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    updateKorisnickaGrupa(id: string, command: UpdateKorisnickaGrupaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/korisnici/update-role/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateKorisnickaGrupa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateKorisnickaGrupa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdateKorisnickaGrupa(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    deleteKorisnickaGrupa(id: string): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/korisnici/delete-role/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteKorisnickaGrupa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteKorisnickaGrupa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processDeleteKorisnickaGrupa(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getForTable(): Observable<ResultOfKorisnikTableDtoResponse> {
        let url_ = this.baseUrl + "/api/korisnici/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfKorisnikTableDtoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfKorisnikTableDtoResponse>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<ResultOfKorisnikTableDtoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfKorisnikTableDtoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfKorisnikTableDtoResponse>(null as any);
    }

    getKorisnickaGrupaList(): Observable<ResultOfGetKorisnickaGrupaListResponse> {
        let url_ = this.baseUrl + "/api/korisnici/get-korisnicke-grupe-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKorisnickaGrupaList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKorisnickaGrupaList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetKorisnickaGrupaListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetKorisnickaGrupaListResponse>;
        }));
    }

    protected processGetKorisnickaGrupaList(response: HttpResponseBase): Observable<ResultOfGetKorisnickaGrupaListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetKorisnickaGrupaListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetKorisnickaGrupaListResponse>(null as any);
    }

    getKorisnikeZaGrupu(nazivGrupe: string): Observable<ResultOfGetKorisnickeZaGrupuResponse> {
        let url_ = this.baseUrl + "/api/korisnici/get-korisnike-za-grupu/{nazivGrupe}";
        if (nazivGrupe === undefined || nazivGrupe === null)
            throw new Error("The parameter 'nazivGrupe' must be defined.");
        url_ = url_.replace("{nazivGrupe}", encodeURIComponent("" + nazivGrupe));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKorisnikeZaGrupu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKorisnikeZaGrupu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetKorisnickeZaGrupuResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetKorisnickeZaGrupuResponse>;
        }));
    }

    protected processGetKorisnikeZaGrupu(response: HttpResponseBase): Observable<ResultOfGetKorisnickeZaGrupuResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetKorisnickeZaGrupuResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetKorisnickeZaGrupuResponse>(null as any);
    }

    getKorisnikAutocomplete(searchValue: string, roleNames?: string[] | null | undefined): Observable<ResultOfGetKorisnikAutocompleteResponse> {
        let url_ = this.baseUrl + "/api/korisnici/search/{searchValue}?";
        if (searchValue === undefined || searchValue === null)
            throw new Error("The parameter 'searchValue' must be defined.");
        url_ = url_.replace("{searchValue}", encodeURIComponent("" + searchValue));
        if (roleNames !== undefined && roleNames !== null)
            roleNames && roleNames.forEach(item => { url_ += "roleNames=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKorisnikAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKorisnikAutocomplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetKorisnikAutocompleteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetKorisnikAutocompleteResponse>;
        }));
    }

    protected processGetKorisnikAutocomplete(response: HttpResponseBase): Observable<ResultOfGetKorisnikAutocompleteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetKorisnikAutocompleteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetKorisnikAutocompleteResponse>(null as any);
    }

    get(request: GetKorisnikQuery): Observable<ResultOfKorisnikDto> {
        let url_ = this.baseUrl + "/api/korisnici/get-korisnik";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfKorisnikDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfKorisnikDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResultOfKorisnikDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfKorisnikDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfKorisnikDto>(null as any);
    }

    confirmEmail(userId?: string | null | undefined, code?: string | null | undefined, tenantKey?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/korisnici/confirm-email?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (tenantKey !== undefined && tenantKey !== null)
            url_ += "tenantKey=" + encodeURIComponent("" + tenantKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    inviteUser(command: InviteKorisnikCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/korisnici/invite-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processInviteUser(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getKorisnikTenantAccesses(korisnikEmail?: string | null | undefined): Observable<ResultOfGetKorisnikTenantAccessResponse> {
        let url_ = this.baseUrl + "/api/korisnici/get-korisnik-tenant-accesses?";
        if (korisnikEmail !== undefined && korisnikEmail !== null)
            url_ += "korisnikEmail=" + encodeURIComponent("" + korisnikEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKorisnikTenantAccesses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKorisnikTenantAccesses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetKorisnikTenantAccessResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetKorisnikTenantAccessResponse>;
        }));
    }

    protected processGetKorisnikTenantAccesses(response: HttpResponseBase): Observable<ResultOfGetKorisnikTenantAccessResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetKorisnikTenantAccessResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetKorisnikTenantAccessResponse>(null as any);
    }

    getKorisnickaGrupa(id?: string | null | undefined): Observable<ResultOfKorisnickaGrupaDto> {
        let url_ = this.baseUrl + "/api/korisnici/get-korisnicka-grupa?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKorisnickaGrupa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKorisnickaGrupa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfKorisnickaGrupaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfKorisnickaGrupaDto>;
        }));
    }

    protected processGetKorisnickaGrupa(response: HttpResponseBase): Observable<ResultOfKorisnickaGrupaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfKorisnickaGrupaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfKorisnickaGrupaDto>(null as any);
    }

    getOvlascenja(): Observable<ResultOfGetOvlascenjaResponse> {
        let url_ = this.baseUrl + "/api/korisnici/get-ovlascenja";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOvlascenja(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOvlascenja(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetOvlascenjaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetOvlascenjaResponse>;
        }));
    }

    protected processGetOvlascenja(response: HttpResponseBase): Observable<ResultOfGetOvlascenjaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetOvlascenjaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetOvlascenjaResponse>(null as any);
    }

    getKorisnickaGrupaDropdown(): Observable<ResultOfGetKorisnickaGrupaDropdownResponse> {
        let url_ = this.baseUrl + "/api/korisnici/get-korisnicka-grupa-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKorisnickaGrupaDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKorisnickaGrupaDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetKorisnickaGrupaDropdownResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetKorisnickaGrupaDropdownResponse>;
        }));
    }

    protected processGetKorisnickaGrupaDropdown(response: HttpResponseBase): Observable<ResultOfGetKorisnickaGrupaDropdownResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetKorisnickaGrupaDropdownResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetKorisnickaGrupaDropdownResponse>(null as any);
    }

    getJePrviLogin(): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/korisnici/je-prvi-login-korisnika";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJePrviLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJePrviLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfBoolean>;
        }));
    }

    protected processGetJePrviLogin(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(null as any);
    }

    setRating(rating?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/korisnici/submit-rating?";
        if (rating === null)
            throw new Error("The parameter 'rating' cannot be null.");
        else if (rating !== undefined)
            url_ += "rating=" + encodeURIComponent("" + rating) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetRating(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetRating(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSetRating(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    checkIfRatingExists(): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/korisnici/check-rating-exists";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfRatingExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfRatingExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfBoolean>;
        }));
    }

    protected processCheckIfRatingExists(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(null as any);
    }

    sendVerificationEmail(command: SendVerificationEmailCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/korisnici/send-verification-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSendVerificationEmail(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    changeActivity(command: ChangeActivityCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/korisnici/change-activity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processChangeActivity(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sendConfirmationCode(command: SendSmsConfirmationCodeKorisnikCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/korisnici/send-confirmation-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConfirmationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConfirmationCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSendConfirmationCode(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    confirmPhone(command: ConfirmPhoneCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/korisnici/confirm-phone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPhone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processConfirmPhone(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    addKorisnikeToGrupa(command: AddKorisnikeToGrupaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/korisnici/add-to-grupa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddKorisnikeToGrupa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddKorisnikeToGrupa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processAddKorisnikeToGrupa(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    removeKorisnikFromGrupa(command: RemoveKorisnikFromGrupaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/korisnici/remove-from-grupa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveKorisnikFromGrupa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveKorisnikFromGrupa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processRemoveKorisnikFromGrupa(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    prviLoginKorisnik(command: PrviLoginKorisnikCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/korisnici/prvi-login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrviLoginKorisnik(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrviLoginKorisnik(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processPrviLoginKorisnik(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    logoutUser(sessionId?: string | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/korisnici/logout-user?";
        if (sessionId !== undefined && sessionId !== null)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogoutUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogoutUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processLogoutUser(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }
}

export interface ILageriClient {
    getForTable(request: GetLageriTableQuery): Observable<PaginatedResultOfLagerTableDtoAndLagerTableSummary>;
    getStanje(robaId?: number | undefined): Observable<ResultOfGetStanjeLageraResponse>;
    getLagerPdf(previewName: string, naziv?: string | null | undefined, sifra?: string | null | undefined, magacinId?: number | undefined, predmetStavkeId?: number | null | undefined, prikaziNuleIMinus?: boolean | null | undefined, datumPrometa?: Date | null | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, strankaIdList?: number[] | null | undefined, sortField?: string | null | undefined, sortOrder?: number | null | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class LageriClient implements ILageriClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(request: GetLageriTableQuery): Observable<PaginatedResultOfLagerTableDtoAndLagerTableSummary> {
        let url_ = this.baseUrl + "/api/lageri/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfLagerTableDtoAndLagerTableSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfLagerTableDtoAndLagerTableSummary>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<PaginatedResultOfLagerTableDtoAndLagerTableSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfLagerTableDtoAndLagerTableSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfLagerTableDtoAndLagerTableSummary>(null as any);
    }

    getStanje(robaId?: number | undefined): Observable<ResultOfGetStanjeLageraResponse> {
        let url_ = this.baseUrl + "/api/lageri/get-stanje?";
        if (robaId === null)
            throw new Error("The parameter 'robaId' cannot be null.");
        else if (robaId !== undefined)
            url_ += "robaId=" + encodeURIComponent("" + robaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStanje(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStanje(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetStanjeLageraResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetStanjeLageraResponse>;
        }));
    }

    protected processGetStanje(response: HttpResponseBase): Observable<ResultOfGetStanjeLageraResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetStanjeLageraResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetStanjeLageraResponse>(null as any);
    }

    getLagerPdf(previewName: string, naziv?: string | null | undefined, sifra?: string | null | undefined, magacinId?: number | undefined, predmetStavkeId?: number | null | undefined, prikaziNuleIMinus?: boolean | null | undefined, datumPrometa?: Date | null | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, strankaIdList?: number[] | null | undefined, sortField?: string | null | undefined, sortOrder?: number | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/lageri/get-lager-pdf/{previewName}?";
        if (previewName === undefined || previewName === null)
            throw new Error("The parameter 'previewName' must be defined.");
        url_ = url_.replace("{previewName}", encodeURIComponent("" + previewName));
        if (naziv !== undefined && naziv !== null)
            url_ += "naziv=" + encodeURIComponent("" + naziv) + "&";
        if (sifra !== undefined && sifra !== null)
            url_ += "sifra=" + encodeURIComponent("" + sifra) + "&";
        if (magacinId === null)
            throw new Error("The parameter 'magacinId' cannot be null.");
        else if (magacinId !== undefined)
            url_ += "magacinId=" + encodeURIComponent("" + magacinId) + "&";
        if (predmetStavkeId !== undefined && predmetStavkeId !== null)
            url_ += "predmetStavkeId=" + encodeURIComponent("" + predmetStavkeId) + "&";
        if (prikaziNuleIMinus !== undefined && prikaziNuleIMinus !== null)
            url_ += "prikaziNuleIMinus=" + encodeURIComponent("" + prikaziNuleIMinus) + "&";
        if (datumPrometa !== undefined && datumPrometa !== null)
            url_ += "datumPrometa=" + encodeURIComponent(datumPrometa ? "" + datumPrometa.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (strankaIdList !== undefined && strankaIdList !== null)
            strankaIdList && strankaIdList.forEach(item => { url_ += "strankaIdList=" + encodeURIComponent("" + item) + "&"; });
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLagerPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLagerPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLagerPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface ILagerTransakcijeClient {
    getForTable(request: GetLagerTransakcijeTableQuery): Observable<ResultOfGetLagerTransakcijeTableResponse>;
    getLagerTransakcijePdf(previewName: string, predmetStavkeId?: number | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class LagerTransakcijeClient implements ILagerTransakcijeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(request: GetLagerTransakcijeTableQuery): Observable<ResultOfGetLagerTransakcijeTableResponse> {
        let url_ = this.baseUrl + "/api/lagertransakcije/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetLagerTransakcijeTableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetLagerTransakcijeTableResponse>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<ResultOfGetLagerTransakcijeTableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetLagerTransakcijeTableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetLagerTransakcijeTableResponse>(null as any);
    }

    getLagerTransakcijePdf(previewName: string, predmetStavkeId?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/lagertransakcije/get-lagertransakcije-pdf/{previewName}?";
        if (previewName === undefined || previewName === null)
            throw new Error("The parameter 'previewName' must be defined.");
        url_ = url_.replace("{previewName}", encodeURIComponent("" + previewName));
        if (predmetStavkeId === null)
            throw new Error("The parameter 'predmetStavkeId' cannot be null.");
        else if (predmetStavkeId !== undefined)
            url_ += "predmetStavkeId=" + encodeURIComponent("" + predmetStavkeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLagerTransakcijePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLagerTransakcijePdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLagerTransakcijePdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IMagaciniClient {
    getForTable(request: GetMagaciniTableQuery): Observable<ResultOfMagaciniTableVm>;
    getById(id: number): Observable<ResultOfMagacinDto>;
    getDropdown(): Observable<ResultOfIEnumerableOfMagacinDropdownDto>;
    create(command: CreateMagacinCommand): Observable<ResultOfMagacinCommandResponse>;
    update(id: number, command: UpdateMagacinCommand): Observable<ResultOfMagacinCommandResponse>;
    delete(id: number): Observable<FileResponse>;
    getByNaziv(naziv: string): Observable<GetMagacinByNazivVm>;
    getMagaciniMultiselect(): Observable<ResultOfMagaciniVm>;
}

@Injectable({
    providedIn: 'root'
})
export class MagaciniClient implements IMagaciniClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(request: GetMagaciniTableQuery): Observable<ResultOfMagaciniTableVm> {
        let url_ = this.baseUrl + "/api/magacini/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfMagaciniTableVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfMagaciniTableVm>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<ResultOfMagaciniTableVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfMagaciniTableVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfMagaciniTableVm>(null as any);
    }

    getById(id: number): Observable<ResultOfMagacinDto> {
        let url_ = this.baseUrl + "/api/magacini/by-id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfMagacinDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfMagacinDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ResultOfMagacinDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfMagacinDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfMagacinDto>(null as any);
    }

    getDropdown(): Observable<ResultOfIEnumerableOfMagacinDropdownDto> {
        let url_ = this.baseUrl + "/api/magacini/dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIEnumerableOfMagacinDropdownDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIEnumerableOfMagacinDropdownDto>;
        }));
    }

    protected processGetDropdown(response: HttpResponseBase): Observable<ResultOfIEnumerableOfMagacinDropdownDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIEnumerableOfMagacinDropdownDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIEnumerableOfMagacinDropdownDto>(null as any);
    }

    create(command: CreateMagacinCommand): Observable<ResultOfMagacinCommandResponse> {
        let url_ = this.baseUrl + "/api/magacini";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfMagacinCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfMagacinCommandResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfMagacinCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfMagacinCommandResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfMagacinCommandResponse>(null as any);
    }

    update(id: number, command: UpdateMagacinCommand): Observable<ResultOfMagacinCommandResponse> {
        let url_ = this.baseUrl + "/api/magacini/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfMagacinCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfMagacinCommandResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultOfMagacinCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfMagacinCommandResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfMagacinCommandResponse>(null as any);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/magacini/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getByNaziv(naziv: string): Observable<GetMagacinByNazivVm> {
        let url_ = this.baseUrl + "/api/magacini/by-naziv/{naziv}";
        if (naziv === undefined || naziv === null)
            throw new Error("The parameter 'naziv' must be defined.");
        url_ = url_.replace("{naziv}", encodeURIComponent("" + naziv));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByNaziv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByNaziv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMagacinByNazivVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMagacinByNazivVm>;
        }));
    }

    protected processGetByNaziv(response: HttpResponseBase): Observable<GetMagacinByNazivVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMagacinByNazivVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMagacinByNazivVm>(null as any);
    }

    getMagaciniMultiselect(): Observable<ResultOfMagaciniVm> {
        let url_ = this.baseUrl + "/api/magacini/get-magacini-for-multiselect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMagaciniMultiselect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMagaciniMultiselect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfMagaciniVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfMagaciniVm>;
        }));
    }

    protected processGetMagaciniMultiselect(response: HttpResponseBase): Observable<ResultOfMagaciniVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfMagaciniVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfMagaciniVm>(null as any);
    }
}

export interface IMagacinTipoviClient {
    getForTable(): Observable<ResultOfGetMagacinTipoveResponse>;
    get(id?: number | null | undefined): Observable<MagacinTipoviVm>;
    create(command: CreateMagacinTipCommand): Observable<MagacinTipTableDto>;
    update(id: number, command: UpdateMagacinTipCommand): Observable<MagacinTipTableDto>;
    delete(id: number): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class MagacinTipoviClient implements IMagacinTipoviClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(): Observable<ResultOfGetMagacinTipoveResponse> {
        let url_ = this.baseUrl + "/api/magacintipovi/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetMagacinTipoveResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetMagacinTipoveResponse>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<ResultOfGetMagacinTipoveResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetMagacinTipoveResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetMagacinTipoveResponse>(null as any);
    }

    get(id?: number | null | undefined): Observable<MagacinTipoviVm> {
        let url_ = this.baseUrl + "/api/magacintipovi?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MagacinTipoviVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MagacinTipoviVm>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MagacinTipoviVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MagacinTipoviVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MagacinTipoviVm>(null as any);
    }

    create(command: CreateMagacinTipCommand): Observable<MagacinTipTableDto> {
        let url_ = this.baseUrl + "/api/magacintipovi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MagacinTipTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MagacinTipTableDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MagacinTipTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MagacinTipTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MagacinTipTableDto>(null as any);
    }

    update(id: number, command: UpdateMagacinTipCommand): Observable<MagacinTipTableDto> {
        let url_ = this.baseUrl + "/api/magacintipovi/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MagacinTipTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MagacinTipTableDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MagacinTipTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MagacinTipTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MagacinTipTableDto>(null as any);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/magacintipovi/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IMaintenancesClient {
    clearDatabase(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class MaintenancesClient implements IMaintenancesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    clearDatabase(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/maintenances/clear-database";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processClearDatabase(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IMemorandumiClient {
    create(command: CreateMemorandumCommand): Observable<ResultOfMemorandumTableDto>;
    getAll(): Observable<ResultOfGetMemorandumiTableResponse>;
    getMemorandum(id: number): Observable<ResultOfMemorandumDto>;
    update(id: number, command: UpdateMemorandumCommand): Observable<ResultOfMemorandumTableDto>;
    getMemorandumiAutocomplete(): Observable<ResultOfGetMemorandumiAutocompleteResponse>;
    uploadLogo(logoFile?: FileParameter | null | undefined, id?: number | undefined): Observable<ResultOfString>;
    getLogo(id?: number | undefined): Observable<ResultOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class MemorandumiClient implements IMemorandumiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    create(command: CreateMemorandumCommand): Observable<ResultOfMemorandumTableDto> {
        let url_ = this.baseUrl + "/api/memorandumi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfMemorandumTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfMemorandumTableDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfMemorandumTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfMemorandumTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfMemorandumTableDto>(null as any);
    }

    getAll(): Observable<ResultOfGetMemorandumiTableResponse> {
        let url_ = this.baseUrl + "/api/memorandumi";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetMemorandumiTableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetMemorandumiTableResponse>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ResultOfGetMemorandumiTableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetMemorandumiTableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetMemorandumiTableResponse>(null as any);
    }

    getMemorandum(id: number): Observable<ResultOfMemorandumDto> {
        let url_ = this.baseUrl + "/api/memorandumi/get-memorandum/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemorandum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemorandum(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfMemorandumDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfMemorandumDto>;
        }));
    }

    protected processGetMemorandum(response: HttpResponseBase): Observable<ResultOfMemorandumDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfMemorandumDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfMemorandumDto>(null as any);
    }

    update(id: number, command: UpdateMemorandumCommand): Observable<ResultOfMemorandumTableDto> {
        let url_ = this.baseUrl + "/api/memorandumi/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfMemorandumTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfMemorandumTableDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultOfMemorandumTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfMemorandumTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfMemorandumTableDto>(null as any);
    }

    getMemorandumiAutocomplete(): Observable<ResultOfGetMemorandumiAutocompleteResponse> {
        let url_ = this.baseUrl + "/api/memorandumi/get-memorandumi-autocomplete";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemorandumiAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemorandumiAutocomplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetMemorandumiAutocompleteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetMemorandumiAutocompleteResponse>;
        }));
    }

    protected processGetMemorandumiAutocomplete(response: HttpResponseBase): Observable<ResultOfGetMemorandumiAutocompleteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetMemorandumiAutocompleteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetMemorandumiAutocompleteResponse>(null as any);
    }

    uploadLogo(logoFile?: FileParameter | null | undefined, id?: number | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/memorandumi/upload-logo-memoranduma";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (logoFile !== null && logoFile !== undefined)
            content_.append("LogoFile", logoFile.data, logoFile.fileName ? logoFile.fileName : "LogoFile");
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUploadLogo(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getLogo(id?: number | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/memorandumi/get-memorandum-logo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processGetLogo(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }
}

export interface IMinimaxClient {
    getApiInfo(): Observable<ResultOfMinimaxApiInfoDto>;
    getOrganisations(): Observable<ResultOfListOfOrganisationDto>;
    getDocumentNumberings(): Observable<ResultOfListOfDocumentNumberingDto>;
    syncItems(): Observable<ResultOfString>;
    initMinimax(command: CreateMinimaxAuthCommand): Observable<ResultOfMinimaxApiInfoDto>;
    setOrganisation(command: SetMinimaxOrganisationCommand): Observable<ResultOfString>;
    sendInvoiceToMinimax(racunId: number): Observable<ResultOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class MinimaxClient implements IMinimaxClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getApiInfo(): Observable<ResultOfMinimaxApiInfoDto> {
        let url_ = this.baseUrl + "/api/minimax/get-api-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApiInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApiInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfMinimaxApiInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfMinimaxApiInfoDto>;
        }));
    }

    protected processGetApiInfo(response: HttpResponseBase): Observable<ResultOfMinimaxApiInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfMinimaxApiInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfMinimaxApiInfoDto>(null as any);
    }

    getOrganisations(): Observable<ResultOfListOfOrganisationDto> {
        let url_ = this.baseUrl + "/api/minimax/get-organisations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganisations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganisations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfOrganisationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfOrganisationDto>;
        }));
    }

    protected processGetOrganisations(response: HttpResponseBase): Observable<ResultOfListOfOrganisationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfOrganisationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfOrganisationDto>(null as any);
    }

    getDocumentNumberings(): Observable<ResultOfListOfDocumentNumberingDto> {
        let url_ = this.baseUrl + "/api/minimax/get-document-numberings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentNumberings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentNumberings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfDocumentNumberingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfDocumentNumberingDto>;
        }));
    }

    protected processGetDocumentNumberings(response: HttpResponseBase): Observable<ResultOfListOfDocumentNumberingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfDocumentNumberingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfDocumentNumberingDto>(null as any);
    }

    syncItems(): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/minimax/sync-items";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSyncItems(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    initMinimax(command: CreateMinimaxAuthCommand): Observable<ResultOfMinimaxApiInfoDto> {
        let url_ = this.baseUrl + "/api/minimax/minimax-init";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitMinimax(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitMinimax(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfMinimaxApiInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfMinimaxApiInfoDto>;
        }));
    }

    protected processInitMinimax(response: HttpResponseBase): Observable<ResultOfMinimaxApiInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfMinimaxApiInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfMinimaxApiInfoDto>(null as any);
    }

    setOrganisation(command: SetMinimaxOrganisationCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/minimax/set-organisation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetOrganisation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetOrganisation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSetOrganisation(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sendInvoiceToMinimax(racunId: number): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/minimax/send-to-minimax/{racunId}";
        if (racunId === undefined || racunId === null)
            throw new Error("The parameter 'racunId' must be defined.");
        url_ = url_.replace("{racunId}", encodeURIComponent("" + racunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendInvoiceToMinimax(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendInvoiceToMinimax(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSendInvoiceToMinimax(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }
}

export interface IMojaFirmaClient {
    zohoInit(request: ZohoInitCommand): Observable<ResultOfString>;
    get(): Observable<ResultOfMojaFirmaDto>;
    getMojaFirmaKompenzacija(): Observable<ResultOfMojaFirmaKompenzacijaDto>;
    getPdvConfiguration(): Observable<ResultOfGetPdvConfigurationResponse>;
    getMojaFirmaIzdavalacPrimalac(): Observable<ResultOfGetMojaFirmaIzdavalacPrimalacVm>;
    getKonfiguracija(): Observable<ResultOfKonfiguracijaMojeFirmeDto>;
    updateKonfiguracija(command: UpdateKonfiguracijaMojeFirmeCommand): Observable<ResultOfKonfiguracijaMojeFirmeDto>;
    updatePracenjeLageraZaEOtpremnice(command: UpdatePracenjeLageraZaEOtpremniceCommand): Observable<ResultOfBoolean>;
    updateSefApiKey(command: UpdateSefApiKeyCommand): Observable<ResultOfApiMenadzmentDto>;
    getApiMenadzment(): Observable<ResultOfApiMenadzmentDto>;
    getMedij(): Observable<ResultOfMedij>;
    uploadLogo(logoFile?: FileParameter | null | undefined): Observable<ResultOfString>;
    getLogo(memorandumId?: number | null | undefined): Observable<FileResponse>;
    getFooterInfo(): Observable<FooterInfoDto>;
    getUSlucajuSpora(): Observable<string>;
    getJePrviLogin(): Observable<ResultOfPrviLoginDto>;
    prviLoginMojaFirma(command: PrviLoginMojaFirmaCommand): Observable<ResultOfString>;
    createZohoDeskTickets(priority?: string | null | undefined, subject?: string | null | undefined, description?: string | null | undefined, attachments?: FileParameter[] | null | undefined): Observable<ResultOfString>;
    seedZohoData(): Observable<ResultOfString>;
    syncSenderSignature(id: string): Observable<ResultOfString>;
    syncSenderSignatures(): Observable<ResultOfString>;
    addSenderSignature(request: AddSenderSignatureCommand): Observable<ResultOfString>;
    resendConfirmationMail(id: string): Observable<ResultOfString>;
    setSignatureAsDefault(id: string): Observable<ResultOfString>;
    setSignatureAsDefaultForExternal(id: string): Observable<ResultOfString>;
    deleteSenderSignature(id: string): Observable<ResultOfString>;
    getSenderSignatures(request: GetSenderSignaturesTableQuery): Observable<PaginatedResultOfSenderSignatureTableDto>;
    getSenderSignaturesDropdown(): Observable<ResultOfIReadOnlyCollectionOfSenderSignatureDropdownDto>;
    getDomains(): Observable<ResultOfIEnumerableOfString>;
    getDomainInfo(domain: string): Observable<ResultOfSenderDomainDto>;
    verifyDkim(domainId: number): Observable<ResultOfString>;
    verifyReturnPath(domainId: number): Observable<ResultOfString>;
    seedTestnihPodataka(): Observable<ResultOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class MojaFirmaClient implements IMojaFirmaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    zohoInit(request: ZohoInitCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/mojafirma/zoho-init";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processZohoInit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processZohoInit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processZohoInit(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    get(): Observable<ResultOfMojaFirmaDto> {
        let url_ = this.baseUrl + "/api/mojafirma";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfMojaFirmaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfMojaFirmaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResultOfMojaFirmaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfMojaFirmaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfMojaFirmaDto>(null as any);
    }

    getMojaFirmaKompenzacija(): Observable<ResultOfMojaFirmaKompenzacijaDto> {
        let url_ = this.baseUrl + "/api/mojafirma/get-moja-firma-kompenzacija";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMojaFirmaKompenzacija(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMojaFirmaKompenzacija(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfMojaFirmaKompenzacijaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfMojaFirmaKompenzacijaDto>;
        }));
    }

    protected processGetMojaFirmaKompenzacija(response: HttpResponseBase): Observable<ResultOfMojaFirmaKompenzacijaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfMojaFirmaKompenzacijaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfMojaFirmaKompenzacijaDto>(null as any);
    }

    getPdvConfiguration(): Observable<ResultOfGetPdvConfigurationResponse> {
        let url_ = this.baseUrl + "/api/mojafirma/pdv-configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdvConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdvConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetPdvConfigurationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetPdvConfigurationResponse>;
        }));
    }

    protected processGetPdvConfiguration(response: HttpResponseBase): Observable<ResultOfGetPdvConfigurationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetPdvConfigurationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPdvConfigurationResponse>(null as any);
    }

    getMojaFirmaIzdavalacPrimalac(): Observable<ResultOfGetMojaFirmaIzdavalacPrimalacVm> {
        let url_ = this.baseUrl + "/api/mojafirma/izdavalac-primalac";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMojaFirmaIzdavalacPrimalac(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMojaFirmaIzdavalacPrimalac(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetMojaFirmaIzdavalacPrimalacVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetMojaFirmaIzdavalacPrimalacVm>;
        }));
    }

    protected processGetMojaFirmaIzdavalacPrimalac(response: HttpResponseBase): Observable<ResultOfGetMojaFirmaIzdavalacPrimalacVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetMojaFirmaIzdavalacPrimalacVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetMojaFirmaIzdavalacPrimalacVm>(null as any);
    }

    getKonfiguracija(): Observable<ResultOfKonfiguracijaMojeFirmeDto> {
        let url_ = this.baseUrl + "/api/mojafirma/get-konfiguracija";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKonfiguracija(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKonfiguracija(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfKonfiguracijaMojeFirmeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfKonfiguracijaMojeFirmeDto>;
        }));
    }

    protected processGetKonfiguracija(response: HttpResponseBase): Observable<ResultOfKonfiguracijaMojeFirmeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfKonfiguracijaMojeFirmeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfKonfiguracijaMojeFirmeDto>(null as any);
    }

    updateKonfiguracija(command: UpdateKonfiguracijaMojeFirmeCommand): Observable<ResultOfKonfiguracijaMojeFirmeDto> {
        let url_ = this.baseUrl + "/api/mojafirma/update-konfiguracija";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateKonfiguracija(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateKonfiguracija(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfKonfiguracijaMojeFirmeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfKonfiguracijaMojeFirmeDto>;
        }));
    }

    protected processUpdateKonfiguracija(response: HttpResponseBase): Observable<ResultOfKonfiguracijaMojeFirmeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfKonfiguracijaMojeFirmeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfKonfiguracijaMojeFirmeDto>(null as any);
    }

    updatePracenjeLageraZaEOtpremnice(command: UpdatePracenjeLageraZaEOtpremniceCommand): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/mojafirma/update-pracenje-lagera-za-eotpremnice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePracenjeLageraZaEOtpremnice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePracenjeLageraZaEOtpremnice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfBoolean>;
        }));
    }

    protected processUpdatePracenjeLageraZaEOtpremnice(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(null as any);
    }

    updateSefApiKey(command: UpdateSefApiKeyCommand): Observable<ResultOfApiMenadzmentDto> {
        let url_ = this.baseUrl + "/api/mojafirma/update-sef-api-key";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSefApiKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSefApiKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfApiMenadzmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfApiMenadzmentDto>;
        }));
    }

    protected processUpdateSefApiKey(response: HttpResponseBase): Observable<ResultOfApiMenadzmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfApiMenadzmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfApiMenadzmentDto>(null as any);
    }

    getApiMenadzment(): Observable<ResultOfApiMenadzmentDto> {
        let url_ = this.baseUrl + "/api/mojafirma/get-api-menadzment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApiMenadzment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApiMenadzment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfApiMenadzmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfApiMenadzmentDto>;
        }));
    }

    protected processGetApiMenadzment(response: HttpResponseBase): Observable<ResultOfApiMenadzmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfApiMenadzmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfApiMenadzmentDto>(null as any);
    }

    getMedij(): Observable<ResultOfMedij> {
        let url_ = this.baseUrl + "/api/mojafirma/get-medij";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedij(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedij(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfMedij>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfMedij>;
        }));
    }

    protected processGetMedij(response: HttpResponseBase): Observable<ResultOfMedij> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfMedij.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfMedij>(null as any);
    }

    uploadLogo(logoFile?: FileParameter | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/mojafirma/upload-logo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (logoFile !== null && logoFile !== undefined)
            content_.append("LogoFile", logoFile.data, logoFile.fileName ? logoFile.fileName : "LogoFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUploadLogo(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getLogo(memorandumId?: number | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/mojafirma/get-logo?";
        if (memorandumId !== undefined && memorandumId !== null)
            url_ += "memorandumId=" + encodeURIComponent("" + memorandumId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLogo(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getFooterInfo(): Observable<FooterInfoDto> {
        let url_ = this.baseUrl + "/api/mojafirma/footer-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFooterInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFooterInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FooterInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FooterInfoDto>;
        }));
    }

    protected processGetFooterInfo(response: HttpResponseBase): Observable<FooterInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FooterInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FooterInfoDto>(null as any);
    }

    getUSlucajuSpora(): Observable<string> {
        let url_ = this.baseUrl + "/api/mojafirma/u-slucaju-spora";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUSlucajuSpora(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUSlucajuSpora(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUSlucajuSpora(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    getJePrviLogin(): Observable<ResultOfPrviLoginDto> {
        let url_ = this.baseUrl + "/api/mojafirma/je-prvi-login-kompanije";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJePrviLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJePrviLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfPrviLoginDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfPrviLoginDto>;
        }));
    }

    protected processGetJePrviLogin(response: HttpResponseBase): Observable<ResultOfPrviLoginDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfPrviLoginDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfPrviLoginDto>(null as any);
    }

    prviLoginMojaFirma(command: PrviLoginMojaFirmaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/mojafirma/prvi-login-kompanije";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrviLoginMojaFirma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrviLoginMojaFirma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processPrviLoginMojaFirma(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    createZohoDeskTickets(priority?: string | null | undefined, subject?: string | null | undefined, description?: string | null | undefined, attachments?: FileParameter[] | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/mojafirma/create-ticket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (priority !== null && priority !== undefined)
            content_.append("Priority", priority.toString());
        if (subject !== null && subject !== undefined)
            content_.append("Subject", subject.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (attachments !== null && attachments !== undefined)
            attachments.forEach(item_ => content_.append("Attachments", item_.data, item_.fileName ? item_.fileName : "Attachments") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateZohoDeskTickets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateZohoDeskTickets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreateZohoDeskTickets(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    seedZohoData(): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/mojafirma/seed-zoho-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSeedZohoData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSeedZohoData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSeedZohoData(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    syncSenderSignature(id: string): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/mojafirma/sync-sender-signature/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncSenderSignature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncSenderSignature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSyncSenderSignature(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    syncSenderSignatures(): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/mojafirma/sync-sender-signatures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncSenderSignatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncSenderSignatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSyncSenderSignatures(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    addSenderSignature(request: AddSenderSignatureCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/mojafirma/add-sender-signature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSenderSignature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSenderSignature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processAddSenderSignature(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    resendConfirmationMail(id: string): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/mojafirma/resend-confirmation-mail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendConfirmationMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendConfirmationMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processResendConfirmationMail(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    setSignatureAsDefault(id: string): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/mojafirma/set-default-signature/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetSignatureAsDefault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSignatureAsDefault(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSetSignatureAsDefault(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    setSignatureAsDefaultForExternal(id: string): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/mojafirma/set-default-signature-for-external/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetSignatureAsDefaultForExternal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSignatureAsDefaultForExternal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSetSignatureAsDefaultForExternal(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    deleteSenderSignature(id: string): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/mojafirma/delete-sender-signature/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSenderSignature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSenderSignature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processDeleteSenderSignature(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getSenderSignatures(request: GetSenderSignaturesTableQuery): Observable<PaginatedResultOfSenderSignatureTableDto> {
        let url_ = this.baseUrl + "/api/mojafirma/get-sender-signatures-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSenderSignatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSenderSignatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfSenderSignatureTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfSenderSignatureTableDto>;
        }));
    }

    protected processGetSenderSignatures(response: HttpResponseBase): Observable<PaginatedResultOfSenderSignatureTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfSenderSignatureTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfSenderSignatureTableDto>(null as any);
    }

    getSenderSignaturesDropdown(): Observable<ResultOfIReadOnlyCollectionOfSenderSignatureDropdownDto> {
        let url_ = this.baseUrl + "/api/mojafirma/get-sender-signatures-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSenderSignaturesDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSenderSignaturesDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIReadOnlyCollectionOfSenderSignatureDropdownDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIReadOnlyCollectionOfSenderSignatureDropdownDto>;
        }));
    }

    protected processGetSenderSignaturesDropdown(response: HttpResponseBase): Observable<ResultOfIReadOnlyCollectionOfSenderSignatureDropdownDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIReadOnlyCollectionOfSenderSignatureDropdownDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIReadOnlyCollectionOfSenderSignatureDropdownDto>(null as any);
    }

    getDomains(): Observable<ResultOfIEnumerableOfString> {
        let url_ = this.baseUrl + "/api/mojafirma/get-domains";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDomains(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDomains(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIEnumerableOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIEnumerableOfString>;
        }));
    }

    protected processGetDomains(response: HttpResponseBase): Observable<ResultOfIEnumerableOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIEnumerableOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIEnumerableOfString>(null as any);
    }

    getDomainInfo(domain: string): Observable<ResultOfSenderDomainDto> {
        let url_ = this.baseUrl + "/api/mojafirma/get-domain-info/{domain}";
        if (domain === undefined || domain === null)
            throw new Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDomainInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDomainInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfSenderDomainDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfSenderDomainDto>;
        }));
    }

    protected processGetDomainInfo(response: HttpResponseBase): Observable<ResultOfSenderDomainDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfSenderDomainDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfSenderDomainDto>(null as any);
    }

    verifyDkim(domainId: number): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/mojafirma/verify-dkim/{domainId}";
        if (domainId === undefined || domainId === null)
            throw new Error("The parameter 'domainId' must be defined.");
        url_ = url_.replace("{domainId}", encodeURIComponent("" + domainId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyDkim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyDkim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processVerifyDkim(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    verifyReturnPath(domainId: number): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/mojafirma/verify-return-path/{domainId}";
        if (domainId === undefined || domainId === null)
            throw new Error("The parameter 'domainId' must be defined.");
        url_ = url_.replace("{domainId}", encodeURIComponent("" + domainId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyReturnPath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyReturnPath(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processVerifyReturnPath(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    seedTestnihPodataka(): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/mojafirma/seed-testnih-podataka";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSeedTestnihPodataka(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSeedTestnihPodataka(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSeedTestnihPodataka(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }
}

export interface INotifikacijeClient {
    getNotifikacijaKorisnikaList(request: GetNotifikacijaKorisnikaListQuery): Observable<PaginatedResultOfNotifikacijaKorisnikaDto>;
    getAktivniJobovi(): Observable<ResultOfListOfAktivniJobDto>;
    readNotifikacijaKorisnika(id?: string | null | undefined): Observable<FileResponse>;
    readAllNotificationsKorisnika(request: ReadAllNotificationsComand): Observable<ResultOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class NotifikacijeClient implements INotifikacijeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getNotifikacijaKorisnikaList(request: GetNotifikacijaKorisnikaListQuery): Observable<PaginatedResultOfNotifikacijaKorisnikaDto> {
        let url_ = this.baseUrl + "/api/notifikacije/get-notifikacije";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotifikacijaKorisnikaList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotifikacijaKorisnikaList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfNotifikacijaKorisnikaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfNotifikacijaKorisnikaDto>;
        }));
    }

    protected processGetNotifikacijaKorisnikaList(response: HttpResponseBase): Observable<PaginatedResultOfNotifikacijaKorisnikaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfNotifikacijaKorisnikaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfNotifikacijaKorisnikaDto>(null as any);
    }

    getAktivniJobovi(): Observable<ResultOfListOfAktivniJobDto> {
        let url_ = this.baseUrl + "/api/notifikacije/get-aktivni-jobovi";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAktivniJobovi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAktivniJobovi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfAktivniJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfAktivniJobDto>;
        }));
    }

    protected processGetAktivniJobovi(response: HttpResponseBase): Observable<ResultOfListOfAktivniJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfAktivniJobDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfAktivniJobDto>(null as any);
    }

    readNotifikacijaKorisnika(id?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/notifikacije/read-notifikacija?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadNotifikacijaKorisnika(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadNotifikacijaKorisnika(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReadNotifikacijaKorisnika(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    readAllNotificationsKorisnika(request: ReadAllNotificationsComand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/notifikacije/read-all-notifikacije";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadAllNotificationsKorisnika(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadAllNotificationsKorisnika(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processReadAllNotificationsKorisnika(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }
}

export interface IOtpremniceClient {
    create(command: CreateOtpremnicaCommand): Observable<ResultOfLong>;
    update(id: number, command: UpdateOtpremnicaCommand): Observable<FileResponse>;
    getOtpremnica(request: GetOtpremnicaQuery): Observable<ResultOfOtpremnicaDto>;
    getNewForStranka(strankaId: string): Observable<ResultOfOtpremnicaDto>;
    getOtpremnicaForIzlazniRacun(racunId: number): Observable<ResultOfOtpremnicaDto>;
    getOtpremnicaForPredracun(predracunId: number): Observable<ResultOfOtpremnicaDto>;
    duplicateOtpremnica(id: number): Observable<ResultOfOtpremnicaDto>;
    getVrstaOtpremnice(): Observable<ResultOfGetVrstaOtpremniceResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class OtpremniceClient implements IOtpremniceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    create(command: CreateOtpremnicaCommand): Observable<ResultOfLong> {
        let url_ = this.baseUrl + "/api/otpremnice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfLong>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfLong>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfLong> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfLong.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLong>(null as any);
    }

    update(id: number, command: UpdateOtpremnicaCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/otpremnice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getOtpremnica(request: GetOtpremnicaQuery): Observable<ResultOfOtpremnicaDto> {
        let url_ = this.baseUrl + "/api/otpremnice/get-otpremnica";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOtpremnica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOtpremnica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfOtpremnicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfOtpremnicaDto>;
        }));
    }

    protected processGetOtpremnica(response: HttpResponseBase): Observable<ResultOfOtpremnicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfOtpremnicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfOtpremnicaDto>(null as any);
    }

    getNewForStranka(strankaId: string): Observable<ResultOfOtpremnicaDto> {
        let url_ = this.baseUrl + "/api/otpremnice/new-for-stranka/{strankaId}";
        if (strankaId === undefined || strankaId === null)
            throw new Error("The parameter 'strankaId' must be defined.");
        url_ = url_.replace("{strankaId}", encodeURIComponent("" + strankaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewForStranka(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewForStranka(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfOtpremnicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfOtpremnicaDto>;
        }));
    }

    protected processGetNewForStranka(response: HttpResponseBase): Observable<ResultOfOtpremnicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfOtpremnicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfOtpremnicaDto>(null as any);
    }

    getOtpremnicaForIzlazniRacun(racunId: number): Observable<ResultOfOtpremnicaDto> {
        let url_ = this.baseUrl + "/api/otpremnice/new-for-izlazni-racun/{racunId}";
        if (racunId === undefined || racunId === null)
            throw new Error("The parameter 'racunId' must be defined.");
        url_ = url_.replace("{racunId}", encodeURIComponent("" + racunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOtpremnicaForIzlazniRacun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOtpremnicaForIzlazniRacun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfOtpremnicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfOtpremnicaDto>;
        }));
    }

    protected processGetOtpremnicaForIzlazniRacun(response: HttpResponseBase): Observable<ResultOfOtpremnicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfOtpremnicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfOtpremnicaDto>(null as any);
    }

    getOtpremnicaForPredracun(predracunId: number): Observable<ResultOfOtpremnicaDto> {
        let url_ = this.baseUrl + "/api/otpremnice/new-for-predracun/{predracunId}";
        if (predracunId === undefined || predracunId === null)
            throw new Error("The parameter 'predracunId' must be defined.");
        url_ = url_.replace("{predracunId}", encodeURIComponent("" + predracunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOtpremnicaForPredracun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOtpremnicaForPredracun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfOtpremnicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfOtpremnicaDto>;
        }));
    }

    protected processGetOtpremnicaForPredracun(response: HttpResponseBase): Observable<ResultOfOtpremnicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfOtpremnicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfOtpremnicaDto>(null as any);
    }

    duplicateOtpremnica(id: number): Observable<ResultOfOtpremnicaDto> {
        let url_ = this.baseUrl + "/api/otpremnice/duplicate-otpremnica/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateOtpremnica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateOtpremnica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfOtpremnicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfOtpremnicaDto>;
        }));
    }

    protected processDuplicateOtpremnica(response: HttpResponseBase): Observable<ResultOfOtpremnicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfOtpremnicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfOtpremnicaDto>(null as any);
    }

    getVrstaOtpremnice(): Observable<ResultOfGetVrstaOtpremniceResponse> {
        let url_ = this.baseUrl + "/api/otpremnice/vrsta-otpremnice-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVrstaOtpremnice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVrstaOtpremnice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetVrstaOtpremniceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetVrstaOtpremniceResponse>;
        }));
    }

    protected processGetVrstaOtpremnice(response: HttpResponseBase): Observable<ResultOfGetVrstaOtpremniceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetVrstaOtpremniceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetVrstaOtpremniceResponse>(null as any);
    }
}

export interface IOznakeClient {
    getForTable(): Observable<OznakeTableVm>;
    getForTree(): Observable<OznakeTreeVm>;
    getOznakaById(oznakaId?: number | undefined): Observable<ResultOfOznakaDto>;
    getForMultiselect(naziv?: string | null | undefined): Observable<ResultOfListOfGetOznakaMultiselectResponse>;
    create(command: CreateOznakaCommand): Observable<ResultOfOznakaTreeDto>;
    get(request: GetOznakeQuery): Observable<OznakeVm>;
    getForRequest(id: number): Observable<ResultOfOznakaRequest>;
    update(id: number, command: UpdateOznakaCommand): Observable<ResultOfOznakaTreeDto>;
    delete(id: number): Observable<ResultOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class OznakeClient implements IOznakeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(): Observable<OznakeTableVm> {
        let url_ = this.baseUrl + "/api/oznake/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OznakeTableVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OznakeTableVm>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<OznakeTableVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OznakeTableVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OznakeTableVm>(null as any);
    }

    getForTree(): Observable<OznakeTreeVm> {
        let url_ = this.baseUrl + "/api/oznake/get-for-tree";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OznakeTreeVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OznakeTreeVm>;
        }));
    }

    protected processGetForTree(response: HttpResponseBase): Observable<OznakeTreeVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OznakeTreeVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OznakeTreeVm>(null as any);
    }

    getOznakaById(oznakaId?: number | undefined): Observable<ResultOfOznakaDto> {
        let url_ = this.baseUrl + "/api/oznake/get-oznaka-by-id?";
        if (oznakaId === null)
            throw new Error("The parameter 'oznakaId' cannot be null.");
        else if (oznakaId !== undefined)
            url_ += "oznakaId=" + encodeURIComponent("" + oznakaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOznakaById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOznakaById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfOznakaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfOznakaDto>;
        }));
    }

    protected processGetOznakaById(response: HttpResponseBase): Observable<ResultOfOznakaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfOznakaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfOznakaDto>(null as any);
    }

    getForMultiselect(naziv?: string | null | undefined): Observable<ResultOfListOfGetOznakaMultiselectResponse> {
        let url_ = this.baseUrl + "/api/oznake/get-for-multiselect?";
        if (naziv !== undefined && naziv !== null)
            url_ += "naziv=" + encodeURIComponent("" + naziv) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForMultiselect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForMultiselect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfGetOznakaMultiselectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfGetOznakaMultiselectResponse>;
        }));
    }

    protected processGetForMultiselect(response: HttpResponseBase): Observable<ResultOfListOfGetOznakaMultiselectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfGetOznakaMultiselectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfGetOznakaMultiselectResponse>(null as any);
    }

    create(command: CreateOznakaCommand): Observable<ResultOfOznakaTreeDto> {
        let url_ = this.baseUrl + "/api/oznake";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfOznakaTreeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfOznakaTreeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfOznakaTreeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfOznakaTreeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfOznakaTreeDto>(null as any);
    }

    get(request: GetOznakeQuery): Observable<OznakeVm> {
        let url_ = this.baseUrl + "/api/oznake/get-dto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OznakeVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OznakeVm>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OznakeVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OznakeVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OznakeVm>(null as any);
    }

    getForRequest(id: number): Observable<ResultOfOznakaRequest> {
        let url_ = this.baseUrl + "/api/oznake/get-for-request/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfOznakaRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfOznakaRequest>;
        }));
    }

    protected processGetForRequest(response: HttpResponseBase): Observable<ResultOfOznakaRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfOznakaRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfOznakaRequest>(null as any);
    }

    update(id: number, command: UpdateOznakaCommand): Observable<ResultOfOznakaTreeDto> {
        let url_ = this.baseUrl + "/api/oznake/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfOznakaTreeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfOznakaTreeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultOfOznakaTreeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfOznakaTreeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfOznakaTreeDto>(null as any);
    }

    delete(id: number): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/oznake/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }
}

export interface IPaketiClient {
    getAll(): Observable<ResultOfListOfPackageDto>;
    getUserPackages(): Observable<ResultOfUserPackagesResponse>;
    updatePackages(req: UpdateUserPackagesCommand): Observable<ResultOfString>;
    getContract(req: GetPackagesContractQuery): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class PaketiClient implements IPaketiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<ResultOfListOfPackageDto> {
        let url_ = this.baseUrl + "/api/paketi/get-all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfPackageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfPackageDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ResultOfListOfPackageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfPackageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfPackageDto>(null as any);
    }

    getUserPackages(): Observable<ResultOfUserPackagesResponse> {
        let url_ = this.baseUrl + "/api/paketi/get-user-packages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPackages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPackages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfUserPackagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfUserPackagesResponse>;
        }));
    }

    protected processGetUserPackages(response: HttpResponseBase): Observable<ResultOfUserPackagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfUserPackagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfUserPackagesResponse>(null as any);
    }

    updatePackages(req: UpdateUserPackagesCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/paketi/update-packages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePackages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePackages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdatePackages(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getContract(req: GetPackagesContractQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/paketi/get-contract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetContract(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IPdvEvidencijeClient {
    getPdvOpsegDropdown(): Observable<ResultOfGetPdvOpsegDropdownResponse>;
    getPdvPeriodDropdown(): Observable<ResultOfGetPdvPeriodDropdownResponse>;
    createPojedinacna(command: CreatePdvEvidencijaPojedinacnaCommand): Observable<ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse>;
    getPdvEvidencijaPojedinacna(id?: number | undefined): Observable<ResultOfPdvEvidencijaPojedinacnaDto>;
    createPojedinacna39(command: CreatePdvEvidencijaPojedinacna39Command): Observable<ResultOfString>;
    getPdvEvidencijaPojedinacna39(id?: number | undefined): Observable<ResultOfPdvEvidencijaPojedinacna39Dto>;
    updatePojedinacna(id: number, command: UpdatePdvEvidencijaPojedinacnaCommand): Observable<ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse>;
    deletePojedinacna(id: number): Observable<FileResponse>;
    updatePojedinacna39(id: number, command: UpdatePdvEvidencijaPojedinacna39Command): Observable<ResultOfString>;
    getStrankaForPdvAutocomplete(dateFrom?: string | null | undefined): Observable<ResultOfGetStrankaForPdvAutocompleteResponse>;
    getTipDokumentaEvidencijeDropdown(): Observable<ResultOfGetTipDokumentaEvidencijeDropdownResponse>;
    getTipPovezanogDokumentaEvidencijeDropdown(): Observable<ResultOfGetTipPovezanogDokumentaEvidencijeDropdownResponse>;
    getOsnovOdabiraDokumentaDropdownQuery(): Observable<ResultOfGetOsnovOdabiraDokumentaDropdownResponse>;
    getTipPovezanogInternogDropdownQuery(): Observable<ResultOfGetTipPovezanogInternogDropdownResponse>;
    getDokumentForPdvAutocomplete(request: GetDokumentForPdvAutocompleteQuery): Observable<ResultOfListOfDokumentForPdvDto>;
    getDokumentForPdvByRacunId(racunId: number, vrstaRacuna?: VrstaRacuna | undefined): Observable<ResultOfListOfDokumentForPdvDto>;
    getForTable(request: GetPdvEvidencijaPojedinacnaTableQuery): Observable<PaginatedResultOfPdvEvidencijaPojedinacnaTableDto>;
    getForTable39(request: GetPdvEvidencijaPojedinacna39TableQuery): Observable<PaginatedResultOfPdvEvidencijaPojedinacna39TableDto>;
    getPdvEvidencijaPojedinacna39Pdf(id: number): Observable<FileResponse>;
    getNewPdvPojedinacnaForIzlazniRacun(racunId: number): Observable<ResultOfDokumentForPdvDto>;
    sefEvidentirajPdvEvidencijaPojedinacna(command: SefEvidentirajPdvEvidencijaPojedinacnaCommand): Observable<ResultOfString>;
    sefGetPdvEvidencijaPojedinacna(evidencijaId?: number | undefined): Observable<ResultOfString>;
    sefEvidentirajPdvEvidencijaPojedinacna39(command: SefEvidentirajPdvEvidencijaPojedinacna39Command): Observable<ResultOfString>;
    sefCancelPdvEvidencijaPojedinacna(command: SefCancelPdvEvidencijaPojedinacnaCommand): Observable<ResultOfString>;
    sefCancelPdvEvidencijaPojedinacna39(command: SefPonistiPdvEvidencijaPojedinacna39Command): Observable<ResultOfString>;
    sefKorigujPdvEvidencijaPojedinacna(id: number, command: SefKorigujPdvEvidencijaPojedinacnaCommand): Observable<ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse>;
    sefKorigujPdvEvidencijaPojedinacna39(id: number, command: SefKorigujPdvEvidencijaPojedinacna39Command): Observable<ResultOfString>;
    sefGetListPdvEvidencijaPojedinacna(dateFrom?: Date | undefined, dateTo?: Date | undefined): Observable<ResultOfGetStrankaForPdvAutocompleteResponse>;
    createPPPDV(command: CreatePPPDVEvidencijaCommand): Observable<ResultOfString>;
    getPPPDVEvidencija(id?: number | undefined): Observable<ResultOfPPPDVEvidencijaDto>;
    updatePPPDV(id: number, command: UpdatePPPDVEvidencijaCommand): Observable<ResultOfString>;
    sefEvidentirajPPPDVEvidenciju(command: SefEvidentirajPPPDVEvidencijaCommand): Observable<ResultOfString>;
    sefKorigujPPPDVEvidenciju(id: number, command: SefKorigujPPPDVEvidencijaCommand): Observable<ResultOfString>;
    getForPPPDVTable(request: GetPPPDVTableQuery): Observable<PaginatedResultOfPPPDVEvidencijaTableDto>;
    getSystemCalculationQuery(request: GetSystemCalculationQuery): Observable<ResultOfSystemCalculationDto>;
    createSefObavestenje(command: CreateSefObavestenjeCommand): Observable<ResultOfSefObavestenjeDto>;
    getSentSefObavestenja(dateFrom?: Date | null | undefined, dateTo?: Date | null | undefined): Observable<ResultOfListOfSefObavestenjeDto>;
    getReceivedSefObavestenja(dateFrom?: Date | null | undefined, dateTo?: Date | null | undefined): Observable<ResultOfListOfSefObavestenjeDto>;
    getRacuniForSefObavestenjeAutocomplete(broj?: string | null | undefined): Observable<ResultOfListOfRacunZaSefObavestenjeDto>;
    getRacunForSefObavestenjeById(id: number, jeSefRacun?: boolean | undefined): Observable<ResultOfRacunZaSefObavestenjeDto>;
    getDatoObavestenjePdf(noticeId: number): Observable<FileResponse>;
    getPrimljenoObavestenjePdf(noticeId: number): Observable<FileResponse>;
    getSefPPPDVTable(request: GetSefPPPDVTableQuery): Observable<ResultOfListOfSefObavestenjeDto>;
    createZbirna(command: CreatePdvEvidencijaZbirnaCommand): Observable<ResultOfCreateUpdatePdvEvidencijaZbirnaResponse>;
    getPdvEvidencijaZbirna(id?: number | undefined): Observable<ResultOfPdvEvidencijaZbirnaDto>;
    createZbirna39(command: CreatePdvEvidencijaZbirna39Command): Observable<ResultOfString>;
    updateZbirna(id: number, command: UpdatePdvEvidencijaZbirnaCommand): Observable<ResultOfCreateUpdatePdvEvidencijaZbirnaResponse>;
    deleteZbirna(id: number): Observable<FileResponse>;
    updateZbirna39(id: number, command: UpdatePdvEvidencijaZbirna39Command): Observable<ResultOfString>;
    deleteZbirna39(id: number): Observable<ResultOfString>;
    getForTable2(request: GetPdvEvidencijaZbirnaTableQuery): Observable<PaginatedResultOfPdvEvidencijaZbirnaTableDto>;
    getForTableZbirna39(request: GetPdvEvidencijaZbirna39TableQuery): Observable<PaginatedResultOfPdvEvidencijaZbirna39TableDto>;
    getPdvEvidencijaZbirna39(id?: number | undefined): Observable<ResultOfPdvEvidencijaZbirna39Dto>;
    getPdvEvidencijaZbirna39Pdf(id: number): Observable<FileResponse>;
    sefEvidentirajPdvEvidencijaZbirna(command: SefEvidentirajPdvEvidencijaZbirnaCommand): Observable<ResultOfString>;
    sefGetPdvEvidencijaZbirna(evidencijaId?: number | undefined): Observable<ResultOfString>;
    sefEvidentirajPdvEvidencijaZbirna39(command: SefEvidentirajPdvEvidencijaZbirna39Command): Observable<ResultOfString>;
    sefCancelPdvEvidencijaZbirna(command: SefCancelPdvEvidencijaZbirnaCommand): Observable<ResultOfString>;
    sefCancelPdvEvidencijaZbirna39(command: SefPonistiPdvEvidencijaZbirna39Command): Observable<ResultOfString>;
    sefKorigujPdvEvidencijaZbirna(id: number, command: SefKorigujPdvEvidencijaZbirnaCommand): Observable<ResultOfCreateUpdatePdvEvidencijaZbirnaResponse>;
    sefKorigujPdvEvidencijaZbirna39(id: number, command: SefKorigujPdvEvidencijaZbirna39Command): Observable<ResultOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class PdvEvidencijeClient implements IPdvEvidencijeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getPdvOpsegDropdown(): Observable<ResultOfGetPdvOpsegDropdownResponse> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pdv-opseg-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdvOpsegDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdvOpsegDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetPdvOpsegDropdownResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetPdvOpsegDropdownResponse>;
        }));
    }

    protected processGetPdvOpsegDropdown(response: HttpResponseBase): Observable<ResultOfGetPdvOpsegDropdownResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetPdvOpsegDropdownResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPdvOpsegDropdownResponse>(null as any);
    }

    getPdvPeriodDropdown(): Observable<ResultOfGetPdvPeriodDropdownResponse> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pdv-period-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdvPeriodDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdvPeriodDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetPdvPeriodDropdownResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetPdvPeriodDropdownResponse>;
        }));
    }

    protected processGetPdvPeriodDropdown(response: HttpResponseBase): Observable<ResultOfGetPdvPeriodDropdownResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetPdvPeriodDropdownResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPdvPeriodDropdownResponse>(null as any);
    }

    createPojedinacna(command: CreatePdvEvidencijaPojedinacnaCommand): Observable<ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePojedinacna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePojedinacna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse>;
        }));
    }

    protected processCreatePojedinacna(response: HttpResponseBase): Observable<ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse>(null as any);
    }

    getPdvEvidencijaPojedinacna(id?: number | undefined): Observable<ResultOfPdvEvidencijaPojedinacnaDto> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdvEvidencijaPojedinacna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdvEvidencijaPojedinacna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfPdvEvidencijaPojedinacnaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfPdvEvidencijaPojedinacnaDto>;
        }));
    }

    protected processGetPdvEvidencijaPojedinacna(response: HttpResponseBase): Observable<ResultOfPdvEvidencijaPojedinacnaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfPdvEvidencijaPojedinacnaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfPdvEvidencijaPojedinacnaDto>(null as any);
    }

    createPojedinacna39(command: CreatePdvEvidencijaPojedinacna39Command): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna39";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePojedinacna39(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePojedinacna39(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreatePojedinacna39(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getPdvEvidencijaPojedinacna39(id?: number | undefined): Observable<ResultOfPdvEvidencijaPojedinacna39Dto> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna39?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdvEvidencijaPojedinacna39(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdvEvidencijaPojedinacna39(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfPdvEvidencijaPojedinacna39Dto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfPdvEvidencijaPojedinacna39Dto>;
        }));
    }

    protected processGetPdvEvidencijaPojedinacna39(response: HttpResponseBase): Observable<ResultOfPdvEvidencijaPojedinacna39Dto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfPdvEvidencijaPojedinacna39Dto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfPdvEvidencijaPojedinacna39Dto>(null as any);
    }

    updatePojedinacna(id: number, command: UpdatePdvEvidencijaPojedinacnaCommand): Observable<ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePojedinacna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePojedinacna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse>;
        }));
    }

    protected processUpdatePojedinacna(response: HttpResponseBase): Observable<ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse>(null as any);
    }

    deletePojedinacna(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePojedinacna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePojedinacna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeletePojedinacna(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    updatePojedinacna39(id: number, command: UpdatePdvEvidencijaPojedinacna39Command): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna39/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePojedinacna39(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePojedinacna39(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdatePojedinacna39(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getStrankaForPdvAutocomplete(dateFrom?: string | null | undefined): Observable<ResultOfGetStrankaForPdvAutocompleteResponse> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna/stranka-for-pdv-autocomplete?";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "dateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStrankaForPdvAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStrankaForPdvAutocomplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetStrankaForPdvAutocompleteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetStrankaForPdvAutocompleteResponse>;
        }));
    }

    protected processGetStrankaForPdvAutocomplete(response: HttpResponseBase): Observable<ResultOfGetStrankaForPdvAutocompleteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetStrankaForPdvAutocompleteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetStrankaForPdvAutocompleteResponse>(null as any);
    }

    getTipDokumentaEvidencijeDropdown(): Observable<ResultOfGetTipDokumentaEvidencijeDropdownResponse> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna/tip-dokumenta-evidencije-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipDokumentaEvidencijeDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipDokumentaEvidencijeDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTipDokumentaEvidencijeDropdownResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTipDokumentaEvidencijeDropdownResponse>;
        }));
    }

    protected processGetTipDokumentaEvidencijeDropdown(response: HttpResponseBase): Observable<ResultOfGetTipDokumentaEvidencijeDropdownResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTipDokumentaEvidencijeDropdownResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTipDokumentaEvidencijeDropdownResponse>(null as any);
    }

    getTipPovezanogDokumentaEvidencijeDropdown(): Observable<ResultOfGetTipPovezanogDokumentaEvidencijeDropdownResponse> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna/tip-povezanog-dokumenta-evidencije-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipPovezanogDokumentaEvidencijeDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipPovezanogDokumentaEvidencijeDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTipPovezanogDokumentaEvidencijeDropdownResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTipPovezanogDokumentaEvidencijeDropdownResponse>;
        }));
    }

    protected processGetTipPovezanogDokumentaEvidencijeDropdown(response: HttpResponseBase): Observable<ResultOfGetTipPovezanogDokumentaEvidencijeDropdownResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTipPovezanogDokumentaEvidencijeDropdownResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTipPovezanogDokumentaEvidencijeDropdownResponse>(null as any);
    }

    getOsnovOdabiraDokumentaDropdownQuery(): Observable<ResultOfGetOsnovOdabiraDokumentaDropdownResponse> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna/osnov-odabira-dokumenta-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOsnovOdabiraDokumentaDropdownQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOsnovOdabiraDokumentaDropdownQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetOsnovOdabiraDokumentaDropdownResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetOsnovOdabiraDokumentaDropdownResponse>;
        }));
    }

    protected processGetOsnovOdabiraDokumentaDropdownQuery(response: HttpResponseBase): Observable<ResultOfGetOsnovOdabiraDokumentaDropdownResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetOsnovOdabiraDokumentaDropdownResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetOsnovOdabiraDokumentaDropdownResponse>(null as any);
    }

    getTipPovezanogInternogDropdownQuery(): Observable<ResultOfGetTipPovezanogInternogDropdownResponse> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna/tip-povezanog-internog-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipPovezanogInternogDropdownQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipPovezanogInternogDropdownQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTipPovezanogInternogDropdownResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTipPovezanogInternogDropdownResponse>;
        }));
    }

    protected processGetTipPovezanogInternogDropdownQuery(response: HttpResponseBase): Observable<ResultOfGetTipPovezanogInternogDropdownResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTipPovezanogInternogDropdownResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTipPovezanogInternogDropdownResponse>(null as any);
    }

    getDokumentForPdvAutocomplete(request: GetDokumentForPdvAutocompleteQuery): Observable<ResultOfListOfDokumentForPdvDto> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna/dokument-for-pdv-autocomplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDokumentForPdvAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDokumentForPdvAutocomplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfDokumentForPdvDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfDokumentForPdvDto>;
        }));
    }

    protected processGetDokumentForPdvAutocomplete(response: HttpResponseBase): Observable<ResultOfListOfDokumentForPdvDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfDokumentForPdvDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfDokumentForPdvDto>(null as any);
    }

    getDokumentForPdvByRacunId(racunId: number, vrstaRacuna?: VrstaRacuna | undefined): Observable<ResultOfListOfDokumentForPdvDto> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna/dokument-for-pdv-by-racun-id/{racunId}?";
        if (racunId === undefined || racunId === null)
            throw new Error("The parameter 'racunId' must be defined.");
        url_ = url_.replace("{racunId}", encodeURIComponent("" + racunId));
        if (vrstaRacuna === null)
            throw new Error("The parameter 'vrstaRacuna' cannot be null.");
        else if (vrstaRacuna !== undefined)
            url_ += "vrstaRacuna=" + encodeURIComponent("" + vrstaRacuna) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDokumentForPdvByRacunId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDokumentForPdvByRacunId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfDokumentForPdvDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfDokumentForPdvDto>;
        }));
    }

    protected processGetDokumentForPdvByRacunId(response: HttpResponseBase): Observable<ResultOfListOfDokumentForPdvDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfDokumentForPdvDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfDokumentForPdvDto>(null as any);
    }

    getForTable(request: GetPdvEvidencijaPojedinacnaTableQuery): Observable<PaginatedResultOfPdvEvidencijaPojedinacnaTableDto> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfPdvEvidencijaPojedinacnaTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfPdvEvidencijaPojedinacnaTableDto>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<PaginatedResultOfPdvEvidencijaPojedinacnaTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfPdvEvidencijaPojedinacnaTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfPdvEvidencijaPojedinacnaTableDto>(null as any);
    }

    getForTable39(request: GetPdvEvidencijaPojedinacna39TableQuery): Observable<PaginatedResultOfPdvEvidencijaPojedinacna39TableDto> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna/get-for-table39";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable39(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable39(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfPdvEvidencijaPojedinacna39TableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfPdvEvidencijaPojedinacna39TableDto>;
        }));
    }

    protected processGetForTable39(response: HttpResponseBase): Observable<PaginatedResultOfPdvEvidencijaPojedinacna39TableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfPdvEvidencijaPojedinacna39TableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfPdvEvidencijaPojedinacna39TableDto>(null as any);
    }

    getPdvEvidencijaPojedinacna39Pdf(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna39/{id}/pdf";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdvEvidencijaPojedinacna39Pdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdvEvidencijaPojedinacna39Pdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPdvEvidencijaPojedinacna39Pdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getNewPdvPojedinacnaForIzlazniRacun(racunId: number): Observable<ResultOfDokumentForPdvDto> {
        let url_ = this.baseUrl + "/api/pdvevidencije/new-pojedinacna-for-izlazni-racun/{racunId}";
        if (racunId === undefined || racunId === null)
            throw new Error("The parameter 'racunId' must be defined.");
        url_ = url_.replace("{racunId}", encodeURIComponent("" + racunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewPdvPojedinacnaForIzlazniRacun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewPdvPojedinacnaForIzlazniRacun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfDokumentForPdvDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfDokumentForPdvDto>;
        }));
    }

    protected processGetNewPdvPojedinacnaForIzlazniRacun(response: HttpResponseBase): Observable<ResultOfDokumentForPdvDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfDokumentForPdvDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfDokumentForPdvDto>(null as any);
    }

    sefEvidentirajPdvEvidencijaPojedinacna(command: SefEvidentirajPdvEvidencijaPojedinacnaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna/sef";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSefEvidentirajPdvEvidencijaPojedinacna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSefEvidentirajPdvEvidencijaPojedinacna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSefEvidentirajPdvEvidencijaPojedinacna(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sefGetPdvEvidencijaPojedinacna(evidencijaId?: number | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna/sef?";
        if (evidencijaId === null)
            throw new Error("The parameter 'evidencijaId' cannot be null.");
        else if (evidencijaId !== undefined)
            url_ += "evidencijaId=" + encodeURIComponent("" + evidencijaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSefGetPdvEvidencijaPojedinacna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSefGetPdvEvidencijaPojedinacna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSefGetPdvEvidencijaPojedinacna(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sefEvidentirajPdvEvidencijaPojedinacna39(command: SefEvidentirajPdvEvidencijaPojedinacna39Command): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna39/sef";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSefEvidentirajPdvEvidencijaPojedinacna39(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSefEvidentirajPdvEvidencijaPojedinacna39(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSefEvidentirajPdvEvidencijaPojedinacna39(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sefCancelPdvEvidencijaPojedinacna(command: SefCancelPdvEvidencijaPojedinacnaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna/sef-cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSefCancelPdvEvidencijaPojedinacna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSefCancelPdvEvidencijaPojedinacna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSefCancelPdvEvidencijaPojedinacna(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sefCancelPdvEvidencijaPojedinacna39(command: SefPonistiPdvEvidencijaPojedinacna39Command): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna39/sef-cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSefCancelPdvEvidencijaPojedinacna39(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSefCancelPdvEvidencijaPojedinacna39(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSefCancelPdvEvidencijaPojedinacna39(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sefKorigujPdvEvidencijaPojedinacna(id: number, command: SefKorigujPdvEvidencijaPojedinacnaCommand): Observable<ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna/koriguj/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSefKorigujPdvEvidencijaPojedinacna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSefKorigujPdvEvidencijaPojedinacna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse>;
        }));
    }

    protected processSefKorigujPdvEvidencijaPojedinacna(response: HttpResponseBase): Observable<ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse>(null as any);
    }

    sefKorigujPdvEvidencijaPojedinacna39(id: number, command: SefKorigujPdvEvidencijaPojedinacna39Command): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna39/koriguj/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSefKorigujPdvEvidencijaPojedinacna39(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSefKorigujPdvEvidencijaPojedinacna39(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSefKorigujPdvEvidencijaPojedinacna39(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sefGetListPdvEvidencijaPojedinacna(dateFrom?: Date | undefined, dateTo?: Date | undefined): Observable<ResultOfGetStrankaForPdvAutocompleteResponse> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pojedinacna/sef-list?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSefGetListPdvEvidencijaPojedinacna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSefGetListPdvEvidencijaPojedinacna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetStrankaForPdvAutocompleteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetStrankaForPdvAutocompleteResponse>;
        }));
    }

    protected processSefGetListPdvEvidencijaPojedinacna(response: HttpResponseBase): Observable<ResultOfGetStrankaForPdvAutocompleteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetStrankaForPdvAutocompleteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetStrankaForPdvAutocompleteResponse>(null as any);
    }

    createPPPDV(command: CreatePPPDVEvidencijaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pppdv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePPPDV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePPPDV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreatePPPDV(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getPPPDVEvidencija(id?: number | undefined): Observable<ResultOfPPPDVEvidencijaDto> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pppdv?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPPPDVEvidencija(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPPPDVEvidencija(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfPPPDVEvidencijaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfPPPDVEvidencijaDto>;
        }));
    }

    protected processGetPPPDVEvidencija(response: HttpResponseBase): Observable<ResultOfPPPDVEvidencijaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfPPPDVEvidencijaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfPPPDVEvidencijaDto>(null as any);
    }

    updatePPPDV(id: number, command: UpdatePPPDVEvidencijaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pppdv/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePPPDV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePPPDV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdatePPPDV(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sefEvidentirajPPPDVEvidenciju(command: SefEvidentirajPPPDVEvidencijaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pppdv/sef";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSefEvidentirajPPPDVEvidenciju(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSefEvidentirajPPPDVEvidenciju(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSefEvidentirajPPPDVEvidenciju(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sefKorigujPPPDVEvidenciju(id: number, command: SefKorigujPPPDVEvidencijaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pppdv/koriguj/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSefKorigujPPPDVEvidenciju(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSefKorigujPPPDVEvidenciju(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSefKorigujPPPDVEvidenciju(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getForPPPDVTable(request: GetPPPDVTableQuery): Observable<PaginatedResultOfPPPDVEvidencijaTableDto> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pppdv/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForPPPDVTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForPPPDVTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfPPPDVEvidencijaTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfPPPDVEvidencijaTableDto>;
        }));
    }

    protected processGetForPPPDVTable(response: HttpResponseBase): Observable<PaginatedResultOfPPPDVEvidencijaTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfPPPDVEvidencijaTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfPPPDVEvidencijaTableDto>(null as any);
    }

    getSystemCalculationQuery(request: GetSystemCalculationQuery): Observable<ResultOfSystemCalculationDto> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pppdv-automatizacija";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSystemCalculationQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSystemCalculationQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfSystemCalculationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfSystemCalculationDto>;
        }));
    }

    protected processGetSystemCalculationQuery(response: HttpResponseBase): Observable<ResultOfSystemCalculationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfSystemCalculationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfSystemCalculationDto>(null as any);
    }

    createSefObavestenje(command: CreateSefObavestenjeCommand): Observable<ResultOfSefObavestenjeDto> {
        let url_ = this.baseUrl + "/api/pdvevidencije/sef-obavestenja";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSefObavestenje(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSefObavestenje(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfSefObavestenjeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfSefObavestenjeDto>;
        }));
    }

    protected processCreateSefObavestenje(response: HttpResponseBase): Observable<ResultOfSefObavestenjeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfSefObavestenjeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfSefObavestenjeDto>(null as any);
    }

    getSentSefObavestenja(dateFrom?: Date | null | undefined, dateTo?: Date | null | undefined): Observable<ResultOfListOfSefObavestenjeDto> {
        let url_ = this.baseUrl + "/api/pdvevidencije/sef-obavestenja/data?";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSentSefObavestenja(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSentSefObavestenja(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfSefObavestenjeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfSefObavestenjeDto>;
        }));
    }

    protected processGetSentSefObavestenja(response: HttpResponseBase): Observable<ResultOfListOfSefObavestenjeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfSefObavestenjeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfSefObavestenjeDto>(null as any);
    }

    getReceivedSefObavestenja(dateFrom?: Date | null | undefined, dateTo?: Date | null | undefined): Observable<ResultOfListOfSefObavestenjeDto> {
        let url_ = this.baseUrl + "/api/pdvevidencije/sef-obavestenja/primljeni?";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceivedSefObavestenja(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceivedSefObavestenja(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfSefObavestenjeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfSefObavestenjeDto>;
        }));
    }

    protected processGetReceivedSefObavestenja(response: HttpResponseBase): Observable<ResultOfListOfSefObavestenjeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfSefObavestenjeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfSefObavestenjeDto>(null as any);
    }

    getRacuniForSefObavestenjeAutocomplete(broj?: string | null | undefined): Observable<ResultOfListOfRacunZaSefObavestenjeDto> {
        let url_ = this.baseUrl + "/api/pdvevidencije/sef-obavestenja/racuni-autocomplete?";
        if (broj !== undefined && broj !== null)
            url_ += "broj=" + encodeURIComponent("" + broj) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRacuniForSefObavestenjeAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRacuniForSefObavestenjeAutocomplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfRacunZaSefObavestenjeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfRacunZaSefObavestenjeDto>;
        }));
    }

    protected processGetRacuniForSefObavestenjeAutocomplete(response: HttpResponseBase): Observable<ResultOfListOfRacunZaSefObavestenjeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfRacunZaSefObavestenjeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfRacunZaSefObavestenjeDto>(null as any);
    }

    getRacunForSefObavestenjeById(id: number, jeSefRacun?: boolean | undefined): Observable<ResultOfRacunZaSefObavestenjeDto> {
        let url_ = this.baseUrl + "/api/pdvevidencije/sef-obavestenja/racuni/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (jeSefRacun === null)
            throw new Error("The parameter 'jeSefRacun' cannot be null.");
        else if (jeSefRacun !== undefined)
            url_ += "jeSefRacun=" + encodeURIComponent("" + jeSefRacun) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRacunForSefObavestenjeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRacunForSefObavestenjeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfRacunZaSefObavestenjeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfRacunZaSefObavestenjeDto>;
        }));
    }

    protected processGetRacunForSefObavestenjeById(response: HttpResponseBase): Observable<ResultOfRacunZaSefObavestenjeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfRacunZaSefObavestenjeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfRacunZaSefObavestenjeDto>(null as any);
    }

    getDatoObavestenjePdf(noticeId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/pdvevidencije/sef-obavestenja/dato/{noticeId}/pdf";
        if (noticeId === undefined || noticeId === null)
            throw new Error("The parameter 'noticeId' must be defined.");
        url_ = url_.replace("{noticeId}", encodeURIComponent("" + noticeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDatoObavestenjePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDatoObavestenjePdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetDatoObavestenjePdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getPrimljenoObavestenjePdf(noticeId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/pdvevidencije/sef-obavestenja/primljeno/{noticeId}/pdf";
        if (noticeId === undefined || noticeId === null)
            throw new Error("The parameter 'noticeId' must be defined.");
        url_ = url_.replace("{noticeId}", encodeURIComponent("" + noticeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrimljenoObavestenjePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrimljenoObavestenjePdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPrimljenoObavestenjePdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getSefPPPDVTable(request: GetSefPPPDVTableQuery): Observable<ResultOfListOfSefObavestenjeDto> {
        let url_ = this.baseUrl + "/api/pdvevidencije/pppdv/sef/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSefPPPDVTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSefPPPDVTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfSefObavestenjeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfSefObavestenjeDto>;
        }));
    }

    protected processGetSefPPPDVTable(response: HttpResponseBase): Observable<ResultOfListOfSefObavestenjeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfSefObavestenjeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfSefObavestenjeDto>(null as any);
    }

    createZbirna(command: CreatePdvEvidencijaZbirnaCommand): Observable<ResultOfCreateUpdatePdvEvidencijaZbirnaResponse> {
        let url_ = this.baseUrl + "/api/pdvevidencije/zbirna";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateZbirna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateZbirna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCreateUpdatePdvEvidencijaZbirnaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCreateUpdatePdvEvidencijaZbirnaResponse>;
        }));
    }

    protected processCreateZbirna(response: HttpResponseBase): Observable<ResultOfCreateUpdatePdvEvidencijaZbirnaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCreateUpdatePdvEvidencijaZbirnaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCreateUpdatePdvEvidencijaZbirnaResponse>(null as any);
    }

    getPdvEvidencijaZbirna(id?: number | undefined): Observable<ResultOfPdvEvidencijaZbirnaDto> {
        let url_ = this.baseUrl + "/api/pdvevidencije/zbirna?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdvEvidencijaZbirna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdvEvidencijaZbirna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfPdvEvidencijaZbirnaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfPdvEvidencijaZbirnaDto>;
        }));
    }

    protected processGetPdvEvidencijaZbirna(response: HttpResponseBase): Observable<ResultOfPdvEvidencijaZbirnaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfPdvEvidencijaZbirnaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfPdvEvidencijaZbirnaDto>(null as any);
    }

    createZbirna39(command: CreatePdvEvidencijaZbirna39Command): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/zbirna-39";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateZbirna39(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateZbirna39(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreateZbirna39(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    updateZbirna(id: number, command: UpdatePdvEvidencijaZbirnaCommand): Observable<ResultOfCreateUpdatePdvEvidencijaZbirnaResponse> {
        let url_ = this.baseUrl + "/api/pdvevidencije/zbirna/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateZbirna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateZbirna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCreateUpdatePdvEvidencijaZbirnaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCreateUpdatePdvEvidencijaZbirnaResponse>;
        }));
    }

    protected processUpdateZbirna(response: HttpResponseBase): Observable<ResultOfCreateUpdatePdvEvidencijaZbirnaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCreateUpdatePdvEvidencijaZbirnaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCreateUpdatePdvEvidencijaZbirnaResponse>(null as any);
    }

    deleteZbirna(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/pdvevidencije/zbirna/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteZbirna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteZbirna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteZbirna(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    updateZbirna39(id: number, command: UpdatePdvEvidencijaZbirna39Command): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/zbirna39/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateZbirna39(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateZbirna39(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdateZbirna39(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    deleteZbirna39(id: number): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/zbirna39/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteZbirna39(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteZbirna39(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processDeleteZbirna39(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getForTable2(request: GetPdvEvidencijaZbirnaTableQuery): Observable<PaginatedResultOfPdvEvidencijaZbirnaTableDto> {
        let url_ = this.baseUrl + "/api/pdvevidencije/zbirna/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfPdvEvidencijaZbirnaTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfPdvEvidencijaZbirnaTableDto>;
        }));
    }

    protected processGetForTable2(response: HttpResponseBase): Observable<PaginatedResultOfPdvEvidencijaZbirnaTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfPdvEvidencijaZbirnaTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfPdvEvidencijaZbirnaTableDto>(null as any);
    }

    getForTableZbirna39(request: GetPdvEvidencijaZbirna39TableQuery): Observable<PaginatedResultOfPdvEvidencijaZbirna39TableDto> {
        let url_ = this.baseUrl + "/api/pdvevidencije/zbirna/get-for-table39";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTableZbirna39(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTableZbirna39(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfPdvEvidencijaZbirna39TableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfPdvEvidencijaZbirna39TableDto>;
        }));
    }

    protected processGetForTableZbirna39(response: HttpResponseBase): Observable<PaginatedResultOfPdvEvidencijaZbirna39TableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfPdvEvidencijaZbirna39TableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfPdvEvidencijaZbirna39TableDto>(null as any);
    }

    getPdvEvidencijaZbirna39(id?: number | undefined): Observable<ResultOfPdvEvidencijaZbirna39Dto> {
        let url_ = this.baseUrl + "/api/pdvevidencije/zbirna39?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdvEvidencijaZbirna39(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdvEvidencijaZbirna39(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfPdvEvidencijaZbirna39Dto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfPdvEvidencijaZbirna39Dto>;
        }));
    }

    protected processGetPdvEvidencijaZbirna39(response: HttpResponseBase): Observable<ResultOfPdvEvidencijaZbirna39Dto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfPdvEvidencijaZbirna39Dto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfPdvEvidencijaZbirna39Dto>(null as any);
    }

    getPdvEvidencijaZbirna39Pdf(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/pdvevidencije/zbirna39/{id}/pdf";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdvEvidencijaZbirna39Pdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdvEvidencijaZbirna39Pdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPdvEvidencijaZbirna39Pdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    sefEvidentirajPdvEvidencijaZbirna(command: SefEvidentirajPdvEvidencijaZbirnaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/zbirna/sef";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSefEvidentirajPdvEvidencijaZbirna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSefEvidentirajPdvEvidencijaZbirna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSefEvidentirajPdvEvidencijaZbirna(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sefGetPdvEvidencijaZbirna(evidencijaId?: number | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/zbirna/sef?";
        if (evidencijaId === null)
            throw new Error("The parameter 'evidencijaId' cannot be null.");
        else if (evidencijaId !== undefined)
            url_ += "evidencijaId=" + encodeURIComponent("" + evidencijaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSefGetPdvEvidencijaZbirna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSefGetPdvEvidencijaZbirna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSefGetPdvEvidencijaZbirna(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sefEvidentirajPdvEvidencijaZbirna39(command: SefEvidentirajPdvEvidencijaZbirna39Command): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/zbirna39/sef";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSefEvidentirajPdvEvidencijaZbirna39(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSefEvidentirajPdvEvidencijaZbirna39(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSefEvidentirajPdvEvidencijaZbirna39(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sefCancelPdvEvidencijaZbirna(command: SefCancelPdvEvidencijaZbirnaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/zbirna/sef-cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSefCancelPdvEvidencijaZbirna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSefCancelPdvEvidencijaZbirna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSefCancelPdvEvidencijaZbirna(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sefCancelPdvEvidencijaZbirna39(command: SefPonistiPdvEvidencijaZbirna39Command): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/zbirna39/sef-cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSefCancelPdvEvidencijaZbirna39(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSefCancelPdvEvidencijaZbirna39(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSefCancelPdvEvidencijaZbirna39(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sefKorigujPdvEvidencijaZbirna(id: number, command: SefKorigujPdvEvidencijaZbirnaCommand): Observable<ResultOfCreateUpdatePdvEvidencijaZbirnaResponse> {
        let url_ = this.baseUrl + "/api/pdvevidencije/zbirna/koriguj/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSefKorigujPdvEvidencijaZbirna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSefKorigujPdvEvidencijaZbirna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCreateUpdatePdvEvidencijaZbirnaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCreateUpdatePdvEvidencijaZbirnaResponse>;
        }));
    }

    protected processSefKorigujPdvEvidencijaZbirna(response: HttpResponseBase): Observable<ResultOfCreateUpdatePdvEvidencijaZbirnaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCreateUpdatePdvEvidencijaZbirnaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCreateUpdatePdvEvidencijaZbirnaResponse>(null as any);
    }

    sefKorigujPdvEvidencijaZbirna39(id: number, command: SefKorigujPdvEvidencijaZbirna39Command): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pdvevidencije/zbirna39/koriguj/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSefKorigujPdvEvidencijaZbirna39(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSefKorigujPdvEvidencijaZbirna39(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSefKorigujPdvEvidencijaZbirna39(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }
}

export interface IPoslovneJediniceClient {
    getForTable(): Observable<ResultOfGetTableResponseOfPoslovnaJedinicaTableDto>;
    getById(id: number): Observable<PoslovnaJedinicaDto>;
    create(command: CreatePoslovnaJedinicaCommand): Observable<ResultOfString>;
    update(id: number, command: UpdatePoslovnaJedinicaCommand): Observable<ResultOfPoslovnaJedinicaTableDto>;
    delete(id: number): Observable<FileResponse>;
    getPoslovneJediniceAutocomplete(): Observable<ResultOfGetPoslovneJediniceAutocompleteResponse>;
    getVrstePoslovneJedinice(): Observable<ResultOfGetVrstePoslovneJediniceResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class PoslovneJediniceClient implements IPoslovneJediniceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(): Observable<ResultOfGetTableResponseOfPoslovnaJedinicaTableDto> {
        let url_ = this.baseUrl + "/api/poslovnejedinice/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTableResponseOfPoslovnaJedinicaTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTableResponseOfPoslovnaJedinicaTableDto>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<ResultOfGetTableResponseOfPoslovnaJedinicaTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTableResponseOfPoslovnaJedinicaTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTableResponseOfPoslovnaJedinicaTableDto>(null as any);
    }

    getById(id: number): Observable<PoslovnaJedinicaDto> {
        let url_ = this.baseUrl + "/api/poslovnejedinice/by-id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PoslovnaJedinicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PoslovnaJedinicaDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<PoslovnaJedinicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PoslovnaJedinicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PoslovnaJedinicaDto>(null as any);
    }

    create(command: CreatePoslovnaJedinicaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/poslovnejedinice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    update(id: number, command: UpdatePoslovnaJedinicaCommand): Observable<ResultOfPoslovnaJedinicaTableDto> {
        let url_ = this.baseUrl + "/api/poslovnejedinice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfPoslovnaJedinicaTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfPoslovnaJedinicaTableDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultOfPoslovnaJedinicaTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfPoslovnaJedinicaTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfPoslovnaJedinicaTableDto>(null as any);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/poslovnejedinice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getPoslovneJediniceAutocomplete(): Observable<ResultOfGetPoslovneJediniceAutocompleteResponse> {
        let url_ = this.baseUrl + "/api/poslovnejedinice/get-poslovne-jedinice-autocomplete";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPoslovneJediniceAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPoslovneJediniceAutocomplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetPoslovneJediniceAutocompleteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetPoslovneJediniceAutocompleteResponse>;
        }));
    }

    protected processGetPoslovneJediniceAutocomplete(response: HttpResponseBase): Observable<ResultOfGetPoslovneJediniceAutocompleteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetPoslovneJediniceAutocompleteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPoslovneJediniceAutocompleteResponse>(null as any);
    }

    getVrstePoslovneJedinice(): Observable<ResultOfGetVrstePoslovneJediniceResponse> {
        let url_ = this.baseUrl + "/api/poslovnejedinice/vrste-poslovne-jedinice-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVrstePoslovneJedinice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVrstePoslovneJedinice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetVrstePoslovneJediniceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetVrstePoslovneJediniceResponse>;
        }));
    }

    protected processGetVrstePoslovneJedinice(response: HttpResponseBase): Observable<ResultOfGetVrstePoslovneJediniceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetVrstePoslovneJediniceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetVrstePoslovneJediniceResponse>(null as any);
    }
}

export interface IPravnaLicaClient {
    getForTable(request: GetPravnoLiceTableQuery): Observable<ResultOfGetTableResponseOfPravnoLiceTableDto>;
    getById(id: number): Observable<ResultOfPravnoLiceDto>;
    create(command: CreatePravnoLiceCommand): Observable<ResultOfPravnoLiceVm>;
    update(id: number, command: UpdatePravnoLiceCommand): Observable<ResultOfPravnoLiceVm>;
    delete(id: number): Observable<FileResponse>;
    getFilters(): Observable<ResultOfGetFiltersResponseOfPravnoLiceFilterDto>;
    import(importFile?: FileParameter | null | undefined): Observable<ResultOfString>;
    importInostrana(importFile?: FileParameter | null | undefined): Observable<ResultOfListOfImportInoKupciDobavljaciDto>;
    exportPravnoLice(command: ExportPravnoLiceCommand): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class PravnaLicaClient implements IPravnaLicaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(request: GetPravnoLiceTableQuery): Observable<ResultOfGetTableResponseOfPravnoLiceTableDto> {
        let url_ = this.baseUrl + "/api/pravnalica/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTableResponseOfPravnoLiceTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTableResponseOfPravnoLiceTableDto>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<ResultOfGetTableResponseOfPravnoLiceTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTableResponseOfPravnoLiceTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTableResponseOfPravnoLiceTableDto>(null as any);
    }

    getById(id: number): Observable<ResultOfPravnoLiceDto> {
        let url_ = this.baseUrl + "/api/pravnalica/by-id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfPravnoLiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfPravnoLiceDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ResultOfPravnoLiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfPravnoLiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfPravnoLiceDto>(null as any);
    }

    create(command: CreatePravnoLiceCommand): Observable<ResultOfPravnoLiceVm> {
        let url_ = this.baseUrl + "/api/pravnalica";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfPravnoLiceVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfPravnoLiceVm>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfPravnoLiceVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfPravnoLiceVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfPravnoLiceVm>(null as any);
    }

    update(id: number, command: UpdatePravnoLiceCommand): Observable<ResultOfPravnoLiceVm> {
        let url_ = this.baseUrl + "/api/pravnalica/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfPravnoLiceVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfPravnoLiceVm>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultOfPravnoLiceVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfPravnoLiceVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfPravnoLiceVm>(null as any);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/pravnalica/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getFilters(): Observable<ResultOfGetFiltersResponseOfPravnoLiceFilterDto> {
        let url_ = this.baseUrl + "/api/pravnalica/get-filters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetFiltersResponseOfPravnoLiceFilterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetFiltersResponseOfPravnoLiceFilterDto>;
        }));
    }

    protected processGetFilters(response: HttpResponseBase): Observable<ResultOfGetFiltersResponseOfPravnoLiceFilterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetFiltersResponseOfPravnoLiceFilterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetFiltersResponseOfPravnoLiceFilterDto>(null as any);
    }

    import(importFile?: FileParameter | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pravnalica/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (importFile !== null && importFile !== undefined)
            content_.append("ImportFile", importFile.data, importFile.fileName ? importFile.fileName : "ImportFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    importInostrana(importFile?: FileParameter | null | undefined): Observable<ResultOfListOfImportInoKupciDobavljaciDto> {
        let url_ = this.baseUrl + "/api/pravnalica/import-inostrana";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (importFile !== null && importFile !== undefined)
            content_.append("ImportFile", importFile.data, importFile.fileName ? importFile.fileName : "ImportFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportInostrana(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportInostrana(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfImportInoKupciDobavljaciDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfImportInoKupciDobavljaciDto>;
        }));
    }

    protected processImportInostrana(response: HttpResponseBase): Observable<ResultOfListOfImportInoKupciDobavljaciDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfImportInoKupciDobavljaciDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfImportInoKupciDobavljaciDto>(null as any);
    }

    exportPravnoLice(command: ExportPravnoLiceCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/pravnalica/export-pravno-lice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPravnoLice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPravnoLice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportPravnoLice(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IPredmetStavkiClient {
    getPredmeteStavke(request: GetPredmeteStavkiQuery): Observable<GetPredmeteStavkiVm>;
    getPredmeteStavkeZaRacune(request: GetPredmeteStavkiZaRacunQuery): Observable<GetPredmeteStavkiZaRacunVm>;
    getPredmeteStavkeZaEOtpremnicu(request: GetPredmeteStavkiZaEotpremnicuQuery): Observable<GetPredmeteStavkiZaEotpremnicuVm>;
}

@Injectable({
    providedIn: 'root'
})
export class PredmetStavkiClient implements IPredmetStavkiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getPredmeteStavke(request: GetPredmeteStavkiQuery): Observable<GetPredmeteStavkiVm> {
        let url_ = this.baseUrl + "/api/predmetstavki";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPredmeteStavke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPredmeteStavke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPredmeteStavkiVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPredmeteStavkiVm>;
        }));
    }

    protected processGetPredmeteStavke(response: HttpResponseBase): Observable<GetPredmeteStavkiVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPredmeteStavkiVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPredmeteStavkiVm>(null as any);
    }

    getPredmeteStavkeZaRacune(request: GetPredmeteStavkiZaRacunQuery): Observable<GetPredmeteStavkiZaRacunVm> {
        let url_ = this.baseUrl + "/api/predmetstavki/za-racune";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPredmeteStavkeZaRacune(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPredmeteStavkeZaRacune(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPredmeteStavkiZaRacunVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPredmeteStavkiZaRacunVm>;
        }));
    }

    protected processGetPredmeteStavkeZaRacune(response: HttpResponseBase): Observable<GetPredmeteStavkiZaRacunVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPredmeteStavkiZaRacunVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPredmeteStavkiZaRacunVm>(null as any);
    }

    getPredmeteStavkeZaEOtpremnicu(request: GetPredmeteStavkiZaEotpremnicuQuery): Observable<GetPredmeteStavkiZaEotpremnicuVm> {
        let url_ = this.baseUrl + "/api/predmetstavki/za-eotpremnice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPredmeteStavkeZaEOtpremnicu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPredmeteStavkeZaEOtpremnicu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPredmeteStavkiZaEotpremnicuVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPredmeteStavkiZaEotpremnicuVm>;
        }));
    }

    protected processGetPredmeteStavkeZaEOtpremnicu(response: HttpResponseBase): Observable<GetPredmeteStavkiZaEotpremnicuVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPredmeteStavkiZaEotpremnicuVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPredmeteStavkiZaEotpremnicuVm>(null as any);
    }
}

export interface IPredracuniClient {
    create(command: CreatePredracunCommand): Observable<ResultOfLong>;
    update(id: number, command: UpdatePredracunCommand): Observable<FileResponse>;
    getDomaciPredracun(request: GetPredracunQuery): Observable<ResultOfPredracunDto>;
    duplicatePredracun(id: number): Observable<ResultOfPredracunDto>;
    getNewForStranka(strankaId: string): Observable<ResultOfPredracunDto>;
    getNewForPonuda(racunId: number): Observable<ResultOfPredracunDto>;
    cancelPredracun(request: CancelPredracunCommand): Observable<ResultOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class PredracuniClient implements IPredracuniClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    create(command: CreatePredracunCommand): Observable<ResultOfLong> {
        let url_ = this.baseUrl + "/api/predracuni";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfLong>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfLong>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfLong> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfLong.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLong>(null as any);
    }

    update(id: number, command: UpdatePredracunCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/predracuni/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getDomaciPredracun(request: GetPredracunQuery): Observable<ResultOfPredracunDto> {
        let url_ = this.baseUrl + "/api/predracuni/get-domaci-predracun";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDomaciPredracun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDomaciPredracun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfPredracunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfPredracunDto>;
        }));
    }

    protected processGetDomaciPredracun(response: HttpResponseBase): Observable<ResultOfPredracunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfPredracunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfPredracunDto>(null as any);
    }

    duplicatePredracun(id: number): Observable<ResultOfPredracunDto> {
        let url_ = this.baseUrl + "/api/predracuni/duplicate-predracun/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicatePredracun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicatePredracun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfPredracunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfPredracunDto>;
        }));
    }

    protected processDuplicatePredracun(response: HttpResponseBase): Observable<ResultOfPredracunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfPredracunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfPredracunDto>(null as any);
    }

    getNewForStranka(strankaId: string): Observable<ResultOfPredracunDto> {
        let url_ = this.baseUrl + "/api/predracuni/new-for-stranka/{strankaId}";
        if (strankaId === undefined || strankaId === null)
            throw new Error("The parameter 'strankaId' must be defined.");
        url_ = url_.replace("{strankaId}", encodeURIComponent("" + strankaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewForStranka(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewForStranka(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfPredracunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfPredracunDto>;
        }));
    }

    protected processGetNewForStranka(response: HttpResponseBase): Observable<ResultOfPredracunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfPredracunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfPredracunDto>(null as any);
    }

    getNewForPonuda(racunId: number): Observable<ResultOfPredracunDto> {
        let url_ = this.baseUrl + "/api/predracuni/new-for-ponuda/{racunId}";
        if (racunId === undefined || racunId === null)
            throw new Error("The parameter 'racunId' must be defined.");
        url_ = url_.replace("{racunId}", encodeURIComponent("" + racunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewForPonuda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewForPonuda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfPredracunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfPredracunDto>;
        }));
    }

    protected processGetNewForPonuda(response: HttpResponseBase): Observable<ResultOfPredracunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfPredracunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfPredracunDto>(null as any);
    }

    cancelPredracun(request: CancelPredracunCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/predracuni/cancel-predracun";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPredracun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPredracun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCancelPredracun(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }
}

export interface IRacuniClient {
    getForTable(request: GetRacunTableQuery): Observable<PaginatedResultOfRacunTableDtoAndRacunSaldoDto>;
    getSaldo(request: GetRacunSaldoQuery): Observable<ResultOfRacunSaldoResult>;
    getSaldoZbirno(request: GetSaldoFaktureZbirnoQuery): Observable<ResultOfSaldoFaktureZbirnoResult>;
    getSaldoAvansaZbirno(request: GetSaldoAvansaZbirnoQuery): Observable<ResultOfSaldoAvansaZbirnoResult>;
    getRacuniForFileManager(tipRacuna?: TipRacuna | undefined): Observable<ResultOfGetForFileManagerResponse>;
    getNeplaceniForTable(request: GetNeplaceniRacunTableQuery): Observable<ResultOfGetNeplaceniRacunTableResponse>;
    getPocetnoStanjeRacunTable(vrstaRacuna?: VrstaRacuna | undefined, jeDevizna?: boolean | undefined): Observable<ResultOfGetPocetnoStanjeRacunTableResponse>;
    getVezaniRacunAutocomplete(request: GetVezaniRacunAutocompleteQuery): Observable<ResultOfListOfVezaniRacunDto>;
    getRacuniKompenzacijaAutocomplete(request: GetRacuniKompenzacijaAutocompleteQuery): Observable<ResultOfListOfRacunKompenzacijaDto>;
    getRacun(request: GetRacunQuery): Observable<ResultOfRacunDto>;
    getRacunInfo(request: GetRacunInfoQuery): Observable<ResultOfRacunInfoDto>;
    getPravila(tipRacuna: TipRacuna): Observable<ResultOfGetPravilaZaBrojResponse>;
    checkIfBrojRacunaExists(request: CheckIfBrojRacunaExistsQuery): Observable<ResultOfBoolean>;
    getOpstaPravilaKonfiguracija(): Observable<ResultOfOpstaPravilaKonfiguracijaDto>;
    getKonfiguracijaDeviznih(): Observable<ResultOfKonfiguracijaDeviznogRacunaDto>;
    getOpomeneKonfiguracija(): Observable<ResultOfOpomeneKonfiguracijaDto>;
    getPravilaZaBrojKonfiguracija(id?: number | null | undefined): Observable<ResultOfGetPravilaZaBrojKonfiguracijaResponse>;
    searchStrankaRacuna(searchValue?: string | null | undefined, jeMojaFirma?: boolean | undefined): Observable<ResultOfSearchStrankaRacunaResponse>;
    getStrankaRacunaSaRacuna(racunId?: number | undefined): Observable<ResultOfStrankaRacunaDto>;
    getPocetnoStanje(strankaId?: number | undefined, vrstaRacuna?: VrstaRacuna | undefined): Observable<ResultOfGetPocetnoStanjeRacunResponse>;
    getFormConfiguration(): Observable<ResultOfGetFormConfigurationResponse>;
    getFormConfigurationDevizni(): Observable<ResultOfGetFormConfigurationDevizniResponse>;
    getPdf(racunId: number, previewTitle: string, pdfNaEngleskom?: boolean | undefined): Observable<FileResponse>;
    getIzjavaZaOdbitakPdvPdf(racunId: number): Observable<FileResponse>;
    getUplatnicaPdf(request: GetUplatnicaPdfQuery): Observable<FileResponse>;
    getIzjavaOPorekluPdf(racunId?: number | undefined): Observable<FileResponse>;
    downloadUlazniRacun(racunId?: number | undefined): Observable<ResultOfString>;
    getUlazniRacunPdf(racunId?: number | undefined): Observable<FileResponse>;
    getRazlogOtkazivanjaStorniranja(racunId?: number | undefined): Observable<Result>;
    getRelevantneDokumente(racunId?: number | undefined): Observable<ResultOfGetRelevantniDokumentUrlListResponse>;
    getRelevantniDokumentUrl(storageFileName?: string | null | undefined): Observable<ResultOfRelevantniDokumentListItemUrlDto>;
    getRelevantniDokument(storageFileName?: string | null | undefined): Observable<FileResponse>;
    exportRacun(command: ExportRacunCommand): Observable<FileResponse>;
    oznaciKaoPoslato(id: number): Observable<ResultOfString>;
    duplirajMasovno(command: DuplirajRacuneCommand): Observable<ResultOfString>;
    posaljiPredracuneEmailom(command: PosaljiPredracuneEmailomCommand): Observable<ResultOfString>;
    uploadMissingPdf(id: number): Observable<ResultOfGetRelevantniDokumentUrlListResponse>;
    getTipTransakcije(): Observable<ResultOfListOfTipTransakcijeUplataDto>;
    getDodatnaUplataById(id?: number | undefined): Observable<ResultOfUplataPoRacunuDto>;
    refreshSaldoViews(id?: number | undefined): Observable<ResultOfString>;
    sendIzjavaZaOdbitakPdv(racunId?: number | undefined, strankaId?: number | null | undefined, to?: string[] | null | undefined, cc?: string[] | null | undefined, attachments?: FileParameter[] | null | undefined): Observable<ResultOfString>;
    getRacunRelevantniDokumentListZipped(request: GetRacunRelevantniDokumentListZippedQuery): Observable<FileResponse>;
    getIzlazniRacunUbl(request: GetIzlazniRacunUblQuery): Observable<FileResponse>;
    posaljiPodsetnikZaPlacanje(request: SendPodsetnikPlacanjaRacunaCommand): Observable<ResultOfString>;
    sendRacunElektronski(racunId?: number | undefined, fromId?: string | undefined, to?: string[] | null | undefined, cc?: string[] | null | undefined, mailNaslov?: string | null | undefined, posaljiNaEngleskom?: boolean | undefined, customPoruka?: string | null | undefined, attachments?: FileParameter[] | null | undefined): Observable<ResultOfString>;
    /**
     * @param racunId (optional) 
     * @param file (optional) 
     * @deprecated
     */
    uploadUlazniRacun(racunId?: number | undefined, file?: FileParameter | null | undefined): Observable<ResultOfString>;
    importXml(files?: FileParameter[] | null | undefined, xml?: XmlRacuna | null | undefined, memorandumId?: number | undefined, tekuciRacunId?: number | undefined): Observable<ResultOfString>;
    removeOznaka(request: RemoveOznakaRacunaCommand): Observable<ResultOfString>;
    addOznake(request: AddOznakeRacunaCommand): Observable<ResultOfString>;
    addVezaniRacuni(request: AddPovezaniRacunCommand): Observable<ResultOfListOfVezaniRacunDto>;
    placanjeStarihRacuna(importFile?: FileParameter | null | undefined, datumDo?: Date | undefined): Observable<ResultOfListOfImportPlacanjeStarihRacunaDto>;
    createDodatnuUplatuRacuna(command: CreateDodatnuUplatuRacunaCommand): Observable<ResultOfListOfCreateDodatnuUplatuRacunaCommand>;
    updateDodatnuUplatuRacuna(command: UpdateDodatnuUplatuRacunaCommand): Observable<ResultOfString>;
    getRacuneZaPlacanje(request: GetRacuneZaPlacanjeQuery): Observable<PaginatedResultOfRacunZaPlacanjeDto>;
    createFilterTemplate(command: CreateRacunFilterCommand): Observable<boolean>;
    getFilters(): Observable<ResultOfGetFiltersResponseOfRacunFilterDto>;
    delete(id: number): Observable<FileResponse>;
    createPraviloZaBroj(request: CreatePraviloZaBrojCommand): Observable<ResultOfKonfiguracijaBrojaRacunaDto>;
    removeVezaniRacun(command: RemoveVezaniRacunCommand): Observable<Result>;
    removeEOtpremnicaFromRacun(command: RemoveEOtpremnicaFromRacunCommand): Observable<Result>;
    addEOtpremnicaToRacun(command: AddEOtpremnicaToRacunCommand): Observable<Result>;
    updatePraviloZaBroj(command: UpdatePraviloZaBrojCommand, id?: number | undefined): Observable<ResultOfKonfiguracijaBrojaRacunaDto>;
    deletePraviloZaBroj(id?: number | undefined): Observable<ResultOfString>;
    updateOpstaPravila(command: UpdateOpstaPravilaCommand): Observable<ResultOfOpstaPravilaKonfiguracijaDto>;
    updateStatusRacuna(racunId?: number | undefined, statusRacuna?: StatusRacuna | undefined): Observable<ResultOfString>;
    updateKonfiguracijaDeviznog(command: UpdateKonfiguracijaDeviznihCommand): Observable<ResultOfKonfiguracijaDeviznogRacunaDto>;
    getPodtipDokumentaDropdown(): Observable<ResultOfListOfBuyerReferenceDto>;
    deleteDodatnuUplatu(id: number): Observable<ResultOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class RacuniClient implements IRacuniClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(request: GetRacunTableQuery): Observable<PaginatedResultOfRacunTableDtoAndRacunSaldoDto> {
        let url_ = this.baseUrl + "/api/racuni/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfRacunTableDtoAndRacunSaldoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfRacunTableDtoAndRacunSaldoDto>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<PaginatedResultOfRacunTableDtoAndRacunSaldoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfRacunTableDtoAndRacunSaldoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfRacunTableDtoAndRacunSaldoDto>(null as any);
    }

    getSaldo(request: GetRacunSaldoQuery): Observable<ResultOfRacunSaldoResult> {
        let url_ = this.baseUrl + "/api/racuni/get-saldo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSaldo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSaldo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfRacunSaldoResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfRacunSaldoResult>;
        }));
    }

    protected processGetSaldo(response: HttpResponseBase): Observable<ResultOfRacunSaldoResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfRacunSaldoResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfRacunSaldoResult>(null as any);
    }

    getSaldoZbirno(request: GetSaldoFaktureZbirnoQuery): Observable<ResultOfSaldoFaktureZbirnoResult> {
        let url_ = this.baseUrl + "/api/racuni/get-saldo-zbirno";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSaldoZbirno(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSaldoZbirno(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfSaldoFaktureZbirnoResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfSaldoFaktureZbirnoResult>;
        }));
    }

    protected processGetSaldoZbirno(response: HttpResponseBase): Observable<ResultOfSaldoFaktureZbirnoResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfSaldoFaktureZbirnoResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfSaldoFaktureZbirnoResult>(null as any);
    }

    getSaldoAvansaZbirno(request: GetSaldoAvansaZbirnoQuery): Observable<ResultOfSaldoAvansaZbirnoResult> {
        let url_ = this.baseUrl + "/api/racuni/get-saldo-avansa-zbirno";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSaldoAvansaZbirno(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSaldoAvansaZbirno(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfSaldoAvansaZbirnoResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfSaldoAvansaZbirnoResult>;
        }));
    }

    protected processGetSaldoAvansaZbirno(response: HttpResponseBase): Observable<ResultOfSaldoAvansaZbirnoResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfSaldoAvansaZbirnoResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfSaldoAvansaZbirnoResult>(null as any);
    }

    getRacuniForFileManager(tipRacuna?: TipRacuna | undefined): Observable<ResultOfGetForFileManagerResponse> {
        let url_ = this.baseUrl + "/api/racuni/get-for-file-manager?";
        if (tipRacuna === null)
            throw new Error("The parameter 'tipRacuna' cannot be null.");
        else if (tipRacuna !== undefined)
            url_ += "tipRacuna=" + encodeURIComponent("" + tipRacuna) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRacuniForFileManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRacuniForFileManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetForFileManagerResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetForFileManagerResponse>;
        }));
    }

    protected processGetRacuniForFileManager(response: HttpResponseBase): Observable<ResultOfGetForFileManagerResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetForFileManagerResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetForFileManagerResponse>(null as any);
    }

    getNeplaceniForTable(request: GetNeplaceniRacunTableQuery): Observable<ResultOfGetNeplaceniRacunTableResponse> {
        let url_ = this.baseUrl + "/api/racuni/get-neplaceni-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNeplaceniForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNeplaceniForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetNeplaceniRacunTableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetNeplaceniRacunTableResponse>;
        }));
    }

    protected processGetNeplaceniForTable(response: HttpResponseBase): Observable<ResultOfGetNeplaceniRacunTableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetNeplaceniRacunTableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetNeplaceniRacunTableResponse>(null as any);
    }

    getPocetnoStanjeRacunTable(vrstaRacuna?: VrstaRacuna | undefined, jeDevizna?: boolean | undefined): Observable<ResultOfGetPocetnoStanjeRacunTableResponse> {
        let url_ = this.baseUrl + "/api/racuni/get-pocetno-stanje-for-table?";
        if (vrstaRacuna === null)
            throw new Error("The parameter 'vrstaRacuna' cannot be null.");
        else if (vrstaRacuna !== undefined)
            url_ += "vrstaRacuna=" + encodeURIComponent("" + vrstaRacuna) + "&";
        if (jeDevizna === null)
            throw new Error("The parameter 'jeDevizna' cannot be null.");
        else if (jeDevizna !== undefined)
            url_ += "jeDevizna=" + encodeURIComponent("" + jeDevizna) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPocetnoStanjeRacunTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPocetnoStanjeRacunTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetPocetnoStanjeRacunTableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetPocetnoStanjeRacunTableResponse>;
        }));
    }

    protected processGetPocetnoStanjeRacunTable(response: HttpResponseBase): Observable<ResultOfGetPocetnoStanjeRacunTableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetPocetnoStanjeRacunTableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPocetnoStanjeRacunTableResponse>(null as any);
    }

    getVezaniRacunAutocomplete(request: GetVezaniRacunAutocompleteQuery): Observable<ResultOfListOfVezaniRacunDto> {
        let url_ = this.baseUrl + "/api/racuni/get-vezani-racun-autocomplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVezaniRacunAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVezaniRacunAutocomplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfVezaniRacunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfVezaniRacunDto>;
        }));
    }

    protected processGetVezaniRacunAutocomplete(response: HttpResponseBase): Observable<ResultOfListOfVezaniRacunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfVezaniRacunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfVezaniRacunDto>(null as any);
    }

    getRacuniKompenzacijaAutocomplete(request: GetRacuniKompenzacijaAutocompleteQuery): Observable<ResultOfListOfRacunKompenzacijaDto> {
        let url_ = this.baseUrl + "/api/racuni/get-racuni-kompenzacija-autocomplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRacuniKompenzacijaAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRacuniKompenzacijaAutocomplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfRacunKompenzacijaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfRacunKompenzacijaDto>;
        }));
    }

    protected processGetRacuniKompenzacijaAutocomplete(response: HttpResponseBase): Observable<ResultOfListOfRacunKompenzacijaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfRacunKompenzacijaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfRacunKompenzacijaDto>(null as any);
    }

    getRacun(request: GetRacunQuery): Observable<ResultOfRacunDto> {
        let url_ = this.baseUrl + "/api/racuni/get-racun";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRacun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRacun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfRacunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfRacunDto>;
        }));
    }

    protected processGetRacun(response: HttpResponseBase): Observable<ResultOfRacunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfRacunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfRacunDto>(null as any);
    }

    getRacunInfo(request: GetRacunInfoQuery): Observable<ResultOfRacunInfoDto> {
        let url_ = this.baseUrl + "/api/racuni/get-racun-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRacunInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRacunInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfRacunInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfRacunInfoDto>;
        }));
    }

    protected processGetRacunInfo(response: HttpResponseBase): Observable<ResultOfRacunInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfRacunInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfRacunInfoDto>(null as any);
    }

    getPravila(tipRacuna: TipRacuna): Observable<ResultOfGetPravilaZaBrojResponse> {
        let url_ = this.baseUrl + "/api/racuni/pravila-broja-za/{tipRacuna}";
        if (tipRacuna === undefined || tipRacuna === null)
            throw new Error("The parameter 'tipRacuna' must be defined.");
        url_ = url_.replace("{tipRacuna}", encodeURIComponent("" + tipRacuna));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPravila(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPravila(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetPravilaZaBrojResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetPravilaZaBrojResponse>;
        }));
    }

    protected processGetPravila(response: HttpResponseBase): Observable<ResultOfGetPravilaZaBrojResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetPravilaZaBrojResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPravilaZaBrojResponse>(null as any);
    }

    checkIfBrojRacunaExists(request: CheckIfBrojRacunaExistsQuery): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/racuni/check-broj-racuna-existance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfBrojRacunaExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfBrojRacunaExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfBoolean>;
        }));
    }

    protected processCheckIfBrojRacunaExists(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(null as any);
    }

    getOpstaPravilaKonfiguracija(): Observable<ResultOfOpstaPravilaKonfiguracijaDto> {
        let url_ = this.baseUrl + "/api/racuni/opsta-pravila-konfiguracija";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOpstaPravilaKonfiguracija(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOpstaPravilaKonfiguracija(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfOpstaPravilaKonfiguracijaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfOpstaPravilaKonfiguracijaDto>;
        }));
    }

    protected processGetOpstaPravilaKonfiguracija(response: HttpResponseBase): Observable<ResultOfOpstaPravilaKonfiguracijaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfOpstaPravilaKonfiguracijaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfOpstaPravilaKonfiguracijaDto>(null as any);
    }

    getKonfiguracijaDeviznih(): Observable<ResultOfKonfiguracijaDeviznogRacunaDto> {
        let url_ = this.baseUrl + "/api/racuni/devizni-racuni-konfiguracija";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKonfiguracijaDeviznih(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKonfiguracijaDeviznih(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfKonfiguracijaDeviznogRacunaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfKonfiguracijaDeviznogRacunaDto>;
        }));
    }

    protected processGetKonfiguracijaDeviznih(response: HttpResponseBase): Observable<ResultOfKonfiguracijaDeviznogRacunaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfKonfiguracijaDeviznogRacunaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfKonfiguracijaDeviznogRacunaDto>(null as any);
    }

    getOpomeneKonfiguracija(): Observable<ResultOfOpomeneKonfiguracijaDto> {
        let url_ = this.baseUrl + "/api/racuni/opomene-konfiguracija";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOpomeneKonfiguracija(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOpomeneKonfiguracija(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfOpomeneKonfiguracijaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfOpomeneKonfiguracijaDto>;
        }));
    }

    protected processGetOpomeneKonfiguracija(response: HttpResponseBase): Observable<ResultOfOpomeneKonfiguracijaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfOpomeneKonfiguracijaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfOpomeneKonfiguracijaDto>(null as any);
    }

    getPravilaZaBrojKonfiguracija(id?: number | null | undefined): Observable<ResultOfGetPravilaZaBrojKonfiguracijaResponse> {
        let url_ = this.baseUrl + "/api/racuni/pravila-za-broj-konfiguracija?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPravilaZaBrojKonfiguracija(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPravilaZaBrojKonfiguracija(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetPravilaZaBrojKonfiguracijaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetPravilaZaBrojKonfiguracijaResponse>;
        }));
    }

    protected processGetPravilaZaBrojKonfiguracija(response: HttpResponseBase): Observable<ResultOfGetPravilaZaBrojKonfiguracijaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetPravilaZaBrojKonfiguracijaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPravilaZaBrojKonfiguracijaResponse>(null as any);
    }

    searchStrankaRacuna(searchValue?: string | null | undefined, jeMojaFirma?: boolean | undefined): Observable<ResultOfSearchStrankaRacunaResponse> {
        let url_ = this.baseUrl + "/api/racuni/search-stranka-racuna?";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        if (jeMojaFirma === null)
            throw new Error("The parameter 'jeMojaFirma' cannot be null.");
        else if (jeMojaFirma !== undefined)
            url_ += "jeMojaFirma=" + encodeURIComponent("" + jeMojaFirma) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchStrankaRacuna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchStrankaRacuna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfSearchStrankaRacunaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfSearchStrankaRacunaResponse>;
        }));
    }

    protected processSearchStrankaRacuna(response: HttpResponseBase): Observable<ResultOfSearchStrankaRacunaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfSearchStrankaRacunaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfSearchStrankaRacunaResponse>(null as any);
    }

    getStrankaRacunaSaRacuna(racunId?: number | undefined): Observable<ResultOfStrankaRacunaDto> {
        let url_ = this.baseUrl + "/api/racuni/get-stranka-racuna-sa-racuna?";
        if (racunId === null)
            throw new Error("The parameter 'racunId' cannot be null.");
        else if (racunId !== undefined)
            url_ += "racunId=" + encodeURIComponent("" + racunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStrankaRacunaSaRacuna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStrankaRacunaSaRacuna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfStrankaRacunaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfStrankaRacunaDto>;
        }));
    }

    protected processGetStrankaRacunaSaRacuna(response: HttpResponseBase): Observable<ResultOfStrankaRacunaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfStrankaRacunaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfStrankaRacunaDto>(null as any);
    }

    getPocetnoStanje(strankaId?: number | undefined, vrstaRacuna?: VrstaRacuna | undefined): Observable<ResultOfGetPocetnoStanjeRacunResponse> {
        let url_ = this.baseUrl + "/api/racuni/pocetno-stanje-racun?";
        if (strankaId === null)
            throw new Error("The parameter 'strankaId' cannot be null.");
        else if (strankaId !== undefined)
            url_ += "strankaId=" + encodeURIComponent("" + strankaId) + "&";
        if (vrstaRacuna === null)
            throw new Error("The parameter 'vrstaRacuna' cannot be null.");
        else if (vrstaRacuna !== undefined)
            url_ += "vrstaRacuna=" + encodeURIComponent("" + vrstaRacuna) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPocetnoStanje(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPocetnoStanje(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetPocetnoStanjeRacunResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetPocetnoStanjeRacunResponse>;
        }));
    }

    protected processGetPocetnoStanje(response: HttpResponseBase): Observable<ResultOfGetPocetnoStanjeRacunResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetPocetnoStanjeRacunResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPocetnoStanjeRacunResponse>(null as any);
    }

    getFormConfiguration(): Observable<ResultOfGetFormConfigurationResponse> {
        let url_ = this.baseUrl + "/api/racuni/form-configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetFormConfigurationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetFormConfigurationResponse>;
        }));
    }

    protected processGetFormConfiguration(response: HttpResponseBase): Observable<ResultOfGetFormConfigurationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetFormConfigurationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetFormConfigurationResponse>(null as any);
    }

    getFormConfigurationDevizni(): Observable<ResultOfGetFormConfigurationDevizniResponse> {
        let url_ = this.baseUrl + "/api/racuni/form-configuration-devizni";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormConfigurationDevizni(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormConfigurationDevizni(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetFormConfigurationDevizniResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetFormConfigurationDevizniResponse>;
        }));
    }

    protected processGetFormConfigurationDevizni(response: HttpResponseBase): Observable<ResultOfGetFormConfigurationDevizniResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetFormConfigurationDevizniResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetFormConfigurationDevizniResponse>(null as any);
    }

    getPdf(racunId: number, previewTitle: string, pdfNaEngleskom?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/racuni/get-pdf/{racunId}/{previewTitle}?";
        if (racunId === undefined || racunId === null)
            throw new Error("The parameter 'racunId' must be defined.");
        url_ = url_.replace("{racunId}", encodeURIComponent("" + racunId));
        if (previewTitle === undefined || previewTitle === null)
            throw new Error("The parameter 'previewTitle' must be defined.");
        url_ = url_.replace("{previewTitle}", encodeURIComponent("" + previewTitle));
        if (pdfNaEngleskom === null)
            throw new Error("The parameter 'pdfNaEngleskom' cannot be null.");
        else if (pdfNaEngleskom !== undefined)
            url_ += "pdfNaEngleskom=" + encodeURIComponent("" + pdfNaEngleskom) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getIzjavaZaOdbitakPdvPdf(racunId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/racuni/get-izjava-za-odbitak-pdf/{racunId}";
        if (racunId === undefined || racunId === null)
            throw new Error("The parameter 'racunId' must be defined.");
        url_ = url_.replace("{racunId}", encodeURIComponent("" + racunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIzjavaZaOdbitakPdvPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIzjavaZaOdbitakPdvPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetIzjavaZaOdbitakPdvPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getUplatnicaPdf(request: GetUplatnicaPdfQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/racuni/get-uplatnica-pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUplatnicaPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUplatnicaPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetUplatnicaPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getIzjavaOPorekluPdf(racunId?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/racuni/get-izjava-o-poreklu-pdf?";
        if (racunId === null)
            throw new Error("The parameter 'racunId' cannot be null.");
        else if (racunId !== undefined)
            url_ += "racunId=" + encodeURIComponent("" + racunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIzjavaOPorekluPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIzjavaOPorekluPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetIzjavaOPorekluPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    downloadUlazniRacun(racunId?: number | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/racuni/download-ulazni-racun?";
        if (racunId === null)
            throw new Error("The parameter 'racunId' cannot be null.");
        else if (racunId !== undefined)
            url_ += "racunId=" + encodeURIComponent("" + racunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadUlazniRacun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadUlazniRacun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processDownloadUlazniRacun(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getUlazniRacunPdf(racunId?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/racuni/get-ulazni-racun-pdf?";
        if (racunId === null)
            throw new Error("The parameter 'racunId' cannot be null.");
        else if (racunId !== undefined)
            url_ += "racunId=" + encodeURIComponent("" + racunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUlazniRacunPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUlazniRacunPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetUlazniRacunPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getRazlogOtkazivanjaStorniranja(racunId?: number | undefined): Observable<Result> {
        let url_ = this.baseUrl + "/api/racuni/get-razlog-otkazivanja-storniranja?";
        if (racunId === null)
            throw new Error("The parameter 'racunId' cannot be null.");
        else if (racunId !== undefined)
            url_ += "racunId=" + encodeURIComponent("" + racunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRazlogOtkazivanjaStorniranja(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRazlogOtkazivanjaStorniranja(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processGetRazlogOtkazivanjaStorniranja(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    getRelevantneDokumente(racunId?: number | undefined): Observable<ResultOfGetRelevantniDokumentUrlListResponse> {
        let url_ = this.baseUrl + "/api/racuni/get-relevantne-dokumente?";
        if (racunId === null)
            throw new Error("The parameter 'racunId' cannot be null.");
        else if (racunId !== undefined)
            url_ += "racunId=" + encodeURIComponent("" + racunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelevantneDokumente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelevantneDokumente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetRelevantniDokumentUrlListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetRelevantniDokumentUrlListResponse>;
        }));
    }

    protected processGetRelevantneDokumente(response: HttpResponseBase): Observable<ResultOfGetRelevantniDokumentUrlListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetRelevantniDokumentUrlListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetRelevantniDokumentUrlListResponse>(null as any);
    }

    getRelevantniDokumentUrl(storageFileName?: string | null | undefined): Observable<ResultOfRelevantniDokumentListItemUrlDto> {
        let url_ = this.baseUrl + "/api/racuni/get-relevantni-dokument-url?";
        if (storageFileName !== undefined && storageFileName !== null)
            url_ += "storageFileName=" + encodeURIComponent("" + storageFileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelevantniDokumentUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelevantniDokumentUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfRelevantniDokumentListItemUrlDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfRelevantniDokumentListItemUrlDto>;
        }));
    }

    protected processGetRelevantniDokumentUrl(response: HttpResponseBase): Observable<ResultOfRelevantniDokumentListItemUrlDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfRelevantniDokumentListItemUrlDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfRelevantniDokumentListItemUrlDto>(null as any);
    }

    getRelevantniDokument(storageFileName?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/racuni/get-relevantni-dokument-content?";
        if (storageFileName !== undefined && storageFileName !== null)
            url_ += "storageFileName=" + encodeURIComponent("" + storageFileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelevantniDokument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelevantniDokument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetRelevantniDokument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    exportRacun(command: ExportRacunCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/racuni/export-racun";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportRacun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRacun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportRacun(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    oznaciKaoPoslato(id: number): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/racuni/oznaci-kao-poslat/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOznaciKaoPoslato(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOznaciKaoPoslato(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processOznaciKaoPoslato(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    duplirajMasovno(command: DuplirajRacuneCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/racuni/dupliraj-masovno";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplirajMasovno(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplirajMasovno(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processDuplirajMasovno(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    posaljiPredracuneEmailom(command: PosaljiPredracuneEmailomCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/racuni/posalji-predracune-emailom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosaljiPredracuneEmailom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosaljiPredracuneEmailom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processPosaljiPredracuneEmailom(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    uploadMissingPdf(id: number): Observable<ResultOfGetRelevantniDokumentUrlListResponse> {
        let url_ = this.baseUrl + "/api/racuni/upload-missing-pdf/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMissingPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMissingPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetRelevantniDokumentUrlListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetRelevantniDokumentUrlListResponse>;
        }));
    }

    protected processUploadMissingPdf(response: HttpResponseBase): Observable<ResultOfGetRelevantniDokumentUrlListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetRelevantniDokumentUrlListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetRelevantniDokumentUrlListResponse>(null as any);
    }

    getTipTransakcije(): Observable<ResultOfListOfTipTransakcijeUplataDto> {
        let url_ = this.baseUrl + "/api/racuni/tip-transakcije-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipTransakcije(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipTransakcije(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfTipTransakcijeUplataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfTipTransakcijeUplataDto>;
        }));
    }

    protected processGetTipTransakcije(response: HttpResponseBase): Observable<ResultOfListOfTipTransakcijeUplataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfTipTransakcijeUplataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfTipTransakcijeUplataDto>(null as any);
    }

    getDodatnaUplataById(id?: number | undefined): Observable<ResultOfUplataPoRacunuDto> {
        let url_ = this.baseUrl + "/api/racuni/get-uplata-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDodatnaUplataById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDodatnaUplataById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfUplataPoRacunuDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfUplataPoRacunuDto>;
        }));
    }

    protected processGetDodatnaUplataById(response: HttpResponseBase): Observable<ResultOfUplataPoRacunuDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfUplataPoRacunuDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfUplataPoRacunuDto>(null as any);
    }

    refreshSaldoViews(id?: number | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/racuni/refresh-saldo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshSaldoViews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshSaldoViews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processRefreshSaldoViews(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sendIzjavaZaOdbitakPdv(racunId?: number | undefined, strankaId?: number | null | undefined, to?: string[] | null | undefined, cc?: string[] | null | undefined, attachments?: FileParameter[] | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/racuni/posalji-izjavu-za_odbitak_pdv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (racunId === null || racunId === undefined)
            throw new Error("The parameter 'racunId' cannot be null.");
        else
            content_.append("RacunId", racunId.toString());
        if (strankaId !== null && strankaId !== undefined)
            content_.append("StrankaId", strankaId.toString());
        if (to !== null && to !== undefined)
            to.forEach(item_ => content_.append("To", item_.toString()));
        if (cc !== null && cc !== undefined)
            cc.forEach(item_ => content_.append("Cc", item_.toString()));
        if (attachments !== null && attachments !== undefined)
            attachments.forEach(item_ => content_.append("Attachments", item_.data, item_.fileName ? item_.fileName : "Attachments") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendIzjavaZaOdbitakPdv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendIzjavaZaOdbitakPdv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSendIzjavaZaOdbitakPdv(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getRacunRelevantniDokumentListZipped(request: GetRacunRelevantniDokumentListZippedQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/racuni/get-racun-relevantni-dokumenti-list-zipped";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRacunRelevantniDokumentListZipped(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRacunRelevantniDokumentListZipped(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetRacunRelevantniDokumentListZipped(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getIzlazniRacunUbl(request: GetIzlazniRacunUblQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/racuni/get-izlazni-racun-ubl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIzlazniRacunUbl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIzlazniRacunUbl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetIzlazniRacunUbl(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    posaljiPodsetnikZaPlacanje(request: SendPodsetnikPlacanjaRacunaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/racuni/posalji-podsetnik-za-placanje";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosaljiPodsetnikZaPlacanje(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosaljiPodsetnikZaPlacanje(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processPosaljiPodsetnikZaPlacanje(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sendRacunElektronski(racunId?: number | undefined, fromId?: string | undefined, to?: string[] | null | undefined, cc?: string[] | null | undefined, mailNaslov?: string | null | undefined, posaljiNaEngleskom?: boolean | undefined, customPoruka?: string | null | undefined, attachments?: FileParameter[] | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/racuni/posalji-racun-elektronski";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (racunId === null || racunId === undefined)
            throw new Error("The parameter 'racunId' cannot be null.");
        else
            content_.append("RacunId", racunId.toString());
        if (fromId === null || fromId === undefined)
            throw new Error("The parameter 'fromId' cannot be null.");
        else
            content_.append("FromId", fromId.toString());
        if (to !== null && to !== undefined)
            to.forEach(item_ => content_.append("To", item_.toString()));
        if (cc !== null && cc !== undefined)
            cc.forEach(item_ => content_.append("Cc", item_.toString()));
        if (mailNaslov !== null && mailNaslov !== undefined)
            content_.append("MailNaslov", mailNaslov.toString());
        if (posaljiNaEngleskom === null || posaljiNaEngleskom === undefined)
            throw new Error("The parameter 'posaljiNaEngleskom' cannot be null.");
        else
            content_.append("PosaljiNaEngleskom", posaljiNaEngleskom.toString());
        if (customPoruka !== null && customPoruka !== undefined)
            content_.append("CustomPoruka", customPoruka.toString());
        if (attachments !== null && attachments !== undefined)
            attachments.forEach(item_ => content_.append("Attachments", item_.data, item_.fileName ? item_.fileName : "Attachments") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendRacunElektronski(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendRacunElektronski(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSendRacunElektronski(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    /**
     * @param racunId (optional) 
     * @param file (optional) 
     * @deprecated
     */
    uploadUlazniRacun(racunId?: number | undefined, file?: FileParameter | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/racuni/upload-ulazni-racun";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (racunId === null || racunId === undefined)
            throw new Error("The parameter 'racunId' cannot be null.");
        else
            content_.append("RacunId", racunId.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadUlazniRacun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadUlazniRacun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUploadUlazniRacun(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    importXml(files?: FileParameter[] | null | undefined, xml?: XmlRacuna | null | undefined, memorandumId?: number | undefined, tekuciRacunId?: number | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/racuni/import-xml";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (xml !== null && xml !== undefined)
            content_.append("Xml", xml.toString());
        if (memorandumId === null || memorandumId === undefined)
            throw new Error("The parameter 'memorandumId' cannot be null.");
        else
            content_.append("MemorandumId", memorandumId.toString());
        if (tekuciRacunId === null || tekuciRacunId === undefined)
            throw new Error("The parameter 'tekuciRacunId' cannot be null.");
        else
            content_.append("TekuciRacunId", tekuciRacunId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportXml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportXml(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processImportXml(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    removeOznaka(request: RemoveOznakaRacunaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/racuni/remove-oznaka";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveOznaka(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveOznaka(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processRemoveOznaka(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    addOznake(request: AddOznakeRacunaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/racuni/add-oznake";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOznake(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOznake(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processAddOznake(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    addVezaniRacuni(request: AddPovezaniRacunCommand): Observable<ResultOfListOfVezaniRacunDto> {
        let url_ = this.baseUrl + "/api/racuni/add-vezani-racuni";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddVezaniRacuni(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddVezaniRacuni(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfVezaniRacunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfVezaniRacunDto>;
        }));
    }

    protected processAddVezaniRacuni(response: HttpResponseBase): Observable<ResultOfListOfVezaniRacunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfVezaniRacunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfVezaniRacunDto>(null as any);
    }

    placanjeStarihRacuna(importFile?: FileParameter | null | undefined, datumDo?: Date | undefined): Observable<ResultOfListOfImportPlacanjeStarihRacunaDto> {
        let url_ = this.baseUrl + "/api/racuni/placanje-starih-racuna-import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (importFile !== null && importFile !== undefined)
            content_.append("ImportFile", importFile.data, importFile.fileName ? importFile.fileName : "ImportFile");
        if (datumDo === null || datumDo === undefined)
            throw new Error("The parameter 'datumDo' cannot be null.");
        else
            content_.append("DatumDo", datumDo.toJSON());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPlacanjeStarihRacuna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlacanjeStarihRacuna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfImportPlacanjeStarihRacunaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfImportPlacanjeStarihRacunaDto>;
        }));
    }

    protected processPlacanjeStarihRacuna(response: HttpResponseBase): Observable<ResultOfListOfImportPlacanjeStarihRacunaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfImportPlacanjeStarihRacunaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfImportPlacanjeStarihRacunaDto>(null as any);
    }

    createDodatnuUplatuRacuna(command: CreateDodatnuUplatuRacunaCommand): Observable<ResultOfListOfCreateDodatnuUplatuRacunaCommand> {
        let url_ = this.baseUrl + "/api/racuni/dodatne-uplate-racuna";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDodatnuUplatuRacuna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDodatnuUplatuRacuna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfCreateDodatnuUplatuRacunaCommand>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfCreateDodatnuUplatuRacunaCommand>;
        }));
    }

    protected processCreateDodatnuUplatuRacuna(response: HttpResponseBase): Observable<ResultOfListOfCreateDodatnuUplatuRacunaCommand> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfCreateDodatnuUplatuRacunaCommand.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfCreateDodatnuUplatuRacunaCommand>(null as any);
    }

    updateDodatnuUplatuRacuna(command: UpdateDodatnuUplatuRacunaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/racuni/update-uplata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDodatnuUplatuRacuna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDodatnuUplatuRacuna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdateDodatnuUplatuRacuna(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getRacuneZaPlacanje(request: GetRacuneZaPlacanjeQuery): Observable<PaginatedResultOfRacunZaPlacanjeDto> {
        let url_ = this.baseUrl + "/api/racuni/get-za-placanje";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRacuneZaPlacanje(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRacuneZaPlacanje(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfRacunZaPlacanjeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfRacunZaPlacanjeDto>;
        }));
    }

    protected processGetRacuneZaPlacanje(response: HttpResponseBase): Observable<PaginatedResultOfRacunZaPlacanjeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfRacunZaPlacanjeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfRacunZaPlacanjeDto>(null as any);
    }

    createFilterTemplate(command: CreateRacunFilterCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/racuni";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFilterTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFilterTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateFilterTemplate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getFilters(): Observable<ResultOfGetFiltersResponseOfRacunFilterDto> {
        let url_ = this.baseUrl + "/api/racuni/get-filters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetFiltersResponseOfRacunFilterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetFiltersResponseOfRacunFilterDto>;
        }));
    }

    protected processGetFilters(response: HttpResponseBase): Observable<ResultOfGetFiltersResponseOfRacunFilterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetFiltersResponseOfRacunFilterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetFiltersResponseOfRacunFilterDto>(null as any);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/racuni/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    createPraviloZaBroj(request: CreatePraviloZaBrojCommand): Observable<ResultOfKonfiguracijaBrojaRacunaDto> {
        let url_ = this.baseUrl + "/api/racuni/create-pravilo-za-broj";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePraviloZaBroj(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePraviloZaBroj(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfKonfiguracijaBrojaRacunaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfKonfiguracijaBrojaRacunaDto>;
        }));
    }

    protected processCreatePraviloZaBroj(response: HttpResponseBase): Observable<ResultOfKonfiguracijaBrojaRacunaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfKonfiguracijaBrojaRacunaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfKonfiguracijaBrojaRacunaDto>(null as any);
    }

    removeVezaniRacun(command: RemoveVezaniRacunCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/racuni/remove-vezani-racun";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveVezaniRacun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveVezaniRacun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processRemoveVezaniRacun(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    removeEOtpremnicaFromRacun(command: RemoveEOtpremnicaFromRacunCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/racuni/remove-eotpremnica-from-racun";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveEOtpremnicaFromRacun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveEOtpremnicaFromRacun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processRemoveEOtpremnicaFromRacun(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    addEOtpremnicaToRacun(command: AddEOtpremnicaToRacunCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/racuni/add-eotpremnica-to-racun";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEOtpremnicaToRacun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEOtpremnicaToRacun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processAddEOtpremnicaToRacun(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    updatePraviloZaBroj(command: UpdatePraviloZaBrojCommand, id?: number | undefined): Observable<ResultOfKonfiguracijaBrojaRacunaDto> {
        let url_ = this.baseUrl + "/api/racuni/update-pravilo-za-broj?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePraviloZaBroj(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePraviloZaBroj(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfKonfiguracijaBrojaRacunaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfKonfiguracijaBrojaRacunaDto>;
        }));
    }

    protected processUpdatePraviloZaBroj(response: HttpResponseBase): Observable<ResultOfKonfiguracijaBrojaRacunaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfKonfiguracijaBrojaRacunaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfKonfiguracijaBrojaRacunaDto>(null as any);
    }

    deletePraviloZaBroj(id?: number | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/racuni/delete-pravilo-za-broj?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePraviloZaBroj(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePraviloZaBroj(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processDeletePraviloZaBroj(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    updateOpstaPravila(command: UpdateOpstaPravilaCommand): Observable<ResultOfOpstaPravilaKonfiguracijaDto> {
        let url_ = this.baseUrl + "/api/racuni/update-opsta-pravila";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOpstaPravila(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOpstaPravila(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfOpstaPravilaKonfiguracijaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfOpstaPravilaKonfiguracijaDto>;
        }));
    }

    protected processUpdateOpstaPravila(response: HttpResponseBase): Observable<ResultOfOpstaPravilaKonfiguracijaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfOpstaPravilaKonfiguracijaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfOpstaPravilaKonfiguracijaDto>(null as any);
    }

    updateStatusRacuna(racunId?: number | undefined, statusRacuna?: StatusRacuna | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/racuni/update-status-racuna?";
        if (racunId === null)
            throw new Error("The parameter 'racunId' cannot be null.");
        else if (racunId !== undefined)
            url_ += "racunId=" + encodeURIComponent("" + racunId) + "&";
        if (statusRacuna === null)
            throw new Error("The parameter 'statusRacuna' cannot be null.");
        else if (statusRacuna !== undefined)
            url_ += "statusRacuna=" + encodeURIComponent("" + statusRacuna) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusRacuna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusRacuna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdateStatusRacuna(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    updateKonfiguracijaDeviznog(command: UpdateKonfiguracijaDeviznihCommand): Observable<ResultOfKonfiguracijaDeviznogRacunaDto> {
        let url_ = this.baseUrl + "/api/racuni/update-konfiguracija-deviznog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateKonfiguracijaDeviznog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateKonfiguracijaDeviznog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfKonfiguracijaDeviznogRacunaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfKonfiguracijaDeviznogRacunaDto>;
        }));
    }

    protected processUpdateKonfiguracijaDeviznog(response: HttpResponseBase): Observable<ResultOfKonfiguracijaDeviznogRacunaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfKonfiguracijaDeviznogRacunaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfKonfiguracijaDeviznogRacunaDto>(null as any);
    }

    getPodtipDokumentaDropdown(): Observable<ResultOfListOfBuyerReferenceDto> {
        let url_ = this.baseUrl + "/api/racuni/get-podtip-dokumenta";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPodtipDokumentaDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPodtipDokumentaDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfBuyerReferenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfBuyerReferenceDto>;
        }));
    }

    protected processGetPodtipDokumentaDropdown(response: HttpResponseBase): Observable<ResultOfListOfBuyerReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfBuyerReferenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfBuyerReferenceDto>(null as any);
    }

    deleteDodatnuUplatu(id: number): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/racuni/delete-dodatnu-uplatu/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDodatnuUplatu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDodatnuUplatu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processDeleteDodatnuUplatu(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }
}

export interface IRadniNaloziClient {
    create(command: CreateRadniNalogCommand): Observable<ResultOfLong>;
    update(command: UpdateRadniNalogCommand): Observable<ResultOfLong>;
    updateStatus(command: UpdateStatusRadnogNalogaCommand): Observable<ResultOfString>;
    cancelRadniNalog(request: CancelRadniNalogCommand): Observable<ResultOfString>;
    get(request: GetRadniNalogQuery): Observable<ResultOfRadniNalogDto>;
    getForTable(request: GetRadniNalogTableQuery): Observable<PaginatedResultOfRadniNalogTableDto>;
    duplicateRadniNalog(id: number): Observable<ResultOfRadniNalogDto>;
}

@Injectable({
    providedIn: 'root'
})
export class RadniNaloziClient implements IRadniNaloziClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    create(command: CreateRadniNalogCommand): Observable<ResultOfLong> {
        let url_ = this.baseUrl + "/api/radninalozi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfLong>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfLong>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfLong> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfLong.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLong>(null as any);
    }

    update(command: UpdateRadniNalogCommand): Observable<ResultOfLong> {
        let url_ = this.baseUrl + "/api/radninalozi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfLong>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfLong>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultOfLong> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfLong.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLong>(null as any);
    }

    updateStatus(command: UpdateStatusRadnogNalogaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/radninalozi/update-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    cancelRadniNalog(request: CancelRadniNalogCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/radninalozi/cancel-radni-nalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelRadniNalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelRadniNalog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCancelRadniNalog(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    get(request: GetRadniNalogQuery): Observable<ResultOfRadniNalogDto> {
        let url_ = this.baseUrl + "/api/radninalozi/get-radni-nalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfRadniNalogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfRadniNalogDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResultOfRadniNalogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfRadniNalogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfRadniNalogDto>(null as any);
    }

    getForTable(request: GetRadniNalogTableQuery): Observable<PaginatedResultOfRadniNalogTableDto> {
        let url_ = this.baseUrl + "/api/radninalozi/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfRadniNalogTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfRadniNalogTableDto>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<PaginatedResultOfRadniNalogTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfRadniNalogTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfRadniNalogTableDto>(null as any);
    }

    duplicateRadniNalog(id: number): Observable<ResultOfRadniNalogDto> {
        let url_ = this.baseUrl + "/api/radninalozi/duplicate-radni-nalog/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateRadniNalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateRadniNalog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfRadniNalogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfRadniNalogDto>;
        }));
    }

    protected processDuplicateRadniNalog(response: HttpResponseBase): Observable<ResultOfRadniNalogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfRadniNalogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfRadniNalogDto>(null as any);
    }
}

export interface IRepromaterijaliClient {
    getForTable(request: GetRepromaterijalTableQuery): Observable<ResultOfGetTableResponseOfRepromaterijalTableDto>;
    getRepromaterijalMultiSelect(): Observable<ResultOfGetRepromaterijalMultiselectResponse>;
    getRepromaterijalById(id: number): Observable<ResultOfRepromaterijalDto>;
    createRepromaterijal(command: CreateRepromaterijalCommand): Observable<ResultOfString>;
    update(id: number, command: UpdateRepromaterijalCommand): Observable<ResultOfString>;
    delete(id: number): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class RepromaterijaliClient implements IRepromaterijaliClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(request: GetRepromaterijalTableQuery): Observable<ResultOfGetTableResponseOfRepromaterijalTableDto> {
        let url_ = this.baseUrl + "/api/repromaterijali/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTableResponseOfRepromaterijalTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTableResponseOfRepromaterijalTableDto>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<ResultOfGetTableResponseOfRepromaterijalTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTableResponseOfRepromaterijalTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTableResponseOfRepromaterijalTableDto>(null as any);
    }

    getRepromaterijalMultiSelect(): Observable<ResultOfGetRepromaterijalMultiselectResponse> {
        let url_ = this.baseUrl + "/api/repromaterijali/get-multiselect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRepromaterijalMultiSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRepromaterijalMultiSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetRepromaterijalMultiselectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetRepromaterijalMultiselectResponse>;
        }));
    }

    protected processGetRepromaterijalMultiSelect(response: HttpResponseBase): Observable<ResultOfGetRepromaterijalMultiselectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetRepromaterijalMultiselectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetRepromaterijalMultiselectResponse>(null as any);
    }

    getRepromaterijalById(id: number): Observable<ResultOfRepromaterijalDto> {
        let url_ = this.baseUrl + "/api/repromaterijali/by-id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRepromaterijalById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRepromaterijalById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfRepromaterijalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfRepromaterijalDto>;
        }));
    }

    protected processGetRepromaterijalById(response: HttpResponseBase): Observable<ResultOfRepromaterijalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfRepromaterijalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfRepromaterijalDto>(null as any);
    }

    createRepromaterijal(command: CreateRepromaterijalCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/repromaterijali";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRepromaterijal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRepromaterijal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreateRepromaterijal(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    update(id: number, command: UpdateRepromaterijalCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/repromaterijali/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/repromaterijali/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IRobeClient {
    getForTable(request: GetRobaTableQuery): Observable<ResultOfGetTableResponseOfRobaTableDto>;
    getById(id: number): Observable<ResultOfRobaDto>;
    create(command: CreateRobaCommand): Observable<ResultOfRobaCommandResponse>;
    update(id: number, command: UpdateRobaCommand): Observable<ResultOfRobaCommandResponse>;
    delete(id: number): Observable<FileResponse>;
    import(magacinId?: number | null | undefined, importFile?: FileParameter | null | undefined): Observable<ResultOfString>;
    prebacivanjeUslugaURobu(command: PrebacivanjeUslugeURobuCommand): Observable<ResultOfString>;
    getPopisnaListaSablon(magacinId: number, prikaziNuleIMinus?: boolean | undefined): Observable<FileResponse>;
    importPopisnaListaSablon(magacinId?: number | undefined, importFile?: FileParameter | null | undefined, prikaziNuleIMinus?: boolean | undefined): Observable<ResultOfString>;
    getArtikalPoMagacinima(predmetStavkeId: number): Observable<ResultOfListOfArtikalPoMagacinimaDto>;
    getUkupnoStanjeRobe(id: number): Observable<ResultOfUkupnoStanjeRobeDto>;
    azurirajLagerTransakcije(predmetStavkeId: number): Observable<ResultOfString>;
    getNalepnicePreview(request: GetNalepnicePreviewQuery): Observable<ResultOfNalepnicePreviewDto>;
    getNalepnicePdf(request: GetNalepnicePdfQuery): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class RobeClient implements IRobeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(request: GetRobaTableQuery): Observable<ResultOfGetTableResponseOfRobaTableDto> {
        let url_ = this.baseUrl + "/api/robe/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTableResponseOfRobaTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTableResponseOfRobaTableDto>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<ResultOfGetTableResponseOfRobaTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTableResponseOfRobaTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTableResponseOfRobaTableDto>(null as any);
    }

    getById(id: number): Observable<ResultOfRobaDto> {
        let url_ = this.baseUrl + "/api/robe/by-id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfRobaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfRobaDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ResultOfRobaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfRobaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfRobaDto>(null as any);
    }

    create(command: CreateRobaCommand): Observable<ResultOfRobaCommandResponse> {
        let url_ = this.baseUrl + "/api/robe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfRobaCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfRobaCommandResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfRobaCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfRobaCommandResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfRobaCommandResponse>(null as any);
    }

    update(id: number, command: UpdateRobaCommand): Observable<ResultOfRobaCommandResponse> {
        let url_ = this.baseUrl + "/api/robe/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfRobaCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfRobaCommandResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultOfRobaCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfRobaCommandResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfRobaCommandResponse>(null as any);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/robe/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    import(magacinId?: number | null | undefined, importFile?: FileParameter | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/robe/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (magacinId !== null && magacinId !== undefined)
            content_.append("MagacinId", magacinId.toString());
        if (importFile !== null && importFile !== undefined)
            content_.append("ImportFile", importFile.data, importFile.fileName ? importFile.fileName : "ImportFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    prebacivanjeUslugaURobu(command: PrebacivanjeUslugeURobuCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/robe/prebacivanje-usluga";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrebacivanjeUslugaURobu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrebacivanjeUslugaURobu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processPrebacivanjeUslugaURobu(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getPopisnaListaSablon(magacinId: number, prikaziNuleIMinus?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/robe/popisna-lista-sablon/{magacinId}?";
        if (magacinId === undefined || magacinId === null)
            throw new Error("The parameter 'magacinId' must be defined.");
        url_ = url_.replace("{magacinId}", encodeURIComponent("" + magacinId));
        if (prikaziNuleIMinus === null)
            throw new Error("The parameter 'prikaziNuleIMinus' cannot be null.");
        else if (prikaziNuleIMinus !== undefined)
            url_ += "prikaziNuleIMinus=" + encodeURIComponent("" + prikaziNuleIMinus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPopisnaListaSablon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPopisnaListaSablon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPopisnaListaSablon(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    importPopisnaListaSablon(magacinId?: number | undefined, importFile?: FileParameter | null | undefined, prikaziNuleIMinus?: boolean | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/robe/import-popisna-lista-sablon";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (magacinId === null || magacinId === undefined)
            throw new Error("The parameter 'magacinId' cannot be null.");
        else
            content_.append("MagacinId", magacinId.toString());
        if (importFile !== null && importFile !== undefined)
            content_.append("ImportFile", importFile.data, importFile.fileName ? importFile.fileName : "ImportFile");
        if (prikaziNuleIMinus === null || prikaziNuleIMinus === undefined)
            throw new Error("The parameter 'prikaziNuleIMinus' cannot be null.");
        else
            content_.append("PrikaziNuleIMinus", prikaziNuleIMinus.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportPopisnaListaSablon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportPopisnaListaSablon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processImportPopisnaListaSablon(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getArtikalPoMagacinima(predmetStavkeId: number): Observable<ResultOfListOfArtikalPoMagacinimaDto> {
        let url_ = this.baseUrl + "/api/robe/artikal-po-magacinima/{predmetStavkeId}";
        if (predmetStavkeId === undefined || predmetStavkeId === null)
            throw new Error("The parameter 'predmetStavkeId' must be defined.");
        url_ = url_.replace("{predmetStavkeId}", encodeURIComponent("" + predmetStavkeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArtikalPoMagacinima(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArtikalPoMagacinima(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfArtikalPoMagacinimaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfArtikalPoMagacinimaDto>;
        }));
    }

    protected processGetArtikalPoMagacinima(response: HttpResponseBase): Observable<ResultOfListOfArtikalPoMagacinimaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfArtikalPoMagacinimaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfArtikalPoMagacinimaDto>(null as any);
    }

    getUkupnoStanjeRobe(id: number): Observable<ResultOfUkupnoStanjeRobeDto> {
        let url_ = this.baseUrl + "/api/robe/ukupno-stanje-by-id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUkupnoStanjeRobe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUkupnoStanjeRobe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfUkupnoStanjeRobeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfUkupnoStanjeRobeDto>;
        }));
    }

    protected processGetUkupnoStanjeRobe(response: HttpResponseBase): Observable<ResultOfUkupnoStanjeRobeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfUkupnoStanjeRobeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfUkupnoStanjeRobeDto>(null as any);
    }

    azurirajLagerTransakcije(predmetStavkeId: number): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/robe/azuriraj-lager-transakcije/{predmetStavkeId}";
        if (predmetStavkeId === undefined || predmetStavkeId === null)
            throw new Error("The parameter 'predmetStavkeId' must be defined.");
        url_ = url_.replace("{predmetStavkeId}", encodeURIComponent("" + predmetStavkeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAzurirajLagerTransakcije(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAzurirajLagerTransakcije(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processAzurirajLagerTransakcije(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getNalepnicePreview(request: GetNalepnicePreviewQuery): Observable<ResultOfNalepnicePreviewDto> {
        let url_ = this.baseUrl + "/api/robe/nalepnice/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNalepnicePreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNalepnicePreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfNalepnicePreviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfNalepnicePreviewDto>;
        }));
    }

    protected processGetNalepnicePreview(response: HttpResponseBase): Observable<ResultOfNalepnicePreviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfNalepnicePreviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfNalepnicePreviewDto>(null as any);
    }

    getNalepnicePdf(request: GetNalepnicePdfQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/robe/nalepnice/pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNalepnicePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNalepnicePdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetNalepnicePdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface ISaldoStrankeClient {
    getSaldoStranke(strankaId?: number | null | undefined, valutaIdStr?: string | null | undefined): Observable<ResultOfGetSaldoStrankeResponse>;
    getDospelaPotrazivanjaAging(strankaId?: number | null | undefined): Observable<ResultOfDospelaPotrazivanjaAgingDto>;
}

@Injectable({
    providedIn: 'root'
})
export class SaldoStrankeClient implements ISaldoStrankeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getSaldoStranke(strankaId?: number | null | undefined, valutaIdStr?: string | null | undefined): Observable<ResultOfGetSaldoStrankeResponse> {
        let url_ = this.baseUrl + "/api/saldostranke?";
        if (strankaId !== undefined && strankaId !== null)
            url_ += "strankaId=" + encodeURIComponent("" + strankaId) + "&";
        if (valutaIdStr !== undefined && valutaIdStr !== null)
            url_ += "valutaIdStr=" + encodeURIComponent("" + valutaIdStr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSaldoStranke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSaldoStranke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetSaldoStrankeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetSaldoStrankeResponse>;
        }));
    }

    protected processGetSaldoStranke(response: HttpResponseBase): Observable<ResultOfGetSaldoStrankeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetSaldoStrankeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetSaldoStrankeResponse>(null as any);
    }

    getDospelaPotrazivanjaAging(strankaId?: number | null | undefined): Observable<ResultOfDospelaPotrazivanjaAgingDto> {
        let url_ = this.baseUrl + "/api/saldostranke/dospela-potrazivanja-aging?";
        if (strankaId !== undefined && strankaId !== null)
            url_ += "strankaId=" + encodeURIComponent("" + strankaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDospelaPotrazivanjaAging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDospelaPotrazivanjaAging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfDospelaPotrazivanjaAgingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfDospelaPotrazivanjaAgingDto>;
        }));
    }

    protected processGetDospelaPotrazivanjaAging(response: HttpResponseBase): Observable<ResultOfDospelaPotrazivanjaAgingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfDospelaPotrazivanjaAgingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfDospelaPotrazivanjaAgingDto>(null as any);
    }
}

export interface ISastavniceClient {
    getForTable(request: GetSastavniceTableQuery): Observable<ResultOfGetSastavniceTableResponse>;
    get(id: number): Observable<ResultOfSastavnicaDto>;
    delete(id: number): Observable<FileResponse>;
    getSastavnica(materijalId?: number | undefined, proizvodId?: number | undefined): Observable<ResultOfSastavnicaDto>;
    create(command: CreateSastavnicaCommand): Observable<ResultOfCreateSastavnicaResponse>;
    update(command: UpdateSastavnicaCommand): Observable<ResultOfCreateSastavnicaResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class SastavniceClient implements ISastavniceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(request: GetSastavniceTableQuery): Observable<ResultOfGetSastavniceTableResponse> {
        let url_ = this.baseUrl + "/api/sastavnice/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetSastavniceTableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetSastavniceTableResponse>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<ResultOfGetSastavniceTableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetSastavniceTableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetSastavniceTableResponse>(null as any);
    }

    get(id: number): Observable<ResultOfSastavnicaDto> {
        let url_ = this.baseUrl + "/api/sastavnice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfSastavnicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfSastavnicaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResultOfSastavnicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfSastavnicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfSastavnicaDto>(null as any);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/sastavnice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getSastavnica(materijalId?: number | undefined, proizvodId?: number | undefined): Observable<ResultOfSastavnicaDto> {
        let url_ = this.baseUrl + "/api/sastavnice/get-sastavnica?";
        if (materijalId === null)
            throw new Error("The parameter 'materijalId' cannot be null.");
        else if (materijalId !== undefined)
            url_ += "materijalId=" + encodeURIComponent("" + materijalId) + "&";
        if (proizvodId === null)
            throw new Error("The parameter 'proizvodId' cannot be null.");
        else if (proizvodId !== undefined)
            url_ += "proizvodId=" + encodeURIComponent("" + proizvodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSastavnica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSastavnica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfSastavnicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfSastavnicaDto>;
        }));
    }

    protected processGetSastavnica(response: HttpResponseBase): Observable<ResultOfSastavnicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfSastavnicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfSastavnicaDto>(null as any);
    }

    create(command: CreateSastavnicaCommand): Observable<ResultOfCreateSastavnicaResponse> {
        let url_ = this.baseUrl + "/api/sastavnice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCreateSastavnicaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCreateSastavnicaResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfCreateSastavnicaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCreateSastavnicaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCreateSastavnicaResponse>(null as any);
    }

    update(command: UpdateSastavnicaCommand): Observable<ResultOfCreateSastavnicaResponse> {
        let url_ = this.baseUrl + "/api/sastavnice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCreateSastavnicaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCreateSastavnicaResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultOfCreateSastavnicaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCreateSastavnicaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCreateSastavnicaResponse>(null as any);
    }
}

export interface ISefClient {
    getUlazneStatusNotifications(request: PurchaseInvoiceStatusChangeDto[]): Observable<FileResponse>;
    getIzlazneStatusNotifications(request: SalesInvoiceStatusChangeDto[]): Observable<FileResponse>;
    sendToSef(id?: number | undefined, senderSignatureId?: string | undefined, attachments?: FileParameter[] | null | undefined, sendToCrf?: boolean | undefined, kontaktEmail?: string | null | undefined): Observable<ResultOfString>;
    sendListToSef(request: SendRacunListToSefCommand): Observable<ResultOfString>;
    cancelIzlazniRacun(request: CancelIzlazniRacunCommand): Observable<ResultOfString>;
    stornoIzlazniRacun(request: StornoIzlazniRacunCommand): Observable<ResultOfString>;
    syncStatuseIzlaznihRacuna(): Observable<ResultOfString>;
    syncStatusPojedinacnogIzlaznogRacuna(request: SyncStatusPojedinacnogIzlaznihRacunaCommand): Observable<ResultOfString>;
    syncDocPojedinacnogIzlaznogRacuna(request: SyncDocPojedinacnogIzlaznogRacunaCommand): Observable<ResultOfString>;
    /**
     * @deprecated
     */
    shouldShowSyncStatuseButton(): Observable<ResultOfBoolean>;
    getNeobradjenRacunUblQuery(racunSefId: number): Observable<FileResponse>;
    syncUlazneRacune(request: SyncUlazneRacuneCommand): Observable<ResultOfString>;
    getSefRacunRelevantniDokumentList(sefId: number): Observable<ResultOfIReadOnlyListOfGetSefDokumentResponse>;
    getSefDokumentUrl(sefId: number): Observable<ResultOfString>;
    getSefRacunRelevantniDokumentListZipped(request: GetSefRacunRelevantniDokumentListZippedQuery): Observable<FileResponse>;
    getSefHealhStatus(): Observable<ResultOfGetSefHealthStatusResponse>;
    odobriOdbaciRacun(command: OdobriOdbaciSefRacunCommand): Observable<ResultOfString>;
    getObradaForm(sefId: number): Observable<ResultOfObradaFormRequest>;
    getSefRacunTable(request: GetSefRacunTableQuery): Observable<PaginatedResultOfNeobradjenSefRacunTableDto>;
    obradi(command: ObradiSefRacunCommand): Observable<Result>;
    createRacunFromSefRacun(command: CreateRacunFromSefRacunCommand): Observable<ResultOfString>;
    debugPrihvatiUbl(file?: FileParameter | null | undefined): Observable<ResultOfDebugSimulacijaResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class SefClient implements ISefClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getUlazneStatusNotifications(request: PurchaseInvoiceStatusChangeDto[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/sef/get-ulazne-status-notifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUlazneStatusNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUlazneStatusNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetUlazneStatusNotifications(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getIzlazneStatusNotifications(request: SalesInvoiceStatusChangeDto[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/sef/get-izlazne-status-notifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIzlazneStatusNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIzlazneStatusNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetIzlazneStatusNotifications(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    sendToSef(id?: number | undefined, senderSignatureId?: string | undefined, attachments?: FileParameter[] | null | undefined, sendToCrf?: boolean | undefined, kontaktEmail?: string | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/sef/posalji-na-sef";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (senderSignatureId === null || senderSignatureId === undefined)
            throw new Error("The parameter 'senderSignatureId' cannot be null.");
        else
            content_.append("SenderSignatureId", senderSignatureId.toString());
        if (attachments !== null && attachments !== undefined)
            attachments.forEach(item_ => content_.append("Attachments", item_.data, item_.fileName ? item_.fileName : "Attachments") );
        if (sendToCrf === null || sendToCrf === undefined)
            throw new Error("The parameter 'sendToCrf' cannot be null.");
        else
            content_.append("SendToCrf", sendToCrf.toString());
        if (kontaktEmail !== null && kontaktEmail !== undefined)
            content_.append("KontaktEmail", kontaktEmail.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendToSef(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendToSef(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSendToSef(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sendListToSef(request: SendRacunListToSefCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/sef/posalji-listu-na-sef";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendListToSef(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendListToSef(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSendListToSef(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    cancelIzlazniRacun(request: CancelIzlazniRacunCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/sef/otkazi-izlazni-racun";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelIzlazniRacun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelIzlazniRacun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCancelIzlazniRacun(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    stornoIzlazniRacun(request: StornoIzlazniRacunCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/sef/storniraj-izlazni-racun";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStornoIzlazniRacun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStornoIzlazniRacun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processStornoIzlazniRacun(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    syncStatuseIzlaznihRacuna(): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/sef/sinhronizuj-statuse-izlaznih-racuna";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncStatuseIzlaznihRacuna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncStatuseIzlaznihRacuna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSyncStatuseIzlaznihRacuna(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    syncStatusPojedinacnogIzlaznogRacuna(request: SyncStatusPojedinacnogIzlaznihRacunaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/sef/sinhronizuj-status-pojedinacnog-izlazog-racuna";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncStatusPojedinacnogIzlaznogRacuna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncStatusPojedinacnogIzlaznogRacuna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSyncStatusPojedinacnogIzlaznogRacuna(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    syncDocPojedinacnogIzlaznogRacuna(request: SyncDocPojedinacnogIzlaznogRacunaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/sef/sinhronizuj-dokumente-pojedinacnog-izlazog-racuna";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncDocPojedinacnogIzlaznogRacuna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncDocPojedinacnogIzlaznogRacuna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSyncDocPojedinacnogIzlaznogRacuna(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    /**
     * @deprecated
     */
    shouldShowSyncStatuseButton(): Observable<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/sef/should-show-sinhronizuj-statuse-izlaznih-racuna";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShouldShowSyncStatuseButton(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShouldShowSyncStatuseButton(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfBoolean>;
        }));
    }

    protected processShouldShowSyncStatuseButton(response: HttpResponseBase): Observable<ResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfBoolean>(null as any);
    }

    getNeobradjenRacunUblQuery(racunSefId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/sef/get-neobradjen-racun-ubl/{racunSefId}";
        if (racunSefId === undefined || racunSefId === null)
            throw new Error("The parameter 'racunSefId' must be defined.");
        url_ = url_.replace("{racunSefId}", encodeURIComponent("" + racunSefId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNeobradjenRacunUblQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNeobradjenRacunUblQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetNeobradjenRacunUblQuery(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    syncUlazneRacune(request: SyncUlazneRacuneCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/sef/sync-ulazne-racune";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncUlazneRacune(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncUlazneRacune(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSyncUlazneRacune(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getSefRacunRelevantniDokumentList(sefId: number): Observable<ResultOfIReadOnlyListOfGetSefDokumentResponse> {
        let url_ = this.baseUrl + "/api/sef/get-sef-racun-relevantni-dokument-list/{sefId}";
        if (sefId === undefined || sefId === null)
            throw new Error("The parameter 'sefId' must be defined.");
        url_ = url_.replace("{sefId}", encodeURIComponent("" + sefId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSefRacunRelevantniDokumentList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSefRacunRelevantniDokumentList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIReadOnlyListOfGetSefDokumentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIReadOnlyListOfGetSefDokumentResponse>;
        }));
    }

    protected processGetSefRacunRelevantniDokumentList(response: HttpResponseBase): Observable<ResultOfIReadOnlyListOfGetSefDokumentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIReadOnlyListOfGetSefDokumentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIReadOnlyListOfGetSefDokumentResponse>(null as any);
    }

    getSefDokumentUrl(sefId: number): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/sef/get-sef-dokument-url/{sefId}";
        if (sefId === undefined || sefId === null)
            throw new Error("The parameter 'sefId' must be defined.");
        url_ = url_.replace("{sefId}", encodeURIComponent("" + sefId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSefDokumentUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSefDokumentUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processGetSefDokumentUrl(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getSefRacunRelevantniDokumentListZipped(request: GetSefRacunRelevantniDokumentListZippedQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/sef/get-sef-racun-relevantni-dokument-list-zipped";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSefRacunRelevantniDokumentListZipped(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSefRacunRelevantniDokumentListZipped(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetSefRacunRelevantniDokumentListZipped(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getSefHealhStatus(): Observable<ResultOfGetSefHealthStatusResponse> {
        let url_ = this.baseUrl + "/api/sef/get-sef-health-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSefHealhStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSefHealhStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetSefHealthStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetSefHealthStatusResponse>;
        }));
    }

    protected processGetSefHealhStatus(response: HttpResponseBase): Observable<ResultOfGetSefHealthStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetSefHealthStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetSefHealthStatusResponse>(null as any);
    }

    odobriOdbaciRacun(command: OdobriOdbaciSefRacunCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/sef/odobri-odbaci-racun";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOdobriOdbaciRacun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOdobriOdbaciRacun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processOdobriOdbaciRacun(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getObradaForm(sefId: number): Observable<ResultOfObradaFormRequest> {
        let url_ = this.baseUrl + "/api/sef/get-obrada-form/{sefId}";
        if (sefId === undefined || sefId === null)
            throw new Error("The parameter 'sefId' must be defined.");
        url_ = url_.replace("{sefId}", encodeURIComponent("" + sefId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObradaForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObradaForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfObradaFormRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfObradaFormRequest>;
        }));
    }

    protected processGetObradaForm(response: HttpResponseBase): Observable<ResultOfObradaFormRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfObradaFormRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfObradaFormRequest>(null as any);
    }

    getSefRacunTable(request: GetSefRacunTableQuery): Observable<PaginatedResultOfNeobradjenSefRacunTableDto> {
        let url_ = this.baseUrl + "/api/sef/get-sef-racun-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSefRacunTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSefRacunTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfNeobradjenSefRacunTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfNeobradjenSefRacunTableDto>;
        }));
    }

    protected processGetSefRacunTable(response: HttpResponseBase): Observable<PaginatedResultOfNeobradjenSefRacunTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfNeobradjenSefRacunTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatedResultOfNeobradjenSefRacunTableDto>(null as any);
    }

    obradi(command: ObradiSefRacunCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/sef";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObradi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObradi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processObradi(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    createRacunFromSefRacun(command: CreateRacunFromSefRacunCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/sef/kreiraj-racun";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRacunFromSefRacun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRacunFromSefRacun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreateRacunFromSefRacun(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    debugPrihvatiUbl(file?: FileParameter | null | undefined): Observable<ResultOfDebugSimulacijaResponse> {
        let url_ = this.baseUrl + "/api/sef/debug-prihvati-ubl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDebugPrihvatiUbl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDebugPrihvatiUbl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfDebugSimulacijaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfDebugSimulacijaResponse>;
        }));
    }

    protected processDebugPrihvatiUbl(response: HttpResponseBase): Observable<ResultOfDebugSimulacijaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfDebugSimulacijaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfDebugSimulacijaResponse>(null as any);
    }
}

export interface ISharedClient {
    getDelatnosti(): Observable<ResultOfGetDelatnostiResponse>;
    getValute(): Observable<ResultOfGetValuteResponse>;
    getDrzave(): Observable<ResultOfGetDrzaveResponse>;
    getPrikazRabata(): Observable<ResultOfGetPrikazRabataResponse>;
    getParitet(): Observable<ResultOfGetParitetResponse>;
    getPrikazDokumentaOSmanjenjuIPovecanju(): Observable<ResultOfGetPrikazDokumentaOSmanjenjuIPovecanjuResponse>;
    getPrikazOtpremnice(): Observable<ResultOfGetPrikazOtpremniceResponse>;
    getPrikazRadnogNaloga(): Observable<ResultOfGetPrikazRadnogNalogaResponse>;
    getBanke(searchValue?: string | null | undefined): Observable<ResultOfGetBankeResponse>;
    getOznakaPdvKategorijeDropdown(): Observable<ResultOfGetOznakaPdvKategorijeDropdownResponse>;
    getIdentifikatorStavkeDropdown(): Observable<ResultOfIEnumerableOfIdentifikatorStavkeDto>;
    getRazlogPdvIzuzecaDropdown(): Observable<ResultOfGetRazlogPdvIzuzecaDropdownResponse>;
    getRazlogPdvIzuzecaNapomenaById(razlogIzuzecaId?: number | undefined): Observable<ResultOfString>;
    getKursZaValute(request: GetKursZaValuteQuery): Observable<ResultOfListOfExchangeRateDto>;
    getSifrePlacanja(): Observable<ResultOfGetSifrePlacanjaResponse>;
    getInstrukcijePlacanja(): Observable<ResultOfGetInstrukcijePlacanjaResponse>;
    getTipoviRacuna(request: GetTipoviRacunaQuery): Observable<ResultOfGetTipoviRacunaResponse>;
    getStatusiRacuna(request: GetStatusiRacunaQuery): Observable<ResultOfGetStatusiRacunaResponse>;
    getStatuseTransakcijeIzvoda(): Observable<ResultOfGetStatuseTransakcijeIzvodaResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class SharedClient implements ISharedClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getDelatnosti(): Observable<ResultOfGetDelatnostiResponse> {
        let url_ = this.baseUrl + "/api/shared/delatnosti";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelatnosti(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelatnosti(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetDelatnostiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetDelatnostiResponse>;
        }));
    }

    protected processGetDelatnosti(response: HttpResponseBase): Observable<ResultOfGetDelatnostiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetDelatnostiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetDelatnostiResponse>(null as any);
    }

    getValute(): Observable<ResultOfGetValuteResponse> {
        let url_ = this.baseUrl + "/api/shared/valute";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetValuteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetValuteResponse>;
        }));
    }

    protected processGetValute(response: HttpResponseBase): Observable<ResultOfGetValuteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetValuteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetValuteResponse>(null as any);
    }

    getDrzave(): Observable<ResultOfGetDrzaveResponse> {
        let url_ = this.baseUrl + "/api/shared/drzave";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDrzave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDrzave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetDrzaveResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetDrzaveResponse>;
        }));
    }

    protected processGetDrzave(response: HttpResponseBase): Observable<ResultOfGetDrzaveResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetDrzaveResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetDrzaveResponse>(null as any);
    }

    getPrikazRabata(): Observable<ResultOfGetPrikazRabataResponse> {
        let url_ = this.baseUrl + "/api/shared/prikaz-rabata";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrikazRabata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrikazRabata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetPrikazRabataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetPrikazRabataResponse>;
        }));
    }

    protected processGetPrikazRabata(response: HttpResponseBase): Observable<ResultOfGetPrikazRabataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetPrikazRabataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPrikazRabataResponse>(null as any);
    }

    getParitet(): Observable<ResultOfGetParitetResponse> {
        let url_ = this.baseUrl + "/api/shared/paritet";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParitet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParitet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetParitetResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetParitetResponse>;
        }));
    }

    protected processGetParitet(response: HttpResponseBase): Observable<ResultOfGetParitetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetParitetResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetParitetResponse>(null as any);
    }

    getPrikazDokumentaOSmanjenjuIPovecanju(): Observable<ResultOfGetPrikazDokumentaOSmanjenjuIPovecanjuResponse> {
        let url_ = this.baseUrl + "/api/shared/prikaz-dokumenata-o-smanjenju-i-povecanju";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrikazDokumentaOSmanjenjuIPovecanju(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrikazDokumentaOSmanjenjuIPovecanju(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetPrikazDokumentaOSmanjenjuIPovecanjuResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetPrikazDokumentaOSmanjenjuIPovecanjuResponse>;
        }));
    }

    protected processGetPrikazDokumentaOSmanjenjuIPovecanju(response: HttpResponseBase): Observable<ResultOfGetPrikazDokumentaOSmanjenjuIPovecanjuResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetPrikazDokumentaOSmanjenjuIPovecanjuResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPrikazDokumentaOSmanjenjuIPovecanjuResponse>(null as any);
    }

    getPrikazOtpremnice(): Observable<ResultOfGetPrikazOtpremniceResponse> {
        let url_ = this.baseUrl + "/api/shared/prikaz-otpremnice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrikazOtpremnice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrikazOtpremnice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetPrikazOtpremniceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetPrikazOtpremniceResponse>;
        }));
    }

    protected processGetPrikazOtpremnice(response: HttpResponseBase): Observable<ResultOfGetPrikazOtpremniceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetPrikazOtpremniceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPrikazOtpremniceResponse>(null as any);
    }

    getPrikazRadnogNaloga(): Observable<ResultOfGetPrikazRadnogNalogaResponse> {
        let url_ = this.baseUrl + "/api/shared/prikaz-radnog-naloga";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrikazRadnogNaloga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrikazRadnogNaloga(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetPrikazRadnogNalogaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetPrikazRadnogNalogaResponse>;
        }));
    }

    protected processGetPrikazRadnogNaloga(response: HttpResponseBase): Observable<ResultOfGetPrikazRadnogNalogaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetPrikazRadnogNalogaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPrikazRadnogNalogaResponse>(null as any);
    }

    getBanke(searchValue?: string | null | undefined): Observable<ResultOfGetBankeResponse> {
        let url_ = this.baseUrl + "/api/shared/banke?";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBanke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBanke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetBankeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetBankeResponse>;
        }));
    }

    protected processGetBanke(response: HttpResponseBase): Observable<ResultOfGetBankeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetBankeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetBankeResponse>(null as any);
    }

    getOznakaPdvKategorijeDropdown(): Observable<ResultOfGetOznakaPdvKategorijeDropdownResponse> {
        let url_ = this.baseUrl + "/api/shared/oznaka-pdv-kategorije-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOznakaPdvKategorijeDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOznakaPdvKategorijeDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetOznakaPdvKategorijeDropdownResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetOznakaPdvKategorijeDropdownResponse>;
        }));
    }

    protected processGetOznakaPdvKategorijeDropdown(response: HttpResponseBase): Observable<ResultOfGetOznakaPdvKategorijeDropdownResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetOznakaPdvKategorijeDropdownResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetOznakaPdvKategorijeDropdownResponse>(null as any);
    }

    getIdentifikatorStavkeDropdown(): Observable<ResultOfIEnumerableOfIdentifikatorStavkeDto> {
        let url_ = this.baseUrl + "/api/shared/identifikator-stavke-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIdentifikatorStavkeDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIdentifikatorStavkeDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIEnumerableOfIdentifikatorStavkeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIEnumerableOfIdentifikatorStavkeDto>;
        }));
    }

    protected processGetIdentifikatorStavkeDropdown(response: HttpResponseBase): Observable<ResultOfIEnumerableOfIdentifikatorStavkeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIEnumerableOfIdentifikatorStavkeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIEnumerableOfIdentifikatorStavkeDto>(null as any);
    }

    getRazlogPdvIzuzecaDropdown(): Observable<ResultOfGetRazlogPdvIzuzecaDropdownResponse> {
        let url_ = this.baseUrl + "/api/shared/razlog-pdv-izuzeca-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRazlogPdvIzuzecaDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRazlogPdvIzuzecaDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetRazlogPdvIzuzecaDropdownResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetRazlogPdvIzuzecaDropdownResponse>;
        }));
    }

    protected processGetRazlogPdvIzuzecaDropdown(response: HttpResponseBase): Observable<ResultOfGetRazlogPdvIzuzecaDropdownResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetRazlogPdvIzuzecaDropdownResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetRazlogPdvIzuzecaDropdownResponse>(null as any);
    }

    getRazlogPdvIzuzecaNapomenaById(razlogIzuzecaId?: number | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/shared/razlog-pdv-izuzeca-napomena-by-id?";
        if (razlogIzuzecaId === null)
            throw new Error("The parameter 'razlogIzuzecaId' cannot be null.");
        else if (razlogIzuzecaId !== undefined)
            url_ += "razlogIzuzecaId=" + encodeURIComponent("" + razlogIzuzecaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRazlogPdvIzuzecaNapomenaById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRazlogPdvIzuzecaNapomenaById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processGetRazlogPdvIzuzecaNapomenaById(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getKursZaValute(request: GetKursZaValuteQuery): Observable<ResultOfListOfExchangeRateDto> {
        let url_ = this.baseUrl + "/api/shared/get-kurs-za-valute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKursZaValute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKursZaValute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfExchangeRateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfExchangeRateDto>;
        }));
    }

    protected processGetKursZaValute(response: HttpResponseBase): Observable<ResultOfListOfExchangeRateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfExchangeRateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfExchangeRateDto>(null as any);
    }

    getSifrePlacanja(): Observable<ResultOfGetSifrePlacanjaResponse> {
        let url_ = this.baseUrl + "/api/shared/get-sifre-placanja";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSifrePlacanja(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSifrePlacanja(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetSifrePlacanjaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetSifrePlacanjaResponse>;
        }));
    }

    protected processGetSifrePlacanja(response: HttpResponseBase): Observable<ResultOfGetSifrePlacanjaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetSifrePlacanjaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetSifrePlacanjaResponse>(null as any);
    }

    getInstrukcijePlacanja(): Observable<ResultOfGetInstrukcijePlacanjaResponse> {
        let url_ = this.baseUrl + "/api/shared/get-instrukcije-placanja";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInstrukcijePlacanja(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInstrukcijePlacanja(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetInstrukcijePlacanjaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetInstrukcijePlacanjaResponse>;
        }));
    }

    protected processGetInstrukcijePlacanja(response: HttpResponseBase): Observable<ResultOfGetInstrukcijePlacanjaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetInstrukcijePlacanjaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetInstrukcijePlacanjaResponse>(null as any);
    }

    getTipoviRacuna(request: GetTipoviRacunaQuery): Observable<ResultOfGetTipoviRacunaResponse> {
        let url_ = this.baseUrl + "/api/shared/tipovi-racuna";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipoviRacuna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipoviRacuna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTipoviRacunaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTipoviRacunaResponse>;
        }));
    }

    protected processGetTipoviRacuna(response: HttpResponseBase): Observable<ResultOfGetTipoviRacunaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTipoviRacunaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTipoviRacunaResponse>(null as any);
    }

    getStatusiRacuna(request: GetStatusiRacunaQuery): Observable<ResultOfGetStatusiRacunaResponse> {
        let url_ = this.baseUrl + "/api/shared/statusi-racuna";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatusiRacuna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatusiRacuna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetStatusiRacunaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetStatusiRacunaResponse>;
        }));
    }

    protected processGetStatusiRacuna(response: HttpResponseBase): Observable<ResultOfGetStatusiRacunaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetStatusiRacunaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetStatusiRacunaResponse>(null as any);
    }

    getStatuseTransakcijeIzvoda(): Observable<ResultOfGetStatuseTransakcijeIzvodaResponse> {
        let url_ = this.baseUrl + "/api/shared/statusi-transakcije-izvoda";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatuseTransakcijeIzvoda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatuseTransakcijeIzvoda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetStatuseTransakcijeIzvodaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetStatuseTransakcijeIzvodaResponse>;
        }));
    }

    protected processGetStatuseTransakcijeIzvoda(response: HttpResponseBase): Observable<ResultOfGetStatuseTransakcijeIzvodaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetStatuseTransakcijeIzvodaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetStatuseTransakcijeIzvodaResponse>(null as any);
    }
}

export interface ISistemClient {
    getSoftwareInformationDto(): Observable<ResultOfSoftwareInformationDto>;
    getApiManagement(): Observable<ResultOfApiManagementDto>;
    getGodinaRacunaDropdown(): Observable<ResultOfGetGodinaRacunaDropdownResponse>;
    generisiApiKey(): Observable<ResultOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class SistemClient implements ISistemClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getSoftwareInformationDto(): Observable<ResultOfSoftwareInformationDto> {
        let url_ = this.baseUrl + "/api/sistem/get-software-information";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSoftwareInformationDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSoftwareInformationDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfSoftwareInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfSoftwareInformationDto>;
        }));
    }

    protected processGetSoftwareInformationDto(response: HttpResponseBase): Observable<ResultOfSoftwareInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfSoftwareInformationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfSoftwareInformationDto>(null as any);
    }

    getApiManagement(): Observable<ResultOfApiManagementDto> {
        let url_ = this.baseUrl + "/api/sistem/get-api-management";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApiManagement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApiManagement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfApiManagementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfApiManagementDto>;
        }));
    }

    protected processGetApiManagement(response: HttpResponseBase): Observable<ResultOfApiManagementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfApiManagementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfApiManagementDto>(null as any);
    }

    getGodinaRacunaDropdown(): Observable<ResultOfGetGodinaRacunaDropdownResponse> {
        let url_ = this.baseUrl + "/api/sistem/godina-racuna-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGodinaRacunaDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGodinaRacunaDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetGodinaRacunaDropdownResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetGodinaRacunaDropdownResponse>;
        }));
    }

    protected processGetGodinaRacunaDropdown(response: HttpResponseBase): Observable<ResultOfGetGodinaRacunaDropdownResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetGodinaRacunaDropdownResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetGodinaRacunaDropdownResponse>(null as any);
    }

    generisiApiKey(): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/sistem/generisi-api-key";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerisiApiKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerisiApiKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processGenerisiApiKey(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }
}

export interface IStrankaClient {
    get(request: GetStrankeQuery): Observable<GetStrankeVm>;
    getStrankeFilter(request: GetStrankaFilterMultiselectQuery): Observable<ResultOfGetStrankaFilterMultiselectResponse>;
    getStranka(id: number): Observable<StrankaDto>;
    getStrankaInfo(id: number): Observable<ResultOfStrankaInfoDto>;
    searchFromKPS(searchValue?: string | null | undefined): Observable<ResultOfListOfPravnoLiceDto>;
    searchFromKPSByNationalNumber(nationalNumber?: string | null | undefined): Observable<PravnoLiceDto>;
    getInformacijaIsporukeForList(strankaId?: number | undefined): Observable<ResultOfListOfListItemDtoOfLong>;
    createInformacijaIsporukeStranka(command: CreateInformacijaIsporukeCommand): Observable<ResultOfInformacijaIsporukeDto>;
    deleteInformacijaIsporuke(id: number): Observable<FileResponse>;
    getInformacijaIsporukeStrankaById(id: number): Observable<ResultOfInformacijaIsporukeDto>;
    updateInformacijaIsporuke(id: number, command: UpdateInformacijaIsporukeCommand): Observable<ResultOfInformacijaIsporukeDto>;
    getStrankaOdTekucegRacuna(brojTekucegRacuna?: string | null | undefined): Observable<ResultOfStrankaDto>;
}

@Injectable({
    providedIn: 'root'
})
export class StrankaClient implements IStrankaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(request: GetStrankeQuery): Observable<GetStrankeVm> {
        let url_ = this.baseUrl + "/api/stranka/get-stranke-query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStrankeVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStrankeVm>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetStrankeVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStrankeVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStrankeVm>(null as any);
    }

    getStrankeFilter(request: GetStrankaFilterMultiselectQuery): Observable<ResultOfGetStrankaFilterMultiselectResponse> {
        let url_ = this.baseUrl + "/api/stranka/get-stranke-filter-query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStrankeFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStrankeFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetStrankaFilterMultiselectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetStrankaFilterMultiselectResponse>;
        }));
    }

    protected processGetStrankeFilter(response: HttpResponseBase): Observable<ResultOfGetStrankaFilterMultiselectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetStrankaFilterMultiselectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetStrankaFilterMultiselectResponse>(null as any);
    }

    getStranka(id: number): Observable<StrankaDto> {
        let url_ = this.baseUrl + "/api/stranka/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStranka(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStranka(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StrankaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StrankaDto>;
        }));
    }

    protected processGetStranka(response: HttpResponseBase): Observable<StrankaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StrankaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StrankaDto>(null as any);
    }

    getStrankaInfo(id: number): Observable<ResultOfStrankaInfoDto> {
        let url_ = this.baseUrl + "/api/stranka/get-stranka-info/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStrankaInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStrankaInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfStrankaInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfStrankaInfoDto>;
        }));
    }

    protected processGetStrankaInfo(response: HttpResponseBase): Observable<ResultOfStrankaInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfStrankaInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfStrankaInfoDto>(null as any);
    }

    searchFromKPS(searchValue?: string | null | undefined): Observable<ResultOfListOfPravnoLiceDto> {
        let url_ = this.baseUrl + "/api/stranka/search-from-kps?";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFromKPS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFromKPS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfPravnoLiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfPravnoLiceDto>;
        }));
    }

    protected processSearchFromKPS(response: HttpResponseBase): Observable<ResultOfListOfPravnoLiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfPravnoLiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfPravnoLiceDto>(null as any);
    }

    searchFromKPSByNationalNumber(nationalNumber?: string | null | undefined): Observable<PravnoLiceDto> {
        let url_ = this.baseUrl + "/api/stranka/search-from-kps-by-national-number?";
        if (nationalNumber !== undefined && nationalNumber !== null)
            url_ += "nationalNumber=" + encodeURIComponent("" + nationalNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFromKPSByNationalNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFromKPSByNationalNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PravnoLiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PravnoLiceDto>;
        }));
    }

    protected processSearchFromKPSByNationalNumber(response: HttpResponseBase): Observable<PravnoLiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PravnoLiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PravnoLiceDto>(null as any);
    }

    getInformacijaIsporukeForList(strankaId?: number | undefined): Observable<ResultOfListOfListItemDtoOfLong> {
        let url_ = this.baseUrl + "/api/stranka/get-for-list?";
        if (strankaId === null)
            throw new Error("The parameter 'strankaId' cannot be null.");
        else if (strankaId !== undefined)
            url_ += "strankaId=" + encodeURIComponent("" + strankaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInformacijaIsporukeForList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInformacijaIsporukeForList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfListItemDtoOfLong>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfListItemDtoOfLong>;
        }));
    }

    protected processGetInformacijaIsporukeForList(response: HttpResponseBase): Observable<ResultOfListOfListItemDtoOfLong> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfListItemDtoOfLong.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfListItemDtoOfLong>(null as any);
    }

    createInformacijaIsporukeStranka(command: CreateInformacijaIsporukeCommand): Observable<ResultOfInformacijaIsporukeDto> {
        let url_ = this.baseUrl + "/api/stranka/informacija-isporuke-stranke";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInformacijaIsporukeStranka(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInformacijaIsporukeStranka(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfInformacijaIsporukeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfInformacijaIsporukeDto>;
        }));
    }

    protected processCreateInformacijaIsporukeStranka(response: HttpResponseBase): Observable<ResultOfInformacijaIsporukeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfInformacijaIsporukeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfInformacijaIsporukeDto>(null as any);
    }

    deleteInformacijaIsporuke(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/stranka/informacija-isporuke-stranke/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInformacijaIsporuke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInformacijaIsporuke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteInformacijaIsporuke(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getInformacijaIsporukeStrankaById(id: number): Observable<ResultOfInformacijaIsporukeDto> {
        let url_ = this.baseUrl + "/api/stranka/informacija-isporuke-stranke/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInformacijaIsporukeStrankaById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInformacijaIsporukeStrankaById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfInformacijaIsporukeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfInformacijaIsporukeDto>;
        }));
    }

    protected processGetInformacijaIsporukeStrankaById(response: HttpResponseBase): Observable<ResultOfInformacijaIsporukeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfInformacijaIsporukeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfInformacijaIsporukeDto>(null as any);
    }

    updateInformacijaIsporuke(id: number, command: UpdateInformacijaIsporukeCommand): Observable<ResultOfInformacijaIsporukeDto> {
        let url_ = this.baseUrl + "/api/stranka/informacija-isporuke-stranke/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInformacijaIsporuke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInformacijaIsporuke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfInformacijaIsporukeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfInformacijaIsporukeDto>;
        }));
    }

    protected processUpdateInformacijaIsporuke(response: HttpResponseBase): Observable<ResultOfInformacijaIsporukeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfInformacijaIsporukeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfInformacijaIsporukeDto>(null as any);
    }

    getStrankaOdTekucegRacuna(brojTekucegRacuna?: string | null | undefined): Observable<ResultOfStrankaDto> {
        let url_ = this.baseUrl + "/api/stranka/get-stranka-od-tekuceg?";
        if (brojTekucegRacuna !== undefined && brojTekucegRacuna !== null)
            url_ += "brojTekucegRacuna=" + encodeURIComponent("" + brojTekucegRacuna) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStrankaOdTekucegRacuna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStrankaOdTekucegRacuna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfStrankaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfStrankaDto>;
        }));
    }

    protected processGetStrankaOdTekucegRacuna(response: HttpResponseBase): Observable<ResultOfStrankaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfStrankaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfStrankaDto>(null as any);
    }
}

export interface ISupportAccessRequestClient {
    get(): Observable<FileResponse>;
    approve(id: number): Observable<FileResponse>;
    reject(id: number): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class SupportAccessRequestClient implements ISupportAccessRequestClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/support-access-request";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    approve(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/support-access-request/{id}/approve";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    reject(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/support-access-request/{id}/reject";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReject(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface ISupportClient {
    createSupportAccessRequest(command: CreateSupportAccessRequestCommand): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class SupportClient implements ISupportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createSupportAccessRequest(command: CreateSupportAccessRequestCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/support/access-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSupportAccessRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSupportAccessRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCreateSupportAccessRequest(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface ITekuciRacuniClient {
    getAll(strankaId?: number | null | undefined, banka?: BankaIzvoda | undefined): Observable<ResultOfGetTekuceRacuneResponse>;
    create(command: CreateTekuciRacunCommand): Observable<ResultOfTekuciRacunDto>;
    getTekuciRacuniDropdown(strankaId?: number | null | undefined, banka?: BankaIzvoda | undefined): Observable<ResultOfGetTekuceRacuneDropdownResponse>;
    getTekuciRacun(id: number): Observable<ResultOfTekuciRacunDto>;
    createTekuceRacuneNbs(): Observable<ResultOfString>;
    update(id: number, command: UpdateTekuciRacunCommand): Observable<ResultOfTekuciRacunDto>;
}

@Injectable({
    providedIn: 'root'
})
export class TekuciRacuniClient implements ITekuciRacuniClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(strankaId?: number | null | undefined, banka?: BankaIzvoda | undefined): Observable<ResultOfGetTekuceRacuneResponse> {
        let url_ = this.baseUrl + "/api/tekuciracuni?";
        if (strankaId !== undefined && strankaId !== null)
            url_ += "strankaId=" + encodeURIComponent("" + strankaId) + "&";
        if (banka === null)
            throw new Error("The parameter 'banka' cannot be null.");
        else if (banka !== undefined)
            url_ += "banka=" + encodeURIComponent("" + banka) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTekuceRacuneResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTekuceRacuneResponse>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ResultOfGetTekuceRacuneResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTekuceRacuneResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTekuceRacuneResponse>(null as any);
    }

    create(command: CreateTekuciRacunCommand): Observable<ResultOfTekuciRacunDto> {
        let url_ = this.baseUrl + "/api/tekuciracuni";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfTekuciRacunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfTekuciRacunDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfTekuciRacunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfTekuciRacunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfTekuciRacunDto>(null as any);
    }

    getTekuciRacuniDropdown(strankaId?: number | null | undefined, banka?: BankaIzvoda | undefined): Observable<ResultOfGetTekuceRacuneDropdownResponse> {
        let url_ = this.baseUrl + "/api/tekuciracuni/get-dropdown?";
        if (strankaId !== undefined && strankaId !== null)
            url_ += "strankaId=" + encodeURIComponent("" + strankaId) + "&";
        if (banka === null)
            throw new Error("The parameter 'banka' cannot be null.");
        else if (banka !== undefined)
            url_ += "banka=" + encodeURIComponent("" + banka) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTekuciRacuniDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTekuciRacuniDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTekuceRacuneDropdownResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTekuceRacuneDropdownResponse>;
        }));
    }

    protected processGetTekuciRacuniDropdown(response: HttpResponseBase): Observable<ResultOfGetTekuceRacuneDropdownResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTekuceRacuneDropdownResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTekuceRacuneDropdownResponse>(null as any);
    }

    getTekuciRacun(id: number): Observable<ResultOfTekuciRacunDto> {
        let url_ = this.baseUrl + "/api/tekuciracuni/get-tekuci-racun/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTekuciRacun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTekuciRacun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfTekuciRacunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfTekuciRacunDto>;
        }));
    }

    protected processGetTekuciRacun(response: HttpResponseBase): Observable<ResultOfTekuciRacunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfTekuciRacunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfTekuciRacunDto>(null as any);
    }

    createTekuceRacuneNbs(): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/tekuciracuni/create-iz-nbs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTekuceRacuneNbs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTekuceRacuneNbs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreateTekuceRacuneNbs(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    update(id: number, command: UpdateTekuciRacunCommand): Observable<ResultOfTekuciRacunDto> {
        let url_ = this.baseUrl + "/api/tekuciracuni/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfTekuciRacunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfTekuciRacunDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultOfTekuciRacunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfTekuciRacunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfTekuciRacunDto>(null as any);
    }
}

export interface IUlazneFaktureClient {
    create(command: CreateUlaznaFakturaCommand): Observable<ResultOfString>;
    klasifikacija(racunId?: number | undefined, klasifikacijaRacuna?: string | null | undefined, pravoNaPdvOdbitak?: string | null | undefined): Observable<ResultOfString>;
    update(id: number, command: UpdateUlaznaFakturaCommand): Observable<FileResponse>;
    get(request: GetUlaznaFakturaQuery): Observable<ResultOfUlaznaFakturaDto>;
    getNewForStranka(strankaId: string): Observable<ResultOfUlaznaFakturaDto>;
    getNewForIsplata(request: GetNewUlaznaFakturaForIsplataQuery): Observable<ResultOfUlaznaFakturaDto>;
    duplicateUlaznaFaktura(id: number): Observable<ResultOfUlaznaFakturaDto>;
    getKlasifikacijaRacunaDropdown(): Observable<ResultOfGetKlasifikacijaRacunaDropdownResponses>;
    getPravoNaPdvOdbitakDropdown(): Observable<ResultOfGetPravoNaPdvOdbitakDropdownResponses>;
    getRacuneForZavisneTroskove(sefId?: number | undefined, searchValue?: string | null | undefined): Observable<ResultOfIEnumerableOfZavisniTrosakUfResponse>;
    getStavkeForZavisneTroskove(req: GetStavkeForZavisneTroskoveQuery): Observable<ResultOfIEnumerableOfZavisniTrosakStavkaDto>;
    getUlazniRacunUblQuery(racunId: number): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class UlazneFaktureClient implements IUlazneFaktureClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    create(command: CreateUlaznaFakturaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/ulaznefakture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    klasifikacija(racunId?: number | undefined, klasifikacijaRacuna?: string | null | undefined, pravoNaPdvOdbitak?: string | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/ulaznefakture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (racunId === null || racunId === undefined)
            throw new Error("The parameter 'racunId' cannot be null.");
        else
            content_.append("RacunId", racunId.toString());
        if (klasifikacijaRacuna !== null && klasifikacijaRacuna !== undefined)
            content_.append("KlasifikacijaRacuna", klasifikacijaRacuna.toString());
        if (pravoNaPdvOdbitak !== null && pravoNaPdvOdbitak !== undefined)
            content_.append("PravoNaPdvOdbitak", pravoNaPdvOdbitak.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKlasifikacija(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKlasifikacija(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processKlasifikacija(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    update(id: number, command: UpdateUlaznaFakturaCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ulaznefakture/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    get(request: GetUlaznaFakturaQuery): Observable<ResultOfUlaznaFakturaDto> {
        let url_ = this.baseUrl + "/api/ulaznefakture/get-ulazna-faktura";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfUlaznaFakturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfUlaznaFakturaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResultOfUlaznaFakturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfUlaznaFakturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfUlaznaFakturaDto>(null as any);
    }

    getNewForStranka(strankaId: string): Observable<ResultOfUlaznaFakturaDto> {
        let url_ = this.baseUrl + "/api/ulaznefakture/new-for-stranka/{strankaId}";
        if (strankaId === undefined || strankaId === null)
            throw new Error("The parameter 'strankaId' must be defined.");
        url_ = url_.replace("{strankaId}", encodeURIComponent("" + strankaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewForStranka(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewForStranka(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfUlaznaFakturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfUlaznaFakturaDto>;
        }));
    }

    protected processGetNewForStranka(response: HttpResponseBase): Observable<ResultOfUlaznaFakturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfUlaznaFakturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfUlaznaFakturaDto>(null as any);
    }

    getNewForIsplata(request: GetNewUlaznaFakturaForIsplataQuery): Observable<ResultOfUlaznaFakturaDto> {
        let url_ = this.baseUrl + "/api/ulaznefakture/new-for-isplata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewForIsplata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewForIsplata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfUlaznaFakturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfUlaznaFakturaDto>;
        }));
    }

    protected processGetNewForIsplata(response: HttpResponseBase): Observable<ResultOfUlaznaFakturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfUlaznaFakturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfUlaznaFakturaDto>(null as any);
    }

    duplicateUlaznaFaktura(id: number): Observable<ResultOfUlaznaFakturaDto> {
        let url_ = this.baseUrl + "/api/ulaznefakture/duplicate-faktura/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateUlaznaFaktura(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateUlaznaFaktura(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfUlaznaFakturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfUlaznaFakturaDto>;
        }));
    }

    protected processDuplicateUlaznaFaktura(response: HttpResponseBase): Observable<ResultOfUlaznaFakturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfUlaznaFakturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfUlaznaFakturaDto>(null as any);
    }

    getKlasifikacijaRacunaDropdown(): Observable<ResultOfGetKlasifikacijaRacunaDropdownResponses> {
        let url_ = this.baseUrl + "/api/ulaznefakture/klasifkacija-ulaznih-racuna";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKlasifikacijaRacunaDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKlasifikacijaRacunaDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetKlasifikacijaRacunaDropdownResponses>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetKlasifikacijaRacunaDropdownResponses>;
        }));
    }

    protected processGetKlasifikacijaRacunaDropdown(response: HttpResponseBase): Observable<ResultOfGetKlasifikacijaRacunaDropdownResponses> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetKlasifikacijaRacunaDropdownResponses.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetKlasifikacijaRacunaDropdownResponses>(null as any);
    }

    getPravoNaPdvOdbitakDropdown(): Observable<ResultOfGetPravoNaPdvOdbitakDropdownResponses> {
        let url_ = this.baseUrl + "/api/ulaznefakture/pravo-na-pdv-odbitak";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPravoNaPdvOdbitakDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPravoNaPdvOdbitakDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetPravoNaPdvOdbitakDropdownResponses>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetPravoNaPdvOdbitakDropdownResponses>;
        }));
    }

    protected processGetPravoNaPdvOdbitakDropdown(response: HttpResponseBase): Observable<ResultOfGetPravoNaPdvOdbitakDropdownResponses> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetPravoNaPdvOdbitakDropdownResponses.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetPravoNaPdvOdbitakDropdownResponses>(null as any);
    }

    getRacuneForZavisneTroskove(sefId?: number | undefined, searchValue?: string | null | undefined): Observable<ResultOfIEnumerableOfZavisniTrosakUfResponse> {
        let url_ = this.baseUrl + "/api/ulaznefakture/get-racune-for-zavisne-troskove?";
        if (sefId === null)
            throw new Error("The parameter 'sefId' cannot be null.");
        else if (sefId !== undefined)
            url_ += "sefId=" + encodeURIComponent("" + sefId) + "&";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRacuneForZavisneTroskove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRacuneForZavisneTroskove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIEnumerableOfZavisniTrosakUfResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIEnumerableOfZavisniTrosakUfResponse>;
        }));
    }

    protected processGetRacuneForZavisneTroskove(response: HttpResponseBase): Observable<ResultOfIEnumerableOfZavisniTrosakUfResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIEnumerableOfZavisniTrosakUfResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIEnumerableOfZavisniTrosakUfResponse>(null as any);
    }

    getStavkeForZavisneTroskove(req: GetStavkeForZavisneTroskoveQuery): Observable<ResultOfIEnumerableOfZavisniTrosakStavkaDto> {
        let url_ = this.baseUrl + "/api/ulaznefakture/get-stavke-for-zavisne-troskove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStavkeForZavisneTroskove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStavkeForZavisneTroskove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIEnumerableOfZavisniTrosakStavkaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIEnumerableOfZavisniTrosakStavkaDto>;
        }));
    }

    protected processGetStavkeForZavisneTroskove(response: HttpResponseBase): Observable<ResultOfIEnumerableOfZavisniTrosakStavkaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIEnumerableOfZavisniTrosakStavkaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIEnumerableOfZavisniTrosakStavkaDto>(null as any);
    }

    getUlazniRacunUblQuery(racunId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ulaznefakture/get-ulazni-racun-ubl/{racunId}";
        if (racunId === undefined || racunId === null)
            throw new Error("The parameter 'racunId' must be defined.");
        url_ = url_.replace("{racunId}", encodeURIComponent("" + racunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUlazniRacunUblQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUlazniRacunUblQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetUlazniRacunUblQuery(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IUslugeClient {
    getById(id: number): Observable<ResultOfUslugaDto>;
    getForTable(request: GetUslugaTableQuery): Observable<ResultOfGetTableResponseOfUslugaTableDto>;
    create(command: CreateUslugaCommand): Observable<ResultOfUslugaCommandResponse>;
    import(importFile?: FileParameter | null | undefined): Observable<ResultOfListOfImportUslugaDto>;
    update(id: number, command: UpdateUslugaCommand): Observable<ResultOfUslugaCommandResponse>;
    delete(id: number): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class UslugeClient implements IUslugeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getById(id: number): Observable<ResultOfUslugaDto> {
        let url_ = this.baseUrl + "/api/usluge/by-id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfUslugaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfUslugaDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ResultOfUslugaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfUslugaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfUslugaDto>(null as any);
    }

    getForTable(request: GetUslugaTableQuery): Observable<ResultOfGetTableResponseOfUslugaTableDto> {
        let url_ = this.baseUrl + "/api/usluge/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTableResponseOfUslugaTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTableResponseOfUslugaTableDto>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<ResultOfGetTableResponseOfUslugaTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTableResponseOfUslugaTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTableResponseOfUslugaTableDto>(null as any);
    }

    create(command: CreateUslugaCommand): Observable<ResultOfUslugaCommandResponse> {
        let url_ = this.baseUrl + "/api/usluge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfUslugaCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfUslugaCommandResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfUslugaCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfUslugaCommandResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfUslugaCommandResponse>(null as any);
    }

    import(importFile?: FileParameter | null | undefined): Observable<ResultOfListOfImportUslugaDto> {
        let url_ = this.baseUrl + "/api/usluge/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (importFile !== null && importFile !== undefined)
            content_.append("ImportFile", importFile.data, importFile.fileName ? importFile.fileName : "ImportFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfImportUslugaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfImportUslugaDto>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<ResultOfListOfImportUslugaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfImportUslugaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfImportUslugaDto>(null as any);
    }

    update(id: number, command: UpdateUslugaCommand): Observable<ResultOfUslugaCommandResponse> {
        let url_ = this.baseUrl + "/api/usluge/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfUslugaCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfUslugaCommandResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultOfUslugaCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfUslugaCommandResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfUslugaCommandResponse>(null as any);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/usluge/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IVozilaClient {
    getForTable(request: GetVozilaTableQuery): Observable<ResultOfGetTableResponseOfVoziloTableDto>;
    getVozilaDropdown(): Observable<ResultOfListOfVoziloDropdownDto>;
    getById(id: number): Observable<ResultOfVoziloDto>;
    create(command: CreateVoziloCommand): Observable<ResultOfVoziloCommandResponse>;
    update(id: number, command: UpdateVoziloCommand): Observable<ResultOfVoziloCommandResponse>;
    delete(id: number): Observable<FileResponse>;
    getVozilaOsiguranjaTable(id?: number | undefined): Observable<VoziloOsiguranjeTableVm>;
    getVoziloOsiguranjeById(id: number): Observable<VoziloOsiguranjeDto>;
    createVoziloOsiguranje(command: CreateVoziloOsiguranjeCommand): Observable<VoziloOsiguranjeResponseVm>;
    updateVoziloOsiguranje(id: number, command: UpdateVoziloOsiguranjeCommand): Observable<VoziloOsiguranjeResponseVm>;
    deleteVoziloOsiguranje(id: number): Observable<FileResponse>;
    getTipoveOsiguranja(): Observable<TipOsiguranjaVm>;
    getVozilaTipove(naziv?: string | null | undefined): Observable<VoziloTipVm>;
    getVozilaMarke(naziv?: string | null | undefined, tipId?: number | null | undefined): Observable<VoziloMarkaVm>;
    getVozilaModele(naziv?: string | null | undefined, markaId?: number | null | undefined): Observable<VoziloModelVm>;
    getVrsteGoriva(): Observable<VrstaGorivaVm>;
    uploadLogo(voziloId?: number | undefined, name?: string | null | undefined, file?: FileParameter | null | undefined): Observable<FileResponse>;
    getFotografijeVozila(id?: number | undefined): Observable<FotografijeVozilaVm>;
    uploadDokument(voziloId?: number | undefined, name?: string | null | undefined, file?: FileParameter | null | undefined): Observable<FileResponse>;
    getFajloveVozila(id?: number | undefined): Observable<DokumentaVozilaVm>;
}

@Injectable({
    providedIn: 'root'
})
export class VozilaClient implements IVozilaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForTable(request: GetVozilaTableQuery): Observable<ResultOfGetTableResponseOfVoziloTableDto> {
        let url_ = this.baseUrl + "/api/vozila/get-for-table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetTableResponseOfVoziloTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetTableResponseOfVoziloTableDto>;
        }));
    }

    protected processGetForTable(response: HttpResponseBase): Observable<ResultOfGetTableResponseOfVoziloTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetTableResponseOfVoziloTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetTableResponseOfVoziloTableDto>(null as any);
    }

    getVozilaDropdown(): Observable<ResultOfListOfVoziloDropdownDto> {
        let url_ = this.baseUrl + "/api/vozila/get-vozila-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVozilaDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVozilaDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfVoziloDropdownDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfVoziloDropdownDto>;
        }));
    }

    protected processGetVozilaDropdown(response: HttpResponseBase): Observable<ResultOfListOfVoziloDropdownDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfVoziloDropdownDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfVoziloDropdownDto>(null as any);
    }

    getById(id: number): Observable<ResultOfVoziloDto> {
        let url_ = this.baseUrl + "/api/vozila/by-id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfVoziloDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfVoziloDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ResultOfVoziloDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfVoziloDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfVoziloDto>(null as any);
    }

    create(command: CreateVoziloCommand): Observable<ResultOfVoziloCommandResponse> {
        let url_ = this.baseUrl + "/api/vozila";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfVoziloCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfVoziloCommandResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfVoziloCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfVoziloCommandResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfVoziloCommandResponse>(null as any);
    }

    update(id: number, command: UpdateVoziloCommand): Observable<ResultOfVoziloCommandResponse> {
        let url_ = this.baseUrl + "/api/vozila/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfVoziloCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfVoziloCommandResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultOfVoziloCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfVoziloCommandResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfVoziloCommandResponse>(null as any);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/vozila/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getVozilaOsiguranjaTable(id?: number | undefined): Observable<VoziloOsiguranjeTableVm> {
        let url_ = this.baseUrl + "/api/vozila/get-vozila-osiguranja-table?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVozilaOsiguranjaTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVozilaOsiguranjaTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoziloOsiguranjeTableVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoziloOsiguranjeTableVm>;
        }));
    }

    protected processGetVozilaOsiguranjaTable(response: HttpResponseBase): Observable<VoziloOsiguranjeTableVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoziloOsiguranjeTableVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VoziloOsiguranjeTableVm>(null as any);
    }

    getVoziloOsiguranjeById(id: number): Observable<VoziloOsiguranjeDto> {
        let url_ = this.baseUrl + "/api/vozila/vozilo-osiguranje-by-id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoziloOsiguranjeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoziloOsiguranjeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoziloOsiguranjeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoziloOsiguranjeDto>;
        }));
    }

    protected processGetVoziloOsiguranjeById(response: HttpResponseBase): Observable<VoziloOsiguranjeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoziloOsiguranjeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VoziloOsiguranjeDto>(null as any);
    }

    createVoziloOsiguranje(command: CreateVoziloOsiguranjeCommand): Observable<VoziloOsiguranjeResponseVm> {
        let url_ = this.baseUrl + "/api/vozila/create-vozilo-osiguranje";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateVoziloOsiguranje(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVoziloOsiguranje(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoziloOsiguranjeResponseVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoziloOsiguranjeResponseVm>;
        }));
    }

    protected processCreateVoziloOsiguranje(response: HttpResponseBase): Observable<VoziloOsiguranjeResponseVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoziloOsiguranjeResponseVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VoziloOsiguranjeResponseVm>(null as any);
    }

    updateVoziloOsiguranje(id: number, command: UpdateVoziloOsiguranjeCommand): Observable<VoziloOsiguranjeResponseVm> {
        let url_ = this.baseUrl + "/api/vozila/update-vozilo-osiguranje/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVoziloOsiguranje(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVoziloOsiguranje(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoziloOsiguranjeResponseVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoziloOsiguranjeResponseVm>;
        }));
    }

    protected processUpdateVoziloOsiguranje(response: HttpResponseBase): Observable<VoziloOsiguranjeResponseVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoziloOsiguranjeResponseVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VoziloOsiguranjeResponseVm>(null as any);
    }

    deleteVoziloOsiguranje(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/vozila/delete-vozilo-osiguranje/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteVoziloOsiguranje(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVoziloOsiguranje(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteVoziloOsiguranje(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getTipoveOsiguranja(): Observable<TipOsiguranjaVm> {
        let url_ = this.baseUrl + "/api/vozila/tipovi-osiguranja";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipoveOsiguranja(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipoveOsiguranja(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipOsiguranjaVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipOsiguranjaVm>;
        }));
    }

    protected processGetTipoveOsiguranja(response: HttpResponseBase): Observable<TipOsiguranjaVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TipOsiguranjaVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipOsiguranjaVm>(null as any);
    }

    getVozilaTipove(naziv?: string | null | undefined): Observable<VoziloTipVm> {
        let url_ = this.baseUrl + "/api/vozila/get-vozila-tipove?";
        if (naziv !== undefined && naziv !== null)
            url_ += "naziv=" + encodeURIComponent("" + naziv) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVozilaTipove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVozilaTipove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoziloTipVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoziloTipVm>;
        }));
    }

    protected processGetVozilaTipove(response: HttpResponseBase): Observable<VoziloTipVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoziloTipVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VoziloTipVm>(null as any);
    }

    getVozilaMarke(naziv?: string | null | undefined, tipId?: number | null | undefined): Observable<VoziloMarkaVm> {
        let url_ = this.baseUrl + "/api/vozila/get-vozila-marke?";
        if (naziv !== undefined && naziv !== null)
            url_ += "naziv=" + encodeURIComponent("" + naziv) + "&";
        if (tipId !== undefined && tipId !== null)
            url_ += "tipId=" + encodeURIComponent("" + tipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVozilaMarke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVozilaMarke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoziloMarkaVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoziloMarkaVm>;
        }));
    }

    protected processGetVozilaMarke(response: HttpResponseBase): Observable<VoziloMarkaVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoziloMarkaVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VoziloMarkaVm>(null as any);
    }

    getVozilaModele(naziv?: string | null | undefined, markaId?: number | null | undefined): Observable<VoziloModelVm> {
        let url_ = this.baseUrl + "/api/vozila/get-vozila-modele?";
        if (naziv !== undefined && naziv !== null)
            url_ += "naziv=" + encodeURIComponent("" + naziv) + "&";
        if (markaId !== undefined && markaId !== null)
            url_ += "markaId=" + encodeURIComponent("" + markaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVozilaModele(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVozilaModele(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoziloModelVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoziloModelVm>;
        }));
    }

    protected processGetVozilaModele(response: HttpResponseBase): Observable<VoziloModelVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoziloModelVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VoziloModelVm>(null as any);
    }

    getVrsteGoriva(): Observable<VrstaGorivaVm> {
        let url_ = this.baseUrl + "/api/vozila/vrste-goriva";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVrsteGoriva(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVrsteGoriva(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VrstaGorivaVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VrstaGorivaVm>;
        }));
    }

    protected processGetVrsteGoriva(response: HttpResponseBase): Observable<VrstaGorivaVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VrstaGorivaVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VrstaGorivaVm>(null as any);
    }

    uploadLogo(voziloId?: number | undefined, name?: string | null | undefined, file?: FileParameter | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/vozila/upload-fotografije";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (voziloId === null || voziloId === undefined)
            throw new Error("The parameter 'voziloId' cannot be null.");
        else
            content_.append("VoziloId", voziloId.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUploadLogo(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getFotografijeVozila(id?: number | undefined): Observable<FotografijeVozilaVm> {
        let url_ = this.baseUrl + "/api/vozila/get-fotografije-vozila?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFotografijeVozila(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFotografijeVozila(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FotografijeVozilaVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FotografijeVozilaVm>;
        }));
    }

    protected processGetFotografijeVozila(response: HttpResponseBase): Observable<FotografijeVozilaVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FotografijeVozilaVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FotografijeVozilaVm>(null as any);
    }

    uploadDokument(voziloId?: number | undefined, name?: string | null | undefined, file?: FileParameter | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/vozila/upload-dokumenta";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (voziloId === null || voziloId === undefined)
            throw new Error("The parameter 'voziloId' cannot be null.");
        else
            content_.append("VoziloId", voziloId.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDokument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDokument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUploadDokument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getFajloveVozila(id?: number | undefined): Observable<DokumentaVozilaVm> {
        let url_ = this.baseUrl + "/api/vozila/get-fajlove-vozila?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFajloveVozila(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFajloveVozila(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DokumentaVozilaVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DokumentaVozilaVm>;
        }));
    }

    protected processGetFajloveVozila(response: HttpResponseBase): Observable<DokumentaVozilaVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DokumentaVozilaVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DokumentaVozilaVm>(null as any);
    }
}

export interface IWcKategorijeClient {
    getAll(): Observable<ResultOfListOfWcKategorijaDto>;
    create(command: CreateWcKategorijaCommand): Observable<ResultOfWcKategorijaDto>;
    getById(id: number): Observable<ResultOfWcKategorijaDto>;
    update(id: number, command: UpdateWcKategorijaCommand): Observable<ResultOfWcKategorijaDto>;
    delete(id: number): Observable<ResultOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class WcKategorijeClient implements IWcKategorijeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<ResultOfListOfWcKategorijaDto> {
        let url_ = this.baseUrl + "/api/wc-kategorije";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfWcKategorijaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfWcKategorijaDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ResultOfListOfWcKategorijaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfWcKategorijaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfWcKategorijaDto>(null as any);
    }

    create(command: CreateWcKategorijaCommand): Observable<ResultOfWcKategorijaDto> {
        let url_ = this.baseUrl + "/api/wc-kategorije";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfWcKategorijaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfWcKategorijaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResultOfWcKategorijaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfWcKategorijaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfWcKategorijaDto>(null as any);
    }

    getById(id: number): Observable<ResultOfWcKategorijaDto> {
        let url_ = this.baseUrl + "/api/wc-kategorije/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfWcKategorijaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfWcKategorijaDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ResultOfWcKategorijaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfWcKategorijaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfWcKategorijaDto>(null as any);
    }

    update(id: number, command: UpdateWcKategorijaCommand): Observable<ResultOfWcKategorijaDto> {
        let url_ = this.baseUrl + "/api/wc-kategorije/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfWcKategorijaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfWcKategorijaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResultOfWcKategorijaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfWcKategorijaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfWcKategorijaDto>(null as any);
    }

    delete(id: number): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/wc-kategorije/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }
}

export interface ITenantsClient {
    get(key: string): Observable<FileResponse>;
    getAll(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class TenantsClient implements ITenantsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(key: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/tenants/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getAll(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/tenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IIdentityClient {
    register(request: RegisterRequest): Observable<FileResponse>;
    createKorisnik(command: CreateKorisnikCommand): Observable<ResultOfString>;
    confirmEmail(userId?: string | null | undefined, code?: string | null | undefined, tenantKey?: string | null | undefined): Observable<ResultOfString>;
    confirmPhoneNumber(userId?: string | null | undefined, code?: string | null | undefined): Observable<FileResponse>;
    resetPasswordInit(command: ResetPasswordInitCommand): Observable<ResultOfResetPasswordInitResponse>;
    resetPassword(command: ResetPasswordCommand, tenantKey?: string | null | undefined): Observable<ResultOfString>;
    updateUserAccessPassword(command: UpdateUserAccessPasswordCommand, tenantKey?: string | null | undefined): Observable<ResultOfString>;
    checkPasswordValidity(command: CheckPasswordValidityQuery): Observable<Result>;
}

@Injectable({
    providedIn: 'root'
})
export class IdentityClient implements IIdentityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    register(request: RegisterRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/identity/register-company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    createKorisnik(command: CreateKorisnikCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/identity/create-korisnik";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateKorisnik(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateKorisnik(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreateKorisnik(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    confirmEmail(userId?: string | null | undefined, code?: string | null | undefined, tenantKey?: string | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/identity/confirm-email?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (tenantKey !== undefined && tenantKey !== null)
            url_ += "tenantKey=" + encodeURIComponent("" + tenantKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    confirmPhoneNumber(userId?: string | null | undefined, code?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/identity/confirm-phone-number?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPhoneNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processConfirmPhoneNumber(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    resetPasswordInit(command: ResetPasswordInitCommand): Observable<ResultOfResetPasswordInitResponse> {
        let url_ = this.baseUrl + "/api/identity/reset-password-init";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPasswordInit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPasswordInit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfResetPasswordInitResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfResetPasswordInitResponse>;
        }));
    }

    protected processResetPasswordInit(response: HttpResponseBase): Observable<ResultOfResetPasswordInitResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfResetPasswordInitResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfResetPasswordInitResponse>(null as any);
    }

    resetPassword(command: ResetPasswordCommand, tenantKey?: string | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/identity/reset-password?";
        if (tenantKey !== undefined && tenantKey !== null)
            url_ += "tenantKey=" + encodeURIComponent("" + tenantKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    updateUserAccessPassword(command: UpdateUserAccessPasswordCommand, tenantKey?: string | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/identity/update-user-access-password?";
        if (tenantKey !== undefined && tenantKey !== null)
            url_ += "tenantKey=" + encodeURIComponent("" + tenantKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserAccessPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserAccessPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdateUserAccessPassword(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    checkPasswordValidity(command: CheckPasswordValidityQuery): Observable<Result> {
        let url_ = this.baseUrl + "/api/identity/check-password-validity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckPasswordValidity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckPasswordValidity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processCheckPasswordValidity(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }
}

export interface ITokensClient {
    getToken(request: TokenRequest): Observable<ResultOfTokenResponse>;
    getTokenWithHeader(request: TokenRequest, tenantKey?: string | null | undefined): Observable<ResultOfTokenResponse>;
    refresh(request: RefreshTokenRequest, tenantKey?: string | null | undefined): Observable<ResultOfTokenResponse>;
    takeOverSession(request: TakeOverSessionRequest, tenantKey?: string | null | undefined): Observable<ResultOfTokenResponse>;
    createMojaFirma(command: CreateMojaFirmaCommand): Observable<ResultOfString>;
    createMojaFirmaTrialAccount(command: CreateMojaFirmaTrialCommand): Observable<ResultOfString>;
    createMojaFirmaRegosAccount(command: CreateMojaFirmaRegosCommand): Observable<ResultOfString>;
    sendConfirmationCode(command: SendConfirmationCodeMojaFirmaCommand): Observable<ResultOfString>;
    uniqueCheckKompanija(command: UniqueCheckMojaFirmaCommand): Observable<Result>;
    switchTenant(request: SwitchTenantRequest): Observable<ResultOfTokenResponse>;
    checkEmailExistance(query: CheckEmailExistanceQuery): Observable<ResultOfPodaciKorisnikaDto>;
}

@Injectable({
    providedIn: 'root'
})
export class TokensClient implements ITokensClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getToken(request: TokenRequest): Observable<ResultOfTokenResponse> {
        let url_ = this.baseUrl + "/api/tokens";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfTokenResponse>;
        }));
    }

    protected processGetToken(response: HttpResponseBase): Observable<ResultOfTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfTokenResponse>(null as any);
    }

    getTokenWithHeader(request: TokenRequest, tenantKey?: string | null | undefined): Observable<ResultOfTokenResponse> {
        let url_ = this.baseUrl + "/api/tokens/get-token-with-header";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "tenantKey": tenantKey !== undefined && tenantKey !== null ? "" + tenantKey : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTokenWithHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTokenWithHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfTokenResponse>;
        }));
    }

    protected processGetTokenWithHeader(response: HttpResponseBase): Observable<ResultOfTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfTokenResponse>(null as any);
    }

    refresh(request: RefreshTokenRequest, tenantKey?: string | null | undefined): Observable<ResultOfTokenResponse> {
        let url_ = this.baseUrl + "/api/tokens/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "tenantKey": tenantKey !== undefined && tenantKey !== null ? "" + tenantKey : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefresh(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefresh(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfTokenResponse>;
        }));
    }

    protected processRefresh(response: HttpResponseBase): Observable<ResultOfTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfTokenResponse>(null as any);
    }

    takeOverSession(request: TakeOverSessionRequest, tenantKey?: string | null | undefined): Observable<ResultOfTokenResponse> {
        let url_ = this.baseUrl + "/api/tokens/take-over-session";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "tenantKey": tenantKey !== undefined && tenantKey !== null ? "" + tenantKey : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTakeOverSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTakeOverSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfTokenResponse>;
        }));
    }

    protected processTakeOverSession(response: HttpResponseBase): Observable<ResultOfTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfTokenResponse>(null as any);
    }

    createMojaFirma(command: CreateMojaFirmaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/tokens/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMojaFirma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMojaFirma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreateMojaFirma(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    createMojaFirmaTrialAccount(command: CreateMojaFirmaTrialCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/tokens/register-trial-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMojaFirmaTrialAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMojaFirmaTrialAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreateMojaFirmaTrialAccount(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    createMojaFirmaRegosAccount(command: CreateMojaFirmaRegosCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/tokens/register-regos-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMojaFirmaRegosAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMojaFirmaRegosAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processCreateMojaFirmaRegosAccount(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sendConfirmationCode(command: SendConfirmationCodeMojaFirmaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/tokens/send-confirmation-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConfirmationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConfirmationCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSendConfirmationCode(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    uniqueCheckKompanija(command: UniqueCheckMojaFirmaCommand): Observable<Result> {
        let url_ = this.baseUrl + "/api/tokens/unique-check-kompanija";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUniqueCheckKompanija(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUniqueCheckKompanija(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUniqueCheckKompanija(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    switchTenant(request: SwitchTenantRequest): Observable<ResultOfTokenResponse> {
        let url_ = this.baseUrl + "/api/tokens/switch-tenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfTokenResponse>;
        }));
    }

    protected processSwitchTenant(response: HttpResponseBase): Observable<ResultOfTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfTokenResponse>(null as any);
    }

    checkEmailExistance(query: CheckEmailExistanceQuery): Observable<ResultOfPodaciKorisnikaDto> {
        let url_ = this.baseUrl + "/api/tokens/check-email-existance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckEmailExistance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckEmailExistance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfPodaciKorisnikaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfPodaciKorisnikaDto>;
        }));
    }

    protected processCheckEmailExistance(response: HttpResponseBase): Observable<ResultOfPodaciKorisnikaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfPodaciKorisnikaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfPodaciKorisnikaDto>(null as any);
    }
}

export class Result implements IResult {
    messages?: string[] | undefined;
    succeeded?: boolean;

    constructor(data?: IResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.succeeded = _data["succeeded"];
        }
    }

    static fromJS(data: any): Result {
        data = typeof data === 'object' ? data : {};
        let result = new Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["succeeded"] = this.succeeded;
        return data;
    }
}

export interface IResult {
    messages?: string[] | undefined;
    succeeded?: boolean;
}

export class ResultOfGetSkladisneJediniceResponse extends Result implements IResultOfGetSkladisneJediniceResponse {
    data?: GetSkladisneJediniceResponse | undefined;

    constructor(data?: IResultOfGetSkladisneJediniceResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetSkladisneJediniceResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetSkladisneJediniceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetSkladisneJediniceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetSkladisneJediniceResponse extends IResult {
    data?: GetSkladisneJediniceResponse | undefined;
}

export class GetSkladisneJediniceResponse implements IGetSkladisneJediniceResponse {
    responseList?: SkladisnaJedinicaDto[] | undefined;

    constructor(data?: IGetSkladisneJediniceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(SkladisnaJedinicaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSkladisneJediniceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSkladisneJediniceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSkladisneJediniceResponse {
    responseList?: SkladisnaJedinicaDto[] | undefined;
}

export class SkladisnaJedinicaDto implements ISkladisnaJedinicaDto {
    id?: number | undefined;
    naziv?: string | undefined;

    constructor(data?: ISkladisnaJedinicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): SkladisnaJedinicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new SkladisnaJedinicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface ISkladisnaJedinicaDto {
    id?: number | undefined;
    naziv?: string | undefined;
}

export class ResultOfSkladisnaJedinicaDto extends Result implements IResultOfSkladisnaJedinicaDto {
    data?: SkladisnaJedinicaDto | undefined;

    constructor(data?: IResultOfSkladisnaJedinicaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? SkladisnaJedinicaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfSkladisnaJedinicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfSkladisnaJedinicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfSkladisnaJedinicaDto extends IResult {
    data?: SkladisnaJedinicaDto | undefined;
}

export class CreateSkladisnaJedinicaCommand implements ICreateSkladisnaJedinicaCommand {
    naziv?: string | undefined;

    constructor(data?: ICreateSkladisnaJedinicaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): CreateSkladisnaJedinicaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSkladisnaJedinicaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface ICreateSkladisnaJedinicaCommand {
    naziv?: string | undefined;
}

export class ResultOfString extends Result implements IResultOfString {
    data?: string | undefined;

    constructor(data?: IResultOfString) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ResultOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfString extends IResult {
    data?: string | undefined;
}

export class KategorijaDokMaterijalaDto implements IKategorijaDokMaterijalaDto {
    id?: number | undefined;
    naziv?: string | undefined;
    rokCuvanja?: number;
    klasifikacionaOznaka?: string | undefined;
    grupaKategorijaDto?: GrupaKategorijaDto | undefined;

    constructor(data?: IKategorijaDokMaterijalaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.rokCuvanja = _data["rokCuvanja"];
            this.klasifikacionaOznaka = _data["klasifikacionaOznaka"];
            this.grupaKategorijaDto = _data["grupaKategorijaDto"] ? GrupaKategorijaDto.fromJS(_data["grupaKategorijaDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KategorijaDokMaterijalaDto {
        data = typeof data === 'object' ? data : {};
        let result = new KategorijaDokMaterijalaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["rokCuvanja"] = this.rokCuvanja;
        data["klasifikacionaOznaka"] = this.klasifikacionaOznaka;
        data["grupaKategorijaDto"] = this.grupaKategorijaDto ? this.grupaKategorijaDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKategorijaDokMaterijalaDto {
    id?: number | undefined;
    naziv?: string | undefined;
    rokCuvanja?: number;
    klasifikacionaOznaka?: string | undefined;
    grupaKategorijaDto?: GrupaKategorijaDto | undefined;
}

export class CreateKategorijaMaterijalaCommand extends KategorijaDokMaterijalaDto implements ICreateKategorijaMaterijalaCommand {

    constructor(data?: ICreateKategorijaMaterijalaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateKategorijaMaterijalaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKategorijaMaterijalaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateKategorijaMaterijalaCommand extends IKategorijaDokMaterijalaDto {
}

export class GrupaKategorijaDto implements IGrupaKategorijaDto {
    id?: number | undefined;
    naziv?: string | undefined;
    jeImportovana?: boolean | undefined;

    constructor(data?: IGrupaKategorijaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.jeImportovana = _data["jeImportovana"];
        }
    }

    static fromJS(data: any): GrupaKategorijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new GrupaKategorijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["jeImportovana"] = this.jeImportovana;
        return data;
    }
}

export interface IGrupaKategorijaDto {
    id?: number | undefined;
    naziv?: string | undefined;
    jeImportovana?: boolean | undefined;
}

export class UpdateKategorijaMaterijalaCommand implements IUpdateKategorijaMaterijalaCommand {
    id?: number;
    naziv?: string | undefined;
    rokCuvanja?: number;

    constructor(data?: IUpdateKategorijaMaterijalaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.rokCuvanja = _data["rokCuvanja"];
        }
    }

    static fromJS(data: any): UpdateKategorijaMaterijalaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateKategorijaMaterijalaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["rokCuvanja"] = this.rokCuvanja;
        return data;
    }
}

export interface IUpdateKategorijaMaterijalaCommand {
    id?: number;
    naziv?: string | undefined;
    rokCuvanja?: number;
}

export class UpdateSkladisnaJedinicaCommand implements IUpdateSkladisnaJedinicaCommand {
    id?: number;
    naziv?: string | undefined;

    constructor(data?: IUpdateSkladisnaJedinicaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): UpdateSkladisnaJedinicaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSkladisnaJedinicaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IUpdateSkladisnaJedinicaCommand {
    id?: number;
    naziv?: string | undefined;
}

export class ResultOfFizickeLokacijeTreeVm extends Result implements IResultOfFizickeLokacijeTreeVm {
    data?: FizickeLokacijeTreeVm | undefined;

    constructor(data?: IResultOfFizickeLokacijeTreeVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? FizickeLokacijeTreeVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfFizickeLokacijeTreeVm {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfFizickeLokacijeTreeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfFizickeLokacijeTreeVm extends IResult {
    data?: FizickeLokacijeTreeVm | undefined;
}

export class FizickeLokacijeTreeVm implements IFizickeLokacijeTreeVm {
    fizickeLokacijeTree?: FizickaLokacijaTreeDto[] | undefined;

    constructor(data?: IFizickeLokacijeTreeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fizickeLokacijeTree"])) {
                this.fizickeLokacijeTree = [] as any;
                for (let item of _data["fizickeLokacijeTree"])
                    this.fizickeLokacijeTree!.push(FizickaLokacijaTreeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FizickeLokacijeTreeVm {
        data = typeof data === 'object' ? data : {};
        let result = new FizickeLokacijeTreeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fizickeLokacijeTree)) {
            data["fizickeLokacijeTree"] = [];
            for (let item of this.fizickeLokacijeTree)
                data["fizickeLokacijeTree"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFizickeLokacijeTreeVm {
    fizickeLokacijeTree?: FizickaLokacijaTreeDto[] | undefined;
}

export class FizickaLokacijaTreeDto implements IFizickaLokacijaTreeDto {
    id?: number | undefined;
    naziv?: string | undefined;
    punNaziv?: string | undefined;
    childrenDto?: FizickaLokacijaTreeDto[] | undefined;

    constructor(data?: IFizickaLokacijaTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.punNaziv = _data["punNaziv"];
            if (Array.isArray(_data["childrenDto"])) {
                this.childrenDto = [] as any;
                for (let item of _data["childrenDto"])
                    this.childrenDto!.push(FizickaLokacijaTreeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FizickaLokacijaTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FizickaLokacijaTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["punNaziv"] = this.punNaziv;
        if (Array.isArray(this.childrenDto)) {
            data["childrenDto"] = [];
            for (let item of this.childrenDto)
                data["childrenDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFizickaLokacijaTreeDto {
    id?: number | undefined;
    naziv?: string | undefined;
    punNaziv?: string | undefined;
    childrenDto?: FizickaLokacijaTreeDto[] | undefined;
}

export class ResultOfFizickaLokacijaDto extends Result implements IResultOfFizickaLokacijaDto {
    data?: FizickaLokacijaDto | undefined;

    constructor(data?: IResultOfFizickaLokacijaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? FizickaLokacijaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfFizickaLokacijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfFizickaLokacijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfFizickaLokacijaDto extends IResult {
    data?: FizickaLokacijaDto | undefined;
}

export class FizickaLokacijaDto implements IFizickaLokacijaDto {
    id?: number | undefined;
    naziv?: string | undefined;
    punNaziv?: string | undefined;
    parent?: FizickaLokacijaAutocompleteItem | undefined;

    constructor(data?: IFizickaLokacijaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.punNaziv = _data["punNaziv"];
            this.parent = _data["parent"] ? FizickaLokacijaAutocompleteItem.fromJS(_data["parent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FizickaLokacijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new FizickaLokacijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["punNaziv"] = this.punNaziv;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFizickaLokacijaDto {
    id?: number | undefined;
    naziv?: string | undefined;
    punNaziv?: string | undefined;
    parent?: FizickaLokacijaAutocompleteItem | undefined;
}

export class FizickaLokacijaAutocompleteItem implements IFizickaLokacijaAutocompleteItem {
    id?: number | undefined;
    naziv?: string | undefined;
    punNaziv?: string | undefined;

    constructor(data?: IFizickaLokacijaAutocompleteItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.punNaziv = _data["punNaziv"];
        }
    }

    static fromJS(data: any): FizickaLokacijaAutocompleteItem {
        data = typeof data === 'object' ? data : {};
        let result = new FizickaLokacijaAutocompleteItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["punNaziv"] = this.punNaziv;
        return data;
    }
}

export interface IFizickaLokacijaAutocompleteItem {
    id?: number | undefined;
    naziv?: string | undefined;
    punNaziv?: string | undefined;
}

export class CreateFizickaLokacijaCommand implements ICreateFizickaLokacijaCommand {
    id?: number | undefined;
    naziv?: string | undefined;
    punNaziv?: string | undefined;
    parent?: FizickaLokacijaAutocompleteItem | undefined;

    constructor(data?: ICreateFizickaLokacijaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.punNaziv = _data["punNaziv"];
            this.parent = _data["parent"] ? FizickaLokacijaAutocompleteItem.fromJS(_data["parent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateFizickaLokacijaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFizickaLokacijaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["punNaziv"] = this.punNaziv;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateFizickaLokacijaCommand {
    id?: number | undefined;
    naziv?: string | undefined;
    punNaziv?: string | undefined;
    parent?: FizickaLokacijaAutocompleteItem | undefined;
}

export class ResultOfFizickaLokacijaSeachResponse extends Result implements IResultOfFizickaLokacijaSeachResponse {
    data?: FizickaLokacijaSeachResponse | undefined;

    constructor(data?: IResultOfFizickaLokacijaSeachResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? FizickaLokacijaSeachResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfFizickaLokacijaSeachResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfFizickaLokacijaSeachResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfFizickaLokacijaSeachResponse extends IResult {
    data?: FizickaLokacijaSeachResponse | undefined;
}

export class FizickaLokacijaSeachResponse implements IFizickaLokacijaSeachResponse {
    fizickeLokacije?: FizickaLokacijaAutocompleteItem[] | undefined;

    constructor(data?: IFizickaLokacijaSeachResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fizickeLokacije"])) {
                this.fizickeLokacije = [] as any;
                for (let item of _data["fizickeLokacije"])
                    this.fizickeLokacije!.push(FizickaLokacijaAutocompleteItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FizickaLokacijaSeachResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FizickaLokacijaSeachResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fizickeLokacije)) {
            data["fizickeLokacije"] = [];
            for (let item of this.fizickeLokacije)
                data["fizickeLokacije"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFizickaLokacijaSeachResponse {
    fizickeLokacije?: FizickaLokacijaAutocompleteItem[] | undefined;
}

export class GetFizickaLokacijaAutocompleteQuery implements IGetFizickaLokacijaAutocompleteQuery {
    naziv?: string | undefined;

    constructor(data?: IGetFizickaLokacijaAutocompleteQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): GetFizickaLokacijaAutocompleteQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFizickaLokacijaAutocompleteQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IGetFizickaLokacijaAutocompleteQuery {
    naziv?: string | undefined;
}

export class UpdateFizickaLokacijaCommand implements IUpdateFizickaLokacijaCommand {
    id?: number | undefined;
    naziv?: string | undefined;
    punNaziv?: string | undefined;
    parent?: FizickaLokacijaAutocompleteItem | undefined;

    constructor(data?: IUpdateFizickaLokacijaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.punNaziv = _data["punNaziv"];
            this.parent = _data["parent"] ? FizickaLokacijaAutocompleteItem.fromJS(_data["parent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateFizickaLokacijaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFizickaLokacijaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["punNaziv"] = this.punNaziv;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateFizickaLokacijaCommand {
    id?: number | undefined;
    naziv?: string | undefined;
    punNaziv?: string | undefined;
    parent?: FizickaLokacijaAutocompleteItem | undefined;
}

export class ResultOfArhivskaExistsResponse extends Result implements IResultOfArhivskaExistsResponse {
    data?: ArhivskaExistsResponse | undefined;

    constructor(data?: IResultOfArhivskaExistsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? ArhivskaExistsResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfArhivskaExistsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfArhivskaExistsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfArhivskaExistsResponse extends IResult {
    data?: ArhivskaExistsResponse | undefined;
}

export class ArhivskaExistsResponse implements IArhivskaExistsResponse {
    arhivskaTableEmpty?: boolean;
    arhivskaTableExists?: boolean | undefined;

    constructor(data?: IArhivskaExistsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arhivskaTableEmpty = _data["arhivskaTableEmpty"];
            this.arhivskaTableExists = _data["arhivskaTableExists"];
        }
    }

    static fromJS(data: any): ArhivskaExistsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ArhivskaExistsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arhivskaTableEmpty"] = this.arhivskaTableEmpty;
        data["arhivskaTableExists"] = this.arhivskaTableExists;
        return data;
    }
}

export interface IArhivskaExistsResponse {
    arhivskaTableEmpty?: boolean;
    arhivskaTableExists?: boolean | undefined;
}

export class GetZipedDocumentsQuery implements IGetZipedDocumentsQuery {
    dto?: ArhivskaDokumentaFormDto | undefined;

    constructor(data?: IGetZipedDocumentsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dto = _data["dto"] ? ArhivskaDokumentaFormDto.fromJS(_data["dto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetZipedDocumentsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetZipedDocumentsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dto"] = this.dto ? this.dto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetZipedDocumentsQuery {
    dto?: ArhivskaDokumentaFormDto | undefined;
}

export class ArhivskaDokumentaFormDto implements IArhivskaDokumentaFormDto {
    naziv?: string | undefined;
    grad?: string | undefined;
    ulicaIBroj?: string | undefined;
    pib?: string | undefined;
    maticniBroj?: string | undefined;
    zastupnik?: string | undefined;
    odgovornoLice?: string | undefined;
    datum?: Date;
    jeCirilica?: boolean;

    constructor(data?: IArhivskaDokumentaFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.grad = _data["grad"];
            this.ulicaIBroj = _data["ulicaIBroj"];
            this.pib = _data["pib"];
            this.maticniBroj = _data["maticniBroj"];
            this.zastupnik = _data["zastupnik"];
            this.odgovornoLice = _data["odgovornoLice"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.jeCirilica = _data["jeCirilica"];
        }
    }

    static fromJS(data: any): ArhivskaDokumentaFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArhivskaDokumentaFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["grad"] = this.grad;
        data["ulicaIBroj"] = this.ulicaIBroj;
        data["pib"] = this.pib;
        data["maticniBroj"] = this.maticniBroj;
        data["zastupnik"] = this.zastupnik;
        data["odgovornoLice"] = this.odgovornoLice;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["jeCirilica"] = this.jeCirilica;
        return data;
    }
}

export interface IArhivskaDokumentaFormDto {
    naziv?: string | undefined;
    grad?: string | undefined;
    ulicaIBroj?: string | undefined;
    pib?: string | undefined;
    maticniBroj?: string | undefined;
    zastupnik?: string | undefined;
    odgovornoLice?: string | undefined;
    datum?: Date;
    jeCirilica?: boolean;
}

export enum ArhivskaKnjigaDopisVrsta {
    DOPIS_LISTA = 0,
    DOPIS_ARHIVSKA = 1,
    LISTA_I_ARHIVSKA = 2,
}

export class ResultOfArhivskaDokumentaFormDto extends Result implements IResultOfArhivskaDokumentaFormDto {
    data?: ArhivskaDokumentaFormDto | undefined;

    constructor(data?: IResultOfArhivskaDokumentaFormDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? ArhivskaDokumentaFormDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfArhivskaDokumentaFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfArhivskaDokumentaFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfArhivskaDokumentaFormDto extends IResult {
    data?: ArhivskaDokumentaFormDto | undefined;
}

export class ResultOfArhivskaPodesavanjaResponse extends Result implements IResultOfArhivskaPodesavanjaResponse {
    data?: ArhivskaPodesavanjaResponse | undefined;

    constructor(data?: IResultOfArhivskaPodesavanjaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? ArhivskaPodesavanjaResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfArhivskaPodesavanjaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfArhivskaPodesavanjaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfArhivskaPodesavanjaResponse extends IResult {
    data?: ArhivskaPodesavanjaResponse | undefined;
}

export class ArhivskaPodesavanjaResponse implements IArhivskaPodesavanjaResponse {
    step01Completed?: boolean;
    step02Completed?: boolean;
    step03Completed?: boolean;
    kategorijeAutoGenerated?: boolean | undefined;

    constructor(data?: IArhivskaPodesavanjaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.step01Completed = _data["step01Completed"];
            this.step02Completed = _data["step02Completed"];
            this.step03Completed = _data["step03Completed"];
            this.kategorijeAutoGenerated = _data["kategorijeAutoGenerated"];
        }
    }

    static fromJS(data: any): ArhivskaPodesavanjaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ArhivskaPodesavanjaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step01Completed"] = this.step01Completed;
        data["step02Completed"] = this.step02Completed;
        data["step03Completed"] = this.step03Completed;
        data["kategorijeAutoGenerated"] = this.kategorijeAutoGenerated;
        return data;
    }
}

export interface IArhivskaPodesavanjaResponse {
    step01Completed?: boolean;
    step02Completed?: boolean;
    step03Completed?: boolean;
    kategorijeAutoGenerated?: boolean | undefined;
}

export class ResultOfOpstaPravilaArhivskaDto extends Result implements IResultOfOpstaPravilaArhivskaDto {
    data?: OpstaPravilaArhivskaDto | undefined;

    constructor(data?: IResultOfOpstaPravilaArhivskaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? OpstaPravilaArhivskaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfOpstaPravilaArhivskaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfOpstaPravilaArhivskaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfOpstaPravilaArhivskaDto extends IResult {
    data?: OpstaPravilaArhivskaDto | undefined;
}

export class OpstaPravilaArhivskaDto implements IOpstaPravilaArhivskaDto {
    brojSaglasnosti?: string | undefined;

    constructor(data?: IOpstaPravilaArhivskaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brojSaglasnosti = _data["brojSaglasnosti"];
        }
    }

    static fromJS(data: any): OpstaPravilaArhivskaDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpstaPravilaArhivskaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brojSaglasnosti"] = this.brojSaglasnosti;
        return data;
    }
}

export interface IOpstaPravilaArhivskaDto {
    brojSaglasnosti?: string | undefined;
}

export class ResultOfPodesavanjaArhivskeDokumentacijeDto extends Result implements IResultOfPodesavanjaArhivskeDokumentacijeDto {
    data?: PodesavanjaArhivskeDokumentacijeDto | undefined;

    constructor(data?: IResultOfPodesavanjaArhivskeDokumentacijeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PodesavanjaArhivskeDokumentacijeDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfPodesavanjaArhivskeDokumentacijeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfPodesavanjaArhivskeDokumentacijeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfPodesavanjaArhivskeDokumentacijeDto extends IResult {
    data?: PodesavanjaArhivskeDokumentacijeDto | undefined;
}

export class PodesavanjaArhivskeDokumentacijeDto implements IPodesavanjaArhivskeDokumentacijeDto {
    arhiv?: string | undefined;
    postanskiBrojArhiva?: string | undefined;
    adresaArhiva?: string | undefined;
    gradArhiva?: string | undefined;
    kontaktOsoba?: string | undefined;
    mail?: string | undefined;
    brojTelefona?: string | undefined;
    jeCirilica?: boolean;

    constructor(data?: IPodesavanjaArhivskeDokumentacijeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arhiv = _data["arhiv"];
            this.postanskiBrojArhiva = _data["postanskiBrojArhiva"];
            this.adresaArhiva = _data["adresaArhiva"];
            this.gradArhiva = _data["gradArhiva"];
            this.kontaktOsoba = _data["kontaktOsoba"];
            this.mail = _data["mail"];
            this.brojTelefona = _data["brojTelefona"];
            this.jeCirilica = _data["jeCirilica"];
        }
    }

    static fromJS(data: any): PodesavanjaArhivskeDokumentacijeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PodesavanjaArhivskeDokumentacijeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arhiv"] = this.arhiv;
        data["postanskiBrojArhiva"] = this.postanskiBrojArhiva;
        data["adresaArhiva"] = this.adresaArhiva;
        data["gradArhiva"] = this.gradArhiva;
        data["kontaktOsoba"] = this.kontaktOsoba;
        data["mail"] = this.mail;
        data["brojTelefona"] = this.brojTelefona;
        data["jeCirilica"] = this.jeCirilica;
        return data;
    }
}

export interface IPodesavanjaArhivskeDokumentacijeDto {
    arhiv?: string | undefined;
    postanskiBrojArhiva?: string | undefined;
    adresaArhiva?: string | undefined;
    gradArhiva?: string | undefined;
    kontaktOsoba?: string | undefined;
    mail?: string | undefined;
    brojTelefona?: string | undefined;
    jeCirilica?: boolean;
}

export class UpdateArhivskaPodesavanjaCommand implements IUpdateArhivskaPodesavanjaCommand {
    arhivskaExisted?: boolean | undefined;
    step01?: boolean;
    step02?: boolean;
    step03?: boolean;
    kategorijaAutomatskiCreated?: boolean | undefined;

    constructor(data?: IUpdateArhivskaPodesavanjaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arhivskaExisted = _data["arhivskaExisted"];
            this.step01 = _data["step01"];
            this.step02 = _data["step02"];
            this.step03 = _data["step03"];
            this.kategorijaAutomatskiCreated = _data["kategorijaAutomatskiCreated"];
        }
    }

    static fromJS(data: any): UpdateArhivskaPodesavanjaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateArhivskaPodesavanjaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arhivskaExisted"] = this.arhivskaExisted;
        data["step01"] = this.step01;
        data["step02"] = this.step02;
        data["step03"] = this.step03;
        data["kategorijaAutomatskiCreated"] = this.kategorijaAutomatskiCreated;
        return data;
    }
}

export interface IUpdateArhivskaPodesavanjaCommand {
    arhivskaExisted?: boolean | undefined;
    step01?: boolean;
    step02?: boolean;
    step03?: boolean;
    kategorijaAutomatskiCreated?: boolean | undefined;
}

export class UpdateOpstaPravilaArhivskaCommand extends OpstaPravilaArhivskaDto implements IUpdateOpstaPravilaArhivskaCommand {

    constructor(data?: IUpdateOpstaPravilaArhivskaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateOpstaPravilaArhivskaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOpstaPravilaArhivskaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateOpstaPravilaArhivskaCommand extends IOpstaPravilaArhivskaDto {
}

export class UpdatePodesavanjaArhivskeDokumentacijeCommand extends PodesavanjaArhivskeDokumentacijeDto implements IUpdatePodesavanjaArhivskeDokumentacijeCommand {

    constructor(data?: IUpdatePodesavanjaArhivskeDokumentacijeCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdatePodesavanjaArhivskeDokumentacijeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePodesavanjaArhivskeDokumentacijeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePodesavanjaArhivskeDokumentacijeCommand extends IPodesavanjaArhivskeDokumentacijeDto {
}

export class ResultOfIEnumerableOfString extends Result implements IResultOfIEnumerableOfString {
    data?: string[] | undefined;

    constructor(data?: IResultOfIEnumerableOfString) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
        }
    }

    static fromJS(data: any): ResultOfIEnumerableOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfIEnumerableOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfIEnumerableOfString extends IResult {
    data?: string[] | undefined;
}

export class ResultOfGrupeKategorijaDropdownResponse extends Result implements IResultOfGrupeKategorijaDropdownResponse {
    data?: GrupeKategorijaDropdownResponse | undefined;

    constructor(data?: IResultOfGrupeKategorijaDropdownResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GrupeKategorijaDropdownResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGrupeKategorijaDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGrupeKategorijaDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGrupeKategorijaDropdownResponse extends IResult {
    data?: GrupeKategorijaDropdownResponse | undefined;
}

export class GrupeKategorijaDropdownResponse implements IGrupeKategorijaDropdownResponse {
    kategorijeList?: GrupaKategorijaDto[] | undefined;

    constructor(data?: IGrupeKategorijaDropdownResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["kategorijeList"])) {
                this.kategorijeList = [] as any;
                for (let item of _data["kategorijeList"])
                    this.kategorijeList!.push(GrupaKategorijaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GrupeKategorijaDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GrupeKategorijaDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.kategorijeList)) {
            data["kategorijeList"] = [];
            for (let item of this.kategorijeList)
                data["kategorijeList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGrupeKategorijaDropdownResponse {
    kategorijeList?: GrupaKategorijaDto[] | undefined;
}

export class ResultOfKategorijeDropdownResponse extends Result implements IResultOfKategorijeDropdownResponse {
    data?: KategorijeDropdownResponse | undefined;

    constructor(data?: IResultOfKategorijeDropdownResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? KategorijeDropdownResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfKategorijeDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfKategorijeDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfKategorijeDropdownResponse extends IResult {
    data?: KategorijeDropdownResponse | undefined;
}

export class KategorijeDropdownResponse implements IKategorijeDropdownResponse {
    kategorijeDropdown?: KategorijaDokMaterijalaDto[] | undefined;

    constructor(data?: IKategorijeDropdownResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["kategorijeDropdown"])) {
                this.kategorijeDropdown = [] as any;
                for (let item of _data["kategorijeDropdown"])
                    this.kategorijeDropdown!.push(KategorijaDokMaterijalaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KategorijeDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KategorijeDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.kategorijeDropdown)) {
            data["kategorijeDropdown"] = [];
            for (let item of this.kategorijeDropdown)
                data["kategorijeDropdown"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKategorijeDropdownResponse {
    kategorijeDropdown?: KategorijaDokMaterijalaDto[] | undefined;
}

export class GetKategorijeDropdownQuery implements IGetKategorijeDropdownQuery {
    naziv?: string | undefined;

    constructor(data?: IGetKategorijeDropdownQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): GetKategorijeDropdownQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetKategorijeDropdownQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IGetKategorijeDropdownQuery {
    naziv?: string | undefined;
}

export class ResultOfSkladisneJediniceDropdownResponse extends Result implements IResultOfSkladisneJediniceDropdownResponse {
    data?: SkladisneJediniceDropdownResponse | undefined;

    constructor(data?: IResultOfSkladisneJediniceDropdownResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? SkladisneJediniceDropdownResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfSkladisneJediniceDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfSkladisneJediniceDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfSkladisneJediniceDropdownResponse extends IResult {
    data?: SkladisneJediniceDropdownResponse | undefined;
}

export class SkladisneJediniceDropdownResponse implements ISkladisneJediniceDropdownResponse {
    skladisneJediniceDropdown?: SkladisnaJedinicaDto[] | undefined;

    constructor(data?: ISkladisneJediniceDropdownResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["skladisneJediniceDropdown"])) {
                this.skladisneJediniceDropdown = [] as any;
                for (let item of _data["skladisneJediniceDropdown"])
                    this.skladisneJediniceDropdown!.push(SkladisnaJedinicaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SkladisneJediniceDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SkladisneJediniceDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.skladisneJediniceDropdown)) {
            data["skladisneJediniceDropdown"] = [];
            for (let item of this.skladisneJediniceDropdown)
                data["skladisneJediniceDropdown"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISkladisneJediniceDropdownResponse {
    skladisneJediniceDropdown?: SkladisnaJedinicaDto[] | undefined;
}

export class GetSkladisneJediniceDropdownQuery implements IGetSkladisneJediniceDropdownQuery {
    naziv?: string | undefined;

    constructor(data?: IGetSkladisneJediniceDropdownQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): GetSkladisneJediniceDropdownQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSkladisneJediniceDropdownQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IGetSkladisneJediniceDropdownQuery {
    naziv?: string | undefined;
}

export class ResultOfArhivskaKnjigaTableItemDto extends Result implements IResultOfArhivskaKnjigaTableItemDto {
    data?: ArhivskaKnjigaTableItemDto | undefined;

    constructor(data?: IResultOfArhivskaKnjigaTableItemDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? ArhivskaKnjigaTableItemDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfArhivskaKnjigaTableItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfArhivskaKnjigaTableItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfArhivskaKnjigaTableItemDto extends IResult {
    data?: ArhivskaKnjigaTableItemDto | undefined;
}

export class ArhivskaKnjigaTableItemDto implements IArhivskaKnjigaTableItemDto {
    id?: number | undefined;
    redniBroj?: number;
    datumUpisa?: string | undefined;
    godinaNastanka?: string | undefined;
    sadrzaj?: string | undefined;
    kolicinaDokumentarnogMaterijala?: number;
    rokCuvanja?: string | undefined;
    isLocked?: boolean | undefined;
    fizickaLokacija?: string | undefined;

    constructor(data?: IArhivskaKnjigaTableItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.redniBroj = _data["redniBroj"];
            this.datumUpisa = _data["datumUpisa"];
            this.godinaNastanka = _data["godinaNastanka"];
            this.sadrzaj = _data["sadrzaj"];
            this.kolicinaDokumentarnogMaterijala = _data["kolicinaDokumentarnogMaterijala"];
            this.rokCuvanja = _data["rokCuvanja"];
            this.isLocked = _data["isLocked"];
            this.fizickaLokacija = _data["fizickaLokacija"];
        }
    }

    static fromJS(data: any): ArhivskaKnjigaTableItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArhivskaKnjigaTableItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["redniBroj"] = this.redniBroj;
        data["datumUpisa"] = this.datumUpisa;
        data["godinaNastanka"] = this.godinaNastanka;
        data["sadrzaj"] = this.sadrzaj;
        data["kolicinaDokumentarnogMaterijala"] = this.kolicinaDokumentarnogMaterijala;
        data["rokCuvanja"] = this.rokCuvanja;
        data["isLocked"] = this.isLocked;
        data["fizickaLokacija"] = this.fizickaLokacija;
        return data;
    }
}

export interface IArhivskaKnjigaTableItemDto {
    id?: number | undefined;
    redniBroj?: number;
    datumUpisa?: string | undefined;
    godinaNastanka?: string | undefined;
    sadrzaj?: string | undefined;
    kolicinaDokumentarnogMaterijala?: number;
    rokCuvanja?: string | undefined;
    isLocked?: boolean | undefined;
    fizickaLokacija?: string | undefined;
}

export class CreateArhivskaKnjigaCommand implements ICreateArhivskaKnjigaCommand {
    id?: number | undefined;
    redniBroj?: number;
    datumUpisa?: Date;
    godinaNastanka?: string | undefined;
    godinaNastankaDo?: string | undefined;
    brojSaglasnosti?: string | undefined;
    klasifikacionaOzanka?: string | undefined;
    sadrzaj?: string | undefined;
    rokCuvanja?: number;
    brojZapisnika?: string | undefined;
    kategorijaDokMaterijalaId?: number;
    kolicinaDokumentarnogMaterijala?: number;
    skladisnaJedinicaDto?: SkladisnaJedinicaDto | undefined;
    fizickaLokacijaDto?: FizickaLokacijaAutocompleteItem | undefined;
    kategorijaDto?: KategorijaDokMaterijalaDto | undefined;
    primedba?: string | undefined;
    fizickaLokacijaRoute?: string | undefined;

    constructor(data?: ICreateArhivskaKnjigaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.redniBroj = _data["redniBroj"];
            this.datumUpisa = _data["datumUpisa"] ? new Date(_data["datumUpisa"].toString()) : <any>undefined;
            this.godinaNastanka = _data["godinaNastanka"];
            this.godinaNastankaDo = _data["godinaNastankaDo"];
            this.brojSaglasnosti = _data["brojSaglasnosti"];
            this.klasifikacionaOzanka = _data["klasifikacionaOzanka"];
            this.sadrzaj = _data["sadrzaj"];
            this.rokCuvanja = _data["rokCuvanja"];
            this.brojZapisnika = _data["brojZapisnika"];
            this.kategorijaDokMaterijalaId = _data["kategorijaDokMaterijalaId"];
            this.kolicinaDokumentarnogMaterijala = _data["kolicinaDokumentarnogMaterijala"];
            this.skladisnaJedinicaDto = _data["skladisnaJedinicaDto"] ? SkladisnaJedinicaDto.fromJS(_data["skladisnaJedinicaDto"]) : <any>undefined;
            this.fizickaLokacijaDto = _data["fizickaLokacijaDto"] ? FizickaLokacijaAutocompleteItem.fromJS(_data["fizickaLokacijaDto"]) : <any>undefined;
            this.kategorijaDto = _data["kategorijaDto"] ? KategorijaDokMaterijalaDto.fromJS(_data["kategorijaDto"]) : <any>undefined;
            this.primedba = _data["primedba"];
            this.fizickaLokacijaRoute = _data["fizickaLokacijaRoute"];
        }
    }

    static fromJS(data: any): CreateArhivskaKnjigaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateArhivskaKnjigaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["redniBroj"] = this.redniBroj;
        data["datumUpisa"] = this.datumUpisa ? this.datumUpisa.toISOString() : <any>undefined;
        data["godinaNastanka"] = this.godinaNastanka;
        data["godinaNastankaDo"] = this.godinaNastankaDo;
        data["brojSaglasnosti"] = this.brojSaglasnosti;
        data["klasifikacionaOzanka"] = this.klasifikacionaOzanka;
        data["sadrzaj"] = this.sadrzaj;
        data["rokCuvanja"] = this.rokCuvanja;
        data["brojZapisnika"] = this.brojZapisnika;
        data["kategorijaDokMaterijalaId"] = this.kategorijaDokMaterijalaId;
        data["kolicinaDokumentarnogMaterijala"] = this.kolicinaDokumentarnogMaterijala;
        data["skladisnaJedinicaDto"] = this.skladisnaJedinicaDto ? this.skladisnaJedinicaDto.toJSON() : <any>undefined;
        data["fizickaLokacijaDto"] = this.fizickaLokacijaDto ? this.fizickaLokacijaDto.toJSON() : <any>undefined;
        data["kategorijaDto"] = this.kategorijaDto ? this.kategorijaDto.toJSON() : <any>undefined;
        data["primedba"] = this.primedba;
        data["fizickaLokacijaRoute"] = this.fizickaLokacijaRoute;
        return data;
    }
}

export interface ICreateArhivskaKnjigaCommand {
    id?: number | undefined;
    redniBroj?: number;
    datumUpisa?: Date;
    godinaNastanka?: string | undefined;
    godinaNastankaDo?: string | undefined;
    brojSaglasnosti?: string | undefined;
    klasifikacionaOzanka?: string | undefined;
    sadrzaj?: string | undefined;
    rokCuvanja?: number;
    brojZapisnika?: string | undefined;
    kategorijaDokMaterijalaId?: number;
    kolicinaDokumentarnogMaterijala?: number;
    skladisnaJedinicaDto?: SkladisnaJedinicaDto | undefined;
    fizickaLokacijaDto?: FizickaLokacijaAutocompleteItem | undefined;
    kategorijaDto?: KategorijaDokMaterijalaDto | undefined;
    primedba?: string | undefined;
    fizickaLokacijaRoute?: string | undefined;
}

export class ResultOfArhivskaKnjigaDto extends Result implements IResultOfArhivskaKnjigaDto {
    data?: ArhivskaKnjigaDto | undefined;

    constructor(data?: IResultOfArhivskaKnjigaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? ArhivskaKnjigaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfArhivskaKnjigaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfArhivskaKnjigaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfArhivskaKnjigaDto extends IResult {
    data?: ArhivskaKnjigaDto | undefined;
}

export class ArhivskaKnjigaDto implements IArhivskaKnjigaDto {
    id?: number | undefined;
    redniBroj?: number;
    datumUpisa?: Date;
    godinaNastanka?: string | undefined;
    godinaNastankaDo?: string | undefined;
    brojSaglasnosti?: string | undefined;
    klasifikacionaOzanka?: string | undefined;
    rokCuvanja?: number;
    sadrzaj?: string | undefined;
    kategorijaDokMaterijalaId?: number;
    brojZapisnika?: string | undefined;
    kolicinaDokumentarnogMaterijala?: number;
    skladisnaJedinicaDto?: SkladisnaJedinicaDto | undefined;
    fizickaLokacijaDto?: FizickaLokacijaAutocompleteItem | undefined;
    kategorijaDto?: KategorijaDokMaterijalaDto | undefined;
    primedba?: string | undefined;
    fizickaLokacijaRoute?: string | undefined;

    constructor(data?: IArhivskaKnjigaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.redniBroj = _data["redniBroj"];
            this.datumUpisa = _data["datumUpisa"] ? new Date(_data["datumUpisa"].toString()) : <any>undefined;
            this.godinaNastanka = _data["godinaNastanka"];
            this.godinaNastankaDo = _data["godinaNastankaDo"];
            this.brojSaglasnosti = _data["brojSaglasnosti"];
            this.klasifikacionaOzanka = _data["klasifikacionaOzanka"];
            this.rokCuvanja = _data["rokCuvanja"];
            this.sadrzaj = _data["sadrzaj"];
            this.kategorijaDokMaterijalaId = _data["kategorijaDokMaterijalaId"];
            this.brojZapisnika = _data["brojZapisnika"];
            this.kolicinaDokumentarnogMaterijala = _data["kolicinaDokumentarnogMaterijala"];
            this.skladisnaJedinicaDto = _data["skladisnaJedinicaDto"] ? SkladisnaJedinicaDto.fromJS(_data["skladisnaJedinicaDto"]) : <any>undefined;
            this.fizickaLokacijaDto = _data["fizickaLokacijaDto"] ? FizickaLokacijaAutocompleteItem.fromJS(_data["fizickaLokacijaDto"]) : <any>undefined;
            this.kategorijaDto = _data["kategorijaDto"] ? KategorijaDokMaterijalaDto.fromJS(_data["kategorijaDto"]) : <any>undefined;
            this.primedba = _data["primedba"];
            this.fizickaLokacijaRoute = _data["fizickaLokacijaRoute"];
        }
    }

    static fromJS(data: any): ArhivskaKnjigaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArhivskaKnjigaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["redniBroj"] = this.redniBroj;
        data["datumUpisa"] = this.datumUpisa ? this.datumUpisa.toISOString() : <any>undefined;
        data["godinaNastanka"] = this.godinaNastanka;
        data["godinaNastankaDo"] = this.godinaNastankaDo;
        data["brojSaglasnosti"] = this.brojSaglasnosti;
        data["klasifikacionaOzanka"] = this.klasifikacionaOzanka;
        data["rokCuvanja"] = this.rokCuvanja;
        data["sadrzaj"] = this.sadrzaj;
        data["kategorijaDokMaterijalaId"] = this.kategorijaDokMaterijalaId;
        data["brojZapisnika"] = this.brojZapisnika;
        data["kolicinaDokumentarnogMaterijala"] = this.kolicinaDokumentarnogMaterijala;
        data["skladisnaJedinicaDto"] = this.skladisnaJedinicaDto ? this.skladisnaJedinicaDto.toJSON() : <any>undefined;
        data["fizickaLokacijaDto"] = this.fizickaLokacijaDto ? this.fizickaLokacijaDto.toJSON() : <any>undefined;
        data["kategorijaDto"] = this.kategorijaDto ? this.kategorijaDto.toJSON() : <any>undefined;
        data["primedba"] = this.primedba;
        data["fizickaLokacijaRoute"] = this.fizickaLokacijaRoute;
        return data;
    }
}

export interface IArhivskaKnjigaDto {
    id?: number | undefined;
    redniBroj?: number;
    datumUpisa?: Date;
    godinaNastanka?: string | undefined;
    godinaNastankaDo?: string | undefined;
    brojSaglasnosti?: string | undefined;
    klasifikacionaOzanka?: string | undefined;
    rokCuvanja?: number;
    sadrzaj?: string | undefined;
    kategorijaDokMaterijalaId?: number;
    brojZapisnika?: string | undefined;
    kolicinaDokumentarnogMaterijala?: number;
    skladisnaJedinicaDto?: SkladisnaJedinicaDto | undefined;
    fizickaLokacijaDto?: FizickaLokacijaAutocompleteItem | undefined;
    kategorijaDto?: KategorijaDokMaterijalaDto | undefined;
    primedba?: string | undefined;
    fizickaLokacijaRoute?: string | undefined;
}

export class PaginatedResultOfArhivskaKnjigaTableItemDto extends Result implements IPaginatedResultOfArhivskaKnjigaTableItemDto {
    data?: ArhivskaKnjigaTableItemDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfArhivskaKnjigaTableItemDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ArhivskaKnjigaTableItemDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfArhivskaKnjigaTableItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfArhivskaKnjigaTableItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfArhivskaKnjigaTableItemDto extends IResult {
    data?: ArhivskaKnjigaTableItemDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class FilterChipDto implements IFilterChipDto {
    key?: string | undefined;
    value?: string | undefined;
    defaultValue?: any | undefined;

    constructor(data?: IFilterChipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.defaultValue = _data["defaultValue"];
        }
    }

    static fromJS(data: any): FilterChipDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterChipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["defaultValue"] = this.defaultValue;
        return data;
    }
}

export interface IFilterChipDto {
    key?: string | undefined;
    value?: string | undefined;
    defaultValue?: any | undefined;
}

export class GetArhivskaKnjigaTableQuery implements IGetArhivskaKnjigaTableQuery {
    godinaNastanka?: number | undefined;
    datumUpisaOd?: Date | undefined;
    datumUpisaDo?: Date | undefined;
    sadrzaj?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    redniBrojSortOrder?: number | undefined;

    constructor(data?: IGetArhivskaKnjigaTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.godinaNastanka = _data["godinaNastanka"];
            this.datumUpisaOd = _data["datumUpisaOd"] ? new Date(_data["datumUpisaOd"].toString()) : <any>undefined;
            this.datumUpisaDo = _data["datumUpisaDo"] ? new Date(_data["datumUpisaDo"].toString()) : <any>undefined;
            this.sadrzaj = _data["sadrzaj"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.redniBrojSortOrder = _data["redniBrojSortOrder"];
        }
    }

    static fromJS(data: any): GetArhivskaKnjigaTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetArhivskaKnjigaTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["godinaNastanka"] = this.godinaNastanka;
        data["datumUpisaOd"] = this.datumUpisaOd ? this.datumUpisaOd.toISOString() : <any>undefined;
        data["datumUpisaDo"] = this.datumUpisaDo ? this.datumUpisaDo.toISOString() : <any>undefined;
        data["sadrzaj"] = this.sadrzaj;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["redniBrojSortOrder"] = this.redniBrojSortOrder;
        return data;
    }
}

export interface IGetArhivskaKnjigaTableQuery {
    godinaNastanka?: number | undefined;
    datumUpisaOd?: Date | undefined;
    datumUpisaDo?: Date | undefined;
    sadrzaj?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    redniBrojSortOrder?: number | undefined;
}

export class PaginatedResultOfKategorijaTableDto extends Result implements IPaginatedResultOfKategorijaTableDto {
    data?: KategorijaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfKategorijaTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(KategorijaTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfKategorijaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfKategorijaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfKategorijaTableDto extends IResult {
    data?: KategorijaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class KategorijaTableDto implements IKategorijaTableDto {
    id?: number;
    naziv?: string | undefined;
    rokCuvanja?: number;
    nazivGrupe?: string | undefined;
    imaPovezaneUpise?: boolean;

    constructor(data?: IKategorijaTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.rokCuvanja = _data["rokCuvanja"];
            this.nazivGrupe = _data["nazivGrupe"];
            this.imaPovezaneUpise = _data["imaPovezaneUpise"];
        }
    }

    static fromJS(data: any): KategorijaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new KategorijaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["rokCuvanja"] = this.rokCuvanja;
        data["nazivGrupe"] = this.nazivGrupe;
        data["imaPovezaneUpise"] = this.imaPovezaneUpise;
        return data;
    }
}

export interface IKategorijaTableDto {
    id?: number;
    naziv?: string | undefined;
    rokCuvanja?: number;
    nazivGrupe?: string | undefined;
    imaPovezaneUpise?: boolean;
}

export class GetKategorijeDokumentarnogMaterijalaQuery implements IGetKategorijeDokumentarnogMaterijalaQuery {
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetKategorijeDokumentarnogMaterijalaQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetKategorijeDokumentarnogMaterijalaQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetKategorijeDokumentarnogMaterijalaQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetKategorijeDokumentarnogMaterijalaQuery {
    pageNumber?: number;
    pageSize?: number;
}

export class UpdateArhivskaCommand implements IUpdateArhivskaCommand {
    id?: number | undefined;
    redniBroj?: number;
    datumUpisa?: Date;
    godinaNastanka?: string | undefined;
    godinaNastankaDo?: string | undefined;
    brojSaglasnosti?: string | undefined;
    klasifikacionaOzanka?: string | undefined;
    rokCuvanja?: number;
    sadrzaj?: string | undefined;
    kategorijaDokMaterijalaId?: number;
    brojZapisnika?: string | undefined;
    kolicinaDokumentarnogMaterijala?: number;
    skladisnaJedinicaDto?: SkladisnaJedinicaDto | undefined;
    fizickaLokacijaDto?: FizickaLokacijaAutocompleteItem | undefined;
    kategorijaDto?: KategorijaDokMaterijalaDto | undefined;
    primedba?: string | undefined;
    fizickaLokacijaRoute?: string | undefined;

    constructor(data?: IUpdateArhivskaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.redniBroj = _data["redniBroj"];
            this.datumUpisa = _data["datumUpisa"] ? new Date(_data["datumUpisa"].toString()) : <any>undefined;
            this.godinaNastanka = _data["godinaNastanka"];
            this.godinaNastankaDo = _data["godinaNastankaDo"];
            this.brojSaglasnosti = _data["brojSaglasnosti"];
            this.klasifikacionaOzanka = _data["klasifikacionaOzanka"];
            this.rokCuvanja = _data["rokCuvanja"];
            this.sadrzaj = _data["sadrzaj"];
            this.kategorijaDokMaterijalaId = _data["kategorijaDokMaterijalaId"];
            this.brojZapisnika = _data["brojZapisnika"];
            this.kolicinaDokumentarnogMaterijala = _data["kolicinaDokumentarnogMaterijala"];
            this.skladisnaJedinicaDto = _data["skladisnaJedinicaDto"] ? SkladisnaJedinicaDto.fromJS(_data["skladisnaJedinicaDto"]) : <any>undefined;
            this.fizickaLokacijaDto = _data["fizickaLokacijaDto"] ? FizickaLokacijaAutocompleteItem.fromJS(_data["fizickaLokacijaDto"]) : <any>undefined;
            this.kategorijaDto = _data["kategorijaDto"] ? KategorijaDokMaterijalaDto.fromJS(_data["kategorijaDto"]) : <any>undefined;
            this.primedba = _data["primedba"];
            this.fizickaLokacijaRoute = _data["fizickaLokacijaRoute"];
        }
    }

    static fromJS(data: any): UpdateArhivskaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateArhivskaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["redniBroj"] = this.redniBroj;
        data["datumUpisa"] = this.datumUpisa ? this.datumUpisa.toISOString() : <any>undefined;
        data["godinaNastanka"] = this.godinaNastanka;
        data["godinaNastankaDo"] = this.godinaNastankaDo;
        data["brojSaglasnosti"] = this.brojSaglasnosti;
        data["klasifikacionaOzanka"] = this.klasifikacionaOzanka;
        data["rokCuvanja"] = this.rokCuvanja;
        data["sadrzaj"] = this.sadrzaj;
        data["kategorijaDokMaterijalaId"] = this.kategorijaDokMaterijalaId;
        data["brojZapisnika"] = this.brojZapisnika;
        data["kolicinaDokumentarnogMaterijala"] = this.kolicinaDokumentarnogMaterijala;
        data["skladisnaJedinicaDto"] = this.skladisnaJedinicaDto ? this.skladisnaJedinicaDto.toJSON() : <any>undefined;
        data["fizickaLokacijaDto"] = this.fizickaLokacijaDto ? this.fizickaLokacijaDto.toJSON() : <any>undefined;
        data["kategorijaDto"] = this.kategorijaDto ? this.kategorijaDto.toJSON() : <any>undefined;
        data["primedba"] = this.primedba;
        data["fizickaLokacijaRoute"] = this.fizickaLokacijaRoute;
        return data;
    }
}

export interface IUpdateArhivskaCommand {
    id?: number | undefined;
    redniBroj?: number;
    datumUpisa?: Date;
    godinaNastanka?: string | undefined;
    godinaNastankaDo?: string | undefined;
    brojSaglasnosti?: string | undefined;
    klasifikacionaOzanka?: string | undefined;
    rokCuvanja?: number;
    sadrzaj?: string | undefined;
    kategorijaDokMaterijalaId?: number;
    brojZapisnika?: string | undefined;
    kolicinaDokumentarnogMaterijala?: number;
    skladisnaJedinicaDto?: SkladisnaJedinicaDto | undefined;
    fizickaLokacijaDto?: FizickaLokacijaAutocompleteItem | undefined;
    kategorijaDto?: KategorijaDokMaterijalaDto | undefined;
    primedba?: string | undefined;
    fizickaLokacijaRoute?: string | undefined;
}

export class GetArhivskaTablePdfQuery implements IGetArhivskaTablePdfQuery {
    redniBrojOd?: number;
    redniBrojDo?: number;
    godinaDokumenta?: string | undefined;
    rokCuvanjaJedinica?: RokCuvanjaJedinica;
    redniBrojSortOrder?: number | undefined;

    constructor(data?: IGetArhivskaTablePdfQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redniBrojOd = _data["redniBrojOd"];
            this.redniBrojDo = _data["redniBrojDo"];
            this.godinaDokumenta = _data["godinaDokumenta"];
            this.rokCuvanjaJedinica = _data["rokCuvanjaJedinica"];
            this.redniBrojSortOrder = _data["redniBrojSortOrder"];
        }
    }

    static fromJS(data: any): GetArhivskaTablePdfQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetArhivskaTablePdfQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redniBrojOd"] = this.redniBrojOd;
        data["redniBrojDo"] = this.redniBrojDo;
        data["godinaDokumenta"] = this.godinaDokumenta;
        data["rokCuvanjaJedinica"] = this.rokCuvanjaJedinica;
        data["redniBrojSortOrder"] = this.redniBrojSortOrder;
        return data;
    }
}

export interface IGetArhivskaTablePdfQuery {
    redniBrojOd?: number;
    redniBrojDo?: number;
    godinaDokumenta?: string | undefined;
    rokCuvanjaJedinica?: RokCuvanjaJedinica;
    redniBrojSortOrder?: number | undefined;
}

export enum RokCuvanjaJedinica {
    MESECI = 0,
    GODINE = 1,
}

export class ResultOfArhivskaTableResponse extends Result implements IResultOfArhivskaTableResponse {
    data?: ArhivskaTableResponse | undefined;

    constructor(data?: IResultOfArhivskaTableResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? ArhivskaTableResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfArhivskaTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfArhivskaTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfArhivskaTableResponse extends IResult {
    data?: ArhivskaTableResponse | undefined;
}

export class ArhivskaTableResponse implements IArhivskaTableResponse {
    arhivskaTableList?: ArhivskaKnjigaTableItemDto[] | undefined;

    constructor(data?: IArhivskaTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["arhivskaTableList"])) {
                this.arhivskaTableList = [] as any;
                for (let item of _data["arhivskaTableList"])
                    this.arhivskaTableList!.push(ArhivskaKnjigaTableItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArhivskaTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ArhivskaTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.arhivskaTableList)) {
            data["arhivskaTableList"] = [];
            for (let item of this.arhivskaTableList)
                data["arhivskaTableList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IArhivskaTableResponse {
    arhivskaTableList?: ArhivskaKnjigaTableItemDto[] | undefined;
}

export class UnlockArhivskaEditCommand implements IUnlockArhivskaEditCommand {
    arhivskeIds?: number[] | undefined;

    constructor(data?: IUnlockArhivskaEditCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["arhivskeIds"])) {
                this.arhivskeIds = [] as any;
                for (let item of _data["arhivskeIds"])
                    this.arhivskeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UnlockArhivskaEditCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UnlockArhivskaEditCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.arhivskeIds)) {
            data["arhivskeIds"] = [];
            for (let item of this.arhivskeIds)
                data["arhivskeIds"].push(item);
        }
        return data;
    }
}

export interface IUnlockArhivskaEditCommand {
    arhivskeIds?: number[] | undefined;
}

export class ResultOfInteger extends Result implements IResultOfInteger {
    data?: number;

    constructor(data?: IResultOfInteger) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ResultOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfInteger extends IResult {
    data?: number;
}

export class ResultOfCreateUpdateRacunResponse extends Result implements IResultOfCreateUpdateRacunResponse {
    data?: CreateUpdateRacunResponse | undefined;

    constructor(data?: IResultOfCreateUpdateRacunResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? CreateUpdateRacunResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfCreateUpdateRacunResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfCreateUpdateRacunResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfCreateUpdateRacunResponse extends IResult {
    data?: CreateUpdateRacunResponse | undefined;
}

export class CreateUpdateRacunResponse implements ICreateUpdateRacunResponse {
    id?: number;
    broj?: string | undefined;

    constructor(data?: ICreateUpdateRacunResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
        }
    }

    static fromJS(data: any): CreateUpdateRacunResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateRacunResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        return data;
    }
}

export interface ICreateUpdateRacunResponse {
    id?: number;
    broj?: string | undefined;
}

export class CreateAvansniRacunCommand implements ICreateAvansniRacunCommand {
    racunDto?: RacunDto | undefined;
    preostaloPdv8?: number | undefined;
    preostaloPdv10?: number | undefined;
    preostaloPdv20?: number | undefined;
    preostaloUkupnoOsnovica8?: number | undefined;
    preostaloUkupnoOsnovica10?: number | undefined;
    preostaloUkupnoOsnovica20?: number | undefined;
    preostaloUkupnoOsnovicaAE10?: number | undefined;
    preostaloUkupnoOsnovicaAE20?: number | undefined;
    preostaloUkupnoOsnovicaO?: number | undefined;
    preostaloUkupnoOsnovicaE?: number | undefined;
    preostaloUkupnoOsnovicaR?: number | undefined;
    preostaloUkupnoOsnovicaZ?: number | undefined;
    preostaloUkupnoOsnovicaSS?: number | undefined;
    preostaloUkupnoOsnovicaOE?: number | undefined;
    preostaloUkupnoOsnovicaN?: number | undefined;
    ukupanIznosUplate?: number | undefined;
    predracunIds?: number[] | undefined;
    uplataId?: number | undefined;

    constructor(data?: ICreateAvansniRacunCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.preostaloPdv8 = _data["preostaloPdv8"];
            this.preostaloPdv10 = _data["preostaloPdv10"];
            this.preostaloPdv20 = _data["preostaloPdv20"];
            this.preostaloUkupnoOsnovica8 = _data["preostaloUkupnoOsnovica8"];
            this.preostaloUkupnoOsnovica10 = _data["preostaloUkupnoOsnovica10"];
            this.preostaloUkupnoOsnovica20 = _data["preostaloUkupnoOsnovica20"];
            this.preostaloUkupnoOsnovicaAE10 = _data["preostaloUkupnoOsnovicaAE10"];
            this.preostaloUkupnoOsnovicaAE20 = _data["preostaloUkupnoOsnovicaAE20"];
            this.preostaloUkupnoOsnovicaO = _data["preostaloUkupnoOsnovicaO"];
            this.preostaloUkupnoOsnovicaE = _data["preostaloUkupnoOsnovicaE"];
            this.preostaloUkupnoOsnovicaR = _data["preostaloUkupnoOsnovicaR"];
            this.preostaloUkupnoOsnovicaZ = _data["preostaloUkupnoOsnovicaZ"];
            this.preostaloUkupnoOsnovicaSS = _data["preostaloUkupnoOsnovicaSS"];
            this.preostaloUkupnoOsnovicaOE = _data["preostaloUkupnoOsnovicaOE"];
            this.preostaloUkupnoOsnovicaN = _data["preostaloUkupnoOsnovicaN"];
            this.ukupanIznosUplate = _data["ukupanIznosUplate"];
            if (Array.isArray(_data["predracunIds"])) {
                this.predracunIds = [] as any;
                for (let item of _data["predracunIds"])
                    this.predracunIds!.push(item);
            }
            this.uplataId = _data["uplataId"];
        }
    }

    static fromJS(data: any): CreateAvansniRacunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAvansniRacunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["preostaloPdv8"] = this.preostaloPdv8;
        data["preostaloPdv10"] = this.preostaloPdv10;
        data["preostaloPdv20"] = this.preostaloPdv20;
        data["preostaloUkupnoOsnovica8"] = this.preostaloUkupnoOsnovica8;
        data["preostaloUkupnoOsnovica10"] = this.preostaloUkupnoOsnovica10;
        data["preostaloUkupnoOsnovica20"] = this.preostaloUkupnoOsnovica20;
        data["preostaloUkupnoOsnovicaAE10"] = this.preostaloUkupnoOsnovicaAE10;
        data["preostaloUkupnoOsnovicaAE20"] = this.preostaloUkupnoOsnovicaAE20;
        data["preostaloUkupnoOsnovicaO"] = this.preostaloUkupnoOsnovicaO;
        data["preostaloUkupnoOsnovicaE"] = this.preostaloUkupnoOsnovicaE;
        data["preostaloUkupnoOsnovicaR"] = this.preostaloUkupnoOsnovicaR;
        data["preostaloUkupnoOsnovicaZ"] = this.preostaloUkupnoOsnovicaZ;
        data["preostaloUkupnoOsnovicaSS"] = this.preostaloUkupnoOsnovicaSS;
        data["preostaloUkupnoOsnovicaOE"] = this.preostaloUkupnoOsnovicaOE;
        data["preostaloUkupnoOsnovicaN"] = this.preostaloUkupnoOsnovicaN;
        data["ukupanIznosUplate"] = this.ukupanIznosUplate;
        if (Array.isArray(this.predracunIds)) {
            data["predracunIds"] = [];
            for (let item of this.predracunIds)
                data["predracunIds"].push(item);
        }
        data["uplataId"] = this.uplataId;
        return data;
    }
}

export interface ICreateAvansniRacunCommand {
    racunDto?: RacunDto | undefined;
    preostaloPdv8?: number | undefined;
    preostaloPdv10?: number | undefined;
    preostaloPdv20?: number | undefined;
    preostaloUkupnoOsnovica8?: number | undefined;
    preostaloUkupnoOsnovica10?: number | undefined;
    preostaloUkupnoOsnovica20?: number | undefined;
    preostaloUkupnoOsnovicaAE10?: number | undefined;
    preostaloUkupnoOsnovicaAE20?: number | undefined;
    preostaloUkupnoOsnovicaO?: number | undefined;
    preostaloUkupnoOsnovicaE?: number | undefined;
    preostaloUkupnoOsnovicaR?: number | undefined;
    preostaloUkupnoOsnovicaZ?: number | undefined;
    preostaloUkupnoOsnovicaSS?: number | undefined;
    preostaloUkupnoOsnovicaOE?: number | undefined;
    preostaloUkupnoOsnovicaN?: number | undefined;
    ukupanIznosUplate?: number | undefined;
    predracunIds?: number[] | undefined;
    uplataId?: number | undefined;
}

export class RacunDto implements IRacunDto {
    id?: number | undefined;
    izlazniRacunIdSef?: number | undefined;
    ulazniRacunIdSef?: number | undefined;
    broj?: string | undefined;
    originalanBroj?: string | undefined;
    praviloSerijskogBrojaId?: number | undefined;
    prikazRabata?: PrikazRabata;
    paritet?: Paritet;
    koristitiPrethodnuGodinu?: boolean;
    datumIzdavanja?: Date;
    mestoIzdavanja?: string | undefined;
    datumPrometa?: Date;
    mestoPrometa?: string | undefined;
    datumValute?: Date;
    datumSlanje?: Date;
    rokPlacanja?: number;
    valutaId?: string;
    valutaText?: string | undefined;
    uplaceno?: number;
    brojUgovora?: string | undefined;
    brojNarudzbenice?: string | undefined;
    brojTendera?: string | undefined;
    sifraObjekta?: string | undefined;
    podaciUplateDto?: PodaciUplateDto | undefined;
    podaciUplateDevizniDto?: PodaciUplateDevizniDto | undefined;
    napomena?: string | undefined;
    napomenaOPoreskomOslobadanju?: string | undefined;
    tip?: TipRacuna;
    vrsta?: VrstaRacuna;
    status?: StatusRacuna;
    statusUplate?: StatusUplateRacuna;
    tekuciRacunId?: number | undefined;
    memorandumId?: number | undefined;
    podtipDokumenta?: number | undefined;
    datumObracunaPdv?: DatumObracunaPdv;
    strankaRacunaDto?: StrankaRacunaDto | undefined;
    stavkeDto?: StavkaRacunaDto[] | undefined;
    oznakeDto?: OznakaDto[] | undefined;
    transakcijaZaRacunDto?: TransakcijaZaRacunDto | undefined;
    tipEntiteta?: TipEntiteta;
    vezaniRacuniDto?: VezaniRacunDto[] | undefined;
    avansneUplateRacunaTableDto?: AvansnaUplataRacunaTableDto[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    ukupanIznosDto?: RacunUkupanIznosDto | undefined;
    relevantniDokumentListItemDtoArray?: FileAttachment[] | undefined;
    datumNarudzbenice?: Date | undefined;
    brojOtpremnice?: string | undefined;
    datumOtpremnice?: Date | undefined;
    imeOsobeOvlasceneZaPotpisivanje?: string | undefined;
    netoTezina?: number | undefined;
    brojPaleta?: number | undefined;
    brojRamova?: number | undefined;
    brutoTezina?: number | undefined;
    koleto?: number | undefined;
    interniBrojZaRutiranje?: string | undefined;
    potrebnaObrada?: boolean;
    nosiocJavneNabavke?: string | undefined;
    mozeNaSef?: boolean;
    pdvObavezaZaIzdavaoca?: boolean | undefined;
    datumUgovora?: Date | undefined;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
    eOtpremnice?: string[] | undefined;
    ePrijemnice?: string[] | undefined;

    constructor(data?: IRacunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.izlazniRacunIdSef = _data["izlazniRacunIdSef"];
            this.ulazniRacunIdSef = _data["ulazniRacunIdSef"];
            this.broj = _data["broj"];
            this.originalanBroj = _data["originalanBroj"];
            this.praviloSerijskogBrojaId = _data["praviloSerijskogBrojaId"];
            this.prikazRabata = _data["prikazRabata"];
            this.paritet = _data["paritet"];
            this.koristitiPrethodnuGodinu = _data["koristitiPrethodnuGodinu"];
            this.datumIzdavanja = _data["datumIzdavanja"] ? new Date(_data["datumIzdavanja"].toString()) : <any>undefined;
            this.mestoIzdavanja = _data["mestoIzdavanja"];
            this.datumPrometa = _data["datumPrometa"] ? new Date(_data["datumPrometa"].toString()) : <any>undefined;
            this.mestoPrometa = _data["mestoPrometa"];
            this.datumValute = _data["datumValute"] ? new Date(_data["datumValute"].toString()) : <any>undefined;
            this.datumSlanje = _data["datumSlanje"] ? new Date(_data["datumSlanje"].toString()) : <any>undefined;
            this.rokPlacanja = _data["rokPlacanja"];
            this.valutaId = _data["valutaId"];
            this.valutaText = _data["valutaText"];
            this.uplaceno = _data["uplaceno"];
            this.brojUgovora = _data["brojUgovora"];
            this.brojNarudzbenice = _data["brojNarudzbenice"];
            this.brojTendera = _data["brojTendera"];
            this.sifraObjekta = _data["sifraObjekta"];
            this.podaciUplateDto = _data["podaciUplateDto"] ? PodaciUplateDto.fromJS(_data["podaciUplateDto"]) : <any>undefined;
            this.podaciUplateDevizniDto = _data["podaciUplateDevizniDto"] ? PodaciUplateDevizniDto.fromJS(_data["podaciUplateDevizniDto"]) : <any>undefined;
            this.napomena = _data["napomena"];
            this.napomenaOPoreskomOslobadanju = _data["napomenaOPoreskomOslobadanju"];
            this.tip = _data["tip"];
            this.vrsta = _data["vrsta"];
            this.status = _data["status"];
            this.statusUplate = _data["statusUplate"];
            this.tekuciRacunId = _data["tekuciRacunId"];
            this.memorandumId = _data["memorandumId"];
            this.podtipDokumenta = _data["podtipDokumenta"];
            this.datumObracunaPdv = _data["datumObracunaPdv"];
            this.strankaRacunaDto = _data["strankaRacunaDto"] ? StrankaRacunaDto.fromJS(_data["strankaRacunaDto"]) : <any>undefined;
            if (Array.isArray(_data["stavkeDto"])) {
                this.stavkeDto = [] as any;
                for (let item of _data["stavkeDto"])
                    this.stavkeDto!.push(StavkaRacunaDto.fromJS(item));
            }
            if (Array.isArray(_data["oznakeDto"])) {
                this.oznakeDto = [] as any;
                for (let item of _data["oznakeDto"])
                    this.oznakeDto!.push(OznakaDto.fromJS(item));
            }
            this.transakcijaZaRacunDto = _data["transakcijaZaRacunDto"] ? TransakcijaZaRacunDto.fromJS(_data["transakcijaZaRacunDto"]) : <any>undefined;
            this.tipEntiteta = _data["tipEntiteta"];
            if (Array.isArray(_data["vezaniRacuniDto"])) {
                this.vezaniRacuniDto = [] as any;
                for (let item of _data["vezaniRacuniDto"])
                    this.vezaniRacuniDto!.push(VezaniRacunDto.fromJS(item));
            }
            if (Array.isArray(_data["avansneUplateRacunaTableDto"])) {
                this.avansneUplateRacunaTableDto = [] as any;
                for (let item of _data["avansneUplateRacunaTableDto"])
                    this.avansneUplateRacunaTableDto!.push(AvansnaUplataRacunaTableDto.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedOn = _data["lastModifiedOn"] ? new Date(_data["lastModifiedOn"].toString()) : <any>undefined;
            this.ukupanIznosDto = _data["ukupanIznosDto"] ? RacunUkupanIznosDto.fromJS(_data["ukupanIznosDto"]) : <any>undefined;
            if (Array.isArray(_data["relevantniDokumentListItemDtoArray"])) {
                this.relevantniDokumentListItemDtoArray = [] as any;
                for (let item of _data["relevantniDokumentListItemDtoArray"])
                    this.relevantniDokumentListItemDtoArray!.push(FileAttachment.fromJS(item));
            }
            this.datumNarudzbenice = _data["datumNarudzbenice"] ? new Date(_data["datumNarudzbenice"].toString()) : <any>undefined;
            this.brojOtpremnice = _data["brojOtpremnice"];
            this.datumOtpremnice = _data["datumOtpremnice"] ? new Date(_data["datumOtpremnice"].toString()) : <any>undefined;
            this.imeOsobeOvlasceneZaPotpisivanje = _data["imeOsobeOvlasceneZaPotpisivanje"];
            this.netoTezina = _data["netoTezina"];
            this.brojPaleta = _data["brojPaleta"];
            this.brojRamova = _data["brojRamova"];
            this.brutoTezina = _data["brutoTezina"];
            this.koleto = _data["koleto"];
            this.interniBrojZaRutiranje = _data["interniBrojZaRutiranje"];
            this.potrebnaObrada = _data["potrebnaObrada"];
            this.nosiocJavneNabavke = _data["nosiocJavneNabavke"];
            this.mozeNaSef = _data["mozeNaSef"];
            this.pdvObavezaZaIzdavaoca = _data["pdvObavezaZaIzdavaoca"];
            this.datumUgovora = _data["datumUgovora"] ? new Date(_data["datumUgovora"].toString()) : <any>undefined;
            this.klasifikacijaRacuna = _data["klasifikacijaRacuna"];
            this.pravoNaPdvOdbitak = _data["pravoNaPdvOdbitak"];
            if (Array.isArray(_data["eOtpremnice"])) {
                this.eOtpremnice = [] as any;
                for (let item of _data["eOtpremnice"])
                    this.eOtpremnice!.push(item);
            }
            if (Array.isArray(_data["ePrijemnice"])) {
                this.ePrijemnice = [] as any;
                for (let item of _data["ePrijemnice"])
                    this.ePrijemnice!.push(item);
            }
        }
    }

    static fromJS(data: any): RacunDto {
        data = typeof data === 'object' ? data : {};
        let result = new RacunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["izlazniRacunIdSef"] = this.izlazniRacunIdSef;
        data["ulazniRacunIdSef"] = this.ulazniRacunIdSef;
        data["broj"] = this.broj;
        data["originalanBroj"] = this.originalanBroj;
        data["praviloSerijskogBrojaId"] = this.praviloSerijskogBrojaId;
        data["prikazRabata"] = this.prikazRabata;
        data["paritet"] = this.paritet;
        data["koristitiPrethodnuGodinu"] = this.koristitiPrethodnuGodinu;
        data["datumIzdavanja"] = this.datumIzdavanja ? this.datumIzdavanja.toISOString() : <any>undefined;
        data["mestoIzdavanja"] = this.mestoIzdavanja;
        data["datumPrometa"] = this.datumPrometa ? this.datumPrometa.toISOString() : <any>undefined;
        data["mestoPrometa"] = this.mestoPrometa;
        data["datumValute"] = this.datumValute ? this.datumValute.toISOString() : <any>undefined;
        data["datumSlanje"] = this.datumSlanje ? this.datumSlanje.toISOString() : <any>undefined;
        data["rokPlacanja"] = this.rokPlacanja;
        data["valutaId"] = this.valutaId;
        data["valutaText"] = this.valutaText;
        data["uplaceno"] = this.uplaceno;
        data["brojUgovora"] = this.brojUgovora;
        data["brojNarudzbenice"] = this.brojNarudzbenice;
        data["brojTendera"] = this.brojTendera;
        data["sifraObjekta"] = this.sifraObjekta;
        data["podaciUplateDto"] = this.podaciUplateDto ? this.podaciUplateDto.toJSON() : <any>undefined;
        data["podaciUplateDevizniDto"] = this.podaciUplateDevizniDto ? this.podaciUplateDevizniDto.toJSON() : <any>undefined;
        data["napomena"] = this.napomena;
        data["napomenaOPoreskomOslobadanju"] = this.napomenaOPoreskomOslobadanju;
        data["tip"] = this.tip;
        data["vrsta"] = this.vrsta;
        data["status"] = this.status;
        data["statusUplate"] = this.statusUplate;
        data["tekuciRacunId"] = this.tekuciRacunId;
        data["memorandumId"] = this.memorandumId;
        data["podtipDokumenta"] = this.podtipDokumenta;
        data["datumObracunaPdv"] = this.datumObracunaPdv;
        data["strankaRacunaDto"] = this.strankaRacunaDto ? this.strankaRacunaDto.toJSON() : <any>undefined;
        if (Array.isArray(this.stavkeDto)) {
            data["stavkeDto"] = [];
            for (let item of this.stavkeDto)
                data["stavkeDto"].push(item.toJSON());
        }
        if (Array.isArray(this.oznakeDto)) {
            data["oznakeDto"] = [];
            for (let item of this.oznakeDto)
                data["oznakeDto"].push(item.toJSON());
        }
        data["transakcijaZaRacunDto"] = this.transakcijaZaRacunDto ? this.transakcijaZaRacunDto.toJSON() : <any>undefined;
        data["tipEntiteta"] = this.tipEntiteta;
        if (Array.isArray(this.vezaniRacuniDto)) {
            data["vezaniRacuniDto"] = [];
            for (let item of this.vezaniRacuniDto)
                data["vezaniRacuniDto"].push(item.toJSON());
        }
        if (Array.isArray(this.avansneUplateRacunaTableDto)) {
            data["avansneUplateRacunaTableDto"] = [];
            for (let item of this.avansneUplateRacunaTableDto)
                data["avansneUplateRacunaTableDto"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined;
        data["ukupanIznosDto"] = this.ukupanIznosDto ? this.ukupanIznosDto.toJSON() : <any>undefined;
        if (Array.isArray(this.relevantniDokumentListItemDtoArray)) {
            data["relevantniDokumentListItemDtoArray"] = [];
            for (let item of this.relevantniDokumentListItemDtoArray)
                data["relevantniDokumentListItemDtoArray"].push(item.toJSON());
        }
        data["datumNarudzbenice"] = this.datumNarudzbenice ? this.datumNarudzbenice.toISOString() : <any>undefined;
        data["brojOtpremnice"] = this.brojOtpremnice;
        data["datumOtpremnice"] = this.datumOtpremnice ? this.datumOtpremnice.toISOString() : <any>undefined;
        data["imeOsobeOvlasceneZaPotpisivanje"] = this.imeOsobeOvlasceneZaPotpisivanje;
        data["netoTezina"] = this.netoTezina;
        data["brojPaleta"] = this.brojPaleta;
        data["brojRamova"] = this.brojRamova;
        data["brutoTezina"] = this.brutoTezina;
        data["koleto"] = this.koleto;
        data["interniBrojZaRutiranje"] = this.interniBrojZaRutiranje;
        data["potrebnaObrada"] = this.potrebnaObrada;
        data["nosiocJavneNabavke"] = this.nosiocJavneNabavke;
        data["mozeNaSef"] = this.mozeNaSef;
        data["pdvObavezaZaIzdavaoca"] = this.pdvObavezaZaIzdavaoca;
        data["datumUgovora"] = this.datumUgovora ? this.datumUgovora.toISOString() : <any>undefined;
        data["klasifikacijaRacuna"] = this.klasifikacijaRacuna;
        data["pravoNaPdvOdbitak"] = this.pravoNaPdvOdbitak;
        if (Array.isArray(this.eOtpremnice)) {
            data["eOtpremnice"] = [];
            for (let item of this.eOtpremnice)
                data["eOtpremnice"].push(item);
        }
        if (Array.isArray(this.ePrijemnice)) {
            data["ePrijemnice"] = [];
            for (let item of this.ePrijemnice)
                data["ePrijemnice"].push(item);
        }
        return data;
    }
}

export interface IRacunDto {
    id?: number | undefined;
    izlazniRacunIdSef?: number | undefined;
    ulazniRacunIdSef?: number | undefined;
    broj?: string | undefined;
    originalanBroj?: string | undefined;
    praviloSerijskogBrojaId?: number | undefined;
    prikazRabata?: PrikazRabata;
    paritet?: Paritet;
    koristitiPrethodnuGodinu?: boolean;
    datumIzdavanja?: Date;
    mestoIzdavanja?: string | undefined;
    datumPrometa?: Date;
    mestoPrometa?: string | undefined;
    datumValute?: Date;
    datumSlanje?: Date;
    rokPlacanja?: number;
    valutaId?: string;
    valutaText?: string | undefined;
    uplaceno?: number;
    brojUgovora?: string | undefined;
    brojNarudzbenice?: string | undefined;
    brojTendera?: string | undefined;
    sifraObjekta?: string | undefined;
    podaciUplateDto?: PodaciUplateDto | undefined;
    podaciUplateDevizniDto?: PodaciUplateDevizniDto | undefined;
    napomena?: string | undefined;
    napomenaOPoreskomOslobadanju?: string | undefined;
    tip?: TipRacuna;
    vrsta?: VrstaRacuna;
    status?: StatusRacuna;
    statusUplate?: StatusUplateRacuna;
    tekuciRacunId?: number | undefined;
    memorandumId?: number | undefined;
    podtipDokumenta?: number | undefined;
    datumObracunaPdv?: DatumObracunaPdv;
    strankaRacunaDto?: StrankaRacunaDto | undefined;
    stavkeDto?: StavkaRacunaDto[] | undefined;
    oznakeDto?: OznakaDto[] | undefined;
    transakcijaZaRacunDto?: TransakcijaZaRacunDto | undefined;
    tipEntiteta?: TipEntiteta;
    vezaniRacuniDto?: VezaniRacunDto[] | undefined;
    avansneUplateRacunaTableDto?: AvansnaUplataRacunaTableDto[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    ukupanIznosDto?: RacunUkupanIznosDto | undefined;
    relevantniDokumentListItemDtoArray?: FileAttachment[] | undefined;
    datumNarudzbenice?: Date | undefined;
    brojOtpremnice?: string | undefined;
    datumOtpremnice?: Date | undefined;
    imeOsobeOvlasceneZaPotpisivanje?: string | undefined;
    netoTezina?: number | undefined;
    brojPaleta?: number | undefined;
    brojRamova?: number | undefined;
    brutoTezina?: number | undefined;
    koleto?: number | undefined;
    interniBrojZaRutiranje?: string | undefined;
    potrebnaObrada?: boolean;
    nosiocJavneNabavke?: string | undefined;
    mozeNaSef?: boolean;
    pdvObavezaZaIzdavaoca?: boolean | undefined;
    datumUgovora?: Date | undefined;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
    eOtpremnice?: string[] | undefined;
    ePrijemnice?: string[] | undefined;
}

export enum PrikazRabata {
    PROCENAT = 0,
    VREDNOST = 1,
    BEZPOPUSTA = 2,
}

export enum Paritet {
    EMPTY = 0,
    EXW = 1,
    FCA = 2,
    FAS = 3,
    FOB = 4,
    CFR = 5,
    CIF = 6,
    CPT = 7,
    CIP = 8,
    DAT = 9,
    DAP = 10,
    DDP = 11,
}

export class PodaciUplateDto implements IPodaciUplateDto {
    sifraPlacanja?: string | undefined;
    svrhaPlacanja?: string | undefined;
    model?: string | undefined;
    pozivNaBroj?: string | undefined;
    instrukcijaPlacanja?: string | undefined;

    constructor(data?: IPodaciUplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifraPlacanja = _data["sifraPlacanja"];
            this.svrhaPlacanja = _data["svrhaPlacanja"];
            this.model = _data["model"];
            this.pozivNaBroj = _data["pozivNaBroj"];
            this.instrukcijaPlacanja = _data["instrukcijaPlacanja"];
        }
    }

    static fromJS(data: any): PodaciUplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PodaciUplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifraPlacanja"] = this.sifraPlacanja;
        data["svrhaPlacanja"] = this.svrhaPlacanja;
        data["model"] = this.model;
        data["pozivNaBroj"] = this.pozivNaBroj;
        data["instrukcijaPlacanja"] = this.instrukcijaPlacanja;
        return data;
    }
}

export interface IPodaciUplateDto {
    sifraPlacanja?: string | undefined;
    svrhaPlacanja?: string | undefined;
    model?: string | undefined;
    pozivNaBroj?: string | undefined;
    instrukcijaPlacanja?: string | undefined;
}

export class PodaciUplateDevizniDto implements IPodaciUplateDevizniDto {
    racunId?: number;
    podaciUplateDevizniId?: number;
    bank?: string | undefined;
    iban?: string | undefined;
    swift?: string | undefined;
    accountName?: string | undefined;
    accountAddres?: string | undefined;
    srednjiKursNaDan?: number | undefined;

    constructor(data?: IPodaciUplateDevizniDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
            this.podaciUplateDevizniId = _data["podaciUplateDevizniId"];
            this.bank = _data["bank"];
            this.iban = _data["iban"];
            this.swift = _data["swift"];
            this.accountName = _data["accountName"];
            this.accountAddres = _data["accountAddres"];
            this.srednjiKursNaDan = _data["srednjiKursNaDan"];
        }
    }

    static fromJS(data: any): PodaciUplateDevizniDto {
        data = typeof data === 'object' ? data : {};
        let result = new PodaciUplateDevizniDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        data["podaciUplateDevizniId"] = this.podaciUplateDevizniId;
        data["bank"] = this.bank;
        data["iban"] = this.iban;
        data["swift"] = this.swift;
        data["accountName"] = this.accountName;
        data["accountAddres"] = this.accountAddres;
        data["srednjiKursNaDan"] = this.srednjiKursNaDan;
        return data;
    }
}

export interface IPodaciUplateDevizniDto {
    racunId?: number;
    podaciUplateDevizniId?: number;
    bank?: string | undefined;
    iban?: string | undefined;
    swift?: string | undefined;
    accountName?: string | undefined;
    accountAddres?: string | undefined;
    srednjiKursNaDan?: number | undefined;
}

export enum TipRacuna {
    EMPTY = 0,
    IZLAZNA_FAKTURA = 1,
    ULAZNA_FAKTURA = 2,
    PREDRACUN = 3,
    OTPREMNICA = 4,
    DOKUMENT_O_SMANJENJU = 5,
    AVANSNI_RACUN = 6,
    KORIGOVANA_FAKTURA = 7,
    DOKUMENT_O_POVECANJU = 8,
    RADNI_NALOG = 9,
    PONUDA = 10,
    FISKALNI_RACUN = 11,
    EOTPREMNICA = 12,
    EPRIJEMNICA = 13,
}

export enum VrstaRacuna {
    EMPTY = 0,
    IZLAZNI = 1,
    ULAZNI = 2,
    POCETNO_STANJE_ULAZNI = 3,
    POCETNO_STANJE_IZLAZNI = 4,
}

export enum StatusRacuna {
    EMPTY = 0,
    NACRT = 1,
    POSLATO = 2,
    OTKAZANO = 3,
    STORNIRANO = 4,
    PRIHVACENO = 5,
    ODBIJENO = 6,
    GRESKA = 7,
    OBRISANO = 8,
    NOVO = 9,
    PREGLEDANO = 10,
    PODSTETNIK_POSLAT = 11,
    PODSETNIK_PONOVO_POSLAT = 12,
    PLACENO = 13,
    PRIMLJENO = 14,
    VAN_VALUTE = 15,
    ARHIVIRANO = 16,
    SLANJE = 17,
    PONISTENO = 18,
    PONOVO_OBAVESTENO = 19,
    NOV = 20,
}

export enum StatusUplateRacuna {
    EMPTY = 0,
    NEPLACEN = 1,
    NEVALIDAN = 2,
    DELIMICNO_PLACEN = 3,
    PLACEN = 4,
    OTKAZAN = 5,
    ASIGNIRAN = 6,
    DELIMICNO_ISKORISCEN = 7,
    ISKORISCEN = 8,
    NEISKORISCEN = 9,
}

export enum DatumObracunaPdv {
    EMPTY = 0,
    NA_DAN_IZDAVANJA = 3,
    NA_DAN_PROMETA = 35,
    NA_DAN_PLACANJA = 432,
    BEZ_OBAVEZE = 9999,
}

export class StrankaRacunaDto implements IStrankaRacunaDto {
    id?: number | undefined;
    naziv?: string | undefined;
    adresa?: string | undefined;
    ulicaIBroj?: string | undefined;
    pib?: string | undefined;
    mb?: string | undefined;
    tipStranke?: TipStranke;
    rokPlacanjaZaUlazne?: number;
    rokPlacanjaZaIzlazne?: number;
    jeAktivna?: boolean;
    brojUgovora?: string | undefined;
    brojTendera?: string | undefined;
    registracioniBroj?: string | undefined;
    jbkjs?: string | undefined;
    informacijeIsporuke?: InformacijaIsporukeDto[] | undefined;

    constructor(data?: IStrankaRacunaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.adresa = _data["adresa"];
            this.ulicaIBroj = _data["ulicaIBroj"];
            this.pib = _data["pib"];
            this.mb = _data["mb"];
            this.tipStranke = _data["tipStranke"];
            this.rokPlacanjaZaUlazne = _data["rokPlacanjaZaUlazne"];
            this.rokPlacanjaZaIzlazne = _data["rokPlacanjaZaIzlazne"];
            this.jeAktivna = _data["jeAktivna"];
            this.brojUgovora = _data["brojUgovora"];
            this.brojTendera = _data["brojTendera"];
            this.registracioniBroj = _data["registracioniBroj"];
            this.jbkjs = _data["jbkjs"];
            if (Array.isArray(_data["informacijeIsporuke"])) {
                this.informacijeIsporuke = [] as any;
                for (let item of _data["informacijeIsporuke"])
                    this.informacijeIsporuke!.push(InformacijaIsporukeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StrankaRacunaDto {
        data = typeof data === 'object' ? data : {};
        let result = new StrankaRacunaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["adresa"] = this.adresa;
        data["ulicaIBroj"] = this.ulicaIBroj;
        data["pib"] = this.pib;
        data["mb"] = this.mb;
        data["tipStranke"] = this.tipStranke;
        data["rokPlacanjaZaUlazne"] = this.rokPlacanjaZaUlazne;
        data["rokPlacanjaZaIzlazne"] = this.rokPlacanjaZaIzlazne;
        data["jeAktivna"] = this.jeAktivna;
        data["brojUgovora"] = this.brojUgovora;
        data["brojTendera"] = this.brojTendera;
        data["registracioniBroj"] = this.registracioniBroj;
        data["jbkjs"] = this.jbkjs;
        if (Array.isArray(this.informacijeIsporuke)) {
            data["informacijeIsporuke"] = [];
            for (let item of this.informacijeIsporuke)
                data["informacijeIsporuke"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStrankaRacunaDto {
    id?: number | undefined;
    naziv?: string | undefined;
    adresa?: string | undefined;
    ulicaIBroj?: string | undefined;
    pib?: string | undefined;
    mb?: string | undefined;
    tipStranke?: TipStranke;
    rokPlacanjaZaUlazne?: number;
    rokPlacanjaZaIzlazne?: number;
    jeAktivna?: boolean;
    brojUgovora?: string | undefined;
    brojTendera?: string | undefined;
    registracioniBroj?: string | undefined;
    jbkjs?: string | undefined;
    informacijeIsporuke?: InformacijaIsporukeDto[] | undefined;
}

export enum TipStranke {
    MOJA_FIRMA = 0,
    FIZIKO_LICE = 1,
    PRAVNO_LICE = 2,
}

export class InformacijaIsporukeDto implements IInformacijaIsporukeDto {
    id?: number | undefined;
    imeLokacijeMestaIsporuke?: string | undefined;
    gln?: string | undefined;
    ulicaIBroj?: string | undefined;
    grad?: string | undefined;
    postanskiBroj?: string | undefined;
    drzavaId?: string | undefined;
    strankaId?: number | undefined;
    shouldCreate?: boolean;

    constructor(data?: IInformacijaIsporukeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imeLokacijeMestaIsporuke = _data["imeLokacijeMestaIsporuke"];
            this.gln = _data["gln"];
            this.ulicaIBroj = _data["ulicaIBroj"];
            this.grad = _data["grad"];
            this.postanskiBroj = _data["postanskiBroj"];
            this.drzavaId = _data["drzavaId"];
            this.strankaId = _data["strankaId"];
            this.shouldCreate = _data["shouldCreate"];
        }
    }

    static fromJS(data: any): InformacijaIsporukeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InformacijaIsporukeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imeLokacijeMestaIsporuke"] = this.imeLokacijeMestaIsporuke;
        data["gln"] = this.gln;
        data["ulicaIBroj"] = this.ulicaIBroj;
        data["grad"] = this.grad;
        data["postanskiBroj"] = this.postanskiBroj;
        data["drzavaId"] = this.drzavaId;
        data["strankaId"] = this.strankaId;
        data["shouldCreate"] = this.shouldCreate;
        return data;
    }
}

export interface IInformacijaIsporukeDto {
    id?: number | undefined;
    imeLokacijeMestaIsporuke?: string | undefined;
    gln?: string | undefined;
    ulicaIBroj?: string | undefined;
    grad?: string | undefined;
    postanskiBroj?: string | undefined;
    drzavaId?: string | undefined;
    strankaId?: number | undefined;
    shouldCreate?: boolean;
}

export class StavkaRacunaDto implements IStavkaRacunaDto {
    id?: number | undefined;
    kolicina?: number;
    iznos?: number;
    zavisniTrosakIznos?: number | undefined;
    redniBroj?: number;
    poreskaOsnovica?: number | undefined;
    nabavnaCenaBezPdv?: number;
    prodajnaCenaBezPdv?: number;
    stopaPDV?: number | undefined;
    pdv?: number | undefined;
    razlogPdvIzuzecaId?: number | undefined;
    rabat?: number | undefined;
    naziv?: string | undefined;
    opis?: string | undefined;
    magacinId?: number | undefined;
    jedinicaMere?: JedinicaMereDto | undefined;
    predmetStavkeDto?: PredmetStavkeDto | undefined;
    oznakeDto?: OznakaDto[] | undefined;
    pdvKategorija?: OznakaPdvKategorije;
    identifikator?: IdentifikatorKlasifikacijeStavke | undefined;
    materijali?: StavkaRacunaDto[] | undefined;
    sifraKupca?: string | undefined;
    sifraDobavljaca?: string | undefined;

    constructor(data?: IStavkaRacunaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kolicina = _data["kolicina"];
            this.iznos = _data["iznos"];
            this.zavisniTrosakIznos = _data["zavisniTrosakIznos"];
            this.redniBroj = _data["redniBroj"];
            this.poreskaOsnovica = _data["poreskaOsnovica"];
            this.nabavnaCenaBezPdv = _data["nabavnaCenaBezPdv"];
            this.prodajnaCenaBezPdv = _data["prodajnaCenaBezPdv"];
            this.stopaPDV = _data["stopaPDV"];
            this.pdv = _data["pdv"];
            this.razlogPdvIzuzecaId = _data["razlogPdvIzuzecaId"];
            this.rabat = _data["rabat"];
            this.naziv = _data["naziv"];
            this.opis = _data["opis"];
            this.magacinId = _data["magacinId"];
            this.jedinicaMere = _data["jedinicaMere"] ? JedinicaMereDto.fromJS(_data["jedinicaMere"]) : <any>undefined;
            this.predmetStavkeDto = _data["predmetStavkeDto"] ? PredmetStavkeDto.fromJS(_data["predmetStavkeDto"]) : <any>undefined;
            if (Array.isArray(_data["oznakeDto"])) {
                this.oznakeDto = [] as any;
                for (let item of _data["oznakeDto"])
                    this.oznakeDto!.push(OznakaDto.fromJS(item));
            }
            this.pdvKategorija = _data["pdvKategorija"];
            this.identifikator = _data["identifikator"];
            if (Array.isArray(_data["materijali"])) {
                this.materijali = [] as any;
                for (let item of _data["materijali"])
                    this.materijali!.push(StavkaRacunaDto.fromJS(item));
            }
            this.sifraKupca = _data["sifraKupca"];
            this.sifraDobavljaca = _data["sifraDobavljaca"];
        }
    }

    static fromJS(data: any): StavkaRacunaDto {
        data = typeof data === 'object' ? data : {};
        let result = new StavkaRacunaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kolicina"] = this.kolicina;
        data["iznos"] = this.iznos;
        data["zavisniTrosakIznos"] = this.zavisniTrosakIznos;
        data["redniBroj"] = this.redniBroj;
        data["poreskaOsnovica"] = this.poreskaOsnovica;
        data["nabavnaCenaBezPdv"] = this.nabavnaCenaBezPdv;
        data["prodajnaCenaBezPdv"] = this.prodajnaCenaBezPdv;
        data["stopaPDV"] = this.stopaPDV;
        data["pdv"] = this.pdv;
        data["razlogPdvIzuzecaId"] = this.razlogPdvIzuzecaId;
        data["rabat"] = this.rabat;
        data["naziv"] = this.naziv;
        data["opis"] = this.opis;
        data["magacinId"] = this.magacinId;
        data["jedinicaMere"] = this.jedinicaMere ? this.jedinicaMere.toJSON() : <any>undefined;
        data["predmetStavkeDto"] = this.predmetStavkeDto ? this.predmetStavkeDto.toJSON() : <any>undefined;
        if (Array.isArray(this.oznakeDto)) {
            data["oznakeDto"] = [];
            for (let item of this.oznakeDto)
                data["oznakeDto"].push(item.toJSON());
        }
        data["pdvKategorija"] = this.pdvKategorija;
        data["identifikator"] = this.identifikator;
        if (Array.isArray(this.materijali)) {
            data["materijali"] = [];
            for (let item of this.materijali)
                data["materijali"].push(item.toJSON());
        }
        data["sifraKupca"] = this.sifraKupca;
        data["sifraDobavljaca"] = this.sifraDobavljaca;
        return data;
    }
}

export interface IStavkaRacunaDto {
    id?: number | undefined;
    kolicina?: number;
    iznos?: number;
    zavisniTrosakIznos?: number | undefined;
    redniBroj?: number;
    poreskaOsnovica?: number | undefined;
    nabavnaCenaBezPdv?: number;
    prodajnaCenaBezPdv?: number;
    stopaPDV?: number | undefined;
    pdv?: number | undefined;
    razlogPdvIzuzecaId?: number | undefined;
    rabat?: number | undefined;
    naziv?: string | undefined;
    opis?: string | undefined;
    magacinId?: number | undefined;
    jedinicaMere?: JedinicaMereDto | undefined;
    predmetStavkeDto?: PredmetStavkeDto | undefined;
    oznakeDto?: OznakaDto[] | undefined;
    pdvKategorija?: OznakaPdvKategorije;
    identifikator?: IdentifikatorKlasifikacijeStavke | undefined;
    materijali?: StavkaRacunaDto[] | undefined;
    sifraKupca?: string | undefined;
    sifraDobavljaca?: string | undefined;
}

export class JedinicaMereDto implements IJedinicaMereDto {
    id?: number | undefined;
    naziv?: string | undefined;
    skracenica?: string | undefined;
    kod?: string | undefined;

    constructor(data?: IJedinicaMereDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.skracenica = _data["skracenica"];
            this.kod = _data["kod"];
        }
    }

    static fromJS(data: any): JedinicaMereDto {
        data = typeof data === 'object' ? data : {};
        let result = new JedinicaMereDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["skracenica"] = this.skracenica;
        data["kod"] = this.kod;
        return data;
    }
}

export interface IJedinicaMereDto {
    id?: number | undefined;
    naziv?: string | undefined;
    skracenica?: string | undefined;
    kod?: string | undefined;
}

export class PredmetStavkeDto implements IPredmetStavkeDto {
    id?: number | undefined;
    idek?: string | undefined;
    naziv?: string | undefined;
    sifra?: string | undefined;
    opis?: string | undefined;
    nabavnaCena?: number;
    marza?: number;
    razlikaUCeni?: number;
    prodajnaCenaBezPdv?: number;
    prodajnaCenaSaPdv?: number;
    stopaPDV?: number;
    defaultMagacinId?: number | undefined;
    tipPredmeta?: TipPredmeta;
    tipArtikla?: TipArtikla;
    jedinicaMereDto?: JedinicaMereDto | undefined;
    oznakeDto?: OznakaDto[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    valutaId?: string | undefined;
    valutaText?: string | undefined;
    materijali?: SastavnicaDto[] | undefined;
    netoTezinaKg?: number;
    buyerItemIdentification?: string | undefined;
    sellerItemIdentification?: string | undefined;
    standardItemIdentification?: string | undefined;
    label?: string | undefined;
    externalId?: number | undefined;
    oznakaPdvKategorije?: OznakaPdvKategorije | undefined;
    razlogPdvIzuzecaId?: number | undefined;
    osnovnaCena?: number | undefined;
    gtin?: string | undefined;
    slikeFileNames?: string[] | undefined;

    constructor(data?: IPredmetStavkeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idek = _data["idek"];
            this.naziv = _data["naziv"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.nabavnaCena = _data["nabavnaCena"];
            this.marza = _data["marza"];
            this.razlikaUCeni = _data["razlikaUCeni"];
            this.prodajnaCenaBezPdv = _data["prodajnaCenaBezPdv"];
            this.prodajnaCenaSaPdv = _data["prodajnaCenaSaPdv"];
            this.stopaPDV = _data["stopaPDV"];
            this.defaultMagacinId = _data["defaultMagacinId"];
            this.tipPredmeta = _data["tipPredmeta"];
            this.tipArtikla = _data["tipArtikla"];
            this.jedinicaMereDto = _data["jedinicaMereDto"] ? JedinicaMereDto.fromJS(_data["jedinicaMereDto"]) : <any>undefined;
            if (Array.isArray(_data["oznakeDto"])) {
                this.oznakeDto = [] as any;
                for (let item of _data["oznakeDto"])
                    this.oznakeDto!.push(OznakaDto.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedOn = _data["lastModifiedOn"] ? new Date(_data["lastModifiedOn"].toString()) : <any>undefined;
            this.valutaId = _data["valutaId"];
            this.valutaText = _data["valutaText"];
            if (Array.isArray(_data["materijali"])) {
                this.materijali = [] as any;
                for (let item of _data["materijali"])
                    this.materijali!.push(SastavnicaDto.fromJS(item));
            }
            this.netoTezinaKg = _data["netoTezinaKg"];
            this.buyerItemIdentification = _data["buyerItemIdentification"];
            this.sellerItemIdentification = _data["sellerItemIdentification"];
            this.standardItemIdentification = _data["standardItemIdentification"];
            this.label = _data["label"];
            this.externalId = _data["externalId"];
            this.oznakaPdvKategorije = _data["oznakaPdvKategorije"];
            this.razlogPdvIzuzecaId = _data["razlogPdvIzuzecaId"];
            this.osnovnaCena = _data["osnovnaCena"];
            this.gtin = _data["gtin"];
            if (Array.isArray(_data["slikeFileNames"])) {
                this.slikeFileNames = [] as any;
                for (let item of _data["slikeFileNames"])
                    this.slikeFileNames!.push(item);
            }
        }
    }

    static fromJS(data: any): PredmetStavkeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredmetStavkeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idek"] = this.idek;
        data["naziv"] = this.naziv;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["nabavnaCena"] = this.nabavnaCena;
        data["marza"] = this.marza;
        data["razlikaUCeni"] = this.razlikaUCeni;
        data["prodajnaCenaBezPdv"] = this.prodajnaCenaBezPdv;
        data["prodajnaCenaSaPdv"] = this.prodajnaCenaSaPdv;
        data["stopaPDV"] = this.stopaPDV;
        data["defaultMagacinId"] = this.defaultMagacinId;
        data["tipPredmeta"] = this.tipPredmeta;
        data["tipArtikla"] = this.tipArtikla;
        data["jedinicaMereDto"] = this.jedinicaMereDto ? this.jedinicaMereDto.toJSON() : <any>undefined;
        if (Array.isArray(this.oznakeDto)) {
            data["oznakeDto"] = [];
            for (let item of this.oznakeDto)
                data["oznakeDto"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined;
        data["valutaId"] = this.valutaId;
        data["valutaText"] = this.valutaText;
        if (Array.isArray(this.materijali)) {
            data["materijali"] = [];
            for (let item of this.materijali)
                data["materijali"].push(item.toJSON());
        }
        data["netoTezinaKg"] = this.netoTezinaKg;
        data["buyerItemIdentification"] = this.buyerItemIdentification;
        data["sellerItemIdentification"] = this.sellerItemIdentification;
        data["standardItemIdentification"] = this.standardItemIdentification;
        data["label"] = this.label;
        data["externalId"] = this.externalId;
        data["oznakaPdvKategorije"] = this.oznakaPdvKategorije;
        data["razlogPdvIzuzecaId"] = this.razlogPdvIzuzecaId;
        data["osnovnaCena"] = this.osnovnaCena;
        data["gtin"] = this.gtin;
        if (Array.isArray(this.slikeFileNames)) {
            data["slikeFileNames"] = [];
            for (let item of this.slikeFileNames)
                data["slikeFileNames"].push(item);
        }
        return data;
    }
}

export interface IPredmetStavkeDto {
    id?: number | undefined;
    idek?: string | undefined;
    naziv?: string | undefined;
    sifra?: string | undefined;
    opis?: string | undefined;
    nabavnaCena?: number;
    marza?: number;
    razlikaUCeni?: number;
    prodajnaCenaBezPdv?: number;
    prodajnaCenaSaPdv?: number;
    stopaPDV?: number;
    defaultMagacinId?: number | undefined;
    tipPredmeta?: TipPredmeta;
    tipArtikla?: TipArtikla;
    jedinicaMereDto?: JedinicaMereDto | undefined;
    oznakeDto?: OznakaDto[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    valutaId?: string | undefined;
    valutaText?: string | undefined;
    materijali?: SastavnicaDto[] | undefined;
    netoTezinaKg?: number;
    buyerItemIdentification?: string | undefined;
    sellerItemIdentification?: string | undefined;
    standardItemIdentification?: string | undefined;
    label?: string | undefined;
    externalId?: number | undefined;
    oznakaPdvKategorije?: OznakaPdvKategorije | undefined;
    razlogPdvIzuzecaId?: number | undefined;
    osnovnaCena?: number | undefined;
    gtin?: string | undefined;
    slikeFileNames?: string[] | undefined;
}

export enum TipPredmeta {
    PREDMET_STAVKE = 0,
    ROBA = 1,
    USLUGA = 2,
    VOZILO = 3,
    PREDMET_IZMENE_OSNOVICE = 4,
    DATI_AVANS = 5,
    PRIMLJENI_AVANS = 6,
    FISKALNI_AVANS = 7,
}

export enum TipArtikla {
    EMPTY = 0,
    ROBA = 1,
    SIROVINE_MATERIJAL = 2,
    POLUPROIZVOD = 3,
    PROIZVOD = 4,
    USLUGA = 5,
    VOZILO = 6,
}

export class OznakaDto implements IOznakaDto {
    id?: number | undefined;
    parentId?: number | undefined;
    naziv?: string | undefined;
    punNaziv?: string | undefined;
    kolicina?: number | undefined;
    iznos?: number | undefined;
    nazivStavke?: string | undefined;
    tipOznake?: TipOznake;
    tipEntiteta?: TipEntiteta;

    constructor(data?: IOznakaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.naziv = _data["naziv"];
            this.punNaziv = _data["punNaziv"];
            this.kolicina = _data["kolicina"];
            this.iznos = _data["iznos"];
            this.nazivStavke = _data["nazivStavke"];
            this.tipOznake = _data["tipOznake"];
            this.tipEntiteta = _data["tipEntiteta"];
        }
    }

    static fromJS(data: any): OznakaDto {
        data = typeof data === 'object' ? data : {};
        let result = new OznakaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["naziv"] = this.naziv;
        data["punNaziv"] = this.punNaziv;
        data["kolicina"] = this.kolicina;
        data["iznos"] = this.iznos;
        data["nazivStavke"] = this.nazivStavke;
        data["tipOznake"] = this.tipOznake;
        data["tipEntiteta"] = this.tipEntiteta;
        return data;
    }
}

export interface IOznakaDto {
    id?: number | undefined;
    parentId?: number | undefined;
    naziv?: string | undefined;
    punNaziv?: string | undefined;
    kolicina?: number | undefined;
    iznos?: number | undefined;
    nazivStavke?: string | undefined;
    tipOznake?: TipOznake;
    tipEntiteta?: TipEntiteta;
}

export enum TipOznake {
    SISTEMSKA = 1,
    KORISNICKA = 2,
}

export enum TipEntiteta {
    EMPTY = 0,
    PREDMET_STAVKE = 1,
    ROBA = 2,
    USLUGA = 3,
    VOZILO = 4,
    RACUN = 5,
    OTPREMNICA = 6,
    DOKUMENT_O_SMANJENJU = 7,
    IZLAZNA_FAKTURA = 8,
    ULAZNA_FAKTURA = 9,
    PREDRACUN = 10,
    AVANSNI_RACUN = 11,
    RADNI_NALOG = 12,
    STRANKA = 12,
    PRAVNO_LICE = 13,
    FIZICKO_LICE = 14,
    MAGACIN = 15,
    VOZILO_OSIGURANJE = 16,
    DOKUMENT_O_POVECANJU = 18,
    KATEGORIJA_ROBE = 19,
}

export class SastavnicaDto implements ISastavnicaDto {
    id?: number;
    proizvodId?: number;
    materijalId?: number;
    kolicina?: number;
    predmetStavkeDto?: PredmetStavkeDto | undefined;

    constructor(data?: ISastavnicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.proizvodId = _data["proizvodId"];
            this.materijalId = _data["materijalId"];
            this.kolicina = _data["kolicina"];
            this.predmetStavkeDto = _data["predmetStavkeDto"] ? PredmetStavkeDto.fromJS(_data["predmetStavkeDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SastavnicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new SastavnicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["proizvodId"] = this.proizvodId;
        data["materijalId"] = this.materijalId;
        data["kolicina"] = this.kolicina;
        data["predmetStavkeDto"] = this.predmetStavkeDto ? this.predmetStavkeDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISastavnicaDto {
    id?: number;
    proizvodId?: number;
    materijalId?: number;
    kolicina?: number;
    predmetStavkeDto?: PredmetStavkeDto | undefined;
}

export enum OznakaPdvKategorije {
    S = 0,
    AE = 1,
    Z = 2,
    E = 3,
    R = 4,
    O = 5,
    OE = 6,
    SS = 7,
    N = 8,
    EMPTY = 9,
    S20 = 10,
    S10 = 11,
    AE10 = 12,
    AE20 = 13,
}

export enum IdentifikatorKlasifikacijeStavke {
    EMPTY = 0,
    PDV_RS_OBJ = 1,
}

export class TransakcijaZaRacunDto implements ITransakcijaZaRacunDto {
    transakcijaIzvodaId?: number;
    uplaceniIznos?: number;

    constructor(data?: ITransakcijaZaRacunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transakcijaIzvodaId = _data["transakcijaIzvodaId"];
            this.uplaceniIznos = _data["uplaceniIznos"];
        }
    }

    static fromJS(data: any): TransakcijaZaRacunDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransakcijaZaRacunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transakcijaIzvodaId"] = this.transakcijaIzvodaId;
        data["uplaceniIznos"] = this.uplaceniIznos;
        return data;
    }
}

export interface ITransakcijaZaRacunDto {
    transakcijaIzvodaId?: number;
    uplaceniIznos?: number;
}

export class VezaniRacunDto implements IVezaniRacunDto {
    racunId?: number;
    tipStr?: string | undefined;
    label?: string | undefined;
    emptyText?: string | undefined;
    status?: StatusRacuna;
    tip?: TipRacuna;
    vrsta?: VrstaRacuna;
    datumIzdavanja?: Date;

    constructor(data?: IVezaniRacunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
            this.tipStr = _data["tipStr"];
            this.label = _data["label"];
            this.emptyText = _data["emptyText"];
            this.status = _data["status"];
            this.tip = _data["tip"];
            this.vrsta = _data["vrsta"];
            this.datumIzdavanja = _data["datumIzdavanja"] ? new Date(_data["datumIzdavanja"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VezaniRacunDto {
        data = typeof data === 'object' ? data : {};
        let result = new VezaniRacunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        data["tipStr"] = this.tipStr;
        data["label"] = this.label;
        data["emptyText"] = this.emptyText;
        data["status"] = this.status;
        data["tip"] = this.tip;
        data["vrsta"] = this.vrsta;
        data["datumIzdavanja"] = this.datumIzdavanja ? this.datumIzdavanja.toISOString() : <any>undefined;
        return data;
    }
}

export interface IVezaniRacunDto {
    racunId?: number;
    tipStr?: string | undefined;
    label?: string | undefined;
    emptyText?: string | undefined;
    status?: StatusRacuna;
    tip?: TipRacuna;
    vrsta?: VrstaRacuna;
    datumIzdavanja?: Date;
}

export class AvansnaUplataRacunaTableDto implements IAvansnaUplataRacunaTableDto {
    id?: number | undefined;
    avansniRacunId?: number;
    avansniRacunBroj?: string | undefined;
    avansniRacunDatumIzdavanja?: Date;
    avansniRacunVrsta?: VrstaRacuna;
    evidentiranaOsnovica8?: number | undefined;
    evidentiranaOsnovica10?: number | undefined;
    evidentiranaOsnovica20?: number | undefined;
    evidentiranPdv8?: number | undefined;
    evidentiranPdv10?: number | undefined;
    evidentiranPdv20?: number | undefined;
    evidentiranaOsnovicaAE?: number | undefined;
    evidentiranaOsnovicaAE10?: number | undefined;
    evidentiranaOsnovicaAE20?: number | undefined;
    evidentiranaOsnovicaO?: number | undefined;
    evidentiranaOsnovicaE?: number | undefined;
    evidentiranaOsnovicaR?: number | undefined;
    evidentiranaOsnovicaZ?: number | undefined;
    evidentiranaOsnovicaSS?: number | undefined;
    evidentiranaOsnovicaOE?: number | undefined;
    evidentiranaOsnovicaN?: number | undefined;
    ukupnaOsnovica8?: number | undefined;
    ukupnaOsnovica10?: number | undefined;
    ukupnaOsnovica20?: number | undefined;
    ukupnoPdv8?: number | undefined;
    ukupnoPdv10?: number | undefined;
    ukupnoPdv20?: number | undefined;
    ukupnaOsnovicaAE?: number | undefined;
    ukupnaOsnovicaAE10?: number | undefined;
    ukupnaOsnovicaAE20?: number | undefined;
    ukupnaOsnovicaO?: number | undefined;
    ukupnaOsnovicaE?: number | undefined;
    ukupnaOsnovicaR?: number | undefined;
    ukupnaOsnovicaZ?: number | undefined;
    ukupnaOsnovicaSS?: number | undefined;
    ukupnaOsnovicaOE?: number | undefined;
    ukupnaOsnovicaN?: number | undefined;
    uplataEvidentiranaOsnovica8?: number | undefined;
    uplataEvidentiranaOsnovica10?: number | undefined;
    uplataEvidentiranaOsnovica20?: number | undefined;
    uplataEvidentiranPdv8?: number | undefined;
    uplataEvidentiranPdv10?: number | undefined;
    uplataEvidentiranPdv20?: number | undefined;
    uplataEvidentiranaOsnovicaAE?: number | undefined;
    uplataEvidentiranaOsnovicaAE10?: number | undefined;
    uplataEvidentiranaOsnovicaAE20?: number | undefined;
    uplataEvidentiranaOsnovicaO?: number | undefined;
    uplataEvidentiranaOsnovicaE?: number | undefined;
    uplataEvidentiranaOsnovicaR?: number | undefined;
    uplataEvidentiranaOsnovicaZ?: number | undefined;
    uplataEvidentiranaOsnovicaSS?: number | undefined;
    uplataEvidentiranaOsnovicaOE?: number | undefined;
    uplataEvidentiranaOsnovicaN?: number | undefined;

    constructor(data?: IAvansnaUplataRacunaTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.avansniRacunId = _data["avansniRacunId"];
            this.avansniRacunBroj = _data["avansniRacunBroj"];
            this.avansniRacunDatumIzdavanja = _data["avansniRacunDatumIzdavanja"] ? new Date(_data["avansniRacunDatumIzdavanja"].toString()) : <any>undefined;
            this.avansniRacunVrsta = _data["avansniRacunVrsta"];
            this.evidentiranaOsnovica8 = _data["evidentiranaOsnovica8"];
            this.evidentiranaOsnovica10 = _data["evidentiranaOsnovica10"];
            this.evidentiranaOsnovica20 = _data["evidentiranaOsnovica20"];
            this.evidentiranPdv8 = _data["evidentiranPdv8"];
            this.evidentiranPdv10 = _data["evidentiranPdv10"];
            this.evidentiranPdv20 = _data["evidentiranPdv20"];
            this.evidentiranaOsnovicaAE = _data["evidentiranaOsnovicaAE"];
            this.evidentiranaOsnovicaAE10 = _data["evidentiranaOsnovicaAE10"];
            this.evidentiranaOsnovicaAE20 = _data["evidentiranaOsnovicaAE20"];
            this.evidentiranaOsnovicaO = _data["evidentiranaOsnovicaO"];
            this.evidentiranaOsnovicaE = _data["evidentiranaOsnovicaE"];
            this.evidentiranaOsnovicaR = _data["evidentiranaOsnovicaR"];
            this.evidentiranaOsnovicaZ = _data["evidentiranaOsnovicaZ"];
            this.evidentiranaOsnovicaSS = _data["evidentiranaOsnovicaSS"];
            this.evidentiranaOsnovicaOE = _data["evidentiranaOsnovicaOE"];
            this.evidentiranaOsnovicaN = _data["evidentiranaOsnovicaN"];
            this.ukupnaOsnovica8 = _data["ukupnaOsnovica8"];
            this.ukupnaOsnovica10 = _data["ukupnaOsnovica10"];
            this.ukupnaOsnovica20 = _data["ukupnaOsnovica20"];
            this.ukupnoPdv8 = _data["ukupnoPdv8"];
            this.ukupnoPdv10 = _data["ukupnoPdv10"];
            this.ukupnoPdv20 = _data["ukupnoPdv20"];
            this.ukupnaOsnovicaAE = _data["ukupnaOsnovicaAE"];
            this.ukupnaOsnovicaAE10 = _data["ukupnaOsnovicaAE10"];
            this.ukupnaOsnovicaAE20 = _data["ukupnaOsnovicaAE20"];
            this.ukupnaOsnovicaO = _data["ukupnaOsnovicaO"];
            this.ukupnaOsnovicaE = _data["ukupnaOsnovicaE"];
            this.ukupnaOsnovicaR = _data["ukupnaOsnovicaR"];
            this.ukupnaOsnovicaZ = _data["ukupnaOsnovicaZ"];
            this.ukupnaOsnovicaSS = _data["ukupnaOsnovicaSS"];
            this.ukupnaOsnovicaOE = _data["ukupnaOsnovicaOE"];
            this.ukupnaOsnovicaN = _data["ukupnaOsnovicaN"];
            this.uplataEvidentiranaOsnovica8 = _data["uplataEvidentiranaOsnovica8"];
            this.uplataEvidentiranaOsnovica10 = _data["uplataEvidentiranaOsnovica10"];
            this.uplataEvidentiranaOsnovica20 = _data["uplataEvidentiranaOsnovica20"];
            this.uplataEvidentiranPdv8 = _data["uplataEvidentiranPdv8"];
            this.uplataEvidentiranPdv10 = _data["uplataEvidentiranPdv10"];
            this.uplataEvidentiranPdv20 = _data["uplataEvidentiranPdv20"];
            this.uplataEvidentiranaOsnovicaAE = _data["uplataEvidentiranaOsnovicaAE"];
            this.uplataEvidentiranaOsnovicaAE10 = _data["uplataEvidentiranaOsnovicaAE10"];
            this.uplataEvidentiranaOsnovicaAE20 = _data["uplataEvidentiranaOsnovicaAE20"];
            this.uplataEvidentiranaOsnovicaO = _data["uplataEvidentiranaOsnovicaO"];
            this.uplataEvidentiranaOsnovicaE = _data["uplataEvidentiranaOsnovicaE"];
            this.uplataEvidentiranaOsnovicaR = _data["uplataEvidentiranaOsnovicaR"];
            this.uplataEvidentiranaOsnovicaZ = _data["uplataEvidentiranaOsnovicaZ"];
            this.uplataEvidentiranaOsnovicaSS = _data["uplataEvidentiranaOsnovicaSS"];
            this.uplataEvidentiranaOsnovicaOE = _data["uplataEvidentiranaOsnovicaOE"];
            this.uplataEvidentiranaOsnovicaN = _data["uplataEvidentiranaOsnovicaN"];
        }
    }

    static fromJS(data: any): AvansnaUplataRacunaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvansnaUplataRacunaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["avansniRacunId"] = this.avansniRacunId;
        data["avansniRacunBroj"] = this.avansniRacunBroj;
        data["avansniRacunDatumIzdavanja"] = this.avansniRacunDatumIzdavanja ? this.avansniRacunDatumIzdavanja.toISOString() : <any>undefined;
        data["avansniRacunVrsta"] = this.avansniRacunVrsta;
        data["evidentiranaOsnovica8"] = this.evidentiranaOsnovica8;
        data["evidentiranaOsnovica10"] = this.evidentiranaOsnovica10;
        data["evidentiranaOsnovica20"] = this.evidentiranaOsnovica20;
        data["evidentiranPdv8"] = this.evidentiranPdv8;
        data["evidentiranPdv10"] = this.evidentiranPdv10;
        data["evidentiranPdv20"] = this.evidentiranPdv20;
        data["evidentiranaOsnovicaAE"] = this.evidentiranaOsnovicaAE;
        data["evidentiranaOsnovicaAE10"] = this.evidentiranaOsnovicaAE10;
        data["evidentiranaOsnovicaAE20"] = this.evidentiranaOsnovicaAE20;
        data["evidentiranaOsnovicaO"] = this.evidentiranaOsnovicaO;
        data["evidentiranaOsnovicaE"] = this.evidentiranaOsnovicaE;
        data["evidentiranaOsnovicaR"] = this.evidentiranaOsnovicaR;
        data["evidentiranaOsnovicaZ"] = this.evidentiranaOsnovicaZ;
        data["evidentiranaOsnovicaSS"] = this.evidentiranaOsnovicaSS;
        data["evidentiranaOsnovicaOE"] = this.evidentiranaOsnovicaOE;
        data["evidentiranaOsnovicaN"] = this.evidentiranaOsnovicaN;
        data["ukupnaOsnovica8"] = this.ukupnaOsnovica8;
        data["ukupnaOsnovica10"] = this.ukupnaOsnovica10;
        data["ukupnaOsnovica20"] = this.ukupnaOsnovica20;
        data["ukupnoPdv8"] = this.ukupnoPdv8;
        data["ukupnoPdv10"] = this.ukupnoPdv10;
        data["ukupnoPdv20"] = this.ukupnoPdv20;
        data["ukupnaOsnovicaAE"] = this.ukupnaOsnovicaAE;
        data["ukupnaOsnovicaAE10"] = this.ukupnaOsnovicaAE10;
        data["ukupnaOsnovicaAE20"] = this.ukupnaOsnovicaAE20;
        data["ukupnaOsnovicaO"] = this.ukupnaOsnovicaO;
        data["ukupnaOsnovicaE"] = this.ukupnaOsnovicaE;
        data["ukupnaOsnovicaR"] = this.ukupnaOsnovicaR;
        data["ukupnaOsnovicaZ"] = this.ukupnaOsnovicaZ;
        data["ukupnaOsnovicaSS"] = this.ukupnaOsnovicaSS;
        data["ukupnaOsnovicaOE"] = this.ukupnaOsnovicaOE;
        data["ukupnaOsnovicaN"] = this.ukupnaOsnovicaN;
        data["uplataEvidentiranaOsnovica8"] = this.uplataEvidentiranaOsnovica8;
        data["uplataEvidentiranaOsnovica10"] = this.uplataEvidentiranaOsnovica10;
        data["uplataEvidentiranaOsnovica20"] = this.uplataEvidentiranaOsnovica20;
        data["uplataEvidentiranPdv8"] = this.uplataEvidentiranPdv8;
        data["uplataEvidentiranPdv10"] = this.uplataEvidentiranPdv10;
        data["uplataEvidentiranPdv20"] = this.uplataEvidentiranPdv20;
        data["uplataEvidentiranaOsnovicaAE"] = this.uplataEvidentiranaOsnovicaAE;
        data["uplataEvidentiranaOsnovicaAE10"] = this.uplataEvidentiranaOsnovicaAE10;
        data["uplataEvidentiranaOsnovicaAE20"] = this.uplataEvidentiranaOsnovicaAE20;
        data["uplataEvidentiranaOsnovicaO"] = this.uplataEvidentiranaOsnovicaO;
        data["uplataEvidentiranaOsnovicaE"] = this.uplataEvidentiranaOsnovicaE;
        data["uplataEvidentiranaOsnovicaR"] = this.uplataEvidentiranaOsnovicaR;
        data["uplataEvidentiranaOsnovicaZ"] = this.uplataEvidentiranaOsnovicaZ;
        data["uplataEvidentiranaOsnovicaSS"] = this.uplataEvidentiranaOsnovicaSS;
        data["uplataEvidentiranaOsnovicaOE"] = this.uplataEvidentiranaOsnovicaOE;
        data["uplataEvidentiranaOsnovicaN"] = this.uplataEvidentiranaOsnovicaN;
        return data;
    }
}

export interface IAvansnaUplataRacunaTableDto {
    id?: number | undefined;
    avansniRacunId?: number;
    avansniRacunBroj?: string | undefined;
    avansniRacunDatumIzdavanja?: Date;
    avansniRacunVrsta?: VrstaRacuna;
    evidentiranaOsnovica8?: number | undefined;
    evidentiranaOsnovica10?: number | undefined;
    evidentiranaOsnovica20?: number | undefined;
    evidentiranPdv8?: number | undefined;
    evidentiranPdv10?: number | undefined;
    evidentiranPdv20?: number | undefined;
    evidentiranaOsnovicaAE?: number | undefined;
    evidentiranaOsnovicaAE10?: number | undefined;
    evidentiranaOsnovicaAE20?: number | undefined;
    evidentiranaOsnovicaO?: number | undefined;
    evidentiranaOsnovicaE?: number | undefined;
    evidentiranaOsnovicaR?: number | undefined;
    evidentiranaOsnovicaZ?: number | undefined;
    evidentiranaOsnovicaSS?: number | undefined;
    evidentiranaOsnovicaOE?: number | undefined;
    evidentiranaOsnovicaN?: number | undefined;
    ukupnaOsnovica8?: number | undefined;
    ukupnaOsnovica10?: number | undefined;
    ukupnaOsnovica20?: number | undefined;
    ukupnoPdv8?: number | undefined;
    ukupnoPdv10?: number | undefined;
    ukupnoPdv20?: number | undefined;
    ukupnaOsnovicaAE?: number | undefined;
    ukupnaOsnovicaAE10?: number | undefined;
    ukupnaOsnovicaAE20?: number | undefined;
    ukupnaOsnovicaO?: number | undefined;
    ukupnaOsnovicaE?: number | undefined;
    ukupnaOsnovicaR?: number | undefined;
    ukupnaOsnovicaZ?: number | undefined;
    ukupnaOsnovicaSS?: number | undefined;
    ukupnaOsnovicaOE?: number | undefined;
    ukupnaOsnovicaN?: number | undefined;
    uplataEvidentiranaOsnovica8?: number | undefined;
    uplataEvidentiranaOsnovica10?: number | undefined;
    uplataEvidentiranaOsnovica20?: number | undefined;
    uplataEvidentiranPdv8?: number | undefined;
    uplataEvidentiranPdv10?: number | undefined;
    uplataEvidentiranPdv20?: number | undefined;
    uplataEvidentiranaOsnovicaAE?: number | undefined;
    uplataEvidentiranaOsnovicaAE10?: number | undefined;
    uplataEvidentiranaOsnovicaAE20?: number | undefined;
    uplataEvidentiranaOsnovicaO?: number | undefined;
    uplataEvidentiranaOsnovicaE?: number | undefined;
    uplataEvidentiranaOsnovicaR?: number | undefined;
    uplataEvidentiranaOsnovicaZ?: number | undefined;
    uplataEvidentiranaOsnovicaSS?: number | undefined;
    uplataEvidentiranaOsnovicaOE?: number | undefined;
    uplataEvidentiranaOsnovicaN?: number | undefined;
}

export class RacunUkupanIznosDto implements IRacunUkupanIznosDto {
    zbirStavkiS?: number | undefined;
    zbirStavki8?: number | undefined;
    zbirStavki10?: number | undefined;
    zbirStavki20?: number | undefined;
    zbirStavkiAE?: number | undefined;
    zbirStavkiAE10?: number | undefined;
    zbirStavkiAE20?: number | undefined;
    zbirStavkiO?: number | undefined;
    zbirStavkiE?: number | undefined;
    zbirStavkiR?: number | undefined;
    zbirStavkiZ?: number | undefined;
    zbirStavkiSS?: number | undefined;
    zbirStavkiOE?: number | undefined;
    zbirStavkiN?: number | undefined;
    smanjenjeNaknade8?: number | undefined;
    smanjenjeNaknade10?: number | undefined;
    smanjenjeNaknade20?: number | undefined;
    smanjenjeNaknadeAE?: number | undefined;
    smanjenjeNaknadeAE10?: number | undefined;
    smanjenjeNaknadeAE20?: number | undefined;
    smanjenjeNaknadeO?: number | undefined;
    smanjenjeNaknadeE?: number | undefined;
    smanjenjeNaknadeR?: number | undefined;
    smanjenjeNaknadeZ?: number | undefined;
    smanjenjeNaknadeSS?: number | undefined;
    smanjenjeNaknadeOE?: number | undefined;
    smanjenjeNaknadeN?: number | undefined;
    ukupnoOsnovica8?: number | undefined;
    ukupnoOsnovica10?: number | undefined;
    ukupnoOsnovica20?: number | undefined;
    ukupnoOsnovicaAE?: number | undefined;
    ukupnoOsnovicaAE10?: number | undefined;
    ukupnoOsnovicaAE20?: number | undefined;
    ukupnoOsnovicaO?: number | undefined;
    ukupnoOsnovicaE?: number | undefined;
    ukupnoOsnovicaR?: number | undefined;
    ukupnoOsnovicaZ?: number | undefined;
    ukupnoOsnovicaSS?: number | undefined;
    ukupnoOsnovicaOE?: number | undefined;
    ukupnoOsnovicaN?: number | undefined;
    ukupnoPdv8?: number | undefined;
    ukupnoPdv10?: number | undefined;
    ukupnoPdv20?: number | undefined;
    rsdUkupnoOsnovica8?: number | undefined;
    rsdUkupnoOsnovica10?: number | undefined;
    rsdUkupnoOsnovica20?: number | undefined;
    rsdUkupnoOsnovicaAE?: number | undefined;
    rsdUkupnoOsnovicaAE10?: number | undefined;
    rsdUkupnoOsnovicaAE20?: number | undefined;
    rsdUkupnoOsnovicaO?: number | undefined;
    rsdUkupnoOsnovicaE?: number | undefined;
    rsdUkupnoOsnovicaR?: number | undefined;
    rsdUkupnoOsnovicaZ?: number | undefined;
    rsdUkupnoOsnovicaSS?: number | undefined;
    rsdUkupnoOsnovicaOE?: number | undefined;
    rsdUkupnoOsnovicaN?: number | undefined;
    rsdUkupnoPdv8?: number | undefined;
    rsdUkupnoPdv10?: number | undefined;
    rsdUkupnoPdv20?: number | undefined;
    avansiraniPdv8?: number | undefined;
    avansiraniPdv10?: number | undefined;
    avansiraniPdv20?: number | undefined;
    avansiranaOsnovicaS?: number | undefined;
    avansiranaOsnovica8?: number | undefined;
    avansiranaOsnovica10?: number | undefined;
    avansiranaOsnovica20?: number | undefined;
    avansiranaOsnovicaAE?: number | undefined;
    avansiranaOsnovicaAE10?: number | undefined;
    avansiranaOsnovicaAE20?: number | undefined;
    avansiranaOsnovicaO?: number | undefined;
    avansiranaOsnovicaE?: number | undefined;
    avansiranaOsnovicaR?: number | undefined;
    avansiranaOsnovicaZ?: number | undefined;
    avansiranaOsnovicaSS?: number | undefined;
    avansiranaOsnovicaOE?: number | undefined;
    avansiranaOsnovicaN?: number | undefined;
    ukupanAvansiranIznos?: number | undefined;
    umanjenaOsnovicaS?: number | undefined;
    umanjenaOsnovica8?: number | undefined;
    umanjenaOsnovica10?: number | undefined;
    umanjenaOsnovica20?: number | undefined;
    umanjenaOsnovicaAE?: number | undefined;
    umanjenaOsnovicaAE10?: number | undefined;
    umanjenaOsnovicaAE20?: number | undefined;
    umanjenaOsnovicaO?: number | undefined;
    umanjenaOsnovicaE?: number | undefined;
    umanjenaOsnovicaR?: number | undefined;
    umanjenaOsnovicaZ?: number | undefined;
    umanjenaOsnovicaSS?: number | undefined;
    umanjenaOsnovicaOE?: number | undefined;
    umanjenaOsnovicaN?: number | undefined;
    ukupnoPdvUmanjenZaAvanse8?: number | undefined;
    ukupnoPdvUmanjenZaAvanse10?: number | undefined;
    ukupnoPdvUmanjenZaAvanse20?: number | undefined;
    iznosZaZaokruzivanje?: number | undefined;
    ukupnoZaUplatu?: number;

    constructor(data?: IRacunUkupanIznosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zbirStavkiS = _data["zbirStavkiS"];
            this.zbirStavki8 = _data["zbirStavki8"];
            this.zbirStavki10 = _data["zbirStavki10"];
            this.zbirStavki20 = _data["zbirStavki20"];
            this.zbirStavkiAE = _data["zbirStavkiAE"];
            this.zbirStavkiAE10 = _data["zbirStavkiAE10"];
            this.zbirStavkiAE20 = _data["zbirStavkiAE20"];
            this.zbirStavkiO = _data["zbirStavkiO"];
            this.zbirStavkiE = _data["zbirStavkiE"];
            this.zbirStavkiR = _data["zbirStavkiR"];
            this.zbirStavkiZ = _data["zbirStavkiZ"];
            this.zbirStavkiSS = _data["zbirStavkiSS"];
            this.zbirStavkiOE = _data["zbirStavkiOE"];
            this.zbirStavkiN = _data["zbirStavkiN"];
            this.smanjenjeNaknade8 = _data["smanjenjeNaknade8"];
            this.smanjenjeNaknade10 = _data["smanjenjeNaknade10"];
            this.smanjenjeNaknade20 = _data["smanjenjeNaknade20"];
            this.smanjenjeNaknadeAE = _data["smanjenjeNaknadeAE"];
            this.smanjenjeNaknadeAE10 = _data["smanjenjeNaknadeAE10"];
            this.smanjenjeNaknadeAE20 = _data["smanjenjeNaknadeAE20"];
            this.smanjenjeNaknadeO = _data["smanjenjeNaknadeO"];
            this.smanjenjeNaknadeE = _data["smanjenjeNaknadeE"];
            this.smanjenjeNaknadeR = _data["smanjenjeNaknadeR"];
            this.smanjenjeNaknadeZ = _data["smanjenjeNaknadeZ"];
            this.smanjenjeNaknadeSS = _data["smanjenjeNaknadeSS"];
            this.smanjenjeNaknadeOE = _data["smanjenjeNaknadeOE"];
            this.smanjenjeNaknadeN = _data["smanjenjeNaknadeN"];
            this.ukupnoOsnovica8 = _data["ukupnoOsnovica8"];
            this.ukupnoOsnovica10 = _data["ukupnoOsnovica10"];
            this.ukupnoOsnovica20 = _data["ukupnoOsnovica20"];
            this.ukupnoOsnovicaAE = _data["ukupnoOsnovicaAE"];
            this.ukupnoOsnovicaAE10 = _data["ukupnoOsnovicaAE10"];
            this.ukupnoOsnovicaAE20 = _data["ukupnoOsnovicaAE20"];
            this.ukupnoOsnovicaO = _data["ukupnoOsnovicaO"];
            this.ukupnoOsnovicaE = _data["ukupnoOsnovicaE"];
            this.ukupnoOsnovicaR = _data["ukupnoOsnovicaR"];
            this.ukupnoOsnovicaZ = _data["ukupnoOsnovicaZ"];
            this.ukupnoOsnovicaSS = _data["ukupnoOsnovicaSS"];
            this.ukupnoOsnovicaOE = _data["ukupnoOsnovicaOE"];
            this.ukupnoOsnovicaN = _data["ukupnoOsnovicaN"];
            this.ukupnoPdv8 = _data["ukupnoPdv8"];
            this.ukupnoPdv10 = _data["ukupnoPdv10"];
            this.ukupnoPdv20 = _data["ukupnoPdv20"];
            this.rsdUkupnoOsnovica8 = _data["rsdUkupnoOsnovica8"];
            this.rsdUkupnoOsnovica10 = _data["rsdUkupnoOsnovica10"];
            this.rsdUkupnoOsnovica20 = _data["rsdUkupnoOsnovica20"];
            this.rsdUkupnoOsnovicaAE = _data["rsdUkupnoOsnovicaAE"];
            this.rsdUkupnoOsnovicaAE10 = _data["rsdUkupnoOsnovicaAE10"];
            this.rsdUkupnoOsnovicaAE20 = _data["rsdUkupnoOsnovicaAE20"];
            this.rsdUkupnoOsnovicaO = _data["rsdUkupnoOsnovicaO"];
            this.rsdUkupnoOsnovicaE = _data["rsdUkupnoOsnovicaE"];
            this.rsdUkupnoOsnovicaR = _data["rsdUkupnoOsnovicaR"];
            this.rsdUkupnoOsnovicaZ = _data["rsdUkupnoOsnovicaZ"];
            this.rsdUkupnoOsnovicaSS = _data["rsdUkupnoOsnovicaSS"];
            this.rsdUkupnoOsnovicaOE = _data["rsdUkupnoOsnovicaOE"];
            this.rsdUkupnoOsnovicaN = _data["rsdUkupnoOsnovicaN"];
            this.rsdUkupnoPdv8 = _data["rsdUkupnoPdv8"];
            this.rsdUkupnoPdv10 = _data["rsdUkupnoPdv10"];
            this.rsdUkupnoPdv20 = _data["rsdUkupnoPdv20"];
            this.avansiraniPdv8 = _data["avansiraniPdv8"];
            this.avansiraniPdv10 = _data["avansiraniPdv10"];
            this.avansiraniPdv20 = _data["avansiraniPdv20"];
            this.avansiranaOsnovicaS = _data["avansiranaOsnovicaS"];
            this.avansiranaOsnovica8 = _data["avansiranaOsnovica8"];
            this.avansiranaOsnovica10 = _data["avansiranaOsnovica10"];
            this.avansiranaOsnovica20 = _data["avansiranaOsnovica20"];
            this.avansiranaOsnovicaAE = _data["avansiranaOsnovicaAE"];
            this.avansiranaOsnovicaAE10 = _data["avansiranaOsnovicaAE10"];
            this.avansiranaOsnovicaAE20 = _data["avansiranaOsnovicaAE20"];
            this.avansiranaOsnovicaO = _data["avansiranaOsnovicaO"];
            this.avansiranaOsnovicaE = _data["avansiranaOsnovicaE"];
            this.avansiranaOsnovicaR = _data["avansiranaOsnovicaR"];
            this.avansiranaOsnovicaZ = _data["avansiranaOsnovicaZ"];
            this.avansiranaOsnovicaSS = _data["avansiranaOsnovicaSS"];
            this.avansiranaOsnovicaOE = _data["avansiranaOsnovicaOE"];
            this.avansiranaOsnovicaN = _data["avansiranaOsnovicaN"];
            this.ukupanAvansiranIznos = _data["ukupanAvansiranIznos"];
            this.umanjenaOsnovicaS = _data["umanjenaOsnovicaS"];
            this.umanjenaOsnovica8 = _data["umanjenaOsnovica8"];
            this.umanjenaOsnovica10 = _data["umanjenaOsnovica10"];
            this.umanjenaOsnovica20 = _data["umanjenaOsnovica20"];
            this.umanjenaOsnovicaAE = _data["umanjenaOsnovicaAE"];
            this.umanjenaOsnovicaAE10 = _data["umanjenaOsnovicaAE10"];
            this.umanjenaOsnovicaAE20 = _data["umanjenaOsnovicaAE20"];
            this.umanjenaOsnovicaO = _data["umanjenaOsnovicaO"];
            this.umanjenaOsnovicaE = _data["umanjenaOsnovicaE"];
            this.umanjenaOsnovicaR = _data["umanjenaOsnovicaR"];
            this.umanjenaOsnovicaZ = _data["umanjenaOsnovicaZ"];
            this.umanjenaOsnovicaSS = _data["umanjenaOsnovicaSS"];
            this.umanjenaOsnovicaOE = _data["umanjenaOsnovicaOE"];
            this.umanjenaOsnovicaN = _data["umanjenaOsnovicaN"];
            this.ukupnoPdvUmanjenZaAvanse8 = _data["ukupnoPdvUmanjenZaAvanse8"];
            this.ukupnoPdvUmanjenZaAvanse10 = _data["ukupnoPdvUmanjenZaAvanse10"];
            this.ukupnoPdvUmanjenZaAvanse20 = _data["ukupnoPdvUmanjenZaAvanse20"];
            this.iznosZaZaokruzivanje = _data["iznosZaZaokruzivanje"];
            this.ukupnoZaUplatu = _data["ukupnoZaUplatu"];
        }
    }

    static fromJS(data: any): RacunUkupanIznosDto {
        data = typeof data === 'object' ? data : {};
        let result = new RacunUkupanIznosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zbirStavkiS"] = this.zbirStavkiS;
        data["zbirStavki8"] = this.zbirStavki8;
        data["zbirStavki10"] = this.zbirStavki10;
        data["zbirStavki20"] = this.zbirStavki20;
        data["zbirStavkiAE"] = this.zbirStavkiAE;
        data["zbirStavkiAE10"] = this.zbirStavkiAE10;
        data["zbirStavkiAE20"] = this.zbirStavkiAE20;
        data["zbirStavkiO"] = this.zbirStavkiO;
        data["zbirStavkiE"] = this.zbirStavkiE;
        data["zbirStavkiR"] = this.zbirStavkiR;
        data["zbirStavkiZ"] = this.zbirStavkiZ;
        data["zbirStavkiSS"] = this.zbirStavkiSS;
        data["zbirStavkiOE"] = this.zbirStavkiOE;
        data["zbirStavkiN"] = this.zbirStavkiN;
        data["smanjenjeNaknade8"] = this.smanjenjeNaknade8;
        data["smanjenjeNaknade10"] = this.smanjenjeNaknade10;
        data["smanjenjeNaknade20"] = this.smanjenjeNaknade20;
        data["smanjenjeNaknadeAE"] = this.smanjenjeNaknadeAE;
        data["smanjenjeNaknadeAE10"] = this.smanjenjeNaknadeAE10;
        data["smanjenjeNaknadeAE20"] = this.smanjenjeNaknadeAE20;
        data["smanjenjeNaknadeO"] = this.smanjenjeNaknadeO;
        data["smanjenjeNaknadeE"] = this.smanjenjeNaknadeE;
        data["smanjenjeNaknadeR"] = this.smanjenjeNaknadeR;
        data["smanjenjeNaknadeZ"] = this.smanjenjeNaknadeZ;
        data["smanjenjeNaknadeSS"] = this.smanjenjeNaknadeSS;
        data["smanjenjeNaknadeOE"] = this.smanjenjeNaknadeOE;
        data["smanjenjeNaknadeN"] = this.smanjenjeNaknadeN;
        data["ukupnoOsnovica8"] = this.ukupnoOsnovica8;
        data["ukupnoOsnovica10"] = this.ukupnoOsnovica10;
        data["ukupnoOsnovica20"] = this.ukupnoOsnovica20;
        data["ukupnoOsnovicaAE"] = this.ukupnoOsnovicaAE;
        data["ukupnoOsnovicaAE10"] = this.ukupnoOsnovicaAE10;
        data["ukupnoOsnovicaAE20"] = this.ukupnoOsnovicaAE20;
        data["ukupnoOsnovicaO"] = this.ukupnoOsnovicaO;
        data["ukupnoOsnovicaE"] = this.ukupnoOsnovicaE;
        data["ukupnoOsnovicaR"] = this.ukupnoOsnovicaR;
        data["ukupnoOsnovicaZ"] = this.ukupnoOsnovicaZ;
        data["ukupnoOsnovicaSS"] = this.ukupnoOsnovicaSS;
        data["ukupnoOsnovicaOE"] = this.ukupnoOsnovicaOE;
        data["ukupnoOsnovicaN"] = this.ukupnoOsnovicaN;
        data["ukupnoPdv8"] = this.ukupnoPdv8;
        data["ukupnoPdv10"] = this.ukupnoPdv10;
        data["ukupnoPdv20"] = this.ukupnoPdv20;
        data["rsdUkupnoOsnovica8"] = this.rsdUkupnoOsnovica8;
        data["rsdUkupnoOsnovica10"] = this.rsdUkupnoOsnovica10;
        data["rsdUkupnoOsnovica20"] = this.rsdUkupnoOsnovica20;
        data["rsdUkupnoOsnovicaAE"] = this.rsdUkupnoOsnovicaAE;
        data["rsdUkupnoOsnovicaAE10"] = this.rsdUkupnoOsnovicaAE10;
        data["rsdUkupnoOsnovicaAE20"] = this.rsdUkupnoOsnovicaAE20;
        data["rsdUkupnoOsnovicaO"] = this.rsdUkupnoOsnovicaO;
        data["rsdUkupnoOsnovicaE"] = this.rsdUkupnoOsnovicaE;
        data["rsdUkupnoOsnovicaR"] = this.rsdUkupnoOsnovicaR;
        data["rsdUkupnoOsnovicaZ"] = this.rsdUkupnoOsnovicaZ;
        data["rsdUkupnoOsnovicaSS"] = this.rsdUkupnoOsnovicaSS;
        data["rsdUkupnoOsnovicaOE"] = this.rsdUkupnoOsnovicaOE;
        data["rsdUkupnoOsnovicaN"] = this.rsdUkupnoOsnovicaN;
        data["rsdUkupnoPdv8"] = this.rsdUkupnoPdv8;
        data["rsdUkupnoPdv10"] = this.rsdUkupnoPdv10;
        data["rsdUkupnoPdv20"] = this.rsdUkupnoPdv20;
        data["avansiraniPdv8"] = this.avansiraniPdv8;
        data["avansiraniPdv10"] = this.avansiraniPdv10;
        data["avansiraniPdv20"] = this.avansiraniPdv20;
        data["avansiranaOsnovicaS"] = this.avansiranaOsnovicaS;
        data["avansiranaOsnovica8"] = this.avansiranaOsnovica8;
        data["avansiranaOsnovica10"] = this.avansiranaOsnovica10;
        data["avansiranaOsnovica20"] = this.avansiranaOsnovica20;
        data["avansiranaOsnovicaAE"] = this.avansiranaOsnovicaAE;
        data["avansiranaOsnovicaAE10"] = this.avansiranaOsnovicaAE10;
        data["avansiranaOsnovicaAE20"] = this.avansiranaOsnovicaAE20;
        data["avansiranaOsnovicaO"] = this.avansiranaOsnovicaO;
        data["avansiranaOsnovicaE"] = this.avansiranaOsnovicaE;
        data["avansiranaOsnovicaR"] = this.avansiranaOsnovicaR;
        data["avansiranaOsnovicaZ"] = this.avansiranaOsnovicaZ;
        data["avansiranaOsnovicaSS"] = this.avansiranaOsnovicaSS;
        data["avansiranaOsnovicaOE"] = this.avansiranaOsnovicaOE;
        data["avansiranaOsnovicaN"] = this.avansiranaOsnovicaN;
        data["ukupanAvansiranIznos"] = this.ukupanAvansiranIznos;
        data["umanjenaOsnovicaS"] = this.umanjenaOsnovicaS;
        data["umanjenaOsnovica8"] = this.umanjenaOsnovica8;
        data["umanjenaOsnovica10"] = this.umanjenaOsnovica10;
        data["umanjenaOsnovica20"] = this.umanjenaOsnovica20;
        data["umanjenaOsnovicaAE"] = this.umanjenaOsnovicaAE;
        data["umanjenaOsnovicaAE10"] = this.umanjenaOsnovicaAE10;
        data["umanjenaOsnovicaAE20"] = this.umanjenaOsnovicaAE20;
        data["umanjenaOsnovicaO"] = this.umanjenaOsnovicaO;
        data["umanjenaOsnovicaE"] = this.umanjenaOsnovicaE;
        data["umanjenaOsnovicaR"] = this.umanjenaOsnovicaR;
        data["umanjenaOsnovicaZ"] = this.umanjenaOsnovicaZ;
        data["umanjenaOsnovicaSS"] = this.umanjenaOsnovicaSS;
        data["umanjenaOsnovicaOE"] = this.umanjenaOsnovicaOE;
        data["umanjenaOsnovicaN"] = this.umanjenaOsnovicaN;
        data["ukupnoPdvUmanjenZaAvanse8"] = this.ukupnoPdvUmanjenZaAvanse8;
        data["ukupnoPdvUmanjenZaAvanse10"] = this.ukupnoPdvUmanjenZaAvanse10;
        data["ukupnoPdvUmanjenZaAvanse20"] = this.ukupnoPdvUmanjenZaAvanse20;
        data["iznosZaZaokruzivanje"] = this.iznosZaZaokruzivanje;
        data["ukupnoZaUplatu"] = this.ukupnoZaUplatu;
        return data;
    }
}

export interface IRacunUkupanIznosDto {
    zbirStavkiS?: number | undefined;
    zbirStavki8?: number | undefined;
    zbirStavki10?: number | undefined;
    zbirStavki20?: number | undefined;
    zbirStavkiAE?: number | undefined;
    zbirStavkiAE10?: number | undefined;
    zbirStavkiAE20?: number | undefined;
    zbirStavkiO?: number | undefined;
    zbirStavkiE?: number | undefined;
    zbirStavkiR?: number | undefined;
    zbirStavkiZ?: number | undefined;
    zbirStavkiSS?: number | undefined;
    zbirStavkiOE?: number | undefined;
    zbirStavkiN?: number | undefined;
    smanjenjeNaknade8?: number | undefined;
    smanjenjeNaknade10?: number | undefined;
    smanjenjeNaknade20?: number | undefined;
    smanjenjeNaknadeAE?: number | undefined;
    smanjenjeNaknadeAE10?: number | undefined;
    smanjenjeNaknadeAE20?: number | undefined;
    smanjenjeNaknadeO?: number | undefined;
    smanjenjeNaknadeE?: number | undefined;
    smanjenjeNaknadeR?: number | undefined;
    smanjenjeNaknadeZ?: number | undefined;
    smanjenjeNaknadeSS?: number | undefined;
    smanjenjeNaknadeOE?: number | undefined;
    smanjenjeNaknadeN?: number | undefined;
    ukupnoOsnovica8?: number | undefined;
    ukupnoOsnovica10?: number | undefined;
    ukupnoOsnovica20?: number | undefined;
    ukupnoOsnovicaAE?: number | undefined;
    ukupnoOsnovicaAE10?: number | undefined;
    ukupnoOsnovicaAE20?: number | undefined;
    ukupnoOsnovicaO?: number | undefined;
    ukupnoOsnovicaE?: number | undefined;
    ukupnoOsnovicaR?: number | undefined;
    ukupnoOsnovicaZ?: number | undefined;
    ukupnoOsnovicaSS?: number | undefined;
    ukupnoOsnovicaOE?: number | undefined;
    ukupnoOsnovicaN?: number | undefined;
    ukupnoPdv8?: number | undefined;
    ukupnoPdv10?: number | undefined;
    ukupnoPdv20?: number | undefined;
    rsdUkupnoOsnovica8?: number | undefined;
    rsdUkupnoOsnovica10?: number | undefined;
    rsdUkupnoOsnovica20?: number | undefined;
    rsdUkupnoOsnovicaAE?: number | undefined;
    rsdUkupnoOsnovicaAE10?: number | undefined;
    rsdUkupnoOsnovicaAE20?: number | undefined;
    rsdUkupnoOsnovicaO?: number | undefined;
    rsdUkupnoOsnovicaE?: number | undefined;
    rsdUkupnoOsnovicaR?: number | undefined;
    rsdUkupnoOsnovicaZ?: number | undefined;
    rsdUkupnoOsnovicaSS?: number | undefined;
    rsdUkupnoOsnovicaOE?: number | undefined;
    rsdUkupnoOsnovicaN?: number | undefined;
    rsdUkupnoPdv8?: number | undefined;
    rsdUkupnoPdv10?: number | undefined;
    rsdUkupnoPdv20?: number | undefined;
    avansiraniPdv8?: number | undefined;
    avansiraniPdv10?: number | undefined;
    avansiraniPdv20?: number | undefined;
    avansiranaOsnovicaS?: number | undefined;
    avansiranaOsnovica8?: number | undefined;
    avansiranaOsnovica10?: number | undefined;
    avansiranaOsnovica20?: number | undefined;
    avansiranaOsnovicaAE?: number | undefined;
    avansiranaOsnovicaAE10?: number | undefined;
    avansiranaOsnovicaAE20?: number | undefined;
    avansiranaOsnovicaO?: number | undefined;
    avansiranaOsnovicaE?: number | undefined;
    avansiranaOsnovicaR?: number | undefined;
    avansiranaOsnovicaZ?: number | undefined;
    avansiranaOsnovicaSS?: number | undefined;
    avansiranaOsnovicaOE?: number | undefined;
    avansiranaOsnovicaN?: number | undefined;
    ukupanAvansiranIznos?: number | undefined;
    umanjenaOsnovicaS?: number | undefined;
    umanjenaOsnovica8?: number | undefined;
    umanjenaOsnovica10?: number | undefined;
    umanjenaOsnovica20?: number | undefined;
    umanjenaOsnovicaAE?: number | undefined;
    umanjenaOsnovicaAE10?: number | undefined;
    umanjenaOsnovicaAE20?: number | undefined;
    umanjenaOsnovicaO?: number | undefined;
    umanjenaOsnovicaE?: number | undefined;
    umanjenaOsnovicaR?: number | undefined;
    umanjenaOsnovicaZ?: number | undefined;
    umanjenaOsnovicaSS?: number | undefined;
    umanjenaOsnovicaOE?: number | undefined;
    umanjenaOsnovicaN?: number | undefined;
    ukupnoPdvUmanjenZaAvanse8?: number | undefined;
    ukupnoPdvUmanjenZaAvanse10?: number | undefined;
    ukupnoPdvUmanjenZaAvanse20?: number | undefined;
    iznosZaZaokruzivanje?: number | undefined;
    ukupnoZaUplatu?: number;
}

export class FileAttachment implements IFileAttachment {
    path?: string | undefined;
    name?: string | undefined;
    contentType?: string | undefined;
    tip?: TipRelevantnogDokumenta;
    isMainAttachment?: boolean;

    constructor(data?: IFileAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"];
            this.name = _data["name"];
            this.contentType = _data["contentType"];
            this.tip = _data["tip"];
            this.isMainAttachment = _data["isMainAttachment"];
        }
    }

    static fromJS(data: any): FileAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new FileAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        data["name"] = this.name;
        data["contentType"] = this.contentType;
        data["tip"] = this.tip;
        data["isMainAttachment"] = this.isMainAttachment;
        return data;
    }
}

export interface IFileAttachment {
    path?: string | undefined;
    name?: string | undefined;
    contentType?: string | undefined;
    tip?: TipRelevantnogDokumenta;
    isMainAttachment?: boolean;
}

export enum TipRelevantnogDokumenta {
    EMPTY = 0,
    FAKTURA_RS = 1,
    FAKTURA_US = 2,
    DODATNI_PRILOG = 3,
    IZJAVA_ODBITAK_PDV = 4,
    FISKALNI_ISECAK = 5,
    FISKALNI_A4 = 6,
    FISKALNI_QR = 7,
    SEF_FAKTURA_RS = 8,
    OTPREMNICA = 9,
    PRIJEMNICA = 10,
}

export enum KlasifikacijaRacuna {
    FAKTURA = 0,
    RACUN = 1,
    DRUGO = 2,
}

export enum PravoNaPdvOdbitak {
    IMA = 0,
    NEMA = 1,
    DELIMICNO = 2,
}

export class UpdateAvansniRacunCommand implements IUpdateAvansniRacunCommand {
    racunDto?: RacunDto | undefined;
    preostaloPdv8?: number | undefined;
    preostaloPdv10?: number | undefined;
    preostaloPdv20?: number | undefined;
    preostaloUkupnoOsnovica8?: number | undefined;
    preostaloUkupnoOsnovica10?: number | undefined;
    preostaloUkupnoOsnovica20?: number | undefined;
    preostaloUkupnoOsnovicaAE10?: number | undefined;
    preostaloUkupnoOsnovicaAE20?: number | undefined;
    preostaloUkupnoOsnovicaO?: number | undefined;
    preostaloUkupnoOsnovicaE?: number | undefined;
    preostaloUkupnoOsnovicaR?: number | undefined;
    preostaloUkupnoOsnovicaZ?: number | undefined;
    preostaloUkupnoOsnovicaSS?: number | undefined;
    preostaloUkupnoOsnovicaOE?: number | undefined;
    preostaloUkupnoOsnovicaN?: number | undefined;
    ukupanIznosUplate?: number | undefined;
    predracunIds?: number[] | undefined;
    uplataId?: number | undefined;

    constructor(data?: IUpdateAvansniRacunCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.preostaloPdv8 = _data["preostaloPdv8"];
            this.preostaloPdv10 = _data["preostaloPdv10"];
            this.preostaloPdv20 = _data["preostaloPdv20"];
            this.preostaloUkupnoOsnovica8 = _data["preostaloUkupnoOsnovica8"];
            this.preostaloUkupnoOsnovica10 = _data["preostaloUkupnoOsnovica10"];
            this.preostaloUkupnoOsnovica20 = _data["preostaloUkupnoOsnovica20"];
            this.preostaloUkupnoOsnovicaAE10 = _data["preostaloUkupnoOsnovicaAE10"];
            this.preostaloUkupnoOsnovicaAE20 = _data["preostaloUkupnoOsnovicaAE20"];
            this.preostaloUkupnoOsnovicaO = _data["preostaloUkupnoOsnovicaO"];
            this.preostaloUkupnoOsnovicaE = _data["preostaloUkupnoOsnovicaE"];
            this.preostaloUkupnoOsnovicaR = _data["preostaloUkupnoOsnovicaR"];
            this.preostaloUkupnoOsnovicaZ = _data["preostaloUkupnoOsnovicaZ"];
            this.preostaloUkupnoOsnovicaSS = _data["preostaloUkupnoOsnovicaSS"];
            this.preostaloUkupnoOsnovicaOE = _data["preostaloUkupnoOsnovicaOE"];
            this.preostaloUkupnoOsnovicaN = _data["preostaloUkupnoOsnovicaN"];
            this.ukupanIznosUplate = _data["ukupanIznosUplate"];
            if (Array.isArray(_data["predracunIds"])) {
                this.predracunIds = [] as any;
                for (let item of _data["predracunIds"])
                    this.predracunIds!.push(item);
            }
            this.uplataId = _data["uplataId"];
        }
    }

    static fromJS(data: any): UpdateAvansniRacunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAvansniRacunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["preostaloPdv8"] = this.preostaloPdv8;
        data["preostaloPdv10"] = this.preostaloPdv10;
        data["preostaloPdv20"] = this.preostaloPdv20;
        data["preostaloUkupnoOsnovica8"] = this.preostaloUkupnoOsnovica8;
        data["preostaloUkupnoOsnovica10"] = this.preostaloUkupnoOsnovica10;
        data["preostaloUkupnoOsnovica20"] = this.preostaloUkupnoOsnovica20;
        data["preostaloUkupnoOsnovicaAE10"] = this.preostaloUkupnoOsnovicaAE10;
        data["preostaloUkupnoOsnovicaAE20"] = this.preostaloUkupnoOsnovicaAE20;
        data["preostaloUkupnoOsnovicaO"] = this.preostaloUkupnoOsnovicaO;
        data["preostaloUkupnoOsnovicaE"] = this.preostaloUkupnoOsnovicaE;
        data["preostaloUkupnoOsnovicaR"] = this.preostaloUkupnoOsnovicaR;
        data["preostaloUkupnoOsnovicaZ"] = this.preostaloUkupnoOsnovicaZ;
        data["preostaloUkupnoOsnovicaSS"] = this.preostaloUkupnoOsnovicaSS;
        data["preostaloUkupnoOsnovicaOE"] = this.preostaloUkupnoOsnovicaOE;
        data["preostaloUkupnoOsnovicaN"] = this.preostaloUkupnoOsnovicaN;
        data["ukupanIznosUplate"] = this.ukupanIznosUplate;
        if (Array.isArray(this.predracunIds)) {
            data["predracunIds"] = [];
            for (let item of this.predracunIds)
                data["predracunIds"].push(item);
        }
        data["uplataId"] = this.uplataId;
        return data;
    }
}

export interface IUpdateAvansniRacunCommand {
    racunDto?: RacunDto | undefined;
    preostaloPdv8?: number | undefined;
    preostaloPdv10?: number | undefined;
    preostaloPdv20?: number | undefined;
    preostaloUkupnoOsnovica8?: number | undefined;
    preostaloUkupnoOsnovica10?: number | undefined;
    preostaloUkupnoOsnovica20?: number | undefined;
    preostaloUkupnoOsnovicaAE10?: number | undefined;
    preostaloUkupnoOsnovicaAE20?: number | undefined;
    preostaloUkupnoOsnovicaO?: number | undefined;
    preostaloUkupnoOsnovicaE?: number | undefined;
    preostaloUkupnoOsnovicaR?: number | undefined;
    preostaloUkupnoOsnovicaZ?: number | undefined;
    preostaloUkupnoOsnovicaSS?: number | undefined;
    preostaloUkupnoOsnovicaOE?: number | undefined;
    preostaloUkupnoOsnovicaN?: number | undefined;
    ukupanIznosUplate?: number | undefined;
    predracunIds?: number[] | undefined;
    uplataId?: number | undefined;
}

export class ResultOfAvansniRacunDto extends Result implements IResultOfAvansniRacunDto {
    data?: AvansniRacunDto | undefined;

    constructor(data?: IResultOfAvansniRacunDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? AvansniRacunDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfAvansniRacunDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfAvansniRacunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfAvansniRacunDto extends IResult {
    data?: AvansniRacunDto | undefined;
}

export class AvansniRacunDto implements IAvansniRacunDto {
    racunDto?: RacunDto | undefined;
    preostaloPdv8?: number | undefined;
    preostaloPdv10?: number | undefined;
    preostaloPdv20?: number | undefined;
    preostaloUkupnoOsnovica8?: number | undefined;
    preostaloUkupnoOsnovica10?: number | undefined;
    preostaloUkupnoOsnovica20?: number | undefined;
    preostaloUkupnoOsnovicaAE10?: number | undefined;
    preostaloUkupnoOsnovicaAE20?: number | undefined;
    preostaloUkupnoOsnovicaO?: number | undefined;
    preostaloUkupnoOsnovicaE?: number | undefined;
    preostaloUkupnoOsnovicaR?: number | undefined;
    preostaloUkupnoOsnovicaZ?: number | undefined;
    preostaloUkupnoOsnovicaSS?: number | undefined;
    preostaloUkupnoOsnovicaOE?: number | undefined;
    preostaloUkupnoOsnovicaN?: number | undefined;
    ukupanIznosUplate?: number | undefined;
    predracunIds?: number[] | undefined;
    uplataId?: number | undefined;

    constructor(data?: IAvansniRacunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.preostaloPdv8 = _data["preostaloPdv8"];
            this.preostaloPdv10 = _data["preostaloPdv10"];
            this.preostaloPdv20 = _data["preostaloPdv20"];
            this.preostaloUkupnoOsnovica8 = _data["preostaloUkupnoOsnovica8"];
            this.preostaloUkupnoOsnovica10 = _data["preostaloUkupnoOsnovica10"];
            this.preostaloUkupnoOsnovica20 = _data["preostaloUkupnoOsnovica20"];
            this.preostaloUkupnoOsnovicaAE10 = _data["preostaloUkupnoOsnovicaAE10"];
            this.preostaloUkupnoOsnovicaAE20 = _data["preostaloUkupnoOsnovicaAE20"];
            this.preostaloUkupnoOsnovicaO = _data["preostaloUkupnoOsnovicaO"];
            this.preostaloUkupnoOsnovicaE = _data["preostaloUkupnoOsnovicaE"];
            this.preostaloUkupnoOsnovicaR = _data["preostaloUkupnoOsnovicaR"];
            this.preostaloUkupnoOsnovicaZ = _data["preostaloUkupnoOsnovicaZ"];
            this.preostaloUkupnoOsnovicaSS = _data["preostaloUkupnoOsnovicaSS"];
            this.preostaloUkupnoOsnovicaOE = _data["preostaloUkupnoOsnovicaOE"];
            this.preostaloUkupnoOsnovicaN = _data["preostaloUkupnoOsnovicaN"];
            this.ukupanIznosUplate = _data["ukupanIznosUplate"];
            if (Array.isArray(_data["predracunIds"])) {
                this.predracunIds = [] as any;
                for (let item of _data["predracunIds"])
                    this.predracunIds!.push(item);
            }
            this.uplataId = _data["uplataId"];
        }
    }

    static fromJS(data: any): AvansniRacunDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvansniRacunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["preostaloPdv8"] = this.preostaloPdv8;
        data["preostaloPdv10"] = this.preostaloPdv10;
        data["preostaloPdv20"] = this.preostaloPdv20;
        data["preostaloUkupnoOsnovica8"] = this.preostaloUkupnoOsnovica8;
        data["preostaloUkupnoOsnovica10"] = this.preostaloUkupnoOsnovica10;
        data["preostaloUkupnoOsnovica20"] = this.preostaloUkupnoOsnovica20;
        data["preostaloUkupnoOsnovicaAE10"] = this.preostaloUkupnoOsnovicaAE10;
        data["preostaloUkupnoOsnovicaAE20"] = this.preostaloUkupnoOsnovicaAE20;
        data["preostaloUkupnoOsnovicaO"] = this.preostaloUkupnoOsnovicaO;
        data["preostaloUkupnoOsnovicaE"] = this.preostaloUkupnoOsnovicaE;
        data["preostaloUkupnoOsnovicaR"] = this.preostaloUkupnoOsnovicaR;
        data["preostaloUkupnoOsnovicaZ"] = this.preostaloUkupnoOsnovicaZ;
        data["preostaloUkupnoOsnovicaSS"] = this.preostaloUkupnoOsnovicaSS;
        data["preostaloUkupnoOsnovicaOE"] = this.preostaloUkupnoOsnovicaOE;
        data["preostaloUkupnoOsnovicaN"] = this.preostaloUkupnoOsnovicaN;
        data["ukupanIznosUplate"] = this.ukupanIznosUplate;
        if (Array.isArray(this.predracunIds)) {
            data["predracunIds"] = [];
            for (let item of this.predracunIds)
                data["predracunIds"].push(item);
        }
        data["uplataId"] = this.uplataId;
        return data;
    }
}

export interface IAvansniRacunDto {
    racunDto?: RacunDto | undefined;
    preostaloPdv8?: number | undefined;
    preostaloPdv10?: number | undefined;
    preostaloPdv20?: number | undefined;
    preostaloUkupnoOsnovica8?: number | undefined;
    preostaloUkupnoOsnovica10?: number | undefined;
    preostaloUkupnoOsnovica20?: number | undefined;
    preostaloUkupnoOsnovicaAE10?: number | undefined;
    preostaloUkupnoOsnovicaAE20?: number | undefined;
    preostaloUkupnoOsnovicaO?: number | undefined;
    preostaloUkupnoOsnovicaE?: number | undefined;
    preostaloUkupnoOsnovicaR?: number | undefined;
    preostaloUkupnoOsnovicaZ?: number | undefined;
    preostaloUkupnoOsnovicaSS?: number | undefined;
    preostaloUkupnoOsnovicaOE?: number | undefined;
    preostaloUkupnoOsnovicaN?: number | undefined;
    ukupanIznosUplate?: number | undefined;
    predracunIds?: number[] | undefined;
    uplataId?: number | undefined;
}

export class GetAvansniRacunQuery implements IGetAvansniRacunQuery {
    id?: number;

    constructor(data?: IGetAvansniRacunQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetAvansniRacunQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvansniRacunQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetAvansniRacunQuery {
    id?: number;
}

export class GetNewAvansniRacunForTransakcijuIzvodaQuery implements IGetNewAvansniRacunForTransakcijuIzvodaQuery {
    strankaId?: number | undefined;
    transakcijaIzvodaId?: number;
    datumPrometa?: Date | undefined;
    datumIzdavanja?: Date | undefined;
    vrstaRacuna?: VrstaRacuna;
    stopaPdv?: number;

    constructor(data?: IGetNewAvansniRacunForTransakcijuIzvodaQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.strankaId = _data["strankaId"];
            this.transakcijaIzvodaId = _data["transakcijaIzvodaId"];
            this.datumPrometa = _data["datumPrometa"] ? new Date(_data["datumPrometa"].toString()) : <any>undefined;
            this.datumIzdavanja = _data["datumIzdavanja"] ? new Date(_data["datumIzdavanja"].toString()) : <any>undefined;
            this.vrstaRacuna = _data["vrstaRacuna"];
            this.stopaPdv = _data["stopaPdv"];
        }
    }

    static fromJS(data: any): GetNewAvansniRacunForTransakcijuIzvodaQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewAvansniRacunForTransakcijuIzvodaQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["strankaId"] = this.strankaId;
        data["transakcijaIzvodaId"] = this.transakcijaIzvodaId;
        data["datumPrometa"] = this.datumPrometa ? this.datumPrometa.toISOString() : <any>undefined;
        data["datumIzdavanja"] = this.datumIzdavanja ? this.datumIzdavanja.toISOString() : <any>undefined;
        data["vrstaRacuna"] = this.vrstaRacuna;
        data["stopaPdv"] = this.stopaPdv;
        return data;
    }
}

export interface IGetNewAvansniRacunForTransakcijuIzvodaQuery {
    strankaId?: number | undefined;
    transakcijaIzvodaId?: number;
    datumPrometa?: Date | undefined;
    datumIzdavanja?: Date | undefined;
    vrstaRacuna?: VrstaRacuna;
    stopaPdv?: number;
}

export class GetNewAvansniForStopaPdvQuery implements IGetNewAvansniForStopaPdvQuery {
    vrstaRacuna?: VrstaRacuna;
    stopaPdv?: number;
    strankaId?: string | undefined;

    constructor(data?: IGetNewAvansniForStopaPdvQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vrstaRacuna = _data["vrstaRacuna"];
            this.stopaPdv = _data["stopaPdv"];
            this.strankaId = _data["strankaId"];
        }
    }

    static fromJS(data: any): GetNewAvansniForStopaPdvQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewAvansniForStopaPdvQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vrstaRacuna"] = this.vrstaRacuna;
        data["stopaPdv"] = this.stopaPdv;
        data["strankaId"] = this.strankaId;
        return data;
    }
}

export interface IGetNewAvansniForStopaPdvQuery {
    vrstaRacuna?: VrstaRacuna;
    stopaPdv?: number;
    strankaId?: string | undefined;
}

export class ResultOfGetTableResponseOfAvansnaUplataRacunaTableDto extends Result implements IResultOfGetTableResponseOfAvansnaUplataRacunaTableDto {
    data?: GetTableResponseOfAvansnaUplataRacunaTableDto | undefined;

    constructor(data?: IResultOfGetTableResponseOfAvansnaUplataRacunaTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetTableResponseOfAvansnaUplataRacunaTableDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetTableResponseOfAvansnaUplataRacunaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetTableResponseOfAvansnaUplataRacunaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetTableResponseOfAvansnaUplataRacunaTableDto extends IResult {
    data?: GetTableResponseOfAvansnaUplataRacunaTableDto | undefined;
}

export class GetTableResponseOfAvansnaUplataRacunaTableDto implements IGetTableResponseOfAvansnaUplataRacunaTableDto {
    responseList?: AvansnaUplataRacunaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;

    constructor(data?: IGetTableResponseOfAvansnaUplataRacunaTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(AvansnaUplataRacunaTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTableResponseOfAvansnaUplataRacunaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTableResponseOfAvansnaUplataRacunaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTableResponseOfAvansnaUplataRacunaTableDto {
    responseList?: AvansnaUplataRacunaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
}

export class GetAvansnaUplataRacunaTableQuery implements IGetAvansnaUplataRacunaTableQuery {
    racunId?: number | undefined;

    constructor(data?: IGetAvansnaUplataRacunaTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
        }
    }

    static fromJS(data: any): GetAvansnaUplataRacunaTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvansnaUplataRacunaTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        return data;
    }
}

export interface IGetAvansnaUplataRacunaTableQuery {
    racunId?: number | undefined;
}

export class ResultOfGetTableResponseOfAvansniRacunTableDto extends Result implements IResultOfGetTableResponseOfAvansniRacunTableDto {
    data?: GetTableResponseOfAvansniRacunTableDto | undefined;

    constructor(data?: IResultOfGetTableResponseOfAvansniRacunTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetTableResponseOfAvansniRacunTableDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetTableResponseOfAvansniRacunTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetTableResponseOfAvansniRacunTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetTableResponseOfAvansniRacunTableDto extends IResult {
    data?: GetTableResponseOfAvansniRacunTableDto | undefined;
}

export class GetTableResponseOfAvansniRacunTableDto implements IGetTableResponseOfAvansniRacunTableDto {
    responseList?: AvansniRacunTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;

    constructor(data?: IGetTableResponseOfAvansniRacunTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(AvansniRacunTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTableResponseOfAvansniRacunTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTableResponseOfAvansniRacunTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTableResponseOfAvansniRacunTableDto {
    responseList?: AvansniRacunTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
}

export class AvansniRacunTableDto implements IAvansniRacunTableDto {
    id?: number;
    broj?: string | undefined;
    brojUgovora?: string | undefined;
    datumIzdavanja?: string | undefined;
    valuta?: string | undefined;
    vrsta?: VrstaRacuna;
    preostaloUkupnoOsnovica8?: number | undefined;
    preostaloUkupnoOsnovica10?: number | undefined;
    preostaloUkupnoOsnovica20?: number | undefined;
    pdv8?: number | undefined;
    pdv10?: number | undefined;
    pdv20?: number | undefined;
    preostaloUkupnoOsnovicaAE?: number | undefined;
    preostaloUkupnoOsnovicaAE10?: number | undefined;
    preostaloUkupnoOsnovicaAE20?: number | undefined;
    preostaloUkupnoOsnovicaO?: number | undefined;
    preostaloUkupnoOsnovicaE?: number | undefined;
    preostaloUkupnoOsnovicaR?: number | undefined;
    preostaloUkupnoOsnovicaZ?: number | undefined;
    preostaloUkupnoOsnovicaSS?: number | undefined;
    preostaloUkupnoOsnovicaOE?: number | undefined;
    preostaloUkupnoOsnovicaN?: number | undefined;
    ukupnaOsnovica8?: number | undefined;
    ukupnaOsnovica10?: number | undefined;
    ukupnaOsnovica20?: number | undefined;
    ukupnoPdv8?: number | undefined;
    ukupnoPdv10?: number | undefined;
    ukupnoPdv20?: number | undefined;
    ukupnaOsnovicaAE?: number | undefined;
    ukupnaOsnovicaAE10?: number | undefined;
    ukupnaOsnovicaAE20?: number | undefined;
    ukupnaOsnovicaO?: number | undefined;
    ukupnaOsnovicaE?: number | undefined;
    ukupnaOsnovicaR?: number | undefined;
    ukupnaOsnovicaZ?: number | undefined;
    ukupnaOsnovicaSS?: number | undefined;
    ukupnaOsnovicaOE?: number | undefined;
    ukupnaOsnovicaN?: number | undefined;

    constructor(data?: IAvansniRacunTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.brojUgovora = _data["brojUgovora"];
            this.datumIzdavanja = _data["datumIzdavanja"];
            this.valuta = _data["valuta"];
            this.vrsta = _data["vrsta"];
            this.preostaloUkupnoOsnovica8 = _data["preostaloUkupnoOsnovica8"];
            this.preostaloUkupnoOsnovica10 = _data["preostaloUkupnoOsnovica10"];
            this.preostaloUkupnoOsnovica20 = _data["preostaloUkupnoOsnovica20"];
            this.pdv8 = _data["pdv8"];
            this.pdv10 = _data["pdv10"];
            this.pdv20 = _data["pdv20"];
            this.preostaloUkupnoOsnovicaAE = _data["preostaloUkupnoOsnovicaAE"];
            this.preostaloUkupnoOsnovicaAE10 = _data["preostaloUkupnoOsnovicaAE10"];
            this.preostaloUkupnoOsnovicaAE20 = _data["preostaloUkupnoOsnovicaAE20"];
            this.preostaloUkupnoOsnovicaO = _data["preostaloUkupnoOsnovicaO"];
            this.preostaloUkupnoOsnovicaE = _data["preostaloUkupnoOsnovicaE"];
            this.preostaloUkupnoOsnovicaR = _data["preostaloUkupnoOsnovicaR"];
            this.preostaloUkupnoOsnovicaZ = _data["preostaloUkupnoOsnovicaZ"];
            this.preostaloUkupnoOsnovicaSS = _data["preostaloUkupnoOsnovicaSS"];
            this.preostaloUkupnoOsnovicaOE = _data["preostaloUkupnoOsnovicaOE"];
            this.preostaloUkupnoOsnovicaN = _data["preostaloUkupnoOsnovicaN"];
            this.ukupnaOsnovica8 = _data["ukupnaOsnovica8"];
            this.ukupnaOsnovica10 = _data["ukupnaOsnovica10"];
            this.ukupnaOsnovica20 = _data["ukupnaOsnovica20"];
            this.ukupnoPdv8 = _data["ukupnoPdv8"];
            this.ukupnoPdv10 = _data["ukupnoPdv10"];
            this.ukupnoPdv20 = _data["ukupnoPdv20"];
            this.ukupnaOsnovicaAE = _data["ukupnaOsnovicaAE"];
            this.ukupnaOsnovicaAE10 = _data["ukupnaOsnovicaAE10"];
            this.ukupnaOsnovicaAE20 = _data["ukupnaOsnovicaAE20"];
            this.ukupnaOsnovicaO = _data["ukupnaOsnovicaO"];
            this.ukupnaOsnovicaE = _data["ukupnaOsnovicaE"];
            this.ukupnaOsnovicaR = _data["ukupnaOsnovicaR"];
            this.ukupnaOsnovicaZ = _data["ukupnaOsnovicaZ"];
            this.ukupnaOsnovicaSS = _data["ukupnaOsnovicaSS"];
            this.ukupnaOsnovicaOE = _data["ukupnaOsnovicaOE"];
            this.ukupnaOsnovicaN = _data["ukupnaOsnovicaN"];
        }
    }

    static fromJS(data: any): AvansniRacunTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvansniRacunTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["brojUgovora"] = this.brojUgovora;
        data["datumIzdavanja"] = this.datumIzdavanja;
        data["valuta"] = this.valuta;
        data["vrsta"] = this.vrsta;
        data["preostaloUkupnoOsnovica8"] = this.preostaloUkupnoOsnovica8;
        data["preostaloUkupnoOsnovica10"] = this.preostaloUkupnoOsnovica10;
        data["preostaloUkupnoOsnovica20"] = this.preostaloUkupnoOsnovica20;
        data["pdv8"] = this.pdv8;
        data["pdv10"] = this.pdv10;
        data["pdv20"] = this.pdv20;
        data["preostaloUkupnoOsnovicaAE"] = this.preostaloUkupnoOsnovicaAE;
        data["preostaloUkupnoOsnovicaAE10"] = this.preostaloUkupnoOsnovicaAE10;
        data["preostaloUkupnoOsnovicaAE20"] = this.preostaloUkupnoOsnovicaAE20;
        data["preostaloUkupnoOsnovicaO"] = this.preostaloUkupnoOsnovicaO;
        data["preostaloUkupnoOsnovicaE"] = this.preostaloUkupnoOsnovicaE;
        data["preostaloUkupnoOsnovicaR"] = this.preostaloUkupnoOsnovicaR;
        data["preostaloUkupnoOsnovicaZ"] = this.preostaloUkupnoOsnovicaZ;
        data["preostaloUkupnoOsnovicaSS"] = this.preostaloUkupnoOsnovicaSS;
        data["preostaloUkupnoOsnovicaOE"] = this.preostaloUkupnoOsnovicaOE;
        data["preostaloUkupnoOsnovicaN"] = this.preostaloUkupnoOsnovicaN;
        data["ukupnaOsnovica8"] = this.ukupnaOsnovica8;
        data["ukupnaOsnovica10"] = this.ukupnaOsnovica10;
        data["ukupnaOsnovica20"] = this.ukupnaOsnovica20;
        data["ukupnoPdv8"] = this.ukupnoPdv8;
        data["ukupnoPdv10"] = this.ukupnoPdv10;
        data["ukupnoPdv20"] = this.ukupnoPdv20;
        data["ukupnaOsnovicaAE"] = this.ukupnaOsnovicaAE;
        data["ukupnaOsnovicaAE10"] = this.ukupnaOsnovicaAE10;
        data["ukupnaOsnovicaAE20"] = this.ukupnaOsnovicaAE20;
        data["ukupnaOsnovicaO"] = this.ukupnaOsnovicaO;
        data["ukupnaOsnovicaE"] = this.ukupnaOsnovicaE;
        data["ukupnaOsnovicaR"] = this.ukupnaOsnovicaR;
        data["ukupnaOsnovicaZ"] = this.ukupnaOsnovicaZ;
        data["ukupnaOsnovicaSS"] = this.ukupnaOsnovicaSS;
        data["ukupnaOsnovicaOE"] = this.ukupnaOsnovicaOE;
        data["ukupnaOsnovicaN"] = this.ukupnaOsnovicaN;
        return data;
    }
}

export interface IAvansniRacunTableDto {
    id?: number;
    broj?: string | undefined;
    brojUgovora?: string | undefined;
    datumIzdavanja?: string | undefined;
    valuta?: string | undefined;
    vrsta?: VrstaRacuna;
    preostaloUkupnoOsnovica8?: number | undefined;
    preostaloUkupnoOsnovica10?: number | undefined;
    preostaloUkupnoOsnovica20?: number | undefined;
    pdv8?: number | undefined;
    pdv10?: number | undefined;
    pdv20?: number | undefined;
    preostaloUkupnoOsnovicaAE?: number | undefined;
    preostaloUkupnoOsnovicaAE10?: number | undefined;
    preostaloUkupnoOsnovicaAE20?: number | undefined;
    preostaloUkupnoOsnovicaO?: number | undefined;
    preostaloUkupnoOsnovicaE?: number | undefined;
    preostaloUkupnoOsnovicaR?: number | undefined;
    preostaloUkupnoOsnovicaZ?: number | undefined;
    preostaloUkupnoOsnovicaSS?: number | undefined;
    preostaloUkupnoOsnovicaOE?: number | undefined;
    preostaloUkupnoOsnovicaN?: number | undefined;
    ukupnaOsnovica8?: number | undefined;
    ukupnaOsnovica10?: number | undefined;
    ukupnaOsnovica20?: number | undefined;
    ukupnoPdv8?: number | undefined;
    ukupnoPdv10?: number | undefined;
    ukupnoPdv20?: number | undefined;
    ukupnaOsnovicaAE?: number | undefined;
    ukupnaOsnovicaAE10?: number | undefined;
    ukupnaOsnovicaAE20?: number | undefined;
    ukupnaOsnovicaO?: number | undefined;
    ukupnaOsnovicaE?: number | undefined;
    ukupnaOsnovicaR?: number | undefined;
    ukupnaOsnovicaZ?: number | undefined;
    ukupnaOsnovicaSS?: number | undefined;
    ukupnaOsnovicaOE?: number | undefined;
    ukupnaOsnovicaN?: number | undefined;
}

export class GetAvansniRacunTableQuery implements IGetAvansniRacunTableQuery {
    strankaId?: number | undefined;
    vrstaRacuna?: VrstaRacuna;
    samoAktivniRacuni?: boolean;
    pdvStope?: number[] | undefined;
    pdvKategorije?: OznakaPdvKategorije[] | undefined;

    constructor(data?: IGetAvansniRacunTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.strankaId = _data["strankaId"];
            this.vrstaRacuna = _data["vrstaRacuna"];
            this.samoAktivniRacuni = _data["samoAktivniRacuni"];
            if (Array.isArray(_data["pdvStope"])) {
                this.pdvStope = [] as any;
                for (let item of _data["pdvStope"])
                    this.pdvStope!.push(item);
            }
            if (Array.isArray(_data["pdvKategorije"])) {
                this.pdvKategorije = [] as any;
                for (let item of _data["pdvKategorije"])
                    this.pdvKategorije!.push(item);
            }
        }
    }

    static fromJS(data: any): GetAvansniRacunTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvansniRacunTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["strankaId"] = this.strankaId;
        data["vrstaRacuna"] = this.vrstaRacuna;
        data["samoAktivniRacuni"] = this.samoAktivniRacuni;
        if (Array.isArray(this.pdvStope)) {
            data["pdvStope"] = [];
            for (let item of this.pdvStope)
                data["pdvStope"].push(item);
        }
        if (Array.isArray(this.pdvKategorije)) {
            data["pdvKategorije"] = [];
            for (let item of this.pdvKategorije)
                data["pdvKategorije"].push(item);
        }
        return data;
    }
}

export interface IGetAvansniRacunTableQuery {
    strankaId?: number | undefined;
    vrstaRacuna?: VrstaRacuna;
    samoAktivniRacuni?: boolean;
    pdvStope?: number[] | undefined;
    pdvKategorije?: OznakaPdvKategorije[] | undefined;
}

export class GetNewAvansniFromPredracunUplataQuery implements IGetNewAvansniFromPredracunUplataQuery {
    predracunList?: UplataIsplataZaRacunDto[] | undefined;
    transakcijaIzvodaId?: number;

    constructor(data?: IGetNewAvansniFromPredracunUplataQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["predracunList"])) {
                this.predracunList = [] as any;
                for (let item of _data["predracunList"])
                    this.predracunList!.push(UplataIsplataZaRacunDto.fromJS(item));
            }
            this.transakcijaIzvodaId = _data["transakcijaIzvodaId"];
        }
    }

    static fromJS(data: any): GetNewAvansniFromPredracunUplataQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewAvansniFromPredracunUplataQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.predracunList)) {
            data["predracunList"] = [];
            for (let item of this.predracunList)
                data["predracunList"].push(item.toJSON());
        }
        data["transakcijaIzvodaId"] = this.transakcijaIzvodaId;
        return data;
    }
}

export interface IGetNewAvansniFromPredracunUplataQuery {
    predracunList?: UplataIsplataZaRacunDto[] | undefined;
    transakcijaIzvodaId?: number;
}

export class UplataIsplataZaRacunDto implements IUplataIsplataZaRacunDto {
    racunId?: number;
    iznos?: number;
    tipRacuna?: TipRacuna;

    constructor(data?: IUplataIsplataZaRacunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
            this.iznos = _data["iznos"];
            this.tipRacuna = _data["tipRacuna"];
        }
    }

    static fromJS(data: any): UplataIsplataZaRacunDto {
        data = typeof data === 'object' ? data : {};
        let result = new UplataIsplataZaRacunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        data["iznos"] = this.iznos;
        data["tipRacuna"] = this.tipRacuna;
        return data;
    }
}

export interface IUplataIsplataZaRacunDto {
    racunId?: number;
    iznos?: number;
    tipRacuna?: TipRacuna;
}

export class ResultOfBoolean extends Result implements IResultOfBoolean {
    data?: boolean;

    constructor(data?: IResultOfBoolean) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ResultOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfBoolean extends IResult {
    data?: boolean;
}

export class ResultOfCenovniciTableVm extends Result implements IResultOfCenovniciTableVm {
    data?: CenovniciTableVm | undefined;

    constructor(data?: IResultOfCenovniciTableVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? CenovniciTableVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfCenovniciTableVm {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfCenovniciTableVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfCenovniciTableVm extends IResult {
    data?: CenovniciTableVm | undefined;
}

export class CenovniciTableVm implements ICenovniciTableVm {
    cenovniciTable?: CenovnikTableDto[] | undefined;

    constructor(data?: ICenovniciTableVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cenovniciTable"])) {
                this.cenovniciTable = [] as any;
                for (let item of _data["cenovniciTable"])
                    this.cenovniciTable!.push(CenovnikTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CenovniciTableVm {
        data = typeof data === 'object' ? data : {};
        let result = new CenovniciTableVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cenovniciTable)) {
            data["cenovniciTable"] = [];
            for (let item of this.cenovniciTable)
                data["cenovniciTable"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICenovniciTableVm {
    cenovniciTable?: CenovnikTableDto[] | undefined;
}

export class CenovnikTableDto implements ICenovnikTableDto {
    id?: number;
    naziv?: string | undefined;
    vrstaEntiteta?: VrstaEntiteta;

    constructor(data?: ICenovnikTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.vrstaEntiteta = _data["vrstaEntiteta"];
        }
    }

    static fromJS(data: any): CenovnikTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CenovnikTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["vrstaEntiteta"] = this.vrstaEntiteta;
        return data;
    }
}

export interface ICenovnikTableDto {
    id?: number;
    naziv?: string | undefined;
    vrstaEntiteta?: VrstaEntiteta;
}

export enum VrstaEntiteta {
    SISTEMSKI = 0,
    KORISNICKI = 1,
}

export class GetCenovnikTableRequest implements IGetCenovnikTableRequest {
    strankaId?: number | undefined;
    naziv?: string | undefined;

    constructor(data?: IGetCenovnikTableRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.strankaId = _data["strankaId"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): GetCenovnikTableRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCenovnikTableRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["strankaId"] = this.strankaId;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IGetCenovnikTableRequest {
    strankaId?: number | undefined;
    naziv?: string | undefined;
}

export class GetCenovniciTableQuery extends GetCenovnikTableRequest implements IGetCenovniciTableQuery {

    constructor(data?: IGetCenovniciTableQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetCenovniciTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCenovniciTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetCenovniciTableQuery extends IGetCenovnikTableRequest {
}

export class ResultOfListOfCenovnikTableDto extends Result implements IResultOfListOfCenovnikTableDto {
    data?: CenovnikTableDto[] | undefined;

    constructor(data?: IResultOfListOfCenovnikTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CenovnikTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfCenovnikTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfCenovnikTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfCenovnikTableDto extends IResult {
    data?: CenovnikTableDto[] | undefined;
}

export class ResultOfListOfCenovnikListDto extends Result implements IResultOfListOfCenovnikListDto {
    data?: CenovnikListDto[] | undefined;

    constructor(data?: IResultOfListOfCenovnikListDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CenovnikListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfCenovnikListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfCenovnikListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfCenovnikListDto extends IResult {
    data?: CenovnikListDto[] | undefined;
}

export class ListItemDtoOfLong implements IListItemDtoOfLong {
    id?: number;
    label?: string | undefined;
    value?: string | undefined;
    innerItems?: ListItemDtoOfLong[] | undefined;

    constructor(data?: IListItemDtoOfLong) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.value = _data["value"];
            if (Array.isArray(_data["innerItems"])) {
                this.innerItems = [] as any;
                for (let item of _data["innerItems"])
                    this.innerItems!.push(ListItemDtoOfLong.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListItemDtoOfLong {
        data = typeof data === 'object' ? data : {};
        let result = new ListItemDtoOfLong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["value"] = this.value;
        if (Array.isArray(this.innerItems)) {
            data["innerItems"] = [];
            for (let item of this.innerItems)
                data["innerItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListItemDtoOfLong {
    id?: number;
    label?: string | undefined;
    value?: string | undefined;
    innerItems?: ListItemDtoOfLong[] | undefined;
}

export class CenovnikListDto extends ListItemDtoOfLong implements ICenovnikListDto {
    vrstaEntiteta?: VrstaEntiteta;

    constructor(data?: ICenovnikListDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.vrstaEntiteta = _data["vrstaEntiteta"];
        }
    }

    static fromJS(data: any): CenovnikListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CenovnikListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vrstaEntiteta"] = this.vrstaEntiteta;
        super.toJSON(data);
        return data;
    }
}

export interface ICenovnikListDto extends IListItemDtoOfLong {
    vrstaEntiteta?: VrstaEntiteta;
}

export class ResultOfCenovnikStavkeTableVm extends Result implements IResultOfCenovnikStavkeTableVm {
    data?: CenovnikStavkeTableVm | undefined;

    constructor(data?: IResultOfCenovnikStavkeTableVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? CenovnikStavkeTableVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfCenovnikStavkeTableVm {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfCenovnikStavkeTableVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfCenovnikStavkeTableVm extends IResult {
    data?: CenovnikStavkeTableVm | undefined;
}

export class CenovnikStavkeTableVm implements ICenovnikStavkeTableVm {
    cenovnikStavke?: CenovnikStavkaDto[] | undefined;

    constructor(data?: ICenovnikStavkeTableVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cenovnikStavke"])) {
                this.cenovnikStavke = [] as any;
                for (let item of _data["cenovnikStavke"])
                    this.cenovnikStavke!.push(CenovnikStavkaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CenovnikStavkeTableVm {
        data = typeof data === 'object' ? data : {};
        let result = new CenovnikStavkeTableVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cenovnikStavke)) {
            data["cenovnikStavke"] = [];
            for (let item of this.cenovnikStavke)
                data["cenovnikStavke"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICenovnikStavkeTableVm {
    cenovnikStavke?: CenovnikStavkaDto[] | undefined;
}

export class CenovnikStavkaDto implements ICenovnikStavkaDto {
    id?: number;
    sifra?: string | undefined;
    nazivPredmetaStavke?: string | undefined;
    nazivJediniceMere?: string | undefined;
    ulaznaCena?: number;
    prodajnaCena?: number;
    cenovnikId?: number;
    predmetStavkeId?: number;
    valutaText?: string | undefined;
    prodajnaOsnovnaCena?: number | undefined;

    constructor(data?: ICenovnikStavkaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.nazivPredmetaStavke = _data["nazivPredmetaStavke"];
            this.nazivJediniceMere = _data["nazivJediniceMere"];
            this.ulaznaCena = _data["ulaznaCena"];
            this.prodajnaCena = _data["prodajnaCena"];
            this.cenovnikId = _data["cenovnikId"];
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.valutaText = _data["valutaText"];
            this.prodajnaOsnovnaCena = _data["prodajnaOsnovnaCena"];
        }
    }

    static fromJS(data: any): CenovnikStavkaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CenovnikStavkaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["nazivPredmetaStavke"] = this.nazivPredmetaStavke;
        data["nazivJediniceMere"] = this.nazivJediniceMere;
        data["ulaznaCena"] = this.ulaznaCena;
        data["prodajnaCena"] = this.prodajnaCena;
        data["cenovnikId"] = this.cenovnikId;
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["valutaText"] = this.valutaText;
        data["prodajnaOsnovnaCena"] = this.prodajnaOsnovnaCena;
        return data;
    }
}

export interface ICenovnikStavkaDto {
    id?: number;
    sifra?: string | undefined;
    nazivPredmetaStavke?: string | undefined;
    nazivJediniceMere?: string | undefined;
    ulaznaCena?: number;
    prodajnaCena?: number;
    cenovnikId?: number;
    predmetStavkeId?: number;
    valutaText?: string | undefined;
    prodajnaOsnovnaCena?: number | undefined;
}

export class ResultOfCenovnikDto extends Result implements IResultOfCenovnikDto {
    data?: CenovnikDto | undefined;

    constructor(data?: IResultOfCenovnikDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? CenovnikDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfCenovnikDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfCenovnikDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfCenovnikDto extends IResult {
    data?: CenovnikDto | undefined;
}

export class CenovnikDto implements ICenovnikDto {
    id?: number | undefined;
    naziv?: string | undefined;
    stavkeCenovnika?: CenovnikStavkaDto[] | undefined;
    stranke?: StrankaDto[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    vrstaEntiteta?: VrstaEntiteta;

    constructor(data?: ICenovnikDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            if (Array.isArray(_data["stavkeCenovnika"])) {
                this.stavkeCenovnika = [] as any;
                for (let item of _data["stavkeCenovnika"])
                    this.stavkeCenovnika!.push(CenovnikStavkaDto.fromJS(item));
            }
            if (Array.isArray(_data["stranke"])) {
                this.stranke = [] as any;
                for (let item of _data["stranke"])
                    this.stranke!.push(StrankaDto.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedOn = _data["lastModifiedOn"] ? new Date(_data["lastModifiedOn"].toString()) : <any>undefined;
            this.vrstaEntiteta = _data["vrstaEntiteta"];
        }
    }

    static fromJS(data: any): CenovnikDto {
        data = typeof data === 'object' ? data : {};
        let result = new CenovnikDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        if (Array.isArray(this.stavkeCenovnika)) {
            data["stavkeCenovnika"] = [];
            for (let item of this.stavkeCenovnika)
                data["stavkeCenovnika"].push(item.toJSON());
        }
        if (Array.isArray(this.stranke)) {
            data["stranke"] = [];
            for (let item of this.stranke)
                data["stranke"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined;
        data["vrstaEntiteta"] = this.vrstaEntiteta;
        return data;
    }
}

export interface ICenovnikDto {
    id?: number | undefined;
    naziv?: string | undefined;
    stavkeCenovnika?: CenovnikStavkaDto[] | undefined;
    stranke?: StrankaDto[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    vrstaEntiteta?: VrstaEntiteta;
}

export class StrankaDto implements IStrankaDto {
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    id?: number | undefined;
    naziv?: string | undefined;
    kupac?: string | undefined;
    dobavljac?: string | undefined;
    napomena?: string | undefined;
    tipStranke?: TipStranke;
    adresa?: AdresaDto | undefined;
    kontaktiDto?: KontaktDto[] | undefined;
    rokPlacanjaZaUlazne?: number;
    rokPlacanjaZaIzlazne?: number;
    tekuciRacuniDto?: TekuciRacunDto[] | undefined;
    uSistemuPDVa?: boolean | undefined;
    jeKupac?: boolean;
    jeDobavljac?: boolean;
    isActive?: boolean;
    valutaPoslovanjaId?: string | undefined;
    gln?: string | undefined;

    constructor(data?: IStrankaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedOn = _data["lastModifiedOn"] ? new Date(_data["lastModifiedOn"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.kupac = _data["kupac"];
            this.dobavljac = _data["dobavljac"];
            this.napomena = _data["napomena"];
            this.tipStranke = _data["tipStranke"];
            this.adresa = _data["adresa"] ? AdresaDto.fromJS(_data["adresa"]) : <any>undefined;
            if (Array.isArray(_data["kontaktiDto"])) {
                this.kontaktiDto = [] as any;
                for (let item of _data["kontaktiDto"])
                    this.kontaktiDto!.push(KontaktDto.fromJS(item));
            }
            this.rokPlacanjaZaUlazne = _data["rokPlacanjaZaUlazne"];
            this.rokPlacanjaZaIzlazne = _data["rokPlacanjaZaIzlazne"];
            if (Array.isArray(_data["tekuciRacuniDto"])) {
                this.tekuciRacuniDto = [] as any;
                for (let item of _data["tekuciRacuniDto"])
                    this.tekuciRacuniDto!.push(TekuciRacunDto.fromJS(item));
            }
            this.uSistemuPDVa = _data["uSistemuPDVa"];
            this.jeKupac = _data["jeKupac"];
            this.jeDobavljac = _data["jeDobavljac"];
            this.isActive = _data["isActive"];
            this.valutaPoslovanjaId = _data["valutaPoslovanjaId"];
            this.gln = _data["gln"];
        }
    }

    static fromJS(data: any): StrankaDto {
        data = typeof data === 'object' ? data : {};
        let result = new StrankaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["kupac"] = this.kupac;
        data["dobavljac"] = this.dobavljac;
        data["napomena"] = this.napomena;
        data["tipStranke"] = this.tipStranke;
        data["adresa"] = this.adresa ? this.adresa.toJSON() : <any>undefined;
        if (Array.isArray(this.kontaktiDto)) {
            data["kontaktiDto"] = [];
            for (let item of this.kontaktiDto)
                data["kontaktiDto"].push(item.toJSON());
        }
        data["rokPlacanjaZaUlazne"] = this.rokPlacanjaZaUlazne;
        data["rokPlacanjaZaIzlazne"] = this.rokPlacanjaZaIzlazne;
        if (Array.isArray(this.tekuciRacuniDto)) {
            data["tekuciRacuniDto"] = [];
            for (let item of this.tekuciRacuniDto)
                data["tekuciRacuniDto"].push(item.toJSON());
        }
        data["uSistemuPDVa"] = this.uSistemuPDVa;
        data["jeKupac"] = this.jeKupac;
        data["jeDobavljac"] = this.jeDobavljac;
        data["isActive"] = this.isActive;
        data["valutaPoslovanjaId"] = this.valutaPoslovanjaId;
        data["gln"] = this.gln;
        return data;
    }
}

export interface IStrankaDto {
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    id?: number | undefined;
    naziv?: string | undefined;
    kupac?: string | undefined;
    dobavljac?: string | undefined;
    napomena?: string | undefined;
    tipStranke?: TipStranke;
    adresa?: AdresaDto | undefined;
    kontaktiDto?: KontaktDto[] | undefined;
    rokPlacanjaZaUlazne?: number;
    rokPlacanjaZaIzlazne?: number;
    tekuciRacuniDto?: TekuciRacunDto[] | undefined;
    uSistemuPDVa?: boolean | undefined;
    jeKupac?: boolean;
    jeDobavljac?: boolean;
    isActive?: boolean;
    valutaPoslovanjaId?: string | undefined;
    gln?: string | undefined;
}

export class AdresaDto implements IAdresaDto {
    id?: number | undefined;
    ulicaIBroj?: string | undefined;
    grad?: string | undefined;
    region?: string | undefined;
    opstina?: string | undefined;
    postanskiBroj?: string | undefined;
    drzavaId?: string | undefined;
    punaAdresa?: string | undefined;

    constructor(data?: IAdresaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ulicaIBroj = _data["ulicaIBroj"];
            this.grad = _data["grad"];
            this.region = _data["region"];
            this.opstina = _data["opstina"];
            this.postanskiBroj = _data["postanskiBroj"];
            this.drzavaId = _data["drzavaId"];
            this.punaAdresa = _data["punaAdresa"];
        }
    }

    static fromJS(data: any): AdresaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdresaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ulicaIBroj"] = this.ulicaIBroj;
        data["grad"] = this.grad;
        data["region"] = this.region;
        data["opstina"] = this.opstina;
        data["postanskiBroj"] = this.postanskiBroj;
        data["drzavaId"] = this.drzavaId;
        data["punaAdresa"] = this.punaAdresa;
        return data;
    }
}

export interface IAdresaDto {
    id?: number | undefined;
    ulicaIBroj?: string | undefined;
    grad?: string | undefined;
    region?: string | undefined;
    opstina?: string | undefined;
    postanskiBroj?: string | undefined;
    drzavaId?: string | undefined;
    punaAdresa?: string | undefined;
}

export class KontaktDto implements IKontaktDto {
    id?: number | undefined;
    strankaId?: number;
    naziv?: string | undefined;
    telefon1?: string | undefined;
    telefon2?: string | undefined;
    telefon3?: string | undefined;
    email?: string | undefined;
    websiteUrl?: string | undefined;
    fax?: string | undefined;
    funkcija?: string | undefined;

    constructor(data?: IKontaktDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.strankaId = _data["strankaId"];
            this.naziv = _data["naziv"];
            this.telefon1 = _data["telefon1"];
            this.telefon2 = _data["telefon2"];
            this.telefon3 = _data["telefon3"];
            this.email = _data["email"];
            this.websiteUrl = _data["websiteUrl"];
            this.fax = _data["fax"];
            this.funkcija = _data["funkcija"];
        }
    }

    static fromJS(data: any): KontaktDto {
        data = typeof data === 'object' ? data : {};
        let result = new KontaktDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["strankaId"] = this.strankaId;
        data["naziv"] = this.naziv;
        data["telefon1"] = this.telefon1;
        data["telefon2"] = this.telefon2;
        data["telefon3"] = this.telefon3;
        data["email"] = this.email;
        data["websiteUrl"] = this.websiteUrl;
        data["fax"] = this.fax;
        data["funkcija"] = this.funkcija;
        return data;
    }
}

export interface IKontaktDto {
    id?: number | undefined;
    strankaId?: number;
    naziv?: string | undefined;
    telefon1?: string | undefined;
    telefon2?: string | undefined;
    telefon3?: string | undefined;
    email?: string | undefined;
    websiteUrl?: string | undefined;
    fax?: string | undefined;
    funkcija?: string | undefined;
}

export class TekuciRacunDto implements ITekuciRacunDto {
    id?: number | undefined;
    ceoBrojRacuna?: string | undefined;
    brojRacuna?: string | undefined;
    kontrolniBroj?: string | undefined;
    iban?: string | undefined;
    tip?: TipTekucegRacuna;
    bankaDto?: BankaDto | undefined;
    nazivBanke?: string | undefined;
    strankaId?: number | undefined;
    isDefault?: boolean;
    prikaziNaPdf?: boolean;
    isActive?: boolean;

    constructor(data?: ITekuciRacunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ceoBrojRacuna = _data["ceoBrojRacuna"];
            this.brojRacuna = _data["brojRacuna"];
            this.kontrolniBroj = _data["kontrolniBroj"];
            this.iban = _data["iban"];
            this.tip = _data["tip"];
            this.bankaDto = _data["bankaDto"] ? BankaDto.fromJS(_data["bankaDto"]) : <any>undefined;
            this.nazivBanke = _data["nazivBanke"];
            this.strankaId = _data["strankaId"];
            this.isDefault = _data["isDefault"];
            this.prikaziNaPdf = _data["prikaziNaPdf"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TekuciRacunDto {
        data = typeof data === 'object' ? data : {};
        let result = new TekuciRacunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ceoBrojRacuna"] = this.ceoBrojRacuna;
        data["brojRacuna"] = this.brojRacuna;
        data["kontrolniBroj"] = this.kontrolniBroj;
        data["iban"] = this.iban;
        data["tip"] = this.tip;
        data["bankaDto"] = this.bankaDto ? this.bankaDto.toJSON() : <any>undefined;
        data["nazivBanke"] = this.nazivBanke;
        data["strankaId"] = this.strankaId;
        data["isDefault"] = this.isDefault;
        data["prikaziNaPdf"] = this.prikaziNaPdf;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITekuciRacunDto {
    id?: number | undefined;
    ceoBrojRacuna?: string | undefined;
    brojRacuna?: string | undefined;
    kontrolniBroj?: string | undefined;
    iban?: string | undefined;
    tip?: TipTekucegRacuna;
    bankaDto?: BankaDto | undefined;
    nazivBanke?: string | undefined;
    strankaId?: number | undefined;
    isDefault?: boolean;
    prikaziNaPdf?: boolean;
    isActive?: boolean;
}

export enum TipTekucegRacuna {
    DINARSKI = 0,
    DEVIZNI = 1,
}

export class BankaDto implements IBankaDto {
    id?: number | undefined;
    naziv?: string | undefined;
    kodBanke?: number | undefined;
    bic?: string | undefined;

    constructor(data?: IBankaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.kodBanke = _data["kodBanke"];
            this.bic = _data["bic"];
        }
    }

    static fromJS(data: any): BankaDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["kodBanke"] = this.kodBanke;
        data["bic"] = this.bic;
        return data;
    }
}

export interface IBankaDto {
    id?: number | undefined;
    naziv?: string | undefined;
    kodBanke?: number | undefined;
    bic?: string | undefined;
}

export class ResultOfGetCenovnikStavkeVm extends Result implements IResultOfGetCenovnikStavkeVm {
    data?: GetCenovnikStavkeVm | undefined;

    constructor(data?: IResultOfGetCenovnikStavkeVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetCenovnikStavkeVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetCenovnikStavkeVm {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetCenovnikStavkeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetCenovnikStavkeVm extends IResult {
    data?: GetCenovnikStavkeVm | undefined;
}

export class GetCenovnikStavkeVm implements IGetCenovnikStavkeVm {
    cenovnikStavke?: CenovnikStavkaDto[] | undefined;

    constructor(data?: IGetCenovnikStavkeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cenovnikStavke"])) {
                this.cenovnikStavke = [] as any;
                for (let item of _data["cenovnikStavke"])
                    this.cenovnikStavke!.push(CenovnikStavkaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCenovnikStavkeVm {
        data = typeof data === 'object' ? data : {};
        let result = new GetCenovnikStavkeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cenovnikStavke)) {
            data["cenovnikStavke"] = [];
            for (let item of this.cenovnikStavke)
                data["cenovnikStavke"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCenovnikStavkeVm {
    cenovnikStavke?: CenovnikStavkaDto[] | undefined;
}

export class GetCenovnikStavkeQuery implements IGetCenovnikStavkeQuery {
    searchValue?: string | undefined;

    constructor(data?: IGetCenovnikStavkeQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchValue = _data["searchValue"];
        }
    }

    static fromJS(data: any): GetCenovnikStavkeQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCenovnikStavkeQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchValue"] = this.searchValue;
        return data;
    }
}

export interface IGetCenovnikStavkeQuery {
    searchValue?: string | undefined;
}

export class ResultOfCenovnikCreateUpdateResponse extends Result implements IResultOfCenovnikCreateUpdateResponse {
    data?: CenovnikCreateUpdateResponse | undefined;

    constructor(data?: IResultOfCenovnikCreateUpdateResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? CenovnikCreateUpdateResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfCenovnikCreateUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfCenovnikCreateUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfCenovnikCreateUpdateResponse extends IResult {
    data?: CenovnikCreateUpdateResponse | undefined;
}

export class CenovnikCreateUpdateResponse implements ICenovnikCreateUpdateResponse {
    cenovnikListDto?: CenovnikListDto | undefined;
    cenovnikTableDto?: CenovnikTableDto | undefined;

    constructor(data?: ICenovnikCreateUpdateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cenovnikListDto = _data["cenovnikListDto"] ? CenovnikListDto.fromJS(_data["cenovnikListDto"]) : <any>undefined;
            this.cenovnikTableDto = _data["cenovnikTableDto"] ? CenovnikTableDto.fromJS(_data["cenovnikTableDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CenovnikCreateUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CenovnikCreateUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cenovnikListDto"] = this.cenovnikListDto ? this.cenovnikListDto.toJSON() : <any>undefined;
        data["cenovnikTableDto"] = this.cenovnikTableDto ? this.cenovnikTableDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICenovnikCreateUpdateResponse {
    cenovnikListDto?: CenovnikListDto | undefined;
    cenovnikTableDto?: CenovnikTableDto | undefined;
}

export class CreateCenovnikCommand implements ICreateCenovnikCommand {
    id?: number | undefined;
    naziv?: string | undefined;
    stavkeCenovnika?: CenovnikStavkaDto[] | undefined;
    stranke?: StrankaDto[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    vrstaEntiteta?: VrstaEntiteta;

    constructor(data?: ICreateCenovnikCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            if (Array.isArray(_data["stavkeCenovnika"])) {
                this.stavkeCenovnika = [] as any;
                for (let item of _data["stavkeCenovnika"])
                    this.stavkeCenovnika!.push(CenovnikStavkaDto.fromJS(item));
            }
            if (Array.isArray(_data["stranke"])) {
                this.stranke = [] as any;
                for (let item of _data["stranke"])
                    this.stranke!.push(StrankaDto.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedOn = _data["lastModifiedOn"] ? new Date(_data["lastModifiedOn"].toString()) : <any>undefined;
            this.vrstaEntiteta = _data["vrstaEntiteta"];
        }
    }

    static fromJS(data: any): CreateCenovnikCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCenovnikCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        if (Array.isArray(this.stavkeCenovnika)) {
            data["stavkeCenovnika"] = [];
            for (let item of this.stavkeCenovnika)
                data["stavkeCenovnika"].push(item.toJSON());
        }
        if (Array.isArray(this.stranke)) {
            data["stranke"] = [];
            for (let item of this.stranke)
                data["stranke"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined;
        data["vrstaEntiteta"] = this.vrstaEntiteta;
        return data;
    }
}

export interface ICreateCenovnikCommand {
    id?: number | undefined;
    naziv?: string | undefined;
    stavkeCenovnika?: CenovnikStavkaDto[] | undefined;
    stranke?: StrankaDto[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    vrstaEntiteta?: VrstaEntiteta;
}

export class UpdateCenovnikCommand implements IUpdateCenovnikCommand {
    id?: number | undefined;
    naziv?: string | undefined;
    stavkeCenovnika?: CenovnikStavkaDto[] | undefined;
    stranke?: StrankaDto[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    vrstaEntiteta?: VrstaEntiteta;

    constructor(data?: IUpdateCenovnikCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            if (Array.isArray(_data["stavkeCenovnika"])) {
                this.stavkeCenovnika = [] as any;
                for (let item of _data["stavkeCenovnika"])
                    this.stavkeCenovnika!.push(CenovnikStavkaDto.fromJS(item));
            }
            if (Array.isArray(_data["stranke"])) {
                this.stranke = [] as any;
                for (let item of _data["stranke"])
                    this.stranke!.push(StrankaDto.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedOn = _data["lastModifiedOn"] ? new Date(_data["lastModifiedOn"].toString()) : <any>undefined;
            this.vrstaEntiteta = _data["vrstaEntiteta"];
        }
    }

    static fromJS(data: any): UpdateCenovnikCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCenovnikCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        if (Array.isArray(this.stavkeCenovnika)) {
            data["stavkeCenovnika"] = [];
            for (let item of this.stavkeCenovnika)
                data["stavkeCenovnika"].push(item.toJSON());
        }
        if (Array.isArray(this.stranke)) {
            data["stranke"] = [];
            for (let item of this.stranke)
                data["stranke"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined;
        data["vrstaEntiteta"] = this.vrstaEntiteta;
        return data;
    }
}

export interface IUpdateCenovnikCommand {
    id?: number | undefined;
    naziv?: string | undefined;
    stavkeCenovnika?: CenovnikStavkaDto[] | undefined;
    stranke?: StrankaDto[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    vrstaEntiteta?: VrstaEntiteta;
}

export class ResultOfGetDashboardPrometCardsResponse extends Result implements IResultOfGetDashboardPrometCardsResponse {
    data?: GetDashboardPrometCardsResponse | undefined;

    constructor(data?: IResultOfGetDashboardPrometCardsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetDashboardPrometCardsResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetDashboardPrometCardsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetDashboardPrometCardsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetDashboardPrometCardsResponse extends IResult {
    data?: GetDashboardPrometCardsResponse | undefined;
}

export class GetDashboardPrometCardsResponse implements IGetDashboardPrometCardsResponse {
    dnevni?: PrometCard | undefined;
    mesecni?: PrometCard | undefined;
    godisnji?: PrometCard | undefined;

    constructor(data?: IGetDashboardPrometCardsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dnevni = _data["dnevni"] ? PrometCard.fromJS(_data["dnevni"]) : <any>undefined;
            this.mesecni = _data["mesecni"] ? PrometCard.fromJS(_data["mesecni"]) : <any>undefined;
            this.godisnji = _data["godisnji"] ? PrometCard.fromJS(_data["godisnji"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDashboardPrometCardsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardPrometCardsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dnevni"] = this.dnevni ? this.dnevni.toJSON() : <any>undefined;
        data["mesecni"] = this.mesecni ? this.mesecni.toJSON() : <any>undefined;
        data["godisnji"] = this.godisnji ? this.godisnji.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDashboardPrometCardsResponse {
    dnevni?: PrometCard | undefined;
    mesecni?: PrometCard | undefined;
    godisnji?: PrometCard | undefined;
}

export class PrometCard implements IPrometCard {
    promet?: number;
    procentualnaRazlika?: string | undefined;
    isNegative?: boolean;
    trenutniNaziv?: string | undefined;
    prethodniNaziv?: string | undefined;

    constructor(data?: IPrometCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promet = _data["promet"];
            this.procentualnaRazlika = _data["procentualnaRazlika"];
            this.isNegative = _data["isNegative"];
            this.trenutniNaziv = _data["trenutniNaziv"];
            this.prethodniNaziv = _data["prethodniNaziv"];
        }
    }

    static fromJS(data: any): PrometCard {
        data = typeof data === 'object' ? data : {};
        let result = new PrometCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promet"] = this.promet;
        data["procentualnaRazlika"] = this.procentualnaRazlika;
        data["isNegative"] = this.isNegative;
        data["trenutniNaziv"] = this.trenutniNaziv;
        data["prethodniNaziv"] = this.prethodniNaziv;
        return data;
    }
}

export interface IPrometCard {
    promet?: number;
    procentualnaRazlika?: string | undefined;
    isNegative?: boolean;
    trenutniNaziv?: string | undefined;
    prethodniNaziv?: string | undefined;
}

export class ResultOfGetPrometChartResponse extends Result implements IResultOfGetPrometChartResponse {
    data?: GetPrometChartResponse | undefined;

    constructor(data?: IResultOfGetPrometChartResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetPrometChartResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetPrometChartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetPrometChartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetPrometChartResponse extends IResult {
    data?: GetPrometChartResponse | undefined;
}

export class GetPrometChartResponse implements IGetPrometChartResponse {
    prometChartQueryResultList?: GetPrometChartQueryResult[] | undefined;

    constructor(data?: IGetPrometChartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["prometChartQueryResultList"])) {
                this.prometChartQueryResultList = [] as any;
                for (let item of _data["prometChartQueryResultList"])
                    this.prometChartQueryResultList!.push(GetPrometChartQueryResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPrometChartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrometChartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prometChartQueryResultList)) {
            data["prometChartQueryResultList"] = [];
            for (let item of this.prometChartQueryResultList)
                data["prometChartQueryResultList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPrometChartResponse {
    prometChartQueryResultList?: GetPrometChartQueryResult[] | undefined;
}

export class GetPrometChartQueryResult implements IGetPrometChartQueryResult {
    mesec?: number;
    sumUlaz?: number;
    sumIzlaz?: number;

    constructor(data?: IGetPrometChartQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mesec = _data["mesec"];
            this.sumUlaz = _data["sumUlaz"];
            this.sumIzlaz = _data["sumIzlaz"];
        }
    }

    static fromJS(data: any): GetPrometChartQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrometChartQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mesec"] = this.mesec;
        data["sumUlaz"] = this.sumUlaz;
        data["sumIzlaz"] = this.sumIzlaz;
        return data;
    }
}

export interface IGetPrometChartQueryResult {
    mesec?: number;
    sumUlaz?: number;
    sumIzlaz?: number;
}

export class ResultOfListOfGetTopNStrankiDonutResponse extends Result implements IResultOfListOfGetTopNStrankiDonutResponse {
    data?: GetTopNStrankiDonutResponse[] | undefined;

    constructor(data?: IResultOfListOfGetTopNStrankiDonutResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GetTopNStrankiDonutResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfGetTopNStrankiDonutResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfGetTopNStrankiDonutResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfGetTopNStrankiDonutResponse extends IResult {
    data?: GetTopNStrankiDonutResponse[] | undefined;
}

export class GetTopNStrankiDonutResponse implements IGetTopNStrankiDonutResponse {
    id?: number;
    naziv?: string | undefined;
    brojFaktura?: number;
    ukupanIznos?: number;
    boja?: string | undefined;
    tipStranke?: TipStranke;

    constructor(data?: IGetTopNStrankiDonutResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.brojFaktura = _data["brojFaktura"];
            this.ukupanIznos = _data["ukupanIznos"];
            this.boja = _data["boja"];
            this.tipStranke = _data["tipStranke"];
        }
    }

    static fromJS(data: any): GetTopNStrankiDonutResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTopNStrankiDonutResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["brojFaktura"] = this.brojFaktura;
        data["ukupanIznos"] = this.ukupanIznos;
        data["boja"] = this.boja;
        data["tipStranke"] = this.tipStranke;
        return data;
    }
}

export interface IGetTopNStrankiDonutResponse {
    id?: number;
    naziv?: string | undefined;
    brojFaktura?: number;
    ukupanIznos?: number;
    boja?: string | undefined;
    tipStranke?: TipStranke;
}

export enum VrstaStranke {
    DOBAVLJAC = 0,
    KUPAC = 1,
    DOBAVLJAC_I_KUPAC = 2,
}

export class KonfiguracijaBrojaDelovodnogDokumentaDto implements IKonfiguracijaBrojaDelovodnogDokumentaDto {
    id?: number | undefined;
    naziv?: string | undefined;
    prefiks?: string | undefined;
    brojac?: number;

    constructor(data?: IKonfiguracijaBrojaDelovodnogDokumentaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.prefiks = _data["prefiks"];
            this.brojac = _data["brojac"];
        }
    }

    static fromJS(data: any): KonfiguracijaBrojaDelovodnogDokumentaDto {
        data = typeof data === 'object' ? data : {};
        let result = new KonfiguracijaBrojaDelovodnogDokumentaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["prefiks"] = this.prefiks;
        data["brojac"] = this.brojac;
        return data;
    }
}

export interface IKonfiguracijaBrojaDelovodnogDokumentaDto {
    id?: number | undefined;
    naziv?: string | undefined;
    prefiks?: string | undefined;
    brojac?: number;
}

export class CreatePraviloZaDelovodniDokumentCommand extends KonfiguracijaBrojaDelovodnogDokumentaDto implements ICreatePraviloZaDelovodniDokumentCommand {

    constructor(data?: ICreatePraviloZaDelovodniDokumentCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreatePraviloZaDelovodniDokumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePraviloZaDelovodniDokumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreatePraviloZaDelovodniDokumentCommand extends IKonfiguracijaBrojaDelovodnogDokumentaDto {
}

export class UpdatePraviloZaDelovodnikDokumentCommand extends KonfiguracijaBrojaDelovodnogDokumentaDto implements IUpdatePraviloZaDelovodnikDokumentCommand {

    constructor(data?: IUpdatePraviloZaDelovodnikDokumentCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdatePraviloZaDelovodnikDokumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePraviloZaDelovodnikDokumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePraviloZaDelovodnikDokumentCommand extends IKonfiguracijaBrojaDelovodnogDokumentaDto {
}

export class ResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaTableDto extends Result implements IResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaTableDto {
    data?: KonfiguracijaBrojaDelovodnogDokumentaTableDto[] | undefined;

    constructor(data?: IResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(KonfiguracijaBrojaDelovodnogDokumentaTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaTableDto extends IResult {
    data?: KonfiguracijaBrojaDelovodnogDokumentaTableDto[] | undefined;
}

export class KonfiguracijaBrojaDelovodnogDokumentaTableDto implements IKonfiguracijaBrojaDelovodnogDokumentaTableDto {
    id?: number;
    naziv?: string | undefined;
    prefiks?: string | undefined;
    brojac?: number;
    isEditable?: boolean;

    constructor(data?: IKonfiguracijaBrojaDelovodnogDokumentaTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.prefiks = _data["prefiks"];
            this.brojac = _data["brojac"];
            this.isEditable = _data["isEditable"];
        }
    }

    static fromJS(data: any): KonfiguracijaBrojaDelovodnogDokumentaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new KonfiguracijaBrojaDelovodnogDokumentaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["prefiks"] = this.prefiks;
        data["brojac"] = this.brojac;
        data["isEditable"] = this.isEditable;
        return data;
    }
}

export interface IKonfiguracijaBrojaDelovodnogDokumentaTableDto {
    id?: number;
    naziv?: string | undefined;
    prefiks?: string | undefined;
    brojac?: number;
    isEditable?: boolean;
}

export class ResultOfKonfiguracijaBrojaDelovodnogDokumentaDto extends Result implements IResultOfKonfiguracijaBrojaDelovodnogDokumentaDto {
    data?: KonfiguracijaBrojaDelovodnogDokumentaDto | undefined;

    constructor(data?: IResultOfKonfiguracijaBrojaDelovodnogDokumentaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? KonfiguracijaBrojaDelovodnogDokumentaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfKonfiguracijaBrojaDelovodnogDokumentaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfKonfiguracijaBrojaDelovodnogDokumentaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfKonfiguracijaBrojaDelovodnogDokumentaDto extends IResult {
    data?: KonfiguracijaBrojaDelovodnogDokumentaDto | undefined;
}

export class ResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaDto extends Result implements IResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaDto {
    data?: KonfiguracijaBrojaDelovodnogDokumentaDto[] | undefined;

    constructor(data?: IResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(KonfiguracijaBrojaDelovodnogDokumentaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfIEnumerableOfKonfiguracijaBrojaDelovodnogDokumentaDto extends IResult {
    data?: KonfiguracijaBrojaDelovodnogDokumentaDto[] | undefined;
}

export class CreateDelovodnikCommand implements ICreateDelovodnikCommand {
    naziv?: string | undefined;
    kategorijaId?: number | undefined;
    praviloZaBrojId?: number;

    constructor(data?: ICreateDelovodnikCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.kategorijaId = _data["kategorijaId"];
            this.praviloZaBrojId = _data["praviloZaBrojId"];
        }
    }

    static fromJS(data: any): CreateDelovodnikCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDelovodnikCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["kategorijaId"] = this.kategorijaId;
        data["praviloZaBrojId"] = this.praviloZaBrojId;
        return data;
    }
}

export interface ICreateDelovodnikCommand {
    naziv?: string | undefined;
    kategorijaId?: number | undefined;
    praviloZaBrojId?: number;
}

export class PaginatedResultOfDelovodnikTableDto extends Result implements IPaginatedResultOfDelovodnikTableDto {
    data?: DelovodnikTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfDelovodnikTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DelovodnikTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfDelovodnikTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfDelovodnikTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfDelovodnikTableDto extends IResult {
    data?: DelovodnikTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class DelovodnikTableDto implements IDelovodnikTableDto {
    id?: number;
    naziv?: string | undefined;
    kategorija?: string | undefined;

    constructor(data?: IDelovodnikTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.kategorija = _data["kategorija"];
        }
    }

    static fromJS(data: any): DelovodnikTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new DelovodnikTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["kategorija"] = this.kategorija;
        return data;
    }
}

export interface IDelovodnikTableDto {
    id?: number;
    naziv?: string | undefined;
    kategorija?: string | undefined;
}

export class GetDelovodnikTableQuery implements IGetDelovodnikTableQuery {
    naziv?: string | undefined;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetDelovodnikTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetDelovodnikTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetDelovodnikTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetDelovodnikTableQuery {
    naziv?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
}

export class DelovodnikDto implements IDelovodnikDto {
    id?: number;
    naziv?: string | undefined;
    kategorijaId?: number | undefined;
    praviloZaBrojId?: number;

    constructor(data?: IDelovodnikDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.kategorijaId = _data["kategorijaId"];
            this.praviloZaBrojId = _data["praviloZaBrojId"];
        }
    }

    static fromJS(data: any): DelovodnikDto {
        data = typeof data === 'object' ? data : {};
        let result = new DelovodnikDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["kategorijaId"] = this.kategorijaId;
        data["praviloZaBrojId"] = this.praviloZaBrojId;
        return data;
    }
}

export interface IDelovodnikDto {
    id?: number;
    naziv?: string | undefined;
    kategorijaId?: number | undefined;
    praviloZaBrojId?: number;
}

export class UpdateDelovodnikCommand extends DelovodnikDto implements IUpdateDelovodnikCommand {

    constructor(data?: IUpdateDelovodnikCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateDelovodnikCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDelovodnikCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDelovodnikCommand extends IDelovodnikDto {
}

export class ResultOfDelovodnikDto extends Result implements IResultOfDelovodnikDto {
    data?: DelovodnikDto | undefined;

    constructor(data?: IResultOfDelovodnikDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? DelovodnikDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfDelovodnikDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfDelovodnikDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfDelovodnikDto extends IResult {
    data?: DelovodnikDto | undefined;
}

export class ResultOfDelovodnikInfoDto extends Result implements IResultOfDelovodnikInfoDto {
    data?: DelovodnikInfoDto | undefined;

    constructor(data?: IResultOfDelovodnikInfoDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? DelovodnikInfoDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfDelovodnikInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfDelovodnikInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfDelovodnikInfoDto extends IResult {
    data?: DelovodnikInfoDto | undefined;
}

export class DelovodnikInfoDto implements IDelovodnikInfoDto {
    id?: number;
    naziv?: string | undefined;
    nazivPravila?: string | undefined;
    kategorijaId?: number | undefined;
    kategorijaNaziv?: string | undefined;

    constructor(data?: IDelovodnikInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.nazivPravila = _data["nazivPravila"];
            this.kategorijaId = _data["kategorijaId"];
            this.kategorijaNaziv = _data["kategorijaNaziv"];
        }
    }

    static fromJS(data: any): DelovodnikInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new DelovodnikInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["nazivPravila"] = this.nazivPravila;
        data["kategorijaId"] = this.kategorijaId;
        data["kategorijaNaziv"] = this.kategorijaNaziv;
        return data;
    }
}

export interface IDelovodnikInfoDto {
    id?: number;
    naziv?: string | undefined;
    nazivPravila?: string | undefined;
    kategorijaId?: number | undefined;
    kategorijaNaziv?: string | undefined;
}

export class ResultOfDelovodniDokumentDto extends Result implements IResultOfDelovodniDokumentDto {
    data?: DelovodniDokumentDto | undefined;

    constructor(data?: IResultOfDelovodniDokumentDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? DelovodniDokumentDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfDelovodniDokumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfDelovodniDokumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfDelovodniDokumentDto extends IResult {
    data?: DelovodniDokumentDto | undefined;
}

export class DelovodniDokumentDto implements IDelovodniDokumentDto {
    delovodniDokumentId?: number | undefined;
    delovodnikId?: number;
    podbroj?: string | undefined;
    datumNastanka?: Date;
    datumUnosa?: Date;
    kategorijaId?: number;
    kategorijaNaziv?: string | undefined;
    strankaRacunaDto?: StrankaRacunaDto | undefined;
    storageFileName?: string | undefined;
    originalFileName?: string | undefined;

    constructor(data?: IDelovodniDokumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delovodniDokumentId = _data["delovodniDokumentId"];
            this.delovodnikId = _data["delovodnikId"];
            this.podbroj = _data["podbroj"];
            this.datumNastanka = _data["datumNastanka"] ? new Date(_data["datumNastanka"].toString()) : <any>undefined;
            this.datumUnosa = _data["datumUnosa"] ? new Date(_data["datumUnosa"].toString()) : <any>undefined;
            this.kategorijaId = _data["kategorijaId"];
            this.kategorijaNaziv = _data["kategorijaNaziv"];
            this.strankaRacunaDto = _data["strankaRacunaDto"] ? StrankaRacunaDto.fromJS(_data["strankaRacunaDto"]) : <any>undefined;
            this.storageFileName = _data["storageFileName"];
            this.originalFileName = _data["originalFileName"];
        }
    }

    static fromJS(data: any): DelovodniDokumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DelovodniDokumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delovodniDokumentId"] = this.delovodniDokumentId;
        data["delovodnikId"] = this.delovodnikId;
        data["podbroj"] = this.podbroj;
        data["datumNastanka"] = this.datumNastanka ? this.datumNastanka.toISOString() : <any>undefined;
        data["datumUnosa"] = this.datumUnosa ? this.datumUnosa.toISOString() : <any>undefined;
        data["kategorijaId"] = this.kategorijaId;
        data["kategorijaNaziv"] = this.kategorijaNaziv;
        data["strankaRacunaDto"] = this.strankaRacunaDto ? this.strankaRacunaDto.toJSON() : <any>undefined;
        data["storageFileName"] = this.storageFileName;
        data["originalFileName"] = this.originalFileName;
        return data;
    }
}

export interface IDelovodniDokumentDto {
    delovodniDokumentId?: number | undefined;
    delovodnikId?: number;
    podbroj?: string | undefined;
    datumNastanka?: Date;
    datumUnosa?: Date;
    kategorijaId?: number;
    kategorijaNaziv?: string | undefined;
    strankaRacunaDto?: StrankaRacunaDto | undefined;
    storageFileName?: string | undefined;
    originalFileName?: string | undefined;
}

export class PaginatedResultOfDelovodniDokumentTableDto extends Result implements IPaginatedResultOfDelovodniDokumentTableDto {
    data?: DelovodniDokumentTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfDelovodniDokumentTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DelovodniDokumentTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfDelovodniDokumentTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfDelovodniDokumentTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfDelovodniDokumentTableDto extends IResult {
    data?: DelovodniDokumentTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class DelovodniDokumentTableDto implements IDelovodniDokumentTableDto {
    id?: number;
    osnovniBroj?: string | undefined;
    podbroj?: string | undefined;
    posiljalac?: string | undefined;
    datumNastanka?: string | undefined;
    datumUnosa?: string | undefined;
    kategorija?: string | undefined;
    rutiranjeStranke?: RutiranjeStrankeDto | undefined;
    attachmentUrl?: string | undefined;

    constructor(data?: IDelovodniDokumentTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.osnovniBroj = _data["osnovniBroj"];
            this.podbroj = _data["podbroj"];
            this.posiljalac = _data["posiljalac"];
            this.datumNastanka = _data["datumNastanka"];
            this.datumUnosa = _data["datumUnosa"];
            this.kategorija = _data["kategorija"];
            this.rutiranjeStranke = _data["rutiranjeStranke"] ? RutiranjeStrankeDto.fromJS(_data["rutiranjeStranke"]) : <any>undefined;
            this.attachmentUrl = _data["attachmentUrl"];
        }
    }

    static fromJS(data: any): DelovodniDokumentTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new DelovodniDokumentTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["osnovniBroj"] = this.osnovniBroj;
        data["podbroj"] = this.podbroj;
        data["posiljalac"] = this.posiljalac;
        data["datumNastanka"] = this.datumNastanka;
        data["datumUnosa"] = this.datumUnosa;
        data["kategorija"] = this.kategorija;
        data["rutiranjeStranke"] = this.rutiranjeStranke ? this.rutiranjeStranke.toJSON() : <any>undefined;
        data["attachmentUrl"] = this.attachmentUrl;
        return data;
    }
}

export interface IDelovodniDokumentTableDto {
    id?: number;
    osnovniBroj?: string | undefined;
    podbroj?: string | undefined;
    posiljalac?: string | undefined;
    datumNastanka?: string | undefined;
    datumUnosa?: string | undefined;
    kategorija?: string | undefined;
    rutiranjeStranke?: RutiranjeStrankeDto | undefined;
    attachmentUrl?: string | undefined;
}

export class RutiranjeStrankeDto implements IRutiranjeStrankeDto {
    strankaId?: number;
    tipStranke?: TipStranke;
    naziv?: string | undefined;
    emptyText?: string | undefined;

    constructor(data?: IRutiranjeStrankeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.strankaId = _data["strankaId"];
            this.tipStranke = _data["tipStranke"];
            this.naziv = _data["naziv"];
            this.emptyText = _data["emptyText"];
        }
    }

    static fromJS(data: any): RutiranjeStrankeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RutiranjeStrankeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["strankaId"] = this.strankaId;
        data["tipStranke"] = this.tipStranke;
        data["naziv"] = this.naziv;
        data["emptyText"] = this.emptyText;
        return data;
    }
}

export interface IRutiranjeStrankeDto {
    strankaId?: number;
    tipStranke?: TipStranke;
    naziv?: string | undefined;
    emptyText?: string | undefined;
}

export class GetDelovodniDokumentTableQuery implements IGetDelovodniDokumentTableQuery {
    delovodnikId?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetDelovodniDokumentTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delovodnikId = _data["delovodnikId"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetDelovodniDokumentTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetDelovodniDokumentTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delovodnikId"] = this.delovodnikId;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetDelovodniDokumentTableQuery {
    delovodnikId?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class CreateDelovodniDokumentCommand extends DelovodniDokumentDto implements ICreateDelovodniDokumentCommand {

    constructor(data?: ICreateDelovodniDokumentCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateDelovodniDokumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDelovodniDokumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateDelovodniDokumentCommand extends IDelovodniDokumentDto {
}

export class DeleteDelovodniDokumentFileCommand implements IDeleteDelovodniDokumentFileCommand {
    delovodniDokumentId?: number;

    constructor(data?: IDeleteDelovodniDokumentFileCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delovodniDokumentId = _data["delovodniDokumentId"];
        }
    }

    static fromJS(data: any): DeleteDelovodniDokumentFileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDelovodniDokumentFileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delovodniDokumentId"] = this.delovodniDokumentId;
        return data;
    }
}

export interface IDeleteDelovodniDokumentFileCommand {
    delovodniDokumentId?: number;
}

export class UpdateDelovodniDokumentCommand extends DelovodniDokumentDto implements IUpdateDelovodniDokumentCommand {

    constructor(data?: IUpdateDelovodniDokumentCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateDelovodniDokumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDelovodniDokumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDelovodniDokumentCommand extends IDelovodniDokumentDto {
}

export class ResultOfDelovodnikPresignedUrlResponse extends Result implements IResultOfDelovodnikPresignedUrlResponse {
    data?: DelovodnikPresignedUrlResponse | undefined;

    constructor(data?: IResultOfDelovodnikPresignedUrlResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? DelovodnikPresignedUrlResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfDelovodnikPresignedUrlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfDelovodnikPresignedUrlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfDelovodnikPresignedUrlResponse extends IResult {
    data?: DelovodnikPresignedUrlResponse | undefined;
}

export class DelovodnikPresignedUrlResponse implements IDelovodnikPresignedUrlResponse {
    url?: string | undefined;
    storageFileName?: string | undefined;
    originalFileName?: string | undefined;
    contentType?: string | undefined;

    constructor(data?: IDelovodnikPresignedUrlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.storageFileName = _data["storageFileName"];
            this.originalFileName = _data["originalFileName"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): DelovodnikPresignedUrlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DelovodnikPresignedUrlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["storageFileName"] = this.storageFileName;
        data["originalFileName"] = this.originalFileName;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IDelovodnikPresignedUrlResponse {
    url?: string | undefined;
    storageFileName?: string | undefined;
    originalFileName?: string | undefined;
    contentType?: string | undefined;
}

export class GetDelovodnikPresignedUrlQuery implements IGetDelovodnikPresignedUrlQuery {
    delovodnikId?: number;
    fileName?: string | undefined;
    contentType?: string | undefined;
    action?: HttpVerb;

    constructor(data?: IGetDelovodnikPresignedUrlQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delovodnikId = _data["delovodnikId"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): GetDelovodnikPresignedUrlQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetDelovodnikPresignedUrlQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delovodnikId"] = this.delovodnikId;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["action"] = this.action;
        return data;
    }
}

export interface IGetDelovodnikPresignedUrlQuery {
    delovodnikId?: number;
    fileName?: string | undefined;
    contentType?: string | undefined;
    action?: HttpVerb;
}

export enum HttpVerb {
    GET = 0,
    HEAD = 1,
    PUT = 2,
    DELETE = 3,
}

export class ResultOfGetPreostaliProstorVM extends Result implements IResultOfGetPreostaliProstorVM {
    data?: GetPreostaliProstorVM | undefined;

    constructor(data?: IResultOfGetPreostaliProstorVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetPreostaliProstorVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetPreostaliProstorVM {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetPreostaliProstorVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetPreostaliProstorVM extends IResult {
    data?: GetPreostaliProstorVM | undefined;
}

export class GetPreostaliProstorVM implements IGetPreostaliProstorVM {
    dostupanProstor?: number;
    ukupanProstor?: number;

    constructor(data?: IGetPreostaliProstorVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dostupanProstor = _data["dostupanProstor"];
            this.ukupanProstor = _data["ukupanProstor"];
        }
    }

    static fromJS(data: any): GetPreostaliProstorVM {
        data = typeof data === 'object' ? data : {};
        let result = new GetPreostaliProstorVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dostupanProstor"] = this.dostupanProstor;
        data["ukupanProstor"] = this.ukupanProstor;
        return data;
    }
}

export interface IGetPreostaliProstorVM {
    dostupanProstor?: number;
    ukupanProstor?: number;
}

export class ResultOfListOfFolderListResponse extends Result implements IResultOfListOfFolderListResponse {
    data?: FolderListResponse[] | undefined;

    constructor(data?: IResultOfListOfFolderListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FolderListResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfFolderListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfFolderListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfFolderListResponse extends IResult {
    data?: FolderListResponse[] | undefined;
}

export class FolderListResponse implements IFolderListResponse {
    id?: number;
    naziv?: string | undefined;
    parentId?: number | undefined;

    constructor(data?: IFolderListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): FolderListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FolderListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IFolderListResponse {
    id?: number;
    naziv?: string | undefined;
    parentId?: number | undefined;
}

export class CreateDatotekaCommand implements ICreateDatotekaCommand {
    naziv?: string | undefined;
    parentId?: number | undefined;
    vrstaDatoteke?: VrstaDatoteke;

    constructor(data?: ICreateDatotekaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.parentId = _data["parentId"];
            this.vrstaDatoteke = _data["vrstaDatoteke"];
        }
    }

    static fromJS(data: any): CreateDatotekaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDatotekaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["parentId"] = this.parentId;
        data["vrstaDatoteke"] = this.vrstaDatoteke;
        return data;
    }
}

export interface ICreateDatotekaCommand {
    naziv?: string | undefined;
    parentId?: number | undefined;
    vrstaDatoteke?: VrstaDatoteke;
}

export enum VrstaDatoteke {
    EMPTY = 0,
    FOLDER = 1,
    DOKUMENT = 2,
    DELOVODNIK = 3,
}

export class ResultOfDatotekaTreeVm extends Result implements IResultOfDatotekaTreeVm {
    data?: DatotekaTreeVm | undefined;

    constructor(data?: IResultOfDatotekaTreeVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? DatotekaTreeVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfDatotekaTreeVm {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfDatotekaTreeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfDatotekaTreeVm extends IResult {
    data?: DatotekaTreeVm | undefined;
}

export class DatotekaTreeVm implements IDatotekaTreeVm {
    datotekaTree?: DatotekaTreeDto[] | undefined;

    constructor(data?: IDatotekaTreeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["datotekaTree"])) {
                this.datotekaTree = [] as any;
                for (let item of _data["datotekaTree"])
                    this.datotekaTree!.push(DatotekaTreeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DatotekaTreeVm {
        data = typeof data === 'object' ? data : {};
        let result = new DatotekaTreeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datotekaTree)) {
            data["datotekaTree"] = [];
            for (let item of this.datotekaTree)
                data["datotekaTree"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDatotekaTreeVm {
    datotekaTree?: DatotekaTreeDto[] | undefined;
}

export class DatotekaTreeDto implements IDatotekaTreeDto {
    id?: number | undefined;
    naziv?: string | undefined;
    velicinaDokumenta?: number | undefined;
    parentId?: number | undefined;
    childrenDto?: DatotekaTreeDto[] | undefined;
    tipFoldera?: TipFoldera;
    vrstaDatoteke?: VrstaDatoteke;

    constructor(data?: IDatotekaTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.velicinaDokumenta = _data["velicinaDokumenta"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["childrenDto"])) {
                this.childrenDto = [] as any;
                for (let item of _data["childrenDto"])
                    this.childrenDto!.push(DatotekaTreeDto.fromJS(item));
            }
            this.tipFoldera = _data["tipFoldera"];
            this.vrstaDatoteke = _data["vrstaDatoteke"];
        }
    }

    static fromJS(data: any): DatotekaTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DatotekaTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["velicinaDokumenta"] = this.velicinaDokumenta;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.childrenDto)) {
            data["childrenDto"] = [];
            for (let item of this.childrenDto)
                data["childrenDto"].push(item.toJSON());
        }
        data["tipFoldera"] = this.tipFoldera;
        data["vrstaDatoteke"] = this.vrstaDatoteke;
        return data;
    }
}

export interface IDatotekaTreeDto {
    id?: number | undefined;
    naziv?: string | undefined;
    velicinaDokumenta?: number | undefined;
    parentId?: number | undefined;
    childrenDto?: DatotekaTreeDto[] | undefined;
    tipFoldera?: TipFoldera;
    vrstaDatoteke?: VrstaDatoteke;
}

export enum TipFoldera {
    EMPTY = 0,
    SISTEMSKI_FOLDERI = 1,
    DELOVODNIK = 2,
    KORISNICKI_FOLDERI = 3,
}

export class ResultOfGetDokumentForPreviewResponse extends Result implements IResultOfGetDokumentForPreviewResponse {
    data?: GetDokumentForPreviewResponse | undefined;

    constructor(data?: IResultOfGetDokumentForPreviewResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetDokumentForPreviewResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetDokumentForPreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetDokumentForPreviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetDokumentForPreviewResponse extends IResult {
    data?: GetDokumentForPreviewResponse | undefined;
}

export class GetDokumentForPreviewResponse implements IGetDokumentForPreviewResponse {
    dto?: DokumentPreviewDto | undefined;

    constructor(data?: IGetDokumentForPreviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dto = _data["dto"] ? DokumentPreviewDto.fromJS(_data["dto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDokumentForPreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDokumentForPreviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dto"] = this.dto ? this.dto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDokumentForPreviewResponse {
    dto?: DokumentPreviewDto | undefined;
}

export class DokumentPreviewDto implements IDokumentPreviewDto {
    fileUrl?: string | undefined;
    naziv?: string | undefined;
    extension?: string | undefined;

    constructor(data?: IDokumentPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileUrl = _data["fileUrl"];
            this.naziv = _data["naziv"];
            this.extension = _data["extension"];
        }
    }

    static fromJS(data: any): DokumentPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new DokumentPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileUrl"] = this.fileUrl;
        data["naziv"] = this.naziv;
        data["extension"] = this.extension;
        return data;
    }
}

export interface IDokumentPreviewDto {
    fileUrl?: string | undefined;
    naziv?: string | undefined;
    extension?: string | undefined;
}

export class ResultOfDatotekaDto extends Result implements IResultOfDatotekaDto {
    data?: DatotekaDto | undefined;

    constructor(data?: IResultOfDatotekaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? DatotekaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfDatotekaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfDatotekaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfDatotekaDto extends IResult {
    data?: DatotekaDto | undefined;
}

export class DatotekaDto implements IDatotekaDto {
    datotekaId?: number;
    naziv?: string | undefined;
    velicinaDokumenta?: number | undefined;
    parentId?: any | undefined;
    folderName?: any | undefined;
    tipFoldera?: TipFoldera;
    vrsta?: VrstaDatoteke;
    children?: DatotekaDto[] | undefined;

    constructor(data?: IDatotekaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datotekaId = _data["datotekaId"];
            this.naziv = _data["naziv"];
            this.velicinaDokumenta = _data["velicinaDokumenta"];
            this.parentId = _data["parentId"];
            this.folderName = _data["folderName"];
            this.tipFoldera = _data["tipFoldera"];
            this.vrsta = _data["vrsta"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(DatotekaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DatotekaDto {
        data = typeof data === 'object' ? data : {};
        let result = new DatotekaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datotekaId"] = this.datotekaId;
        data["naziv"] = this.naziv;
        data["velicinaDokumenta"] = this.velicinaDokumenta;
        data["parentId"] = this.parentId;
        data["folderName"] = this.folderName;
        data["tipFoldera"] = this.tipFoldera;
        data["vrsta"] = this.vrsta;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDatotekaDto {
    datotekaId?: number;
    naziv?: string | undefined;
    velicinaDokumenta?: number | undefined;
    parentId?: any | undefined;
    folderName?: any | undefined;
    tipFoldera?: TipFoldera;
    vrsta?: VrstaDatoteke;
    children?: DatotekaDto[] | undefined;
}

export enum DmsActionType {
    EMPTY = 0,
    SIGN = 1,
    SEAL = 2,
    TIMESTAMP = 3,
    ALL = 4,
    EXPIRED = 5,
}

export class ResultOfListOfDmsAkcijaLogTableDto extends Result implements IResultOfListOfDmsAkcijaLogTableDto {
    data?: DmsAkcijaLogTableDto[] | undefined;

    constructor(data?: IResultOfListOfDmsAkcijaLogTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DmsAkcijaLogTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfDmsAkcijaLogTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfDmsAkcijaLogTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfDmsAkcijaLogTableDto extends IResult {
    data?: DmsAkcijaLogTableDto[] | undefined;
}

export class DmsAkcijaLogTableDto implements IDmsAkcijaLogTableDto {
    dmsAkcijaLogId?: number;
    datotekaId?: number;
    datotekaNaziv?: string | undefined;
    akcijaType?: DmsActionType;
    status?: DmsAkcijaStatus;
    vremeZahteva?: Date;
    vremeOdgovora?: Date | undefined;
    zahtevaoKorisnik?: string | undefined;
    odgovorioKorisnik?: string | undefined;

    constructor(data?: IDmsAkcijaLogTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dmsAkcijaLogId = _data["dmsAkcijaLogId"];
            this.datotekaId = _data["datotekaId"];
            this.datotekaNaziv = _data["datotekaNaziv"];
            this.akcijaType = _data["akcijaType"];
            this.status = _data["status"];
            this.vremeZahteva = _data["vremeZahteva"] ? new Date(_data["vremeZahteva"].toString()) : <any>undefined;
            this.vremeOdgovora = _data["vremeOdgovora"] ? new Date(_data["vremeOdgovora"].toString()) : <any>undefined;
            this.zahtevaoKorisnik = _data["zahtevaoKorisnik"];
            this.odgovorioKorisnik = _data["odgovorioKorisnik"];
        }
    }

    static fromJS(data: any): DmsAkcijaLogTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new DmsAkcijaLogTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dmsAkcijaLogId"] = this.dmsAkcijaLogId;
        data["datotekaId"] = this.datotekaId;
        data["datotekaNaziv"] = this.datotekaNaziv;
        data["akcijaType"] = this.akcijaType;
        data["status"] = this.status;
        data["vremeZahteva"] = this.vremeZahteva ? this.vremeZahteva.toISOString() : <any>undefined;
        data["vremeOdgovora"] = this.vremeOdgovora ? this.vremeOdgovora.toISOString() : <any>undefined;
        data["zahtevaoKorisnik"] = this.zahtevaoKorisnik;
        data["odgovorioKorisnik"] = this.odgovorioKorisnik;
        return data;
    }
}

export interface IDmsAkcijaLogTableDto {
    dmsAkcijaLogId?: number;
    datotekaId?: number;
    datotekaNaziv?: string | undefined;
    akcijaType?: DmsActionType;
    status?: DmsAkcijaStatus;
    vremeZahteva?: Date;
    vremeOdgovora?: Date | undefined;
    zahtevaoKorisnik?: string | undefined;
    odgovorioKorisnik?: string | undefined;
}

export enum DmsAkcijaStatus {
    PENDING = 0,
    ACCEPTED = 1,
    REJECTED = 2,
    EXPIRED = 3,
    FAILED = 4,
}

export class RejectDmsActionCommand implements IRejectDmsActionCommand {
    dmsAkcijaLogId?: number;

    constructor(data?: IRejectDmsActionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dmsAkcijaLogId = _data["dmsAkcijaLogId"];
        }
    }

    static fromJS(data: any): RejectDmsActionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RejectDmsActionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dmsAkcijaLogId"] = this.dmsAkcijaLogId;
        return data;
    }
}

export interface IRejectDmsActionCommand {
    dmsAkcijaLogId?: number;
}

export class ResultOfLong extends Result implements IResultOfLong {
    data?: number;

    constructor(data?: IResultOfLong) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ResultOfLong {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfLong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfLong extends IResult {
    data?: number;
}

export class CreateDokumentOSmanjenjuCommand implements ICreateDokumentOSmanjenjuCommand {
    racunDto?: RacunDto | undefined;
    prikazIzmenaOsnoviceDto?: PrikazIzmenaOsnoviceDto | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    brojReferentnogDokumenta?: string | undefined;

    constructor(data?: ICreateDokumentOSmanjenjuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.prikazIzmenaOsnoviceDto = _data["prikazIzmenaOsnoviceDto"] ? PrikazIzmenaOsnoviceDto.fromJS(_data["prikazIzmenaOsnoviceDto"]) : <any>undefined;
            this.periodOd = _data["periodOd"] ? new Date(_data["periodOd"].toString()) : <any>undefined;
            this.periodDo = _data["periodDo"] ? new Date(_data["periodDo"].toString()) : <any>undefined;
            this.brojReferentnogDokumenta = _data["brojReferentnogDokumenta"];
        }
    }

    static fromJS(data: any): CreateDokumentOSmanjenjuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDokumentOSmanjenjuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["prikazIzmenaOsnoviceDto"] = this.prikazIzmenaOsnoviceDto ? this.prikazIzmenaOsnoviceDto.toJSON() : <any>undefined;
        data["periodOd"] = this.periodOd ? this.periodOd.toISOString() : <any>undefined;
        data["periodDo"] = this.periodDo ? this.periodDo.toISOString() : <any>undefined;
        data["brojReferentnogDokumenta"] = this.brojReferentnogDokumenta;
        return data;
    }
}

export interface ICreateDokumentOSmanjenjuCommand {
    racunDto?: RacunDto | undefined;
    prikazIzmenaOsnoviceDto?: PrikazIzmenaOsnoviceDto | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    brojReferentnogDokumenta?: string | undefined;
}

export class PrikazIzmenaOsnoviceDto implements IPrikazIzmenaOsnoviceDto {
    prikazIzmenaOsnovice?: PrikazIzmenaOsnovice;
    prikazIzmenaOsnoviceStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IPrikazIzmenaOsnoviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prikazIzmenaOsnovice = _data["prikazIzmenaOsnovice"];
            this.prikazIzmenaOsnoviceStr = _data["prikazIzmenaOsnoviceStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): PrikazIzmenaOsnoviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrikazIzmenaOsnoviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prikazIzmenaOsnovice"] = this.prikazIzmenaOsnovice;
        data["prikazIzmenaOsnoviceStr"] = this.prikazIzmenaOsnoviceStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IPrikazIzmenaOsnoviceDto {
    prikazIzmenaOsnovice?: PrikazIzmenaOsnovice;
    prikazIzmenaOsnoviceStr?: string | undefined;
    opis?: string | undefined;
}

export enum PrikazIzmenaOsnovice {
    FAKTURE_U_PERIODU = 0,
    POJEDINACNA = 1,
    AVANSNA_FAKTURA = 2,
}

export class UpdateDokumentOSmanjenjuCommand implements IUpdateDokumentOSmanjenjuCommand {
    racunDto?: RacunDto | undefined;
    prikazIzmenaOsnoviceDto?: PrikazIzmenaOsnoviceDto | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    brojReferentnogDokumenta?: string | undefined;

    constructor(data?: IUpdateDokumentOSmanjenjuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.prikazIzmenaOsnoviceDto = _data["prikazIzmenaOsnoviceDto"] ? PrikazIzmenaOsnoviceDto.fromJS(_data["prikazIzmenaOsnoviceDto"]) : <any>undefined;
            this.periodOd = _data["periodOd"] ? new Date(_data["periodOd"].toString()) : <any>undefined;
            this.periodDo = _data["periodDo"] ? new Date(_data["periodDo"].toString()) : <any>undefined;
            this.brojReferentnogDokumenta = _data["brojReferentnogDokumenta"];
        }
    }

    static fromJS(data: any): UpdateDokumentOSmanjenjuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDokumentOSmanjenjuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["prikazIzmenaOsnoviceDto"] = this.prikazIzmenaOsnoviceDto ? this.prikazIzmenaOsnoviceDto.toJSON() : <any>undefined;
        data["periodOd"] = this.periodOd ? this.periodOd.toISOString() : <any>undefined;
        data["periodDo"] = this.periodDo ? this.periodDo.toISOString() : <any>undefined;
        data["brojReferentnogDokumenta"] = this.brojReferentnogDokumenta;
        return data;
    }
}

export interface IUpdateDokumentOSmanjenjuCommand {
    racunDto?: RacunDto | undefined;
    prikazIzmenaOsnoviceDto?: PrikazIzmenaOsnoviceDto | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    brojReferentnogDokumenta?: string | undefined;
}

export class PaginatedResultOfPostmarkOutboundMessageDto extends Result implements IPaginatedResultOfPostmarkOutboundMessageDto {
    data?: PostmarkOutboundMessageDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfPostmarkOutboundMessageDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PostmarkOutboundMessageDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfPostmarkOutboundMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfPostmarkOutboundMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfPostmarkOutboundMessageDto extends IResult {
    data?: PostmarkOutboundMessageDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PostmarkOutboundMessageDto implements IPostmarkOutboundMessageDto {
    attachments?: string[] | undefined;
    bcc?: PostmarkRecipientDto[] | undefined;
    cc?: PostmarkRecipientDto[] | undefined;
    recipients?: string[] | undefined;
    to?: PostmarkRecipientDto[] | undefined;
    from?: string | undefined;
    messageId?: string | undefined;
    metadata?: { [key: string]: string; } | undefined;
    receivedAtTime?: string | undefined;
    receivedAtDate?: string | undefined;
    status?: StatusPostmarkMessageDto | undefined;
    subject?: string | undefined;
    tag?: TagPostmarkMessageDto | undefined;

    constructor(data?: IPostmarkOutboundMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(item);
            }
            if (Array.isArray(_data["bcc"])) {
                this.bcc = [] as any;
                for (let item of _data["bcc"])
                    this.bcc!.push(PostmarkRecipientDto.fromJS(item));
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(PostmarkRecipientDto.fromJS(item));
            }
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(item);
            }
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(PostmarkRecipientDto.fromJS(item));
            }
            this.from = _data["from"];
            this.messageId = _data["messageId"];
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
            this.receivedAtTime = _data["receivedAtTime"];
            this.receivedAtDate = _data["receivedAtDate"];
            this.status = _data["status"] ? StatusPostmarkMessageDto.fromJS(_data["status"]) : <any>undefined;
            this.subject = _data["subject"];
            this.tag = _data["tag"] ? TagPostmarkMessageDto.fromJS(_data["tag"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PostmarkOutboundMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostmarkOutboundMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item);
        }
        if (Array.isArray(this.bcc)) {
            data["bcc"] = [];
            for (let item of this.bcc)
                data["bcc"].push(item.toJSON());
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item.toJSON());
        }
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item.toJSON());
        }
        data["from"] = this.from;
        data["messageId"] = this.messageId;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        data["receivedAtTime"] = this.receivedAtTime;
        data["receivedAtDate"] = this.receivedAtDate;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["subject"] = this.subject;
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPostmarkOutboundMessageDto {
    attachments?: string[] | undefined;
    bcc?: PostmarkRecipientDto[] | undefined;
    cc?: PostmarkRecipientDto[] | undefined;
    recipients?: string[] | undefined;
    to?: PostmarkRecipientDto[] | undefined;
    from?: string | undefined;
    messageId?: string | undefined;
    metadata?: { [key: string]: string; } | undefined;
    receivedAtTime?: string | undefined;
    receivedAtDate?: string | undefined;
    status?: StatusPostmarkMessageDto | undefined;
    subject?: string | undefined;
    tag?: TagPostmarkMessageDto | undefined;
}

export class PostmarkRecipientDto implements IPostmarkRecipientDto {
    email?: string | undefined;
    name?: string | undefined;

    constructor(data?: IPostmarkRecipientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PostmarkRecipientDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostmarkRecipientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["name"] = this.name;
        return data;
    }
}

export interface IPostmarkRecipientDto {
    email?: string | undefined;
    name?: string | undefined;
}

export class StatusPostmarkMessageDto implements IStatusPostmarkMessageDto {
    status?: string | undefined;
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IStatusPostmarkMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.statusStr = _data["statusStr"];
            this.statusBadgeStr = _data["statusBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): StatusPostmarkMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusPostmarkMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["statusStr"] = this.statusStr;
        data["statusBadgeStr"] = this.statusBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IStatusPostmarkMessageDto {
    status?: string | undefined;
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class TagPostmarkMessageDto implements ITagPostmarkMessageDto {
    tag?: string | undefined;
    tagStr?: string | undefined;
    tagBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: ITagPostmarkMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag = _data["tag"];
            this.tagStr = _data["tagStr"];
            this.tagBadgeStr = _data["tagBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): TagPostmarkMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagPostmarkMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag;
        data["tagStr"] = this.tagStr;
        data["tagBadgeStr"] = this.tagBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface ITagPostmarkMessageDto {
    tag?: string | undefined;
    tagStr?: string | undefined;
    tagBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class GetEmailTableQuery implements IGetEmailTableQuery {
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetEmailTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetEmailTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetEmailTableQuery {
    pageNumber?: number;
    pageSize?: number;
}

export class ResultOfPostmarkOutboundMessageDetailDto extends Result implements IResultOfPostmarkOutboundMessageDetailDto {
    data?: PostmarkOutboundMessageDetailDto | undefined;

    constructor(data?: IResultOfPostmarkOutboundMessageDetailDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PostmarkOutboundMessageDetailDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfPostmarkOutboundMessageDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfPostmarkOutboundMessageDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfPostmarkOutboundMessageDetailDto extends IResult {
    data?: PostmarkOutboundMessageDetailDto | undefined;
}

export class PostmarkOutboundMessageDetailDto implements IPostmarkOutboundMessageDetailDto {
    textBody?: string | undefined;
    htmlBody?: string | undefined;
    body?: string | undefined;
    tag?: TagPostmarkMessageDto | undefined;
    messageId?: string | undefined;
    messageStream?: string | undefined;
    to?: PostmarkRecipientDto[] | undefined;
    cc?: PostmarkRecipientDto[] | undefined;
    bcc?: PostmarkRecipientDto[] | undefined;
    recipients?: string[] | undefined;
    receivedAtTime?: string | undefined;
    receivedAtDate?: string | undefined;
    from?: string | undefined;
    subject?: string | undefined;
    attachments?: string[] | undefined;
    status?: StatusPostmarkMessageDto | undefined;
    trackOpens?: boolean;
    tracksLinks?: string | undefined;
    metadata?: { [key: string]: string; } | undefined;
    sandboxed?: boolean;
    messageEvents?: PostmarkMessageEventsDto[] | undefined;

    constructor(data?: IPostmarkOutboundMessageDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.textBody = _data["textBody"];
            this.htmlBody = _data["htmlBody"];
            this.body = _data["body"];
            this.tag = _data["tag"] ? TagPostmarkMessageDto.fromJS(_data["tag"]) : <any>undefined;
            this.messageId = _data["messageId"];
            this.messageStream = _data["messageStream"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(PostmarkRecipientDto.fromJS(item));
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(PostmarkRecipientDto.fromJS(item));
            }
            if (Array.isArray(_data["bcc"])) {
                this.bcc = [] as any;
                for (let item of _data["bcc"])
                    this.bcc!.push(PostmarkRecipientDto.fromJS(item));
            }
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(item);
            }
            this.receivedAtTime = _data["receivedAtTime"];
            this.receivedAtDate = _data["receivedAtDate"];
            this.from = _data["from"];
            this.subject = _data["subject"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(item);
            }
            this.status = _data["status"] ? StatusPostmarkMessageDto.fromJS(_data["status"]) : <any>undefined;
            this.trackOpens = _data["trackOpens"];
            this.tracksLinks = _data["tracksLinks"];
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
            this.sandboxed = _data["sandboxed"];
            if (Array.isArray(_data["messageEvents"])) {
                this.messageEvents = [] as any;
                for (let item of _data["messageEvents"])
                    this.messageEvents!.push(PostmarkMessageEventsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PostmarkOutboundMessageDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostmarkOutboundMessageDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["textBody"] = this.textBody;
        data["htmlBody"] = this.htmlBody;
        data["body"] = this.body;
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        data["messageId"] = this.messageId;
        data["messageStream"] = this.messageStream;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item.toJSON());
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item.toJSON());
        }
        if (Array.isArray(this.bcc)) {
            data["bcc"] = [];
            for (let item of this.bcc)
                data["bcc"].push(item.toJSON());
        }
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        data["receivedAtTime"] = this.receivedAtTime;
        data["receivedAtDate"] = this.receivedAtDate;
        data["from"] = this.from;
        data["subject"] = this.subject;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item);
        }
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["trackOpens"] = this.trackOpens;
        data["tracksLinks"] = this.tracksLinks;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        data["sandboxed"] = this.sandboxed;
        if (Array.isArray(this.messageEvents)) {
            data["messageEvents"] = [];
            for (let item of this.messageEvents)
                data["messageEvents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPostmarkOutboundMessageDetailDto {
    textBody?: string | undefined;
    htmlBody?: string | undefined;
    body?: string | undefined;
    tag?: TagPostmarkMessageDto | undefined;
    messageId?: string | undefined;
    messageStream?: string | undefined;
    to?: PostmarkRecipientDto[] | undefined;
    cc?: PostmarkRecipientDto[] | undefined;
    bcc?: PostmarkRecipientDto[] | undefined;
    recipients?: string[] | undefined;
    receivedAtTime?: string | undefined;
    receivedAtDate?: string | undefined;
    from?: string | undefined;
    subject?: string | undefined;
    attachments?: string[] | undefined;
    status?: StatusPostmarkMessageDto | undefined;
    trackOpens?: boolean;
    tracksLinks?: string | undefined;
    metadata?: { [key: string]: string; } | undefined;
    sandboxed?: boolean;
    messageEvents?: PostmarkMessageEventsDto[] | undefined;
}

export class PostmarkMessageEventsDto implements IPostmarkMessageEventsDto {
    recipient?: string | undefined;
    type?: string | undefined;
    receivedAt?: Date;
    details?: { [key: string]: string; } | undefined;

    constructor(data?: IPostmarkMessageEventsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipient = _data["recipient"];
            this.type = _data["type"];
            this.receivedAt = _data["receivedAt"] ? new Date(_data["receivedAt"].toString()) : <any>undefined;
            if (_data["details"]) {
                this.details = {} as any;
                for (let key in _data["details"]) {
                    if (_data["details"].hasOwnProperty(key))
                        (<any>this.details)![key] = _data["details"][key];
                }
            }
        }
    }

    static fromJS(data: any): PostmarkMessageEventsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostmarkMessageEventsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipient"] = this.recipient;
        data["type"] = this.type;
        data["receivedAt"] = this.receivedAt ? this.receivedAt.toISOString() : <any>undefined;
        if (this.details) {
            data["details"] = {};
            for (let key in this.details) {
                if (this.details.hasOwnProperty(key))
                    (<any>data["details"])[key] = (<any>this.details)[key];
            }
        }
        return data;
    }
}

export interface IPostmarkMessageEventsDto {
    recipient?: string | undefined;
    type?: string | undefined;
    receivedAt?: Date;
    details?: { [key: string]: string; } | undefined;
}

export class ResultOfGetEmailsForRacunResponse extends Result implements IResultOfGetEmailsForRacunResponse {
    data?: GetEmailsForRacunResponse | undefined;

    constructor(data?: IResultOfGetEmailsForRacunResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetEmailsForRacunResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetEmailsForRacunResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetEmailsForRacunResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetEmailsForRacunResponse extends IResult {
    data?: GetEmailsForRacunResponse | undefined;
}

export class GetEmailsForRacunResponse implements IGetEmailsForRacunResponse {
    emails?: PostmarkOutboundMessageDetailDto[] | undefined;

    constructor(data?: IGetEmailsForRacunResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(PostmarkOutboundMessageDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEmailsForRacunResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailsForRacunResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEmailsForRacunResponse {
    emails?: PostmarkOutboundMessageDetailDto[] | undefined;
}

export class EOtpremnicaDto implements IEOtpremnicaDto {
    id?: number | undefined;
    tipOtpremnice?: TipOtpremnice;
    vrstaDokumenta?: VrstaDokumentaOtpremnica;
    broj?: string | undefined;
    datumIzdavanjaOtpremnice?: Date;
    tezinaIsporuke?: number | undefined;
    zapreminaIsporuke?: number | undefined;
    stvarniDatum?: Date;
    brojPaketa?: number;
    brojUgovora?: string | undefined;
    brojNarudzbenice?: string | undefined;
    brojOkvirnogSporazuma?: string | undefined;
    jeRobaTreceStrane?: boolean;
    napomena?: string | undefined;
    robaTreceStrane?: string | undefined;
    brojOtpremniceTrecaStrana?: string | undefined;
    strankaDto?: StrankaOtpremniceDto | undefined;
    posiljalacKontaktDto?: KontaktOsobaDto | undefined;
    posiljalacKontaktOsobaId?: number | undefined;
    primalacKontaktDto?: KontaktOsobaDto | undefined;
    primalacKontaktOsobaId?: number | undefined;
    nacinOtpreme?: NacinOtpreme;
    licniNacinOtpreme?: LicniNacinOtpremeDto | undefined;
    adresaOtpremeDto?: AdresaIsporukeDto | undefined;
    adresaOdredistaDto?: AdresaIsporukeDto | undefined;
    fazeVoznjeDto?: FazaVoznjeDto[] | undefined;
    stavkeDto?: StavkaOtpremniceDto[] | undefined;
    jedinicaMereTezinaDto?: JedinicaMereDto | undefined;
    jedinicaMereZapreminaDto?: JedinicaMereDto | undefined;
    planiraniDatumPocetka?: Date | undefined;
    planiraniDatumZavrsetka?: Date;
    napomenaIsporuke?: string | undefined;
    povratRobe?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    opasneMaterijeDto?: OpasnaMaterijaDto[] | undefined;
    imaOpasneMaterije?: boolean;
    status?: StatusEOtpremnice;
    sefId?: string | undefined;
    praviloZaBrojId?: number | undefined;
    pdfDokumentList?: FileAttachment[] | undefined;
    predracunId?: number | undefined;

    constructor(data?: IEOtpremnicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tipOtpremnice = _data["tipOtpremnice"];
            this.vrstaDokumenta = _data["vrstaDokumenta"];
            this.broj = _data["broj"];
            this.datumIzdavanjaOtpremnice = _data["datumIzdavanjaOtpremnice"] ? new Date(_data["datumIzdavanjaOtpremnice"].toString()) : <any>undefined;
            this.tezinaIsporuke = _data["tezinaIsporuke"];
            this.zapreminaIsporuke = _data["zapreminaIsporuke"];
            this.stvarniDatum = _data["stvarniDatum"] ? new Date(_data["stvarniDatum"].toString()) : <any>undefined;
            this.brojPaketa = _data["brojPaketa"];
            this.brojUgovora = _data["brojUgovora"];
            this.brojNarudzbenice = _data["brojNarudzbenice"];
            this.brojOkvirnogSporazuma = _data["brojOkvirnogSporazuma"];
            this.jeRobaTreceStrane = _data["jeRobaTreceStrane"];
            this.napomena = _data["napomena"];
            this.robaTreceStrane = _data["robaTreceStrane"];
            this.brojOtpremniceTrecaStrana = _data["brojOtpremniceTrecaStrana"];
            this.strankaDto = _data["strankaDto"] ? StrankaOtpremniceDto.fromJS(_data["strankaDto"]) : <any>undefined;
            this.posiljalacKontaktDto = _data["posiljalacKontaktDto"] ? KontaktOsobaDto.fromJS(_data["posiljalacKontaktDto"]) : <any>undefined;
            this.posiljalacKontaktOsobaId = _data["posiljalacKontaktOsobaId"];
            this.primalacKontaktDto = _data["primalacKontaktDto"] ? KontaktOsobaDto.fromJS(_data["primalacKontaktDto"]) : <any>undefined;
            this.primalacKontaktOsobaId = _data["primalacKontaktOsobaId"];
            this.nacinOtpreme = _data["nacinOtpreme"];
            this.licniNacinOtpreme = _data["licniNacinOtpreme"] ? LicniNacinOtpremeDto.fromJS(_data["licniNacinOtpreme"]) : <any>undefined;
            this.adresaOtpremeDto = _data["adresaOtpremeDto"] ? AdresaIsporukeDto.fromJS(_data["adresaOtpremeDto"]) : <any>undefined;
            this.adresaOdredistaDto = _data["adresaOdredistaDto"] ? AdresaIsporukeDto.fromJS(_data["adresaOdredistaDto"]) : <any>undefined;
            if (Array.isArray(_data["fazeVoznjeDto"])) {
                this.fazeVoznjeDto = [] as any;
                for (let item of _data["fazeVoznjeDto"])
                    this.fazeVoznjeDto!.push(FazaVoznjeDto.fromJS(item));
            }
            if (Array.isArray(_data["stavkeDto"])) {
                this.stavkeDto = [] as any;
                for (let item of _data["stavkeDto"])
                    this.stavkeDto!.push(StavkaOtpremniceDto.fromJS(item));
            }
            this.jedinicaMereTezinaDto = _data["jedinicaMereTezinaDto"] ? JedinicaMereDto.fromJS(_data["jedinicaMereTezinaDto"]) : <any>undefined;
            this.jedinicaMereZapreminaDto = _data["jedinicaMereZapreminaDto"] ? JedinicaMereDto.fromJS(_data["jedinicaMereZapreminaDto"]) : <any>undefined;
            this.planiraniDatumPocetka = _data["planiraniDatumPocetka"] ? new Date(_data["planiraniDatumPocetka"].toString()) : <any>undefined;
            this.planiraniDatumZavrsetka = _data["planiraniDatumZavrsetka"] ? new Date(_data["planiraniDatumZavrsetka"].toString()) : <any>undefined;
            this.napomenaIsporuke = _data["napomenaIsporuke"];
            this.povratRobe = _data["povratRobe"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedOn = _data["lastModifiedOn"] ? new Date(_data["lastModifiedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["opasneMaterijeDto"])) {
                this.opasneMaterijeDto = [] as any;
                for (let item of _data["opasneMaterijeDto"])
                    this.opasneMaterijeDto!.push(OpasnaMaterijaDto.fromJS(item));
            }
            this.imaOpasneMaterije = _data["imaOpasneMaterije"];
            this.status = _data["status"];
            this.sefId = _data["sefId"];
            this.praviloZaBrojId = _data["praviloZaBrojId"];
            if (Array.isArray(_data["pdfDokumentList"])) {
                this.pdfDokumentList = [] as any;
                for (let item of _data["pdfDokumentList"])
                    this.pdfDokumentList!.push(FileAttachment.fromJS(item));
            }
            this.predracunId = _data["predracunId"];
        }
    }

    static fromJS(data: any): EOtpremnicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EOtpremnicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipOtpremnice"] = this.tipOtpremnice;
        data["vrstaDokumenta"] = this.vrstaDokumenta;
        data["broj"] = this.broj;
        data["datumIzdavanjaOtpremnice"] = this.datumIzdavanjaOtpremnice ? formatDate(this.datumIzdavanjaOtpremnice) : <any>undefined;
        data["tezinaIsporuke"] = this.tezinaIsporuke;
        data["zapreminaIsporuke"] = this.zapreminaIsporuke;
        data["stvarniDatum"] = this.stvarniDatum ? this.stvarniDatum.toISOString() : <any>undefined;
        data["brojPaketa"] = this.brojPaketa;
        data["brojUgovora"] = this.brojUgovora;
        data["brojNarudzbenice"] = this.brojNarudzbenice;
        data["brojOkvirnogSporazuma"] = this.brojOkvirnogSporazuma;
        data["jeRobaTreceStrane"] = this.jeRobaTreceStrane;
        data["napomena"] = this.napomena;
        data["robaTreceStrane"] = this.robaTreceStrane;
        data["brojOtpremniceTrecaStrana"] = this.brojOtpremniceTrecaStrana;
        data["strankaDto"] = this.strankaDto ? this.strankaDto.toJSON() : <any>undefined;
        data["posiljalacKontaktDto"] = this.posiljalacKontaktDto ? this.posiljalacKontaktDto.toJSON() : <any>undefined;
        data["posiljalacKontaktOsobaId"] = this.posiljalacKontaktOsobaId;
        data["primalacKontaktDto"] = this.primalacKontaktDto ? this.primalacKontaktDto.toJSON() : <any>undefined;
        data["primalacKontaktOsobaId"] = this.primalacKontaktOsobaId;
        data["nacinOtpreme"] = this.nacinOtpreme;
        data["licniNacinOtpreme"] = this.licniNacinOtpreme ? this.licniNacinOtpreme.toJSON() : <any>undefined;
        data["adresaOtpremeDto"] = this.adresaOtpremeDto ? this.adresaOtpremeDto.toJSON() : <any>undefined;
        data["adresaOdredistaDto"] = this.adresaOdredistaDto ? this.adresaOdredistaDto.toJSON() : <any>undefined;
        if (Array.isArray(this.fazeVoznjeDto)) {
            data["fazeVoznjeDto"] = [];
            for (let item of this.fazeVoznjeDto)
                data["fazeVoznjeDto"].push(item.toJSON());
        }
        if (Array.isArray(this.stavkeDto)) {
            data["stavkeDto"] = [];
            for (let item of this.stavkeDto)
                data["stavkeDto"].push(item.toJSON());
        }
        data["jedinicaMereTezinaDto"] = this.jedinicaMereTezinaDto ? this.jedinicaMereTezinaDto.toJSON() : <any>undefined;
        data["jedinicaMereZapreminaDto"] = this.jedinicaMereZapreminaDto ? this.jedinicaMereZapreminaDto.toJSON() : <any>undefined;
        data["planiraniDatumPocetka"] = this.planiraniDatumPocetka ? this.planiraniDatumPocetka.toISOString() : <any>undefined;
        data["planiraniDatumZavrsetka"] = this.planiraniDatumZavrsetka ? this.planiraniDatumZavrsetka.toISOString() : <any>undefined;
        data["napomenaIsporuke"] = this.napomenaIsporuke;
        data["povratRobe"] = this.povratRobe;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.opasneMaterijeDto)) {
            data["opasneMaterijeDto"] = [];
            for (let item of this.opasneMaterijeDto)
                data["opasneMaterijeDto"].push(item.toJSON());
        }
        data["imaOpasneMaterije"] = this.imaOpasneMaterije;
        data["status"] = this.status;
        data["sefId"] = this.sefId;
        data["praviloZaBrojId"] = this.praviloZaBrojId;
        if (Array.isArray(this.pdfDokumentList)) {
            data["pdfDokumentList"] = [];
            for (let item of this.pdfDokumentList)
                data["pdfDokumentList"].push(item.toJSON());
        }
        data["predracunId"] = this.predracunId;
        return data;
    }
}

export interface IEOtpremnicaDto {
    id?: number | undefined;
    tipOtpremnice?: TipOtpremnice;
    vrstaDokumenta?: VrstaDokumentaOtpremnica;
    broj?: string | undefined;
    datumIzdavanjaOtpremnice?: Date;
    tezinaIsporuke?: number | undefined;
    zapreminaIsporuke?: number | undefined;
    stvarniDatum?: Date;
    brojPaketa?: number;
    brojUgovora?: string | undefined;
    brojNarudzbenice?: string | undefined;
    brojOkvirnogSporazuma?: string | undefined;
    jeRobaTreceStrane?: boolean;
    napomena?: string | undefined;
    robaTreceStrane?: string | undefined;
    brojOtpremniceTrecaStrana?: string | undefined;
    strankaDto?: StrankaOtpremniceDto | undefined;
    posiljalacKontaktDto?: KontaktOsobaDto | undefined;
    posiljalacKontaktOsobaId?: number | undefined;
    primalacKontaktDto?: KontaktOsobaDto | undefined;
    primalacKontaktOsobaId?: number | undefined;
    nacinOtpreme?: NacinOtpreme;
    licniNacinOtpreme?: LicniNacinOtpremeDto | undefined;
    adresaOtpremeDto?: AdresaIsporukeDto | undefined;
    adresaOdredistaDto?: AdresaIsporukeDto | undefined;
    fazeVoznjeDto?: FazaVoznjeDto[] | undefined;
    stavkeDto?: StavkaOtpremniceDto[] | undefined;
    jedinicaMereTezinaDto?: JedinicaMereDto | undefined;
    jedinicaMereZapreminaDto?: JedinicaMereDto | undefined;
    planiraniDatumPocetka?: Date | undefined;
    planiraniDatumZavrsetka?: Date;
    napomenaIsporuke?: string | undefined;
    povratRobe?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    opasneMaterijeDto?: OpasnaMaterijaDto[] | undefined;
    imaOpasneMaterije?: boolean;
    status?: StatusEOtpremnice;
    sefId?: string | undefined;
    praviloZaBrojId?: number | undefined;
    pdfDokumentList?: FileAttachment[] | undefined;
    predracunId?: number | undefined;
}

export class CreateEOtpremnicaCommand extends EOtpremnicaDto implements ICreateEOtpremnicaCommand {

    constructor(data?: ICreateEOtpremnicaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateEOtpremnicaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEOtpremnicaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateEOtpremnicaCommand extends IEOtpremnicaDto {
}

export enum TipOtpremnice {
    EKSTERNA = 0,
    INTERNA = 1,
}

export enum VrstaDokumentaOtpremnica {
    IZLAZNA = 0,
    ULAZNA = 1,
}

export class StrankaOtpremniceDto implements IStrankaOtpremniceDto {
    id?: number | undefined;
    naziv?: string | undefined;
    adresa?: string | undefined;
    pib?: string | undefined;
    mb?: string | undefined;
    tipStranke?: TipStranke;
    jeAktivna?: boolean;
    brojUgovora?: string | undefined;
    brojTendera?: string | undefined;
    registracioniBroj?: string | undefined;
    jbkjs?: string | undefined;
    grad?: string | undefined;

    constructor(data?: IStrankaOtpremniceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.adresa = _data["adresa"];
            this.pib = _data["pib"];
            this.mb = _data["mb"];
            this.tipStranke = _data["tipStranke"];
            this.jeAktivna = _data["jeAktivna"];
            this.brojUgovora = _data["brojUgovora"];
            this.brojTendera = _data["brojTendera"];
            this.registracioniBroj = _data["registracioniBroj"];
            this.jbkjs = _data["jbkjs"];
            this.grad = _data["grad"];
        }
    }

    static fromJS(data: any): StrankaOtpremniceDto {
        data = typeof data === 'object' ? data : {};
        let result = new StrankaOtpremniceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["adresa"] = this.adresa;
        data["pib"] = this.pib;
        data["mb"] = this.mb;
        data["tipStranke"] = this.tipStranke;
        data["jeAktivna"] = this.jeAktivna;
        data["brojUgovora"] = this.brojUgovora;
        data["brojTendera"] = this.brojTendera;
        data["registracioniBroj"] = this.registracioniBroj;
        data["jbkjs"] = this.jbkjs;
        data["grad"] = this.grad;
        return data;
    }
}

export interface IStrankaOtpremniceDto {
    id?: number | undefined;
    naziv?: string | undefined;
    adresa?: string | undefined;
    pib?: string | undefined;
    mb?: string | undefined;
    tipStranke?: TipStranke;
    jeAktivna?: boolean;
    brojUgovora?: string | undefined;
    brojTendera?: string | undefined;
    registracioniBroj?: string | undefined;
    jbkjs?: string | undefined;
    grad?: string | undefined;
}

export class KontaktOsobaDto implements IKontaktOsobaDto {
    id?: number | undefined;
    ime?: string | undefined;
    telefon?: string | undefined;
    email?: string | undefined;

    constructor(data?: IKontaktOsobaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ime = _data["ime"];
            this.telefon = _data["telefon"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): KontaktOsobaDto {
        data = typeof data === 'object' ? data : {};
        let result = new KontaktOsobaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ime"] = this.ime;
        data["telefon"] = this.telefon;
        data["email"] = this.email;
        return data;
    }
}

export interface IKontaktOsobaDto {
    id?: number | undefined;
    ime?: string | undefined;
    telefon?: string | undefined;
    email?: string | undefined;
}

export enum NacinOtpreme {
    SOPSTVENI_PREVOZ = 0,
    PREVOZNIK = 1,
    PREVOZ_PRIMAOCA = 2,
    LICNO_PREUZIMANJE = 3,
    LICNA_DOSTAVA = 4,
}

export class LicniNacinOtpremeDto implements ILicniNacinOtpremeDto {
    id?: number | undefined;
    ime?: string | undefined;
    prezime?: string | undefined;
    brojLicneKarte?: string | undefined;

    constructor(data?: ILicniNacinOtpremeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ime = _data["ime"];
            this.prezime = _data["prezime"];
            this.brojLicneKarte = _data["brojLicneKarte"];
        }
    }

    static fromJS(data: any): LicniNacinOtpremeDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicniNacinOtpremeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ime"] = this.ime;
        data["prezime"] = this.prezime;
        data["brojLicneKarte"] = this.brojLicneKarte;
        return data;
    }
}

export interface ILicniNacinOtpremeDto {
    id?: number | undefined;
    ime?: string | undefined;
    prezime?: string | undefined;
    brojLicneKarte?: string | undefined;
}

export class AdresaIsporukeDto implements IAdresaIsporukeDto {
    id?: number | undefined;
    ulica?: string | undefined;
    broj?: string | undefined;
    mesto?: string | undefined;
    postanskiBroj?: string | undefined;
    magacinId?: number | undefined;
    nazivMagacina?: string | undefined;
    sifraObjekta?: string | undefined;

    constructor(data?: IAdresaIsporukeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ulica = _data["ulica"];
            this.broj = _data["broj"];
            this.mesto = _data["mesto"];
            this.postanskiBroj = _data["postanskiBroj"];
            this.magacinId = _data["magacinId"];
            this.nazivMagacina = _data["nazivMagacina"];
            this.sifraObjekta = _data["sifraObjekta"];
        }
    }

    static fromJS(data: any): AdresaIsporukeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdresaIsporukeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ulica"] = this.ulica;
        data["broj"] = this.broj;
        data["mesto"] = this.mesto;
        data["postanskiBroj"] = this.postanskiBroj;
        data["magacinId"] = this.magacinId;
        data["nazivMagacina"] = this.nazivMagacina;
        data["sifraObjekta"] = this.sifraObjekta;
        return data;
    }
}

export interface IAdresaIsporukeDto {
    id?: number | undefined;
    ulica?: string | undefined;
    broj?: string | undefined;
    mesto?: string | undefined;
    postanskiBroj?: string | undefined;
    magacinId?: number | undefined;
    nazivMagacina?: string | undefined;
    sifraObjekta?: string | undefined;
}

export class FazaVoznjeDto implements IFazaVoznjeDto {
    id?: number | undefined;
    mestoUtovara?: string | undefined;
    mestoIsporuke?: string | undefined;
    prevoznikDto?: StrankaOtpremniceDto | undefined;
    prevoznikId?: number | undefined;
    vozacDto?: VozacFazeDto | undefined;
    vozacFazeId?: number | undefined;
    redniBroj?: number;

    constructor(data?: IFazaVoznjeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mestoUtovara = _data["mestoUtovara"];
            this.mestoIsporuke = _data["mestoIsporuke"];
            this.prevoznikDto = _data["prevoznikDto"] ? StrankaOtpremniceDto.fromJS(_data["prevoznikDto"]) : <any>undefined;
            this.prevoznikId = _data["prevoznikId"];
            this.vozacDto = _data["vozacDto"] ? VozacFazeDto.fromJS(_data["vozacDto"]) : <any>undefined;
            this.vozacFazeId = _data["vozacFazeId"];
            this.redniBroj = _data["redniBroj"];
        }
    }

    static fromJS(data: any): FazaVoznjeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FazaVoznjeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mestoUtovara"] = this.mestoUtovara;
        data["mestoIsporuke"] = this.mestoIsporuke;
        data["prevoznikDto"] = this.prevoznikDto ? this.prevoznikDto.toJSON() : <any>undefined;
        data["prevoznikId"] = this.prevoznikId;
        data["vozacDto"] = this.vozacDto ? this.vozacDto.toJSON() : <any>undefined;
        data["vozacFazeId"] = this.vozacFazeId;
        data["redniBroj"] = this.redniBroj;
        return data;
    }
}

export interface IFazaVoznjeDto {
    id?: number | undefined;
    mestoUtovara?: string | undefined;
    mestoIsporuke?: string | undefined;
    prevoznikDto?: StrankaOtpremniceDto | undefined;
    prevoznikId?: number | undefined;
    vozacDto?: VozacFazeDto | undefined;
    vozacFazeId?: number | undefined;
    redniBroj?: number;
}

export class VozacFazeDto implements IVozacFazeDto {
    id?: number | undefined;
    ime?: string | undefined;
    prezime?: string | undefined;
    email?: string | undefined;
    telefon?: string | undefined;
    registarskiBrojVozila?: string | undefined;
    brojVozackeDozvole?: string | undefined;

    constructor(data?: IVozacFazeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ime = _data["ime"];
            this.prezime = _data["prezime"];
            this.email = _data["email"];
            this.telefon = _data["telefon"];
            this.registarskiBrojVozila = _data["registarskiBrojVozila"];
            this.brojVozackeDozvole = _data["brojVozackeDozvole"];
        }
    }

    static fromJS(data: any): VozacFazeDto {
        data = typeof data === 'object' ? data : {};
        let result = new VozacFazeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ime"] = this.ime;
        data["prezime"] = this.prezime;
        data["email"] = this.email;
        data["telefon"] = this.telefon;
        data["registarskiBrojVozila"] = this.registarskiBrojVozila;
        data["brojVozackeDozvole"] = this.brojVozackeDozvole;
        return data;
    }
}

export interface IVozacFazeDto {
    id?: number | undefined;
    ime?: string | undefined;
    prezime?: string | undefined;
    email?: string | undefined;
    telefon?: string | undefined;
    registarskiBrojVozila?: string | undefined;
    brojVozackeDozvole?: string | undefined;
}

export class StavkaOtpremniceDto implements IStavkaOtpremniceDto {
    id?: number | undefined;
    predmetStavkeDto?: PredmetStavkeDto | undefined;
    gtin?: string | undefined;
    naziv?: string | undefined;
    kolicina?: number;
    jedinicaMereDto?: JedinicaMereDto | undefined;
    jedinicaMereId?: number;
    akciznaKategorijaDto?: AkciznaKategorijaDto | undefined;
    komentar?: string | undefined;
    pristiglaKolicina?: number | undefined;
    primljenaKolicina?: number | undefined;
    vracenaKolicina?: number | undefined;
    redniBroj?: number | undefined;
    sifra?: string | undefined;
    dodatniAtributiDto?: DodatniAtributStavkeDto[] | undefined;

    constructor(data?: IStavkaOtpremniceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.predmetStavkeDto = _data["predmetStavkeDto"] ? PredmetStavkeDto.fromJS(_data["predmetStavkeDto"]) : <any>undefined;
            this.gtin = _data["gtin"];
            this.naziv = _data["naziv"];
            this.kolicina = _data["kolicina"];
            this.jedinicaMereDto = _data["jedinicaMereDto"] ? JedinicaMereDto.fromJS(_data["jedinicaMereDto"]) : <any>undefined;
            this.jedinicaMereId = _data["jedinicaMereId"];
            this.akciznaKategorijaDto = _data["akciznaKategorijaDto"] ? AkciznaKategorijaDto.fromJS(_data["akciznaKategorijaDto"]) : <any>undefined;
            this.komentar = _data["komentar"];
            this.pristiglaKolicina = _data["pristiglaKolicina"];
            this.primljenaKolicina = _data["primljenaKolicina"];
            this.vracenaKolicina = _data["vracenaKolicina"];
            this.redniBroj = _data["redniBroj"];
            this.sifra = _data["sifra"];
            if (Array.isArray(_data["dodatniAtributiDto"])) {
                this.dodatniAtributiDto = [] as any;
                for (let item of _data["dodatniAtributiDto"])
                    this.dodatniAtributiDto!.push(DodatniAtributStavkeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StavkaOtpremniceDto {
        data = typeof data === 'object' ? data : {};
        let result = new StavkaOtpremniceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["predmetStavkeDto"] = this.predmetStavkeDto ? this.predmetStavkeDto.toJSON() : <any>undefined;
        data["gtin"] = this.gtin;
        data["naziv"] = this.naziv;
        data["kolicina"] = this.kolicina;
        data["jedinicaMereDto"] = this.jedinicaMereDto ? this.jedinicaMereDto.toJSON() : <any>undefined;
        data["jedinicaMereId"] = this.jedinicaMereId;
        data["akciznaKategorijaDto"] = this.akciznaKategorijaDto ? this.akciznaKategorijaDto.toJSON() : <any>undefined;
        data["komentar"] = this.komentar;
        data["pristiglaKolicina"] = this.pristiglaKolicina;
        data["primljenaKolicina"] = this.primljenaKolicina;
        data["vracenaKolicina"] = this.vracenaKolicina;
        data["redniBroj"] = this.redniBroj;
        data["sifra"] = this.sifra;
        if (Array.isArray(this.dodatniAtributiDto)) {
            data["dodatniAtributiDto"] = [];
            for (let item of this.dodatniAtributiDto)
                data["dodatniAtributiDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStavkaOtpremniceDto {
    id?: number | undefined;
    predmetStavkeDto?: PredmetStavkeDto | undefined;
    gtin?: string | undefined;
    naziv?: string | undefined;
    kolicina?: number;
    jedinicaMereDto?: JedinicaMereDto | undefined;
    jedinicaMereId?: number;
    akciznaKategorijaDto?: AkciznaKategorijaDto | undefined;
    komentar?: string | undefined;
    pristiglaKolicina?: number | undefined;
    primljenaKolicina?: number | undefined;
    vracenaKolicina?: number | undefined;
    redniBroj?: number | undefined;
    sifra?: string | undefined;
    dodatniAtributiDto?: DodatniAtributStavkeDto[] | undefined;
}

export class AkciznaKategorijaDto implements IAkciznaKategorijaDto {
    id?: number | undefined;
    tipAkcizneKategorije?: TipAkcizneKategorije | undefined;
    vrednost?: string | undefined;
    tipPakovanjaDuvana?: TipPakovanjaDuvana | undefined;
    sifraRobneMarke?: string | undefined;

    constructor(data?: IAkciznaKategorijaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tipAkcizneKategorije = _data["tipAkcizneKategorije"];
            this.vrednost = _data["vrednost"];
            this.tipPakovanjaDuvana = _data["tipPakovanjaDuvana"];
            this.sifraRobneMarke = _data["sifraRobneMarke"];
        }
    }

    static fromJS(data: any): AkciznaKategorijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AkciznaKategorijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipAkcizneKategorije"] = this.tipAkcizneKategorije;
        data["vrednost"] = this.vrednost;
        data["tipPakovanjaDuvana"] = this.tipPakovanjaDuvana;
        data["sifraRobneMarke"] = this.sifraRobneMarke;
        return data;
    }
}

export interface IAkciznaKategorijaDto {
    id?: number | undefined;
    tipAkcizneKategorije?: TipAkcizneKategorije | undefined;
    vrednost?: string | undefined;
    tipPakovanjaDuvana?: TipPakovanjaDuvana | undefined;
    sifraRobneMarke?: string | undefined;
}

export enum TipAkcizneKategorije {
    DUVAN = 0,
    KAFA = 1,
    ALKOHOL = 2,
    NAFTNI_DERIVATI = 3,
    NIKOTINSKI_PROIZVODI = 4,
}

export enum TipPakovanjaDuvana {
    PALETA = 0,
    BOKS = 1,
    MASTER_CASE = 2,
    PAKLICA = 3,
}

export class DodatniAtributStavkeDto implements IDodatniAtributStavkeDto {
    id?: number | undefined;
    naziv?: string | undefined;
    vrednost?: string | undefined;

    constructor(data?: IDodatniAtributStavkeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.vrednost = _data["vrednost"];
        }
    }

    static fromJS(data: any): DodatniAtributStavkeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DodatniAtributStavkeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["vrednost"] = this.vrednost;
        return data;
    }
}

export interface IDodatniAtributStavkeDto {
    id?: number | undefined;
    naziv?: string | undefined;
    vrednost?: string | undefined;
}

export class OpasnaMaterijaDto implements IOpasnaMaterijaDto {
    id?: number | undefined;
    naziv?: string | undefined;
    vrednost?: string | undefined;
    komentar?: string | undefined;

    constructor(data?: IOpasnaMaterijaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.vrednost = _data["vrednost"];
            this.komentar = _data["komentar"];
        }
    }

    static fromJS(data: any): OpasnaMaterijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpasnaMaterijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["vrednost"] = this.vrednost;
        data["komentar"] = this.komentar;
        return data;
    }
}

export interface IOpasnaMaterijaDto {
    id?: number | undefined;
    naziv?: string | undefined;
    vrednost?: string | undefined;
    komentar?: string | undefined;
}

export enum StatusEOtpremnice {
    EMPTY = 0,
    POSLATO = 1,
    PRIMLJENO = 2,
    STORNIRANO = 3,
    FIZICKI_PRIJEM = 4,
    ZAPLENJENO = 5,
    USAGLASENO = 6,
    PRIHVACENO = 7,
    ODBIJENO = 8,
    NACRT = 9,
    SLANJE = 10,
}

export class CreateEPrijemnicaCommand implements ICreateEPrijemnicaCommand {
    eOtpremniceId?: number;
    brojPrijemnice?: string | undefined;
    stavkeDto?: StavkaOtpremniceDto[] | undefined;
    magacinId?: number;
    napomena?: string | undefined;
    praviloZaBrojId?: number;

    constructor(data?: ICreateEPrijemnicaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eOtpremniceId = _data["eOtpremniceId"];
            this.brojPrijemnice = _data["brojPrijemnice"];
            if (Array.isArray(_data["stavkeDto"])) {
                this.stavkeDto = [] as any;
                for (let item of _data["stavkeDto"])
                    this.stavkeDto!.push(StavkaOtpremniceDto.fromJS(item));
            }
            this.magacinId = _data["magacinId"];
            this.napomena = _data["napomena"];
            this.praviloZaBrojId = _data["praviloZaBrojId"];
        }
    }

    static fromJS(data: any): CreateEPrijemnicaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEPrijemnicaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eOtpremniceId"] = this.eOtpremniceId;
        data["brojPrijemnice"] = this.brojPrijemnice;
        if (Array.isArray(this.stavkeDto)) {
            data["stavkeDto"] = [];
            for (let item of this.stavkeDto)
                data["stavkeDto"].push(item.toJSON());
        }
        data["magacinId"] = this.magacinId;
        data["napomena"] = this.napomena;
        data["praviloZaBrojId"] = this.praviloZaBrojId;
        return data;
    }
}

export interface ICreateEPrijemnicaCommand {
    eOtpremniceId?: number;
    brojPrijemnice?: string | undefined;
    stavkeDto?: StavkaOtpremniceDto[] | undefined;
    magacinId?: number;
    napomena?: string | undefined;
    praviloZaBrojId?: number;
}

export class ResultOfEPrijemnicaDto extends Result implements IResultOfEPrijemnicaDto {
    data?: EPrijemnicaDto | undefined;

    constructor(data?: IResultOfEPrijemnicaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EPrijemnicaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfEPrijemnicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfEPrijemnicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfEPrijemnicaDto extends IResult {
    data?: EPrijemnicaDto | undefined;
}

export class EPrijemnicaDto implements IEPrijemnicaDto {
    id?: number | undefined;
    tipOtpremnice?: TipOtpremnice;
    vrstaDokumenta?: VrstaDokumentaOtpremnica;
    broj?: string | undefined;
    datumIzdavanjaOtpremnice?: Date;
    tezinaIsporuke?: number | undefined;
    zapreminaIsporuke?: number | undefined;
    stvarniDatum?: Date;
    brojPaketa?: number;
    brojUgovora?: string | undefined;
    brojNarudzbenice?: string | undefined;
    brojOkvirnogSporazuma?: string | undefined;
    jeRobaTreceStrane?: boolean;
    napomena?: string | undefined;
    robaTreceStrane?: string | undefined;
    strankaDto?: StrankaOtpremniceDto | undefined;
    posiljalacKontaktDto?: KontaktOsobaDto | undefined;
    primalacKontaktDto?: KontaktOsobaDto | undefined;
    nacinOtpreme?: NacinOtpreme;
    licniNacinOtpreme?: LicniNacinOtpremeDto | undefined;
    adresaOtpremeDto?: AdresaIsporukeDto | undefined;
    adresaOdredistaDto?: AdresaIsporukeDto | undefined;
    fazeVoznjeDto?: FazaVoznjeDto[] | undefined;
    stavkeDto?: StavkaOtpremniceDto[] | undefined;
    datumIzdavanjaPrijemnica?: Date;
    brojPrijemnice?: string | undefined;
    jeAutomatskiGenerisana?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    sefId?: string | undefined;
    praviloZaBrojId?: number | undefined;

    constructor(data?: IEPrijemnicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tipOtpremnice = _data["tipOtpremnice"];
            this.vrstaDokumenta = _data["vrstaDokumenta"];
            this.broj = _data["broj"];
            this.datumIzdavanjaOtpremnice = _data["datumIzdavanjaOtpremnice"] ? new Date(_data["datumIzdavanjaOtpremnice"].toString()) : <any>undefined;
            this.tezinaIsporuke = _data["tezinaIsporuke"];
            this.zapreminaIsporuke = _data["zapreminaIsporuke"];
            this.stvarniDatum = _data["stvarniDatum"] ? new Date(_data["stvarniDatum"].toString()) : <any>undefined;
            this.brojPaketa = _data["brojPaketa"];
            this.brojUgovora = _data["brojUgovora"];
            this.brojNarudzbenice = _data["brojNarudzbenice"];
            this.brojOkvirnogSporazuma = _data["brojOkvirnogSporazuma"];
            this.jeRobaTreceStrane = _data["jeRobaTreceStrane"];
            this.napomena = _data["napomena"];
            this.robaTreceStrane = _data["robaTreceStrane"];
            this.strankaDto = _data["strankaDto"] ? StrankaOtpremniceDto.fromJS(_data["strankaDto"]) : <any>undefined;
            this.posiljalacKontaktDto = _data["posiljalacKontaktDto"] ? KontaktOsobaDto.fromJS(_data["posiljalacKontaktDto"]) : <any>undefined;
            this.primalacKontaktDto = _data["primalacKontaktDto"] ? KontaktOsobaDto.fromJS(_data["primalacKontaktDto"]) : <any>undefined;
            this.nacinOtpreme = _data["nacinOtpreme"];
            this.licniNacinOtpreme = _data["licniNacinOtpreme"] ? LicniNacinOtpremeDto.fromJS(_data["licniNacinOtpreme"]) : <any>undefined;
            this.adresaOtpremeDto = _data["adresaOtpremeDto"] ? AdresaIsporukeDto.fromJS(_data["adresaOtpremeDto"]) : <any>undefined;
            this.adresaOdredistaDto = _data["adresaOdredistaDto"] ? AdresaIsporukeDto.fromJS(_data["adresaOdredistaDto"]) : <any>undefined;
            if (Array.isArray(_data["fazeVoznjeDto"])) {
                this.fazeVoznjeDto = [] as any;
                for (let item of _data["fazeVoznjeDto"])
                    this.fazeVoznjeDto!.push(FazaVoznjeDto.fromJS(item));
            }
            if (Array.isArray(_data["stavkeDto"])) {
                this.stavkeDto = [] as any;
                for (let item of _data["stavkeDto"])
                    this.stavkeDto!.push(StavkaOtpremniceDto.fromJS(item));
            }
            this.datumIzdavanjaPrijemnica = _data["datumIzdavanjaPrijemnica"] ? new Date(_data["datumIzdavanjaPrijemnica"].toString()) : <any>undefined;
            this.brojPrijemnice = _data["brojPrijemnice"];
            this.jeAutomatskiGenerisana = _data["jeAutomatskiGenerisana"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedOn = _data["lastModifiedOn"] ? new Date(_data["lastModifiedOn"].toString()) : <any>undefined;
            this.sefId = _data["sefId"];
            this.praviloZaBrojId = _data["praviloZaBrojId"];
        }
    }

    static fromJS(data: any): EPrijemnicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EPrijemnicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipOtpremnice"] = this.tipOtpremnice;
        data["vrstaDokumenta"] = this.vrstaDokumenta;
        data["broj"] = this.broj;
        data["datumIzdavanjaOtpremnice"] = this.datumIzdavanjaOtpremnice ? this.datumIzdavanjaOtpremnice.toISOString() : <any>undefined;
        data["tezinaIsporuke"] = this.tezinaIsporuke;
        data["zapreminaIsporuke"] = this.zapreminaIsporuke;
        data["stvarniDatum"] = this.stvarniDatum ? this.stvarniDatum.toISOString() : <any>undefined;
        data["brojPaketa"] = this.brojPaketa;
        data["brojUgovora"] = this.brojUgovora;
        data["brojNarudzbenice"] = this.brojNarudzbenice;
        data["brojOkvirnogSporazuma"] = this.brojOkvirnogSporazuma;
        data["jeRobaTreceStrane"] = this.jeRobaTreceStrane;
        data["napomena"] = this.napomena;
        data["robaTreceStrane"] = this.robaTreceStrane;
        data["strankaDto"] = this.strankaDto ? this.strankaDto.toJSON() : <any>undefined;
        data["posiljalacKontaktDto"] = this.posiljalacKontaktDto ? this.posiljalacKontaktDto.toJSON() : <any>undefined;
        data["primalacKontaktDto"] = this.primalacKontaktDto ? this.primalacKontaktDto.toJSON() : <any>undefined;
        data["nacinOtpreme"] = this.nacinOtpreme;
        data["licniNacinOtpreme"] = this.licniNacinOtpreme ? this.licniNacinOtpreme.toJSON() : <any>undefined;
        data["adresaOtpremeDto"] = this.adresaOtpremeDto ? this.adresaOtpremeDto.toJSON() : <any>undefined;
        data["adresaOdredistaDto"] = this.adresaOdredistaDto ? this.adresaOdredistaDto.toJSON() : <any>undefined;
        if (Array.isArray(this.fazeVoznjeDto)) {
            data["fazeVoznjeDto"] = [];
            for (let item of this.fazeVoznjeDto)
                data["fazeVoznjeDto"].push(item.toJSON());
        }
        if (Array.isArray(this.stavkeDto)) {
            data["stavkeDto"] = [];
            for (let item of this.stavkeDto)
                data["stavkeDto"].push(item.toJSON());
        }
        data["datumIzdavanjaPrijemnica"] = this.datumIzdavanjaPrijemnica ? formatDate(this.datumIzdavanjaPrijemnica) : <any>undefined;
        data["brojPrijemnice"] = this.brojPrijemnice;
        data["jeAutomatskiGenerisana"] = this.jeAutomatskiGenerisana;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined;
        data["sefId"] = this.sefId;
        data["praviloZaBrojId"] = this.praviloZaBrojId;
        return data;
    }
}

export interface IEPrijemnicaDto {
    id?: number | undefined;
    tipOtpremnice?: TipOtpremnice;
    vrstaDokumenta?: VrstaDokumentaOtpremnica;
    broj?: string | undefined;
    datumIzdavanjaOtpremnice?: Date;
    tezinaIsporuke?: number | undefined;
    zapreminaIsporuke?: number | undefined;
    stvarniDatum?: Date;
    brojPaketa?: number;
    brojUgovora?: string | undefined;
    brojNarudzbenice?: string | undefined;
    brojOkvirnogSporazuma?: string | undefined;
    jeRobaTreceStrane?: boolean;
    napomena?: string | undefined;
    robaTreceStrane?: string | undefined;
    strankaDto?: StrankaOtpremniceDto | undefined;
    posiljalacKontaktDto?: KontaktOsobaDto | undefined;
    primalacKontaktDto?: KontaktOsobaDto | undefined;
    nacinOtpreme?: NacinOtpreme;
    licniNacinOtpreme?: LicniNacinOtpremeDto | undefined;
    adresaOtpremeDto?: AdresaIsporukeDto | undefined;
    adresaOdredistaDto?: AdresaIsporukeDto | undefined;
    fazeVoznjeDto?: FazaVoznjeDto[] | undefined;
    stavkeDto?: StavkaOtpremniceDto[] | undefined;
    datumIzdavanjaPrijemnica?: Date;
    brojPrijemnice?: string | undefined;
    jeAutomatskiGenerisana?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    sefId?: string | undefined;
    praviloZaBrojId?: number | undefined;
}

export class ResultOfEOtpremnicaDto extends Result implements IResultOfEOtpremnicaDto {
    data?: EOtpremnicaDto | undefined;

    constructor(data?: IResultOfEOtpremnicaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EOtpremnicaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfEOtpremnicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfEOtpremnicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfEOtpremnicaDto extends IResult {
    data?: EOtpremnicaDto | undefined;
}

export class PaginatedResultOfEOtpremnicaTableDto extends Result implements IPaginatedResultOfEOtpremnicaTableDto {
    data?: EOtpremnicaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfEOtpremnicaTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EOtpremnicaTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfEOtpremnicaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfEOtpremnicaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfEOtpremnicaTableDto extends IResult {
    data?: EOtpremnicaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class EOtpremnicaTableDto implements IEOtpremnicaTableDto {
    id?: number;
    brojOtpremnice?: string | undefined;
    stranka?: string | undefined;
    adresaOtpreme?: string | undefined;
    adresaOdredista?: string | undefined;
    datumIzdavanja?: string | undefined;
    planiraniDatumOtpremeString?: string | undefined;
    stvarniDatumOtpremeString?: string | undefined;
    statusDto?: StatusEOtpremniceDto | undefined;
    vrstaDokumenta?: VrstaDokumentaOtpremnica;
    pocetakVoznje?: boolean;
    planiraniDatumOtpreme?: Date | undefined;
    stvarniDatumOtpreme?: Date | undefined;
    imaFazeVoznje?: boolean;
    razlogStorniranja?: string | undefined;
    racunId?: number | undefined;
    racunBroj?: string | undefined;
    racunTip?: TipRacuna | undefined;
    racunVrsta?: VrstaRacuna | undefined;

    constructor(data?: IEOtpremnicaTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.brojOtpremnice = _data["brojOtpremnice"];
            this.stranka = _data["stranka"];
            this.adresaOtpreme = _data["adresaOtpreme"];
            this.adresaOdredista = _data["adresaOdredista"];
            this.datumIzdavanja = _data["datumIzdavanja"];
            this.planiraniDatumOtpremeString = _data["planiraniDatumOtpremeString"];
            this.stvarniDatumOtpremeString = _data["stvarniDatumOtpremeString"];
            this.statusDto = _data["statusDto"] ? StatusEOtpremniceDto.fromJS(_data["statusDto"]) : <any>undefined;
            this.vrstaDokumenta = _data["vrstaDokumenta"];
            this.pocetakVoznje = _data["pocetakVoznje"];
            this.planiraniDatumOtpreme = _data["planiraniDatumOtpreme"] ? new Date(_data["planiraniDatumOtpreme"].toString()) : <any>undefined;
            this.stvarniDatumOtpreme = _data["stvarniDatumOtpreme"] ? new Date(_data["stvarniDatumOtpreme"].toString()) : <any>undefined;
            this.imaFazeVoznje = _data["imaFazeVoznje"];
            this.razlogStorniranja = _data["razlogStorniranja"];
            this.racunId = _data["racunId"];
            this.racunBroj = _data["racunBroj"];
            this.racunTip = _data["racunTip"];
            this.racunVrsta = _data["racunVrsta"];
        }
    }

    static fromJS(data: any): EOtpremnicaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new EOtpremnicaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["brojOtpremnice"] = this.brojOtpremnice;
        data["stranka"] = this.stranka;
        data["adresaOtpreme"] = this.adresaOtpreme;
        data["adresaOdredista"] = this.adresaOdredista;
        data["datumIzdavanja"] = this.datumIzdavanja;
        data["planiraniDatumOtpremeString"] = this.planiraniDatumOtpremeString;
        data["stvarniDatumOtpremeString"] = this.stvarniDatumOtpremeString;
        data["statusDto"] = this.statusDto ? this.statusDto.toJSON() : <any>undefined;
        data["vrstaDokumenta"] = this.vrstaDokumenta;
        data["pocetakVoznje"] = this.pocetakVoznje;
        data["planiraniDatumOtpreme"] = this.planiraniDatumOtpreme ? this.planiraniDatumOtpreme.toISOString() : <any>undefined;
        data["stvarniDatumOtpreme"] = this.stvarniDatumOtpreme ? this.stvarniDatumOtpreme.toISOString() : <any>undefined;
        data["imaFazeVoznje"] = this.imaFazeVoznje;
        data["razlogStorniranja"] = this.razlogStorniranja;
        data["racunId"] = this.racunId;
        data["racunBroj"] = this.racunBroj;
        data["racunTip"] = this.racunTip;
        data["racunVrsta"] = this.racunVrsta;
        return data;
    }
}

export interface IEOtpremnicaTableDto {
    id?: number;
    brojOtpremnice?: string | undefined;
    stranka?: string | undefined;
    adresaOtpreme?: string | undefined;
    adresaOdredista?: string | undefined;
    datumIzdavanja?: string | undefined;
    planiraniDatumOtpremeString?: string | undefined;
    stvarniDatumOtpremeString?: string | undefined;
    statusDto?: StatusEOtpremniceDto | undefined;
    vrstaDokumenta?: VrstaDokumentaOtpremnica;
    pocetakVoznje?: boolean;
    planiraniDatumOtpreme?: Date | undefined;
    stvarniDatumOtpreme?: Date | undefined;
    imaFazeVoznje?: boolean;
    razlogStorniranja?: string | undefined;
    racunId?: number | undefined;
    racunBroj?: string | undefined;
    racunTip?: TipRacuna | undefined;
    racunVrsta?: VrstaRacuna | undefined;
}

export class StatusEOtpremniceDto implements IStatusEOtpremniceDto {
    status?: StatusEOtpremnice;
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IStatusEOtpremniceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.statusStr = _data["statusStr"];
            this.statusBadgeStr = _data["statusBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): StatusEOtpremniceDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusEOtpremniceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["statusStr"] = this.statusStr;
        data["statusBadgeStr"] = this.statusBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IStatusEOtpremniceDto {
    status?: StatusEOtpremnice;
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class GetEOtpremnicaTableQuery implements IGetEOtpremnicaTableQuery {
    vrstaDokumenta?: VrstaDokumentaOtpremnica;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetEOtpremnicaTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vrstaDokumenta = _data["vrstaDokumenta"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetEOtpremnicaTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetEOtpremnicaTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vrstaDokumenta"] = this.vrstaDokumenta;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetEOtpremnicaTableQuery {
    vrstaDokumenta?: VrstaDokumentaOtpremnica;
    pageNumber?: number;
    pageSize?: number;
}

export class PaginatedResultOfEPrijemnicaTableDto extends Result implements IPaginatedResultOfEPrijemnicaTableDto {
    data?: EPrijemnicaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfEPrijemnicaTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EPrijemnicaTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfEPrijemnicaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfEPrijemnicaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfEPrijemnicaTableDto extends IResult {
    data?: EPrijemnicaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class EPrijemnicaTableDto implements IEPrijemnicaTableDto {
    id?: number;
    brojPrijemnice?: string | undefined;
    stranka?: string | undefined;
    adresaOtpreme?: string | undefined;
    adresaOdredista?: string | undefined;
    datumOtpremnice?: string | undefined;
    datumFizickogPrijema?: string | undefined;
    datumIzdavanja?: string | undefined;
    statusDto?: StatusEOtpremniceDto | undefined;
    vrstaDokumenta?: VrstaDokumentaOtpremnica;
    jeVezana?: boolean;
    strankaId?: number;
    racunId?: number | undefined;
    racunBroj?: string | undefined;
    racunTip?: TipRacuna | undefined;
    racunVrsta?: VrstaRacuna | undefined;

    constructor(data?: IEPrijemnicaTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.brojPrijemnice = _data["brojPrijemnice"];
            this.stranka = _data["stranka"];
            this.adresaOtpreme = _data["adresaOtpreme"];
            this.adresaOdredista = _data["adresaOdredista"];
            this.datumOtpremnice = _data["datumOtpremnice"];
            this.datumFizickogPrijema = _data["datumFizickogPrijema"];
            this.datumIzdavanja = _data["datumIzdavanja"];
            this.statusDto = _data["statusDto"] ? StatusEOtpremniceDto.fromJS(_data["statusDto"]) : <any>undefined;
            this.vrstaDokumenta = _data["vrstaDokumenta"];
            this.jeVezana = _data["jeVezana"];
            this.strankaId = _data["strankaId"];
            this.racunId = _data["racunId"];
            this.racunBroj = _data["racunBroj"];
            this.racunTip = _data["racunTip"];
            this.racunVrsta = _data["racunVrsta"];
        }
    }

    static fromJS(data: any): EPrijemnicaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new EPrijemnicaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["brojPrijemnice"] = this.brojPrijemnice;
        data["stranka"] = this.stranka;
        data["adresaOtpreme"] = this.adresaOtpreme;
        data["adresaOdredista"] = this.adresaOdredista;
        data["datumOtpremnice"] = this.datumOtpremnice;
        data["datumFizickogPrijema"] = this.datumFizickogPrijema;
        data["datumIzdavanja"] = this.datumIzdavanja;
        data["statusDto"] = this.statusDto ? this.statusDto.toJSON() : <any>undefined;
        data["vrstaDokumenta"] = this.vrstaDokumenta;
        data["jeVezana"] = this.jeVezana;
        data["strankaId"] = this.strankaId;
        data["racunId"] = this.racunId;
        data["racunBroj"] = this.racunBroj;
        data["racunTip"] = this.racunTip;
        data["racunVrsta"] = this.racunVrsta;
        return data;
    }
}

export interface IEPrijemnicaTableDto {
    id?: number;
    brojPrijemnice?: string | undefined;
    stranka?: string | undefined;
    adresaOtpreme?: string | undefined;
    adresaOdredista?: string | undefined;
    datumOtpremnice?: string | undefined;
    datumFizickogPrijema?: string | undefined;
    datumIzdavanja?: string | undefined;
    statusDto?: StatusEOtpremniceDto | undefined;
    vrstaDokumenta?: VrstaDokumentaOtpremnica;
    jeVezana?: boolean;
    strankaId?: number;
    racunId?: number | undefined;
    racunBroj?: string | undefined;
    racunTip?: TipRacuna | undefined;
    racunVrsta?: VrstaRacuna | undefined;
}

export class GetEPrijemnicaTableQuery implements IGetEPrijemnicaTableQuery {
    vrstaDokumenta?: VrstaDokumentaOtpremnica;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetEPrijemnicaTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vrstaDokumenta = _data["vrstaDokumenta"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetEPrijemnicaTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetEPrijemnicaTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vrstaDokumenta"] = this.vrstaDokumenta;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetEPrijemnicaTableQuery {
    vrstaDokumenta?: VrstaDokumentaOtpremnica;
    pageNumber?: number;
    pageSize?: number;
}

export enum TipIzmenePosiljke {
    EMPTY = 0,
    STORNO = 1,
    ZAPLENA_ROBE = 2,
    PRIHVACENA_PRIJEMNICA = 3,
    ODBIJENA_PRIJEMNICA = 4,
    PRETOVAR = 5,
    FIZICKI_PRIJEM_ROBE = 6,
    START_PREVOZA = 7,
    PROMENA_VOZILA = 8,
}

export class PretovarIsporukeCommand implements IPretovarIsporukeCommand {
    otpremnicaId?: number;
    fazeVoznje?: FazaVoznjeDto[] | undefined;

    constructor(data?: IPretovarIsporukeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.otpremnicaId = _data["otpremnicaId"];
            if (Array.isArray(_data["fazeVoznje"])) {
                this.fazeVoznje = [] as any;
                for (let item of _data["fazeVoznje"])
                    this.fazeVoznje!.push(FazaVoznjeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PretovarIsporukeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PretovarIsporukeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["otpremnicaId"] = this.otpremnicaId;
        if (Array.isArray(this.fazeVoznje)) {
            data["fazeVoznje"] = [];
            for (let item of this.fazeVoznje)
                data["fazeVoznje"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPretovarIsporukeCommand {
    otpremnicaId?: number;
    fazeVoznje?: FazaVoznjeDto[] | undefined;
}

export class PromenaVozilaCommand implements IPromenaVozilaCommand {
    otpremnicaId?: number;
    vozacFazeDto?: VozacFazeDto | undefined;

    constructor(data?: IPromenaVozilaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.otpremnicaId = _data["otpremnicaId"];
            this.vozacFazeDto = _data["vozacFazeDto"] ? VozacFazeDto.fromJS(_data["vozacFazeDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PromenaVozilaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PromenaVozilaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["otpremnicaId"] = this.otpremnicaId;
        data["vozacFazeDto"] = this.vozacFazeDto ? this.vozacFazeDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPromenaVozilaCommand {
    otpremnicaId?: number;
    vozacFazeDto?: VozacFazeDto | undefined;
}

export class UpdateEOtpremnicaCommand extends EOtpremnicaDto implements IUpdateEOtpremnicaCommand {

    constructor(data?: IUpdateEOtpremnicaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateEOtpremnicaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEOtpremnicaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateEOtpremnicaCommand extends IEOtpremnicaDto {
}

export class ResultOfGetNaciniOtpremeResponse extends Result implements IResultOfGetNaciniOtpremeResponse {
    data?: GetNaciniOtpremeResponse | undefined;

    constructor(data?: IResultOfGetNaciniOtpremeResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetNaciniOtpremeResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetNaciniOtpremeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetNaciniOtpremeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetNaciniOtpremeResponse extends IResult {
    data?: GetNaciniOtpremeResponse | undefined;
}

export class GetNaciniOtpremeResponse implements IGetNaciniOtpremeResponse {
    nacinOtpremeDtoList?: NacinOtpremeDto[] | undefined;

    constructor(data?: IGetNaciniOtpremeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["nacinOtpremeDtoList"])) {
                this.nacinOtpremeDtoList = [] as any;
                for (let item of _data["nacinOtpremeDtoList"])
                    this.nacinOtpremeDtoList!.push(NacinOtpremeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNaciniOtpremeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNaciniOtpremeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.nacinOtpremeDtoList)) {
            data["nacinOtpremeDtoList"] = [];
            for (let item of this.nacinOtpremeDtoList)
                data["nacinOtpremeDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNaciniOtpremeResponse {
    nacinOtpremeDtoList?: NacinOtpremeDto[] | undefined;
}

export class NacinOtpremeDto implements INacinOtpremeDto {
    nacinOtpreme?: NacinOtpreme;
    nacinOtpremeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: INacinOtpremeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nacinOtpreme = _data["nacinOtpreme"];
            this.nacinOtpremeStr = _data["nacinOtpremeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): NacinOtpremeDto {
        data = typeof data === 'object' ? data : {};
        let result = new NacinOtpremeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nacinOtpreme"] = this.nacinOtpreme;
        data["nacinOtpremeStr"] = this.nacinOtpremeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface INacinOtpremeDto {
    nacinOtpreme?: NacinOtpreme;
    nacinOtpremeStr?: string | undefined;
    opis?: string | undefined;
}

export class ResultOfGetTipOtpremniceResponse extends Result implements IResultOfGetTipOtpremniceResponse {
    data?: GetTipOtpremniceResponse | undefined;

    constructor(data?: IResultOfGetTipOtpremniceResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetTipOtpremniceResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetTipOtpremniceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetTipOtpremniceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetTipOtpremniceResponse extends IResult {
    data?: GetTipOtpremniceResponse | undefined;
}

export class GetTipOtpremniceResponse implements IGetTipOtpremniceResponse {
    tipOtpremniceList?: TipOtpremniceDto[] | undefined;

    constructor(data?: IGetTipOtpremniceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tipOtpremniceList"])) {
                this.tipOtpremniceList = [] as any;
                for (let item of _data["tipOtpremniceList"])
                    this.tipOtpremniceList!.push(TipOtpremniceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTipOtpremniceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTipOtpremniceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tipOtpremniceList)) {
            data["tipOtpremniceList"] = [];
            for (let item of this.tipOtpremniceList)
                data["tipOtpremniceList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTipOtpremniceResponse {
    tipOtpremniceList?: TipOtpremniceDto[] | undefined;
}

export class TipOtpremniceDto implements ITipOtpremniceDto {
    tip?: TipOtpremnice;
    tipStr?: string | undefined;
    tipBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: ITipOtpremniceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tip = _data["tip"];
            this.tipStr = _data["tipStr"];
            this.tipBadgeStr = _data["tipBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): TipOtpremniceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipOtpremniceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tip"] = this.tip;
        data["tipStr"] = this.tipStr;
        data["tipBadgeStr"] = this.tipBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface ITipOtpremniceDto {
    tip?: TipOtpremnice;
    tipStr?: string | undefined;
    tipBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class ResultOfICollectionOfStavkaOtpremniceDto extends Result implements IResultOfICollectionOfStavkaOtpremniceDto {
    data?: StavkaOtpremniceDto[] | undefined;

    constructor(data?: IResultOfICollectionOfStavkaOtpremniceDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StavkaOtpremniceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfICollectionOfStavkaOtpremniceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfICollectionOfStavkaOtpremniceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfICollectionOfStavkaOtpremniceDto extends IResult {
    data?: StavkaOtpremniceDto[] | undefined;
}

export class ResultOfGetTipAkcizneKategorijeResponse extends Result implements IResultOfGetTipAkcizneKategorijeResponse {
    data?: GetTipAkcizneKategorijeResponse | undefined;

    constructor(data?: IResultOfGetTipAkcizneKategorijeResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetTipAkcizneKategorijeResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetTipAkcizneKategorijeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetTipAkcizneKategorijeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetTipAkcizneKategorijeResponse extends IResult {
    data?: GetTipAkcizneKategorijeResponse | undefined;
}

export class GetTipAkcizneKategorijeResponse implements IGetTipAkcizneKategorijeResponse {
    tipAkcizneKategorijeList?: TipAkcizneKategorijeDto[] | undefined;

    constructor(data?: IGetTipAkcizneKategorijeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tipAkcizneKategorijeList"])) {
                this.tipAkcizneKategorijeList = [] as any;
                for (let item of _data["tipAkcizneKategorijeList"])
                    this.tipAkcizneKategorijeList!.push(TipAkcizneKategorijeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTipAkcizneKategorijeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTipAkcizneKategorijeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tipAkcizneKategorijeList)) {
            data["tipAkcizneKategorijeList"] = [];
            for (let item of this.tipAkcizneKategorijeList)
                data["tipAkcizneKategorijeList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTipAkcizneKategorijeResponse {
    tipAkcizneKategorijeList?: TipAkcizneKategorijeDto[] | undefined;
}

export class TipAkcizneKategorijeDto implements ITipAkcizneKategorijeDto {
    tip?: TipAkcizneKategorije;
    tipStr?: string | undefined;
    tipBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: ITipAkcizneKategorijeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tip = _data["tip"];
            this.tipStr = _data["tipStr"];
            this.tipBadgeStr = _data["tipBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): TipAkcizneKategorijeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipAkcizneKategorijeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tip"] = this.tip;
        data["tipStr"] = this.tipStr;
        data["tipBadgeStr"] = this.tipBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface ITipAkcizneKategorijeDto {
    tip?: TipAkcizneKategorije;
    tipStr?: string | undefined;
    tipBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class ResultOfGetTipPakovanjaDuvanaResponse extends Result implements IResultOfGetTipPakovanjaDuvanaResponse {
    data?: GetTipPakovanjaDuvanaResponse | undefined;

    constructor(data?: IResultOfGetTipPakovanjaDuvanaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetTipPakovanjaDuvanaResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetTipPakovanjaDuvanaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetTipPakovanjaDuvanaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetTipPakovanjaDuvanaResponse extends IResult {
    data?: GetTipPakovanjaDuvanaResponse | undefined;
}

export class GetTipPakovanjaDuvanaResponse implements IGetTipPakovanjaDuvanaResponse {
    tipPakovanjaDuvanaList?: TipPakovanjaDuvanaDto[] | undefined;

    constructor(data?: IGetTipPakovanjaDuvanaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tipPakovanjaDuvanaList"])) {
                this.tipPakovanjaDuvanaList = [] as any;
                for (let item of _data["tipPakovanjaDuvanaList"])
                    this.tipPakovanjaDuvanaList!.push(TipPakovanjaDuvanaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTipPakovanjaDuvanaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTipPakovanjaDuvanaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tipPakovanjaDuvanaList)) {
            data["tipPakovanjaDuvanaList"] = [];
            for (let item of this.tipPakovanjaDuvanaList)
                data["tipPakovanjaDuvanaList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTipPakovanjaDuvanaResponse {
    tipPakovanjaDuvanaList?: TipPakovanjaDuvanaDto[] | undefined;
}

export class TipPakovanjaDuvanaDto implements ITipPakovanjaDuvanaDto {
    tip?: TipPakovanjaDuvana;
    tipStr?: string | undefined;
    tipBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: ITipPakovanjaDuvanaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tip = _data["tip"];
            this.tipStr = _data["tipStr"];
            this.tipBadgeStr = _data["tipBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): TipPakovanjaDuvanaDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipPakovanjaDuvanaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tip"] = this.tip;
        data["tipStr"] = this.tipStr;
        data["tipBadgeStr"] = this.tipBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface ITipPakovanjaDuvanaDto {
    tip?: TipPakovanjaDuvana;
    tipStr?: string | undefined;
    tipBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class ResultOfListOfAdresaIsporukeDto extends Result implements IResultOfListOfAdresaIsporukeDto {
    data?: AdresaIsporukeDto[] | undefined;

    constructor(data?: IResultOfListOfAdresaIsporukeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AdresaIsporukeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfAdresaIsporukeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfAdresaIsporukeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfAdresaIsporukeDto extends IResult {
    data?: AdresaIsporukeDto[] | undefined;
}

export class ResultOfVozacFazeDto extends Result implements IResultOfVozacFazeDto {
    data?: VozacFazeDto | undefined;

    constructor(data?: IResultOfVozacFazeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? VozacFazeDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfVozacFazeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfVozacFazeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfVozacFazeDto extends IResult {
    data?: VozacFazeDto | undefined;
}

export class ResultOfIEnumerableOfEOtpremnicaAutocompleteResponse extends Result implements IResultOfIEnumerableOfEOtpremnicaAutocompleteResponse {
    data?: EOtpremnicaAutocompleteResponse[] | undefined;

    constructor(data?: IResultOfIEnumerableOfEOtpremnicaAutocompleteResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EOtpremnicaAutocompleteResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfIEnumerableOfEOtpremnicaAutocompleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfIEnumerableOfEOtpremnicaAutocompleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfIEnumerableOfEOtpremnicaAutocompleteResponse extends IResult {
    data?: EOtpremnicaAutocompleteResponse[] | undefined;
}

export class EOtpremnicaAutocompleteResponse implements IEOtpremnicaAutocompleteResponse {
    eOtpremnicaSefId?: string;
    brojOtpremniceTrecaStrana?: string | undefined;

    constructor(data?: IEOtpremnicaAutocompleteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eOtpremnicaSefId = _data["eOtpremnicaSefId"];
            this.brojOtpremniceTrecaStrana = _data["brojOtpremniceTrecaStrana"];
        }
    }

    static fromJS(data: any): EOtpremnicaAutocompleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EOtpremnicaAutocompleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eOtpremnicaSefId"] = this.eOtpremnicaSefId;
        data["brojOtpremniceTrecaStrana"] = this.brojOtpremniceTrecaStrana;
        return data;
    }
}

export interface IEOtpremnicaAutocompleteResponse {
    eOtpremnicaSefId?: string;
    brojOtpremniceTrecaStrana?: string | undefined;
}

export class ResultOfListOfEOtpremnicaDropdownDto extends Result implements IResultOfListOfEOtpremnicaDropdownDto {
    data?: EOtpremnicaDropdownDto[] | undefined;

    constructor(data?: IResultOfListOfEOtpremnicaDropdownDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EOtpremnicaDropdownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfEOtpremnicaDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfEOtpremnicaDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfEOtpremnicaDropdownDto extends IResult {
    data?: EOtpremnicaDropdownDto[] | undefined;
}

export class EOtpremnicaDropdownDto implements IEOtpremnicaDropdownDto {
    eOtpremnicaId?: number;
    broj?: string | undefined;

    constructor(data?: IEOtpremnicaDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eOtpremnicaId = _data["eOtpremnicaId"];
            this.broj = _data["broj"];
        }
    }

    static fromJS(data: any): EOtpremnicaDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new EOtpremnicaDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eOtpremnicaId"] = this.eOtpremnicaId;
        data["broj"] = this.broj;
        return data;
    }
}

export interface IEOtpremnicaDropdownDto {
    eOtpremnicaId?: number;
    broj?: string | undefined;
}

export enum TipDokumentaOtpremnica {
    OTPREMNICA = 0,
    PRIJEMNICA = 1,
}

export class ResultOfListOfStavkaRacunaDto extends Result implements IResultOfListOfStavkaRacunaDto {
    data?: StavkaRacunaDto[] | undefined;

    constructor(data?: IResultOfListOfStavkaRacunaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StavkaRacunaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfStavkaRacunaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfStavkaRacunaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfStavkaRacunaDto extends IResult {
    data?: StavkaRacunaDto[] | undefined;
}

export class PushNotificationDto implements IPushNotificationDto {
    subscriptionKey?: string | undefined;
    change?: ItemDto | undefined;

    constructor(data?: IPushNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionKey = _data["subscriptionKey"];
            this.change = _data["change"] ? ItemDto.fromJS(_data["change"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PushNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PushNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionKey"] = this.subscriptionKey;
        data["change"] = this.change ? this.change.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPushNotificationDto {
    subscriptionKey?: string | undefined;
    change?: ItemDto | undefined;
}

export class ItemDto implements IItemDto {
    id?: string;
    type?: string | undefined;
    dateUtc?: Date;
    requestId?: string | undefined;
    data?: ItemDataDto | undefined;

    constructor(data?: IItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.dateUtc = _data["dateUtc"] ? new Date(_data["dateUtc"].toString()) : <any>undefined;
            this.requestId = _data["requestId"];
            this.data = _data["data"] ? ItemDataDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["dateUtc"] = this.dateUtc ? this.dateUtc.toISOString() : <any>undefined;
        data["requestId"] = this.requestId;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IItemDto {
    id?: string;
    type?: string | undefined;
    dateUtc?: Date;
    requestId?: string | undefined;
    data?: ItemDataDto | undefined;
}

export class ItemDataDto implements IItemDataDto {
    deliveryConfirmationDateUtc?: Date | undefined;
    transportationStartDate?: Date | undefined;
    applicationResponse?: ApplicationResponseDto | undefined;
    receiptAdvice?: ReceiptAdviceDto | undefined;
    despatchAdvice?: DespatchAdviceDto | undefined;
    cancelReason?: string | undefined;

    constructor(data?: IItemDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryConfirmationDateUtc = _data["deliveryConfirmationDateUtc"] ? new Date(_data["deliveryConfirmationDateUtc"].toString()) : <any>undefined;
            this.transportationStartDate = _data["transportationStartDate"] ? new Date(_data["transportationStartDate"].toString()) : <any>undefined;
            this.applicationResponse = _data["applicationResponse"] ? ApplicationResponseDto.fromJS(_data["applicationResponse"]) : <any>undefined;
            this.receiptAdvice = _data["receiptAdvice"] ? ReceiptAdviceDto.fromJS(_data["receiptAdvice"]) : <any>undefined;
            this.despatchAdvice = _data["despatchAdvice"] ? DespatchAdviceDto.fromJS(_data["despatchAdvice"]) : <any>undefined;
            this.cancelReason = _data["cancelReason"];
        }
    }

    static fromJS(data: any): ItemDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryConfirmationDateUtc"] = this.deliveryConfirmationDateUtc ? this.deliveryConfirmationDateUtc.toISOString() : <any>undefined;
        data["transportationStartDate"] = this.transportationStartDate ? this.transportationStartDate.toISOString() : <any>undefined;
        data["applicationResponse"] = this.applicationResponse ? this.applicationResponse.toJSON() : <any>undefined;
        data["receiptAdvice"] = this.receiptAdvice ? this.receiptAdvice.toJSON() : <any>undefined;
        data["despatchAdvice"] = this.despatchAdvice ? this.despatchAdvice.toJSON() : <any>undefined;
        data["cancelReason"] = this.cancelReason;
        return data;
    }
}

export interface IItemDataDto {
    deliveryConfirmationDateUtc?: Date | undefined;
    transportationStartDate?: Date | undefined;
    applicationResponse?: ApplicationResponseDto | undefined;
    receiptAdvice?: ReceiptAdviceDto | undefined;
    despatchAdvice?: DespatchAdviceDto | undefined;
    cancelReason?: string | undefined;
}

export class ApplicationResponseDto implements IApplicationResponseDto {
    id?: string;
    responseTypeCode?: string | undefined;
    isAutogenerated?: boolean;

    constructor(data?: IApplicationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.responseTypeCode = _data["responseTypeCode"];
            this.isAutogenerated = _data["isAutogenerated"];
        }
    }

    static fromJS(data: any): ApplicationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["responseTypeCode"] = this.responseTypeCode;
        data["isAutogenerated"] = this.isAutogenerated;
        return data;
    }
}

export interface IApplicationResponseDto {
    id?: string;
    responseTypeCode?: string | undefined;
    isAutogenerated?: boolean;
}

export class ReceiptAdviceDto implements IReceiptAdviceDto {
    id?: string;
    documentNumber?: string | undefined;
    status?: string | undefined;
    isAutogenerated?: boolean;

    constructor(data?: IReceiptAdviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentNumber = _data["documentNumber"];
            this.status = _data["status"];
            this.isAutogenerated = _data["isAutogenerated"];
        }
    }

    static fromJS(data: any): ReceiptAdviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptAdviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentNumber"] = this.documentNumber;
        data["status"] = this.status;
        data["isAutogenerated"] = this.isAutogenerated;
        return data;
    }
}

export interface IReceiptAdviceDto {
    id?: string;
    documentNumber?: string | undefined;
    status?: string | undefined;
    isAutogenerated?: boolean;
}

export class DespatchAdviceDto implements IDespatchAdviceDto {
    id?: string;
    documentNumber?: string | undefined;

    constructor(data?: IDespatchAdviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentNumber = _data["documentNumber"];
        }
    }

    static fromJS(data: any): DespatchAdviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new DespatchAdviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentNumber"] = this.documentNumber;
        return data;
    }
}

export interface IDespatchAdviceDto {
    id?: string;
    documentNumber?: string | undefined;
}

export class PaginatedResultOfFiskalniRacunTableDto extends Result implements IPaginatedResultOfFiskalniRacunTableDto {
    data?: FiskalniRacunTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfFiskalniRacunTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FiskalniRacunTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfFiskalniRacunTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfFiskalniRacunTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfFiskalniRacunTableDto extends IResult {
    data?: FiskalniRacunTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class FiskalniRacunTableDto implements IFiskalniRacunTableDto {
    id?: string | undefined;
    invoiceResponseId?: number | undefined;
    cashier?: string | undefined;
    status?: StatusFiskalnogRacunDto | undefined;
    stranka?: RutiranjeStrankeDto | undefined;
    tip?: TipFiskalnogRacunaDto | undefined;
    invoiceType?: InvoiceType;
    transactionType?: TransactionType;
    invoiceNumber?: string | undefined;
    invoiceCounter?: string | undefined;
    sdcDateTime?: string | undefined;
    locationName?: string | undefined;
    amount?: number;
    jePovezan?: boolean;
    jeIskoriscen?: boolean;
    imaPrometProdaje?: boolean;
    buyerIdentification?: BuyerIdentification | undefined;

    constructor(data?: IFiskalniRacunTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceResponseId = _data["invoiceResponseId"];
            this.cashier = _data["cashier"];
            this.status = _data["status"] ? StatusFiskalnogRacunDto.fromJS(_data["status"]) : <any>undefined;
            this.stranka = _data["stranka"] ? RutiranjeStrankeDto.fromJS(_data["stranka"]) : <any>undefined;
            this.tip = _data["tip"] ? TipFiskalnogRacunaDto.fromJS(_data["tip"]) : <any>undefined;
            this.invoiceType = _data["invoiceType"];
            this.transactionType = _data["transactionType"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceCounter = _data["invoiceCounter"];
            this.sdcDateTime = _data["sdcDateTime"];
            this.locationName = _data["locationName"];
            this.amount = _data["amount"];
            this.jePovezan = _data["jePovezan"];
            this.jeIskoriscen = _data["jeIskoriscen"];
            this.imaPrometProdaje = _data["imaPrometProdaje"];
            this.buyerIdentification = _data["buyerIdentification"];
        }
    }

    static fromJS(data: any): FiskalniRacunTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FiskalniRacunTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceResponseId"] = this.invoiceResponseId;
        data["cashier"] = this.cashier;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        data["tip"] = this.tip ? this.tip.toJSON() : <any>undefined;
        data["invoiceType"] = this.invoiceType;
        data["transactionType"] = this.transactionType;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceCounter"] = this.invoiceCounter;
        data["sdcDateTime"] = this.sdcDateTime;
        data["locationName"] = this.locationName;
        data["amount"] = this.amount;
        data["jePovezan"] = this.jePovezan;
        data["jeIskoriscen"] = this.jeIskoriscen;
        data["imaPrometProdaje"] = this.imaPrometProdaje;
        data["buyerIdentification"] = this.buyerIdentification;
        return data;
    }
}

export interface IFiskalniRacunTableDto {
    id?: string | undefined;
    invoiceResponseId?: number | undefined;
    cashier?: string | undefined;
    status?: StatusFiskalnogRacunDto | undefined;
    stranka?: RutiranjeStrankeDto | undefined;
    tip?: TipFiskalnogRacunaDto | undefined;
    invoiceType?: InvoiceType;
    transactionType?: TransactionType;
    invoiceNumber?: string | undefined;
    invoiceCounter?: string | undefined;
    sdcDateTime?: string | undefined;
    locationName?: string | undefined;
    amount?: number;
    jePovezan?: boolean;
    jeIskoriscen?: boolean;
    imaPrometProdaje?: boolean;
    buyerIdentification?: BuyerIdentification | undefined;
}

export class StatusFiskalnogRacunDto implements IStatusFiskalnogRacunDto {
    statusFiskalnogRacuna?: StatusFiskalnogRacuna;
    statusFiskalnogRacunaStr?: string | undefined;
    statusFiskalnogRacunaBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IStatusFiskalnogRacunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusFiskalnogRacuna = _data["statusFiskalnogRacuna"];
            this.statusFiskalnogRacunaStr = _data["statusFiskalnogRacunaStr"];
            this.statusFiskalnogRacunaBadgeStr = _data["statusFiskalnogRacunaBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): StatusFiskalnogRacunDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusFiskalnogRacunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusFiskalnogRacuna"] = this.statusFiskalnogRacuna;
        data["statusFiskalnogRacunaStr"] = this.statusFiskalnogRacunaStr;
        data["statusFiskalnogRacunaBadgeStr"] = this.statusFiskalnogRacunaBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IStatusFiskalnogRacunDto {
    statusFiskalnogRacuna?: StatusFiskalnogRacuna;
    statusFiskalnogRacunaStr?: string | undefined;
    statusFiskalnogRacunaBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export enum StatusFiskalnogRacuna {
    NACRT = 0,
    IZDAT = 1,
}

export class TipFiskalnogRacunaDto implements ITipFiskalnogRacunaDto {
    tipFiskalnogRacunaStr?: string | undefined;
    tipFiskalnogRacunaBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: ITipFiskalnogRacunaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipFiskalnogRacunaStr = _data["tipFiskalnogRacunaStr"];
            this.tipFiskalnogRacunaBadgeStr = _data["tipFiskalnogRacunaBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): TipFiskalnogRacunaDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipFiskalnogRacunaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipFiskalnogRacunaStr"] = this.tipFiskalnogRacunaStr;
        data["tipFiskalnogRacunaBadgeStr"] = this.tipFiskalnogRacunaBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface ITipFiskalnogRacunaDto {
    tipFiskalnogRacunaStr?: string | undefined;
    tipFiskalnogRacunaBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export enum InvoiceType {
    NORMAL = 0,
    PROFORMA = 1,
    COPY = 2,
    TRAINING = 3,
    ADVANCE = 4,
}

export enum TransactionType {
    SALE = 0,
    REFUND = 1,
}

export enum BuyerIdentification {
    EMPTY = 0,
    PIB_KUPCA = 10,
    JMBG = 11,
    PPIB_I_JBKJS = 12,
    BROJ_LICNE = 20,
    BROJ_IZBEGLICKE_LEGITIMACIJE = 21,
    EBS = 22,
    BROJ_PASOSA = 23,
    BROJ_PASOSA_STRANO_LICE = 30,
    BROJ_DIPLOMATSKE_LEGITIMACIJE = 31,
    BROJ_LICNE_MKD = 32,
    BROJ_LICNE_MNE = 33,
    BROJ_LICNE_ALB = 34,
    BROJ_LICNE_BIH = 35,
    BROJ_LICNE_PO_ODLUCI = 36,
    PORESKI_ID_IZ_STRANE_DRZAVE = 40,
}

export class GetFiskalniRacunTableQuery implements IGetFiskalniRacunTableQuery {
    poslovniProstor?: string | undefined;
    brojRacuna?: string | undefined;
    kasir?: string | undefined;
    vrstaRacuna?: InvoiceType | undefined;
    tipTransakcije?: TransactionType | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetFiskalniRacunTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poslovniProstor = _data["poslovniProstor"];
            this.brojRacuna = _data["brojRacuna"];
            this.kasir = _data["kasir"];
            this.vrstaRacuna = _data["vrstaRacuna"];
            this.tipTransakcije = _data["tipTransakcije"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetFiskalniRacunTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFiskalniRacunTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poslovniProstor"] = this.poslovniProstor;
        data["brojRacuna"] = this.brojRacuna;
        data["kasir"] = this.kasir;
        data["vrstaRacuna"] = this.vrstaRacuna;
        data["tipTransakcije"] = this.tipTransakcije;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetFiskalniRacunTableQuery {
    poslovniProstor?: string | undefined;
    brojRacuna?: string | undefined;
    kasir?: string | undefined;
    vrstaRacuna?: InvoiceType | undefined;
    tipTransakcije?: TransactionType | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    pageNumber?: number;
    pageSize?: number;
}

export class ResultOfFiskalniPrometDanasDto extends Result implements IResultOfFiskalniPrometDanasDto {
    data?: FiskalniPrometDanasDto | undefined;

    constructor(data?: IResultOfFiskalniPrometDanasDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? FiskalniPrometDanasDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfFiskalniPrometDanasDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfFiskalniPrometDanasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfFiskalniPrometDanasDto extends IResult {
    data?: FiskalniPrometDanasDto | undefined;
}

export class FiskalniPrometDanasDto implements IFiskalniPrometDanasDto {
    ukupanPromet?: number;
    brojRacuna?: number;
    prosek?: number;
    procenatPromene?: number | undefined;
    lokacije?: FiskalniPrometLokacijaDto[] | undefined;

    constructor(data?: IFiskalniPrometDanasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ukupanPromet = _data["ukupanPromet"];
            this.brojRacuna = _data["brojRacuna"];
            this.prosek = _data["prosek"];
            this.procenatPromene = _data["procenatPromene"];
            if (Array.isArray(_data["lokacije"])) {
                this.lokacije = [] as any;
                for (let item of _data["lokacije"])
                    this.lokacije!.push(FiskalniPrometLokacijaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FiskalniPrometDanasDto {
        data = typeof data === 'object' ? data : {};
        let result = new FiskalniPrometDanasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ukupanPromet"] = this.ukupanPromet;
        data["brojRacuna"] = this.brojRacuna;
        data["prosek"] = this.prosek;
        data["procenatPromene"] = this.procenatPromene;
        if (Array.isArray(this.lokacije)) {
            data["lokacije"] = [];
            for (let item of this.lokacije)
                data["lokacije"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFiskalniPrometDanasDto {
    ukupanPromet?: number;
    brojRacuna?: number;
    prosek?: number;
    procenatPromene?: number | undefined;
    lokacije?: FiskalniPrometLokacijaDto[] | undefined;
}

export class FiskalniPrometLokacijaDto implements IFiskalniPrometLokacijaDto {
    locationName?: string | undefined;
    address?: string | undefined;
    promet?: number;
    brojRacuna?: number;
    prosek?: number;
    procenatPromene?: number | undefined;

    constructor(data?: IFiskalniPrometLokacijaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationName = _data["locationName"];
            this.address = _data["address"];
            this.promet = _data["promet"];
            this.brojRacuna = _data["brojRacuna"];
            this.prosek = _data["prosek"];
            this.procenatPromene = _data["procenatPromene"];
        }
    }

    static fromJS(data: any): FiskalniPrometLokacijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new FiskalniPrometLokacijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationName"] = this.locationName;
        data["address"] = this.address;
        data["promet"] = this.promet;
        data["brojRacuna"] = this.brojRacuna;
        data["prosek"] = this.prosek;
        data["procenatPromene"] = this.procenatPromene;
        return data;
    }
}

export interface IFiskalniPrometLokacijaDto {
    locationName?: string | undefined;
    address?: string | undefined;
    promet?: number;
    brojRacuna?: number;
    prosek?: number;
    procenatPromene?: number | undefined;
}

export enum FiskalniPrometPeriod {
    Danas = 0,
    SedamDana = 1,
    Mesec = 2,
    Kvartal = 3,
    Godina = 4,
}

export class ResultOfFiskalniRacunInfoDto extends Result implements IResultOfFiskalniRacunInfoDto {
    data?: FiskalniRacunInfoDto | undefined;

    constructor(data?: IResultOfFiskalniRacunInfoDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? FiskalniRacunInfoDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfFiskalniRacunInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfFiskalniRacunInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfFiskalniRacunInfoDto extends IResult {
    data?: FiskalniRacunInfoDto | undefined;
}

export class FiskalniRacunInfoDto implements IFiskalniRacunInfoDto {
    invoiceNumber?: string | undefined;
    dateAndTime?: string | undefined;
    invoiceCounter?: string | undefined;
    totalAmount?: number;
    invoiceResponseId?: number;
    invoicePayments?: InvoicePaymentDto[] | undefined;

    constructor(data?: IFiskalniRacunInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNumber = _data["invoiceNumber"];
            this.dateAndTime = _data["dateAndTime"];
            this.invoiceCounter = _data["invoiceCounter"];
            this.totalAmount = _data["totalAmount"];
            this.invoiceResponseId = _data["invoiceResponseId"];
            if (Array.isArray(_data["invoicePayments"])) {
                this.invoicePayments = [] as any;
                for (let item of _data["invoicePayments"])
                    this.invoicePayments!.push(InvoicePaymentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FiskalniRacunInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new FiskalniRacunInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber;
        data["dateAndTime"] = this.dateAndTime;
        data["invoiceCounter"] = this.invoiceCounter;
        data["totalAmount"] = this.totalAmount;
        data["invoiceResponseId"] = this.invoiceResponseId;
        if (Array.isArray(this.invoicePayments)) {
            data["invoicePayments"] = [];
            for (let item of this.invoicePayments)
                data["invoicePayments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFiskalniRacunInfoDto {
    invoiceNumber?: string | undefined;
    dateAndTime?: string | undefined;
    invoiceCounter?: string | undefined;
    totalAmount?: number;
    invoiceResponseId?: number;
    invoicePayments?: InvoicePaymentDto[] | undefined;
}

export class InvoicePaymentDto implements IInvoicePaymentDto {
    amount?: number;
    paymentType?: PaymentType;

    constructor(data?: IInvoicePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.paymentType = _data["paymentType"];
        }
    }

    static fromJS(data: any): InvoicePaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["paymentType"] = this.paymentType;
        return data;
    }
}

export interface IInvoicePaymentDto {
    amount?: number;
    paymentType?: PaymentType;
}

export enum PaymentType {
    OTHER = 0,
    CASH = 1,
    CARD = 2,
    CHECK = 3,
    WIRE_TRANSFER = 4,
    VOUCHER = 5,
    MOBILE_MONEY = 6,
}

export class ResultOfListOfKategorijaListDto extends Result implements IResultOfListOfKategorijaListDto {
    data?: KategorijaListDto[] | undefined;

    constructor(data?: IResultOfListOfKategorijaListDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(KategorijaListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfKategorijaListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfKategorijaListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfKategorijaListDto extends IResult {
    data?: KategorijaListDto[] | undefined;
}

export class KategorijaListDto implements IKategorijaListDto {
    item?: KategorijaListItemDto | undefined;

    constructor(data?: IKategorijaListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"] ? KategorijaListItemDto.fromJS(_data["item"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KategorijaListDto {
        data = typeof data === 'object' ? data : {};
        let result = new KategorijaListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKategorijaListDto {
    item?: KategorijaListItemDto | undefined;
}

export class KategorijaListItemDto implements IKategorijaListItemDto {
    kategorijaId?: number;
    naziv?: string | undefined;

    constructor(data?: IKategorijaListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kategorijaId = _data["kategorijaId"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): KategorijaListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new KategorijaListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kategorijaId"] = this.kategorijaId;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IKategorijaListItemDto {
    kategorijaId?: number;
    naziv?: string | undefined;
}

export class PaginatedResultOfFiskalniArtikalDto extends Result implements IPaginatedResultOfFiskalniArtikalDto {
    data?: FiskalniArtikalDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfFiskalniArtikalDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FiskalniArtikalDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfFiskalniArtikalDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfFiskalniArtikalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfFiskalniArtikalDto extends IResult {
    data?: FiskalniArtikalDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class FiskalniArtikalDto implements IFiskalniArtikalDto {
    predmetStavkeDto?: PredmetStavkeDto | undefined;
    kolicina?: number | undefined;
    barkodovi?: string[] | undefined;
    upareniBarkod?: string | undefined;
    magacinId?: number | undefined;
    magacinNaziv?: string | undefined;
    jeDuplikat?: boolean;

    constructor(data?: IFiskalniArtikalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predmetStavkeDto = _data["predmetStavkeDto"] ? PredmetStavkeDto.fromJS(_data["predmetStavkeDto"]) : <any>undefined;
            this.kolicina = _data["kolicina"];
            if (Array.isArray(_data["barkodovi"])) {
                this.barkodovi = [] as any;
                for (let item of _data["barkodovi"])
                    this.barkodovi!.push(item);
            }
            this.upareniBarkod = _data["upareniBarkod"];
            this.magacinId = _data["magacinId"];
            this.magacinNaziv = _data["magacinNaziv"];
            this.jeDuplikat = _data["jeDuplikat"];
        }
    }

    static fromJS(data: any): FiskalniArtikalDto {
        data = typeof data === 'object' ? data : {};
        let result = new FiskalniArtikalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predmetStavkeDto"] = this.predmetStavkeDto ? this.predmetStavkeDto.toJSON() : <any>undefined;
        data["kolicina"] = this.kolicina;
        if (Array.isArray(this.barkodovi)) {
            data["barkodovi"] = [];
            for (let item of this.barkodovi)
                data["barkodovi"].push(item);
        }
        data["upareniBarkod"] = this.upareniBarkod;
        data["magacinId"] = this.magacinId;
        data["magacinNaziv"] = this.magacinNaziv;
        data["jeDuplikat"] = this.jeDuplikat;
        return data;
    }
}

export interface IFiskalniArtikalDto {
    predmetStavkeDto?: PredmetStavkeDto | undefined;
    kolicina?: number | undefined;
    barkodovi?: string[] | undefined;
    upareniBarkod?: string | undefined;
    magacinId?: number | undefined;
    magacinNaziv?: string | undefined;
    jeDuplikat?: boolean;
}

export class ResultOfListOfSertifikatFiskalneKaseDto extends Result implements IResultOfListOfSertifikatFiskalneKaseDto {
    data?: SertifikatFiskalneKaseDto[] | undefined;

    constructor(data?: IResultOfListOfSertifikatFiskalneKaseDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SertifikatFiskalneKaseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfSertifikatFiskalneKaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfSertifikatFiskalneKaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfSertifikatFiskalneKaseDto extends IResult {
    data?: SertifikatFiskalneKaseDto[] | undefined;
}

export class SertifikatFiskalneKaseDto implements ISertifikatFiskalneKaseDto {
    naziv?: string | undefined;
    jid?: string | undefined;
    tip?: TipBezbednosnogElementa;

    constructor(data?: ISertifikatFiskalneKaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.jid = _data["jid"];
            this.tip = _data["tip"];
        }
    }

    static fromJS(data: any): SertifikatFiskalneKaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SertifikatFiskalneKaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["jid"] = this.jid;
        data["tip"] = this.tip;
        return data;
    }
}

export interface ISertifikatFiskalneKaseDto {
    naziv?: string | undefined;
    jid?: string | undefined;
    tip?: TipBezbednosnogElementa;
}

export enum TipBezbednosnogElementa {
    LPFR = 0,
    VPFR = 1,
}

export class ResultOfListOfLpfrLicencaDropdownDto extends Result implements IResultOfListOfLpfrLicencaDropdownDto {
    data?: LpfrLicencaDropdownDto[] | undefined;

    constructor(data?: IResultOfListOfLpfrLicencaDropdownDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LpfrLicencaDropdownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfLpfrLicencaDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfLpfrLicencaDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfLpfrLicencaDropdownDto extends IResult {
    data?: LpfrLicencaDropdownDto[] | undefined;
}

export class LpfrLicencaDropdownDto implements ILpfrLicencaDropdownDto {
    id?: string | undefined;
    expirationDate?: Date | undefined;
    modRada?: ModRada;
    uredjajId?: string | undefined;

    constructor(data?: ILpfrLicencaDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.modRada = _data["modRada"];
            this.uredjajId = _data["uredjajId"];
        }
    }

    static fromJS(data: any): LpfrLicencaDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new LpfrLicencaDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["modRada"] = this.modRada;
        data["uredjajId"] = this.uredjajId;
        return data;
    }
}

export interface ILpfrLicencaDropdownDto {
    id?: string | undefined;
    expirationDate?: Date | undefined;
    modRada?: ModRada;
    uredjajId?: string | undefined;
}

export enum ModRada {
    EMPTY = 0,
    ESIR_LPRF = 1,
    ESIR = 2,
    LPFR = 3,
    MIDDLEWARE = 4,
}

export class GetArtikalListByPretragaQuery implements IGetArtikalListByPretragaQuery {
    pretraga?: string | undefined;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetArtikalListByPretragaQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pretraga = _data["pretraga"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetArtikalListByPretragaQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetArtikalListByPretragaQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pretraga"] = this.pretraga;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetArtikalListByPretragaQuery {
    pretraga?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
}

export class ResultOfGetVrstaFiskalnogRacunResponse extends Result implements IResultOfGetVrstaFiskalnogRacunResponse {
    data?: GetVrstaFiskalnogRacunResponse | undefined;

    constructor(data?: IResultOfGetVrstaFiskalnogRacunResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetVrstaFiskalnogRacunResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetVrstaFiskalnogRacunResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetVrstaFiskalnogRacunResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetVrstaFiskalnogRacunResponse extends IResult {
    data?: GetVrstaFiskalnogRacunResponse | undefined;
}

export class GetVrstaFiskalnogRacunResponse implements IGetVrstaFiskalnogRacunResponse {
    vrstaFiskalnogRacunaDtoList?: VrstaFiskalnogRacunaDto[] | undefined;

    constructor(data?: IGetVrstaFiskalnogRacunResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vrstaFiskalnogRacunaDtoList"])) {
                this.vrstaFiskalnogRacunaDtoList = [] as any;
                for (let item of _data["vrstaFiskalnogRacunaDtoList"])
                    this.vrstaFiskalnogRacunaDtoList!.push(VrstaFiskalnogRacunaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetVrstaFiskalnogRacunResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetVrstaFiskalnogRacunResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vrstaFiskalnogRacunaDtoList)) {
            data["vrstaFiskalnogRacunaDtoList"] = [];
            for (let item of this.vrstaFiskalnogRacunaDtoList)
                data["vrstaFiskalnogRacunaDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetVrstaFiskalnogRacunResponse {
    vrstaFiskalnogRacunaDtoList?: VrstaFiskalnogRacunaDto[] | undefined;
}

export class VrstaFiskalnogRacunaDto implements IVrstaFiskalnogRacunaDto {
    vrstaFiskalnogRacuna?: VrstaFiskalnogRacuna;
    vrstaFiskalnogRacunaStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IVrstaFiskalnogRacunaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vrstaFiskalnogRacuna = _data["vrstaFiskalnogRacuna"];
            this.vrstaFiskalnogRacunaStr = _data["vrstaFiskalnogRacunaStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): VrstaFiskalnogRacunaDto {
        data = typeof data === 'object' ? data : {};
        let result = new VrstaFiskalnogRacunaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vrstaFiskalnogRacuna"] = this.vrstaFiskalnogRacuna;
        data["vrstaFiskalnogRacunaStr"] = this.vrstaFiskalnogRacunaStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IVrstaFiskalnogRacunaDto {
    vrstaFiskalnogRacuna?: VrstaFiskalnogRacuna;
    vrstaFiskalnogRacunaStr?: string | undefined;
    opis?: string | undefined;
}

export enum VrstaFiskalnogRacuna {
    EMPTY = 0,
    PROMET = 1,
    PROMET_REFUNDACIJA = 2,
    PREDRACUN = 3,
    PREDRACUN_REFUNDACIJA = 4,
    AVANS = 5,
    AVANS_REFUNDACIJA = 6,
    OBUKA = 7,
    OBUKA_REFUNDACIJA = 8,
}

export class ResultOfGetBuyerIdentificationResponse extends Result implements IResultOfGetBuyerIdentificationResponse {
    data?: GetBuyerIdentificationResponse | undefined;

    constructor(data?: IResultOfGetBuyerIdentificationResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetBuyerIdentificationResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetBuyerIdentificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetBuyerIdentificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetBuyerIdentificationResponse extends IResult {
    data?: GetBuyerIdentificationResponse | undefined;
}

export class GetBuyerIdentificationResponse implements IGetBuyerIdentificationResponse {
    buyerIdentificationDtoList?: BuyerIdentificationDto[] | undefined;

    constructor(data?: IGetBuyerIdentificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["buyerIdentificationDtoList"])) {
                this.buyerIdentificationDtoList = [] as any;
                for (let item of _data["buyerIdentificationDtoList"])
                    this.buyerIdentificationDtoList!.push(BuyerIdentificationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBuyerIdentificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuyerIdentificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buyerIdentificationDtoList)) {
            data["buyerIdentificationDtoList"] = [];
            for (let item of this.buyerIdentificationDtoList)
                data["buyerIdentificationDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBuyerIdentificationResponse {
    buyerIdentificationDtoList?: BuyerIdentificationDto[] | undefined;
}

export class BuyerIdentificationDto implements IBuyerIdentificationDto {
    buyerIdentification?: BuyerIdentification;
    buyerIdentificationStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IBuyerIdentificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buyerIdentification = _data["buyerIdentification"];
            this.buyerIdentificationStr = _data["buyerIdentificationStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): BuyerIdentificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuyerIdentificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buyerIdentification"] = this.buyerIdentification;
        data["buyerIdentificationStr"] = this.buyerIdentificationStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IBuyerIdentificationDto {
    buyerIdentification?: BuyerIdentification;
    buyerIdentificationStr?: string | undefined;
    opis?: string | undefined;
}

export class ResultOfGetBuyerOptionalFieldResponse extends Result implements IResultOfGetBuyerOptionalFieldResponse {
    data?: GetBuyerOptionalFieldResponse | undefined;

    constructor(data?: IResultOfGetBuyerOptionalFieldResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetBuyerOptionalFieldResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetBuyerOptionalFieldResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetBuyerOptionalFieldResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetBuyerOptionalFieldResponse extends IResult {
    data?: GetBuyerOptionalFieldResponse | undefined;
}

export class GetBuyerOptionalFieldResponse implements IGetBuyerOptionalFieldResponse {
    buyerOptionalFieldDtoList?: BuyerOptionalFieldDto[] | undefined;

    constructor(data?: IGetBuyerOptionalFieldResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["buyerOptionalFieldDtoList"])) {
                this.buyerOptionalFieldDtoList = [] as any;
                for (let item of _data["buyerOptionalFieldDtoList"])
                    this.buyerOptionalFieldDtoList!.push(BuyerOptionalFieldDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBuyerOptionalFieldResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuyerOptionalFieldResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buyerOptionalFieldDtoList)) {
            data["buyerOptionalFieldDtoList"] = [];
            for (let item of this.buyerOptionalFieldDtoList)
                data["buyerOptionalFieldDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBuyerOptionalFieldResponse {
    buyerOptionalFieldDtoList?: BuyerOptionalFieldDto[] | undefined;
}

export class BuyerOptionalFieldDto implements IBuyerOptionalFieldDto {
    buyerOptionalField?: BuyerOptionalField;
    buyerOptionalFieldStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IBuyerOptionalFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buyerOptionalField = _data["buyerOptionalField"];
            this.buyerOptionalFieldStr = _data["buyerOptionalFieldStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): BuyerOptionalFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuyerOptionalFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buyerOptionalField"] = this.buyerOptionalField;
        data["buyerOptionalFieldStr"] = this.buyerOptionalFieldStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IBuyerOptionalFieldDto {
    buyerOptionalField?: BuyerOptionalField;
    buyerOptionalFieldStr?: string | undefined;
    opis?: string | undefined;
}

export enum BuyerOptionalField {
    Empty = 0,
    BROJ_SNPDV = 20,
    LNPDV = 21,
    BROJ_PPO_PDV = 30,
    BROJ_ZPPO_PDV = 31,
    BROJ_MPPO_PDV = 32,
    BROJ_IPPO_PDV = 33,
    BROJ_KORPORACIJSKE_KARTICE = 50,
    VREMENSKI_PERIOD = 60,
}

export class ResultOfInvoiceStatusResponse extends Result implements IResultOfInvoiceStatusResponse {
    data?: InvoiceStatusResponse | undefined;

    constructor(data?: IResultOfInvoiceStatusResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? InvoiceStatusResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfInvoiceStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfInvoiceStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfInvoiceStatusResponse extends IResult {
    data?: InvoiceStatusResponse | undefined;
}

export class InvoiceStatusResponse implements IInvoiceStatusResponse {
    sdcDateTime?: string | undefined;
    supportedLanguages?: string[] | undefined;
    uid?: string | undefined;
    taxCoreApi?: string | undefined;
    currentTaxRates?: TaxGroupResponse | undefined;
    allTaxRates?: TaxGroupResponse[] | undefined;

    constructor(data?: IInvoiceStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sdcDateTime = _data["sdcDateTime"];
            if (Array.isArray(_data["supportedLanguages"])) {
                this.supportedLanguages = [] as any;
                for (let item of _data["supportedLanguages"])
                    this.supportedLanguages!.push(item);
            }
            this.uid = _data["uid"];
            this.taxCoreApi = _data["taxCoreApi"];
            this.currentTaxRates = _data["currentTaxRates"] ? TaxGroupResponse.fromJS(_data["currentTaxRates"]) : <any>undefined;
            if (Array.isArray(_data["allTaxRates"])) {
                this.allTaxRates = [] as any;
                for (let item of _data["allTaxRates"])
                    this.allTaxRates!.push(TaxGroupResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sdcDateTime"] = this.sdcDateTime;
        if (Array.isArray(this.supportedLanguages)) {
            data["supportedLanguages"] = [];
            for (let item of this.supportedLanguages)
                data["supportedLanguages"].push(item);
        }
        data["uid"] = this.uid;
        data["taxCoreApi"] = this.taxCoreApi;
        data["currentTaxRates"] = this.currentTaxRates ? this.currentTaxRates.toJSON() : <any>undefined;
        if (Array.isArray(this.allTaxRates)) {
            data["allTaxRates"] = [];
            for (let item of this.allTaxRates)
                data["allTaxRates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvoiceStatusResponse {
    sdcDateTime?: string | undefined;
    supportedLanguages?: string[] | undefined;
    uid?: string | undefined;
    taxCoreApi?: string | undefined;
    currentTaxRates?: TaxGroupResponse | undefined;
    allTaxRates?: TaxGroupResponse[] | undefined;
}

export class TaxGroupResponse implements ITaxGroupResponse {
    groupId?: number;
    validFrom?: Date;
    taxCategories?: TaxCategoryResponse[] | undefined;

    constructor(data?: ITaxGroupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            if (Array.isArray(_data["taxCategories"])) {
                this.taxCategories = [] as any;
                for (let item of _data["taxCategories"])
                    this.taxCategories!.push(TaxCategoryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxGroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxGroupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        if (Array.isArray(this.taxCategories)) {
            data["taxCategories"] = [];
            for (let item of this.taxCategories)
                data["taxCategories"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaxGroupResponse {
    groupId?: number;
    validFrom?: Date;
    taxCategories?: TaxCategoryResponse[] | undefined;
}

export class TaxCategoryResponse implements ITaxCategoryResponse {
    categoryId?: number;
    name?: string | undefined;
    taxCategoryType?: TaxCategoryType;
    orderId?: number;
    taxRates?: TaxRateResponse[] | undefined;

    constructor(data?: ITaxCategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.taxCategoryType = _data["taxCategoryType"];
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["taxRates"])) {
                this.taxRates = [] as any;
                for (let item of _data["taxRates"])
                    this.taxRates!.push(TaxRateResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxCategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxCategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["taxCategoryType"] = this.taxCategoryType;
        data["orderId"] = this.orderId;
        if (Array.isArray(this.taxRates)) {
            data["taxRates"] = [];
            for (let item of this.taxRates)
                data["taxRates"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaxCategoryResponse {
    categoryId?: number;
    name?: string | undefined;
    taxCategoryType?: TaxCategoryType;
    orderId?: number;
    taxRates?: TaxRateResponse[] | undefined;
}

export enum TaxCategoryType {
    TAX_ONE_NET = 0,
    TAX_ON_TOTAL = 1,
    AMOUNT_PER_QUANTITY = 2,
}

export class TaxRateResponse implements ITaxRateResponse {
    rateId?: number;
    rate?: number;
    label?: string | undefined;

    constructor(data?: ITaxRateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rateId = _data["rateId"];
            this.rate = _data["rate"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): TaxRateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaxRateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rateId"] = this.rateId;
        data["rate"] = this.rate;
        data["label"] = this.label;
        return data;
    }
}

export interface ITaxRateResponse {
    rateId?: number;
    rate?: number;
    label?: string | undefined;
}

export class ResultOfInvoiceSubjectResponse extends Result implements IResultOfInvoiceSubjectResponse {
    data?: InvoiceSubjectResponse | undefined;

    constructor(data?: IResultOfInvoiceSubjectResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? InvoiceSubjectResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfInvoiceSubjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfInvoiceSubjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfInvoiceSubjectResponse extends IResult {
    data?: InvoiceSubjectResponse | undefined;
}

export class InvoiceSubjectResponse implements IInvoiceSubjectResponse {
    address?: string | undefined;
    businessName?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    district?: string | undefined;
    locationName?: string | undefined;
    tin?: string | undefined;
    uid?: string | undefined;

    constructor(data?: IInvoiceSubjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.businessName = _data["businessName"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.district = _data["district"];
            this.locationName = _data["locationName"];
            this.tin = _data["tin"];
            this.uid = _data["uid"];
        }
    }

    static fromJS(data: any): InvoiceSubjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSubjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["businessName"] = this.businessName;
        data["city"] = this.city;
        data["country"] = this.country;
        data["district"] = this.district;
        data["locationName"] = this.locationName;
        data["tin"] = this.tin;
        data["uid"] = this.uid;
        return data;
    }
}

export interface IInvoiceSubjectResponse {
    address?: string | undefined;
    businessName?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    district?: string | undefined;
    locationName?: string | undefined;
    tin?: string | undefined;
    uid?: string | undefined;
}

export class PaginatedResultOfBezbednosniElementDto extends Result implements IPaginatedResultOfBezbednosniElementDto {
    data?: BezbednosniElementDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfBezbednosniElementDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BezbednosniElementDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfBezbednosniElementDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfBezbednosniElementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfBezbednosniElementDto extends IResult {
    data?: BezbednosniElementDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class BezbednosniElementDto implements IBezbednosniElementDto {
    id?: number | undefined;
    naziv?: string | undefined;
    jid?: string | undefined;
    tip?: TipBezbednosnogElementaDto | undefined;
    datumVazenja?: string | undefined;
    jeInicijalizovan?: boolean;

    constructor(data?: IBezbednosniElementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.jid = _data["jid"];
            this.tip = _data["tip"] ? TipBezbednosnogElementaDto.fromJS(_data["tip"]) : <any>undefined;
            this.datumVazenja = _data["datumVazenja"];
            this.jeInicijalizovan = _data["jeInicijalizovan"];
        }
    }

    static fromJS(data: any): BezbednosniElementDto {
        data = typeof data === 'object' ? data : {};
        let result = new BezbednosniElementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["jid"] = this.jid;
        data["tip"] = this.tip ? this.tip.toJSON() : <any>undefined;
        data["datumVazenja"] = this.datumVazenja;
        data["jeInicijalizovan"] = this.jeInicijalizovan;
        return data;
    }
}

export interface IBezbednosniElementDto {
    id?: number | undefined;
    naziv?: string | undefined;
    jid?: string | undefined;
    tip?: TipBezbednosnogElementaDto | undefined;
    datumVazenja?: string | undefined;
    jeInicijalizovan?: boolean;
}

export class TipBezbednosnogElementaDto implements ITipBezbednosnogElementaDto {
    tip?: TipBezbednosnogElementa;
    tipStr?: string | undefined;

    constructor(data?: ITipBezbednosnogElementaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tip = _data["tip"];
            this.tipStr = _data["tipStr"];
        }
    }

    static fromJS(data: any): TipBezbednosnogElementaDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipBezbednosnogElementaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tip"] = this.tip;
        data["tipStr"] = this.tipStr;
        return data;
    }
}

export interface ITipBezbednosnogElementaDto {
    tip?: TipBezbednosnogElementa;
    tipStr?: string | undefined;
}

export class GetBezbednosniElementiTableQuery implements IGetBezbednosniElementiTableQuery {
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetBezbednosniElementiTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetBezbednosniElementiTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetBezbednosniElementiTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetBezbednosniElementiTableQuery {
    pageNumber?: number;
    pageSize?: number;
}

export class PaginatedResultOfLpfrLicencaDto extends Result implements IPaginatedResultOfLpfrLicencaDto {
    data?: LpfrLicencaDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfLpfrLicencaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LpfrLicencaDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfLpfrLicencaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfLpfrLicencaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfLpfrLicencaDto extends IResult {
    data?: LpfrLicencaDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class LpfrLicencaDto implements ILpfrLicencaDto {
    id?: string | undefined;
    expirationDate?: string | undefined;
    modRadaDto?: ModRadaDto | undefined;
    uredjajId?: string | undefined;
    sertifikatiJID?: string | undefined;
    statusLicenceDto?: StatusLicenceDto | undefined;

    constructor(data?: ILpfrLicencaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.expirationDate = _data["expirationDate"];
            this.modRadaDto = _data["modRadaDto"] ? ModRadaDto.fromJS(_data["modRadaDto"]) : <any>undefined;
            this.uredjajId = _data["uredjajId"];
            this.sertifikatiJID = _data["sertifikatiJID"];
            this.statusLicenceDto = _data["statusLicenceDto"] ? StatusLicenceDto.fromJS(_data["statusLicenceDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LpfrLicencaDto {
        data = typeof data === 'object' ? data : {};
        let result = new LpfrLicencaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expirationDate"] = this.expirationDate;
        data["modRadaDto"] = this.modRadaDto ? this.modRadaDto.toJSON() : <any>undefined;
        data["uredjajId"] = this.uredjajId;
        data["sertifikatiJID"] = this.sertifikatiJID;
        data["statusLicenceDto"] = this.statusLicenceDto ? this.statusLicenceDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILpfrLicencaDto {
    id?: string | undefined;
    expirationDate?: string | undefined;
    modRadaDto?: ModRadaDto | undefined;
    uredjajId?: string | undefined;
    sertifikatiJID?: string | undefined;
    statusLicenceDto?: StatusLicenceDto | undefined;
}

export class ModRadaDto implements IModRadaDto {
    modRada?: ModRada;
    modRadaStr?: string | undefined;
    modRadaBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IModRadaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modRada = _data["modRada"];
            this.modRadaStr = _data["modRadaStr"];
            this.modRadaBadgeStr = _data["modRadaBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): ModRadaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModRadaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modRada"] = this.modRada;
        data["modRadaStr"] = this.modRadaStr;
        data["modRadaBadgeStr"] = this.modRadaBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IModRadaDto {
    modRada?: ModRada;
    modRadaStr?: string | undefined;
    modRadaBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class StatusLicenceDto implements IStatusLicenceDto {
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;

    constructor(data?: IStatusLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusStr = _data["statusStr"];
            this.statusBadgeStr = _data["statusBadgeStr"];
        }
    }

    static fromJS(data: any): StatusLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusStr"] = this.statusStr;
        data["statusBadgeStr"] = this.statusBadgeStr;
        return data;
    }
}

export interface IStatusLicenceDto {
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;
}

export class GetLicenceZaFiskalnuTableQuery implements IGetLicenceZaFiskalnuTableQuery {
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetLicenceZaFiskalnuTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetLicenceZaFiskalnuTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetLicenceZaFiskalnuTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetLicenceZaFiskalnuTableQuery {
    pageNumber?: number;
    pageSize?: number;
}

export class ResultOfBezbednosniElementInfoDto extends Result implements IResultOfBezbednosniElementInfoDto {
    data?: BezbednosniElementInfoDto | undefined;

    constructor(data?: IResultOfBezbednosniElementInfoDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? BezbednosniElementInfoDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfBezbednosniElementInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfBezbednosniElementInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfBezbednosniElementInfoDto extends IResult {
    data?: BezbednosniElementInfoDto | undefined;
}

export class BezbednosniElementInfoDto implements IBezbednosniElementInfoDto {
    id?: number;
    naziv?: string | undefined;
    jid?: string | undefined;
    lozinka?: string | undefined;
    pak?: string | undefined;
    poslovnaJedinicaId?: number;

    constructor(data?: IBezbednosniElementInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.jid = _data["jid"];
            this.lozinka = _data["lozinka"];
            this.pak = _data["pak"];
            this.poslovnaJedinicaId = _data["poslovnaJedinicaId"];
        }
    }

    static fromJS(data: any): BezbednosniElementInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BezbednosniElementInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["jid"] = this.jid;
        data["lozinka"] = this.lozinka;
        data["pak"] = this.pak;
        data["poslovnaJedinicaId"] = this.poslovnaJedinicaId;
        return data;
    }
}

export interface IBezbednosniElementInfoDto {
    id?: number;
    naziv?: string | undefined;
    jid?: string | undefined;
    lozinka?: string | undefined;
    pak?: string | undefined;
    poslovnaJedinicaId?: number;
}

export class ResultOfEsdcCardStatus extends Result implements IResultOfEsdcCardStatus {
    data?: EsdcCardStatus;

    constructor(data?: IResultOfEsdcCardStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ResultOfEsdcCardStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfEsdcCardStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfEsdcCardStatus extends IResult {
    data?: EsdcCardStatus;
}

export enum EsdcCardStatus {
    NOT_INSERTED = 0,
    INSERTED = 1,
    INSERTED_AND_VERIFIED = 2,
}

export class ResultOfInvoiceReportResponse extends Result implements IResultOfInvoiceReportResponse {
    data?: InvoiceReportResponse | undefined;

    constructor(data?: IResultOfInvoiceReportResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? InvoiceReportResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfInvoiceReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfInvoiceReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfInvoiceReportResponse extends IResult {
    data?: InvoiceReportResponse | undefined;
}

export class InvoiceReportResponse implements IInvoiceReportResponse {
    businessName?: string | undefined;
    tin?: string | undefined;
    locationName?: string | undefined;
    address?: string | undefined;
    dateTime?: string | undefined;
    district?: string | undefined;
    journal?: string | undefined;
    number?: number;
    perTransactionType?: InvoiceReportTransactionTypeSummary[] | undefined;
    total?: InvoiceReportSummary | undefined;
    uid?: string | undefined;

    constructor(data?: IInvoiceReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessName = _data["businessName"];
            this.tin = _data["tin"];
            this.locationName = _data["locationName"];
            this.address = _data["address"];
            this.dateTime = _data["dateTime"];
            this.district = _data["district"];
            this.journal = _data["journal"];
            this.number = _data["number"];
            if (Array.isArray(_data["perTransactionType"])) {
                this.perTransactionType = [] as any;
                for (let item of _data["perTransactionType"])
                    this.perTransactionType!.push(InvoiceReportTransactionTypeSummary.fromJS(item));
            }
            this.total = _data["total"] ? InvoiceReportSummary.fromJS(_data["total"]) : <any>undefined;
            this.uid = _data["uid"];
        }
    }

    static fromJS(data: any): InvoiceReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessName"] = this.businessName;
        data["tin"] = this.tin;
        data["locationName"] = this.locationName;
        data["address"] = this.address;
        data["dateTime"] = this.dateTime;
        data["district"] = this.district;
        data["journal"] = this.journal;
        data["number"] = this.number;
        if (Array.isArray(this.perTransactionType)) {
            data["perTransactionType"] = [];
            for (let item of this.perTransactionType)
                data["perTransactionType"].push(item.toJSON());
        }
        data["total"] = this.total ? this.total.toJSON() : <any>undefined;
        data["uid"] = this.uid;
        return data;
    }
}

export interface IInvoiceReportResponse {
    businessName?: string | undefined;
    tin?: string | undefined;
    locationName?: string | undefined;
    address?: string | undefined;
    dateTime?: string | undefined;
    district?: string | undefined;
    journal?: string | undefined;
    number?: number;
    perTransactionType?: InvoiceReportTransactionTypeSummary[] | undefined;
    total?: InvoiceReportSummary | undefined;
    uid?: string | undefined;
}

export class InvoiceReportTransactionTypeSummary implements IInvoiceReportTransactionTypeSummary {
    invoiceCount?: number;
    invoiceType?: InvoiceType;
    transactionType?: TransactionType;
    payments?: InvoiceReportPayment[] | undefined;
    taxItems?: InvoiceReportTaxItem[] | undefined;

    constructor(data?: IInvoiceReportTransactionTypeSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceCount = _data["invoiceCount"];
            this.invoiceType = _data["invoiceType"];
            this.transactionType = _data["transactionType"];
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(InvoiceReportPayment.fromJS(item));
            }
            if (Array.isArray(_data["taxItems"])) {
                this.taxItems = [] as any;
                for (let item of _data["taxItems"])
                    this.taxItems!.push(InvoiceReportTaxItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceReportTransactionTypeSummary {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceReportTransactionTypeSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceCount"] = this.invoiceCount;
        data["invoiceType"] = this.invoiceType;
        data["transactionType"] = this.transactionType;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        if (Array.isArray(this.taxItems)) {
            data["taxItems"] = [];
            for (let item of this.taxItems)
                data["taxItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvoiceReportTransactionTypeSummary {
    invoiceCount?: number;
    invoiceType?: InvoiceType;
    transactionType?: TransactionType;
    payments?: InvoiceReportPayment[] | undefined;
    taxItems?: InvoiceReportTaxItem[] | undefined;
}

export class InvoiceReportPayment implements IInvoiceReportPayment {
    amount?: number;
    paymentType?: PaymentType;

    constructor(data?: IInvoiceReportPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.paymentType = _data["paymentType"];
        }
    }

    static fromJS(data: any): InvoiceReportPayment {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceReportPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["paymentType"] = this.paymentType;
        return data;
    }
}

export interface IInvoiceReportPayment {
    amount?: number;
    paymentType?: PaymentType;
}

export class InvoiceReportTaxItem implements IInvoiceReportTaxItem {
    amount?: number;
    categoryName?: string | undefined;
    categoryOrderId?: number;
    categoryType?: TaxCategoryType;
    label?: string | undefined;
    rate?: number;
    total?: number;

    constructor(data?: IInvoiceReportTaxItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.categoryName = _data["categoryName"];
            this.categoryOrderId = _data["categoryOrderId"];
            this.categoryType = _data["categoryType"];
            this.label = _data["label"];
            this.rate = _data["rate"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): InvoiceReportTaxItem {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceReportTaxItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["categoryName"] = this.categoryName;
        data["categoryOrderId"] = this.categoryOrderId;
        data["categoryType"] = this.categoryType;
        data["label"] = this.label;
        data["rate"] = this.rate;
        data["total"] = this.total;
        return data;
    }
}

export interface IInvoiceReportTaxItem {
    amount?: number;
    categoryName?: string | undefined;
    categoryOrderId?: number;
    categoryType?: TaxCategoryType;
    label?: string | undefined;
    rate?: number;
    total?: number;
}

export class InvoiceReportSummary implements IInvoiceReportSummary {
    invoiceCount?: number;
    payments?: InvoiceReportPayment[] | undefined;
    taxItems?: InvoiceReportTaxItem[] | undefined;

    constructor(data?: IInvoiceReportSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceCount = _data["invoiceCount"];
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(InvoiceReportPayment.fromJS(item));
            }
            if (Array.isArray(_data["taxItems"])) {
                this.taxItems = [] as any;
                for (let item of _data["taxItems"])
                    this.taxItems!.push(InvoiceReportTaxItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceReportSummary {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceReportSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceCount"] = this.invoiceCount;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        if (Array.isArray(this.taxItems)) {
            data["taxItems"] = [];
            for (let item of this.taxItems)
                data["taxItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvoiceReportSummary {
    invoiceCount?: number;
    payments?: InvoiceReportPayment[] | undefined;
    taxItems?: InvoiceReportTaxItem[] | undefined;
}

export class GetPeriodicReportQuery implements IGetPeriodicReportQuery {
    print?: boolean;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IGetPeriodicReportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.print = _data["print"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPeriodicReportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPeriodicReportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["print"] = this.print;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetPeriodicReportQuery {
    print?: boolean;
    startDate?: Date;
    endDate?: Date;
}

export class ResultOfGetStatusBezbednosnogElementaResponse extends Result implements IResultOfGetStatusBezbednosnogElementaResponse {
    data?: GetStatusBezbednosnogElementaResponse | undefined;

    constructor(data?: IResultOfGetStatusBezbednosnogElementaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetStatusBezbednosnogElementaResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetStatusBezbednosnogElementaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetStatusBezbednosnogElementaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetStatusBezbednosnogElementaResponse extends IResult {
    data?: GetStatusBezbednosnogElementaResponse | undefined;
}

export class GetStatusBezbednosnogElementaResponse implements IGetStatusBezbednosnogElementaResponse {
    isVerified?: boolean;
    esdcCardStatus?: EsdcCardStatus;
    status?: StatusVerifikacijeBezbednosnogElementa;
    uid?: string | undefined;

    constructor(data?: IGetStatusBezbednosnogElementaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isVerified = _data["isVerified"];
            this.esdcCardStatus = _data["esdcCardStatus"];
            this.status = _data["status"];
            this.uid = _data["uid"];
        }
    }

    static fromJS(data: any): GetStatusBezbednosnogElementaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStatusBezbednosnogElementaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isVerified"] = this.isVerified;
        data["esdcCardStatus"] = this.esdcCardStatus;
        data["status"] = this.status;
        data["uid"] = this.uid;
        return data;
    }
}

export interface IGetStatusBezbednosnogElementaResponse {
    isVerified?: boolean;
    esdcCardStatus?: EsdcCardStatus;
    status?: StatusVerifikacijeBezbednosnogElementa;
    uid?: string | undefined;
}

export enum StatusVerifikacijeBezbednosnogElementa {
    DETEKTOVAN = 0,
    INICIJALIZOVAN = 1,
}

export class ResultOfGetReferentniFiskalniRacunAutocompleteResponse extends Result implements IResultOfGetReferentniFiskalniRacunAutocompleteResponse {
    data?: GetReferentniFiskalniRacunAutocompleteResponse | undefined;

    constructor(data?: IResultOfGetReferentniFiskalniRacunAutocompleteResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetReferentniFiskalniRacunAutocompleteResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetReferentniFiskalniRacunAutocompleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetReferentniFiskalniRacunAutocompleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetReferentniFiskalniRacunAutocompleteResponse extends IResult {
    data?: GetReferentniFiskalniRacunAutocompleteResponse | undefined;
}

export class GetReferentniFiskalniRacunAutocompleteResponse implements IGetReferentniFiskalniRacunAutocompleteResponse {
    listReferentniFiskalniRacuniDto?: ReferentniFiskalniRacunDto[] | undefined;

    constructor(data?: IGetReferentniFiskalniRacunAutocompleteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["listReferentniFiskalniRacuniDto"])) {
                this.listReferentniFiskalniRacuniDto = [] as any;
                for (let item of _data["listReferentniFiskalniRacuniDto"])
                    this.listReferentniFiskalniRacuniDto!.push(ReferentniFiskalniRacunDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetReferentniFiskalniRacunAutocompleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferentniFiskalniRacunAutocompleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.listReferentniFiskalniRacuniDto)) {
            data["listReferentniFiskalniRacuniDto"] = [];
            for (let item of this.listReferentniFiskalniRacuniDto)
                data["listReferentniFiskalniRacuniDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetReferentniFiskalniRacunAutocompleteResponse {
    listReferentniFiskalniRacuniDto?: ReferentniFiskalniRacunDto[] | undefined;
}

export class ReferentniFiskalniRacunDto implements IReferentniFiskalniRacunDto {
    id?: string | undefined;
    referentDocumentNumber?: string | undefined;
    referentDocumentDT?: Date | undefined;
    jeStariRacun?: boolean | undefined;
    hasStariReferentniRacun?: boolean | undefined;
    invoiceType?: InvoiceType | undefined;
    transactionType?: TransactionType | undefined;
    amount?: number | undefined;
    buyerIdentification?: BuyerIdentification | undefined;
    buyerId?: string | undefined;
    buyerOptionalField?: BuyerOptionalField | undefined;
    buyerCostCenterId?: string | undefined;

    constructor(data?: IReferentniFiskalniRacunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referentDocumentNumber = _data["referentDocumentNumber"];
            this.referentDocumentDT = _data["referentDocumentDT"] ? new Date(_data["referentDocumentDT"].toString()) : <any>undefined;
            this.jeStariRacun = _data["jeStariRacun"];
            this.hasStariReferentniRacun = _data["hasStariReferentniRacun"];
            this.invoiceType = _data["invoiceType"];
            this.transactionType = _data["transactionType"];
            this.amount = _data["amount"];
            this.buyerIdentification = _data["buyerIdentification"];
            this.buyerId = _data["buyerId"];
            this.buyerOptionalField = _data["buyerOptionalField"];
            this.buyerCostCenterId = _data["buyerCostCenterId"];
        }
    }

    static fromJS(data: any): ReferentniFiskalniRacunDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferentniFiskalniRacunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referentDocumentNumber"] = this.referentDocumentNumber;
        data["referentDocumentDT"] = this.referentDocumentDT ? this.referentDocumentDT.toISOString() : <any>undefined;
        data["jeStariRacun"] = this.jeStariRacun;
        data["hasStariReferentniRacun"] = this.hasStariReferentniRacun;
        data["invoiceType"] = this.invoiceType;
        data["transactionType"] = this.transactionType;
        data["amount"] = this.amount;
        data["buyerIdentification"] = this.buyerIdentification;
        data["buyerId"] = this.buyerId;
        data["buyerOptionalField"] = this.buyerOptionalField;
        data["buyerCostCenterId"] = this.buyerCostCenterId;
        return data;
    }
}

export interface IReferentniFiskalniRacunDto {
    id?: string | undefined;
    referentDocumentNumber?: string | undefined;
    referentDocumentDT?: Date | undefined;
    jeStariRacun?: boolean | undefined;
    hasStariReferentniRacun?: boolean | undefined;
    invoiceType?: InvoiceType | undefined;
    transactionType?: TransactionType | undefined;
    amount?: number | undefined;
    buyerIdentification?: BuyerIdentification | undefined;
    buyerId?: string | undefined;
    buyerOptionalField?: BuyerOptionalField | undefined;
    buyerCostCenterId?: string | undefined;
}

export class ResultOfGetStavkeAvansnogFiskalnogVm extends Result implements IResultOfGetStavkeAvansnogFiskalnogVm {
    data?: GetStavkeAvansnogFiskalnogVm | undefined;

    constructor(data?: IResultOfGetStavkeAvansnogFiskalnogVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetStavkeAvansnogFiskalnogVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetStavkeAvansnogFiskalnogVm {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetStavkeAvansnogFiskalnogVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetStavkeAvansnogFiskalnogVm extends IResult {
    data?: GetStavkeAvansnogFiskalnogVm | undefined;
}

export class GetStavkeAvansnogFiskalnogVm implements IGetStavkeAvansnogFiskalnogVm {
    predmetiStavkiDto?: PredmetStavkeDto[] | undefined;

    constructor(data?: IGetStavkeAvansnogFiskalnogVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["predmetiStavkiDto"])) {
                this.predmetiStavkiDto = [] as any;
                for (let item of _data["predmetiStavkiDto"])
                    this.predmetiStavkiDto!.push(PredmetStavkeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStavkeAvansnogFiskalnogVm {
        data = typeof data === 'object' ? data : {};
        let result = new GetStavkeAvansnogFiskalnogVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.predmetiStavkiDto)) {
            data["predmetiStavkiDto"] = [];
            for (let item of this.predmetiStavkiDto)
                data["predmetiStavkiDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStavkeAvansnogFiskalnogVm {
    predmetiStavkiDto?: PredmetStavkeDto[] | undefined;
}

export class ResultOfInvoiceResponse extends Result implements IResultOfInvoiceResponse {
    data?: InvoiceResponse | undefined;

    constructor(data?: IResultOfInvoiceResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? InvoiceResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfInvoiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfInvoiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfInvoiceResponse extends IResult {
    data?: InvoiceResponse | undefined;
}

export abstract class AuditableEntity implements IAuditableEntity {
    createdBy?: string;
    createdOn?: Date;
    lastModifiedBy?: string;
    lastModifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    deletedBy?: string | undefined;

    constructor(data?: IAuditableEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedOn = _data["lastModifiedOn"] ? new Date(_data["lastModifiedOn"].toString()) : <any>undefined;
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
        }
    }

    static fromJS(data: any): AuditableEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AuditableEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        return data;
    }
}

export interface IAuditableEntity {
    createdBy?: string;
    createdOn?: Date;
    lastModifiedBy?: string;
    lastModifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    deletedBy?: string | undefined;
}

export class InvoiceResponse extends AuditableEntity implements IInvoiceResponse {
    invoiceResponseId?: number;
    requestedBy?: string | undefined;
    signedBy?: string | undefined;
    sdcDateTime?: string | undefined;
    sdcDateTimeLocalString?: string | undefined;
    sdcDateTimeTs?: Date;
    invoiceCounter?: string | undefined;
    invoiceCounterExtension?: string | undefined;
    invoiceNumber?: string | undefined;
    verificationUrl?: string | undefined;
    verificationQRCode?: string | undefined;
    journal?: string | undefined;
    totalCounter?: number;
    transactionTypeCounter?: number;
    totalAmount?: number;
    encryptedInternalData?: string | undefined;
    signature?: string | undefined;
    taxGroupRevision?: number;
    businessName?: string | undefined;
    tin?: string | undefined;
    locationName?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    mrc?: string | undefined;
    messages?: string | undefined;
    invoiceRequestId?: string;
    invoiceRequest?: InvoiceRequest | undefined;
    taxItems?: InvoiceTaxItem[] | undefined;
    documents?: FiskalniRacunRelevantniDokument[] | undefined;

    constructor(data?: IInvoiceResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.invoiceResponseId = _data["invoiceResponseId"];
            this.requestedBy = _data["requestedBy"];
            this.signedBy = _data["signedBy"];
            this.sdcDateTime = _data["sdcDateTime"];
            this.sdcDateTimeLocalString = _data["sdcDateTimeLocalString"];
            this.sdcDateTimeTs = _data["sdcDateTimeTs"] ? new Date(_data["sdcDateTimeTs"].toString()) : <any>undefined;
            this.invoiceCounter = _data["invoiceCounter"];
            this.invoiceCounterExtension = _data["invoiceCounterExtension"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.verificationUrl = _data["verificationUrl"];
            this.verificationQRCode = _data["verificationQRCode"];
            this.journal = _data["journal"];
            this.totalCounter = _data["totalCounter"];
            this.transactionTypeCounter = _data["transactionTypeCounter"];
            this.totalAmount = _data["totalAmount"];
            this.encryptedInternalData = _data["encryptedInternalData"];
            this.signature = _data["signature"];
            this.taxGroupRevision = _data["taxGroupRevision"];
            this.businessName = _data["businessName"];
            this.tin = _data["tin"];
            this.locationName = _data["locationName"];
            this.address = _data["address"];
            this.district = _data["district"];
            this.mrc = _data["mrc"];
            this.messages = _data["messages"];
            this.invoiceRequestId = _data["invoiceRequestId"];
            this.invoiceRequest = _data["invoiceRequest"] ? InvoiceRequest.fromJS(_data["invoiceRequest"]) : <any>undefined;
            if (Array.isArray(_data["taxItems"])) {
                this.taxItems = [] as any;
                for (let item of _data["taxItems"])
                    this.taxItems!.push(InvoiceTaxItem.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(FiskalniRacunRelevantniDokument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceResponseId"] = this.invoiceResponseId;
        data["requestedBy"] = this.requestedBy;
        data["signedBy"] = this.signedBy;
        data["sdcDateTime"] = this.sdcDateTime;
        data["sdcDateTimeLocalString"] = this.sdcDateTimeLocalString;
        data["sdcDateTimeTs"] = this.sdcDateTimeTs ? this.sdcDateTimeTs.toISOString() : <any>undefined;
        data["invoiceCounter"] = this.invoiceCounter;
        data["invoiceCounterExtension"] = this.invoiceCounterExtension;
        data["invoiceNumber"] = this.invoiceNumber;
        data["verificationUrl"] = this.verificationUrl;
        data["verificationQRCode"] = this.verificationQRCode;
        data["journal"] = this.journal;
        data["totalCounter"] = this.totalCounter;
        data["transactionTypeCounter"] = this.transactionTypeCounter;
        data["totalAmount"] = this.totalAmount;
        data["encryptedInternalData"] = this.encryptedInternalData;
        data["signature"] = this.signature;
        data["taxGroupRevision"] = this.taxGroupRevision;
        data["businessName"] = this.businessName;
        data["tin"] = this.tin;
        data["locationName"] = this.locationName;
        data["address"] = this.address;
        data["district"] = this.district;
        data["mrc"] = this.mrc;
        data["messages"] = this.messages;
        data["invoiceRequestId"] = this.invoiceRequestId;
        data["invoiceRequest"] = this.invoiceRequest ? this.invoiceRequest.toJSON() : <any>undefined;
        if (Array.isArray(this.taxItems)) {
            data["taxItems"] = [];
            for (let item of this.taxItems)
                data["taxItems"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInvoiceResponse extends IAuditableEntity {
    invoiceResponseId?: number;
    requestedBy?: string | undefined;
    signedBy?: string | undefined;
    sdcDateTime?: string | undefined;
    sdcDateTimeLocalString?: string | undefined;
    sdcDateTimeTs?: Date;
    invoiceCounter?: string | undefined;
    invoiceCounterExtension?: string | undefined;
    invoiceNumber?: string | undefined;
    verificationUrl?: string | undefined;
    verificationQRCode?: string | undefined;
    journal?: string | undefined;
    totalCounter?: number;
    transactionTypeCounter?: number;
    totalAmount?: number;
    encryptedInternalData?: string | undefined;
    signature?: string | undefined;
    taxGroupRevision?: number;
    businessName?: string | undefined;
    tin?: string | undefined;
    locationName?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    mrc?: string | undefined;
    messages?: string | undefined;
    invoiceRequestId?: string;
    invoiceRequest?: InvoiceRequest | undefined;
    taxItems?: InvoiceTaxItem[] | undefined;
    documents?: FiskalniRacunRelevantniDokument[] | undefined;
}

export class InvoiceRequest extends AuditableEntity implements IInvoiceRequest {
    invoiceRequestId?: string;
    dateAndTimeOfIssue?: Date | undefined;
    cashier?: string | undefined;
    buyerId?: string | undefined;
    buyerIdentification?: BuyerIdentification | undefined;
    buyerCostCenterId?: string | undefined;
    buyerOptionalField?: BuyerOptionalField | undefined;
    invoiceType?: InvoiceType;
    transactionType?: TransactionType;
    invoiceNumber?: string | undefined;
    referentDocumentNumber?: string | undefined;
    referentDocumentDT?: Date | undefined;
    optionId?: number;
    option?: InvoiceOption | undefined;
    strankaId?: number | undefined;
    stranka?: Stranka | undefined;
    isRefunded?: boolean;
    status?: StatusFiskalnogRacuna;
    invoiceResponse?: InvoiceResponse | undefined;
    journalOptionId?: number | undefined;
    journalOption?: JournalOption | undefined;
    items?: InvoiceItem[] | undefined;
    payments?: InvoicePayment[] | undefined;
    lagerTransakcije?: LagerTransakcija[] | undefined;
    referentniParent?: ReferentniFiskalniRacun | undefined;
    referentniChild?: ReferentniFiskalniRacun | undefined;
    referentniRoot?: ReferentniFiskalniRacun | undefined;

    constructor(data?: IInvoiceRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.invoiceRequestId = _data["invoiceRequestId"];
            this.dateAndTimeOfIssue = _data["dateAndTimeOfIssue"] ? new Date(_data["dateAndTimeOfIssue"].toString()) : <any>undefined;
            this.cashier = _data["cashier"];
            this.buyerId = _data["buyerId"];
            this.buyerIdentification = _data["buyerIdentification"];
            this.buyerCostCenterId = _data["buyerCostCenterId"];
            this.buyerOptionalField = _data["buyerOptionalField"];
            this.invoiceType = _data["invoiceType"];
            this.transactionType = _data["transactionType"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.referentDocumentNumber = _data["referentDocumentNumber"];
            this.referentDocumentDT = _data["referentDocumentDT"] ? new Date(_data["referentDocumentDT"].toString()) : <any>undefined;
            this.optionId = _data["optionId"];
            this.option = _data["option"] ? InvoiceOption.fromJS(_data["option"]) : <any>undefined;
            this.strankaId = _data["strankaId"];
            this.stranka = _data["stranka"] ? Stranka.fromJS(_data["stranka"]) : <any>undefined;
            this.isRefunded = _data["isRefunded"];
            this.status = _data["status"];
            this.invoiceResponse = _data["invoiceResponse"] ? InvoiceResponse.fromJS(_data["invoiceResponse"]) : <any>undefined;
            this.journalOptionId = _data["journalOptionId"];
            this.journalOption = _data["journalOption"] ? JournalOption.fromJS(_data["journalOption"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InvoiceItem.fromJS(item));
            }
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(InvoicePayment.fromJS(item));
            }
            if (Array.isArray(_data["lagerTransakcije"])) {
                this.lagerTransakcije = [] as any;
                for (let item of _data["lagerTransakcije"])
                    this.lagerTransakcije!.push(LagerTransakcija.fromJS(item));
            }
            this.referentniParent = _data["referentniParent"] ? ReferentniFiskalniRacun.fromJS(_data["referentniParent"]) : <any>undefined;
            this.referentniChild = _data["referentniChild"] ? ReferentniFiskalniRacun.fromJS(_data["referentniChild"]) : <any>undefined;
            this.referentniRoot = _data["referentniRoot"] ? ReferentniFiskalniRacun.fromJS(_data["referentniRoot"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceRequestId"] = this.invoiceRequestId;
        data["dateAndTimeOfIssue"] = this.dateAndTimeOfIssue ? this.dateAndTimeOfIssue.toISOString() : <any>undefined;
        data["cashier"] = this.cashier;
        data["buyerId"] = this.buyerId;
        data["buyerIdentification"] = this.buyerIdentification;
        data["buyerCostCenterId"] = this.buyerCostCenterId;
        data["buyerOptionalField"] = this.buyerOptionalField;
        data["invoiceType"] = this.invoiceType;
        data["transactionType"] = this.transactionType;
        data["invoiceNumber"] = this.invoiceNumber;
        data["referentDocumentNumber"] = this.referentDocumentNumber;
        data["referentDocumentDT"] = this.referentDocumentDT ? this.referentDocumentDT.toISOString() : <any>undefined;
        data["optionId"] = this.optionId;
        data["option"] = this.option ? this.option.toJSON() : <any>undefined;
        data["strankaId"] = this.strankaId;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        data["isRefunded"] = this.isRefunded;
        data["status"] = this.status;
        data["invoiceResponse"] = this.invoiceResponse ? this.invoiceResponse.toJSON() : <any>undefined;
        data["journalOptionId"] = this.journalOptionId;
        data["journalOption"] = this.journalOption ? this.journalOption.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        if (Array.isArray(this.lagerTransakcije)) {
            data["lagerTransakcije"] = [];
            for (let item of this.lagerTransakcije)
                data["lagerTransakcije"].push(item.toJSON());
        }
        data["referentniParent"] = this.referentniParent ? this.referentniParent.toJSON() : <any>undefined;
        data["referentniChild"] = this.referentniChild ? this.referentniChild.toJSON() : <any>undefined;
        data["referentniRoot"] = this.referentniRoot ? this.referentniRoot.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoiceRequest extends IAuditableEntity {
    invoiceRequestId?: string;
    dateAndTimeOfIssue?: Date | undefined;
    cashier?: string | undefined;
    buyerId?: string | undefined;
    buyerIdentification?: BuyerIdentification | undefined;
    buyerCostCenterId?: string | undefined;
    buyerOptionalField?: BuyerOptionalField | undefined;
    invoiceType?: InvoiceType;
    transactionType?: TransactionType;
    invoiceNumber?: string | undefined;
    referentDocumentNumber?: string | undefined;
    referentDocumentDT?: Date | undefined;
    optionId?: number;
    option?: InvoiceOption | undefined;
    strankaId?: number | undefined;
    stranka?: Stranka | undefined;
    isRefunded?: boolean;
    status?: StatusFiskalnogRacuna;
    invoiceResponse?: InvoiceResponse | undefined;
    journalOptionId?: number | undefined;
    journalOption?: JournalOption | undefined;
    items?: InvoiceItem[] | undefined;
    payments?: InvoicePayment[] | undefined;
    lagerTransakcije?: LagerTransakcija[] | undefined;
    referentniParent?: ReferentniFiskalniRacun | undefined;
    referentniChild?: ReferentniFiskalniRacun | undefined;
    referentniRoot?: ReferentniFiskalniRacun | undefined;
}

export class InvoiceOption implements IInvoiceOption {
    invoiceOptionId?: number;
    omitQRCodeGen?: Omit;
    omitTextualRepresentation?: Omit;

    constructor(data?: IInvoiceOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceOptionId = _data["invoiceOptionId"];
            this.omitQRCodeGen = _data["omitQRCodeGen"];
            this.omitTextualRepresentation = _data["omitTextualRepresentation"];
        }
    }

    static fromJS(data: any): InvoiceOption {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceOptionId"] = this.invoiceOptionId;
        data["omitQRCodeGen"] = this.omitQRCodeGen;
        data["omitTextualRepresentation"] = this.omitTextualRepresentation;
        return data;
    }
}

export interface IInvoiceOption {
    invoiceOptionId?: number;
    omitQRCodeGen?: Omit;
    omitTextualRepresentation?: Omit;
}

export enum Omit {
    RETURN = 0,
    OMIT_GENERATION = 1,
}

export class Stranka extends AuditableEntity implements IStranka {
    strankaId?: number;
    naziv?: string | undefined;
    napomena?: string | undefined;
    tipStranke?: TipStranke;
    rokPlacanjaZaUlazne?: number;
    rokPlacanjaZaIzlazne?: number;
    jeKupac?: boolean;
    jeDobavljac?: boolean;
    isActive?: boolean;
    gln?: string | undefined;
    adresaId?: number | undefined;
    adresa?: Adresa | undefined;
    valutaPoslovanjaId?: string | undefined;
    valutaPoslovanja?: Valuta | undefined;
    cenovnici?: CenovnikStranka[] | undefined;
    predmetiStavkiSef?: PredmetStavkeSefMap[] | undefined;
    racuni?: Racun[] | undefined;
    informacijaIsporukeStranke?: InformacijaIsporukeStranka[] | undefined;
    transakcijeIzvoda?: TransakcijaIzvoda[] | undefined;
    izvodi?: Izvod[] | undefined;
    oznake?: OznakaStranke[] | undefined;
    kontakti?: Kontakt[] | undefined;
    tekuciRacuni?: TekuciRacun[] | undefined;
    poslovneJedinice?: PoslovnaJedinica[] | undefined;
    racunMessages?: RacunMessage[] | undefined;
    invoiceRequests?: InvoiceRequest[] | undefined;
    delovodniDokumenti?: DelovodniDokument[] | undefined;
    pojedinacnePdvEvidencije39?: PojedinacnaPdvEvidencija39[] | undefined;
    otpremnicePrimalac?: EOtpremnicaBase[] | undefined;
    fazeVoznje?: FazaVoznje[] | undefined;
    fizickoLice?: FizickoLice | undefined;
    pravnoLice?: PravnoLice | undefined;
    saldo?: SaldoStranka | undefined;

    constructor(data?: IStranka) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.strankaId = _data["strankaId"];
            this.naziv = _data["naziv"];
            this.napomena = _data["napomena"];
            this.tipStranke = _data["tipStranke"];
            this.rokPlacanjaZaUlazne = _data["rokPlacanjaZaUlazne"];
            this.rokPlacanjaZaIzlazne = _data["rokPlacanjaZaIzlazne"];
            this.jeKupac = _data["jeKupac"];
            this.jeDobavljac = _data["jeDobavljac"];
            this.isActive = _data["isActive"];
            this.gln = _data["gln"];
            this.adresaId = _data["adresaId"];
            this.adresa = _data["adresa"] ? Adresa.fromJS(_data["adresa"]) : <any>undefined;
            this.valutaPoslovanjaId = _data["valutaPoslovanjaId"];
            this.valutaPoslovanja = _data["valutaPoslovanja"] ? Valuta.fromJS(_data["valutaPoslovanja"]) : <any>undefined;
            if (Array.isArray(_data["cenovnici"])) {
                this.cenovnici = [] as any;
                for (let item of _data["cenovnici"])
                    this.cenovnici!.push(CenovnikStranka.fromJS(item));
            }
            if (Array.isArray(_data["predmetiStavkiSef"])) {
                this.predmetiStavkiSef = [] as any;
                for (let item of _data["predmetiStavkiSef"])
                    this.predmetiStavkiSef!.push(PredmetStavkeSefMap.fromJS(item));
            }
            if (Array.isArray(_data["racuni"])) {
                this.racuni = [] as any;
                for (let item of _data["racuni"])
                    this.racuni!.push(Racun.fromJS(item));
            }
            if (Array.isArray(_data["informacijaIsporukeStranke"])) {
                this.informacijaIsporukeStranke = [] as any;
                for (let item of _data["informacijaIsporukeStranke"])
                    this.informacijaIsporukeStranke!.push(InformacijaIsporukeStranka.fromJS(item));
            }
            if (Array.isArray(_data["transakcijeIzvoda"])) {
                this.transakcijeIzvoda = [] as any;
                for (let item of _data["transakcijeIzvoda"])
                    this.transakcijeIzvoda!.push(TransakcijaIzvoda.fromJS(item));
            }
            if (Array.isArray(_data["izvodi"])) {
                this.izvodi = [] as any;
                for (let item of _data["izvodi"])
                    this.izvodi!.push(Izvod.fromJS(item));
            }
            if (Array.isArray(_data["oznake"])) {
                this.oznake = [] as any;
                for (let item of _data["oznake"])
                    this.oznake!.push(OznakaStranke.fromJS(item));
            }
            if (Array.isArray(_data["kontakti"])) {
                this.kontakti = [] as any;
                for (let item of _data["kontakti"])
                    this.kontakti!.push(Kontakt.fromJS(item));
            }
            if (Array.isArray(_data["tekuciRacuni"])) {
                this.tekuciRacuni = [] as any;
                for (let item of _data["tekuciRacuni"])
                    this.tekuciRacuni!.push(TekuciRacun.fromJS(item));
            }
            if (Array.isArray(_data["poslovneJedinice"])) {
                this.poslovneJedinice = [] as any;
                for (let item of _data["poslovneJedinice"])
                    this.poslovneJedinice!.push(PoslovnaJedinica.fromJS(item));
            }
            if (Array.isArray(_data["racunMessages"])) {
                this.racunMessages = [] as any;
                for (let item of _data["racunMessages"])
                    this.racunMessages!.push(RacunMessage.fromJS(item));
            }
            if (Array.isArray(_data["invoiceRequests"])) {
                this.invoiceRequests = [] as any;
                for (let item of _data["invoiceRequests"])
                    this.invoiceRequests!.push(InvoiceRequest.fromJS(item));
            }
            if (Array.isArray(_data["delovodniDokumenti"])) {
                this.delovodniDokumenti = [] as any;
                for (let item of _data["delovodniDokumenti"])
                    this.delovodniDokumenti!.push(DelovodniDokument.fromJS(item));
            }
            if (Array.isArray(_data["pojedinacnePdvEvidencije39"])) {
                this.pojedinacnePdvEvidencije39 = [] as any;
                for (let item of _data["pojedinacnePdvEvidencije39"])
                    this.pojedinacnePdvEvidencije39!.push(PojedinacnaPdvEvidencija39.fromJS(item));
            }
            if (Array.isArray(_data["otpremnicePrimalac"])) {
                this.otpremnicePrimalac = [] as any;
                for (let item of _data["otpremnicePrimalac"])
                    this.otpremnicePrimalac!.push(EOtpremnicaBase.fromJS(item));
            }
            if (Array.isArray(_data["fazeVoznje"])) {
                this.fazeVoznje = [] as any;
                for (let item of _data["fazeVoznje"])
                    this.fazeVoznje!.push(FazaVoznje.fromJS(item));
            }
            this.fizickoLice = _data["fizickoLice"] ? FizickoLice.fromJS(_data["fizickoLice"]) : <any>undefined;
            this.pravnoLice = _data["pravnoLice"] ? PravnoLice.fromJS(_data["pravnoLice"]) : <any>undefined;
            this.saldo = _data["saldo"] ? SaldoStranka.fromJS(_data["saldo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Stranka {
        data = typeof data === 'object' ? data : {};
        let result = new Stranka();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["strankaId"] = this.strankaId;
        data["naziv"] = this.naziv;
        data["napomena"] = this.napomena;
        data["tipStranke"] = this.tipStranke;
        data["rokPlacanjaZaUlazne"] = this.rokPlacanjaZaUlazne;
        data["rokPlacanjaZaIzlazne"] = this.rokPlacanjaZaIzlazne;
        data["jeKupac"] = this.jeKupac;
        data["jeDobavljac"] = this.jeDobavljac;
        data["isActive"] = this.isActive;
        data["gln"] = this.gln;
        data["adresaId"] = this.adresaId;
        data["adresa"] = this.adresa ? this.adresa.toJSON() : <any>undefined;
        data["valutaPoslovanjaId"] = this.valutaPoslovanjaId;
        data["valutaPoslovanja"] = this.valutaPoslovanja ? this.valutaPoslovanja.toJSON() : <any>undefined;
        if (Array.isArray(this.cenovnici)) {
            data["cenovnici"] = [];
            for (let item of this.cenovnici)
                data["cenovnici"].push(item.toJSON());
        }
        if (Array.isArray(this.predmetiStavkiSef)) {
            data["predmetiStavkiSef"] = [];
            for (let item of this.predmetiStavkiSef)
                data["predmetiStavkiSef"].push(item.toJSON());
        }
        if (Array.isArray(this.racuni)) {
            data["racuni"] = [];
            for (let item of this.racuni)
                data["racuni"].push(item.toJSON());
        }
        if (Array.isArray(this.informacijaIsporukeStranke)) {
            data["informacijaIsporukeStranke"] = [];
            for (let item of this.informacijaIsporukeStranke)
                data["informacijaIsporukeStranke"].push(item.toJSON());
        }
        if (Array.isArray(this.transakcijeIzvoda)) {
            data["transakcijeIzvoda"] = [];
            for (let item of this.transakcijeIzvoda)
                data["transakcijeIzvoda"].push(item.toJSON());
        }
        if (Array.isArray(this.izvodi)) {
            data["izvodi"] = [];
            for (let item of this.izvodi)
                data["izvodi"].push(item.toJSON());
        }
        if (Array.isArray(this.oznake)) {
            data["oznake"] = [];
            for (let item of this.oznake)
                data["oznake"].push(item.toJSON());
        }
        if (Array.isArray(this.kontakti)) {
            data["kontakti"] = [];
            for (let item of this.kontakti)
                data["kontakti"].push(item.toJSON());
        }
        if (Array.isArray(this.tekuciRacuni)) {
            data["tekuciRacuni"] = [];
            for (let item of this.tekuciRacuni)
                data["tekuciRacuni"].push(item.toJSON());
        }
        if (Array.isArray(this.poslovneJedinice)) {
            data["poslovneJedinice"] = [];
            for (let item of this.poslovneJedinice)
                data["poslovneJedinice"].push(item.toJSON());
        }
        if (Array.isArray(this.racunMessages)) {
            data["racunMessages"] = [];
            for (let item of this.racunMessages)
                data["racunMessages"].push(item.toJSON());
        }
        if (Array.isArray(this.invoiceRequests)) {
            data["invoiceRequests"] = [];
            for (let item of this.invoiceRequests)
                data["invoiceRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.delovodniDokumenti)) {
            data["delovodniDokumenti"] = [];
            for (let item of this.delovodniDokumenti)
                data["delovodniDokumenti"].push(item.toJSON());
        }
        if (Array.isArray(this.pojedinacnePdvEvidencije39)) {
            data["pojedinacnePdvEvidencije39"] = [];
            for (let item of this.pojedinacnePdvEvidencije39)
                data["pojedinacnePdvEvidencije39"].push(item.toJSON());
        }
        if (Array.isArray(this.otpremnicePrimalac)) {
            data["otpremnicePrimalac"] = [];
            for (let item of this.otpremnicePrimalac)
                data["otpremnicePrimalac"].push(item.toJSON());
        }
        if (Array.isArray(this.fazeVoznje)) {
            data["fazeVoznje"] = [];
            for (let item of this.fazeVoznje)
                data["fazeVoznje"].push(item.toJSON());
        }
        data["fizickoLice"] = this.fizickoLice ? this.fizickoLice.toJSON() : <any>undefined;
        data["pravnoLice"] = this.pravnoLice ? this.pravnoLice.toJSON() : <any>undefined;
        data["saldo"] = this.saldo ? this.saldo.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStranka extends IAuditableEntity {
    strankaId?: number;
    naziv?: string | undefined;
    napomena?: string | undefined;
    tipStranke?: TipStranke;
    rokPlacanjaZaUlazne?: number;
    rokPlacanjaZaIzlazne?: number;
    jeKupac?: boolean;
    jeDobavljac?: boolean;
    isActive?: boolean;
    gln?: string | undefined;
    adresaId?: number | undefined;
    adresa?: Adresa | undefined;
    valutaPoslovanjaId?: string | undefined;
    valutaPoslovanja?: Valuta | undefined;
    cenovnici?: CenovnikStranka[] | undefined;
    predmetiStavkiSef?: PredmetStavkeSefMap[] | undefined;
    racuni?: Racun[] | undefined;
    informacijaIsporukeStranke?: InformacijaIsporukeStranka[] | undefined;
    transakcijeIzvoda?: TransakcijaIzvoda[] | undefined;
    izvodi?: Izvod[] | undefined;
    oznake?: OznakaStranke[] | undefined;
    kontakti?: Kontakt[] | undefined;
    tekuciRacuni?: TekuciRacun[] | undefined;
    poslovneJedinice?: PoslovnaJedinica[] | undefined;
    racunMessages?: RacunMessage[] | undefined;
    invoiceRequests?: InvoiceRequest[] | undefined;
    delovodniDokumenti?: DelovodniDokument[] | undefined;
    pojedinacnePdvEvidencije39?: PojedinacnaPdvEvidencija39[] | undefined;
    otpremnicePrimalac?: EOtpremnicaBase[] | undefined;
    fazeVoznje?: FazaVoznje[] | undefined;
    fizickoLice?: FizickoLice | undefined;
    pravnoLice?: PravnoLice | undefined;
    saldo?: SaldoStranka | undefined;
}

export class Adresa extends AuditableEntity implements IAdresa {
    adresaId?: number;
    ulicaIBroj?: string | undefined;
    grad?: string | undefined;
    postanskiBroj?: string | undefined;
    opstina?: string | undefined;
    region?: string | undefined;
    drzavaId?: string;
    drzava?: Drzava | undefined;
    stranka?: Stranka | undefined;
    banka?: Banka | undefined;
    poslovnaJedinica?: PoslovnaJedinica | undefined;
    magacin?: Magacin | undefined;

    constructor(data?: IAdresa) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.adresaId = _data["adresaId"];
            this.ulicaIBroj = _data["ulicaIBroj"];
            this.grad = _data["grad"];
            this.postanskiBroj = _data["postanskiBroj"];
            this.opstina = _data["opstina"];
            this.region = _data["region"];
            this.drzavaId = _data["drzavaId"];
            this.drzava = _data["drzava"] ? Drzava.fromJS(_data["drzava"]) : <any>undefined;
            this.stranka = _data["stranka"] ? Stranka.fromJS(_data["stranka"]) : <any>undefined;
            this.banka = _data["banka"] ? Banka.fromJS(_data["banka"]) : <any>undefined;
            this.poslovnaJedinica = _data["poslovnaJedinica"] ? PoslovnaJedinica.fromJS(_data["poslovnaJedinica"]) : <any>undefined;
            this.magacin = _data["magacin"] ? Magacin.fromJS(_data["magacin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Adresa {
        data = typeof data === 'object' ? data : {};
        let result = new Adresa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adresaId"] = this.adresaId;
        data["ulicaIBroj"] = this.ulicaIBroj;
        data["grad"] = this.grad;
        data["postanskiBroj"] = this.postanskiBroj;
        data["opstina"] = this.opstina;
        data["region"] = this.region;
        data["drzavaId"] = this.drzavaId;
        data["drzava"] = this.drzava ? this.drzava.toJSON() : <any>undefined;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        data["banka"] = this.banka ? this.banka.toJSON() : <any>undefined;
        data["poslovnaJedinica"] = this.poslovnaJedinica ? this.poslovnaJedinica.toJSON() : <any>undefined;
        data["magacin"] = this.magacin ? this.magacin.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAdresa extends IAuditableEntity {
    adresaId?: number;
    ulicaIBroj?: string | undefined;
    grad?: string | undefined;
    postanskiBroj?: string | undefined;
    opstina?: string | undefined;
    region?: string | undefined;
    drzavaId?: string;
    drzava?: Drzava | undefined;
    stranka?: Stranka | undefined;
    banka?: Banka | undefined;
    poslovnaJedinica?: PoslovnaJedinica | undefined;
    magacin?: Magacin | undefined;
}

export class Drzava implements IDrzava {
    drzavaId?: string;
    kodDrzave?: number;
    kodDrzaveNumChar?: string | undefined;
    kodDrzaveAlfaChar3?: string | undefined;
    kodDrzaveAlfaChar2?: string | undefined;
    nazivSrbCir?: string | undefined;
    nazivSrbLat?: string | undefined;
    nazivEng?: string | undefined;
    informacijaIsporukeRacuna?: InformacijaIsporukeRacuna[] | undefined;
    adrese?: Adresa[] | undefined;
    valute?: Valuta[] | undefined;
    informacijaIsporukeStranke?: InformacijaIsporukeStranka[] | undefined;

    constructor(data?: IDrzava) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.drzavaId = _data["drzavaId"];
            this.kodDrzave = _data["kodDrzave"];
            this.kodDrzaveNumChar = _data["kodDrzaveNumChar"];
            this.kodDrzaveAlfaChar3 = _data["kodDrzaveAlfaChar3"];
            this.kodDrzaveAlfaChar2 = _data["kodDrzaveAlfaChar2"];
            this.nazivSrbCir = _data["nazivSrbCir"];
            this.nazivSrbLat = _data["nazivSrbLat"];
            this.nazivEng = _data["nazivEng"];
            if (Array.isArray(_data["informacijaIsporukeRacuna"])) {
                this.informacijaIsporukeRacuna = [] as any;
                for (let item of _data["informacijaIsporukeRacuna"])
                    this.informacijaIsporukeRacuna!.push(InformacijaIsporukeRacuna.fromJS(item));
            }
            if (Array.isArray(_data["adrese"])) {
                this.adrese = [] as any;
                for (let item of _data["adrese"])
                    this.adrese!.push(Adresa.fromJS(item));
            }
            if (Array.isArray(_data["valute"])) {
                this.valute = [] as any;
                for (let item of _data["valute"])
                    this.valute!.push(Valuta.fromJS(item));
            }
            if (Array.isArray(_data["informacijaIsporukeStranke"])) {
                this.informacijaIsporukeStranke = [] as any;
                for (let item of _data["informacijaIsporukeStranke"])
                    this.informacijaIsporukeStranke!.push(InformacijaIsporukeStranka.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Drzava {
        data = typeof data === 'object' ? data : {};
        let result = new Drzava();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["drzavaId"] = this.drzavaId;
        data["kodDrzave"] = this.kodDrzave;
        data["kodDrzaveNumChar"] = this.kodDrzaveNumChar;
        data["kodDrzaveAlfaChar3"] = this.kodDrzaveAlfaChar3;
        data["kodDrzaveAlfaChar2"] = this.kodDrzaveAlfaChar2;
        data["nazivSrbCir"] = this.nazivSrbCir;
        data["nazivSrbLat"] = this.nazivSrbLat;
        data["nazivEng"] = this.nazivEng;
        if (Array.isArray(this.informacijaIsporukeRacuna)) {
            data["informacijaIsporukeRacuna"] = [];
            for (let item of this.informacijaIsporukeRacuna)
                data["informacijaIsporukeRacuna"].push(item.toJSON());
        }
        if (Array.isArray(this.adrese)) {
            data["adrese"] = [];
            for (let item of this.adrese)
                data["adrese"].push(item.toJSON());
        }
        if (Array.isArray(this.valute)) {
            data["valute"] = [];
            for (let item of this.valute)
                data["valute"].push(item.toJSON());
        }
        if (Array.isArray(this.informacijaIsporukeStranke)) {
            data["informacijaIsporukeStranke"] = [];
            for (let item of this.informacijaIsporukeStranke)
                data["informacijaIsporukeStranke"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDrzava {
    drzavaId?: string;
    kodDrzave?: number;
    kodDrzaveNumChar?: string | undefined;
    kodDrzaveAlfaChar3?: string | undefined;
    kodDrzaveAlfaChar2?: string | undefined;
    nazivSrbCir?: string | undefined;
    nazivSrbLat?: string | undefined;
    nazivEng?: string | undefined;
    informacijaIsporukeRacuna?: InformacijaIsporukeRacuna[] | undefined;
    adrese?: Adresa[] | undefined;
    valute?: Valuta[] | undefined;
    informacijaIsporukeStranke?: InformacijaIsporukeStranka[] | undefined;
}

export abstract class InformacijaIsporuke implements IInformacijaIsporuke {
    imeLokacijeMestaIsporuke?: string | undefined;
    gln?: string | undefined;
    ulicaIBroj?: string | undefined;
    grad?: string | undefined;
    postanskiBroj?: string | undefined;
    drzavaId?: string;
    drzava?: Drzava | undefined;

    constructor(data?: IInformacijaIsporuke) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imeLokacijeMestaIsporuke = _data["imeLokacijeMestaIsporuke"];
            this.gln = _data["gln"];
            this.ulicaIBroj = _data["ulicaIBroj"];
            this.grad = _data["grad"];
            this.postanskiBroj = _data["postanskiBroj"];
            this.drzavaId = _data["drzavaId"];
            this.drzava = _data["drzava"] ? Drzava.fromJS(_data["drzava"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InformacijaIsporuke {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'InformacijaIsporuke' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imeLokacijeMestaIsporuke"] = this.imeLokacijeMestaIsporuke;
        data["gln"] = this.gln;
        data["ulicaIBroj"] = this.ulicaIBroj;
        data["grad"] = this.grad;
        data["postanskiBroj"] = this.postanskiBroj;
        data["drzavaId"] = this.drzavaId;
        data["drzava"] = this.drzava ? this.drzava.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInformacijaIsporuke {
    imeLokacijeMestaIsporuke?: string | undefined;
    gln?: string | undefined;
    ulicaIBroj?: string | undefined;
    grad?: string | undefined;
    postanskiBroj?: string | undefined;
    drzavaId?: string;
    drzava?: Drzava | undefined;
}

export class InformacijaIsporukeRacuna extends InformacijaIsporuke implements IInformacijaIsporukeRacuna {
    informacijaIsporukeRacunaId?: number;
    izlaznaFaktura?: IzlaznaFaktura | undefined;
    otpremnica?: Otpremnica | undefined;

    constructor(data?: IInformacijaIsporukeRacuna) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.informacijaIsporukeRacunaId = _data["informacijaIsporukeRacunaId"];
            this.izlaznaFaktura = _data["izlaznaFaktura"] ? IzlaznaFaktura.fromJS(_data["izlaznaFaktura"]) : <any>undefined;
            this.otpremnica = _data["otpremnica"] ? Otpremnica.fromJS(_data["otpremnica"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InformacijaIsporukeRacuna {
        data = typeof data === 'object' ? data : {};
        let result = new InformacijaIsporukeRacuna();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["informacijaIsporukeRacunaId"] = this.informacijaIsporukeRacunaId;
        data["izlaznaFaktura"] = this.izlaznaFaktura ? this.izlaznaFaktura.toJSON() : <any>undefined;
        data["otpremnica"] = this.otpremnica ? this.otpremnica.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IInformacijaIsporukeRacuna extends IInformacijaIsporuke {
    informacijaIsporukeRacunaId?: number;
    izlaznaFaktura?: IzlaznaFaktura | undefined;
    otpremnica?: Otpremnica | undefined;
}

export abstract class Faktura implements IFaktura {
    brojFiskalnogIsecka?: string | undefined;
    vrstaFakture?: VrstaFakture;

    constructor(data?: IFaktura) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brojFiskalnogIsecka = _data["brojFiskalnogIsecka"];
            this.vrstaFakture = _data["vrstaFakture"];
        }
    }

    static fromJS(data: any): Faktura {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Faktura' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brojFiskalnogIsecka"] = this.brojFiskalnogIsecka;
        data["vrstaFakture"] = this.vrstaFakture;
        return data;
    }
}

export interface IFaktura {
    brojFiskalnogIsecka?: string | undefined;
    vrstaFakture?: VrstaFakture;
}

export class IzlaznaFaktura extends Faktura implements IIzlaznaFaktura {
    racunId?: number;
    racun?: Racun | undefined;
    informacijaIsporukeId?: number | undefined;
    informacijaIsporuke?: InformacijaIsporukeRacuna | undefined;

    constructor(data?: IIzlaznaFaktura) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.racunId = _data["racunId"];
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
            this.informacijaIsporukeId = _data["informacijaIsporukeId"];
            this.informacijaIsporuke = _data["informacijaIsporuke"] ? InformacijaIsporukeRacuna.fromJS(_data["informacijaIsporuke"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IzlaznaFaktura {
        data = typeof data === 'object' ? data : {};
        let result = new IzlaznaFaktura();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        data["informacijaIsporukeId"] = this.informacijaIsporukeId;
        data["informacijaIsporuke"] = this.informacijaIsporuke ? this.informacijaIsporuke.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IIzlaznaFaktura extends IFaktura {
    racunId?: number;
    racun?: Racun | undefined;
    informacijaIsporukeId?: number | undefined;
    informacijaIsporuke?: InformacijaIsporukeRacuna | undefined;
}

export class Racun extends AuditableEntity implements IRacun {
    racunId?: number;
    izlazniRacunIdSef?: number | undefined;
    ulazniRacunIdSef?: number | undefined;
    broj?: string | undefined;
    originalanBroj?: string | undefined;
    mestoIzdavanja?: string | undefined;
    mestoPrometa?: string | undefined;
    brojUgovora?: string | undefined;
    brojNarudzbenice?: string | undefined;
    brojTendera?: string | undefined;
    sifraObjekta?: string | undefined;
    imeOsobeOvlasceneZaPotpisivanje?: string | undefined;
    brojOtpremnice?: string | undefined;
    napomena?: string | undefined;
    napomenaOPoreskomOslobadanju?: string | undefined;
    crfId?: string | undefined;
    sefKomentar?: string | undefined;
    datumIzdavanja?: Date;
    datumPrometa?: Date;
    datumValute?: Date;
    datumSlanjaSef?: Date | undefined;
    datumSlanjaEmail?: Date | undefined;
    datumNarudzbenice?: Date | undefined;
    datumOtpremnice?: Date | undefined;
    datumStorniranja?: Date | undefined;
    potrebnaObrada?: boolean;
    mozeNaSef?: boolean;
    sentToCrf?: boolean;
    tip?: TipRacuna;
    vrsta?: VrstaRacuna;
    status?: StatusRacuna;
    statusUplate?: StatusUplateRacuna;
    crfStatus?: CrfStatus;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
    uplaceno?: number;
    uplacenoKonvertovanRsd?: number | undefined;
    podaciUplate?: PodaciUplate | undefined;
    valutaId?: string;
    valuta?: Valuta | undefined;
    tekuciRacunId?: number | undefined;
    tekuciRacun?: TekuciRacun | undefined;
    adresaStranke?: string | undefined;
    strankaId?: number | undefined;
    stranka?: Stranka | undefined;
    memorandum?: Memorandum | undefined;
    memorandumId?: number | undefined;
    podtipDokumenta?: number | undefined;
    prikazRabata?: PrikazRabata;
    paritet?: Paritet;
    praviloZaBrojId?: number | undefined;
    praviloZaBroj?: KonfiguracijaBrojaRacuna | undefined;
    datumObracunaPdv?: DatumObracunaPdv;
    razlogOtkazivanjaStorniranja?: string | undefined;
    stornoBroj?: string | undefined;
    netoTezina?: number | undefined;
    brojPaleta?: number | undefined;
    koleto?: number | undefined;
    brojRamova?: number | undefined;
    brutoTezina?: number | undefined;
    interniBrojZaRutiranje?: string | undefined;
    nosiocJavneNabavke?: string | undefined;
    pdvObavezaZaIzdavaoca?: boolean | undefined;
    datumUgovora?: Date | undefined;
    minimaxId?: number | undefined;
    saldoRootId?: number | undefined;
    saldoRoot?: Racun | undefined;
    saldoRootBackRef?: Racun[] | undefined;
    eOtpremnice?: EOtpremnicaBase[] | undefined;
    eOtpremniceIzPredracuna?: EOtpremnicaBase[] | undefined;
    dokumentOPovecanju?: DokumentOPovecanju | undefined;
    dokumentOSmanjenju?: DokumentOSmanjenju | undefined;
    radniNalog?: RadniNalog | undefined;
    otpremnica?: Otpremnica | undefined;
    izlaznaFaktura?: IzlaznaFaktura | undefined;
    ulaznaFaktura?: UlaznaFaktura | undefined;
    predracun?: Predracun | undefined;
    avansniRacun?: AvansniRacun | undefined;
    podaciUplateDevizni?: PodaciUplateDevizni | undefined;
    ukupanIznos?: RacunUkupanIznos | undefined;
    pdvEvidencijaPojedinacna?: PdvEvidencijaPojedinacna | undefined;
    kalkulacija?: Kalkulacija | undefined;
    stavke?: StavkaRacuna[] | undefined;
    oznake?: OznakaRacuna[] | undefined;
    lagerTransakcije?: LagerTransakcija[] | undefined;
    evidentiraneUplate?: UplataPoRacunu[] | undefined;
    avansneUplate?: AvansnaUplataRacuna[] | undefined;
    povezaniParentRacuni?: PovezanRacun[] | undefined;
    povezaniChildRacuni?: PovezanRacun[] | undefined;
    relevantniDokumenti?: RacunRelevantniDokument[] | undefined;
    kompenzacije?: KompenzacionaObaveza[] | undefined;
    pdvEvidencijePojedinacne?: PdvEvidencijaPojedinacnaPovezanRacun[] | undefined;
    pdvEvidencijePojedinacne39?: PojedinacnaPdvEvidencija39[] | undefined;
    pdvEvidencijePojedinacnePovezani39?: PojedinacnaPdvEvidencija39PovezanRacun[] | undefined;
    racunMessages?: RacunMessage[] | undefined;
    vozila?: RacunVozilo[] | undefined;

    constructor(data?: IRacun) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.racunId = _data["racunId"];
            this.izlazniRacunIdSef = _data["izlazniRacunIdSef"];
            this.ulazniRacunIdSef = _data["ulazniRacunIdSef"];
            this.broj = _data["broj"];
            this.originalanBroj = _data["originalanBroj"];
            this.mestoIzdavanja = _data["mestoIzdavanja"];
            this.mestoPrometa = _data["mestoPrometa"];
            this.brojUgovora = _data["brojUgovora"];
            this.brojNarudzbenice = _data["brojNarudzbenice"];
            this.brojTendera = _data["brojTendera"];
            this.sifraObjekta = _data["sifraObjekta"];
            this.imeOsobeOvlasceneZaPotpisivanje = _data["imeOsobeOvlasceneZaPotpisivanje"];
            this.brojOtpremnice = _data["brojOtpremnice"];
            this.napomena = _data["napomena"];
            this.napomenaOPoreskomOslobadanju = _data["napomenaOPoreskomOslobadanju"];
            this.crfId = _data["crfId"];
            this.sefKomentar = _data["sefKomentar"];
            this.datumIzdavanja = _data["datumIzdavanja"] ? new Date(_data["datumIzdavanja"].toString()) : <any>undefined;
            this.datumPrometa = _data["datumPrometa"] ? new Date(_data["datumPrometa"].toString()) : <any>undefined;
            this.datumValute = _data["datumValute"] ? new Date(_data["datumValute"].toString()) : <any>undefined;
            this.datumSlanjaSef = _data["datumSlanjaSef"] ? new Date(_data["datumSlanjaSef"].toString()) : <any>undefined;
            this.datumSlanjaEmail = _data["datumSlanjaEmail"] ? new Date(_data["datumSlanjaEmail"].toString()) : <any>undefined;
            this.datumNarudzbenice = _data["datumNarudzbenice"] ? new Date(_data["datumNarudzbenice"].toString()) : <any>undefined;
            this.datumOtpremnice = _data["datumOtpremnice"] ? new Date(_data["datumOtpremnice"].toString()) : <any>undefined;
            this.datumStorniranja = _data["datumStorniranja"] ? new Date(_data["datumStorniranja"].toString()) : <any>undefined;
            this.potrebnaObrada = _data["potrebnaObrada"];
            this.mozeNaSef = _data["mozeNaSef"];
            this.sentToCrf = _data["sentToCrf"];
            this.tip = _data["tip"];
            this.vrsta = _data["vrsta"];
            this.status = _data["status"];
            this.statusUplate = _data["statusUplate"];
            this.crfStatus = _data["crfStatus"];
            this.klasifikacijaRacuna = _data["klasifikacijaRacuna"];
            this.pravoNaPdvOdbitak = _data["pravoNaPdvOdbitak"];
            this.uplaceno = _data["uplaceno"];
            this.uplacenoKonvertovanRsd = _data["uplacenoKonvertovanRsd"];
            this.podaciUplate = _data["podaciUplate"] ? PodaciUplate.fromJS(_data["podaciUplate"]) : <any>undefined;
            this.valutaId = _data["valutaId"];
            this.valuta = _data["valuta"] ? Valuta.fromJS(_data["valuta"]) : <any>undefined;
            this.tekuciRacunId = _data["tekuciRacunId"];
            this.tekuciRacun = _data["tekuciRacun"] ? TekuciRacun.fromJS(_data["tekuciRacun"]) : <any>undefined;
            this.adresaStranke = _data["adresaStranke"];
            this.strankaId = _data["strankaId"];
            this.stranka = _data["stranka"] ? Stranka.fromJS(_data["stranka"]) : <any>undefined;
            this.memorandum = _data["memorandum"] ? Memorandum.fromJS(_data["memorandum"]) : <any>undefined;
            this.memorandumId = _data["memorandumId"];
            this.podtipDokumenta = _data["podtipDokumenta"];
            this.prikazRabata = _data["prikazRabata"];
            this.paritet = _data["paritet"];
            this.praviloZaBrojId = _data["praviloZaBrojId"];
            this.praviloZaBroj = _data["praviloZaBroj"] ? KonfiguracijaBrojaRacuna.fromJS(_data["praviloZaBroj"]) : <any>undefined;
            this.datumObracunaPdv = _data["datumObracunaPdv"];
            this.razlogOtkazivanjaStorniranja = _data["razlogOtkazivanjaStorniranja"];
            this.stornoBroj = _data["stornoBroj"];
            this.netoTezina = _data["netoTezina"];
            this.brojPaleta = _data["brojPaleta"];
            this.koleto = _data["koleto"];
            this.brojRamova = _data["brojRamova"];
            this.brutoTezina = _data["brutoTezina"];
            this.interniBrojZaRutiranje = _data["interniBrojZaRutiranje"];
            this.nosiocJavneNabavke = _data["nosiocJavneNabavke"];
            this.pdvObavezaZaIzdavaoca = _data["pdvObavezaZaIzdavaoca"];
            this.datumUgovora = _data["datumUgovora"] ? new Date(_data["datumUgovora"].toString()) : <any>undefined;
            this.minimaxId = _data["minimaxId"];
            this.saldoRootId = _data["saldoRootId"];
            this.saldoRoot = _data["saldoRoot"] ? Racun.fromJS(_data["saldoRoot"]) : <any>undefined;
            if (Array.isArray(_data["saldoRootBackRef"])) {
                this.saldoRootBackRef = [] as any;
                for (let item of _data["saldoRootBackRef"])
                    this.saldoRootBackRef!.push(Racun.fromJS(item));
            }
            if (Array.isArray(_data["eOtpremnice"])) {
                this.eOtpremnice = [] as any;
                for (let item of _data["eOtpremnice"])
                    this.eOtpremnice!.push(EOtpremnicaBase.fromJS(item));
            }
            if (Array.isArray(_data["eOtpremniceIzPredracuna"])) {
                this.eOtpremniceIzPredracuna = [] as any;
                for (let item of _data["eOtpremniceIzPredracuna"])
                    this.eOtpremniceIzPredracuna!.push(EOtpremnicaBase.fromJS(item));
            }
            this.dokumentOPovecanju = _data["dokumentOPovecanju"] ? DokumentOPovecanju.fromJS(_data["dokumentOPovecanju"]) : <any>undefined;
            this.dokumentOSmanjenju = _data["dokumentOSmanjenju"] ? DokumentOSmanjenju.fromJS(_data["dokumentOSmanjenju"]) : <any>undefined;
            this.radniNalog = _data["radniNalog"] ? RadniNalog.fromJS(_data["radniNalog"]) : <any>undefined;
            this.otpremnica = _data["otpremnica"] ? Otpremnica.fromJS(_data["otpremnica"]) : <any>undefined;
            this.izlaznaFaktura = _data["izlaznaFaktura"] ? IzlaznaFaktura.fromJS(_data["izlaznaFaktura"]) : <any>undefined;
            this.ulaznaFaktura = _data["ulaznaFaktura"] ? UlaznaFaktura.fromJS(_data["ulaznaFaktura"]) : <any>undefined;
            this.predracun = _data["predracun"] ? Predracun.fromJS(_data["predracun"]) : <any>undefined;
            this.avansniRacun = _data["avansniRacun"] ? AvansniRacun.fromJS(_data["avansniRacun"]) : <any>undefined;
            this.podaciUplateDevizni = _data["podaciUplateDevizni"] ? PodaciUplateDevizni.fromJS(_data["podaciUplateDevizni"]) : <any>undefined;
            this.ukupanIznos = _data["ukupanIznos"] ? RacunUkupanIznos.fromJS(_data["ukupanIznos"]) : <any>undefined;
            this.pdvEvidencijaPojedinacna = _data["pdvEvidencijaPojedinacna"] ? PdvEvidencijaPojedinacna.fromJS(_data["pdvEvidencijaPojedinacna"]) : <any>undefined;
            this.kalkulacija = _data["kalkulacija"] ? Kalkulacija.fromJS(_data["kalkulacija"]) : <any>undefined;
            if (Array.isArray(_data["stavke"])) {
                this.stavke = [] as any;
                for (let item of _data["stavke"])
                    this.stavke!.push(StavkaRacuna.fromJS(item));
            }
            if (Array.isArray(_data["oznake"])) {
                this.oznake = [] as any;
                for (let item of _data["oznake"])
                    this.oznake!.push(OznakaRacuna.fromJS(item));
            }
            if (Array.isArray(_data["lagerTransakcije"])) {
                this.lagerTransakcije = [] as any;
                for (let item of _data["lagerTransakcije"])
                    this.lagerTransakcije!.push(LagerTransakcija.fromJS(item));
            }
            if (Array.isArray(_data["evidentiraneUplate"])) {
                this.evidentiraneUplate = [] as any;
                for (let item of _data["evidentiraneUplate"])
                    this.evidentiraneUplate!.push(UplataPoRacunu.fromJS(item));
            }
            if (Array.isArray(_data["avansneUplate"])) {
                this.avansneUplate = [] as any;
                for (let item of _data["avansneUplate"])
                    this.avansneUplate!.push(AvansnaUplataRacuna.fromJS(item));
            }
            if (Array.isArray(_data["povezaniParentRacuni"])) {
                this.povezaniParentRacuni = [] as any;
                for (let item of _data["povezaniParentRacuni"])
                    this.povezaniParentRacuni!.push(PovezanRacun.fromJS(item));
            }
            if (Array.isArray(_data["povezaniChildRacuni"])) {
                this.povezaniChildRacuni = [] as any;
                for (let item of _data["povezaniChildRacuni"])
                    this.povezaniChildRacuni!.push(PovezanRacun.fromJS(item));
            }
            if (Array.isArray(_data["relevantniDokumenti"])) {
                this.relevantniDokumenti = [] as any;
                for (let item of _data["relevantniDokumenti"])
                    this.relevantniDokumenti!.push(RacunRelevantniDokument.fromJS(item));
            }
            if (Array.isArray(_data["kompenzacije"])) {
                this.kompenzacije = [] as any;
                for (let item of _data["kompenzacije"])
                    this.kompenzacije!.push(KompenzacionaObaveza.fromJS(item));
            }
            if (Array.isArray(_data["pdvEvidencijePojedinacne"])) {
                this.pdvEvidencijePojedinacne = [] as any;
                for (let item of _data["pdvEvidencijePojedinacne"])
                    this.pdvEvidencijePojedinacne!.push(PdvEvidencijaPojedinacnaPovezanRacun.fromJS(item));
            }
            if (Array.isArray(_data["pdvEvidencijePojedinacne39"])) {
                this.pdvEvidencijePojedinacne39 = [] as any;
                for (let item of _data["pdvEvidencijePojedinacne39"])
                    this.pdvEvidencijePojedinacne39!.push(PojedinacnaPdvEvidencija39.fromJS(item));
            }
            if (Array.isArray(_data["pdvEvidencijePojedinacnePovezani39"])) {
                this.pdvEvidencijePojedinacnePovezani39 = [] as any;
                for (let item of _data["pdvEvidencijePojedinacnePovezani39"])
                    this.pdvEvidencijePojedinacnePovezani39!.push(PojedinacnaPdvEvidencija39PovezanRacun.fromJS(item));
            }
            if (Array.isArray(_data["racunMessages"])) {
                this.racunMessages = [] as any;
                for (let item of _data["racunMessages"])
                    this.racunMessages!.push(RacunMessage.fromJS(item));
            }
            if (Array.isArray(_data["vozila"])) {
                this.vozila = [] as any;
                for (let item of _data["vozila"])
                    this.vozila!.push(RacunVozilo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Racun {
        data = typeof data === 'object' ? data : {};
        let result = new Racun();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        data["izlazniRacunIdSef"] = this.izlazniRacunIdSef;
        data["ulazniRacunIdSef"] = this.ulazniRacunIdSef;
        data["broj"] = this.broj;
        data["originalanBroj"] = this.originalanBroj;
        data["mestoIzdavanja"] = this.mestoIzdavanja;
        data["mestoPrometa"] = this.mestoPrometa;
        data["brojUgovora"] = this.brojUgovora;
        data["brojNarudzbenice"] = this.brojNarudzbenice;
        data["brojTendera"] = this.brojTendera;
        data["sifraObjekta"] = this.sifraObjekta;
        data["imeOsobeOvlasceneZaPotpisivanje"] = this.imeOsobeOvlasceneZaPotpisivanje;
        data["brojOtpremnice"] = this.brojOtpremnice;
        data["napomena"] = this.napomena;
        data["napomenaOPoreskomOslobadanju"] = this.napomenaOPoreskomOslobadanju;
        data["crfId"] = this.crfId;
        data["sefKomentar"] = this.sefKomentar;
        data["datumIzdavanja"] = this.datumIzdavanja ? this.datumIzdavanja.toISOString() : <any>undefined;
        data["datumPrometa"] = this.datumPrometa ? this.datumPrometa.toISOString() : <any>undefined;
        data["datumValute"] = this.datumValute ? this.datumValute.toISOString() : <any>undefined;
        data["datumSlanjaSef"] = this.datumSlanjaSef ? this.datumSlanjaSef.toISOString() : <any>undefined;
        data["datumSlanjaEmail"] = this.datumSlanjaEmail ? this.datumSlanjaEmail.toISOString() : <any>undefined;
        data["datumNarudzbenice"] = this.datumNarudzbenice ? this.datumNarudzbenice.toISOString() : <any>undefined;
        data["datumOtpremnice"] = this.datumOtpremnice ? this.datumOtpremnice.toISOString() : <any>undefined;
        data["datumStorniranja"] = this.datumStorniranja ? this.datumStorniranja.toISOString() : <any>undefined;
        data["potrebnaObrada"] = this.potrebnaObrada;
        data["mozeNaSef"] = this.mozeNaSef;
        data["sentToCrf"] = this.sentToCrf;
        data["tip"] = this.tip;
        data["vrsta"] = this.vrsta;
        data["status"] = this.status;
        data["statusUplate"] = this.statusUplate;
        data["crfStatus"] = this.crfStatus;
        data["klasifikacijaRacuna"] = this.klasifikacijaRacuna;
        data["pravoNaPdvOdbitak"] = this.pravoNaPdvOdbitak;
        data["uplaceno"] = this.uplaceno;
        data["uplacenoKonvertovanRsd"] = this.uplacenoKonvertovanRsd;
        data["podaciUplate"] = this.podaciUplate ? this.podaciUplate.toJSON() : <any>undefined;
        data["valutaId"] = this.valutaId;
        data["valuta"] = this.valuta ? this.valuta.toJSON() : <any>undefined;
        data["tekuciRacunId"] = this.tekuciRacunId;
        data["tekuciRacun"] = this.tekuciRacun ? this.tekuciRacun.toJSON() : <any>undefined;
        data["adresaStranke"] = this.adresaStranke;
        data["strankaId"] = this.strankaId;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        data["memorandum"] = this.memorandum ? this.memorandum.toJSON() : <any>undefined;
        data["memorandumId"] = this.memorandumId;
        data["podtipDokumenta"] = this.podtipDokumenta;
        data["prikazRabata"] = this.prikazRabata;
        data["paritet"] = this.paritet;
        data["praviloZaBrojId"] = this.praviloZaBrojId;
        data["praviloZaBroj"] = this.praviloZaBroj ? this.praviloZaBroj.toJSON() : <any>undefined;
        data["datumObracunaPdv"] = this.datumObracunaPdv;
        data["razlogOtkazivanjaStorniranja"] = this.razlogOtkazivanjaStorniranja;
        data["stornoBroj"] = this.stornoBroj;
        data["netoTezina"] = this.netoTezina;
        data["brojPaleta"] = this.brojPaleta;
        data["koleto"] = this.koleto;
        data["brojRamova"] = this.brojRamova;
        data["brutoTezina"] = this.brutoTezina;
        data["interniBrojZaRutiranje"] = this.interniBrojZaRutiranje;
        data["nosiocJavneNabavke"] = this.nosiocJavneNabavke;
        data["pdvObavezaZaIzdavaoca"] = this.pdvObavezaZaIzdavaoca;
        data["datumUgovora"] = this.datumUgovora ? this.datumUgovora.toISOString() : <any>undefined;
        data["minimaxId"] = this.minimaxId;
        data["saldoRootId"] = this.saldoRootId;
        data["saldoRoot"] = this.saldoRoot ? this.saldoRoot.toJSON() : <any>undefined;
        if (Array.isArray(this.saldoRootBackRef)) {
            data["saldoRootBackRef"] = [];
            for (let item of this.saldoRootBackRef)
                data["saldoRootBackRef"].push(item.toJSON());
        }
        if (Array.isArray(this.eOtpremnice)) {
            data["eOtpremnice"] = [];
            for (let item of this.eOtpremnice)
                data["eOtpremnice"].push(item.toJSON());
        }
        if (Array.isArray(this.eOtpremniceIzPredracuna)) {
            data["eOtpremniceIzPredracuna"] = [];
            for (let item of this.eOtpremniceIzPredracuna)
                data["eOtpremniceIzPredracuna"].push(item.toJSON());
        }
        data["dokumentOPovecanju"] = this.dokumentOPovecanju ? this.dokumentOPovecanju.toJSON() : <any>undefined;
        data["dokumentOSmanjenju"] = this.dokumentOSmanjenju ? this.dokumentOSmanjenju.toJSON() : <any>undefined;
        data["radniNalog"] = this.radniNalog ? this.radniNalog.toJSON() : <any>undefined;
        data["otpremnica"] = this.otpremnica ? this.otpremnica.toJSON() : <any>undefined;
        data["izlaznaFaktura"] = this.izlaznaFaktura ? this.izlaznaFaktura.toJSON() : <any>undefined;
        data["ulaznaFaktura"] = this.ulaznaFaktura ? this.ulaznaFaktura.toJSON() : <any>undefined;
        data["predracun"] = this.predracun ? this.predracun.toJSON() : <any>undefined;
        data["avansniRacun"] = this.avansniRacun ? this.avansniRacun.toJSON() : <any>undefined;
        data["podaciUplateDevizni"] = this.podaciUplateDevizni ? this.podaciUplateDevizni.toJSON() : <any>undefined;
        data["ukupanIznos"] = this.ukupanIznos ? this.ukupanIznos.toJSON() : <any>undefined;
        data["pdvEvidencijaPojedinacna"] = this.pdvEvidencijaPojedinacna ? this.pdvEvidencijaPojedinacna.toJSON() : <any>undefined;
        data["kalkulacija"] = this.kalkulacija ? this.kalkulacija.toJSON() : <any>undefined;
        if (Array.isArray(this.stavke)) {
            data["stavke"] = [];
            for (let item of this.stavke)
                data["stavke"].push(item.toJSON());
        }
        if (Array.isArray(this.oznake)) {
            data["oznake"] = [];
            for (let item of this.oznake)
                data["oznake"].push(item.toJSON());
        }
        if (Array.isArray(this.lagerTransakcije)) {
            data["lagerTransakcije"] = [];
            for (let item of this.lagerTransakcije)
                data["lagerTransakcije"].push(item.toJSON());
        }
        if (Array.isArray(this.evidentiraneUplate)) {
            data["evidentiraneUplate"] = [];
            for (let item of this.evidentiraneUplate)
                data["evidentiraneUplate"].push(item.toJSON());
        }
        if (Array.isArray(this.avansneUplate)) {
            data["avansneUplate"] = [];
            for (let item of this.avansneUplate)
                data["avansneUplate"].push(item.toJSON());
        }
        if (Array.isArray(this.povezaniParentRacuni)) {
            data["povezaniParentRacuni"] = [];
            for (let item of this.povezaniParentRacuni)
                data["povezaniParentRacuni"].push(item.toJSON());
        }
        if (Array.isArray(this.povezaniChildRacuni)) {
            data["povezaniChildRacuni"] = [];
            for (let item of this.povezaniChildRacuni)
                data["povezaniChildRacuni"].push(item.toJSON());
        }
        if (Array.isArray(this.relevantniDokumenti)) {
            data["relevantniDokumenti"] = [];
            for (let item of this.relevantniDokumenti)
                data["relevantniDokumenti"].push(item.toJSON());
        }
        if (Array.isArray(this.kompenzacije)) {
            data["kompenzacije"] = [];
            for (let item of this.kompenzacije)
                data["kompenzacije"].push(item.toJSON());
        }
        if (Array.isArray(this.pdvEvidencijePojedinacne)) {
            data["pdvEvidencijePojedinacne"] = [];
            for (let item of this.pdvEvidencijePojedinacne)
                data["pdvEvidencijePojedinacne"].push(item.toJSON());
        }
        if (Array.isArray(this.pdvEvidencijePojedinacne39)) {
            data["pdvEvidencijePojedinacne39"] = [];
            for (let item of this.pdvEvidencijePojedinacne39)
                data["pdvEvidencijePojedinacne39"].push(item.toJSON());
        }
        if (Array.isArray(this.pdvEvidencijePojedinacnePovezani39)) {
            data["pdvEvidencijePojedinacnePovezani39"] = [];
            for (let item of this.pdvEvidencijePojedinacnePovezani39)
                data["pdvEvidencijePojedinacnePovezani39"].push(item.toJSON());
        }
        if (Array.isArray(this.racunMessages)) {
            data["racunMessages"] = [];
            for (let item of this.racunMessages)
                data["racunMessages"].push(item.toJSON());
        }
        if (Array.isArray(this.vozila)) {
            data["vozila"] = [];
            for (let item of this.vozila)
                data["vozila"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IRacun extends IAuditableEntity {
    racunId?: number;
    izlazniRacunIdSef?: number | undefined;
    ulazniRacunIdSef?: number | undefined;
    broj?: string | undefined;
    originalanBroj?: string | undefined;
    mestoIzdavanja?: string | undefined;
    mestoPrometa?: string | undefined;
    brojUgovora?: string | undefined;
    brojNarudzbenice?: string | undefined;
    brojTendera?: string | undefined;
    sifraObjekta?: string | undefined;
    imeOsobeOvlasceneZaPotpisivanje?: string | undefined;
    brojOtpremnice?: string | undefined;
    napomena?: string | undefined;
    napomenaOPoreskomOslobadanju?: string | undefined;
    crfId?: string | undefined;
    sefKomentar?: string | undefined;
    datumIzdavanja?: Date;
    datumPrometa?: Date;
    datumValute?: Date;
    datumSlanjaSef?: Date | undefined;
    datumSlanjaEmail?: Date | undefined;
    datumNarudzbenice?: Date | undefined;
    datumOtpremnice?: Date | undefined;
    datumStorniranja?: Date | undefined;
    potrebnaObrada?: boolean;
    mozeNaSef?: boolean;
    sentToCrf?: boolean;
    tip?: TipRacuna;
    vrsta?: VrstaRacuna;
    status?: StatusRacuna;
    statusUplate?: StatusUplateRacuna;
    crfStatus?: CrfStatus;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
    uplaceno?: number;
    uplacenoKonvertovanRsd?: number | undefined;
    podaciUplate?: PodaciUplate | undefined;
    valutaId?: string;
    valuta?: Valuta | undefined;
    tekuciRacunId?: number | undefined;
    tekuciRacun?: TekuciRacun | undefined;
    adresaStranke?: string | undefined;
    strankaId?: number | undefined;
    stranka?: Stranka | undefined;
    memorandum?: Memorandum | undefined;
    memorandumId?: number | undefined;
    podtipDokumenta?: number | undefined;
    prikazRabata?: PrikazRabata;
    paritet?: Paritet;
    praviloZaBrojId?: number | undefined;
    praviloZaBroj?: KonfiguracijaBrojaRacuna | undefined;
    datumObracunaPdv?: DatumObracunaPdv;
    razlogOtkazivanjaStorniranja?: string | undefined;
    stornoBroj?: string | undefined;
    netoTezina?: number | undefined;
    brojPaleta?: number | undefined;
    koleto?: number | undefined;
    brojRamova?: number | undefined;
    brutoTezina?: number | undefined;
    interniBrojZaRutiranje?: string | undefined;
    nosiocJavneNabavke?: string | undefined;
    pdvObavezaZaIzdavaoca?: boolean | undefined;
    datumUgovora?: Date | undefined;
    minimaxId?: number | undefined;
    saldoRootId?: number | undefined;
    saldoRoot?: Racun | undefined;
    saldoRootBackRef?: Racun[] | undefined;
    eOtpremnice?: EOtpremnicaBase[] | undefined;
    eOtpremniceIzPredracuna?: EOtpremnicaBase[] | undefined;
    dokumentOPovecanju?: DokumentOPovecanju | undefined;
    dokumentOSmanjenju?: DokumentOSmanjenju | undefined;
    radniNalog?: RadniNalog | undefined;
    otpremnica?: Otpremnica | undefined;
    izlaznaFaktura?: IzlaznaFaktura | undefined;
    ulaznaFaktura?: UlaznaFaktura | undefined;
    predracun?: Predracun | undefined;
    avansniRacun?: AvansniRacun | undefined;
    podaciUplateDevizni?: PodaciUplateDevizni | undefined;
    ukupanIznos?: RacunUkupanIznos | undefined;
    pdvEvidencijaPojedinacna?: PdvEvidencijaPojedinacna | undefined;
    kalkulacija?: Kalkulacija | undefined;
    stavke?: StavkaRacuna[] | undefined;
    oznake?: OznakaRacuna[] | undefined;
    lagerTransakcije?: LagerTransakcija[] | undefined;
    evidentiraneUplate?: UplataPoRacunu[] | undefined;
    avansneUplate?: AvansnaUplataRacuna[] | undefined;
    povezaniParentRacuni?: PovezanRacun[] | undefined;
    povezaniChildRacuni?: PovezanRacun[] | undefined;
    relevantniDokumenti?: RacunRelevantniDokument[] | undefined;
    kompenzacije?: KompenzacionaObaveza[] | undefined;
    pdvEvidencijePojedinacne?: PdvEvidencijaPojedinacnaPovezanRacun[] | undefined;
    pdvEvidencijePojedinacne39?: PojedinacnaPdvEvidencija39[] | undefined;
    pdvEvidencijePojedinacnePovezani39?: PojedinacnaPdvEvidencija39PovezanRacun[] | undefined;
    racunMessages?: RacunMessage[] | undefined;
    vozila?: RacunVozilo[] | undefined;
}

export enum CrfStatus {
    EMPTY = 0,
    AKTIVAN = 1,
    INVALID = 2,
    OTKAZAN = 3,
    DELIMICNO_SETTLED = 4,
    SETTLED = 5,
    DODELJEN = 6,
    PROFAKTURA = 7,
    GRESKA = 8,
}

export abstract class ValueObject implements IValueObject {

    constructor(data?: IValueObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ValueObject {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ValueObject' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IValueObject {
}

export class PodaciUplate extends ValueObject implements IPodaciUplate {
    sifraPlacanja?: string | undefined;
    svrhaPlacanja?: string | undefined;
    model?: string | undefined;
    pozivNaBroj?: string | undefined;
    instrukcijaPlacanja?: string | undefined;

    constructor(data?: IPodaciUplate) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sifraPlacanja = _data["sifraPlacanja"];
            this.svrhaPlacanja = _data["svrhaPlacanja"];
            this.model = _data["model"];
            this.pozivNaBroj = _data["pozivNaBroj"];
            this.instrukcijaPlacanja = _data["instrukcijaPlacanja"];
        }
    }

    static fromJS(data: any): PodaciUplate {
        data = typeof data === 'object' ? data : {};
        let result = new PodaciUplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifraPlacanja"] = this.sifraPlacanja;
        data["svrhaPlacanja"] = this.svrhaPlacanja;
        data["model"] = this.model;
        data["pozivNaBroj"] = this.pozivNaBroj;
        data["instrukcijaPlacanja"] = this.instrukcijaPlacanja;
        super.toJSON(data);
        return data;
    }
}

export interface IPodaciUplate extends IValueObject {
    sifraPlacanja?: string | undefined;
    svrhaPlacanja?: string | undefined;
    model?: string | undefined;
    pozivNaBroj?: string | undefined;
    instrukcijaPlacanja?: string | undefined;
}

export class Valuta implements IValuta {
    valutaId?: string;
    kodValute?: number;
    kodValuteNumChar?: string | undefined;
    kodValuteAlfaChar?: string | undefined;
    unit?: number;
    convertable?: number | undefined;
    nazivValuteCir?: string | undefined;
    nazivValuteLat?: string | undefined;
    nazivValuteEng?: string | undefined;
    indicator?: number | undefined;
    drzavaId?: string | undefined;
    drzava?: Drzava | undefined;
    mojaFirmaKonfiguracije?: KonfiguracijaMojeFirme[] | undefined;
    racuni?: Racun[] | undefined;
    memorandumi?: Memorandum[] | undefined;
    predmetiStavki?: PredmetStavke[] | undefined;

    constructor(data?: IValuta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valutaId = _data["valutaId"];
            this.kodValute = _data["kodValute"];
            this.kodValuteNumChar = _data["kodValuteNumChar"];
            this.kodValuteAlfaChar = _data["kodValuteAlfaChar"];
            this.unit = _data["unit"];
            this.convertable = _data["convertable"];
            this.nazivValuteCir = _data["nazivValuteCir"];
            this.nazivValuteLat = _data["nazivValuteLat"];
            this.nazivValuteEng = _data["nazivValuteEng"];
            this.indicator = _data["indicator"];
            this.drzavaId = _data["drzavaId"];
            this.drzava = _data["drzava"] ? Drzava.fromJS(_data["drzava"]) : <any>undefined;
            if (Array.isArray(_data["mojaFirmaKonfiguracije"])) {
                this.mojaFirmaKonfiguracije = [] as any;
                for (let item of _data["mojaFirmaKonfiguracije"])
                    this.mojaFirmaKonfiguracije!.push(KonfiguracijaMojeFirme.fromJS(item));
            }
            if (Array.isArray(_data["racuni"])) {
                this.racuni = [] as any;
                for (let item of _data["racuni"])
                    this.racuni!.push(Racun.fromJS(item));
            }
            if (Array.isArray(_data["memorandumi"])) {
                this.memorandumi = [] as any;
                for (let item of _data["memorandumi"])
                    this.memorandumi!.push(Memorandum.fromJS(item));
            }
            if (Array.isArray(_data["predmetiStavki"])) {
                this.predmetiStavki = [] as any;
                for (let item of _data["predmetiStavki"])
                    this.predmetiStavki!.push(PredmetStavke.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Valuta {
        data = typeof data === 'object' ? data : {};
        let result = new Valuta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valutaId"] = this.valutaId;
        data["kodValute"] = this.kodValute;
        data["kodValuteNumChar"] = this.kodValuteNumChar;
        data["kodValuteAlfaChar"] = this.kodValuteAlfaChar;
        data["unit"] = this.unit;
        data["convertable"] = this.convertable;
        data["nazivValuteCir"] = this.nazivValuteCir;
        data["nazivValuteLat"] = this.nazivValuteLat;
        data["nazivValuteEng"] = this.nazivValuteEng;
        data["indicator"] = this.indicator;
        data["drzavaId"] = this.drzavaId;
        data["drzava"] = this.drzava ? this.drzava.toJSON() : <any>undefined;
        if (Array.isArray(this.mojaFirmaKonfiguracije)) {
            data["mojaFirmaKonfiguracije"] = [];
            for (let item of this.mojaFirmaKonfiguracije)
                data["mojaFirmaKonfiguracije"].push(item.toJSON());
        }
        if (Array.isArray(this.racuni)) {
            data["racuni"] = [];
            for (let item of this.racuni)
                data["racuni"].push(item.toJSON());
        }
        if (Array.isArray(this.memorandumi)) {
            data["memorandumi"] = [];
            for (let item of this.memorandumi)
                data["memorandumi"].push(item.toJSON());
        }
        if (Array.isArray(this.predmetiStavki)) {
            data["predmetiStavki"] = [];
            for (let item of this.predmetiStavki)
                data["predmetiStavki"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValuta {
    valutaId?: string;
    kodValute?: number;
    kodValuteNumChar?: string | undefined;
    kodValuteAlfaChar?: string | undefined;
    unit?: number;
    convertable?: number | undefined;
    nazivValuteCir?: string | undefined;
    nazivValuteLat?: string | undefined;
    nazivValuteEng?: string | undefined;
    indicator?: number | undefined;
    drzavaId?: string | undefined;
    drzava?: Drzava | undefined;
    mojaFirmaKonfiguracije?: KonfiguracijaMojeFirme[] | undefined;
    racuni?: Racun[] | undefined;
    memorandumi?: Memorandum[] | undefined;
    predmetiStavki?: PredmetStavke[] | undefined;
}

export class KonfiguracijaMojeFirme implements IKonfiguracijaMojeFirme {
    konfiguracijaMojeFirmeId?: number;
    logoNaziv?: string | undefined;
    upisaniKapital?: number;
    upisaniKapitalValutaId?: string;
    upisaniKapitalValuta?: Valuta | undefined;
    aprBD?: string | undefined;
    pePDV?: string | undefined;
    stopaPDV?: number;
    oznakaPdvKategorije?: OznakaPdvKategorije | undefined;
    razlogPdvIzuzecaId?: number | undefined;
    razlogPdvIzuzeca?: RazlogPdvIzuzeca | undefined;
    websiteUrl?: string | undefined;
    email?: string | undefined;
    vlasnici?: string | undefined;
    zastupnici?: string | undefined;
    imeOsobeOvlasceneZaPotpisivanje?: string | undefined;
    gln?: string | undefined;
    displayPlacanjeStarihRacuna?: boolean;
    pracenjeLageraZaEOtpremnice?: boolean;
    mojaFirmaId?: number;
    mojaFirma?: PravnoLice | undefined;

    constructor(data?: IKonfiguracijaMojeFirme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.konfiguracijaMojeFirmeId = _data["konfiguracijaMojeFirmeId"];
            this.logoNaziv = _data["logoNaziv"];
            this.upisaniKapital = _data["upisaniKapital"];
            this.upisaniKapitalValutaId = _data["upisaniKapitalValutaId"];
            this.upisaniKapitalValuta = _data["upisaniKapitalValuta"] ? Valuta.fromJS(_data["upisaniKapitalValuta"]) : <any>undefined;
            this.aprBD = _data["aprBD"];
            this.pePDV = _data["pePDV"];
            this.stopaPDV = _data["stopaPDV"];
            this.oznakaPdvKategorije = _data["oznakaPdvKategorije"];
            this.razlogPdvIzuzecaId = _data["razlogPdvIzuzecaId"];
            this.razlogPdvIzuzeca = _data["razlogPdvIzuzeca"] ? RazlogPdvIzuzeca.fromJS(_data["razlogPdvIzuzeca"]) : <any>undefined;
            this.websiteUrl = _data["websiteUrl"];
            this.email = _data["email"];
            this.vlasnici = _data["vlasnici"];
            this.zastupnici = _data["zastupnici"];
            this.imeOsobeOvlasceneZaPotpisivanje = _data["imeOsobeOvlasceneZaPotpisivanje"];
            this.gln = _data["gln"];
            this.displayPlacanjeStarihRacuna = _data["displayPlacanjeStarihRacuna"];
            this.pracenjeLageraZaEOtpremnice = _data["pracenjeLageraZaEOtpremnice"];
            this.mojaFirmaId = _data["mojaFirmaId"];
            this.mojaFirma = _data["mojaFirma"] ? PravnoLice.fromJS(_data["mojaFirma"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KonfiguracijaMojeFirme {
        data = typeof data === 'object' ? data : {};
        let result = new KonfiguracijaMojeFirme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["konfiguracijaMojeFirmeId"] = this.konfiguracijaMojeFirmeId;
        data["logoNaziv"] = this.logoNaziv;
        data["upisaniKapital"] = this.upisaniKapital;
        data["upisaniKapitalValutaId"] = this.upisaniKapitalValutaId;
        data["upisaniKapitalValuta"] = this.upisaniKapitalValuta ? this.upisaniKapitalValuta.toJSON() : <any>undefined;
        data["aprBD"] = this.aprBD;
        data["pePDV"] = this.pePDV;
        data["stopaPDV"] = this.stopaPDV;
        data["oznakaPdvKategorije"] = this.oznakaPdvKategorije;
        data["razlogPdvIzuzecaId"] = this.razlogPdvIzuzecaId;
        data["razlogPdvIzuzeca"] = this.razlogPdvIzuzeca ? this.razlogPdvIzuzeca.toJSON() : <any>undefined;
        data["websiteUrl"] = this.websiteUrl;
        data["email"] = this.email;
        data["vlasnici"] = this.vlasnici;
        data["zastupnici"] = this.zastupnici;
        data["imeOsobeOvlasceneZaPotpisivanje"] = this.imeOsobeOvlasceneZaPotpisivanje;
        data["gln"] = this.gln;
        data["displayPlacanjeStarihRacuna"] = this.displayPlacanjeStarihRacuna;
        data["pracenjeLageraZaEOtpremnice"] = this.pracenjeLageraZaEOtpremnice;
        data["mojaFirmaId"] = this.mojaFirmaId;
        data["mojaFirma"] = this.mojaFirma ? this.mojaFirma.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKonfiguracijaMojeFirme {
    konfiguracijaMojeFirmeId?: number;
    logoNaziv?: string | undefined;
    upisaniKapital?: number;
    upisaniKapitalValutaId?: string;
    upisaniKapitalValuta?: Valuta | undefined;
    aprBD?: string | undefined;
    pePDV?: string | undefined;
    stopaPDV?: number;
    oznakaPdvKategorije?: OznakaPdvKategorije | undefined;
    razlogPdvIzuzecaId?: number | undefined;
    razlogPdvIzuzeca?: RazlogPdvIzuzeca | undefined;
    websiteUrl?: string | undefined;
    email?: string | undefined;
    vlasnici?: string | undefined;
    zastupnici?: string | undefined;
    imeOsobeOvlasceneZaPotpisivanje?: string | undefined;
    gln?: string | undefined;
    displayPlacanjeStarihRacuna?: boolean;
    pracenjeLageraZaEOtpremnice?: boolean;
    mojaFirmaId?: number;
    mojaFirma?: PravnoLice | undefined;
}

export class RazlogPdvIzuzeca implements IRazlogPdvIzuzeca {
    razlogPdvIzuzecaId?: number;
    key?: string | undefined;
    law?: string | undefined;
    article?: string | undefined;
    paragraph?: string | undefined;
    point?: string | undefined;
    subpoint?: string | undefined;
    text?: string | undefined;
    freeFromNote?: string | undefined;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    category?: string | undefined;
    predmetStavke?: PredmetStavke | undefined;
    konfiguracijaMojeFirme?: KonfiguracijaMojeFirme | undefined;
    racuni?: PoreskaKategorijaStavkeRacuna[] | undefined;

    constructor(data?: IRazlogPdvIzuzeca) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.razlogPdvIzuzecaId = _data["razlogPdvIzuzecaId"];
            this.key = _data["key"];
            this.law = _data["law"];
            this.article = _data["article"];
            this.paragraph = _data["paragraph"];
            this.point = _data["point"];
            this.subpoint = _data["subpoint"];
            this.text = _data["text"];
            this.freeFromNote = _data["freeFromNote"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.category = _data["category"];
            this.predmetStavke = _data["predmetStavke"] ? PredmetStavke.fromJS(_data["predmetStavke"]) : <any>undefined;
            this.konfiguracijaMojeFirme = _data["konfiguracijaMojeFirme"] ? KonfiguracijaMojeFirme.fromJS(_data["konfiguracijaMojeFirme"]) : <any>undefined;
            if (Array.isArray(_data["racuni"])) {
                this.racuni = [] as any;
                for (let item of _data["racuni"])
                    this.racuni!.push(PoreskaKategorijaStavkeRacuna.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RazlogPdvIzuzeca {
        data = typeof data === 'object' ? data : {};
        let result = new RazlogPdvIzuzeca();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["razlogPdvIzuzecaId"] = this.razlogPdvIzuzecaId;
        data["key"] = this.key;
        data["law"] = this.law;
        data["article"] = this.article;
        data["paragraph"] = this.paragraph;
        data["point"] = this.point;
        data["subpoint"] = this.subpoint;
        data["text"] = this.text;
        data["freeFromNote"] = this.freeFromNote;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["category"] = this.category;
        data["predmetStavke"] = this.predmetStavke ? this.predmetStavke.toJSON() : <any>undefined;
        data["konfiguracijaMojeFirme"] = this.konfiguracijaMojeFirme ? this.konfiguracijaMojeFirme.toJSON() : <any>undefined;
        if (Array.isArray(this.racuni)) {
            data["racuni"] = [];
            for (let item of this.racuni)
                data["racuni"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRazlogPdvIzuzeca {
    razlogPdvIzuzecaId?: number;
    key?: string | undefined;
    law?: string | undefined;
    article?: string | undefined;
    paragraph?: string | undefined;
    point?: string | undefined;
    subpoint?: string | undefined;
    text?: string | undefined;
    freeFromNote?: string | undefined;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    category?: string | undefined;
    predmetStavke?: PredmetStavke | undefined;
    konfiguracijaMojeFirme?: KonfiguracijaMojeFirme | undefined;
    racuni?: PoreskaKategorijaStavkeRacuna[] | undefined;
}

export class PredmetStavke extends AuditableEntity implements IPredmetStavke {
    predmetStavkeId?: number;
    idek?: string | undefined;
    naziv?: string | undefined;
    sifra?: string | undefined;
    tipPredmeta?: TipPredmeta;
    tipArtikla?: TipArtikla;
    stopaPDV?: number;
    label?: string | undefined;
    externalId?: number | undefined;
    oznakaPdvKategorije?: OznakaPdvKategorije | undefined;
    razlogPdvIzuzecaId?: number | undefined;
    razlogPdvIzuzeca?: RazlogPdvIzuzeca | undefined;
    jedinicaMereId?: number;
    jedinicaMere?: JedinicaMere | undefined;
    cenovnici?: CenovnikStavka[] | undefined;
    oznake?: OznakaPredmetaStavke[] | undefined;
    wcKategorije?: RobaWcKategorija[] | undefined;
    strankeSef?: PredmetStavkeSefMap[] | undefined;
    stavkeRacuna?: StavkaRacuna[] | undefined;
    invoiceItems?: InvoiceItem[] | undefined;
    stavkeKalkulacije?: KalkulacijaStavka[] | undefined;
    lageri?: Lager[] | undefined;
    materijali?: Sastavnica[] | undefined;
    proizvodi?: Sastavnica[] | undefined;
    stavkeOtpremnice?: StavkaOtpremnice[] | undefined;
    usluga?: Usluga | undefined;
    roba?: Roba | undefined;
    vozilo?: Vozilo | undefined;
    atributi?: RobaAtribut[] | undefined;
    varijacije?: RobaVarijacija[] | undefined;
    valutaId?: string | undefined;
    valuta?: Valuta | undefined;
    slikeFileNames?: string[] | undefined;
    nabavnaCena?: number;
    prodajnaCenaBezPdv?: number;
    prodajnaCenaSaPdv?: number;

    constructor(data?: IPredmetStavke) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.idek = _data["idek"];
            this.naziv = _data["naziv"];
            this.sifra = _data["sifra"];
            this.tipPredmeta = _data["tipPredmeta"];
            this.tipArtikla = _data["tipArtikla"];
            this.stopaPDV = _data["stopaPDV"];
            this.label = _data["label"];
            this.externalId = _data["externalId"];
            this.oznakaPdvKategorije = _data["oznakaPdvKategorije"];
            this.razlogPdvIzuzecaId = _data["razlogPdvIzuzecaId"];
            this.razlogPdvIzuzeca = _data["razlogPdvIzuzeca"] ? RazlogPdvIzuzeca.fromJS(_data["razlogPdvIzuzeca"]) : <any>undefined;
            this.jedinicaMereId = _data["jedinicaMereId"];
            this.jedinicaMere = _data["jedinicaMere"] ? JedinicaMere.fromJS(_data["jedinicaMere"]) : <any>undefined;
            if (Array.isArray(_data["cenovnici"])) {
                this.cenovnici = [] as any;
                for (let item of _data["cenovnici"])
                    this.cenovnici!.push(CenovnikStavka.fromJS(item));
            }
            if (Array.isArray(_data["oznake"])) {
                this.oznake = [] as any;
                for (let item of _data["oznake"])
                    this.oznake!.push(OznakaPredmetaStavke.fromJS(item));
            }
            if (Array.isArray(_data["wcKategorije"])) {
                this.wcKategorije = [] as any;
                for (let item of _data["wcKategorije"])
                    this.wcKategorije!.push(RobaWcKategorija.fromJS(item));
            }
            if (Array.isArray(_data["strankeSef"])) {
                this.strankeSef = [] as any;
                for (let item of _data["strankeSef"])
                    this.strankeSef!.push(PredmetStavkeSefMap.fromJS(item));
            }
            if (Array.isArray(_data["stavkeRacuna"])) {
                this.stavkeRacuna = [] as any;
                for (let item of _data["stavkeRacuna"])
                    this.stavkeRacuna!.push(StavkaRacuna.fromJS(item));
            }
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(InvoiceItem.fromJS(item));
            }
            if (Array.isArray(_data["stavkeKalkulacije"])) {
                this.stavkeKalkulacije = [] as any;
                for (let item of _data["stavkeKalkulacije"])
                    this.stavkeKalkulacije!.push(KalkulacijaStavka.fromJS(item));
            }
            if (Array.isArray(_data["lageri"])) {
                this.lageri = [] as any;
                for (let item of _data["lageri"])
                    this.lageri!.push(Lager.fromJS(item));
            }
            if (Array.isArray(_data["materijali"])) {
                this.materijali = [] as any;
                for (let item of _data["materijali"])
                    this.materijali!.push(Sastavnica.fromJS(item));
            }
            if (Array.isArray(_data["proizvodi"])) {
                this.proizvodi = [] as any;
                for (let item of _data["proizvodi"])
                    this.proizvodi!.push(Sastavnica.fromJS(item));
            }
            if (Array.isArray(_data["stavkeOtpremnice"])) {
                this.stavkeOtpremnice = [] as any;
                for (let item of _data["stavkeOtpremnice"])
                    this.stavkeOtpremnice!.push(StavkaOtpremnice.fromJS(item));
            }
            this.usluga = _data["usluga"] ? Usluga.fromJS(_data["usluga"]) : <any>undefined;
            this.roba = _data["roba"] ? Roba.fromJS(_data["roba"]) : <any>undefined;
            this.vozilo = _data["vozilo"] ? Vozilo.fromJS(_data["vozilo"]) : <any>undefined;
            if (Array.isArray(_data["atributi"])) {
                this.atributi = [] as any;
                for (let item of _data["atributi"])
                    this.atributi!.push(RobaAtribut.fromJS(item));
            }
            if (Array.isArray(_data["varijacije"])) {
                this.varijacije = [] as any;
                for (let item of _data["varijacije"])
                    this.varijacije!.push(RobaVarijacija.fromJS(item));
            }
            this.valutaId = _data["valutaId"];
            this.valuta = _data["valuta"] ? Valuta.fromJS(_data["valuta"]) : <any>undefined;
            if (Array.isArray(_data["slikeFileNames"])) {
                this.slikeFileNames = [] as any;
                for (let item of _data["slikeFileNames"])
                    this.slikeFileNames!.push(item);
            }
            this.nabavnaCena = _data["nabavnaCena"];
            this.prodajnaCenaBezPdv = _data["prodajnaCenaBezPdv"];
            this.prodajnaCenaSaPdv = _data["prodajnaCenaSaPdv"];
        }
    }

    static fromJS(data: any): PredmetStavke {
        data = typeof data === 'object' ? data : {};
        let result = new PredmetStavke();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["idek"] = this.idek;
        data["naziv"] = this.naziv;
        data["sifra"] = this.sifra;
        data["tipPredmeta"] = this.tipPredmeta;
        data["tipArtikla"] = this.tipArtikla;
        data["stopaPDV"] = this.stopaPDV;
        data["label"] = this.label;
        data["externalId"] = this.externalId;
        data["oznakaPdvKategorije"] = this.oznakaPdvKategorije;
        data["razlogPdvIzuzecaId"] = this.razlogPdvIzuzecaId;
        data["razlogPdvIzuzeca"] = this.razlogPdvIzuzeca ? this.razlogPdvIzuzeca.toJSON() : <any>undefined;
        data["jedinicaMereId"] = this.jedinicaMereId;
        data["jedinicaMere"] = this.jedinicaMere ? this.jedinicaMere.toJSON() : <any>undefined;
        if (Array.isArray(this.cenovnici)) {
            data["cenovnici"] = [];
            for (let item of this.cenovnici)
                data["cenovnici"].push(item.toJSON());
        }
        if (Array.isArray(this.oznake)) {
            data["oznake"] = [];
            for (let item of this.oznake)
                data["oznake"].push(item.toJSON());
        }
        if (Array.isArray(this.wcKategorije)) {
            data["wcKategorije"] = [];
            for (let item of this.wcKategorije)
                data["wcKategorije"].push(item.toJSON());
        }
        if (Array.isArray(this.strankeSef)) {
            data["strankeSef"] = [];
            for (let item of this.strankeSef)
                data["strankeSef"].push(item.toJSON());
        }
        if (Array.isArray(this.stavkeRacuna)) {
            data["stavkeRacuna"] = [];
            for (let item of this.stavkeRacuna)
                data["stavkeRacuna"].push(item.toJSON());
        }
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item.toJSON());
        }
        if (Array.isArray(this.stavkeKalkulacije)) {
            data["stavkeKalkulacije"] = [];
            for (let item of this.stavkeKalkulacije)
                data["stavkeKalkulacije"].push(item.toJSON());
        }
        if (Array.isArray(this.lageri)) {
            data["lageri"] = [];
            for (let item of this.lageri)
                data["lageri"].push(item.toJSON());
        }
        if (Array.isArray(this.materijali)) {
            data["materijali"] = [];
            for (let item of this.materijali)
                data["materijali"].push(item.toJSON());
        }
        if (Array.isArray(this.proizvodi)) {
            data["proizvodi"] = [];
            for (let item of this.proizvodi)
                data["proizvodi"].push(item.toJSON());
        }
        if (Array.isArray(this.stavkeOtpremnice)) {
            data["stavkeOtpremnice"] = [];
            for (let item of this.stavkeOtpremnice)
                data["stavkeOtpremnice"].push(item.toJSON());
        }
        data["usluga"] = this.usluga ? this.usluga.toJSON() : <any>undefined;
        data["roba"] = this.roba ? this.roba.toJSON() : <any>undefined;
        data["vozilo"] = this.vozilo ? this.vozilo.toJSON() : <any>undefined;
        if (Array.isArray(this.atributi)) {
            data["atributi"] = [];
            for (let item of this.atributi)
                data["atributi"].push(item.toJSON());
        }
        if (Array.isArray(this.varijacije)) {
            data["varijacije"] = [];
            for (let item of this.varijacije)
                data["varijacije"].push(item.toJSON());
        }
        data["valutaId"] = this.valutaId;
        data["valuta"] = this.valuta ? this.valuta.toJSON() : <any>undefined;
        if (Array.isArray(this.slikeFileNames)) {
            data["slikeFileNames"] = [];
            for (let item of this.slikeFileNames)
                data["slikeFileNames"].push(item);
        }
        data["nabavnaCena"] = this.nabavnaCena;
        data["prodajnaCenaBezPdv"] = this.prodajnaCenaBezPdv;
        data["prodajnaCenaSaPdv"] = this.prodajnaCenaSaPdv;
        super.toJSON(data);
        return data;
    }
}

export interface IPredmetStavke extends IAuditableEntity {
    predmetStavkeId?: number;
    idek?: string | undefined;
    naziv?: string | undefined;
    sifra?: string | undefined;
    tipPredmeta?: TipPredmeta;
    tipArtikla?: TipArtikla;
    stopaPDV?: number;
    label?: string | undefined;
    externalId?: number | undefined;
    oznakaPdvKategorije?: OznakaPdvKategorije | undefined;
    razlogPdvIzuzecaId?: number | undefined;
    razlogPdvIzuzeca?: RazlogPdvIzuzeca | undefined;
    jedinicaMereId?: number;
    jedinicaMere?: JedinicaMere | undefined;
    cenovnici?: CenovnikStavka[] | undefined;
    oznake?: OznakaPredmetaStavke[] | undefined;
    wcKategorije?: RobaWcKategorija[] | undefined;
    strankeSef?: PredmetStavkeSefMap[] | undefined;
    stavkeRacuna?: StavkaRacuna[] | undefined;
    invoiceItems?: InvoiceItem[] | undefined;
    stavkeKalkulacije?: KalkulacijaStavka[] | undefined;
    lageri?: Lager[] | undefined;
    materijali?: Sastavnica[] | undefined;
    proizvodi?: Sastavnica[] | undefined;
    stavkeOtpremnice?: StavkaOtpremnice[] | undefined;
    usluga?: Usluga | undefined;
    roba?: Roba | undefined;
    vozilo?: Vozilo | undefined;
    atributi?: RobaAtribut[] | undefined;
    varijacije?: RobaVarijacija[] | undefined;
    valutaId?: string | undefined;
    valuta?: Valuta | undefined;
    slikeFileNames?: string[] | undefined;
    nabavnaCena?: number;
    prodajnaCenaBezPdv?: number;
    prodajnaCenaSaPdv?: number;
}

export class JedinicaMere implements IJedinicaMere {
    jedinicaMereId?: number;
    naziv?: string | undefined;
    skracenica?: string | undefined;
    kod?: string | undefined;
    simbol?: string | undefined;
    nazivEng?: string | undefined;
    nazivSrbCir?: string | undefined;
    isOnShortList?: boolean;
    predmetiStavki?: PredmetStavke[] | undefined;
    stavkeRacuna?: StavkaRacuna[] | undefined;
    otpremniceTezina?: EOtpremnica[] | undefined;
    otpremniceZapremina?: EOtpremnica[] | undefined;
    stavkeOtpremnice?: StavkaOtpremnice[] | undefined;

    constructor(data?: IJedinicaMere) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jedinicaMereId = _data["jedinicaMereId"];
            this.naziv = _data["naziv"];
            this.skracenica = _data["skracenica"];
            this.kod = _data["kod"];
            this.simbol = _data["simbol"];
            this.nazivEng = _data["nazivEng"];
            this.nazivSrbCir = _data["nazivSrbCir"];
            this.isOnShortList = _data["isOnShortList"];
            if (Array.isArray(_data["predmetiStavki"])) {
                this.predmetiStavki = [] as any;
                for (let item of _data["predmetiStavki"])
                    this.predmetiStavki!.push(PredmetStavke.fromJS(item));
            }
            if (Array.isArray(_data["stavkeRacuna"])) {
                this.stavkeRacuna = [] as any;
                for (let item of _data["stavkeRacuna"])
                    this.stavkeRacuna!.push(StavkaRacuna.fromJS(item));
            }
            if (Array.isArray(_data["otpremniceTezina"])) {
                this.otpremniceTezina = [] as any;
                for (let item of _data["otpremniceTezina"])
                    this.otpremniceTezina!.push(EOtpremnica.fromJS(item));
            }
            if (Array.isArray(_data["otpremniceZapremina"])) {
                this.otpremniceZapremina = [] as any;
                for (let item of _data["otpremniceZapremina"])
                    this.otpremniceZapremina!.push(EOtpremnica.fromJS(item));
            }
            if (Array.isArray(_data["stavkeOtpremnice"])) {
                this.stavkeOtpremnice = [] as any;
                for (let item of _data["stavkeOtpremnice"])
                    this.stavkeOtpremnice!.push(StavkaOtpremnice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JedinicaMere {
        data = typeof data === 'object' ? data : {};
        let result = new JedinicaMere();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jedinicaMereId"] = this.jedinicaMereId;
        data["naziv"] = this.naziv;
        data["skracenica"] = this.skracenica;
        data["kod"] = this.kod;
        data["simbol"] = this.simbol;
        data["nazivEng"] = this.nazivEng;
        data["nazivSrbCir"] = this.nazivSrbCir;
        data["isOnShortList"] = this.isOnShortList;
        if (Array.isArray(this.predmetiStavki)) {
            data["predmetiStavki"] = [];
            for (let item of this.predmetiStavki)
                data["predmetiStavki"].push(item.toJSON());
        }
        if (Array.isArray(this.stavkeRacuna)) {
            data["stavkeRacuna"] = [];
            for (let item of this.stavkeRacuna)
                data["stavkeRacuna"].push(item.toJSON());
        }
        if (Array.isArray(this.otpremniceTezina)) {
            data["otpremniceTezina"] = [];
            for (let item of this.otpremniceTezina)
                data["otpremniceTezina"].push(item.toJSON());
        }
        if (Array.isArray(this.otpremniceZapremina)) {
            data["otpremniceZapremina"] = [];
            for (let item of this.otpremniceZapremina)
                data["otpremniceZapremina"].push(item.toJSON());
        }
        if (Array.isArray(this.stavkeOtpremnice)) {
            data["stavkeOtpremnice"] = [];
            for (let item of this.stavkeOtpremnice)
                data["stavkeOtpremnice"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJedinicaMere {
    jedinicaMereId?: number;
    naziv?: string | undefined;
    skracenica?: string | undefined;
    kod?: string | undefined;
    simbol?: string | undefined;
    nazivEng?: string | undefined;
    nazivSrbCir?: string | undefined;
    isOnShortList?: boolean;
    predmetiStavki?: PredmetStavke[] | undefined;
    stavkeRacuna?: StavkaRacuna[] | undefined;
    otpremniceTezina?: EOtpremnica[] | undefined;
    otpremniceZapremina?: EOtpremnica[] | undefined;
    stavkeOtpremnice?: StavkaOtpremnice[] | undefined;
}

export class StavkaRacuna implements IStavkaRacuna {
    stavkaRacunaId?: number;
    kolicina?: number;
    iznos?: number;
    zavisniTrosakIznos?: number | undefined;
    redniBroj?: number;
    poreskaOsnovica?: number | undefined;
    sifraKupca?: string | undefined;
    sifraDobavljaca?: string | undefined;
    nabavnaCenaBezPdv?: number;
    prodajnaCenaBezPdv?: number;
    pdv?: number | undefined;
    stopaPDV?: number | undefined;
    rabat?: number | undefined;
    naziv?: string | undefined;
    opis?: string | undefined;
    identifikatorKlasifikacijeStavke?: IdentifikatorKlasifikacijeStavke | undefined;
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;
    racunId?: number;
    racun?: Racun | undefined;
    jedinicaMereId?: number;
    jedinicaMere?: JedinicaMere | undefined;
    magacinId?: number | undefined;
    magacin?: Magacin | undefined;
    poreskaKategorija?: PoreskaKategorijaStavkeRacuna | undefined;
    oznake?: OznakaStavkeRacuna[] | undefined;
    materijali?: StavkaRacunaSastavnica[] | undefined;
    proizvodi?: StavkaRacunaSastavnica[] | undefined;
    nabavnaCenaSaPdv?: number;

    constructor(data?: IStavkaRacuna) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stavkaRacunaId = _data["stavkaRacunaId"];
            this.kolicina = _data["kolicina"];
            this.iznos = _data["iznos"];
            this.zavisniTrosakIznos = _data["zavisniTrosakIznos"];
            this.redniBroj = _data["redniBroj"];
            this.poreskaOsnovica = _data["poreskaOsnovica"];
            this.sifraKupca = _data["sifraKupca"];
            this.sifraDobavljaca = _data["sifraDobavljaca"];
            this.nabavnaCenaBezPdv = _data["nabavnaCenaBezPdv"];
            this.prodajnaCenaBezPdv = _data["prodajnaCenaBezPdv"];
            this.pdv = _data["pdv"];
            this.stopaPDV = _data["stopaPDV"];
            this.rabat = _data["rabat"];
            this.naziv = _data["naziv"];
            this.opis = _data["opis"];
            this.identifikatorKlasifikacijeStavke = _data["identifikatorKlasifikacijeStavke"];
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.predmetStavke = _data["predmetStavke"] ? PredmetStavke.fromJS(_data["predmetStavke"]) : <any>undefined;
            this.racunId = _data["racunId"];
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
            this.jedinicaMereId = _data["jedinicaMereId"];
            this.jedinicaMere = _data["jedinicaMere"] ? JedinicaMere.fromJS(_data["jedinicaMere"]) : <any>undefined;
            this.magacinId = _data["magacinId"];
            this.magacin = _data["magacin"] ? Magacin.fromJS(_data["magacin"]) : <any>undefined;
            this.poreskaKategorija = _data["poreskaKategorija"] ? PoreskaKategorijaStavkeRacuna.fromJS(_data["poreskaKategorija"]) : <any>undefined;
            if (Array.isArray(_data["oznake"])) {
                this.oznake = [] as any;
                for (let item of _data["oznake"])
                    this.oznake!.push(OznakaStavkeRacuna.fromJS(item));
            }
            if (Array.isArray(_data["materijali"])) {
                this.materijali = [] as any;
                for (let item of _data["materijali"])
                    this.materijali!.push(StavkaRacunaSastavnica.fromJS(item));
            }
            if (Array.isArray(_data["proizvodi"])) {
                this.proizvodi = [] as any;
                for (let item of _data["proizvodi"])
                    this.proizvodi!.push(StavkaRacunaSastavnica.fromJS(item));
            }
            this.nabavnaCenaSaPdv = _data["nabavnaCenaSaPdv"];
        }
    }

    static fromJS(data: any): StavkaRacuna {
        data = typeof data === 'object' ? data : {};
        let result = new StavkaRacuna();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stavkaRacunaId"] = this.stavkaRacunaId;
        data["kolicina"] = this.kolicina;
        data["iznos"] = this.iznos;
        data["zavisniTrosakIznos"] = this.zavisniTrosakIznos;
        data["redniBroj"] = this.redniBroj;
        data["poreskaOsnovica"] = this.poreskaOsnovica;
        data["sifraKupca"] = this.sifraKupca;
        data["sifraDobavljaca"] = this.sifraDobavljaca;
        data["nabavnaCenaBezPdv"] = this.nabavnaCenaBezPdv;
        data["prodajnaCenaBezPdv"] = this.prodajnaCenaBezPdv;
        data["pdv"] = this.pdv;
        data["stopaPDV"] = this.stopaPDV;
        data["rabat"] = this.rabat;
        data["naziv"] = this.naziv;
        data["opis"] = this.opis;
        data["identifikatorKlasifikacijeStavke"] = this.identifikatorKlasifikacijeStavke;
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["predmetStavke"] = this.predmetStavke ? this.predmetStavke.toJSON() : <any>undefined;
        data["racunId"] = this.racunId;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        data["jedinicaMereId"] = this.jedinicaMereId;
        data["jedinicaMere"] = this.jedinicaMere ? this.jedinicaMere.toJSON() : <any>undefined;
        data["magacinId"] = this.magacinId;
        data["magacin"] = this.magacin ? this.magacin.toJSON() : <any>undefined;
        data["poreskaKategorija"] = this.poreskaKategorija ? this.poreskaKategorija.toJSON() : <any>undefined;
        if (Array.isArray(this.oznake)) {
            data["oznake"] = [];
            for (let item of this.oznake)
                data["oznake"].push(item.toJSON());
        }
        if (Array.isArray(this.materijali)) {
            data["materijali"] = [];
            for (let item of this.materijali)
                data["materijali"].push(item.toJSON());
        }
        if (Array.isArray(this.proizvodi)) {
            data["proizvodi"] = [];
            for (let item of this.proizvodi)
                data["proizvodi"].push(item.toJSON());
        }
        data["nabavnaCenaSaPdv"] = this.nabavnaCenaSaPdv;
        return data;
    }
}

export interface IStavkaRacuna {
    stavkaRacunaId?: number;
    kolicina?: number;
    iznos?: number;
    zavisniTrosakIznos?: number | undefined;
    redniBroj?: number;
    poreskaOsnovica?: number | undefined;
    sifraKupca?: string | undefined;
    sifraDobavljaca?: string | undefined;
    nabavnaCenaBezPdv?: number;
    prodajnaCenaBezPdv?: number;
    pdv?: number | undefined;
    stopaPDV?: number | undefined;
    rabat?: number | undefined;
    naziv?: string | undefined;
    opis?: string | undefined;
    identifikatorKlasifikacijeStavke?: IdentifikatorKlasifikacijeStavke | undefined;
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;
    racunId?: number;
    racun?: Racun | undefined;
    jedinicaMereId?: number;
    jedinicaMere?: JedinicaMere | undefined;
    magacinId?: number | undefined;
    magacin?: Magacin | undefined;
    poreskaKategorija?: PoreskaKategorijaStavkeRacuna | undefined;
    oznake?: OznakaStavkeRacuna[] | undefined;
    materijali?: StavkaRacunaSastavnica[] | undefined;
    proizvodi?: StavkaRacunaSastavnica[] | undefined;
    nabavnaCenaSaPdv?: number;
}

export class Magacin extends AuditableEntity implements IMagacin {
    magacinId?: number;
    naziv?: string | undefined;
    magacinTip?: MagacinTip | undefined;
    sifra?: string | undefined;
    magacinTipId?: number;
    kontaktOsoba?: string | undefined;
    kontaktTelefon?: string | undefined;
    email?: string | undefined;
    adresa?: Adresa | undefined;
    adresaId?: number | undefined;
    poslovnaJedinicaId?: number | undefined;
    poslovnaJedinica?: PoslovnaJedinica | undefined;
    otpremnice?: Otpremnica[] | undefined;
    lageri?: Lager[] | undefined;
    oznake?: OznakaMagacina[] | undefined;
    stavkeRacuna?: StavkaRacuna[] | undefined;
    adreseIsporuke?: AdresaIsporuke[] | undefined;

    constructor(data?: IMagacin) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.magacinId = _data["magacinId"];
            this.naziv = _data["naziv"];
            this.magacinTip = _data["magacinTip"] ? MagacinTip.fromJS(_data["magacinTip"]) : <any>undefined;
            this.sifra = _data["sifra"];
            this.magacinTipId = _data["magacinTipId"];
            this.kontaktOsoba = _data["kontaktOsoba"];
            this.kontaktTelefon = _data["kontaktTelefon"];
            this.email = _data["email"];
            this.adresa = _data["adresa"] ? Adresa.fromJS(_data["adresa"]) : <any>undefined;
            this.adresaId = _data["adresaId"];
            this.poslovnaJedinicaId = _data["poslovnaJedinicaId"];
            this.poslovnaJedinica = _data["poslovnaJedinica"] ? PoslovnaJedinica.fromJS(_data["poslovnaJedinica"]) : <any>undefined;
            if (Array.isArray(_data["otpremnice"])) {
                this.otpremnice = [] as any;
                for (let item of _data["otpremnice"])
                    this.otpremnice!.push(Otpremnica.fromJS(item));
            }
            if (Array.isArray(_data["lageri"])) {
                this.lageri = [] as any;
                for (let item of _data["lageri"])
                    this.lageri!.push(Lager.fromJS(item));
            }
            if (Array.isArray(_data["oznake"])) {
                this.oznake = [] as any;
                for (let item of _data["oznake"])
                    this.oznake!.push(OznakaMagacina.fromJS(item));
            }
            if (Array.isArray(_data["stavkeRacuna"])) {
                this.stavkeRacuna = [] as any;
                for (let item of _data["stavkeRacuna"])
                    this.stavkeRacuna!.push(StavkaRacuna.fromJS(item));
            }
            if (Array.isArray(_data["adreseIsporuke"])) {
                this.adreseIsporuke = [] as any;
                for (let item of _data["adreseIsporuke"])
                    this.adreseIsporuke!.push(AdresaIsporuke.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Magacin {
        data = typeof data === 'object' ? data : {};
        let result = new Magacin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["magacinId"] = this.magacinId;
        data["naziv"] = this.naziv;
        data["magacinTip"] = this.magacinTip ? this.magacinTip.toJSON() : <any>undefined;
        data["sifra"] = this.sifra;
        data["magacinTipId"] = this.magacinTipId;
        data["kontaktOsoba"] = this.kontaktOsoba;
        data["kontaktTelefon"] = this.kontaktTelefon;
        data["email"] = this.email;
        data["adresa"] = this.adresa ? this.adresa.toJSON() : <any>undefined;
        data["adresaId"] = this.adresaId;
        data["poslovnaJedinicaId"] = this.poslovnaJedinicaId;
        data["poslovnaJedinica"] = this.poslovnaJedinica ? this.poslovnaJedinica.toJSON() : <any>undefined;
        if (Array.isArray(this.otpremnice)) {
            data["otpremnice"] = [];
            for (let item of this.otpremnice)
                data["otpremnice"].push(item.toJSON());
        }
        if (Array.isArray(this.lageri)) {
            data["lageri"] = [];
            for (let item of this.lageri)
                data["lageri"].push(item.toJSON());
        }
        if (Array.isArray(this.oznake)) {
            data["oznake"] = [];
            for (let item of this.oznake)
                data["oznake"].push(item.toJSON());
        }
        if (Array.isArray(this.stavkeRacuna)) {
            data["stavkeRacuna"] = [];
            for (let item of this.stavkeRacuna)
                data["stavkeRacuna"].push(item.toJSON());
        }
        if (Array.isArray(this.adreseIsporuke)) {
            data["adreseIsporuke"] = [];
            for (let item of this.adreseIsporuke)
                data["adreseIsporuke"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMagacin extends IAuditableEntity {
    magacinId?: number;
    naziv?: string | undefined;
    magacinTip?: MagacinTip | undefined;
    sifra?: string | undefined;
    magacinTipId?: number;
    kontaktOsoba?: string | undefined;
    kontaktTelefon?: string | undefined;
    email?: string | undefined;
    adresa?: Adresa | undefined;
    adresaId?: number | undefined;
    poslovnaJedinicaId?: number | undefined;
    poslovnaJedinica?: PoslovnaJedinica | undefined;
    otpremnice?: Otpremnica[] | undefined;
    lageri?: Lager[] | undefined;
    oznake?: OznakaMagacina[] | undefined;
    stavkeRacuna?: StavkaRacuna[] | undefined;
    adreseIsporuke?: AdresaIsporuke[] | undefined;
}

export class MagacinTip implements IMagacinTip {
    magacinTipId?: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    magacini?: Magacin[] | undefined;

    constructor(data?: IMagacinTip) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.magacinTipId = _data["magacinTipId"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            if (Array.isArray(_data["magacini"])) {
                this.magacini = [] as any;
                for (let item of _data["magacini"])
                    this.magacini!.push(Magacin.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MagacinTip {
        data = typeof data === 'object' ? data : {};
        let result = new MagacinTip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["magacinTipId"] = this.magacinTipId;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        if (Array.isArray(this.magacini)) {
            data["magacini"] = [];
            for (let item of this.magacini)
                data["magacini"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMagacinTip {
    magacinTipId?: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    magacini?: Magacin[] | undefined;
}

export class PoslovnaJedinica implements IPoslovnaJedinica {
    poslovnaJedinicaId?: number;
    naziv?: string | undefined;
    jeAktivna?: boolean;
    opis?: string | undefined;
    adresa?: Adresa | undefined;
    adresaId?: number | undefined;
    strankaId?: number | undefined;
    stranka?: Stranka | undefined;
    sifraDelatnosti?: string | undefined;
    vrsta?: VrstaPoslovneJedinice;
    memorandumi?: Memorandum[] | undefined;
    magacini?: Magacin[] | undefined;
    bezbednosniElementi?: BezbednosniElement[] | undefined;
    kasiri?: ApplicationUser[] | undefined;

    constructor(data?: IPoslovnaJedinica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poslovnaJedinicaId = _data["poslovnaJedinicaId"];
            this.naziv = _data["naziv"];
            this.jeAktivna = _data["jeAktivna"];
            this.opis = _data["opis"];
            this.adresa = _data["adresa"] ? Adresa.fromJS(_data["adresa"]) : <any>undefined;
            this.adresaId = _data["adresaId"];
            this.strankaId = _data["strankaId"];
            this.stranka = _data["stranka"] ? Stranka.fromJS(_data["stranka"]) : <any>undefined;
            this.sifraDelatnosti = _data["sifraDelatnosti"];
            this.vrsta = _data["vrsta"];
            if (Array.isArray(_data["memorandumi"])) {
                this.memorandumi = [] as any;
                for (let item of _data["memorandumi"])
                    this.memorandumi!.push(Memorandum.fromJS(item));
            }
            if (Array.isArray(_data["magacini"])) {
                this.magacini = [] as any;
                for (let item of _data["magacini"])
                    this.magacini!.push(Magacin.fromJS(item));
            }
            if (Array.isArray(_data["bezbednosniElementi"])) {
                this.bezbednosniElementi = [] as any;
                for (let item of _data["bezbednosniElementi"])
                    this.bezbednosniElementi!.push(BezbednosniElement.fromJS(item));
            }
            if (Array.isArray(_data["kasiri"])) {
                this.kasiri = [] as any;
                for (let item of _data["kasiri"])
                    this.kasiri!.push(ApplicationUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PoslovnaJedinica {
        data = typeof data === 'object' ? data : {};
        let result = new PoslovnaJedinica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poslovnaJedinicaId"] = this.poslovnaJedinicaId;
        data["naziv"] = this.naziv;
        data["jeAktivna"] = this.jeAktivna;
        data["opis"] = this.opis;
        data["adresa"] = this.adresa ? this.adresa.toJSON() : <any>undefined;
        data["adresaId"] = this.adresaId;
        data["strankaId"] = this.strankaId;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        data["sifraDelatnosti"] = this.sifraDelatnosti;
        data["vrsta"] = this.vrsta;
        if (Array.isArray(this.memorandumi)) {
            data["memorandumi"] = [];
            for (let item of this.memorandumi)
                data["memorandumi"].push(item.toJSON());
        }
        if (Array.isArray(this.magacini)) {
            data["magacini"] = [];
            for (let item of this.magacini)
                data["magacini"].push(item.toJSON());
        }
        if (Array.isArray(this.bezbednosniElementi)) {
            data["bezbednosniElementi"] = [];
            for (let item of this.bezbednosniElementi)
                data["bezbednosniElementi"].push(item.toJSON());
        }
        if (Array.isArray(this.kasiri)) {
            data["kasiri"] = [];
            for (let item of this.kasiri)
                data["kasiri"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPoslovnaJedinica {
    poslovnaJedinicaId?: number;
    naziv?: string | undefined;
    jeAktivna?: boolean;
    opis?: string | undefined;
    adresa?: Adresa | undefined;
    adresaId?: number | undefined;
    strankaId?: number | undefined;
    stranka?: Stranka | undefined;
    sifraDelatnosti?: string | undefined;
    vrsta?: VrstaPoslovneJedinice;
    memorandumi?: Memorandum[] | undefined;
    magacini?: Magacin[] | undefined;
    bezbednosniElementi?: BezbednosniElement[] | undefined;
    kasiri?: ApplicationUser[] | undefined;
}

export enum VrstaPoslovneJedinice {
    SEDISTE = 0,
    PRODAJNO_MESTO = 1,
    DRUGO = 2,
}

export class Memorandum implements IMemorandum {
    memorandumId?: number;
    naziv?: string | undefined;
    bojaTabele?: string | undefined;
    napomenaOPoreskomOslobadjanju?: string | undefined;
    napomena?: string | undefined;
    prikaziSpojenuCifruSlovima?: boolean;
    prikaziZakonskiAktOValidnosti?: boolean;
    prikaziFooterSekciju?: boolean;
    prikaziBrojStrana?: boolean;
    koristiKompanijskiLogo?: boolean;
    website?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    vrstaEntiteta?: VrstaEntiteta;
    valutaId?: string | undefined;
    valuta?: Valuta | undefined;
    poslovnaJedinica?: PoslovnaJedinica | undefined;
    poslovnaJedinicaId?: number | undefined;
    racuni?: Racun[] | undefined;

    constructor(data?: IMemorandum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memorandumId = _data["memorandumId"];
            this.naziv = _data["naziv"];
            this.bojaTabele = _data["bojaTabele"];
            this.napomenaOPoreskomOslobadjanju = _data["napomenaOPoreskomOslobadjanju"];
            this.napomena = _data["napomena"];
            this.prikaziSpojenuCifruSlovima = _data["prikaziSpojenuCifruSlovima"];
            this.prikaziZakonskiAktOValidnosti = _data["prikaziZakonskiAktOValidnosti"];
            this.prikaziFooterSekciju = _data["prikaziFooterSekciju"];
            this.prikaziBrojStrana = _data["prikaziBrojStrana"];
            this.koristiKompanijskiLogo = _data["koristiKompanijskiLogo"];
            this.website = _data["website"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.vrstaEntiteta = _data["vrstaEntiteta"];
            this.valutaId = _data["valutaId"];
            this.valuta = _data["valuta"] ? Valuta.fromJS(_data["valuta"]) : <any>undefined;
            this.poslovnaJedinica = _data["poslovnaJedinica"] ? PoslovnaJedinica.fromJS(_data["poslovnaJedinica"]) : <any>undefined;
            this.poslovnaJedinicaId = _data["poslovnaJedinicaId"];
            if (Array.isArray(_data["racuni"])) {
                this.racuni = [] as any;
                for (let item of _data["racuni"])
                    this.racuni!.push(Racun.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Memorandum {
        data = typeof data === 'object' ? data : {};
        let result = new Memorandum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memorandumId"] = this.memorandumId;
        data["naziv"] = this.naziv;
        data["bojaTabele"] = this.bojaTabele;
        data["napomenaOPoreskomOslobadjanju"] = this.napomenaOPoreskomOslobadjanju;
        data["napomena"] = this.napomena;
        data["prikaziSpojenuCifruSlovima"] = this.prikaziSpojenuCifruSlovima;
        data["prikaziZakonskiAktOValidnosti"] = this.prikaziZakonskiAktOValidnosti;
        data["prikaziFooterSekciju"] = this.prikaziFooterSekciju;
        data["prikaziBrojStrana"] = this.prikaziBrojStrana;
        data["koristiKompanijskiLogo"] = this.koristiKompanijskiLogo;
        data["website"] = this.website;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["vrstaEntiteta"] = this.vrstaEntiteta;
        data["valutaId"] = this.valutaId;
        data["valuta"] = this.valuta ? this.valuta.toJSON() : <any>undefined;
        data["poslovnaJedinica"] = this.poslovnaJedinica ? this.poslovnaJedinica.toJSON() : <any>undefined;
        data["poslovnaJedinicaId"] = this.poslovnaJedinicaId;
        if (Array.isArray(this.racuni)) {
            data["racuni"] = [];
            for (let item of this.racuni)
                data["racuni"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMemorandum {
    memorandumId?: number;
    naziv?: string | undefined;
    bojaTabele?: string | undefined;
    napomenaOPoreskomOslobadjanju?: string | undefined;
    napomena?: string | undefined;
    prikaziSpojenuCifruSlovima?: boolean;
    prikaziZakonskiAktOValidnosti?: boolean;
    prikaziFooterSekciju?: boolean;
    prikaziBrojStrana?: boolean;
    koristiKompanijskiLogo?: boolean;
    website?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    vrstaEntiteta?: VrstaEntiteta;
    valutaId?: string | undefined;
    valuta?: Valuta | undefined;
    poslovnaJedinica?: PoslovnaJedinica | undefined;
    poslovnaJedinicaId?: number | undefined;
    racuni?: Racun[] | undefined;
}

export class BezbednosniElement implements IBezbednosniElement {
    bezbednosniElementId?: number;
    naziv?: string | undefined;
    jid?: string | undefined;
    address?: string | undefined;
    businessName?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    district?: string | undefined;
    locationName?: string | undefined;
    tin?: string | undefined;
    status?: StatusVerifikacijeBezbednosnogElementa | undefined;
    tip?: TipBezbednosnogElementa;
    lozinka?: string | undefined;
    pak?: string | undefined;
    vaziDo?: Date | undefined;
    originalFileName?: string | undefined;
    poslataNotifikacija30Dana?: boolean;
    datumSlanjaNotifikacije30Dana?: Date | undefined;
    poslovnaJedinicaId?: number | undefined;
    poslovnaJedinica?: PoslovnaJedinica | undefined;
    licence?: LicencaSertifikata[] | undefined;

    constructor(data?: IBezbednosniElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bezbednosniElementId = _data["bezbednosniElementId"];
            this.naziv = _data["naziv"];
            this.jid = _data["jid"];
            this.address = _data["address"];
            this.businessName = _data["businessName"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.district = _data["district"];
            this.locationName = _data["locationName"];
            this.tin = _data["tin"];
            this.status = _data["status"];
            this.tip = _data["tip"];
            this.lozinka = _data["lozinka"];
            this.pak = _data["pak"];
            this.vaziDo = _data["vaziDo"] ? new Date(_data["vaziDo"].toString()) : <any>undefined;
            this.originalFileName = _data["originalFileName"];
            this.poslataNotifikacija30Dana = _data["poslataNotifikacija30Dana"];
            this.datumSlanjaNotifikacije30Dana = _data["datumSlanjaNotifikacije30Dana"] ? new Date(_data["datumSlanjaNotifikacije30Dana"].toString()) : <any>undefined;
            this.poslovnaJedinicaId = _data["poslovnaJedinicaId"];
            this.poslovnaJedinica = _data["poslovnaJedinica"] ? PoslovnaJedinica.fromJS(_data["poslovnaJedinica"]) : <any>undefined;
            if (Array.isArray(_data["licence"])) {
                this.licence = [] as any;
                for (let item of _data["licence"])
                    this.licence!.push(LicencaSertifikata.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BezbednosniElement {
        data = typeof data === 'object' ? data : {};
        let result = new BezbednosniElement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bezbednosniElementId"] = this.bezbednosniElementId;
        data["naziv"] = this.naziv;
        data["jid"] = this.jid;
        data["address"] = this.address;
        data["businessName"] = this.businessName;
        data["city"] = this.city;
        data["country"] = this.country;
        data["district"] = this.district;
        data["locationName"] = this.locationName;
        data["tin"] = this.tin;
        data["status"] = this.status;
        data["tip"] = this.tip;
        data["lozinka"] = this.lozinka;
        data["pak"] = this.pak;
        data["vaziDo"] = this.vaziDo ? this.vaziDo.toISOString() : <any>undefined;
        data["originalFileName"] = this.originalFileName;
        data["poslataNotifikacija30Dana"] = this.poslataNotifikacija30Dana;
        data["datumSlanjaNotifikacije30Dana"] = this.datumSlanjaNotifikacije30Dana ? this.datumSlanjaNotifikacije30Dana.toISOString() : <any>undefined;
        data["poslovnaJedinicaId"] = this.poslovnaJedinicaId;
        data["poslovnaJedinica"] = this.poslovnaJedinica ? this.poslovnaJedinica.toJSON() : <any>undefined;
        if (Array.isArray(this.licence)) {
            data["licence"] = [];
            for (let item of this.licence)
                data["licence"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBezbednosniElement {
    bezbednosniElementId?: number;
    naziv?: string | undefined;
    jid?: string | undefined;
    address?: string | undefined;
    businessName?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    district?: string | undefined;
    locationName?: string | undefined;
    tin?: string | undefined;
    status?: StatusVerifikacijeBezbednosnogElementa | undefined;
    tip?: TipBezbednosnogElementa;
    lozinka?: string | undefined;
    pak?: string | undefined;
    vaziDo?: Date | undefined;
    originalFileName?: string | undefined;
    poslataNotifikacija30Dana?: boolean;
    datumSlanjaNotifikacije30Dana?: Date | undefined;
    poslovnaJedinicaId?: number | undefined;
    poslovnaJedinica?: PoslovnaJedinica | undefined;
    licence?: LicencaSertifikata[] | undefined;
}

export class LicencaSertifikata implements ILicencaSertifikata {
    bezbednosniElementId?: number;
    bezbednosniElement?: BezbednosniElement | undefined;
    lpfrLicencaId?: string | undefined;
    lpfrLicenca?: LPFRLicenca | undefined;

    constructor(data?: ILicencaSertifikata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bezbednosniElementId = _data["bezbednosniElementId"];
            this.bezbednosniElement = _data["bezbednosniElement"] ? BezbednosniElement.fromJS(_data["bezbednosniElement"]) : <any>undefined;
            this.lpfrLicencaId = _data["lpfrLicencaId"];
            this.lpfrLicenca = _data["lpfrLicenca"] ? LPFRLicenca.fromJS(_data["lpfrLicenca"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LicencaSertifikata {
        data = typeof data === 'object' ? data : {};
        let result = new LicencaSertifikata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bezbednosniElementId"] = this.bezbednosniElementId;
        data["bezbednosniElement"] = this.bezbednosniElement ? this.bezbednosniElement.toJSON() : <any>undefined;
        data["lpfrLicencaId"] = this.lpfrLicencaId;
        data["lpfrLicenca"] = this.lpfrLicenca ? this.lpfrLicenca.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILicencaSertifikata {
    bezbednosniElementId?: number;
    bezbednosniElement?: BezbednosniElement | undefined;
    lpfrLicencaId?: string | undefined;
    lpfrLicenca?: LPFRLicenca | undefined;
}

export class LPFRLicenca implements ILPFRLicenca {
    id?: string | undefined;
    isActive?: boolean;
    expirationDate?: Date | undefined;
    modRada?: ModRada;
    uredjajId?: string | undefined;
    sertifikati?: LicencaSertifikata[] | undefined;

    constructor(data?: ILPFRLicenca) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.modRada = _data["modRada"];
            this.uredjajId = _data["uredjajId"];
            if (Array.isArray(_data["sertifikati"])) {
                this.sertifikati = [] as any;
                for (let item of _data["sertifikati"])
                    this.sertifikati!.push(LicencaSertifikata.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LPFRLicenca {
        data = typeof data === 'object' ? data : {};
        let result = new LPFRLicenca();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["modRada"] = this.modRada;
        data["uredjajId"] = this.uredjajId;
        if (Array.isArray(this.sertifikati)) {
            data["sertifikati"] = [];
            for (let item of this.sertifikati)
                data["sertifikati"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILPFRLicenca {
    id?: string | undefined;
    isActive?: boolean;
    expirationDate?: Date | undefined;
    modRada?: ModRada;
    uredjajId?: string | undefined;
    sertifikati?: LicencaSertifikata[] | undefined;
}

export class IdentityUserOfString implements IIdentityUserOfString {
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;

    constructor(data?: IIdentityUserOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>undefined;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
        }
    }

    static fromJS(data: any): IdentityUserOfString {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        return data;
    }
}

export interface IIdentityUserOfString {
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
}

export class IdentityUser extends IdentityUserOfString implements IIdentityUser {

    constructor(data?: IIdentityUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): IdentityUser {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IIdentityUser extends IIdentityUserOfString {
}

export class ApplicationUser extends IdentityUser implements IApplicationUser {
    firstName?: string | undefined;
    lastName?: string | undefined;
    imageUrl?: string | undefined;
    isActive?: boolean;
    tenantKey?: string | undefined;
    roleNames?: string | undefined;
    pozivniBroj?: string | undefined;
    prihvaceniUsloviKoriscenja?: boolean;
    datumPrihvatanjaUslovaKoriscenja?: Date | undefined;
    isLoggedIn?: boolean;
    zohoContactId?: number | undefined;
    poslovnaJedinicaId?: number | undefined;
    poslovnaJedinica?: PoslovnaJedinica | undefined;
    refreshTokens?: RefreshToken[] | undefined;

    constructor(data?: IApplicationUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.imageUrl = _data["imageUrl"];
            this.isActive = _data["isActive"];
            this.tenantKey = _data["tenantKey"];
            this.roleNames = _data["roleNames"];
            this.pozivniBroj = _data["pozivniBroj"];
            this.prihvaceniUsloviKoriscenja = _data["prihvaceniUsloviKoriscenja"];
            this.datumPrihvatanjaUslovaKoriscenja = _data["datumPrihvatanjaUslovaKoriscenja"] ? new Date(_data["datumPrihvatanjaUslovaKoriscenja"].toString()) : <any>undefined;
            this.isLoggedIn = _data["isLoggedIn"];
            this.zohoContactId = _data["zohoContactId"];
            this.poslovnaJedinicaId = _data["poslovnaJedinicaId"];
            this.poslovnaJedinica = _data["poslovnaJedinica"] ? PoslovnaJedinica.fromJS(_data["poslovnaJedinica"]) : <any>undefined;
            if (Array.isArray(_data["refreshTokens"])) {
                this.refreshTokens = [] as any;
                for (let item of _data["refreshTokens"])
                    this.refreshTokens!.push(RefreshToken.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApplicationUser {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["imageUrl"] = this.imageUrl;
        data["isActive"] = this.isActive;
        data["tenantKey"] = this.tenantKey;
        data["roleNames"] = this.roleNames;
        data["pozivniBroj"] = this.pozivniBroj;
        data["prihvaceniUsloviKoriscenja"] = this.prihvaceniUsloviKoriscenja;
        data["datumPrihvatanjaUslovaKoriscenja"] = this.datumPrihvatanjaUslovaKoriscenja ? this.datumPrihvatanjaUslovaKoriscenja.toISOString() : <any>undefined;
        data["isLoggedIn"] = this.isLoggedIn;
        data["zohoContactId"] = this.zohoContactId;
        data["poslovnaJedinicaId"] = this.poslovnaJedinicaId;
        data["poslovnaJedinica"] = this.poslovnaJedinica ? this.poslovnaJedinica.toJSON() : <any>undefined;
        if (Array.isArray(this.refreshTokens)) {
            data["refreshTokens"] = [];
            for (let item of this.refreshTokens)
                data["refreshTokens"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IApplicationUser extends IIdentityUser {
    firstName?: string | undefined;
    lastName?: string | undefined;
    imageUrl?: string | undefined;
    isActive?: boolean;
    tenantKey?: string | undefined;
    roleNames?: string | undefined;
    pozivniBroj?: string | undefined;
    prihvaceniUsloviKoriscenja?: boolean;
    datumPrihvatanjaUslovaKoriscenja?: Date | undefined;
    isLoggedIn?: boolean;
    zohoContactId?: number | undefined;
    poslovnaJedinicaId?: number | undefined;
    poslovnaJedinica?: PoslovnaJedinica | undefined;
    refreshTokens?: RefreshToken[] | undefined;
}

export class RefreshToken implements IRefreshToken {
    id?: number;
    userId?: string | undefined;
    user?: ApplicationUser | undefined;
    token?: string | undefined;
    expiresAt?: Date;
    createdAt?: Date;
    createdByIp?: string | undefined;
    revokedAt?: Date | undefined;
    deviceType?: SessionDeviceType;
    deviceToken?: string | undefined;
    sessionId?: string;

    constructor(data?: IRefreshToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? ApplicationUser.fromJS(_data["user"]) : <any>undefined;
            this.token = _data["token"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdByIp = _data["createdByIp"];
            this.revokedAt = _data["revokedAt"] ? new Date(_data["revokedAt"].toString()) : <any>undefined;
            this.deviceType = _data["deviceType"];
            this.deviceToken = _data["deviceToken"];
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): RefreshToken {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["token"] = this.token;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdByIp"] = this.createdByIp;
        data["revokedAt"] = this.revokedAt ? this.revokedAt.toISOString() : <any>undefined;
        data["deviceType"] = this.deviceType;
        data["deviceToken"] = this.deviceToken;
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface IRefreshToken {
    id?: number;
    userId?: string | undefined;
    user?: ApplicationUser | undefined;
    token?: string | undefined;
    expiresAt?: Date;
    createdAt?: Date;
    createdByIp?: string | undefined;
    revokedAt?: Date | undefined;
    deviceType?: SessionDeviceType;
    deviceToken?: string | undefined;
    sessionId?: string;
}

export enum SessionDeviceType {
    Web = 0,
    Kasa = 1,
    Mobile = 2,
    Dms = 3,
}

export class Otpremnica implements IOtpremnica {
    racunId?: number;
    racun?: Racun | undefined;
    preuzeo?: string | undefined;
    izdao?: string | undefined;
    brojVozilaIliLk?: string | undefined;
    vrsta?: VrstaOtpremnice;
    interniMagacinId?: number | undefined;
    magacin?: Magacin | undefined;
    informacijaIsporukeId?: number | undefined;
    informacijaIsporuke?: InformacijaIsporukeRacuna | undefined;

    constructor(data?: IOtpremnica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
            this.preuzeo = _data["preuzeo"];
            this.izdao = _data["izdao"];
            this.brojVozilaIliLk = _data["brojVozilaIliLk"];
            this.vrsta = _data["vrsta"];
            this.interniMagacinId = _data["interniMagacinId"];
            this.magacin = _data["magacin"] ? Magacin.fromJS(_data["magacin"]) : <any>undefined;
            this.informacijaIsporukeId = _data["informacijaIsporukeId"];
            this.informacijaIsporuke = _data["informacijaIsporuke"] ? InformacijaIsporukeRacuna.fromJS(_data["informacijaIsporuke"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Otpremnica {
        data = typeof data === 'object' ? data : {};
        let result = new Otpremnica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        data["preuzeo"] = this.preuzeo;
        data["izdao"] = this.izdao;
        data["brojVozilaIliLk"] = this.brojVozilaIliLk;
        data["vrsta"] = this.vrsta;
        data["interniMagacinId"] = this.interniMagacinId;
        data["magacin"] = this.magacin ? this.magacin.toJSON() : <any>undefined;
        data["informacijaIsporukeId"] = this.informacijaIsporukeId;
        data["informacijaIsporuke"] = this.informacijaIsporuke ? this.informacijaIsporuke.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOtpremnica {
    racunId?: number;
    racun?: Racun | undefined;
    preuzeo?: string | undefined;
    izdao?: string | undefined;
    brojVozilaIliLk?: string | undefined;
    vrsta?: VrstaOtpremnice;
    interniMagacinId?: number | undefined;
    magacin?: Magacin | undefined;
    informacijaIsporukeId?: number | undefined;
    informacijaIsporuke?: InformacijaIsporukeRacuna | undefined;
}

export enum VrstaOtpremnice {
    EMPTY = 0,
    STANDARDNA = 1,
    INTERNA = 2,
}

export class Lager implements ILager {
    lagerId?: number;
    magacinId?: number;
    magacin?: Magacin | undefined;
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;
    stanje?: number;
    rezervisano?: number;
    prosecnaNabavnaCena?: number;
    prosecnaProdajnaCena?: number;
    slobodno?: number;
    lagerTransakcije?: LagerTransakcija[] | undefined;

    constructor(data?: ILager) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lagerId = _data["lagerId"];
            this.magacinId = _data["magacinId"];
            this.magacin = _data["magacin"] ? Magacin.fromJS(_data["magacin"]) : <any>undefined;
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.predmetStavke = _data["predmetStavke"] ? PredmetStavke.fromJS(_data["predmetStavke"]) : <any>undefined;
            this.stanje = _data["stanje"];
            this.rezervisano = _data["rezervisano"];
            this.prosecnaNabavnaCena = _data["prosecnaNabavnaCena"];
            this.prosecnaProdajnaCena = _data["prosecnaProdajnaCena"];
            this.slobodno = _data["slobodno"];
            if (Array.isArray(_data["lagerTransakcije"])) {
                this.lagerTransakcije = [] as any;
                for (let item of _data["lagerTransakcije"])
                    this.lagerTransakcije!.push(LagerTransakcija.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Lager {
        data = typeof data === 'object' ? data : {};
        let result = new Lager();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lagerId"] = this.lagerId;
        data["magacinId"] = this.magacinId;
        data["magacin"] = this.magacin ? this.magacin.toJSON() : <any>undefined;
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["predmetStavke"] = this.predmetStavke ? this.predmetStavke.toJSON() : <any>undefined;
        data["stanje"] = this.stanje;
        data["rezervisano"] = this.rezervisano;
        data["prosecnaNabavnaCena"] = this.prosecnaNabavnaCena;
        data["prosecnaProdajnaCena"] = this.prosecnaProdajnaCena;
        data["slobodno"] = this.slobodno;
        if (Array.isArray(this.lagerTransakcije)) {
            data["lagerTransakcije"] = [];
            for (let item of this.lagerTransakcije)
                data["lagerTransakcije"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILager {
    lagerId?: number;
    magacinId?: number;
    magacin?: Magacin | undefined;
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;
    stanje?: number;
    rezervisano?: number;
    prosecnaNabavnaCena?: number;
    prosecnaProdajnaCena?: number;
    slobodno?: number;
    lagerTransakcije?: LagerTransakcija[] | undefined;
}

export class LagerTransakcija extends AuditableEntity implements ILagerTransakcija {
    transakcijaId?: number;
    tip?: TipLagerTransakcije;
    ulaz?: number;
    izlaz?: number;
    nabavnaCena?: number;
    prodajnaCena?: number;
    datumPrometa?: Date;
    nabavnaVrednost?: number;
    prodajnaVrednost?: number;
    lagerId?: number;
    lager?: Lager | undefined;
    racunId?: number | undefined;
    racun?: Racun | undefined;
    invoiceRequestId?: string | undefined;
    invoiceRequest?: InvoiceRequest | undefined;
    eOtpremnicaId?: number | undefined;
    eOtpremnicaBase?: EOtpremnicaBase | undefined;

    constructor(data?: ILagerTransakcija) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.transakcijaId = _data["transakcijaId"];
            this.tip = _data["tip"];
            this.ulaz = _data["ulaz"];
            this.izlaz = _data["izlaz"];
            this.nabavnaCena = _data["nabavnaCena"];
            this.prodajnaCena = _data["prodajnaCena"];
            this.datumPrometa = _data["datumPrometa"] ? new Date(_data["datumPrometa"].toString()) : <any>undefined;
            this.nabavnaVrednost = _data["nabavnaVrednost"];
            this.prodajnaVrednost = _data["prodajnaVrednost"];
            this.lagerId = _data["lagerId"];
            this.lager = _data["lager"] ? Lager.fromJS(_data["lager"]) : <any>undefined;
            this.racunId = _data["racunId"];
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
            this.invoiceRequestId = _data["invoiceRequestId"];
            this.invoiceRequest = _data["invoiceRequest"] ? InvoiceRequest.fromJS(_data["invoiceRequest"]) : <any>undefined;
            this.eOtpremnicaId = _data["eOtpremnicaId"];
            this.eOtpremnicaBase = _data["eOtpremnicaBase"] ? EOtpremnicaBase.fromJS(_data["eOtpremnicaBase"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LagerTransakcija {
        data = typeof data === 'object' ? data : {};
        let result = new LagerTransakcija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transakcijaId"] = this.transakcijaId;
        data["tip"] = this.tip;
        data["ulaz"] = this.ulaz;
        data["izlaz"] = this.izlaz;
        data["nabavnaCena"] = this.nabavnaCena;
        data["prodajnaCena"] = this.prodajnaCena;
        data["datumPrometa"] = this.datumPrometa ? this.datumPrometa.toISOString() : <any>undefined;
        data["nabavnaVrednost"] = this.nabavnaVrednost;
        data["prodajnaVrednost"] = this.prodajnaVrednost;
        data["lagerId"] = this.lagerId;
        data["lager"] = this.lager ? this.lager.toJSON() : <any>undefined;
        data["racunId"] = this.racunId;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        data["invoiceRequestId"] = this.invoiceRequestId;
        data["invoiceRequest"] = this.invoiceRequest ? this.invoiceRequest.toJSON() : <any>undefined;
        data["eOtpremnicaId"] = this.eOtpremnicaId;
        data["eOtpremnicaBase"] = this.eOtpremnicaBase ? this.eOtpremnicaBase.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ILagerTransakcija extends IAuditableEntity {
    transakcijaId?: number;
    tip?: TipLagerTransakcije;
    ulaz?: number;
    izlaz?: number;
    nabavnaCena?: number;
    prodajnaCena?: number;
    datumPrometa?: Date;
    nabavnaVrednost?: number;
    prodajnaVrednost?: number;
    lagerId?: number;
    lager?: Lager | undefined;
    racunId?: number | undefined;
    racun?: Racun | undefined;
    invoiceRequestId?: string | undefined;
    invoiceRequest?: InvoiceRequest | undefined;
    eOtpremnicaId?: number | undefined;
    eOtpremnicaBase?: EOtpremnicaBase | undefined;
}

export enum TipLagerTransakcije {
    MANUELNI = 0,
    PO_ULAZNOM_RACUNU = 1,
    PO_IZLAZNOM_RACUNU = 2,
    PO_POVRATNICI = 3,
    PO_PREDRACUNU = 4,
    PO_OTPREMNICI = 5,
    PO_RADNOM_NALOGU = 6,
    PO_POPISU = 7,
    PO_IMPORTU = 8,
    PO_INTERNOJ_OTPREMNICI = 9,
    PO_FISKALNOM_RACUNU = 10,
    PO_EOTPREMNICI = 11,
    PO_INTERNOJ_EOTPREMNICI = 12,
    PO_EPRIJEMNICI = 13,
}

export abstract class EOtpremnicaBase extends AuditableEntity implements IEOtpremnicaBase {
    id?: number;
    tipOtpremnice?: TipOtpremnice;
    vrstaDokumenta?: VrstaDokumentaOtpremnica;
    broj?: string | undefined;
    sefId?: string | undefined;
    datumIzdavanjaOtpremnice?: Date;
    tezinaIsporuke?: number | undefined;
    zapreminaIsporuke?: number | undefined;
    stvarniDatum?: Date;
    brojPaketa?: number;
    brojUgovora?: string | undefined;
    brojNarudzbenice?: string | undefined;
    brojOkvirnogSporazuma?: string | undefined;
    jeRobaTreceStrane?: boolean;
    status?: StatusEOtpremnice;
    napomena?: string | undefined;
    robaTreceStrane?: string | undefined;
    strankaId?: number;
    stranka?: Stranka | undefined;
    posiljalacKontaktOsobaId?: number | undefined;
    posiljalacKontakt?: KontaktOsoba | undefined;
    primalacKontaktOsobaId?: number | undefined;
    primalacKontakt?: KontaktOsoba | undefined;
    nacinOtpreme?: NacinOtpreme;
    licniNacinOtpreme?: LicniNacinOtpreme | undefined;
    adresaOtpremeId?: number;
    adresaOtpreme?: AdresaIsporuke | undefined;
    adresaOdredistaId?: number;
    adresaOdredista?: AdresaIsporuke | undefined;
    praviloZaBrojId?: number | undefined;
    racunId?: number | undefined;
    racun?: Racun | undefined;
    predracunId?: number | undefined;
    predracun?: Racun | undefined;
    fazeVoznje?: FazaVoznje[] | undefined;
    stavke?: StavkaOtpremnice[] | undefined;
    relevantniDokumenti?: EOtpremnicaRelevantniDokument[] | undefined;
    lagerTransakcije?: LagerTransakcija[] | undefined;

    constructor(data?: IEOtpremnicaBase) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.tipOtpremnice = _data["tipOtpremnice"];
            this.vrstaDokumenta = _data["vrstaDokumenta"];
            this.broj = _data["broj"];
            this.sefId = _data["sefId"];
            this.datumIzdavanjaOtpremnice = _data["datumIzdavanjaOtpremnice"] ? new Date(_data["datumIzdavanjaOtpremnice"].toString()) : <any>undefined;
            this.tezinaIsporuke = _data["tezinaIsporuke"];
            this.zapreminaIsporuke = _data["zapreminaIsporuke"];
            this.stvarniDatum = _data["stvarniDatum"] ? new Date(_data["stvarniDatum"].toString()) : <any>undefined;
            this.brojPaketa = _data["brojPaketa"];
            this.brojUgovora = _data["brojUgovora"];
            this.brojNarudzbenice = _data["brojNarudzbenice"];
            this.brojOkvirnogSporazuma = _data["brojOkvirnogSporazuma"];
            this.jeRobaTreceStrane = _data["jeRobaTreceStrane"];
            this.status = _data["status"];
            this.napomena = _data["napomena"];
            this.robaTreceStrane = _data["robaTreceStrane"];
            this.strankaId = _data["strankaId"];
            this.stranka = _data["stranka"] ? Stranka.fromJS(_data["stranka"]) : <any>undefined;
            this.posiljalacKontaktOsobaId = _data["posiljalacKontaktOsobaId"];
            this.posiljalacKontakt = _data["posiljalacKontakt"] ? KontaktOsoba.fromJS(_data["posiljalacKontakt"]) : <any>undefined;
            this.primalacKontaktOsobaId = _data["primalacKontaktOsobaId"];
            this.primalacKontakt = _data["primalacKontakt"] ? KontaktOsoba.fromJS(_data["primalacKontakt"]) : <any>undefined;
            this.nacinOtpreme = _data["nacinOtpreme"];
            this.licniNacinOtpreme = _data["licniNacinOtpreme"] ? LicniNacinOtpreme.fromJS(_data["licniNacinOtpreme"]) : <any>undefined;
            this.adresaOtpremeId = _data["adresaOtpremeId"];
            this.adresaOtpreme = _data["adresaOtpreme"] ? AdresaIsporuke.fromJS(_data["adresaOtpreme"]) : <any>undefined;
            this.adresaOdredistaId = _data["adresaOdredistaId"];
            this.adresaOdredista = _data["adresaOdredista"] ? AdresaIsporuke.fromJS(_data["adresaOdredista"]) : <any>undefined;
            this.praviloZaBrojId = _data["praviloZaBrojId"];
            this.racunId = _data["racunId"];
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
            this.predracunId = _data["predracunId"];
            this.predracun = _data["predracun"] ? Racun.fromJS(_data["predracun"]) : <any>undefined;
            if (Array.isArray(_data["fazeVoznje"])) {
                this.fazeVoznje = [] as any;
                for (let item of _data["fazeVoznje"])
                    this.fazeVoznje!.push(FazaVoznje.fromJS(item));
            }
            if (Array.isArray(_data["stavke"])) {
                this.stavke = [] as any;
                for (let item of _data["stavke"])
                    this.stavke!.push(StavkaOtpremnice.fromJS(item));
            }
            if (Array.isArray(_data["relevantniDokumenti"])) {
                this.relevantniDokumenti = [] as any;
                for (let item of _data["relevantniDokumenti"])
                    this.relevantniDokumenti!.push(EOtpremnicaRelevantniDokument.fromJS(item));
            }
            if (Array.isArray(_data["lagerTransakcije"])) {
                this.lagerTransakcije = [] as any;
                for (let item of _data["lagerTransakcije"])
                    this.lagerTransakcije!.push(LagerTransakcija.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EOtpremnicaBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EOtpremnicaBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipOtpremnice"] = this.tipOtpremnice;
        data["vrstaDokumenta"] = this.vrstaDokumenta;
        data["broj"] = this.broj;
        data["sefId"] = this.sefId;
        data["datumIzdavanjaOtpremnice"] = this.datumIzdavanjaOtpremnice ? formatDate(this.datumIzdavanjaOtpremnice) : <any>undefined;
        data["tezinaIsporuke"] = this.tezinaIsporuke;
        data["zapreminaIsporuke"] = this.zapreminaIsporuke;
        data["stvarniDatum"] = this.stvarniDatum ? this.stvarniDatum.toISOString() : <any>undefined;
        data["brojPaketa"] = this.brojPaketa;
        data["brojUgovora"] = this.brojUgovora;
        data["brojNarudzbenice"] = this.brojNarudzbenice;
        data["brojOkvirnogSporazuma"] = this.brojOkvirnogSporazuma;
        data["jeRobaTreceStrane"] = this.jeRobaTreceStrane;
        data["status"] = this.status;
        data["napomena"] = this.napomena;
        data["robaTreceStrane"] = this.robaTreceStrane;
        data["strankaId"] = this.strankaId;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        data["posiljalacKontaktOsobaId"] = this.posiljalacKontaktOsobaId;
        data["posiljalacKontakt"] = this.posiljalacKontakt ? this.posiljalacKontakt.toJSON() : <any>undefined;
        data["primalacKontaktOsobaId"] = this.primalacKontaktOsobaId;
        data["primalacKontakt"] = this.primalacKontakt ? this.primalacKontakt.toJSON() : <any>undefined;
        data["nacinOtpreme"] = this.nacinOtpreme;
        data["licniNacinOtpreme"] = this.licniNacinOtpreme ? this.licniNacinOtpreme.toJSON() : <any>undefined;
        data["adresaOtpremeId"] = this.adresaOtpremeId;
        data["adresaOtpreme"] = this.adresaOtpreme ? this.adresaOtpreme.toJSON() : <any>undefined;
        data["adresaOdredistaId"] = this.adresaOdredistaId;
        data["adresaOdredista"] = this.adresaOdredista ? this.adresaOdredista.toJSON() : <any>undefined;
        data["praviloZaBrojId"] = this.praviloZaBrojId;
        data["racunId"] = this.racunId;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        data["predracunId"] = this.predracunId;
        data["predracun"] = this.predracun ? this.predracun.toJSON() : <any>undefined;
        if (Array.isArray(this.fazeVoznje)) {
            data["fazeVoznje"] = [];
            for (let item of this.fazeVoznje)
                data["fazeVoznje"].push(item.toJSON());
        }
        if (Array.isArray(this.stavke)) {
            data["stavke"] = [];
            for (let item of this.stavke)
                data["stavke"].push(item.toJSON());
        }
        if (Array.isArray(this.relevantniDokumenti)) {
            data["relevantniDokumenti"] = [];
            for (let item of this.relevantniDokumenti)
                data["relevantniDokumenti"].push(item.toJSON());
        }
        if (Array.isArray(this.lagerTransakcije)) {
            data["lagerTransakcije"] = [];
            for (let item of this.lagerTransakcije)
                data["lagerTransakcije"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IEOtpremnicaBase extends IAuditableEntity {
    id?: number;
    tipOtpremnice?: TipOtpremnice;
    vrstaDokumenta?: VrstaDokumentaOtpremnica;
    broj?: string | undefined;
    sefId?: string | undefined;
    datumIzdavanjaOtpremnice?: Date;
    tezinaIsporuke?: number | undefined;
    zapreminaIsporuke?: number | undefined;
    stvarniDatum?: Date;
    brojPaketa?: number;
    brojUgovora?: string | undefined;
    brojNarudzbenice?: string | undefined;
    brojOkvirnogSporazuma?: string | undefined;
    jeRobaTreceStrane?: boolean;
    status?: StatusEOtpremnice;
    napomena?: string | undefined;
    robaTreceStrane?: string | undefined;
    strankaId?: number;
    stranka?: Stranka | undefined;
    posiljalacKontaktOsobaId?: number | undefined;
    posiljalacKontakt?: KontaktOsoba | undefined;
    primalacKontaktOsobaId?: number | undefined;
    primalacKontakt?: KontaktOsoba | undefined;
    nacinOtpreme?: NacinOtpreme;
    licniNacinOtpreme?: LicniNacinOtpreme | undefined;
    adresaOtpremeId?: number;
    adresaOtpreme?: AdresaIsporuke | undefined;
    adresaOdredistaId?: number;
    adresaOdredista?: AdresaIsporuke | undefined;
    praviloZaBrojId?: number | undefined;
    racunId?: number | undefined;
    racun?: Racun | undefined;
    predracunId?: number | undefined;
    predracun?: Racun | undefined;
    fazeVoznje?: FazaVoznje[] | undefined;
    stavke?: StavkaOtpremnice[] | undefined;
    relevantniDokumenti?: EOtpremnicaRelevantniDokument[] | undefined;
    lagerTransakcije?: LagerTransakcija[] | undefined;
}

export class KontaktOsoba implements IKontaktOsoba {
    id?: number;
    ime?: string | undefined;
    telefon?: string | undefined;
    email?: string | undefined;
    eOtpremnicaBasePosiljalac?: EOtpremnicaBase[] | undefined;
    eOtpremnicaBasePrimalac?: EOtpremnicaBase[] | undefined;

    constructor(data?: IKontaktOsoba) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ime = _data["ime"];
            this.telefon = _data["telefon"];
            this.email = _data["email"];
            if (Array.isArray(_data["eOtpremnicaBasePosiljalac"])) {
                this.eOtpremnicaBasePosiljalac = [] as any;
                for (let item of _data["eOtpremnicaBasePosiljalac"])
                    this.eOtpremnicaBasePosiljalac!.push(EOtpremnicaBase.fromJS(item));
            }
            if (Array.isArray(_data["eOtpremnicaBasePrimalac"])) {
                this.eOtpremnicaBasePrimalac = [] as any;
                for (let item of _data["eOtpremnicaBasePrimalac"])
                    this.eOtpremnicaBasePrimalac!.push(EOtpremnicaBase.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KontaktOsoba {
        data = typeof data === 'object' ? data : {};
        let result = new KontaktOsoba();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ime"] = this.ime;
        data["telefon"] = this.telefon;
        data["email"] = this.email;
        if (Array.isArray(this.eOtpremnicaBasePosiljalac)) {
            data["eOtpremnicaBasePosiljalac"] = [];
            for (let item of this.eOtpremnicaBasePosiljalac)
                data["eOtpremnicaBasePosiljalac"].push(item.toJSON());
        }
        if (Array.isArray(this.eOtpremnicaBasePrimalac)) {
            data["eOtpremnicaBasePrimalac"] = [];
            for (let item of this.eOtpremnicaBasePrimalac)
                data["eOtpremnicaBasePrimalac"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKontaktOsoba {
    id?: number;
    ime?: string | undefined;
    telefon?: string | undefined;
    email?: string | undefined;
    eOtpremnicaBasePosiljalac?: EOtpremnicaBase[] | undefined;
    eOtpremnicaBasePrimalac?: EOtpremnicaBase[] | undefined;
}

export class LicniNacinOtpreme implements ILicniNacinOtpreme {
    id?: number;
    ime?: string | undefined;
    prezime?: string | undefined;
    brojLicneKarte?: string | undefined;
    eOtpremnicaBaseId?: number;
    eOtpremnicaBase?: EOtpremnicaBase | undefined;

    constructor(data?: ILicniNacinOtpreme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ime = _data["ime"];
            this.prezime = _data["prezime"];
            this.brojLicneKarte = _data["brojLicneKarte"];
            this.eOtpremnicaBaseId = _data["eOtpremnicaBaseId"];
            this.eOtpremnicaBase = _data["eOtpremnicaBase"] ? EOtpremnicaBase.fromJS(_data["eOtpremnicaBase"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LicniNacinOtpreme {
        data = typeof data === 'object' ? data : {};
        let result = new LicniNacinOtpreme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ime"] = this.ime;
        data["prezime"] = this.prezime;
        data["brojLicneKarte"] = this.brojLicneKarte;
        data["eOtpremnicaBaseId"] = this.eOtpremnicaBaseId;
        data["eOtpremnicaBase"] = this.eOtpremnicaBase ? this.eOtpremnicaBase.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILicniNacinOtpreme {
    id?: number;
    ime?: string | undefined;
    prezime?: string | undefined;
    brojLicneKarte?: string | undefined;
    eOtpremnicaBaseId?: number;
    eOtpremnicaBase?: EOtpremnicaBase | undefined;
}

export class AdresaIsporuke implements IAdresaIsporuke {
    id?: number;
    ulica?: string | undefined;
    broj?: string | undefined;
    mesto?: string | undefined;
    postanskiBroj?: string | undefined;
    magacin?: Magacin | undefined;
    magacinId?: number | undefined;
    sifraObjekta?: string | undefined;
    baseOtpreme?: EOtpremnicaBase[] | undefined;
    baseOdredista?: EOtpremnicaBase[] | undefined;

    constructor(data?: IAdresaIsporuke) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ulica = _data["ulica"];
            this.broj = _data["broj"];
            this.mesto = _data["mesto"];
            this.postanskiBroj = _data["postanskiBroj"];
            this.magacin = _data["magacin"] ? Magacin.fromJS(_data["magacin"]) : <any>undefined;
            this.magacinId = _data["magacinId"];
            this.sifraObjekta = _data["sifraObjekta"];
            if (Array.isArray(_data["baseOtpreme"])) {
                this.baseOtpreme = [] as any;
                for (let item of _data["baseOtpreme"])
                    this.baseOtpreme!.push(EOtpremnicaBase.fromJS(item));
            }
            if (Array.isArray(_data["baseOdredista"])) {
                this.baseOdredista = [] as any;
                for (let item of _data["baseOdredista"])
                    this.baseOdredista!.push(EOtpremnicaBase.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdresaIsporuke {
        data = typeof data === 'object' ? data : {};
        let result = new AdresaIsporuke();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ulica"] = this.ulica;
        data["broj"] = this.broj;
        data["mesto"] = this.mesto;
        data["postanskiBroj"] = this.postanskiBroj;
        data["magacin"] = this.magacin ? this.magacin.toJSON() : <any>undefined;
        data["magacinId"] = this.magacinId;
        data["sifraObjekta"] = this.sifraObjekta;
        if (Array.isArray(this.baseOtpreme)) {
            data["baseOtpreme"] = [];
            for (let item of this.baseOtpreme)
                data["baseOtpreme"].push(item.toJSON());
        }
        if (Array.isArray(this.baseOdredista)) {
            data["baseOdredista"] = [];
            for (let item of this.baseOdredista)
                data["baseOdredista"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAdresaIsporuke {
    id?: number;
    ulica?: string | undefined;
    broj?: string | undefined;
    mesto?: string | undefined;
    postanskiBroj?: string | undefined;
    magacin?: Magacin | undefined;
    magacinId?: number | undefined;
    sifraObjekta?: string | undefined;
    baseOtpreme?: EOtpremnicaBase[] | undefined;
    baseOdredista?: EOtpremnicaBase[] | undefined;
}

export class FazaVoznje implements IFazaVoznje {
    id?: number;
    mestoUtovara?: string | undefined;
    mestoIsporuke?: string | undefined;
    prevoznikId?: number;
    prevoznik?: Stranka | undefined;
    vozacFazeId?: number;
    vozac?: VozacFaze | undefined;
    redniBroj?: number;
    eOtpremnicaBaseId?: number;
    eOtpremnicaBase?: EOtpremnicaBase | undefined;

    constructor(data?: IFazaVoznje) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mestoUtovara = _data["mestoUtovara"];
            this.mestoIsporuke = _data["mestoIsporuke"];
            this.prevoznikId = _data["prevoznikId"];
            this.prevoznik = _data["prevoznik"] ? Stranka.fromJS(_data["prevoznik"]) : <any>undefined;
            this.vozacFazeId = _data["vozacFazeId"];
            this.vozac = _data["vozac"] ? VozacFaze.fromJS(_data["vozac"]) : <any>undefined;
            this.redniBroj = _data["redniBroj"];
            this.eOtpremnicaBaseId = _data["eOtpremnicaBaseId"];
            this.eOtpremnicaBase = _data["eOtpremnicaBase"] ? EOtpremnicaBase.fromJS(_data["eOtpremnicaBase"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FazaVoznje {
        data = typeof data === 'object' ? data : {};
        let result = new FazaVoznje();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mestoUtovara"] = this.mestoUtovara;
        data["mestoIsporuke"] = this.mestoIsporuke;
        data["prevoznikId"] = this.prevoznikId;
        data["prevoznik"] = this.prevoznik ? this.prevoznik.toJSON() : <any>undefined;
        data["vozacFazeId"] = this.vozacFazeId;
        data["vozac"] = this.vozac ? this.vozac.toJSON() : <any>undefined;
        data["redniBroj"] = this.redniBroj;
        data["eOtpremnicaBaseId"] = this.eOtpremnicaBaseId;
        data["eOtpremnicaBase"] = this.eOtpremnicaBase ? this.eOtpremnicaBase.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFazaVoznje {
    id?: number;
    mestoUtovara?: string | undefined;
    mestoIsporuke?: string | undefined;
    prevoznikId?: number;
    prevoznik?: Stranka | undefined;
    vozacFazeId?: number;
    vozac?: VozacFaze | undefined;
    redniBroj?: number;
    eOtpremnicaBaseId?: number;
    eOtpremnicaBase?: EOtpremnicaBase | undefined;
}

export class VozacFaze implements IVozacFaze {
    id?: number;
    ime?: string | undefined;
    prezime?: string | undefined;
    email?: string | undefined;
    telefon?: string | undefined;
    registarskiBrojVozila?: string | undefined;
    brojVozackeDozvole?: string | undefined;
    fazeVoznje?: FazaVoznje[] | undefined;

    constructor(data?: IVozacFaze) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ime = _data["ime"];
            this.prezime = _data["prezime"];
            this.email = _data["email"];
            this.telefon = _data["telefon"];
            this.registarskiBrojVozila = _data["registarskiBrojVozila"];
            this.brojVozackeDozvole = _data["brojVozackeDozvole"];
            if (Array.isArray(_data["fazeVoznje"])) {
                this.fazeVoznje = [] as any;
                for (let item of _data["fazeVoznje"])
                    this.fazeVoznje!.push(FazaVoznje.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VozacFaze {
        data = typeof data === 'object' ? data : {};
        let result = new VozacFaze();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ime"] = this.ime;
        data["prezime"] = this.prezime;
        data["email"] = this.email;
        data["telefon"] = this.telefon;
        data["registarskiBrojVozila"] = this.registarskiBrojVozila;
        data["brojVozackeDozvole"] = this.brojVozackeDozvole;
        if (Array.isArray(this.fazeVoznje)) {
            data["fazeVoznje"] = [];
            for (let item of this.fazeVoznje)
                data["fazeVoznje"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVozacFaze {
    id?: number;
    ime?: string | undefined;
    prezime?: string | undefined;
    email?: string | undefined;
    telefon?: string | undefined;
    registarskiBrojVozila?: string | undefined;
    brojVozackeDozvole?: string | undefined;
    fazeVoznje?: FazaVoznje[] | undefined;
}

export class StavkaOtpremnice implements IStavkaOtpremnice {
    id?: number;
    predmetStavkeId?: number | undefined;
    predmetStavke?: PredmetStavke | undefined;
    eOtpremnicaBaseId?: number;
    eOtpremnicaBase?: EOtpremnicaBase | undefined;
    redniBroj?: number;
    gtin?: string | undefined;
    naziv?: string | undefined;
    sifra?: string | undefined;
    kolicina?: number;
    jedinicaMereId?: number;
    jedinicaMere?: JedinicaMere | undefined;
    akciznaKategorija?: AkciznaKategorija | undefined;
    komentar?: string | undefined;
    pristiglaKolicina?: number | undefined;
    primljenaKolicina?: number | undefined;
    vracenaKolicina?: number | undefined;
    dodatniAtributi?: DodatniAtributStavke[] | undefined;

    constructor(data?: IStavkaOtpremnice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.predmetStavke = _data["predmetStavke"] ? PredmetStavke.fromJS(_data["predmetStavke"]) : <any>undefined;
            this.eOtpremnicaBaseId = _data["eOtpremnicaBaseId"];
            this.eOtpremnicaBase = _data["eOtpremnicaBase"] ? EOtpremnicaBase.fromJS(_data["eOtpremnicaBase"]) : <any>undefined;
            this.redniBroj = _data["redniBroj"];
            this.gtin = _data["gtin"];
            this.naziv = _data["naziv"];
            this.sifra = _data["sifra"];
            this.kolicina = _data["kolicina"];
            this.jedinicaMereId = _data["jedinicaMereId"];
            this.jedinicaMere = _data["jedinicaMere"] ? JedinicaMere.fromJS(_data["jedinicaMere"]) : <any>undefined;
            this.akciznaKategorija = _data["akciznaKategorija"] ? AkciznaKategorija.fromJS(_data["akciznaKategorija"]) : <any>undefined;
            this.komentar = _data["komentar"];
            this.pristiglaKolicina = _data["pristiglaKolicina"];
            this.primljenaKolicina = _data["primljenaKolicina"];
            this.vracenaKolicina = _data["vracenaKolicina"];
            if (Array.isArray(_data["dodatniAtributi"])) {
                this.dodatniAtributi = [] as any;
                for (let item of _data["dodatniAtributi"])
                    this.dodatniAtributi!.push(DodatniAtributStavke.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StavkaOtpremnice {
        data = typeof data === 'object' ? data : {};
        let result = new StavkaOtpremnice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["predmetStavke"] = this.predmetStavke ? this.predmetStavke.toJSON() : <any>undefined;
        data["eOtpremnicaBaseId"] = this.eOtpremnicaBaseId;
        data["eOtpremnicaBase"] = this.eOtpremnicaBase ? this.eOtpremnicaBase.toJSON() : <any>undefined;
        data["redniBroj"] = this.redniBroj;
        data["gtin"] = this.gtin;
        data["naziv"] = this.naziv;
        data["sifra"] = this.sifra;
        data["kolicina"] = this.kolicina;
        data["jedinicaMereId"] = this.jedinicaMereId;
        data["jedinicaMere"] = this.jedinicaMere ? this.jedinicaMere.toJSON() : <any>undefined;
        data["akciznaKategorija"] = this.akciznaKategorija ? this.akciznaKategorija.toJSON() : <any>undefined;
        data["komentar"] = this.komentar;
        data["pristiglaKolicina"] = this.pristiglaKolicina;
        data["primljenaKolicina"] = this.primljenaKolicina;
        data["vracenaKolicina"] = this.vracenaKolicina;
        if (Array.isArray(this.dodatniAtributi)) {
            data["dodatniAtributi"] = [];
            for (let item of this.dodatniAtributi)
                data["dodatniAtributi"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStavkaOtpremnice {
    id?: number;
    predmetStavkeId?: number | undefined;
    predmetStavke?: PredmetStavke | undefined;
    eOtpremnicaBaseId?: number;
    eOtpremnicaBase?: EOtpremnicaBase | undefined;
    redniBroj?: number;
    gtin?: string | undefined;
    naziv?: string | undefined;
    sifra?: string | undefined;
    kolicina?: number;
    jedinicaMereId?: number;
    jedinicaMere?: JedinicaMere | undefined;
    akciznaKategorija?: AkciznaKategorija | undefined;
    komentar?: string | undefined;
    pristiglaKolicina?: number | undefined;
    primljenaKolicina?: number | undefined;
    vracenaKolicina?: number | undefined;
    dodatniAtributi?: DodatniAtributStavke[] | undefined;
}

export class AkciznaKategorija implements IAkciznaKategorija {
    id?: number;
    stavkaOtpremniceId?: number;
    stavkaOtpremnice?: StavkaOtpremnice | undefined;
    tipAkcizneKategorije?: TipAkcizneKategorije;
    vrednost?: string | undefined;
    tipPakovanjaDuvana?: TipPakovanjaDuvana | undefined;
    sifraRobneMarke?: string | undefined;

    constructor(data?: IAkciznaKategorija) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stavkaOtpremniceId = _data["stavkaOtpremniceId"];
            this.stavkaOtpremnice = _data["stavkaOtpremnice"] ? StavkaOtpremnice.fromJS(_data["stavkaOtpremnice"]) : <any>undefined;
            this.tipAkcizneKategorije = _data["tipAkcizneKategorije"];
            this.vrednost = _data["vrednost"];
            this.tipPakovanjaDuvana = _data["tipPakovanjaDuvana"];
            this.sifraRobneMarke = _data["sifraRobneMarke"];
        }
    }

    static fromJS(data: any): AkciznaKategorija {
        data = typeof data === 'object' ? data : {};
        let result = new AkciznaKategorija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stavkaOtpremniceId"] = this.stavkaOtpremniceId;
        data["stavkaOtpremnice"] = this.stavkaOtpremnice ? this.stavkaOtpremnice.toJSON() : <any>undefined;
        data["tipAkcizneKategorije"] = this.tipAkcizneKategorije;
        data["vrednost"] = this.vrednost;
        data["tipPakovanjaDuvana"] = this.tipPakovanjaDuvana;
        data["sifraRobneMarke"] = this.sifraRobneMarke;
        return data;
    }
}

export interface IAkciznaKategorija {
    id?: number;
    stavkaOtpremniceId?: number;
    stavkaOtpremnice?: StavkaOtpremnice | undefined;
    tipAkcizneKategorije?: TipAkcizneKategorije;
    vrednost?: string | undefined;
    tipPakovanjaDuvana?: TipPakovanjaDuvana | undefined;
    sifraRobneMarke?: string | undefined;
}

export class DodatniAtributStavke implements IDodatniAtributStavke {
    id?: number;
    stavkaOtpremniceId?: number;
    stavkaOtpremnice?: StavkaOtpremnice | undefined;
    naziv?: string | undefined;
    vrednost?: string | undefined;

    constructor(data?: IDodatniAtributStavke) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stavkaOtpremniceId = _data["stavkaOtpremniceId"];
            this.stavkaOtpremnice = _data["stavkaOtpremnice"] ? StavkaOtpremnice.fromJS(_data["stavkaOtpremnice"]) : <any>undefined;
            this.naziv = _data["naziv"];
            this.vrednost = _data["vrednost"];
        }
    }

    static fromJS(data: any): DodatniAtributStavke {
        data = typeof data === 'object' ? data : {};
        let result = new DodatniAtributStavke();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stavkaOtpremniceId"] = this.stavkaOtpremniceId;
        data["stavkaOtpremnice"] = this.stavkaOtpremnice ? this.stavkaOtpremnice.toJSON() : <any>undefined;
        data["naziv"] = this.naziv;
        data["vrednost"] = this.vrednost;
        return data;
    }
}

export interface IDodatniAtributStavke {
    id?: number;
    stavkaOtpremniceId?: number;
    stavkaOtpremnice?: StavkaOtpremnice | undefined;
    naziv?: string | undefined;
    vrednost?: string | undefined;
}

export abstract class RelevantniDokument extends AuditableEntity implements IRelevantniDokument {
    originalFileName?: string | undefined;
    storageFileName?: string | undefined;
    storageFolder?: string | undefined;
    fullStoragePath?: string | undefined;
    tipRelevantnogDokumenta?: TipRelevantnogDokumenta;

    constructor(data?: IRelevantniDokument) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.originalFileName = _data["originalFileName"];
            this.storageFileName = _data["storageFileName"];
            this.storageFolder = _data["storageFolder"];
            this.fullStoragePath = _data["fullStoragePath"];
            this.tipRelevantnogDokumenta = _data["tipRelevantnogDokumenta"];
        }
    }

    static fromJS(data: any): RelevantniDokument {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RelevantniDokument' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalFileName"] = this.originalFileName;
        data["storageFileName"] = this.storageFileName;
        data["storageFolder"] = this.storageFolder;
        data["fullStoragePath"] = this.fullStoragePath;
        data["tipRelevantnogDokumenta"] = this.tipRelevantnogDokumenta;
        super.toJSON(data);
        return data;
    }
}

export interface IRelevantniDokument extends IAuditableEntity {
    originalFileName?: string | undefined;
    storageFileName?: string | undefined;
    storageFolder?: string | undefined;
    fullStoragePath?: string | undefined;
    tipRelevantnogDokumenta?: TipRelevantnogDokumenta;
}

export class EOtpremnicaRelevantniDokument extends RelevantniDokument implements IEOtpremnicaRelevantniDokument {
    eOtpremnicaRelevantniDokumentId?: number;
    otpremnicaId?: number;
    eOtpremnicaBase?: EOtpremnicaBase | undefined;
    datoteka?: Datoteka | undefined;

    constructor(data?: IEOtpremnicaRelevantniDokument) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.eOtpremnicaRelevantniDokumentId = _data["eOtpremnicaRelevantniDokumentId"];
            this.otpremnicaId = _data["otpremnicaId"];
            this.eOtpremnicaBase = _data["eOtpremnicaBase"] ? EOtpremnicaBase.fromJS(_data["eOtpremnicaBase"]) : <any>undefined;
            this.datoteka = _data["datoteka"] ? Datoteka.fromJS(_data["datoteka"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EOtpremnicaRelevantniDokument {
        data = typeof data === 'object' ? data : {};
        let result = new EOtpremnicaRelevantniDokument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eOtpremnicaRelevantniDokumentId"] = this.eOtpremnicaRelevantniDokumentId;
        data["otpremnicaId"] = this.otpremnicaId;
        data["eOtpremnicaBase"] = this.eOtpremnicaBase ? this.eOtpremnicaBase.toJSON() : <any>undefined;
        data["datoteka"] = this.datoteka ? this.datoteka.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IEOtpremnicaRelevantniDokument extends IRelevantniDokument {
    eOtpremnicaRelevantniDokumentId?: number;
    otpremnicaId?: number;
    eOtpremnicaBase?: EOtpremnicaBase | undefined;
    datoteka?: Datoteka | undefined;
}

export class Datoteka implements IDatoteka {
    datotekaId?: number;
    naziv?: string | undefined;
    storageFileName?: string | undefined;
    velicinaDokumenta?: number | undefined;
    tipFoldera?: TipFoldera;
    sefRacunRelevantniDokument?: SefRacunRelevantniDokument | undefined;
    sefRacunRelevantniDokumentId?: number | undefined;
    fiskalniRacunRelevantniDokument?: FiskalniRacunRelevantniDokument | undefined;
    fiskalniRacunRelevantniDokumentId?: number | undefined;
    racunRelevantniDokument?: RacunRelevantniDokument | undefined;
    racunRelevantniDokumentId?: number | undefined;
    eOtpremnicaRelevantniDokument?: EOtpremnicaRelevantniDokument | undefined;
    eOtpremnicaRelevantniDokumentId?: number | undefined;
    delovodniDokument?: DelovodniDokument | undefined;
    delovodniDokumentId?: number | undefined;
    folderName?: string | undefined;
    parentId?: number | undefined;
    parent?: Datoteka | undefined;
    children?: Datoteka[] | undefined;

    constructor(data?: IDatoteka) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datotekaId = _data["datotekaId"];
            this.naziv = _data["naziv"];
            this.storageFileName = _data["storageFileName"];
            this.velicinaDokumenta = _data["velicinaDokumenta"];
            this.tipFoldera = _data["tipFoldera"];
            this.sefRacunRelevantniDokument = _data["sefRacunRelevantniDokument"] ? SefRacunRelevantniDokument.fromJS(_data["sefRacunRelevantniDokument"]) : <any>undefined;
            this.sefRacunRelevantniDokumentId = _data["sefRacunRelevantniDokumentId"];
            this.fiskalniRacunRelevantniDokument = _data["fiskalniRacunRelevantniDokument"] ? FiskalniRacunRelevantniDokument.fromJS(_data["fiskalniRacunRelevantniDokument"]) : <any>undefined;
            this.fiskalniRacunRelevantniDokumentId = _data["fiskalniRacunRelevantniDokumentId"];
            this.racunRelevantniDokument = _data["racunRelevantniDokument"] ? RacunRelevantniDokument.fromJS(_data["racunRelevantniDokument"]) : <any>undefined;
            this.racunRelevantniDokumentId = _data["racunRelevantniDokumentId"];
            this.eOtpremnicaRelevantniDokument = _data["eOtpremnicaRelevantniDokument"] ? EOtpremnicaRelevantniDokument.fromJS(_data["eOtpremnicaRelevantniDokument"]) : <any>undefined;
            this.eOtpremnicaRelevantniDokumentId = _data["eOtpremnicaRelevantniDokumentId"];
            this.delovodniDokument = _data["delovodniDokument"] ? DelovodniDokument.fromJS(_data["delovodniDokument"]) : <any>undefined;
            this.delovodniDokumentId = _data["delovodniDokumentId"];
            this.folderName = _data["folderName"];
            this.parentId = _data["parentId"];
            this.parent = _data["parent"] ? Datoteka.fromJS(_data["parent"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(Datoteka.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Datoteka {
        data = typeof data === 'object' ? data : {};
        let result = new Datoteka();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datotekaId"] = this.datotekaId;
        data["naziv"] = this.naziv;
        data["storageFileName"] = this.storageFileName;
        data["velicinaDokumenta"] = this.velicinaDokumenta;
        data["tipFoldera"] = this.tipFoldera;
        data["sefRacunRelevantniDokument"] = this.sefRacunRelevantniDokument ? this.sefRacunRelevantniDokument.toJSON() : <any>undefined;
        data["sefRacunRelevantniDokumentId"] = this.sefRacunRelevantniDokumentId;
        data["fiskalniRacunRelevantniDokument"] = this.fiskalniRacunRelevantniDokument ? this.fiskalniRacunRelevantniDokument.toJSON() : <any>undefined;
        data["fiskalniRacunRelevantniDokumentId"] = this.fiskalniRacunRelevantniDokumentId;
        data["racunRelevantniDokument"] = this.racunRelevantniDokument ? this.racunRelevantniDokument.toJSON() : <any>undefined;
        data["racunRelevantniDokumentId"] = this.racunRelevantniDokumentId;
        data["eOtpremnicaRelevantniDokument"] = this.eOtpremnicaRelevantniDokument ? this.eOtpremnicaRelevantniDokument.toJSON() : <any>undefined;
        data["eOtpremnicaRelevantniDokumentId"] = this.eOtpremnicaRelevantniDokumentId;
        data["delovodniDokument"] = this.delovodniDokument ? this.delovodniDokument.toJSON() : <any>undefined;
        data["delovodniDokumentId"] = this.delovodniDokumentId;
        data["folderName"] = this.folderName;
        data["parentId"] = this.parentId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDatoteka {
    datotekaId?: number;
    naziv?: string | undefined;
    storageFileName?: string | undefined;
    velicinaDokumenta?: number | undefined;
    tipFoldera?: TipFoldera;
    sefRacunRelevantniDokument?: SefRacunRelevantniDokument | undefined;
    sefRacunRelevantniDokumentId?: number | undefined;
    fiskalniRacunRelevantniDokument?: FiskalniRacunRelevantniDokument | undefined;
    fiskalniRacunRelevantniDokumentId?: number | undefined;
    racunRelevantniDokument?: RacunRelevantniDokument | undefined;
    racunRelevantniDokumentId?: number | undefined;
    eOtpremnicaRelevantniDokument?: EOtpremnicaRelevantniDokument | undefined;
    eOtpremnicaRelevantniDokumentId?: number | undefined;
    delovodniDokument?: DelovodniDokument | undefined;
    delovodniDokumentId?: number | undefined;
    folderName?: string | undefined;
    parentId?: number | undefined;
    parent?: Datoteka | undefined;
    children?: Datoteka[] | undefined;
}

export class SefRacunRelevantniDokument extends RelevantniDokument implements ISefRacunRelevantniDokument {
    sefRacunRelevantniDokumentId?: number;
    sefRacunId?: number;
    sefRacun?: SefRacun | undefined;
    datoteka?: Datoteka | undefined;

    constructor(data?: ISefRacunRelevantniDokument) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sefRacunRelevantniDokumentId = _data["sefRacunRelevantniDokumentId"];
            this.sefRacunId = _data["sefRacunId"];
            this.sefRacun = _data["sefRacun"] ? SefRacun.fromJS(_data["sefRacun"]) : <any>undefined;
            this.datoteka = _data["datoteka"] ? Datoteka.fromJS(_data["datoteka"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SefRacunRelevantniDokument {
        data = typeof data === 'object' ? data : {};
        let result = new SefRacunRelevantniDokument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sefRacunRelevantniDokumentId"] = this.sefRacunRelevantniDokumentId;
        data["sefRacunId"] = this.sefRacunId;
        data["sefRacun"] = this.sefRacun ? this.sefRacun.toJSON() : <any>undefined;
        data["datoteka"] = this.datoteka ? this.datoteka.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISefRacunRelevantniDokument extends IRelevantniDokument {
    sefRacunRelevantniDokumentId?: number;
    sefRacunId?: number;
    sefRacun?: SefRacun | undefined;
    datoteka?: Datoteka | undefined;
}

export class SefRacun implements ISefRacun {
    sefRacunId?: number;
    sefId?: number;
    broj?: string | undefined;
    datumIzdavanja?: Date;
    datumValute?: Date;
    datumPrometa?: Date | undefined;
    pib?: string | undefined;
    maticniBroj?: string | undefined;
    tip?: TipRacuna;
    iznos?: number;
    stranka?: string | undefined;
    status?: StatusRacuna;
    razlogOtkazivanjaOdbijanja?: string | undefined;
    valutaAlphaChar?: string | undefined;
    jeKreiranUlazniRacun?: boolean;
    datumStorniranja?: Date | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    jeReferencaNaAvansniRacun?: boolean | undefined;
    relevantniDokumenti?: SefRacunRelevantniDokument[] | undefined;

    constructor(data?: ISefRacun) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sefRacunId = _data["sefRacunId"];
            this.sefId = _data["sefId"];
            this.broj = _data["broj"];
            this.datumIzdavanja = _data["datumIzdavanja"] ? new Date(_data["datumIzdavanja"].toString()) : <any>undefined;
            this.datumValute = _data["datumValute"] ? new Date(_data["datumValute"].toString()) : <any>undefined;
            this.datumPrometa = _data["datumPrometa"] ? new Date(_data["datumPrometa"].toString()) : <any>undefined;
            this.pib = _data["pib"];
            this.maticniBroj = _data["maticniBroj"];
            this.tip = _data["tip"];
            this.iznos = _data["iznos"];
            this.stranka = _data["stranka"];
            this.status = _data["status"];
            this.razlogOtkazivanjaOdbijanja = _data["razlogOtkazivanjaOdbijanja"];
            this.valutaAlphaChar = _data["valutaAlphaChar"];
            this.jeKreiranUlazniRacun = _data["jeKreiranUlazniRacun"];
            this.datumStorniranja = _data["datumStorniranja"] ? new Date(_data["datumStorniranja"].toString()) : <any>undefined;
            this.periodOd = _data["periodOd"] ? new Date(_data["periodOd"].toString()) : <any>undefined;
            this.periodDo = _data["periodDo"] ? new Date(_data["periodDo"].toString()) : <any>undefined;
            this.jeReferencaNaAvansniRacun = _data["jeReferencaNaAvansniRacun"];
            if (Array.isArray(_data["relevantniDokumenti"])) {
                this.relevantniDokumenti = [] as any;
                for (let item of _data["relevantniDokumenti"])
                    this.relevantniDokumenti!.push(SefRacunRelevantniDokument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SefRacun {
        data = typeof data === 'object' ? data : {};
        let result = new SefRacun();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sefRacunId"] = this.sefRacunId;
        data["sefId"] = this.sefId;
        data["broj"] = this.broj;
        data["datumIzdavanja"] = this.datumIzdavanja ? this.datumIzdavanja.toISOString() : <any>undefined;
        data["datumValute"] = this.datumValute ? this.datumValute.toISOString() : <any>undefined;
        data["datumPrometa"] = this.datumPrometa ? this.datumPrometa.toISOString() : <any>undefined;
        data["pib"] = this.pib;
        data["maticniBroj"] = this.maticniBroj;
        data["tip"] = this.tip;
        data["iznos"] = this.iznos;
        data["stranka"] = this.stranka;
        data["status"] = this.status;
        data["razlogOtkazivanjaOdbijanja"] = this.razlogOtkazivanjaOdbijanja;
        data["valutaAlphaChar"] = this.valutaAlphaChar;
        data["jeKreiranUlazniRacun"] = this.jeKreiranUlazniRacun;
        data["datumStorniranja"] = this.datumStorniranja ? this.datumStorniranja.toISOString() : <any>undefined;
        data["periodOd"] = this.periodOd ? this.periodOd.toISOString() : <any>undefined;
        data["periodDo"] = this.periodDo ? this.periodDo.toISOString() : <any>undefined;
        data["jeReferencaNaAvansniRacun"] = this.jeReferencaNaAvansniRacun;
        if (Array.isArray(this.relevantniDokumenti)) {
            data["relevantniDokumenti"] = [];
            for (let item of this.relevantniDokumenti)
                data["relevantniDokumenti"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISefRacun {
    sefRacunId?: number;
    sefId?: number;
    broj?: string | undefined;
    datumIzdavanja?: Date;
    datumValute?: Date;
    datumPrometa?: Date | undefined;
    pib?: string | undefined;
    maticniBroj?: string | undefined;
    tip?: TipRacuna;
    iznos?: number;
    stranka?: string | undefined;
    status?: StatusRacuna;
    razlogOtkazivanjaOdbijanja?: string | undefined;
    valutaAlphaChar?: string | undefined;
    jeKreiranUlazniRacun?: boolean;
    datumStorniranja?: Date | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    jeReferencaNaAvansniRacun?: boolean | undefined;
    relevantniDokumenti?: SefRacunRelevantniDokument[] | undefined;
}

export class FiskalniRacunRelevantniDokument extends RelevantniDokument implements IFiskalniRacunRelevantniDokument {
    fiskalniRacunRelevantniDokumentId?: number;
    invoiceResponseId?: number;
    invoiceResponse?: InvoiceResponse | undefined;
    fiskalniFileType?: FiskalniFileType;
    datoteka?: Datoteka | undefined;

    constructor(data?: IFiskalniRacunRelevantniDokument) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fiskalniRacunRelevantniDokumentId = _data["fiskalniRacunRelevantniDokumentId"];
            this.invoiceResponseId = _data["invoiceResponseId"];
            this.invoiceResponse = _data["invoiceResponse"] ? InvoiceResponse.fromJS(_data["invoiceResponse"]) : <any>undefined;
            this.fiskalniFileType = _data["fiskalniFileType"];
            this.datoteka = _data["datoteka"] ? Datoteka.fromJS(_data["datoteka"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FiskalniRacunRelevantniDokument {
        data = typeof data === 'object' ? data : {};
        let result = new FiskalniRacunRelevantniDokument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fiskalniRacunRelevantniDokumentId"] = this.fiskalniRacunRelevantniDokumentId;
        data["invoiceResponseId"] = this.invoiceResponseId;
        data["invoiceResponse"] = this.invoiceResponse ? this.invoiceResponse.toJSON() : <any>undefined;
        data["fiskalniFileType"] = this.fiskalniFileType;
        data["datoteka"] = this.datoteka ? this.datoteka.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFiskalniRacunRelevantniDokument extends IRelevantniDokument {
    fiskalniRacunRelevantniDokumentId?: number;
    invoiceResponseId?: number;
    invoiceResponse?: InvoiceResponse | undefined;
    fiskalniFileType?: FiskalniFileType;
    datoteka?: Datoteka | undefined;
}

export enum FiskalniFileType {
    FISKALNI_ISECAK = 0,
    QR_CODE = 1,
}

export class RacunRelevantniDokument extends RelevantniDokument implements IRacunRelevantniDokument {
    racunRelevantniDokumentId?: number;
    racunId?: number;
    racun?: Racun | undefined;
    datoteka?: Datoteka | undefined;

    constructor(data?: IRacunRelevantniDokument) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.racunRelevantniDokumentId = _data["racunRelevantniDokumentId"];
            this.racunId = _data["racunId"];
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
            this.datoteka = _data["datoteka"] ? Datoteka.fromJS(_data["datoteka"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RacunRelevantniDokument {
        data = typeof data === 'object' ? data : {};
        let result = new RacunRelevantniDokument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunRelevantniDokumentId"] = this.racunRelevantniDokumentId;
        data["racunId"] = this.racunId;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        data["datoteka"] = this.datoteka ? this.datoteka.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IRacunRelevantniDokument extends IRelevantniDokument {
    racunRelevantniDokumentId?: number;
    racunId?: number;
    racun?: Racun | undefined;
    datoteka?: Datoteka | undefined;
}

export class DelovodniDokument implements IDelovodniDokument {
    delovodniDokumentId?: number;
    osnovniBroj?: string | undefined;
    podbroj?: string | undefined;
    datumNastanka?: Date;
    datumUnosa?: Date;
    fileName?: string | undefined;
    originalFileName?: string | undefined;
    delovodnikId?: number;
    delovodnik?: Delovodnik | undefined;
    datoteka?: Datoteka | undefined;
    posaljilacId?: number | undefined;
    posaljilac?: Stranka | undefined;
    kategorijaId?: number;
    kategorija?: KategorijaDokumentarnogMaterijala | undefined;

    constructor(data?: IDelovodniDokument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delovodniDokumentId = _data["delovodniDokumentId"];
            this.osnovniBroj = _data["osnovniBroj"];
            this.podbroj = _data["podbroj"];
            this.datumNastanka = _data["datumNastanka"] ? new Date(_data["datumNastanka"].toString()) : <any>undefined;
            this.datumUnosa = _data["datumUnosa"] ? new Date(_data["datumUnosa"].toString()) : <any>undefined;
            this.fileName = _data["fileName"];
            this.originalFileName = _data["originalFileName"];
            this.delovodnikId = _data["delovodnikId"];
            this.delovodnik = _data["delovodnik"] ? Delovodnik.fromJS(_data["delovodnik"]) : <any>undefined;
            this.datoteka = _data["datoteka"] ? Datoteka.fromJS(_data["datoteka"]) : <any>undefined;
            this.posaljilacId = _data["posaljilacId"];
            this.posaljilac = _data["posaljilac"] ? Stranka.fromJS(_data["posaljilac"]) : <any>undefined;
            this.kategorijaId = _data["kategorijaId"];
            this.kategorija = _data["kategorija"] ? KategorijaDokumentarnogMaterijala.fromJS(_data["kategorija"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DelovodniDokument {
        data = typeof data === 'object' ? data : {};
        let result = new DelovodniDokument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delovodniDokumentId"] = this.delovodniDokumentId;
        data["osnovniBroj"] = this.osnovniBroj;
        data["podbroj"] = this.podbroj;
        data["datumNastanka"] = this.datumNastanka ? this.datumNastanka.toISOString() : <any>undefined;
        data["datumUnosa"] = this.datumUnosa ? this.datumUnosa.toISOString() : <any>undefined;
        data["fileName"] = this.fileName;
        data["originalFileName"] = this.originalFileName;
        data["delovodnikId"] = this.delovodnikId;
        data["delovodnik"] = this.delovodnik ? this.delovodnik.toJSON() : <any>undefined;
        data["datoteka"] = this.datoteka ? this.datoteka.toJSON() : <any>undefined;
        data["posaljilacId"] = this.posaljilacId;
        data["posaljilac"] = this.posaljilac ? this.posaljilac.toJSON() : <any>undefined;
        data["kategorijaId"] = this.kategorijaId;
        data["kategorija"] = this.kategorija ? this.kategorija.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDelovodniDokument {
    delovodniDokumentId?: number;
    osnovniBroj?: string | undefined;
    podbroj?: string | undefined;
    datumNastanka?: Date;
    datumUnosa?: Date;
    fileName?: string | undefined;
    originalFileName?: string | undefined;
    delovodnikId?: number;
    delovodnik?: Delovodnik | undefined;
    datoteka?: Datoteka | undefined;
    posaljilacId?: number | undefined;
    posaljilac?: Stranka | undefined;
    kategorijaId?: number;
    kategorija?: KategorijaDokumentarnogMaterijala | undefined;
}

export class Delovodnik extends AuditableEntity implements IDelovodnik {
    delovodnikId?: number;
    naziv?: string | undefined;
    sledeciSlobodanBroj?: number;
    praviloZaBrojId?: number;
    praviloZaBroj?: KonfiguracijaBrojaDelovodnogDokumenta | undefined;
    kategorijaId?: number | undefined;
    kategorija?: KategorijaDokumentarnogMaterijala | undefined;
    delovodniDokumenti?: DelovodniDokument[] | undefined;

    constructor(data?: IDelovodnik) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.delovodnikId = _data["delovodnikId"];
            this.naziv = _data["naziv"];
            this.sledeciSlobodanBroj = _data["sledeciSlobodanBroj"];
            this.praviloZaBrojId = _data["praviloZaBrojId"];
            this.praviloZaBroj = _data["praviloZaBroj"] ? KonfiguracijaBrojaDelovodnogDokumenta.fromJS(_data["praviloZaBroj"]) : <any>undefined;
            this.kategorijaId = _data["kategorijaId"];
            this.kategorija = _data["kategorija"] ? KategorijaDokumentarnogMaterijala.fromJS(_data["kategorija"]) : <any>undefined;
            if (Array.isArray(_data["delovodniDokumenti"])) {
                this.delovodniDokumenti = [] as any;
                for (let item of _data["delovodniDokumenti"])
                    this.delovodniDokumenti!.push(DelovodniDokument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Delovodnik {
        data = typeof data === 'object' ? data : {};
        let result = new Delovodnik();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delovodnikId"] = this.delovodnikId;
        data["naziv"] = this.naziv;
        data["sledeciSlobodanBroj"] = this.sledeciSlobodanBroj;
        data["praviloZaBrojId"] = this.praviloZaBrojId;
        data["praviloZaBroj"] = this.praviloZaBroj ? this.praviloZaBroj.toJSON() : <any>undefined;
        data["kategorijaId"] = this.kategorijaId;
        data["kategorija"] = this.kategorija ? this.kategorija.toJSON() : <any>undefined;
        if (Array.isArray(this.delovodniDokumenti)) {
            data["delovodniDokumenti"] = [];
            for (let item of this.delovodniDokumenti)
                data["delovodniDokumenti"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDelovodnik extends IAuditableEntity {
    delovodnikId?: number;
    naziv?: string | undefined;
    sledeciSlobodanBroj?: number;
    praviloZaBrojId?: number;
    praviloZaBroj?: KonfiguracijaBrojaDelovodnogDokumenta | undefined;
    kategorijaId?: number | undefined;
    kategorija?: KategorijaDokumentarnogMaterijala | undefined;
    delovodniDokumenti?: DelovodniDokument[] | undefined;
}

export class KonfiguracijaBrojaDelovodnogDokumenta extends AuditableEntity implements IKonfiguracijaBrojaDelovodnogDokumenta {
    konfiguracijaBrojaDelovodnogDokumentaId?: number;
    naziv?: string | undefined;
    prefiks?: string | undefined;
    brojac?: number;
    delovodnici?: Delovodnik[] | undefined;

    constructor(data?: IKonfiguracijaBrojaDelovodnogDokumenta) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.konfiguracijaBrojaDelovodnogDokumentaId = _data["konfiguracijaBrojaDelovodnogDokumentaId"];
            this.naziv = _data["naziv"];
            this.prefiks = _data["prefiks"];
            this.brojac = _data["brojac"];
            if (Array.isArray(_data["delovodnici"])) {
                this.delovodnici = [] as any;
                for (let item of _data["delovodnici"])
                    this.delovodnici!.push(Delovodnik.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KonfiguracijaBrojaDelovodnogDokumenta {
        data = typeof data === 'object' ? data : {};
        let result = new KonfiguracijaBrojaDelovodnogDokumenta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["konfiguracijaBrojaDelovodnogDokumentaId"] = this.konfiguracijaBrojaDelovodnogDokumentaId;
        data["naziv"] = this.naziv;
        data["prefiks"] = this.prefiks;
        data["brojac"] = this.brojac;
        if (Array.isArray(this.delovodnici)) {
            data["delovodnici"] = [];
            for (let item of this.delovodnici)
                data["delovodnici"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IKonfiguracijaBrojaDelovodnogDokumenta extends IAuditableEntity {
    konfiguracijaBrojaDelovodnogDokumentaId?: number;
    naziv?: string | undefined;
    prefiks?: string | undefined;
    brojac?: number;
    delovodnici?: Delovodnik[] | undefined;
}

export class KategorijaDokumentarnogMaterijala extends AuditableEntity implements IKategorijaDokumentarnogMaterijala {
    kategorijaId?: number;
    naziv?: string | undefined;
    klasifikacionaOznaka?: string | undefined;
    rokCuvanja?: number;
    grupaId?: number;
    grupa?: GrupaKategorijaDokumentarnogMaterijala | undefined;
    delovodnici?: Delovodnik[] | undefined;
    delovodniDokumenti?: DelovodniDokument[] | undefined;

    constructor(data?: IKategorijaDokumentarnogMaterijala) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.kategorijaId = _data["kategorijaId"];
            this.naziv = _data["naziv"];
            this.klasifikacionaOznaka = _data["klasifikacionaOznaka"];
            this.rokCuvanja = _data["rokCuvanja"];
            this.grupaId = _data["grupaId"];
            this.grupa = _data["grupa"] ? GrupaKategorijaDokumentarnogMaterijala.fromJS(_data["grupa"]) : <any>undefined;
            if (Array.isArray(_data["delovodnici"])) {
                this.delovodnici = [] as any;
                for (let item of _data["delovodnici"])
                    this.delovodnici!.push(Delovodnik.fromJS(item));
            }
            if (Array.isArray(_data["delovodniDokumenti"])) {
                this.delovodniDokumenti = [] as any;
                for (let item of _data["delovodniDokumenti"])
                    this.delovodniDokumenti!.push(DelovodniDokument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KategorijaDokumentarnogMaterijala {
        data = typeof data === 'object' ? data : {};
        let result = new KategorijaDokumentarnogMaterijala();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kategorijaId"] = this.kategorijaId;
        data["naziv"] = this.naziv;
        data["klasifikacionaOznaka"] = this.klasifikacionaOznaka;
        data["rokCuvanja"] = this.rokCuvanja;
        data["grupaId"] = this.grupaId;
        data["grupa"] = this.grupa ? this.grupa.toJSON() : <any>undefined;
        if (Array.isArray(this.delovodnici)) {
            data["delovodnici"] = [];
            for (let item of this.delovodnici)
                data["delovodnici"].push(item.toJSON());
        }
        if (Array.isArray(this.delovodniDokumenti)) {
            data["delovodniDokumenti"] = [];
            for (let item of this.delovodniDokumenti)
                data["delovodniDokumenti"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IKategorijaDokumentarnogMaterijala extends IAuditableEntity {
    kategorijaId?: number;
    naziv?: string | undefined;
    klasifikacionaOznaka?: string | undefined;
    rokCuvanja?: number;
    grupaId?: number;
    grupa?: GrupaKategorijaDokumentarnogMaterijala | undefined;
    delovodnici?: Delovodnik[] | undefined;
    delovodniDokumenti?: DelovodniDokument[] | undefined;
}

export class GrupaKategorijaDokumentarnogMaterijala extends AuditableEntity implements IGrupaKategorijaDokumentarnogMaterijala {
    grupaId?: number;
    naziv?: string | undefined;
    jeImportovana?: boolean;

    constructor(data?: IGrupaKategorijaDokumentarnogMaterijala) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.grupaId = _data["grupaId"];
            this.naziv = _data["naziv"];
            this.jeImportovana = _data["jeImportovana"];
        }
    }

    static fromJS(data: any): GrupaKategorijaDokumentarnogMaterijala {
        data = typeof data === 'object' ? data : {};
        let result = new GrupaKategorijaDokumentarnogMaterijala();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grupaId"] = this.grupaId;
        data["naziv"] = this.naziv;
        data["jeImportovana"] = this.jeImportovana;
        super.toJSON(data);
        return data;
    }
}

export interface IGrupaKategorijaDokumentarnogMaterijala extends IAuditableEntity {
    grupaId?: number;
    naziv?: string | undefined;
    jeImportovana?: boolean;
}

export class OznakaMagacina implements IOznakaMagacina {
    oznakaId?: number;
    oznaka?: Oznaka | undefined;
    magacinId?: number;
    magacin?: Magacin | undefined;

    constructor(data?: IOznakaMagacina) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oznakaId = _data["oznakaId"];
            this.oznaka = _data["oznaka"] ? Oznaka.fromJS(_data["oznaka"]) : <any>undefined;
            this.magacinId = _data["magacinId"];
            this.magacin = _data["magacin"] ? Magacin.fromJS(_data["magacin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OznakaMagacina {
        data = typeof data === 'object' ? data : {};
        let result = new OznakaMagacina();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oznakaId"] = this.oznakaId;
        data["oznaka"] = this.oznaka ? this.oznaka.toJSON() : <any>undefined;
        data["magacinId"] = this.magacinId;
        data["magacin"] = this.magacin ? this.magacin.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOznakaMagacina {
    oznakaId?: number;
    oznaka?: Oznaka | undefined;
    magacinId?: number;
    magacin?: Magacin | undefined;
}

export class Oznaka implements IOznaka {
    oznakaId?: number;
    naziv?: string | undefined;
    punNaziv?: string | undefined;
    tipOznake?: TipOznake;
    tipEntiteta?: TipEntiteta;
    parentId?: number | undefined;
    parent?: Oznaka | undefined;
    children?: Oznaka[] | undefined;
    oznakeRacuna?: OznakaRacuna[] | undefined;
    oznakeStranaka?: OznakaStranke[] | undefined;
    oznakePredmetaStavki?: OznakaPredmetaStavke[] | undefined;
    oznakeMagacina?: OznakaMagacina[] | undefined;
    oznakeStavkiRacuna?: OznakaStavkeRacuna[] | undefined;

    constructor(data?: IOznaka) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oznakaId = _data["oznakaId"];
            this.naziv = _data["naziv"];
            this.punNaziv = _data["punNaziv"];
            this.tipOznake = _data["tipOznake"];
            this.tipEntiteta = _data["tipEntiteta"];
            this.parentId = _data["parentId"];
            this.parent = _data["parent"] ? Oznaka.fromJS(_data["parent"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(Oznaka.fromJS(item));
            }
            if (Array.isArray(_data["oznakeRacuna"])) {
                this.oznakeRacuna = [] as any;
                for (let item of _data["oznakeRacuna"])
                    this.oznakeRacuna!.push(OznakaRacuna.fromJS(item));
            }
            if (Array.isArray(_data["oznakeStranaka"])) {
                this.oznakeStranaka = [] as any;
                for (let item of _data["oznakeStranaka"])
                    this.oznakeStranaka!.push(OznakaStranke.fromJS(item));
            }
            if (Array.isArray(_data["oznakePredmetaStavki"])) {
                this.oznakePredmetaStavki = [] as any;
                for (let item of _data["oznakePredmetaStavki"])
                    this.oznakePredmetaStavki!.push(OznakaPredmetaStavke.fromJS(item));
            }
            if (Array.isArray(_data["oznakeMagacina"])) {
                this.oznakeMagacina = [] as any;
                for (let item of _data["oznakeMagacina"])
                    this.oznakeMagacina!.push(OznakaMagacina.fromJS(item));
            }
            if (Array.isArray(_data["oznakeStavkiRacuna"])) {
                this.oznakeStavkiRacuna = [] as any;
                for (let item of _data["oznakeStavkiRacuna"])
                    this.oznakeStavkiRacuna!.push(OznakaStavkeRacuna.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Oznaka {
        data = typeof data === 'object' ? data : {};
        let result = new Oznaka();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oznakaId"] = this.oznakaId;
        data["naziv"] = this.naziv;
        data["punNaziv"] = this.punNaziv;
        data["tipOznake"] = this.tipOznake;
        data["tipEntiteta"] = this.tipEntiteta;
        data["parentId"] = this.parentId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        if (Array.isArray(this.oznakeRacuna)) {
            data["oznakeRacuna"] = [];
            for (let item of this.oznakeRacuna)
                data["oznakeRacuna"].push(item.toJSON());
        }
        if (Array.isArray(this.oznakeStranaka)) {
            data["oznakeStranaka"] = [];
            for (let item of this.oznakeStranaka)
                data["oznakeStranaka"].push(item.toJSON());
        }
        if (Array.isArray(this.oznakePredmetaStavki)) {
            data["oznakePredmetaStavki"] = [];
            for (let item of this.oznakePredmetaStavki)
                data["oznakePredmetaStavki"].push(item.toJSON());
        }
        if (Array.isArray(this.oznakeMagacina)) {
            data["oznakeMagacina"] = [];
            for (let item of this.oznakeMagacina)
                data["oznakeMagacina"].push(item.toJSON());
        }
        if (Array.isArray(this.oznakeStavkiRacuna)) {
            data["oznakeStavkiRacuna"] = [];
            for (let item of this.oznakeStavkiRacuna)
                data["oznakeStavkiRacuna"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOznaka {
    oznakaId?: number;
    naziv?: string | undefined;
    punNaziv?: string | undefined;
    tipOznake?: TipOznake;
    tipEntiteta?: TipEntiteta;
    parentId?: number | undefined;
    parent?: Oznaka | undefined;
    children?: Oznaka[] | undefined;
    oznakeRacuna?: OznakaRacuna[] | undefined;
    oznakeStranaka?: OznakaStranke[] | undefined;
    oznakePredmetaStavki?: OznakaPredmetaStavke[] | undefined;
    oznakeMagacina?: OznakaMagacina[] | undefined;
    oznakeStavkiRacuna?: OznakaStavkeRacuna[] | undefined;
}

export class OznakaRacuna implements IOznakaRacuna {
    oznakaId?: number;
    oznaka?: Oznaka | undefined;
    racunId?: number;
    racun?: Racun | undefined;

    constructor(data?: IOznakaRacuna) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oznakaId = _data["oznakaId"];
            this.oznaka = _data["oznaka"] ? Oznaka.fromJS(_data["oznaka"]) : <any>undefined;
            this.racunId = _data["racunId"];
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OznakaRacuna {
        data = typeof data === 'object' ? data : {};
        let result = new OznakaRacuna();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oznakaId"] = this.oznakaId;
        data["oznaka"] = this.oznaka ? this.oznaka.toJSON() : <any>undefined;
        data["racunId"] = this.racunId;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOznakaRacuna {
    oznakaId?: number;
    oznaka?: Oznaka | undefined;
    racunId?: number;
    racun?: Racun | undefined;
}

export class OznakaStranke implements IOznakaStranke {
    oznakaId?: number;
    oznaka?: Oznaka | undefined;
    strankaId?: number;
    stranka?: Stranka | undefined;

    constructor(data?: IOznakaStranke) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oznakaId = _data["oznakaId"];
            this.oznaka = _data["oznaka"] ? Oznaka.fromJS(_data["oznaka"]) : <any>undefined;
            this.strankaId = _data["strankaId"];
            this.stranka = _data["stranka"] ? Stranka.fromJS(_data["stranka"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OznakaStranke {
        data = typeof data === 'object' ? data : {};
        let result = new OznakaStranke();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oznakaId"] = this.oznakaId;
        data["oznaka"] = this.oznaka ? this.oznaka.toJSON() : <any>undefined;
        data["strankaId"] = this.strankaId;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOznakaStranke {
    oznakaId?: number;
    oznaka?: Oznaka | undefined;
    strankaId?: number;
    stranka?: Stranka | undefined;
}

export class OznakaPredmetaStavke implements IOznakaPredmetaStavke {
    oznakaId?: number;
    oznaka?: Oznaka | undefined;
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;

    constructor(data?: IOznakaPredmetaStavke) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oznakaId = _data["oznakaId"];
            this.oznaka = _data["oznaka"] ? Oznaka.fromJS(_data["oznaka"]) : <any>undefined;
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.predmetStavke = _data["predmetStavke"] ? PredmetStavke.fromJS(_data["predmetStavke"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OznakaPredmetaStavke {
        data = typeof data === 'object' ? data : {};
        let result = new OznakaPredmetaStavke();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oznakaId"] = this.oznakaId;
        data["oznaka"] = this.oznaka ? this.oznaka.toJSON() : <any>undefined;
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["predmetStavke"] = this.predmetStavke ? this.predmetStavke.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOznakaPredmetaStavke {
    oznakaId?: number;
    oznaka?: Oznaka | undefined;
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;
}

export class OznakaStavkeRacuna implements IOznakaStavkeRacuna {
    oznakaId?: number;
    oznaka?: Oznaka | undefined;
    stavkaRacunaId?: number;
    stavkaRacuna?: StavkaRacuna | undefined;
    kolicina?: number | undefined;
    iznos?: number | undefined;

    constructor(data?: IOznakaStavkeRacuna) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oznakaId = _data["oznakaId"];
            this.oznaka = _data["oznaka"] ? Oznaka.fromJS(_data["oznaka"]) : <any>undefined;
            this.stavkaRacunaId = _data["stavkaRacunaId"];
            this.stavkaRacuna = _data["stavkaRacuna"] ? StavkaRacuna.fromJS(_data["stavkaRacuna"]) : <any>undefined;
            this.kolicina = _data["kolicina"];
            this.iznos = _data["iznos"];
        }
    }

    static fromJS(data: any): OznakaStavkeRacuna {
        data = typeof data === 'object' ? data : {};
        let result = new OznakaStavkeRacuna();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oznakaId"] = this.oznakaId;
        data["oznaka"] = this.oznaka ? this.oznaka.toJSON() : <any>undefined;
        data["stavkaRacunaId"] = this.stavkaRacunaId;
        data["stavkaRacuna"] = this.stavkaRacuna ? this.stavkaRacuna.toJSON() : <any>undefined;
        data["kolicina"] = this.kolicina;
        data["iznos"] = this.iznos;
        return data;
    }
}

export interface IOznakaStavkeRacuna {
    oznakaId?: number;
    oznaka?: Oznaka | undefined;
    stavkaRacunaId?: number;
    stavkaRacuna?: StavkaRacuna | undefined;
    kolicina?: number | undefined;
    iznos?: number | undefined;
}

export class PoreskaKategorijaStavkeRacuna implements IPoreskaKategorijaStavkeRacuna {
    poreskaKategorijaRacunaId?: number;
    stavkaRacunaId?: number;
    stavkaRacuna?: StavkaRacuna | undefined;
    poreskaKategorijaId?: number;
    poreskaKategorija?: PoreskaKategorija | undefined;
    razlogPdvIzuzecaId?: number | undefined;
    razlogPdvIzuzeca?: RazlogPdvIzuzeca | undefined;
    brojOdluke?: string | undefined;

    constructor(data?: IPoreskaKategorijaStavkeRacuna) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poreskaKategorijaRacunaId = _data["poreskaKategorijaRacunaId"];
            this.stavkaRacunaId = _data["stavkaRacunaId"];
            this.stavkaRacuna = _data["stavkaRacuna"] ? StavkaRacuna.fromJS(_data["stavkaRacuna"]) : <any>undefined;
            this.poreskaKategorijaId = _data["poreskaKategorijaId"];
            this.poreskaKategorija = _data["poreskaKategorija"] ? PoreskaKategorija.fromJS(_data["poreskaKategorija"]) : <any>undefined;
            this.razlogPdvIzuzecaId = _data["razlogPdvIzuzecaId"];
            this.razlogPdvIzuzeca = _data["razlogPdvIzuzeca"] ? RazlogPdvIzuzeca.fromJS(_data["razlogPdvIzuzeca"]) : <any>undefined;
            this.brojOdluke = _data["brojOdluke"];
        }
    }

    static fromJS(data: any): PoreskaKategorijaStavkeRacuna {
        data = typeof data === 'object' ? data : {};
        let result = new PoreskaKategorijaStavkeRacuna();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poreskaKategorijaRacunaId"] = this.poreskaKategorijaRacunaId;
        data["stavkaRacunaId"] = this.stavkaRacunaId;
        data["stavkaRacuna"] = this.stavkaRacuna ? this.stavkaRacuna.toJSON() : <any>undefined;
        data["poreskaKategorijaId"] = this.poreskaKategorijaId;
        data["poreskaKategorija"] = this.poreskaKategorija ? this.poreskaKategorija.toJSON() : <any>undefined;
        data["razlogPdvIzuzecaId"] = this.razlogPdvIzuzecaId;
        data["razlogPdvIzuzeca"] = this.razlogPdvIzuzeca ? this.razlogPdvIzuzeca.toJSON() : <any>undefined;
        data["brojOdluke"] = this.brojOdluke;
        return data;
    }
}

export interface IPoreskaKategorijaStavkeRacuna {
    poreskaKategorijaRacunaId?: number;
    stavkaRacunaId?: number;
    stavkaRacuna?: StavkaRacuna | undefined;
    poreskaKategorijaId?: number;
    poreskaKategorija?: PoreskaKategorija | undefined;
    razlogPdvIzuzecaId?: number | undefined;
    razlogPdvIzuzeca?: RazlogPdvIzuzeca | undefined;
    brojOdluke?: string | undefined;
}

export class PoreskaKategorija implements IPoreskaKategorija {
    poreskaKategorijaId?: number;
    naziv?: string | undefined;
    oznaka?: OznakaPdvKategorije;
    stopa?: number;
    opis?: string | undefined;
    racuni?: PoreskaKategorijaStavkeRacuna[] | undefined;

    constructor(data?: IPoreskaKategorija) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poreskaKategorijaId = _data["poreskaKategorijaId"];
            this.naziv = _data["naziv"];
            this.oznaka = _data["oznaka"];
            this.stopa = _data["stopa"];
            this.opis = _data["opis"];
            if (Array.isArray(_data["racuni"])) {
                this.racuni = [] as any;
                for (let item of _data["racuni"])
                    this.racuni!.push(PoreskaKategorijaStavkeRacuna.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PoreskaKategorija {
        data = typeof data === 'object' ? data : {};
        let result = new PoreskaKategorija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poreskaKategorijaId"] = this.poreskaKategorijaId;
        data["naziv"] = this.naziv;
        data["oznaka"] = this.oznaka;
        data["stopa"] = this.stopa;
        data["opis"] = this.opis;
        if (Array.isArray(this.racuni)) {
            data["racuni"] = [];
            for (let item of this.racuni)
                data["racuni"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPoreskaKategorija {
    poreskaKategorijaId?: number;
    naziv?: string | undefined;
    oznaka?: OznakaPdvKategorije;
    stopa?: number;
    opis?: string | undefined;
    racuni?: PoreskaKategorijaStavkeRacuna[] | undefined;
}

export class StavkaRacunaSastavnica implements IStavkaRacunaSastavnica {
    stavkaRacunaSastavnicaId?: number;
    materijalId?: number;
    materijal?: StavkaRacuna | undefined;
    proizvodId?: number;
    proizvod?: StavkaRacuna | undefined;

    constructor(data?: IStavkaRacunaSastavnica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stavkaRacunaSastavnicaId = _data["stavkaRacunaSastavnicaId"];
            this.materijalId = _data["materijalId"];
            this.materijal = _data["materijal"] ? StavkaRacuna.fromJS(_data["materijal"]) : <any>undefined;
            this.proizvodId = _data["proizvodId"];
            this.proizvod = _data["proizvod"] ? StavkaRacuna.fromJS(_data["proizvod"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StavkaRacunaSastavnica {
        data = typeof data === 'object' ? data : {};
        let result = new StavkaRacunaSastavnica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stavkaRacunaSastavnicaId"] = this.stavkaRacunaSastavnicaId;
        data["materijalId"] = this.materijalId;
        data["materijal"] = this.materijal ? this.materijal.toJSON() : <any>undefined;
        data["proizvodId"] = this.proizvodId;
        data["proizvod"] = this.proizvod ? this.proizvod.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStavkaRacunaSastavnica {
    stavkaRacunaSastavnicaId?: number;
    materijalId?: number;
    materijal?: StavkaRacuna | undefined;
    proizvodId?: number;
    proizvod?: StavkaRacuna | undefined;
}

export class EOtpremnica extends EOtpremnicaBase implements IEOtpremnica {
    jedinicaMereTezina?: JedinicaMere | undefined;
    jedinicaMereTezinaId?: number | undefined;
    jedinicaMereZapremina?: JedinicaMere | undefined;
    jedinicaMereZapreminaId?: number | undefined;
    planiraniDatumPocetka?: Date | undefined;
    planiraniDatumZavrsetka?: Date;
    napomenaIsporuke?: string | undefined;
    povratRobe?: boolean;
    pocetakVoznje?: boolean | undefined;
    datumPocetkaVoznje?: Date | undefined;
    fizickiPrijemDatum?: Date | undefined;
    opasneMaterije?: OpasnaMaterija[] | undefined;
    razlogStorniranja?: string | undefined;

    constructor(data?: IEOtpremnica) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jedinicaMereTezina = _data["jedinicaMereTezina"] ? JedinicaMere.fromJS(_data["jedinicaMereTezina"]) : <any>undefined;
            this.jedinicaMereTezinaId = _data["jedinicaMereTezinaId"];
            this.jedinicaMereZapremina = _data["jedinicaMereZapremina"] ? JedinicaMere.fromJS(_data["jedinicaMereZapremina"]) : <any>undefined;
            this.jedinicaMereZapreminaId = _data["jedinicaMereZapreminaId"];
            this.planiraniDatumPocetka = _data["planiraniDatumPocetka"] ? new Date(_data["planiraniDatumPocetka"].toString()) : <any>undefined;
            this.planiraniDatumZavrsetka = _data["planiraniDatumZavrsetka"] ? new Date(_data["planiraniDatumZavrsetka"].toString()) : <any>undefined;
            this.napomenaIsporuke = _data["napomenaIsporuke"];
            this.povratRobe = _data["povratRobe"];
            this.pocetakVoznje = _data["pocetakVoznje"];
            this.datumPocetkaVoznje = _data["datumPocetkaVoznje"] ? new Date(_data["datumPocetkaVoznje"].toString()) : <any>undefined;
            this.fizickiPrijemDatum = _data["fizickiPrijemDatum"] ? new Date(_data["fizickiPrijemDatum"].toString()) : <any>undefined;
            if (Array.isArray(_data["opasneMaterije"])) {
                this.opasneMaterije = [] as any;
                for (let item of _data["opasneMaterije"])
                    this.opasneMaterije!.push(OpasnaMaterija.fromJS(item));
            }
            this.razlogStorniranja = _data["razlogStorniranja"];
        }
    }

    static fromJS(data: any): EOtpremnica {
        data = typeof data === 'object' ? data : {};
        let result = new EOtpremnica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jedinicaMereTezina"] = this.jedinicaMereTezina ? this.jedinicaMereTezina.toJSON() : <any>undefined;
        data["jedinicaMereTezinaId"] = this.jedinicaMereTezinaId;
        data["jedinicaMereZapremina"] = this.jedinicaMereZapremina ? this.jedinicaMereZapremina.toJSON() : <any>undefined;
        data["jedinicaMereZapreminaId"] = this.jedinicaMereZapreminaId;
        data["planiraniDatumPocetka"] = this.planiraniDatumPocetka ? this.planiraniDatumPocetka.toISOString() : <any>undefined;
        data["planiraniDatumZavrsetka"] = this.planiraniDatumZavrsetka ? this.planiraniDatumZavrsetka.toISOString() : <any>undefined;
        data["napomenaIsporuke"] = this.napomenaIsporuke;
        data["povratRobe"] = this.povratRobe;
        data["pocetakVoznje"] = this.pocetakVoznje;
        data["datumPocetkaVoznje"] = this.datumPocetkaVoznje ? this.datumPocetkaVoznje.toISOString() : <any>undefined;
        data["fizickiPrijemDatum"] = this.fizickiPrijemDatum ? this.fizickiPrijemDatum.toISOString() : <any>undefined;
        if (Array.isArray(this.opasneMaterije)) {
            data["opasneMaterije"] = [];
            for (let item of this.opasneMaterije)
                data["opasneMaterije"].push(item.toJSON());
        }
        data["razlogStorniranja"] = this.razlogStorniranja;
        super.toJSON(data);
        return data;
    }
}

export interface IEOtpremnica extends IEOtpremnicaBase {
    jedinicaMereTezina?: JedinicaMere | undefined;
    jedinicaMereTezinaId?: number | undefined;
    jedinicaMereZapremina?: JedinicaMere | undefined;
    jedinicaMereZapreminaId?: number | undefined;
    planiraniDatumPocetka?: Date | undefined;
    planiraniDatumZavrsetka?: Date;
    napomenaIsporuke?: string | undefined;
    povratRobe?: boolean;
    pocetakVoznje?: boolean | undefined;
    datumPocetkaVoznje?: Date | undefined;
    fizickiPrijemDatum?: Date | undefined;
    opasneMaterije?: OpasnaMaterija[] | undefined;
    razlogStorniranja?: string | undefined;
}

export class OpasnaMaterija implements IOpasnaMaterija {
    id?: number;
    eOtpremnicaId?: number;
    eOtpremnica?: EOtpremnica | undefined;
    naziv?: string | undefined;
    vrednost?: string | undefined;
    komentar?: string | undefined;

    constructor(data?: IOpasnaMaterija) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eOtpremnicaId = _data["eOtpremnicaId"];
            this.eOtpremnica = _data["eOtpremnica"] ? EOtpremnica.fromJS(_data["eOtpremnica"]) : <any>undefined;
            this.naziv = _data["naziv"];
            this.vrednost = _data["vrednost"];
            this.komentar = _data["komentar"];
        }
    }

    static fromJS(data: any): OpasnaMaterija {
        data = typeof data === 'object' ? data : {};
        let result = new OpasnaMaterija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eOtpremnicaId"] = this.eOtpremnicaId;
        data["eOtpremnica"] = this.eOtpremnica ? this.eOtpremnica.toJSON() : <any>undefined;
        data["naziv"] = this.naziv;
        data["vrednost"] = this.vrednost;
        data["komentar"] = this.komentar;
        return data;
    }
}

export interface IOpasnaMaterija {
    id?: number;
    eOtpremnicaId?: number;
    eOtpremnica?: EOtpremnica | undefined;
    naziv?: string | undefined;
    vrednost?: string | undefined;
    komentar?: string | undefined;
}

export class CenovnikStavka implements ICenovnikStavka {
    cenovnikStavkaId?: number;
    nabavnaCena?: number;
    prodajnaCenaBezPdv?: number;
    prodajnaCenaSaPdv?: number;
    cenovnikId?: number;
    cenovnik?: Cenovnik | undefined;
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;
    robaVarijacijaId?: number | undefined;
    robaVarijacija?: RobaVarijacija | undefined;

    constructor(data?: ICenovnikStavka) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cenovnikStavkaId = _data["cenovnikStavkaId"];
            this.nabavnaCena = _data["nabavnaCena"];
            this.prodajnaCenaBezPdv = _data["prodajnaCenaBezPdv"];
            this.prodajnaCenaSaPdv = _data["prodajnaCenaSaPdv"];
            this.cenovnikId = _data["cenovnikId"];
            this.cenovnik = _data["cenovnik"] ? Cenovnik.fromJS(_data["cenovnik"]) : <any>undefined;
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.predmetStavke = _data["predmetStavke"] ? PredmetStavke.fromJS(_data["predmetStavke"]) : <any>undefined;
            this.robaVarijacijaId = _data["robaVarijacijaId"];
            this.robaVarijacija = _data["robaVarijacija"] ? RobaVarijacija.fromJS(_data["robaVarijacija"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CenovnikStavka {
        data = typeof data === 'object' ? data : {};
        let result = new CenovnikStavka();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cenovnikStavkaId"] = this.cenovnikStavkaId;
        data["nabavnaCena"] = this.nabavnaCena;
        data["prodajnaCenaBezPdv"] = this.prodajnaCenaBezPdv;
        data["prodajnaCenaSaPdv"] = this.prodajnaCenaSaPdv;
        data["cenovnikId"] = this.cenovnikId;
        data["cenovnik"] = this.cenovnik ? this.cenovnik.toJSON() : <any>undefined;
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["predmetStavke"] = this.predmetStavke ? this.predmetStavke.toJSON() : <any>undefined;
        data["robaVarijacijaId"] = this.robaVarijacijaId;
        data["robaVarijacija"] = this.robaVarijacija ? this.robaVarijacija.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICenovnikStavka {
    cenovnikStavkaId?: number;
    nabavnaCena?: number;
    prodajnaCenaBezPdv?: number;
    prodajnaCenaSaPdv?: number;
    cenovnikId?: number;
    cenovnik?: Cenovnik | undefined;
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;
    robaVarijacijaId?: number | undefined;
    robaVarijacija?: RobaVarijacija | undefined;
}

export class Cenovnik extends AuditableEntity implements ICenovnik {
    cenovnikId?: number;
    naziv?: string | undefined;
    vrstaEntiteta?: VrstaEntiteta;
    stavkeCenovnika?: CenovnikStavka[] | undefined;
    cenovnikStranke?: CenovnikStranka[] | undefined;

    constructor(data?: ICenovnik) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cenovnikId = _data["cenovnikId"];
            this.naziv = _data["naziv"];
            this.vrstaEntiteta = _data["vrstaEntiteta"];
            if (Array.isArray(_data["stavkeCenovnika"])) {
                this.stavkeCenovnika = [] as any;
                for (let item of _data["stavkeCenovnika"])
                    this.stavkeCenovnika!.push(CenovnikStavka.fromJS(item));
            }
            if (Array.isArray(_data["cenovnikStranke"])) {
                this.cenovnikStranke = [] as any;
                for (let item of _data["cenovnikStranke"])
                    this.cenovnikStranke!.push(CenovnikStranka.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Cenovnik {
        data = typeof data === 'object' ? data : {};
        let result = new Cenovnik();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cenovnikId"] = this.cenovnikId;
        data["naziv"] = this.naziv;
        data["vrstaEntiteta"] = this.vrstaEntiteta;
        if (Array.isArray(this.stavkeCenovnika)) {
            data["stavkeCenovnika"] = [];
            for (let item of this.stavkeCenovnika)
                data["stavkeCenovnika"].push(item.toJSON());
        }
        if (Array.isArray(this.cenovnikStranke)) {
            data["cenovnikStranke"] = [];
            for (let item of this.cenovnikStranke)
                data["cenovnikStranke"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICenovnik extends IAuditableEntity {
    cenovnikId?: number;
    naziv?: string | undefined;
    vrstaEntiteta?: VrstaEntiteta;
    stavkeCenovnika?: CenovnikStavka[] | undefined;
    cenovnikStranke?: CenovnikStranka[] | undefined;
}

export class CenovnikStranka implements ICenovnikStranka {
    cenovnikStrankaId?: number;
    pocetakVazenja?: Date;
    zavrsetakVazenja?: Date;
    cenovnikId?: number;
    cenovnik?: Cenovnik | undefined;
    strankaId?: number;
    stranka?: Stranka | undefined;

    constructor(data?: ICenovnikStranka) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cenovnikStrankaId = _data["cenovnikStrankaId"];
            this.pocetakVazenja = _data["pocetakVazenja"] ? new Date(_data["pocetakVazenja"].toString()) : <any>undefined;
            this.zavrsetakVazenja = _data["zavrsetakVazenja"] ? new Date(_data["zavrsetakVazenja"].toString()) : <any>undefined;
            this.cenovnikId = _data["cenovnikId"];
            this.cenovnik = _data["cenovnik"] ? Cenovnik.fromJS(_data["cenovnik"]) : <any>undefined;
            this.strankaId = _data["strankaId"];
            this.stranka = _data["stranka"] ? Stranka.fromJS(_data["stranka"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CenovnikStranka {
        data = typeof data === 'object' ? data : {};
        let result = new CenovnikStranka();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cenovnikStrankaId"] = this.cenovnikStrankaId;
        data["pocetakVazenja"] = this.pocetakVazenja ? this.pocetakVazenja.toISOString() : <any>undefined;
        data["zavrsetakVazenja"] = this.zavrsetakVazenja ? this.zavrsetakVazenja.toISOString() : <any>undefined;
        data["cenovnikId"] = this.cenovnikId;
        data["cenovnik"] = this.cenovnik ? this.cenovnik.toJSON() : <any>undefined;
        data["strankaId"] = this.strankaId;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICenovnikStranka {
    cenovnikStrankaId?: number;
    pocetakVazenja?: Date;
    zavrsetakVazenja?: Date;
    cenovnikId?: number;
    cenovnik?: Cenovnik | undefined;
    strankaId?: number;
    stranka?: Stranka | undefined;
}

export class RobaVarijacija implements IRobaVarijacija {
    robaVarijacijaId?: number;
    parentPredmetStavkeId?: number;
    parentPredmetStavke?: PredmetStavke | undefined;
    sifra?: string | undefined;
    stanjeZaliha?: WcStockStatus;
    tezinaKg?: number | undefined;
    slikeFileNames?: string[] | undefined;
    atributVrijednosti?: { [key: string]: string; } | undefined;
    wcVarijacijaId?: number | undefined;
    wcSyncedAt?: Date | undefined;
    wcSyncStatus?: WcSyncStatus;
    wcSyncError?: string | undefined;
    cenovnikStavke?: CenovnikStavka[] | undefined;

    constructor(data?: IRobaVarijacija) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.robaVarijacijaId = _data["robaVarijacijaId"];
            this.parentPredmetStavkeId = _data["parentPredmetStavkeId"];
            this.parentPredmetStavke = _data["parentPredmetStavke"] ? PredmetStavke.fromJS(_data["parentPredmetStavke"]) : <any>undefined;
            this.sifra = _data["sifra"];
            this.stanjeZaliha = _data["stanjeZaliha"];
            this.tezinaKg = _data["tezinaKg"];
            if (Array.isArray(_data["slikeFileNames"])) {
                this.slikeFileNames = [] as any;
                for (let item of _data["slikeFileNames"])
                    this.slikeFileNames!.push(item);
            }
            if (_data["atributVrijednosti"]) {
                this.atributVrijednosti = {} as any;
                for (let key in _data["atributVrijednosti"]) {
                    if (_data["atributVrijednosti"].hasOwnProperty(key))
                        (<any>this.atributVrijednosti)![key] = _data["atributVrijednosti"][key];
                }
            }
            this.wcVarijacijaId = _data["wcVarijacijaId"];
            this.wcSyncedAt = _data["wcSyncedAt"] ? new Date(_data["wcSyncedAt"].toString()) : <any>undefined;
            this.wcSyncStatus = _data["wcSyncStatus"];
            this.wcSyncError = _data["wcSyncError"];
            if (Array.isArray(_data["cenovnikStavke"])) {
                this.cenovnikStavke = [] as any;
                for (let item of _data["cenovnikStavke"])
                    this.cenovnikStavke!.push(CenovnikStavka.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RobaVarijacija {
        data = typeof data === 'object' ? data : {};
        let result = new RobaVarijacija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["robaVarijacijaId"] = this.robaVarijacijaId;
        data["parentPredmetStavkeId"] = this.parentPredmetStavkeId;
        data["parentPredmetStavke"] = this.parentPredmetStavke ? this.parentPredmetStavke.toJSON() : <any>undefined;
        data["sifra"] = this.sifra;
        data["stanjeZaliha"] = this.stanjeZaliha;
        data["tezinaKg"] = this.tezinaKg;
        if (Array.isArray(this.slikeFileNames)) {
            data["slikeFileNames"] = [];
            for (let item of this.slikeFileNames)
                data["slikeFileNames"].push(item);
        }
        if (this.atributVrijednosti) {
            data["atributVrijednosti"] = {};
            for (let key in this.atributVrijednosti) {
                if (this.atributVrijednosti.hasOwnProperty(key))
                    (<any>data["atributVrijednosti"])[key] = (<any>this.atributVrijednosti)[key];
            }
        }
        data["wcVarijacijaId"] = this.wcVarijacijaId;
        data["wcSyncedAt"] = this.wcSyncedAt ? this.wcSyncedAt.toISOString() : <any>undefined;
        data["wcSyncStatus"] = this.wcSyncStatus;
        data["wcSyncError"] = this.wcSyncError;
        if (Array.isArray(this.cenovnikStavke)) {
            data["cenovnikStavke"] = [];
            for (let item of this.cenovnikStavke)
                data["cenovnikStavke"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRobaVarijacija {
    robaVarijacijaId?: number;
    parentPredmetStavkeId?: number;
    parentPredmetStavke?: PredmetStavke | undefined;
    sifra?: string | undefined;
    stanjeZaliha?: WcStockStatus;
    tezinaKg?: number | undefined;
    slikeFileNames?: string[] | undefined;
    atributVrijednosti?: { [key: string]: string; } | undefined;
    wcVarijacijaId?: number | undefined;
    wcSyncedAt?: Date | undefined;
    wcSyncStatus?: WcSyncStatus;
    wcSyncError?: string | undefined;
    cenovnikStavke?: CenovnikStavka[] | undefined;
}

export enum WcStockStatus {
    InStock = 0,
    OutOfStock = 1,
    OnBackorder = 2,
}

export enum WcSyncStatus {
    PENDING = 0,
    SYNCED = 1,
    ERROR = 2,
}

export class RobaWcKategorija implements IRobaWcKategorija {
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;
    wcKategorijaId?: number;
    wcKategorija?: WcKategorija | undefined;

    constructor(data?: IRobaWcKategorija) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.predmetStavke = _data["predmetStavke"] ? PredmetStavke.fromJS(_data["predmetStavke"]) : <any>undefined;
            this.wcKategorijaId = _data["wcKategorijaId"];
            this.wcKategorija = _data["wcKategorija"] ? WcKategorija.fromJS(_data["wcKategorija"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RobaWcKategorija {
        data = typeof data === 'object' ? data : {};
        let result = new RobaWcKategorija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["predmetStavke"] = this.predmetStavke ? this.predmetStavke.toJSON() : <any>undefined;
        data["wcKategorijaId"] = this.wcKategorijaId;
        data["wcKategorija"] = this.wcKategorija ? this.wcKategorija.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRobaWcKategorija {
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;
    wcKategorijaId?: number;
    wcKategorija?: WcKategorija | undefined;
}

export class WcKategorija implements IWcKategorija {
    wcKategorijaId?: number;
    kompanijaId?: number;
    naziv?: string | undefined;
    slug?: string | undefined;
    opis?: string | undefined;
    parentKategorijaId?: number | undefined;
    slikanFileName?: string | undefined;
    redosljadPrikaza?: number;
    wcKategorijaExtId?: number | undefined;
    wcSyncedAt?: Date | undefined;
    wcSyncStatus?: WcSyncStatus;
    wcSyncError?: string | undefined;
    parentKategorija?: WcKategorija | undefined;
    podKategorije?: WcKategorija[] | undefined;
    robe?: RobaWcKategorija[] | undefined;

    constructor(data?: IWcKategorija) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wcKategorijaId = _data["wcKategorijaId"];
            this.kompanijaId = _data["kompanijaId"];
            this.naziv = _data["naziv"];
            this.slug = _data["slug"];
            this.opis = _data["opis"];
            this.parentKategorijaId = _data["parentKategorijaId"];
            this.slikanFileName = _data["slikanFileName"];
            this.redosljadPrikaza = _data["redosljadPrikaza"];
            this.wcKategorijaExtId = _data["wcKategorijaExtId"];
            this.wcSyncedAt = _data["wcSyncedAt"] ? new Date(_data["wcSyncedAt"].toString()) : <any>undefined;
            this.wcSyncStatus = _data["wcSyncStatus"];
            this.wcSyncError = _data["wcSyncError"];
            this.parentKategorija = _data["parentKategorija"] ? WcKategorija.fromJS(_data["parentKategorija"]) : <any>undefined;
            if (Array.isArray(_data["podKategorije"])) {
                this.podKategorije = [] as any;
                for (let item of _data["podKategorije"])
                    this.podKategorije!.push(WcKategorija.fromJS(item));
            }
            if (Array.isArray(_data["robe"])) {
                this.robe = [] as any;
                for (let item of _data["robe"])
                    this.robe!.push(RobaWcKategorija.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WcKategorija {
        data = typeof data === 'object' ? data : {};
        let result = new WcKategorija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wcKategorijaId"] = this.wcKategorijaId;
        data["kompanijaId"] = this.kompanijaId;
        data["naziv"] = this.naziv;
        data["slug"] = this.slug;
        data["opis"] = this.opis;
        data["parentKategorijaId"] = this.parentKategorijaId;
        data["slikanFileName"] = this.slikanFileName;
        data["redosljadPrikaza"] = this.redosljadPrikaza;
        data["wcKategorijaExtId"] = this.wcKategorijaExtId;
        data["wcSyncedAt"] = this.wcSyncedAt ? this.wcSyncedAt.toISOString() : <any>undefined;
        data["wcSyncStatus"] = this.wcSyncStatus;
        data["wcSyncError"] = this.wcSyncError;
        data["parentKategorija"] = this.parentKategorija ? this.parentKategorija.toJSON() : <any>undefined;
        if (Array.isArray(this.podKategorije)) {
            data["podKategorije"] = [];
            for (let item of this.podKategorije)
                data["podKategorije"].push(item.toJSON());
        }
        if (Array.isArray(this.robe)) {
            data["robe"] = [];
            for (let item of this.robe)
                data["robe"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWcKategorija {
    wcKategorijaId?: number;
    kompanijaId?: number;
    naziv?: string | undefined;
    slug?: string | undefined;
    opis?: string | undefined;
    parentKategorijaId?: number | undefined;
    slikanFileName?: string | undefined;
    redosljadPrikaza?: number;
    wcKategorijaExtId?: number | undefined;
    wcSyncedAt?: Date | undefined;
    wcSyncStatus?: WcSyncStatus;
    wcSyncError?: string | undefined;
    parentKategorija?: WcKategorija | undefined;
    podKategorije?: WcKategorija[] | undefined;
    robe?: RobaWcKategorija[] | undefined;
}

export class PredmetStavkeSefMap implements IPredmetStavkeSefMap {
    predmetStavkeSefMapId?: number;
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;
    strankaId?: number;
    stranka?: Stranka | undefined;
    sellerItemIdentification?: string | undefined;
    buyerItemIdentification?: string | undefined;
    standardItemIdentification?: string | undefined;

    constructor(data?: IPredmetStavkeSefMap) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predmetStavkeSefMapId = _data["predmetStavkeSefMapId"];
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.predmetStavke = _data["predmetStavke"] ? PredmetStavke.fromJS(_data["predmetStavke"]) : <any>undefined;
            this.strankaId = _data["strankaId"];
            this.stranka = _data["stranka"] ? Stranka.fromJS(_data["stranka"]) : <any>undefined;
            this.sellerItemIdentification = _data["sellerItemIdentification"];
            this.buyerItemIdentification = _data["buyerItemIdentification"];
            this.standardItemIdentification = _data["standardItemIdentification"];
        }
    }

    static fromJS(data: any): PredmetStavkeSefMap {
        data = typeof data === 'object' ? data : {};
        let result = new PredmetStavkeSefMap();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predmetStavkeSefMapId"] = this.predmetStavkeSefMapId;
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["predmetStavke"] = this.predmetStavke ? this.predmetStavke.toJSON() : <any>undefined;
        data["strankaId"] = this.strankaId;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        data["sellerItemIdentification"] = this.sellerItemIdentification;
        data["buyerItemIdentification"] = this.buyerItemIdentification;
        data["standardItemIdentification"] = this.standardItemIdentification;
        return data;
    }
}

export interface IPredmetStavkeSefMap {
    predmetStavkeSefMapId?: number;
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;
    strankaId?: number;
    stranka?: Stranka | undefined;
    sellerItemIdentification?: string | undefined;
    buyerItemIdentification?: string | undefined;
    standardItemIdentification?: string | undefined;
}

export class InvoiceItem implements IInvoiceItem {
    invoiceItemId?: number;
    gtin?: string | undefined;
    name?: string | undefined;
    quantity?: number;
    totalAmount?: number;
    unitPrice?: number;
    discount?: number | undefined;
    label?: string | undefined;
    invoiceRequestId?: string;
    invoiceRequest?: InvoiceRequest | undefined;
    magacinId?: number | undefined;
    magacin?: Magacin | undefined;
    predmetStavkeId?: number | undefined;
    predmetStavke?: PredmetStavke | undefined;

    constructor(data?: IInvoiceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceItemId = _data["invoiceItemId"];
            this.gtin = _data["gtin"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.totalAmount = _data["totalAmount"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.label = _data["label"];
            this.invoiceRequestId = _data["invoiceRequestId"];
            this.invoiceRequest = _data["invoiceRequest"] ? InvoiceRequest.fromJS(_data["invoiceRequest"]) : <any>undefined;
            this.magacinId = _data["magacinId"];
            this.magacin = _data["magacin"] ? Magacin.fromJS(_data["magacin"]) : <any>undefined;
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.predmetStavke = _data["predmetStavke"] ? PredmetStavke.fromJS(_data["predmetStavke"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoiceItem {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceItemId"] = this.invoiceItemId;
        data["gtin"] = this.gtin;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["totalAmount"] = this.totalAmount;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["label"] = this.label;
        data["invoiceRequestId"] = this.invoiceRequestId;
        data["invoiceRequest"] = this.invoiceRequest ? this.invoiceRequest.toJSON() : <any>undefined;
        data["magacinId"] = this.magacinId;
        data["magacin"] = this.magacin ? this.magacin.toJSON() : <any>undefined;
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["predmetStavke"] = this.predmetStavke ? this.predmetStavke.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInvoiceItem {
    invoiceItemId?: number;
    gtin?: string | undefined;
    name?: string | undefined;
    quantity?: number;
    totalAmount?: number;
    unitPrice?: number;
    discount?: number | undefined;
    label?: string | undefined;
    invoiceRequestId?: string;
    invoiceRequest?: InvoiceRequest | undefined;
    magacinId?: number | undefined;
    magacin?: Magacin | undefined;
    predmetStavkeId?: number | undefined;
    predmetStavke?: PredmetStavke | undefined;
}

export class KalkulacijaStavka extends AuditableEntity implements IKalkulacijaStavka {
    kalkulacijaStavkaId?: number;
    nazivRobe?: string | undefined;
    jedinicaMereNaziv?: string | undefined;
    kolicina?: number;
    nabavnaCenaPoJm?: number;
    nabavnaCena?: number;
    zavisniTroskovi?: number;
    razlikaUCeni?: number;
    marza?: number;
    prodajnaCenaBezPdv?: number;
    pdvStopa?: number;
    obracunatiPdvIznos?: number;
    prodajnaCenaSaPdv?: number;
    prodajnaCenaPoJm?: number;
    napomena?: string | undefined;
    kalkulacijaId?: number;
    kalkulacija?: Kalkulacija | undefined;
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;

    constructor(data?: IKalkulacijaStavka) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.kalkulacijaStavkaId = _data["kalkulacijaStavkaId"];
            this.nazivRobe = _data["nazivRobe"];
            this.jedinicaMereNaziv = _data["jedinicaMereNaziv"];
            this.kolicina = _data["kolicina"];
            this.nabavnaCenaPoJm = _data["nabavnaCenaPoJm"];
            this.nabavnaCena = _data["nabavnaCena"];
            this.zavisniTroskovi = _data["zavisniTroskovi"];
            this.razlikaUCeni = _data["razlikaUCeni"];
            this.marza = _data["marza"];
            this.prodajnaCenaBezPdv = _data["prodajnaCenaBezPdv"];
            this.pdvStopa = _data["pdvStopa"];
            this.obracunatiPdvIznos = _data["obracunatiPdvIznos"];
            this.prodajnaCenaSaPdv = _data["prodajnaCenaSaPdv"];
            this.prodajnaCenaPoJm = _data["prodajnaCenaPoJm"];
            this.napomena = _data["napomena"];
            this.kalkulacijaId = _data["kalkulacijaId"];
            this.kalkulacija = _data["kalkulacija"] ? Kalkulacija.fromJS(_data["kalkulacija"]) : <any>undefined;
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.predmetStavke = _data["predmetStavke"] ? PredmetStavke.fromJS(_data["predmetStavke"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KalkulacijaStavka {
        data = typeof data === 'object' ? data : {};
        let result = new KalkulacijaStavka();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kalkulacijaStavkaId"] = this.kalkulacijaStavkaId;
        data["nazivRobe"] = this.nazivRobe;
        data["jedinicaMereNaziv"] = this.jedinicaMereNaziv;
        data["kolicina"] = this.kolicina;
        data["nabavnaCenaPoJm"] = this.nabavnaCenaPoJm;
        data["nabavnaCena"] = this.nabavnaCena;
        data["zavisniTroskovi"] = this.zavisniTroskovi;
        data["razlikaUCeni"] = this.razlikaUCeni;
        data["marza"] = this.marza;
        data["prodajnaCenaBezPdv"] = this.prodajnaCenaBezPdv;
        data["pdvStopa"] = this.pdvStopa;
        data["obracunatiPdvIznos"] = this.obracunatiPdvIznos;
        data["prodajnaCenaSaPdv"] = this.prodajnaCenaSaPdv;
        data["prodajnaCenaPoJm"] = this.prodajnaCenaPoJm;
        data["napomena"] = this.napomena;
        data["kalkulacijaId"] = this.kalkulacijaId;
        data["kalkulacija"] = this.kalkulacija ? this.kalkulacija.toJSON() : <any>undefined;
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["predmetStavke"] = this.predmetStavke ? this.predmetStavke.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IKalkulacijaStavka extends IAuditableEntity {
    kalkulacijaStavkaId?: number;
    nazivRobe?: string | undefined;
    jedinicaMereNaziv?: string | undefined;
    kolicina?: number;
    nabavnaCenaPoJm?: number;
    nabavnaCena?: number;
    zavisniTroskovi?: number;
    razlikaUCeni?: number;
    marza?: number;
    prodajnaCenaBezPdv?: number;
    pdvStopa?: number;
    obracunatiPdvIznos?: number;
    prodajnaCenaSaPdv?: number;
    prodajnaCenaPoJm?: number;
    napomena?: string | undefined;
    kalkulacijaId?: number;
    kalkulacija?: Kalkulacija | undefined;
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;
}

export class Kalkulacija extends AuditableEntity implements IKalkulacija {
    kalkulacijaId?: number;
    broj?: string | undefined;
    datumIzdavanja?: Date;
    racun?: Racun | undefined;
    racunId?: number | undefined;
    listaStavki?: KalkulacijaStavka[] | undefined;

    constructor(data?: IKalkulacija) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.kalkulacijaId = _data["kalkulacijaId"];
            this.broj = _data["broj"];
            this.datumIzdavanja = _data["datumIzdavanja"] ? new Date(_data["datumIzdavanja"].toString()) : <any>undefined;
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
            this.racunId = _data["racunId"];
            if (Array.isArray(_data["listaStavki"])) {
                this.listaStavki = [] as any;
                for (let item of _data["listaStavki"])
                    this.listaStavki!.push(KalkulacijaStavka.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Kalkulacija {
        data = typeof data === 'object' ? data : {};
        let result = new Kalkulacija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kalkulacijaId"] = this.kalkulacijaId;
        data["broj"] = this.broj;
        data["datumIzdavanja"] = this.datumIzdavanja ? this.datumIzdavanja.toISOString() : <any>undefined;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        data["racunId"] = this.racunId;
        if (Array.isArray(this.listaStavki)) {
            data["listaStavki"] = [];
            for (let item of this.listaStavki)
                data["listaStavki"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IKalkulacija extends IAuditableEntity {
    kalkulacijaId?: number;
    broj?: string | undefined;
    datumIzdavanja?: Date;
    racun?: Racun | undefined;
    racunId?: number | undefined;
    listaStavki?: KalkulacijaStavka[] | undefined;
}

export class Sastavnica implements ISastavnica {
    sastavnicaId?: number;
    kolicina?: number;
    materijalId?: number;
    materijal?: PredmetStavke | undefined;
    proizvodId?: number;
    proizvod?: PredmetStavke | undefined;

    constructor(data?: ISastavnica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sastavnicaId = _data["sastavnicaId"];
            this.kolicina = _data["kolicina"];
            this.materijalId = _data["materijalId"];
            this.materijal = _data["materijal"] ? PredmetStavke.fromJS(_data["materijal"]) : <any>undefined;
            this.proizvodId = _data["proizvodId"];
            this.proizvod = _data["proizvod"] ? PredmetStavke.fromJS(_data["proizvod"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Sastavnica {
        data = typeof data === 'object' ? data : {};
        let result = new Sastavnica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sastavnicaId"] = this.sastavnicaId;
        data["kolicina"] = this.kolicina;
        data["materijalId"] = this.materijalId;
        data["materijal"] = this.materijal ? this.materijal.toJSON() : <any>undefined;
        data["proizvodId"] = this.proizvodId;
        data["proizvod"] = this.proizvod ? this.proizvod.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISastavnica {
    sastavnicaId?: number;
    kolicina?: number;
    materijalId?: number;
    materijal?: PredmetStavke | undefined;
    proizvodId?: number;
    proizvod?: PredmetStavke | undefined;
}

export class Usluga implements IUsluga {
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;
    packageType?: SubscriptionPackage;

    constructor(data?: IUsluga) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.predmetStavke = _data["predmetStavke"] ? PredmetStavke.fromJS(_data["predmetStavke"]) : <any>undefined;
            this.packageType = _data["packageType"];
        }
    }

    static fromJS(data: any): Usluga {
        data = typeof data === 'object' ? data : {};
        let result = new Usluga();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["predmetStavke"] = this.predmetStavke ? this.predmetStavke.toJSON() : <any>undefined;
        data["packageType"] = this.packageType;
        return data;
    }
}

export interface IUsluga {
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;
    packageType?: SubscriptionPackage;
}

export enum SubscriptionPackage {
    ROOT = 0,
    EFAKTURE = 1,
    PROIZVODNJA = 2,
    FINANSIJE = 3,
    VELEPRODAJA = 4,
    ARHIVA = 5,
    FISKALNA_KASA = 6,
    MALOPRODAJA = 7,
    KORISNICKI_NALOG = 8,
    FISKLANI_API = 9,
    EFAKTURE_API = 10,
    BESPLATNO = 11,
    PROSTOR = 12,
    PRODAJNO_MESTO = 13,
    INFO_ZGRADA = 14,
    NAPREDNA_PRAVA_PRISTUPA = 15,
    EOTPREMNICE = 16,
    EOTPREMNICE_API = 17,
    EMPTY = 99,
}

export class Roba implements IRoba {
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;
    masaPoJedinici?: number | undefined;
    napomena?: string | undefined;
    kategorijaId?: number | undefined;
    kategorija?: Oznaka | undefined;
    nazivNaEngleskom?: string | undefined;
    netoTezinaKg?: number;
    tarifniBroj?: TarifniBroj | undefined;
    repromaterijali?: RepromaterijalZaRobu[] | undefined;
    barkodovi?: RobaBarkod[] | undefined;

    constructor(data?: IRoba) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.predmetStavke = _data["predmetStavke"] ? PredmetStavke.fromJS(_data["predmetStavke"]) : <any>undefined;
            this.masaPoJedinici = _data["masaPoJedinici"];
            this.napomena = _data["napomena"];
            this.kategorijaId = _data["kategorijaId"];
            this.kategorija = _data["kategorija"] ? Oznaka.fromJS(_data["kategorija"]) : <any>undefined;
            this.nazivNaEngleskom = _data["nazivNaEngleskom"];
            this.netoTezinaKg = _data["netoTezinaKg"];
            this.tarifniBroj = _data["tarifniBroj"] ? TarifniBroj.fromJS(_data["tarifniBroj"]) : <any>undefined;
            if (Array.isArray(_data["repromaterijali"])) {
                this.repromaterijali = [] as any;
                for (let item of _data["repromaterijali"])
                    this.repromaterijali!.push(RepromaterijalZaRobu.fromJS(item));
            }
            if (Array.isArray(_data["barkodovi"])) {
                this.barkodovi = [] as any;
                for (let item of _data["barkodovi"])
                    this.barkodovi!.push(RobaBarkod.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Roba {
        data = typeof data === 'object' ? data : {};
        let result = new Roba();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["predmetStavke"] = this.predmetStavke ? this.predmetStavke.toJSON() : <any>undefined;
        data["masaPoJedinici"] = this.masaPoJedinici;
        data["napomena"] = this.napomena;
        data["kategorijaId"] = this.kategorijaId;
        data["kategorija"] = this.kategorija ? this.kategorija.toJSON() : <any>undefined;
        data["nazivNaEngleskom"] = this.nazivNaEngleskom;
        data["netoTezinaKg"] = this.netoTezinaKg;
        data["tarifniBroj"] = this.tarifniBroj ? this.tarifniBroj.toJSON() : <any>undefined;
        if (Array.isArray(this.repromaterijali)) {
            data["repromaterijali"] = [];
            for (let item of this.repromaterijali)
                data["repromaterijali"].push(item.toJSON());
        }
        if (Array.isArray(this.barkodovi)) {
            data["barkodovi"] = [];
            for (let item of this.barkodovi)
                data["barkodovi"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoba {
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;
    masaPoJedinici?: number | undefined;
    napomena?: string | undefined;
    kategorijaId?: number | undefined;
    kategorija?: Oznaka | undefined;
    nazivNaEngleskom?: string | undefined;
    netoTezinaKg?: number;
    tarifniBroj?: TarifniBroj | undefined;
    repromaterijali?: RepromaterijalZaRobu[] | undefined;
    barkodovi?: RobaBarkod[] | undefined;
}

export class TarifniBroj extends ValueObject implements ITarifniBroj {
    ct?: string | undefined;
    ostatak?: string | undefined;

    constructor(data?: ITarifniBroj) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ct = _data["ct"];
            this.ostatak = _data["ostatak"];
        }
    }

    static fromJS(data: any): TarifniBroj {
        data = typeof data === 'object' ? data : {};
        let result = new TarifniBroj();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ct"] = this.ct;
        data["ostatak"] = this.ostatak;
        super.toJSON(data);
        return data;
    }
}

export interface ITarifniBroj extends IValueObject {
    ct?: string | undefined;
    ostatak?: string | undefined;
}

export class RepromaterijalZaRobu implements IRepromaterijalZaRobu {
    repromaterijalZaRobuId?: number;
    repromaterijalId?: number;
    repromaterijal?: Repromaterijal | undefined;
    robaId?: number;
    roba?: Roba | undefined;

    constructor(data?: IRepromaterijalZaRobu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repromaterijalZaRobuId = _data["repromaterijalZaRobuId"];
            this.repromaterijalId = _data["repromaterijalId"];
            this.repromaterijal = _data["repromaterijal"] ? Repromaterijal.fromJS(_data["repromaterijal"]) : <any>undefined;
            this.robaId = _data["robaId"];
            this.roba = _data["roba"] ? Roba.fromJS(_data["roba"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RepromaterijalZaRobu {
        data = typeof data === 'object' ? data : {};
        let result = new RepromaterijalZaRobu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["repromaterijalZaRobuId"] = this.repromaterijalZaRobuId;
        data["repromaterijalId"] = this.repromaterijalId;
        data["repromaterijal"] = this.repromaterijal ? this.repromaterijal.toJSON() : <any>undefined;
        data["robaId"] = this.robaId;
        data["roba"] = this.roba ? this.roba.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRepromaterijalZaRobu {
    repromaterijalZaRobuId?: number;
    repromaterijalId?: number;
    repromaterijal?: Repromaterijal | undefined;
    robaId?: number;
    roba?: Roba | undefined;
}

export class Repromaterijal implements IRepromaterijal {
    repromaterijalId?: number;
    naziv?: string | undefined;
    tarifniBroj?: TarifniBroj | undefined;
    robe?: RepromaterijalZaRobu[] | undefined;

    constructor(data?: IRepromaterijal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repromaterijalId = _data["repromaterijalId"];
            this.naziv = _data["naziv"];
            this.tarifniBroj = _data["tarifniBroj"] ? TarifniBroj.fromJS(_data["tarifniBroj"]) : <any>undefined;
            if (Array.isArray(_data["robe"])) {
                this.robe = [] as any;
                for (let item of _data["robe"])
                    this.robe!.push(RepromaterijalZaRobu.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Repromaterijal {
        data = typeof data === 'object' ? data : {};
        let result = new Repromaterijal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["repromaterijalId"] = this.repromaterijalId;
        data["naziv"] = this.naziv;
        data["tarifniBroj"] = this.tarifniBroj ? this.tarifniBroj.toJSON() : <any>undefined;
        if (Array.isArray(this.robe)) {
            data["robe"] = [];
            for (let item of this.robe)
                data["robe"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRepromaterijal {
    repromaterijalId?: number;
    naziv?: string | undefined;
    tarifniBroj?: TarifniBroj | undefined;
    robe?: RepromaterijalZaRobu[] | undefined;
}

export class RobaBarkod implements IRobaBarkod {
    robaBarkodId?: number;
    predmetStavkeId?: number;
    roba?: Roba | undefined;
    barkod?: string | undefined;
    jePrimarni?: boolean;

    constructor(data?: IRobaBarkod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.robaBarkodId = _data["robaBarkodId"];
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.roba = _data["roba"] ? Roba.fromJS(_data["roba"]) : <any>undefined;
            this.barkod = _data["barkod"];
            this.jePrimarni = _data["jePrimarni"];
        }
    }

    static fromJS(data: any): RobaBarkod {
        data = typeof data === 'object' ? data : {};
        let result = new RobaBarkod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["robaBarkodId"] = this.robaBarkodId;
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["roba"] = this.roba ? this.roba.toJSON() : <any>undefined;
        data["barkod"] = this.barkod;
        data["jePrimarni"] = this.jePrimarni;
        return data;
    }
}

export interface IRobaBarkod {
    robaBarkodId?: number;
    predmetStavkeId?: number;
    roba?: Roba | undefined;
    barkod?: string | undefined;
    jePrimarni?: boolean;
}

export class Vozilo implements IVozilo {
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;
    modelId?: number;
    model?: VoziloModel | undefined;
    fotografijeVozila?: VoziloFotografije[] | undefined;
    dokumentaVozila?: VoziloDokumenta[] | undefined;
    osiguranjeVozila?: VoziloOsiguranje[] | undefined;
    racuni?: RacunVozilo[] | undefined;
    drzavaIzdavanja?: string | undefined;
    organIzdavanja?: string | undefined;
    upravaIzdavanja?: string | undefined;
    brojSaobracajne?: string | undefined;
    datumIzdavanja?: Date | undefined;
    datumIsteka?: Date | undefined;
    serijskiBroj?: string | undefined;
    datumPrveRegistracije?: Date | undefined;
    godinaProizvodnje?: number | undefined;
    brojSasije?: string | undefined;
    registarskaOznaka?: string | undefined;
    brojKilovata?: number;
    brojKubika?: number;
    vrstaGoriva?: VrstaGoriva;
    odnosSnageITezine?: number | undefined;
    tezina?: number | undefined;
    maksimalnaDozvoljenaTezina?: number | undefined;
    brojMestaZaSedenje?: number | undefined;
    brojMestaZaStajanje?: number | undefined;
    brojMotora?: string | undefined;
    brojOsovina?: number | undefined;
    boja?: string | undefined;
    datumZabraneOtudjenja?: Date | undefined;
    nosivost?: number | undefined;
    maticniBrojIliJMBGVlasnika?: string | undefined;
    prezimeIliPoslovnoImeVlasnika?: string | undefined;
    imeVlasnika?: string | undefined;
    adresaVlasnika?: string | undefined;
    maticniBrojIliJMBGKorisnika?: string | undefined;
    prezimeIliPoslovnoImeKorisnika?: string | undefined;
    imeKorisnika?: string | undefined;
    trenutnaKilometraza?: number | undefined;
    datumIstekaRegistracije?: Date | undefined;
    adresaKorisnika?: string | undefined;

    constructor(data?: IVozilo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.predmetStavke = _data["predmetStavke"] ? PredmetStavke.fromJS(_data["predmetStavke"]) : <any>undefined;
            this.modelId = _data["modelId"];
            this.model = _data["model"] ? VoziloModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["fotografijeVozila"])) {
                this.fotografijeVozila = [] as any;
                for (let item of _data["fotografijeVozila"])
                    this.fotografijeVozila!.push(VoziloFotografije.fromJS(item));
            }
            if (Array.isArray(_data["dokumentaVozila"])) {
                this.dokumentaVozila = [] as any;
                for (let item of _data["dokumentaVozila"])
                    this.dokumentaVozila!.push(VoziloDokumenta.fromJS(item));
            }
            if (Array.isArray(_data["osiguranjeVozila"])) {
                this.osiguranjeVozila = [] as any;
                for (let item of _data["osiguranjeVozila"])
                    this.osiguranjeVozila!.push(VoziloOsiguranje.fromJS(item));
            }
            if (Array.isArray(_data["racuni"])) {
                this.racuni = [] as any;
                for (let item of _data["racuni"])
                    this.racuni!.push(RacunVozilo.fromJS(item));
            }
            this.drzavaIzdavanja = _data["drzavaIzdavanja"];
            this.organIzdavanja = _data["organIzdavanja"];
            this.upravaIzdavanja = _data["upravaIzdavanja"];
            this.brojSaobracajne = _data["brojSaobracajne"];
            this.datumIzdavanja = _data["datumIzdavanja"] ? new Date(_data["datumIzdavanja"].toString()) : <any>undefined;
            this.datumIsteka = _data["datumIsteka"] ? new Date(_data["datumIsteka"].toString()) : <any>undefined;
            this.serijskiBroj = _data["serijskiBroj"];
            this.datumPrveRegistracije = _data["datumPrveRegistracije"] ? new Date(_data["datumPrveRegistracije"].toString()) : <any>undefined;
            this.godinaProizvodnje = _data["godinaProizvodnje"];
            this.brojSasije = _data["brojSasije"];
            this.registarskaOznaka = _data["registarskaOznaka"];
            this.brojKilovata = _data["brojKilovata"];
            this.brojKubika = _data["brojKubika"];
            this.vrstaGoriva = _data["vrstaGoriva"];
            this.odnosSnageITezine = _data["odnosSnageITezine"];
            this.tezina = _data["tezina"];
            this.maksimalnaDozvoljenaTezina = _data["maksimalnaDozvoljenaTezina"];
            this.brojMestaZaSedenje = _data["brojMestaZaSedenje"];
            this.brojMestaZaStajanje = _data["brojMestaZaStajanje"];
            this.brojMotora = _data["brojMotora"];
            this.brojOsovina = _data["brojOsovina"];
            this.boja = _data["boja"];
            this.datumZabraneOtudjenja = _data["datumZabraneOtudjenja"] ? new Date(_data["datumZabraneOtudjenja"].toString()) : <any>undefined;
            this.nosivost = _data["nosivost"];
            this.maticniBrojIliJMBGVlasnika = _data["maticniBrojIliJMBGVlasnika"];
            this.prezimeIliPoslovnoImeVlasnika = _data["prezimeIliPoslovnoImeVlasnika"];
            this.imeVlasnika = _data["imeVlasnika"];
            this.adresaVlasnika = _data["adresaVlasnika"];
            this.maticniBrojIliJMBGKorisnika = _data["maticniBrojIliJMBGKorisnika"];
            this.prezimeIliPoslovnoImeKorisnika = _data["prezimeIliPoslovnoImeKorisnika"];
            this.imeKorisnika = _data["imeKorisnika"];
            this.trenutnaKilometraza = _data["trenutnaKilometraza"];
            this.datumIstekaRegistracije = _data["datumIstekaRegistracije"] ? new Date(_data["datumIstekaRegistracije"].toString()) : <any>undefined;
            this.adresaKorisnika = _data["adresaKorisnika"];
        }
    }

    static fromJS(data: any): Vozilo {
        data = typeof data === 'object' ? data : {};
        let result = new Vozilo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["predmetStavke"] = this.predmetStavke ? this.predmetStavke.toJSON() : <any>undefined;
        data["modelId"] = this.modelId;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.fotografijeVozila)) {
            data["fotografijeVozila"] = [];
            for (let item of this.fotografijeVozila)
                data["fotografijeVozila"].push(item.toJSON());
        }
        if (Array.isArray(this.dokumentaVozila)) {
            data["dokumentaVozila"] = [];
            for (let item of this.dokumentaVozila)
                data["dokumentaVozila"].push(item.toJSON());
        }
        if (Array.isArray(this.osiguranjeVozila)) {
            data["osiguranjeVozila"] = [];
            for (let item of this.osiguranjeVozila)
                data["osiguranjeVozila"].push(item.toJSON());
        }
        if (Array.isArray(this.racuni)) {
            data["racuni"] = [];
            for (let item of this.racuni)
                data["racuni"].push(item.toJSON());
        }
        data["drzavaIzdavanja"] = this.drzavaIzdavanja;
        data["organIzdavanja"] = this.organIzdavanja;
        data["upravaIzdavanja"] = this.upravaIzdavanja;
        data["brojSaobracajne"] = this.brojSaobracajne;
        data["datumIzdavanja"] = this.datumIzdavanja ? this.datumIzdavanja.toISOString() : <any>undefined;
        data["datumIsteka"] = this.datumIsteka ? this.datumIsteka.toISOString() : <any>undefined;
        data["serijskiBroj"] = this.serijskiBroj;
        data["datumPrveRegistracije"] = this.datumPrveRegistracije ? this.datumPrveRegistracije.toISOString() : <any>undefined;
        data["godinaProizvodnje"] = this.godinaProizvodnje;
        data["brojSasije"] = this.brojSasije;
        data["registarskaOznaka"] = this.registarskaOznaka;
        data["brojKilovata"] = this.brojKilovata;
        data["brojKubika"] = this.brojKubika;
        data["vrstaGoriva"] = this.vrstaGoriva;
        data["odnosSnageITezine"] = this.odnosSnageITezine;
        data["tezina"] = this.tezina;
        data["maksimalnaDozvoljenaTezina"] = this.maksimalnaDozvoljenaTezina;
        data["brojMestaZaSedenje"] = this.brojMestaZaSedenje;
        data["brojMestaZaStajanje"] = this.brojMestaZaStajanje;
        data["brojMotora"] = this.brojMotora;
        data["brojOsovina"] = this.brojOsovina;
        data["boja"] = this.boja;
        data["datumZabraneOtudjenja"] = this.datumZabraneOtudjenja ? this.datumZabraneOtudjenja.toISOString() : <any>undefined;
        data["nosivost"] = this.nosivost;
        data["maticniBrojIliJMBGVlasnika"] = this.maticniBrojIliJMBGVlasnika;
        data["prezimeIliPoslovnoImeVlasnika"] = this.prezimeIliPoslovnoImeVlasnika;
        data["imeVlasnika"] = this.imeVlasnika;
        data["adresaVlasnika"] = this.adresaVlasnika;
        data["maticniBrojIliJMBGKorisnika"] = this.maticniBrojIliJMBGKorisnika;
        data["prezimeIliPoslovnoImeKorisnika"] = this.prezimeIliPoslovnoImeKorisnika;
        data["imeKorisnika"] = this.imeKorisnika;
        data["trenutnaKilometraza"] = this.trenutnaKilometraza;
        data["datumIstekaRegistracije"] = this.datumIstekaRegistracije ? this.datumIstekaRegistracije.toISOString() : <any>undefined;
        data["adresaKorisnika"] = this.adresaKorisnika;
        return data;
    }
}

export interface IVozilo {
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;
    modelId?: number;
    model?: VoziloModel | undefined;
    fotografijeVozila?: VoziloFotografije[] | undefined;
    dokumentaVozila?: VoziloDokumenta[] | undefined;
    osiguranjeVozila?: VoziloOsiguranje[] | undefined;
    racuni?: RacunVozilo[] | undefined;
    drzavaIzdavanja?: string | undefined;
    organIzdavanja?: string | undefined;
    upravaIzdavanja?: string | undefined;
    brojSaobracajne?: string | undefined;
    datumIzdavanja?: Date | undefined;
    datumIsteka?: Date | undefined;
    serijskiBroj?: string | undefined;
    datumPrveRegistracije?: Date | undefined;
    godinaProizvodnje?: number | undefined;
    brojSasije?: string | undefined;
    registarskaOznaka?: string | undefined;
    brojKilovata?: number;
    brojKubika?: number;
    vrstaGoriva?: VrstaGoriva;
    odnosSnageITezine?: number | undefined;
    tezina?: number | undefined;
    maksimalnaDozvoljenaTezina?: number | undefined;
    brojMestaZaSedenje?: number | undefined;
    brojMestaZaStajanje?: number | undefined;
    brojMotora?: string | undefined;
    brojOsovina?: number | undefined;
    boja?: string | undefined;
    datumZabraneOtudjenja?: Date | undefined;
    nosivost?: number | undefined;
    maticniBrojIliJMBGVlasnika?: string | undefined;
    prezimeIliPoslovnoImeVlasnika?: string | undefined;
    imeVlasnika?: string | undefined;
    adresaVlasnika?: string | undefined;
    maticniBrojIliJMBGKorisnika?: string | undefined;
    prezimeIliPoslovnoImeKorisnika?: string | undefined;
    imeKorisnika?: string | undefined;
    trenutnaKilometraza?: number | undefined;
    datumIstekaRegistracije?: Date | undefined;
    adresaKorisnika?: string | undefined;
}

export class VoziloModel implements IVoziloModel {
    modelId?: number;
    markaId?: number;
    naziv?: string | undefined;
    voziloMarka?: VoziloMarka | undefined;

    constructor(data?: IVoziloModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.markaId = _data["markaId"];
            this.naziv = _data["naziv"];
            this.voziloMarka = _data["voziloMarka"] ? VoziloMarka.fromJS(_data["voziloMarka"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VoziloModel {
        data = typeof data === 'object' ? data : {};
        let result = new VoziloModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["markaId"] = this.markaId;
        data["naziv"] = this.naziv;
        data["voziloMarka"] = this.voziloMarka ? this.voziloMarka.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVoziloModel {
    modelId?: number;
    markaId?: number;
    naziv?: string | undefined;
    voziloMarka?: VoziloMarka | undefined;
}

export class VoziloMarka implements IVoziloMarka {
    markaId?: number;
    tipId?: number;
    naziv?: string | undefined;
    voziloTip?: VoziloTip | undefined;
    modeliVozila?: VoziloModel[] | undefined;

    constructor(data?: IVoziloMarka) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.markaId = _data["markaId"];
            this.tipId = _data["tipId"];
            this.naziv = _data["naziv"];
            this.voziloTip = _data["voziloTip"] ? VoziloTip.fromJS(_data["voziloTip"]) : <any>undefined;
            if (Array.isArray(_data["modeliVozila"])) {
                this.modeliVozila = [] as any;
                for (let item of _data["modeliVozila"])
                    this.modeliVozila!.push(VoziloModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoziloMarka {
        data = typeof data === 'object' ? data : {};
        let result = new VoziloMarka();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["markaId"] = this.markaId;
        data["tipId"] = this.tipId;
        data["naziv"] = this.naziv;
        data["voziloTip"] = this.voziloTip ? this.voziloTip.toJSON() : <any>undefined;
        if (Array.isArray(this.modeliVozila)) {
            data["modeliVozila"] = [];
            for (let item of this.modeliVozila)
                data["modeliVozila"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVoziloMarka {
    markaId?: number;
    tipId?: number;
    naziv?: string | undefined;
    voziloTip?: VoziloTip | undefined;
    modeliVozila?: VoziloModel[] | undefined;
}

export class VoziloTip implements IVoziloTip {
    voziloTipId?: number;
    naziv?: string | undefined;
    markeVozila?: VoziloMarka[] | undefined;

    constructor(data?: IVoziloTip) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voziloTipId = _data["voziloTipId"];
            this.naziv = _data["naziv"];
            if (Array.isArray(_data["markeVozila"])) {
                this.markeVozila = [] as any;
                for (let item of _data["markeVozila"])
                    this.markeVozila!.push(VoziloMarka.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoziloTip {
        data = typeof data === 'object' ? data : {};
        let result = new VoziloTip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voziloTipId"] = this.voziloTipId;
        data["naziv"] = this.naziv;
        if (Array.isArray(this.markeVozila)) {
            data["markeVozila"] = [];
            for (let item of this.markeVozila)
                data["markeVozila"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVoziloTip {
    voziloTipId?: number;
    naziv?: string | undefined;
    markeVozila?: VoziloMarka[] | undefined;
}

export class VoziloFotografije implements IVoziloFotografije {
    id?: number;
    naziv?: string | undefined;
    originalniNaziv?: string | undefined;
    tipFajla?: FileType;
    datumOtpremanja?: Date;
    predmetStavkeId?: number;
    vozilo?: Vozilo | undefined;

    constructor(data?: IVoziloFotografije) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.originalniNaziv = _data["originalniNaziv"];
            this.tipFajla = _data["tipFajla"];
            this.datumOtpremanja = _data["datumOtpremanja"] ? new Date(_data["datumOtpremanja"].toString()) : <any>undefined;
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.vozilo = _data["vozilo"] ? Vozilo.fromJS(_data["vozilo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VoziloFotografije {
        data = typeof data === 'object' ? data : {};
        let result = new VoziloFotografije();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["originalniNaziv"] = this.originalniNaziv;
        data["tipFajla"] = this.tipFajla;
        data["datumOtpremanja"] = this.datumOtpremanja ? this.datumOtpremanja.toISOString() : <any>undefined;
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["vozilo"] = this.vozilo ? this.vozilo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVoziloFotografije {
    id?: number;
    naziv?: string | undefined;
    originalniNaziv?: string | undefined;
    tipFajla?: FileType;
    datumOtpremanja?: Date;
    predmetStavkeId?: number;
    vozilo?: Vozilo | undefined;
}

export enum FileType {
    EMPTY = 0,
    TEXT_PLAIN = 1,
    APPLICATION_MSWORD = 2,
    APPLICATION_MSEXCEL = 3,
    APPLICATION_MSPOWERPOINT = 4,
    APPLICATION_PDF = 5,
    IMAGE = 6,
    XML = 7,
    CSV = 8,
    PFX = 9,
}

export class VoziloDokumenta implements IVoziloDokumenta {
    id?: number;
    naziv?: string | undefined;
    originalniNaziv?: string | undefined;
    tipFajla?: FileType;
    datumOtpremanja?: Date;
    predmetStavkeId?: number;
    vozilo?: Vozilo | undefined;

    constructor(data?: IVoziloDokumenta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.originalniNaziv = _data["originalniNaziv"];
            this.tipFajla = _data["tipFajla"];
            this.datumOtpremanja = _data["datumOtpremanja"] ? new Date(_data["datumOtpremanja"].toString()) : <any>undefined;
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.vozilo = _data["vozilo"] ? Vozilo.fromJS(_data["vozilo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VoziloDokumenta {
        data = typeof data === 'object' ? data : {};
        let result = new VoziloDokumenta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["originalniNaziv"] = this.originalniNaziv;
        data["tipFajla"] = this.tipFajla;
        data["datumOtpremanja"] = this.datumOtpremanja ? this.datumOtpremanja.toISOString() : <any>undefined;
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["vozilo"] = this.vozilo ? this.vozilo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVoziloDokumenta {
    id?: number;
    naziv?: string | undefined;
    originalniNaziv?: string | undefined;
    tipFajla?: FileType;
    datumOtpremanja?: Date;
    predmetStavkeId?: number;
    vozilo?: Vozilo | undefined;
}

export class VoziloOsiguranje implements IVoziloOsiguranje {
    id?: number;
    tipOsiguranja?: TipOsiguranja;
    nazivOsiguravajuceKuce?: string | undefined;
    nazivOsiguranja?: string | undefined;
    datumPocetka?: Date;
    datumZavrsetka?: Date | undefined;
    cena?: number | undefined;
    datumValute?: Date | undefined;
    napomena?: string | undefined;
    predmetStavkeId?: number;
    vozilo?: Vozilo | undefined;

    constructor(data?: IVoziloOsiguranje) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tipOsiguranja = _data["tipOsiguranja"];
            this.nazivOsiguravajuceKuce = _data["nazivOsiguravajuceKuce"];
            this.nazivOsiguranja = _data["nazivOsiguranja"];
            this.datumPocetka = _data["datumPocetka"] ? new Date(_data["datumPocetka"].toString()) : <any>undefined;
            this.datumZavrsetka = _data["datumZavrsetka"] ? new Date(_data["datumZavrsetka"].toString()) : <any>undefined;
            this.cena = _data["cena"];
            this.datumValute = _data["datumValute"] ? new Date(_data["datumValute"].toString()) : <any>undefined;
            this.napomena = _data["napomena"];
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.vozilo = _data["vozilo"] ? Vozilo.fromJS(_data["vozilo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VoziloOsiguranje {
        data = typeof data === 'object' ? data : {};
        let result = new VoziloOsiguranje();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipOsiguranja"] = this.tipOsiguranja;
        data["nazivOsiguravajuceKuce"] = this.nazivOsiguravajuceKuce;
        data["nazivOsiguranja"] = this.nazivOsiguranja;
        data["datumPocetka"] = this.datumPocetka ? this.datumPocetka.toISOString() : <any>undefined;
        data["datumZavrsetka"] = this.datumZavrsetka ? this.datumZavrsetka.toISOString() : <any>undefined;
        data["cena"] = this.cena;
        data["datumValute"] = this.datumValute ? this.datumValute.toISOString() : <any>undefined;
        data["napomena"] = this.napomena;
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["vozilo"] = this.vozilo ? this.vozilo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVoziloOsiguranje {
    id?: number;
    tipOsiguranja?: TipOsiguranja;
    nazivOsiguravajuceKuce?: string | undefined;
    nazivOsiguranja?: string | undefined;
    datumPocetka?: Date;
    datumZavrsetka?: Date | undefined;
    cena?: number | undefined;
    datumValute?: Date | undefined;
    napomena?: string | undefined;
    predmetStavkeId?: number;
    vozilo?: Vozilo | undefined;
}

export enum TipOsiguranja {
    AUTOODGOVORNOST = 1,
    AUTOKASKO = 2,
    ZELENI_KARTON = 3,
    POMOC_NA_PUTU = 4,
    EMPTY = -1,
}

export class RacunVozilo implements IRacunVozilo {
    racunVoziloId?: number;
    racunId?: number;
    racun?: Racun | undefined;
    voziloId?: number;
    vozilo?: Vozilo | undefined;
    registracionaOznaka?: string | undefined;

    constructor(data?: IRacunVozilo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunVoziloId = _data["racunVoziloId"];
            this.racunId = _data["racunId"];
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
            this.voziloId = _data["voziloId"];
            this.vozilo = _data["vozilo"] ? Vozilo.fromJS(_data["vozilo"]) : <any>undefined;
            this.registracionaOznaka = _data["registracionaOznaka"];
        }
    }

    static fromJS(data: any): RacunVozilo {
        data = typeof data === 'object' ? data : {};
        let result = new RacunVozilo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunVoziloId"] = this.racunVoziloId;
        data["racunId"] = this.racunId;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        data["voziloId"] = this.voziloId;
        data["vozilo"] = this.vozilo ? this.vozilo.toJSON() : <any>undefined;
        data["registracionaOznaka"] = this.registracionaOznaka;
        return data;
    }
}

export interface IRacunVozilo {
    racunVoziloId?: number;
    racunId?: number;
    racun?: Racun | undefined;
    voziloId?: number;
    vozilo?: Vozilo | undefined;
    registracionaOznaka?: string | undefined;
}

export enum VrstaGoriva {
    BENZIN = 1,
    DIZEL = 2,
    BENZIN_GAS = 3,
    BENZIN_METAN = 4,
    ELEKTRICNI = 5,
    HIBRIDNI = 6,
    EMPTY = -1,
}

export class RobaAtribut implements IRobaAtribut {
    robaAtributId?: number;
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;
    naziv?: string | undefined;
    vrednosti?: string[] | undefined;

    constructor(data?: IRobaAtribut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.robaAtributId = _data["robaAtributId"];
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.predmetStavke = _data["predmetStavke"] ? PredmetStavke.fromJS(_data["predmetStavke"]) : <any>undefined;
            this.naziv = _data["naziv"];
            if (Array.isArray(_data["vrednosti"])) {
                this.vrednosti = [] as any;
                for (let item of _data["vrednosti"])
                    this.vrednosti!.push(item);
            }
        }
    }

    static fromJS(data: any): RobaAtribut {
        data = typeof data === 'object' ? data : {};
        let result = new RobaAtribut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["robaAtributId"] = this.robaAtributId;
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["predmetStavke"] = this.predmetStavke ? this.predmetStavke.toJSON() : <any>undefined;
        data["naziv"] = this.naziv;
        if (Array.isArray(this.vrednosti)) {
            data["vrednosti"] = [];
            for (let item of this.vrednosti)
                data["vrednosti"].push(item);
        }
        return data;
    }
}

export interface IRobaAtribut {
    robaAtributId?: number;
    predmetStavkeId?: number;
    predmetStavke?: PredmetStavke | undefined;
    naziv?: string | undefined;
    vrednosti?: string[] | undefined;
}

export class PravnoLice implements IPravnoLice {
    strankaId?: number;
    stranka?: Stranka | undefined;
    pib?: string | undefined;
    maticniBroj?: string | undefined;
    punNaziv?: string | undefined;
    vlasnici?: string | undefined;
    zastupnici?: string | undefined;
    pravniOblik?: PravniOblik;
    tipPravnogLica?: TipPravnogLica;
    sifraDelatnosti?: string | undefined;
    registracioniBroj?: string | undefined;
    poreskiBrojStranogLica?: string | undefined;
    brojUgovora?: string | undefined;
    brojTendera?: string | undefined;
    datumRegistracije?: Date | undefined;
    datumOsnivanja?: Date | undefined;
    datumPocetkaStatusa?: Date | undefined;
    jeKorisnikAplikacije?: boolean;
    uSistemuPdv?: boolean;
    jbkjs?: string | undefined;
    jeBudzetskiKorisnik?: boolean;
    konfiguracijaMojeFirme?: KonfiguracijaMojeFirme | undefined;
    konfiguracijaRacuna?: KonfiguracijaRacuna | undefined;
    pdvEvidencijePojedinacne?: PdvEvidencijaPojedinacna[] | undefined;
    pibOrJbkjs?: string | undefined;

    constructor(data?: IPravnoLice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.strankaId = _data["strankaId"];
            this.stranka = _data["stranka"] ? Stranka.fromJS(_data["stranka"]) : <any>undefined;
            this.pib = _data["pib"];
            this.maticniBroj = _data["maticniBroj"];
            this.punNaziv = _data["punNaziv"];
            this.vlasnici = _data["vlasnici"];
            this.zastupnici = _data["zastupnici"];
            this.pravniOblik = _data["pravniOblik"];
            this.tipPravnogLica = _data["tipPravnogLica"];
            this.sifraDelatnosti = _data["sifraDelatnosti"];
            this.registracioniBroj = _data["registracioniBroj"];
            this.poreskiBrojStranogLica = _data["poreskiBrojStranogLica"];
            this.brojUgovora = _data["brojUgovora"];
            this.brojTendera = _data["brojTendera"];
            this.datumRegistracije = _data["datumRegistracije"] ? new Date(_data["datumRegistracije"].toString()) : <any>undefined;
            this.datumOsnivanja = _data["datumOsnivanja"] ? new Date(_data["datumOsnivanja"].toString()) : <any>undefined;
            this.datumPocetkaStatusa = _data["datumPocetkaStatusa"] ? new Date(_data["datumPocetkaStatusa"].toString()) : <any>undefined;
            this.jeKorisnikAplikacije = _data["jeKorisnikAplikacije"];
            this.uSistemuPdv = _data["uSistemuPdv"];
            this.jbkjs = _data["jbkjs"];
            this.jeBudzetskiKorisnik = _data["jeBudzetskiKorisnik"];
            this.konfiguracijaMojeFirme = _data["konfiguracijaMojeFirme"] ? KonfiguracijaMojeFirme.fromJS(_data["konfiguracijaMojeFirme"]) : <any>undefined;
            this.konfiguracijaRacuna = _data["konfiguracijaRacuna"] ? KonfiguracijaRacuna.fromJS(_data["konfiguracijaRacuna"]) : <any>undefined;
            if (Array.isArray(_data["pdvEvidencijePojedinacne"])) {
                this.pdvEvidencijePojedinacne = [] as any;
                for (let item of _data["pdvEvidencijePojedinacne"])
                    this.pdvEvidencijePojedinacne!.push(PdvEvidencijaPojedinacna.fromJS(item));
            }
            this.pibOrJbkjs = _data["pibOrJbkjs"];
        }
    }

    static fromJS(data: any): PravnoLice {
        data = typeof data === 'object' ? data : {};
        let result = new PravnoLice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["strankaId"] = this.strankaId;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        data["pib"] = this.pib;
        data["maticniBroj"] = this.maticniBroj;
        data["punNaziv"] = this.punNaziv;
        data["vlasnici"] = this.vlasnici;
        data["zastupnici"] = this.zastupnici;
        data["pravniOblik"] = this.pravniOblik;
        data["tipPravnogLica"] = this.tipPravnogLica;
        data["sifraDelatnosti"] = this.sifraDelatnosti;
        data["registracioniBroj"] = this.registracioniBroj;
        data["poreskiBrojStranogLica"] = this.poreskiBrojStranogLica;
        data["brojUgovora"] = this.brojUgovora;
        data["brojTendera"] = this.brojTendera;
        data["datumRegistracije"] = this.datumRegistracije ? this.datumRegistracije.toISOString() : <any>undefined;
        data["datumOsnivanja"] = this.datumOsnivanja ? this.datumOsnivanja.toISOString() : <any>undefined;
        data["datumPocetkaStatusa"] = this.datumPocetkaStatusa ? this.datumPocetkaStatusa.toISOString() : <any>undefined;
        data["jeKorisnikAplikacije"] = this.jeKorisnikAplikacije;
        data["uSistemuPdv"] = this.uSistemuPdv;
        data["jbkjs"] = this.jbkjs;
        data["jeBudzetskiKorisnik"] = this.jeBudzetskiKorisnik;
        data["konfiguracijaMojeFirme"] = this.konfiguracijaMojeFirme ? this.konfiguracijaMojeFirme.toJSON() : <any>undefined;
        data["konfiguracijaRacuna"] = this.konfiguracijaRacuna ? this.konfiguracijaRacuna.toJSON() : <any>undefined;
        if (Array.isArray(this.pdvEvidencijePojedinacne)) {
            data["pdvEvidencijePojedinacne"] = [];
            for (let item of this.pdvEvidencijePojedinacne)
                data["pdvEvidencijePojedinacne"].push(item.toJSON());
        }
        data["pibOrJbkjs"] = this.pibOrJbkjs;
        return data;
    }
}

export interface IPravnoLice {
    strankaId?: number;
    stranka?: Stranka | undefined;
    pib?: string | undefined;
    maticniBroj?: string | undefined;
    punNaziv?: string | undefined;
    vlasnici?: string | undefined;
    zastupnici?: string | undefined;
    pravniOblik?: PravniOblik;
    tipPravnogLica?: TipPravnogLica;
    sifraDelatnosti?: string | undefined;
    registracioniBroj?: string | undefined;
    poreskiBrojStranogLica?: string | undefined;
    brojUgovora?: string | undefined;
    brojTendera?: string | undefined;
    datumRegistracije?: Date | undefined;
    datumOsnivanja?: Date | undefined;
    datumPocetkaStatusa?: Date | undefined;
    jeKorisnikAplikacije?: boolean;
    uSistemuPdv?: boolean;
    jbkjs?: string | undefined;
    jeBudzetskiKorisnik?: boolean;
    konfiguracijaMojeFirme?: KonfiguracijaMojeFirme | undefined;
    konfiguracijaRacuna?: KonfiguracijaRacuna | undefined;
    pdvEvidencijePojedinacne?: PdvEvidencijaPojedinacna[] | undefined;
    pibOrJbkjs?: string | undefined;
}

export enum PravniOblik {
    EMPTY = 0,
    PREDUZETNIK = 1,
    ORTACKO_DRUSTVO = 2,
    KOMANDITNO_DRUSTVO = 3,
    DOO = 4,
    AKCIONARSKO_DRUSTVO = 5,
    POLJOPRIVREDNO_GAZDINSTVO = 6,
}

export enum TipPravnogLica {
    EMPTY = 0,
    DOMACE = 1,
    STRANO = 2,
}

export class KonfiguracijaRacuna implements IKonfiguracijaRacuna {
    konfiguracijaRacunaId?: number;
    defaultDatumPrometa?: DatumPrometaOption;
    periodZaPrikazRacuna?: PeriodZaPrikazRacuna;
    mestoIzdavanjaPrometa?: string | undefined;
    prikaziNadlezniSudZaSpor?: boolean;
    nadlezanSudZaSpor?: string | undefined;
    sifraPlacanja?: string | undefined;
    modelPlacanja?: string | undefined;
    instrukcijaPlacanja?: string | undefined;
    prikaziOznake?: boolean;
    kreirajOtpremnicu?: boolean;
    prikaziPonudu?: boolean;
    saljiOpomeneMailom?: boolean;
    izgledFaktureId?: number | undefined;
    prikaziCifuSlovimaSpojeno?: boolean;
    prikaziSekcijuZaRacunanjeTezine?: boolean;
    prikaziSekcijuZaInformacijeOIsporuci?: boolean;
    prikazRabata?: PrikazRabata;
    prikazOtpremnice?: PrikazOtpremnice;
    prikazRadnogNaloga?: PrikazRadnogNaloga;
    mojaFirmaId?: number;
    mojaFirma?: PravnoLice | undefined;

    constructor(data?: IKonfiguracijaRacuna) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.konfiguracijaRacunaId = _data["konfiguracijaRacunaId"];
            this.defaultDatumPrometa = _data["defaultDatumPrometa"];
            this.periodZaPrikazRacuna = _data["periodZaPrikazRacuna"];
            this.mestoIzdavanjaPrometa = _data["mestoIzdavanjaPrometa"];
            this.prikaziNadlezniSudZaSpor = _data["prikaziNadlezniSudZaSpor"];
            this.nadlezanSudZaSpor = _data["nadlezanSudZaSpor"];
            this.sifraPlacanja = _data["sifraPlacanja"];
            this.modelPlacanja = _data["modelPlacanja"];
            this.instrukcijaPlacanja = _data["instrukcijaPlacanja"];
            this.prikaziOznake = _data["prikaziOznake"];
            this.kreirajOtpremnicu = _data["kreirajOtpremnicu"];
            this.prikaziPonudu = _data["prikaziPonudu"];
            this.saljiOpomeneMailom = _data["saljiOpomeneMailom"];
            this.izgledFaktureId = _data["izgledFaktureId"];
            this.prikaziCifuSlovimaSpojeno = _data["prikaziCifuSlovimaSpojeno"];
            this.prikaziSekcijuZaRacunanjeTezine = _data["prikaziSekcijuZaRacunanjeTezine"];
            this.prikaziSekcijuZaInformacijeOIsporuci = _data["prikaziSekcijuZaInformacijeOIsporuci"];
            this.prikazRabata = _data["prikazRabata"];
            this.prikazOtpremnice = _data["prikazOtpremnice"];
            this.prikazRadnogNaloga = _data["prikazRadnogNaloga"];
            this.mojaFirmaId = _data["mojaFirmaId"];
            this.mojaFirma = _data["mojaFirma"] ? PravnoLice.fromJS(_data["mojaFirma"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KonfiguracijaRacuna {
        data = typeof data === 'object' ? data : {};
        let result = new KonfiguracijaRacuna();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["konfiguracijaRacunaId"] = this.konfiguracijaRacunaId;
        data["defaultDatumPrometa"] = this.defaultDatumPrometa;
        data["periodZaPrikazRacuna"] = this.periodZaPrikazRacuna;
        data["mestoIzdavanjaPrometa"] = this.mestoIzdavanjaPrometa;
        data["prikaziNadlezniSudZaSpor"] = this.prikaziNadlezniSudZaSpor;
        data["nadlezanSudZaSpor"] = this.nadlezanSudZaSpor;
        data["sifraPlacanja"] = this.sifraPlacanja;
        data["modelPlacanja"] = this.modelPlacanja;
        data["instrukcijaPlacanja"] = this.instrukcijaPlacanja;
        data["prikaziOznake"] = this.prikaziOznake;
        data["kreirajOtpremnicu"] = this.kreirajOtpremnicu;
        data["prikaziPonudu"] = this.prikaziPonudu;
        data["saljiOpomeneMailom"] = this.saljiOpomeneMailom;
        data["izgledFaktureId"] = this.izgledFaktureId;
        data["prikaziCifuSlovimaSpojeno"] = this.prikaziCifuSlovimaSpojeno;
        data["prikaziSekcijuZaRacunanjeTezine"] = this.prikaziSekcijuZaRacunanjeTezine;
        data["prikaziSekcijuZaInformacijeOIsporuci"] = this.prikaziSekcijuZaInformacijeOIsporuci;
        data["prikazRabata"] = this.prikazRabata;
        data["prikazOtpremnice"] = this.prikazOtpremnice;
        data["prikazRadnogNaloga"] = this.prikazRadnogNaloga;
        data["mojaFirmaId"] = this.mojaFirmaId;
        data["mojaFirma"] = this.mojaFirma ? this.mojaFirma.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKonfiguracijaRacuna {
    konfiguracijaRacunaId?: number;
    defaultDatumPrometa?: DatumPrometaOption;
    periodZaPrikazRacuna?: PeriodZaPrikazRacuna;
    mestoIzdavanjaPrometa?: string | undefined;
    prikaziNadlezniSudZaSpor?: boolean;
    nadlezanSudZaSpor?: string | undefined;
    sifraPlacanja?: string | undefined;
    modelPlacanja?: string | undefined;
    instrukcijaPlacanja?: string | undefined;
    prikaziOznake?: boolean;
    kreirajOtpremnicu?: boolean;
    prikaziPonudu?: boolean;
    saljiOpomeneMailom?: boolean;
    izgledFaktureId?: number | undefined;
    prikaziCifuSlovimaSpojeno?: boolean;
    prikaziSekcijuZaRacunanjeTezine?: boolean;
    prikaziSekcijuZaInformacijeOIsporuci?: boolean;
    prikazRabata?: PrikazRabata;
    prikazOtpremnice?: PrikazOtpremnice;
    prikazRadnogNaloga?: PrikazRadnogNaloga;
    mojaFirmaId?: number;
    mojaFirma?: PravnoLice | undefined;
}

export enum DatumPrometaOption {
    EMPTY = 0,
    DANASNJI_DATUM = 1,
    POSLEDNJI_DAN_TRENUTNI_MESEC = 2,
    POSLEDNJI_DAN_PRETHODNI_MESEC = 3,
    POSLEDNJI_DAN_NAREDNI_MESEC = 4,
}

export enum PeriodZaPrikazRacuna {
    TRENUTNA_GODINA = 0,
    KVARTALNO = 1,
    TROMESECNO = 2,
}

export enum PrikazOtpremnice {
    SA_CENOM = 0,
    BEZ_CENE = 1,
}

export enum PrikazRadnogNaloga {
    SA_CENOM = 0,
    BEZ_CENE = 1,
}

export class PdvEvidencijaPojedinacna extends AuditableEntity implements IPdvEvidencijaPojedinacna {
    pdvEvidencijaPojedinacnaId?: number;
    sefId?: number;
    broj?: string | undefined;
    brojDokumenta?: string | undefined;
    dokumentId?: number | undefined;
    dokument?: Racun | undefined;
    jeStranaFaktura?: boolean;
    smer?: VrstaRacuna;
    tip?: PdvEvidencijaTipDokumenta;
    osnovOdabiraDokumenta?: PdvEvidencijaOsnovOdabiraDokumenta | undefined;
    pravnoLiceId?: number;
    pravnoLice?: PravnoLice | undefined;
    ukupanIznosNaknade?: number;
    osnovica10?: number | undefined;
    osnovica20?: number | undefined;
    obracunatPdv10?: number | undefined;
    obracunatPdv20?: number | undefined;
    obracunatPdv?: number;
    datumValute?: Date | undefined;
    datumPrometa?: Date | undefined;
    datumSlanja?: Date | undefined;
    datumEvidentiranja?: Date | undefined;
    opisPrometa?: string | undefined;
    opisPrometa20?: string | undefined;
    opisPrometa10?: string | undefined;
    godina?: number;
    povezaniDokumenti?: PdvEvidencijaPojedinacnaPovezanRacun[] | undefined;
    period?: PdvPeriod;
    pravnoNaOdbitak?: PdvEvidencijaPravnoNaOdbitak;
    status?: PdvEvidencijaStatus;

    constructor(data?: IPdvEvidencijaPojedinacna) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pdvEvidencijaPojedinacnaId = _data["pdvEvidencijaPojedinacnaId"];
            this.sefId = _data["sefId"];
            this.broj = _data["broj"];
            this.brojDokumenta = _data["brojDokumenta"];
            this.dokumentId = _data["dokumentId"];
            this.dokument = _data["dokument"] ? Racun.fromJS(_data["dokument"]) : <any>undefined;
            this.jeStranaFaktura = _data["jeStranaFaktura"];
            this.smer = _data["smer"];
            this.tip = _data["tip"];
            this.osnovOdabiraDokumenta = _data["osnovOdabiraDokumenta"];
            this.pravnoLiceId = _data["pravnoLiceId"];
            this.pravnoLice = _data["pravnoLice"] ? PravnoLice.fromJS(_data["pravnoLice"]) : <any>undefined;
            this.ukupanIznosNaknade = _data["ukupanIznosNaknade"];
            this.osnovica10 = _data["osnovica10"];
            this.osnovica20 = _data["osnovica20"];
            this.obracunatPdv10 = _data["obracunatPdv10"];
            this.obracunatPdv20 = _data["obracunatPdv20"];
            this.obracunatPdv = _data["obracunatPdv"];
            this.datumValute = _data["datumValute"] ? new Date(_data["datumValute"].toString()) : <any>undefined;
            this.datumPrometa = _data["datumPrometa"] ? new Date(_data["datumPrometa"].toString()) : <any>undefined;
            this.datumSlanja = _data["datumSlanja"] ? new Date(_data["datumSlanja"].toString()) : <any>undefined;
            this.datumEvidentiranja = _data["datumEvidentiranja"] ? new Date(_data["datumEvidentiranja"].toString()) : <any>undefined;
            this.opisPrometa = _data["opisPrometa"];
            this.opisPrometa20 = _data["opisPrometa20"];
            this.opisPrometa10 = _data["opisPrometa10"];
            this.godina = _data["godina"];
            if (Array.isArray(_data["povezaniDokumenti"])) {
                this.povezaniDokumenti = [] as any;
                for (let item of _data["povezaniDokumenti"])
                    this.povezaniDokumenti!.push(PdvEvidencijaPojedinacnaPovezanRacun.fromJS(item));
            }
            this.period = _data["period"];
            this.pravnoNaOdbitak = _data["pravnoNaOdbitak"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PdvEvidencijaPojedinacna {
        data = typeof data === 'object' ? data : {};
        let result = new PdvEvidencijaPojedinacna();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pdvEvidencijaPojedinacnaId"] = this.pdvEvidencijaPojedinacnaId;
        data["sefId"] = this.sefId;
        data["broj"] = this.broj;
        data["brojDokumenta"] = this.brojDokumenta;
        data["dokumentId"] = this.dokumentId;
        data["dokument"] = this.dokument ? this.dokument.toJSON() : <any>undefined;
        data["jeStranaFaktura"] = this.jeStranaFaktura;
        data["smer"] = this.smer;
        data["tip"] = this.tip;
        data["osnovOdabiraDokumenta"] = this.osnovOdabiraDokumenta;
        data["pravnoLiceId"] = this.pravnoLiceId;
        data["pravnoLice"] = this.pravnoLice ? this.pravnoLice.toJSON() : <any>undefined;
        data["ukupanIznosNaknade"] = this.ukupanIznosNaknade;
        data["osnovica10"] = this.osnovica10;
        data["osnovica20"] = this.osnovica20;
        data["obracunatPdv10"] = this.obracunatPdv10;
        data["obracunatPdv20"] = this.obracunatPdv20;
        data["obracunatPdv"] = this.obracunatPdv;
        data["datumValute"] = this.datumValute ? this.datumValute.toISOString() : <any>undefined;
        data["datumPrometa"] = this.datumPrometa ? this.datumPrometa.toISOString() : <any>undefined;
        data["datumSlanja"] = this.datumSlanja ? this.datumSlanja.toISOString() : <any>undefined;
        data["datumEvidentiranja"] = this.datumEvidentiranja ? this.datumEvidentiranja.toISOString() : <any>undefined;
        data["opisPrometa"] = this.opisPrometa;
        data["opisPrometa20"] = this.opisPrometa20;
        data["opisPrometa10"] = this.opisPrometa10;
        data["godina"] = this.godina;
        if (Array.isArray(this.povezaniDokumenti)) {
            data["povezaniDokumenti"] = [];
            for (let item of this.povezaniDokumenti)
                data["povezaniDokumenti"].push(item.toJSON());
        }
        data["period"] = this.period;
        data["pravnoNaOdbitak"] = this.pravnoNaOdbitak;
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IPdvEvidencijaPojedinacna extends IAuditableEntity {
    pdvEvidencijaPojedinacnaId?: number;
    sefId?: number;
    broj?: string | undefined;
    brojDokumenta?: string | undefined;
    dokumentId?: number | undefined;
    dokument?: Racun | undefined;
    jeStranaFaktura?: boolean;
    smer?: VrstaRacuna;
    tip?: PdvEvidencijaTipDokumenta;
    osnovOdabiraDokumenta?: PdvEvidencijaOsnovOdabiraDokumenta | undefined;
    pravnoLiceId?: number;
    pravnoLice?: PravnoLice | undefined;
    ukupanIznosNaknade?: number;
    osnovica10?: number | undefined;
    osnovica20?: number | undefined;
    obracunatPdv10?: number | undefined;
    obracunatPdv20?: number | undefined;
    obracunatPdv?: number;
    datumValute?: Date | undefined;
    datumPrometa?: Date | undefined;
    datumSlanja?: Date | undefined;
    datumEvidentiranja?: Date | undefined;
    opisPrometa?: string | undefined;
    opisPrometa20?: string | undefined;
    opisPrometa10?: string | undefined;
    godina?: number;
    povezaniDokumenti?: PdvEvidencijaPojedinacnaPovezanRacun[] | undefined;
    period?: PdvPeriod;
    pravnoNaOdbitak?: PdvEvidencijaPravnoNaOdbitak;
    status?: PdvEvidencijaStatus;
}

export enum PdvEvidencijaTipDokumenta {
    FAKTURA = 0,
    DOKUMENT_O_SMANJENJU = 1,
    DOKUMENT_O_POVECANJU = 2,
    AVANSNA_FAKTURA = 3,
    INTERNI_RACUN_ZA_PROMET_STRANOG_LICA = 4,
    DRUGI_INTERNI_RACUN = 5,
}

export enum PdvEvidencijaOsnovOdabiraDokumenta {
    PROMET = 1,
    AVANS = 2,
    POVECANJE = 3,
    SMANJENJE = 4,
}

export class PdvEvidencijaPojedinacnaPovezanRacun implements IPdvEvidencijaPojedinacnaPovezanRacun {
    evidencijaId?: number;
    evidencija?: PdvEvidencijaPojedinacna | undefined;
    racunId?: number;
    racun?: Racun | undefined;

    constructor(data?: IPdvEvidencijaPojedinacnaPovezanRacun) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.evidencijaId = _data["evidencijaId"];
            this.evidencija = _data["evidencija"] ? PdvEvidencijaPojedinacna.fromJS(_data["evidencija"]) : <any>undefined;
            this.racunId = _data["racunId"];
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PdvEvidencijaPojedinacnaPovezanRacun {
        data = typeof data === 'object' ? data : {};
        let result = new PdvEvidencijaPojedinacnaPovezanRacun();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evidencijaId"] = this.evidencijaId;
        data["evidencija"] = this.evidencija ? this.evidencija.toJSON() : <any>undefined;
        data["racunId"] = this.racunId;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPdvEvidencijaPojedinacnaPovezanRacun {
    evidencijaId?: number;
    evidencija?: PdvEvidencijaPojedinacna | undefined;
    racunId?: number;
    racun?: Racun | undefined;
}

export enum PdvPeriod {
    JANUAR = 0,
    FEBRUAR = 1,
    MART = 2,
    APRIL = 3,
    MAJ = 4,
    JUN = 5,
    JUL = 6,
    AVGUST = 7,
    SEPTEMBAR = 8,
    OKTOBAR = 9,
    NOVEMBAR = 10,
    DECEMBAR = 11,
    PRVI_KVARTAL = 12,
    DRUGI_KVARTAL = 13,
    TRECI_KVARTAL = 14,
    CETVRTI_KVARTAL = 15,
}

export enum PdvEvidencijaPravnoNaOdbitak {
    BEZ_PRAVA = 0,
    DELIMIČNO = 1,
    POTPUNO = 2,
}

export enum PdvEvidencijaStatus {
    U_PRIPREMI = 0,
    EVIDENTIRANO = 1,
    KORIGOVANO = 2,
    STORNIRANO = 3,
}

export class TekuciRacun extends AuditableEntity implements ITekuciRacun {
    tekuciRacunId?: number;
    ceoBrojRacuna?: string | undefined;
    brojRacuna?: string | undefined;
    kontrolniBroj?: string | undefined;
    tip?: TipTekucegRacuna;
    iban?: string | undefined;
    strankaId?: number;
    stranka?: Stranka | undefined;
    bankaId?: number;
    banka?: Banka | undefined;
    racuni?: Racun[] | undefined;
    izvodi?: Izvod[] | undefined;
    isDefault?: boolean;
    prikaziNaPdf?: boolean;
    isActive?: boolean;

    constructor(data?: ITekuciRacun) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tekuciRacunId = _data["tekuciRacunId"];
            this.ceoBrojRacuna = _data["ceoBrojRacuna"];
            this.brojRacuna = _data["brojRacuna"];
            this.kontrolniBroj = _data["kontrolniBroj"];
            this.tip = _data["tip"];
            this.iban = _data["iban"];
            this.strankaId = _data["strankaId"];
            this.stranka = _data["stranka"] ? Stranka.fromJS(_data["stranka"]) : <any>undefined;
            this.bankaId = _data["bankaId"];
            this.banka = _data["banka"] ? Banka.fromJS(_data["banka"]) : <any>undefined;
            if (Array.isArray(_data["racuni"])) {
                this.racuni = [] as any;
                for (let item of _data["racuni"])
                    this.racuni!.push(Racun.fromJS(item));
            }
            if (Array.isArray(_data["izvodi"])) {
                this.izvodi = [] as any;
                for (let item of _data["izvodi"])
                    this.izvodi!.push(Izvod.fromJS(item));
            }
            this.isDefault = _data["isDefault"];
            this.prikaziNaPdf = _data["prikaziNaPdf"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TekuciRacun {
        data = typeof data === 'object' ? data : {};
        let result = new TekuciRacun();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tekuciRacunId"] = this.tekuciRacunId;
        data["ceoBrojRacuna"] = this.ceoBrojRacuna;
        data["brojRacuna"] = this.brojRacuna;
        data["kontrolniBroj"] = this.kontrolniBroj;
        data["tip"] = this.tip;
        data["iban"] = this.iban;
        data["strankaId"] = this.strankaId;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        data["bankaId"] = this.bankaId;
        data["banka"] = this.banka ? this.banka.toJSON() : <any>undefined;
        if (Array.isArray(this.racuni)) {
            data["racuni"] = [];
            for (let item of this.racuni)
                data["racuni"].push(item.toJSON());
        }
        if (Array.isArray(this.izvodi)) {
            data["izvodi"] = [];
            for (let item of this.izvodi)
                data["izvodi"].push(item.toJSON());
        }
        data["isDefault"] = this.isDefault;
        data["prikaziNaPdf"] = this.prikaziNaPdf;
        data["isActive"] = this.isActive;
        super.toJSON(data);
        return data;
    }
}

export interface ITekuciRacun extends IAuditableEntity {
    tekuciRacunId?: number;
    ceoBrojRacuna?: string | undefined;
    brojRacuna?: string | undefined;
    kontrolniBroj?: string | undefined;
    tip?: TipTekucegRacuna;
    iban?: string | undefined;
    strankaId?: number;
    stranka?: Stranka | undefined;
    bankaId?: number;
    banka?: Banka | undefined;
    racuni?: Racun[] | undefined;
    izvodi?: Izvod[] | undefined;
    isDefault?: boolean;
    prikaziNaPdf?: boolean;
    isActive?: boolean;
}

export class Banka implements IBanka {
    bankaId?: number;
    naziv?: string | undefined;
    bic?: string | undefined;
    datumOtvaranja?: Date;
    datumZatvaranja?: Date | undefined;
    maticniBroj?: number;
    pib?: string | undefined;
    logoSmall?: string | undefined;
    logoBig?: string | undefined;
    direktor?: string | undefined;
    opis?: string | undefined;
    bankTypeID?: number;
    bankStatusID?: number;
    adresaId?: number | undefined;
    adresa?: Adresa | undefined;
    kontaktId?: number | undefined;
    kontakt?: Kontakt | undefined;
    tekuciRacuni?: TekuciRacun[] | undefined;
    bankaJibs?: BankaJib[] | undefined;

    constructor(data?: IBanka) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankaId = _data["bankaId"];
            this.naziv = _data["naziv"];
            this.bic = _data["bic"];
            this.datumOtvaranja = _data["datumOtvaranja"] ? new Date(_data["datumOtvaranja"].toString()) : <any>undefined;
            this.datumZatvaranja = _data["datumZatvaranja"] ? new Date(_data["datumZatvaranja"].toString()) : <any>undefined;
            this.maticniBroj = _data["maticniBroj"];
            this.pib = _data["pib"];
            this.logoSmall = _data["logoSmall"];
            this.logoBig = _data["logoBig"];
            this.direktor = _data["direktor"];
            this.opis = _data["opis"];
            this.bankTypeID = _data["bankTypeID"];
            this.bankStatusID = _data["bankStatusID"];
            this.adresaId = _data["adresaId"];
            this.adresa = _data["adresa"] ? Adresa.fromJS(_data["adresa"]) : <any>undefined;
            this.kontaktId = _data["kontaktId"];
            this.kontakt = _data["kontakt"] ? Kontakt.fromJS(_data["kontakt"]) : <any>undefined;
            if (Array.isArray(_data["tekuciRacuni"])) {
                this.tekuciRacuni = [] as any;
                for (let item of _data["tekuciRacuni"])
                    this.tekuciRacuni!.push(TekuciRacun.fromJS(item));
            }
            if (Array.isArray(_data["bankaJibs"])) {
                this.bankaJibs = [] as any;
                for (let item of _data["bankaJibs"])
                    this.bankaJibs!.push(BankaJib.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Banka {
        data = typeof data === 'object' ? data : {};
        let result = new Banka();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankaId"] = this.bankaId;
        data["naziv"] = this.naziv;
        data["bic"] = this.bic;
        data["datumOtvaranja"] = this.datumOtvaranja ? this.datumOtvaranja.toISOString() : <any>undefined;
        data["datumZatvaranja"] = this.datumZatvaranja ? this.datumZatvaranja.toISOString() : <any>undefined;
        data["maticniBroj"] = this.maticniBroj;
        data["pib"] = this.pib;
        data["logoSmall"] = this.logoSmall;
        data["logoBig"] = this.logoBig;
        data["direktor"] = this.direktor;
        data["opis"] = this.opis;
        data["bankTypeID"] = this.bankTypeID;
        data["bankStatusID"] = this.bankStatusID;
        data["adresaId"] = this.adresaId;
        data["adresa"] = this.adresa ? this.adresa.toJSON() : <any>undefined;
        data["kontaktId"] = this.kontaktId;
        data["kontakt"] = this.kontakt ? this.kontakt.toJSON() : <any>undefined;
        if (Array.isArray(this.tekuciRacuni)) {
            data["tekuciRacuni"] = [];
            for (let item of this.tekuciRacuni)
                data["tekuciRacuni"].push(item.toJSON());
        }
        if (Array.isArray(this.bankaJibs)) {
            data["bankaJibs"] = [];
            for (let item of this.bankaJibs)
                data["bankaJibs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBanka {
    bankaId?: number;
    naziv?: string | undefined;
    bic?: string | undefined;
    datumOtvaranja?: Date;
    datumZatvaranja?: Date | undefined;
    maticniBroj?: number;
    pib?: string | undefined;
    logoSmall?: string | undefined;
    logoBig?: string | undefined;
    direktor?: string | undefined;
    opis?: string | undefined;
    bankTypeID?: number;
    bankStatusID?: number;
    adresaId?: number | undefined;
    adresa?: Adresa | undefined;
    kontaktId?: number | undefined;
    kontakt?: Kontakt | undefined;
    tekuciRacuni?: TekuciRacun[] | undefined;
    bankaJibs?: BankaJib[] | undefined;
}

export class Kontakt extends AuditableEntity implements IKontakt {
    kontaktId?: number;
    naziv?: string | undefined;
    telefon1?: string | undefined;
    telefon2?: string | undefined;
    telefon3?: string | undefined;
    email?: string | undefined;
    websiteUrl?: string | undefined;
    fax?: string | undefined;
    strankaId?: number | undefined;
    stranka?: Stranka | undefined;
    funkcija?: string | undefined;
    banka?: Banka | undefined;

    constructor(data?: IKontakt) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.kontaktId = _data["kontaktId"];
            this.naziv = _data["naziv"];
            this.telefon1 = _data["telefon1"];
            this.telefon2 = _data["telefon2"];
            this.telefon3 = _data["telefon3"];
            this.email = _data["email"];
            this.websiteUrl = _data["websiteUrl"];
            this.fax = _data["fax"];
            this.strankaId = _data["strankaId"];
            this.stranka = _data["stranka"] ? Stranka.fromJS(_data["stranka"]) : <any>undefined;
            this.funkcija = _data["funkcija"];
            this.banka = _data["banka"] ? Banka.fromJS(_data["banka"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Kontakt {
        data = typeof data === 'object' ? data : {};
        let result = new Kontakt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kontaktId"] = this.kontaktId;
        data["naziv"] = this.naziv;
        data["telefon1"] = this.telefon1;
        data["telefon2"] = this.telefon2;
        data["telefon3"] = this.telefon3;
        data["email"] = this.email;
        data["websiteUrl"] = this.websiteUrl;
        data["fax"] = this.fax;
        data["strankaId"] = this.strankaId;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        data["funkcija"] = this.funkcija;
        data["banka"] = this.banka ? this.banka.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IKontakt extends IAuditableEntity {
    kontaktId?: number;
    naziv?: string | undefined;
    telefon1?: string | undefined;
    telefon2?: string | undefined;
    telefon3?: string | undefined;
    email?: string | undefined;
    websiteUrl?: string | undefined;
    fax?: string | undefined;
    strankaId?: number | undefined;
    stranka?: Stranka | undefined;
    funkcija?: string | undefined;
    banka?: Banka | undefined;
}

export class BankaJib implements IBankaJib {
    bankaJibId?: number;
    jib?: number;
    isCurrent?: boolean;
    bankaId?: number;
    banka?: Banka | undefined;

    constructor(data?: IBankaJib) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankaJibId = _data["bankaJibId"];
            this.jib = _data["jib"];
            this.isCurrent = _data["isCurrent"];
            this.bankaId = _data["bankaId"];
            this.banka = _data["banka"] ? Banka.fromJS(_data["banka"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BankaJib {
        data = typeof data === 'object' ? data : {};
        let result = new BankaJib();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankaJibId"] = this.bankaJibId;
        data["jib"] = this.jib;
        data["isCurrent"] = this.isCurrent;
        data["bankaId"] = this.bankaId;
        data["banka"] = this.banka ? this.banka.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBankaJib {
    bankaJibId?: number;
    jib?: number;
    isCurrent?: boolean;
    bankaId?: number;
    banka?: Banka | undefined;
}

export class Izvod extends AuditableEntity implements IIzvod {
    izvodId?: number;
    sifraStatusaBanke?: number;
    tipStatusaBanke?: string | undefined;
    detaljiStatusaBanke?: string | undefined;
    oznakaValute?: string | undefined;
    brojTekucegRacuna?: string | undefined;
    broj?: number;
    stanjePrethodnogIzvoda?: KnjigovodstvenoStanjeIzvoda | undefined;
    stanjeTrenutnogIzvoda?: KnjigovodstvenoStanjeIzvoda | undefined;
    rezervisanaSredstva?: number | undefined;
    dozvoljenOkvirniKreditIskoriscenIznos?: number | undefined;
    dozvoljenOkvirniKreditNeiskoriscenIznos?: number | undefined;
    rezervisanaSredstvaDirektneNaplate?: number | undefined;
    projektovanoStanjeRacuna?: number | undefined;
    jeRucnoUneto?: boolean;
    datumIzdavanja?: Date;
    status?: StatusIzvoda;
    tekuciRacunId?: number;
    tekuciRacun?: TekuciRacun | undefined;
    mojaFirmaId?: number;
    mojaFirma?: Stranka | undefined;
    transakcije?: TransakcijaIzvoda[] | undefined;

    constructor(data?: IIzvod) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.izvodId = _data["izvodId"];
            this.sifraStatusaBanke = _data["sifraStatusaBanke"];
            this.tipStatusaBanke = _data["tipStatusaBanke"];
            this.detaljiStatusaBanke = _data["detaljiStatusaBanke"];
            this.oznakaValute = _data["oznakaValute"];
            this.brojTekucegRacuna = _data["brojTekucegRacuna"];
            this.broj = _data["broj"];
            this.stanjePrethodnogIzvoda = _data["stanjePrethodnogIzvoda"] ? KnjigovodstvenoStanjeIzvoda.fromJS(_data["stanjePrethodnogIzvoda"]) : <any>undefined;
            this.stanjeTrenutnogIzvoda = _data["stanjeTrenutnogIzvoda"] ? KnjigovodstvenoStanjeIzvoda.fromJS(_data["stanjeTrenutnogIzvoda"]) : <any>undefined;
            this.rezervisanaSredstva = _data["rezervisanaSredstva"];
            this.dozvoljenOkvirniKreditIskoriscenIznos = _data["dozvoljenOkvirniKreditIskoriscenIznos"];
            this.dozvoljenOkvirniKreditNeiskoriscenIznos = _data["dozvoljenOkvirniKreditNeiskoriscenIznos"];
            this.rezervisanaSredstvaDirektneNaplate = _data["rezervisanaSredstvaDirektneNaplate"];
            this.projektovanoStanjeRacuna = _data["projektovanoStanjeRacuna"];
            this.jeRucnoUneto = _data["jeRucnoUneto"];
            this.datumIzdavanja = _data["datumIzdavanja"] ? new Date(_data["datumIzdavanja"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.tekuciRacunId = _data["tekuciRacunId"];
            this.tekuciRacun = _data["tekuciRacun"] ? TekuciRacun.fromJS(_data["tekuciRacun"]) : <any>undefined;
            this.mojaFirmaId = _data["mojaFirmaId"];
            this.mojaFirma = _data["mojaFirma"] ? Stranka.fromJS(_data["mojaFirma"]) : <any>undefined;
            if (Array.isArray(_data["transakcije"])) {
                this.transakcije = [] as any;
                for (let item of _data["transakcije"])
                    this.transakcije!.push(TransakcijaIzvoda.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Izvod {
        data = typeof data === 'object' ? data : {};
        let result = new Izvod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["izvodId"] = this.izvodId;
        data["sifraStatusaBanke"] = this.sifraStatusaBanke;
        data["tipStatusaBanke"] = this.tipStatusaBanke;
        data["detaljiStatusaBanke"] = this.detaljiStatusaBanke;
        data["oznakaValute"] = this.oznakaValute;
        data["brojTekucegRacuna"] = this.brojTekucegRacuna;
        data["broj"] = this.broj;
        data["stanjePrethodnogIzvoda"] = this.stanjePrethodnogIzvoda ? this.stanjePrethodnogIzvoda.toJSON() : <any>undefined;
        data["stanjeTrenutnogIzvoda"] = this.stanjeTrenutnogIzvoda ? this.stanjeTrenutnogIzvoda.toJSON() : <any>undefined;
        data["rezervisanaSredstva"] = this.rezervisanaSredstva;
        data["dozvoljenOkvirniKreditIskoriscenIznos"] = this.dozvoljenOkvirniKreditIskoriscenIznos;
        data["dozvoljenOkvirniKreditNeiskoriscenIznos"] = this.dozvoljenOkvirniKreditNeiskoriscenIznos;
        data["rezervisanaSredstvaDirektneNaplate"] = this.rezervisanaSredstvaDirektneNaplate;
        data["projektovanoStanjeRacuna"] = this.projektovanoStanjeRacuna;
        data["jeRucnoUneto"] = this.jeRucnoUneto;
        data["datumIzdavanja"] = this.datumIzdavanja ? this.datumIzdavanja.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["tekuciRacunId"] = this.tekuciRacunId;
        data["tekuciRacun"] = this.tekuciRacun ? this.tekuciRacun.toJSON() : <any>undefined;
        data["mojaFirmaId"] = this.mojaFirmaId;
        data["mojaFirma"] = this.mojaFirma ? this.mojaFirma.toJSON() : <any>undefined;
        if (Array.isArray(this.transakcije)) {
            data["transakcije"] = [];
            for (let item of this.transakcije)
                data["transakcije"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IIzvod extends IAuditableEntity {
    izvodId?: number;
    sifraStatusaBanke?: number;
    tipStatusaBanke?: string | undefined;
    detaljiStatusaBanke?: string | undefined;
    oznakaValute?: string | undefined;
    brojTekucegRacuna?: string | undefined;
    broj?: number;
    stanjePrethodnogIzvoda?: KnjigovodstvenoStanjeIzvoda | undefined;
    stanjeTrenutnogIzvoda?: KnjigovodstvenoStanjeIzvoda | undefined;
    rezervisanaSredstva?: number | undefined;
    dozvoljenOkvirniKreditIskoriscenIznos?: number | undefined;
    dozvoljenOkvirniKreditNeiskoriscenIznos?: number | undefined;
    rezervisanaSredstvaDirektneNaplate?: number | undefined;
    projektovanoStanjeRacuna?: number | undefined;
    jeRucnoUneto?: boolean;
    datumIzdavanja?: Date;
    status?: StatusIzvoda;
    tekuciRacunId?: number;
    tekuciRacun?: TekuciRacun | undefined;
    mojaFirmaId?: number;
    mojaFirma?: Stranka | undefined;
    transakcije?: TransakcijaIzvoda[] | undefined;
}

export class KnjigovodstvenoStanjeIzvoda extends ValueObject implements IKnjigovodstvenoStanjeIzvoda {
    iznos?: number;
    datumKnjizenja?: Date;

    constructor(data?: IKnjigovodstvenoStanjeIzvoda) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.iznos = _data["iznos"];
            this.datumKnjizenja = _data["datumKnjizenja"] ? new Date(_data["datumKnjizenja"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): KnjigovodstvenoStanjeIzvoda {
        data = typeof data === 'object' ? data : {};
        let result = new KnjigovodstvenoStanjeIzvoda();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iznos"] = this.iznos;
        data["datumKnjizenja"] = this.datumKnjizenja ? this.datumKnjizenja.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IKnjigovodstvenoStanjeIzvoda extends IValueObject {
    iznos?: number;
    datumKnjizenja?: Date;
}

export enum StatusIzvoda {
    EMPTY = 0,
    NOV = 1,
    OBRADA_U_TOKU = 2,
    OBRADEN = 3,
}

export class TransakcijaIzvoda implements ITransakcijaIzvoda {
    transakcijaIzvodaId?: number;
    brojZaReklamaciju?: string | undefined;
    smerKnjizenja?: string | undefined;
    drugaStranaNaziv?: string | undefined;
    drugaStranaGrad?: string | undefined;
    drugaStranaRacun?: string | undefined;
    uplacenIznos?: number;
    raspolozivIznos?: number;
    oznakaValute?: string | undefined;
    svrhaPlacanja?: string | undefined;
    sifraPlacanja?: string | undefined;
    datumKnjizenja?: Date;
    datumUnosaTransakcije?: Date;
    datumValute?: Date;
    pozivNaBrojVlasnikaRacuna?: string | undefined;
    pozivNaBrojDrugeStrane?: string | undefined;
    swift?: string | undefined;
    status?: StatusTransakcijeIzvoda;
    tipUplate?: TipUplate;
    kategorijaIsplate?: KategorijaIsplate;
    drugaStranaId?: number | undefined;
    drugaStrana?: Stranka | undefined;
    izvod?: Izvod | undefined;
    izvodId?: number;
    racuni?: UplataPoRacunu[] | undefined;

    constructor(data?: ITransakcijaIzvoda) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transakcijaIzvodaId = _data["transakcijaIzvodaId"];
            this.brojZaReklamaciju = _data["brojZaReklamaciju"];
            this.smerKnjizenja = _data["smerKnjizenja"];
            this.drugaStranaNaziv = _data["drugaStranaNaziv"];
            this.drugaStranaGrad = _data["drugaStranaGrad"];
            this.drugaStranaRacun = _data["drugaStranaRacun"];
            this.uplacenIznos = _data["uplacenIznos"];
            this.raspolozivIznos = _data["raspolozivIznos"];
            this.oznakaValute = _data["oznakaValute"];
            this.svrhaPlacanja = _data["svrhaPlacanja"];
            this.sifraPlacanja = _data["sifraPlacanja"];
            this.datumKnjizenja = _data["datumKnjizenja"] ? new Date(_data["datumKnjizenja"].toString()) : <any>undefined;
            this.datumUnosaTransakcije = _data["datumUnosaTransakcije"] ? new Date(_data["datumUnosaTransakcije"].toString()) : <any>undefined;
            this.datumValute = _data["datumValute"] ? new Date(_data["datumValute"].toString()) : <any>undefined;
            this.pozivNaBrojVlasnikaRacuna = _data["pozivNaBrojVlasnikaRacuna"];
            this.pozivNaBrojDrugeStrane = _data["pozivNaBrojDrugeStrane"];
            this.swift = _data["swift"];
            this.status = _data["status"];
            this.tipUplate = _data["tipUplate"];
            this.kategorijaIsplate = _data["kategorijaIsplate"];
            this.drugaStranaId = _data["drugaStranaId"];
            this.drugaStrana = _data["drugaStrana"] ? Stranka.fromJS(_data["drugaStrana"]) : <any>undefined;
            this.izvod = _data["izvod"] ? Izvod.fromJS(_data["izvod"]) : <any>undefined;
            this.izvodId = _data["izvodId"];
            if (Array.isArray(_data["racuni"])) {
                this.racuni = [] as any;
                for (let item of _data["racuni"])
                    this.racuni!.push(UplataPoRacunu.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransakcijaIzvoda {
        data = typeof data === 'object' ? data : {};
        let result = new TransakcijaIzvoda();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transakcijaIzvodaId"] = this.transakcijaIzvodaId;
        data["brojZaReklamaciju"] = this.brojZaReklamaciju;
        data["smerKnjizenja"] = this.smerKnjizenja;
        data["drugaStranaNaziv"] = this.drugaStranaNaziv;
        data["drugaStranaGrad"] = this.drugaStranaGrad;
        data["drugaStranaRacun"] = this.drugaStranaRacun;
        data["uplacenIznos"] = this.uplacenIznos;
        data["raspolozivIznos"] = this.raspolozivIznos;
        data["oznakaValute"] = this.oznakaValute;
        data["svrhaPlacanja"] = this.svrhaPlacanja;
        data["sifraPlacanja"] = this.sifraPlacanja;
        data["datumKnjizenja"] = this.datumKnjizenja ? this.datumKnjizenja.toISOString() : <any>undefined;
        data["datumUnosaTransakcije"] = this.datumUnosaTransakcije ? this.datumUnosaTransakcije.toISOString() : <any>undefined;
        data["datumValute"] = this.datumValute ? this.datumValute.toISOString() : <any>undefined;
        data["pozivNaBrojVlasnikaRacuna"] = this.pozivNaBrojVlasnikaRacuna;
        data["pozivNaBrojDrugeStrane"] = this.pozivNaBrojDrugeStrane;
        data["swift"] = this.swift;
        data["status"] = this.status;
        data["tipUplate"] = this.tipUplate;
        data["kategorijaIsplate"] = this.kategorijaIsplate;
        data["drugaStranaId"] = this.drugaStranaId;
        data["drugaStrana"] = this.drugaStrana ? this.drugaStrana.toJSON() : <any>undefined;
        data["izvod"] = this.izvod ? this.izvod.toJSON() : <any>undefined;
        data["izvodId"] = this.izvodId;
        if (Array.isArray(this.racuni)) {
            data["racuni"] = [];
            for (let item of this.racuni)
                data["racuni"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITransakcijaIzvoda {
    transakcijaIzvodaId?: number;
    brojZaReklamaciju?: string | undefined;
    smerKnjizenja?: string | undefined;
    drugaStranaNaziv?: string | undefined;
    drugaStranaGrad?: string | undefined;
    drugaStranaRacun?: string | undefined;
    uplacenIznos?: number;
    raspolozivIznos?: number;
    oznakaValute?: string | undefined;
    svrhaPlacanja?: string | undefined;
    sifraPlacanja?: string | undefined;
    datumKnjizenja?: Date;
    datumUnosaTransakcije?: Date;
    datumValute?: Date;
    pozivNaBrojVlasnikaRacuna?: string | undefined;
    pozivNaBrojDrugeStrane?: string | undefined;
    swift?: string | undefined;
    status?: StatusTransakcijeIzvoda;
    tipUplate?: TipUplate;
    kategorijaIsplate?: KategorijaIsplate;
    drugaStranaId?: number | undefined;
    drugaStrana?: Stranka | undefined;
    izvod?: Izvod | undefined;
    izvodId?: number;
    racuni?: UplataPoRacunu[] | undefined;
}

export enum StatusTransakcijeIzvoda {
    EVIDENTIRANO = 1,
    RACUN_NIJE_ODREDEN = 2,
    SPREMNO_ZA_EVIDENCIJU = 3,
    DELIMICNO_EVIDENTIRANO = 4,
}

export enum TipUplate {
    UPLATA_KUPCA = 1,
    TRANSFER_MOJE_FIRME = 2,
    OSTALO = 3,
}

export enum KategorijaIsplate {
    EMPTY = 0,
    PRAVNE_USLUGE = 1,
    PLATE = 2,
    HIGIJENA = 3,
    KANCELARIJSKI_MATERIJAL = 4,
    REZIJE_I_KIRIJE = 5,
    TRANSFER_MOJE_FIRME = 6,
}

export class UplataPoRacunu implements IUplataPoRacunu {
    uplataPoRacunuId?: number;
    uplataId?: number | undefined;
    uplata?: TransakcijaIzvoda | undefined;
    uplataKompenzacijaId?: number | undefined;
    uplataKompenzacija?: Kompenzacija | undefined;
    racunId?: number;
    racun?: Racun | undefined;
    uplacenIznos?: number;
    tipTransakcije?: TipTransakcije | undefined;

    constructor(data?: IUplataPoRacunu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uplataPoRacunuId = _data["uplataPoRacunuId"];
            this.uplataId = _data["uplataId"];
            this.uplata = _data["uplata"] ? TransakcijaIzvoda.fromJS(_data["uplata"]) : <any>undefined;
            this.uplataKompenzacijaId = _data["uplataKompenzacijaId"];
            this.uplataKompenzacija = _data["uplataKompenzacija"] ? Kompenzacija.fromJS(_data["uplataKompenzacija"]) : <any>undefined;
            this.racunId = _data["racunId"];
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
            this.uplacenIznos = _data["uplacenIznos"];
            this.tipTransakcije = _data["tipTransakcije"];
        }
    }

    static fromJS(data: any): UplataPoRacunu {
        data = typeof data === 'object' ? data : {};
        let result = new UplataPoRacunu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uplataPoRacunuId"] = this.uplataPoRacunuId;
        data["uplataId"] = this.uplataId;
        data["uplata"] = this.uplata ? this.uplata.toJSON() : <any>undefined;
        data["uplataKompenzacijaId"] = this.uplataKompenzacijaId;
        data["uplataKompenzacija"] = this.uplataKompenzacija ? this.uplataKompenzacija.toJSON() : <any>undefined;
        data["racunId"] = this.racunId;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        data["uplacenIznos"] = this.uplacenIznos;
        data["tipTransakcije"] = this.tipTransakcije;
        return data;
    }
}

export interface IUplataPoRacunu {
    uplataPoRacunuId?: number;
    uplataId?: number | undefined;
    uplata?: TransakcijaIzvoda | undefined;
    uplataKompenzacijaId?: number | undefined;
    uplataKompenzacija?: Kompenzacija | undefined;
    racunId?: number;
    racun?: Racun | undefined;
    uplacenIznos?: number;
    tipTransakcije?: TipTransakcije | undefined;
}

export class Kompenzacija extends AuditableEntity implements IKompenzacija {
    kompenzacijaId?: number;
    broj?: string | undefined;
    tekuciRacunStranke?: string | undefined;
    strankaId?: number;
    stranka?: Stranka | undefined;
    tekuciRacunId?: number;
    tekuciRacun?: TekuciRacun | undefined;
    razlika?: number;
    vrsta?: VrstaRacuna;
    napomena?: string | undefined;
    obavezePremaDuzniku?: KompenzacionaObaveza[] | undefined;
    obavezePremaPoveriocu?: KompenzacionaObaveza[] | undefined;
    uplate?: UplataPoRacunu[] | undefined;

    constructor(data?: IKompenzacija) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.kompenzacijaId = _data["kompenzacijaId"];
            this.broj = _data["broj"];
            this.tekuciRacunStranke = _data["tekuciRacunStranke"];
            this.strankaId = _data["strankaId"];
            this.stranka = _data["stranka"] ? Stranka.fromJS(_data["stranka"]) : <any>undefined;
            this.tekuciRacunId = _data["tekuciRacunId"];
            this.tekuciRacun = _data["tekuciRacun"] ? TekuciRacun.fromJS(_data["tekuciRacun"]) : <any>undefined;
            this.razlika = _data["razlika"];
            this.vrsta = _data["vrsta"];
            this.napomena = _data["napomena"];
            if (Array.isArray(_data["obavezePremaDuzniku"])) {
                this.obavezePremaDuzniku = [] as any;
                for (let item of _data["obavezePremaDuzniku"])
                    this.obavezePremaDuzniku!.push(KompenzacionaObaveza.fromJS(item));
            }
            if (Array.isArray(_data["obavezePremaPoveriocu"])) {
                this.obavezePremaPoveriocu = [] as any;
                for (let item of _data["obavezePremaPoveriocu"])
                    this.obavezePremaPoveriocu!.push(KompenzacionaObaveza.fromJS(item));
            }
            if (Array.isArray(_data["uplate"])) {
                this.uplate = [] as any;
                for (let item of _data["uplate"])
                    this.uplate!.push(UplataPoRacunu.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Kompenzacija {
        data = typeof data === 'object' ? data : {};
        let result = new Kompenzacija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kompenzacijaId"] = this.kompenzacijaId;
        data["broj"] = this.broj;
        data["tekuciRacunStranke"] = this.tekuciRacunStranke;
        data["strankaId"] = this.strankaId;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        data["tekuciRacunId"] = this.tekuciRacunId;
        data["tekuciRacun"] = this.tekuciRacun ? this.tekuciRacun.toJSON() : <any>undefined;
        data["razlika"] = this.razlika;
        data["vrsta"] = this.vrsta;
        data["napomena"] = this.napomena;
        if (Array.isArray(this.obavezePremaDuzniku)) {
            data["obavezePremaDuzniku"] = [];
            for (let item of this.obavezePremaDuzniku)
                data["obavezePremaDuzniku"].push(item.toJSON());
        }
        if (Array.isArray(this.obavezePremaPoveriocu)) {
            data["obavezePremaPoveriocu"] = [];
            for (let item of this.obavezePremaPoveriocu)
                data["obavezePremaPoveriocu"].push(item.toJSON());
        }
        if (Array.isArray(this.uplate)) {
            data["uplate"] = [];
            for (let item of this.uplate)
                data["uplate"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IKompenzacija extends IAuditableEntity {
    kompenzacijaId?: number;
    broj?: string | undefined;
    tekuciRacunStranke?: string | undefined;
    strankaId?: number;
    stranka?: Stranka | undefined;
    tekuciRacunId?: number;
    tekuciRacun?: TekuciRacun | undefined;
    razlika?: number;
    vrsta?: VrstaRacuna;
    napomena?: string | undefined;
    obavezePremaDuzniku?: KompenzacionaObaveza[] | undefined;
    obavezePremaPoveriocu?: KompenzacionaObaveza[] | undefined;
    uplate?: UplataPoRacunu[] | undefined;
}

export class KompenzacionaObaveza implements IKompenzacionaObaveza {
    kompenzacionaObavezaId?: number;
    racunId?: number;
    racun?: Racun | undefined;
    poverilacId?: number | undefined;
    poverilac?: Kompenzacija | undefined;
    duznikId?: number | undefined;
    duznik?: Kompenzacija | undefined;
    iznos?: number;

    constructor(data?: IKompenzacionaObaveza) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kompenzacionaObavezaId = _data["kompenzacionaObavezaId"];
            this.racunId = _data["racunId"];
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
            this.poverilacId = _data["poverilacId"];
            this.poverilac = _data["poverilac"] ? Kompenzacija.fromJS(_data["poverilac"]) : <any>undefined;
            this.duznikId = _data["duznikId"];
            this.duznik = _data["duznik"] ? Kompenzacija.fromJS(_data["duznik"]) : <any>undefined;
            this.iznos = _data["iznos"];
        }
    }

    static fromJS(data: any): KompenzacionaObaveza {
        data = typeof data === 'object' ? data : {};
        let result = new KompenzacionaObaveza();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kompenzacionaObavezaId"] = this.kompenzacionaObavezaId;
        data["racunId"] = this.racunId;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        data["poverilacId"] = this.poverilacId;
        data["poverilac"] = this.poverilac ? this.poverilac.toJSON() : <any>undefined;
        data["duznikId"] = this.duznikId;
        data["duznik"] = this.duznik ? this.duznik.toJSON() : <any>undefined;
        data["iznos"] = this.iznos;
        return data;
    }
}

export interface IKompenzacionaObaveza {
    kompenzacionaObavezaId?: number;
    racunId?: number;
    racun?: Racun | undefined;
    poverilacId?: number | undefined;
    poverilac?: Kompenzacija | undefined;
    duznikId?: number | undefined;
    duznik?: Kompenzacija | undefined;
    iznos?: number;
}

export enum TipTransakcije {
    UPLATA_KUPCA = 1,
    PLACANJE_DOBAVLJACU = 2,
    ISPLATA_ZARADE = 3,
    POREZI_I_DOPRINOSI = 4,
    PROVIZIJA_BANKE = 5,
    KAMATNA_NAKNADA = 6,
    KURSNA_RAZLIKA = 7,
    PRIMLJENI_AVANS = 8,
    DATI_AVANS = 9,
    KREDITI = 10,
    OSTALI_RASHODI = 11,
}

export class KonfiguracijaBrojaRacuna extends AuditableEntity implements IKonfiguracijaBrojaRacuna {
    konfiguracijaBrojaRacunaId?: number;
    naziv?: string | undefined;
    tipRacuna?: TipRacuna;
    prefiks?: string | undefined;
    brojac?: number;
    sufiks?: string | undefined;
    isDefault?: boolean;
    minimaxId?: number | undefined;
    racuni?: Racun[] | undefined;

    constructor(data?: IKonfiguracijaBrojaRacuna) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.konfiguracijaBrojaRacunaId = _data["konfiguracijaBrojaRacunaId"];
            this.naziv = _data["naziv"];
            this.tipRacuna = _data["tipRacuna"];
            this.prefiks = _data["prefiks"];
            this.brojac = _data["brojac"];
            this.sufiks = _data["sufiks"];
            this.isDefault = _data["isDefault"];
            this.minimaxId = _data["minimaxId"];
            if (Array.isArray(_data["racuni"])) {
                this.racuni = [] as any;
                for (let item of _data["racuni"])
                    this.racuni!.push(Racun.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KonfiguracijaBrojaRacuna {
        data = typeof data === 'object' ? data : {};
        let result = new KonfiguracijaBrojaRacuna();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["konfiguracijaBrojaRacunaId"] = this.konfiguracijaBrojaRacunaId;
        data["naziv"] = this.naziv;
        data["tipRacuna"] = this.tipRacuna;
        data["prefiks"] = this.prefiks;
        data["brojac"] = this.brojac;
        data["sufiks"] = this.sufiks;
        data["isDefault"] = this.isDefault;
        data["minimaxId"] = this.minimaxId;
        if (Array.isArray(this.racuni)) {
            data["racuni"] = [];
            for (let item of this.racuni)
                data["racuni"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IKonfiguracijaBrojaRacuna extends IAuditableEntity {
    konfiguracijaBrojaRacunaId?: number;
    naziv?: string | undefined;
    tipRacuna?: TipRacuna;
    prefiks?: string | undefined;
    brojac?: number;
    sufiks?: string | undefined;
    isDefault?: boolean;
    minimaxId?: number | undefined;
    racuni?: Racun[] | undefined;
}

export abstract class IzmenaOsnovice implements IIzmenaOsnovice {
    racunId?: number;
    racun?: Racun | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    prikazIzmenaOsnovice?: PrikazIzmenaOsnovice;

    constructor(data?: IIzmenaOsnovice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
            this.periodOd = _data["periodOd"] ? new Date(_data["periodOd"].toString()) : <any>undefined;
            this.periodDo = _data["periodDo"] ? new Date(_data["periodDo"].toString()) : <any>undefined;
            this.prikazIzmenaOsnovice = _data["prikazIzmenaOsnovice"];
        }
    }

    static fromJS(data: any): IzmenaOsnovice {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IzmenaOsnovice' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        data["periodOd"] = this.periodOd ? this.periodOd.toISOString() : <any>undefined;
        data["periodDo"] = this.periodDo ? this.periodDo.toISOString() : <any>undefined;
        data["prikazIzmenaOsnovice"] = this.prikazIzmenaOsnovice;
        return data;
    }
}

export interface IIzmenaOsnovice {
    racunId?: number;
    racun?: Racun | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    prikazIzmenaOsnovice?: PrikazIzmenaOsnovice;
}

export class DokumentOPovecanju extends IzmenaOsnovice implements IDokumentOPovecanju {

    constructor(data?: IDokumentOPovecanju) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DokumentOPovecanju {
        data = typeof data === 'object' ? data : {};
        let result = new DokumentOPovecanju();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDokumentOPovecanju extends IIzmenaOsnovice {
}

export class DokumentOSmanjenju extends IzmenaOsnovice implements IDokumentOSmanjenju {
    jeReferencaNaAvansniRacun?: boolean | undefined;

    constructor(data?: IDokumentOSmanjenju) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jeReferencaNaAvansniRacun = _data["jeReferencaNaAvansniRacun"];
        }
    }

    static fromJS(data: any): DokumentOSmanjenju {
        data = typeof data === 'object' ? data : {};
        let result = new DokumentOSmanjenju();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jeReferencaNaAvansniRacun"] = this.jeReferencaNaAvansniRacun;
        super.toJSON(data);
        return data;
    }
}

export interface IDokumentOSmanjenju extends IIzmenaOsnovice {
    jeReferencaNaAvansniRacun?: boolean | undefined;
}

export class RadniNalog implements IRadniNalog {
    racunId?: number;
    racun?: Racun | undefined;
    rok?: Date;
    vrsta?: VrstaRadnogNaloga;
    statusRadnogNaloga?: StatusRadnogNaloga;

    constructor(data?: IRadniNalog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
            this.rok = _data["rok"] ? new Date(_data["rok"].toString()) : <any>undefined;
            this.vrsta = _data["vrsta"];
            this.statusRadnogNaloga = _data["statusRadnogNaloga"];
        }
    }

    static fromJS(data: any): RadniNalog {
        data = typeof data === 'object' ? data : {};
        let result = new RadniNalog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        data["rok"] = this.rok ? this.rok.toISOString() : <any>undefined;
        data["vrsta"] = this.vrsta;
        data["statusRadnogNaloga"] = this.statusRadnogNaloga;
        return data;
    }
}

export interface IRadniNalog {
    racunId?: number;
    racun?: Racun | undefined;
    rok?: Date;
    vrsta?: VrstaRadnogNaloga;
    statusRadnogNaloga?: StatusRadnogNaloga;
}

export enum VrstaRadnogNaloga {
    EMPTY = 0,
    PROIZVODNJA_PO_NARUDZBINI = 1,
    USLUZNA_DELATNOST = 2,
    GRAĐEVINA = 3,
    EVIDENCIJA_VREMENA_I_MATERIJALA = 4,
    PROIZVODNJA_ZA_LAGER = 5,
}

export enum StatusRadnogNaloga {
    EMPTY = 0,
    NACRT = 1,
    ZAPOCET = 2,
    ZAVRSEN = 3,
    OTKAZAN = 4,
}

export class UlaznaFaktura extends Faktura implements IUlaznaFaktura {
    racunId?: number;
    racun?: Racun | undefined;
    zavisniTroskovi?: ZavisniTrosakRacuna[] | undefined;

    constructor(data?: IUlaznaFaktura) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.racunId = _data["racunId"];
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
            if (Array.isArray(_data["zavisniTroskovi"])) {
                this.zavisniTroskovi = [] as any;
                for (let item of _data["zavisniTroskovi"])
                    this.zavisniTroskovi!.push(ZavisniTrosakRacuna.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UlaznaFaktura {
        data = typeof data === 'object' ? data : {};
        let result = new UlaznaFaktura();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        if (Array.isArray(this.zavisniTroskovi)) {
            data["zavisniTroskovi"] = [];
            for (let item of this.zavisniTroskovi)
                data["zavisniTroskovi"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUlaznaFaktura extends IFaktura {
    racunId?: number;
    racun?: Racun | undefined;
    zavisniTroskovi?: ZavisniTrosakRacuna[] | undefined;
}

export class ZavisniTrosakRacuna implements IZavisniTrosakRacuna {
    id?: number;
    originalniBrojRacuna?: string | undefined;
    naziv?: string | undefined;
    iznosBezPdv?: number;
    iznosSaPdv?: number;
    ulaznaFakturaId?: number;
    ulaznaFaktura?: UlaznaFaktura | undefined;

    constructor(data?: IZavisniTrosakRacuna) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.originalniBrojRacuna = _data["originalniBrojRacuna"];
            this.naziv = _data["naziv"];
            this.iznosBezPdv = _data["iznosBezPdv"];
            this.iznosSaPdv = _data["iznosSaPdv"];
            this.ulaznaFakturaId = _data["ulaznaFakturaId"];
            this.ulaznaFaktura = _data["ulaznaFaktura"] ? UlaznaFaktura.fromJS(_data["ulaznaFaktura"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ZavisniTrosakRacuna {
        data = typeof data === 'object' ? data : {};
        let result = new ZavisniTrosakRacuna();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["originalniBrojRacuna"] = this.originalniBrojRacuna;
        data["naziv"] = this.naziv;
        data["iznosBezPdv"] = this.iznosBezPdv;
        data["iznosSaPdv"] = this.iznosSaPdv;
        data["ulaznaFakturaId"] = this.ulaznaFakturaId;
        data["ulaznaFaktura"] = this.ulaznaFaktura ? this.ulaznaFaktura.toJSON() : <any>undefined;
        return data;
    }
}

export interface IZavisniTrosakRacuna {
    id?: number;
    originalniBrojRacuna?: string | undefined;
    naziv?: string | undefined;
    iznosBezPdv?: number;
    iznosSaPdv?: number;
    ulaznaFakturaId?: number;
    ulaznaFaktura?: UlaznaFaktura | undefined;
}

export enum VrstaFakture {
    EMPTY = 0,
    DOMACA = 1,
    STRANA = 2,
    POCETNO_STANJE = 3,
}

export class Predracun implements IPredracun {
    racunId?: number;
    racun?: Racun | undefined;
    rokVazenja?: number;
    jeIstekao?: boolean;
    jePonuda?: boolean;

    constructor(data?: IPredracun) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
            this.rokVazenja = _data["rokVazenja"];
            this.jeIstekao = _data["jeIstekao"];
            this.jePonuda = _data["jePonuda"];
        }
    }

    static fromJS(data: any): Predracun {
        data = typeof data === 'object' ? data : {};
        let result = new Predracun();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        data["rokVazenja"] = this.rokVazenja;
        data["jeIstekao"] = this.jeIstekao;
        data["jePonuda"] = this.jePonuda;
        return data;
    }
}

export interface IPredracun {
    racunId?: number;
    racun?: Racun | undefined;
    rokVazenja?: number;
    jeIstekao?: boolean;
    jePonuda?: boolean;
}

export class AvansniRacun implements IAvansniRacun {
    racunId?: number;
    racun?: Racun | undefined;
    preostaloPdv8?: number | undefined;
    preostaloPdv10?: number | undefined;
    preostaloPdv20?: number | undefined;
    preostaloUkupnoOsnovica8?: number | undefined;
    preostaloUkupnoOsnovica10?: number | undefined;
    preostaloUkupnoOsnovica20?: number | undefined;
    preostaloUkupnoOsnovicaAe?: number | undefined;
    preostaloUkupnoOsnovicaAe10?: number | undefined;
    preostaloUkupnoOsnovicaAe20?: number | undefined;
    preostaloUkupnoOsnovicaO?: number | undefined;
    preostaloUkupnoOsnovicaE?: number | undefined;
    preostaloUkupnoOsnovicaR?: number | undefined;
    preostaloUkupnoOsnovicaZ?: number | undefined;
    preostaloUkupnoOsnovicaSs?: number | undefined;
    preostaloUkupnoOsnovicaOe?: number | undefined;
    preostaloUkupnoOsnovicaN?: number | undefined;
    evidentiranNaRacunima?: AvansnaUplataRacuna[] | undefined;

    constructor(data?: IAvansniRacun) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
            this.preostaloPdv8 = _data["preostaloPdv8"];
            this.preostaloPdv10 = _data["preostaloPdv10"];
            this.preostaloPdv20 = _data["preostaloPdv20"];
            this.preostaloUkupnoOsnovica8 = _data["preostaloUkupnoOsnovica8"];
            this.preostaloUkupnoOsnovica10 = _data["preostaloUkupnoOsnovica10"];
            this.preostaloUkupnoOsnovica20 = _data["preostaloUkupnoOsnovica20"];
            this.preostaloUkupnoOsnovicaAe = _data["preostaloUkupnoOsnovicaAe"];
            this.preostaloUkupnoOsnovicaAe10 = _data["preostaloUkupnoOsnovicaAe10"];
            this.preostaloUkupnoOsnovicaAe20 = _data["preostaloUkupnoOsnovicaAe20"];
            this.preostaloUkupnoOsnovicaO = _data["preostaloUkupnoOsnovicaO"];
            this.preostaloUkupnoOsnovicaE = _data["preostaloUkupnoOsnovicaE"];
            this.preostaloUkupnoOsnovicaR = _data["preostaloUkupnoOsnovicaR"];
            this.preostaloUkupnoOsnovicaZ = _data["preostaloUkupnoOsnovicaZ"];
            this.preostaloUkupnoOsnovicaSs = _data["preostaloUkupnoOsnovicaSs"];
            this.preostaloUkupnoOsnovicaOe = _data["preostaloUkupnoOsnovicaOe"];
            this.preostaloUkupnoOsnovicaN = _data["preostaloUkupnoOsnovicaN"];
            if (Array.isArray(_data["evidentiranNaRacunima"])) {
                this.evidentiranNaRacunima = [] as any;
                for (let item of _data["evidentiranNaRacunima"])
                    this.evidentiranNaRacunima!.push(AvansnaUplataRacuna.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AvansniRacun {
        data = typeof data === 'object' ? data : {};
        let result = new AvansniRacun();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        data["preostaloPdv8"] = this.preostaloPdv8;
        data["preostaloPdv10"] = this.preostaloPdv10;
        data["preostaloPdv20"] = this.preostaloPdv20;
        data["preostaloUkupnoOsnovica8"] = this.preostaloUkupnoOsnovica8;
        data["preostaloUkupnoOsnovica10"] = this.preostaloUkupnoOsnovica10;
        data["preostaloUkupnoOsnovica20"] = this.preostaloUkupnoOsnovica20;
        data["preostaloUkupnoOsnovicaAe"] = this.preostaloUkupnoOsnovicaAe;
        data["preostaloUkupnoOsnovicaAe10"] = this.preostaloUkupnoOsnovicaAe10;
        data["preostaloUkupnoOsnovicaAe20"] = this.preostaloUkupnoOsnovicaAe20;
        data["preostaloUkupnoOsnovicaO"] = this.preostaloUkupnoOsnovicaO;
        data["preostaloUkupnoOsnovicaE"] = this.preostaloUkupnoOsnovicaE;
        data["preostaloUkupnoOsnovicaR"] = this.preostaloUkupnoOsnovicaR;
        data["preostaloUkupnoOsnovicaZ"] = this.preostaloUkupnoOsnovicaZ;
        data["preostaloUkupnoOsnovicaSs"] = this.preostaloUkupnoOsnovicaSs;
        data["preostaloUkupnoOsnovicaOe"] = this.preostaloUkupnoOsnovicaOe;
        data["preostaloUkupnoOsnovicaN"] = this.preostaloUkupnoOsnovicaN;
        if (Array.isArray(this.evidentiranNaRacunima)) {
            data["evidentiranNaRacunima"] = [];
            for (let item of this.evidentiranNaRacunima)
                data["evidentiranNaRacunima"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAvansniRacun {
    racunId?: number;
    racun?: Racun | undefined;
    preostaloPdv8?: number | undefined;
    preostaloPdv10?: number | undefined;
    preostaloPdv20?: number | undefined;
    preostaloUkupnoOsnovica8?: number | undefined;
    preostaloUkupnoOsnovica10?: number | undefined;
    preostaloUkupnoOsnovica20?: number | undefined;
    preostaloUkupnoOsnovicaAe?: number | undefined;
    preostaloUkupnoOsnovicaAe10?: number | undefined;
    preostaloUkupnoOsnovicaAe20?: number | undefined;
    preostaloUkupnoOsnovicaO?: number | undefined;
    preostaloUkupnoOsnovicaE?: number | undefined;
    preostaloUkupnoOsnovicaR?: number | undefined;
    preostaloUkupnoOsnovicaZ?: number | undefined;
    preostaloUkupnoOsnovicaSs?: number | undefined;
    preostaloUkupnoOsnovicaOe?: number | undefined;
    preostaloUkupnoOsnovicaN?: number | undefined;
    evidentiranNaRacunima?: AvansnaUplataRacuna[] | undefined;
}

export class AvansnaUplataRacuna implements IAvansnaUplataRacuna {
    avansnaUplataRacunaId?: number;
    avansniRacunId?: number;
    avansniRacun?: AvansniRacun | undefined;
    racunId?: number;
    racun?: Racun | undefined;
    evidentiranaOsnovica8?: number | undefined;
    evidentiranaOsnovica10?: number | undefined;
    evidentiranaOsnovica20?: number | undefined;
    evidentiranPdv8?: number | undefined;
    evidentiranPdv10?: number | undefined;
    evidentiranPdv20?: number | undefined;
    evidentiranaOsnovicaAE?: number | undefined;
    evidentiranaOsnovicaAE10?: number | undefined;
    evidentiranaOsnovicaAE20?: number | undefined;
    evidentiranaOsnovicaO?: number | undefined;
    evidentiranaOsnovicaE?: number | undefined;
    evidentiranaOsnovicaR?: number | undefined;
    evidentiranaOsnovicaZ?: number | undefined;
    evidentiranaOsnovicaSS?: number | undefined;
    evidentiranaOsnovicaOE?: number | undefined;
    evidentiranaOsnovicaN?: number | undefined;

    constructor(data?: IAvansnaUplataRacuna) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avansnaUplataRacunaId = _data["avansnaUplataRacunaId"];
            this.avansniRacunId = _data["avansniRacunId"];
            this.avansniRacun = _data["avansniRacun"] ? AvansniRacun.fromJS(_data["avansniRacun"]) : <any>undefined;
            this.racunId = _data["racunId"];
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
            this.evidentiranaOsnovica8 = _data["evidentiranaOsnovica8"];
            this.evidentiranaOsnovica10 = _data["evidentiranaOsnovica10"];
            this.evidentiranaOsnovica20 = _data["evidentiranaOsnovica20"];
            this.evidentiranPdv8 = _data["evidentiranPdv8"];
            this.evidentiranPdv10 = _data["evidentiranPdv10"];
            this.evidentiranPdv20 = _data["evidentiranPdv20"];
            this.evidentiranaOsnovicaAE = _data["evidentiranaOsnovicaAE"];
            this.evidentiranaOsnovicaAE10 = _data["evidentiranaOsnovicaAE10"];
            this.evidentiranaOsnovicaAE20 = _data["evidentiranaOsnovicaAE20"];
            this.evidentiranaOsnovicaO = _data["evidentiranaOsnovicaO"];
            this.evidentiranaOsnovicaE = _data["evidentiranaOsnovicaE"];
            this.evidentiranaOsnovicaR = _data["evidentiranaOsnovicaR"];
            this.evidentiranaOsnovicaZ = _data["evidentiranaOsnovicaZ"];
            this.evidentiranaOsnovicaSS = _data["evidentiranaOsnovicaSS"];
            this.evidentiranaOsnovicaOE = _data["evidentiranaOsnovicaOE"];
            this.evidentiranaOsnovicaN = _data["evidentiranaOsnovicaN"];
        }
    }

    static fromJS(data: any): AvansnaUplataRacuna {
        data = typeof data === 'object' ? data : {};
        let result = new AvansnaUplataRacuna();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avansnaUplataRacunaId"] = this.avansnaUplataRacunaId;
        data["avansniRacunId"] = this.avansniRacunId;
        data["avansniRacun"] = this.avansniRacun ? this.avansniRacun.toJSON() : <any>undefined;
        data["racunId"] = this.racunId;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        data["evidentiranaOsnovica8"] = this.evidentiranaOsnovica8;
        data["evidentiranaOsnovica10"] = this.evidentiranaOsnovica10;
        data["evidentiranaOsnovica20"] = this.evidentiranaOsnovica20;
        data["evidentiranPdv8"] = this.evidentiranPdv8;
        data["evidentiranPdv10"] = this.evidentiranPdv10;
        data["evidentiranPdv20"] = this.evidentiranPdv20;
        data["evidentiranaOsnovicaAE"] = this.evidentiranaOsnovicaAE;
        data["evidentiranaOsnovicaAE10"] = this.evidentiranaOsnovicaAE10;
        data["evidentiranaOsnovicaAE20"] = this.evidentiranaOsnovicaAE20;
        data["evidentiranaOsnovicaO"] = this.evidentiranaOsnovicaO;
        data["evidentiranaOsnovicaE"] = this.evidentiranaOsnovicaE;
        data["evidentiranaOsnovicaR"] = this.evidentiranaOsnovicaR;
        data["evidentiranaOsnovicaZ"] = this.evidentiranaOsnovicaZ;
        data["evidentiranaOsnovicaSS"] = this.evidentiranaOsnovicaSS;
        data["evidentiranaOsnovicaOE"] = this.evidentiranaOsnovicaOE;
        data["evidentiranaOsnovicaN"] = this.evidentiranaOsnovicaN;
        return data;
    }
}

export interface IAvansnaUplataRacuna {
    avansnaUplataRacunaId?: number;
    avansniRacunId?: number;
    avansniRacun?: AvansniRacun | undefined;
    racunId?: number;
    racun?: Racun | undefined;
    evidentiranaOsnovica8?: number | undefined;
    evidentiranaOsnovica10?: number | undefined;
    evidentiranaOsnovica20?: number | undefined;
    evidentiranPdv8?: number | undefined;
    evidentiranPdv10?: number | undefined;
    evidentiranPdv20?: number | undefined;
    evidentiranaOsnovicaAE?: number | undefined;
    evidentiranaOsnovicaAE10?: number | undefined;
    evidentiranaOsnovicaAE20?: number | undefined;
    evidentiranaOsnovicaO?: number | undefined;
    evidentiranaOsnovicaE?: number | undefined;
    evidentiranaOsnovicaR?: number | undefined;
    evidentiranaOsnovicaZ?: number | undefined;
    evidentiranaOsnovicaSS?: number | undefined;
    evidentiranaOsnovicaOE?: number | undefined;
    evidentiranaOsnovicaN?: number | undefined;
}

export class PodaciUplateDevizni implements IPodaciUplateDevizni {
    racun?: Racun | undefined;
    racunId?: number;
    podaciUplateDevizniId?: number;
    bank?: string | undefined;
    iban?: string | undefined;
    swift?: string | undefined;
    accountName?: string | undefined;
    accountAddres?: string | undefined;
    srednjiKursNaDan?: number | undefined;

    constructor(data?: IPodaciUplateDevizni) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
            this.racunId = _data["racunId"];
            this.podaciUplateDevizniId = _data["podaciUplateDevizniId"];
            this.bank = _data["bank"];
            this.iban = _data["iban"];
            this.swift = _data["swift"];
            this.accountName = _data["accountName"];
            this.accountAddres = _data["accountAddres"];
            this.srednjiKursNaDan = _data["srednjiKursNaDan"];
        }
    }

    static fromJS(data: any): PodaciUplateDevizni {
        data = typeof data === 'object' ? data : {};
        let result = new PodaciUplateDevizni();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        data["racunId"] = this.racunId;
        data["podaciUplateDevizniId"] = this.podaciUplateDevizniId;
        data["bank"] = this.bank;
        data["iban"] = this.iban;
        data["swift"] = this.swift;
        data["accountName"] = this.accountName;
        data["accountAddres"] = this.accountAddres;
        data["srednjiKursNaDan"] = this.srednjiKursNaDan;
        return data;
    }
}

export interface IPodaciUplateDevizni {
    racun?: Racun | undefined;
    racunId?: number;
    podaciUplateDevizniId?: number;
    bank?: string | undefined;
    iban?: string | undefined;
    swift?: string | undefined;
    accountName?: string | undefined;
    accountAddres?: string | undefined;
    srednjiKursNaDan?: number | undefined;
}

export class RacunUkupanIznos implements IRacunUkupanIznos {
    racunId?: number;
    racun?: Racun | undefined;
    zbirStavki8?: number | undefined;
    zbirStavki10?: number | undefined;
    zbirStavki20?: number | undefined;
    zbirStavkiS?: number | undefined;
    zbirStavkiAE?: number | undefined;
    zbirStavkiAE10?: number | undefined;
    zbirStavkiAE20?: number | undefined;
    zbirStavkiO?: number | undefined;
    zbirStavkiE?: number | undefined;
    zbirStavkiR?: number | undefined;
    zbirStavkiZ?: number | undefined;
    zbirStavkiSS?: number | undefined;
    zbirStavkiOE?: number | undefined;
    zbirStavkiN?: number | undefined;
    smanjenjeNaknade8?: number | undefined;
    smanjenjeNaknade10?: number | undefined;
    smanjenjeNaknade20?: number | undefined;
    smanjenjeNaknadeAE?: number | undefined;
    smanjenjeNaknadeAE10?: number | undefined;
    smanjenjeNaknadeAE20?: number | undefined;
    smanjenjeNaknadeO?: number | undefined;
    smanjenjeNaknadeE?: number | undefined;
    smanjenjeNaknadeR?: number | undefined;
    smanjenjeNaknadeZ?: number | undefined;
    smanjenjeNaknadeSS?: number | undefined;
    smanjenjeNaknadeOE?: number | undefined;
    smanjenjeNaknadeN?: number | undefined;
    ukupnoOsnovica8?: number | undefined;
    ukupnoOsnovica10?: number | undefined;
    ukupnoOsnovica20?: number | undefined;
    ukupnoOsnovicaAE?: number | undefined;
    ukupnoOsnovicaAE10?: number | undefined;
    ukupnoOsnovicaAE20?: number | undefined;
    ukupnoOsnovicaO?: number | undefined;
    ukupnoOsnovicaE?: number | undefined;
    ukupnoOsnovicaR?: number | undefined;
    ukupnoOsnovicaZ?: number | undefined;
    ukupnoOsnovicaSS?: number | undefined;
    ukupnoOsnovicaOE?: number | undefined;
    ukupnoOsnovicaN?: number | undefined;
    ukupnoPdv8?: number | undefined;
    ukupnoPdv10?: number | undefined;
    ukupnoPdv20?: number | undefined;
    rsdUkupnoOsnovica8?: number | undefined;
    rsdUkupnoOsnovica10?: number | undefined;
    rsdUkupnoOsnovica20?: number | undefined;
    rsdUkupnoOsnovicaAE?: number | undefined;
    rsdUkupnoOsnovicaAE10?: number | undefined;
    rsdUkupnoOsnovicaAE20?: number | undefined;
    rsdUkupnoOsnovicaO?: number | undefined;
    rsdUkupnoOsnovicaE?: number | undefined;
    rsdUkupnoOsnovicaR?: number | undefined;
    rsdUkupnoOsnovicaZ?: number | undefined;
    rsdUkupnoOsnovicaSS?: number | undefined;
    rsdUkupnoOsnovicaOE?: number | undefined;
    rsdUkupnoOsnovicaN?: number | undefined;
    rsdUkupnoPdv8?: number | undefined;
    rsdUkupnoPdv10?: number | undefined;
    rsdUkupnoPdv20?: number | undefined;
    avansiraniPdv8?: number | undefined;
    avansiraniPdv10?: number | undefined;
    avansiraniPdv20?: number | undefined;
    avansiranaOsnovicaS?: number | undefined;
    avansiranaOsnovica8?: number | undefined;
    avansiranaOsnovica10?: number | undefined;
    avansiranaOsnovica20?: number | undefined;
    avansiranaOsnovicaAE?: number | undefined;
    avansiranaOsnovicaAE10?: number | undefined;
    avansiranaOsnovicaAE20?: number | undefined;
    avansiranaOsnovicaO?: number | undefined;
    avansiranaOsnovicaE?: number | undefined;
    avansiranaOsnovicaR?: number | undefined;
    avansiranaOsnovicaZ?: number | undefined;
    avansiranaOsnovicaSS?: number | undefined;
    avansiranaOsnovicaOE?: number | undefined;
    avansiranaOsnovicaN?: number | undefined;
    ukupanAvansiranIznos?: number | undefined;
    umanjenaOsnovicaS?: number | undefined;
    umanjenaOsnovica8?: number | undefined;
    umanjenaOsnovica10?: number | undefined;
    umanjenaOsnovica20?: number | undefined;
    umanjenaOsnovicaAE?: number | undefined;
    umanjenaOsnovicaAE10?: number | undefined;
    umanjenaOsnovicaAE20?: number | undefined;
    umanjenaOsnovicaO?: number | undefined;
    umanjenaOsnovicaE?: number | undefined;
    umanjenaOsnovicaR?: number | undefined;
    umanjenaOsnovicaZ?: number | undefined;
    umanjenaOsnovicaSS?: number | undefined;
    umanjenaOsnovicaOE?: number | undefined;
    umanjenaOsnovicaN?: number | undefined;
    ukupnoPdvUmanjenZaAvanse8?: number | undefined;
    ukupnoPdvUmanjenZaAvanse10?: number | undefined;
    ukupnoPdvUmanjenZaAvanse20?: number | undefined;
    iznosZaZaokruzivanje?: number | undefined;
    ukupnoZaUplatu?: number;

    constructor(data?: IRacunUkupanIznos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
            this.zbirStavki8 = _data["zbirStavki8"];
            this.zbirStavki10 = _data["zbirStavki10"];
            this.zbirStavki20 = _data["zbirStavki20"];
            this.zbirStavkiS = _data["zbirStavkiS"];
            this.zbirStavkiAE = _data["zbirStavkiAE"];
            this.zbirStavkiAE10 = _data["zbirStavkiAE10"];
            this.zbirStavkiAE20 = _data["zbirStavkiAE20"];
            this.zbirStavkiO = _data["zbirStavkiO"];
            this.zbirStavkiE = _data["zbirStavkiE"];
            this.zbirStavkiR = _data["zbirStavkiR"];
            this.zbirStavkiZ = _data["zbirStavkiZ"];
            this.zbirStavkiSS = _data["zbirStavkiSS"];
            this.zbirStavkiOE = _data["zbirStavkiOE"];
            this.zbirStavkiN = _data["zbirStavkiN"];
            this.smanjenjeNaknade8 = _data["smanjenjeNaknade8"];
            this.smanjenjeNaknade10 = _data["smanjenjeNaknade10"];
            this.smanjenjeNaknade20 = _data["smanjenjeNaknade20"];
            this.smanjenjeNaknadeAE = _data["smanjenjeNaknadeAE"];
            this.smanjenjeNaknadeAE10 = _data["smanjenjeNaknadeAE10"];
            this.smanjenjeNaknadeAE20 = _data["smanjenjeNaknadeAE20"];
            this.smanjenjeNaknadeO = _data["smanjenjeNaknadeO"];
            this.smanjenjeNaknadeE = _data["smanjenjeNaknadeE"];
            this.smanjenjeNaknadeR = _data["smanjenjeNaknadeR"];
            this.smanjenjeNaknadeZ = _data["smanjenjeNaknadeZ"];
            this.smanjenjeNaknadeSS = _data["smanjenjeNaknadeSS"];
            this.smanjenjeNaknadeOE = _data["smanjenjeNaknadeOE"];
            this.smanjenjeNaknadeN = _data["smanjenjeNaknadeN"];
            this.ukupnoOsnovica8 = _data["ukupnoOsnovica8"];
            this.ukupnoOsnovica10 = _data["ukupnoOsnovica10"];
            this.ukupnoOsnovica20 = _data["ukupnoOsnovica20"];
            this.ukupnoOsnovicaAE = _data["ukupnoOsnovicaAE"];
            this.ukupnoOsnovicaAE10 = _data["ukupnoOsnovicaAE10"];
            this.ukupnoOsnovicaAE20 = _data["ukupnoOsnovicaAE20"];
            this.ukupnoOsnovicaO = _data["ukupnoOsnovicaO"];
            this.ukupnoOsnovicaE = _data["ukupnoOsnovicaE"];
            this.ukupnoOsnovicaR = _data["ukupnoOsnovicaR"];
            this.ukupnoOsnovicaZ = _data["ukupnoOsnovicaZ"];
            this.ukupnoOsnovicaSS = _data["ukupnoOsnovicaSS"];
            this.ukupnoOsnovicaOE = _data["ukupnoOsnovicaOE"];
            this.ukupnoOsnovicaN = _data["ukupnoOsnovicaN"];
            this.ukupnoPdv8 = _data["ukupnoPdv8"];
            this.ukupnoPdv10 = _data["ukupnoPdv10"];
            this.ukupnoPdv20 = _data["ukupnoPdv20"];
            this.rsdUkupnoOsnovica8 = _data["rsdUkupnoOsnovica8"];
            this.rsdUkupnoOsnovica10 = _data["rsdUkupnoOsnovica10"];
            this.rsdUkupnoOsnovica20 = _data["rsdUkupnoOsnovica20"];
            this.rsdUkupnoOsnovicaAE = _data["rsdUkupnoOsnovicaAE"];
            this.rsdUkupnoOsnovicaAE10 = _data["rsdUkupnoOsnovicaAE10"];
            this.rsdUkupnoOsnovicaAE20 = _data["rsdUkupnoOsnovicaAE20"];
            this.rsdUkupnoOsnovicaO = _data["rsdUkupnoOsnovicaO"];
            this.rsdUkupnoOsnovicaE = _data["rsdUkupnoOsnovicaE"];
            this.rsdUkupnoOsnovicaR = _data["rsdUkupnoOsnovicaR"];
            this.rsdUkupnoOsnovicaZ = _data["rsdUkupnoOsnovicaZ"];
            this.rsdUkupnoOsnovicaSS = _data["rsdUkupnoOsnovicaSS"];
            this.rsdUkupnoOsnovicaOE = _data["rsdUkupnoOsnovicaOE"];
            this.rsdUkupnoOsnovicaN = _data["rsdUkupnoOsnovicaN"];
            this.rsdUkupnoPdv8 = _data["rsdUkupnoPdv8"];
            this.rsdUkupnoPdv10 = _data["rsdUkupnoPdv10"];
            this.rsdUkupnoPdv20 = _data["rsdUkupnoPdv20"];
            this.avansiraniPdv8 = _data["avansiraniPdv8"];
            this.avansiraniPdv10 = _data["avansiraniPdv10"];
            this.avansiraniPdv20 = _data["avansiraniPdv20"];
            this.avansiranaOsnovicaS = _data["avansiranaOsnovicaS"];
            this.avansiranaOsnovica8 = _data["avansiranaOsnovica8"];
            this.avansiranaOsnovica10 = _data["avansiranaOsnovica10"];
            this.avansiranaOsnovica20 = _data["avansiranaOsnovica20"];
            this.avansiranaOsnovicaAE = _data["avansiranaOsnovicaAE"];
            this.avansiranaOsnovicaAE10 = _data["avansiranaOsnovicaAE10"];
            this.avansiranaOsnovicaAE20 = _data["avansiranaOsnovicaAE20"];
            this.avansiranaOsnovicaO = _data["avansiranaOsnovicaO"];
            this.avansiranaOsnovicaE = _data["avansiranaOsnovicaE"];
            this.avansiranaOsnovicaR = _data["avansiranaOsnovicaR"];
            this.avansiranaOsnovicaZ = _data["avansiranaOsnovicaZ"];
            this.avansiranaOsnovicaSS = _data["avansiranaOsnovicaSS"];
            this.avansiranaOsnovicaOE = _data["avansiranaOsnovicaOE"];
            this.avansiranaOsnovicaN = _data["avansiranaOsnovicaN"];
            this.ukupanAvansiranIznos = _data["ukupanAvansiranIznos"];
            this.umanjenaOsnovicaS = _data["umanjenaOsnovicaS"];
            this.umanjenaOsnovica8 = _data["umanjenaOsnovica8"];
            this.umanjenaOsnovica10 = _data["umanjenaOsnovica10"];
            this.umanjenaOsnovica20 = _data["umanjenaOsnovica20"];
            this.umanjenaOsnovicaAE = _data["umanjenaOsnovicaAE"];
            this.umanjenaOsnovicaAE10 = _data["umanjenaOsnovicaAE10"];
            this.umanjenaOsnovicaAE20 = _data["umanjenaOsnovicaAE20"];
            this.umanjenaOsnovicaO = _data["umanjenaOsnovicaO"];
            this.umanjenaOsnovicaE = _data["umanjenaOsnovicaE"];
            this.umanjenaOsnovicaR = _data["umanjenaOsnovicaR"];
            this.umanjenaOsnovicaZ = _data["umanjenaOsnovicaZ"];
            this.umanjenaOsnovicaSS = _data["umanjenaOsnovicaSS"];
            this.umanjenaOsnovicaOE = _data["umanjenaOsnovicaOE"];
            this.umanjenaOsnovicaN = _data["umanjenaOsnovicaN"];
            this.ukupnoPdvUmanjenZaAvanse8 = _data["ukupnoPdvUmanjenZaAvanse8"];
            this.ukupnoPdvUmanjenZaAvanse10 = _data["ukupnoPdvUmanjenZaAvanse10"];
            this.ukupnoPdvUmanjenZaAvanse20 = _data["ukupnoPdvUmanjenZaAvanse20"];
            this.iznosZaZaokruzivanje = _data["iznosZaZaokruzivanje"];
            this.ukupnoZaUplatu = _data["ukupnoZaUplatu"];
        }
    }

    static fromJS(data: any): RacunUkupanIznos {
        data = typeof data === 'object' ? data : {};
        let result = new RacunUkupanIznos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        data["zbirStavki8"] = this.zbirStavki8;
        data["zbirStavki10"] = this.zbirStavki10;
        data["zbirStavki20"] = this.zbirStavki20;
        data["zbirStavkiS"] = this.zbirStavkiS;
        data["zbirStavkiAE"] = this.zbirStavkiAE;
        data["zbirStavkiAE10"] = this.zbirStavkiAE10;
        data["zbirStavkiAE20"] = this.zbirStavkiAE20;
        data["zbirStavkiO"] = this.zbirStavkiO;
        data["zbirStavkiE"] = this.zbirStavkiE;
        data["zbirStavkiR"] = this.zbirStavkiR;
        data["zbirStavkiZ"] = this.zbirStavkiZ;
        data["zbirStavkiSS"] = this.zbirStavkiSS;
        data["zbirStavkiOE"] = this.zbirStavkiOE;
        data["zbirStavkiN"] = this.zbirStavkiN;
        data["smanjenjeNaknade8"] = this.smanjenjeNaknade8;
        data["smanjenjeNaknade10"] = this.smanjenjeNaknade10;
        data["smanjenjeNaknade20"] = this.smanjenjeNaknade20;
        data["smanjenjeNaknadeAE"] = this.smanjenjeNaknadeAE;
        data["smanjenjeNaknadeAE10"] = this.smanjenjeNaknadeAE10;
        data["smanjenjeNaknadeAE20"] = this.smanjenjeNaknadeAE20;
        data["smanjenjeNaknadeO"] = this.smanjenjeNaknadeO;
        data["smanjenjeNaknadeE"] = this.smanjenjeNaknadeE;
        data["smanjenjeNaknadeR"] = this.smanjenjeNaknadeR;
        data["smanjenjeNaknadeZ"] = this.smanjenjeNaknadeZ;
        data["smanjenjeNaknadeSS"] = this.smanjenjeNaknadeSS;
        data["smanjenjeNaknadeOE"] = this.smanjenjeNaknadeOE;
        data["smanjenjeNaknadeN"] = this.smanjenjeNaknadeN;
        data["ukupnoOsnovica8"] = this.ukupnoOsnovica8;
        data["ukupnoOsnovica10"] = this.ukupnoOsnovica10;
        data["ukupnoOsnovica20"] = this.ukupnoOsnovica20;
        data["ukupnoOsnovicaAE"] = this.ukupnoOsnovicaAE;
        data["ukupnoOsnovicaAE10"] = this.ukupnoOsnovicaAE10;
        data["ukupnoOsnovicaAE20"] = this.ukupnoOsnovicaAE20;
        data["ukupnoOsnovicaO"] = this.ukupnoOsnovicaO;
        data["ukupnoOsnovicaE"] = this.ukupnoOsnovicaE;
        data["ukupnoOsnovicaR"] = this.ukupnoOsnovicaR;
        data["ukupnoOsnovicaZ"] = this.ukupnoOsnovicaZ;
        data["ukupnoOsnovicaSS"] = this.ukupnoOsnovicaSS;
        data["ukupnoOsnovicaOE"] = this.ukupnoOsnovicaOE;
        data["ukupnoOsnovicaN"] = this.ukupnoOsnovicaN;
        data["ukupnoPdv8"] = this.ukupnoPdv8;
        data["ukupnoPdv10"] = this.ukupnoPdv10;
        data["ukupnoPdv20"] = this.ukupnoPdv20;
        data["rsdUkupnoOsnovica8"] = this.rsdUkupnoOsnovica8;
        data["rsdUkupnoOsnovica10"] = this.rsdUkupnoOsnovica10;
        data["rsdUkupnoOsnovica20"] = this.rsdUkupnoOsnovica20;
        data["rsdUkupnoOsnovicaAE"] = this.rsdUkupnoOsnovicaAE;
        data["rsdUkupnoOsnovicaAE10"] = this.rsdUkupnoOsnovicaAE10;
        data["rsdUkupnoOsnovicaAE20"] = this.rsdUkupnoOsnovicaAE20;
        data["rsdUkupnoOsnovicaO"] = this.rsdUkupnoOsnovicaO;
        data["rsdUkupnoOsnovicaE"] = this.rsdUkupnoOsnovicaE;
        data["rsdUkupnoOsnovicaR"] = this.rsdUkupnoOsnovicaR;
        data["rsdUkupnoOsnovicaZ"] = this.rsdUkupnoOsnovicaZ;
        data["rsdUkupnoOsnovicaSS"] = this.rsdUkupnoOsnovicaSS;
        data["rsdUkupnoOsnovicaOE"] = this.rsdUkupnoOsnovicaOE;
        data["rsdUkupnoOsnovicaN"] = this.rsdUkupnoOsnovicaN;
        data["rsdUkupnoPdv8"] = this.rsdUkupnoPdv8;
        data["rsdUkupnoPdv10"] = this.rsdUkupnoPdv10;
        data["rsdUkupnoPdv20"] = this.rsdUkupnoPdv20;
        data["avansiraniPdv8"] = this.avansiraniPdv8;
        data["avansiraniPdv10"] = this.avansiraniPdv10;
        data["avansiraniPdv20"] = this.avansiraniPdv20;
        data["avansiranaOsnovicaS"] = this.avansiranaOsnovicaS;
        data["avansiranaOsnovica8"] = this.avansiranaOsnovica8;
        data["avansiranaOsnovica10"] = this.avansiranaOsnovica10;
        data["avansiranaOsnovica20"] = this.avansiranaOsnovica20;
        data["avansiranaOsnovicaAE"] = this.avansiranaOsnovicaAE;
        data["avansiranaOsnovicaAE10"] = this.avansiranaOsnovicaAE10;
        data["avansiranaOsnovicaAE20"] = this.avansiranaOsnovicaAE20;
        data["avansiranaOsnovicaO"] = this.avansiranaOsnovicaO;
        data["avansiranaOsnovicaE"] = this.avansiranaOsnovicaE;
        data["avansiranaOsnovicaR"] = this.avansiranaOsnovicaR;
        data["avansiranaOsnovicaZ"] = this.avansiranaOsnovicaZ;
        data["avansiranaOsnovicaSS"] = this.avansiranaOsnovicaSS;
        data["avansiranaOsnovicaOE"] = this.avansiranaOsnovicaOE;
        data["avansiranaOsnovicaN"] = this.avansiranaOsnovicaN;
        data["ukupanAvansiranIznos"] = this.ukupanAvansiranIznos;
        data["umanjenaOsnovicaS"] = this.umanjenaOsnovicaS;
        data["umanjenaOsnovica8"] = this.umanjenaOsnovica8;
        data["umanjenaOsnovica10"] = this.umanjenaOsnovica10;
        data["umanjenaOsnovica20"] = this.umanjenaOsnovica20;
        data["umanjenaOsnovicaAE"] = this.umanjenaOsnovicaAE;
        data["umanjenaOsnovicaAE10"] = this.umanjenaOsnovicaAE10;
        data["umanjenaOsnovicaAE20"] = this.umanjenaOsnovicaAE20;
        data["umanjenaOsnovicaO"] = this.umanjenaOsnovicaO;
        data["umanjenaOsnovicaE"] = this.umanjenaOsnovicaE;
        data["umanjenaOsnovicaR"] = this.umanjenaOsnovicaR;
        data["umanjenaOsnovicaZ"] = this.umanjenaOsnovicaZ;
        data["umanjenaOsnovicaSS"] = this.umanjenaOsnovicaSS;
        data["umanjenaOsnovicaOE"] = this.umanjenaOsnovicaOE;
        data["umanjenaOsnovicaN"] = this.umanjenaOsnovicaN;
        data["ukupnoPdvUmanjenZaAvanse8"] = this.ukupnoPdvUmanjenZaAvanse8;
        data["ukupnoPdvUmanjenZaAvanse10"] = this.ukupnoPdvUmanjenZaAvanse10;
        data["ukupnoPdvUmanjenZaAvanse20"] = this.ukupnoPdvUmanjenZaAvanse20;
        data["iznosZaZaokruzivanje"] = this.iznosZaZaokruzivanje;
        data["ukupnoZaUplatu"] = this.ukupnoZaUplatu;
        return data;
    }
}

export interface IRacunUkupanIznos {
    racunId?: number;
    racun?: Racun | undefined;
    zbirStavki8?: number | undefined;
    zbirStavki10?: number | undefined;
    zbirStavki20?: number | undefined;
    zbirStavkiS?: number | undefined;
    zbirStavkiAE?: number | undefined;
    zbirStavkiAE10?: number | undefined;
    zbirStavkiAE20?: number | undefined;
    zbirStavkiO?: number | undefined;
    zbirStavkiE?: number | undefined;
    zbirStavkiR?: number | undefined;
    zbirStavkiZ?: number | undefined;
    zbirStavkiSS?: number | undefined;
    zbirStavkiOE?: number | undefined;
    zbirStavkiN?: number | undefined;
    smanjenjeNaknade8?: number | undefined;
    smanjenjeNaknade10?: number | undefined;
    smanjenjeNaknade20?: number | undefined;
    smanjenjeNaknadeAE?: number | undefined;
    smanjenjeNaknadeAE10?: number | undefined;
    smanjenjeNaknadeAE20?: number | undefined;
    smanjenjeNaknadeO?: number | undefined;
    smanjenjeNaknadeE?: number | undefined;
    smanjenjeNaknadeR?: number | undefined;
    smanjenjeNaknadeZ?: number | undefined;
    smanjenjeNaknadeSS?: number | undefined;
    smanjenjeNaknadeOE?: number | undefined;
    smanjenjeNaknadeN?: number | undefined;
    ukupnoOsnovica8?: number | undefined;
    ukupnoOsnovica10?: number | undefined;
    ukupnoOsnovica20?: number | undefined;
    ukupnoOsnovicaAE?: number | undefined;
    ukupnoOsnovicaAE10?: number | undefined;
    ukupnoOsnovicaAE20?: number | undefined;
    ukupnoOsnovicaO?: number | undefined;
    ukupnoOsnovicaE?: number | undefined;
    ukupnoOsnovicaR?: number | undefined;
    ukupnoOsnovicaZ?: number | undefined;
    ukupnoOsnovicaSS?: number | undefined;
    ukupnoOsnovicaOE?: number | undefined;
    ukupnoOsnovicaN?: number | undefined;
    ukupnoPdv8?: number | undefined;
    ukupnoPdv10?: number | undefined;
    ukupnoPdv20?: number | undefined;
    rsdUkupnoOsnovica8?: number | undefined;
    rsdUkupnoOsnovica10?: number | undefined;
    rsdUkupnoOsnovica20?: number | undefined;
    rsdUkupnoOsnovicaAE?: number | undefined;
    rsdUkupnoOsnovicaAE10?: number | undefined;
    rsdUkupnoOsnovicaAE20?: number | undefined;
    rsdUkupnoOsnovicaO?: number | undefined;
    rsdUkupnoOsnovicaE?: number | undefined;
    rsdUkupnoOsnovicaR?: number | undefined;
    rsdUkupnoOsnovicaZ?: number | undefined;
    rsdUkupnoOsnovicaSS?: number | undefined;
    rsdUkupnoOsnovicaOE?: number | undefined;
    rsdUkupnoOsnovicaN?: number | undefined;
    rsdUkupnoPdv8?: number | undefined;
    rsdUkupnoPdv10?: number | undefined;
    rsdUkupnoPdv20?: number | undefined;
    avansiraniPdv8?: number | undefined;
    avansiraniPdv10?: number | undefined;
    avansiraniPdv20?: number | undefined;
    avansiranaOsnovicaS?: number | undefined;
    avansiranaOsnovica8?: number | undefined;
    avansiranaOsnovica10?: number | undefined;
    avansiranaOsnovica20?: number | undefined;
    avansiranaOsnovicaAE?: number | undefined;
    avansiranaOsnovicaAE10?: number | undefined;
    avansiranaOsnovicaAE20?: number | undefined;
    avansiranaOsnovicaO?: number | undefined;
    avansiranaOsnovicaE?: number | undefined;
    avansiranaOsnovicaR?: number | undefined;
    avansiranaOsnovicaZ?: number | undefined;
    avansiranaOsnovicaSS?: number | undefined;
    avansiranaOsnovicaOE?: number | undefined;
    avansiranaOsnovicaN?: number | undefined;
    ukupanAvansiranIznos?: number | undefined;
    umanjenaOsnovicaS?: number | undefined;
    umanjenaOsnovica8?: number | undefined;
    umanjenaOsnovica10?: number | undefined;
    umanjenaOsnovica20?: number | undefined;
    umanjenaOsnovicaAE?: number | undefined;
    umanjenaOsnovicaAE10?: number | undefined;
    umanjenaOsnovicaAE20?: number | undefined;
    umanjenaOsnovicaO?: number | undefined;
    umanjenaOsnovicaE?: number | undefined;
    umanjenaOsnovicaR?: number | undefined;
    umanjenaOsnovicaZ?: number | undefined;
    umanjenaOsnovicaSS?: number | undefined;
    umanjenaOsnovicaOE?: number | undefined;
    umanjenaOsnovicaN?: number | undefined;
    ukupnoPdvUmanjenZaAvanse8?: number | undefined;
    ukupnoPdvUmanjenZaAvanse10?: number | undefined;
    ukupnoPdvUmanjenZaAvanse20?: number | undefined;
    iznosZaZaokruzivanje?: number | undefined;
    ukupnoZaUplatu?: number;
}

export class PovezanRacun implements IPovezanRacun {
    parentId?: number;
    parent?: Racun | undefined;
    childId?: number;
    child?: Racun | undefined;

    constructor(data?: IPovezanRacun) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.parent = _data["parent"] ? Racun.fromJS(_data["parent"]) : <any>undefined;
            this.childId = _data["childId"];
            this.child = _data["child"] ? Racun.fromJS(_data["child"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PovezanRacun {
        data = typeof data === 'object' ? data : {};
        let result = new PovezanRacun();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["childId"] = this.childId;
        data["child"] = this.child ? this.child.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPovezanRacun {
    parentId?: number;
    parent?: Racun | undefined;
    childId?: number;
    child?: Racun | undefined;
}

export class PojedinacnaPdvEvidencija39 extends AuditableEntity implements IPojedinacnaPdvEvidencija39 {
    pojedinacnaPdvEvidencijaId?: number;
    sefId?: number;
    broj?: string | undefined;
    datumEvidentiranja?: Date | undefined;
    godina?: number;
    status?: PdvEvidencijaStatus;
    period?: PdvPeriod;
    smer?: VrstaRacuna;
    tip?: PdvEvidencijaTipDokumenta;
    tipPovezaneFakture?: PdvEvidencijaTipPovezaneFakture;
    osnovOdabiraDokumenta?: PdvEvidencijaOsnovOdabiraDokumenta;
    tipPovezanogInternog?: PdvEvidencijaTipPovezanogInternog;
    vremenskiPeriodPocetak?: Date | undefined;
    vremenskiPeriodZavrsetak?: Date | undefined;
    osnovAvansnogPlacanja?: string | undefined;
    datumAvansa?: Date | undefined;
    promet10?: PdvPrometObject | undefined;
    promet20?: PdvPrometObject | undefined;
    promet10Bn?: PdvPrometObject | undefined;
    promet20Bn?: PdvPrometObject | undefined;
    promet10Obj?: PdvPrometObject | undefined;
    promet20Obj?: PdvPrometObject | undefined;
    promet10BnObj?: PdvPrometObject | undefined;
    promet20BnObj?: PdvPrometObject | undefined;
    opisPrometa10?: string | undefined;
    osnovica10?: number | undefined;
    obracunatPdv10?: number | undefined;
    opisPrometa20?: string | undefined;
    osnovica20?: number | undefined;
    obracunatPdv20?: number | undefined;
    opisPrometaAE20?: string | undefined;
    osnovicaAE20?: number | undefined;
    obracunatPdvAE20?: number | undefined;
    opisPrometaAE20Obj?: string | undefined;
    osnovicaAE20Obj?: number | undefined;
    obracunatPdvAE20Obj?: number | undefined;
    opisPrometaAE10?: string | undefined;
    osnovicaAE10?: number | undefined;
    obracunatPdvAE10?: number | undefined;
    opisPrometaAE10Obj?: string | undefined;
    osnovicaAE10Obj?: number | undefined;
    obracunatPdvAE10Obj?: number | undefined;
    opisPrometaAE20BN?: string | undefined;
    osnovicaAE20BN?: number | undefined;
    obracunatPdvAE20BN?: number | undefined;
    opisPrometaAE20ObjBN?: string | undefined;
    osnovicaAE20ObjBN?: number | undefined;
    obracunatPdvAE20ObjBN?: number | undefined;
    opisPrometaAE10BN?: string | undefined;
    osnovicaAE10BN?: number | undefined;
    obracunatPdvAE10BN?: number | undefined;
    opisPrometaAE10ObjBN?: string | undefined;
    osnovicaAE10ObjBN?: number | undefined;
    obracunatPdvAE10ObjBN?: number | undefined;
    ukupanIznosNaknade?: number;
    obracunatPdv?: number;
    strankaId?: number;
    stranka?: Stranka | undefined;
    brojPovezaneFakture?: string | undefined;
    povezanaFakturaId?: number | undefined;
    glavnaFaktura?: Racun | undefined;
    povezaneFakture?: PojedinacnaPdvEvidencija39PovezanRacun[] | undefined;
    brojeviDokumenataVanSefa?: BrojDokumentaVanSEFa[] | undefined;

    constructor(data?: IPojedinacnaPdvEvidencija39) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pojedinacnaPdvEvidencijaId = _data["pojedinacnaPdvEvidencijaId"];
            this.sefId = _data["sefId"];
            this.broj = _data["broj"];
            this.datumEvidentiranja = _data["datumEvidentiranja"] ? new Date(_data["datumEvidentiranja"].toString()) : <any>undefined;
            this.godina = _data["godina"];
            this.status = _data["status"];
            this.period = _data["period"];
            this.smer = _data["smer"];
            this.tip = _data["tip"];
            this.tipPovezaneFakture = _data["tipPovezaneFakture"];
            this.osnovOdabiraDokumenta = _data["osnovOdabiraDokumenta"];
            this.tipPovezanogInternog = _data["tipPovezanogInternog"];
            this.vremenskiPeriodPocetak = _data["vremenskiPeriodPocetak"] ? new Date(_data["vremenskiPeriodPocetak"].toString()) : <any>undefined;
            this.vremenskiPeriodZavrsetak = _data["vremenskiPeriodZavrsetak"] ? new Date(_data["vremenskiPeriodZavrsetak"].toString()) : <any>undefined;
            this.osnovAvansnogPlacanja = _data["osnovAvansnogPlacanja"];
            this.datumAvansa = _data["datumAvansa"] ? new Date(_data["datumAvansa"].toString()) : <any>undefined;
            this.promet10 = _data["promet10"] ? PdvPrometObject.fromJS(_data["promet10"]) : <any>undefined;
            this.promet20 = _data["promet20"] ? PdvPrometObject.fromJS(_data["promet20"]) : <any>undefined;
            this.promet10Bn = _data["promet10Bn"] ? PdvPrometObject.fromJS(_data["promet10Bn"]) : <any>undefined;
            this.promet20Bn = _data["promet20Bn"] ? PdvPrometObject.fromJS(_data["promet20Bn"]) : <any>undefined;
            this.promet10Obj = _data["promet10Obj"] ? PdvPrometObject.fromJS(_data["promet10Obj"]) : <any>undefined;
            this.promet20Obj = _data["promet20Obj"] ? PdvPrometObject.fromJS(_data["promet20Obj"]) : <any>undefined;
            this.promet10BnObj = _data["promet10BnObj"] ? PdvPrometObject.fromJS(_data["promet10BnObj"]) : <any>undefined;
            this.promet20BnObj = _data["promet20BnObj"] ? PdvPrometObject.fromJS(_data["promet20BnObj"]) : <any>undefined;
            this.opisPrometa10 = _data["opisPrometa10"];
            this.osnovica10 = _data["osnovica10"];
            this.obracunatPdv10 = _data["obracunatPdv10"];
            this.opisPrometa20 = _data["opisPrometa20"];
            this.osnovica20 = _data["osnovica20"];
            this.obracunatPdv20 = _data["obracunatPdv20"];
            this.opisPrometaAE20 = _data["opisPrometaAE20"];
            this.osnovicaAE20 = _data["osnovicaAE20"];
            this.obracunatPdvAE20 = _data["obracunatPdvAE20"];
            this.opisPrometaAE20Obj = _data["opisPrometaAE20Obj"];
            this.osnovicaAE20Obj = _data["osnovicaAE20Obj"];
            this.obracunatPdvAE20Obj = _data["obracunatPdvAE20Obj"];
            this.opisPrometaAE10 = _data["opisPrometaAE10"];
            this.osnovicaAE10 = _data["osnovicaAE10"];
            this.obracunatPdvAE10 = _data["obracunatPdvAE10"];
            this.opisPrometaAE10Obj = _data["opisPrometaAE10Obj"];
            this.osnovicaAE10Obj = _data["osnovicaAE10Obj"];
            this.obracunatPdvAE10Obj = _data["obracunatPdvAE10Obj"];
            this.opisPrometaAE20BN = _data["opisPrometaAE20BN"];
            this.osnovicaAE20BN = _data["osnovicaAE20BN"];
            this.obracunatPdvAE20BN = _data["obracunatPdvAE20BN"];
            this.opisPrometaAE20ObjBN = _data["opisPrometaAE20ObjBN"];
            this.osnovicaAE20ObjBN = _data["osnovicaAE20ObjBN"];
            this.obracunatPdvAE20ObjBN = _data["obracunatPdvAE20ObjBN"];
            this.opisPrometaAE10BN = _data["opisPrometaAE10BN"];
            this.osnovicaAE10BN = _data["osnovicaAE10BN"];
            this.obracunatPdvAE10BN = _data["obracunatPdvAE10BN"];
            this.opisPrometaAE10ObjBN = _data["opisPrometaAE10ObjBN"];
            this.osnovicaAE10ObjBN = _data["osnovicaAE10ObjBN"];
            this.obracunatPdvAE10ObjBN = _data["obracunatPdvAE10ObjBN"];
            this.ukupanIznosNaknade = _data["ukupanIznosNaknade"];
            this.obracunatPdv = _data["obracunatPdv"];
            this.strankaId = _data["strankaId"];
            this.stranka = _data["stranka"] ? Stranka.fromJS(_data["stranka"]) : <any>undefined;
            this.brojPovezaneFakture = _data["brojPovezaneFakture"];
            this.povezanaFakturaId = _data["povezanaFakturaId"];
            this.glavnaFaktura = _data["glavnaFaktura"] ? Racun.fromJS(_data["glavnaFaktura"]) : <any>undefined;
            if (Array.isArray(_data["povezaneFakture"])) {
                this.povezaneFakture = [] as any;
                for (let item of _data["povezaneFakture"])
                    this.povezaneFakture!.push(PojedinacnaPdvEvidencija39PovezanRacun.fromJS(item));
            }
            if (Array.isArray(_data["brojeviDokumenataVanSefa"])) {
                this.brojeviDokumenataVanSefa = [] as any;
                for (let item of _data["brojeviDokumenataVanSefa"])
                    this.brojeviDokumenataVanSefa!.push(BrojDokumentaVanSEFa.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PojedinacnaPdvEvidencija39 {
        data = typeof data === 'object' ? data : {};
        let result = new PojedinacnaPdvEvidencija39();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pojedinacnaPdvEvidencijaId"] = this.pojedinacnaPdvEvidencijaId;
        data["sefId"] = this.sefId;
        data["broj"] = this.broj;
        data["datumEvidentiranja"] = this.datumEvidentiranja ? this.datumEvidentiranja.toISOString() : <any>undefined;
        data["godina"] = this.godina;
        data["status"] = this.status;
        data["period"] = this.period;
        data["smer"] = this.smer;
        data["tip"] = this.tip;
        data["tipPovezaneFakture"] = this.tipPovezaneFakture;
        data["osnovOdabiraDokumenta"] = this.osnovOdabiraDokumenta;
        data["tipPovezanogInternog"] = this.tipPovezanogInternog;
        data["vremenskiPeriodPocetak"] = this.vremenskiPeriodPocetak ? this.vremenskiPeriodPocetak.toISOString() : <any>undefined;
        data["vremenskiPeriodZavrsetak"] = this.vremenskiPeriodZavrsetak ? this.vremenskiPeriodZavrsetak.toISOString() : <any>undefined;
        data["osnovAvansnogPlacanja"] = this.osnovAvansnogPlacanja;
        data["datumAvansa"] = this.datumAvansa ? this.datumAvansa.toISOString() : <any>undefined;
        data["promet10"] = this.promet10 ? this.promet10.toJSON() : <any>undefined;
        data["promet20"] = this.promet20 ? this.promet20.toJSON() : <any>undefined;
        data["promet10Bn"] = this.promet10Bn ? this.promet10Bn.toJSON() : <any>undefined;
        data["promet20Bn"] = this.promet20Bn ? this.promet20Bn.toJSON() : <any>undefined;
        data["promet10Obj"] = this.promet10Obj ? this.promet10Obj.toJSON() : <any>undefined;
        data["promet20Obj"] = this.promet20Obj ? this.promet20Obj.toJSON() : <any>undefined;
        data["promet10BnObj"] = this.promet10BnObj ? this.promet10BnObj.toJSON() : <any>undefined;
        data["promet20BnObj"] = this.promet20BnObj ? this.promet20BnObj.toJSON() : <any>undefined;
        data["opisPrometa10"] = this.opisPrometa10;
        data["osnovica10"] = this.osnovica10;
        data["obracunatPdv10"] = this.obracunatPdv10;
        data["opisPrometa20"] = this.opisPrometa20;
        data["osnovica20"] = this.osnovica20;
        data["obracunatPdv20"] = this.obracunatPdv20;
        data["opisPrometaAE20"] = this.opisPrometaAE20;
        data["osnovicaAE20"] = this.osnovicaAE20;
        data["obracunatPdvAE20"] = this.obracunatPdvAE20;
        data["opisPrometaAE20Obj"] = this.opisPrometaAE20Obj;
        data["osnovicaAE20Obj"] = this.osnovicaAE20Obj;
        data["obracunatPdvAE20Obj"] = this.obracunatPdvAE20Obj;
        data["opisPrometaAE10"] = this.opisPrometaAE10;
        data["osnovicaAE10"] = this.osnovicaAE10;
        data["obracunatPdvAE10"] = this.obracunatPdvAE10;
        data["opisPrometaAE10Obj"] = this.opisPrometaAE10Obj;
        data["osnovicaAE10Obj"] = this.osnovicaAE10Obj;
        data["obracunatPdvAE10Obj"] = this.obracunatPdvAE10Obj;
        data["opisPrometaAE20BN"] = this.opisPrometaAE20BN;
        data["osnovicaAE20BN"] = this.osnovicaAE20BN;
        data["obracunatPdvAE20BN"] = this.obracunatPdvAE20BN;
        data["opisPrometaAE20ObjBN"] = this.opisPrometaAE20ObjBN;
        data["osnovicaAE20ObjBN"] = this.osnovicaAE20ObjBN;
        data["obracunatPdvAE20ObjBN"] = this.obracunatPdvAE20ObjBN;
        data["opisPrometaAE10BN"] = this.opisPrometaAE10BN;
        data["osnovicaAE10BN"] = this.osnovicaAE10BN;
        data["obracunatPdvAE10BN"] = this.obracunatPdvAE10BN;
        data["opisPrometaAE10ObjBN"] = this.opisPrometaAE10ObjBN;
        data["osnovicaAE10ObjBN"] = this.osnovicaAE10ObjBN;
        data["obracunatPdvAE10ObjBN"] = this.obracunatPdvAE10ObjBN;
        data["ukupanIznosNaknade"] = this.ukupanIznosNaknade;
        data["obracunatPdv"] = this.obracunatPdv;
        data["strankaId"] = this.strankaId;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        data["brojPovezaneFakture"] = this.brojPovezaneFakture;
        data["povezanaFakturaId"] = this.povezanaFakturaId;
        data["glavnaFaktura"] = this.glavnaFaktura ? this.glavnaFaktura.toJSON() : <any>undefined;
        if (Array.isArray(this.povezaneFakture)) {
            data["povezaneFakture"] = [];
            for (let item of this.povezaneFakture)
                data["povezaneFakture"].push(item.toJSON());
        }
        if (Array.isArray(this.brojeviDokumenataVanSefa)) {
            data["brojeviDokumenataVanSefa"] = [];
            for (let item of this.brojeviDokumenataVanSefa)
                data["brojeviDokumenataVanSefa"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPojedinacnaPdvEvidencija39 extends IAuditableEntity {
    pojedinacnaPdvEvidencijaId?: number;
    sefId?: number;
    broj?: string | undefined;
    datumEvidentiranja?: Date | undefined;
    godina?: number;
    status?: PdvEvidencijaStatus;
    period?: PdvPeriod;
    smer?: VrstaRacuna;
    tip?: PdvEvidencijaTipDokumenta;
    tipPovezaneFakture?: PdvEvidencijaTipPovezaneFakture;
    osnovOdabiraDokumenta?: PdvEvidencijaOsnovOdabiraDokumenta;
    tipPovezanogInternog?: PdvEvidencijaTipPovezanogInternog;
    vremenskiPeriodPocetak?: Date | undefined;
    vremenskiPeriodZavrsetak?: Date | undefined;
    osnovAvansnogPlacanja?: string | undefined;
    datumAvansa?: Date | undefined;
    promet10?: PdvPrometObject | undefined;
    promet20?: PdvPrometObject | undefined;
    promet10Bn?: PdvPrometObject | undefined;
    promet20Bn?: PdvPrometObject | undefined;
    promet10Obj?: PdvPrometObject | undefined;
    promet20Obj?: PdvPrometObject | undefined;
    promet10BnObj?: PdvPrometObject | undefined;
    promet20BnObj?: PdvPrometObject | undefined;
    opisPrometa10?: string | undefined;
    osnovica10?: number | undefined;
    obracunatPdv10?: number | undefined;
    opisPrometa20?: string | undefined;
    osnovica20?: number | undefined;
    obracunatPdv20?: number | undefined;
    opisPrometaAE20?: string | undefined;
    osnovicaAE20?: number | undefined;
    obracunatPdvAE20?: number | undefined;
    opisPrometaAE20Obj?: string | undefined;
    osnovicaAE20Obj?: number | undefined;
    obracunatPdvAE20Obj?: number | undefined;
    opisPrometaAE10?: string | undefined;
    osnovicaAE10?: number | undefined;
    obracunatPdvAE10?: number | undefined;
    opisPrometaAE10Obj?: string | undefined;
    osnovicaAE10Obj?: number | undefined;
    obracunatPdvAE10Obj?: number | undefined;
    opisPrometaAE20BN?: string | undefined;
    osnovicaAE20BN?: number | undefined;
    obracunatPdvAE20BN?: number | undefined;
    opisPrometaAE20ObjBN?: string | undefined;
    osnovicaAE20ObjBN?: number | undefined;
    obracunatPdvAE20ObjBN?: number | undefined;
    opisPrometaAE10BN?: string | undefined;
    osnovicaAE10BN?: number | undefined;
    obracunatPdvAE10BN?: number | undefined;
    opisPrometaAE10ObjBN?: string | undefined;
    osnovicaAE10ObjBN?: number | undefined;
    obracunatPdvAE10ObjBN?: number | undefined;
    ukupanIznosNaknade?: number;
    obracunatPdv?: number;
    strankaId?: number;
    stranka?: Stranka | undefined;
    brojPovezaneFakture?: string | undefined;
    povezanaFakturaId?: number | undefined;
    glavnaFaktura?: Racun | undefined;
    povezaneFakture?: PojedinacnaPdvEvidencija39PovezanRacun[] | undefined;
    brojeviDokumenataVanSefa?: BrojDokumentaVanSEFa[] | undefined;
}

export enum PdvEvidencijaTipPovezaneFakture {
    EMPTY = 0,
    FAKTURA = 1,
    VREMENSKI_PERIOD = 2,
    AVANSNA_FAKTURA = 3,
}

export enum PdvEvidencijaTipPovezanogInternog {
    EMPTY = 0,
    INTERNI_RACUN_ZA_PROMET = 1,
    INTERNI_RACUN_ZA_AVANS = 2,
}

export class PdvPrometObject extends ValueObject implements IPdvPrometObject {
    opis?: string | undefined;
    osnovica?: number | undefined;
    obracunatiPdv?: number | undefined;

    constructor(data?: IPdvPrometObject) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.opis = _data["opis"];
            this.osnovica = _data["osnovica"];
            this.obracunatiPdv = _data["obracunatiPdv"];
        }
    }

    static fromJS(data: any): PdvPrometObject {
        data = typeof data === 'object' ? data : {};
        let result = new PdvPrometObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opis"] = this.opis;
        data["osnovica"] = this.osnovica;
        data["obracunatiPdv"] = this.obracunatiPdv;
        super.toJSON(data);
        return data;
    }
}

export interface IPdvPrometObject extends IValueObject {
    opis?: string | undefined;
    osnovica?: number | undefined;
    obracunatiPdv?: number | undefined;
}

export class PojedinacnaPdvEvidencija39PovezanRacun implements IPojedinacnaPdvEvidencija39PovezanRacun {
    evidencijaId?: number;
    evidencija?: PojedinacnaPdvEvidencija39 | undefined;
    racunId?: number;
    racun?: Racun | undefined;

    constructor(data?: IPojedinacnaPdvEvidencija39PovezanRacun) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.evidencijaId = _data["evidencijaId"];
            this.evidencija = _data["evidencija"] ? PojedinacnaPdvEvidencija39.fromJS(_data["evidencija"]) : <any>undefined;
            this.racunId = _data["racunId"];
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PojedinacnaPdvEvidencija39PovezanRacun {
        data = typeof data === 'object' ? data : {};
        let result = new PojedinacnaPdvEvidencija39PovezanRacun();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evidencijaId"] = this.evidencijaId;
        data["evidencija"] = this.evidencija ? this.evidencija.toJSON() : <any>undefined;
        data["racunId"] = this.racunId;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPojedinacnaPdvEvidencija39PovezanRacun {
    evidencijaId?: number;
    evidencija?: PojedinacnaPdvEvidencija39 | undefined;
    racunId?: number;
    racun?: Racun | undefined;
}

export class BrojDokumentaVanSEFa implements IBrojDokumentaVanSEFa {
    brojDokumentaId?: number;
    broj?: string | undefined;
    pojedinacnaPdvEvidencijaId?: number;
    pojedinacnaPdvEvidencija?: PojedinacnaPdvEvidencija39 | undefined;

    constructor(data?: IBrojDokumentaVanSEFa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brojDokumentaId = _data["brojDokumentaId"];
            this.broj = _data["broj"];
            this.pojedinacnaPdvEvidencijaId = _data["pojedinacnaPdvEvidencijaId"];
            this.pojedinacnaPdvEvidencija = _data["pojedinacnaPdvEvidencija"] ? PojedinacnaPdvEvidencija39.fromJS(_data["pojedinacnaPdvEvidencija"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BrojDokumentaVanSEFa {
        data = typeof data === 'object' ? data : {};
        let result = new BrojDokumentaVanSEFa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brojDokumentaId"] = this.brojDokumentaId;
        data["broj"] = this.broj;
        data["pojedinacnaPdvEvidencijaId"] = this.pojedinacnaPdvEvidencijaId;
        data["pojedinacnaPdvEvidencija"] = this.pojedinacnaPdvEvidencija ? this.pojedinacnaPdvEvidencija.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBrojDokumentaVanSEFa {
    brojDokumentaId?: number;
    broj?: string | undefined;
    pojedinacnaPdvEvidencijaId?: number;
    pojedinacnaPdvEvidencija?: PojedinacnaPdvEvidencija39 | undefined;
}

export class RacunMessage implements IRacunMessage {
    racunMessageId?: number;
    messageId?: string | undefined;
    racunId?: number;
    racun?: Racun | undefined;
    strankaId?: number;
    stranka?: Stranka | undefined;

    constructor(data?: IRacunMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunMessageId = _data["racunMessageId"];
            this.messageId = _data["messageId"];
            this.racunId = _data["racunId"];
            this.racun = _data["racun"] ? Racun.fromJS(_data["racun"]) : <any>undefined;
            this.strankaId = _data["strankaId"];
            this.stranka = _data["stranka"] ? Stranka.fromJS(_data["stranka"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RacunMessage {
        data = typeof data === 'object' ? data : {};
        let result = new RacunMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunMessageId"] = this.racunMessageId;
        data["messageId"] = this.messageId;
        data["racunId"] = this.racunId;
        data["racun"] = this.racun ? this.racun.toJSON() : <any>undefined;
        data["strankaId"] = this.strankaId;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRacunMessage {
    racunMessageId?: number;
    messageId?: string | undefined;
    racunId?: number;
    racun?: Racun | undefined;
    strankaId?: number;
    stranka?: Stranka | undefined;
}

export class InformacijaIsporukeStranka extends InformacijaIsporuke implements IInformacijaIsporukeStranka {
    informacijaIsporukeStrankaId?: number;
    strankaId?: number;
    stranka?: Stranka | undefined;

    constructor(data?: IInformacijaIsporukeStranka) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.informacijaIsporukeStrankaId = _data["informacijaIsporukeStrankaId"];
            this.strankaId = _data["strankaId"];
            this.stranka = _data["stranka"] ? Stranka.fromJS(_data["stranka"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InformacijaIsporukeStranka {
        data = typeof data === 'object' ? data : {};
        let result = new InformacijaIsporukeStranka();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["informacijaIsporukeStrankaId"] = this.informacijaIsporukeStrankaId;
        data["strankaId"] = this.strankaId;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IInformacijaIsporukeStranka extends IInformacijaIsporuke {
    informacijaIsporukeStrankaId?: number;
    strankaId?: number;
    stranka?: Stranka | undefined;
}

export class FizickoLice extends AuditableEntity implements IFizickoLice {
    strankaId?: number;
    ime?: string | undefined;
    prezime?: string | undefined;
    jmbg?: string | undefined;
    pol?: PolFizickogLica;
    datumRodjenja?: Date | undefined;
    mobilniTelefon?: string | undefined;
    stranka?: Stranka | undefined;
    stanovi?: StambeniKorisnik[] | undefined;

    constructor(data?: IFizickoLice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.strankaId = _data["strankaId"];
            this.ime = _data["ime"];
            this.prezime = _data["prezime"];
            this.jmbg = _data["jmbg"];
            this.pol = _data["pol"];
            this.datumRodjenja = _data["datumRodjenja"] ? new Date(_data["datumRodjenja"].toString()) : <any>undefined;
            this.mobilniTelefon = _data["mobilniTelefon"];
            this.stranka = _data["stranka"] ? Stranka.fromJS(_data["stranka"]) : <any>undefined;
            if (Array.isArray(_data["stanovi"])) {
                this.stanovi = [] as any;
                for (let item of _data["stanovi"])
                    this.stanovi!.push(StambeniKorisnik.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FizickoLice {
        data = typeof data === 'object' ? data : {};
        let result = new FizickoLice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["strankaId"] = this.strankaId;
        data["ime"] = this.ime;
        data["prezime"] = this.prezime;
        data["jmbg"] = this.jmbg;
        data["pol"] = this.pol;
        data["datumRodjenja"] = this.datumRodjenja ? this.datumRodjenja.toISOString() : <any>undefined;
        data["mobilniTelefon"] = this.mobilniTelefon;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        if (Array.isArray(this.stanovi)) {
            data["stanovi"] = [];
            for (let item of this.stanovi)
                data["stanovi"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFizickoLice extends IAuditableEntity {
    strankaId?: number;
    ime?: string | undefined;
    prezime?: string | undefined;
    jmbg?: string | undefined;
    pol?: PolFizickogLica;
    datumRodjenja?: Date | undefined;
    mobilniTelefon?: string | undefined;
    stranka?: Stranka | undefined;
    stanovi?: StambeniKorisnik[] | undefined;
}

export enum PolFizickogLica {
    MUSKO = 0,
    ZENSKO = 1,
    DRUGO = 2,
    EMPTY = -1,
}

export class StambeniKorisnik implements IStambeniKorisnik {
    fizickoLiceId?: number;
    fizickoLice?: FizickoLice | undefined;
    stanId?: number;
    stan?: Stan | undefined;

    constructor(data?: IStambeniKorisnik) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fizickoLiceId = _data["fizickoLiceId"];
            this.fizickoLice = _data["fizickoLice"] ? FizickoLice.fromJS(_data["fizickoLice"]) : <any>undefined;
            this.stanId = _data["stanId"];
            this.stan = _data["stan"] ? Stan.fromJS(_data["stan"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StambeniKorisnik {
        data = typeof data === 'object' ? data : {};
        let result = new StambeniKorisnik();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fizickoLiceId"] = this.fizickoLiceId;
        data["fizickoLice"] = this.fizickoLice ? this.fizickoLice.toJSON() : <any>undefined;
        data["stanId"] = this.stanId;
        data["stan"] = this.stan ? this.stan.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStambeniKorisnik {
    fizickoLiceId?: number;
    fizickoLice?: FizickoLice | undefined;
    stanId?: number;
    stan?: Stan | undefined;
}

export class Stan implements IStan {
    stanId?: number;
    sifraProstora?: string | undefined;
    grejnaPovrsina?: number;
    brojClanova?: number;
    brojStana?: number;
    stambeniKorisnici?: StambeniKorisnik[] | undefined;

    constructor(data?: IStan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stanId = _data["stanId"];
            this.sifraProstora = _data["sifraProstora"];
            this.grejnaPovrsina = _data["grejnaPovrsina"];
            this.brojClanova = _data["brojClanova"];
            this.brojStana = _data["brojStana"];
            if (Array.isArray(_data["stambeniKorisnici"])) {
                this.stambeniKorisnici = [] as any;
                for (let item of _data["stambeniKorisnici"])
                    this.stambeniKorisnici!.push(StambeniKorisnik.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Stan {
        data = typeof data === 'object' ? data : {};
        let result = new Stan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stanId"] = this.stanId;
        data["sifraProstora"] = this.sifraProstora;
        data["grejnaPovrsina"] = this.grejnaPovrsina;
        data["brojClanova"] = this.brojClanova;
        data["brojStana"] = this.brojStana;
        if (Array.isArray(this.stambeniKorisnici)) {
            data["stambeniKorisnici"] = [];
            for (let item of this.stambeniKorisnici)
                data["stambeniKorisnici"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStan {
    stanId?: number;
    sifraProstora?: string | undefined;
    grejnaPovrsina?: number;
    brojClanova?: number;
    brojStana?: number;
    stambeniKorisnici?: StambeniKorisnik[] | undefined;
}

export class SaldoStranka implements ISaldoStranka {
    saldoId?: number;
    potrazivanja?: number;
    brojFakturaPotrazivanja?: number;
    uplate?: number;
    saldoKupac?: number;
    potrazivanjaVanValute?: number;
    brojFakturaPotrazivanjaVanValute?: number;
    dugovanja?: number;
    brojFakturaDugovanja?: number;
    placanja?: number;
    saldoDobavljac?: number;
    dugovanjaVanValute?: number;
    brojFakturaDugovanjaVanValute?: number;
    datiAvans?: number;
    primljeniAvans?: number;
    strankaId?: number;
    stranka?: Stranka | undefined;

    constructor(data?: ISaldoStranka) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.saldoId = _data["saldoId"];
            this.potrazivanja = _data["potrazivanja"];
            this.brojFakturaPotrazivanja = _data["brojFakturaPotrazivanja"];
            this.uplate = _data["uplate"];
            this.saldoKupac = _data["saldoKupac"];
            this.potrazivanjaVanValute = _data["potrazivanjaVanValute"];
            this.brojFakturaPotrazivanjaVanValute = _data["brojFakturaPotrazivanjaVanValute"];
            this.dugovanja = _data["dugovanja"];
            this.brojFakturaDugovanja = _data["brojFakturaDugovanja"];
            this.placanja = _data["placanja"];
            this.saldoDobavljac = _data["saldoDobavljac"];
            this.dugovanjaVanValute = _data["dugovanjaVanValute"];
            this.brojFakturaDugovanjaVanValute = _data["brojFakturaDugovanjaVanValute"];
            this.datiAvans = _data["datiAvans"];
            this.primljeniAvans = _data["primljeniAvans"];
            this.strankaId = _data["strankaId"];
            this.stranka = _data["stranka"] ? Stranka.fromJS(_data["stranka"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaldoStranka {
        data = typeof data === 'object' ? data : {};
        let result = new SaldoStranka();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saldoId"] = this.saldoId;
        data["potrazivanja"] = this.potrazivanja;
        data["brojFakturaPotrazivanja"] = this.brojFakturaPotrazivanja;
        data["uplate"] = this.uplate;
        data["saldoKupac"] = this.saldoKupac;
        data["potrazivanjaVanValute"] = this.potrazivanjaVanValute;
        data["brojFakturaPotrazivanjaVanValute"] = this.brojFakturaPotrazivanjaVanValute;
        data["dugovanja"] = this.dugovanja;
        data["brojFakturaDugovanja"] = this.brojFakturaDugovanja;
        data["placanja"] = this.placanja;
        data["saldoDobavljac"] = this.saldoDobavljac;
        data["dugovanjaVanValute"] = this.dugovanjaVanValute;
        data["brojFakturaDugovanjaVanValute"] = this.brojFakturaDugovanjaVanValute;
        data["datiAvans"] = this.datiAvans;
        data["primljeniAvans"] = this.primljeniAvans;
        data["strankaId"] = this.strankaId;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaldoStranka {
    saldoId?: number;
    potrazivanja?: number;
    brojFakturaPotrazivanja?: number;
    uplate?: number;
    saldoKupac?: number;
    potrazivanjaVanValute?: number;
    brojFakturaPotrazivanjaVanValute?: number;
    dugovanja?: number;
    brojFakturaDugovanja?: number;
    placanja?: number;
    saldoDobavljac?: number;
    dugovanjaVanValute?: number;
    brojFakturaDugovanjaVanValute?: number;
    datiAvans?: number;
    primljeniAvans?: number;
    strankaId?: number;
    stranka?: Stranka | undefined;
}

export class JournalOption implements IJournalOption {
    journalOptionId?: number;
    print?: boolean | undefined;
    a4Printer?: string | undefined;
    message?: string | undefined;
    preamble?: string | undefined;
    advance?: number | undefined;
    advanceTax?: number | undefined;
    invoiceRequest?: InvoiceRequest | undefined;

    constructor(data?: IJournalOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.journalOptionId = _data["journalOptionId"];
            this.print = _data["print"];
            this.a4Printer = _data["a4Printer"];
            this.message = _data["message"];
            this.preamble = _data["preamble"];
            this.advance = _data["advance"];
            this.advanceTax = _data["advanceTax"];
            this.invoiceRequest = _data["invoiceRequest"] ? InvoiceRequest.fromJS(_data["invoiceRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): JournalOption {
        data = typeof data === 'object' ? data : {};
        let result = new JournalOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["journalOptionId"] = this.journalOptionId;
        data["print"] = this.print;
        data["a4Printer"] = this.a4Printer;
        data["message"] = this.message;
        data["preamble"] = this.preamble;
        data["advance"] = this.advance;
        data["advanceTax"] = this.advanceTax;
        data["invoiceRequest"] = this.invoiceRequest ? this.invoiceRequest.toJSON() : <any>undefined;
        return data;
    }
}

export interface IJournalOption {
    journalOptionId?: number;
    print?: boolean | undefined;
    a4Printer?: string | undefined;
    message?: string | undefined;
    preamble?: string | undefined;
    advance?: number | undefined;
    advanceTax?: number | undefined;
    invoiceRequest?: InvoiceRequest | undefined;
}

export class InvoicePayment implements IInvoicePayment {
    invoicePaymentId?: number;
    amount?: number;
    paymentType?: PaymentType;
    invoiceRequestId?: string;
    invoiceRequest?: InvoiceRequest | undefined;

    constructor(data?: IInvoicePayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoicePaymentId = _data["invoicePaymentId"];
            this.amount = _data["amount"];
            this.paymentType = _data["paymentType"];
            this.invoiceRequestId = _data["invoiceRequestId"];
            this.invoiceRequest = _data["invoiceRequest"] ? InvoiceRequest.fromJS(_data["invoiceRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoicePayment {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoicePaymentId"] = this.invoicePaymentId;
        data["amount"] = this.amount;
        data["paymentType"] = this.paymentType;
        data["invoiceRequestId"] = this.invoiceRequestId;
        data["invoiceRequest"] = this.invoiceRequest ? this.invoiceRequest.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInvoicePayment {
    invoicePaymentId?: number;
    amount?: number;
    paymentType?: PaymentType;
    invoiceRequestId?: string;
    invoiceRequest?: InvoiceRequest | undefined;
}

export class ReferentniFiskalniRacun implements IReferentniFiskalniRacun {
    referentniFiskalniRacunId?: number;
    parentId?: string;
    parent?: InvoiceRequest | undefined;
    childId?: string | undefined;
    child?: InvoiceRequest | undefined;
    rootId?: string | undefined;
    root?: InvoiceRequest | undefined;
    searchable?: boolean;
    invoiceType?: InvoiceType;
    transactionType?: TransactionType;
    parentResponseInvoiceNumber?: string | undefined;
    hasStariReferentniRacun?: boolean;

    constructor(data?: IReferentniFiskalniRacun) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referentniFiskalniRacunId = _data["referentniFiskalniRacunId"];
            this.parentId = _data["parentId"];
            this.parent = _data["parent"] ? InvoiceRequest.fromJS(_data["parent"]) : <any>undefined;
            this.childId = _data["childId"];
            this.child = _data["child"] ? InvoiceRequest.fromJS(_data["child"]) : <any>undefined;
            this.rootId = _data["rootId"];
            this.root = _data["root"] ? InvoiceRequest.fromJS(_data["root"]) : <any>undefined;
            this.searchable = _data["searchable"];
            this.invoiceType = _data["invoiceType"];
            this.transactionType = _data["transactionType"];
            this.parentResponseInvoiceNumber = _data["parentResponseInvoiceNumber"];
            this.hasStariReferentniRacun = _data["hasStariReferentniRacun"];
        }
    }

    static fromJS(data: any): ReferentniFiskalniRacun {
        data = typeof data === 'object' ? data : {};
        let result = new ReferentniFiskalniRacun();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referentniFiskalniRacunId"] = this.referentniFiskalniRacunId;
        data["parentId"] = this.parentId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["childId"] = this.childId;
        data["child"] = this.child ? this.child.toJSON() : <any>undefined;
        data["rootId"] = this.rootId;
        data["root"] = this.root ? this.root.toJSON() : <any>undefined;
        data["searchable"] = this.searchable;
        data["invoiceType"] = this.invoiceType;
        data["transactionType"] = this.transactionType;
        data["parentResponseInvoiceNumber"] = this.parentResponseInvoiceNumber;
        data["hasStariReferentniRacun"] = this.hasStariReferentniRacun;
        return data;
    }
}

export interface IReferentniFiskalniRacun {
    referentniFiskalniRacunId?: number;
    parentId?: string;
    parent?: InvoiceRequest | undefined;
    childId?: string | undefined;
    child?: InvoiceRequest | undefined;
    rootId?: string | undefined;
    root?: InvoiceRequest | undefined;
    searchable?: boolean;
    invoiceType?: InvoiceType;
    transactionType?: TransactionType;
    parentResponseInvoiceNumber?: string | undefined;
    hasStariReferentniRacun?: boolean;
}

export class InvoiceTaxItem extends AuditableEntity implements IInvoiceTaxItem {
    invoiceTaxItemId?: number;
    amount?: number;
    categoryName?: string | undefined;
    categoryType?: TaxCategoryType;
    label?: string | undefined;
    rate?: number;
    invoiceResponseId?: number;
    invoiceResponse?: InvoiceResponse | undefined;

    constructor(data?: IInvoiceTaxItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.invoiceTaxItemId = _data["invoiceTaxItemId"];
            this.amount = _data["amount"];
            this.categoryName = _data["categoryName"];
            this.categoryType = _data["categoryType"];
            this.label = _data["label"];
            this.rate = _data["rate"];
            this.invoiceResponseId = _data["invoiceResponseId"];
            this.invoiceResponse = _data["invoiceResponse"] ? InvoiceResponse.fromJS(_data["invoiceResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoiceTaxItem {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceTaxItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceTaxItemId"] = this.invoiceTaxItemId;
        data["amount"] = this.amount;
        data["categoryName"] = this.categoryName;
        data["categoryType"] = this.categoryType;
        data["label"] = this.label;
        data["rate"] = this.rate;
        data["invoiceResponseId"] = this.invoiceResponseId;
        data["invoiceResponse"] = this.invoiceResponse ? this.invoiceResponse.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoiceTaxItem extends IAuditableEntity {
    invoiceTaxItemId?: number;
    amount?: number;
    categoryName?: string | undefined;
    categoryType?: TaxCategoryType;
    label?: string | undefined;
    rate?: number;
    invoiceResponseId?: number;
    invoiceResponse?: InvoiceResponse | undefined;
}

export class ResultOfGetStavkeRefundacijeFiskalnogVm extends Result implements IResultOfGetStavkeRefundacijeFiskalnogVm {
    data?: GetStavkeRefundacijeFiskalnogVm | undefined;

    constructor(data?: IResultOfGetStavkeRefundacijeFiskalnogVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetStavkeRefundacijeFiskalnogVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetStavkeRefundacijeFiskalnogVm {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetStavkeRefundacijeFiskalnogVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetStavkeRefundacijeFiskalnogVm extends IResult {
    data?: GetStavkeRefundacijeFiskalnogVm | undefined;
}

export class GetStavkeRefundacijeFiskalnogVm implements IGetStavkeRefundacijeFiskalnogVm {
    invoiceItemList?: InvoiceItemDto[] | undefined;
    invoicePaymentList?: InvoicePaymentDto[] | undefined;

    constructor(data?: IGetStavkeRefundacijeFiskalnogVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invoiceItemList"])) {
                this.invoiceItemList = [] as any;
                for (let item of _data["invoiceItemList"])
                    this.invoiceItemList!.push(InvoiceItemDto.fromJS(item));
            }
            if (Array.isArray(_data["invoicePaymentList"])) {
                this.invoicePaymentList = [] as any;
                for (let item of _data["invoicePaymentList"])
                    this.invoicePaymentList!.push(InvoicePaymentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStavkeRefundacijeFiskalnogVm {
        data = typeof data === 'object' ? data : {};
        let result = new GetStavkeRefundacijeFiskalnogVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoiceItemList)) {
            data["invoiceItemList"] = [];
            for (let item of this.invoiceItemList)
                data["invoiceItemList"].push(item.toJSON());
        }
        if (Array.isArray(this.invoicePaymentList)) {
            data["invoicePaymentList"] = [];
            for (let item of this.invoicePaymentList)
                data["invoicePaymentList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStavkeRefundacijeFiskalnogVm {
    invoiceItemList?: InvoiceItemDto[] | undefined;
    invoicePaymentList?: InvoicePaymentDto[] | undefined;
}

export class InvoiceItemDto implements IInvoiceItemDto {
    invoiceItemId?: number | undefined;
    predmetStavkeId?: number | undefined;
    magacinId?: number | undefined;
    gtin?: string | undefined;
    name?: string | undefined;
    quantity?: number;
    totalAmount?: number;
    unitPrice?: number;
    labels?: string[] | undefined;
    nazivProizvoda?: string | undefined;
    discount?: number | undefined;
    price?: number | undefined;

    constructor(data?: IInvoiceItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceItemId = _data["invoiceItemId"];
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.magacinId = _data["magacinId"];
            this.gtin = _data["gtin"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.totalAmount = _data["totalAmount"];
            this.unitPrice = _data["unitPrice"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(item);
            }
            this.nazivProizvoda = _data["nazivProizvoda"];
            this.discount = _data["discount"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): InvoiceItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceItemId"] = this.invoiceItemId;
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["magacinId"] = this.magacinId;
        data["gtin"] = this.gtin;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["totalAmount"] = this.totalAmount;
        data["unitPrice"] = this.unitPrice;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        data["nazivProizvoda"] = this.nazivProizvoda;
        data["discount"] = this.discount;
        data["price"] = this.price;
        return data;
    }
}

export interface IInvoiceItemDto {
    invoiceItemId?: number | undefined;
    predmetStavkeId?: number | undefined;
    magacinId?: number | undefined;
    gtin?: string | undefined;
    name?: string | undefined;
    quantity?: number;
    totalAmount?: number;
    unitPrice?: number;
    labels?: string[] | undefined;
    nazivProizvoda?: string | undefined;
    discount?: number | undefined;
    price?: number | undefined;
}

export class ResultOfGetReferentniFiskalniRacunResponse extends Result implements IResultOfGetReferentniFiskalniRacunResponse {
    data?: GetReferentniFiskalniRacunResponse | undefined;

    constructor(data?: IResultOfGetReferentniFiskalniRacunResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetReferentniFiskalniRacunResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetReferentniFiskalniRacunResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetReferentniFiskalniRacunResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetReferentniFiskalniRacunResponse extends IResult {
    data?: GetReferentniFiskalniRacunResponse | undefined;
}

export class GetReferentniFiskalniRacunResponse implements IGetReferentniFiskalniRacunResponse {
    referentniFiskalniRacunDto?: ReferentniFiskalniRacunDto | undefined;
    invoiceTransaction?: InvoiceTransaction | undefined;

    constructor(data?: IGetReferentniFiskalniRacunResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referentniFiskalniRacunDto = _data["referentniFiskalniRacunDto"] ? ReferentniFiskalniRacunDto.fromJS(_data["referentniFiskalniRacunDto"]) : <any>undefined;
            this.invoiceTransaction = _data["invoiceTransaction"] ? InvoiceTransaction.fromJS(_data["invoiceTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetReferentniFiskalniRacunResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferentniFiskalniRacunResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referentniFiskalniRacunDto"] = this.referentniFiskalniRacunDto ? this.referentniFiskalniRacunDto.toJSON() : <any>undefined;
        data["invoiceTransaction"] = this.invoiceTransaction ? this.invoiceTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetReferentniFiskalniRacunResponse {
    referentniFiskalniRacunDto?: ReferentniFiskalniRacunDto | undefined;
    invoiceTransaction?: InvoiceTransaction | undefined;
}

export class InvoiceTransaction implements IInvoiceTransaction {
    invoiceType?: InvoiceType;
    transactionType?: TransactionType;

    constructor(data?: IInvoiceTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceType = _data["invoiceType"];
            this.transactionType = _data["transactionType"];
        }
    }

    static fromJS(data: any): InvoiceTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceType"] = this.invoiceType;
        data["transactionType"] = this.transactionType;
        return data;
    }
}

export interface IInvoiceTransaction {
    invoiceType?: InvoiceType;
    transactionType?: TransactionType;
}

export class ResultOfPredefinisaniTekstDto extends Result implements IResultOfPredefinisaniTekstDto {
    data?: PredefinisaniTekstDto | undefined;

    constructor(data?: IResultOfPredefinisaniTekstDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PredefinisaniTekstDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfPredefinisaniTekstDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfPredefinisaniTekstDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfPredefinisaniTekstDto extends IResult {
    data?: PredefinisaniTekstDto | undefined;
}

export class PredefinisaniTekstDto implements IPredefinisaniTekstDto {
    textBefore?: string | undefined;
    textAfter?: string | undefined;

    constructor(data?: IPredefinisaniTekstDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.textBefore = _data["textBefore"];
            this.textAfter = _data["textAfter"];
        }
    }

    static fromJS(data: any): PredefinisaniTekstDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredefinisaniTekstDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["textBefore"] = this.textBefore;
        data["textAfter"] = this.textAfter;
        return data;
    }
}

export interface IPredefinisaniTekstDto {
    textBefore?: string | undefined;
    textAfter?: string | undefined;
}

export class ResultOfOpstaPravilaFiskalniDto extends Result implements IResultOfOpstaPravilaFiskalniDto {
    data?: OpstaPravilaFiskalniDto | undefined;

    constructor(data?: IResultOfOpstaPravilaFiskalniDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? OpstaPravilaFiskalniDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfOpstaPravilaFiskalniDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfOpstaPravilaFiskalniDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfOpstaPravilaFiskalniDto extends IResult {
    data?: OpstaPravilaFiskalniDto | undefined;
}

export class OpstaPravilaFiskalniDto implements IOpstaPravilaFiskalniDto {
    velicinaPapiraDto?: VelicinaPapiraDto | undefined;
    prikazRabataDto?: PrikazRabataDto | undefined;
    barkodSkener?: boolean;
    postFiskalizacijeAkcijaDto?: PostFiskalizacijaAkcijaDto | undefined;
    stampanje?: boolean;

    constructor(data?: IOpstaPravilaFiskalniDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.velicinaPapiraDto = _data["velicinaPapiraDto"] ? VelicinaPapiraDto.fromJS(_data["velicinaPapiraDto"]) : <any>undefined;
            this.prikazRabataDto = _data["prikazRabataDto"] ? PrikazRabataDto.fromJS(_data["prikazRabataDto"]) : <any>undefined;
            this.barkodSkener = _data["barkodSkener"];
            this.postFiskalizacijeAkcijaDto = _data["postFiskalizacijeAkcijaDto"] ? PostFiskalizacijaAkcijaDto.fromJS(_data["postFiskalizacijeAkcijaDto"]) : <any>undefined;
            this.stampanje = _data["stampanje"];
        }
    }

    static fromJS(data: any): OpstaPravilaFiskalniDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpstaPravilaFiskalniDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["velicinaPapiraDto"] = this.velicinaPapiraDto ? this.velicinaPapiraDto.toJSON() : <any>undefined;
        data["prikazRabataDto"] = this.prikazRabataDto ? this.prikazRabataDto.toJSON() : <any>undefined;
        data["barkodSkener"] = this.barkodSkener;
        data["postFiskalizacijeAkcijaDto"] = this.postFiskalizacijeAkcijaDto ? this.postFiskalizacijeAkcijaDto.toJSON() : <any>undefined;
        data["stampanje"] = this.stampanje;
        return data;
    }
}

export interface IOpstaPravilaFiskalniDto {
    velicinaPapiraDto?: VelicinaPapiraDto | undefined;
    prikazRabataDto?: PrikazRabataDto | undefined;
    barkodSkener?: boolean;
    postFiskalizacijeAkcijaDto?: PostFiskalizacijaAkcijaDto | undefined;
    stampanje?: boolean;
}

export class VelicinaPapiraDto implements IVelicinaPapiraDto {
    velicinaPapira?: VelicinaPapira;
    velicinaPapiraStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IVelicinaPapiraDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.velicinaPapira = _data["velicinaPapira"];
            this.velicinaPapiraStr = _data["velicinaPapiraStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): VelicinaPapiraDto {
        data = typeof data === 'object' ? data : {};
        let result = new VelicinaPapiraDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["velicinaPapira"] = this.velicinaPapira;
        data["velicinaPapiraStr"] = this.velicinaPapiraStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IVelicinaPapiraDto {
    velicinaPapira?: VelicinaPapira;
    velicinaPapiraStr?: string | undefined;
    opis?: string | undefined;
}

export enum VelicinaPapira {
    VELIKI = 0,
    MALI = 1,
}

export class PrikazRabataDto implements IPrikazRabataDto {
    prikazRabata?: PrikazRabata;
    prikazRabataStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IPrikazRabataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prikazRabata = _data["prikazRabata"];
            this.prikazRabataStr = _data["prikazRabataStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): PrikazRabataDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrikazRabataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prikazRabata"] = this.prikazRabata;
        data["prikazRabataStr"] = this.prikazRabataStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IPrikazRabataDto {
    prikazRabata?: PrikazRabata;
    prikazRabataStr?: string | undefined;
    opis?: string | undefined;
}

export class PostFiskalizacijaAkcijaDto implements IPostFiskalizacijaAkcijaDto {
    postFiskalizacijeAkcija?: PostFiskalizacijeAkcija;
    postFiskalizacijeAkcijaStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IPostFiskalizacijaAkcijaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postFiskalizacijeAkcija = _data["postFiskalizacijeAkcija"];
            this.postFiskalizacijeAkcijaStr = _data["postFiskalizacijeAkcijaStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): PostFiskalizacijaAkcijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostFiskalizacijaAkcijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postFiskalizacijeAkcija"] = this.postFiskalizacijeAkcija;
        data["postFiskalizacijeAkcijaStr"] = this.postFiskalizacijeAkcijaStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IPostFiskalizacijaAkcijaDto {
    postFiskalizacijeAkcija?: PostFiskalizacijeAkcija;
    postFiskalizacijeAkcijaStr?: string | undefined;
    opis?: string | undefined;
}

export enum PostFiskalizacijeAkcija {
    TABELA = 0,
    NOVA_FORMA = 1,
}

export class ResultOfGetVelicinaPapiraResponse extends Result implements IResultOfGetVelicinaPapiraResponse {
    data?: GetVelicinaPapiraResponse | undefined;

    constructor(data?: IResultOfGetVelicinaPapiraResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetVelicinaPapiraResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetVelicinaPapiraResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetVelicinaPapiraResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetVelicinaPapiraResponse extends IResult {
    data?: GetVelicinaPapiraResponse | undefined;
}

export class GetVelicinaPapiraResponse implements IGetVelicinaPapiraResponse {
    velicinaPapiraDtoList?: VelicinaPapiraDto[] | undefined;

    constructor(data?: IGetVelicinaPapiraResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["velicinaPapiraDtoList"])) {
                this.velicinaPapiraDtoList = [] as any;
                for (let item of _data["velicinaPapiraDtoList"])
                    this.velicinaPapiraDtoList!.push(VelicinaPapiraDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetVelicinaPapiraResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetVelicinaPapiraResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.velicinaPapiraDtoList)) {
            data["velicinaPapiraDtoList"] = [];
            for (let item of this.velicinaPapiraDtoList)
                data["velicinaPapiraDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetVelicinaPapiraResponse {
    velicinaPapiraDtoList?: VelicinaPapiraDto[] | undefined;
}

export class ResultOfGetTipAkcijeResponse extends Result implements IResultOfGetTipAkcijeResponse {
    data?: GetTipAkcijeResponse | undefined;

    constructor(data?: IResultOfGetTipAkcijeResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetTipAkcijeResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetTipAkcijeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetTipAkcijeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetTipAkcijeResponse extends IResult {
    data?: GetTipAkcijeResponse | undefined;
}

export class GetTipAkcijeResponse implements IGetTipAkcijeResponse {
    postFiskalizacijaAkcijaDtoList?: PostFiskalizacijaAkcijaDto[] | undefined;

    constructor(data?: IGetTipAkcijeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["postFiskalizacijaAkcijaDtoList"])) {
                this.postFiskalizacijaAkcijaDtoList = [] as any;
                for (let item of _data["postFiskalizacijaAkcijaDtoList"])
                    this.postFiskalizacijaAkcijaDtoList!.push(PostFiskalizacijaAkcijaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTipAkcijeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTipAkcijeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.postFiskalizacijaAkcijaDtoList)) {
            data["postFiskalizacijaAkcijaDtoList"] = [];
            for (let item of this.postFiskalizacijaAkcijaDtoList)
                data["postFiskalizacijaAkcijaDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTipAkcijeResponse {
    postFiskalizacijaAkcijaDtoList?: PostFiskalizacijaAkcijaDto[] | undefined;
}

export class ResultOfRelevantniDokumentListItemUrlDto extends Result implements IResultOfRelevantniDokumentListItemUrlDto {
    data?: RelevantniDokumentListItemUrlDto | undefined;

    constructor(data?: IResultOfRelevantniDokumentListItemUrlDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? RelevantniDokumentListItemUrlDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfRelevantniDokumentListItemUrlDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfRelevantniDokumentListItemUrlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfRelevantniDokumentListItemUrlDto extends IResult {
    data?: RelevantniDokumentListItemUrlDto | undefined;
}

export class RelevantniDokumentListItemUrlDto implements IRelevantniDokumentListItemUrlDto {
    fileUrl?: string | undefined;
    naziv?: string | undefined;
    storageFileName?: string | undefined;
    fileType?: FileType;
    tipRelevantnogDokumenta?: TipRelevantnogDokumenta;

    constructor(data?: IRelevantniDokumentListItemUrlDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileUrl = _data["fileUrl"];
            this.naziv = _data["naziv"];
            this.storageFileName = _data["storageFileName"];
            this.fileType = _data["fileType"];
            this.tipRelevantnogDokumenta = _data["tipRelevantnogDokumenta"];
        }
    }

    static fromJS(data: any): RelevantniDokumentListItemUrlDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelevantniDokumentListItemUrlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileUrl"] = this.fileUrl;
        data["naziv"] = this.naziv;
        data["storageFileName"] = this.storageFileName;
        data["fileType"] = this.fileType;
        data["tipRelevantnogDokumenta"] = this.tipRelevantnogDokumenta;
        return data;
    }
}

export interface IRelevantniDokumentListItemUrlDto {
    fileUrl?: string | undefined;
    naziv?: string | undefined;
    storageFileName?: string | undefined;
    fileType?: FileType;
    tipRelevantnogDokumenta?: TipRelevantnogDokumenta;
}

export class ResultOfListOfProizvodiZaAvanseMaloprodajaDto extends Result implements IResultOfListOfProizvodiZaAvanseMaloprodajaDto {
    data?: ProizvodiZaAvanseMaloprodajaDto[] | undefined;

    constructor(data?: IResultOfListOfProizvodiZaAvanseMaloprodajaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProizvodiZaAvanseMaloprodajaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfProizvodiZaAvanseMaloprodajaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfProizvodiZaAvanseMaloprodajaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfProizvodiZaAvanseMaloprodajaDto extends IResult {
    data?: ProizvodiZaAvanseMaloprodajaDto[] | undefined;
}

export class ProizvodiZaAvanseMaloprodajaDto implements IProizvodiZaAvanseMaloprodajaDto {
    predmetStavkeId?: number;
    naziv?: string | undefined;

    constructor(data?: IProizvodiZaAvanseMaloprodajaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): ProizvodiZaAvanseMaloprodajaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProizvodiZaAvanseMaloprodajaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IProizvodiZaAvanseMaloprodajaDto {
    predmetStavkeId?: number;
    naziv?: string | undefined;
}

export class GetProizvodiZaAvanseListQuery implements IGetProizvodiZaAvanseListQuery {
    searchValue?: string | undefined;

    constructor(data?: IGetProizvodiZaAvanseListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchValue = _data["searchValue"];
        }
    }

    static fromJS(data: any): GetProizvodiZaAvanseListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetProizvodiZaAvanseListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchValue"] = this.searchValue;
        return data;
    }
}

export interface IGetProizvodiZaAvanseListQuery {
    searchValue?: string | undefined;
}

export class ResultOfFiskalniIsecakPdfData extends Result implements IResultOfFiskalniIsecakPdfData {
    data?: FiskalniIsecakPdfData | undefined;

    constructor(data?: IResultOfFiskalniIsecakPdfData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? FiskalniIsecakPdfData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfFiskalniIsecakPdfData {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfFiskalniIsecakPdfData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfFiskalniIsecakPdfData extends IResult {
    data?: FiskalniIsecakPdfData | undefined;
}

export class FiskalniIsecakPdfData implements IFiskalniIsecakPdfData {
    journal?: string | undefined;
    fileName?: string | undefined;
    invoiceResponseId?: number;
    velicinaPapira?: VelicinaPapira;
    textBefore?: string | undefined;
    textAfter?: string | undefined;

    constructor(data?: IFiskalniIsecakPdfData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.journal = _data["journal"];
            this.fileName = _data["fileName"];
            this.invoiceResponseId = _data["invoiceResponseId"];
            this.velicinaPapira = _data["velicinaPapira"];
            this.textBefore = _data["textBefore"];
            this.textAfter = _data["textAfter"];
        }
    }

    static fromJS(data: any): FiskalniIsecakPdfData {
        data = typeof data === 'object' ? data : {};
        let result = new FiskalniIsecakPdfData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["journal"] = this.journal;
        data["fileName"] = this.fileName;
        data["invoiceResponseId"] = this.invoiceResponseId;
        data["velicinaPapira"] = this.velicinaPapira;
        data["textBefore"] = this.textBefore;
        data["textAfter"] = this.textAfter;
        return data;
    }
}

export interface IFiskalniIsecakPdfData {
    journal?: string | undefined;
    fileName?: string | undefined;
    invoiceResponseId?: number;
    velicinaPapira?: VelicinaPapira;
    textBefore?: string | undefined;
    textAfter?: string | undefined;
}

export class InvoiceRequestDto implements IInvoiceRequestDto {
    invoiceRequestId?: string | undefined;
    dateAndTimeOfIssue?: Date | undefined;
    cashier?: string | undefined;
    buyerId?: string | undefined;
    buyerCostCenterId?: string | undefined;
    buyerIdentification?: BuyerIdentification | undefined;
    buyerOptionalField?: BuyerOptionalField | undefined;
    invoiceType?: InvoiceType;
    transactionType?: TransactionType;
    invoiceNumber?: string | undefined;
    journalOption?: JournalOptionDto | undefined;
    referentniFiskalniRacunDto?: ReferentniFiskalniRacunDto | undefined;
    optionId?: number | undefined;
    option?: InvoiceOptionDto | undefined;
    invoiceItems?: InvoiceItemDto[] | undefined;
    invoicePayments?: InvoicePaymentDto[] | undefined;

    constructor(data?: IInvoiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceRequestId = _data["invoiceRequestId"];
            this.dateAndTimeOfIssue = _data["dateAndTimeOfIssue"] ? new Date(_data["dateAndTimeOfIssue"].toString()) : <any>undefined;
            this.cashier = _data["cashier"];
            this.buyerId = _data["buyerId"];
            this.buyerCostCenterId = _data["buyerCostCenterId"];
            this.buyerIdentification = _data["buyerIdentification"];
            this.buyerOptionalField = _data["buyerOptionalField"];
            this.invoiceType = _data["invoiceType"];
            this.transactionType = _data["transactionType"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.journalOption = _data["journalOption"] ? JournalOptionDto.fromJS(_data["journalOption"]) : <any>undefined;
            this.referentniFiskalniRacunDto = _data["referentniFiskalniRacunDto"] ? ReferentniFiskalniRacunDto.fromJS(_data["referentniFiskalniRacunDto"]) : <any>undefined;
            this.optionId = _data["optionId"];
            this.option = _data["option"] ? InvoiceOptionDto.fromJS(_data["option"]) : <any>undefined;
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(InvoiceItemDto.fromJS(item));
            }
            if (Array.isArray(_data["invoicePayments"])) {
                this.invoicePayments = [] as any;
                for (let item of _data["invoicePayments"])
                    this.invoicePayments!.push(InvoicePaymentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceRequestId"] = this.invoiceRequestId;
        data["dateAndTimeOfIssue"] = this.dateAndTimeOfIssue ? this.dateAndTimeOfIssue.toISOString() : <any>undefined;
        data["cashier"] = this.cashier;
        data["buyerId"] = this.buyerId;
        data["buyerCostCenterId"] = this.buyerCostCenterId;
        data["buyerIdentification"] = this.buyerIdentification;
        data["buyerOptionalField"] = this.buyerOptionalField;
        data["invoiceType"] = this.invoiceType;
        data["transactionType"] = this.transactionType;
        data["invoiceNumber"] = this.invoiceNumber;
        data["journalOption"] = this.journalOption ? this.journalOption.toJSON() : <any>undefined;
        data["referentniFiskalniRacunDto"] = this.referentniFiskalniRacunDto ? this.referentniFiskalniRacunDto.toJSON() : <any>undefined;
        data["optionId"] = this.optionId;
        data["option"] = this.option ? this.option.toJSON() : <any>undefined;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item.toJSON());
        }
        if (Array.isArray(this.invoicePayments)) {
            data["invoicePayments"] = [];
            for (let item of this.invoicePayments)
                data["invoicePayments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvoiceRequestDto {
    invoiceRequestId?: string | undefined;
    dateAndTimeOfIssue?: Date | undefined;
    cashier?: string | undefined;
    buyerId?: string | undefined;
    buyerCostCenterId?: string | undefined;
    buyerIdentification?: BuyerIdentification | undefined;
    buyerOptionalField?: BuyerOptionalField | undefined;
    invoiceType?: InvoiceType;
    transactionType?: TransactionType;
    invoiceNumber?: string | undefined;
    journalOption?: JournalOptionDto | undefined;
    referentniFiskalniRacunDto?: ReferentniFiskalniRacunDto | undefined;
    optionId?: number | undefined;
    option?: InvoiceOptionDto | undefined;
    invoiceItems?: InvoiceItemDto[] | undefined;
    invoicePayments?: InvoicePaymentDto[] | undefined;
}

export class CreateFiskalniRacunCommand extends InvoiceRequestDto implements ICreateFiskalniRacunCommand {

    constructor(data?: ICreateFiskalniRacunCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateFiskalniRacunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFiskalniRacunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateFiskalniRacunCommand extends IInvoiceRequestDto {
}

export class JournalOptionDto implements IJournalOptionDto {
    journalOptionId?: number | undefined;
    print?: boolean | undefined;
    a4Printer?: string | undefined;
    message?: string | undefined;
    preamble?: string | undefined;
    advance?: number;
    advanceTax?: number;

    constructor(data?: IJournalOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.journalOptionId = _data["journalOptionId"];
            this.print = _data["print"];
            this.a4Printer = _data["a4Printer"];
            this.message = _data["message"];
            this.preamble = _data["preamble"];
            this.advance = _data["advance"];
            this.advanceTax = _data["advanceTax"];
        }
    }

    static fromJS(data: any): JournalOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new JournalOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["journalOptionId"] = this.journalOptionId;
        data["print"] = this.print;
        data["a4Printer"] = this.a4Printer;
        data["message"] = this.message;
        data["preamble"] = this.preamble;
        data["advance"] = this.advance;
        data["advanceTax"] = this.advanceTax;
        return data;
    }
}

export interface IJournalOptionDto {
    journalOptionId?: number | undefined;
    print?: boolean | undefined;
    a4Printer?: string | undefined;
    message?: string | undefined;
    preamble?: string | undefined;
    advance?: number;
    advanceTax?: number;
}

export class InvoiceOptionDto implements IInvoiceOptionDto {
    invoiceOptionId?: number | undefined;
    omitQRCodeGen?: Omit;
    omitTextualRepresentation?: Omit;

    constructor(data?: IInvoiceOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceOptionId = _data["invoiceOptionId"];
            this.omitQRCodeGen = _data["omitQRCodeGen"];
            this.omitTextualRepresentation = _data["omitTextualRepresentation"];
        }
    }

    static fromJS(data: any): InvoiceOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceOptionId"] = this.invoiceOptionId;
        data["omitQRCodeGen"] = this.omitQRCodeGen;
        data["omitTextualRepresentation"] = this.omitTextualRepresentation;
        return data;
    }
}

export interface IInvoiceOptionDto {
    invoiceOptionId?: number | undefined;
    omitQRCodeGen?: Omit;
    omitTextualRepresentation?: Omit;
}

export class ImportSertifikatFiskalneKaseDtoCommand implements IImportSertifikatFiskalneKaseDtoCommand {
    naziv?: string | undefined;
    jid?: string | undefined;
    lozinka?: string | undefined;
    pak?: string | undefined;
    poslovnaJedinicaId?: number;
    licence?: LpfrLicencaDropdownDto[] | undefined;
    vaziDo?: Date | undefined;

    constructor(data?: IImportSertifikatFiskalneKaseDtoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.jid = _data["jid"];
            this.lozinka = _data["lozinka"];
            this.pak = _data["pak"];
            this.poslovnaJedinicaId = _data["poslovnaJedinicaId"];
            if (Array.isArray(_data["licence"])) {
                this.licence = [] as any;
                for (let item of _data["licence"])
                    this.licence!.push(LpfrLicencaDropdownDto.fromJS(item));
            }
            this.vaziDo = _data["vaziDo"] ? new Date(_data["vaziDo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ImportSertifikatFiskalneKaseDtoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportSertifikatFiskalneKaseDtoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["jid"] = this.jid;
        data["lozinka"] = this.lozinka;
        data["pak"] = this.pak;
        data["poslovnaJedinicaId"] = this.poslovnaJedinicaId;
        if (Array.isArray(this.licence)) {
            data["licence"] = [];
            for (let item of this.licence)
                data["licence"].push(item.toJSON());
        }
        data["vaziDo"] = this.vaziDo ? this.vaziDo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IImportSertifikatFiskalneKaseDtoCommand {
    naziv?: string | undefined;
    jid?: string | undefined;
    lozinka?: string | undefined;
    pak?: string | undefined;
    poslovnaJedinicaId?: number;
    licence?: LpfrLicencaDropdownDto[] | undefined;
    vaziDo?: Date | undefined;
}

export class CreateEmptyBezbednosniElementLPFRCommand implements ICreateEmptyBezbednosniElementLPFRCommand {
    jid?: string | undefined;
    poslovnaJedinicaId?: number;
    licence?: LpfrLicencaDropdownDto[] | undefined;
    vaziDo?: Date | undefined;

    constructor(data?: ICreateEmptyBezbednosniElementLPFRCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jid = _data["jid"];
            this.poslovnaJedinicaId = _data["poslovnaJedinicaId"];
            if (Array.isArray(_data["licence"])) {
                this.licence = [] as any;
                for (let item of _data["licence"])
                    this.licence!.push(LpfrLicencaDropdownDto.fromJS(item));
            }
            this.vaziDo = _data["vaziDo"] ? new Date(_data["vaziDo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateEmptyBezbednosniElementLPFRCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmptyBezbednosniElementLPFRCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jid"] = this.jid;
        data["poslovnaJedinicaId"] = this.poslovnaJedinicaId;
        if (Array.isArray(this.licence)) {
            data["licence"] = [];
            for (let item of this.licence)
                data["licence"].push(item.toJSON());
        }
        data["vaziDo"] = this.vaziDo ? this.vaziDo.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateEmptyBezbednosniElementLPFRCommand {
    jid?: string | undefined;
    poslovnaJedinicaId?: number;
    licence?: LpfrLicencaDropdownDto[] | undefined;
    vaziDo?: Date | undefined;
}

export class UpdateBezbednosniElementCommand extends BezbednosniElementInfoDto implements IUpdateBezbednosniElementCommand {

    constructor(data?: IUpdateBezbednosniElementCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateBezbednosniElementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBezbednosniElementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateBezbednosniElementCommand extends IBezbednosniElementInfoDto {
}

export class AddPredefinisaniTekstCommand implements IAddPredefinisaniTekstCommand {
    textBefore?: string | undefined;
    textAfter?: string | undefined;

    constructor(data?: IAddPredefinisaniTekstCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.textBefore = _data["textBefore"];
            this.textAfter = _data["textAfter"];
        }
    }

    static fromJS(data: any): AddPredefinisaniTekstCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddPredefinisaniTekstCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["textBefore"] = this.textBefore;
        data["textAfter"] = this.textAfter;
        return data;
    }
}

export interface IAddPredefinisaniTekstCommand {
    textBefore?: string | undefined;
    textAfter?: string | undefined;
}

export class UpdateOpstaPravilaFiskalnaCommand extends OpstaPravilaFiskalniDto implements IUpdateOpstaPravilaFiskalnaCommand {

    constructor(data?: IUpdateOpstaPravilaFiskalnaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateOpstaPravilaFiskalnaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOpstaPravilaFiskalnaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateOpstaPravilaFiskalnaCommand extends IOpstaPravilaFiskalniDto {
}

export class PaginatedResultOfUlazniFiskalniRacunTableDto extends Result implements IPaginatedResultOfUlazniFiskalniRacunTableDto {
    data?: UlazniFiskalniRacunTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfUlazniFiskalniRacunTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UlazniFiskalniRacunTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfUlazniFiskalniRacunTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfUlazniFiskalniRacunTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfUlazniFiskalniRacunTableDto extends IResult {
    data?: UlazniFiskalniRacunTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class UlazniFiskalniRacunTableDto implements IUlazniFiskalniRacunTableDto {
    id?: number;
    invoiceNumber?: string | undefined;
    sdcDateTime?: string | undefined;
    invoiceCounter?: string | undefined;
    invoiceType?: InvoiceType;
    transactionType?: TransactionType;
    tip?: TipFiskalnogRacunaDto | undefined;
    amount?: number;
    tin?: string | undefined;
    businessName?: string | undefined;
    locationName?: string | undefined;

    constructor(data?: IUlazniFiskalniRacunTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.sdcDateTime = _data["sdcDateTime"];
            this.invoiceCounter = _data["invoiceCounter"];
            this.invoiceType = _data["invoiceType"];
            this.transactionType = _data["transactionType"];
            this.tip = _data["tip"] ? TipFiskalnogRacunaDto.fromJS(_data["tip"]) : <any>undefined;
            this.amount = _data["amount"];
            this.tin = _data["tin"];
            this.businessName = _data["businessName"];
            this.locationName = _data["locationName"];
        }
    }

    static fromJS(data: any): UlazniFiskalniRacunTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new UlazniFiskalniRacunTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["sdcDateTime"] = this.sdcDateTime;
        data["invoiceCounter"] = this.invoiceCounter;
        data["invoiceType"] = this.invoiceType;
        data["transactionType"] = this.transactionType;
        data["tip"] = this.tip ? this.tip.toJSON() : <any>undefined;
        data["amount"] = this.amount;
        data["tin"] = this.tin;
        data["businessName"] = this.businessName;
        data["locationName"] = this.locationName;
        return data;
    }
}

export interface IUlazniFiskalniRacunTableDto {
    id?: number;
    invoiceNumber?: string | undefined;
    sdcDateTime?: string | undefined;
    invoiceCounter?: string | undefined;
    invoiceType?: InvoiceType;
    transactionType?: TransactionType;
    tip?: TipFiskalnogRacunaDto | undefined;
    amount?: number;
    tin?: string | undefined;
    businessName?: string | undefined;
    locationName?: string | undefined;
}

export class GetUlazniFiskalniRacunTableQuery implements IGetUlazniFiskalniRacunTableQuery {
    brojRacuna?: string | undefined;
    prodavac?: string | undefined;
    vrstaRacuna?: InvoiceType | undefined;
    tipTransakcije?: TransactionType | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetUlazniFiskalniRacunTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brojRacuna = _data["brojRacuna"];
            this.prodavac = _data["prodavac"];
            this.vrstaRacuna = _data["vrstaRacuna"];
            this.tipTransakcije = _data["tipTransakcije"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetUlazniFiskalniRacunTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUlazniFiskalniRacunTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brojRacuna"] = this.brojRacuna;
        data["prodavac"] = this.prodavac;
        data["vrstaRacuna"] = this.vrstaRacuna;
        data["tipTransakcije"] = this.tipTransakcije;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetUlazniFiskalniRacunTableQuery {
    brojRacuna?: string | undefined;
    prodavac?: string | undefined;
    vrstaRacuna?: InvoiceType | undefined;
    tipTransakcije?: TransactionType | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    pageNumber?: number;
    pageSize?: number;
}

export class CreateUlazniFiskalniRacunCommand implements ICreateUlazniFiskalniRacunCommand {
    invoiceNumber?: string | undefined;
    sdcDateTime?: string | undefined;
    invoiceCounter?: string | undefined;
    invoiceType?: string | undefined;
    transactionType?: string | undefined;
    totalAmount?: number;
    tin?: string | undefined;
    businessName?: string | undefined;
    locationName?: string | undefined;
    journal?: string | undefined;

    constructor(data?: ICreateUlazniFiskalniRacunCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNumber = _data["invoiceNumber"];
            this.sdcDateTime = _data["sdcDateTime"];
            this.invoiceCounter = _data["invoiceCounter"];
            this.invoiceType = _data["invoiceType"];
            this.transactionType = _data["transactionType"];
            this.totalAmount = _data["totalAmount"];
            this.tin = _data["tin"];
            this.businessName = _data["businessName"];
            this.locationName = _data["locationName"];
            this.journal = _data["journal"];
        }
    }

    static fromJS(data: any): CreateUlazniFiskalniRacunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUlazniFiskalniRacunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber;
        data["sdcDateTime"] = this.sdcDateTime;
        data["invoiceCounter"] = this.invoiceCounter;
        data["invoiceType"] = this.invoiceType;
        data["transactionType"] = this.transactionType;
        data["totalAmount"] = this.totalAmount;
        data["tin"] = this.tin;
        data["businessName"] = this.businessName;
        data["locationName"] = this.locationName;
        data["journal"] = this.journal;
        return data;
    }
}

export interface ICreateUlazniFiskalniRacunCommand {
    invoiceNumber?: string | undefined;
    sdcDateTime?: string | undefined;
    invoiceCounter?: string | undefined;
    invoiceType?: string | undefined;
    transactionType?: string | undefined;
    totalAmount?: number;
    tin?: string | undefined;
    businessName?: string | undefined;
    locationName?: string | undefined;
    journal?: string | undefined;
}

export class ResultOfGetTableResponseOfFizickoLiceTableDto extends Result implements IResultOfGetTableResponseOfFizickoLiceTableDto {
    data?: GetTableResponseOfFizickoLiceTableDto | undefined;

    constructor(data?: IResultOfGetTableResponseOfFizickoLiceTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetTableResponseOfFizickoLiceTableDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetTableResponseOfFizickoLiceTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetTableResponseOfFizickoLiceTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetTableResponseOfFizickoLiceTableDto extends IResult {
    data?: GetTableResponseOfFizickoLiceTableDto | undefined;
}

export class GetTableResponseOfFizickoLiceTableDto implements IGetTableResponseOfFizickoLiceTableDto {
    responseList?: FizickoLiceTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;

    constructor(data?: IGetTableResponseOfFizickoLiceTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(FizickoLiceTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTableResponseOfFizickoLiceTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTableResponseOfFizickoLiceTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTableResponseOfFizickoLiceTableDto {
    responseList?: FizickoLiceTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
}

export class FizickoLiceTableDto implements IFizickoLiceTableDto {
    id?: number;
    ime?: string | undefined;
    prezime?: string | undefined;
    imePrezime?: string | undefined;
    grad?: string | undefined;
    drzava?: string | undefined;
    mesto?: string | undefined;

    constructor(data?: IFizickoLiceTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ime = _data["ime"];
            this.prezime = _data["prezime"];
            this.imePrezime = _data["imePrezime"];
            this.grad = _data["grad"];
            this.drzava = _data["drzava"];
            this.mesto = _data["mesto"];
        }
    }

    static fromJS(data: any): FizickoLiceTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FizickoLiceTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ime"] = this.ime;
        data["prezime"] = this.prezime;
        data["imePrezime"] = this.imePrezime;
        data["grad"] = this.grad;
        data["drzava"] = this.drzava;
        data["mesto"] = this.mesto;
        return data;
    }
}

export interface IFizickoLiceTableDto {
    id?: number;
    ime?: string | undefined;
    prezime?: string | undefined;
    imePrezime?: string | undefined;
    grad?: string | undefined;
    drzava?: string | undefined;
    mesto?: string | undefined;
}

export class GetFizickaLicaTableQuery implements IGetFizickaLicaTableQuery {
    ime?: string | undefined;
    adresa?: string | undefined;

    constructor(data?: IGetFizickaLicaTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ime = _data["ime"];
            this.adresa = _data["adresa"];
        }
    }

    static fromJS(data: any): GetFizickaLicaTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFizickaLicaTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ime"] = this.ime;
        data["adresa"] = this.adresa;
        return data;
    }
}

export interface IGetFizickaLicaTableQuery {
    ime?: string | undefined;
    adresa?: string | undefined;
}

export class ResultOfFizickoLiceDto extends Result implements IResultOfFizickoLiceDto {
    data?: FizickoLiceDto | undefined;

    constructor(data?: IResultOfFizickoLiceDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? FizickoLiceDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfFizickoLiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfFizickoLiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfFizickoLiceDto extends IResult {
    data?: FizickoLiceDto | undefined;
}

export class FizickoLiceDto extends StrankaDto implements IFizickoLiceDto {
    ime?: string | undefined;
    prezime?: string | undefined;
    jmbg?: string | undefined;
    mobilniTelefon?: string | undefined;
    pol?: PolFizickogLica;
    datumRodjenja?: Date | undefined;
    naziv?: string | undefined;

    constructor(data?: IFizickoLiceDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ime = _data["ime"];
            this.prezime = _data["prezime"];
            this.jmbg = _data["jmbg"];
            this.mobilniTelefon = _data["mobilniTelefon"];
            this.pol = _data["pol"];
            this.datumRodjenja = _data["datumRodjenja"] ? new Date(_data["datumRodjenja"].toString()) : <any>undefined;
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): FizickoLiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new FizickoLiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ime"] = this.ime;
        data["prezime"] = this.prezime;
        data["jmbg"] = this.jmbg;
        data["mobilniTelefon"] = this.mobilniTelefon;
        data["pol"] = this.pol;
        data["datumRodjenja"] = this.datumRodjenja ? this.datumRodjenja.toISOString() : <any>undefined;
        data["naziv"] = this.naziv;
        super.toJSON(data);
        return data;
    }
}

export interface IFizickoLiceDto extends IStrankaDto {
    ime?: string | undefined;
    prezime?: string | undefined;
    jmbg?: string | undefined;
    mobilniTelefon?: string | undefined;
    pol?: PolFizickogLica;
    datumRodjenja?: Date | undefined;
    naziv?: string | undefined;
}

export class ResultOfFizickoLiceVm extends Result implements IResultOfFizickoLiceVm {
    data?: FizickoLiceVm | undefined;

    constructor(data?: IResultOfFizickoLiceVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? FizickoLiceVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfFizickoLiceVm {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfFizickoLiceVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfFizickoLiceVm extends IResult {
    data?: FizickoLiceVm | undefined;
}

export class FizickoLiceVm implements IFizickoLiceVm {
    fizickoLiceTableDto?: FizickoLiceTableDto | undefined;
    fizickoLiceDto?: FizickoLiceDto | undefined;

    constructor(data?: IFizickoLiceVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fizickoLiceTableDto = _data["fizickoLiceTableDto"] ? FizickoLiceTableDto.fromJS(_data["fizickoLiceTableDto"]) : <any>undefined;
            this.fizickoLiceDto = _data["fizickoLiceDto"] ? FizickoLiceDto.fromJS(_data["fizickoLiceDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FizickoLiceVm {
        data = typeof data === 'object' ? data : {};
        let result = new FizickoLiceVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fizickoLiceTableDto"] = this.fizickoLiceTableDto ? this.fizickoLiceTableDto.toJSON() : <any>undefined;
        data["fizickoLiceDto"] = this.fizickoLiceDto ? this.fizickoLiceDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFizickoLiceVm {
    fizickoLiceTableDto?: FizickoLiceTableDto | undefined;
    fizickoLiceDto?: FizickoLiceDto | undefined;
}

export class CreateFizickoLiceCommand implements ICreateFizickoLiceCommand {
    ime?: string | undefined;
    prezime?: string | undefined;
    jmbg?: string | undefined;
    mobilniTelefon?: string | undefined;
    pol?: PolFizickogLica;
    datumRodjenja?: Date | undefined;
    id?: number | undefined;
    naziv?: string | undefined;
    kupac?: string | undefined;
    dobavljac?: string | undefined;
    napomena?: string | undefined;
    tipStranke?: TipStranke;
    adresa?: AdresaDto | undefined;
    rokPlacanjaZaUlazne?: number;
    rokPlacanjaZaIzlazne?: number;
    tekuciRacuniDto?: TekuciRacunDto[] | undefined;
    kontaktiDto?: KontaktDto[] | undefined;
    uSistemuPDVa?: boolean | undefined;
    jeKupac?: boolean;
    jeDobavljac?: boolean;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    valutaPoslovanjaId?: string | undefined;
    valutaPoslovanjaTekst?: string | undefined;
    gln?: string | undefined;

    constructor(data?: ICreateFizickoLiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ime = _data["ime"];
            this.prezime = _data["prezime"];
            this.jmbg = _data["jmbg"];
            this.mobilniTelefon = _data["mobilniTelefon"];
            this.pol = _data["pol"];
            this.datumRodjenja = _data["datumRodjenja"] ? new Date(_data["datumRodjenja"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.kupac = _data["kupac"];
            this.dobavljac = _data["dobavljac"];
            this.napomena = _data["napomena"];
            this.tipStranke = _data["tipStranke"];
            this.adresa = _data["adresa"] ? AdresaDto.fromJS(_data["adresa"]) : <any>undefined;
            this.rokPlacanjaZaUlazne = _data["rokPlacanjaZaUlazne"];
            this.rokPlacanjaZaIzlazne = _data["rokPlacanjaZaIzlazne"];
            if (Array.isArray(_data["tekuciRacuniDto"])) {
                this.tekuciRacuniDto = [] as any;
                for (let item of _data["tekuciRacuniDto"])
                    this.tekuciRacuniDto!.push(TekuciRacunDto.fromJS(item));
            }
            if (Array.isArray(_data["kontaktiDto"])) {
                this.kontaktiDto = [] as any;
                for (let item of _data["kontaktiDto"])
                    this.kontaktiDto!.push(KontaktDto.fromJS(item));
            }
            this.uSistemuPDVa = _data["uSistemuPDVa"];
            this.jeKupac = _data["jeKupac"];
            this.jeDobavljac = _data["jeDobavljac"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedOn = _data["lastModifiedOn"] ? new Date(_data["lastModifiedOn"].toString()) : <any>undefined;
            this.valutaPoslovanjaId = _data["valutaPoslovanjaId"];
            this.valutaPoslovanjaTekst = _data["valutaPoslovanjaTekst"];
            this.gln = _data["gln"];
        }
    }

    static fromJS(data: any): CreateFizickoLiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFizickoLiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ime"] = this.ime;
        data["prezime"] = this.prezime;
        data["jmbg"] = this.jmbg;
        data["mobilniTelefon"] = this.mobilniTelefon;
        data["pol"] = this.pol;
        data["datumRodjenja"] = this.datumRodjenja ? this.datumRodjenja.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["kupac"] = this.kupac;
        data["dobavljac"] = this.dobavljac;
        data["napomena"] = this.napomena;
        data["tipStranke"] = this.tipStranke;
        data["adresa"] = this.adresa ? this.adresa.toJSON() : <any>undefined;
        data["rokPlacanjaZaUlazne"] = this.rokPlacanjaZaUlazne;
        data["rokPlacanjaZaIzlazne"] = this.rokPlacanjaZaIzlazne;
        if (Array.isArray(this.tekuciRacuniDto)) {
            data["tekuciRacuniDto"] = [];
            for (let item of this.tekuciRacuniDto)
                data["tekuciRacuniDto"].push(item.toJSON());
        }
        if (Array.isArray(this.kontaktiDto)) {
            data["kontaktiDto"] = [];
            for (let item of this.kontaktiDto)
                data["kontaktiDto"].push(item.toJSON());
        }
        data["uSistemuPDVa"] = this.uSistemuPDVa;
        data["jeKupac"] = this.jeKupac;
        data["jeDobavljac"] = this.jeDobavljac;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined;
        data["valutaPoslovanjaId"] = this.valutaPoslovanjaId;
        data["valutaPoslovanjaTekst"] = this.valutaPoslovanjaTekst;
        data["gln"] = this.gln;
        return data;
    }
}

export interface ICreateFizickoLiceCommand {
    ime?: string | undefined;
    prezime?: string | undefined;
    jmbg?: string | undefined;
    mobilniTelefon?: string | undefined;
    pol?: PolFizickogLica;
    datumRodjenja?: Date | undefined;
    id?: number | undefined;
    naziv?: string | undefined;
    kupac?: string | undefined;
    dobavljac?: string | undefined;
    napomena?: string | undefined;
    tipStranke?: TipStranke;
    adresa?: AdresaDto | undefined;
    rokPlacanjaZaUlazne?: number;
    rokPlacanjaZaIzlazne?: number;
    tekuciRacuniDto?: TekuciRacunDto[] | undefined;
    kontaktiDto?: KontaktDto[] | undefined;
    uSistemuPDVa?: boolean | undefined;
    jeKupac?: boolean;
    jeDobavljac?: boolean;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    valutaPoslovanjaId?: string | undefined;
    valutaPoslovanjaTekst?: string | undefined;
    gln?: string | undefined;
}

export class UpdateFizickoLiceCommand implements IUpdateFizickoLiceCommand {
    ime?: string | undefined;
    prezime?: string | undefined;
    jmbg?: string | undefined;
    mobilniTelefon?: string | undefined;
    pol?: PolFizickogLica;
    datumRodjenja?: Date | undefined;
    id?: number | undefined;
    naziv?: string | undefined;
    kupac?: string | undefined;
    dobavljac?: string | undefined;
    napomena?: string | undefined;
    tipStranke?: TipStranke;
    adresa?: AdresaDto | undefined;
    rokPlacanjaZaUlazne?: number;
    rokPlacanjaZaIzlazne?: number;
    tekuciRacuniDto?: TekuciRacunDto[] | undefined;
    kontaktiDto?: KontaktDto[] | undefined;
    uSistemuPDVa?: boolean | undefined;
    jeKupac?: boolean;
    jeDobavljac?: boolean;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    valutaPoslovanjaId?: string | undefined;
    valutaPoslovanjaTekst?: string | undefined;
    gln?: string | undefined;

    constructor(data?: IUpdateFizickoLiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ime = _data["ime"];
            this.prezime = _data["prezime"];
            this.jmbg = _data["jmbg"];
            this.mobilniTelefon = _data["mobilniTelefon"];
            this.pol = _data["pol"];
            this.datumRodjenja = _data["datumRodjenja"] ? new Date(_data["datumRodjenja"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.kupac = _data["kupac"];
            this.dobavljac = _data["dobavljac"];
            this.napomena = _data["napomena"];
            this.tipStranke = _data["tipStranke"];
            this.adresa = _data["adresa"] ? AdresaDto.fromJS(_data["adresa"]) : <any>undefined;
            this.rokPlacanjaZaUlazne = _data["rokPlacanjaZaUlazne"];
            this.rokPlacanjaZaIzlazne = _data["rokPlacanjaZaIzlazne"];
            if (Array.isArray(_data["tekuciRacuniDto"])) {
                this.tekuciRacuniDto = [] as any;
                for (let item of _data["tekuciRacuniDto"])
                    this.tekuciRacuniDto!.push(TekuciRacunDto.fromJS(item));
            }
            if (Array.isArray(_data["kontaktiDto"])) {
                this.kontaktiDto = [] as any;
                for (let item of _data["kontaktiDto"])
                    this.kontaktiDto!.push(KontaktDto.fromJS(item));
            }
            this.uSistemuPDVa = _data["uSistemuPDVa"];
            this.jeKupac = _data["jeKupac"];
            this.jeDobavljac = _data["jeDobavljac"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedOn = _data["lastModifiedOn"] ? new Date(_data["lastModifiedOn"].toString()) : <any>undefined;
            this.valutaPoslovanjaId = _data["valutaPoslovanjaId"];
            this.valutaPoslovanjaTekst = _data["valutaPoslovanjaTekst"];
            this.gln = _data["gln"];
        }
    }

    static fromJS(data: any): UpdateFizickoLiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFizickoLiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ime"] = this.ime;
        data["prezime"] = this.prezime;
        data["jmbg"] = this.jmbg;
        data["mobilniTelefon"] = this.mobilniTelefon;
        data["pol"] = this.pol;
        data["datumRodjenja"] = this.datumRodjenja ? this.datumRodjenja.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["kupac"] = this.kupac;
        data["dobavljac"] = this.dobavljac;
        data["napomena"] = this.napomena;
        data["tipStranke"] = this.tipStranke;
        data["adresa"] = this.adresa ? this.adresa.toJSON() : <any>undefined;
        data["rokPlacanjaZaUlazne"] = this.rokPlacanjaZaUlazne;
        data["rokPlacanjaZaIzlazne"] = this.rokPlacanjaZaIzlazne;
        if (Array.isArray(this.tekuciRacuniDto)) {
            data["tekuciRacuniDto"] = [];
            for (let item of this.tekuciRacuniDto)
                data["tekuciRacuniDto"].push(item.toJSON());
        }
        if (Array.isArray(this.kontaktiDto)) {
            data["kontaktiDto"] = [];
            for (let item of this.kontaktiDto)
                data["kontaktiDto"].push(item.toJSON());
        }
        data["uSistemuPDVa"] = this.uSistemuPDVa;
        data["jeKupac"] = this.jeKupac;
        data["jeDobavljac"] = this.jeDobavljac;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined;
        data["valutaPoslovanjaId"] = this.valutaPoslovanjaId;
        data["valutaPoslovanjaTekst"] = this.valutaPoslovanjaTekst;
        data["gln"] = this.gln;
        return data;
    }
}

export interface IUpdateFizickoLiceCommand {
    ime?: string | undefined;
    prezime?: string | undefined;
    jmbg?: string | undefined;
    mobilniTelefon?: string | undefined;
    pol?: PolFizickogLica;
    datumRodjenja?: Date | undefined;
    id?: number | undefined;
    naziv?: string | undefined;
    kupac?: string | undefined;
    dobavljac?: string | undefined;
    napomena?: string | undefined;
    tipStranke?: TipStranke;
    adresa?: AdresaDto | undefined;
    rokPlacanjaZaUlazne?: number;
    rokPlacanjaZaIzlazne?: number;
    tekuciRacuniDto?: TekuciRacunDto[] | undefined;
    kontaktiDto?: KontaktDto[] | undefined;
    uSistemuPDVa?: boolean | undefined;
    jeKupac?: boolean;
    jeDobavljac?: boolean;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    valutaPoslovanjaId?: string | undefined;
    valutaPoslovanjaTekst?: string | undefined;
    gln?: string | undefined;
}

export class ResultOfStanDto extends Result implements IResultOfStanDto {
    data?: StanDto | undefined;

    constructor(data?: IResultOfStanDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? StanDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfStanDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfStanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfStanDto extends IResult {
    data?: StanDto | undefined;
}

export class StanDto implements IStanDto {
    id?: number | undefined;
    sifraProstora?: string | undefined;
    grejnaPovrsina?: number;
    brojClanova?: number;
    brojStana?: number;

    constructor(data?: IStanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifraProstora = _data["sifraProstora"];
            this.grejnaPovrsina = _data["grejnaPovrsina"];
            this.brojClanova = _data["brojClanova"];
            this.brojStana = _data["brojStana"];
        }
    }

    static fromJS(data: any): StanDto {
        data = typeof data === 'object' ? data : {};
        let result = new StanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifraProstora"] = this.sifraProstora;
        data["grejnaPovrsina"] = this.grejnaPovrsina;
        data["brojClanova"] = this.brojClanova;
        data["brojStana"] = this.brojStana;
        return data;
    }
}

export interface IStanDto {
    id?: number | undefined;
    sifraProstora?: string | undefined;
    grejnaPovrsina?: number;
    brojClanova?: number;
    brojStana?: number;
}

export class ResultOfListOfListItemDtoOfLong extends Result implements IResultOfListOfListItemDtoOfLong {
    data?: ListItemDtoOfLong[] | undefined;

    constructor(data?: IResultOfListOfListItemDtoOfLong) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ListItemDtoOfLong.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfListItemDtoOfLong {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfListItemDtoOfLong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfListItemDtoOfLong extends IResult {
    data?: ListItemDtoOfLong[] | undefined;
}

export class CreateStanCommand implements ICreateStanCommand {
    fizickoLiceId?: number;
    stan?: StanDto | undefined;

    constructor(data?: ICreateStanCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fizickoLiceId = _data["fizickoLiceId"];
            this.stan = _data["stan"] ? StanDto.fromJS(_data["stan"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateStanCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStanCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fizickoLiceId"] = this.fizickoLiceId;
        data["stan"] = this.stan ? this.stan.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateStanCommand {
    fizickoLiceId?: number;
    stan?: StanDto | undefined;
}

export class UpdateStanCommand implements IUpdateStanCommand {
    fizickoLiceId?: number;
    stan?: StanDto | undefined;

    constructor(data?: IUpdateStanCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fizickoLiceId = _data["fizickoLiceId"];
            this.stan = _data["stan"] ? StanDto.fromJS(_data["stan"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateStanCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStanCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fizickoLiceId"] = this.fizickoLiceId;
        data["stan"] = this.stan ? this.stan.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateStanCommand {
    fizickoLiceId?: number;
    stan?: StanDto | undefined;
}

export class InitVm implements IInitVm {
    racunDto?: RacunDto | undefined;
    tipPristupa?: TipPristupa;
    predmetStavkeDto?: PredmetStavkeDto | undefined;
    basicNotification?: BasicNotification | undefined;
    jobNotification?: JobNotification | undefined;
    sefHealthNotification?: SefHealthNotification | undefined;
    sessionTokenNotification?: SessionTokenNotification | undefined;
    statsChangedNotification?: StatsChangedNotification | undefined;
    notificationMessageType?: NotificationMessageType;
    jobBegginingEndingNotification?: JobBegginingEndingNotification | undefined;
    vrstaJoba?: VrstaJoba;
    fizickaLokacijaDto?: FizickaLokacijaDto | undefined;
    esdcCardStatusChangeNotification?: EsdcCardStatusChangeNotification | undefined;
    arhivskaPdfRequestDto?: ArhivskaPdfRequestDto | undefined;
    xml?: XmlRacuna;

    constructor(data?: IInitVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.tipPristupa = _data["tipPristupa"];
            this.predmetStavkeDto = _data["predmetStavkeDto"] ? PredmetStavkeDto.fromJS(_data["predmetStavkeDto"]) : <any>undefined;
            this.basicNotification = _data["basicNotification"] ? BasicNotification.fromJS(_data["basicNotification"]) : <any>undefined;
            this.jobNotification = _data["jobNotification"] ? JobNotification.fromJS(_data["jobNotification"]) : <any>undefined;
            this.sefHealthNotification = _data["sefHealthNotification"] ? SefHealthNotification.fromJS(_data["sefHealthNotification"]) : <any>undefined;
            this.sessionTokenNotification = _data["sessionTokenNotification"] ? SessionTokenNotification.fromJS(_data["sessionTokenNotification"]) : <any>undefined;
            this.statsChangedNotification = _data["statsChangedNotification"] ? StatsChangedNotification.fromJS(_data["statsChangedNotification"]) : <any>undefined;
            this.notificationMessageType = _data["notificationMessageType"];
            this.jobBegginingEndingNotification = _data["jobBegginingEndingNotification"] ? JobBegginingEndingNotification.fromJS(_data["jobBegginingEndingNotification"]) : <any>undefined;
            this.vrstaJoba = _data["vrstaJoba"];
            this.fizickaLokacijaDto = _data["fizickaLokacijaDto"] ? FizickaLokacijaDto.fromJS(_data["fizickaLokacijaDto"]) : <any>undefined;
            this.esdcCardStatusChangeNotification = _data["esdcCardStatusChangeNotification"] ? EsdcCardStatusChangeNotification.fromJS(_data["esdcCardStatusChangeNotification"]) : <any>undefined;
            this.arhivskaPdfRequestDto = _data["arhivskaPdfRequestDto"] ? ArhivskaPdfRequestDto.fromJS(_data["arhivskaPdfRequestDto"]) : <any>undefined;
            this.xml = _data["xml"];
        }
    }

    static fromJS(data: any): InitVm {
        data = typeof data === 'object' ? data : {};
        let result = new InitVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["tipPristupa"] = this.tipPristupa;
        data["predmetStavkeDto"] = this.predmetStavkeDto ? this.predmetStavkeDto.toJSON() : <any>undefined;
        data["basicNotification"] = this.basicNotification ? this.basicNotification.toJSON() : <any>undefined;
        data["jobNotification"] = this.jobNotification ? this.jobNotification.toJSON() : <any>undefined;
        data["sefHealthNotification"] = this.sefHealthNotification ? this.sefHealthNotification.toJSON() : <any>undefined;
        data["sessionTokenNotification"] = this.sessionTokenNotification ? this.sessionTokenNotification.toJSON() : <any>undefined;
        data["statsChangedNotification"] = this.statsChangedNotification ? this.statsChangedNotification.toJSON() : <any>undefined;
        data["notificationMessageType"] = this.notificationMessageType;
        data["jobBegginingEndingNotification"] = this.jobBegginingEndingNotification ? this.jobBegginingEndingNotification.toJSON() : <any>undefined;
        data["vrstaJoba"] = this.vrstaJoba;
        data["fizickaLokacijaDto"] = this.fizickaLokacijaDto ? this.fizickaLokacijaDto.toJSON() : <any>undefined;
        data["esdcCardStatusChangeNotification"] = this.esdcCardStatusChangeNotification ? this.esdcCardStatusChangeNotification.toJSON() : <any>undefined;
        data["arhivskaPdfRequestDto"] = this.arhivskaPdfRequestDto ? this.arhivskaPdfRequestDto.toJSON() : <any>undefined;
        data["xml"] = this.xml;
        return data;
    }
}

export interface IInitVm {
    racunDto?: RacunDto | undefined;
    tipPristupa?: TipPristupa;
    predmetStavkeDto?: PredmetStavkeDto | undefined;
    basicNotification?: BasicNotification | undefined;
    jobNotification?: JobNotification | undefined;
    sefHealthNotification?: SefHealthNotification | undefined;
    sessionTokenNotification?: SessionTokenNotification | undefined;
    statsChangedNotification?: StatsChangedNotification | undefined;
    notificationMessageType?: NotificationMessageType;
    jobBegginingEndingNotification?: JobBegginingEndingNotification | undefined;
    vrstaJoba?: VrstaJoba;
    fizickaLokacijaDto?: FizickaLokacijaDto | undefined;
    esdcCardStatusChangeNotification?: EsdcCardStatusChangeNotification | undefined;
    arhivskaPdfRequestDto?: ArhivskaPdfRequestDto | undefined;
    xml?: XmlRacuna;
}

export enum TipPristupa {
    ALL = 0,
    IZLAZNA_FAKTURA_VIEW = 1,
    IZLAZNA_FAKTURA_CRUD = 2,
    AVANSNI_RACUN_VIEW = 3,
    AVANSNI_RACUN_CRUD = 4,
    IZMENA_OSNOVICE_VIEW = 5,
    IZMENA_OSNOVICE_CRUD = 6,
    KOMPENZACIJA_VIEW = 7,
    KOMPENZACIJA_CRUD = 8,
    ULAZNA_FAKTURA_VIEW = 9,
    ULAZNA_FAKTURA_CRUD = 10,
    PREDRACUN_VIEW = 11,
    PREDRACUN_CRUD = 12,
    OTPREMNICA_VIEW = 13,
    OTPREMNICA_CRUD = 14,
    RADNI_NALOG_VIEW = 15,
    RADNI_NALOG_CRUD = 16,
    PDV_VIEW = 17,
    PDV_CRUD = 18,
    IZVOD_CRUD = 19,
    MAGACIN_CRUD = 20,
    STRANKA_CRUD = 21,
    VOZILO_CRUD = 22,
    CENOVNIK_CRUD = 23,
    ADMIN_CRUD = 24,
    IZVESTAJ_VIEW = 25,
    FISKALNI_RACUN_VIEW = 26,
    FISKALNI_RACUN_CRUD = 27,
    ARHIVSKA_KNJIGA_VIEW = 28,
    ARHIVSKA_KNJIGA_CRUD = 29,
    ROBNI_PROMET_VIEW = 30,
    ROBNI_PROMET_CRUD = 31,
    DMS_VIEW = 32,
    DMS_CRUD = 33,
}

export class BasicNotification implements IBasicNotification {
    messageType?: NotificationMessageType;
    message?: string | undefined;
    label?: LabelType;
    iconName?: string | undefined;
    iconColor?: string | undefined;
    actionUrl?: string | undefined;
    id?: string | undefined;

    constructor(data?: IBasicNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageType = _data["messageType"];
            this.message = _data["message"];
            this.label = _data["label"];
            this.iconName = _data["iconName"];
            this.iconColor = _data["iconColor"];
            this.actionUrl = _data["actionUrl"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BasicNotification {
        data = typeof data === 'object' ? data : {};
        let result = new BasicNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageType"] = this.messageType;
        data["message"] = this.message;
        data["label"] = this.label;
        data["iconName"] = this.iconName;
        data["iconColor"] = this.iconColor;
        data["actionUrl"] = this.actionUrl;
        data["id"] = this.id;
        return data;
    }
}

export interface IBasicNotification {
    messageType?: NotificationMessageType;
    message?: string | undefined;
    label?: LabelType;
    iconName?: string | undefined;
    iconColor?: string | undefined;
    actionUrl?: string | undefined;
    id?: string | undefined;
}

export enum NotificationMessageType {
    BASIC = 0,
    STATUS_CHANGE = 1,
    JOB = 2,
    SEF_ACTIVITY = 3,
    SESSION_TOKEN_VALIDITY = 4,
    RATING = 5,
    JOB_BEGGINING_ENDING = 6,
    ESDC_CARD_STATUS_CHANGE = 7,
}

export enum LabelType {
    Information = 0,
    Success = 1,
    Warning = 2,
    Error = 3,
}

export class JobNotification implements IJobNotification {
    messageType?: NotificationMessageType;
    message?: string | undefined;
    vrstaJoba?: VrstaJoba;
    progress?: number;
    iconName?: string | undefined;
    iconColor?: string | undefined;
    actionUrl?: string | undefined;
    id?: string | undefined;
    label?: LabelType;

    constructor(data?: IJobNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageType = _data["messageType"];
            this.message = _data["message"];
            this.vrstaJoba = _data["vrstaJoba"];
            this.progress = _data["progress"];
            this.iconName = _data["iconName"];
            this.iconColor = _data["iconColor"];
            this.actionUrl = _data["actionUrl"];
            this.id = _data["id"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): JobNotification {
        data = typeof data === 'object' ? data : {};
        let result = new JobNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageType"] = this.messageType;
        data["message"] = this.message;
        data["vrstaJoba"] = this.vrstaJoba;
        data["progress"] = this.progress;
        data["iconName"] = this.iconName;
        data["iconColor"] = this.iconColor;
        data["actionUrl"] = this.actionUrl;
        data["id"] = this.id;
        data["label"] = this.label;
        return data;
    }
}

export interface IJobNotification {
    messageType?: NotificationMessageType;
    message?: string | undefined;
    vrstaJoba?: VrstaJoba;
    progress?: number;
    iconName?: string | undefined;
    iconColor?: string | undefined;
    actionUrl?: string | undefined;
    id?: string | undefined;
    label?: LabelType;
}

export enum VrstaJoba {
    EMPTY = 0,
    KREIRANJE_RACUNA = 1,
    SINHRONIZACIJA_ULAZNIH_RACUNA = 2,
    IMPORT_POCETNIH_STANJA = 3,
    IMPORT_SIFARNIKA = 4,
    IMPORT_IZVODA = 5,
    SINHRONIZACIJA_IZLAZNIH_RACUNA = 6,
    SINHRONIZACIJA_ULAZNIH_EOTPREMNICA = 7,
    MASOVNO_DUPLIRANJE_RACUNA = 8,
    MASOVNO_SLANJE_PREDRACUNA_EMAIL = 9,
}

export class SefHealthNotification implements ISefHealthNotification {
    messageType?: NotificationMessageType;
    actionUrl?: string | undefined;
    id?: string | undefined;
    iconName?: string | undefined;
    iconColor?: string | undefined;
    backgroundColor?: string | undefined;
    isActive?: boolean;

    constructor(data?: ISefHealthNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageType = _data["messageType"];
            this.actionUrl = _data["actionUrl"];
            this.id = _data["id"];
            this.iconName = _data["iconName"];
            this.iconColor = _data["iconColor"];
            this.backgroundColor = _data["backgroundColor"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SefHealthNotification {
        data = typeof data === 'object' ? data : {};
        let result = new SefHealthNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageType"] = this.messageType;
        data["actionUrl"] = this.actionUrl;
        data["id"] = this.id;
        data["iconName"] = this.iconName;
        data["iconColor"] = this.iconColor;
        data["backgroundColor"] = this.backgroundColor;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISefHealthNotification {
    messageType?: NotificationMessageType;
    actionUrl?: string | undefined;
    id?: string | undefined;
    iconName?: string | undefined;
    iconColor?: string | undefined;
    backgroundColor?: string | undefined;
    isActive?: boolean;
}

export class SessionTokenNotification implements ISessionTokenNotification {
    sessionId?: string | undefined;
    messageType?: NotificationMessageType;
    id?: string | undefined;
    iconName?: string | undefined;
    iconColor?: string | undefined;
    actionUrl?: string | undefined;

    constructor(data?: ISessionTokenNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.messageType = _data["messageType"];
            this.id = _data["id"];
            this.iconName = _data["iconName"];
            this.iconColor = _data["iconColor"];
            this.actionUrl = _data["actionUrl"];
        }
    }

    static fromJS(data: any): SessionTokenNotification {
        data = typeof data === 'object' ? data : {};
        let result = new SessionTokenNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["messageType"] = this.messageType;
        data["id"] = this.id;
        data["iconName"] = this.iconName;
        data["iconColor"] = this.iconColor;
        data["actionUrl"] = this.actionUrl;
        return data;
    }
}

export interface ISessionTokenNotification {
    sessionId?: string | undefined;
    messageType?: NotificationMessageType;
    id?: string | undefined;
    iconName?: string | undefined;
    iconColor?: string | undefined;
    actionUrl?: string | undefined;
}

export class StatsChangedNotification implements IStatsChangedNotification {
    messageType?: NotificationMessageType;
    title?: string | undefined;
    message?: string | undefined;
    actionUrl?: string | undefined;
    iconName?: string | undefined;
    iconColor?: string | undefined;
    backgroundColor?: string | undefined;
    id?: string | undefined;

    constructor(data?: IStatsChangedNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageType = _data["messageType"];
            this.title = _data["title"];
            this.message = _data["message"];
            this.actionUrl = _data["actionUrl"];
            this.iconName = _data["iconName"];
            this.iconColor = _data["iconColor"];
            this.backgroundColor = _data["backgroundColor"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StatsChangedNotification {
        data = typeof data === 'object' ? data : {};
        let result = new StatsChangedNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageType"] = this.messageType;
        data["title"] = this.title;
        data["message"] = this.message;
        data["actionUrl"] = this.actionUrl;
        data["iconName"] = this.iconName;
        data["iconColor"] = this.iconColor;
        data["backgroundColor"] = this.backgroundColor;
        data["id"] = this.id;
        return data;
    }
}

export interface IStatsChangedNotification {
    messageType?: NotificationMessageType;
    title?: string | undefined;
    message?: string | undefined;
    actionUrl?: string | undefined;
    iconName?: string | undefined;
    iconColor?: string | undefined;
    backgroundColor?: string | undefined;
    id?: string | undefined;
}

export class JobBegginingEndingNotification implements IJobBegginingEndingNotification {
    messageType?: NotificationMessageType;
    vrstaJoba?: VrstaJoba;
    jePocetak?: boolean;
    iconName?: string | undefined;
    iconColor?: string | undefined;
    actionUrl?: string | undefined;
    id?: string | undefined;

    constructor(data?: IJobBegginingEndingNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageType = _data["messageType"];
            this.vrstaJoba = _data["vrstaJoba"];
            this.jePocetak = _data["jePocetak"];
            this.iconName = _data["iconName"];
            this.iconColor = _data["iconColor"];
            this.actionUrl = _data["actionUrl"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): JobBegginingEndingNotification {
        data = typeof data === 'object' ? data : {};
        let result = new JobBegginingEndingNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageType"] = this.messageType;
        data["vrstaJoba"] = this.vrstaJoba;
        data["jePocetak"] = this.jePocetak;
        data["iconName"] = this.iconName;
        data["iconColor"] = this.iconColor;
        data["actionUrl"] = this.actionUrl;
        data["id"] = this.id;
        return data;
    }
}

export interface IJobBegginingEndingNotification {
    messageType?: NotificationMessageType;
    vrstaJoba?: VrstaJoba;
    jePocetak?: boolean;
    iconName?: string | undefined;
    iconColor?: string | undefined;
    actionUrl?: string | undefined;
    id?: string | undefined;
}

export class EsdcCardStatusChangeNotification implements IEsdcCardStatusChangeNotification {
    messageType?: NotificationMessageType;
    actionUrl?: string | undefined;
    id?: string | undefined;
    iconName?: string | undefined;
    iconColor?: string | undefined;
    backgroundColor?: string | undefined;
    cardStatus?: EsdcCardStatus;

    constructor(data?: IEsdcCardStatusChangeNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageType = _data["messageType"];
            this.actionUrl = _data["actionUrl"];
            this.id = _data["id"];
            this.iconName = _data["iconName"];
            this.iconColor = _data["iconColor"];
            this.backgroundColor = _data["backgroundColor"];
            this.cardStatus = _data["cardStatus"];
        }
    }

    static fromJS(data: any): EsdcCardStatusChangeNotification {
        data = typeof data === 'object' ? data : {};
        let result = new EsdcCardStatusChangeNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageType"] = this.messageType;
        data["actionUrl"] = this.actionUrl;
        data["id"] = this.id;
        data["iconName"] = this.iconName;
        data["iconColor"] = this.iconColor;
        data["backgroundColor"] = this.backgroundColor;
        data["cardStatus"] = this.cardStatus;
        return data;
    }
}

export interface IEsdcCardStatusChangeNotification {
    messageType?: NotificationMessageType;
    actionUrl?: string | undefined;
    id?: string | undefined;
    iconName?: string | undefined;
    iconColor?: string | undefined;
    backgroundColor?: string | undefined;
    cardStatus?: EsdcCardStatus;
}

export class ArhivskaPdfRequestDto implements IArhivskaPdfRequestDto {
    redniBrojOd?: number;
    redniBrojDo?: number;
    godinaDokumenta?: string | undefined;
    rokCuvanjaJedinica?: RokCuvanjaJedinica;
    redniBrojSortOrder?: number | undefined;

    constructor(data?: IArhivskaPdfRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redniBrojOd = _data["redniBrojOd"];
            this.redniBrojDo = _data["redniBrojDo"];
            this.godinaDokumenta = _data["godinaDokumenta"];
            this.rokCuvanjaJedinica = _data["rokCuvanjaJedinica"];
            this.redniBrojSortOrder = _data["redniBrojSortOrder"];
        }
    }

    static fromJS(data: any): ArhivskaPdfRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArhivskaPdfRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redniBrojOd"] = this.redniBrojOd;
        data["redniBrojDo"] = this.redniBrojDo;
        data["godinaDokumenta"] = this.godinaDokumenta;
        data["rokCuvanjaJedinica"] = this.rokCuvanjaJedinica;
        data["redniBrojSortOrder"] = this.redniBrojSortOrder;
        return data;
    }
}

export interface IArhivskaPdfRequestDto {
    redniBrojOd?: number;
    redniBrojDo?: number;
    godinaDokumenta?: string | undefined;
    rokCuvanjaJedinica?: RokCuvanjaJedinica;
    redniBrojSortOrder?: number | undefined;
}

export enum XmlRacuna {
    UBL = 0,
    ALTOVA = 1,
}

export class ResultOfGetMenuInitResponse extends Result implements IResultOfGetMenuInitResponse {
    data?: GetMenuInitResponse | undefined;

    constructor(data?: IResultOfGetMenuInitResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetMenuInitResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetMenuInitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetMenuInitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetMenuInitResponse extends IResult {
    data?: GetMenuInitResponse | undefined;
}

export class GetMenuInitResponse implements IGetMenuInitResponse {
    prikaziPonude?: boolean;
    pracenjeLageraZaEOtpremnice?: boolean;

    constructor(data?: IGetMenuInitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prikaziPonude = _data["prikaziPonude"];
            this.pracenjeLageraZaEOtpremnice = _data["pracenjeLageraZaEOtpremnice"];
        }
    }

    static fromJS(data: any): GetMenuInitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMenuInitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prikaziPonude"] = this.prikaziPonude;
        data["pracenjeLageraZaEOtpremnice"] = this.pracenjeLageraZaEOtpremnice;
        return data;
    }
}

export interface IGetMenuInitResponse {
    prikaziPonude?: boolean;
    pracenjeLageraZaEOtpremnice?: boolean;
}

export class CreateIzlaznaFakturaCommand implements ICreateIzlaznaFakturaCommand {
    brojFiskalnogIsecka?: string | undefined;
    racunDto?: RacunDto | undefined;
    informacijaIsporuke?: InformacijaIsporukeDto | undefined;
    vrstaFakture?: VrstaFakture;
    voziloId?: number | undefined;
    vozila?: VoziloDropdownDto[] | undefined;
    avansnaUplata?: AvansnaUplataRacunaTableDto | undefined;
    zavisniTroskoviStavkeDto?: ZavisniTrosakStavkaDto[] | undefined;
    eOtpremnice?: EOtpremnicaDropdownDto[] | undefined;
    ePrijemnice?: EOtpremnicaDropdownDto[] | undefined;

    constructor(data?: ICreateIzlaznaFakturaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brojFiskalnogIsecka = _data["brojFiskalnogIsecka"];
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.informacijaIsporuke = _data["informacijaIsporuke"] ? InformacijaIsporukeDto.fromJS(_data["informacijaIsporuke"]) : <any>undefined;
            this.vrstaFakture = _data["vrstaFakture"];
            this.voziloId = _data["voziloId"];
            if (Array.isArray(_data["vozila"])) {
                this.vozila = [] as any;
                for (let item of _data["vozila"])
                    this.vozila!.push(VoziloDropdownDto.fromJS(item));
            }
            this.avansnaUplata = _data["avansnaUplata"] ? AvansnaUplataRacunaTableDto.fromJS(_data["avansnaUplata"]) : <any>undefined;
            if (Array.isArray(_data["zavisniTroskoviStavkeDto"])) {
                this.zavisniTroskoviStavkeDto = [] as any;
                for (let item of _data["zavisniTroskoviStavkeDto"])
                    this.zavisniTroskoviStavkeDto!.push(ZavisniTrosakStavkaDto.fromJS(item));
            }
            if (Array.isArray(_data["eOtpremnice"])) {
                this.eOtpremnice = [] as any;
                for (let item of _data["eOtpremnice"])
                    this.eOtpremnice!.push(EOtpremnicaDropdownDto.fromJS(item));
            }
            if (Array.isArray(_data["ePrijemnice"])) {
                this.ePrijemnice = [] as any;
                for (let item of _data["ePrijemnice"])
                    this.ePrijemnice!.push(EOtpremnicaDropdownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateIzlaznaFakturaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIzlaznaFakturaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brojFiskalnogIsecka"] = this.brojFiskalnogIsecka;
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["informacijaIsporuke"] = this.informacijaIsporuke ? this.informacijaIsporuke.toJSON() : <any>undefined;
        data["vrstaFakture"] = this.vrstaFakture;
        data["voziloId"] = this.voziloId;
        if (Array.isArray(this.vozila)) {
            data["vozila"] = [];
            for (let item of this.vozila)
                data["vozila"].push(item.toJSON());
        }
        data["avansnaUplata"] = this.avansnaUplata ? this.avansnaUplata.toJSON() : <any>undefined;
        if (Array.isArray(this.zavisniTroskoviStavkeDto)) {
            data["zavisniTroskoviStavkeDto"] = [];
            for (let item of this.zavisniTroskoviStavkeDto)
                data["zavisniTroskoviStavkeDto"].push(item.toJSON());
        }
        if (Array.isArray(this.eOtpremnice)) {
            data["eOtpremnice"] = [];
            for (let item of this.eOtpremnice)
                data["eOtpremnice"].push(item.toJSON());
        }
        if (Array.isArray(this.ePrijemnice)) {
            data["ePrijemnice"] = [];
            for (let item of this.ePrijemnice)
                data["ePrijemnice"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateIzlaznaFakturaCommand {
    brojFiskalnogIsecka?: string | undefined;
    racunDto?: RacunDto | undefined;
    informacijaIsporuke?: InformacijaIsporukeDto | undefined;
    vrstaFakture?: VrstaFakture;
    voziloId?: number | undefined;
    vozila?: VoziloDropdownDto[] | undefined;
    avansnaUplata?: AvansnaUplataRacunaTableDto | undefined;
    zavisniTroskoviStavkeDto?: ZavisniTrosakStavkaDto[] | undefined;
    eOtpremnice?: EOtpremnicaDropdownDto[] | undefined;
    ePrijemnice?: EOtpremnicaDropdownDto[] | undefined;
}

export class VoziloDropdownDto implements IVoziloDropdownDto {
    predmetStavkeId?: number;
    registarskaOznaka?: string | undefined;

    constructor(data?: IVoziloDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.registarskaOznaka = _data["registarskaOznaka"];
        }
    }

    static fromJS(data: any): VoziloDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoziloDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["registarskaOznaka"] = this.registarskaOznaka;
        return data;
    }
}

export interface IVoziloDropdownDto {
    predmetStavkeId?: number;
    registarskaOznaka?: string | undefined;
}

export class ZavisniTrosakStavkaDto implements IZavisniTrosakStavkaDto {
    originalniBrojRacuna?: string | undefined;
    naziv?: string | undefined;
    iznosBezPdv?: number;
    iznosSaPdv?: number;

    constructor(data?: IZavisniTrosakStavkaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalniBrojRacuna = _data["originalniBrojRacuna"];
            this.naziv = _data["naziv"];
            this.iznosBezPdv = _data["iznosBezPdv"];
            this.iznosSaPdv = _data["iznosSaPdv"];
        }
    }

    static fromJS(data: any): ZavisniTrosakStavkaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZavisniTrosakStavkaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalniBrojRacuna"] = this.originalniBrojRacuna;
        data["naziv"] = this.naziv;
        data["iznosBezPdv"] = this.iznosBezPdv;
        data["iznosSaPdv"] = this.iznosSaPdv;
        return data;
    }
}

export interface IZavisniTrosakStavkaDto {
    originalniBrojRacuna?: string | undefined;
    naziv?: string | undefined;
    iznosBezPdv?: number;
    iznosSaPdv?: number;
}

export class UpdateIzlaznaFakturaCommand implements IUpdateIzlaznaFakturaCommand {
    brojFiskalnogIsecka?: string | undefined;
    racunDto?: RacunDto | undefined;
    informacijaIsporuke?: InformacijaIsporukeDto | undefined;
    vrstaFakture?: VrstaFakture;
    zavisniTroskoviStavkeDto?: ZavisniTrosakStavkaDto[] | undefined;
    voziloId?: number | undefined;
    vozila?: VoziloDropdownDto[] | undefined;
    avansnaUplata?: AvansnaUplataRacunaTableDto | undefined;
    eOtpremnice?: EOtpremnicaDropdownDto[] | undefined;
    ePrijemnice?: EOtpremnicaDropdownDto[] | undefined;

    constructor(data?: IUpdateIzlaznaFakturaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brojFiskalnogIsecka = _data["brojFiskalnogIsecka"];
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.informacijaIsporuke = _data["informacijaIsporuke"] ? InformacijaIsporukeDto.fromJS(_data["informacijaIsporuke"]) : <any>undefined;
            this.vrstaFakture = _data["vrstaFakture"];
            if (Array.isArray(_data["zavisniTroskoviStavkeDto"])) {
                this.zavisniTroskoviStavkeDto = [] as any;
                for (let item of _data["zavisniTroskoviStavkeDto"])
                    this.zavisniTroskoviStavkeDto!.push(ZavisniTrosakStavkaDto.fromJS(item));
            }
            this.voziloId = _data["voziloId"];
            if (Array.isArray(_data["vozila"])) {
                this.vozila = [] as any;
                for (let item of _data["vozila"])
                    this.vozila!.push(VoziloDropdownDto.fromJS(item));
            }
            this.avansnaUplata = _data["avansnaUplata"] ? AvansnaUplataRacunaTableDto.fromJS(_data["avansnaUplata"]) : <any>undefined;
            if (Array.isArray(_data["eOtpremnice"])) {
                this.eOtpremnice = [] as any;
                for (let item of _data["eOtpremnice"])
                    this.eOtpremnice!.push(EOtpremnicaDropdownDto.fromJS(item));
            }
            if (Array.isArray(_data["ePrijemnice"])) {
                this.ePrijemnice = [] as any;
                for (let item of _data["ePrijemnice"])
                    this.ePrijemnice!.push(EOtpremnicaDropdownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateIzlaznaFakturaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIzlaznaFakturaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brojFiskalnogIsecka"] = this.brojFiskalnogIsecka;
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["informacijaIsporuke"] = this.informacijaIsporuke ? this.informacijaIsporuke.toJSON() : <any>undefined;
        data["vrstaFakture"] = this.vrstaFakture;
        if (Array.isArray(this.zavisniTroskoviStavkeDto)) {
            data["zavisniTroskoviStavkeDto"] = [];
            for (let item of this.zavisniTroskoviStavkeDto)
                data["zavisniTroskoviStavkeDto"].push(item.toJSON());
        }
        data["voziloId"] = this.voziloId;
        if (Array.isArray(this.vozila)) {
            data["vozila"] = [];
            for (let item of this.vozila)
                data["vozila"].push(item.toJSON());
        }
        data["avansnaUplata"] = this.avansnaUplata ? this.avansnaUplata.toJSON() : <any>undefined;
        if (Array.isArray(this.eOtpremnice)) {
            data["eOtpremnice"] = [];
            for (let item of this.eOtpremnice)
                data["eOtpremnice"].push(item.toJSON());
        }
        if (Array.isArray(this.ePrijemnice)) {
            data["ePrijemnice"] = [];
            for (let item of this.ePrijemnice)
                data["ePrijemnice"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateIzlaznaFakturaCommand {
    brojFiskalnogIsecka?: string | undefined;
    racunDto?: RacunDto | undefined;
    informacijaIsporuke?: InformacijaIsporukeDto | undefined;
    vrstaFakture?: VrstaFakture;
    zavisniTroskoviStavkeDto?: ZavisniTrosakStavkaDto[] | undefined;
    voziloId?: number | undefined;
    vozila?: VoziloDropdownDto[] | undefined;
    avansnaUplata?: AvansnaUplataRacunaTableDto | undefined;
    eOtpremnice?: EOtpremnicaDropdownDto[] | undefined;
    ePrijemnice?: EOtpremnicaDropdownDto[] | undefined;
}

export class ResultOfIzlaznaFakturaDto extends Result implements IResultOfIzlaznaFakturaDto {
    data?: IzlaznaFakturaDto | undefined;

    constructor(data?: IResultOfIzlaznaFakturaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? IzlaznaFakturaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfIzlaznaFakturaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfIzlaznaFakturaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfIzlaznaFakturaDto extends IResult {
    data?: IzlaznaFakturaDto | undefined;
}

export class IzlaznaFakturaDto implements IIzlaznaFakturaDto {
    racunDto?: RacunDto | undefined;
    brojFiskalnogIsecka?: string | undefined;
    informacijaIsporuke?: InformacijaIsporukeDto | undefined;
    vrstaFakture?: VrstaFakture;
    vozila?: VoziloDropdownDto[] | undefined;
    avansnaUplata?: AvansnaUplataRacunaTableDto | undefined;
    zavisniTroskoviStavkeDto?: ZavisniTrosakStavkaDto[] | undefined;
    eOtpremnice?: EOtpremnicaDropdownDto[] | undefined;
    ePrijemnice?: EOtpremnicaDropdownDto[] | undefined;

    constructor(data?: IIzlaznaFakturaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.brojFiskalnogIsecka = _data["brojFiskalnogIsecka"];
            this.informacijaIsporuke = _data["informacijaIsporuke"] ? InformacijaIsporukeDto.fromJS(_data["informacijaIsporuke"]) : <any>undefined;
            this.vrstaFakture = _data["vrstaFakture"];
            if (Array.isArray(_data["vozila"])) {
                this.vozila = [] as any;
                for (let item of _data["vozila"])
                    this.vozila!.push(VoziloDropdownDto.fromJS(item));
            }
            this.avansnaUplata = _data["avansnaUplata"] ? AvansnaUplataRacunaTableDto.fromJS(_data["avansnaUplata"]) : <any>undefined;
            if (Array.isArray(_data["zavisniTroskoviStavkeDto"])) {
                this.zavisniTroskoviStavkeDto = [] as any;
                for (let item of _data["zavisniTroskoviStavkeDto"])
                    this.zavisniTroskoviStavkeDto!.push(ZavisniTrosakStavkaDto.fromJS(item));
            }
            if (Array.isArray(_data["eOtpremnice"])) {
                this.eOtpremnice = [] as any;
                for (let item of _data["eOtpremnice"])
                    this.eOtpremnice!.push(EOtpremnicaDropdownDto.fromJS(item));
            }
            if (Array.isArray(_data["ePrijemnice"])) {
                this.ePrijemnice = [] as any;
                for (let item of _data["ePrijemnice"])
                    this.ePrijemnice!.push(EOtpremnicaDropdownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IzlaznaFakturaDto {
        data = typeof data === 'object' ? data : {};
        let result = new IzlaznaFakturaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["brojFiskalnogIsecka"] = this.brojFiskalnogIsecka;
        data["informacijaIsporuke"] = this.informacijaIsporuke ? this.informacijaIsporuke.toJSON() : <any>undefined;
        data["vrstaFakture"] = this.vrstaFakture;
        if (Array.isArray(this.vozila)) {
            data["vozila"] = [];
            for (let item of this.vozila)
                data["vozila"].push(item.toJSON());
        }
        data["avansnaUplata"] = this.avansnaUplata ? this.avansnaUplata.toJSON() : <any>undefined;
        if (Array.isArray(this.zavisniTroskoviStavkeDto)) {
            data["zavisniTroskoviStavkeDto"] = [];
            for (let item of this.zavisniTroskoviStavkeDto)
                data["zavisniTroskoviStavkeDto"].push(item.toJSON());
        }
        if (Array.isArray(this.eOtpremnice)) {
            data["eOtpremnice"] = [];
            for (let item of this.eOtpremnice)
                data["eOtpremnice"].push(item.toJSON());
        }
        if (Array.isArray(this.ePrijemnice)) {
            data["ePrijemnice"] = [];
            for (let item of this.ePrijemnice)
                data["ePrijemnice"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIzlaznaFakturaDto {
    racunDto?: RacunDto | undefined;
    brojFiskalnogIsecka?: string | undefined;
    informacijaIsporuke?: InformacijaIsporukeDto | undefined;
    vrstaFakture?: VrstaFakture;
    vozila?: VoziloDropdownDto[] | undefined;
    avansnaUplata?: AvansnaUplataRacunaTableDto | undefined;
    zavisniTroskoviStavkeDto?: ZavisniTrosakStavkaDto[] | undefined;
    eOtpremnice?: EOtpremnicaDropdownDto[] | undefined;
    ePrijemnice?: EOtpremnicaDropdownDto[] | undefined;
}

export class GetIzlaznaFakturaQuery implements IGetIzlaznaFakturaQuery {
    id?: number;

    constructor(data?: IGetIzlaznaFakturaQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetIzlaznaFakturaQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetIzlaznaFakturaQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetIzlaznaFakturaQuery {
    id?: number;
}

export class GetNewIzlaznaFakturaForOtpremnicaQuery implements IGetNewIzlaznaFakturaForOtpremnicaQuery {
    otpremnicaIdArray?: number[] | undefined;

    constructor(data?: IGetNewIzlaznaFakturaForOtpremnicaQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["otpremnicaIdArray"])) {
                this.otpremnicaIdArray = [] as any;
                for (let item of _data["otpremnicaIdArray"])
                    this.otpremnicaIdArray!.push(item);
            }
        }
    }

    static fromJS(data: any): GetNewIzlaznaFakturaForOtpremnicaQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewIzlaznaFakturaForOtpremnicaQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.otpremnicaIdArray)) {
            data["otpremnicaIdArray"] = [];
            for (let item of this.otpremnicaIdArray)
                data["otpremnicaIdArray"].push(item);
        }
        return data;
    }
}

export interface IGetNewIzlaznaFakturaForOtpremnicaQuery {
    otpremnicaIdArray?: number[] | undefined;
}

export class ResultOfIzlaznaFakturForPrijemnicaDto extends Result implements IResultOfIzlaznaFakturForPrijemnicaDto {
    data?: IzlaznaFakturForPrijemnicaDto | undefined;

    constructor(data?: IResultOfIzlaznaFakturForPrijemnicaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? IzlaznaFakturForPrijemnicaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfIzlaznaFakturForPrijemnicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfIzlaznaFakturForPrijemnicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfIzlaznaFakturForPrijemnicaDto extends IResult {
    data?: IzlaznaFakturForPrijemnicaDto | undefined;
}

export class IzlaznaFakturForPrijemnicaDto implements IIzlaznaFakturForPrijemnicaDto {
    stavkeDto?: StavkaRacunaDto[] | undefined;
    strankaRacunaDto?: StrankaRacunaDto | undefined;
    ePrijemnice?: EOtpremnicaDropdownDto[] | undefined;

    constructor(data?: IIzlaznaFakturForPrijemnicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stavkeDto"])) {
                this.stavkeDto = [] as any;
                for (let item of _data["stavkeDto"])
                    this.stavkeDto!.push(StavkaRacunaDto.fromJS(item));
            }
            this.strankaRacunaDto = _data["strankaRacunaDto"] ? StrankaRacunaDto.fromJS(_data["strankaRacunaDto"]) : <any>undefined;
            if (Array.isArray(_data["ePrijemnice"])) {
                this.ePrijemnice = [] as any;
                for (let item of _data["ePrijemnice"])
                    this.ePrijemnice!.push(EOtpremnicaDropdownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IzlaznaFakturForPrijemnicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new IzlaznaFakturForPrijemnicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stavkeDto)) {
            data["stavkeDto"] = [];
            for (let item of this.stavkeDto)
                data["stavkeDto"].push(item.toJSON());
        }
        data["strankaRacunaDto"] = this.strankaRacunaDto ? this.strankaRacunaDto.toJSON() : <any>undefined;
        if (Array.isArray(this.ePrijemnice)) {
            data["ePrijemnice"] = [];
            for (let item of this.ePrijemnice)
                data["ePrijemnice"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIzlaznaFakturForPrijemnicaDto {
    stavkeDto?: StavkaRacunaDto[] | undefined;
    strankaRacunaDto?: StrankaRacunaDto | undefined;
    ePrijemnice?: EOtpremnicaDropdownDto[] | undefined;
}

export class GetNewIzlaznaFakturaForPrijemnicaQuery implements IGetNewIzlaznaFakturaForPrijemnicaQuery {
    prijemnicaIdArray?: number[] | undefined;

    constructor(data?: IGetNewIzlaznaFakturaForPrijemnicaQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["prijemnicaIdArray"])) {
                this.prijemnicaIdArray = [] as any;
                for (let item of _data["prijemnicaIdArray"])
                    this.prijemnicaIdArray!.push(item);
            }
        }
    }

    static fromJS(data: any): GetNewIzlaznaFakturaForPrijemnicaQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewIzlaznaFakturaForPrijemnicaQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prijemnicaIdArray)) {
            data["prijemnicaIdArray"] = [];
            for (let item of this.prijemnicaIdArray)
                data["prijemnicaIdArray"].push(item);
        }
        return data;
    }
}

export interface IGetNewIzlaznaFakturaForPrijemnicaQuery {
    prijemnicaIdArray?: number[] | undefined;
}

export class GetNewIzlaznaFakturaForUplataQuery implements IGetNewIzlaznaFakturaForUplataQuery {
    strankaId?: number | undefined;
    uplataId?: number;
    datumPrometa?: Date | undefined;
    datumIzdavanja?: Date | undefined;

    constructor(data?: IGetNewIzlaznaFakturaForUplataQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.strankaId = _data["strankaId"];
            this.uplataId = _data["uplataId"];
            this.datumPrometa = _data["datumPrometa"] ? new Date(_data["datumPrometa"].toString()) : <any>undefined;
            this.datumIzdavanja = _data["datumIzdavanja"] ? new Date(_data["datumIzdavanja"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNewIzlaznaFakturaForUplataQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewIzlaznaFakturaForUplataQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["strankaId"] = this.strankaId;
        data["uplataId"] = this.uplataId;
        data["datumPrometa"] = this.datumPrometa ? this.datumPrometa.toISOString() : <any>undefined;
        data["datumIzdavanja"] = this.datumIzdavanja ? this.datumIzdavanja.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetNewIzlaznaFakturaForUplataQuery {
    strankaId?: number | undefined;
    uplataId?: number;
    datumPrometa?: Date | undefined;
    datumIzdavanja?: Date | undefined;
}

export class CreateIzlaznaFakturaForPredracunUplataCommand implements ICreateIzlaznaFakturaForPredracunUplataCommand {
    predracunList?: UplataIsplataZaRacunDto[] | undefined;
    transakcijaIzvodaId?: number;

    constructor(data?: ICreateIzlaznaFakturaForPredracunUplataCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["predracunList"])) {
                this.predracunList = [] as any;
                for (let item of _data["predracunList"])
                    this.predracunList!.push(UplataIsplataZaRacunDto.fromJS(item));
            }
            this.transakcijaIzvodaId = _data["transakcijaIzvodaId"];
        }
    }

    static fromJS(data: any): CreateIzlaznaFakturaForPredracunUplataCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIzlaznaFakturaForPredracunUplataCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.predracunList)) {
            data["predracunList"] = [];
            for (let item of this.predracunList)
                data["predracunList"].push(item.toJSON());
        }
        data["transakcijaIzvodaId"] = this.transakcijaIzvodaId;
        return data;
    }
}

export interface ICreateIzlaznaFakturaForPredracunUplataCommand {
    predracunList?: UplataIsplataZaRacunDto[] | undefined;
    transakcijaIzvodaId?: number;
}

export class CreateDokumentOPovecanjuCommand implements ICreateDokumentOPovecanjuCommand {
    racunDto?: RacunDto | undefined;
    prikazIzmenaOsnoviceDto?: PrikazIzmenaOsnoviceDto | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    brojReferentnogDokumenta?: string | undefined;

    constructor(data?: ICreateDokumentOPovecanjuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.prikazIzmenaOsnoviceDto = _data["prikazIzmenaOsnoviceDto"] ? PrikazIzmenaOsnoviceDto.fromJS(_data["prikazIzmenaOsnoviceDto"]) : <any>undefined;
            this.periodOd = _data["periodOd"] ? new Date(_data["periodOd"].toString()) : <any>undefined;
            this.periodDo = _data["periodDo"] ? new Date(_data["periodDo"].toString()) : <any>undefined;
            this.brojReferentnogDokumenta = _data["brojReferentnogDokumenta"];
        }
    }

    static fromJS(data: any): CreateDokumentOPovecanjuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDokumentOPovecanjuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["prikazIzmenaOsnoviceDto"] = this.prikazIzmenaOsnoviceDto ? this.prikazIzmenaOsnoviceDto.toJSON() : <any>undefined;
        data["periodOd"] = this.periodOd ? this.periodOd.toISOString() : <any>undefined;
        data["periodDo"] = this.periodDo ? this.periodDo.toISOString() : <any>undefined;
        data["brojReferentnogDokumenta"] = this.brojReferentnogDokumenta;
        return data;
    }
}

export interface ICreateDokumentOPovecanjuCommand {
    racunDto?: RacunDto | undefined;
    prikazIzmenaOsnoviceDto?: PrikazIzmenaOsnoviceDto | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    brojReferentnogDokumenta?: string | undefined;
}

export class UpdateDokumentOPovecanjuCommand implements IUpdateDokumentOPovecanjuCommand {
    racunDto?: RacunDto | undefined;
    prikazIzmenaOsnoviceDto?: PrikazIzmenaOsnoviceDto | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    brojReferentnogDokumenta?: string | undefined;

    constructor(data?: IUpdateDokumentOPovecanjuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.prikazIzmenaOsnoviceDto = _data["prikazIzmenaOsnoviceDto"] ? PrikazIzmenaOsnoviceDto.fromJS(_data["prikazIzmenaOsnoviceDto"]) : <any>undefined;
            this.periodOd = _data["periodOd"] ? new Date(_data["periodOd"].toString()) : <any>undefined;
            this.periodDo = _data["periodDo"] ? new Date(_data["periodDo"].toString()) : <any>undefined;
            this.brojReferentnogDokumenta = _data["brojReferentnogDokumenta"];
        }
    }

    static fromJS(data: any): UpdateDokumentOPovecanjuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDokumentOPovecanjuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["prikazIzmenaOsnoviceDto"] = this.prikazIzmenaOsnoviceDto ? this.prikazIzmenaOsnoviceDto.toJSON() : <any>undefined;
        data["periodOd"] = this.periodOd ? this.periodOd.toISOString() : <any>undefined;
        data["periodDo"] = this.periodDo ? this.periodDo.toISOString() : <any>undefined;
        data["brojReferentnogDokumenta"] = this.brojReferentnogDokumenta;
        return data;
    }
}

export interface IUpdateDokumentOPovecanjuCommand {
    racunDto?: RacunDto | undefined;
    prikazIzmenaOsnoviceDto?: PrikazIzmenaOsnoviceDto | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    brojReferentnogDokumenta?: string | undefined;
}

export class EvidentirajDokumentOPromeniCommand implements IEvidentirajDokumentOPromeniCommand {
    dokumentId?: number;
    tipRacuna?: TipRacuna;
    izvornaFakturaId?: number;

    constructor(data?: IEvidentirajDokumentOPromeniCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dokumentId = _data["dokumentId"];
            this.tipRacuna = _data["tipRacuna"];
            this.izvornaFakturaId = _data["izvornaFakturaId"];
        }
    }

    static fromJS(data: any): EvidentirajDokumentOPromeniCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EvidentirajDokumentOPromeniCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dokumentId"] = this.dokumentId;
        data["tipRacuna"] = this.tipRacuna;
        data["izvornaFakturaId"] = this.izvornaFakturaId;
        return data;
    }
}

export interface IEvidentirajDokumentOPromeniCommand {
    dokumentId?: number;
    tipRacuna?: TipRacuna;
    izvornaFakturaId?: number;
}

export class ResultOfDokumentOSmanjenjuDto extends Result implements IResultOfDokumentOSmanjenjuDto {
    data?: DokumentOSmanjenjuDto | undefined;

    constructor(data?: IResultOfDokumentOSmanjenjuDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? DokumentOSmanjenjuDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfDokumentOSmanjenjuDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfDokumentOSmanjenjuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfDokumentOSmanjenjuDto extends IResult {
    data?: DokumentOSmanjenjuDto | undefined;
}

export class DokumentOSmanjenjuDto implements IDokumentOSmanjenjuDto {
    racunDto?: RacunDto | undefined;
    prikazIzmenaOsnoviceDto?: PrikazIzmenaOsnoviceDto | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    jeReferencaNaAvansniRacun?: boolean | undefined;
    brojReferentnogDokumenta?: string | undefined;

    constructor(data?: IDokumentOSmanjenjuDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.prikazIzmenaOsnoviceDto = _data["prikazIzmenaOsnoviceDto"] ? PrikazIzmenaOsnoviceDto.fromJS(_data["prikazIzmenaOsnoviceDto"]) : <any>undefined;
            this.periodOd = _data["periodOd"] ? new Date(_data["periodOd"].toString()) : <any>undefined;
            this.periodDo = _data["periodDo"] ? new Date(_data["periodDo"].toString()) : <any>undefined;
            this.jeReferencaNaAvansniRacun = _data["jeReferencaNaAvansniRacun"];
            this.brojReferentnogDokumenta = _data["brojReferentnogDokumenta"];
        }
    }

    static fromJS(data: any): DokumentOSmanjenjuDto {
        data = typeof data === 'object' ? data : {};
        let result = new DokumentOSmanjenjuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["prikazIzmenaOsnoviceDto"] = this.prikazIzmenaOsnoviceDto ? this.prikazIzmenaOsnoviceDto.toJSON() : <any>undefined;
        data["periodOd"] = this.periodOd ? this.periodOd.toISOString() : <any>undefined;
        data["periodDo"] = this.periodDo ? this.periodDo.toISOString() : <any>undefined;
        data["jeReferencaNaAvansniRacun"] = this.jeReferencaNaAvansniRacun;
        data["brojReferentnogDokumenta"] = this.brojReferentnogDokumenta;
        return data;
    }
}

export interface IDokumentOSmanjenjuDto {
    racunDto?: RacunDto | undefined;
    prikazIzmenaOsnoviceDto?: PrikazIzmenaOsnoviceDto | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    jeReferencaNaAvansniRacun?: boolean | undefined;
    brojReferentnogDokumenta?: string | undefined;
}

export class GetDokumentOSmanjenjuQuery implements IGetDokumentOSmanjenjuQuery {
    id?: number;

    constructor(data?: IGetDokumentOSmanjenjuQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetDokumentOSmanjenjuQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetDokumentOSmanjenjuQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetDokumentOSmanjenjuQuery {
    id?: number;
}

export class ResultOfDokumentOPovecanjuDto extends Result implements IResultOfDokumentOPovecanjuDto {
    data?: DokumentOPovecanjuDto | undefined;

    constructor(data?: IResultOfDokumentOPovecanjuDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? DokumentOPovecanjuDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfDokumentOPovecanjuDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfDokumentOPovecanjuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfDokumentOPovecanjuDto extends IResult {
    data?: DokumentOPovecanjuDto | undefined;
}

export class DokumentOPovecanjuDto implements IDokumentOPovecanjuDto {
    racunDto?: RacunDto | undefined;
    prikazIzmenaOsnoviceDto?: PrikazIzmenaOsnoviceDto | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    brojReferentnogDokumenta?: string | undefined;
    relevantniDokumentListItemDtos?: FileAttachment[] | undefined;

    constructor(data?: IDokumentOPovecanjuDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.prikazIzmenaOsnoviceDto = _data["prikazIzmenaOsnoviceDto"] ? PrikazIzmenaOsnoviceDto.fromJS(_data["prikazIzmenaOsnoviceDto"]) : <any>undefined;
            this.periodOd = _data["periodOd"] ? new Date(_data["periodOd"].toString()) : <any>undefined;
            this.periodDo = _data["periodDo"] ? new Date(_data["periodDo"].toString()) : <any>undefined;
            this.brojReferentnogDokumenta = _data["brojReferentnogDokumenta"];
            if (Array.isArray(_data["relevantniDokumentListItemDtos"])) {
                this.relevantniDokumentListItemDtos = [] as any;
                for (let item of _data["relevantniDokumentListItemDtos"])
                    this.relevantniDokumentListItemDtos!.push(FileAttachment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DokumentOPovecanjuDto {
        data = typeof data === 'object' ? data : {};
        let result = new DokumentOPovecanjuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["prikazIzmenaOsnoviceDto"] = this.prikazIzmenaOsnoviceDto ? this.prikazIzmenaOsnoviceDto.toJSON() : <any>undefined;
        data["periodOd"] = this.periodOd ? this.periodOd.toISOString() : <any>undefined;
        data["periodDo"] = this.periodDo ? this.periodDo.toISOString() : <any>undefined;
        data["brojReferentnogDokumenta"] = this.brojReferentnogDokumenta;
        if (Array.isArray(this.relevantniDokumentListItemDtos)) {
            data["relevantniDokumentListItemDtos"] = [];
            for (let item of this.relevantniDokumentListItemDtos)
                data["relevantniDokumentListItemDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDokumentOPovecanjuDto {
    racunDto?: RacunDto | undefined;
    prikazIzmenaOsnoviceDto?: PrikazIzmenaOsnoviceDto | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    brojReferentnogDokumenta?: string | undefined;
    relevantniDokumentListItemDtos?: FileAttachment[] | undefined;
}

export class GetDokumentOPovecanjuQuery implements IGetDokumentOPovecanjuQuery {
    id?: number;

    constructor(data?: IGetDokumentOPovecanjuQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetDokumentOPovecanjuQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetDokumentOPovecanjuQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetDokumentOPovecanjuQuery {
    id?: number;
}

export class ResultOfGetKpoTableResponse extends Result implements IResultOfGetKpoTableResponse {
    data?: GetKpoTableResponse | undefined;

    constructor(data?: IResultOfGetKpoTableResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetKpoTableResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetKpoTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetKpoTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetKpoTableResponse extends IResult {
    data?: GetKpoTableResponse | undefined;
}

export class GetKpoTableResponse implements IGetKpoTableResponse {
    kpoIzlazniRacunDtoList?: KpoTableDto[] | undefined;

    constructor(data?: IGetKpoTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["kpoIzlazniRacunDtoList"])) {
                this.kpoIzlazniRacunDtoList = [] as any;
                for (let item of _data["kpoIzlazniRacunDtoList"])
                    this.kpoIzlazniRacunDtoList!.push(KpoTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetKpoTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetKpoTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.kpoIzlazniRacunDtoList)) {
            data["kpoIzlazniRacunDtoList"] = [];
            for (let item of this.kpoIzlazniRacunDtoList)
                data["kpoIzlazniRacunDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetKpoTableResponse {
    kpoIzlazniRacunDtoList?: KpoTableDto[] | undefined;
}

export class KpoTableDto implements IKpoTableDto {
    id?: number;
    datumKnjizenja?: string | undefined;
    brojFakture?: string | undefined;
    iznosRoba?: number;
    iznosUsluga?: number;
    ukupniPrihodi?: number;

    constructor(data?: IKpoTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.datumKnjizenja = _data["datumKnjizenja"];
            this.brojFakture = _data["brojFakture"];
            this.iznosRoba = _data["iznosRoba"];
            this.iznosUsluga = _data["iznosUsluga"];
            this.ukupniPrihodi = _data["ukupniPrihodi"];
        }
    }

    static fromJS(data: any): KpoTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new KpoTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["datumKnjizenja"] = this.datumKnjizenja;
        data["brojFakture"] = this.brojFakture;
        data["iznosRoba"] = this.iznosRoba;
        data["iznosUsluga"] = this.iznosUsluga;
        data["ukupniPrihodi"] = this.ukupniPrihodi;
        return data;
    }
}

export interface IKpoTableDto {
    id?: number;
    datumKnjizenja?: string | undefined;
    brojFakture?: string | undefined;
    iznosRoba?: number;
    iznosUsluga?: number;
    ukupniPrihodi?: number;
}

export class PaginatedResultOfIosRacunDto extends Result implements IPaginatedResultOfIosRacunDto {
    data?: IosRacunDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfIosRacunDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IosRacunDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfIosRacunDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfIosRacunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfIosRacunDto extends IResult {
    data?: IosRacunDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class IosRacunDto implements IIosRacunDto {
    id?: number;
    datumIzdavanja?: string | undefined;
    datumValute?: string | undefined;
    brojFakture?: string | undefined;
    duguje?: number;
    potrazuje?: number;
    uplaceno?: number;
    saldo?: number;
    vrstaRacuna?: VrstaRacuna;
    tipRacuna?: TipRacuna;
    rutiranjeStranke?: RutiranjeStrankeDto | undefined;

    constructor(data?: IIosRacunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.datumIzdavanja = _data["datumIzdavanja"];
            this.datumValute = _data["datumValute"];
            this.brojFakture = _data["brojFakture"];
            this.duguje = _data["duguje"];
            this.potrazuje = _data["potrazuje"];
            this.uplaceno = _data["uplaceno"];
            this.saldo = _data["saldo"];
            this.vrstaRacuna = _data["vrstaRacuna"];
            this.tipRacuna = _data["tipRacuna"];
            this.rutiranjeStranke = _data["rutiranjeStranke"] ? RutiranjeStrankeDto.fromJS(_data["rutiranjeStranke"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IosRacunDto {
        data = typeof data === 'object' ? data : {};
        let result = new IosRacunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["datumIzdavanja"] = this.datumIzdavanja;
        data["datumValute"] = this.datumValute;
        data["brojFakture"] = this.brojFakture;
        data["duguje"] = this.duguje;
        data["potrazuje"] = this.potrazuje;
        data["uplaceno"] = this.uplaceno;
        data["saldo"] = this.saldo;
        data["vrstaRacuna"] = this.vrstaRacuna;
        data["tipRacuna"] = this.tipRacuna;
        data["rutiranjeStranke"] = this.rutiranjeStranke ? this.rutiranjeStranke.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIosRacunDto {
    id?: number;
    datumIzdavanja?: string | undefined;
    datumValute?: string | undefined;
    brojFakture?: string | undefined;
    duguje?: number;
    potrazuje?: number;
    uplaceno?: number;
    saldo?: number;
    vrstaRacuna?: VrstaRacuna;
    tipRacuna?: TipRacuna;
    rutiranjeStranke?: RutiranjeStrankeDto | undefined;
}

export class GetIosTableQuery implements IGetIosTableQuery {
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetIosTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetIosTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetIosTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetIosTableQuery {
    pageNumber?: number;
    pageSize?: number;
}

export class ResultOfMaloprodajaIzvestajDto extends Result implements IResultOfMaloprodajaIzvestajDto {
    data?: MaloprodajaIzvestajDto | undefined;

    constructor(data?: IResultOfMaloprodajaIzvestajDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? MaloprodajaIzvestajDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfMaloprodajaIzvestajDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfMaloprodajaIzvestajDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfMaloprodajaIzvestajDto extends IResult {
    data?: MaloprodajaIzvestajDto | undefined;
}

export class MaloprodajaIzvestajDto implements IMaloprodajaIzvestajDto {
    nazivPoreskogObveznika?: string | undefined;
    pib?: string | undefined;
    adresaObjekta?: string | undefined;
    grad?: string | undefined;
    prometProdaja?: number;
    prometRefundacija?: number;
    prometUkupno?: number;
    avansProdaja?: number;
    avansRealizacija?: number;
    avansRefundacija?: number;
    avansUkupno?: number;
    ukupnoPorezZaPrometProdaju?: number;
    ukupnoPorezZaPrometRefundaciju?: number;
    saldoPorezaPromet?: number;
    ukupnoPorezZaAvansProdaju?: number;
    ukupnoPorezZaAvansRefundaciju?: number;
    saldoPorezaAvans?: number;
    prometPoNacinuPlacanja?: TabelePoNacinuPlacanjaDto[] | undefined;
    avansPoNacinuPlacanja?: TabelePoNacinuPlacanjaDto[] | undefined;
    stanjeBlagajne?: TabelePoNacinuPlacanjaDto[] | undefined;
    ukupnoPrometPoNacinuPlacanja?: number;
    ukupnoAvansPoNacinuPlacanja?: number;
    ukupnoStanjeBlagajne?: number;
    prometPoStopama?: PrometPoStopamaDto[] | undefined;
    ukupnoPorezPoStopama?: number;
    kusur?: number | undefined;
    brojPrometProdaja?: number;
    brojPrometRefundacija?: number;
    brojAvansProdaja?: number;
    brojAvansRefundacija?: number;

    constructor(data?: IMaloprodajaIzvestajDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nazivPoreskogObveznika = _data["nazivPoreskogObveznika"];
            this.pib = _data["pib"];
            this.adresaObjekta = _data["adresaObjekta"];
            this.grad = _data["grad"];
            this.prometProdaja = _data["prometProdaja"];
            this.prometRefundacija = _data["prometRefundacija"];
            this.prometUkupno = _data["prometUkupno"];
            this.avansProdaja = _data["avansProdaja"];
            this.avansRealizacija = _data["avansRealizacija"];
            this.avansRefundacija = _data["avansRefundacija"];
            this.avansUkupno = _data["avansUkupno"];
            this.ukupnoPorezZaPrometProdaju = _data["ukupnoPorezZaPrometProdaju"];
            this.ukupnoPorezZaPrometRefundaciju = _data["ukupnoPorezZaPrometRefundaciju"];
            this.saldoPorezaPromet = _data["saldoPorezaPromet"];
            this.ukupnoPorezZaAvansProdaju = _data["ukupnoPorezZaAvansProdaju"];
            this.ukupnoPorezZaAvansRefundaciju = _data["ukupnoPorezZaAvansRefundaciju"];
            this.saldoPorezaAvans = _data["saldoPorezaAvans"];
            if (Array.isArray(_data["prometPoNacinuPlacanja"])) {
                this.prometPoNacinuPlacanja = [] as any;
                for (let item of _data["prometPoNacinuPlacanja"])
                    this.prometPoNacinuPlacanja!.push(TabelePoNacinuPlacanjaDto.fromJS(item));
            }
            if (Array.isArray(_data["avansPoNacinuPlacanja"])) {
                this.avansPoNacinuPlacanja = [] as any;
                for (let item of _data["avansPoNacinuPlacanja"])
                    this.avansPoNacinuPlacanja!.push(TabelePoNacinuPlacanjaDto.fromJS(item));
            }
            if (Array.isArray(_data["stanjeBlagajne"])) {
                this.stanjeBlagajne = [] as any;
                for (let item of _data["stanjeBlagajne"])
                    this.stanjeBlagajne!.push(TabelePoNacinuPlacanjaDto.fromJS(item));
            }
            this.ukupnoPrometPoNacinuPlacanja = _data["ukupnoPrometPoNacinuPlacanja"];
            this.ukupnoAvansPoNacinuPlacanja = _data["ukupnoAvansPoNacinuPlacanja"];
            this.ukupnoStanjeBlagajne = _data["ukupnoStanjeBlagajne"];
            if (Array.isArray(_data["prometPoStopama"])) {
                this.prometPoStopama = [] as any;
                for (let item of _data["prometPoStopama"])
                    this.prometPoStopama!.push(PrometPoStopamaDto.fromJS(item));
            }
            this.ukupnoPorezPoStopama = _data["ukupnoPorezPoStopama"];
            this.kusur = _data["kusur"];
            this.brojPrometProdaja = _data["brojPrometProdaja"];
            this.brojPrometRefundacija = _data["brojPrometRefundacija"];
            this.brojAvansProdaja = _data["brojAvansProdaja"];
            this.brojAvansRefundacija = _data["brojAvansRefundacija"];
        }
    }

    static fromJS(data: any): MaloprodajaIzvestajDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaloprodajaIzvestajDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nazivPoreskogObveznika"] = this.nazivPoreskogObveznika;
        data["pib"] = this.pib;
        data["adresaObjekta"] = this.adresaObjekta;
        data["grad"] = this.grad;
        data["prometProdaja"] = this.prometProdaja;
        data["prometRefundacija"] = this.prometRefundacija;
        data["prometUkupno"] = this.prometUkupno;
        data["avansProdaja"] = this.avansProdaja;
        data["avansRealizacija"] = this.avansRealizacija;
        data["avansRefundacija"] = this.avansRefundacija;
        data["avansUkupno"] = this.avansUkupno;
        data["ukupnoPorezZaPrometProdaju"] = this.ukupnoPorezZaPrometProdaju;
        data["ukupnoPorezZaPrometRefundaciju"] = this.ukupnoPorezZaPrometRefundaciju;
        data["saldoPorezaPromet"] = this.saldoPorezaPromet;
        data["ukupnoPorezZaAvansProdaju"] = this.ukupnoPorezZaAvansProdaju;
        data["ukupnoPorezZaAvansRefundaciju"] = this.ukupnoPorezZaAvansRefundaciju;
        data["saldoPorezaAvans"] = this.saldoPorezaAvans;
        if (Array.isArray(this.prometPoNacinuPlacanja)) {
            data["prometPoNacinuPlacanja"] = [];
            for (let item of this.prometPoNacinuPlacanja)
                data["prometPoNacinuPlacanja"].push(item.toJSON());
        }
        if (Array.isArray(this.avansPoNacinuPlacanja)) {
            data["avansPoNacinuPlacanja"] = [];
            for (let item of this.avansPoNacinuPlacanja)
                data["avansPoNacinuPlacanja"].push(item.toJSON());
        }
        if (Array.isArray(this.stanjeBlagajne)) {
            data["stanjeBlagajne"] = [];
            for (let item of this.stanjeBlagajne)
                data["stanjeBlagajne"].push(item.toJSON());
        }
        data["ukupnoPrometPoNacinuPlacanja"] = this.ukupnoPrometPoNacinuPlacanja;
        data["ukupnoAvansPoNacinuPlacanja"] = this.ukupnoAvansPoNacinuPlacanja;
        data["ukupnoStanjeBlagajne"] = this.ukupnoStanjeBlagajne;
        if (Array.isArray(this.prometPoStopama)) {
            data["prometPoStopama"] = [];
            for (let item of this.prometPoStopama)
                data["prometPoStopama"].push(item.toJSON());
        }
        data["ukupnoPorezPoStopama"] = this.ukupnoPorezPoStopama;
        data["kusur"] = this.kusur;
        data["brojPrometProdaja"] = this.brojPrometProdaja;
        data["brojPrometRefundacija"] = this.brojPrometRefundacija;
        data["brojAvansProdaja"] = this.brojAvansProdaja;
        data["brojAvansRefundacija"] = this.brojAvansRefundacija;
        return data;
    }
}

export interface IMaloprodajaIzvestajDto {
    nazivPoreskogObveznika?: string | undefined;
    pib?: string | undefined;
    adresaObjekta?: string | undefined;
    grad?: string | undefined;
    prometProdaja?: number;
    prometRefundacija?: number;
    prometUkupno?: number;
    avansProdaja?: number;
    avansRealizacija?: number;
    avansRefundacija?: number;
    avansUkupno?: number;
    ukupnoPorezZaPrometProdaju?: number;
    ukupnoPorezZaPrometRefundaciju?: number;
    saldoPorezaPromet?: number;
    ukupnoPorezZaAvansProdaju?: number;
    ukupnoPorezZaAvansRefundaciju?: number;
    saldoPorezaAvans?: number;
    prometPoNacinuPlacanja?: TabelePoNacinuPlacanjaDto[] | undefined;
    avansPoNacinuPlacanja?: TabelePoNacinuPlacanjaDto[] | undefined;
    stanjeBlagajne?: TabelePoNacinuPlacanjaDto[] | undefined;
    ukupnoPrometPoNacinuPlacanja?: number;
    ukupnoAvansPoNacinuPlacanja?: number;
    ukupnoStanjeBlagajne?: number;
    prometPoStopama?: PrometPoStopamaDto[] | undefined;
    ukupnoPorezPoStopama?: number;
    kusur?: number | undefined;
    brojPrometProdaja?: number;
    brojPrometRefundacija?: number;
    brojAvansProdaja?: number;
    brojAvansRefundacija?: number;
}

export class TabelePoNacinuPlacanjaDto implements ITabelePoNacinuPlacanjaDto {
    tipPlacanja?: string | undefined;
    prodaja?: number;
    refundacija?: number;
    ukupno?: number;

    constructor(data?: ITabelePoNacinuPlacanjaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipPlacanja = _data["tipPlacanja"];
            this.prodaja = _data["prodaja"];
            this.refundacija = _data["refundacija"];
            this.ukupno = _data["ukupno"];
        }
    }

    static fromJS(data: any): TabelePoNacinuPlacanjaDto {
        data = typeof data === 'object' ? data : {};
        let result = new TabelePoNacinuPlacanjaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipPlacanja"] = this.tipPlacanja;
        data["prodaja"] = this.prodaja;
        data["refundacija"] = this.refundacija;
        data["ukupno"] = this.ukupno;
        return data;
    }
}

export interface ITabelePoNacinuPlacanjaDto {
    tipPlacanja?: string | undefined;
    prodaja?: number;
    refundacija?: number;
    ukupno?: number;
}

export class PrometPoStopamaDto implements IPrometPoStopamaDto {
    oznaka?: string | undefined;
    ime?: string | undefined;
    stopa?: number;
    porez?: number;

    constructor(data?: IPrometPoStopamaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oznaka = _data["oznaka"];
            this.ime = _data["ime"];
            this.stopa = _data["stopa"];
            this.porez = _data["porez"];
        }
    }

    static fromJS(data: any): PrometPoStopamaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrometPoStopamaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oznaka"] = this.oznaka;
        data["ime"] = this.ime;
        data["stopa"] = this.stopa;
        data["porez"] = this.porez;
        return data;
    }
}

export interface IPrometPoStopamaDto {
    oznaka?: string | undefined;
    ime?: string | undefined;
    stopa?: number;
    porez?: number;
}

export class GetDnevniIzvestajMaloprodajaQuery implements IGetDnevniIzvestajMaloprodajaQuery {
    filteri?: DnevniIzvestajMaloprodajaFilter | undefined;

    constructor(data?: IGetDnevniIzvestajMaloprodajaQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filteri = _data["filteri"] ? DnevniIzvestajMaloprodajaFilter.fromJS(_data["filteri"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDnevniIzvestajMaloprodajaQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetDnevniIzvestajMaloprodajaQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filteri"] = this.filteri ? this.filteri.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDnevniIzvestajMaloprodajaQuery {
    filteri?: DnevniIzvestajMaloprodajaFilter | undefined;
}

export class DnevniIzvestajMaloprodajaFilter implements IDnevniIzvestajMaloprodajaFilter {
    datum?: Date | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    kasirId?: string | undefined;
    jeOnlineProdaja?: boolean;

    constructor(data?: IDnevniIzvestajMaloprodajaFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.kasirId = _data["kasirId"];
            this.jeOnlineProdaja = _data["jeOnlineProdaja"];
        }
    }

    static fromJS(data: any): DnevniIzvestajMaloprodajaFilter {
        data = typeof data === 'object' ? data : {};
        let result = new DnevniIzvestajMaloprodajaFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["kasirId"] = this.kasirId;
        data["jeOnlineProdaja"] = this.jeOnlineProdaja;
        return data;
    }
}

export interface IDnevniIzvestajMaloprodajaFilter {
    datum?: Date | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    kasirId?: string | undefined;
    jeOnlineProdaja?: boolean;
}

export class ResultOfListOfIzvestajPoArtiklimaTableDto extends Result implements IResultOfListOfIzvestajPoArtiklimaTableDto {
    data?: IzvestajPoArtiklimaTableDto[] | undefined;

    constructor(data?: IResultOfListOfIzvestajPoArtiklimaTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IzvestajPoArtiklimaTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfIzvestajPoArtiklimaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfIzvestajPoArtiklimaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfIzvestajPoArtiklimaTableDto extends IResult {
    data?: IzvestajPoArtiklimaTableDto[] | undefined;
}

export class IzvestajPoArtiklimaTableDto implements IIzvestajPoArtiklimaTableDto {
    sifra?: string | undefined;
    imeArtikla?: string | undefined;
    cena?: number;
    kolicina?: number;
    ukupno?: number;

    constructor(data?: IIzvestajPoArtiklimaTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.imeArtikla = _data["imeArtikla"];
            this.cena = _data["cena"];
            this.kolicina = _data["kolicina"];
            this.ukupno = _data["ukupno"];
        }
    }

    static fromJS(data: any): IzvestajPoArtiklimaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new IzvestajPoArtiklimaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["imeArtikla"] = this.imeArtikla;
        data["cena"] = this.cena;
        data["kolicina"] = this.kolicina;
        data["ukupno"] = this.ukupno;
        return data;
    }
}

export interface IIzvestajPoArtiklimaTableDto {
    sifra?: string | undefined;
    imeArtikla?: string | undefined;
    cena?: number;
    kolicina?: number;
    ukupno?: number;
}

export class GetIzvestajPoArtiklimaMaloprodajaQuery implements IGetIzvestajPoArtiklimaMaloprodajaQuery {
    filteri?: DnevniIzvestajMaloprodajaFilter | undefined;

    constructor(data?: IGetIzvestajPoArtiklimaMaloprodajaQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filteri = _data["filteri"] ? DnevniIzvestajMaloprodajaFilter.fromJS(_data["filteri"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetIzvestajPoArtiklimaMaloprodajaQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetIzvestajPoArtiklimaMaloprodajaQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filteri"] = this.filteri ? this.filteri.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetIzvestajPoArtiklimaMaloprodajaQuery {
    filteri?: DnevniIzvestajMaloprodajaFilter | undefined;
}

export class ResultOfListOfIzvestajIzlaznihDokumenataDto extends Result implements IResultOfListOfIzvestajIzlaznihDokumenataDto {
    data?: IzvestajIzlaznihDokumenataDto[] | undefined;

    constructor(data?: IResultOfListOfIzvestajIzlaznihDokumenataDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IzvestajIzlaznihDokumenataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfIzvestajIzlaznihDokumenataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfIzvestajIzlaznihDokumenataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfIzvestajIzlaznihDokumenataDto extends IResult {
    data?: IzvestajIzlaznihDokumenataDto[] | undefined;
}

export class IzvestajIzlaznihDokumenataDto implements IIzvestajIzlaznihDokumenataDto {
    nazivGrupacije?: string | undefined;
    izlazniDokumentiIzvestajDto?: IzlazniDokumentiIzvestajDto[] | undefined;
    ukupnoKolicina?: number;
    ukupnoVrednostRobe?: number;
    ukupnoRabat?: number;
    ukupnoPdv?: number;
    ukupnoFakturisanaVrednost?: number;

    constructor(data?: IIzvestajIzlaznihDokumenataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nazivGrupacije = _data["nazivGrupacije"];
            if (Array.isArray(_data["izlazniDokumentiIzvestajDto"])) {
                this.izlazniDokumentiIzvestajDto = [] as any;
                for (let item of _data["izlazniDokumentiIzvestajDto"])
                    this.izlazniDokumentiIzvestajDto!.push(IzlazniDokumentiIzvestajDto.fromJS(item));
            }
            this.ukupnoKolicina = _data["ukupnoKolicina"];
            this.ukupnoVrednostRobe = _data["ukupnoVrednostRobe"];
            this.ukupnoRabat = _data["ukupnoRabat"];
            this.ukupnoPdv = _data["ukupnoPdv"];
            this.ukupnoFakturisanaVrednost = _data["ukupnoFakturisanaVrednost"];
        }
    }

    static fromJS(data: any): IzvestajIzlaznihDokumenataDto {
        data = typeof data === 'object' ? data : {};
        let result = new IzvestajIzlaznihDokumenataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nazivGrupacije"] = this.nazivGrupacije;
        if (Array.isArray(this.izlazniDokumentiIzvestajDto)) {
            data["izlazniDokumentiIzvestajDto"] = [];
            for (let item of this.izlazniDokumentiIzvestajDto)
                data["izlazniDokumentiIzvestajDto"].push(item.toJSON());
        }
        data["ukupnoKolicina"] = this.ukupnoKolicina;
        data["ukupnoVrednostRobe"] = this.ukupnoVrednostRobe;
        data["ukupnoRabat"] = this.ukupnoRabat;
        data["ukupnoPdv"] = this.ukupnoPdv;
        data["ukupnoFakturisanaVrednost"] = this.ukupnoFakturisanaVrednost;
        return data;
    }
}

export interface IIzvestajIzlaznihDokumenataDto {
    nazivGrupacije?: string | undefined;
    izlazniDokumentiIzvestajDto?: IzlazniDokumentiIzvestajDto[] | undefined;
    ukupnoKolicina?: number;
    ukupnoVrednostRobe?: number;
    ukupnoRabat?: number;
    ukupnoPdv?: number;
    ukupnoFakturisanaVrednost?: number;
}

export class IzlazniDokumentiIzvestajDto implements IIzlazniDokumentiIzvestajDto {
    broj?: string | undefined;
    nazivPodgrupacije?: string | undefined;
    datum?: Date;
    jedinicaMere?: string | undefined;
    kolicina?: number;
    cena?: number;
    vrednostRobe?: number;
    rabat?: number;
    pdv?: number;
    fakturisanaVrednost?: number;

    constructor(data?: IIzlazniDokumentiIzvestajDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.broj = _data["broj"];
            this.nazivPodgrupacije = _data["nazivPodgrupacije"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.jedinicaMere = _data["jedinicaMere"];
            this.kolicina = _data["kolicina"];
            this.cena = _data["cena"];
            this.vrednostRobe = _data["vrednostRobe"];
            this.rabat = _data["rabat"];
            this.pdv = _data["pdv"];
            this.fakturisanaVrednost = _data["fakturisanaVrednost"];
        }
    }

    static fromJS(data: any): IzlazniDokumentiIzvestajDto {
        data = typeof data === 'object' ? data : {};
        let result = new IzlazniDokumentiIzvestajDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["broj"] = this.broj;
        data["nazivPodgrupacije"] = this.nazivPodgrupacije;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["jedinicaMere"] = this.jedinicaMere;
        data["kolicina"] = this.kolicina;
        data["cena"] = this.cena;
        data["vrednostRobe"] = this.vrednostRobe;
        data["rabat"] = this.rabat;
        data["pdv"] = this.pdv;
        data["fakturisanaVrednost"] = this.fakturisanaVrednost;
        return data;
    }
}

export interface IIzlazniDokumentiIzvestajDto {
    broj?: string | undefined;
    nazivPodgrupacije?: string | undefined;
    datum?: Date;
    jedinicaMere?: string | undefined;
    kolicina?: number;
    cena?: number;
    vrednostRobe?: number;
    rabat?: number;
    pdv?: number;
    fakturisanaVrednost?: number;
}

export class GetIzvestajIzlaznihDokumenataQuery implements IGetIzvestajIzlaznihDokumenataQuery {
    filteri?: IzvestajIzlaznihDokumenataFilter | undefined;

    constructor(data?: IGetIzvestajIzlaznihDokumenataQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filteri = _data["filteri"] ? IzvestajIzlaznihDokumenataFilter.fromJS(_data["filteri"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetIzvestajIzlaznihDokumenataQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetIzvestajIzlaznihDokumenataQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filteri"] = this.filteri ? this.filteri.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetIzvestajIzlaznihDokumenataQuery {
    filteri?: IzvestajIzlaznihDokumenataFilter | undefined;
}

export class IzvestajIzlaznihDokumenataFilter implements IIzvestajIzlaznihDokumenataFilter {
    datumOd?: Date;
    datumDo?: Date;
    tipIzvestajaVeleprodaja?: TipIzvestajaVeleprodaja;
    podtipIzvestajaVeleprodaja?: PodtipIzvestajaVeleprodaja | undefined;
    stranke?: StrankaMultiSelectItem[] | undefined;
    magacini?: MagacinMultiSelectItem[] | undefined;

    constructor(data?: IIzvestajIzlaznihDokumenataFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.tipIzvestajaVeleprodaja = _data["tipIzvestajaVeleprodaja"];
            this.podtipIzvestajaVeleprodaja = _data["podtipIzvestajaVeleprodaja"];
            if (Array.isArray(_data["stranke"])) {
                this.stranke = [] as any;
                for (let item of _data["stranke"])
                    this.stranke!.push(StrankaMultiSelectItem.fromJS(item));
            }
            if (Array.isArray(_data["magacini"])) {
                this.magacini = [] as any;
                for (let item of _data["magacini"])
                    this.magacini!.push(MagacinMultiSelectItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IzvestajIzlaznihDokumenataFilter {
        data = typeof data === 'object' ? data : {};
        let result = new IzvestajIzlaznihDokumenataFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["tipIzvestajaVeleprodaja"] = this.tipIzvestajaVeleprodaja;
        data["podtipIzvestajaVeleprodaja"] = this.podtipIzvestajaVeleprodaja;
        if (Array.isArray(this.stranke)) {
            data["stranke"] = [];
            for (let item of this.stranke)
                data["stranke"].push(item.toJSON());
        }
        if (Array.isArray(this.magacini)) {
            data["magacini"] = [];
            for (let item of this.magacini)
                data["magacini"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIzvestajIzlaznihDokumenataFilter {
    datumOd?: Date;
    datumDo?: Date;
    tipIzvestajaVeleprodaja?: TipIzvestajaVeleprodaja;
    podtipIzvestajaVeleprodaja?: PodtipIzvestajaVeleprodaja | undefined;
    stranke?: StrankaMultiSelectItem[] | undefined;
    magacini?: MagacinMultiSelectItem[] | undefined;
}

export enum TipIzvestajaVeleprodaja {
    PO_ARTIKLIMA = 0,
    PO_PARTNERIMA = 1,
}

export enum PodtipIzvestajaVeleprodaja {
    KOMPLETAN = 0,
    SUMIRAN = 1,
}

export class StrankaMultiSelectItem implements IStrankaMultiSelectItem {
    id?: number;
    naziv?: string | undefined;
    pib?: string | undefined;

    constructor(data?: IStrankaMultiSelectItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.pib = _data["pib"];
        }
    }

    static fromJS(data: any): StrankaMultiSelectItem {
        data = typeof data === 'object' ? data : {};
        let result = new StrankaMultiSelectItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["pib"] = this.pib;
        return data;
    }
}

export interface IStrankaMultiSelectItem {
    id?: number;
    naziv?: string | undefined;
    pib?: string | undefined;
}

export class MagacinMultiSelectItem implements IMagacinMultiSelectItem {
    id?: number;
    naziv?: string | undefined;

    constructor(data?: IMagacinMultiSelectItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): MagacinMultiSelectItem {
        data = typeof data === 'object' ? data : {};
        let result = new MagacinMultiSelectItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IMagacinMultiSelectItem {
    id?: number;
    naziv?: string | undefined;
}

export class GetIzvestajIzlaznihDokumenataPdfQuery implements IGetIzvestajIzlaznihDokumenataPdfQuery {
    izvestajIzlaznihDokumenataDto?: IzvestajIzlaznihDokumenataDto[] | undefined;
    filteri?: IzvestajIzlaznihDokumenataFilter2 | undefined;

    constructor(data?: IGetIzvestajIzlaznihDokumenataPdfQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["izvestajIzlaznihDokumenataDto"])) {
                this.izvestajIzlaznihDokumenataDto = [] as any;
                for (let item of _data["izvestajIzlaznihDokumenataDto"])
                    this.izvestajIzlaznihDokumenataDto!.push(IzvestajIzlaznihDokumenataDto.fromJS(item));
            }
            this.filteri = _data["filteri"] ? IzvestajIzlaznihDokumenataFilter2.fromJS(_data["filteri"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetIzvestajIzlaznihDokumenataPdfQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetIzvestajIzlaznihDokumenataPdfQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.izvestajIzlaznihDokumenataDto)) {
            data["izvestajIzlaznihDokumenataDto"] = [];
            for (let item of this.izvestajIzlaznihDokumenataDto)
                data["izvestajIzlaznihDokumenataDto"].push(item.toJSON());
        }
        data["filteri"] = this.filteri ? this.filteri.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetIzvestajIzlaznihDokumenataPdfQuery {
    izvestajIzlaznihDokumenataDto?: IzvestajIzlaznihDokumenataDto[] | undefined;
    filteri?: IzvestajIzlaznihDokumenataFilter2 | undefined;
}

export class IzvestajIzlaznihDokumenataFilter2 implements IIzvestajIzlaznihDokumenataFilter2 {
    datumOd?: Date;
    datumDo?: Date;
    tipIzvestajaVeleprodaja?: TipIzvestajaVeleprodaja;
    podtipIzvestajaVeleprodaja?: PodtipIzvestajaVeleprodaja;
    stranke?: StrankaMultiSelectItem[] | undefined;
    magacini?: MagacinMultiSelectItem[] | undefined;

    constructor(data?: IIzvestajIzlaznihDokumenataFilter2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.tipIzvestajaVeleprodaja = _data["tipIzvestajaVeleprodaja"];
            this.podtipIzvestajaVeleprodaja = _data["podtipIzvestajaVeleprodaja"];
            if (Array.isArray(_data["stranke"])) {
                this.stranke = [] as any;
                for (let item of _data["stranke"])
                    this.stranke!.push(StrankaMultiSelectItem.fromJS(item));
            }
            if (Array.isArray(_data["magacini"])) {
                this.magacini = [] as any;
                for (let item of _data["magacini"])
                    this.magacini!.push(MagacinMultiSelectItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IzvestajIzlaznihDokumenataFilter2 {
        data = typeof data === 'object' ? data : {};
        let result = new IzvestajIzlaznihDokumenataFilter2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["tipIzvestajaVeleprodaja"] = this.tipIzvestajaVeleprodaja;
        data["podtipIzvestajaVeleprodaja"] = this.podtipIzvestajaVeleprodaja;
        if (Array.isArray(this.stranke)) {
            data["stranke"] = [];
            for (let item of this.stranke)
                data["stranke"].push(item.toJSON());
        }
        if (Array.isArray(this.magacini)) {
            data["magacini"] = [];
            for (let item of this.magacini)
                data["magacini"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIzvestajIzlaznihDokumenataFilter2 {
    datumOd?: Date;
    datumDo?: Date;
    tipIzvestajaVeleprodaja?: TipIzvestajaVeleprodaja;
    podtipIzvestajaVeleprodaja?: PodtipIzvestajaVeleprodaja;
    stranke?: StrankaMultiSelectItem[] | undefined;
    magacini?: MagacinMultiSelectItem[] | undefined;
}

export class GetDnevniIzvestajMaloprodajaPdfQuery implements IGetDnevniIzvestajMaloprodajaPdfQuery {
    maloprodajaIzvestajDto?: MaloprodajaIzvestajDto | undefined;
    filter?: DnevniIzvestajMaloprodajaFilter2 | undefined;

    constructor(data?: IGetDnevniIzvestajMaloprodajaPdfQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maloprodajaIzvestajDto = _data["maloprodajaIzvestajDto"] ? MaloprodajaIzvestajDto.fromJS(_data["maloprodajaIzvestajDto"]) : <any>undefined;
            this.filter = _data["filter"] ? DnevniIzvestajMaloprodajaFilter2.fromJS(_data["filter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDnevniIzvestajMaloprodajaPdfQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetDnevniIzvestajMaloprodajaPdfQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maloprodajaIzvestajDto"] = this.maloprodajaIzvestajDto ? this.maloprodajaIzvestajDto.toJSON() : <any>undefined;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDnevniIzvestajMaloprodajaPdfQuery {
    maloprodajaIzvestajDto?: MaloprodajaIzvestajDto | undefined;
    filter?: DnevniIzvestajMaloprodajaFilter2 | undefined;
}

export class DnevniIzvestajMaloprodajaFilter2 implements IDnevniIzvestajMaloprodajaFilter2 {
    datum?: Date | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    kasirId?: string | undefined;

    constructor(data?: IDnevniIzvestajMaloprodajaFilter2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.kasirId = _data["kasirId"];
        }
    }

    static fromJS(data: any): DnevniIzvestajMaloprodajaFilter2 {
        data = typeof data === 'object' ? data : {};
        let result = new DnevniIzvestajMaloprodajaFilter2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["kasirId"] = this.kasirId;
        return data;
    }
}

export interface IDnevniIzvestajMaloprodajaFilter2 {
    datum?: Date | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    kasirId?: string | undefined;
}

export class GetIzvestajPoArtiklimaMaloprodajaPdfQuery implements IGetIzvestajPoArtiklimaMaloprodajaPdfQuery {
    izvestajPoArtiklimaDto?: IzvestajPoArtiklimaTableDto[] | undefined;
    datumOd?: Date;
    datumDo?: Date;

    constructor(data?: IGetIzvestajPoArtiklimaMaloprodajaPdfQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["izvestajPoArtiklimaDto"])) {
                this.izvestajPoArtiklimaDto = [] as any;
                for (let item of _data["izvestajPoArtiklimaDto"])
                    this.izvestajPoArtiklimaDto!.push(IzvestajPoArtiklimaTableDto.fromJS(item));
            }
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetIzvestajPoArtiklimaMaloprodajaPdfQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetIzvestajPoArtiklimaMaloprodajaPdfQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.izvestajPoArtiklimaDto)) {
            data["izvestajPoArtiklimaDto"] = [];
            for (let item of this.izvestajPoArtiklimaDto)
                data["izvestajPoArtiklimaDto"].push(item.toJSON());
        }
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetIzvestajPoArtiklimaMaloprodajaPdfQuery {
    izvestajPoArtiklimaDto?: IzvestajPoArtiklimaTableDto[] | undefined;
    datumOd?: Date;
    datumDo?: Date;
}

export class ResultOfProdajaPoMagacinimaDto extends Result implements IResultOfProdajaPoMagacinimaDto {
    data?: ProdajaPoMagacinimaDto | undefined;

    constructor(data?: IResultOfProdajaPoMagacinimaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? ProdajaPoMagacinimaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfProdajaPoMagacinimaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfProdajaPoMagacinimaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfProdajaPoMagacinimaDto extends IResult {
    data?: ProdajaPoMagacinimaDto | undefined;
}

export class ProdajaPoMagacinimaDto implements IProdajaPoMagacinimaDto {
    magacini?: ProdajaMagacinaDto[] | undefined;
    ukupnoBezPdv?: number;
    ukupnoPdv?: number;
    ukupnoSaPdv?: number;

    constructor(data?: IProdajaPoMagacinimaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["magacini"])) {
                this.magacini = [] as any;
                for (let item of _data["magacini"])
                    this.magacini!.push(ProdajaMagacinaDto.fromJS(item));
            }
            this.ukupnoBezPdv = _data["ukupnoBezPdv"];
            this.ukupnoPdv = _data["ukupnoPdv"];
            this.ukupnoSaPdv = _data["ukupnoSaPdv"];
        }
    }

    static fromJS(data: any): ProdajaPoMagacinimaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProdajaPoMagacinimaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.magacini)) {
            data["magacini"] = [];
            for (let item of this.magacini)
                data["magacini"].push(item.toJSON());
        }
        data["ukupnoBezPdv"] = this.ukupnoBezPdv;
        data["ukupnoPdv"] = this.ukupnoPdv;
        data["ukupnoSaPdv"] = this.ukupnoSaPdv;
        return data;
    }
}

export interface IProdajaPoMagacinimaDto {
    magacini?: ProdajaMagacinaDto[] | undefined;
    ukupnoBezPdv?: number;
    ukupnoPdv?: number;
    ukupnoSaPdv?: number;
}

export class ProdajaMagacinaDto implements IProdajaMagacinaDto {
    magacinId?: number;
    nazivMagacina?: string | undefined;
    meseci?: ProdajaMagacinaPoMesecuDto[] | undefined;
    ukupnoBezPdv?: number;
    ukupnoPdv?: number;
    ukupnoSaPdv?: number;

    constructor(data?: IProdajaMagacinaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.magacinId = _data["magacinId"];
            this.nazivMagacina = _data["nazivMagacina"];
            if (Array.isArray(_data["meseci"])) {
                this.meseci = [] as any;
                for (let item of _data["meseci"])
                    this.meseci!.push(ProdajaMagacinaPoMesecuDto.fromJS(item));
            }
            this.ukupnoBezPdv = _data["ukupnoBezPdv"];
            this.ukupnoPdv = _data["ukupnoPdv"];
            this.ukupnoSaPdv = _data["ukupnoSaPdv"];
        }
    }

    static fromJS(data: any): ProdajaMagacinaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProdajaMagacinaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["magacinId"] = this.magacinId;
        data["nazivMagacina"] = this.nazivMagacina;
        if (Array.isArray(this.meseci)) {
            data["meseci"] = [];
            for (let item of this.meseci)
                data["meseci"].push(item.toJSON());
        }
        data["ukupnoBezPdv"] = this.ukupnoBezPdv;
        data["ukupnoPdv"] = this.ukupnoPdv;
        data["ukupnoSaPdv"] = this.ukupnoSaPdv;
        return data;
    }
}

export interface IProdajaMagacinaDto {
    magacinId?: number;
    nazivMagacina?: string | undefined;
    meseci?: ProdajaMagacinaPoMesecuDto[] | undefined;
    ukupnoBezPdv?: number;
    ukupnoPdv?: number;
    ukupnoSaPdv?: number;
}

export class ProdajaMagacinaPoMesecuDto implements IProdajaMagacinaPoMesecuDto {
    godina?: number;
    mesec?: number;
    naziv?: string | undefined;
    jeNepunMesec?: boolean;
    iznosBezPdv?: number;
    pdv?: number;
    iznosSaPdv?: number;

    constructor(data?: IProdajaMagacinaPoMesecuDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.godina = _data["godina"];
            this.mesec = _data["mesec"];
            this.naziv = _data["naziv"];
            this.jeNepunMesec = _data["jeNepunMesec"];
            this.iznosBezPdv = _data["iznosBezPdv"];
            this.pdv = _data["pdv"];
            this.iznosSaPdv = _data["iznosSaPdv"];
        }
    }

    static fromJS(data: any): ProdajaMagacinaPoMesecuDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProdajaMagacinaPoMesecuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["godina"] = this.godina;
        data["mesec"] = this.mesec;
        data["naziv"] = this.naziv;
        data["jeNepunMesec"] = this.jeNepunMesec;
        data["iznosBezPdv"] = this.iznosBezPdv;
        data["pdv"] = this.pdv;
        data["iznosSaPdv"] = this.iznosSaPdv;
        return data;
    }
}

export interface IProdajaMagacinaPoMesecuDto {
    godina?: number;
    mesec?: number;
    naziv?: string | undefined;
    jeNepunMesec?: boolean;
    iznosBezPdv?: number;
    pdv?: number;
    iznosSaPdv?: number;
}

export class GetProdajaPoMagacinimaQuery implements IGetProdajaPoMagacinimaQuery {
    datumOd?: Date;
    datumDo?: Date;
    magacinIds?: number[] | undefined;

    constructor(data?: IGetProdajaPoMagacinimaQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            if (Array.isArray(_data["magacinIds"])) {
                this.magacinIds = [] as any;
                for (let item of _data["magacinIds"])
                    this.magacinIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetProdajaPoMagacinimaQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetProdajaPoMagacinimaQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        if (Array.isArray(this.magacinIds)) {
            data["magacinIds"] = [];
            for (let item of this.magacinIds)
                data["magacinIds"].push(item);
        }
        return data;
    }
}

export interface IGetProdajaPoMagacinimaQuery {
    datumOd?: Date;
    datumDo?: Date;
    magacinIds?: number[] | undefined;
}

export class GetProdajaPoMagacinimaPdfQuery implements IGetProdajaPoMagacinimaPdfQuery {
    datumOd?: Date;
    datumDo?: Date;
    magacinIds?: number[] | undefined;

    constructor(data?: IGetProdajaPoMagacinimaPdfQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            if (Array.isArray(_data["magacinIds"])) {
                this.magacinIds = [] as any;
                for (let item of _data["magacinIds"])
                    this.magacinIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetProdajaPoMagacinimaPdfQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetProdajaPoMagacinimaPdfQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        if (Array.isArray(this.magacinIds)) {
            data["magacinIds"] = [];
            for (let item of this.magacinIds)
                data["magacinIds"].push(item);
        }
        return data;
    }
}

export interface IGetProdajaPoMagacinimaPdfQuery {
    datumOd?: Date;
    datumDo?: Date;
    magacinIds?: number[] | undefined;
}

export class ResultOfGetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto extends Result implements IResultOfGetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto {
    data?: GetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto | undefined;

    constructor(data?: IResultOfGetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto extends IResult {
    data?: GetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto | undefined;
}

export class GetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto implements IGetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto {
    responseList?: IzvodTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    availableFilters?: IzvodTableAvailableFiltersDto | undefined;

    constructor(data?: IGetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(IzvodTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.availableFilters = _data["availableFilters"] ? IzvodTableAvailableFiltersDto.fromJS(_data["availableFilters"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["availableFilters"] = this.availableFilters ? this.availableFilters.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTableResponseWithAvailableFiltersOfIzvodTableDtoAndIzvodTableAvailableFiltersDto {
    responseList?: IzvodTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    availableFilters?: IzvodTableAvailableFiltersDto | undefined;
}

export class IzvodTableDto implements IIzvodTableDto {
    id?: number;
    brojIzvoda?: string | undefined;
    datumIzdavanja?: string | undefined;
    konacnoStanje?: number;
    brojUplata?: string | undefined;
    brojIsplata?: string | undefined;
    nazivGrupe?: string | undefined;
    valutaText?: string | undefined;
    statusDto?: StatusIzvodaDto | undefined;

    constructor(data?: IIzvodTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.brojIzvoda = _data["brojIzvoda"];
            this.datumIzdavanja = _data["datumIzdavanja"];
            this.konacnoStanje = _data["konacnoStanje"];
            this.brojUplata = _data["brojUplata"];
            this.brojIsplata = _data["brojIsplata"];
            this.nazivGrupe = _data["nazivGrupe"];
            this.valutaText = _data["valutaText"];
            this.statusDto = _data["statusDto"] ? StatusIzvodaDto.fromJS(_data["statusDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IzvodTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new IzvodTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["brojIzvoda"] = this.brojIzvoda;
        data["datumIzdavanja"] = this.datumIzdavanja;
        data["konacnoStanje"] = this.konacnoStanje;
        data["brojUplata"] = this.brojUplata;
        data["brojIsplata"] = this.brojIsplata;
        data["nazivGrupe"] = this.nazivGrupe;
        data["valutaText"] = this.valutaText;
        data["statusDto"] = this.statusDto ? this.statusDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIzvodTableDto {
    id?: number;
    brojIzvoda?: string | undefined;
    datumIzdavanja?: string | undefined;
    konacnoStanje?: number;
    brojUplata?: string | undefined;
    brojIsplata?: string | undefined;
    nazivGrupe?: string | undefined;
    valutaText?: string | undefined;
    statusDto?: StatusIzvodaDto | undefined;
}

export class StatusIzvodaDto implements IStatusIzvodaDto {
    status?: StatusIzvoda;
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IStatusIzvodaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.statusStr = _data["statusStr"];
            this.statusBadgeStr = _data["statusBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): StatusIzvodaDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusIzvodaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["statusStr"] = this.statusStr;
        data["statusBadgeStr"] = this.statusBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IStatusIzvodaDto {
    status?: StatusIzvoda;
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class IzvodTableAvailableFiltersDto implements IIzvodTableAvailableFiltersDto {
    banke?: BankaDto[] | undefined;
    tekuciRacuni?: TekuciRacunDto[] | undefined;
    godine?: number[] | undefined;
    meseci?: number[] | undefined;

    constructor(data?: IIzvodTableAvailableFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["banke"])) {
                this.banke = [] as any;
                for (let item of _data["banke"])
                    this.banke!.push(BankaDto.fromJS(item));
            }
            if (Array.isArray(_data["tekuciRacuni"])) {
                this.tekuciRacuni = [] as any;
                for (let item of _data["tekuciRacuni"])
                    this.tekuciRacuni!.push(TekuciRacunDto.fromJS(item));
            }
            if (Array.isArray(_data["godine"])) {
                this.godine = [] as any;
                for (let item of _data["godine"])
                    this.godine!.push(item);
            }
            if (Array.isArray(_data["meseci"])) {
                this.meseci = [] as any;
                for (let item of _data["meseci"])
                    this.meseci!.push(item);
            }
        }
    }

    static fromJS(data: any): IzvodTableAvailableFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new IzvodTableAvailableFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.banke)) {
            data["banke"] = [];
            for (let item of this.banke)
                data["banke"].push(item.toJSON());
        }
        if (Array.isArray(this.tekuciRacuni)) {
            data["tekuciRacuni"] = [];
            for (let item of this.tekuciRacuni)
                data["tekuciRacuni"].push(item.toJSON());
        }
        if (Array.isArray(this.godine)) {
            data["godine"] = [];
            for (let item of this.godine)
                data["godine"].push(item);
        }
        if (Array.isArray(this.meseci)) {
            data["meseci"] = [];
            for (let item of this.meseci)
                data["meseci"].push(item);
        }
        return data;
    }
}

export interface IIzvodTableAvailableFiltersDto {
    banke?: BankaDto[] | undefined;
    tekuciRacuni?: TekuciRacunDto[] | undefined;
    godine?: number[] | undefined;
    meseci?: number[] | undefined;
}

export class GetIzvodTableQuery implements IGetIzvodTableQuery {
    godina?: number | undefined;
    mesec?: number | undefined;
    bankaDto?: BankaDto | undefined;
    tekuciRacunDto?: TekuciRacunDto | undefined;

    constructor(data?: IGetIzvodTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.godina = _data["godina"];
            this.mesec = _data["mesec"];
            this.bankaDto = _data["bankaDto"] ? BankaDto.fromJS(_data["bankaDto"]) : <any>undefined;
            this.tekuciRacunDto = _data["tekuciRacunDto"] ? TekuciRacunDto.fromJS(_data["tekuciRacunDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetIzvodTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetIzvodTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["godina"] = this.godina;
        data["mesec"] = this.mesec;
        data["bankaDto"] = this.bankaDto ? this.bankaDto.toJSON() : <any>undefined;
        data["tekuciRacunDto"] = this.tekuciRacunDto ? this.tekuciRacunDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetIzvodTableQuery {
    godina?: number | undefined;
    mesec?: number | undefined;
    bankaDto?: BankaDto | undefined;
    tekuciRacunDto?: TekuciRacunDto | undefined;
}

export class ResultOfIzvodDto extends Result implements IResultOfIzvodDto {
    data?: IzvodDto | undefined;

    constructor(data?: IResultOfIzvodDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? IzvodDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfIzvodDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfIzvodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfIzvodDto extends IResult {
    data?: IzvodDto | undefined;
}

export class IzvodDto implements IIzvodDto {
    id?: number | undefined;
    tekuciRacunId?: number;
    brojTekucegRacuna?: string | undefined;
    broj?: number;
    datumIzdavanja?: string | undefined;
    valutaId?: string;
    valutaText?: string | undefined;
    stanjePrethodnogIzvoda?: number;
    stanjeTrenutnogIzvoda?: number;
    promenaStanja?: number;
    uplateTable?: UplataTableDto[] | undefined;
    isplateTable?: IsplataTableDto[] | undefined;
    ukupnoPotrazuje?: number;
    ukupnoDuguje?: number;
    nazivBanke?: string | undefined;
    sledeciIzvod?: SaltanjeIzvodaDto | undefined;
    prethodniIzvod?: SaltanjeIzvodaDto | undefined;
    statusDto?: StatusIzvodaDto | undefined;
    jeRucnoUneto?: boolean;

    constructor(data?: IIzvodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tekuciRacunId = _data["tekuciRacunId"];
            this.brojTekucegRacuna = _data["brojTekucegRacuna"];
            this.broj = _data["broj"];
            this.datumIzdavanja = _data["datumIzdavanja"];
            this.valutaId = _data["valutaId"];
            this.valutaText = _data["valutaText"];
            this.stanjePrethodnogIzvoda = _data["stanjePrethodnogIzvoda"];
            this.stanjeTrenutnogIzvoda = _data["stanjeTrenutnogIzvoda"];
            this.promenaStanja = _data["promenaStanja"];
            if (Array.isArray(_data["uplateTable"])) {
                this.uplateTable = [] as any;
                for (let item of _data["uplateTable"])
                    this.uplateTable!.push(UplataTableDto.fromJS(item));
            }
            if (Array.isArray(_data["isplateTable"])) {
                this.isplateTable = [] as any;
                for (let item of _data["isplateTable"])
                    this.isplateTable!.push(IsplataTableDto.fromJS(item));
            }
            this.ukupnoPotrazuje = _data["ukupnoPotrazuje"];
            this.ukupnoDuguje = _data["ukupnoDuguje"];
            this.nazivBanke = _data["nazivBanke"];
            this.sledeciIzvod = _data["sledeciIzvod"] ? SaltanjeIzvodaDto.fromJS(_data["sledeciIzvod"]) : <any>undefined;
            this.prethodniIzvod = _data["prethodniIzvod"] ? SaltanjeIzvodaDto.fromJS(_data["prethodniIzvod"]) : <any>undefined;
            this.statusDto = _data["statusDto"] ? StatusIzvodaDto.fromJS(_data["statusDto"]) : <any>undefined;
            this.jeRucnoUneto = _data["jeRucnoUneto"];
        }
    }

    static fromJS(data: any): IzvodDto {
        data = typeof data === 'object' ? data : {};
        let result = new IzvodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tekuciRacunId"] = this.tekuciRacunId;
        data["brojTekucegRacuna"] = this.brojTekucegRacuna;
        data["broj"] = this.broj;
        data["datumIzdavanja"] = this.datumIzdavanja;
        data["valutaId"] = this.valutaId;
        data["valutaText"] = this.valutaText;
        data["stanjePrethodnogIzvoda"] = this.stanjePrethodnogIzvoda;
        data["stanjeTrenutnogIzvoda"] = this.stanjeTrenutnogIzvoda;
        data["promenaStanja"] = this.promenaStanja;
        if (Array.isArray(this.uplateTable)) {
            data["uplateTable"] = [];
            for (let item of this.uplateTable)
                data["uplateTable"].push(item.toJSON());
        }
        if (Array.isArray(this.isplateTable)) {
            data["isplateTable"] = [];
            for (let item of this.isplateTable)
                data["isplateTable"].push(item.toJSON());
        }
        data["ukupnoPotrazuje"] = this.ukupnoPotrazuje;
        data["ukupnoDuguje"] = this.ukupnoDuguje;
        data["nazivBanke"] = this.nazivBanke;
        data["sledeciIzvod"] = this.sledeciIzvod ? this.sledeciIzvod.toJSON() : <any>undefined;
        data["prethodniIzvod"] = this.prethodniIzvod ? this.prethodniIzvod.toJSON() : <any>undefined;
        data["statusDto"] = this.statusDto ? this.statusDto.toJSON() : <any>undefined;
        data["jeRucnoUneto"] = this.jeRucnoUneto;
        return data;
    }
}

export interface IIzvodDto {
    id?: number | undefined;
    tekuciRacunId?: number;
    brojTekucegRacuna?: string | undefined;
    broj?: number;
    datumIzdavanja?: string | undefined;
    valutaId?: string;
    valutaText?: string | undefined;
    stanjePrethodnogIzvoda?: number;
    stanjeTrenutnogIzvoda?: number;
    promenaStanja?: number;
    uplateTable?: UplataTableDto[] | undefined;
    isplateTable?: IsplataTableDto[] | undefined;
    ukupnoPotrazuje?: number;
    ukupnoDuguje?: number;
    nazivBanke?: string | undefined;
    sledeciIzvod?: SaltanjeIzvodaDto | undefined;
    prethodniIzvod?: SaltanjeIzvodaDto | undefined;
    statusDto?: StatusIzvodaDto | undefined;
    jeRucnoUneto?: boolean;
}

export class UplataTableDto implements IUplataTableDto {
    id?: number;
    iznos?: number;
    raspolozivIznos?: number;
    svrhaUplate?: string | undefined;
    pozivNaBrojDrugeStrane?: string | undefined;
    statusDto?: StatusTransakcijeIzvodaDto | undefined;
    tip?: TipUplate;
    vezaniRacuni?: VezaniRacunDto[] | undefined;
    drugaStrana?: RutiranjeStrankeDto | undefined;
    valutaText?: string | undefined;
    datumIzvoda?: string | undefined;
    izvodId?: number;
    brojIzvoda?: number;

    constructor(data?: IUplataTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.iznos = _data["iznos"];
            this.raspolozivIznos = _data["raspolozivIznos"];
            this.svrhaUplate = _data["svrhaUplate"];
            this.pozivNaBrojDrugeStrane = _data["pozivNaBrojDrugeStrane"];
            this.statusDto = _data["statusDto"] ? StatusTransakcijeIzvodaDto.fromJS(_data["statusDto"]) : <any>undefined;
            this.tip = _data["tip"];
            if (Array.isArray(_data["vezaniRacuni"])) {
                this.vezaniRacuni = [] as any;
                for (let item of _data["vezaniRacuni"])
                    this.vezaniRacuni!.push(VezaniRacunDto.fromJS(item));
            }
            this.drugaStrana = _data["drugaStrana"] ? RutiranjeStrankeDto.fromJS(_data["drugaStrana"]) : <any>undefined;
            this.valutaText = _data["valutaText"];
            this.datumIzvoda = _data["datumIzvoda"];
            this.izvodId = _data["izvodId"];
            this.brojIzvoda = _data["brojIzvoda"];
        }
    }

    static fromJS(data: any): UplataTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new UplataTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["iznos"] = this.iznos;
        data["raspolozivIznos"] = this.raspolozivIznos;
        data["svrhaUplate"] = this.svrhaUplate;
        data["pozivNaBrojDrugeStrane"] = this.pozivNaBrojDrugeStrane;
        data["statusDto"] = this.statusDto ? this.statusDto.toJSON() : <any>undefined;
        data["tip"] = this.tip;
        if (Array.isArray(this.vezaniRacuni)) {
            data["vezaniRacuni"] = [];
            for (let item of this.vezaniRacuni)
                data["vezaniRacuni"].push(item.toJSON());
        }
        data["drugaStrana"] = this.drugaStrana ? this.drugaStrana.toJSON() : <any>undefined;
        data["valutaText"] = this.valutaText;
        data["datumIzvoda"] = this.datumIzvoda;
        data["izvodId"] = this.izvodId;
        data["brojIzvoda"] = this.brojIzvoda;
        return data;
    }
}

export interface IUplataTableDto {
    id?: number;
    iznos?: number;
    raspolozivIznos?: number;
    svrhaUplate?: string | undefined;
    pozivNaBrojDrugeStrane?: string | undefined;
    statusDto?: StatusTransakcijeIzvodaDto | undefined;
    tip?: TipUplate;
    vezaniRacuni?: VezaniRacunDto[] | undefined;
    drugaStrana?: RutiranjeStrankeDto | undefined;
    valutaText?: string | undefined;
    datumIzvoda?: string | undefined;
    izvodId?: number;
    brojIzvoda?: number;
}

export class StatusTransakcijeIzvodaDto implements IStatusTransakcijeIzvodaDto {
    status?: StatusTransakcijeIzvoda;
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;

    constructor(data?: IStatusTransakcijeIzvodaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.statusStr = _data["statusStr"];
            this.statusBadgeStr = _data["statusBadgeStr"];
        }
    }

    static fromJS(data: any): StatusTransakcijeIzvodaDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusTransakcijeIzvodaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["statusStr"] = this.statusStr;
        data["statusBadgeStr"] = this.statusBadgeStr;
        return data;
    }
}

export interface IStatusTransakcijeIzvodaDto {
    status?: StatusTransakcijeIzvoda;
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;
}

export class IsplataTableDto implements IIsplataTableDto {
    id?: number;
    drugaStrana?: RutiranjeStrankeDto | undefined;
    iznos?: number;
    raspolozivIznos?: number;
    svrhaUplate?: string | undefined;
    pozivNaBrojVlasnika?: string | undefined;
    pozivNaBrojDrugeStrane?: string | undefined;
    statusDto?: StatusTransakcijeIzvodaDto | undefined;
    kategorija?: KategorijaIsplate;
    vezaniRacuni?: VezaniRacunDto[] | undefined;
    valutaText?: string | undefined;
    datumIzvoda?: string | undefined;
    izvodId?: number;
    brojIzvoda?: number;

    constructor(data?: IIsplataTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.drugaStrana = _data["drugaStrana"] ? RutiranjeStrankeDto.fromJS(_data["drugaStrana"]) : <any>undefined;
            this.iznos = _data["iznos"];
            this.raspolozivIznos = _data["raspolozivIznos"];
            this.svrhaUplate = _data["svrhaUplate"];
            this.pozivNaBrojVlasnika = _data["pozivNaBrojVlasnika"];
            this.pozivNaBrojDrugeStrane = _data["pozivNaBrojDrugeStrane"];
            this.statusDto = _data["statusDto"] ? StatusTransakcijeIzvodaDto.fromJS(_data["statusDto"]) : <any>undefined;
            this.kategorija = _data["kategorija"];
            if (Array.isArray(_data["vezaniRacuni"])) {
                this.vezaniRacuni = [] as any;
                for (let item of _data["vezaniRacuni"])
                    this.vezaniRacuni!.push(VezaniRacunDto.fromJS(item));
            }
            this.valutaText = _data["valutaText"];
            this.datumIzvoda = _data["datumIzvoda"];
            this.izvodId = _data["izvodId"];
            this.brojIzvoda = _data["brojIzvoda"];
        }
    }

    static fromJS(data: any): IsplataTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsplataTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["drugaStrana"] = this.drugaStrana ? this.drugaStrana.toJSON() : <any>undefined;
        data["iznos"] = this.iznos;
        data["raspolozivIznos"] = this.raspolozivIznos;
        data["svrhaUplate"] = this.svrhaUplate;
        data["pozivNaBrojVlasnika"] = this.pozivNaBrojVlasnika;
        data["pozivNaBrojDrugeStrane"] = this.pozivNaBrojDrugeStrane;
        data["statusDto"] = this.statusDto ? this.statusDto.toJSON() : <any>undefined;
        data["kategorija"] = this.kategorija;
        if (Array.isArray(this.vezaniRacuni)) {
            data["vezaniRacuni"] = [];
            for (let item of this.vezaniRacuni)
                data["vezaniRacuni"].push(item.toJSON());
        }
        data["valutaText"] = this.valutaText;
        data["datumIzvoda"] = this.datumIzvoda;
        data["izvodId"] = this.izvodId;
        data["brojIzvoda"] = this.brojIzvoda;
        return data;
    }
}

export interface IIsplataTableDto {
    id?: number;
    drugaStrana?: RutiranjeStrankeDto | undefined;
    iznos?: number;
    raspolozivIznos?: number;
    svrhaUplate?: string | undefined;
    pozivNaBrojVlasnika?: string | undefined;
    pozivNaBrojDrugeStrane?: string | undefined;
    statusDto?: StatusTransakcijeIzvodaDto | undefined;
    kategorija?: KategorijaIsplate;
    vezaniRacuni?: VezaniRacunDto[] | undefined;
    valutaText?: string | undefined;
    datumIzvoda?: string | undefined;
    izvodId?: number;
    brojIzvoda?: number;
}

export class SaltanjeIzvodaDto implements ISaltanjeIzvodaDto {
    izvodId?: number;
    text?: string | undefined;

    constructor(data?: ISaltanjeIzvodaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.izvodId = _data["izvodId"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): SaltanjeIzvodaDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaltanjeIzvodaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["izvodId"] = this.izvodId;
        data["text"] = this.text;
        return data;
    }
}

export interface ISaltanjeIzvodaDto {
    izvodId?: number;
    text?: string | undefined;
}

export class PaginatedResultOfUplataTableDto extends Result implements IPaginatedResultOfUplataTableDto {
    data?: UplataTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfUplataTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UplataTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfUplataTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfUplataTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfUplataTableDto extends IResult {
    data?: UplataTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PaginatedResultOfUplataTableDtoAndUplateIsplateSummaryDto extends PaginatedResultOfUplataTableDto implements IPaginatedResultOfUplataTableDtoAndUplateIsplateSummaryDto {
    summaryData?: UplateIsplateSummaryDto | undefined;

    constructor(data?: IPaginatedResultOfUplataTableDtoAndUplateIsplateSummaryDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.summaryData = _data["summaryData"] ? UplateIsplateSummaryDto.fromJS(_data["summaryData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaginatedResultOfUplataTableDtoAndUplateIsplateSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfUplataTableDtoAndUplateIsplateSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summaryData"] = this.summaryData ? this.summaryData.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfUplataTableDtoAndUplateIsplateSummaryDto extends IPaginatedResultOfUplataTableDto {
    summaryData?: UplateIsplateSummaryDto | undefined;
}

export class UplateIsplateSummaryDto implements IUplateIsplateSummaryDto {
    brojRekorda?: string | undefined;
    ukupanIznos?: string | undefined;

    constructor(data?: IUplateIsplateSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brojRekorda = _data["brojRekorda"];
            this.ukupanIznos = _data["ukupanIznos"];
        }
    }

    static fromJS(data: any): UplateIsplateSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UplateIsplateSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brojRekorda"] = this.brojRekorda;
        data["ukupanIznos"] = this.ukupanIznos;
        return data;
    }
}

export interface IUplateIsplateSummaryDto {
    brojRekorda?: string | undefined;
    ukupanIznos?: string | undefined;
}

export class GetUplateQuery implements IGetUplateQuery {
    kupac?: string | undefined;
    pozivNaBroj?: string | undefined;
    svrhaUplate?: string | undefined;
    izvodId?: number | undefined;
    statusi?: StatusTransakcijeIzvodaDto[] | undefined;
    mesec?: number | undefined;
    datumIzdavanjaOd?: Date | undefined;
    datumIzdavanjaDo?: Date | undefined;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetUplateQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kupac = _data["kupac"];
            this.pozivNaBroj = _data["pozivNaBroj"];
            this.svrhaUplate = _data["svrhaUplate"];
            this.izvodId = _data["izvodId"];
            if (Array.isArray(_data["statusi"])) {
                this.statusi = [] as any;
                for (let item of _data["statusi"])
                    this.statusi!.push(StatusTransakcijeIzvodaDto.fromJS(item));
            }
            this.mesec = _data["mesec"];
            this.datumIzdavanjaOd = _data["datumIzdavanjaOd"] ? new Date(_data["datumIzdavanjaOd"].toString()) : <any>undefined;
            this.datumIzdavanjaDo = _data["datumIzdavanjaDo"] ? new Date(_data["datumIzdavanjaDo"].toString()) : <any>undefined;
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetUplateQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUplateQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kupac"] = this.kupac;
        data["pozivNaBroj"] = this.pozivNaBroj;
        data["svrhaUplate"] = this.svrhaUplate;
        data["izvodId"] = this.izvodId;
        if (Array.isArray(this.statusi)) {
            data["statusi"] = [];
            for (let item of this.statusi)
                data["statusi"].push(item.toJSON());
        }
        data["mesec"] = this.mesec;
        data["datumIzdavanjaOd"] = this.datumIzdavanjaOd ? this.datumIzdavanjaOd.toISOString() : <any>undefined;
        data["datumIzdavanjaDo"] = this.datumIzdavanjaDo ? this.datumIzdavanjaDo.toISOString() : <any>undefined;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetUplateQuery {
    kupac?: string | undefined;
    pozivNaBroj?: string | undefined;
    svrhaUplate?: string | undefined;
    izvodId?: number | undefined;
    statusi?: StatusTransakcijeIzvodaDto[] | undefined;
    mesec?: number | undefined;
    datumIzdavanjaOd?: Date | undefined;
    datumIzdavanjaDo?: Date | undefined;
    pageNumber?: number;
    pageSize?: number;
}

export class PaginatedResultOfIsplataTableDto extends Result implements IPaginatedResultOfIsplataTableDto {
    data?: IsplataTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfIsplataTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IsplataTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfIsplataTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfIsplataTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfIsplataTableDto extends IResult {
    data?: IsplataTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PaginatedResultOfIsplataTableDtoAndUplateIsplateSummaryDto extends PaginatedResultOfIsplataTableDto implements IPaginatedResultOfIsplataTableDtoAndUplateIsplateSummaryDto {
    summaryData?: UplateIsplateSummaryDto | undefined;

    constructor(data?: IPaginatedResultOfIsplataTableDtoAndUplateIsplateSummaryDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.summaryData = _data["summaryData"] ? UplateIsplateSummaryDto.fromJS(_data["summaryData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaginatedResultOfIsplataTableDtoAndUplateIsplateSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfIsplataTableDtoAndUplateIsplateSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summaryData"] = this.summaryData ? this.summaryData.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfIsplataTableDtoAndUplateIsplateSummaryDto extends IPaginatedResultOfIsplataTableDto {
    summaryData?: UplateIsplateSummaryDto | undefined;
}

export class GetIsplateQuery implements IGetIsplateQuery {
    kupac?: string | undefined;
    pozivNaBroj?: string | undefined;
    svrhaUplate?: string | undefined;
    izvodId?: number | undefined;
    statusi?: StatusTransakcijeIzvodaDto[] | undefined;
    mesec?: number | undefined;
    datumIzdavanjaOd?: Date | undefined;
    datumIzdavanjaDo?: Date | undefined;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetIsplateQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kupac = _data["kupac"];
            this.pozivNaBroj = _data["pozivNaBroj"];
            this.svrhaUplate = _data["svrhaUplate"];
            this.izvodId = _data["izvodId"];
            if (Array.isArray(_data["statusi"])) {
                this.statusi = [] as any;
                for (let item of _data["statusi"])
                    this.statusi!.push(StatusTransakcijeIzvodaDto.fromJS(item));
            }
            this.mesec = _data["mesec"];
            this.datumIzdavanjaOd = _data["datumIzdavanjaOd"] ? new Date(_data["datumIzdavanjaOd"].toString()) : <any>undefined;
            this.datumIzdavanjaDo = _data["datumIzdavanjaDo"] ? new Date(_data["datumIzdavanjaDo"].toString()) : <any>undefined;
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetIsplateQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetIsplateQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kupac"] = this.kupac;
        data["pozivNaBroj"] = this.pozivNaBroj;
        data["svrhaUplate"] = this.svrhaUplate;
        data["izvodId"] = this.izvodId;
        if (Array.isArray(this.statusi)) {
            data["statusi"] = [];
            for (let item of this.statusi)
                data["statusi"].push(item.toJSON());
        }
        data["mesec"] = this.mesec;
        data["datumIzdavanjaOd"] = this.datumIzdavanjaOd ? this.datumIzdavanjaOd.toISOString() : <any>undefined;
        data["datumIzdavanjaDo"] = this.datumIzdavanjaDo ? this.datumIzdavanjaDo.toISOString() : <any>undefined;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetIsplateQuery {
    kupac?: string | undefined;
    pozivNaBroj?: string | undefined;
    svrhaUplate?: string | undefined;
    izvodId?: number | undefined;
    statusi?: StatusTransakcijeIzvodaDto[] | undefined;
    mesec?: number | undefined;
    datumIzdavanjaOd?: Date | undefined;
    datumIzdavanjaDo?: Date | undefined;
    pageNumber?: number;
    pageSize?: number;
}

export class ResultOfGetIzvodFajlIzvorDropdownResponse extends Result implements IResultOfGetIzvodFajlIzvorDropdownResponse {
    data?: GetIzvodFajlIzvorDropdownResponse | undefined;

    constructor(data?: IResultOfGetIzvodFajlIzvorDropdownResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetIzvodFajlIzvorDropdownResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetIzvodFajlIzvorDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetIzvodFajlIzvorDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetIzvodFajlIzvorDropdownResponse extends IResult {
    data?: GetIzvodFajlIzvorDropdownResponse | undefined;
}

export class GetIzvodFajlIzvorDropdownResponse implements IGetIzvodFajlIzvorDropdownResponse {
    izvodFajlIzvorDropdownDtoList?: IzvodFajlIzvorDropdownDto[] | undefined;

    constructor(data?: IGetIzvodFajlIzvorDropdownResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["izvodFajlIzvorDropdownDtoList"])) {
                this.izvodFajlIzvorDropdownDtoList = [] as any;
                for (let item of _data["izvodFajlIzvorDropdownDtoList"])
                    this.izvodFajlIzvorDropdownDtoList!.push(IzvodFajlIzvorDropdownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIzvodFajlIzvorDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetIzvodFajlIzvorDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.izvodFajlIzvorDropdownDtoList)) {
            data["izvodFajlIzvorDropdownDtoList"] = [];
            for (let item of this.izvodFajlIzvorDropdownDtoList)
                data["izvodFajlIzvorDropdownDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetIzvodFajlIzvorDropdownResponse {
    izvodFajlIzvorDropdownDtoList?: IzvodFajlIzvorDropdownDto[] | undefined;
}

export class IzvodFajlIzvorDropdownDto implements IIzvodFajlIzvorDropdownDto {
    isDefault?: boolean;
    nazivBanke?: string | undefined;
    banka?: BankaIzvoda;
    fileType?: FileType;

    constructor(data?: IIzvodFajlIzvorDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDefault = _data["isDefault"];
            this.nazivBanke = _data["nazivBanke"];
            this.banka = _data["banka"];
            this.fileType = _data["fileType"];
        }
    }

    static fromJS(data: any): IzvodFajlIzvorDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new IzvodFajlIzvorDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDefault"] = this.isDefault;
        data["nazivBanke"] = this.nazivBanke;
        data["banka"] = this.banka;
        data["fileType"] = this.fileType;
        return data;
    }
}

export interface IIzvodFajlIzvorDropdownDto {
    isDefault?: boolean;
    nazivBanke?: string | undefined;
    banka?: BankaIzvoda;
    fileType?: FileType;
}

export enum BankaIzvoda {
    ASSECO = 0,
    POSTANSKA_STEDIONICA = 1,
    EUROBANK_DIREKTNA = 2,
    RAIFFEISEN = 3,
    RAIFFEISEN_DEVIZNI = 4,
    NLB = 5,
    OTP = 6,
    ERSTE_CSV = 7,
    BANKA_INTESA = 8,
    ADDICO_BANKA = 9,
    RBA = 10,
    PROCREDIT_BANK = 11,
    AIK_BANKA = 12,
    HALCOM = 13,
    ASSECO_DEVIZNI = 14,
    HALKBANK = 15,
    PROCREDIT_DEVIZNI = 16,
    UNICREDIT_BANK = 17,
    EMPTY = 99,
}

export class ObradiTransakcijeIzvodaCommand implements IObradiTransakcijeIzvodaCommand {
    id?: number;
    smer?: string | undefined;

    constructor(data?: IObradiTransakcijeIzvodaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.smer = _data["smer"];
        }
    }

    static fromJS(data: any): ObradiTransakcijeIzvodaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObradiTransakcijeIzvodaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["smer"] = this.smer;
        return data;
    }
}

export interface IObradiTransakcijeIzvodaCommand {
    id?: number;
    smer?: string | undefined;
}

export class ResultOfUplataTableDto extends Result implements IResultOfUplataTableDto {
    data?: UplataTableDto | undefined;

    constructor(data?: IResultOfUplataTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? UplataTableDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfUplataTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfUplataTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfUplataTableDto extends IResult {
    data?: UplataTableDto | undefined;
}

export class EvidentirajUplatuCommand implements IEvidentirajUplatuCommand {
    uplataIsplataZaRacunList?: UplataIsplataZaRacunDto[] | undefined;
    transakcijaIzvodaId?: number;

    constructor(data?: IEvidentirajUplatuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["uplataIsplataZaRacunList"])) {
                this.uplataIsplataZaRacunList = [] as any;
                for (let item of _data["uplataIsplataZaRacunList"])
                    this.uplataIsplataZaRacunList!.push(UplataIsplataZaRacunDto.fromJS(item));
            }
            this.transakcijaIzvodaId = _data["transakcijaIzvodaId"];
        }
    }

    static fromJS(data: any): EvidentirajUplatuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EvidentirajUplatuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uplataIsplataZaRacunList)) {
            data["uplataIsplataZaRacunList"] = [];
            for (let item of this.uplataIsplataZaRacunList)
                data["uplataIsplataZaRacunList"].push(item.toJSON());
        }
        data["transakcijaIzvodaId"] = this.transakcijaIzvodaId;
        return data;
    }
}

export interface IEvidentirajUplatuCommand {
    uplataIsplataZaRacunList?: UplataIsplataZaRacunDto[] | undefined;
    transakcijaIzvodaId?: number;
}

export class PonistiEvidentiranuUplatuCommand implements IPonistiEvidentiranuUplatuCommand {
    transakcijaIzvodaId?: number;

    constructor(data?: IPonistiEvidentiranuUplatuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transakcijaIzvodaId = _data["transakcijaIzvodaId"];
        }
    }

    static fromJS(data: any): PonistiEvidentiranuUplatuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PonistiEvidentiranuUplatuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transakcijaIzvodaId"] = this.transakcijaIzvodaId;
        return data;
    }
}

export interface IPonistiEvidentiranuUplatuCommand {
    transakcijaIzvodaId?: number;
}

export class ResultOfIsplataTableDto extends Result implements IResultOfIsplataTableDto {
    data?: IsplataTableDto | undefined;

    constructor(data?: IResultOfIsplataTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? IsplataTableDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfIsplataTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfIsplataTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfIsplataTableDto extends IResult {
    data?: IsplataTableDto | undefined;
}

export class EvidentirajIsplatuCommand implements IEvidentirajIsplatuCommand {
    uplataIsplataZaRacunList?: UplataIsplataZaRacunDto[] | undefined;
    transakcijaIzvodaId?: number;

    constructor(data?: IEvidentirajIsplatuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["uplataIsplataZaRacunList"])) {
                this.uplataIsplataZaRacunList = [] as any;
                for (let item of _data["uplataIsplataZaRacunList"])
                    this.uplataIsplataZaRacunList!.push(UplataIsplataZaRacunDto.fromJS(item));
            }
            this.transakcijaIzvodaId = _data["transakcijaIzvodaId"];
        }
    }

    static fromJS(data: any): EvidentirajIsplatuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EvidentirajIsplatuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uplataIsplataZaRacunList)) {
            data["uplataIsplataZaRacunList"] = [];
            for (let item of this.uplataIsplataZaRacunList)
                data["uplataIsplataZaRacunList"].push(item.toJSON());
        }
        data["transakcijaIzvodaId"] = this.transakcijaIzvodaId;
        return data;
    }
}

export interface IEvidentirajIsplatuCommand {
    uplataIsplataZaRacunList?: UplataIsplataZaRacunDto[] | undefined;
    transakcijaIzvodaId?: number;
}

export class DodajIzvodManuelnoCommand extends IzvodDto implements IDodajIzvodManuelnoCommand {

    constructor(data?: IDodajIzvodManuelnoCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DodajIzvodManuelnoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DodajIzvodManuelnoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDodajIzvodManuelnoCommand extends IIzvodDto {
}

export class ResultOfDecimal extends Result implements IResultOfDecimal {
    data?: number;

    constructor(data?: IResultOfDecimal) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ResultOfDecimal {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfDecimal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfDecimal extends IResult {
    data?: number;
}

export class TransakcijaIzvodaDto implements ITransakcijaIzvodaDto {
    id?: number | undefined;
    datumKnjizenja?: Date;
    datumValute?: Date;
    brojZaReklamaciju?: string | undefined;
    smerKnjizenja?: string | undefined;
    drugaStrana?: StrankaDto | undefined;
    drugaStranaNaziv?: string | undefined;
    drugaStranaRacun?: string | undefined;
    iznos?: number;
    oznakaValute?: string | undefined;
    svrhaPlacanja?: string | undefined;
    swift?: string | undefined;
    kategorijaIsplate?: KategorijaIsplate;
    sifraPlacanja?: string | undefined;
    izvodId?: number;
    pozivNaBroj?: string | undefined;

    constructor(data?: ITransakcijaIzvodaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.datumKnjizenja = _data["datumKnjizenja"] ? new Date(_data["datumKnjizenja"].toString()) : <any>undefined;
            this.datumValute = _data["datumValute"] ? new Date(_data["datumValute"].toString()) : <any>undefined;
            this.brojZaReklamaciju = _data["brojZaReklamaciju"];
            this.smerKnjizenja = _data["smerKnjizenja"];
            this.drugaStrana = _data["drugaStrana"] ? StrankaDto.fromJS(_data["drugaStrana"]) : <any>undefined;
            this.drugaStranaNaziv = _data["drugaStranaNaziv"];
            this.drugaStranaRacun = _data["drugaStranaRacun"];
            this.iznos = _data["iznos"];
            this.oznakaValute = _data["oznakaValute"];
            this.svrhaPlacanja = _data["svrhaPlacanja"];
            this.swift = _data["swift"];
            this.kategorijaIsplate = _data["kategorijaIsplate"];
            this.sifraPlacanja = _data["sifraPlacanja"];
            this.izvodId = _data["izvodId"];
            this.pozivNaBroj = _data["pozivNaBroj"];
        }
    }

    static fromJS(data: any): TransakcijaIzvodaDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransakcijaIzvodaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["datumKnjizenja"] = this.datumKnjizenja ? this.datumKnjizenja.toISOString() : <any>undefined;
        data["datumValute"] = this.datumValute ? this.datumValute.toISOString() : <any>undefined;
        data["brojZaReklamaciju"] = this.brojZaReklamaciju;
        data["smerKnjizenja"] = this.smerKnjizenja;
        data["drugaStrana"] = this.drugaStrana ? this.drugaStrana.toJSON() : <any>undefined;
        data["drugaStranaNaziv"] = this.drugaStranaNaziv;
        data["drugaStranaRacun"] = this.drugaStranaRacun;
        data["iznos"] = this.iznos;
        data["oznakaValute"] = this.oznakaValute;
        data["svrhaPlacanja"] = this.svrhaPlacanja;
        data["swift"] = this.swift;
        data["kategorijaIsplate"] = this.kategorijaIsplate;
        data["sifraPlacanja"] = this.sifraPlacanja;
        data["izvodId"] = this.izvodId;
        data["pozivNaBroj"] = this.pozivNaBroj;
        return data;
    }
}

export interface ITransakcijaIzvodaDto {
    id?: number | undefined;
    datumKnjizenja?: Date;
    datumValute?: Date;
    brojZaReklamaciju?: string | undefined;
    smerKnjizenja?: string | undefined;
    drugaStrana?: StrankaDto | undefined;
    drugaStranaNaziv?: string | undefined;
    drugaStranaRacun?: string | undefined;
    iznos?: number;
    oznakaValute?: string | undefined;
    svrhaPlacanja?: string | undefined;
    swift?: string | undefined;
    kategorijaIsplate?: KategorijaIsplate;
    sifraPlacanja?: string | undefined;
    izvodId?: number;
    pozivNaBroj?: string | undefined;
}

export class DodajTransakcijuManuelnoCommand extends TransakcijaIzvodaDto implements IDodajTransakcijuManuelnoCommand {

    constructor(data?: IDodajTransakcijuManuelnoCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DodajTransakcijuManuelnoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DodajTransakcijuManuelnoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDodajTransakcijuManuelnoCommand extends ITransakcijaIzvodaDto {
}

export class ResultOfGetJediniceMeraResponse extends Result implements IResultOfGetJediniceMeraResponse {
    data?: GetJediniceMeraResponse | undefined;

    constructor(data?: IResultOfGetJediniceMeraResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetJediniceMeraResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetJediniceMeraResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetJediniceMeraResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetJediniceMeraResponse extends IResult {
    data?: GetJediniceMeraResponse | undefined;
}

export class GetJediniceMeraResponse implements IGetJediniceMeraResponse {
    jediniceMeraDto?: JedinicaMereTableDto[] | undefined;

    constructor(data?: IGetJediniceMeraResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["jediniceMeraDto"])) {
                this.jediniceMeraDto = [] as any;
                for (let item of _data["jediniceMeraDto"])
                    this.jediniceMeraDto!.push(JedinicaMereTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJediniceMeraResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetJediniceMeraResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.jediniceMeraDto)) {
            data["jediniceMeraDto"] = [];
            for (let item of this.jediniceMeraDto)
                data["jediniceMeraDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJediniceMeraResponse {
    jediniceMeraDto?: JedinicaMereTableDto[] | undefined;
}

export class JedinicaMereTableDto implements IJedinicaMereTableDto {
    id?: number;
    skracenica?: string | undefined;
    naziv?: string | undefined;

    constructor(data?: IJedinicaMereTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skracenica = _data["skracenica"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): JedinicaMereTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new JedinicaMereTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skracenica"] = this.skracenica;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IJedinicaMereTableDto {
    id?: number;
    skracenica?: string | undefined;
    naziv?: string | undefined;
}

export class JediniceMeraVm implements IJediniceMeraVm {
    jediniceMera?: JedinicaMereDto[] | undefined;

    constructor(data?: IJediniceMeraVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["jediniceMera"])) {
                this.jediniceMera = [] as any;
                for (let item of _data["jediniceMera"])
                    this.jediniceMera!.push(JedinicaMereDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JediniceMeraVm {
        data = typeof data === 'object' ? data : {};
        let result = new JediniceMeraVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.jediniceMera)) {
            data["jediniceMera"] = [];
            for (let item of this.jediniceMera)
                data["jediniceMera"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJediniceMeraVm {
    jediniceMera?: JedinicaMereDto[] | undefined;
}

export class ResultOfGetJedinicaMereDropdownResponse extends Result implements IResultOfGetJedinicaMereDropdownResponse {
    data?: GetJedinicaMereDropdownResponse | undefined;

    constructor(data?: IResultOfGetJedinicaMereDropdownResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetJedinicaMereDropdownResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetJedinicaMereDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetJedinicaMereDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetJedinicaMereDropdownResponse extends IResult {
    data?: GetJedinicaMereDropdownResponse | undefined;
}

export class GetJedinicaMereDropdownResponse implements IGetJedinicaMereDropdownResponse {
    jedinicaMereDropdownDtoList?: JedinicaMereDropdownDto[] | undefined;

    constructor(data?: IGetJedinicaMereDropdownResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["jedinicaMereDropdownDtoList"])) {
                this.jedinicaMereDropdownDtoList = [] as any;
                for (let item of _data["jedinicaMereDropdownDtoList"])
                    this.jedinicaMereDropdownDtoList!.push(JedinicaMereDropdownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJedinicaMereDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetJedinicaMereDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.jedinicaMereDropdownDtoList)) {
            data["jedinicaMereDropdownDtoList"] = [];
            for (let item of this.jedinicaMereDropdownDtoList)
                data["jedinicaMereDropdownDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJedinicaMereDropdownResponse {
    jedinicaMereDropdownDtoList?: JedinicaMereDropdownDto[] | undefined;
}

export class JedinicaMereDropdownDto implements IJedinicaMereDropdownDto {
    id?: number;
    naziv?: string | undefined;

    constructor(data?: IJedinicaMereDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): JedinicaMereDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new JedinicaMereDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IJedinicaMereDropdownDto {
    id?: number;
    naziv?: string | undefined;
}

export class CreateJedinicaMereCommand extends JedinicaMereDto implements ICreateJedinicaMereCommand {

    constructor(data?: ICreateJedinicaMereCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateJedinicaMereCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJedinicaMereCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateJedinicaMereCommand extends IJedinicaMereDto {
}

export class UpdateJedinicaMereCommand extends JedinicaMereDto implements IUpdateJedinicaMereCommand {

    constructor(data?: IUpdateJedinicaMereCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateJedinicaMereCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJedinicaMereCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateJedinicaMereCommand extends IJedinicaMereDto {
}

export class PaginatedResultOfKalkulacijaTableDto extends Result implements IPaginatedResultOfKalkulacijaTableDto {
    data?: KalkulacijaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfKalkulacijaTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(KalkulacijaTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfKalkulacijaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfKalkulacijaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfKalkulacijaTableDto extends IResult {
    data?: KalkulacijaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class KalkulacijaTableDto implements IKalkulacijaTableDto {
    id?: number;
    broj?: string | undefined;
    datumIzdavanja?: string | undefined;

    constructor(data?: IKalkulacijaTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.datumIzdavanja = _data["datumIzdavanja"];
        }
    }

    static fromJS(data: any): KalkulacijaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new KalkulacijaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["datumIzdavanja"] = this.datumIzdavanja;
        return data;
    }
}

export interface IKalkulacijaTableDto {
    id?: number;
    broj?: string | undefined;
    datumIzdavanja?: string | undefined;
}

export class GetKalkulacijaTableQuery implements IGetKalkulacijaTableQuery {

    constructor(data?: IGetKalkulacijaTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetKalkulacijaTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetKalkulacijaTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetKalkulacijaTableQuery {
}

export class PaginatedResultOfKompenzacijaTableDto extends Result implements IPaginatedResultOfKompenzacijaTableDto {
    data?: KompenzacijaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfKompenzacijaTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(KompenzacijaTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfKompenzacijaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfKompenzacijaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfKompenzacijaTableDto extends IResult {
    data?: KompenzacijaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class KompenzacijaTableDto implements IKompenzacijaTableDto {
    id?: number;
    broj?: string | undefined;
    stranka?: RutiranjeStrankeDto | undefined;
    datumKreiranja?: string | undefined;
    razlika?: number;

    constructor(data?: IKompenzacijaTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.stranka = _data["stranka"] ? RutiranjeStrankeDto.fromJS(_data["stranka"]) : <any>undefined;
            this.datumKreiranja = _data["datumKreiranja"];
            this.razlika = _data["razlika"];
        }
    }

    static fromJS(data: any): KompenzacijaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new KompenzacijaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        data["datumKreiranja"] = this.datumKreiranja;
        data["razlika"] = this.razlika;
        return data;
    }
}

export interface IKompenzacijaTableDto {
    id?: number;
    broj?: string | undefined;
    stranka?: RutiranjeStrankeDto | undefined;
    datumKreiranja?: string | undefined;
    razlika?: number;
}

export class GetKompenzacijaTableQuery implements IGetKompenzacijaTableQuery {
    vrsta?: VrstaRacuna;
    pageNumber?: number;
    pageSize?: number;
    strankaId?: number | undefined;

    constructor(data?: IGetKompenzacijaTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vrsta = _data["vrsta"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.strankaId = _data["strankaId"];
        }
    }

    static fromJS(data: any): GetKompenzacijaTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetKompenzacijaTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vrsta"] = this.vrsta;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["strankaId"] = this.strankaId;
        return data;
    }
}

export interface IGetKompenzacijaTableQuery {
    vrsta?: VrstaRacuna;
    pageNumber?: number;
    pageSize?: number;
    strankaId?: number | undefined;
}

export class ResultOfKompenzacijaDto extends Result implements IResultOfKompenzacijaDto {
    data?: KompenzacijaDto | undefined;

    constructor(data?: IResultOfKompenzacijaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? KompenzacijaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfKompenzacijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfKompenzacijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfKompenzacijaDto extends IResult {
    data?: KompenzacijaDto | undefined;
}

export class KompenzacijaDto implements IKompenzacijaDto {
    kompenzacijaId?: number | undefined;
    broj?: string | undefined;
    tekuciRacunStranke?: string | undefined;
    strankaId?: number;
    stranka?: StrankaRacunaDto | undefined;
    tekuciRacunId?: number;
    razlika?: number;
    vrsta?: VrstaRacuna;
    napomena?: string | undefined;
    obavezePremaPoveriocu?: KompenzacionaObavezaDto[] | undefined;
    obavezePremaDuzniku?: KompenzacionaObavezaDto[] | undefined;

    constructor(data?: IKompenzacijaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kompenzacijaId = _data["kompenzacijaId"];
            this.broj = _data["broj"];
            this.tekuciRacunStranke = _data["tekuciRacunStranke"];
            this.strankaId = _data["strankaId"];
            this.stranka = _data["stranka"] ? StrankaRacunaDto.fromJS(_data["stranka"]) : <any>undefined;
            this.tekuciRacunId = _data["tekuciRacunId"];
            this.razlika = _data["razlika"];
            this.vrsta = _data["vrsta"];
            this.napomena = _data["napomena"];
            if (Array.isArray(_data["obavezePremaPoveriocu"])) {
                this.obavezePremaPoveriocu = [] as any;
                for (let item of _data["obavezePremaPoveriocu"])
                    this.obavezePremaPoveriocu!.push(KompenzacionaObavezaDto.fromJS(item));
            }
            if (Array.isArray(_data["obavezePremaDuzniku"])) {
                this.obavezePremaDuzniku = [] as any;
                for (let item of _data["obavezePremaDuzniku"])
                    this.obavezePremaDuzniku!.push(KompenzacionaObavezaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KompenzacijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new KompenzacijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kompenzacijaId"] = this.kompenzacijaId;
        data["broj"] = this.broj;
        data["tekuciRacunStranke"] = this.tekuciRacunStranke;
        data["strankaId"] = this.strankaId;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        data["tekuciRacunId"] = this.tekuciRacunId;
        data["razlika"] = this.razlika;
        data["vrsta"] = this.vrsta;
        data["napomena"] = this.napomena;
        if (Array.isArray(this.obavezePremaPoveriocu)) {
            data["obavezePremaPoveriocu"] = [];
            for (let item of this.obavezePremaPoveriocu)
                data["obavezePremaPoveriocu"].push(item.toJSON());
        }
        if (Array.isArray(this.obavezePremaDuzniku)) {
            data["obavezePremaDuzniku"] = [];
            for (let item of this.obavezePremaDuzniku)
                data["obavezePremaDuzniku"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKompenzacijaDto {
    kompenzacijaId?: number | undefined;
    broj?: string | undefined;
    tekuciRacunStranke?: string | undefined;
    strankaId?: number;
    stranka?: StrankaRacunaDto | undefined;
    tekuciRacunId?: number;
    razlika?: number;
    vrsta?: VrstaRacuna;
    napomena?: string | undefined;
    obavezePremaPoveriocu?: KompenzacionaObavezaDto[] | undefined;
    obavezePremaDuzniku?: KompenzacionaObavezaDto[] | undefined;
}

export class KompenzacionaObavezaDto implements IKompenzacionaObavezaDto {
    kompenzacionaObavezaId?: number | undefined;
    racunId?: number;
    poverilacId?: number | undefined;
    duznikId?: number | undefined;
    broj?: string | undefined;
    originalanBroj?: string | undefined;
    datumPrometa?: string | undefined;
    datumValute?: string | undefined;
    iznos?: number;
    ukupanIznosRacuna?: number;
    preostaloBezTrenutneObaveze?: number | undefined;

    constructor(data?: IKompenzacionaObavezaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kompenzacionaObavezaId = _data["kompenzacionaObavezaId"];
            this.racunId = _data["racunId"];
            this.poverilacId = _data["poverilacId"];
            this.duznikId = _data["duznikId"];
            this.broj = _data["broj"];
            this.originalanBroj = _data["originalanBroj"];
            this.datumPrometa = _data["datumPrometa"];
            this.datumValute = _data["datumValute"];
            this.iznos = _data["iznos"];
            this.ukupanIznosRacuna = _data["ukupanIznosRacuna"];
            this.preostaloBezTrenutneObaveze = _data["preostaloBezTrenutneObaveze"];
        }
    }

    static fromJS(data: any): KompenzacionaObavezaDto {
        data = typeof data === 'object' ? data : {};
        let result = new KompenzacionaObavezaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kompenzacionaObavezaId"] = this.kompenzacionaObavezaId;
        data["racunId"] = this.racunId;
        data["poverilacId"] = this.poverilacId;
        data["duznikId"] = this.duznikId;
        data["broj"] = this.broj;
        data["originalanBroj"] = this.originalanBroj;
        data["datumPrometa"] = this.datumPrometa;
        data["datumValute"] = this.datumValute;
        data["iznos"] = this.iznos;
        data["ukupanIznosRacuna"] = this.ukupanIznosRacuna;
        data["preostaloBezTrenutneObaveze"] = this.preostaloBezTrenutneObaveze;
        return data;
    }
}

export interface IKompenzacionaObavezaDto {
    kompenzacionaObavezaId?: number | undefined;
    racunId?: number;
    poverilacId?: number | undefined;
    duznikId?: number | undefined;
    broj?: string | undefined;
    originalanBroj?: string | undefined;
    datumPrometa?: string | undefined;
    datumValute?: string | undefined;
    iznos?: number;
    ukupanIznosRacuna?: number;
    preostaloBezTrenutneObaveze?: number | undefined;
}

export class CreateKompenzacijuCommand implements ICreateKompenzacijuCommand {
    kompenzacijaId?: number | undefined;
    broj?: string | undefined;
    tekuciRacunStranke?: string | undefined;
    stranka?: StrankaRacunaDto | undefined;
    napomena?: string | undefined;
    tekuciRacunId?: number;
    razlika?: number;
    vrsta?: VrstaRacuna;
    obavezePremaPoveriocu?: KompenzacionaObavezaDto[] | undefined;
    obavezePremaDuzniku?: KompenzacionaObavezaDto[] | undefined;

    constructor(data?: ICreateKompenzacijuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kompenzacijaId = _data["kompenzacijaId"];
            this.broj = _data["broj"];
            this.tekuciRacunStranke = _data["tekuciRacunStranke"];
            this.stranka = _data["stranka"] ? StrankaRacunaDto.fromJS(_data["stranka"]) : <any>undefined;
            this.napomena = _data["napomena"];
            this.tekuciRacunId = _data["tekuciRacunId"];
            this.razlika = _data["razlika"];
            this.vrsta = _data["vrsta"];
            if (Array.isArray(_data["obavezePremaPoveriocu"])) {
                this.obavezePremaPoveriocu = [] as any;
                for (let item of _data["obavezePremaPoveriocu"])
                    this.obavezePremaPoveriocu!.push(KompenzacionaObavezaDto.fromJS(item));
            }
            if (Array.isArray(_data["obavezePremaDuzniku"])) {
                this.obavezePremaDuzniku = [] as any;
                for (let item of _data["obavezePremaDuzniku"])
                    this.obavezePremaDuzniku!.push(KompenzacionaObavezaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateKompenzacijuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKompenzacijuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kompenzacijaId"] = this.kompenzacijaId;
        data["broj"] = this.broj;
        data["tekuciRacunStranke"] = this.tekuciRacunStranke;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        data["napomena"] = this.napomena;
        data["tekuciRacunId"] = this.tekuciRacunId;
        data["razlika"] = this.razlika;
        data["vrsta"] = this.vrsta;
        if (Array.isArray(this.obavezePremaPoveriocu)) {
            data["obavezePremaPoveriocu"] = [];
            for (let item of this.obavezePremaPoveriocu)
                data["obavezePremaPoveriocu"].push(item.toJSON());
        }
        if (Array.isArray(this.obavezePremaDuzniku)) {
            data["obavezePremaDuzniku"] = [];
            for (let item of this.obavezePremaDuzniku)
                data["obavezePremaDuzniku"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateKompenzacijuCommand {
    kompenzacijaId?: number | undefined;
    broj?: string | undefined;
    tekuciRacunStranke?: string | undefined;
    stranka?: StrankaRacunaDto | undefined;
    napomena?: string | undefined;
    tekuciRacunId?: number;
    razlika?: number;
    vrsta?: VrstaRacuna;
    obavezePremaPoveriocu?: KompenzacionaObavezaDto[] | undefined;
    obavezePremaDuzniku?: KompenzacionaObavezaDto[] | undefined;
}

export class UpdateKompenzacijuCommand implements IUpdateKompenzacijuCommand {
    kompenzacijaId?: number | undefined;
    broj?: string | undefined;
    tekuciRacunStranke?: string | undefined;
    stranka?: StrankaRacunaDto | undefined;
    napomena?: string | undefined;
    tekuciRacunId?: number;
    razlika?: number;
    vrsta?: VrstaRacuna;
    obavezePremaPoveriocu?: KompenzacionaObavezaDto[] | undefined;
    obavezePremaDuzniku?: KompenzacionaObavezaDto[] | undefined;

    constructor(data?: IUpdateKompenzacijuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kompenzacijaId = _data["kompenzacijaId"];
            this.broj = _data["broj"];
            this.tekuciRacunStranke = _data["tekuciRacunStranke"];
            this.stranka = _data["stranka"] ? StrankaRacunaDto.fromJS(_data["stranka"]) : <any>undefined;
            this.napomena = _data["napomena"];
            this.tekuciRacunId = _data["tekuciRacunId"];
            this.razlika = _data["razlika"];
            this.vrsta = _data["vrsta"];
            if (Array.isArray(_data["obavezePremaPoveriocu"])) {
                this.obavezePremaPoveriocu = [] as any;
                for (let item of _data["obavezePremaPoveriocu"])
                    this.obavezePremaPoveriocu!.push(KompenzacionaObavezaDto.fromJS(item));
            }
            if (Array.isArray(_data["obavezePremaDuzniku"])) {
                this.obavezePremaDuzniku = [] as any;
                for (let item of _data["obavezePremaDuzniku"])
                    this.obavezePremaDuzniku!.push(KompenzacionaObavezaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateKompenzacijuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateKompenzacijuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kompenzacijaId"] = this.kompenzacijaId;
        data["broj"] = this.broj;
        data["tekuciRacunStranke"] = this.tekuciRacunStranke;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        data["napomena"] = this.napomena;
        data["tekuciRacunId"] = this.tekuciRacunId;
        data["razlika"] = this.razlika;
        data["vrsta"] = this.vrsta;
        if (Array.isArray(this.obavezePremaPoveriocu)) {
            data["obavezePremaPoveriocu"] = [];
            for (let item of this.obavezePremaPoveriocu)
                data["obavezePremaPoveriocu"].push(item.toJSON());
        }
        if (Array.isArray(this.obavezePremaDuzniku)) {
            data["obavezePremaDuzniku"] = [];
            for (let item of this.obavezePremaDuzniku)
                data["obavezePremaDuzniku"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateKompenzacijuCommand {
    kompenzacijaId?: number | undefined;
    broj?: string | undefined;
    tekuciRacunStranke?: string | undefined;
    stranka?: StrankaRacunaDto | undefined;
    napomena?: string | undefined;
    tekuciRacunId?: number;
    razlika?: number;
    vrsta?: VrstaRacuna;
    obavezePremaPoveriocu?: KompenzacionaObavezaDto[] | undefined;
    obavezePremaDuzniku?: KompenzacionaObavezaDto[] | undefined;
}

export class ResultOfKontaktiTableVm extends Result implements IResultOfKontaktiTableVm {
    data?: KontaktiTableVm | undefined;

    constructor(data?: IResultOfKontaktiTableVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? KontaktiTableVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfKontaktiTableVm {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfKontaktiTableVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfKontaktiTableVm extends IResult {
    data?: KontaktiTableVm | undefined;
}

export class KontaktiTableVm implements IKontaktiTableVm {
    kontaktiTable?: KontaktTableDto[] | undefined;

    constructor(data?: IKontaktiTableVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["kontaktiTable"])) {
                this.kontaktiTable = [] as any;
                for (let item of _data["kontaktiTable"])
                    this.kontaktiTable!.push(KontaktTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KontaktiTableVm {
        data = typeof data === 'object' ? data : {};
        let result = new KontaktiTableVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.kontaktiTable)) {
            data["kontaktiTable"] = [];
            for (let item of this.kontaktiTable)
                data["kontaktiTable"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKontaktiTableVm {
    kontaktiTable?: KontaktTableDto[] | undefined;
}

export class KontaktTableDto implements IKontaktTableDto {
    id?: number;
    naziv?: string | undefined;
    telefon1?: string | undefined;
    telefon2?: string | undefined;
    telefon3?: string | undefined;
    email?: string | undefined;
    websiteUrl?: string | undefined;
    nazivStranke?: string | undefined;
    funkcija?: string | undefined;

    constructor(data?: IKontaktTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.telefon1 = _data["telefon1"];
            this.telefon2 = _data["telefon2"];
            this.telefon3 = _data["telefon3"];
            this.email = _data["email"];
            this.websiteUrl = _data["websiteUrl"];
            this.nazivStranke = _data["nazivStranke"];
            this.funkcija = _data["funkcija"];
        }
    }

    static fromJS(data: any): KontaktTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new KontaktTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["telefon1"] = this.telefon1;
        data["telefon2"] = this.telefon2;
        data["telefon3"] = this.telefon3;
        data["email"] = this.email;
        data["websiteUrl"] = this.websiteUrl;
        data["nazivStranke"] = this.nazivStranke;
        data["funkcija"] = this.funkcija;
        return data;
    }
}

export interface IKontaktTableDto {
    id?: number;
    naziv?: string | undefined;
    telefon1?: string | undefined;
    telefon2?: string | undefined;
    telefon3?: string | undefined;
    email?: string | undefined;
    websiteUrl?: string | undefined;
    nazivStranke?: string | undefined;
    funkcija?: string | undefined;
}

export class ResultOfKontaktDto extends Result implements IResultOfKontaktDto {
    data?: KontaktDto | undefined;

    constructor(data?: IResultOfKontaktDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? KontaktDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfKontaktDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfKontaktDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfKontaktDto extends IResult {
    data?: KontaktDto | undefined;
}

export class ResultOfGetKontaktiOdStrankaResponse extends Result implements IResultOfGetKontaktiOdStrankaResponse {
    data?: GetKontaktiOdStrankaResponse | undefined;

    constructor(data?: IResultOfGetKontaktiOdStrankaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetKontaktiOdStrankaResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetKontaktiOdStrankaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetKontaktiOdStrankaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetKontaktiOdStrankaResponse extends IResult {
    data?: GetKontaktiOdStrankaResponse | undefined;
}

export class GetKontaktiOdStrankaResponse implements IGetKontaktiOdStrankaResponse {
    kontakti?: MailReceiverDto[] | undefined;

    constructor(data?: IGetKontaktiOdStrankaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["kontakti"])) {
                this.kontakti = [] as any;
                for (let item of _data["kontakti"])
                    this.kontakti!.push(MailReceiverDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetKontaktiOdStrankaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetKontaktiOdStrankaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.kontakti)) {
            data["kontakti"] = [];
            for (let item of this.kontakti)
                data["kontakti"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetKontaktiOdStrankaResponse {
    kontakti?: MailReceiverDto[] | undefined;
}

export class MailReceiverDto implements IMailReceiverDto {
    email?: string | undefined;
    name?: string | undefined;
    isNew?: boolean;

    constructor(data?: IMailReceiverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.name = _data["name"];
            this.isNew = _data["isNew"];
        }
    }

    static fromJS(data: any): MailReceiverDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailReceiverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["name"] = this.name;
        data["isNew"] = this.isNew;
        return data;
    }
}

export interface IMailReceiverDto {
    email?: string | undefined;
    name?: string | undefined;
    isNew?: boolean;
}

export class CreateKontaktCommand extends KontaktDto implements ICreateKontaktCommand {

    constructor(data?: ICreateKontaktCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateKontaktCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKontaktCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateKontaktCommand extends IKontaktDto {
}

export class UpdateKontaktCommand extends KontaktDto implements IUpdateKontaktCommand {

    constructor(data?: IUpdateKontaktCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateKontaktCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateKontaktCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateKontaktCommand extends IKontaktDto {
}

export class CreateKontaktFromEmailCommand implements ICreateKontaktFromEmailCommand {
    strankaId?: number | undefined;
    kontakti?: MailReceiverDto[] | undefined;

    constructor(data?: ICreateKontaktFromEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.strankaId = _data["strankaId"];
            if (Array.isArray(_data["kontakti"])) {
                this.kontakti = [] as any;
                for (let item of _data["kontakti"])
                    this.kontakti!.push(MailReceiverDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateKontaktFromEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKontaktFromEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["strankaId"] = this.strankaId;
        if (Array.isArray(this.kontakti)) {
            data["kontakti"] = [];
            for (let item of this.kontakti)
                data["kontakti"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateKontaktFromEmailCommand {
    strankaId?: number | undefined;
    kontakti?: MailReceiverDto[] | undefined;
}

export class ResultOfKorisnikTableDto extends Result implements IResultOfKorisnikTableDto {
    data?: KorisnikTableDto | undefined;

    constructor(data?: IResultOfKorisnikTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? KorisnikTableDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfKorisnikTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfKorisnikTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfKorisnikTableDto extends IResult {
    data?: KorisnikTableDto | undefined;
}

export class KorisnikTableDto implements IKorisnikTableDto {
    id?: string | undefined;
    name?: string | undefined;
    imageUrl?: string | undefined;
    isActive?: string | undefined;
    email?: string | undefined;
    emailConfirmed?: string | undefined;
    phoneNumber?: string | undefined;
    roleNames?: string | undefined;

    constructor(data?: IKorisnikTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.imageUrl = _data["imageUrl"];
            this.isActive = _data["isActive"];
            this.email = _data["email"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.phoneNumber = _data["phoneNumber"];
            this.roleNames = _data["roleNames"];
        }
    }

    static fromJS(data: any): KorisnikTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new KorisnikTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["imageUrl"] = this.imageUrl;
        data["isActive"] = this.isActive;
        data["email"] = this.email;
        data["emailConfirmed"] = this.emailConfirmed;
        data["phoneNumber"] = this.phoneNumber;
        data["roleNames"] = this.roleNames;
        return data;
    }
}

export interface IKorisnikTableDto {
    id?: string | undefined;
    name?: string | undefined;
    imageUrl?: string | undefined;
    isActive?: string | undefined;
    email?: string | undefined;
    emailConfirmed?: string | undefined;
    phoneNumber?: string | undefined;
    roleNames?: string | undefined;
}

export class UpdateKorisnikCommand implements IUpdateKorisnikCommand {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    mobilniDto?: MobilniTelefonDto | undefined;
    password?: string | undefined;
    passwordCheck?: string | undefined;
    image?: FileUploadRequestOfIFormFile | undefined;
    emailConfirmed?: boolean | undefined;
    phoneNumberConfirmed?: boolean | undefined;
    isActive?: boolean | undefined;
    poslovnaJedinicaId?: number | undefined;

    constructor(data?: IUpdateKorisnikCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.mobilniDto = _data["mobilniDto"] ? MobilniTelefonDto.fromJS(_data["mobilniDto"]) : <any>undefined;
            this.password = _data["password"];
            this.passwordCheck = _data["passwordCheck"];
            this.image = _data["image"] ? FileUploadRequestOfIFormFile.fromJS(_data["image"]) : <any>undefined;
            this.emailConfirmed = _data["emailConfirmed"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.isActive = _data["isActive"];
            this.poslovnaJedinicaId = _data["poslovnaJedinicaId"];
        }
    }

    static fromJS(data: any): UpdateKorisnikCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateKorisnikCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["mobilniDto"] = this.mobilniDto ? this.mobilniDto.toJSON() : <any>undefined;
        data["password"] = this.password;
        data["passwordCheck"] = this.passwordCheck;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["emailConfirmed"] = this.emailConfirmed;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["isActive"] = this.isActive;
        data["poslovnaJedinicaId"] = this.poslovnaJedinicaId;
        return data;
    }
}

export interface IUpdateKorisnikCommand {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    mobilniDto?: MobilniTelefonDto | undefined;
    password?: string | undefined;
    passwordCheck?: string | undefined;
    image?: FileUploadRequestOfIFormFile | undefined;
    emailConfirmed?: boolean | undefined;
    phoneNumberConfirmed?: boolean | undefined;
    isActive?: boolean | undefined;
    poslovnaJedinicaId?: number | undefined;
}

export class MobilniTelefonDto implements IMobilniTelefonDto {
    pozivniBroj?: string | undefined;
    brojTelefona?: string | undefined;
    getMobilniTelefon?: string | undefined;

    constructor(data?: IMobilniTelefonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pozivniBroj = _data["pozivniBroj"];
            this.brojTelefona = _data["brojTelefona"];
            this.getMobilniTelefon = _data["getMobilniTelefon"];
        }
    }

    static fromJS(data: any): MobilniTelefonDto {
        data = typeof data === 'object' ? data : {};
        let result = new MobilniTelefonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pozivniBroj"] = this.pozivniBroj;
        data["brojTelefona"] = this.brojTelefona;
        data["getMobilniTelefon"] = this.getMobilniTelefon;
        return data;
    }
}

export interface IMobilniTelefonDto {
    pozivniBroj?: string | undefined;
    brojTelefona?: string | undefined;
    getMobilniTelefon?: string | undefined;
}

export class FileUploadRequestOfIFormFile implements IFileUploadRequestOfIFormFile {
    name?: string | undefined;
    contentType?: string | undefined;
    data?: string | undefined;
    folderName?: string | undefined;

    constructor(data?: IFileUploadRequestOfIFormFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.contentType = _data["contentType"];
            this.data = _data["data"];
            this.folderName = _data["folderName"];
        }
    }

    static fromJS(data: any): FileUploadRequestOfIFormFile {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadRequestOfIFormFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["contentType"] = this.contentType;
        data["data"] = this.data;
        data["folderName"] = this.folderName;
        return data;
    }
}

export interface IFileUploadRequestOfIFormFile {
    name?: string | undefined;
    contentType?: string | undefined;
    data?: string | undefined;
    folderName?: string | undefined;
}

export class ResetPasswordKorisnikCommand implements IResetPasswordKorisnikCommand {
    korisnikEmail?: string | undefined;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
    newPasswordCheck?: string | undefined;

    constructor(data?: IResetPasswordKorisnikCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.korisnikEmail = _data["korisnikEmail"];
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
            this.newPasswordCheck = _data["newPasswordCheck"];
        }
    }

    static fromJS(data: any): ResetPasswordKorisnikCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordKorisnikCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["korisnikEmail"] = this.korisnikEmail;
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        data["newPasswordCheck"] = this.newPasswordCheck;
        return data;
    }
}

export interface IResetPasswordKorisnikCommand {
    korisnikEmail?: string | undefined;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
    newPasswordCheck?: string | undefined;
}

export class CreateKorisnickaGrupaCommand implements ICreateKorisnickaGrupaCommand {
    id?: string | undefined;
    naziv?: string | undefined;
    opis?: string | undefined;
    ovlascenjaDto?: KeyValuePairOfStringAndString[] | undefined;

    constructor(data?: ICreateKorisnickaGrupaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.opis = _data["opis"];
            if (Array.isArray(_data["ovlascenjaDto"])) {
                this.ovlascenjaDto = [] as any;
                for (let item of _data["ovlascenjaDto"])
                    this.ovlascenjaDto!.push(KeyValuePairOfStringAndString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateKorisnickaGrupaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKorisnickaGrupaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["opis"] = this.opis;
        if (Array.isArray(this.ovlascenjaDto)) {
            data["ovlascenjaDto"] = [];
            for (let item of this.ovlascenjaDto)
                data["ovlascenjaDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateKorisnickaGrupaCommand {
    id?: string | undefined;
    naziv?: string | undefined;
    opis?: string | undefined;
    ovlascenjaDto?: KeyValuePairOfStringAndString[] | undefined;
}

export class KeyValuePairOfStringAndString implements IKeyValuePairOfStringAndString {
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IKeyValuePairOfStringAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePairOfStringAndString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IKeyValuePairOfStringAndString {
    key?: string | undefined;
    value?: string | undefined;
}

export class UpdateKorisnickaGrupaCommand implements IUpdateKorisnickaGrupaCommand {
    id?: string | undefined;
    naziv?: string | undefined;
    opis?: string | undefined;
    ovlascenjaDto?: KeyValuePairOfStringAndString[] | undefined;

    constructor(data?: IUpdateKorisnickaGrupaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.opis = _data["opis"];
            if (Array.isArray(_data["ovlascenjaDto"])) {
                this.ovlascenjaDto = [] as any;
                for (let item of _data["ovlascenjaDto"])
                    this.ovlascenjaDto!.push(KeyValuePairOfStringAndString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateKorisnickaGrupaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateKorisnickaGrupaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["opis"] = this.opis;
        if (Array.isArray(this.ovlascenjaDto)) {
            data["ovlascenjaDto"] = [];
            for (let item of this.ovlascenjaDto)
                data["ovlascenjaDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateKorisnickaGrupaCommand {
    id?: string | undefined;
    naziv?: string | undefined;
    opis?: string | undefined;
    ovlascenjaDto?: KeyValuePairOfStringAndString[] | undefined;
}

export class ResultOfKorisnikTableDtoResponse extends Result implements IResultOfKorisnikTableDtoResponse {
    data?: KorisnikTableDtoResponse | undefined;

    constructor(data?: IResultOfKorisnikTableDtoResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? KorisnikTableDtoResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfKorisnikTableDtoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfKorisnikTableDtoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfKorisnikTableDtoResponse extends IResult {
    data?: KorisnikTableDtoResponse | undefined;
}

export class KorisnikTableDtoResponse implements IKorisnikTableDtoResponse {
    korisnici?: KorisnikTableDto[] | undefined;

    constructor(data?: IKorisnikTableDtoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["korisnici"])) {
                this.korisnici = [] as any;
                for (let item of _data["korisnici"])
                    this.korisnici!.push(KorisnikTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KorisnikTableDtoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KorisnikTableDtoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.korisnici)) {
            data["korisnici"] = [];
            for (let item of this.korisnici)
                data["korisnici"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKorisnikTableDtoResponse {
    korisnici?: KorisnikTableDto[] | undefined;
}

export class ResultOfGetKorisnickaGrupaListResponse extends Result implements IResultOfGetKorisnickaGrupaListResponse {
    data?: GetKorisnickaGrupaListResponse | undefined;

    constructor(data?: IResultOfGetKorisnickaGrupaListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetKorisnickaGrupaListResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetKorisnickaGrupaListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetKorisnickaGrupaListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetKorisnickaGrupaListResponse extends IResult {
    data?: GetKorisnickaGrupaListResponse | undefined;
}

export class GetKorisnickaGrupaListResponse implements IGetKorisnickaGrupaListResponse {
    korisnickaGrupaCardDtoList?: KorisnickaGrupaCardDto[] | undefined;

    constructor(data?: IGetKorisnickaGrupaListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["korisnickaGrupaCardDtoList"])) {
                this.korisnickaGrupaCardDtoList = [] as any;
                for (let item of _data["korisnickaGrupaCardDtoList"])
                    this.korisnickaGrupaCardDtoList!.push(KorisnickaGrupaCardDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetKorisnickaGrupaListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetKorisnickaGrupaListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.korisnickaGrupaCardDtoList)) {
            data["korisnickaGrupaCardDtoList"] = [];
            for (let item of this.korisnickaGrupaCardDtoList)
                data["korisnickaGrupaCardDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetKorisnickaGrupaListResponse {
    korisnickaGrupaCardDtoList?: KorisnickaGrupaCardDto[] | undefined;
}

export class KorisnickaGrupaCardDto implements IKorisnickaGrupaCardDto {
    id?: string | undefined;
    naziv?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IKorisnickaGrupaCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): KorisnickaGrupaCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new KorisnickaGrupaCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IKorisnickaGrupaCardDto {
    id?: string | undefined;
    naziv?: string | undefined;
    opis?: string | undefined;
}

export class ResultOfGetKorisnickeZaGrupuResponse extends Result implements IResultOfGetKorisnickeZaGrupuResponse {
    data?: GetKorisnickeZaGrupuResponse | undefined;

    constructor(data?: IResultOfGetKorisnickeZaGrupuResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetKorisnickeZaGrupuResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetKorisnickeZaGrupuResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetKorisnickeZaGrupuResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetKorisnickeZaGrupuResponse extends IResult {
    data?: GetKorisnickeZaGrupuResponse | undefined;
}

export class GetKorisnickeZaGrupuResponse implements IGetKorisnickeZaGrupuResponse {
    korisnikZaGrupuDtoList?: KorisnikZaGrupuDto[] | undefined;

    constructor(data?: IGetKorisnickeZaGrupuResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["korisnikZaGrupuDtoList"])) {
                this.korisnikZaGrupuDtoList = [] as any;
                for (let item of _data["korisnikZaGrupuDtoList"])
                    this.korisnikZaGrupuDtoList!.push(KorisnikZaGrupuDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetKorisnickeZaGrupuResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetKorisnickeZaGrupuResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.korisnikZaGrupuDtoList)) {
            data["korisnikZaGrupuDtoList"] = [];
            for (let item of this.korisnikZaGrupuDtoList)
                data["korisnikZaGrupuDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetKorisnickeZaGrupuResponse {
    korisnikZaGrupuDtoList?: KorisnikZaGrupuDto[] | undefined;
}

export class KorisnikZaGrupuDto implements IKorisnikZaGrupuDto {
    id?: string | undefined;
    naziv?: string | undefined;
    email?: string | undefined;

    constructor(data?: IKorisnikZaGrupuDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): KorisnikZaGrupuDto {
        data = typeof data === 'object' ? data : {};
        let result = new KorisnikZaGrupuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["email"] = this.email;
        return data;
    }
}

export interface IKorisnikZaGrupuDto {
    id?: string | undefined;
    naziv?: string | undefined;
    email?: string | undefined;
}

export class ResultOfGetKorisnikAutocompleteResponse extends Result implements IResultOfGetKorisnikAutocompleteResponse {
    data?: GetKorisnikAutocompleteResponse | undefined;

    constructor(data?: IResultOfGetKorisnikAutocompleteResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetKorisnikAutocompleteResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetKorisnikAutocompleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetKorisnikAutocompleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetKorisnikAutocompleteResponse extends IResult {
    data?: GetKorisnikAutocompleteResponse | undefined;
}

export class GetKorisnikAutocompleteResponse implements IGetKorisnikAutocompleteResponse {
    korisnikAutocompleteDtoList?: KorisnikAutocompleteDto[] | undefined;

    constructor(data?: IGetKorisnikAutocompleteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["korisnikAutocompleteDtoList"])) {
                this.korisnikAutocompleteDtoList = [] as any;
                for (let item of _data["korisnikAutocompleteDtoList"])
                    this.korisnikAutocompleteDtoList!.push(KorisnikAutocompleteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetKorisnikAutocompleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetKorisnikAutocompleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.korisnikAutocompleteDtoList)) {
            data["korisnikAutocompleteDtoList"] = [];
            for (let item of this.korisnikAutocompleteDtoList)
                data["korisnikAutocompleteDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetKorisnikAutocompleteResponse {
    korisnikAutocompleteDtoList?: KorisnikAutocompleteDto[] | undefined;
}

export class KorisnikAutocompleteDto implements IKorisnikAutocompleteDto {
    id?: string | undefined;
    naziv?: string | undefined;
    email?: string | undefined;
    roles?: string | undefined;

    constructor(data?: IKorisnikAutocompleteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.email = _data["email"];
            this.roles = _data["roles"];
        }
    }

    static fromJS(data: any): KorisnikAutocompleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new KorisnikAutocompleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["email"] = this.email;
        data["roles"] = this.roles;
        return data;
    }
}

export interface IKorisnikAutocompleteDto {
    id?: string | undefined;
    naziv?: string | undefined;
    email?: string | undefined;
    roles?: string | undefined;
}

export class ResultOfKorisnikDto extends Result implements IResultOfKorisnikDto {
    data?: KorisnikDto | undefined;

    constructor(data?: IResultOfKorisnikDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? KorisnikDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfKorisnikDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfKorisnikDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfKorisnikDto extends IResult {
    data?: KorisnikDto | undefined;
}

export class KorisnikDto implements IKorisnikDto {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    passwordCheck?: string | undefined;
    mobilniDto?: MobilniTelefonDto | undefined;
    emailConfirmed?: boolean | undefined;
    phoneNumberConfirmed?: boolean | undefined;
    isActive?: boolean | undefined;
    poslovnaJedinicaId?: number | undefined;

    constructor(data?: IKorisnikDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.passwordCheck = _data["passwordCheck"];
            this.mobilniDto = _data["mobilniDto"] ? MobilniTelefonDto.fromJS(_data["mobilniDto"]) : <any>undefined;
            this.emailConfirmed = _data["emailConfirmed"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.isActive = _data["isActive"];
            this.poslovnaJedinicaId = _data["poslovnaJedinicaId"];
        }
    }

    static fromJS(data: any): KorisnikDto {
        data = typeof data === 'object' ? data : {};
        let result = new KorisnikDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["password"] = this.password;
        data["passwordCheck"] = this.passwordCheck;
        data["mobilniDto"] = this.mobilniDto ? this.mobilniDto.toJSON() : <any>undefined;
        data["emailConfirmed"] = this.emailConfirmed;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["isActive"] = this.isActive;
        data["poslovnaJedinicaId"] = this.poslovnaJedinicaId;
        return data;
    }
}

export interface IKorisnikDto {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    passwordCheck?: string | undefined;
    mobilniDto?: MobilniTelefonDto | undefined;
    emailConfirmed?: boolean | undefined;
    phoneNumberConfirmed?: boolean | undefined;
    isActive?: boolean | undefined;
    poslovnaJedinicaId?: number | undefined;
}

export class GetKorisnikQuery implements IGetKorisnikQuery {
    email?: string | undefined;

    constructor(data?: IGetKorisnikQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): GetKorisnikQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetKorisnikQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IGetKorisnikQuery {
    email?: string | undefined;
}

export class InviteKorisnikCommand implements IInviteKorisnikCommand {
    email?: string | undefined;
    roleId?: string | undefined;
    poslovnaJedinicaId?: number;
    origin?: string | undefined;

    constructor(data?: IInviteKorisnikCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.roleId = _data["roleId"];
            this.poslovnaJedinicaId = _data["poslovnaJedinicaId"];
            this.origin = _data["origin"];
        }
    }

    static fromJS(data: any): InviteKorisnikCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InviteKorisnikCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["roleId"] = this.roleId;
        data["poslovnaJedinicaId"] = this.poslovnaJedinicaId;
        data["origin"] = this.origin;
        return data;
    }
}

export interface IInviteKorisnikCommand {
    email?: string | undefined;
    roleId?: string | undefined;
    poslovnaJedinicaId?: number;
    origin?: string | undefined;
}

export class ResultOfGetKorisnikTenantAccessResponse extends Result implements IResultOfGetKorisnikTenantAccessResponse {
    data?: GetKorisnikTenantAccessResponse | undefined;

    constructor(data?: IResultOfGetKorisnikTenantAccessResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetKorisnikTenantAccessResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetKorisnikTenantAccessResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetKorisnikTenantAccessResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetKorisnikTenantAccessResponse extends IResult {
    data?: GetKorisnikTenantAccessResponse | undefined;
}

export class GetKorisnikTenantAccessResponse implements IGetKorisnikTenantAccessResponse {
    korisnikTenantAccesses?: KorisnikTenantAccessDto[] | undefined;

    constructor(data?: IGetKorisnikTenantAccessResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["korisnikTenantAccesses"])) {
                this.korisnikTenantAccesses = [] as any;
                for (let item of _data["korisnikTenantAccesses"])
                    this.korisnikTenantAccesses!.push(KorisnikTenantAccessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetKorisnikTenantAccessResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetKorisnikTenantAccessResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.korisnikTenantAccesses)) {
            data["korisnikTenantAccesses"] = [];
            for (let item of this.korisnikTenantAccesses)
                data["korisnikTenantAccesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetKorisnikTenantAccessResponse {
    korisnikTenantAccesses?: KorisnikTenantAccessDto[] | undefined;
}

export class KorisnikTenantAccessDto implements IKorisnikTenantAccessDto {
    tenantKey?: string | undefined;
    tenantName?: string | undefined;

    constructor(data?: IKorisnikTenantAccessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantKey = _data["tenantKey"];
            this.tenantName = _data["tenantName"];
        }
    }

    static fromJS(data: any): KorisnikTenantAccessDto {
        data = typeof data === 'object' ? data : {};
        let result = new KorisnikTenantAccessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantKey"] = this.tenantKey;
        data["tenantName"] = this.tenantName;
        return data;
    }
}

export interface IKorisnikTenantAccessDto {
    tenantKey?: string | undefined;
    tenantName?: string | undefined;
}

export class ResultOfKorisnickaGrupaDto extends Result implements IResultOfKorisnickaGrupaDto {
    data?: KorisnickaGrupaDto | undefined;

    constructor(data?: IResultOfKorisnickaGrupaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? KorisnickaGrupaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfKorisnickaGrupaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfKorisnickaGrupaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfKorisnickaGrupaDto extends IResult {
    data?: KorisnickaGrupaDto | undefined;
}

export class KorisnickaGrupaDto implements IKorisnickaGrupaDto {
    id?: string | undefined;
    naziv?: string | undefined;
    opis?: string | undefined;
    ovlascenjaDto?: KeyValuePairOfStringAndString[] | undefined;

    constructor(data?: IKorisnickaGrupaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.opis = _data["opis"];
            if (Array.isArray(_data["ovlascenjaDto"])) {
                this.ovlascenjaDto = [] as any;
                for (let item of _data["ovlascenjaDto"])
                    this.ovlascenjaDto!.push(KeyValuePairOfStringAndString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KorisnickaGrupaDto {
        data = typeof data === 'object' ? data : {};
        let result = new KorisnickaGrupaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["opis"] = this.opis;
        if (Array.isArray(this.ovlascenjaDto)) {
            data["ovlascenjaDto"] = [];
            for (let item of this.ovlascenjaDto)
                data["ovlascenjaDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKorisnickaGrupaDto {
    id?: string | undefined;
    naziv?: string | undefined;
    opis?: string | undefined;
    ovlascenjaDto?: KeyValuePairOfStringAndString[] | undefined;
}

export class ResultOfGetOvlascenjaResponse extends Result implements IResultOfGetOvlascenjaResponse {
    data?: GetOvlascenjaResponse | undefined;

    constructor(data?: IResultOfGetOvlascenjaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetOvlascenjaResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetOvlascenjaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetOvlascenjaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetOvlascenjaResponse extends IResult {
    data?: GetOvlascenjaResponse | undefined;
}

export class GetOvlascenjaResponse implements IGetOvlascenjaResponse {
    ovlascenjeDtoListPoGrupi?: PermissionsPerGroupResponse[] | undefined;

    constructor(data?: IGetOvlascenjaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ovlascenjeDtoListPoGrupi"])) {
                this.ovlascenjeDtoListPoGrupi = [] as any;
                for (let item of _data["ovlascenjeDtoListPoGrupi"])
                    this.ovlascenjeDtoListPoGrupi!.push(PermissionsPerGroupResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOvlascenjaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOvlascenjaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ovlascenjeDtoListPoGrupi)) {
            data["ovlascenjeDtoListPoGrupi"] = [];
            for (let item of this.ovlascenjeDtoListPoGrupi)
                data["ovlascenjeDtoListPoGrupi"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOvlascenjaResponse {
    ovlascenjeDtoListPoGrupi?: PermissionsPerGroupResponse[] | undefined;
}

export class PermissionsPerGroupResponse implements IPermissionsPerGroupResponse {
    groupName?: string | undefined;
    persmissions?: KeyValuePairOfStringAndString[] | undefined;

    constructor(data?: IPermissionsPerGroupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["persmissions"])) {
                this.persmissions = [] as any;
                for (let item of _data["persmissions"])
                    this.persmissions!.push(KeyValuePairOfStringAndString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionsPerGroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionsPerGroupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        if (Array.isArray(this.persmissions)) {
            data["persmissions"] = [];
            for (let item of this.persmissions)
                data["persmissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPermissionsPerGroupResponse {
    groupName?: string | undefined;
    persmissions?: KeyValuePairOfStringAndString[] | undefined;
}

export class ResultOfGetKorisnickaGrupaDropdownResponse extends Result implements IResultOfGetKorisnickaGrupaDropdownResponse {
    data?: GetKorisnickaGrupaDropdownResponse | undefined;

    constructor(data?: IResultOfGetKorisnickaGrupaDropdownResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetKorisnickaGrupaDropdownResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetKorisnickaGrupaDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetKorisnickaGrupaDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetKorisnickaGrupaDropdownResponse extends IResult {
    data?: GetKorisnickaGrupaDropdownResponse | undefined;
}

export class GetKorisnickaGrupaDropdownResponse implements IGetKorisnickaGrupaDropdownResponse {
    korisnickaGrupaDropdownDtoList?: KorisnickaGrupaDropdownDto[] | undefined;

    constructor(data?: IGetKorisnickaGrupaDropdownResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["korisnickaGrupaDropdownDtoList"])) {
                this.korisnickaGrupaDropdownDtoList = [] as any;
                for (let item of _data["korisnickaGrupaDropdownDtoList"])
                    this.korisnickaGrupaDropdownDtoList!.push(KorisnickaGrupaDropdownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetKorisnickaGrupaDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetKorisnickaGrupaDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.korisnickaGrupaDropdownDtoList)) {
            data["korisnickaGrupaDropdownDtoList"] = [];
            for (let item of this.korisnickaGrupaDropdownDtoList)
                data["korisnickaGrupaDropdownDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetKorisnickaGrupaDropdownResponse {
    korisnickaGrupaDropdownDtoList?: KorisnickaGrupaDropdownDto[] | undefined;
}

export class KorisnickaGrupaDropdownDto implements IKorisnickaGrupaDropdownDto {
    id?: string | undefined;
    naziv?: string | undefined;

    constructor(data?: IKorisnickaGrupaDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): KorisnickaGrupaDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new KorisnickaGrupaDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IKorisnickaGrupaDropdownDto {
    id?: string | undefined;
    naziv?: string | undefined;
}

export class SendVerificationEmailCommand implements ISendVerificationEmailCommand {
    korisnikEmail?: string | undefined;
    origin?: string | undefined;

    constructor(data?: ISendVerificationEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.korisnikEmail = _data["korisnikEmail"];
            this.origin = _data["origin"];
        }
    }

    static fromJS(data: any): SendVerificationEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["korisnikEmail"] = this.korisnikEmail;
        data["origin"] = this.origin;
        return data;
    }
}

export interface ISendVerificationEmailCommand {
    korisnikEmail?: string | undefined;
    origin?: string | undefined;
}

export class ChangeActivityCommand implements IChangeActivityCommand {
    id?: string | undefined;
    isActivated?: boolean;

    constructor(data?: IChangeActivityCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActivated = _data["isActivated"];
        }
    }

    static fromJS(data: any): ChangeActivityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeActivityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActivated"] = this.isActivated;
        return data;
    }
}

export interface IChangeActivityCommand {
    id?: string | undefined;
    isActivated?: boolean;
}

export class SendSmsConfirmationCodeKorisnikCommand implements ISendSmsConfirmationCodeKorisnikCommand {
    korisnikEmail?: string | undefined;
    pozivniBroj?: string | undefined;
    brojTelefona?: string | undefined;
    getMobilniTelefon?: string | undefined;

    constructor(data?: ISendSmsConfirmationCodeKorisnikCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.korisnikEmail = _data["korisnikEmail"];
            this.pozivniBroj = _data["pozivniBroj"];
            this.brojTelefona = _data["brojTelefona"];
            this.getMobilniTelefon = _data["getMobilniTelefon"];
        }
    }

    static fromJS(data: any): SendSmsConfirmationCodeKorisnikCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendSmsConfirmationCodeKorisnikCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["korisnikEmail"] = this.korisnikEmail;
        data["pozivniBroj"] = this.pozivniBroj;
        data["brojTelefona"] = this.brojTelefona;
        data["getMobilniTelefon"] = this.getMobilniTelefon;
        return data;
    }
}

export interface ISendSmsConfirmationCodeKorisnikCommand {
    korisnikEmail?: string | undefined;
    pozivniBroj?: string | undefined;
    brojTelefona?: string | undefined;
    getMobilniTelefon?: string | undefined;
}

export class ConfirmPhoneCommand implements IConfirmPhoneCommand {
    korisnikEmail?: string | undefined;
    code?: string | undefined;

    constructor(data?: IConfirmPhoneCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.korisnikEmail = _data["korisnikEmail"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ConfirmPhoneCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmPhoneCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["korisnikEmail"] = this.korisnikEmail;
        data["code"] = this.code;
        return data;
    }
}

export interface IConfirmPhoneCommand {
    korisnikEmail?: string | undefined;
    code?: string | undefined;
}

export class AddKorisnikeToGrupaCommand implements IAddKorisnikeToGrupaCommand {
    nazivGrupe?: string | undefined;
    korisnikIdList?: string[] | undefined;

    constructor(data?: IAddKorisnikeToGrupaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nazivGrupe = _data["nazivGrupe"];
            if (Array.isArray(_data["korisnikIdList"])) {
                this.korisnikIdList = [] as any;
                for (let item of _data["korisnikIdList"])
                    this.korisnikIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): AddKorisnikeToGrupaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddKorisnikeToGrupaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nazivGrupe"] = this.nazivGrupe;
        if (Array.isArray(this.korisnikIdList)) {
            data["korisnikIdList"] = [];
            for (let item of this.korisnikIdList)
                data["korisnikIdList"].push(item);
        }
        return data;
    }
}

export interface IAddKorisnikeToGrupaCommand {
    nazivGrupe?: string | undefined;
    korisnikIdList?: string[] | undefined;
}

export class RemoveKorisnikFromGrupaCommand implements IRemoveKorisnikFromGrupaCommand {
    nazivGrupe?: string | undefined;
    korisnikId?: string | undefined;

    constructor(data?: IRemoveKorisnikFromGrupaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nazivGrupe = _data["nazivGrupe"];
            this.korisnikId = _data["korisnikId"];
        }
    }

    static fromJS(data: any): RemoveKorisnikFromGrupaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveKorisnikFromGrupaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nazivGrupe"] = this.nazivGrupe;
        data["korisnikId"] = this.korisnikId;
        return data;
    }
}

export interface IRemoveKorisnikFromGrupaCommand {
    nazivGrupe?: string | undefined;
    korisnikId?: string | undefined;
}

export class PrviLoginKorisnikCommand implements IPrviLoginKorisnikCommand {
    prihvaceniUsloviKoriscenja?: boolean;

    constructor(data?: IPrviLoginKorisnikCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prihvaceniUsloviKoriscenja = _data["prihvaceniUsloviKoriscenja"];
        }
    }

    static fromJS(data: any): PrviLoginKorisnikCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PrviLoginKorisnikCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prihvaceniUsloviKoriscenja"] = this.prihvaceniUsloviKoriscenja;
        return data;
    }
}

export interface IPrviLoginKorisnikCommand {
    prihvaceniUsloviKoriscenja?: boolean;
}

export class PaginatedResultOfLagerTableDto extends Result implements IPaginatedResultOfLagerTableDto {
    data?: LagerTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfLagerTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LagerTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfLagerTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfLagerTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfLagerTableDto extends IResult {
    data?: LagerTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PaginatedResultOfLagerTableDtoAndLagerTableSummary extends PaginatedResultOfLagerTableDto implements IPaginatedResultOfLagerTableDtoAndLagerTableSummary {
    summaryData?: LagerTableSummary | undefined;

    constructor(data?: IPaginatedResultOfLagerTableDtoAndLagerTableSummary) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.summaryData = _data["summaryData"] ? LagerTableSummary.fromJS(_data["summaryData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaginatedResultOfLagerTableDtoAndLagerTableSummary {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfLagerTableDtoAndLagerTableSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summaryData"] = this.summaryData ? this.summaryData.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfLagerTableDtoAndLagerTableSummary extends IPaginatedResultOfLagerTableDto {
    summaryData?: LagerTableSummary | undefined;
}

export class LagerTableSummary implements ILagerTableSummary {
    isMaloprodaja?: boolean;

    constructor(data?: ILagerTableSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMaloprodaja = _data["isMaloprodaja"];
        }
    }

    static fromJS(data: any): LagerTableSummary {
        data = typeof data === 'object' ? data : {};
        let result = new LagerTableSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMaloprodaja"] = this.isMaloprodaja;
        return data;
    }
}

export interface ILagerTableSummary {
    isMaloprodaja?: boolean;
}

export class LagerTableDto implements ILagerTableDto {
    lagerId?: number;
    predmetStavkeId?: number;
    magacinId?: number;
    nazivMagacina?: string | undefined;
    sifraINaziv?: string | undefined;
    sifra?: string | undefined;
    naziv?: string | undefined;
    barkodovi?: string | undefined;
    jedinicaMereNaziv?: string | undefined;
    stanje?: number;
    rezervisano?: number;
    slobodno?: number;
    cena?: string | undefined;
    vrednost?: string | undefined;
    cenaDecimal?: number;
    vrednostDecimal?: number;
    stopaPDV?: number;
    valutaText?: string | undefined;
    originalnaCena?: number | undefined;
    originalnaValutaText?: string | undefined;

    constructor(data?: ILagerTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lagerId = _data["lagerId"];
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.magacinId = _data["magacinId"];
            this.nazivMagacina = _data["nazivMagacina"];
            this.sifraINaziv = _data["sifraINaziv"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.barkodovi = _data["barkodovi"];
            this.jedinicaMereNaziv = _data["jedinicaMereNaziv"];
            this.stanje = _data["stanje"];
            this.rezervisano = _data["rezervisano"];
            this.slobodno = _data["slobodno"];
            this.cena = _data["cena"];
            this.vrednost = _data["vrednost"];
            this.cenaDecimal = _data["cenaDecimal"];
            this.vrednostDecimal = _data["vrednostDecimal"];
            this.stopaPDV = _data["stopaPDV"];
            this.valutaText = _data["valutaText"];
            this.originalnaCena = _data["originalnaCena"];
            this.originalnaValutaText = _data["originalnaValutaText"];
        }
    }

    static fromJS(data: any): LagerTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new LagerTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lagerId"] = this.lagerId;
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["magacinId"] = this.magacinId;
        data["nazivMagacina"] = this.nazivMagacina;
        data["sifraINaziv"] = this.sifraINaziv;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["barkodovi"] = this.barkodovi;
        data["jedinicaMereNaziv"] = this.jedinicaMereNaziv;
        data["stanje"] = this.stanje;
        data["rezervisano"] = this.rezervisano;
        data["slobodno"] = this.slobodno;
        data["cena"] = this.cena;
        data["vrednost"] = this.vrednost;
        data["cenaDecimal"] = this.cenaDecimal;
        data["vrednostDecimal"] = this.vrednostDecimal;
        data["stopaPDV"] = this.stopaPDV;
        data["valutaText"] = this.valutaText;
        data["originalnaCena"] = this.originalnaCena;
        data["originalnaValutaText"] = this.originalnaValutaText;
        return data;
    }
}

export interface ILagerTableDto {
    lagerId?: number;
    predmetStavkeId?: number;
    magacinId?: number;
    nazivMagacina?: string | undefined;
    sifraINaziv?: string | undefined;
    sifra?: string | undefined;
    naziv?: string | undefined;
    barkodovi?: string | undefined;
    jedinicaMereNaziv?: string | undefined;
    stanje?: number;
    rezervisano?: number;
    slobodno?: number;
    cena?: string | undefined;
    vrednost?: string | undefined;
    cenaDecimal?: number;
    vrednostDecimal?: number;
    stopaPDV?: number;
    valutaText?: string | undefined;
    originalnaCena?: number | undefined;
    originalnaValutaText?: string | undefined;
}

export class GetLageriTableQuery implements IGetLageriTableQuery {
    naziv?: string | undefined;
    sifra?: string | undefined;
    magacinId?: number;
    predmetStavkeId?: number | undefined;
    stranke?: StrankaDto[] | undefined;
    pageNumber?: number;
    pageSize?: number;
    datumPrometa?: Date | undefined;
    prikaziNuleIMinus?: boolean | undefined;
    sortField?: string | undefined;
    sortOrder?: number | undefined;

    constructor(data?: IGetLageriTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.sifra = _data["sifra"];
            this.magacinId = _data["magacinId"];
            this.predmetStavkeId = _data["predmetStavkeId"];
            if (Array.isArray(_data["stranke"])) {
                this.stranke = [] as any;
                for (let item of _data["stranke"])
                    this.stranke!.push(StrankaDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.datumPrometa = _data["datumPrometa"] ? new Date(_data["datumPrometa"].toString()) : <any>undefined;
            this.prikaziNuleIMinus = _data["prikaziNuleIMinus"];
            this.sortField = _data["sortField"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): GetLageriTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetLageriTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["sifra"] = this.sifra;
        data["magacinId"] = this.magacinId;
        data["predmetStavkeId"] = this.predmetStavkeId;
        if (Array.isArray(this.stranke)) {
            data["stranke"] = [];
            for (let item of this.stranke)
                data["stranke"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["datumPrometa"] = this.datumPrometa ? this.datumPrometa.toISOString() : <any>undefined;
        data["prikaziNuleIMinus"] = this.prikaziNuleIMinus;
        data["sortField"] = this.sortField;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IGetLageriTableQuery {
    naziv?: string | undefined;
    sifra?: string | undefined;
    magacinId?: number;
    predmetStavkeId?: number | undefined;
    stranke?: StrankaDto[] | undefined;
    pageNumber?: number;
    pageSize?: number;
    datumPrometa?: Date | undefined;
    prikaziNuleIMinus?: boolean | undefined;
    sortField?: string | undefined;
    sortOrder?: number | undefined;
}

export class ResultOfGetStanjeLageraResponse extends Result implements IResultOfGetStanjeLageraResponse {
    data?: GetStanjeLageraResponse | undefined;

    constructor(data?: IResultOfGetStanjeLageraResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetStanjeLageraResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetStanjeLageraResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetStanjeLageraResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetStanjeLageraResponse extends IResult {
    data?: GetStanjeLageraResponse | undefined;
}

export class GetStanjeLageraResponse implements IGetStanjeLageraResponse {
    stanjeLageraDtoList?: StanjeLageraDto[] | undefined;

    constructor(data?: IGetStanjeLageraResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stanjeLageraDtoList"])) {
                this.stanjeLageraDtoList = [] as any;
                for (let item of _data["stanjeLageraDtoList"])
                    this.stanjeLageraDtoList!.push(StanjeLageraDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStanjeLageraResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStanjeLageraResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stanjeLageraDtoList)) {
            data["stanjeLageraDtoList"] = [];
            for (let item of this.stanjeLageraDtoList)
                data["stanjeLageraDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStanjeLageraResponse {
    stanjeLageraDtoList?: StanjeLageraDto[] | undefined;
}

export class StanjeLageraDto implements IStanjeLageraDto {
    nazivMagacina?: string | undefined;
    slobodno?: number;
    rezervisano?: number;
    cena?: string | undefined;
    vrednost?: string | undefined;

    constructor(data?: IStanjeLageraDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nazivMagacina = _data["nazivMagacina"];
            this.slobodno = _data["slobodno"];
            this.rezervisano = _data["rezervisano"];
            this.cena = _data["cena"];
            this.vrednost = _data["vrednost"];
        }
    }

    static fromJS(data: any): StanjeLageraDto {
        data = typeof data === 'object' ? data : {};
        let result = new StanjeLageraDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nazivMagacina"] = this.nazivMagacina;
        data["slobodno"] = this.slobodno;
        data["rezervisano"] = this.rezervisano;
        data["cena"] = this.cena;
        data["vrednost"] = this.vrednost;
        return data;
    }
}

export interface IStanjeLageraDto {
    nazivMagacina?: string | undefined;
    slobodno?: number;
    rezervisano?: number;
    cena?: string | undefined;
    vrednost?: string | undefined;
}

export class ResultOfGetLagerTransakcijeTableResponse extends Result implements IResultOfGetLagerTransakcijeTableResponse {
    data?: GetLagerTransakcijeTableResponse | undefined;

    constructor(data?: IResultOfGetLagerTransakcijeTableResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetLagerTransakcijeTableResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetLagerTransakcijeTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetLagerTransakcijeTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetLagerTransakcijeTableResponse extends IResult {
    data?: GetLagerTransakcijeTableResponse | undefined;
}

export class GetLagerTransakcijeTableResponse implements IGetLagerTransakcijeTableResponse {
    lagerTransakcijeTableDtoList?: LagerTransakcijeTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;

    constructor(data?: IGetLagerTransakcijeTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lagerTransakcijeTableDtoList"])) {
                this.lagerTransakcijeTableDtoList = [] as any;
                for (let item of _data["lagerTransakcijeTableDtoList"])
                    this.lagerTransakcijeTableDtoList!.push(LagerTransakcijeTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLagerTransakcijeTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLagerTransakcijeTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lagerTransakcijeTableDtoList)) {
            data["lagerTransakcijeTableDtoList"] = [];
            for (let item of this.lagerTransakcijeTableDtoList)
                data["lagerTransakcijeTableDtoList"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLagerTransakcijeTableResponse {
    lagerTransakcijeTableDtoList?: LagerTransakcijeTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
}

export class LagerTransakcijeTableDto implements ILagerTransakcijeTableDto {
    tipDto?: TipTransakcijeDto | undefined;
    promena?: string | undefined;
    nabavnaCena?: number;
    prodajnaCena?: number;
    nabavnaVrednost?: number;
    prodajnaVrednost?: number;
    nazivGrupe?: string | undefined;
    rutiranjeStranke?: RutiranjeStrankeDto | undefined;
    rutiranjeVezanogRacuna?: VezaniRacunDto | undefined;
    valutaText?: string | undefined;

    constructor(data?: ILagerTransakcijeTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipDto = _data["tipDto"] ? TipTransakcijeDto.fromJS(_data["tipDto"]) : <any>undefined;
            this.promena = _data["promena"];
            this.nabavnaCena = _data["nabavnaCena"];
            this.prodajnaCena = _data["prodajnaCena"];
            this.nabavnaVrednost = _data["nabavnaVrednost"];
            this.prodajnaVrednost = _data["prodajnaVrednost"];
            this.nazivGrupe = _data["nazivGrupe"];
            this.rutiranjeStranke = _data["rutiranjeStranke"] ? RutiranjeStrankeDto.fromJS(_data["rutiranjeStranke"]) : <any>undefined;
            this.rutiranjeVezanogRacuna = _data["rutiranjeVezanogRacuna"] ? VezaniRacunDto.fromJS(_data["rutiranjeVezanogRacuna"]) : <any>undefined;
            this.valutaText = _data["valutaText"];
        }
    }

    static fromJS(data: any): LagerTransakcijeTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new LagerTransakcijeTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipDto"] = this.tipDto ? this.tipDto.toJSON() : <any>undefined;
        data["promena"] = this.promena;
        data["nabavnaCena"] = this.nabavnaCena;
        data["prodajnaCena"] = this.prodajnaCena;
        data["nabavnaVrednost"] = this.nabavnaVrednost;
        data["prodajnaVrednost"] = this.prodajnaVrednost;
        data["nazivGrupe"] = this.nazivGrupe;
        data["rutiranjeStranke"] = this.rutiranjeStranke ? this.rutiranjeStranke.toJSON() : <any>undefined;
        data["rutiranjeVezanogRacuna"] = this.rutiranjeVezanogRacuna ? this.rutiranjeVezanogRacuna.toJSON() : <any>undefined;
        data["valutaText"] = this.valutaText;
        return data;
    }
}

export interface ILagerTransakcijeTableDto {
    tipDto?: TipTransakcijeDto | undefined;
    promena?: string | undefined;
    nabavnaCena?: number;
    prodajnaCena?: number;
    nabavnaVrednost?: number;
    prodajnaVrednost?: number;
    nazivGrupe?: string | undefined;
    rutiranjeStranke?: RutiranjeStrankeDto | undefined;
    rutiranjeVezanogRacuna?: VezaniRacunDto | undefined;
    valutaText?: string | undefined;
}

export class TipTransakcijeDto implements ITipTransakcijeDto {
    tip?: TipLagerTransakcije;
    tipStr?: string | undefined;
    tipBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: ITipTransakcijeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tip = _data["tip"];
            this.tipStr = _data["tipStr"];
            this.tipBadgeStr = _data["tipBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): TipTransakcijeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipTransakcijeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tip"] = this.tip;
        data["tipStr"] = this.tipStr;
        data["tipBadgeStr"] = this.tipBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface ITipTransakcijeDto {
    tip?: TipLagerTransakcije;
    tipStr?: string | undefined;
    tipBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class GetLagerTransakcijeTableQuery implements IGetLagerTransakcijeTableQuery {
    predmetStavkeId?: number | undefined;
    tipTransakcije?: TipLagerTransakcije;
    stranka?: string | undefined;
    brojRacuna?: string | undefined;
    datumPrometa?: Date | undefined;

    constructor(data?: IGetLagerTransakcijeTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.tipTransakcije = _data["tipTransakcije"];
            this.stranka = _data["stranka"];
            this.brojRacuna = _data["brojRacuna"];
            this.datumPrometa = _data["datumPrometa"] ? new Date(_data["datumPrometa"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLagerTransakcijeTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetLagerTransakcijeTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["tipTransakcije"] = this.tipTransakcije;
        data["stranka"] = this.stranka;
        data["brojRacuna"] = this.brojRacuna;
        data["datumPrometa"] = this.datumPrometa ? this.datumPrometa.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetLagerTransakcijeTableQuery {
    predmetStavkeId?: number | undefined;
    tipTransakcije?: TipLagerTransakcije;
    stranka?: string | undefined;
    brojRacuna?: string | undefined;
    datumPrometa?: Date | undefined;
}

export class ResultOfMagaciniTableVm extends Result implements IResultOfMagaciniTableVm {
    data?: MagaciniTableVm | undefined;

    constructor(data?: IResultOfMagaciniTableVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? MagaciniTableVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfMagaciniTableVm {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfMagaciniTableVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfMagaciniTableVm extends IResult {
    data?: MagaciniTableVm | undefined;
}

export class MagaciniTableVm implements IMagaciniTableVm {
    magaciniTable?: MagacinTableDto[] | undefined;

    constructor(data?: IMagaciniTableVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["magaciniTable"])) {
                this.magaciniTable = [] as any;
                for (let item of _data["magaciniTable"])
                    this.magaciniTable!.push(MagacinTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MagaciniTableVm {
        data = typeof data === 'object' ? data : {};
        let result = new MagaciniTableVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.magaciniTable)) {
            data["magaciniTable"] = [];
            for (let item of this.magaciniTable)
                data["magaciniTable"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMagaciniTableVm {
    magaciniTable?: MagacinTableDto[] | undefined;
}

export class MagacinTableDto implements IMagacinTableDto {
    id?: number;
    sifraINaziv?: string | undefined;
    kontaktOsoba?: string | undefined;
    kontaktTelefon?: string | undefined;
    magacinTipNaziv?: string | undefined;
    punaAdresa?: string | undefined;

    constructor(data?: IMagacinTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifraINaziv = _data["sifraINaziv"];
            this.kontaktOsoba = _data["kontaktOsoba"];
            this.kontaktTelefon = _data["kontaktTelefon"];
            this.magacinTipNaziv = _data["magacinTipNaziv"];
            this.punaAdresa = _data["punaAdresa"];
        }
    }

    static fromJS(data: any): MagacinTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MagacinTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifraINaziv"] = this.sifraINaziv;
        data["kontaktOsoba"] = this.kontaktOsoba;
        data["kontaktTelefon"] = this.kontaktTelefon;
        data["magacinTipNaziv"] = this.magacinTipNaziv;
        data["punaAdresa"] = this.punaAdresa;
        return data;
    }
}

export interface IMagacinTableDto {
    id?: number;
    sifraINaziv?: string | undefined;
    kontaktOsoba?: string | undefined;
    kontaktTelefon?: string | undefined;
    magacinTipNaziv?: string | undefined;
    punaAdresa?: string | undefined;
}

export class GetMagacinTableRequest implements IGetMagacinTableRequest {
    naziv?: string | undefined;
    sifra?: string | undefined;
    magacinTipId?: number | undefined;

    constructor(data?: IGetMagacinTableRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.sifra = _data["sifra"];
            this.magacinTipId = _data["magacinTipId"];
        }
    }

    static fromJS(data: any): GetMagacinTableRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMagacinTableRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["sifra"] = this.sifra;
        data["magacinTipId"] = this.magacinTipId;
        return data;
    }
}

export interface IGetMagacinTableRequest {
    naziv?: string | undefined;
    sifra?: string | undefined;
    magacinTipId?: number | undefined;
}

export class GetMagaciniTableQuery extends GetMagacinTableRequest implements IGetMagaciniTableQuery {

    constructor(data?: IGetMagaciniTableQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetMagaciniTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMagaciniTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetMagaciniTableQuery extends IGetMagacinTableRequest {
}

export class ResultOfMagacinDto extends Result implements IResultOfMagacinDto {
    data?: MagacinDto | undefined;

    constructor(data?: IResultOfMagacinDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? MagacinDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfMagacinDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfMagacinDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfMagacinDto extends IResult {
    data?: MagacinDto | undefined;
}

export class MagacinDto implements IMagacinDto {
    id?: number | undefined;
    naziv?: string | undefined;
    sifra?: string | undefined;
    magacinTipId?: number | undefined;
    magacinTipNaziv?: string | undefined;
    kontaktOsoba?: string | undefined;
    kontaktTelefon?: string | undefined;
    email?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    adresa?: AdresaDto | undefined;
    otpremnica?: OtpremnicaDto | undefined;

    constructor(data?: IMagacinDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.sifra = _data["sifra"];
            this.magacinTipId = _data["magacinTipId"];
            this.magacinTipNaziv = _data["magacinTipNaziv"];
            this.kontaktOsoba = _data["kontaktOsoba"];
            this.kontaktTelefon = _data["kontaktTelefon"];
            this.email = _data["email"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedOn = _data["lastModifiedOn"] ? new Date(_data["lastModifiedOn"].toString()) : <any>undefined;
            this.adresa = _data["adresa"] ? AdresaDto.fromJS(_data["adresa"]) : <any>undefined;
            this.otpremnica = _data["otpremnica"] ? OtpremnicaDto.fromJS(_data["otpremnica"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MagacinDto {
        data = typeof data === 'object' ? data : {};
        let result = new MagacinDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["sifra"] = this.sifra;
        data["magacinTipId"] = this.magacinTipId;
        data["magacinTipNaziv"] = this.magacinTipNaziv;
        data["kontaktOsoba"] = this.kontaktOsoba;
        data["kontaktTelefon"] = this.kontaktTelefon;
        data["email"] = this.email;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined;
        data["adresa"] = this.adresa ? this.adresa.toJSON() : <any>undefined;
        data["otpremnica"] = this.otpremnica ? this.otpremnica.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMagacinDto {
    id?: number | undefined;
    naziv?: string | undefined;
    sifra?: string | undefined;
    magacinTipId?: number | undefined;
    magacinTipNaziv?: string | undefined;
    kontaktOsoba?: string | undefined;
    kontaktTelefon?: string | undefined;
    email?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    adresa?: AdresaDto | undefined;
    otpremnica?: OtpremnicaDto | undefined;
}

export class OtpremnicaDto implements IOtpremnicaDto {
    racunDto?: RacunDto | undefined;
    informacijaIsporuke?: InformacijaIsporukeDto | undefined;
    vrsta?: VrstaOtpremnice;
    interniMagacinId?: number | undefined;
    vozila?: VoziloDropdownDto[] | undefined;

    constructor(data?: IOtpremnicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.informacijaIsporuke = _data["informacijaIsporuke"] ? InformacijaIsporukeDto.fromJS(_data["informacijaIsporuke"]) : <any>undefined;
            this.vrsta = _data["vrsta"];
            this.interniMagacinId = _data["interniMagacinId"];
            if (Array.isArray(_data["vozila"])) {
                this.vozila = [] as any;
                for (let item of _data["vozila"])
                    this.vozila!.push(VoziloDropdownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OtpremnicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtpremnicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["informacijaIsporuke"] = this.informacijaIsporuke ? this.informacijaIsporuke.toJSON() : <any>undefined;
        data["vrsta"] = this.vrsta;
        data["interniMagacinId"] = this.interniMagacinId;
        if (Array.isArray(this.vozila)) {
            data["vozila"] = [];
            for (let item of this.vozila)
                data["vozila"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOtpremnicaDto {
    racunDto?: RacunDto | undefined;
    informacijaIsporuke?: InformacijaIsporukeDto | undefined;
    vrsta?: VrstaOtpremnice;
    interniMagacinId?: number | undefined;
    vozila?: VoziloDropdownDto[] | undefined;
}

export class ResultOfIEnumerableOfMagacinDropdownDto extends Result implements IResultOfIEnumerableOfMagacinDropdownDto {
    data?: MagacinDropdownDto[] | undefined;

    constructor(data?: IResultOfIEnumerableOfMagacinDropdownDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MagacinDropdownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfIEnumerableOfMagacinDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfIEnumerableOfMagacinDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfIEnumerableOfMagacinDropdownDto extends IResult {
    data?: MagacinDropdownDto[] | undefined;
}

export class MagacinDropdownDto implements IMagacinDropdownDto {
    id?: number;
    naziv?: string | undefined;
    isMaloprodaja?: boolean;

    constructor(data?: IMagacinDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.isMaloprodaja = _data["isMaloprodaja"];
        }
    }

    static fromJS(data: any): MagacinDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new MagacinDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["isMaloprodaja"] = this.isMaloprodaja;
        return data;
    }
}

export interface IMagacinDropdownDto {
    id?: number;
    naziv?: string | undefined;
    isMaloprodaja?: boolean;
}

export class ResultOfMagacinCommandResponse extends Result implements IResultOfMagacinCommandResponse {
    data?: MagacinCommandResponse | undefined;

    constructor(data?: IResultOfMagacinCommandResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? MagacinCommandResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfMagacinCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfMagacinCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfMagacinCommandResponse extends IResult {
    data?: MagacinCommandResponse | undefined;
}

export class MagacinCommandResponse implements IMagacinCommandResponse {
    magacinDto?: MagacinDto | undefined;
    magacinTableDto?: MagacinTableDto | undefined;

    constructor(data?: IMagacinCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.magacinDto = _data["magacinDto"] ? MagacinDto.fromJS(_data["magacinDto"]) : <any>undefined;
            this.magacinTableDto = _data["magacinTableDto"] ? MagacinTableDto.fromJS(_data["magacinTableDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MagacinCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MagacinCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["magacinDto"] = this.magacinDto ? this.magacinDto.toJSON() : <any>undefined;
        data["magacinTableDto"] = this.magacinTableDto ? this.magacinTableDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMagacinCommandResponse {
    magacinDto?: MagacinDto | undefined;
    magacinTableDto?: MagacinTableDto | undefined;
}

export class CreateMagacinCommand implements ICreateMagacinCommand {
    id?: number | undefined;
    naziv?: string | undefined;
    sifra?: string | undefined;
    magacinTipId?: number | undefined;
    magacinTipNaziv?: string | undefined;
    kontaktOsoba?: string | undefined;
    kontaktTelefon?: string | undefined;
    email?: string | undefined;
    adresa?: AdresaDto | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;

    constructor(data?: ICreateMagacinCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.sifra = _data["sifra"];
            this.magacinTipId = _data["magacinTipId"];
            this.magacinTipNaziv = _data["magacinTipNaziv"];
            this.kontaktOsoba = _data["kontaktOsoba"];
            this.kontaktTelefon = _data["kontaktTelefon"];
            this.email = _data["email"];
            this.adresa = _data["adresa"] ? AdresaDto.fromJS(_data["adresa"]) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedOn = _data["lastModifiedOn"] ? new Date(_data["lastModifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateMagacinCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMagacinCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["sifra"] = this.sifra;
        data["magacinTipId"] = this.magacinTipId;
        data["magacinTipNaziv"] = this.magacinTipNaziv;
        data["kontaktOsoba"] = this.kontaktOsoba;
        data["kontaktTelefon"] = this.kontaktTelefon;
        data["email"] = this.email;
        data["adresa"] = this.adresa ? this.adresa.toJSON() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateMagacinCommand {
    id?: number | undefined;
    naziv?: string | undefined;
    sifra?: string | undefined;
    magacinTipId?: number | undefined;
    magacinTipNaziv?: string | undefined;
    kontaktOsoba?: string | undefined;
    kontaktTelefon?: string | undefined;
    email?: string | undefined;
    adresa?: AdresaDto | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
}

export class UpdateMagacinCommand extends MagacinDto implements IUpdateMagacinCommand {

    constructor(data?: IUpdateMagacinCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateMagacinCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMagacinCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateMagacinCommand extends IMagacinDto {
}

export class GetMagacinByNazivVm implements IGetMagacinByNazivVm {
    magacini?: MagacinDto[] | undefined;

    constructor(data?: IGetMagacinByNazivVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["magacini"])) {
                this.magacini = [] as any;
                for (let item of _data["magacini"])
                    this.magacini!.push(MagacinDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMagacinByNazivVm {
        data = typeof data === 'object' ? data : {};
        let result = new GetMagacinByNazivVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.magacini)) {
            data["magacini"] = [];
            for (let item of this.magacini)
                data["magacini"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMagacinByNazivVm {
    magacini?: MagacinDto[] | undefined;
}

export class ResultOfMagaciniVm extends Result implements IResultOfMagaciniVm {
    data?: MagaciniVm | undefined;

    constructor(data?: IResultOfMagaciniVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? MagaciniVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfMagaciniVm {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfMagaciniVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfMagaciniVm extends IResult {
    data?: MagaciniVm | undefined;
}

export class MagaciniVm implements IMagaciniVm {
    magacini?: MagacinDto[] | undefined;

    constructor(data?: IMagaciniVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["magacini"])) {
                this.magacini = [] as any;
                for (let item of _data["magacini"])
                    this.magacini!.push(MagacinDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MagaciniVm {
        data = typeof data === 'object' ? data : {};
        let result = new MagaciniVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.magacini)) {
            data["magacini"] = [];
            for (let item of this.magacini)
                data["magacini"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMagaciniVm {
    magacini?: MagacinDto[] | undefined;
}

export class ResultOfGetMagacinTipoveResponse extends Result implements IResultOfGetMagacinTipoveResponse {
    data?: GetMagacinTipoveResponse | undefined;

    constructor(data?: IResultOfGetMagacinTipoveResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetMagacinTipoveResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetMagacinTipoveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetMagacinTipoveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetMagacinTipoveResponse extends IResult {
    data?: GetMagacinTipoveResponse | undefined;
}

export class GetMagacinTipoveResponse implements IGetMagacinTipoveResponse {
    magacinTipoviDto?: MagacinTipTableDto[] | undefined;

    constructor(data?: IGetMagacinTipoveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["magacinTipoviDto"])) {
                this.magacinTipoviDto = [] as any;
                for (let item of _data["magacinTipoviDto"])
                    this.magacinTipoviDto!.push(MagacinTipTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMagacinTipoveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMagacinTipoveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.magacinTipoviDto)) {
            data["magacinTipoviDto"] = [];
            for (let item of this.magacinTipoviDto)
                data["magacinTipoviDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMagacinTipoveResponse {
    magacinTipoviDto?: MagacinTipTableDto[] | undefined;
}

export class MagacinTipTableDto implements IMagacinTipTableDto {
    id?: number;
    sifra?: string | undefined;
    naziv?: string | undefined;

    constructor(data?: IMagacinTipTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): MagacinTipTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MagacinTipTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IMagacinTipTableDto {
    id?: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
}

export class MagacinTipoviVm implements IMagacinTipoviVm {
    magacinTipovi?: MagacinTipDto[] | undefined;

    constructor(data?: IMagacinTipoviVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["magacinTipovi"])) {
                this.magacinTipovi = [] as any;
                for (let item of _data["magacinTipovi"])
                    this.magacinTipovi!.push(MagacinTipDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MagacinTipoviVm {
        data = typeof data === 'object' ? data : {};
        let result = new MagacinTipoviVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.magacinTipovi)) {
            data["magacinTipovi"] = [];
            for (let item of this.magacinTipovi)
                data["magacinTipovi"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMagacinTipoviVm {
    magacinTipovi?: MagacinTipDto[] | undefined;
}

export class MagacinTipDto implements IMagacinTipDto {
    id?: number | undefined;
    sifra?: string | undefined;
    naziv?: string | undefined;

    constructor(data?: IMagacinTipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): MagacinTipDto {
        data = typeof data === 'object' ? data : {};
        let result = new MagacinTipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IMagacinTipDto {
    id?: number | undefined;
    sifra?: string | undefined;
    naziv?: string | undefined;
}

export class CreateMagacinTipCommand extends MagacinTipDto implements ICreateMagacinTipCommand {

    constructor(data?: ICreateMagacinTipCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateMagacinTipCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMagacinTipCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateMagacinTipCommand extends IMagacinTipDto {
}

export class UpdateMagacinTipCommand extends MagacinTipDto implements IUpdateMagacinTipCommand {

    constructor(data?: IUpdateMagacinTipCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateMagacinTipCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMagacinTipCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateMagacinTipCommand extends IMagacinTipDto {
}

export class ResultOfMemorandumTableDto extends Result implements IResultOfMemorandumTableDto {
    data?: MemorandumTableDto | undefined;

    constructor(data?: IResultOfMemorandumTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? MemorandumTableDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfMemorandumTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfMemorandumTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfMemorandumTableDto extends IResult {
    data?: MemorandumTableDto | undefined;
}

export class MemorandumTableDto implements IMemorandumTableDto {
    id?: number;
    naziv?: string | undefined;

    constructor(data?: IMemorandumTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): MemorandumTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemorandumTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IMemorandumTableDto {
    id?: number;
    naziv?: string | undefined;
}

export class CreateMemorandumCommand implements ICreateMemorandumCommand {
    id?: number;
    naziv?: string | undefined;
    bojaTabele?: string | undefined;
    napomenaOPoreskomOslobadjanju?: string | undefined;
    napomena?: string | undefined;
    prikaziZakonskiAktOValidnosti?: boolean;
    koristiKompanijskiLogo?: boolean;
    website?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    prikaziFooterSekciju?: boolean;
    prikaziBrojStrana?: boolean;
    valutaId?: string;
    valutaText?: string | undefined;
    poslovnaJedinica?: PoslovnaJedinicaDto | undefined;
    poslovnaJedinicaId?: number | undefined;
    logoFile?: string | undefined;

    constructor(data?: ICreateMemorandumCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.bojaTabele = _data["bojaTabele"];
            this.napomenaOPoreskomOslobadjanju = _data["napomenaOPoreskomOslobadjanju"];
            this.napomena = _data["napomena"];
            this.prikaziZakonskiAktOValidnosti = _data["prikaziZakonskiAktOValidnosti"];
            this.koristiKompanijskiLogo = _data["koristiKompanijskiLogo"];
            this.website = _data["website"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.prikaziFooterSekciju = _data["prikaziFooterSekciju"];
            this.prikaziBrojStrana = _data["prikaziBrojStrana"];
            this.valutaId = _data["valutaId"];
            this.valutaText = _data["valutaText"];
            this.poslovnaJedinica = _data["poslovnaJedinica"] ? PoslovnaJedinicaDto.fromJS(_data["poslovnaJedinica"]) : <any>undefined;
            this.poslovnaJedinicaId = _data["poslovnaJedinicaId"];
            this.logoFile = _data["logoFile"];
        }
    }

    static fromJS(data: any): CreateMemorandumCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMemorandumCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["bojaTabele"] = this.bojaTabele;
        data["napomenaOPoreskomOslobadjanju"] = this.napomenaOPoreskomOslobadjanju;
        data["napomena"] = this.napomena;
        data["prikaziZakonskiAktOValidnosti"] = this.prikaziZakonskiAktOValidnosti;
        data["koristiKompanijskiLogo"] = this.koristiKompanijskiLogo;
        data["website"] = this.website;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["prikaziFooterSekciju"] = this.prikaziFooterSekciju;
        data["prikaziBrojStrana"] = this.prikaziBrojStrana;
        data["valutaId"] = this.valutaId;
        data["valutaText"] = this.valutaText;
        data["poslovnaJedinica"] = this.poslovnaJedinica ? this.poslovnaJedinica.toJSON() : <any>undefined;
        data["poslovnaJedinicaId"] = this.poslovnaJedinicaId;
        data["logoFile"] = this.logoFile;
        return data;
    }
}

export interface ICreateMemorandumCommand {
    id?: number;
    naziv?: string | undefined;
    bojaTabele?: string | undefined;
    napomenaOPoreskomOslobadjanju?: string | undefined;
    napomena?: string | undefined;
    prikaziZakonskiAktOValidnosti?: boolean;
    koristiKompanijskiLogo?: boolean;
    website?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    prikaziFooterSekciju?: boolean;
    prikaziBrojStrana?: boolean;
    valutaId?: string;
    valutaText?: string | undefined;
    poslovnaJedinica?: PoslovnaJedinicaDto | undefined;
    poslovnaJedinicaId?: number | undefined;
    logoFile?: string | undefined;
}

export class PoslovnaJedinicaDto implements IPoslovnaJedinicaDto {
    id?: number | undefined;
    naziv?: string | undefined;
    jeAktivna?: boolean | undefined;
    opis?: string | undefined;
    adresa?: AdresaDto | undefined;
    strankaId?: number | undefined;
    sifraDelatnosti?: string | undefined;
    vrsta?: VrstaPoslovneJedinice;
    magacini?: MagacinDto[] | undefined;

    constructor(data?: IPoslovnaJedinicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.jeAktivna = _data["jeAktivna"];
            this.opis = _data["opis"];
            this.adresa = _data["adresa"] ? AdresaDto.fromJS(_data["adresa"]) : <any>undefined;
            this.strankaId = _data["strankaId"];
            this.sifraDelatnosti = _data["sifraDelatnosti"];
            this.vrsta = _data["vrsta"];
            if (Array.isArray(_data["magacini"])) {
                this.magacini = [] as any;
                for (let item of _data["magacini"])
                    this.magacini!.push(MagacinDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PoslovnaJedinicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PoslovnaJedinicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["jeAktivna"] = this.jeAktivna;
        data["opis"] = this.opis;
        data["adresa"] = this.adresa ? this.adresa.toJSON() : <any>undefined;
        data["strankaId"] = this.strankaId;
        data["sifraDelatnosti"] = this.sifraDelatnosti;
        data["vrsta"] = this.vrsta;
        if (Array.isArray(this.magacini)) {
            data["magacini"] = [];
            for (let item of this.magacini)
                data["magacini"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPoslovnaJedinicaDto {
    id?: number | undefined;
    naziv?: string | undefined;
    jeAktivna?: boolean | undefined;
    opis?: string | undefined;
    adresa?: AdresaDto | undefined;
    strankaId?: number | undefined;
    sifraDelatnosti?: string | undefined;
    vrsta?: VrstaPoslovneJedinice;
    magacini?: MagacinDto[] | undefined;
}

export class ResultOfGetMemorandumiTableResponse extends Result implements IResultOfGetMemorandumiTableResponse {
    data?: GetMemorandumiTableResponse | undefined;

    constructor(data?: IResultOfGetMemorandumiTableResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetMemorandumiTableResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetMemorandumiTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetMemorandumiTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetMemorandumiTableResponse extends IResult {
    data?: GetMemorandumiTableResponse | undefined;
}

export class GetMemorandumiTableResponse implements IGetMemorandumiTableResponse {
    memorandumTableDtoList?: MemorandumTableDto[] | undefined;

    constructor(data?: IGetMemorandumiTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["memorandumTableDtoList"])) {
                this.memorandumTableDtoList = [] as any;
                for (let item of _data["memorandumTableDtoList"])
                    this.memorandumTableDtoList!.push(MemorandumTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMemorandumiTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMemorandumiTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.memorandumTableDtoList)) {
            data["memorandumTableDtoList"] = [];
            for (let item of this.memorandumTableDtoList)
                data["memorandumTableDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMemorandumiTableResponse {
    memorandumTableDtoList?: MemorandumTableDto[] | undefined;
}

export class ResultOfMemorandumDto extends Result implements IResultOfMemorandumDto {
    data?: MemorandumDto | undefined;

    constructor(data?: IResultOfMemorandumDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? MemorandumDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfMemorandumDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfMemorandumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfMemorandumDto extends IResult {
    data?: MemorandumDto | undefined;
}

export class MemorandumDto implements IMemorandumDto {
    id?: number;
    naziv?: string | undefined;
    bojaTabele?: string | undefined;
    napomenaOPoreskomOslobadjanju?: string | undefined;
    napomena?: string | undefined;
    prikaziZakonskiAktOValidnosti?: boolean;
    koristiKompanijskiLogo?: boolean;
    website?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    prikaziFooterSekciju?: boolean;
    prikaziBrojStrana?: boolean;
    valutaId?: string;
    valutaText?: string | undefined;
    poslovnaJedinica?: PoslovnaJedinicaDto | undefined;
    poslovnaJedinicaId?: number | undefined;
    logoFile?: string | undefined;

    constructor(data?: IMemorandumDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.bojaTabele = _data["bojaTabele"];
            this.napomenaOPoreskomOslobadjanju = _data["napomenaOPoreskomOslobadjanju"];
            this.napomena = _data["napomena"];
            this.prikaziZakonskiAktOValidnosti = _data["prikaziZakonskiAktOValidnosti"];
            this.koristiKompanijskiLogo = _data["koristiKompanijskiLogo"];
            this.website = _data["website"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.prikaziFooterSekciju = _data["prikaziFooterSekciju"];
            this.prikaziBrojStrana = _data["prikaziBrojStrana"];
            this.valutaId = _data["valutaId"];
            this.valutaText = _data["valutaText"];
            this.poslovnaJedinica = _data["poslovnaJedinica"] ? PoslovnaJedinicaDto.fromJS(_data["poslovnaJedinica"]) : <any>undefined;
            this.poslovnaJedinicaId = _data["poslovnaJedinicaId"];
            this.logoFile = _data["logoFile"];
        }
    }

    static fromJS(data: any): MemorandumDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemorandumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["bojaTabele"] = this.bojaTabele;
        data["napomenaOPoreskomOslobadjanju"] = this.napomenaOPoreskomOslobadjanju;
        data["napomena"] = this.napomena;
        data["prikaziZakonskiAktOValidnosti"] = this.prikaziZakonskiAktOValidnosti;
        data["koristiKompanijskiLogo"] = this.koristiKompanijskiLogo;
        data["website"] = this.website;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["prikaziFooterSekciju"] = this.prikaziFooterSekciju;
        data["prikaziBrojStrana"] = this.prikaziBrojStrana;
        data["valutaId"] = this.valutaId;
        data["valutaText"] = this.valutaText;
        data["poslovnaJedinica"] = this.poslovnaJedinica ? this.poslovnaJedinica.toJSON() : <any>undefined;
        data["poslovnaJedinicaId"] = this.poslovnaJedinicaId;
        data["logoFile"] = this.logoFile;
        return data;
    }
}

export interface IMemorandumDto {
    id?: number;
    naziv?: string | undefined;
    bojaTabele?: string | undefined;
    napomenaOPoreskomOslobadjanju?: string | undefined;
    napomena?: string | undefined;
    prikaziZakonskiAktOValidnosti?: boolean;
    koristiKompanijskiLogo?: boolean;
    website?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    prikaziFooterSekciju?: boolean;
    prikaziBrojStrana?: boolean;
    valutaId?: string;
    valutaText?: string | undefined;
    poslovnaJedinica?: PoslovnaJedinicaDto | undefined;
    poslovnaJedinicaId?: number | undefined;
    logoFile?: string | undefined;
}

export class UpdateMemorandumCommand implements IUpdateMemorandumCommand {
    id?: number;
    naziv?: string | undefined;
    bojaTabele?: string | undefined;
    napomenaOPoreskomOslobadjanju?: string | undefined;
    napomena?: string | undefined;
    prikaziSpojenuCifruSlovima?: boolean;
    prikaziZakonskiAktOValidnosti?: boolean;
    koristiKompanijskiLogo?: boolean;
    website?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    valutaId?: string;
    valutaText?: string | undefined;
    poslovnaJedinica?: PoslovnaJedinicaDto | undefined;
    poslovnaJedinicaId?: number | undefined;
    logoFile?: string | undefined;
    prikaziFooterSekciju?: boolean;
    prikaziBrojStrana?: boolean;

    constructor(data?: IUpdateMemorandumCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.bojaTabele = _data["bojaTabele"];
            this.napomenaOPoreskomOslobadjanju = _data["napomenaOPoreskomOslobadjanju"];
            this.napomena = _data["napomena"];
            this.prikaziSpojenuCifruSlovima = _data["prikaziSpojenuCifruSlovima"];
            this.prikaziZakonskiAktOValidnosti = _data["prikaziZakonskiAktOValidnosti"];
            this.koristiKompanijskiLogo = _data["koristiKompanijskiLogo"];
            this.website = _data["website"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.valutaId = _data["valutaId"];
            this.valutaText = _data["valutaText"];
            this.poslovnaJedinica = _data["poslovnaJedinica"] ? PoslovnaJedinicaDto.fromJS(_data["poslovnaJedinica"]) : <any>undefined;
            this.poslovnaJedinicaId = _data["poslovnaJedinicaId"];
            this.logoFile = _data["logoFile"];
            this.prikaziFooterSekciju = _data["prikaziFooterSekciju"];
            this.prikaziBrojStrana = _data["prikaziBrojStrana"];
        }
    }

    static fromJS(data: any): UpdateMemorandumCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMemorandumCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["bojaTabele"] = this.bojaTabele;
        data["napomenaOPoreskomOslobadjanju"] = this.napomenaOPoreskomOslobadjanju;
        data["napomena"] = this.napomena;
        data["prikaziSpojenuCifruSlovima"] = this.prikaziSpojenuCifruSlovima;
        data["prikaziZakonskiAktOValidnosti"] = this.prikaziZakonskiAktOValidnosti;
        data["koristiKompanijskiLogo"] = this.koristiKompanijskiLogo;
        data["website"] = this.website;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["valutaId"] = this.valutaId;
        data["valutaText"] = this.valutaText;
        data["poslovnaJedinica"] = this.poslovnaJedinica ? this.poslovnaJedinica.toJSON() : <any>undefined;
        data["poslovnaJedinicaId"] = this.poslovnaJedinicaId;
        data["logoFile"] = this.logoFile;
        data["prikaziFooterSekciju"] = this.prikaziFooterSekciju;
        data["prikaziBrojStrana"] = this.prikaziBrojStrana;
        return data;
    }
}

export interface IUpdateMemorandumCommand {
    id?: number;
    naziv?: string | undefined;
    bojaTabele?: string | undefined;
    napomenaOPoreskomOslobadjanju?: string | undefined;
    napomena?: string | undefined;
    prikaziSpojenuCifruSlovima?: boolean;
    prikaziZakonskiAktOValidnosti?: boolean;
    koristiKompanijskiLogo?: boolean;
    website?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    valutaId?: string;
    valutaText?: string | undefined;
    poslovnaJedinica?: PoslovnaJedinicaDto | undefined;
    poslovnaJedinicaId?: number | undefined;
    logoFile?: string | undefined;
    prikaziFooterSekciju?: boolean;
    prikaziBrojStrana?: boolean;
}

export class ResultOfGetMemorandumiAutocompleteResponse extends Result implements IResultOfGetMemorandumiAutocompleteResponse {
    data?: GetMemorandumiAutocompleteResponse | undefined;

    constructor(data?: IResultOfGetMemorandumiAutocompleteResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetMemorandumiAutocompleteResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetMemorandumiAutocompleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetMemorandumiAutocompleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetMemorandumiAutocompleteResponse extends IResult {
    data?: GetMemorandumiAutocompleteResponse | undefined;
}

export class GetMemorandumiAutocompleteResponse implements IGetMemorandumiAutocompleteResponse {
    memorandumAutocompleteDtoList?: MemorandumAutocompleteDto[] | undefined;

    constructor(data?: IGetMemorandumiAutocompleteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["memorandumAutocompleteDtoList"])) {
                this.memorandumAutocompleteDtoList = [] as any;
                for (let item of _data["memorandumAutocompleteDtoList"])
                    this.memorandumAutocompleteDtoList!.push(MemorandumAutocompleteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMemorandumiAutocompleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMemorandumiAutocompleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.memorandumAutocompleteDtoList)) {
            data["memorandumAutocompleteDtoList"] = [];
            for (let item of this.memorandumAutocompleteDtoList)
                data["memorandumAutocompleteDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMemorandumiAutocompleteResponse {
    memorandumAutocompleteDtoList?: MemorandumAutocompleteDto[] | undefined;
}

export class MemorandumAutocompleteDto implements IMemorandumAutocompleteDto {
    id?: number;
    naziv?: string | undefined;
    napomena?: string | undefined;
    napomenaOPoreskomOslobadanju?: string | undefined;

    constructor(data?: IMemorandumAutocompleteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.napomena = _data["napomena"];
            this.napomenaOPoreskomOslobadanju = _data["napomenaOPoreskomOslobadanju"];
        }
    }

    static fromJS(data: any): MemorandumAutocompleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemorandumAutocompleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["napomena"] = this.napomena;
        data["napomenaOPoreskomOslobadanju"] = this.napomenaOPoreskomOslobadanju;
        return data;
    }
}

export interface IMemorandumAutocompleteDto {
    id?: number;
    naziv?: string | undefined;
    napomena?: string | undefined;
    napomenaOPoreskomOslobadanju?: string | undefined;
}

export class ResultOfMinimaxApiInfoDto extends Result implements IResultOfMinimaxApiInfoDto {
    data?: MinimaxApiInfoDto | undefined;

    constructor(data?: IResultOfMinimaxApiInfoDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? MinimaxApiInfoDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfMinimaxApiInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfMinimaxApiInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfMinimaxApiInfoDto extends IResult {
    data?: MinimaxApiInfoDto | undefined;
}

export class MinimaxApiInfoDto implements IMinimaxApiInfoDto {
    isInitialized?: boolean;
    clientId?: string | undefined;
    clientSecret?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
    organisationName?: string | undefined;

    constructor(data?: IMinimaxApiInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isInitialized = _data["isInitialized"];
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.organisationName = _data["organisationName"];
        }
    }

    static fromJS(data: any): MinimaxApiInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinimaxApiInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isInitialized"] = this.isInitialized;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["username"] = this.username;
        data["password"] = this.password;
        data["organisationName"] = this.organisationName;
        return data;
    }
}

export interface IMinimaxApiInfoDto {
    isInitialized?: boolean;
    clientId?: string | undefined;
    clientSecret?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
    organisationName?: string | undefined;
}

export class ResultOfListOfOrganisationDto extends Result implements IResultOfListOfOrganisationDto {
    data?: OrganisationDto[] | undefined;

    constructor(data?: IResultOfListOfOrganisationDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OrganisationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfOrganisationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfOrganisationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfOrganisationDto extends IResult {
    data?: OrganisationDto[] | undefined;
}

export class BaseObject implements IBaseObject {
    id?: number;
    name?: string | undefined;

    constructor(data?: IBaseObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BaseObject {
        data = typeof data === 'object' ? data : {};
        let result = new BaseObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IBaseObject {
    id?: number;
    name?: string | undefined;
}

export class OrganisationDto extends BaseObject implements IOrganisationDto {

    constructor(data?: IOrganisationDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): OrganisationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOrganisationDto extends IBaseObject {
}

export class ResultOfListOfDocumentNumberingDto extends Result implements IResultOfListOfDocumentNumberingDto {
    data?: DocumentNumberingDto[] | undefined;

    constructor(data?: IResultOfListOfDocumentNumberingDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DocumentNumberingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfDocumentNumberingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfDocumentNumberingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfDocumentNumberingDto extends IResult {
    data?: DocumentNumberingDto[] | undefined;
}

export class DocumentNumberingDto implements IDocumentNumberingDto {
    id?: number;
    naziv?: string | undefined;

    constructor(data?: IDocumentNumberingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): DocumentNumberingDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentNumberingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IDocumentNumberingDto {
    id?: number;
    naziv?: string | undefined;
}

export class CreateMinimaxAuthCommand implements ICreateMinimaxAuthCommand {
    clientId?: string | undefined;
    clientSecret?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: ICreateMinimaxAuthCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateMinimaxAuthCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMinimaxAuthCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface ICreateMinimaxAuthCommand {
    clientId?: string | undefined;
    clientSecret?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
}

export class SetMinimaxOrganisationCommand extends OrganisationDto implements ISetMinimaxOrganisationCommand {

    constructor(data?: ISetMinimaxOrganisationCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SetMinimaxOrganisationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetMinimaxOrganisationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISetMinimaxOrganisationCommand extends IOrganisationDto {
}

export class ZohoInitCommand implements IZohoInitCommand {
    deskToken?: string | undefined;
    crmToken?: string | undefined;

    constructor(data?: IZohoInitCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deskToken = _data["deskToken"];
            this.crmToken = _data["crmToken"];
        }
    }

    static fromJS(data: any): ZohoInitCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ZohoInitCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deskToken"] = this.deskToken;
        data["crmToken"] = this.crmToken;
        return data;
    }
}

export interface IZohoInitCommand {
    deskToken?: string | undefined;
    crmToken?: string | undefined;
}

export class ResultOfMojaFirmaDto extends Result implements IResultOfMojaFirmaDto {
    data?: MojaFirmaDto | undefined;

    constructor(data?: IResultOfMojaFirmaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? MojaFirmaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfMojaFirmaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfMojaFirmaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfMojaFirmaDto extends IResult {
    data?: MojaFirmaDto | undefined;
}

export class MojaFirmaDto implements IMojaFirmaDto {
    id?: number;
    naziv?: string | undefined;
    punNaziv?: string | undefined;
    adresa?: string | undefined;
    pib?: string | undefined;
    mb?: string | undefined;
    pravniOblik?: string | undefined;
    sifraDelatnosti?: string | undefined;
    vlasnici?: string | undefined;
    zastupnici?: string | undefined;
    datumOsnivanjaStr?: string | undefined;
    tekuciRacuniDto?: TekuciRacunDto[] | undefined;

    constructor(data?: IMojaFirmaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.punNaziv = _data["punNaziv"];
            this.adresa = _data["adresa"];
            this.pib = _data["pib"];
            this.mb = _data["mb"];
            this.pravniOblik = _data["pravniOblik"];
            this.sifraDelatnosti = _data["sifraDelatnosti"];
            this.vlasnici = _data["vlasnici"];
            this.zastupnici = _data["zastupnici"];
            this.datumOsnivanjaStr = _data["datumOsnivanjaStr"];
            if (Array.isArray(_data["tekuciRacuniDto"])) {
                this.tekuciRacuniDto = [] as any;
                for (let item of _data["tekuciRacuniDto"])
                    this.tekuciRacuniDto!.push(TekuciRacunDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MojaFirmaDto {
        data = typeof data === 'object' ? data : {};
        let result = new MojaFirmaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["punNaziv"] = this.punNaziv;
        data["adresa"] = this.adresa;
        data["pib"] = this.pib;
        data["mb"] = this.mb;
        data["pravniOblik"] = this.pravniOblik;
        data["sifraDelatnosti"] = this.sifraDelatnosti;
        data["vlasnici"] = this.vlasnici;
        data["zastupnici"] = this.zastupnici;
        data["datumOsnivanjaStr"] = this.datumOsnivanjaStr;
        if (Array.isArray(this.tekuciRacuniDto)) {
            data["tekuciRacuniDto"] = [];
            for (let item of this.tekuciRacuniDto)
                data["tekuciRacuniDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMojaFirmaDto {
    id?: number;
    naziv?: string | undefined;
    punNaziv?: string | undefined;
    adresa?: string | undefined;
    pib?: string | undefined;
    mb?: string | undefined;
    pravniOblik?: string | undefined;
    sifraDelatnosti?: string | undefined;
    vlasnici?: string | undefined;
    zastupnici?: string | undefined;
    datumOsnivanjaStr?: string | undefined;
    tekuciRacuniDto?: TekuciRacunDto[] | undefined;
}

export class ResultOfMojaFirmaKompenzacijaDto extends Result implements IResultOfMojaFirmaKompenzacijaDto {
    data?: MojaFirmaKompenzacijaDto | undefined;

    constructor(data?: IResultOfMojaFirmaKompenzacijaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? MojaFirmaKompenzacijaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfMojaFirmaKompenzacijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfMojaFirmaKompenzacijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfMojaFirmaKompenzacijaDto extends IResult {
    data?: MojaFirmaKompenzacijaDto | undefined;
}

export class MojaFirmaKompenzacijaDto implements IMojaFirmaKompenzacijaDto {
    naziv?: string | undefined;
    adresa?: string | undefined;
    pib?: string | undefined;
    mb?: string | undefined;

    constructor(data?: IMojaFirmaKompenzacijaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.adresa = _data["adresa"];
            this.pib = _data["pib"];
            this.mb = _data["mb"];
        }
    }

    static fromJS(data: any): MojaFirmaKompenzacijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new MojaFirmaKompenzacijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["adresa"] = this.adresa;
        data["pib"] = this.pib;
        data["mb"] = this.mb;
        return data;
    }
}

export interface IMojaFirmaKompenzacijaDto {
    naziv?: string | undefined;
    adresa?: string | undefined;
    pib?: string | undefined;
    mb?: string | undefined;
}

export class ResultOfGetPdvConfigurationResponse extends Result implements IResultOfGetPdvConfigurationResponse {
    data?: GetPdvConfigurationResponse | undefined;

    constructor(data?: IResultOfGetPdvConfigurationResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetPdvConfigurationResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetPdvConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetPdvConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetPdvConfigurationResponse extends IResult {
    data?: GetPdvConfigurationResponse | undefined;
}

export class GetPdvConfigurationResponse implements IGetPdvConfigurationResponse {
    uSistemuPDVa?: boolean;
    stopaPDVa?: number;

    constructor(data?: IGetPdvConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uSistemuPDVa = _data["uSistemuPDVa"];
            this.stopaPDVa = _data["stopaPDVa"];
        }
    }

    static fromJS(data: any): GetPdvConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPdvConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uSistemuPDVa"] = this.uSistemuPDVa;
        data["stopaPDVa"] = this.stopaPDVa;
        return data;
    }
}

export interface IGetPdvConfigurationResponse {
    uSistemuPDVa?: boolean;
    stopaPDVa?: number;
}

export class ResultOfGetMojaFirmaIzdavalacPrimalacVm extends Result implements IResultOfGetMojaFirmaIzdavalacPrimalacVm {
    data?: GetMojaFirmaIzdavalacPrimalacVm | undefined;

    constructor(data?: IResultOfGetMojaFirmaIzdavalacPrimalacVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetMojaFirmaIzdavalacPrimalacVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetMojaFirmaIzdavalacPrimalacVm {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetMojaFirmaIzdavalacPrimalacVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetMojaFirmaIzdavalacPrimalacVm extends IResult {
    data?: GetMojaFirmaIzdavalacPrimalacVm | undefined;
}

export class GetMojaFirmaIzdavalacPrimalacVm implements IGetMojaFirmaIzdavalacPrimalacVm {
    headerInfo?: MojaFirmaHeaderInfoDto | undefined;
    izdavalacPrimalac?: StrankaRacunaDto | undefined;

    constructor(data?: IGetMojaFirmaIzdavalacPrimalacVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.headerInfo = _data["headerInfo"] ? MojaFirmaHeaderInfoDto.fromJS(_data["headerInfo"]) : <any>undefined;
            this.izdavalacPrimalac = _data["izdavalacPrimalac"] ? StrankaRacunaDto.fromJS(_data["izdavalacPrimalac"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMojaFirmaIzdavalacPrimalacVm {
        data = typeof data === 'object' ? data : {};
        let result = new GetMojaFirmaIzdavalacPrimalacVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headerInfo"] = this.headerInfo ? this.headerInfo.toJSON() : <any>undefined;
        data["izdavalacPrimalac"] = this.izdavalacPrimalac ? this.izdavalacPrimalac.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMojaFirmaIzdavalacPrimalacVm {
    headerInfo?: MojaFirmaHeaderInfoDto | undefined;
    izdavalacPrimalac?: StrankaRacunaDto | undefined;
}

export class MojaFirmaHeaderInfoDto implements IMojaFirmaHeaderInfoDto {
    telefon?: string | undefined;
    email?: string | undefined;
    webSite?: string | undefined;
    logoPath?: string | undefined;

    constructor(data?: IMojaFirmaHeaderInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.telefon = _data["telefon"];
            this.email = _data["email"];
            this.webSite = _data["webSite"];
            this.logoPath = _data["logoPath"];
        }
    }

    static fromJS(data: any): MojaFirmaHeaderInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MojaFirmaHeaderInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["telefon"] = this.telefon;
        data["email"] = this.email;
        data["webSite"] = this.webSite;
        data["logoPath"] = this.logoPath;
        return data;
    }
}

export interface IMojaFirmaHeaderInfoDto {
    telefon?: string | undefined;
    email?: string | undefined;
    webSite?: string | undefined;
    logoPath?: string | undefined;
}

export class ResultOfKonfiguracijaMojeFirmeDto extends Result implements IResultOfKonfiguracijaMojeFirmeDto {
    data?: KonfiguracijaMojeFirmeDto | undefined;

    constructor(data?: IResultOfKonfiguracijaMojeFirmeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? KonfiguracijaMojeFirmeDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfKonfiguracijaMojeFirmeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfKonfiguracijaMojeFirmeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfKonfiguracijaMojeFirmeDto extends IResult {
    data?: KonfiguracijaMojeFirmeDto | undefined;
}

export class KonfiguracijaMojeFirmeDto implements IKonfiguracijaMojeFirmeDto {
    logoNaziv?: string | undefined;
    upisaniKapital?: number;
    valutaId?: string;
    valutaText?: string | undefined;
    aprBD?: string | undefined;
    pePDV?: string | undefined;
    uSistemuPDVa?: boolean;
    stopaPDV?: number;
    oznakaPdvKategorije?: OznakaPdvKategorije | undefined;
    razlogPdvIzuzecaId?: number | undefined;
    websiteUrl?: string | undefined;
    email?: string | undefined;
    vlasnici?: string | undefined;
    zastupnici?: string | undefined;
    ulicaIBroj?: string | undefined;
    grad?: string | undefined;
    postanskiBroj?: string | undefined;
    imeOsobeOvlasceneZaPotpisivanje?: string | undefined;
    displayPlacanjeStarihRacuna?: boolean;
    gln?: string | undefined;
    pracenjeLageraZaEOtpremnice?: boolean;

    constructor(data?: IKonfiguracijaMojeFirmeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logoNaziv = _data["logoNaziv"];
            this.upisaniKapital = _data["upisaniKapital"];
            this.valutaId = _data["valutaId"];
            this.valutaText = _data["valutaText"];
            this.aprBD = _data["aprBD"];
            this.pePDV = _data["pePDV"];
            this.uSistemuPDVa = _data["uSistemuPDVa"];
            this.stopaPDV = _data["stopaPDV"];
            this.oznakaPdvKategorije = _data["oznakaPdvKategorije"];
            this.razlogPdvIzuzecaId = _data["razlogPdvIzuzecaId"];
            this.websiteUrl = _data["websiteUrl"];
            this.email = _data["email"];
            this.vlasnici = _data["vlasnici"];
            this.zastupnici = _data["zastupnici"];
            this.ulicaIBroj = _data["ulicaIBroj"];
            this.grad = _data["grad"];
            this.postanskiBroj = _data["postanskiBroj"];
            this.imeOsobeOvlasceneZaPotpisivanje = _data["imeOsobeOvlasceneZaPotpisivanje"];
            this.displayPlacanjeStarihRacuna = _data["displayPlacanjeStarihRacuna"];
            this.gln = _data["gln"];
            this.pracenjeLageraZaEOtpremnice = _data["pracenjeLageraZaEOtpremnice"];
        }
    }

    static fromJS(data: any): KonfiguracijaMojeFirmeDto {
        data = typeof data === 'object' ? data : {};
        let result = new KonfiguracijaMojeFirmeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logoNaziv"] = this.logoNaziv;
        data["upisaniKapital"] = this.upisaniKapital;
        data["valutaId"] = this.valutaId;
        data["valutaText"] = this.valutaText;
        data["aprBD"] = this.aprBD;
        data["pePDV"] = this.pePDV;
        data["uSistemuPDVa"] = this.uSistemuPDVa;
        data["stopaPDV"] = this.stopaPDV;
        data["oznakaPdvKategorije"] = this.oznakaPdvKategorije;
        data["razlogPdvIzuzecaId"] = this.razlogPdvIzuzecaId;
        data["websiteUrl"] = this.websiteUrl;
        data["email"] = this.email;
        data["vlasnici"] = this.vlasnici;
        data["zastupnici"] = this.zastupnici;
        data["ulicaIBroj"] = this.ulicaIBroj;
        data["grad"] = this.grad;
        data["postanskiBroj"] = this.postanskiBroj;
        data["imeOsobeOvlasceneZaPotpisivanje"] = this.imeOsobeOvlasceneZaPotpisivanje;
        data["displayPlacanjeStarihRacuna"] = this.displayPlacanjeStarihRacuna;
        data["gln"] = this.gln;
        data["pracenjeLageraZaEOtpremnice"] = this.pracenjeLageraZaEOtpremnice;
        return data;
    }
}

export interface IKonfiguracijaMojeFirmeDto {
    logoNaziv?: string | undefined;
    upisaniKapital?: number;
    valutaId?: string;
    valutaText?: string | undefined;
    aprBD?: string | undefined;
    pePDV?: string | undefined;
    uSistemuPDVa?: boolean;
    stopaPDV?: number;
    oznakaPdvKategorije?: OznakaPdvKategorije | undefined;
    razlogPdvIzuzecaId?: number | undefined;
    websiteUrl?: string | undefined;
    email?: string | undefined;
    vlasnici?: string | undefined;
    zastupnici?: string | undefined;
    ulicaIBroj?: string | undefined;
    grad?: string | undefined;
    postanskiBroj?: string | undefined;
    imeOsobeOvlasceneZaPotpisivanje?: string | undefined;
    displayPlacanjeStarihRacuna?: boolean;
    gln?: string | undefined;
    pracenjeLageraZaEOtpremnice?: boolean;
}

export class UpdateKonfiguracijaMojeFirmeCommand implements IUpdateKonfiguracijaMojeFirmeCommand {
    upisaniKapital?: number;
    aprBD?: string | undefined;
    pePDV?: string | undefined;
    uSistemuPDVa?: boolean;
    stopaPDV?: number;
    oznakaPdvKategorije?: OznakaPdvKategorije | undefined;
    razlogPdvIzuzecaId?: number | undefined;
    valutaId?: string;
    valutaText?: string | undefined;
    logoNaziv?: string | undefined;
    websiteUrl?: string | undefined;
    email?: string | undefined;
    vlasnici?: string | undefined;
    zastupnici?: string | undefined;
    apiKeySEF?: string | undefined;
    ulicaIBroj?: string | undefined;
    grad?: string | undefined;
    postanskiBroj?: string | undefined;
    imeOsobeOvlasceneZaPotpisivanje?: string | undefined;
    gln?: string | undefined;
    displayPlacanjeStarihRacuna?: boolean;

    constructor(data?: IUpdateKonfiguracijaMojeFirmeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.upisaniKapital = _data["upisaniKapital"];
            this.aprBD = _data["aprBD"];
            this.pePDV = _data["pePDV"];
            this.uSistemuPDVa = _data["uSistemuPDVa"];
            this.stopaPDV = _data["stopaPDV"];
            this.oznakaPdvKategorije = _data["oznakaPdvKategorije"];
            this.razlogPdvIzuzecaId = _data["razlogPdvIzuzecaId"];
            this.valutaId = _data["valutaId"];
            this.valutaText = _data["valutaText"];
            this.logoNaziv = _data["logoNaziv"];
            this.websiteUrl = _data["websiteUrl"];
            this.email = _data["email"];
            this.vlasnici = _data["vlasnici"];
            this.zastupnici = _data["zastupnici"];
            this.apiKeySEF = _data["apiKeySEF"];
            this.ulicaIBroj = _data["ulicaIBroj"];
            this.grad = _data["grad"];
            this.postanskiBroj = _data["postanskiBroj"];
            this.imeOsobeOvlasceneZaPotpisivanje = _data["imeOsobeOvlasceneZaPotpisivanje"];
            this.gln = _data["gln"];
            this.displayPlacanjeStarihRacuna = _data["displayPlacanjeStarihRacuna"];
        }
    }

    static fromJS(data: any): UpdateKonfiguracijaMojeFirmeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateKonfiguracijaMojeFirmeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["upisaniKapital"] = this.upisaniKapital;
        data["aprBD"] = this.aprBD;
        data["pePDV"] = this.pePDV;
        data["uSistemuPDVa"] = this.uSistemuPDVa;
        data["stopaPDV"] = this.stopaPDV;
        data["oznakaPdvKategorije"] = this.oznakaPdvKategorije;
        data["razlogPdvIzuzecaId"] = this.razlogPdvIzuzecaId;
        data["valutaId"] = this.valutaId;
        data["valutaText"] = this.valutaText;
        data["logoNaziv"] = this.logoNaziv;
        data["websiteUrl"] = this.websiteUrl;
        data["email"] = this.email;
        data["vlasnici"] = this.vlasnici;
        data["zastupnici"] = this.zastupnici;
        data["apiKeySEF"] = this.apiKeySEF;
        data["ulicaIBroj"] = this.ulicaIBroj;
        data["grad"] = this.grad;
        data["postanskiBroj"] = this.postanskiBroj;
        data["imeOsobeOvlasceneZaPotpisivanje"] = this.imeOsobeOvlasceneZaPotpisivanje;
        data["gln"] = this.gln;
        data["displayPlacanjeStarihRacuna"] = this.displayPlacanjeStarihRacuna;
        return data;
    }
}

export interface IUpdateKonfiguracijaMojeFirmeCommand {
    upisaniKapital?: number;
    aprBD?: string | undefined;
    pePDV?: string | undefined;
    uSistemuPDVa?: boolean;
    stopaPDV?: number;
    oznakaPdvKategorije?: OznakaPdvKategorije | undefined;
    razlogPdvIzuzecaId?: number | undefined;
    valutaId?: string;
    valutaText?: string | undefined;
    logoNaziv?: string | undefined;
    websiteUrl?: string | undefined;
    email?: string | undefined;
    vlasnici?: string | undefined;
    zastupnici?: string | undefined;
    apiKeySEF?: string | undefined;
    ulicaIBroj?: string | undefined;
    grad?: string | undefined;
    postanskiBroj?: string | undefined;
    imeOsobeOvlasceneZaPotpisivanje?: string | undefined;
    gln?: string | undefined;
    displayPlacanjeStarihRacuna?: boolean;
}

export class UpdatePracenjeLageraZaEOtpremniceCommand implements IUpdatePracenjeLageraZaEOtpremniceCommand {
    pracenjeLageraZaEOtpremnice?: boolean;

    constructor(data?: IUpdatePracenjeLageraZaEOtpremniceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pracenjeLageraZaEOtpremnice = _data["pracenjeLageraZaEOtpremnice"];
        }
    }

    static fromJS(data: any): UpdatePracenjeLageraZaEOtpremniceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePracenjeLageraZaEOtpremniceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pracenjeLageraZaEOtpremnice"] = this.pracenjeLageraZaEOtpremnice;
        return data;
    }
}

export interface IUpdatePracenjeLageraZaEOtpremniceCommand {
    pracenjeLageraZaEOtpremnice?: boolean;
}

export class ResultOfApiMenadzmentDto extends Result implements IResultOfApiMenadzmentDto {
    data?: ApiMenadzmentDto | undefined;

    constructor(data?: IResultOfApiMenadzmentDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? ApiMenadzmentDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfApiMenadzmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfApiMenadzmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfApiMenadzmentDto extends IResult {
    data?: ApiMenadzmentDto | undefined;
}

export class ApiMenadzmentDto implements IApiMenadzmentDto {
    apiKeySEF?: string | undefined;
    apiKeyZaOtpremnice?: string | undefined;
    medij?: Medij;
    endpointZaUlazneNotifikacije?: string | undefined;
    endpointZaIzlazneNotifikacije?: string | undefined;
    endpointZaOtpremnicaNotifikacije?: string | undefined;

    constructor(data?: IApiMenadzmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiKeySEF = _data["apiKeySEF"];
            this.apiKeyZaOtpremnice = _data["apiKeyZaOtpremnice"];
            this.medij = _data["medij"];
            this.endpointZaUlazneNotifikacije = _data["endpointZaUlazneNotifikacije"];
            this.endpointZaIzlazneNotifikacije = _data["endpointZaIzlazneNotifikacije"];
            this.endpointZaOtpremnicaNotifikacije = _data["endpointZaOtpremnicaNotifikacije"];
        }
    }

    static fromJS(data: any): ApiMenadzmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiMenadzmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKeySEF"] = this.apiKeySEF;
        data["apiKeyZaOtpremnice"] = this.apiKeyZaOtpremnice;
        data["medij"] = this.medij;
        data["endpointZaUlazneNotifikacije"] = this.endpointZaUlazneNotifikacije;
        data["endpointZaIzlazneNotifikacije"] = this.endpointZaIzlazneNotifikacije;
        data["endpointZaOtpremnicaNotifikacije"] = this.endpointZaOtpremnicaNotifikacije;
        return data;
    }
}

export interface IApiMenadzmentDto {
    apiKeySEF?: string | undefined;
    apiKeyZaOtpremnice?: string | undefined;
    medij?: Medij;
    endpointZaUlazneNotifikacije?: string | undefined;
    endpointZaIzlazneNotifikacije?: string | undefined;
    endpointZaOtpremnicaNotifikacije?: string | undefined;
}

export enum Medij {
    DEFAULT = 0,
    REGOS = 1,
    BIZ_UP = 2,
    WEBSITE = 3,
}

export class UpdateSefApiKeyCommand implements IUpdateSefApiKeyCommand {
    apiKeySEF?: string | undefined;
    isDeliveryNote?: boolean;

    constructor(data?: IUpdateSefApiKeyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiKeySEF = _data["apiKeySEF"];
            this.isDeliveryNote = _data["isDeliveryNote"];
        }
    }

    static fromJS(data: any): UpdateSefApiKeyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSefApiKeyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKeySEF"] = this.apiKeySEF;
        data["isDeliveryNote"] = this.isDeliveryNote;
        return data;
    }
}

export interface IUpdateSefApiKeyCommand {
    apiKeySEF?: string | undefined;
    isDeliveryNote?: boolean;
}

export class ResultOfMedij extends Result implements IResultOfMedij {
    data?: Medij;

    constructor(data?: IResultOfMedij) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ResultOfMedij {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfMedij();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfMedij extends IResult {
    data?: Medij;
}

export class FooterInfoDto implements IFooterInfoDto {
    pib?: string | undefined;
    mb?: string | undefined;
    sifraDelatnosti?: string | undefined;
    upisanKapital?: string | undefined;
    aprBD?: string | undefined;
    pePDV?: string | undefined;

    constructor(data?: IFooterInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pib = _data["pib"];
            this.mb = _data["mb"];
            this.sifraDelatnosti = _data["sifraDelatnosti"];
            this.upisanKapital = _data["upisanKapital"];
            this.aprBD = _data["aprBD"];
            this.pePDV = _data["pePDV"];
        }
    }

    static fromJS(data: any): FooterInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new FooterInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pib"] = this.pib;
        data["mb"] = this.mb;
        data["sifraDelatnosti"] = this.sifraDelatnosti;
        data["upisanKapital"] = this.upisanKapital;
        data["aprBD"] = this.aprBD;
        data["pePDV"] = this.pePDV;
        return data;
    }
}

export interface IFooterInfoDto {
    pib?: string | undefined;
    mb?: string | undefined;
    sifraDelatnosti?: string | undefined;
    upisanKapital?: string | undefined;
    aprBD?: string | undefined;
    pePDV?: string | undefined;
}

export class ResultOfPrviLoginDto extends Result implements IResultOfPrviLoginDto {
    data?: PrviLoginDto | undefined;

    constructor(data?: IResultOfPrviLoginDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PrviLoginDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfPrviLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfPrviLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfPrviLoginDto extends IResult {
    data?: PrviLoginDto | undefined;
}

export class PrviLoginDto implements IPrviLoginDto {
    jePrviLogin?: boolean;

    constructor(data?: IPrviLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jePrviLogin = _data["jePrviLogin"];
        }
    }

    static fromJS(data: any): PrviLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrviLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jePrviLogin"] = this.jePrviLogin;
        return data;
    }
}

export interface IPrviLoginDto {
    jePrviLogin?: boolean;
}

export class PrviLoginMojaFirmaCommand implements IPrviLoginMojaFirmaCommand {
    uSistemuPDVa?: boolean;
    pravniOblik?: PravniOblik;
    stopaPDV?: number;
    oznakaPdvKategorije?: OznakaPdvKategorije | undefined;
    razlogPdvIzuzecaId?: number | undefined;
    prihvaceniUsloviKoriscenja?: boolean;

    constructor(data?: IPrviLoginMojaFirmaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uSistemuPDVa = _data["uSistemuPDVa"];
            this.pravniOblik = _data["pravniOblik"];
            this.stopaPDV = _data["stopaPDV"];
            this.oznakaPdvKategorije = _data["oznakaPdvKategorije"];
            this.razlogPdvIzuzecaId = _data["razlogPdvIzuzecaId"];
            this.prihvaceniUsloviKoriscenja = _data["prihvaceniUsloviKoriscenja"];
        }
    }

    static fromJS(data: any): PrviLoginMojaFirmaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PrviLoginMojaFirmaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uSistemuPDVa"] = this.uSistemuPDVa;
        data["pravniOblik"] = this.pravniOblik;
        data["stopaPDV"] = this.stopaPDV;
        data["oznakaPdvKategorije"] = this.oznakaPdvKategorije;
        data["razlogPdvIzuzecaId"] = this.razlogPdvIzuzecaId;
        data["prihvaceniUsloviKoriscenja"] = this.prihvaceniUsloviKoriscenja;
        return data;
    }
}

export interface IPrviLoginMojaFirmaCommand {
    uSistemuPDVa?: boolean;
    pravniOblik?: PravniOblik;
    stopaPDV?: number;
    oznakaPdvKategorije?: OznakaPdvKategorije | undefined;
    razlogPdvIzuzecaId?: number | undefined;
    prihvaceniUsloviKoriscenja?: boolean;
}

export class SenderSignatureDto implements ISenderSignatureDto {
    fromEmail?: string | undefined;
    name?: string | undefined;
    replyToEmail?: string | undefined;
    confirmationPersonalNote?: string | undefined;

    constructor(data?: ISenderSignatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromEmail = _data["fromEmail"];
            this.name = _data["name"];
            this.replyToEmail = _data["replyToEmail"];
            this.confirmationPersonalNote = _data["confirmationPersonalNote"];
        }
    }

    static fromJS(data: any): SenderSignatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new SenderSignatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromEmail"] = this.fromEmail;
        data["name"] = this.name;
        data["replyToEmail"] = this.replyToEmail;
        data["confirmationPersonalNote"] = this.confirmationPersonalNote;
        return data;
    }
}

export interface ISenderSignatureDto {
    fromEmail?: string | undefined;
    name?: string | undefined;
    replyToEmail?: string | undefined;
    confirmationPersonalNote?: string | undefined;
}

export class AddSenderSignatureCommand extends SenderSignatureDto implements IAddSenderSignatureCommand {

    constructor(data?: IAddSenderSignatureCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AddSenderSignatureCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddSenderSignatureCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAddSenderSignatureCommand extends ISenderSignatureDto {
}

export class PaginatedResultOfSenderSignatureTableDto extends Result implements IPaginatedResultOfSenderSignatureTableDto {
    data?: SenderSignatureTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfSenderSignatureTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SenderSignatureTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfSenderSignatureTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfSenderSignatureTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfSenderSignatureTableDto extends IResult {
    data?: SenderSignatureTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class SenderSignatureTableDto implements ISenderSignatureTableDto {
    id?: string;
    email?: string | undefined;
    name?: string | undefined;
    replyToEmail?: string | undefined;
    confirmed?: boolean;
    default?: boolean;
    defaultForExternal?: boolean;

    constructor(data?: ISenderSignatureTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.replyToEmail = _data["replyToEmail"];
            this.confirmed = _data["confirmed"];
            this.default = _data["default"];
            this.defaultForExternal = _data["defaultForExternal"];
        }
    }

    static fromJS(data: any): SenderSignatureTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SenderSignatureTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["name"] = this.name;
        data["replyToEmail"] = this.replyToEmail;
        data["confirmed"] = this.confirmed;
        data["default"] = this.default;
        data["defaultForExternal"] = this.defaultForExternal;
        return data;
    }
}

export interface ISenderSignatureTableDto {
    id?: string;
    email?: string | undefined;
    name?: string | undefined;
    replyToEmail?: string | undefined;
    confirmed?: boolean;
    default?: boolean;
    defaultForExternal?: boolean;
}

export class GetSenderSignaturesTableQuery implements IGetSenderSignaturesTableQuery {
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetSenderSignaturesTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetSenderSignaturesTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSenderSignaturesTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetSenderSignaturesTableQuery {
    pageNumber?: number;
    pageSize?: number;
}

export class ResultOfIReadOnlyCollectionOfSenderSignatureDropdownDto extends Result implements IResultOfIReadOnlyCollectionOfSenderSignatureDropdownDto {
    data?: SenderSignatureDropdownDto[] | undefined;

    constructor(data?: IResultOfIReadOnlyCollectionOfSenderSignatureDropdownDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SenderSignatureDropdownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfIReadOnlyCollectionOfSenderSignatureDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfIReadOnlyCollectionOfSenderSignatureDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfIReadOnlyCollectionOfSenderSignatureDropdownDto extends IResult {
    data?: SenderSignatureDropdownDto[] | undefined;
}

export class SenderSignatureDropdownDto implements ISenderSignatureDropdownDto {
    id?: string;
    email?: string | undefined;

    constructor(data?: ISenderSignatureDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SenderSignatureDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new SenderSignatureDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        return data;
    }
}

export interface ISenderSignatureDropdownDto {
    id?: string;
    email?: string | undefined;
}

export class ResultOfSenderDomainDto extends Result implements IResultOfSenderDomainDto {
    data?: SenderDomainDto | undefined;

    constructor(data?: IResultOfSenderDomainDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? SenderDomainDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfSenderDomainDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfSenderDomainDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfSenderDomainDto extends IResult {
    data?: SenderDomainDto | undefined;
}

export class SenderDomainDto implements ISenderDomainDto {
    id?: number;
    dkimHost?: string | undefined;
    dkimVerified?: boolean;
    dkimValue?: string | undefined;
    returnPathHost?: string | undefined;
    returnPathVerified?: boolean;
    returnPathValue?: string | undefined;

    constructor(data?: ISenderDomainDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dkimHost = _data["dkimHost"];
            this.dkimVerified = _data["dkimVerified"];
            this.dkimValue = _data["dkimValue"];
            this.returnPathHost = _data["returnPathHost"];
            this.returnPathVerified = _data["returnPathVerified"];
            this.returnPathValue = _data["returnPathValue"];
        }
    }

    static fromJS(data: any): SenderDomainDto {
        data = typeof data === 'object' ? data : {};
        let result = new SenderDomainDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dkimHost"] = this.dkimHost;
        data["dkimVerified"] = this.dkimVerified;
        data["dkimValue"] = this.dkimValue;
        data["returnPathHost"] = this.returnPathHost;
        data["returnPathVerified"] = this.returnPathVerified;
        data["returnPathValue"] = this.returnPathValue;
        return data;
    }
}

export interface ISenderDomainDto {
    id?: number;
    dkimHost?: string | undefined;
    dkimVerified?: boolean;
    dkimValue?: string | undefined;
    returnPathHost?: string | undefined;
    returnPathVerified?: boolean;
    returnPathValue?: string | undefined;
}

export class PaginatedResultOfNotifikacijaKorisnikaDto extends Result implements IPaginatedResultOfNotifikacijaKorisnikaDto {
    data?: NotifikacijaKorisnikaDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfNotifikacijaKorisnikaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(NotifikacijaKorisnikaDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfNotifikacijaKorisnikaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfNotifikacijaKorisnikaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfNotifikacijaKorisnikaDto extends IResult {
    data?: NotifikacijaKorisnikaDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class NotifikacijaKorisnikaDto implements INotifikacijaKorisnikaDto {
    id?: string | undefined;
    jeProcitana?: boolean;
    naslov?: string | undefined;
    tekst?: string | undefined;
    iconDto?: TableColumnIconDto | undefined;
    actionUrl?: string | undefined;
    tip?: TipNotifikacije;

    constructor(data?: INotifikacijaKorisnikaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jeProcitana = _data["jeProcitana"];
            this.naslov = _data["naslov"];
            this.tekst = _data["tekst"];
            this.iconDto = _data["iconDto"] ? TableColumnIconDto.fromJS(_data["iconDto"]) : <any>undefined;
            this.actionUrl = _data["actionUrl"];
            this.tip = _data["tip"];
        }
    }

    static fromJS(data: any): NotifikacijaKorisnikaDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotifikacijaKorisnikaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jeProcitana"] = this.jeProcitana;
        data["naslov"] = this.naslov;
        data["tekst"] = this.tekst;
        data["iconDto"] = this.iconDto ? this.iconDto.toJSON() : <any>undefined;
        data["actionUrl"] = this.actionUrl;
        data["tip"] = this.tip;
        return data;
    }
}

export interface INotifikacijaKorisnikaDto {
    id?: string | undefined;
    jeProcitana?: boolean;
    naslov?: string | undefined;
    tekst?: string | undefined;
    iconDto?: TableColumnIconDto | undefined;
    actionUrl?: string | undefined;
    tip?: TipNotifikacije;
}

export class TableColumnIconDto implements ITableColumnIconDto {
    backgroundColor?: string | undefined;
    iconName?: string | undefined;
    iconColor?: string | undefined;

    constructor(data?: ITableColumnIconDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.backgroundColor = _data["backgroundColor"];
            this.iconName = _data["iconName"];
            this.iconColor = _data["iconColor"];
        }
    }

    static fromJS(data: any): TableColumnIconDto {
        data = typeof data === 'object' ? data : {};
        let result = new TableColumnIconDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["backgroundColor"] = this.backgroundColor;
        data["iconName"] = this.iconName;
        data["iconColor"] = this.iconColor;
        return data;
    }
}

export interface ITableColumnIconDto {
    backgroundColor?: string | undefined;
    iconName?: string | undefined;
    iconColor?: string | undefined;
}

export enum TipNotifikacije {
    EKOMPANIJA = 0,
    SEF = 1,
    KORISNICKA = 2,
}

export class GetNotifikacijaKorisnikaListQuery implements IGetNotifikacijaKorisnikaListQuery {
    samoNeprocitane?: boolean;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetNotifikacijaKorisnikaListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.samoNeprocitane = _data["samoNeprocitane"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetNotifikacijaKorisnikaListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotifikacijaKorisnikaListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["samoNeprocitane"] = this.samoNeprocitane;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetNotifikacijaKorisnikaListQuery {
    samoNeprocitane?: boolean;
    pageNumber?: number;
    pageSize?: number;
}

export class ResultOfListOfAktivniJobDto extends Result implements IResultOfListOfAktivniJobDto {
    data?: AktivniJobDto[] | undefined;

    constructor(data?: IResultOfListOfAktivniJobDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AktivniJobDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfAktivniJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfAktivniJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfAktivniJobDto extends IResult {
    data?: AktivniJobDto[] | undefined;
}

export class AktivniJobDto implements IAktivniJobDto {
    vrstaJoba?: VrstaJoba;
    progress?: number;

    constructor(data?: IAktivniJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vrstaJoba = _data["vrstaJoba"];
            this.progress = _data["progress"];
        }
    }

    static fromJS(data: any): AktivniJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new AktivniJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vrstaJoba"] = this.vrstaJoba;
        data["progress"] = this.progress;
        return data;
    }
}

export interface IAktivniJobDto {
    vrstaJoba?: VrstaJoba;
    progress?: number;
}

export class ReadAllNotificationsComand implements IReadAllNotificationsComand {
    notifikacijeIds?: string[] | undefined;

    constructor(data?: IReadAllNotificationsComand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notifikacijeIds"])) {
                this.notifikacijeIds = [] as any;
                for (let item of _data["notifikacijeIds"])
                    this.notifikacijeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ReadAllNotificationsComand {
        data = typeof data === 'object' ? data : {};
        let result = new ReadAllNotificationsComand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notifikacijeIds)) {
            data["notifikacijeIds"] = [];
            for (let item of this.notifikacijeIds)
                data["notifikacijeIds"].push(item);
        }
        return data;
    }
}

export interface IReadAllNotificationsComand {
    notifikacijeIds?: string[] | undefined;
}

export class CreateOtpremnicaCommand implements ICreateOtpremnicaCommand {
    preuzeo?: string | undefined;
    izdao?: string | undefined;
    racunDto?: RacunDto | undefined;
    brojVozilaIliLk?: string | undefined;
    voziloId?: number | undefined;
    informacijaIsporuke?: InformacijaIsporukeDto | undefined;
    vozila?: VoziloDropdownDto[] | undefined;
    vrsta?: VrstaOtpremnice;
    interniMagacinId?: number | undefined;

    constructor(data?: ICreateOtpremnicaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preuzeo = _data["preuzeo"];
            this.izdao = _data["izdao"];
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.brojVozilaIliLk = _data["brojVozilaIliLk"];
            this.voziloId = _data["voziloId"];
            this.informacijaIsporuke = _data["informacijaIsporuke"] ? InformacijaIsporukeDto.fromJS(_data["informacijaIsporuke"]) : <any>undefined;
            if (Array.isArray(_data["vozila"])) {
                this.vozila = [] as any;
                for (let item of _data["vozila"])
                    this.vozila!.push(VoziloDropdownDto.fromJS(item));
            }
            this.vrsta = _data["vrsta"];
            this.interniMagacinId = _data["interniMagacinId"];
        }
    }

    static fromJS(data: any): CreateOtpremnicaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOtpremnicaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preuzeo"] = this.preuzeo;
        data["izdao"] = this.izdao;
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["brojVozilaIliLk"] = this.brojVozilaIliLk;
        data["voziloId"] = this.voziloId;
        data["informacijaIsporuke"] = this.informacijaIsporuke ? this.informacijaIsporuke.toJSON() : <any>undefined;
        if (Array.isArray(this.vozila)) {
            data["vozila"] = [];
            for (let item of this.vozila)
                data["vozila"].push(item.toJSON());
        }
        data["vrsta"] = this.vrsta;
        data["interniMagacinId"] = this.interniMagacinId;
        return data;
    }
}

export interface ICreateOtpremnicaCommand {
    preuzeo?: string | undefined;
    izdao?: string | undefined;
    racunDto?: RacunDto | undefined;
    brojVozilaIliLk?: string | undefined;
    voziloId?: number | undefined;
    informacijaIsporuke?: InformacijaIsporukeDto | undefined;
    vozila?: VoziloDropdownDto[] | undefined;
    vrsta?: VrstaOtpremnice;
    interniMagacinId?: number | undefined;
}

export class UpdateOtpremnicaCommand implements IUpdateOtpremnicaCommand {
    preuzeo?: string | undefined;
    izdao?: string | undefined;
    racunDto?: RacunDto | undefined;
    brojVozilaIliLk?: string | undefined;
    voziloId?: number | undefined;
    informacijaIsporuke?: InformacijaIsporukeDto | undefined;
    vozila?: VoziloDropdownDto[] | undefined;
    vrsta?: VrstaOtpremnice;
    interniMagacinId?: number | undefined;

    constructor(data?: IUpdateOtpremnicaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preuzeo = _data["preuzeo"];
            this.izdao = _data["izdao"];
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.brojVozilaIliLk = _data["brojVozilaIliLk"];
            this.voziloId = _data["voziloId"];
            this.informacijaIsporuke = _data["informacijaIsporuke"] ? InformacijaIsporukeDto.fromJS(_data["informacijaIsporuke"]) : <any>undefined;
            if (Array.isArray(_data["vozila"])) {
                this.vozila = [] as any;
                for (let item of _data["vozila"])
                    this.vozila!.push(VoziloDropdownDto.fromJS(item));
            }
            this.vrsta = _data["vrsta"];
            this.interniMagacinId = _data["interniMagacinId"];
        }
    }

    static fromJS(data: any): UpdateOtpremnicaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOtpremnicaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preuzeo"] = this.preuzeo;
        data["izdao"] = this.izdao;
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["brojVozilaIliLk"] = this.brojVozilaIliLk;
        data["voziloId"] = this.voziloId;
        data["informacijaIsporuke"] = this.informacijaIsporuke ? this.informacijaIsporuke.toJSON() : <any>undefined;
        if (Array.isArray(this.vozila)) {
            data["vozila"] = [];
            for (let item of this.vozila)
                data["vozila"].push(item.toJSON());
        }
        data["vrsta"] = this.vrsta;
        data["interniMagacinId"] = this.interniMagacinId;
        return data;
    }
}

export interface IUpdateOtpremnicaCommand {
    preuzeo?: string | undefined;
    izdao?: string | undefined;
    racunDto?: RacunDto | undefined;
    brojVozilaIliLk?: string | undefined;
    voziloId?: number | undefined;
    informacijaIsporuke?: InformacijaIsporukeDto | undefined;
    vozila?: VoziloDropdownDto[] | undefined;
    vrsta?: VrstaOtpremnice;
    interniMagacinId?: number | undefined;
}

export class ResultOfOtpremnicaDto extends Result implements IResultOfOtpremnicaDto {
    data?: OtpremnicaDto | undefined;

    constructor(data?: IResultOfOtpremnicaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? OtpremnicaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfOtpremnicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfOtpremnicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfOtpremnicaDto extends IResult {
    data?: OtpremnicaDto | undefined;
}

export class GetRacunRequestDto implements IGetRacunRequestDto {
    id?: number;

    constructor(data?: IGetRacunRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetRacunRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRacunRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetRacunRequestDto {
    id?: number;
}

export class GetOtpremnicaQuery extends GetRacunRequestDto implements IGetOtpremnicaQuery {

    constructor(data?: IGetOtpremnicaQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetOtpremnicaQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetOtpremnicaQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetOtpremnicaQuery extends IGetRacunRequestDto {
}

export class ResultOfGetVrstaOtpremniceResponse extends Result implements IResultOfGetVrstaOtpremniceResponse {
    data?: GetVrstaOtpremniceResponse | undefined;

    constructor(data?: IResultOfGetVrstaOtpremniceResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetVrstaOtpremniceResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetVrstaOtpremniceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetVrstaOtpremniceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetVrstaOtpremniceResponse extends IResult {
    data?: GetVrstaOtpremniceResponse | undefined;
}

export class GetVrstaOtpremniceResponse implements IGetVrstaOtpremniceResponse {
    vrstaOtpremniceDtoList?: VrstaOtpremniceDto[] | undefined;

    constructor(data?: IGetVrstaOtpremniceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vrstaOtpremniceDtoList"])) {
                this.vrstaOtpremniceDtoList = [] as any;
                for (let item of _data["vrstaOtpremniceDtoList"])
                    this.vrstaOtpremniceDtoList!.push(VrstaOtpremniceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetVrstaOtpremniceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetVrstaOtpremniceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vrstaOtpremniceDtoList)) {
            data["vrstaOtpremniceDtoList"] = [];
            for (let item of this.vrstaOtpremniceDtoList)
                data["vrstaOtpremniceDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetVrstaOtpremniceResponse {
    vrstaOtpremniceDtoList?: VrstaOtpremniceDto[] | undefined;
}

export class VrstaOtpremniceDto implements IVrstaOtpremniceDto {
    vrsta?: VrstaOtpremnice;
    vrstaStr?: string | undefined;
    vrstaBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IVrstaOtpremniceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vrsta = _data["vrsta"];
            this.vrstaStr = _data["vrstaStr"];
            this.vrstaBadgeStr = _data["vrstaBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): VrstaOtpremniceDto {
        data = typeof data === 'object' ? data : {};
        let result = new VrstaOtpremniceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vrsta"] = this.vrsta;
        data["vrstaStr"] = this.vrstaStr;
        data["vrstaBadgeStr"] = this.vrstaBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IVrstaOtpremniceDto {
    vrsta?: VrstaOtpremnice;
    vrstaStr?: string | undefined;
    vrstaBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class OznakeTableVm implements IOznakeTableVm {
    oznakeTable?: OznakaTableDto[] | undefined;

    constructor(data?: IOznakeTableVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["oznakeTable"])) {
                this.oznakeTable = [] as any;
                for (let item of _data["oznakeTable"])
                    this.oznakeTable!.push(OznakaTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OznakeTableVm {
        data = typeof data === 'object' ? data : {};
        let result = new OznakeTableVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.oznakeTable)) {
            data["oznakeTable"] = [];
            for (let item of this.oznakeTable)
                data["oznakeTable"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOznakeTableVm {
    oznakeTable?: OznakaTableDto[] | undefined;
}

export class OznakaTableDto implements IOznakaTableDto {
    id?: number;
    naziv?: string | undefined;

    constructor(data?: IOznakaTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): OznakaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new OznakaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IOznakaTableDto {
    id?: number;
    naziv?: string | undefined;
}

export class OznakeTreeVm implements IOznakeTreeVm {
    oznakeTree?: OznakaTreeDto[] | undefined;

    constructor(data?: IOznakeTreeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["oznakeTree"])) {
                this.oznakeTree = [] as any;
                for (let item of _data["oznakeTree"])
                    this.oznakeTree!.push(OznakaTreeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OznakeTreeVm {
        data = typeof data === 'object' ? data : {};
        let result = new OznakeTreeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.oznakeTree)) {
            data["oznakeTree"] = [];
            for (let item of this.oznakeTree)
                data["oznakeTree"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOznakeTreeVm {
    oznakeTree?: OznakaTreeDto[] | undefined;
}

export class OznakaTreeDto implements IOznakaTreeDto {
    id?: number;
    naziv?: string | undefined;
    childrenDto?: OznakaTreeDto[] | undefined;

    constructor(data?: IOznakaTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            if (Array.isArray(_data["childrenDto"])) {
                this.childrenDto = [] as any;
                for (let item of _data["childrenDto"])
                    this.childrenDto!.push(OznakaTreeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OznakaTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OznakaTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        if (Array.isArray(this.childrenDto)) {
            data["childrenDto"] = [];
            for (let item of this.childrenDto)
                data["childrenDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOznakaTreeDto {
    id?: number;
    naziv?: string | undefined;
    childrenDto?: OznakaTreeDto[] | undefined;
}

export class ResultOfOznakaDto extends Result implements IResultOfOznakaDto {
    data?: OznakaDto | undefined;

    constructor(data?: IResultOfOznakaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? OznakaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfOznakaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfOznakaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfOznakaDto extends IResult {
    data?: OznakaDto | undefined;
}

export class ResultOfListOfGetOznakaMultiselectResponse extends Result implements IResultOfListOfGetOznakaMultiselectResponse {
    data?: GetOznakaMultiselectResponse[] | undefined;

    constructor(data?: IResultOfListOfGetOznakaMultiselectResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GetOznakaMultiselectResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfGetOznakaMultiselectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfGetOznakaMultiselectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfGetOznakaMultiselectResponse extends IResult {
    data?: GetOznakaMultiselectResponse[] | undefined;
}

export class GetOznakaMultiselectResponse implements IGetOznakaMultiselectResponse {
    id?: number;
    naziv?: string | undefined;

    constructor(data?: IGetOznakaMultiselectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): GetOznakaMultiselectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOznakaMultiselectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IGetOznakaMultiselectResponse {
    id?: number;
    naziv?: string | undefined;
}

export class ResultOfOznakaTreeDto extends Result implements IResultOfOznakaTreeDto {
    data?: OznakaTreeDto | undefined;

    constructor(data?: IResultOfOznakaTreeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? OznakaTreeDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfOznakaTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfOznakaTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfOznakaTreeDto extends IResult {
    data?: OznakaTreeDto | undefined;
}

export class CreateOznakaCommand implements ICreateOznakaCommand {
    id?: number | undefined;
    parent?: OznakaDto | undefined;
    naziv?: string | undefined;

    constructor(data?: ICreateOznakaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parent = _data["parent"] ? OznakaDto.fromJS(_data["parent"]) : <any>undefined;
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): CreateOznakaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOznakaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface ICreateOznakaCommand {
    id?: number | undefined;
    parent?: OznakaDto | undefined;
    naziv?: string | undefined;
}

export class OznakeVm implements IOznakeVm {
    oznake?: OznakaDto[] | undefined;

    constructor(data?: IOznakeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["oznake"])) {
                this.oznake = [] as any;
                for (let item of _data["oznake"])
                    this.oznake!.push(OznakaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OznakeVm {
        data = typeof data === 'object' ? data : {};
        let result = new OznakeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.oznake)) {
            data["oznake"] = [];
            for (let item of this.oznake)
                data["oznake"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOznakeVm {
    oznake?: OznakaDto[] | undefined;
}

export class GetOznakeByNazivRequestDto implements IGetOznakeByNazivRequestDto {
    id?: number | undefined;
    naziv?: string | undefined;
    tipOznake?: TipOznake | undefined;
    excludeTipoveEntiteta?: TipEntiteta[] | undefined;

    constructor(data?: IGetOznakeByNazivRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.tipOznake = _data["tipOznake"];
            if (Array.isArray(_data["excludeTipoveEntiteta"])) {
                this.excludeTipoveEntiteta = [] as any;
                for (let item of _data["excludeTipoveEntiteta"])
                    this.excludeTipoveEntiteta!.push(item);
            }
        }
    }

    static fromJS(data: any): GetOznakeByNazivRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOznakeByNazivRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["tipOznake"] = this.tipOznake;
        if (Array.isArray(this.excludeTipoveEntiteta)) {
            data["excludeTipoveEntiteta"] = [];
            for (let item of this.excludeTipoveEntiteta)
                data["excludeTipoveEntiteta"].push(item);
        }
        return data;
    }
}

export interface IGetOznakeByNazivRequestDto {
    id?: number | undefined;
    naziv?: string | undefined;
    tipOznake?: TipOznake | undefined;
    excludeTipoveEntiteta?: TipEntiteta[] | undefined;
}

export class GetOznakeQuery extends GetOznakeByNazivRequestDto implements IGetOznakeQuery {

    constructor(data?: IGetOznakeQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetOznakeQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetOznakeQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetOznakeQuery extends IGetOznakeByNazivRequestDto {
}

export class ResultOfOznakaRequest extends Result implements IResultOfOznakaRequest {
    data?: OznakaRequest | undefined;

    constructor(data?: IResultOfOznakaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? OznakaRequest.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfOznakaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfOznakaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfOznakaRequest extends IResult {
    data?: OznakaRequest | undefined;
}

export class OznakaRequest implements IOznakaRequest {
    id?: number | undefined;
    parent?: OznakaDto | undefined;
    naziv?: string | undefined;

    constructor(data?: IOznakaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parent = _data["parent"] ? OznakaDto.fromJS(_data["parent"]) : <any>undefined;
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): OznakaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OznakaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IOznakaRequest {
    id?: number | undefined;
    parent?: OznakaDto | undefined;
    naziv?: string | undefined;
}

export class UpdateOznakaCommand implements IUpdateOznakaCommand {
    id?: number | undefined;
    parent?: OznakaDto | undefined;
    naziv?: string | undefined;

    constructor(data?: IUpdateOznakaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parent = _data["parent"] ? OznakaDto.fromJS(_data["parent"]) : <any>undefined;
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): UpdateOznakaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOznakaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IUpdateOznakaCommand {
    id?: number | undefined;
    parent?: OznakaDto | undefined;
    naziv?: string | undefined;
}

export class ResultOfListOfPackageDto extends Result implements IResultOfListOfPackageDto {
    data?: PackageDto[] | undefined;

    constructor(data?: IResultOfListOfPackageDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PackageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfPackageDto extends IResult {
    data?: PackageDto[] | undefined;
}

export class PackageDto implements IPackageDto {
    packageId?: string;
    price?: number;
    priceLabel?: string | undefined;
    packageType?: SubscriptionPackage;
    label?: string | undefined;
    isAddition?: boolean;
    freeSeats?: number;

    constructor(data?: IPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageId = _data["packageId"];
            this.price = _data["price"];
            this.priceLabel = _data["priceLabel"];
            this.packageType = _data["packageType"];
            this.label = _data["label"];
            this.isAddition = _data["isAddition"];
            this.freeSeats = _data["freeSeats"];
        }
    }

    static fromJS(data: any): PackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageId"] = this.packageId;
        data["price"] = this.price;
        data["priceLabel"] = this.priceLabel;
        data["packageType"] = this.packageType;
        data["label"] = this.label;
        data["isAddition"] = this.isAddition;
        data["freeSeats"] = this.freeSeats;
        return data;
    }
}

export interface IPackageDto {
    packageId?: string;
    price?: number;
    priceLabel?: string | undefined;
    packageType?: SubscriptionPackage;
    label?: string | undefined;
    isAddition?: boolean;
    freeSeats?: number;
}

export class ResultOfUserPackagesResponse extends Result implements IResultOfUserPackagesResponse {
    data?: UserPackagesResponse | undefined;

    constructor(data?: IResultOfUserPackagesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? UserPackagesResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfUserPackagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfUserPackagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfUserPackagesResponse extends IResult {
    data?: UserPackagesResponse | undefined;
}

export class UserPackagesResponse implements IUserPackagesResponse {
    paketi?: OdabirPaketaDto | undefined;
    zastupnici?: string | undefined;

    constructor(data?: IUserPackagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paketi = _data["paketi"] ? OdabirPaketaDto.fromJS(_data["paketi"]) : <any>undefined;
            this.zastupnici = _data["zastupnici"];
        }
    }

    static fromJS(data: any): UserPackagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserPackagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paketi"] = this.paketi ? this.paketi.toJSON() : <any>undefined;
        data["zastupnici"] = this.zastupnici;
        return data;
    }
}

export interface IUserPackagesResponse {
    paketi?: OdabirPaketaDto | undefined;
    zastupnici?: string | undefined;
}

export class OdabirPaketaDto implements IOdabirPaketaDto {
    packages?: PackageDto[] | undefined;
    dodatniKorisnici?: number;
    dodatnaProdajnaMesta?: number;
    isYearly?: boolean;

    constructor(data?: IOdabirPaketaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["packages"])) {
                this.packages = [] as any;
                for (let item of _data["packages"])
                    this.packages!.push(PackageDto.fromJS(item));
            }
            this.dodatniKorisnici = _data["dodatniKorisnici"];
            this.dodatnaProdajnaMesta = _data["dodatnaProdajnaMesta"];
            this.isYearly = _data["isYearly"];
        }
    }

    static fromJS(data: any): OdabirPaketaDto {
        data = typeof data === 'object' ? data : {};
        let result = new OdabirPaketaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (let item of this.packages)
                data["packages"].push(item.toJSON());
        }
        data["dodatniKorisnici"] = this.dodatniKorisnici;
        data["dodatnaProdajnaMesta"] = this.dodatnaProdajnaMesta;
        data["isYearly"] = this.isYearly;
        return data;
    }
}

export interface IOdabirPaketaDto {
    packages?: PackageDto[] | undefined;
    dodatniKorisnici?: number;
    dodatnaProdajnaMesta?: number;
    isYearly?: boolean;
}

export class UpdateUserPackagesCommand implements IUpdateUserPackagesCommand {
    odabirPaketaDto?: OdabirPaketaDto | undefined;
    zastupnik?: string | undefined;

    constructor(data?: IUpdateUserPackagesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odabirPaketaDto = _data["odabirPaketaDto"] ? OdabirPaketaDto.fromJS(_data["odabirPaketaDto"]) : <any>undefined;
            this.zastupnik = _data["zastupnik"];
        }
    }

    static fromJS(data: any): UpdateUserPackagesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPackagesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["odabirPaketaDto"] = this.odabirPaketaDto ? this.odabirPaketaDto.toJSON() : <any>undefined;
        data["zastupnik"] = this.zastupnik;
        return data;
    }
}

export interface IUpdateUserPackagesCommand {
    odabirPaketaDto?: OdabirPaketaDto | undefined;
    zastupnik?: string | undefined;
}

export class GetPackagesContractQuery implements IGetPackagesContractQuery {
    dto?: OdabirPaketaDto | undefined;
    zastupnik?: string | undefined;

    constructor(data?: IGetPackagesContractQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dto = _data["dto"] ? OdabirPaketaDto.fromJS(_data["dto"]) : <any>undefined;
            this.zastupnik = _data["zastupnik"];
        }
    }

    static fromJS(data: any): GetPackagesContractQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPackagesContractQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dto"] = this.dto ? this.dto.toJSON() : <any>undefined;
        data["zastupnik"] = this.zastupnik;
        return data;
    }
}

export interface IGetPackagesContractQuery {
    dto?: OdabirPaketaDto | undefined;
    zastupnik?: string | undefined;
}

export class ResultOfGetPdvOpsegDropdownResponse extends Result implements IResultOfGetPdvOpsegDropdownResponse {
    data?: GetPdvOpsegDropdownResponse | undefined;

    constructor(data?: IResultOfGetPdvOpsegDropdownResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetPdvOpsegDropdownResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetPdvOpsegDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetPdvOpsegDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetPdvOpsegDropdownResponse extends IResult {
    data?: GetPdvOpsegDropdownResponse | undefined;
}

export class GetPdvOpsegDropdownResponse implements IGetPdvOpsegDropdownResponse {
    responseList?: PdvOpsegDto[] | undefined;

    constructor(data?: IGetPdvOpsegDropdownResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(PdvOpsegDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPdvOpsegDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPdvOpsegDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPdvOpsegDropdownResponse {
    responseList?: PdvOpsegDto[] | undefined;
}

export class PdvOpsegDto implements IPdvOpsegDto {
    opseg?: PdvOpseg;
    opsegStr?: string | undefined;
    opsegBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IPdvOpsegDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opseg = _data["opseg"];
            this.opsegStr = _data["opsegStr"];
            this.opsegBadgeStr = _data["opsegBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): PdvOpsegDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdvOpsegDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opseg"] = this.opseg;
        data["opsegStr"] = this.opsegStr;
        data["opsegBadgeStr"] = this.opsegBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IPdvOpsegDto {
    opseg?: PdvOpseg;
    opsegStr?: string | undefined;
    opsegBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export enum PdvOpseg {
    MESECNO = 0,
    KVARTALNO = 1,
}

export class ResultOfGetPdvPeriodDropdownResponse extends Result implements IResultOfGetPdvPeriodDropdownResponse {
    data?: GetPdvPeriodDropdownResponse | undefined;

    constructor(data?: IResultOfGetPdvPeriodDropdownResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetPdvPeriodDropdownResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetPdvPeriodDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetPdvPeriodDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetPdvPeriodDropdownResponse extends IResult {
    data?: GetPdvPeriodDropdownResponse | undefined;
}

export class GetPdvPeriodDropdownResponse implements IGetPdvPeriodDropdownResponse {
    responseList?: PdvPeriodDto[] | undefined;

    constructor(data?: IGetPdvPeriodDropdownResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(PdvPeriodDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPdvPeriodDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPdvPeriodDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPdvPeriodDropdownResponse {
    responseList?: PdvPeriodDto[] | undefined;
}

export class PdvPeriodDto implements IPdvPeriodDto {
    period?: PdvPeriod;
    periodStr?: string | undefined;
    periodBadgeStr?: string | undefined;
    opis?: string | undefined;
    opseg?: PdvOpseg;

    constructor(data?: IPdvPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"];
            this.periodStr = _data["periodStr"];
            this.periodBadgeStr = _data["periodBadgeStr"];
            this.opis = _data["opis"];
            this.opseg = _data["opseg"];
        }
    }

    static fromJS(data: any): PdvPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdvPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["periodStr"] = this.periodStr;
        data["periodBadgeStr"] = this.periodBadgeStr;
        data["opis"] = this.opis;
        data["opseg"] = this.opseg;
        return data;
    }
}

export interface IPdvPeriodDto {
    period?: PdvPeriod;
    periodStr?: string | undefined;
    periodBadgeStr?: string | undefined;
    opis?: string | undefined;
    opseg?: PdvOpseg;
}

export class ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse extends Result implements IResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse {
    data?: CreateUpdatePdvEvidencijaPojedinacnaResponse | undefined;

    constructor(data?: IResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? CreateUpdatePdvEvidencijaPojedinacnaResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfCreateUpdatePdvEvidencijaPojedinacnaResponse extends IResult {
    data?: CreateUpdatePdvEvidencijaPojedinacnaResponse | undefined;
}

export class CreateUpdatePdvEvidencijaPojedinacnaResponse implements ICreateUpdatePdvEvidencijaPojedinacnaResponse {
    id?: number;
    broj?: string | undefined;

    constructor(data?: ICreateUpdatePdvEvidencijaPojedinacnaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
        }
    }

    static fromJS(data: any): CreateUpdatePdvEvidencijaPojedinacnaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdatePdvEvidencijaPojedinacnaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        return data;
    }
}

export interface ICreateUpdatePdvEvidencijaPojedinacnaResponse {
    id?: number;
    broj?: string | undefined;
}

export class PdvEvidencijaPojedinacnaDto implements IPdvEvidencijaPojedinacnaDto {
    id?: number | undefined;
    sefId?: number;
    broj?: string | undefined;
    datumPrometa?: Date | undefined;
    datumValute?: Date | undefined;
    datumSlanja?: Date | undefined;
    datumEvidentiranja?: Date | undefined;
    opisPrometa?: string | undefined;
    opisPrometa10?: string | undefined;
    opisPrometa20?: string | undefined;
    ukupanIznosNaknade?: number;
    osnovica10?: number | undefined;
    osnovica20?: number | undefined;
    obracunatPdv10?: number;
    obracunatPdv20?: number;
    obracunatPdv?: number;
    ukupanIznos?: number;
    tip?: PdvEvidencijaTipDokumenta;
    osnovOdabiraDokumenta?: PdvEvidencijaOsnovOdabiraDokumenta | undefined;
    period?: PdvPeriod;
    pravnoNaOdbitak?: PdvEvidencijaPravnoNaOdbitak;
    status?: PdvEvidencijaStatus;
    stranka?: StrankaForPdvDto | undefined;
    dokument?: DokumentForPdvDto | undefined;
    povezaniDokumenti?: VezaniRacunDto[] | undefined;
    godina?: number;

    constructor(data?: IPdvEvidencijaPojedinacnaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sefId = _data["sefId"];
            this.broj = _data["broj"];
            this.datumPrometa = _data["datumPrometa"] ? new Date(_data["datumPrometa"].toString()) : <any>undefined;
            this.datumValute = _data["datumValute"] ? new Date(_data["datumValute"].toString()) : <any>undefined;
            this.datumSlanja = _data["datumSlanja"] ? new Date(_data["datumSlanja"].toString()) : <any>undefined;
            this.datumEvidentiranja = _data["datumEvidentiranja"] ? new Date(_data["datumEvidentiranja"].toString()) : <any>undefined;
            this.opisPrometa = _data["opisPrometa"];
            this.opisPrometa10 = _data["opisPrometa10"];
            this.opisPrometa20 = _data["opisPrometa20"];
            this.ukupanIznosNaknade = _data["ukupanIznosNaknade"];
            this.osnovica10 = _data["osnovica10"];
            this.osnovica20 = _data["osnovica20"];
            this.obracunatPdv10 = _data["obracunatPdv10"];
            this.obracunatPdv20 = _data["obracunatPdv20"];
            this.obracunatPdv = _data["obracunatPdv"];
            this.ukupanIznos = _data["ukupanIznos"];
            this.tip = _data["tip"];
            this.osnovOdabiraDokumenta = _data["osnovOdabiraDokumenta"];
            this.period = _data["period"];
            this.pravnoNaOdbitak = _data["pravnoNaOdbitak"];
            this.status = _data["status"];
            this.stranka = _data["stranka"] ? StrankaForPdvDto.fromJS(_data["stranka"]) : <any>undefined;
            this.dokument = _data["dokument"] ? DokumentForPdvDto.fromJS(_data["dokument"]) : <any>undefined;
            if (Array.isArray(_data["povezaniDokumenti"])) {
                this.povezaniDokumenti = [] as any;
                for (let item of _data["povezaniDokumenti"])
                    this.povezaniDokumenti!.push(VezaniRacunDto.fromJS(item));
            }
            this.godina = _data["godina"];
        }
    }

    static fromJS(data: any): PdvEvidencijaPojedinacnaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdvEvidencijaPojedinacnaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sefId"] = this.sefId;
        data["broj"] = this.broj;
        data["datumPrometa"] = this.datumPrometa ? this.datumPrometa.toISOString() : <any>undefined;
        data["datumValute"] = this.datumValute ? this.datumValute.toISOString() : <any>undefined;
        data["datumSlanja"] = this.datumSlanja ? this.datumSlanja.toISOString() : <any>undefined;
        data["datumEvidentiranja"] = this.datumEvidentiranja ? this.datumEvidentiranja.toISOString() : <any>undefined;
        data["opisPrometa"] = this.opisPrometa;
        data["opisPrometa10"] = this.opisPrometa10;
        data["opisPrometa20"] = this.opisPrometa20;
        data["ukupanIznosNaknade"] = this.ukupanIznosNaknade;
        data["osnovica10"] = this.osnovica10;
        data["osnovica20"] = this.osnovica20;
        data["obracunatPdv10"] = this.obracunatPdv10;
        data["obracunatPdv20"] = this.obracunatPdv20;
        data["obracunatPdv"] = this.obracunatPdv;
        data["ukupanIznos"] = this.ukupanIznos;
        data["tip"] = this.tip;
        data["osnovOdabiraDokumenta"] = this.osnovOdabiraDokumenta;
        data["period"] = this.period;
        data["pravnoNaOdbitak"] = this.pravnoNaOdbitak;
        data["status"] = this.status;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        data["dokument"] = this.dokument ? this.dokument.toJSON() : <any>undefined;
        if (Array.isArray(this.povezaniDokumenti)) {
            data["povezaniDokumenti"] = [];
            for (let item of this.povezaniDokumenti)
                data["povezaniDokumenti"].push(item.toJSON());
        }
        data["godina"] = this.godina;
        return data;
    }
}

export interface IPdvEvidencijaPojedinacnaDto {
    id?: number | undefined;
    sefId?: number;
    broj?: string | undefined;
    datumPrometa?: Date | undefined;
    datumValute?: Date | undefined;
    datumSlanja?: Date | undefined;
    datumEvidentiranja?: Date | undefined;
    opisPrometa?: string | undefined;
    opisPrometa10?: string | undefined;
    opisPrometa20?: string | undefined;
    ukupanIznosNaknade?: number;
    osnovica10?: number | undefined;
    osnovica20?: number | undefined;
    obracunatPdv10?: number;
    obracunatPdv20?: number;
    obracunatPdv?: number;
    ukupanIznos?: number;
    tip?: PdvEvidencijaTipDokumenta;
    osnovOdabiraDokumenta?: PdvEvidencijaOsnovOdabiraDokumenta | undefined;
    period?: PdvPeriod;
    pravnoNaOdbitak?: PdvEvidencijaPravnoNaOdbitak;
    status?: PdvEvidencijaStatus;
    stranka?: StrankaForPdvDto | undefined;
    dokument?: DokumentForPdvDto | undefined;
    povezaniDokumenti?: VezaniRacunDto[] | undefined;
    godina?: number;
}

export class CreatePdvEvidencijaPojedinacnaCommand extends PdvEvidencijaPojedinacnaDto implements ICreatePdvEvidencijaPojedinacnaCommand {

    constructor(data?: ICreatePdvEvidencijaPojedinacnaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreatePdvEvidencijaPojedinacnaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePdvEvidencijaPojedinacnaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreatePdvEvidencijaPojedinacnaCommand extends IPdvEvidencijaPojedinacnaDto {
}

export class StrankaForPdvDto implements IStrankaForPdvDto {
    id?: number;
    naziv?: string | undefined;
    pibOrJbkjs?: string | undefined;
    poreskiBrojStranogLica?: string | undefined;

    constructor(data?: IStrankaForPdvDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.pibOrJbkjs = _data["pibOrJbkjs"];
            this.poreskiBrojStranogLica = _data["poreskiBrojStranogLica"];
        }
    }

    static fromJS(data: any): StrankaForPdvDto {
        data = typeof data === 'object' ? data : {};
        let result = new StrankaForPdvDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["pibOrJbkjs"] = this.pibOrJbkjs;
        data["poreskiBrojStranogLica"] = this.poreskiBrojStranogLica;
        return data;
    }
}

export interface IStrankaForPdvDto {
    id?: number;
    naziv?: string | undefined;
    pibOrJbkjs?: string | undefined;
    poreskiBrojStranogLica?: string | undefined;
}

export class DokumentForPdvDto implements IDokumentForPdvDto {
    id?: number | undefined;
    broj?: string | undefined;
    tip?: TipRacuna;
    jeInostranaFaktura?: boolean;
    smer?: VrstaRacuna;
    stranka?: StrankaForPdvDto | undefined;
    ukupanIznosNaknade?: number;
    kurs?: number;
    osnovica10?: number | undefined;
    osnovica20?: number | undefined;
    osnovica10OsimObj?: number | undefined;
    osnovica20OsimObj?: number | undefined;
    obracunatPdv20?: number | undefined;
    obracunatPdv10?: number | undefined;
    obracunatPdv20OsimObj?: number | undefined;
    obracunatPdv10OsimObj?: number | undefined;
    ukupanIznos?: number;
    datumPrometa?: Date | undefined;
    datumValute?: Date | undefined;
    datumPocetka?: Date | undefined;
    datumZavrsetka?: Date | undefined;
    datumAvansa?: Date | undefined;
    opisZa10?: string | undefined;
    opisZa20?: string | undefined;
    opisZa10OsimObj?: string | undefined;
    opisZa20OsimObj?: string | undefined;
    vezaniRacuni?: VezaniRacunDto[] | undefined;

    constructor(data?: IDokumentForPdvDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.tip = _data["tip"];
            this.jeInostranaFaktura = _data["jeInostranaFaktura"];
            this.smer = _data["smer"];
            this.stranka = _data["stranka"] ? StrankaForPdvDto.fromJS(_data["stranka"]) : <any>undefined;
            this.ukupanIznosNaknade = _data["ukupanIznosNaknade"];
            this.kurs = _data["kurs"];
            this.osnovica10 = _data["osnovica10"];
            this.osnovica20 = _data["osnovica20"];
            this.osnovica10OsimObj = _data["osnovica10OsimObj"];
            this.osnovica20OsimObj = _data["osnovica20OsimObj"];
            this.obracunatPdv20 = _data["obracunatPdv20"];
            this.obracunatPdv10 = _data["obracunatPdv10"];
            this.obracunatPdv20OsimObj = _data["obracunatPdv20OsimObj"];
            this.obracunatPdv10OsimObj = _data["obracunatPdv10OsimObj"];
            this.ukupanIznos = _data["ukupanIznos"];
            this.datumPrometa = _data["datumPrometa"] ? new Date(_data["datumPrometa"].toString()) : <any>undefined;
            this.datumValute = _data["datumValute"] ? new Date(_data["datumValute"].toString()) : <any>undefined;
            this.datumPocetka = _data["datumPocetka"] ? new Date(_data["datumPocetka"].toString()) : <any>undefined;
            this.datumZavrsetka = _data["datumZavrsetka"] ? new Date(_data["datumZavrsetka"].toString()) : <any>undefined;
            this.datumAvansa = _data["datumAvansa"] ? new Date(_data["datumAvansa"].toString()) : <any>undefined;
            this.opisZa10 = _data["opisZa10"];
            this.opisZa20 = _data["opisZa20"];
            this.opisZa10OsimObj = _data["opisZa10OsimObj"];
            this.opisZa20OsimObj = _data["opisZa20OsimObj"];
            if (Array.isArray(_data["vezaniRacuni"])) {
                this.vezaniRacuni = [] as any;
                for (let item of _data["vezaniRacuni"])
                    this.vezaniRacuni!.push(VezaniRacunDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DokumentForPdvDto {
        data = typeof data === 'object' ? data : {};
        let result = new DokumentForPdvDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["tip"] = this.tip;
        data["jeInostranaFaktura"] = this.jeInostranaFaktura;
        data["smer"] = this.smer;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        data["ukupanIznosNaknade"] = this.ukupanIznosNaknade;
        data["kurs"] = this.kurs;
        data["osnovica10"] = this.osnovica10;
        data["osnovica20"] = this.osnovica20;
        data["osnovica10OsimObj"] = this.osnovica10OsimObj;
        data["osnovica20OsimObj"] = this.osnovica20OsimObj;
        data["obracunatPdv20"] = this.obracunatPdv20;
        data["obracunatPdv10"] = this.obracunatPdv10;
        data["obracunatPdv20OsimObj"] = this.obracunatPdv20OsimObj;
        data["obracunatPdv10OsimObj"] = this.obracunatPdv10OsimObj;
        data["ukupanIznos"] = this.ukupanIznos;
        data["datumPrometa"] = this.datumPrometa ? this.datumPrometa.toISOString() : <any>undefined;
        data["datumValute"] = this.datumValute ? this.datumValute.toISOString() : <any>undefined;
        data["datumPocetka"] = this.datumPocetka ? this.datumPocetka.toISOString() : <any>undefined;
        data["datumZavrsetka"] = this.datumZavrsetka ? this.datumZavrsetka.toISOString() : <any>undefined;
        data["datumAvansa"] = this.datumAvansa ? this.datumAvansa.toISOString() : <any>undefined;
        data["opisZa10"] = this.opisZa10;
        data["opisZa20"] = this.opisZa20;
        data["opisZa10OsimObj"] = this.opisZa10OsimObj;
        data["opisZa20OsimObj"] = this.opisZa20OsimObj;
        if (Array.isArray(this.vezaniRacuni)) {
            data["vezaniRacuni"] = [];
            for (let item of this.vezaniRacuni)
                data["vezaniRacuni"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDokumentForPdvDto {
    id?: number | undefined;
    broj?: string | undefined;
    tip?: TipRacuna;
    jeInostranaFaktura?: boolean;
    smer?: VrstaRacuna;
    stranka?: StrankaForPdvDto | undefined;
    ukupanIznosNaknade?: number;
    kurs?: number;
    osnovica10?: number | undefined;
    osnovica20?: number | undefined;
    osnovica10OsimObj?: number | undefined;
    osnovica20OsimObj?: number | undefined;
    obracunatPdv20?: number | undefined;
    obracunatPdv10?: number | undefined;
    obracunatPdv20OsimObj?: number | undefined;
    obracunatPdv10OsimObj?: number | undefined;
    ukupanIznos?: number;
    datumPrometa?: Date | undefined;
    datumValute?: Date | undefined;
    datumPocetka?: Date | undefined;
    datumZavrsetka?: Date | undefined;
    datumAvansa?: Date | undefined;
    opisZa10?: string | undefined;
    opisZa20?: string | undefined;
    opisZa10OsimObj?: string | undefined;
    opisZa20OsimObj?: string | undefined;
    vezaniRacuni?: VezaniRacunDto[] | undefined;
}

export class PdvEvidencijaPojedinacna39Dto implements IPdvEvidencijaPojedinacna39Dto {
    id?: number | undefined;
    sefId?: number;
    broj?: string | undefined;
    datumEvidentiranja?: Date | undefined;
    godina?: number;
    status?: PdvEvidencijaStatus;
    period?: PdvPeriod;
    tip?: PdvEvidencijaTipDokumenta;
    smer?: VrstaRacuna;
    tipPovezaneFakture?: PdvEvidencijaTipPovezaneFakture;
    osnovOdabiraDokumenta?: PdvEvidencijaOsnovOdabiraDokumenta;
    tipPovezanogInternog?: PdvEvidencijaTipPovezanogInternog;
    vremenskiPeriodPocetak?: Date | undefined;
    vremenskiPeriodZavrsetak?: Date | undefined;
    osnovAvansnogPlacanja?: string | undefined;
    datumAvansa?: Date | undefined;
    opisPrometa10?: string | undefined;
    osnovica10?: number | undefined;
    obracunatPdv10?: number | undefined;
    opisPrometa20?: string | undefined;
    osnovica20?: number | undefined;
    obracunatPdv20?: number | undefined;
    opisPrometaAE20?: string | undefined;
    osnovicaAE20?: number | undefined;
    obracunatPdvAE20?: number | undefined;
    opisPrometaAE20Obj?: string | undefined;
    osnovicaAE20Obj?: number | undefined;
    obracunatPdvAE20Obj?: number | undefined;
    opisPrometaAE10?: string | undefined;
    osnovicaAE10?: number | undefined;
    obracunatPdvAE10?: number | undefined;
    opisPrometaAE10Obj?: string | undefined;
    osnovicaAE10Obj?: number | undefined;
    obracunatPdvAE10Obj?: number | undefined;
    opisPrometaAE20BN?: string | undefined;
    osnovicaAE20BN?: number | undefined;
    obracunatPdvAE20BN?: number | undefined;
    opisPrometaAE20ObjBN?: string | undefined;
    osnovicaAE20ObjBN?: number | undefined;
    obracunatPdvAE20ObjBN?: number | undefined;
    opisPrometaAE10BN?: string | undefined;
    osnovicaAE10BN?: number | undefined;
    obracunatPdvAE10BN?: number | undefined;
    opisPrometaAE10ObjBN?: string | undefined;
    osnovicaAE10ObjBN?: number | undefined;
    obracunatPdvAE10ObjBN?: number | undefined;
    promet10?: PdvPrometObject | undefined;
    promet20?: PdvPrometObject | undefined;
    promet10Bn?: PdvPrometObject | undefined;
    promet20Bn?: PdvPrometObject | undefined;
    promet10Obj?: PdvPrometObject | undefined;
    promet20Obj?: PdvPrometObject | undefined;
    promet10BnObj?: PdvPrometObject | undefined;
    promet20BnObj?: PdvPrometObject | undefined;
    ukupanIznosNaknade?: number | undefined;
    obracunatPdv?: number;
    brojDokumentaNabavka?: string | undefined;
    stranka?: StrankaForPdvDto | undefined;
    povezanaFaktura?: DokumentForPdvDto | undefined;
    povezaniRacuni?: VezaniRacunDto[] | undefined;
    povezaniVanSefa?: string[] | undefined;

    constructor(data?: IPdvEvidencijaPojedinacna39Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sefId = _data["sefId"];
            this.broj = _data["broj"];
            this.datumEvidentiranja = _data["datumEvidentiranja"] ? new Date(_data["datumEvidentiranja"].toString()) : <any>undefined;
            this.godina = _data["godina"];
            this.status = _data["status"];
            this.period = _data["period"];
            this.tip = _data["tip"];
            this.smer = _data["smer"];
            this.tipPovezaneFakture = _data["tipPovezaneFakture"];
            this.osnovOdabiraDokumenta = _data["osnovOdabiraDokumenta"];
            this.tipPovezanogInternog = _data["tipPovezanogInternog"];
            this.vremenskiPeriodPocetak = _data["vremenskiPeriodPocetak"] ? new Date(_data["vremenskiPeriodPocetak"].toString()) : <any>undefined;
            this.vremenskiPeriodZavrsetak = _data["vremenskiPeriodZavrsetak"] ? new Date(_data["vremenskiPeriodZavrsetak"].toString()) : <any>undefined;
            this.osnovAvansnogPlacanja = _data["osnovAvansnogPlacanja"];
            this.datumAvansa = _data["datumAvansa"] ? new Date(_data["datumAvansa"].toString()) : <any>undefined;
            this.opisPrometa10 = _data["opisPrometa10"];
            this.osnovica10 = _data["osnovica10"];
            this.obracunatPdv10 = _data["obracunatPdv10"];
            this.opisPrometa20 = _data["opisPrometa20"];
            this.osnovica20 = _data["osnovica20"];
            this.obracunatPdv20 = _data["obracunatPdv20"];
            this.opisPrometaAE20 = _data["opisPrometaAE20"];
            this.osnovicaAE20 = _data["osnovicaAE20"];
            this.obracunatPdvAE20 = _data["obracunatPdvAE20"];
            this.opisPrometaAE20Obj = _data["opisPrometaAE20Obj"];
            this.osnovicaAE20Obj = _data["osnovicaAE20Obj"];
            this.obracunatPdvAE20Obj = _data["obracunatPdvAE20Obj"];
            this.opisPrometaAE10 = _data["opisPrometaAE10"];
            this.osnovicaAE10 = _data["osnovicaAE10"];
            this.obracunatPdvAE10 = _data["obracunatPdvAE10"];
            this.opisPrometaAE10Obj = _data["opisPrometaAE10Obj"];
            this.osnovicaAE10Obj = _data["osnovicaAE10Obj"];
            this.obracunatPdvAE10Obj = _data["obracunatPdvAE10Obj"];
            this.opisPrometaAE20BN = _data["opisPrometaAE20BN"];
            this.osnovicaAE20BN = _data["osnovicaAE20BN"];
            this.obracunatPdvAE20BN = _data["obracunatPdvAE20BN"];
            this.opisPrometaAE20ObjBN = _data["opisPrometaAE20ObjBN"];
            this.osnovicaAE20ObjBN = _data["osnovicaAE20ObjBN"];
            this.obracunatPdvAE20ObjBN = _data["obracunatPdvAE20ObjBN"];
            this.opisPrometaAE10BN = _data["opisPrometaAE10BN"];
            this.osnovicaAE10BN = _data["osnovicaAE10BN"];
            this.obracunatPdvAE10BN = _data["obracunatPdvAE10BN"];
            this.opisPrometaAE10ObjBN = _data["opisPrometaAE10ObjBN"];
            this.osnovicaAE10ObjBN = _data["osnovicaAE10ObjBN"];
            this.obracunatPdvAE10ObjBN = _data["obracunatPdvAE10ObjBN"];
            this.promet10 = _data["promet10"] ? PdvPrometObject.fromJS(_data["promet10"]) : <any>undefined;
            this.promet20 = _data["promet20"] ? PdvPrometObject.fromJS(_data["promet20"]) : <any>undefined;
            this.promet10Bn = _data["promet10Bn"] ? PdvPrometObject.fromJS(_data["promet10Bn"]) : <any>undefined;
            this.promet20Bn = _data["promet20Bn"] ? PdvPrometObject.fromJS(_data["promet20Bn"]) : <any>undefined;
            this.promet10Obj = _data["promet10Obj"] ? PdvPrometObject.fromJS(_data["promet10Obj"]) : <any>undefined;
            this.promet20Obj = _data["promet20Obj"] ? PdvPrometObject.fromJS(_data["promet20Obj"]) : <any>undefined;
            this.promet10BnObj = _data["promet10BnObj"] ? PdvPrometObject.fromJS(_data["promet10BnObj"]) : <any>undefined;
            this.promet20BnObj = _data["promet20BnObj"] ? PdvPrometObject.fromJS(_data["promet20BnObj"]) : <any>undefined;
            this.ukupanIznosNaknade = _data["ukupanIznosNaknade"];
            this.obracunatPdv = _data["obracunatPdv"];
            this.brojDokumentaNabavka = _data["brojDokumentaNabavka"];
            this.stranka = _data["stranka"] ? StrankaForPdvDto.fromJS(_data["stranka"]) : <any>undefined;
            this.povezanaFaktura = _data["povezanaFaktura"] ? DokumentForPdvDto.fromJS(_data["povezanaFaktura"]) : <any>undefined;
            if (Array.isArray(_data["povezaniRacuni"])) {
                this.povezaniRacuni = [] as any;
                for (let item of _data["povezaniRacuni"])
                    this.povezaniRacuni!.push(VezaniRacunDto.fromJS(item));
            }
            if (Array.isArray(_data["povezaniVanSefa"])) {
                this.povezaniVanSefa = [] as any;
                for (let item of _data["povezaniVanSefa"])
                    this.povezaniVanSefa!.push(item);
            }
        }
    }

    static fromJS(data: any): PdvEvidencijaPojedinacna39Dto {
        data = typeof data === 'object' ? data : {};
        let result = new PdvEvidencijaPojedinacna39Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sefId"] = this.sefId;
        data["broj"] = this.broj;
        data["datumEvidentiranja"] = this.datumEvidentiranja ? this.datumEvidentiranja.toISOString() : <any>undefined;
        data["godina"] = this.godina;
        data["status"] = this.status;
        data["period"] = this.period;
        data["tip"] = this.tip;
        data["smer"] = this.smer;
        data["tipPovezaneFakture"] = this.tipPovezaneFakture;
        data["osnovOdabiraDokumenta"] = this.osnovOdabiraDokumenta;
        data["tipPovezanogInternog"] = this.tipPovezanogInternog;
        data["vremenskiPeriodPocetak"] = this.vremenskiPeriodPocetak ? this.vremenskiPeriodPocetak.toISOString() : <any>undefined;
        data["vremenskiPeriodZavrsetak"] = this.vremenskiPeriodZavrsetak ? this.vremenskiPeriodZavrsetak.toISOString() : <any>undefined;
        data["osnovAvansnogPlacanja"] = this.osnovAvansnogPlacanja;
        data["datumAvansa"] = this.datumAvansa ? this.datumAvansa.toISOString() : <any>undefined;
        data["opisPrometa10"] = this.opisPrometa10;
        data["osnovica10"] = this.osnovica10;
        data["obracunatPdv10"] = this.obracunatPdv10;
        data["opisPrometa20"] = this.opisPrometa20;
        data["osnovica20"] = this.osnovica20;
        data["obracunatPdv20"] = this.obracunatPdv20;
        data["opisPrometaAE20"] = this.opisPrometaAE20;
        data["osnovicaAE20"] = this.osnovicaAE20;
        data["obracunatPdvAE20"] = this.obracunatPdvAE20;
        data["opisPrometaAE20Obj"] = this.opisPrometaAE20Obj;
        data["osnovicaAE20Obj"] = this.osnovicaAE20Obj;
        data["obracunatPdvAE20Obj"] = this.obracunatPdvAE20Obj;
        data["opisPrometaAE10"] = this.opisPrometaAE10;
        data["osnovicaAE10"] = this.osnovicaAE10;
        data["obracunatPdvAE10"] = this.obracunatPdvAE10;
        data["opisPrometaAE10Obj"] = this.opisPrometaAE10Obj;
        data["osnovicaAE10Obj"] = this.osnovicaAE10Obj;
        data["obracunatPdvAE10Obj"] = this.obracunatPdvAE10Obj;
        data["opisPrometaAE20BN"] = this.opisPrometaAE20BN;
        data["osnovicaAE20BN"] = this.osnovicaAE20BN;
        data["obracunatPdvAE20BN"] = this.obracunatPdvAE20BN;
        data["opisPrometaAE20ObjBN"] = this.opisPrometaAE20ObjBN;
        data["osnovicaAE20ObjBN"] = this.osnovicaAE20ObjBN;
        data["obracunatPdvAE20ObjBN"] = this.obracunatPdvAE20ObjBN;
        data["opisPrometaAE10BN"] = this.opisPrometaAE10BN;
        data["osnovicaAE10BN"] = this.osnovicaAE10BN;
        data["obracunatPdvAE10BN"] = this.obracunatPdvAE10BN;
        data["opisPrometaAE10ObjBN"] = this.opisPrometaAE10ObjBN;
        data["osnovicaAE10ObjBN"] = this.osnovicaAE10ObjBN;
        data["obracunatPdvAE10ObjBN"] = this.obracunatPdvAE10ObjBN;
        data["promet10"] = this.promet10 ? this.promet10.toJSON() : <any>undefined;
        data["promet20"] = this.promet20 ? this.promet20.toJSON() : <any>undefined;
        data["promet10Bn"] = this.promet10Bn ? this.promet10Bn.toJSON() : <any>undefined;
        data["promet20Bn"] = this.promet20Bn ? this.promet20Bn.toJSON() : <any>undefined;
        data["promet10Obj"] = this.promet10Obj ? this.promet10Obj.toJSON() : <any>undefined;
        data["promet20Obj"] = this.promet20Obj ? this.promet20Obj.toJSON() : <any>undefined;
        data["promet10BnObj"] = this.promet10BnObj ? this.promet10BnObj.toJSON() : <any>undefined;
        data["promet20BnObj"] = this.promet20BnObj ? this.promet20BnObj.toJSON() : <any>undefined;
        data["ukupanIznosNaknade"] = this.ukupanIznosNaknade;
        data["obracunatPdv"] = this.obracunatPdv;
        data["brojDokumentaNabavka"] = this.brojDokumentaNabavka;
        data["stranka"] = this.stranka ? this.stranka.toJSON() : <any>undefined;
        data["povezanaFaktura"] = this.povezanaFaktura ? this.povezanaFaktura.toJSON() : <any>undefined;
        if (Array.isArray(this.povezaniRacuni)) {
            data["povezaniRacuni"] = [];
            for (let item of this.povezaniRacuni)
                data["povezaniRacuni"].push(item.toJSON());
        }
        if (Array.isArray(this.povezaniVanSefa)) {
            data["povezaniVanSefa"] = [];
            for (let item of this.povezaniVanSefa)
                data["povezaniVanSefa"].push(item);
        }
        return data;
    }
}

export interface IPdvEvidencijaPojedinacna39Dto {
    id?: number | undefined;
    sefId?: number;
    broj?: string | undefined;
    datumEvidentiranja?: Date | undefined;
    godina?: number;
    status?: PdvEvidencijaStatus;
    period?: PdvPeriod;
    tip?: PdvEvidencijaTipDokumenta;
    smer?: VrstaRacuna;
    tipPovezaneFakture?: PdvEvidencijaTipPovezaneFakture;
    osnovOdabiraDokumenta?: PdvEvidencijaOsnovOdabiraDokumenta;
    tipPovezanogInternog?: PdvEvidencijaTipPovezanogInternog;
    vremenskiPeriodPocetak?: Date | undefined;
    vremenskiPeriodZavrsetak?: Date | undefined;
    osnovAvansnogPlacanja?: string | undefined;
    datumAvansa?: Date | undefined;
    opisPrometa10?: string | undefined;
    osnovica10?: number | undefined;
    obracunatPdv10?: number | undefined;
    opisPrometa20?: string | undefined;
    osnovica20?: number | undefined;
    obracunatPdv20?: number | undefined;
    opisPrometaAE20?: string | undefined;
    osnovicaAE20?: number | undefined;
    obracunatPdvAE20?: number | undefined;
    opisPrometaAE20Obj?: string | undefined;
    osnovicaAE20Obj?: number | undefined;
    obracunatPdvAE20Obj?: number | undefined;
    opisPrometaAE10?: string | undefined;
    osnovicaAE10?: number | undefined;
    obracunatPdvAE10?: number | undefined;
    opisPrometaAE10Obj?: string | undefined;
    osnovicaAE10Obj?: number | undefined;
    obracunatPdvAE10Obj?: number | undefined;
    opisPrometaAE20BN?: string | undefined;
    osnovicaAE20BN?: number | undefined;
    obracunatPdvAE20BN?: number | undefined;
    opisPrometaAE20ObjBN?: string | undefined;
    osnovicaAE20ObjBN?: number | undefined;
    obracunatPdvAE20ObjBN?: number | undefined;
    opisPrometaAE10BN?: string | undefined;
    osnovicaAE10BN?: number | undefined;
    obracunatPdvAE10BN?: number | undefined;
    opisPrometaAE10ObjBN?: string | undefined;
    osnovicaAE10ObjBN?: number | undefined;
    obracunatPdvAE10ObjBN?: number | undefined;
    promet10?: PdvPrometObject | undefined;
    promet20?: PdvPrometObject | undefined;
    promet10Bn?: PdvPrometObject | undefined;
    promet20Bn?: PdvPrometObject | undefined;
    promet10Obj?: PdvPrometObject | undefined;
    promet20Obj?: PdvPrometObject | undefined;
    promet10BnObj?: PdvPrometObject | undefined;
    promet20BnObj?: PdvPrometObject | undefined;
    ukupanIznosNaknade?: number | undefined;
    obracunatPdv?: number;
    brojDokumentaNabavka?: string | undefined;
    stranka?: StrankaForPdvDto | undefined;
    povezanaFaktura?: DokumentForPdvDto | undefined;
    povezaniRacuni?: VezaniRacunDto[] | undefined;
    povezaniVanSefa?: string[] | undefined;
}

export class CreatePdvEvidencijaPojedinacna39Command extends PdvEvidencijaPojedinacna39Dto implements ICreatePdvEvidencijaPojedinacna39Command {

    constructor(data?: ICreatePdvEvidencijaPojedinacna39Command) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreatePdvEvidencijaPojedinacna39Command {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePdvEvidencijaPojedinacna39Command();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreatePdvEvidencijaPojedinacna39Command extends IPdvEvidencijaPojedinacna39Dto {
}

export class UpdatePdvEvidencijaPojedinacnaCommand extends PdvEvidencijaPojedinacnaDto implements IUpdatePdvEvidencijaPojedinacnaCommand {

    constructor(data?: IUpdatePdvEvidencijaPojedinacnaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdatePdvEvidencijaPojedinacnaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePdvEvidencijaPojedinacnaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePdvEvidencijaPojedinacnaCommand extends IPdvEvidencijaPojedinacnaDto {
}

export class UpdatePdvEvidencijaPojedinacna39Command extends PdvEvidencijaPojedinacna39Dto implements IUpdatePdvEvidencijaPojedinacna39Command {

    constructor(data?: IUpdatePdvEvidencijaPojedinacna39Command) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdatePdvEvidencijaPojedinacna39Command {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePdvEvidencijaPojedinacna39Command();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePdvEvidencijaPojedinacna39Command extends IPdvEvidencijaPojedinacna39Dto {
}

export class ResultOfGetStrankaForPdvAutocompleteResponse extends Result implements IResultOfGetStrankaForPdvAutocompleteResponse {
    data?: GetStrankaForPdvAutocompleteResponse | undefined;

    constructor(data?: IResultOfGetStrankaForPdvAutocompleteResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetStrankaForPdvAutocompleteResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetStrankaForPdvAutocompleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetStrankaForPdvAutocompleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetStrankaForPdvAutocompleteResponse extends IResult {
    data?: GetStrankaForPdvAutocompleteResponse | undefined;
}

export class GetStrankaForPdvAutocompleteResponse implements IGetStrankaForPdvAutocompleteResponse {
    responseList?: StrankaForPdvDto[] | undefined;

    constructor(data?: IGetStrankaForPdvAutocompleteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(StrankaForPdvDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStrankaForPdvAutocompleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStrankaForPdvAutocompleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStrankaForPdvAutocompleteResponse {
    responseList?: StrankaForPdvDto[] | undefined;
}

export class ResultOfGetTipDokumentaEvidencijeDropdownResponse extends Result implements IResultOfGetTipDokumentaEvidencijeDropdownResponse {
    data?: GetTipDokumentaEvidencijeDropdownResponse | undefined;

    constructor(data?: IResultOfGetTipDokumentaEvidencijeDropdownResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetTipDokumentaEvidencijeDropdownResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetTipDokumentaEvidencijeDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetTipDokumentaEvidencijeDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetTipDokumentaEvidencijeDropdownResponse extends IResult {
    data?: GetTipDokumentaEvidencijeDropdownResponse | undefined;
}

export class GetTipDokumentaEvidencijeDropdownResponse implements IGetTipDokumentaEvidencijeDropdownResponse {
    responseList?: TipDokumentaEvidencijeDto[] | undefined;

    constructor(data?: IGetTipDokumentaEvidencijeDropdownResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(TipDokumentaEvidencijeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTipDokumentaEvidencijeDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTipDokumentaEvidencijeDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTipDokumentaEvidencijeDropdownResponse {
    responseList?: TipDokumentaEvidencijeDto[] | undefined;
}

export class TipDokumentaEvidencijeDto implements ITipDokumentaEvidencijeDto {
    tip?: PdvEvidencijaTipDokumenta;
    tipStr?: string | undefined;
    tipBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: ITipDokumentaEvidencijeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tip = _data["tip"];
            this.tipStr = _data["tipStr"];
            this.tipBadgeStr = _data["tipBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): TipDokumentaEvidencijeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipDokumentaEvidencijeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tip"] = this.tip;
        data["tipStr"] = this.tipStr;
        data["tipBadgeStr"] = this.tipBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface ITipDokumentaEvidencijeDto {
    tip?: PdvEvidencijaTipDokumenta;
    tipStr?: string | undefined;
    tipBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class ResultOfGetTipPovezanogDokumentaEvidencijeDropdownResponse extends Result implements IResultOfGetTipPovezanogDokumentaEvidencijeDropdownResponse {
    data?: GetTipPovezanogDokumentaEvidencijeDropdownResponse | undefined;

    constructor(data?: IResultOfGetTipPovezanogDokumentaEvidencijeDropdownResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetTipPovezanogDokumentaEvidencijeDropdownResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetTipPovezanogDokumentaEvidencijeDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetTipPovezanogDokumentaEvidencijeDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetTipPovezanogDokumentaEvidencijeDropdownResponse extends IResult {
    data?: GetTipPovezanogDokumentaEvidencijeDropdownResponse | undefined;
}

export class GetTipPovezanogDokumentaEvidencijeDropdownResponse implements IGetTipPovezanogDokumentaEvidencijeDropdownResponse {
    responseList?: TipPojedinacnogDokumentaEvidencijeDto[] | undefined;

    constructor(data?: IGetTipPovezanogDokumentaEvidencijeDropdownResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(TipPojedinacnogDokumentaEvidencijeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTipPovezanogDokumentaEvidencijeDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTipPovezanogDokumentaEvidencijeDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTipPovezanogDokumentaEvidencijeDropdownResponse {
    responseList?: TipPojedinacnogDokumentaEvidencijeDto[] | undefined;
}

export class TipPojedinacnogDokumentaEvidencijeDto implements ITipPojedinacnogDokumentaEvidencijeDto {
    tipPovezanog?: PdvEvidencijaTipPovezaneFakture;
    tipStr?: string | undefined;
    tipBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: ITipPojedinacnogDokumentaEvidencijeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipPovezanog = _data["tipPovezanog"];
            this.tipStr = _data["tipStr"];
            this.tipBadgeStr = _data["tipBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): TipPojedinacnogDokumentaEvidencijeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipPojedinacnogDokumentaEvidencijeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipPovezanog"] = this.tipPovezanog;
        data["tipStr"] = this.tipStr;
        data["tipBadgeStr"] = this.tipBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface ITipPojedinacnogDokumentaEvidencijeDto {
    tipPovezanog?: PdvEvidencijaTipPovezaneFakture;
    tipStr?: string | undefined;
    tipBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class ResultOfGetOsnovOdabiraDokumentaDropdownResponse extends Result implements IResultOfGetOsnovOdabiraDokumentaDropdownResponse {
    data?: GetOsnovOdabiraDokumentaDropdownResponse | undefined;

    constructor(data?: IResultOfGetOsnovOdabiraDokumentaDropdownResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetOsnovOdabiraDokumentaDropdownResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetOsnovOdabiraDokumentaDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetOsnovOdabiraDokumentaDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetOsnovOdabiraDokumentaDropdownResponse extends IResult {
    data?: GetOsnovOdabiraDokumentaDropdownResponse | undefined;
}

export class GetOsnovOdabiraDokumentaDropdownResponse implements IGetOsnovOdabiraDokumentaDropdownResponse {
    responseList?: OsnovOdabiraDokumentaDto[] | undefined;

    constructor(data?: IGetOsnovOdabiraDokumentaDropdownResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(OsnovOdabiraDokumentaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOsnovOdabiraDokumentaDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOsnovOdabiraDokumentaDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOsnovOdabiraDokumentaDropdownResponse {
    responseList?: OsnovOdabiraDokumentaDto[] | undefined;
}

export class OsnovOdabiraDokumentaDto implements IOsnovOdabiraDokumentaDto {
    osnov?: PdvEvidencijaOsnovOdabiraDokumenta;
    osnovStr?: string | undefined;
    osnovBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IOsnovOdabiraDokumentaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.osnov = _data["osnov"];
            this.osnovStr = _data["osnovStr"];
            this.osnovBadgeStr = _data["osnovBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): OsnovOdabiraDokumentaDto {
        data = typeof data === 'object' ? data : {};
        let result = new OsnovOdabiraDokumentaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["osnov"] = this.osnov;
        data["osnovStr"] = this.osnovStr;
        data["osnovBadgeStr"] = this.osnovBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IOsnovOdabiraDokumentaDto {
    osnov?: PdvEvidencijaOsnovOdabiraDokumenta;
    osnovStr?: string | undefined;
    osnovBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class ResultOfGetTipPovezanogInternogDropdownResponse extends Result implements IResultOfGetTipPovezanogInternogDropdownResponse {
    data?: GetTipPovezanogInternogDropdownResponse | undefined;

    constructor(data?: IResultOfGetTipPovezanogInternogDropdownResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetTipPovezanogInternogDropdownResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetTipPovezanogInternogDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetTipPovezanogInternogDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetTipPovezanogInternogDropdownResponse extends IResult {
    data?: GetTipPovezanogInternogDropdownResponse | undefined;
}

export class GetTipPovezanogInternogDropdownResponse implements IGetTipPovezanogInternogDropdownResponse {
    responseList?: TipPovezanogInternogDto[] | undefined;

    constructor(data?: IGetTipPovezanogInternogDropdownResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(TipPovezanogInternogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTipPovezanogInternogDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTipPovezanogInternogDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTipPovezanogInternogDropdownResponse {
    responseList?: TipPovezanogInternogDto[] | undefined;
}

export class TipPovezanogInternogDto implements ITipPovezanogInternogDto {
    osnov?: PdvEvidencijaTipPovezanogInternog;
    osnovStr?: string | undefined;
    osnovBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: ITipPovezanogInternogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.osnov = _data["osnov"];
            this.osnovStr = _data["osnovStr"];
            this.osnovBadgeStr = _data["osnovBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): TipPovezanogInternogDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipPovezanogInternogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["osnov"] = this.osnov;
        data["osnovStr"] = this.osnovStr;
        data["osnovBadgeStr"] = this.osnovBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface ITipPovezanogInternogDto {
    osnov?: PdvEvidencijaTipPovezanogInternog;
    osnovStr?: string | undefined;
    osnovBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class ResultOfListOfDokumentForPdvDto extends Result implements IResultOfListOfDokumentForPdvDto {
    data?: DokumentForPdvDto[] | undefined;

    constructor(data?: IResultOfListOfDokumentForPdvDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DokumentForPdvDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfDokumentForPdvDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfDokumentForPdvDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfDokumentForPdvDto extends IResult {
    data?: DokumentForPdvDto[] | undefined;
}

export class GetDokumentForPdvAutocompleteQuery implements IGetDokumentForPdvAutocompleteQuery {
    broj?: string | undefined;
    tipRacuna?: TipRacuna;
    vrstaRacuna?: VrstaRacuna;
    jeStranaFaktura?: boolean;
    pdvEvidencijaId?: number | undefined;

    constructor(data?: IGetDokumentForPdvAutocompleteQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.broj = _data["broj"];
            this.tipRacuna = _data["tipRacuna"];
            this.vrstaRacuna = _data["vrstaRacuna"];
            this.jeStranaFaktura = _data["jeStranaFaktura"];
            this.pdvEvidencijaId = _data["pdvEvidencijaId"];
        }
    }

    static fromJS(data: any): GetDokumentForPdvAutocompleteQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetDokumentForPdvAutocompleteQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["broj"] = this.broj;
        data["tipRacuna"] = this.tipRacuna;
        data["vrstaRacuna"] = this.vrstaRacuna;
        data["jeStranaFaktura"] = this.jeStranaFaktura;
        data["pdvEvidencijaId"] = this.pdvEvidencijaId;
        return data;
    }
}

export interface IGetDokumentForPdvAutocompleteQuery {
    broj?: string | undefined;
    tipRacuna?: TipRacuna;
    vrstaRacuna?: VrstaRacuna;
    jeStranaFaktura?: boolean;
    pdvEvidencijaId?: number | undefined;
}

export class PaginatedResultOfPdvEvidencijaPojedinacnaTableDto extends Result implements IPaginatedResultOfPdvEvidencijaPojedinacnaTableDto {
    data?: PdvEvidencijaPojedinacnaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfPdvEvidencijaPojedinacnaTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PdvEvidencijaPojedinacnaTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfPdvEvidencijaPojedinacnaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfPdvEvidencijaPojedinacnaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfPdvEvidencijaPojedinacnaTableDto extends IResult {
    data?: PdvEvidencijaPojedinacnaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PdvEvidencijaPojedinacnaTableDto implements IPdvEvidencijaPojedinacnaTableDto {
    id?: number;
    broj?: string | undefined;
    periodDto?: PdvPeriodDto | undefined;
    statusDto?: PdvEvidencijaStatusDto | undefined;
    brojDokumenta?: string | undefined;
    datumPromeneStatusa?: string | undefined;
    tipDto?: TipDokumentaEvidencijeDto | undefined;
    iznosNaknade?: number;
    pdv?: number;

    constructor(data?: IPdvEvidencijaPojedinacnaTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.periodDto = _data["periodDto"] ? PdvPeriodDto.fromJS(_data["periodDto"]) : <any>undefined;
            this.statusDto = _data["statusDto"] ? PdvEvidencijaStatusDto.fromJS(_data["statusDto"]) : <any>undefined;
            this.brojDokumenta = _data["brojDokumenta"];
            this.datumPromeneStatusa = _data["datumPromeneStatusa"];
            this.tipDto = _data["tipDto"] ? TipDokumentaEvidencijeDto.fromJS(_data["tipDto"]) : <any>undefined;
            this.iznosNaknade = _data["iznosNaknade"];
            this.pdv = _data["pdv"];
        }
    }

    static fromJS(data: any): PdvEvidencijaPojedinacnaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdvEvidencijaPojedinacnaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["periodDto"] = this.periodDto ? this.periodDto.toJSON() : <any>undefined;
        data["statusDto"] = this.statusDto ? this.statusDto.toJSON() : <any>undefined;
        data["brojDokumenta"] = this.brojDokumenta;
        data["datumPromeneStatusa"] = this.datumPromeneStatusa;
        data["tipDto"] = this.tipDto ? this.tipDto.toJSON() : <any>undefined;
        data["iznosNaknade"] = this.iznosNaknade;
        data["pdv"] = this.pdv;
        return data;
    }
}

export interface IPdvEvidencijaPojedinacnaTableDto {
    id?: number;
    broj?: string | undefined;
    periodDto?: PdvPeriodDto | undefined;
    statusDto?: PdvEvidencijaStatusDto | undefined;
    brojDokumenta?: string | undefined;
    datumPromeneStatusa?: string | undefined;
    tipDto?: TipDokumentaEvidencijeDto | undefined;
    iznosNaknade?: number;
    pdv?: number;
}

export class PdvEvidencijaStatusDto implements IPdvEvidencijaStatusDto {
    status?: PdvEvidencijaStatus;
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IPdvEvidencijaStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.statusStr = _data["statusStr"];
            this.statusBadgeStr = _data["statusBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): PdvEvidencijaStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdvEvidencijaStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["statusStr"] = this.statusStr;
        data["statusBadgeStr"] = this.statusBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IPdvEvidencijaStatusDto {
    status?: PdvEvidencijaStatus;
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class GetPdvEvidencijaPojedinacnaTableQuery implements IGetPdvEvidencijaPojedinacnaTableQuery {
    brojObracuna?: string | undefined;
    originalniBroj?: string | undefined;
    tipoviDokumenta?: PdvEvidencijaTipDokumenta[] | undefined;
    statusi?: PdvEvidencijaStatus[] | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    mesec?: number | undefined;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetPdvEvidencijaPojedinacnaTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brojObracuna = _data["brojObracuna"];
            this.originalniBroj = _data["originalniBroj"];
            if (Array.isArray(_data["tipoviDokumenta"])) {
                this.tipoviDokumenta = [] as any;
                for (let item of _data["tipoviDokumenta"])
                    this.tipoviDokumenta!.push(item);
            }
            if (Array.isArray(_data["statusi"])) {
                this.statusi = [] as any;
                for (let item of _data["statusi"])
                    this.statusi!.push(item);
            }
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.mesec = _data["mesec"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetPdvEvidencijaPojedinacnaTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPdvEvidencijaPojedinacnaTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brojObracuna"] = this.brojObracuna;
        data["originalniBroj"] = this.originalniBroj;
        if (Array.isArray(this.tipoviDokumenta)) {
            data["tipoviDokumenta"] = [];
            for (let item of this.tipoviDokumenta)
                data["tipoviDokumenta"].push(item);
        }
        if (Array.isArray(this.statusi)) {
            data["statusi"] = [];
            for (let item of this.statusi)
                data["statusi"].push(item);
        }
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["mesec"] = this.mesec;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetPdvEvidencijaPojedinacnaTableQuery {
    brojObracuna?: string | undefined;
    originalniBroj?: string | undefined;
    tipoviDokumenta?: PdvEvidencijaTipDokumenta[] | undefined;
    statusi?: PdvEvidencijaStatus[] | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    mesec?: number | undefined;
    pageNumber?: number;
    pageSize?: number;
}

export class PaginatedResultOfPdvEvidencijaPojedinacna39TableDto extends Result implements IPaginatedResultOfPdvEvidencijaPojedinacna39TableDto {
    data?: PdvEvidencijaPojedinacna39TableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfPdvEvidencijaPojedinacna39TableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PdvEvidencijaPojedinacna39TableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfPdvEvidencijaPojedinacna39TableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfPdvEvidencijaPojedinacna39TableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfPdvEvidencijaPojedinacna39TableDto extends IResult {
    data?: PdvEvidencijaPojedinacna39TableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PdvEvidencijaPojedinacna39TableDto implements IPdvEvidencijaPojedinacna39TableDto {
    id?: number;
    broj?: string | undefined;
    periodDto?: PdvPeriodDto | undefined;
    statusDto?: PdvEvidencijaStatusDto | undefined;
    brojPovezaneFakture?: string | undefined;
    datumPromeneStatusa?: string | undefined;
    tipDto?: TipDokumentaEvidencijeDto | undefined;
    pdv?: number;

    constructor(data?: IPdvEvidencijaPojedinacna39TableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.periodDto = _data["periodDto"] ? PdvPeriodDto.fromJS(_data["periodDto"]) : <any>undefined;
            this.statusDto = _data["statusDto"] ? PdvEvidencijaStatusDto.fromJS(_data["statusDto"]) : <any>undefined;
            this.brojPovezaneFakture = _data["brojPovezaneFakture"];
            this.datumPromeneStatusa = _data["datumPromeneStatusa"];
            this.tipDto = _data["tipDto"] ? TipDokumentaEvidencijeDto.fromJS(_data["tipDto"]) : <any>undefined;
            this.pdv = _data["pdv"];
        }
    }

    static fromJS(data: any): PdvEvidencijaPojedinacna39TableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdvEvidencijaPojedinacna39TableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["periodDto"] = this.periodDto ? this.periodDto.toJSON() : <any>undefined;
        data["statusDto"] = this.statusDto ? this.statusDto.toJSON() : <any>undefined;
        data["brojPovezaneFakture"] = this.brojPovezaneFakture;
        data["datumPromeneStatusa"] = this.datumPromeneStatusa;
        data["tipDto"] = this.tipDto ? this.tipDto.toJSON() : <any>undefined;
        data["pdv"] = this.pdv;
        return data;
    }
}

export interface IPdvEvidencijaPojedinacna39TableDto {
    id?: number;
    broj?: string | undefined;
    periodDto?: PdvPeriodDto | undefined;
    statusDto?: PdvEvidencijaStatusDto | undefined;
    brojPovezaneFakture?: string | undefined;
    datumPromeneStatusa?: string | undefined;
    tipDto?: TipDokumentaEvidencijeDto | undefined;
    pdv?: number;
}

export class GetPdvEvidencijaPojedinacna39TableQuery implements IGetPdvEvidencijaPojedinacna39TableQuery {
    brojObracuna?: string | undefined;
    originalniBroj?: string | undefined;
    tipoviDokumenta?: PdvEvidencijaTipDokumenta[] | undefined;
    statusi?: PdvEvidencijaStatus[] | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    mesec?: number | undefined;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetPdvEvidencijaPojedinacna39TableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brojObracuna = _data["brojObracuna"];
            this.originalniBroj = _data["originalniBroj"];
            if (Array.isArray(_data["tipoviDokumenta"])) {
                this.tipoviDokumenta = [] as any;
                for (let item of _data["tipoviDokumenta"])
                    this.tipoviDokumenta!.push(item);
            }
            if (Array.isArray(_data["statusi"])) {
                this.statusi = [] as any;
                for (let item of _data["statusi"])
                    this.statusi!.push(item);
            }
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.mesec = _data["mesec"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetPdvEvidencijaPojedinacna39TableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPdvEvidencijaPojedinacna39TableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brojObracuna"] = this.brojObracuna;
        data["originalniBroj"] = this.originalniBroj;
        if (Array.isArray(this.tipoviDokumenta)) {
            data["tipoviDokumenta"] = [];
            for (let item of this.tipoviDokumenta)
                data["tipoviDokumenta"].push(item);
        }
        if (Array.isArray(this.statusi)) {
            data["statusi"] = [];
            for (let item of this.statusi)
                data["statusi"].push(item);
        }
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["mesec"] = this.mesec;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetPdvEvidencijaPojedinacna39TableQuery {
    brojObracuna?: string | undefined;
    originalniBroj?: string | undefined;
    tipoviDokumenta?: PdvEvidencijaTipDokumenta[] | undefined;
    statusi?: PdvEvidencijaStatus[] | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    mesec?: number | undefined;
    pageNumber?: number;
    pageSize?: number;
}

export class ResultOfPdvEvidencijaPojedinacnaDto extends Result implements IResultOfPdvEvidencijaPojedinacnaDto {
    data?: PdvEvidencijaPojedinacnaDto | undefined;

    constructor(data?: IResultOfPdvEvidencijaPojedinacnaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PdvEvidencijaPojedinacnaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfPdvEvidencijaPojedinacnaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfPdvEvidencijaPojedinacnaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfPdvEvidencijaPojedinacnaDto extends IResult {
    data?: PdvEvidencijaPojedinacnaDto | undefined;
}

export class ResultOfPdvEvidencijaPojedinacna39Dto extends Result implements IResultOfPdvEvidencijaPojedinacna39Dto {
    data?: PdvEvidencijaPojedinacna39Dto | undefined;

    constructor(data?: IResultOfPdvEvidencijaPojedinacna39Dto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PdvEvidencijaPojedinacna39Dto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfPdvEvidencijaPojedinacna39Dto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfPdvEvidencijaPojedinacna39Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfPdvEvidencijaPojedinacna39Dto extends IResult {
    data?: PdvEvidencijaPojedinacna39Dto | undefined;
}

export class ResultOfDokumentForPdvDto extends Result implements IResultOfDokumentForPdvDto {
    data?: DokumentForPdvDto | undefined;

    constructor(data?: IResultOfDokumentForPdvDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? DokumentForPdvDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfDokumentForPdvDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfDokumentForPdvDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfDokumentForPdvDto extends IResult {
    data?: DokumentForPdvDto | undefined;
}

export class SefEvidentirajPdvEvidencijaPojedinacnaCommand implements ISefEvidentirajPdvEvidencijaPojedinacnaCommand {
    evidencijaId?: number;

    constructor(data?: ISefEvidentirajPdvEvidencijaPojedinacnaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.evidencijaId = _data["evidencijaId"];
        }
    }

    static fromJS(data: any): SefEvidentirajPdvEvidencijaPojedinacnaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SefEvidentirajPdvEvidencijaPojedinacnaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evidencijaId"] = this.evidencijaId;
        return data;
    }
}

export interface ISefEvidentirajPdvEvidencijaPojedinacnaCommand {
    evidencijaId?: number;
}

export class SefEvidentirajPdvEvidencijaPojedinacna39Command implements ISefEvidentirajPdvEvidencijaPojedinacna39Command {
    evidencijaId?: number;

    constructor(data?: ISefEvidentirajPdvEvidencijaPojedinacna39Command) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.evidencijaId = _data["evidencijaId"];
        }
    }

    static fromJS(data: any): SefEvidentirajPdvEvidencijaPojedinacna39Command {
        data = typeof data === 'object' ? data : {};
        let result = new SefEvidentirajPdvEvidencijaPojedinacna39Command();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evidencijaId"] = this.evidencijaId;
        return data;
    }
}

export interface ISefEvidentirajPdvEvidencijaPojedinacna39Command {
    evidencijaId?: number;
}

export class SefCancelPdvEvidencijaPojedinacnaCommand implements ISefCancelPdvEvidencijaPojedinacnaCommand {
    evidencijaId?: number;

    constructor(data?: ISefCancelPdvEvidencijaPojedinacnaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.evidencijaId = _data["evidencijaId"];
        }
    }

    static fromJS(data: any): SefCancelPdvEvidencijaPojedinacnaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SefCancelPdvEvidencijaPojedinacnaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evidencijaId"] = this.evidencijaId;
        return data;
    }
}

export interface ISefCancelPdvEvidencijaPojedinacnaCommand {
    evidencijaId?: number;
}

export class SefPonistiPdvEvidencijaPojedinacna39Command implements ISefPonistiPdvEvidencijaPojedinacna39Command {
    id?: number;

    constructor(data?: ISefPonistiPdvEvidencijaPojedinacna39Command) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SefPonistiPdvEvidencijaPojedinacna39Command {
        data = typeof data === 'object' ? data : {};
        let result = new SefPonistiPdvEvidencijaPojedinacna39Command();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ISefPonistiPdvEvidencijaPojedinacna39Command {
    id?: number;
}

export class SefKorigujPdvEvidencijaPojedinacnaCommand extends PdvEvidencijaPojedinacnaDto implements ISefKorigujPdvEvidencijaPojedinacnaCommand {

    constructor(data?: ISefKorigujPdvEvidencijaPojedinacnaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SefKorigujPdvEvidencijaPojedinacnaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SefKorigujPdvEvidencijaPojedinacnaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISefKorigujPdvEvidencijaPojedinacnaCommand extends IPdvEvidencijaPojedinacnaDto {
}

export class SefKorigujPdvEvidencijaPojedinacna39Command extends PdvEvidencijaPojedinacna39Dto implements ISefKorigujPdvEvidencijaPojedinacna39Command {

    constructor(data?: ISefKorigujPdvEvidencijaPojedinacna39Command) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SefKorigujPdvEvidencijaPojedinacna39Command {
        data = typeof data === 'object' ? data : {};
        let result = new SefKorigujPdvEvidencijaPojedinacna39Command();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISefKorigujPdvEvidencijaPojedinacna39Command extends IPdvEvidencijaPojedinacna39Dto {
}

export class PPPDVEvidencijaDto implements IPPPDVEvidencijaDto {
    id?: number | undefined;
    sefId?: number;
    broj?: string | undefined;
    godina?: number;
    datumEvidentiranja?: Date | undefined;
    status?: PdvEvidencijaStatus;
    period?: PdvPeriod;
    eF20Osnovica11?: number | undefined;
    eF20Pdv11?: number | undefined;
    eF10Osnovica11?: number | undefined;
    eF10Pdv11?: number | undefined;
    fiskalni20Osnovica11?: number | undefined;
    fiskalni20Pdv11?: number | undefined;
    fiskalni10Osnovica11?: number | undefined;
    fiskalni10Pdv11?: number | undefined;
    drugi20Osnovica11?: number | undefined;
    drugi20Pdv11?: number | undefined;
    drugi10Osnovica11?: number | undefined;
    drugi10Pdv11?: number | undefined;
    ukupno20Osnovica11?: number | undefined;
    ukupno20Pdv11?: number | undefined;
    ukupno10Osnovica11?: number | undefined;
    ukupno10Pdv11?: number | undefined;
    odbitak20Pdv11?: number | undefined;
    odbitak10Pdv11?: number | undefined;
    eF20Osnovica12?: number | undefined;
    eF20Pdv12?: number | undefined;
    eF10Osnovica12?: number | undefined;
    eF10Pdv12?: number | undefined;
    fiskalni20Osnovica12?: number | undefined;
    fiskalni20Pdv12?: number | undefined;
    fiskalni10Osnovica12?: number | undefined;
    fiskalni10Pdv12?: number | undefined;
    drugi20Osnovica12?: number | undefined;
    drugi20Pdv12?: number | undefined;
    drugi10Osnovica12?: number | undefined;
    drugi10Pdv12?: number | undefined;
    ukupno20Osnovica12?: number | undefined;
    ukupno20Pdv12?: number | undefined;
    ukupno10Osnovica12?: number | undefined;
    ukupno10Pdv12?: number | undefined;
    odbitak20Pdv12?: number | undefined;
    odbitak10Pdv12?: number | undefined;
    eF20Osnovica13?: number | undefined;
    eF20Pdv13?: number | undefined;
    eF10Osnovica13?: number | undefined;
    eF10Pdv13?: number | undefined;
    fiskalni20Osnovica13?: number | undefined;
    fiskalni20Pdv13?: number | undefined;
    fiskalni10Osnovica13?: number | undefined;
    fiskalni10Pdv13?: number | undefined;
    drugi20Osnovica13?: number | undefined;
    drugi20Pdv13?: number | undefined;
    drugi10Osnovica13?: number | undefined;
    drugi10Pdv13?: number | undefined;
    ukupno20Osnovica13?: number | undefined;
    ukupno20Pdv13?: number | undefined;
    ukupno10Osnovica13?: number | undefined;
    ukupno10Pdv13?: number | undefined;
    odbitak20Pdv13?: number | undefined;
    odbitak10Pdv13?: number | undefined;
    eF20Osnovica14?: number | undefined;
    eF20Pdv14?: number | undefined;
    eF10Osnovica14?: number | undefined;
    eF10Pdv14?: number | undefined;
    fiskalni20Osnovica14?: number | undefined;
    fiskalni20Pdv14?: number | undefined;
    fiskalni10Osnovica14?: number | undefined;
    fiskalni10Pdv14?: number | undefined;
    drugi20Osnovica14?: number | undefined;
    drugi20Pdv14?: number | undefined;
    drugi10Osnovica14?: number | undefined;
    drugi10Pdv14?: number | undefined;
    drugaDok20Osnovica14?: number | undefined;
    drugaDok20Pdv14?: number | undefined;
    drugaDok10Osnovica14?: number | undefined;
    drugaDok10Pdv14?: number | undefined;
    ukupno20Osnovica14?: number | undefined;
    ukupno20Pdv14?: number | undefined;
    ukupno10Osnovica14?: number | undefined;
    ukupno10Pdv14?: number | undefined;
    eF20Osnovica15?: number | undefined;
    eF20Pdv15?: number | undefined;
    eF10Osnovica15?: number | undefined;
    eF10Pdv15?: number | undefined;
    fiskalni20Osnovica15?: number | undefined;
    fiskalni20Pdv15?: number | undefined;
    fiskalni10Osnovica15?: number | undefined;
    fiskalni10Pdv15?: number | undefined;
    drugi20Osnovica15?: number | undefined;
    drugi20Pdv15?: number | undefined;
    drugi10Osnovica15?: number | undefined;
    drugi10Pdv15?: number | undefined;
    ukupno20Osnovica15?: number | undefined;
    ukupno20Pdv15?: number | undefined;
    ukupno10Osnovica15?: number | undefined;
    ukupno10Pdv15?: number | undefined;
    odbitak20Pdv15?: number | undefined;
    odbitak10Pdv15?: number | undefined;
    eF20Osnovica16?: number | undefined;
    eF20Pdv16?: number | undefined;
    eF10Osnovica16?: number | undefined;
    eF10Pdv16?: number | undefined;
    fiskalni20Osnovica16?: number | undefined;
    fiskalni20Pdv16?: number | undefined;
    fiskalni10Osnovica16?: number | undefined;
    fiskalni10Pdv16?: number | undefined;
    drugi20Osnovica16?: number | undefined;
    drugi20Pdv16?: number | undefined;
    drugi10Osnovica16?: number | undefined;
    drugi10Pdv16?: number | undefined;
    drugaDok20Osnovica16?: number | undefined;
    drugaDok20Pdv16?: number | undefined;
    drugaDok10Osnovica16?: number | undefined;
    drugaDok10Pdv16?: number | undefined;
    ukupno20Osnovica16?: number | undefined;
    ukupno20Pdv16?: number | undefined;
    ukupno10Osnovica16?: number | undefined;
    ukupno10Pdv16?: number | undefined;
    irS20Osnovica21?: number | undefined;
    irS20Pdv21?: number | undefined;
    irS10Osnovica21?: number | undefined;
    irS10Pdv21?: number | undefined;
    iR20Osnovica21?: number | undefined;
    iR20Pdv21?: number | undefined;
    iR10Osnovica21?: number | undefined;
    iR10Pdv21?: number | undefined;
    ukupno20Osnovica21?: number | undefined;
    ukupno20Pdv21?: number | undefined;
    ukupno10Osnovica21?: number | undefined;
    ukupno10Pdv21?: number | undefined;
    odbitak20Pdv21?: number | undefined;
    odbitak10Pdv21?: number | undefined;
    irS20Osnovica22?: number | undefined;
    irS20Pdv22?: number | undefined;
    irS10Osnovica22?: number | undefined;
    irS10Pdv22?: number | undefined;
    iR20Osnovica22?: number | undefined;
    iR20Pdv22?: number | undefined;
    iR10Osnovica22?: number | undefined;
    iR10Pdv22?: number | undefined;
    ukupno20Osnovica22?: number | undefined;
    ukupno20Pdv22?: number | undefined;
    ukupno10Osnovica22?: number | undefined;
    ukupno10Pdv22?: number | undefined;
    odbitak20Pdv22?: number | undefined;
    odbitak10Pdv22?: number | undefined;
    irS20Osnovica23?: number | undefined;
    irS20Pdv23?: number | undefined;
    irS10Osnovica23?: number | undefined;
    irS10Pdv23?: number | undefined;
    iR20Osnovica23?: number | undefined;
    iR20Pdv23?: number | undefined;
    iR10Osnovica23?: number | undefined;
    iR10Pdv23?: number | undefined;
    ukupno20Osnovica23?: number | undefined;
    ukupno20Pdv23?: number | undefined;
    ukupno10Osnovica23?: number | undefined;
    ukupno10Pdv23?: number | undefined;
    odbitak20Pdv23?: number | undefined;
    odbitak10Pdv23?: number | undefined;
    irS20Osnovica24?: number | undefined;
    irS10Osnovica24?: number | undefined;
    iR20Osnovica24?: number | undefined;
    iR10Osnovica24?: number | undefined;
    ukupno20Osnovica24?: number | undefined;
    ukupno10Osnovica24?: number | undefined;
    odbitak20Pdv24?: number | undefined;
    odbitak10Pdv24?: number | undefined;
    irS20Osnovica25?: number | undefined;
    irS20Pdv25?: number | undefined;
    irS10Osnovica25?: number | undefined;
    irS10Pdv25?: number | undefined;
    iR20Osnovica25?: number | undefined;
    iR20Pdv25?: number | undefined;
    iR10Osnovica25?: number | undefined;
    iR10Pdv25?: number | undefined;
    ukupno20Osnovica25?: number | undefined;
    ukupno20Pdv25?: number | undefined;
    ukupno10Osnovica25?: number | undefined;
    ukupno10Pdv25?: number | undefined;
    odbitak20Pdv25?: number | undefined;
    odbitak10Pdv25?: number | undefined;
    irS20Osnovica26?: number | undefined;
    irS10Osnovica26?: number | undefined;
    iR20Osnovica26?: number | undefined;
    iR10Osnovica26?: number | undefined;
    ukupno20Osnovica26?: number | undefined;
    ukupno10Osnovica26?: number | undefined;
    odbitak20Pdv26?: number | undefined;
    odbitak10Pdv26?: number | undefined;
    placeniPdv20?: number | undefined;
    placeniPdv10?: number | undefined;
    placeniPdvOdb20?: number | undefined;
    placeniPdvOdb10?: number | undefined;
    ukupnoPlaceniPdv?: number | undefined;
    ukupnoPlaceniPdvOdb?: number | undefined;
    ukupnoPdvPolj?: number | undefined;
    ukupnoPdvPoljOdb?: number | undefined;
    sticanjePravaOdb?: number | undefined;
    naknadnoSticanjePravaOdb?: number | undefined;
    odlukaPoreskogOrgana51?: number | undefined;
    povecanjeSrazmernogOdb?: number | undefined;
    sticanjePravaOdbPdv?: number | undefined;
    drugiOsnov51?: number | undefined;
    prestanakUslova?: number | undefined;
    odlukaPoreskogOrgana52?: number | undefined;
    smanjenjeSrazmernogOdb?: number | undefined;
    podnosenjeZahteva?: number | undefined;
    odlukaCarinskogOrgana?: number | undefined;
    smanjenjePdv?: number | undefined;
    drugiOsnov52?: number | undefined;

    constructor(data?: IPPPDVEvidencijaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sefId = _data["sefId"];
            this.broj = _data["broj"];
            this.godina = _data["godina"];
            this.datumEvidentiranja = _data["datumEvidentiranja"] ? new Date(_data["datumEvidentiranja"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.period = _data["period"];
            this.eF20Osnovica11 = _data["eF20Osnovica11"];
            this.eF20Pdv11 = _data["eF20Pdv11"];
            this.eF10Osnovica11 = _data["eF10Osnovica11"];
            this.eF10Pdv11 = _data["eF10Pdv11"];
            this.fiskalni20Osnovica11 = _data["fiskalni20Osnovica11"];
            this.fiskalni20Pdv11 = _data["fiskalni20Pdv11"];
            this.fiskalni10Osnovica11 = _data["fiskalni10Osnovica11"];
            this.fiskalni10Pdv11 = _data["fiskalni10Pdv11"];
            this.drugi20Osnovica11 = _data["drugi20Osnovica11"];
            this.drugi20Pdv11 = _data["drugi20Pdv11"];
            this.drugi10Osnovica11 = _data["drugi10Osnovica11"];
            this.drugi10Pdv11 = _data["drugi10Pdv11"];
            this.ukupno20Osnovica11 = _data["ukupno20Osnovica11"];
            this.ukupno20Pdv11 = _data["ukupno20Pdv11"];
            this.ukupno10Osnovica11 = _data["ukupno10Osnovica11"];
            this.ukupno10Pdv11 = _data["ukupno10Pdv11"];
            this.odbitak20Pdv11 = _data["odbitak20Pdv11"];
            this.odbitak10Pdv11 = _data["odbitak10Pdv11"];
            this.eF20Osnovica12 = _data["eF20Osnovica12"];
            this.eF20Pdv12 = _data["eF20Pdv12"];
            this.eF10Osnovica12 = _data["eF10Osnovica12"];
            this.eF10Pdv12 = _data["eF10Pdv12"];
            this.fiskalni20Osnovica12 = _data["fiskalni20Osnovica12"];
            this.fiskalni20Pdv12 = _data["fiskalni20Pdv12"];
            this.fiskalni10Osnovica12 = _data["fiskalni10Osnovica12"];
            this.fiskalni10Pdv12 = _data["fiskalni10Pdv12"];
            this.drugi20Osnovica12 = _data["drugi20Osnovica12"];
            this.drugi20Pdv12 = _data["drugi20Pdv12"];
            this.drugi10Osnovica12 = _data["drugi10Osnovica12"];
            this.drugi10Pdv12 = _data["drugi10Pdv12"];
            this.ukupno20Osnovica12 = _data["ukupno20Osnovica12"];
            this.ukupno20Pdv12 = _data["ukupno20Pdv12"];
            this.ukupno10Osnovica12 = _data["ukupno10Osnovica12"];
            this.ukupno10Pdv12 = _data["ukupno10Pdv12"];
            this.odbitak20Pdv12 = _data["odbitak20Pdv12"];
            this.odbitak10Pdv12 = _data["odbitak10Pdv12"];
            this.eF20Osnovica13 = _data["eF20Osnovica13"];
            this.eF20Pdv13 = _data["eF20Pdv13"];
            this.eF10Osnovica13 = _data["eF10Osnovica13"];
            this.eF10Pdv13 = _data["eF10Pdv13"];
            this.fiskalni20Osnovica13 = _data["fiskalni20Osnovica13"];
            this.fiskalni20Pdv13 = _data["fiskalni20Pdv13"];
            this.fiskalni10Osnovica13 = _data["fiskalni10Osnovica13"];
            this.fiskalni10Pdv13 = _data["fiskalni10Pdv13"];
            this.drugi20Osnovica13 = _data["drugi20Osnovica13"];
            this.drugi20Pdv13 = _data["drugi20Pdv13"];
            this.drugi10Osnovica13 = _data["drugi10Osnovica13"];
            this.drugi10Pdv13 = _data["drugi10Pdv13"];
            this.ukupno20Osnovica13 = _data["ukupno20Osnovica13"];
            this.ukupno20Pdv13 = _data["ukupno20Pdv13"];
            this.ukupno10Osnovica13 = _data["ukupno10Osnovica13"];
            this.ukupno10Pdv13 = _data["ukupno10Pdv13"];
            this.odbitak20Pdv13 = _data["odbitak20Pdv13"];
            this.odbitak10Pdv13 = _data["odbitak10Pdv13"];
            this.eF20Osnovica14 = _data["eF20Osnovica14"];
            this.eF20Pdv14 = _data["eF20Pdv14"];
            this.eF10Osnovica14 = _data["eF10Osnovica14"];
            this.eF10Pdv14 = _data["eF10Pdv14"];
            this.fiskalni20Osnovica14 = _data["fiskalni20Osnovica14"];
            this.fiskalni20Pdv14 = _data["fiskalni20Pdv14"];
            this.fiskalni10Osnovica14 = _data["fiskalni10Osnovica14"];
            this.fiskalni10Pdv14 = _data["fiskalni10Pdv14"];
            this.drugi20Osnovica14 = _data["drugi20Osnovica14"];
            this.drugi20Pdv14 = _data["drugi20Pdv14"];
            this.drugi10Osnovica14 = _data["drugi10Osnovica14"];
            this.drugi10Pdv14 = _data["drugi10Pdv14"];
            this.drugaDok20Osnovica14 = _data["drugaDok20Osnovica14"];
            this.drugaDok20Pdv14 = _data["drugaDok20Pdv14"];
            this.drugaDok10Osnovica14 = _data["drugaDok10Osnovica14"];
            this.drugaDok10Pdv14 = _data["drugaDok10Pdv14"];
            this.ukupno20Osnovica14 = _data["ukupno20Osnovica14"];
            this.ukupno20Pdv14 = _data["ukupno20Pdv14"];
            this.ukupno10Osnovica14 = _data["ukupno10Osnovica14"];
            this.ukupno10Pdv14 = _data["ukupno10Pdv14"];
            this.eF20Osnovica15 = _data["eF20Osnovica15"];
            this.eF20Pdv15 = _data["eF20Pdv15"];
            this.eF10Osnovica15 = _data["eF10Osnovica15"];
            this.eF10Pdv15 = _data["eF10Pdv15"];
            this.fiskalni20Osnovica15 = _data["fiskalni20Osnovica15"];
            this.fiskalni20Pdv15 = _data["fiskalni20Pdv15"];
            this.fiskalni10Osnovica15 = _data["fiskalni10Osnovica15"];
            this.fiskalni10Pdv15 = _data["fiskalni10Pdv15"];
            this.drugi20Osnovica15 = _data["drugi20Osnovica15"];
            this.drugi20Pdv15 = _data["drugi20Pdv15"];
            this.drugi10Osnovica15 = _data["drugi10Osnovica15"];
            this.drugi10Pdv15 = _data["drugi10Pdv15"];
            this.ukupno20Osnovica15 = _data["ukupno20Osnovica15"];
            this.ukupno20Pdv15 = _data["ukupno20Pdv15"];
            this.ukupno10Osnovica15 = _data["ukupno10Osnovica15"];
            this.ukupno10Pdv15 = _data["ukupno10Pdv15"];
            this.odbitak20Pdv15 = _data["odbitak20Pdv15"];
            this.odbitak10Pdv15 = _data["odbitak10Pdv15"];
            this.eF20Osnovica16 = _data["eF20Osnovica16"];
            this.eF20Pdv16 = _data["eF20Pdv16"];
            this.eF10Osnovica16 = _data["eF10Osnovica16"];
            this.eF10Pdv16 = _data["eF10Pdv16"];
            this.fiskalni20Osnovica16 = _data["fiskalni20Osnovica16"];
            this.fiskalni20Pdv16 = _data["fiskalni20Pdv16"];
            this.fiskalni10Osnovica16 = _data["fiskalni10Osnovica16"];
            this.fiskalni10Pdv16 = _data["fiskalni10Pdv16"];
            this.drugi20Osnovica16 = _data["drugi20Osnovica16"];
            this.drugi20Pdv16 = _data["drugi20Pdv16"];
            this.drugi10Osnovica16 = _data["drugi10Osnovica16"];
            this.drugi10Pdv16 = _data["drugi10Pdv16"];
            this.drugaDok20Osnovica16 = _data["drugaDok20Osnovica16"];
            this.drugaDok20Pdv16 = _data["drugaDok20Pdv16"];
            this.drugaDok10Osnovica16 = _data["drugaDok10Osnovica16"];
            this.drugaDok10Pdv16 = _data["drugaDok10Pdv16"];
            this.ukupno20Osnovica16 = _data["ukupno20Osnovica16"];
            this.ukupno20Pdv16 = _data["ukupno20Pdv16"];
            this.ukupno10Osnovica16 = _data["ukupno10Osnovica16"];
            this.ukupno10Pdv16 = _data["ukupno10Pdv16"];
            this.irS20Osnovica21 = _data["irS20Osnovica21"];
            this.irS20Pdv21 = _data["irS20Pdv21"];
            this.irS10Osnovica21 = _data["irS10Osnovica21"];
            this.irS10Pdv21 = _data["irS10Pdv21"];
            this.iR20Osnovica21 = _data["iR20Osnovica21"];
            this.iR20Pdv21 = _data["iR20Pdv21"];
            this.iR10Osnovica21 = _data["iR10Osnovica21"];
            this.iR10Pdv21 = _data["iR10Pdv21"];
            this.ukupno20Osnovica21 = _data["ukupno20Osnovica21"];
            this.ukupno20Pdv21 = _data["ukupno20Pdv21"];
            this.ukupno10Osnovica21 = _data["ukupno10Osnovica21"];
            this.ukupno10Pdv21 = _data["ukupno10Pdv21"];
            this.odbitak20Pdv21 = _data["odbitak20Pdv21"];
            this.odbitak10Pdv21 = _data["odbitak10Pdv21"];
            this.irS20Osnovica22 = _data["irS20Osnovica22"];
            this.irS20Pdv22 = _data["irS20Pdv22"];
            this.irS10Osnovica22 = _data["irS10Osnovica22"];
            this.irS10Pdv22 = _data["irS10Pdv22"];
            this.iR20Osnovica22 = _data["iR20Osnovica22"];
            this.iR20Pdv22 = _data["iR20Pdv22"];
            this.iR10Osnovica22 = _data["iR10Osnovica22"];
            this.iR10Pdv22 = _data["iR10Pdv22"];
            this.ukupno20Osnovica22 = _data["ukupno20Osnovica22"];
            this.ukupno20Pdv22 = _data["ukupno20Pdv22"];
            this.ukupno10Osnovica22 = _data["ukupno10Osnovica22"];
            this.ukupno10Pdv22 = _data["ukupno10Pdv22"];
            this.odbitak20Pdv22 = _data["odbitak20Pdv22"];
            this.odbitak10Pdv22 = _data["odbitak10Pdv22"];
            this.irS20Osnovica23 = _data["irS20Osnovica23"];
            this.irS20Pdv23 = _data["irS20Pdv23"];
            this.irS10Osnovica23 = _data["irS10Osnovica23"];
            this.irS10Pdv23 = _data["irS10Pdv23"];
            this.iR20Osnovica23 = _data["iR20Osnovica23"];
            this.iR20Pdv23 = _data["iR20Pdv23"];
            this.iR10Osnovica23 = _data["iR10Osnovica23"];
            this.iR10Pdv23 = _data["iR10Pdv23"];
            this.ukupno20Osnovica23 = _data["ukupno20Osnovica23"];
            this.ukupno20Pdv23 = _data["ukupno20Pdv23"];
            this.ukupno10Osnovica23 = _data["ukupno10Osnovica23"];
            this.ukupno10Pdv23 = _data["ukupno10Pdv23"];
            this.odbitak20Pdv23 = _data["odbitak20Pdv23"];
            this.odbitak10Pdv23 = _data["odbitak10Pdv23"];
            this.irS20Osnovica24 = _data["irS20Osnovica24"];
            this.irS10Osnovica24 = _data["irS10Osnovica24"];
            this.iR20Osnovica24 = _data["iR20Osnovica24"];
            this.iR10Osnovica24 = _data["iR10Osnovica24"];
            this.ukupno20Osnovica24 = _data["ukupno20Osnovica24"];
            this.ukupno10Osnovica24 = _data["ukupno10Osnovica24"];
            this.odbitak20Pdv24 = _data["odbitak20Pdv24"];
            this.odbitak10Pdv24 = _data["odbitak10Pdv24"];
            this.irS20Osnovica25 = _data["irS20Osnovica25"];
            this.irS20Pdv25 = _data["irS20Pdv25"];
            this.irS10Osnovica25 = _data["irS10Osnovica25"];
            this.irS10Pdv25 = _data["irS10Pdv25"];
            this.iR20Osnovica25 = _data["iR20Osnovica25"];
            this.iR20Pdv25 = _data["iR20Pdv25"];
            this.iR10Osnovica25 = _data["iR10Osnovica25"];
            this.iR10Pdv25 = _data["iR10Pdv25"];
            this.ukupno20Osnovica25 = _data["ukupno20Osnovica25"];
            this.ukupno20Pdv25 = _data["ukupno20Pdv25"];
            this.ukupno10Osnovica25 = _data["ukupno10Osnovica25"];
            this.ukupno10Pdv25 = _data["ukupno10Pdv25"];
            this.odbitak20Pdv25 = _data["odbitak20Pdv25"];
            this.odbitak10Pdv25 = _data["odbitak10Pdv25"];
            this.irS20Osnovica26 = _data["irS20Osnovica26"];
            this.irS10Osnovica26 = _data["irS10Osnovica26"];
            this.iR20Osnovica26 = _data["iR20Osnovica26"];
            this.iR10Osnovica26 = _data["iR10Osnovica26"];
            this.ukupno20Osnovica26 = _data["ukupno20Osnovica26"];
            this.ukupno10Osnovica26 = _data["ukupno10Osnovica26"];
            this.odbitak20Pdv26 = _data["odbitak20Pdv26"];
            this.odbitak10Pdv26 = _data["odbitak10Pdv26"];
            this.placeniPdv20 = _data["placeniPdv20"];
            this.placeniPdv10 = _data["placeniPdv10"];
            this.placeniPdvOdb20 = _data["placeniPdvOdb20"];
            this.placeniPdvOdb10 = _data["placeniPdvOdb10"];
            this.ukupnoPlaceniPdv = _data["ukupnoPlaceniPdv"];
            this.ukupnoPlaceniPdvOdb = _data["ukupnoPlaceniPdvOdb"];
            this.ukupnoPdvPolj = _data["ukupnoPdvPolj"];
            this.ukupnoPdvPoljOdb = _data["ukupnoPdvPoljOdb"];
            this.sticanjePravaOdb = _data["sticanjePravaOdb"];
            this.naknadnoSticanjePravaOdb = _data["naknadnoSticanjePravaOdb"];
            this.odlukaPoreskogOrgana51 = _data["odlukaPoreskogOrgana51"];
            this.povecanjeSrazmernogOdb = _data["povecanjeSrazmernogOdb"];
            this.sticanjePravaOdbPdv = _data["sticanjePravaOdbPdv"];
            this.drugiOsnov51 = _data["drugiOsnov51"];
            this.prestanakUslova = _data["prestanakUslova"];
            this.odlukaPoreskogOrgana52 = _data["odlukaPoreskogOrgana52"];
            this.smanjenjeSrazmernogOdb = _data["smanjenjeSrazmernogOdb"];
            this.podnosenjeZahteva = _data["podnosenjeZahteva"];
            this.odlukaCarinskogOrgana = _data["odlukaCarinskogOrgana"];
            this.smanjenjePdv = _data["smanjenjePdv"];
            this.drugiOsnov52 = _data["drugiOsnov52"];
        }
    }

    static fromJS(data: any): PPPDVEvidencijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PPPDVEvidencijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sefId"] = this.sefId;
        data["broj"] = this.broj;
        data["godina"] = this.godina;
        data["datumEvidentiranja"] = this.datumEvidentiranja ? this.datumEvidentiranja.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["period"] = this.period;
        data["eF20Osnovica11"] = this.eF20Osnovica11;
        data["eF20Pdv11"] = this.eF20Pdv11;
        data["eF10Osnovica11"] = this.eF10Osnovica11;
        data["eF10Pdv11"] = this.eF10Pdv11;
        data["fiskalni20Osnovica11"] = this.fiskalni20Osnovica11;
        data["fiskalni20Pdv11"] = this.fiskalni20Pdv11;
        data["fiskalni10Osnovica11"] = this.fiskalni10Osnovica11;
        data["fiskalni10Pdv11"] = this.fiskalni10Pdv11;
        data["drugi20Osnovica11"] = this.drugi20Osnovica11;
        data["drugi20Pdv11"] = this.drugi20Pdv11;
        data["drugi10Osnovica11"] = this.drugi10Osnovica11;
        data["drugi10Pdv11"] = this.drugi10Pdv11;
        data["ukupno20Osnovica11"] = this.ukupno20Osnovica11;
        data["ukupno20Pdv11"] = this.ukupno20Pdv11;
        data["ukupno10Osnovica11"] = this.ukupno10Osnovica11;
        data["ukupno10Pdv11"] = this.ukupno10Pdv11;
        data["odbitak20Pdv11"] = this.odbitak20Pdv11;
        data["odbitak10Pdv11"] = this.odbitak10Pdv11;
        data["eF20Osnovica12"] = this.eF20Osnovica12;
        data["eF20Pdv12"] = this.eF20Pdv12;
        data["eF10Osnovica12"] = this.eF10Osnovica12;
        data["eF10Pdv12"] = this.eF10Pdv12;
        data["fiskalni20Osnovica12"] = this.fiskalni20Osnovica12;
        data["fiskalni20Pdv12"] = this.fiskalni20Pdv12;
        data["fiskalni10Osnovica12"] = this.fiskalni10Osnovica12;
        data["fiskalni10Pdv12"] = this.fiskalni10Pdv12;
        data["drugi20Osnovica12"] = this.drugi20Osnovica12;
        data["drugi20Pdv12"] = this.drugi20Pdv12;
        data["drugi10Osnovica12"] = this.drugi10Osnovica12;
        data["drugi10Pdv12"] = this.drugi10Pdv12;
        data["ukupno20Osnovica12"] = this.ukupno20Osnovica12;
        data["ukupno20Pdv12"] = this.ukupno20Pdv12;
        data["ukupno10Osnovica12"] = this.ukupno10Osnovica12;
        data["ukupno10Pdv12"] = this.ukupno10Pdv12;
        data["odbitak20Pdv12"] = this.odbitak20Pdv12;
        data["odbitak10Pdv12"] = this.odbitak10Pdv12;
        data["eF20Osnovica13"] = this.eF20Osnovica13;
        data["eF20Pdv13"] = this.eF20Pdv13;
        data["eF10Osnovica13"] = this.eF10Osnovica13;
        data["eF10Pdv13"] = this.eF10Pdv13;
        data["fiskalni20Osnovica13"] = this.fiskalni20Osnovica13;
        data["fiskalni20Pdv13"] = this.fiskalni20Pdv13;
        data["fiskalni10Osnovica13"] = this.fiskalni10Osnovica13;
        data["fiskalni10Pdv13"] = this.fiskalni10Pdv13;
        data["drugi20Osnovica13"] = this.drugi20Osnovica13;
        data["drugi20Pdv13"] = this.drugi20Pdv13;
        data["drugi10Osnovica13"] = this.drugi10Osnovica13;
        data["drugi10Pdv13"] = this.drugi10Pdv13;
        data["ukupno20Osnovica13"] = this.ukupno20Osnovica13;
        data["ukupno20Pdv13"] = this.ukupno20Pdv13;
        data["ukupno10Osnovica13"] = this.ukupno10Osnovica13;
        data["ukupno10Pdv13"] = this.ukupno10Pdv13;
        data["odbitak20Pdv13"] = this.odbitak20Pdv13;
        data["odbitak10Pdv13"] = this.odbitak10Pdv13;
        data["eF20Osnovica14"] = this.eF20Osnovica14;
        data["eF20Pdv14"] = this.eF20Pdv14;
        data["eF10Osnovica14"] = this.eF10Osnovica14;
        data["eF10Pdv14"] = this.eF10Pdv14;
        data["fiskalni20Osnovica14"] = this.fiskalni20Osnovica14;
        data["fiskalni20Pdv14"] = this.fiskalni20Pdv14;
        data["fiskalni10Osnovica14"] = this.fiskalni10Osnovica14;
        data["fiskalni10Pdv14"] = this.fiskalni10Pdv14;
        data["drugi20Osnovica14"] = this.drugi20Osnovica14;
        data["drugi20Pdv14"] = this.drugi20Pdv14;
        data["drugi10Osnovica14"] = this.drugi10Osnovica14;
        data["drugi10Pdv14"] = this.drugi10Pdv14;
        data["drugaDok20Osnovica14"] = this.drugaDok20Osnovica14;
        data["drugaDok20Pdv14"] = this.drugaDok20Pdv14;
        data["drugaDok10Osnovica14"] = this.drugaDok10Osnovica14;
        data["drugaDok10Pdv14"] = this.drugaDok10Pdv14;
        data["ukupno20Osnovica14"] = this.ukupno20Osnovica14;
        data["ukupno20Pdv14"] = this.ukupno20Pdv14;
        data["ukupno10Osnovica14"] = this.ukupno10Osnovica14;
        data["ukupno10Pdv14"] = this.ukupno10Pdv14;
        data["eF20Osnovica15"] = this.eF20Osnovica15;
        data["eF20Pdv15"] = this.eF20Pdv15;
        data["eF10Osnovica15"] = this.eF10Osnovica15;
        data["eF10Pdv15"] = this.eF10Pdv15;
        data["fiskalni20Osnovica15"] = this.fiskalni20Osnovica15;
        data["fiskalni20Pdv15"] = this.fiskalni20Pdv15;
        data["fiskalni10Osnovica15"] = this.fiskalni10Osnovica15;
        data["fiskalni10Pdv15"] = this.fiskalni10Pdv15;
        data["drugi20Osnovica15"] = this.drugi20Osnovica15;
        data["drugi20Pdv15"] = this.drugi20Pdv15;
        data["drugi10Osnovica15"] = this.drugi10Osnovica15;
        data["drugi10Pdv15"] = this.drugi10Pdv15;
        data["ukupno20Osnovica15"] = this.ukupno20Osnovica15;
        data["ukupno20Pdv15"] = this.ukupno20Pdv15;
        data["ukupno10Osnovica15"] = this.ukupno10Osnovica15;
        data["ukupno10Pdv15"] = this.ukupno10Pdv15;
        data["odbitak20Pdv15"] = this.odbitak20Pdv15;
        data["odbitak10Pdv15"] = this.odbitak10Pdv15;
        data["eF20Osnovica16"] = this.eF20Osnovica16;
        data["eF20Pdv16"] = this.eF20Pdv16;
        data["eF10Osnovica16"] = this.eF10Osnovica16;
        data["eF10Pdv16"] = this.eF10Pdv16;
        data["fiskalni20Osnovica16"] = this.fiskalni20Osnovica16;
        data["fiskalni20Pdv16"] = this.fiskalni20Pdv16;
        data["fiskalni10Osnovica16"] = this.fiskalni10Osnovica16;
        data["fiskalni10Pdv16"] = this.fiskalni10Pdv16;
        data["drugi20Osnovica16"] = this.drugi20Osnovica16;
        data["drugi20Pdv16"] = this.drugi20Pdv16;
        data["drugi10Osnovica16"] = this.drugi10Osnovica16;
        data["drugi10Pdv16"] = this.drugi10Pdv16;
        data["drugaDok20Osnovica16"] = this.drugaDok20Osnovica16;
        data["drugaDok20Pdv16"] = this.drugaDok20Pdv16;
        data["drugaDok10Osnovica16"] = this.drugaDok10Osnovica16;
        data["drugaDok10Pdv16"] = this.drugaDok10Pdv16;
        data["ukupno20Osnovica16"] = this.ukupno20Osnovica16;
        data["ukupno20Pdv16"] = this.ukupno20Pdv16;
        data["ukupno10Osnovica16"] = this.ukupno10Osnovica16;
        data["ukupno10Pdv16"] = this.ukupno10Pdv16;
        data["irS20Osnovica21"] = this.irS20Osnovica21;
        data["irS20Pdv21"] = this.irS20Pdv21;
        data["irS10Osnovica21"] = this.irS10Osnovica21;
        data["irS10Pdv21"] = this.irS10Pdv21;
        data["iR20Osnovica21"] = this.iR20Osnovica21;
        data["iR20Pdv21"] = this.iR20Pdv21;
        data["iR10Osnovica21"] = this.iR10Osnovica21;
        data["iR10Pdv21"] = this.iR10Pdv21;
        data["ukupno20Osnovica21"] = this.ukupno20Osnovica21;
        data["ukupno20Pdv21"] = this.ukupno20Pdv21;
        data["ukupno10Osnovica21"] = this.ukupno10Osnovica21;
        data["ukupno10Pdv21"] = this.ukupno10Pdv21;
        data["odbitak20Pdv21"] = this.odbitak20Pdv21;
        data["odbitak10Pdv21"] = this.odbitak10Pdv21;
        data["irS20Osnovica22"] = this.irS20Osnovica22;
        data["irS20Pdv22"] = this.irS20Pdv22;
        data["irS10Osnovica22"] = this.irS10Osnovica22;
        data["irS10Pdv22"] = this.irS10Pdv22;
        data["iR20Osnovica22"] = this.iR20Osnovica22;
        data["iR20Pdv22"] = this.iR20Pdv22;
        data["iR10Osnovica22"] = this.iR10Osnovica22;
        data["iR10Pdv22"] = this.iR10Pdv22;
        data["ukupno20Osnovica22"] = this.ukupno20Osnovica22;
        data["ukupno20Pdv22"] = this.ukupno20Pdv22;
        data["ukupno10Osnovica22"] = this.ukupno10Osnovica22;
        data["ukupno10Pdv22"] = this.ukupno10Pdv22;
        data["odbitak20Pdv22"] = this.odbitak20Pdv22;
        data["odbitak10Pdv22"] = this.odbitak10Pdv22;
        data["irS20Osnovica23"] = this.irS20Osnovica23;
        data["irS20Pdv23"] = this.irS20Pdv23;
        data["irS10Osnovica23"] = this.irS10Osnovica23;
        data["irS10Pdv23"] = this.irS10Pdv23;
        data["iR20Osnovica23"] = this.iR20Osnovica23;
        data["iR20Pdv23"] = this.iR20Pdv23;
        data["iR10Osnovica23"] = this.iR10Osnovica23;
        data["iR10Pdv23"] = this.iR10Pdv23;
        data["ukupno20Osnovica23"] = this.ukupno20Osnovica23;
        data["ukupno20Pdv23"] = this.ukupno20Pdv23;
        data["ukupno10Osnovica23"] = this.ukupno10Osnovica23;
        data["ukupno10Pdv23"] = this.ukupno10Pdv23;
        data["odbitak20Pdv23"] = this.odbitak20Pdv23;
        data["odbitak10Pdv23"] = this.odbitak10Pdv23;
        data["irS20Osnovica24"] = this.irS20Osnovica24;
        data["irS10Osnovica24"] = this.irS10Osnovica24;
        data["iR20Osnovica24"] = this.iR20Osnovica24;
        data["iR10Osnovica24"] = this.iR10Osnovica24;
        data["ukupno20Osnovica24"] = this.ukupno20Osnovica24;
        data["ukupno10Osnovica24"] = this.ukupno10Osnovica24;
        data["odbitak20Pdv24"] = this.odbitak20Pdv24;
        data["odbitak10Pdv24"] = this.odbitak10Pdv24;
        data["irS20Osnovica25"] = this.irS20Osnovica25;
        data["irS20Pdv25"] = this.irS20Pdv25;
        data["irS10Osnovica25"] = this.irS10Osnovica25;
        data["irS10Pdv25"] = this.irS10Pdv25;
        data["iR20Osnovica25"] = this.iR20Osnovica25;
        data["iR20Pdv25"] = this.iR20Pdv25;
        data["iR10Osnovica25"] = this.iR10Osnovica25;
        data["iR10Pdv25"] = this.iR10Pdv25;
        data["ukupno20Osnovica25"] = this.ukupno20Osnovica25;
        data["ukupno20Pdv25"] = this.ukupno20Pdv25;
        data["ukupno10Osnovica25"] = this.ukupno10Osnovica25;
        data["ukupno10Pdv25"] = this.ukupno10Pdv25;
        data["odbitak20Pdv25"] = this.odbitak20Pdv25;
        data["odbitak10Pdv25"] = this.odbitak10Pdv25;
        data["irS20Osnovica26"] = this.irS20Osnovica26;
        data["irS10Osnovica26"] = this.irS10Osnovica26;
        data["iR20Osnovica26"] = this.iR20Osnovica26;
        data["iR10Osnovica26"] = this.iR10Osnovica26;
        data["ukupno20Osnovica26"] = this.ukupno20Osnovica26;
        data["ukupno10Osnovica26"] = this.ukupno10Osnovica26;
        data["odbitak20Pdv26"] = this.odbitak20Pdv26;
        data["odbitak10Pdv26"] = this.odbitak10Pdv26;
        data["placeniPdv20"] = this.placeniPdv20;
        data["placeniPdv10"] = this.placeniPdv10;
        data["placeniPdvOdb20"] = this.placeniPdvOdb20;
        data["placeniPdvOdb10"] = this.placeniPdvOdb10;
        data["ukupnoPlaceniPdv"] = this.ukupnoPlaceniPdv;
        data["ukupnoPlaceniPdvOdb"] = this.ukupnoPlaceniPdvOdb;
        data["ukupnoPdvPolj"] = this.ukupnoPdvPolj;
        data["ukupnoPdvPoljOdb"] = this.ukupnoPdvPoljOdb;
        data["sticanjePravaOdb"] = this.sticanjePravaOdb;
        data["naknadnoSticanjePravaOdb"] = this.naknadnoSticanjePravaOdb;
        data["odlukaPoreskogOrgana51"] = this.odlukaPoreskogOrgana51;
        data["povecanjeSrazmernogOdb"] = this.povecanjeSrazmernogOdb;
        data["sticanjePravaOdbPdv"] = this.sticanjePravaOdbPdv;
        data["drugiOsnov51"] = this.drugiOsnov51;
        data["prestanakUslova"] = this.prestanakUslova;
        data["odlukaPoreskogOrgana52"] = this.odlukaPoreskogOrgana52;
        data["smanjenjeSrazmernogOdb"] = this.smanjenjeSrazmernogOdb;
        data["podnosenjeZahteva"] = this.podnosenjeZahteva;
        data["odlukaCarinskogOrgana"] = this.odlukaCarinskogOrgana;
        data["smanjenjePdv"] = this.smanjenjePdv;
        data["drugiOsnov52"] = this.drugiOsnov52;
        return data;
    }
}

export interface IPPPDVEvidencijaDto {
    id?: number | undefined;
    sefId?: number;
    broj?: string | undefined;
    godina?: number;
    datumEvidentiranja?: Date | undefined;
    status?: PdvEvidencijaStatus;
    period?: PdvPeriod;
    eF20Osnovica11?: number | undefined;
    eF20Pdv11?: number | undefined;
    eF10Osnovica11?: number | undefined;
    eF10Pdv11?: number | undefined;
    fiskalni20Osnovica11?: number | undefined;
    fiskalni20Pdv11?: number | undefined;
    fiskalni10Osnovica11?: number | undefined;
    fiskalni10Pdv11?: number | undefined;
    drugi20Osnovica11?: number | undefined;
    drugi20Pdv11?: number | undefined;
    drugi10Osnovica11?: number | undefined;
    drugi10Pdv11?: number | undefined;
    ukupno20Osnovica11?: number | undefined;
    ukupno20Pdv11?: number | undefined;
    ukupno10Osnovica11?: number | undefined;
    ukupno10Pdv11?: number | undefined;
    odbitak20Pdv11?: number | undefined;
    odbitak10Pdv11?: number | undefined;
    eF20Osnovica12?: number | undefined;
    eF20Pdv12?: number | undefined;
    eF10Osnovica12?: number | undefined;
    eF10Pdv12?: number | undefined;
    fiskalni20Osnovica12?: number | undefined;
    fiskalni20Pdv12?: number | undefined;
    fiskalni10Osnovica12?: number | undefined;
    fiskalni10Pdv12?: number | undefined;
    drugi20Osnovica12?: number | undefined;
    drugi20Pdv12?: number | undefined;
    drugi10Osnovica12?: number | undefined;
    drugi10Pdv12?: number | undefined;
    ukupno20Osnovica12?: number | undefined;
    ukupno20Pdv12?: number | undefined;
    ukupno10Osnovica12?: number | undefined;
    ukupno10Pdv12?: number | undefined;
    odbitak20Pdv12?: number | undefined;
    odbitak10Pdv12?: number | undefined;
    eF20Osnovica13?: number | undefined;
    eF20Pdv13?: number | undefined;
    eF10Osnovica13?: number | undefined;
    eF10Pdv13?: number | undefined;
    fiskalni20Osnovica13?: number | undefined;
    fiskalni20Pdv13?: number | undefined;
    fiskalni10Osnovica13?: number | undefined;
    fiskalni10Pdv13?: number | undefined;
    drugi20Osnovica13?: number | undefined;
    drugi20Pdv13?: number | undefined;
    drugi10Osnovica13?: number | undefined;
    drugi10Pdv13?: number | undefined;
    ukupno20Osnovica13?: number | undefined;
    ukupno20Pdv13?: number | undefined;
    ukupno10Osnovica13?: number | undefined;
    ukupno10Pdv13?: number | undefined;
    odbitak20Pdv13?: number | undefined;
    odbitak10Pdv13?: number | undefined;
    eF20Osnovica14?: number | undefined;
    eF20Pdv14?: number | undefined;
    eF10Osnovica14?: number | undefined;
    eF10Pdv14?: number | undefined;
    fiskalni20Osnovica14?: number | undefined;
    fiskalni20Pdv14?: number | undefined;
    fiskalni10Osnovica14?: number | undefined;
    fiskalni10Pdv14?: number | undefined;
    drugi20Osnovica14?: number | undefined;
    drugi20Pdv14?: number | undefined;
    drugi10Osnovica14?: number | undefined;
    drugi10Pdv14?: number | undefined;
    drugaDok20Osnovica14?: number | undefined;
    drugaDok20Pdv14?: number | undefined;
    drugaDok10Osnovica14?: number | undefined;
    drugaDok10Pdv14?: number | undefined;
    ukupno20Osnovica14?: number | undefined;
    ukupno20Pdv14?: number | undefined;
    ukupno10Osnovica14?: number | undefined;
    ukupno10Pdv14?: number | undefined;
    eF20Osnovica15?: number | undefined;
    eF20Pdv15?: number | undefined;
    eF10Osnovica15?: number | undefined;
    eF10Pdv15?: number | undefined;
    fiskalni20Osnovica15?: number | undefined;
    fiskalni20Pdv15?: number | undefined;
    fiskalni10Osnovica15?: number | undefined;
    fiskalni10Pdv15?: number | undefined;
    drugi20Osnovica15?: number | undefined;
    drugi20Pdv15?: number | undefined;
    drugi10Osnovica15?: number | undefined;
    drugi10Pdv15?: number | undefined;
    ukupno20Osnovica15?: number | undefined;
    ukupno20Pdv15?: number | undefined;
    ukupno10Osnovica15?: number | undefined;
    ukupno10Pdv15?: number | undefined;
    odbitak20Pdv15?: number | undefined;
    odbitak10Pdv15?: number | undefined;
    eF20Osnovica16?: number | undefined;
    eF20Pdv16?: number | undefined;
    eF10Osnovica16?: number | undefined;
    eF10Pdv16?: number | undefined;
    fiskalni20Osnovica16?: number | undefined;
    fiskalni20Pdv16?: number | undefined;
    fiskalni10Osnovica16?: number | undefined;
    fiskalni10Pdv16?: number | undefined;
    drugi20Osnovica16?: number | undefined;
    drugi20Pdv16?: number | undefined;
    drugi10Osnovica16?: number | undefined;
    drugi10Pdv16?: number | undefined;
    drugaDok20Osnovica16?: number | undefined;
    drugaDok20Pdv16?: number | undefined;
    drugaDok10Osnovica16?: number | undefined;
    drugaDok10Pdv16?: number | undefined;
    ukupno20Osnovica16?: number | undefined;
    ukupno20Pdv16?: number | undefined;
    ukupno10Osnovica16?: number | undefined;
    ukupno10Pdv16?: number | undefined;
    irS20Osnovica21?: number | undefined;
    irS20Pdv21?: number | undefined;
    irS10Osnovica21?: number | undefined;
    irS10Pdv21?: number | undefined;
    iR20Osnovica21?: number | undefined;
    iR20Pdv21?: number | undefined;
    iR10Osnovica21?: number | undefined;
    iR10Pdv21?: number | undefined;
    ukupno20Osnovica21?: number | undefined;
    ukupno20Pdv21?: number | undefined;
    ukupno10Osnovica21?: number | undefined;
    ukupno10Pdv21?: number | undefined;
    odbitak20Pdv21?: number | undefined;
    odbitak10Pdv21?: number | undefined;
    irS20Osnovica22?: number | undefined;
    irS20Pdv22?: number | undefined;
    irS10Osnovica22?: number | undefined;
    irS10Pdv22?: number | undefined;
    iR20Osnovica22?: number | undefined;
    iR20Pdv22?: number | undefined;
    iR10Osnovica22?: number | undefined;
    iR10Pdv22?: number | undefined;
    ukupno20Osnovica22?: number | undefined;
    ukupno20Pdv22?: number | undefined;
    ukupno10Osnovica22?: number | undefined;
    ukupno10Pdv22?: number | undefined;
    odbitak20Pdv22?: number | undefined;
    odbitak10Pdv22?: number | undefined;
    irS20Osnovica23?: number | undefined;
    irS20Pdv23?: number | undefined;
    irS10Osnovica23?: number | undefined;
    irS10Pdv23?: number | undefined;
    iR20Osnovica23?: number | undefined;
    iR20Pdv23?: number | undefined;
    iR10Osnovica23?: number | undefined;
    iR10Pdv23?: number | undefined;
    ukupno20Osnovica23?: number | undefined;
    ukupno20Pdv23?: number | undefined;
    ukupno10Osnovica23?: number | undefined;
    ukupno10Pdv23?: number | undefined;
    odbitak20Pdv23?: number | undefined;
    odbitak10Pdv23?: number | undefined;
    irS20Osnovica24?: number | undefined;
    irS10Osnovica24?: number | undefined;
    iR20Osnovica24?: number | undefined;
    iR10Osnovica24?: number | undefined;
    ukupno20Osnovica24?: number | undefined;
    ukupno10Osnovica24?: number | undefined;
    odbitak20Pdv24?: number | undefined;
    odbitak10Pdv24?: number | undefined;
    irS20Osnovica25?: number | undefined;
    irS20Pdv25?: number | undefined;
    irS10Osnovica25?: number | undefined;
    irS10Pdv25?: number | undefined;
    iR20Osnovica25?: number | undefined;
    iR20Pdv25?: number | undefined;
    iR10Osnovica25?: number | undefined;
    iR10Pdv25?: number | undefined;
    ukupno20Osnovica25?: number | undefined;
    ukupno20Pdv25?: number | undefined;
    ukupno10Osnovica25?: number | undefined;
    ukupno10Pdv25?: number | undefined;
    odbitak20Pdv25?: number | undefined;
    odbitak10Pdv25?: number | undefined;
    irS20Osnovica26?: number | undefined;
    irS10Osnovica26?: number | undefined;
    iR20Osnovica26?: number | undefined;
    iR10Osnovica26?: number | undefined;
    ukupno20Osnovica26?: number | undefined;
    ukupno10Osnovica26?: number | undefined;
    odbitak20Pdv26?: number | undefined;
    odbitak10Pdv26?: number | undefined;
    placeniPdv20?: number | undefined;
    placeniPdv10?: number | undefined;
    placeniPdvOdb20?: number | undefined;
    placeniPdvOdb10?: number | undefined;
    ukupnoPlaceniPdv?: number | undefined;
    ukupnoPlaceniPdvOdb?: number | undefined;
    ukupnoPdvPolj?: number | undefined;
    ukupnoPdvPoljOdb?: number | undefined;
    sticanjePravaOdb?: number | undefined;
    naknadnoSticanjePravaOdb?: number | undefined;
    odlukaPoreskogOrgana51?: number | undefined;
    povecanjeSrazmernogOdb?: number | undefined;
    sticanjePravaOdbPdv?: number | undefined;
    drugiOsnov51?: number | undefined;
    prestanakUslova?: number | undefined;
    odlukaPoreskogOrgana52?: number | undefined;
    smanjenjeSrazmernogOdb?: number | undefined;
    podnosenjeZahteva?: number | undefined;
    odlukaCarinskogOrgana?: number | undefined;
    smanjenjePdv?: number | undefined;
    drugiOsnov52?: number | undefined;
}

export class CreatePPPDVEvidencijaCommand extends PPPDVEvidencijaDto implements ICreatePPPDVEvidencijaCommand {

    constructor(data?: ICreatePPPDVEvidencijaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreatePPPDVEvidencijaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePPPDVEvidencijaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreatePPPDVEvidencijaCommand extends IPPPDVEvidencijaDto {
}

export class UpdatePPPDVEvidencijaCommand extends PPPDVEvidencijaDto implements IUpdatePPPDVEvidencijaCommand {

    constructor(data?: IUpdatePPPDVEvidencijaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdatePPPDVEvidencijaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePPPDVEvidencijaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePPPDVEvidencijaCommand extends IPPPDVEvidencijaDto {
}

export class SefEvidentirajPPPDVEvidencijaCommand implements ISefEvidentirajPPPDVEvidencijaCommand {
    id?: number;

    constructor(data?: ISefEvidentirajPPPDVEvidencijaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SefEvidentirajPPPDVEvidencijaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SefEvidentirajPPPDVEvidencijaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ISefEvidentirajPPPDVEvidencijaCommand {
    id?: number;
}

export class SefKorigujPPPDVEvidencijaCommand extends PPPDVEvidencijaDto implements ISefKorigujPPPDVEvidencijaCommand {

    constructor(data?: ISefKorigujPPPDVEvidencijaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SefKorigujPPPDVEvidencijaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SefKorigujPPPDVEvidencijaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISefKorigujPPPDVEvidencijaCommand extends IPPPDVEvidencijaDto {
}

export class PaginatedResultOfPPPDVEvidencijaTableDto extends Result implements IPaginatedResultOfPPPDVEvidencijaTableDto {
    data?: PPPDVEvidencijaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfPPPDVEvidencijaTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PPPDVEvidencijaTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfPPPDVEvidencijaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfPPPDVEvidencijaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfPPPDVEvidencijaTableDto extends IResult {
    data?: PPPDVEvidencijaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PPPDVEvidencijaTableDto implements IPPPDVEvidencijaTableDto {
    id?: number;
    broj?: string | undefined;
    periodDto?: PdvPeriodDto | undefined;
    godina?: number;
    statusDto?: PdvEvidencijaStatusDto | undefined;
    datumPromeneStatusa?: string | undefined;

    constructor(data?: IPPPDVEvidencijaTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.periodDto = _data["periodDto"] ? PdvPeriodDto.fromJS(_data["periodDto"]) : <any>undefined;
            this.godina = _data["godina"];
            this.statusDto = _data["statusDto"] ? PdvEvidencijaStatusDto.fromJS(_data["statusDto"]) : <any>undefined;
            this.datumPromeneStatusa = _data["datumPromeneStatusa"];
        }
    }

    static fromJS(data: any): PPPDVEvidencijaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PPPDVEvidencijaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["periodDto"] = this.periodDto ? this.periodDto.toJSON() : <any>undefined;
        data["godina"] = this.godina;
        data["statusDto"] = this.statusDto ? this.statusDto.toJSON() : <any>undefined;
        data["datumPromeneStatusa"] = this.datumPromeneStatusa;
        return data;
    }
}

export interface IPPPDVEvidencijaTableDto {
    id?: number;
    broj?: string | undefined;
    periodDto?: PdvPeriodDto | undefined;
    godina?: number;
    statusDto?: PdvEvidencijaStatusDto | undefined;
    datumPromeneStatusa?: string | undefined;
}

export class GetPPPDVTableQuery implements IGetPPPDVTableQuery {
    broj?: string | undefined;
    statusi?: PdvEvidencijaStatus[] | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetPPPDVTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.broj = _data["broj"];
            if (Array.isArray(_data["statusi"])) {
                this.statusi = [] as any;
                for (let item of _data["statusi"])
                    this.statusi!.push(item);
            }
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetPPPDVTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPPPDVTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["broj"] = this.broj;
        if (Array.isArray(this.statusi)) {
            data["statusi"] = [];
            for (let item of this.statusi)
                data["statusi"].push(item);
        }
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetPPPDVTableQuery {
    broj?: string | undefined;
    statusi?: PdvEvidencijaStatus[] | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    pageNumber?: number;
    pageSize?: number;
}

export class ResultOfPPPDVEvidencijaDto extends Result implements IResultOfPPPDVEvidencijaDto {
    data?: PPPDVEvidencijaDto | undefined;

    constructor(data?: IResultOfPPPDVEvidencijaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PPPDVEvidencijaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfPPPDVEvidencijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfPPPDVEvidencijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfPPPDVEvidencijaDto extends IResult {
    data?: PPPDVEvidencijaDto | undefined;
}

export class ResultOfSystemCalculationDto extends Result implements IResultOfSystemCalculationDto {
    data?: SystemCalculationDto | undefined;

    constructor(data?: IResultOfSystemCalculationDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? SystemCalculationDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfSystemCalculationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfSystemCalculationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfSystemCalculationDto extends IResult {
    data?: SystemCalculationDto | undefined;
}

export class SystemCalculationDto implements ISystemCalculationDto {
    taxId?: string | undefined;
    year?: number | undefined;
    vatPeriodRange?: string | undefined;
    vatPeriod?: string | undefined;
    dataCollectionDate?: Date | undefined;
    turnoverAsSupplier?: TurnoverAsSupplier | undefined;
    turnoverAsRecipient?: TurnoverAsRecipient | undefined;
    vatForImport?: VatForImport | undefined;

    constructor(data?: ISystemCalculationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxId = _data["taxId"];
            this.year = _data["year"];
            this.vatPeriodRange = _data["vatPeriodRange"];
            this.vatPeriod = _data["vatPeriod"];
            this.dataCollectionDate = _data["dataCollectionDate"] ? new Date(_data["dataCollectionDate"].toString()) : <any>undefined;
            this.turnoverAsSupplier = _data["turnoverAsSupplier"] ? TurnoverAsSupplier.fromJS(_data["turnoverAsSupplier"]) : <any>undefined;
            this.turnoverAsRecipient = _data["turnoverAsRecipient"] ? TurnoverAsRecipient.fromJS(_data["turnoverAsRecipient"]) : <any>undefined;
            this.vatForImport = _data["vatForImport"] ? VatForImport.fromJS(_data["vatForImport"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SystemCalculationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemCalculationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxId"] = this.taxId;
        data["year"] = this.year;
        data["vatPeriodRange"] = this.vatPeriodRange;
        data["vatPeriod"] = this.vatPeriod;
        data["dataCollectionDate"] = this.dataCollectionDate ? this.dataCollectionDate.toISOString() : <any>undefined;
        data["turnoverAsSupplier"] = this.turnoverAsSupplier ? this.turnoverAsSupplier.toJSON() : <any>undefined;
        data["turnoverAsRecipient"] = this.turnoverAsRecipient ? this.turnoverAsRecipient.toJSON() : <any>undefined;
        data["vatForImport"] = this.vatForImport ? this.vatForImport.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISystemCalculationDto {
    taxId?: string | undefined;
    year?: number | undefined;
    vatPeriodRange?: string | undefined;
    vatPeriod?: string | undefined;
    dataCollectionDate?: Date | undefined;
    turnoverAsSupplier?: TurnoverAsSupplier | undefined;
    turnoverAsRecipient?: TurnoverAsRecipient | undefined;
    vatForImport?: VatForImport | undefined;
}

export class TurnoverAsSupplier implements ITurnoverAsSupplier {
    firstTransferOfTheRightToDispose?: FirstTransferOfTheRightToDispose | undefined;
    turnoverExceptForTransferOfTheRight?: TurnoverExceptForTransferOfTheRight | undefined;
    increaseOfBaseIeVat?: IncreaseOfBaseIeVat | undefined;
    feePaidBeforeTurnoverIePrepayment?: FeePaidBeforeTurnoverIePrepayment | undefined;

    constructor(data?: ITurnoverAsSupplier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstTransferOfTheRightToDispose = _data["firstTransferOfTheRightToDispose"] ? FirstTransferOfTheRightToDispose.fromJS(_data["firstTransferOfTheRightToDispose"]) : <any>undefined;
            this.turnoverExceptForTransferOfTheRight = _data["turnoverExceptForTransferOfTheRight"] ? TurnoverExceptForTransferOfTheRight.fromJS(_data["turnoverExceptForTransferOfTheRight"]) : <any>undefined;
            this.increaseOfBaseIeVat = _data["increaseOfBaseIeVat"] ? IncreaseOfBaseIeVat.fromJS(_data["increaseOfBaseIeVat"]) : <any>undefined;
            this.feePaidBeforeTurnoverIePrepayment = _data["feePaidBeforeTurnoverIePrepayment"] ? FeePaidBeforeTurnoverIePrepayment.fromJS(_data["feePaidBeforeTurnoverIePrepayment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TurnoverAsSupplier {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoverAsSupplier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstTransferOfTheRightToDispose"] = this.firstTransferOfTheRightToDispose ? this.firstTransferOfTheRightToDispose.toJSON() : <any>undefined;
        data["turnoverExceptForTransferOfTheRight"] = this.turnoverExceptForTransferOfTheRight ? this.turnoverExceptForTransferOfTheRight.toJSON() : <any>undefined;
        data["increaseOfBaseIeVat"] = this.increaseOfBaseIeVat ? this.increaseOfBaseIeVat.toJSON() : <any>undefined;
        data["feePaidBeforeTurnoverIePrepayment"] = this.feePaidBeforeTurnoverIePrepayment ? this.feePaidBeforeTurnoverIePrepayment.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITurnoverAsSupplier {
    firstTransferOfTheRightToDispose?: FirstTransferOfTheRightToDispose | undefined;
    turnoverExceptForTransferOfTheRight?: TurnoverExceptForTransferOfTheRight | undefined;
    increaseOfBaseIeVat?: IncreaseOfBaseIeVat | undefined;
    feePaidBeforeTurnoverIePrepayment?: FeePaidBeforeTurnoverIePrepayment | undefined;
}

export class FirstTransferOfTheRightToDispose implements IFirstTransferOfTheRightToDispose {
    turnoverAtRateOf20Percent?: TurnoverAtRate | undefined;
    turnoverAtRateOf10Percent?: TurnoverAtRate | undefined;

    constructor(data?: IFirstTransferOfTheRightToDispose) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.turnoverAtRateOf20Percent = _data["turnoverAtRateOf20Percent"] ? TurnoverAtRate.fromJS(_data["turnoverAtRateOf20Percent"]) : <any>undefined;
            this.turnoverAtRateOf10Percent = _data["turnoverAtRateOf10Percent"] ? TurnoverAtRate.fromJS(_data["turnoverAtRateOf10Percent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FirstTransferOfTheRightToDispose {
        data = typeof data === 'object' ? data : {};
        let result = new FirstTransferOfTheRightToDispose();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["turnoverAtRateOf20Percent"] = this.turnoverAtRateOf20Percent ? this.turnoverAtRateOf20Percent.toJSON() : <any>undefined;
        data["turnoverAtRateOf10Percent"] = this.turnoverAtRateOf10Percent ? this.turnoverAtRateOf10Percent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFirstTransferOfTheRightToDispose {
    turnoverAtRateOf20Percent?: TurnoverAtRate | undefined;
    turnoverAtRateOf10Percent?: TurnoverAtRate | undefined;
}

export class TurnoverAtRate implements ITurnoverAtRate {
    invoiceBase?: number | undefined;
    invoiceVat?: number | undefined;

    constructor(data?: ITurnoverAtRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceBase = _data["invoiceBase"];
            this.invoiceVat = _data["invoiceVat"];
        }
    }

    static fromJS(data: any): TurnoverAtRate {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoverAtRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceBase"] = this.invoiceBase;
        data["invoiceVat"] = this.invoiceVat;
        return data;
    }
}

export interface ITurnoverAtRate {
    invoiceBase?: number | undefined;
    invoiceVat?: number | undefined;
}

export class TurnoverExceptForTransferOfTheRight implements ITurnoverExceptForTransferOfTheRight {
    turnoverAtRateOf20Percent?: TurnoverAtRate | undefined;
    turnoverAtRateOf10Percent?: TurnoverAtRate | undefined;

    constructor(data?: ITurnoverExceptForTransferOfTheRight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.turnoverAtRateOf20Percent = _data["turnoverAtRateOf20Percent"] ? TurnoverAtRate.fromJS(_data["turnoverAtRateOf20Percent"]) : <any>undefined;
            this.turnoverAtRateOf10Percent = _data["turnoverAtRateOf10Percent"] ? TurnoverAtRate.fromJS(_data["turnoverAtRateOf10Percent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TurnoverExceptForTransferOfTheRight {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoverExceptForTransferOfTheRight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["turnoverAtRateOf20Percent"] = this.turnoverAtRateOf20Percent ? this.turnoverAtRateOf20Percent.toJSON() : <any>undefined;
        data["turnoverAtRateOf10Percent"] = this.turnoverAtRateOf10Percent ? this.turnoverAtRateOf10Percent.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITurnoverExceptForTransferOfTheRight {
    turnoverAtRateOf20Percent?: TurnoverAtRate | undefined;
    turnoverAtRateOf10Percent?: TurnoverAtRate | undefined;
}

export class IncreaseOfBaseIeVat implements IIncreaseOfBaseIeVat {
    turnoverAtRateOf20Percent?: TurnoverAtRate | undefined;
    turnoverAtRateOf10Percent?: TurnoverAtRate | undefined;

    constructor(data?: IIncreaseOfBaseIeVat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.turnoverAtRateOf20Percent = _data["turnoverAtRateOf20Percent"] ? TurnoverAtRate.fromJS(_data["turnoverAtRateOf20Percent"]) : <any>undefined;
            this.turnoverAtRateOf10Percent = _data["turnoverAtRateOf10Percent"] ? TurnoverAtRate.fromJS(_data["turnoverAtRateOf10Percent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IncreaseOfBaseIeVat {
        data = typeof data === 'object' ? data : {};
        let result = new IncreaseOfBaseIeVat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["turnoverAtRateOf20Percent"] = this.turnoverAtRateOf20Percent ? this.turnoverAtRateOf20Percent.toJSON() : <any>undefined;
        data["turnoverAtRateOf10Percent"] = this.turnoverAtRateOf10Percent ? this.turnoverAtRateOf10Percent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIncreaseOfBaseIeVat {
    turnoverAtRateOf20Percent?: TurnoverAtRate | undefined;
    turnoverAtRateOf10Percent?: TurnoverAtRate | undefined;
}

export class FeePaidBeforeTurnoverIePrepayment implements IFeePaidBeforeTurnoverIePrepayment {
    prepaymentForTurnoverAtRateOf20Percent?: TurnoverAtRate | undefined;
    prepaymentForTurnoverAtRateOf10Percent?: TurnoverAtRate | undefined;

    constructor(data?: IFeePaidBeforeTurnoverIePrepayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prepaymentForTurnoverAtRateOf20Percent = _data["prepaymentForTurnoverAtRateOf20Percent"] ? TurnoverAtRate.fromJS(_data["prepaymentForTurnoverAtRateOf20Percent"]) : <any>undefined;
            this.prepaymentForTurnoverAtRateOf10Percent = _data["prepaymentForTurnoverAtRateOf10Percent"] ? TurnoverAtRate.fromJS(_data["prepaymentForTurnoverAtRateOf10Percent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeePaidBeforeTurnoverIePrepayment {
        data = typeof data === 'object' ? data : {};
        let result = new FeePaidBeforeTurnoverIePrepayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prepaymentForTurnoverAtRateOf20Percent"] = this.prepaymentForTurnoverAtRateOf20Percent ? this.prepaymentForTurnoverAtRateOf20Percent.toJSON() : <any>undefined;
        data["prepaymentForTurnoverAtRateOf10Percent"] = this.prepaymentForTurnoverAtRateOf10Percent ? this.prepaymentForTurnoverAtRateOf10Percent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFeePaidBeforeTurnoverIePrepayment {
    prepaymentForTurnoverAtRateOf20Percent?: TurnoverAtRate | undefined;
    prepaymentForTurnoverAtRateOf10Percent?: TurnoverAtRate | undefined;
}

export class TurnoverAsRecipient implements ITurnoverAsRecipient {
    transferOfTheRightToDispose?: TransferOfTheRightToDispose | undefined;
    turnoverExceptForTransferOfTheRight?: TurnoverExceptForTransferOfTheRight2 | undefined;
    increaseOfBaseIeVat?: IncreaseOfBaseIeVat2 | undefined;
    decreaseOfBaseIeVat?: DecreaseOfBaseIeVat | undefined;
    feePaidBeforeTurnoverIePrepayment?: FeePaidBeforeTurnoverIePrepayment2 | undefined;
    decreaseOfPrepayment?: DecreaseOfPrepayment | undefined;

    constructor(data?: ITurnoverAsRecipient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transferOfTheRightToDispose = _data["transferOfTheRightToDispose"] ? TransferOfTheRightToDispose.fromJS(_data["transferOfTheRightToDispose"]) : <any>undefined;
            this.turnoverExceptForTransferOfTheRight = _data["turnoverExceptForTransferOfTheRight"] ? TurnoverExceptForTransferOfTheRight2.fromJS(_data["turnoverExceptForTransferOfTheRight"]) : <any>undefined;
            this.increaseOfBaseIeVat = _data["increaseOfBaseIeVat"] ? IncreaseOfBaseIeVat2.fromJS(_data["increaseOfBaseIeVat"]) : <any>undefined;
            this.decreaseOfBaseIeVat = _data["decreaseOfBaseIeVat"] ? DecreaseOfBaseIeVat.fromJS(_data["decreaseOfBaseIeVat"]) : <any>undefined;
            this.feePaidBeforeTurnoverIePrepayment = _data["feePaidBeforeTurnoverIePrepayment"] ? FeePaidBeforeTurnoverIePrepayment2.fromJS(_data["feePaidBeforeTurnoverIePrepayment"]) : <any>undefined;
            this.decreaseOfPrepayment = _data["decreaseOfPrepayment"] ? DecreaseOfPrepayment.fromJS(_data["decreaseOfPrepayment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TurnoverAsRecipient {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoverAsRecipient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transferOfTheRightToDispose"] = this.transferOfTheRightToDispose ? this.transferOfTheRightToDispose.toJSON() : <any>undefined;
        data["turnoverExceptForTransferOfTheRight"] = this.turnoverExceptForTransferOfTheRight ? this.turnoverExceptForTransferOfTheRight.toJSON() : <any>undefined;
        data["increaseOfBaseIeVat"] = this.increaseOfBaseIeVat ? this.increaseOfBaseIeVat.toJSON() : <any>undefined;
        data["decreaseOfBaseIeVat"] = this.decreaseOfBaseIeVat ? this.decreaseOfBaseIeVat.toJSON() : <any>undefined;
        data["feePaidBeforeTurnoverIePrepayment"] = this.feePaidBeforeTurnoverIePrepayment ? this.feePaidBeforeTurnoverIePrepayment.toJSON() : <any>undefined;
        data["decreaseOfPrepayment"] = this.decreaseOfPrepayment ? this.decreaseOfPrepayment.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITurnoverAsRecipient {
    transferOfTheRightToDispose?: TransferOfTheRightToDispose | undefined;
    turnoverExceptForTransferOfTheRight?: TurnoverExceptForTransferOfTheRight2 | undefined;
    increaseOfBaseIeVat?: IncreaseOfBaseIeVat2 | undefined;
    decreaseOfBaseIeVat?: DecreaseOfBaseIeVat | undefined;
    feePaidBeforeTurnoverIePrepayment?: FeePaidBeforeTurnoverIePrepayment2 | undefined;
    decreaseOfPrepayment?: DecreaseOfPrepayment | undefined;
}

export class TransferOfTheRightToDispose implements ITransferOfTheRightToDispose {
    turnoverAtRateOf20Percent?: TurnoverAtRate2 | undefined;
    turnoverAtRateOf10Percent?: TurnoverAtRate2 | undefined;

    constructor(data?: ITransferOfTheRightToDispose) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.turnoverAtRateOf20Percent = _data["turnoverAtRateOf20Percent"] ? TurnoverAtRate2.fromJS(_data["turnoverAtRateOf20Percent"]) : <any>undefined;
            this.turnoverAtRateOf10Percent = _data["turnoverAtRateOf10Percent"] ? TurnoverAtRate2.fromJS(_data["turnoverAtRateOf10Percent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TransferOfTheRightToDispose {
        data = typeof data === 'object' ? data : {};
        let result = new TransferOfTheRightToDispose();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["turnoverAtRateOf20Percent"] = this.turnoverAtRateOf20Percent ? this.turnoverAtRateOf20Percent.toJSON() : <any>undefined;
        data["turnoverAtRateOf10Percent"] = this.turnoverAtRateOf10Percent ? this.turnoverAtRateOf10Percent.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITransferOfTheRightToDispose {
    turnoverAtRateOf20Percent?: TurnoverAtRate2 | undefined;
    turnoverAtRateOf10Percent?: TurnoverAtRate2 | undefined;
}

export class TurnoverAtRate2 implements ITurnoverAtRate2 {
    internalInvoiceForeignerBase?: number | undefined;
    internalInvoiceForeignerVat?: number | undefined;
    internalInvoiceVatPayerBase?: number | undefined;
    internalInvoiceVatPayerVat?: number | undefined;

    constructor(data?: ITurnoverAtRate2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalInvoiceForeignerBase = _data["internalInvoiceForeignerBase"];
            this.internalInvoiceForeignerVat = _data["internalInvoiceForeignerVat"];
            this.internalInvoiceVatPayerBase = _data["internalInvoiceVatPayerBase"];
            this.internalInvoiceVatPayerVat = _data["internalInvoiceVatPayerVat"];
        }
    }

    static fromJS(data: any): TurnoverAtRate2 {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoverAtRate2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalInvoiceForeignerBase"] = this.internalInvoiceForeignerBase;
        data["internalInvoiceForeignerVat"] = this.internalInvoiceForeignerVat;
        data["internalInvoiceVatPayerBase"] = this.internalInvoiceVatPayerBase;
        data["internalInvoiceVatPayerVat"] = this.internalInvoiceVatPayerVat;
        return data;
    }
}

export interface ITurnoverAtRate2 {
    internalInvoiceForeignerBase?: number | undefined;
    internalInvoiceForeignerVat?: number | undefined;
    internalInvoiceVatPayerBase?: number | undefined;
    internalInvoiceVatPayerVat?: number | undefined;
}

export class TurnoverExceptForTransferOfTheRight2 implements ITurnoverExceptForTransferOfTheRight2 {
    turnoverAtRateOf20Percent?: TurnoverAtRate2 | undefined;
    turnoverAtRateOf10Percent?: TurnoverAtRate2 | undefined;

    constructor(data?: ITurnoverExceptForTransferOfTheRight2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.turnoverAtRateOf20Percent = _data["turnoverAtRateOf20Percent"] ? TurnoverAtRate2.fromJS(_data["turnoverAtRateOf20Percent"]) : <any>undefined;
            this.turnoverAtRateOf10Percent = _data["turnoverAtRateOf10Percent"] ? TurnoverAtRate2.fromJS(_data["turnoverAtRateOf10Percent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TurnoverExceptForTransferOfTheRight2 {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoverExceptForTransferOfTheRight2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["turnoverAtRateOf20Percent"] = this.turnoverAtRateOf20Percent ? this.turnoverAtRateOf20Percent.toJSON() : <any>undefined;
        data["turnoverAtRateOf10Percent"] = this.turnoverAtRateOf10Percent ? this.turnoverAtRateOf10Percent.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITurnoverExceptForTransferOfTheRight2 {
    turnoverAtRateOf20Percent?: TurnoverAtRate2 | undefined;
    turnoverAtRateOf10Percent?: TurnoverAtRate2 | undefined;
}

export class IncreaseOfBaseIeVat2 implements IIncreaseOfBaseIeVat2 {
    turnoverAtRateOf20Percent?: TurnoverAtRate2 | undefined;
    turnoverAtRateOf10Percent?: TurnoverAtRate2 | undefined;

    constructor(data?: IIncreaseOfBaseIeVat2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.turnoverAtRateOf20Percent = _data["turnoverAtRateOf20Percent"] ? TurnoverAtRate2.fromJS(_data["turnoverAtRateOf20Percent"]) : <any>undefined;
            this.turnoverAtRateOf10Percent = _data["turnoverAtRateOf10Percent"] ? TurnoverAtRate2.fromJS(_data["turnoverAtRateOf10Percent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IncreaseOfBaseIeVat2 {
        data = typeof data === 'object' ? data : {};
        let result = new IncreaseOfBaseIeVat2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["turnoverAtRateOf20Percent"] = this.turnoverAtRateOf20Percent ? this.turnoverAtRateOf20Percent.toJSON() : <any>undefined;
        data["turnoverAtRateOf10Percent"] = this.turnoverAtRateOf10Percent ? this.turnoverAtRateOf10Percent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIncreaseOfBaseIeVat2 {
    turnoverAtRateOf20Percent?: TurnoverAtRate2 | undefined;
    turnoverAtRateOf10Percent?: TurnoverAtRate2 | undefined;
}

export class DecreaseOfBaseIeVat implements IDecreaseOfBaseIeVat {
    turnoverAtRateOf20Percent?: TurnoverAtRate3 | undefined;
    turnoverAtRateOf10Percent?: TurnoverAtRate3 | undefined;

    constructor(data?: IDecreaseOfBaseIeVat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.turnoverAtRateOf20Percent = _data["turnoverAtRateOf20Percent"] ? TurnoverAtRate3.fromJS(_data["turnoverAtRateOf20Percent"]) : <any>undefined;
            this.turnoverAtRateOf10Percent = _data["turnoverAtRateOf10Percent"] ? TurnoverAtRate3.fromJS(_data["turnoverAtRateOf10Percent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DecreaseOfBaseIeVat {
        data = typeof data === 'object' ? data : {};
        let result = new DecreaseOfBaseIeVat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["turnoverAtRateOf20Percent"] = this.turnoverAtRateOf20Percent ? this.turnoverAtRateOf20Percent.toJSON() : <any>undefined;
        data["turnoverAtRateOf10Percent"] = this.turnoverAtRateOf10Percent ? this.turnoverAtRateOf10Percent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDecreaseOfBaseIeVat {
    turnoverAtRateOf20Percent?: TurnoverAtRate3 | undefined;
    turnoverAtRateOf10Percent?: TurnoverAtRate3 | undefined;
}

export class TurnoverAtRate3 implements ITurnoverAtRate3 {
    internalInvoiceForeignerBase?: number | undefined;
    internalInvoiceVatPayerBase?: number | undefined;

    constructor(data?: ITurnoverAtRate3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalInvoiceForeignerBase = _data["internalInvoiceForeignerBase"];
            this.internalInvoiceVatPayerBase = _data["internalInvoiceVatPayerBase"];
        }
    }

    static fromJS(data: any): TurnoverAtRate3 {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoverAtRate3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalInvoiceForeignerBase"] = this.internalInvoiceForeignerBase;
        data["internalInvoiceVatPayerBase"] = this.internalInvoiceVatPayerBase;
        return data;
    }
}

export interface ITurnoverAtRate3 {
    internalInvoiceForeignerBase?: number | undefined;
    internalInvoiceVatPayerBase?: number | undefined;
}

export class FeePaidBeforeTurnoverIePrepayment2 implements IFeePaidBeforeTurnoverIePrepayment2 {
    prepaymentForTurnoverAtRateOf20Percent?: TurnoverAtRate2 | undefined;
    prepaymentForTurnoverAtRateOf10Percent?: TurnoverAtRate2 | undefined;

    constructor(data?: IFeePaidBeforeTurnoverIePrepayment2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prepaymentForTurnoverAtRateOf20Percent = _data["prepaymentForTurnoverAtRateOf20Percent"] ? TurnoverAtRate2.fromJS(_data["prepaymentForTurnoverAtRateOf20Percent"]) : <any>undefined;
            this.prepaymentForTurnoverAtRateOf10Percent = _data["prepaymentForTurnoverAtRateOf10Percent"] ? TurnoverAtRate2.fromJS(_data["prepaymentForTurnoverAtRateOf10Percent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeePaidBeforeTurnoverIePrepayment2 {
        data = typeof data === 'object' ? data : {};
        let result = new FeePaidBeforeTurnoverIePrepayment2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prepaymentForTurnoverAtRateOf20Percent"] = this.prepaymentForTurnoverAtRateOf20Percent ? this.prepaymentForTurnoverAtRateOf20Percent.toJSON() : <any>undefined;
        data["prepaymentForTurnoverAtRateOf10Percent"] = this.prepaymentForTurnoverAtRateOf10Percent ? this.prepaymentForTurnoverAtRateOf10Percent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFeePaidBeforeTurnoverIePrepayment2 {
    prepaymentForTurnoverAtRateOf20Percent?: TurnoverAtRate2 | undefined;
    prepaymentForTurnoverAtRateOf10Percent?: TurnoverAtRate2 | undefined;
}

export class DecreaseOfPrepayment implements IDecreaseOfPrepayment {
    prepaymentForTurnoverAtRateOf20Percent?: TurnoverAtRate3 | undefined;
    prepaymentForTurnoverAtRateOf10Percent?: TurnoverAtRate3 | undefined;

    constructor(data?: IDecreaseOfPrepayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prepaymentForTurnoverAtRateOf20Percent = _data["prepaymentForTurnoverAtRateOf20Percent"] ? TurnoverAtRate3.fromJS(_data["prepaymentForTurnoverAtRateOf20Percent"]) : <any>undefined;
            this.prepaymentForTurnoverAtRateOf10Percent = _data["prepaymentForTurnoverAtRateOf10Percent"] ? TurnoverAtRate3.fromJS(_data["prepaymentForTurnoverAtRateOf10Percent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DecreaseOfPrepayment {
        data = typeof data === 'object' ? data : {};
        let result = new DecreaseOfPrepayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prepaymentForTurnoverAtRateOf20Percent"] = this.prepaymentForTurnoverAtRateOf20Percent ? this.prepaymentForTurnoverAtRateOf20Percent.toJSON() : <any>undefined;
        data["prepaymentForTurnoverAtRateOf10Percent"] = this.prepaymentForTurnoverAtRateOf10Percent ? this.prepaymentForTurnoverAtRateOf10Percent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDecreaseOfPrepayment {
    prepaymentForTurnoverAtRateOf20Percent?: TurnoverAtRate3 | undefined;
    prepaymentForTurnoverAtRateOf10Percent?: TurnoverAtRate3 | undefined;
}

export class VatForImport implements IVatForImport {
    paidVatRate20?: number | undefined;
    paidVatRate10?: number | undefined;

    constructor(data?: IVatForImport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paidVatRate20 = _data["paidVatRate20"];
            this.paidVatRate10 = _data["paidVatRate10"];
        }
    }

    static fromJS(data: any): VatForImport {
        data = typeof data === 'object' ? data : {};
        let result = new VatForImport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paidVatRate20"] = this.paidVatRate20;
        data["paidVatRate10"] = this.paidVatRate10;
        return data;
    }
}

export interface IVatForImport {
    paidVatRate20?: number | undefined;
    paidVatRate10?: number | undefined;
}

export class GetSystemCalculationQuery implements IGetSystemCalculationQuery {
    filterZaAutomatizacijuPPPDV?: FilterZaAutomatizacijuPPPDV | undefined;

    constructor(data?: IGetSystemCalculationQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterZaAutomatizacijuPPPDV = _data["filterZaAutomatizacijuPPPDV"] ? FilterZaAutomatizacijuPPPDV.fromJS(_data["filterZaAutomatizacijuPPPDV"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSystemCalculationQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemCalculationQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterZaAutomatizacijuPPPDV"] = this.filterZaAutomatizacijuPPPDV ? this.filterZaAutomatizacijuPPPDV.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSystemCalculationQuery {
    filterZaAutomatizacijuPPPDV?: FilterZaAutomatizacijuPPPDV | undefined;
}

export class FilterZaAutomatizacijuPPPDV implements IFilterZaAutomatizacijuPPPDV {
    year?: number;
    vatPeriodRange?: string | undefined;
    vatPeriod?: string | undefined;

    constructor(data?: IFilterZaAutomatizacijuPPPDV) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.vatPeriodRange = _data["vatPeriodRange"];
            this.vatPeriod = _data["vatPeriod"];
        }
    }

    static fromJS(data: any): FilterZaAutomatizacijuPPPDV {
        data = typeof data === 'object' ? data : {};
        let result = new FilterZaAutomatizacijuPPPDV();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["vatPeriodRange"] = this.vatPeriodRange;
        data["vatPeriod"] = this.vatPeriod;
        return data;
    }
}

export interface IFilterZaAutomatizacijuPPPDV {
    year?: number;
    vatPeriodRange?: string | undefined;
    vatPeriod?: string | undefined;
}

export class ResultOfSefObavestenjeDto extends Result implements IResultOfSefObavestenjeDto {
    data?: SefObavestenjeDto | undefined;

    constructor(data?: IResultOfSefObavestenjeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? SefObavestenjeDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfSefObavestenjeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfSefObavestenjeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfSefObavestenjeDto extends IResult {
    data?: SefObavestenjeDto | undefined;
}

export class SefObavestenjeDto implements ISefObavestenjeDto {
    noticeNumber?: string | undefined;
    noticeDate?: Date | undefined;
    noticeDateStr?: string | undefined;
    totalVatAmount?: number;
    documentIssueOrigin?: string | undefined;
    basisOfNotice?: string | undefined;
    documentReferenceType?: string | undefined;
    relatedDocumentNumber?: string | undefined;
    relatedDocumentIssueDate?: Date | undefined;
    relatedInvoicePeriodStartDate?: Date | undefined;
    relatedInvoicePeriodEndDate?: Date | undefined;
    relatedDocumentStornoDate?: Date | undefined;
    notes?: string | undefined;
    id?: number;
    recipient?: SefObavestenjePartyDto | undefined;
    sender?: SefObavestenjePartyDto | undefined;
    sendingStatus?: string | undefined;
    sendingStatusInfo?: SefObavestenjeStatusDto | undefined;
    salesInvoiceId?: number | undefined;
    purchaseInvoiceId?: number | undefined;

    constructor(data?: ISefObavestenjeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noticeNumber = _data["noticeNumber"];
            this.noticeDate = _data["noticeDate"] ? new Date(_data["noticeDate"].toString()) : <any>undefined;
            this.noticeDateStr = _data["noticeDateStr"];
            this.totalVatAmount = _data["totalVatAmount"];
            this.documentIssueOrigin = _data["documentIssueOrigin"];
            this.basisOfNotice = _data["basisOfNotice"];
            this.documentReferenceType = _data["documentReferenceType"];
            this.relatedDocumentNumber = _data["relatedDocumentNumber"];
            this.relatedDocumentIssueDate = _data["relatedDocumentIssueDate"] ? new Date(_data["relatedDocumentIssueDate"].toString()) : <any>undefined;
            this.relatedInvoicePeriodStartDate = _data["relatedInvoicePeriodStartDate"] ? new Date(_data["relatedInvoicePeriodStartDate"].toString()) : <any>undefined;
            this.relatedInvoicePeriodEndDate = _data["relatedInvoicePeriodEndDate"] ? new Date(_data["relatedInvoicePeriodEndDate"].toString()) : <any>undefined;
            this.relatedDocumentStornoDate = _data["relatedDocumentStornoDate"] ? new Date(_data["relatedDocumentStornoDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.id = _data["id"];
            this.recipient = _data["recipient"] ? SefObavestenjePartyDto.fromJS(_data["recipient"]) : <any>undefined;
            this.sender = _data["sender"] ? SefObavestenjePartyDto.fromJS(_data["sender"]) : <any>undefined;
            this.sendingStatus = _data["sendingStatus"];
            this.sendingStatusInfo = _data["sendingStatusInfo"] ? SefObavestenjeStatusDto.fromJS(_data["sendingStatusInfo"]) : <any>undefined;
            this.salesInvoiceId = _data["salesInvoiceId"];
            this.purchaseInvoiceId = _data["purchaseInvoiceId"];
        }
    }

    static fromJS(data: any): SefObavestenjeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SefObavestenjeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noticeNumber"] = this.noticeNumber;
        data["noticeDate"] = this.noticeDate ? this.noticeDate.toISOString() : <any>undefined;
        data["noticeDateStr"] = this.noticeDateStr;
        data["totalVatAmount"] = this.totalVatAmount;
        data["documentIssueOrigin"] = this.documentIssueOrigin;
        data["basisOfNotice"] = this.basisOfNotice;
        data["documentReferenceType"] = this.documentReferenceType;
        data["relatedDocumentNumber"] = this.relatedDocumentNumber;
        data["relatedDocumentIssueDate"] = this.relatedDocumentIssueDate ? this.relatedDocumentIssueDate.toISOString() : <any>undefined;
        data["relatedInvoicePeriodStartDate"] = this.relatedInvoicePeriodStartDate ? this.relatedInvoicePeriodStartDate.toISOString() : <any>undefined;
        data["relatedInvoicePeriodEndDate"] = this.relatedInvoicePeriodEndDate ? this.relatedInvoicePeriodEndDate.toISOString() : <any>undefined;
        data["relatedDocumentStornoDate"] = this.relatedDocumentStornoDate ? this.relatedDocumentStornoDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["id"] = this.id;
        data["recipient"] = this.recipient ? this.recipient.toJSON() : <any>undefined;
        data["sender"] = this.sender ? this.sender.toJSON() : <any>undefined;
        data["sendingStatus"] = this.sendingStatus;
        data["sendingStatusInfo"] = this.sendingStatusInfo ? this.sendingStatusInfo.toJSON() : <any>undefined;
        data["salesInvoiceId"] = this.salesInvoiceId;
        data["purchaseInvoiceId"] = this.purchaseInvoiceId;
        return data;
    }
}

export interface ISefObavestenjeDto {
    noticeNumber?: string | undefined;
    noticeDate?: Date | undefined;
    noticeDateStr?: string | undefined;
    totalVatAmount?: number;
    documentIssueOrigin?: string | undefined;
    basisOfNotice?: string | undefined;
    documentReferenceType?: string | undefined;
    relatedDocumentNumber?: string | undefined;
    relatedDocumentIssueDate?: Date | undefined;
    relatedInvoicePeriodStartDate?: Date | undefined;
    relatedInvoicePeriodEndDate?: Date | undefined;
    relatedDocumentStornoDate?: Date | undefined;
    notes?: string | undefined;
    id?: number;
    recipient?: SefObavestenjePartyDto | undefined;
    sender?: SefObavestenjePartyDto | undefined;
    sendingStatus?: string | undefined;
    sendingStatusInfo?: SefObavestenjeStatusDto | undefined;
    salesInvoiceId?: number | undefined;
    purchaseInvoiceId?: number | undefined;
}

export class SefObavestenjePartyDto implements ISefObavestenjePartyDto {
    id?: number;
    vatRegistrationCode?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    registrationCode?: string | undefined;
    isBudget?: boolean;

    constructor(data?: ISefObavestenjePartyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vatRegistrationCode = _data["vatRegistrationCode"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.registrationCode = _data["registrationCode"];
            this.isBudget = _data["isBudget"];
        }
    }

    static fromJS(data: any): SefObavestenjePartyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SefObavestenjePartyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vatRegistrationCode"] = this.vatRegistrationCode;
        data["name"] = this.name;
        data["address"] = this.address;
        data["registrationCode"] = this.registrationCode;
        data["isBudget"] = this.isBudget;
        return data;
    }
}

export interface ISefObavestenjePartyDto {
    id?: number;
    vatRegistrationCode?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    registrationCode?: string | undefined;
    isBudget?: boolean;
}

export class SefObavestenjeStatusDto implements ISefObavestenjeStatusDto {
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;

    constructor(data?: ISefObavestenjeStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusStr = _data["statusStr"];
            this.statusBadgeStr = _data["statusBadgeStr"];
        }
    }

    static fromJS(data: any): SefObavestenjeStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new SefObavestenjeStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusStr"] = this.statusStr;
        data["statusBadgeStr"] = this.statusBadgeStr;
        return data;
    }
}

export interface ISefObavestenjeStatusDto {
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;
}

export class CreateSefObavestenjeCommand implements ICreateSefObavestenjeCommand {
    brojObavestenja?: string | undefined;
    ukupanIznosPdv?: number;
    porekeloDokumenta?: DocumentIssueOrigin;
    osnovObavestenja?: BasisOfNotice;
    tipReferentnogDokumenta?: DocumentReferenceType;
    brojReferentnogDokumenta?: string | undefined;
    datumReferentnogDokumenta?: Date | undefined;
    pocetakPeriodaFakture?: Date | undefined;
    krajPeriodaFakture?: Date | undefined;
    datumStornoReferentnogDokumenta?: Date | undefined;
    napomena?: string | undefined;
    pibPrimaoca?: string | undefined;
    mbPrimaoca?: string | undefined;

    constructor(data?: ICreateSefObavestenjeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brojObavestenja = _data["brojObavestenja"];
            this.ukupanIznosPdv = _data["ukupanIznosPdv"];
            this.porekeloDokumenta = _data["porekeloDokumenta"];
            this.osnovObavestenja = _data["osnovObavestenja"];
            this.tipReferentnogDokumenta = _data["tipReferentnogDokumenta"];
            this.brojReferentnogDokumenta = _data["brojReferentnogDokumenta"];
            this.datumReferentnogDokumenta = _data["datumReferentnogDokumenta"] ? new Date(_data["datumReferentnogDokumenta"].toString()) : <any>undefined;
            this.pocetakPeriodaFakture = _data["pocetakPeriodaFakture"] ? new Date(_data["pocetakPeriodaFakture"].toString()) : <any>undefined;
            this.krajPeriodaFakture = _data["krajPeriodaFakture"] ? new Date(_data["krajPeriodaFakture"].toString()) : <any>undefined;
            this.datumStornoReferentnogDokumenta = _data["datumStornoReferentnogDokumenta"] ? new Date(_data["datumStornoReferentnogDokumenta"].toString()) : <any>undefined;
            this.napomena = _data["napomena"];
            this.pibPrimaoca = _data["pibPrimaoca"];
            this.mbPrimaoca = _data["mbPrimaoca"];
        }
    }

    static fromJS(data: any): CreateSefObavestenjeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSefObavestenjeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brojObavestenja"] = this.brojObavestenja;
        data["ukupanIznosPdv"] = this.ukupanIznosPdv;
        data["porekeloDokumenta"] = this.porekeloDokumenta;
        data["osnovObavestenja"] = this.osnovObavestenja;
        data["tipReferentnogDokumenta"] = this.tipReferentnogDokumenta;
        data["brojReferentnogDokumenta"] = this.brojReferentnogDokumenta;
        data["datumReferentnogDokumenta"] = this.datumReferentnogDokumenta ? this.datumReferentnogDokumenta.toISOString() : <any>undefined;
        data["pocetakPeriodaFakture"] = this.pocetakPeriodaFakture ? this.pocetakPeriodaFakture.toISOString() : <any>undefined;
        data["krajPeriodaFakture"] = this.krajPeriodaFakture ? this.krajPeriodaFakture.toISOString() : <any>undefined;
        data["datumStornoReferentnogDokumenta"] = this.datumStornoReferentnogDokumenta ? this.datumStornoReferentnogDokumenta.toISOString() : <any>undefined;
        data["napomena"] = this.napomena;
        data["pibPrimaoca"] = this.pibPrimaoca;
        data["mbPrimaoca"] = this.mbPrimaoca;
        return data;
    }
}

export interface ICreateSefObavestenjeCommand {
    brojObavestenja?: string | undefined;
    ukupanIznosPdv?: number;
    porekeloDokumenta?: DocumentIssueOrigin;
    osnovObavestenja?: BasisOfNotice;
    tipReferentnogDokumenta?: DocumentReferenceType;
    brojReferentnogDokumenta?: string | undefined;
    datumReferentnogDokumenta?: Date | undefined;
    pocetakPeriodaFakture?: Date | undefined;
    krajPeriodaFakture?: Date | undefined;
    datumStornoReferentnogDokumenta?: Date | undefined;
    napomena?: string | undefined;
    pibPrimaoca?: string | undefined;
    mbPrimaoca?: string | undefined;
}

export enum DocumentIssueOrigin {
    EMPTY = 0,
    DOCUMENT_ISSUED_VIA_SEF = 1,
    DOCUMENT_ISSUED_OUTSIDE_SEF = 2,
}

export enum BasisOfNotice {
    EMPTY = 0,
    CREDIT_NOTE_ISSUED = 1,
    STORNO = 2,
}

export enum DocumentReferenceType {
    EMPTY = 0,
    CREDIT_NOTE_REFERENCE_TO_INVOICE = 1,
    CREDIT_NOTE_REFERENCE_TO_PREPAYMENT_INVOICE = 2,
    CREDIT_NOTE_REFERENCE_TO_PERIOD = 3,
    STORNO_INVOICE = 4,
    STORNO_PREPAYMENT = 5,
    STORNO_DEBIT_NOTE = 6,
}

export class ResultOfListOfSefObavestenjeDto extends Result implements IResultOfListOfSefObavestenjeDto {
    data?: SefObavestenjeDto[] | undefined;

    constructor(data?: IResultOfListOfSefObavestenjeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SefObavestenjeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfSefObavestenjeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfSefObavestenjeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfSefObavestenjeDto extends IResult {
    data?: SefObavestenjeDto[] | undefined;
}

export class ResultOfListOfRacunZaSefObavestenjeDto extends Result implements IResultOfListOfRacunZaSefObavestenjeDto {
    data?: RacunZaSefObavestenjeDto[] | undefined;

    constructor(data?: IResultOfListOfRacunZaSefObavestenjeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RacunZaSefObavestenjeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfRacunZaSefObavestenjeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfRacunZaSefObavestenjeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfRacunZaSefObavestenjeDto extends IResult {
    data?: RacunZaSefObavestenjeDto[] | undefined;
}

export class RacunZaSefObavestenjeDto implements IRacunZaSefObavestenjeDto {
    id?: number;
    broj?: string | undefined;
    intorniBroj?: string | undefined;
    tip?: TipRacuna;
    datumIzdavanja?: Date;
    datumStorniranja?: Date | undefined;
    jeStorno?: boolean;
    jeNeobradjeniSefRacun?: boolean;
    ukupanIznosPdv?: number;
    pib?: string | undefined;
    maticniBroj?: string | undefined;
    nazivStranke?: string | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    jeReferencaNaAvansniRacun?: boolean | undefined;

    constructor(data?: IRacunZaSefObavestenjeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.intorniBroj = _data["intorniBroj"];
            this.tip = _data["tip"];
            this.datumIzdavanja = _data["datumIzdavanja"] ? new Date(_data["datumIzdavanja"].toString()) : <any>undefined;
            this.datumStorniranja = _data["datumStorniranja"] ? new Date(_data["datumStorniranja"].toString()) : <any>undefined;
            this.jeStorno = _data["jeStorno"];
            this.jeNeobradjeniSefRacun = _data["jeNeobradjeniSefRacun"];
            this.ukupanIznosPdv = _data["ukupanIznosPdv"];
            this.pib = _data["pib"];
            this.maticniBroj = _data["maticniBroj"];
            this.nazivStranke = _data["nazivStranke"];
            this.periodOd = _data["periodOd"] ? new Date(_data["periodOd"].toString()) : <any>undefined;
            this.periodDo = _data["periodDo"] ? new Date(_data["periodDo"].toString()) : <any>undefined;
            this.jeReferencaNaAvansniRacun = _data["jeReferencaNaAvansniRacun"];
        }
    }

    static fromJS(data: any): RacunZaSefObavestenjeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RacunZaSefObavestenjeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["intorniBroj"] = this.intorniBroj;
        data["tip"] = this.tip;
        data["datumIzdavanja"] = this.datumIzdavanja ? this.datumIzdavanja.toISOString() : <any>undefined;
        data["datumStorniranja"] = this.datumStorniranja ? this.datumStorniranja.toISOString() : <any>undefined;
        data["jeStorno"] = this.jeStorno;
        data["jeNeobradjeniSefRacun"] = this.jeNeobradjeniSefRacun;
        data["ukupanIznosPdv"] = this.ukupanIznosPdv;
        data["pib"] = this.pib;
        data["maticniBroj"] = this.maticniBroj;
        data["nazivStranke"] = this.nazivStranke;
        data["periodOd"] = this.periodOd ? this.periodOd.toISOString() : <any>undefined;
        data["periodDo"] = this.periodDo ? this.periodDo.toISOString() : <any>undefined;
        data["jeReferencaNaAvansniRacun"] = this.jeReferencaNaAvansniRacun;
        return data;
    }
}

export interface IRacunZaSefObavestenjeDto {
    id?: number;
    broj?: string | undefined;
    intorniBroj?: string | undefined;
    tip?: TipRacuna;
    datumIzdavanja?: Date;
    datumStorniranja?: Date | undefined;
    jeStorno?: boolean;
    jeNeobradjeniSefRacun?: boolean;
    ukupanIznosPdv?: number;
    pib?: string | undefined;
    maticniBroj?: string | undefined;
    nazivStranke?: string | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    jeReferencaNaAvansniRacun?: boolean | undefined;
}

export class ResultOfRacunZaSefObavestenjeDto extends Result implements IResultOfRacunZaSefObavestenjeDto {
    data?: RacunZaSefObavestenjeDto | undefined;

    constructor(data?: IResultOfRacunZaSefObavestenjeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? RacunZaSefObavestenjeDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfRacunZaSefObavestenjeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfRacunZaSefObavestenjeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfRacunZaSefObavestenjeDto extends IResult {
    data?: RacunZaSefObavestenjeDto | undefined;
}

export class GetSefPPPDVTableQuery implements IGetSefPPPDVTableQuery {
    year?: number;
    isReceived?: boolean;

    constructor(data?: IGetSefPPPDVTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.isReceived = _data["isReceived"];
        }
    }

    static fromJS(data: any): GetSefPPPDVTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSefPPPDVTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["isReceived"] = this.isReceived;
        return data;
    }
}

export interface IGetSefPPPDVTableQuery {
    year?: number;
    isReceived?: boolean;
}

export class ResultOfCreateUpdatePdvEvidencijaZbirnaResponse extends Result implements IResultOfCreateUpdatePdvEvidencijaZbirnaResponse {
    data?: CreateUpdatePdvEvidencijaZbirnaResponse | undefined;

    constructor(data?: IResultOfCreateUpdatePdvEvidencijaZbirnaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? CreateUpdatePdvEvidencijaZbirnaResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfCreateUpdatePdvEvidencijaZbirnaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfCreateUpdatePdvEvidencijaZbirnaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfCreateUpdatePdvEvidencijaZbirnaResponse extends IResult {
    data?: CreateUpdatePdvEvidencijaZbirnaResponse | undefined;
}

export class CreateUpdatePdvEvidencijaZbirnaResponse implements ICreateUpdatePdvEvidencijaZbirnaResponse {
    id?: number;
    broj?: string | undefined;

    constructor(data?: ICreateUpdatePdvEvidencijaZbirnaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
        }
    }

    static fromJS(data: any): CreateUpdatePdvEvidencijaZbirnaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdatePdvEvidencijaZbirnaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        return data;
    }
}

export interface ICreateUpdatePdvEvidencijaZbirnaResponse {
    id?: number;
    broj?: string | undefined;
}

export class PdvEvidencijaZbirnaDto implements IPdvEvidencijaZbirnaDto {
    sefId?: number | undefined;
    id?: number | undefined;
    broj?: string | undefined;
    datumPromeneStatusa?: Date | undefined;
    godina?: number;
    prometSNaknadomOpis20?: string | undefined;
    prometSNaknadomOsnovica20?: number;
    prometSNaknadomPdv20?: number;
    prometSNaknadomUkupanIznos20?: number;
    prometSNaknadomOpis10?: string | undefined;
    prometSNaknadomOsnovica10?: number;
    prometSNaknadomPdv10?: number;
    prometSNaknadomUkupanIznos10?: number;
    prometAvansOpis20?: string | undefined;
    prometAvansOsnovica20?: number;
    prometAvansPdv20?: number;
    prometAvansUkupanIznos20?: number;
    prometAvansOpis10?: string | undefined;
    prometAvansOsnovica10?: number;
    prometAvansPdv10?: number;
    prometAvansUkupanIznos10?: number;
    prometBezNaknadeOpis20?: string | undefined;
    prometBezNaknadeOsnovica20?: number;
    prometBezNaknadePdv20?: number;
    prometBezNaknadeUkupanIznos20?: number;
    prometBezNaknadeOpis10?: string | undefined;
    prometBezNaknadeOsnovica10?: number;
    prometBezNaknadePdv10?: number;
    prometBezNaknadeUkupanIznos10?: number;
    period?: PdvPeriod;
    status?: PdvEvidencijaStatus;
    smanjenjePdv?: number;
    uvecanjePdv?: number;

    constructor(data?: IPdvEvidencijaZbirnaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sefId = _data["sefId"];
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.datumPromeneStatusa = _data["datumPromeneStatusa"] ? new Date(_data["datumPromeneStatusa"].toString()) : <any>undefined;
            this.godina = _data["godina"];
            this.prometSNaknadomOpis20 = _data["prometSNaknadomOpis20"];
            this.prometSNaknadomOsnovica20 = _data["prometSNaknadomOsnovica20"];
            this.prometSNaknadomPdv20 = _data["prometSNaknadomPdv20"];
            this.prometSNaknadomUkupanIznos20 = _data["prometSNaknadomUkupanIznos20"];
            this.prometSNaknadomOpis10 = _data["prometSNaknadomOpis10"];
            this.prometSNaknadomOsnovica10 = _data["prometSNaknadomOsnovica10"];
            this.prometSNaknadomPdv10 = _data["prometSNaknadomPdv10"];
            this.prometSNaknadomUkupanIznos10 = _data["prometSNaknadomUkupanIznos10"];
            this.prometAvansOpis20 = _data["prometAvansOpis20"];
            this.prometAvansOsnovica20 = _data["prometAvansOsnovica20"];
            this.prometAvansPdv20 = _data["prometAvansPdv20"];
            this.prometAvansUkupanIznos20 = _data["prometAvansUkupanIznos20"];
            this.prometAvansOpis10 = _data["prometAvansOpis10"];
            this.prometAvansOsnovica10 = _data["prometAvansOsnovica10"];
            this.prometAvansPdv10 = _data["prometAvansPdv10"];
            this.prometAvansUkupanIznos10 = _data["prometAvansUkupanIznos10"];
            this.prometBezNaknadeOpis20 = _data["prometBezNaknadeOpis20"];
            this.prometBezNaknadeOsnovica20 = _data["prometBezNaknadeOsnovica20"];
            this.prometBezNaknadePdv20 = _data["prometBezNaknadePdv20"];
            this.prometBezNaknadeUkupanIznos20 = _data["prometBezNaknadeUkupanIznos20"];
            this.prometBezNaknadeOpis10 = _data["prometBezNaknadeOpis10"];
            this.prometBezNaknadeOsnovica10 = _data["prometBezNaknadeOsnovica10"];
            this.prometBezNaknadePdv10 = _data["prometBezNaknadePdv10"];
            this.prometBezNaknadeUkupanIznos10 = _data["prometBezNaknadeUkupanIznos10"];
            this.period = _data["period"];
            this.status = _data["status"];
            this.smanjenjePdv = _data["smanjenjePdv"];
            this.uvecanjePdv = _data["uvecanjePdv"];
        }
    }

    static fromJS(data: any): PdvEvidencijaZbirnaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdvEvidencijaZbirnaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sefId"] = this.sefId;
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["datumPromeneStatusa"] = this.datumPromeneStatusa ? this.datumPromeneStatusa.toISOString() : <any>undefined;
        data["godina"] = this.godina;
        data["prometSNaknadomOpis20"] = this.prometSNaknadomOpis20;
        data["prometSNaknadomOsnovica20"] = this.prometSNaknadomOsnovica20;
        data["prometSNaknadomPdv20"] = this.prometSNaknadomPdv20;
        data["prometSNaknadomUkupanIznos20"] = this.prometSNaknadomUkupanIznos20;
        data["prometSNaknadomOpis10"] = this.prometSNaknadomOpis10;
        data["prometSNaknadomOsnovica10"] = this.prometSNaknadomOsnovica10;
        data["prometSNaknadomPdv10"] = this.prometSNaknadomPdv10;
        data["prometSNaknadomUkupanIznos10"] = this.prometSNaknadomUkupanIznos10;
        data["prometAvansOpis20"] = this.prometAvansOpis20;
        data["prometAvansOsnovica20"] = this.prometAvansOsnovica20;
        data["prometAvansPdv20"] = this.prometAvansPdv20;
        data["prometAvansUkupanIznos20"] = this.prometAvansUkupanIznos20;
        data["prometAvansOpis10"] = this.prometAvansOpis10;
        data["prometAvansOsnovica10"] = this.prometAvansOsnovica10;
        data["prometAvansPdv10"] = this.prometAvansPdv10;
        data["prometAvansUkupanIznos10"] = this.prometAvansUkupanIznos10;
        data["prometBezNaknadeOpis20"] = this.prometBezNaknadeOpis20;
        data["prometBezNaknadeOsnovica20"] = this.prometBezNaknadeOsnovica20;
        data["prometBezNaknadePdv20"] = this.prometBezNaknadePdv20;
        data["prometBezNaknadeUkupanIznos20"] = this.prometBezNaknadeUkupanIznos20;
        data["prometBezNaknadeOpis10"] = this.prometBezNaknadeOpis10;
        data["prometBezNaknadeOsnovica10"] = this.prometBezNaknadeOsnovica10;
        data["prometBezNaknadePdv10"] = this.prometBezNaknadePdv10;
        data["prometBezNaknadeUkupanIznos10"] = this.prometBezNaknadeUkupanIznos10;
        data["period"] = this.period;
        data["status"] = this.status;
        data["smanjenjePdv"] = this.smanjenjePdv;
        data["uvecanjePdv"] = this.uvecanjePdv;
        return data;
    }
}

export interface IPdvEvidencijaZbirnaDto {
    sefId?: number | undefined;
    id?: number | undefined;
    broj?: string | undefined;
    datumPromeneStatusa?: Date | undefined;
    godina?: number;
    prometSNaknadomOpis20?: string | undefined;
    prometSNaknadomOsnovica20?: number;
    prometSNaknadomPdv20?: number;
    prometSNaknadomUkupanIznos20?: number;
    prometSNaknadomOpis10?: string | undefined;
    prometSNaknadomOsnovica10?: number;
    prometSNaknadomPdv10?: number;
    prometSNaknadomUkupanIznos10?: number;
    prometAvansOpis20?: string | undefined;
    prometAvansOsnovica20?: number;
    prometAvansPdv20?: number;
    prometAvansUkupanIznos20?: number;
    prometAvansOpis10?: string | undefined;
    prometAvansOsnovica10?: number;
    prometAvansPdv10?: number;
    prometAvansUkupanIznos10?: number;
    prometBezNaknadeOpis20?: string | undefined;
    prometBezNaknadeOsnovica20?: number;
    prometBezNaknadePdv20?: number;
    prometBezNaknadeUkupanIznos20?: number;
    prometBezNaknadeOpis10?: string | undefined;
    prometBezNaknadeOsnovica10?: number;
    prometBezNaknadePdv10?: number;
    prometBezNaknadeUkupanIznos10?: number;
    period?: PdvPeriod;
    status?: PdvEvidencijaStatus;
    smanjenjePdv?: number;
    uvecanjePdv?: number;
}

export class CreatePdvEvidencijaZbirnaCommand extends PdvEvidencijaZbirnaDto implements ICreatePdvEvidencijaZbirnaCommand {

    constructor(data?: ICreatePdvEvidencijaZbirnaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreatePdvEvidencijaZbirnaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePdvEvidencijaZbirnaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreatePdvEvidencijaZbirnaCommand extends IPdvEvidencijaZbirnaDto {
}

export class PdvEvidencijaZbirna39Dto implements IPdvEvidencijaZbirna39Dto {
    sefId?: number | undefined;
    id?: number | undefined;
    broj?: string | undefined;
    datumPromeneStatusa?: Date | undefined;
    status?: PdvEvidencijaStatus;
    godina?: number;
    period?: PdvPeriod;
    avansIznosUplate20?: number;
    avansOsnovica20?: number;
    avansObracunatiPdv20?: number;
    avansIznosUplate10?: number;
    avansOsnovica10?: number;
    avansObracunatiPdv10?: number;
    prometSaNaknadomOsnovica20?: number;
    prometSaNaknadomObracunatiPdv20?: number;
    prometSaNaknadomOsnovica10?: number;
    prometSaNaknadomObracunatiPdv10?: number;
    prometBezNaknadeOsnovica20?: number;
    prometBezNaknadeObracunatiPdv20?: number;
    prometBezNaknadeOsnovica10?: number;
    prometBezNaknadeObracunatiPdv10?: number;
    osnovica20Tur?: number;
    obracunatiPdv20Tur?: number;
    avansOsnovica20Tur?: number;
    avansObracunatiPdv20Tur?: number;
    osnovica20Art?: number;
    obracunatiPdv20Art?: number;
    avansOsnovica20Art?: number;
    avansObracunatiPdv20Art?: number;
    osnovica10Art?: number;
    obracunatiPdv10Art?: number;
    avansOsnovica10Art?: number;
    avansObracunatiPdv10Art?: number;
    povecanjeSmanjenjeIsporucilac?: PoreskiDuznikIsporucilacPrimalacDto | undefined;
    povecanjeSmanjenjePrimalac?: PoreskiDuznikIsporucilacPrimalacDto | undefined;
    storniranjeIsporucilac?: PoreskiDuznikIsporucilacPrimalacDto | undefined;
    storniranjePrimalac?: PoreskiDuznikIsporucilacPrimalacDto | undefined;

    constructor(data?: IPdvEvidencijaZbirna39Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sefId = _data["sefId"];
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.datumPromeneStatusa = _data["datumPromeneStatusa"] ? new Date(_data["datumPromeneStatusa"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.godina = _data["godina"];
            this.period = _data["period"];
            this.avansIznosUplate20 = _data["avansIznosUplate20"];
            this.avansOsnovica20 = _data["avansOsnovica20"];
            this.avansObracunatiPdv20 = _data["avansObracunatiPdv20"];
            this.avansIznosUplate10 = _data["avansIznosUplate10"];
            this.avansOsnovica10 = _data["avansOsnovica10"];
            this.avansObracunatiPdv10 = _data["avansObracunatiPdv10"];
            this.prometSaNaknadomOsnovica20 = _data["prometSaNaknadomOsnovica20"];
            this.prometSaNaknadomObracunatiPdv20 = _data["prometSaNaknadomObracunatiPdv20"];
            this.prometSaNaknadomOsnovica10 = _data["prometSaNaknadomOsnovica10"];
            this.prometSaNaknadomObracunatiPdv10 = _data["prometSaNaknadomObracunatiPdv10"];
            this.prometBezNaknadeOsnovica20 = _data["prometBezNaknadeOsnovica20"];
            this.prometBezNaknadeObracunatiPdv20 = _data["prometBezNaknadeObracunatiPdv20"];
            this.prometBezNaknadeOsnovica10 = _data["prometBezNaknadeOsnovica10"];
            this.prometBezNaknadeObracunatiPdv10 = _data["prometBezNaknadeObracunatiPdv10"];
            this.osnovica20Tur = _data["osnovica20Tur"];
            this.obracunatiPdv20Tur = _data["obracunatiPdv20Tur"];
            this.avansOsnovica20Tur = _data["avansOsnovica20Tur"];
            this.avansObracunatiPdv20Tur = _data["avansObracunatiPdv20Tur"];
            this.osnovica20Art = _data["osnovica20Art"];
            this.obracunatiPdv20Art = _data["obracunatiPdv20Art"];
            this.avansOsnovica20Art = _data["avansOsnovica20Art"];
            this.avansObracunatiPdv20Art = _data["avansObracunatiPdv20Art"];
            this.osnovica10Art = _data["osnovica10Art"];
            this.obracunatiPdv10Art = _data["obracunatiPdv10Art"];
            this.avansOsnovica10Art = _data["avansOsnovica10Art"];
            this.avansObracunatiPdv10Art = _data["avansObracunatiPdv10Art"];
            this.povecanjeSmanjenjeIsporucilac = _data["povecanjeSmanjenjeIsporucilac"] ? PoreskiDuznikIsporucilacPrimalacDto.fromJS(_data["povecanjeSmanjenjeIsporucilac"]) : <any>undefined;
            this.povecanjeSmanjenjePrimalac = _data["povecanjeSmanjenjePrimalac"] ? PoreskiDuznikIsporucilacPrimalacDto.fromJS(_data["povecanjeSmanjenjePrimalac"]) : <any>undefined;
            this.storniranjeIsporucilac = _data["storniranjeIsporucilac"] ? PoreskiDuznikIsporucilacPrimalacDto.fromJS(_data["storniranjeIsporucilac"]) : <any>undefined;
            this.storniranjePrimalac = _data["storniranjePrimalac"] ? PoreskiDuznikIsporucilacPrimalacDto.fromJS(_data["storniranjePrimalac"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PdvEvidencijaZbirna39Dto {
        data = typeof data === 'object' ? data : {};
        let result = new PdvEvidencijaZbirna39Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sefId"] = this.sefId;
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["datumPromeneStatusa"] = this.datumPromeneStatusa ? this.datumPromeneStatusa.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["godina"] = this.godina;
        data["period"] = this.period;
        data["avansIznosUplate20"] = this.avansIznosUplate20;
        data["avansOsnovica20"] = this.avansOsnovica20;
        data["avansObracunatiPdv20"] = this.avansObracunatiPdv20;
        data["avansIznosUplate10"] = this.avansIznosUplate10;
        data["avansOsnovica10"] = this.avansOsnovica10;
        data["avansObracunatiPdv10"] = this.avansObracunatiPdv10;
        data["prometSaNaknadomOsnovica20"] = this.prometSaNaknadomOsnovica20;
        data["prometSaNaknadomObracunatiPdv20"] = this.prometSaNaknadomObracunatiPdv20;
        data["prometSaNaknadomOsnovica10"] = this.prometSaNaknadomOsnovica10;
        data["prometSaNaknadomObracunatiPdv10"] = this.prometSaNaknadomObracunatiPdv10;
        data["prometBezNaknadeOsnovica20"] = this.prometBezNaknadeOsnovica20;
        data["prometBezNaknadeObracunatiPdv20"] = this.prometBezNaknadeObracunatiPdv20;
        data["prometBezNaknadeOsnovica10"] = this.prometBezNaknadeOsnovica10;
        data["prometBezNaknadeObracunatiPdv10"] = this.prometBezNaknadeObracunatiPdv10;
        data["osnovica20Tur"] = this.osnovica20Tur;
        data["obracunatiPdv20Tur"] = this.obracunatiPdv20Tur;
        data["avansOsnovica20Tur"] = this.avansOsnovica20Tur;
        data["avansObracunatiPdv20Tur"] = this.avansObracunatiPdv20Tur;
        data["osnovica20Art"] = this.osnovica20Art;
        data["obracunatiPdv20Art"] = this.obracunatiPdv20Art;
        data["avansOsnovica20Art"] = this.avansOsnovica20Art;
        data["avansObracunatiPdv20Art"] = this.avansObracunatiPdv20Art;
        data["osnovica10Art"] = this.osnovica10Art;
        data["obracunatiPdv10Art"] = this.obracunatiPdv10Art;
        data["avansOsnovica10Art"] = this.avansOsnovica10Art;
        data["avansObracunatiPdv10Art"] = this.avansObracunatiPdv10Art;
        data["povecanjeSmanjenjeIsporucilac"] = this.povecanjeSmanjenjeIsporucilac ? this.povecanjeSmanjenjeIsporucilac.toJSON() : <any>undefined;
        data["povecanjeSmanjenjePrimalac"] = this.povecanjeSmanjenjePrimalac ? this.povecanjeSmanjenjePrimalac.toJSON() : <any>undefined;
        data["storniranjeIsporucilac"] = this.storniranjeIsporucilac ? this.storniranjeIsporucilac.toJSON() : <any>undefined;
        data["storniranjePrimalac"] = this.storniranjePrimalac ? this.storniranjePrimalac.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPdvEvidencijaZbirna39Dto {
    sefId?: number | undefined;
    id?: number | undefined;
    broj?: string | undefined;
    datumPromeneStatusa?: Date | undefined;
    status?: PdvEvidencijaStatus;
    godina?: number;
    period?: PdvPeriod;
    avansIznosUplate20?: number;
    avansOsnovica20?: number;
    avansObracunatiPdv20?: number;
    avansIznosUplate10?: number;
    avansOsnovica10?: number;
    avansObracunatiPdv10?: number;
    prometSaNaknadomOsnovica20?: number;
    prometSaNaknadomObracunatiPdv20?: number;
    prometSaNaknadomOsnovica10?: number;
    prometSaNaknadomObracunatiPdv10?: number;
    prometBezNaknadeOsnovica20?: number;
    prometBezNaknadeObracunatiPdv20?: number;
    prometBezNaknadeOsnovica10?: number;
    prometBezNaknadeObracunatiPdv10?: number;
    osnovica20Tur?: number;
    obracunatiPdv20Tur?: number;
    avansOsnovica20Tur?: number;
    avansObracunatiPdv20Tur?: number;
    osnovica20Art?: number;
    obracunatiPdv20Art?: number;
    avansOsnovica20Art?: number;
    avansObracunatiPdv20Art?: number;
    osnovica10Art?: number;
    obracunatiPdv10Art?: number;
    avansOsnovica10Art?: number;
    avansObracunatiPdv10Art?: number;
    povecanjeSmanjenjeIsporucilac?: PoreskiDuznikIsporucilacPrimalacDto | undefined;
    povecanjeSmanjenjePrimalac?: PoreskiDuznikIsporucilacPrimalacDto | undefined;
    storniranjeIsporucilac?: PoreskiDuznikIsporucilacPrimalacDto | undefined;
    storniranjePrimalac?: PoreskiDuznikIsporucilacPrimalacDto | undefined;
}

export class CreatePdvEvidencijaZbirna39Command extends PdvEvidencijaZbirna39Dto implements ICreatePdvEvidencijaZbirna39Command {

    constructor(data?: ICreatePdvEvidencijaZbirna39Command) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreatePdvEvidencijaZbirna39Command {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePdvEvidencijaZbirna39Command();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreatePdvEvidencijaZbirna39Command extends IPdvEvidencijaZbirna39Dto {
}

export class PoreskiDuznikIsporucilacPrimalacDto implements IPoreskiDuznikIsporucilacPrimalacDto {
    id?: number | undefined;
    povecanjeOsnovica20?: number;
    povecanjePdv20?: number;
    povecanjeAvansOsnovica20?: number;
    povecanjeAvansPdv20?: number;
    povecanjeOsnovica10?: number;
    povecanjePdv10?: number;
    povecanjeAvansOsnovica10?: number;
    povecanjeAvansPdv10?: number;
    smanjenjeOsnovica20?: number;
    smanjenjePdv20?: number;
    smanjenjeAvansOsnovica20?: number;
    smanjenjeAvansPdv20?: number;
    smanjenjeOsnovica10?: number;
    smanjenjePdv10?: number;
    smanjenjeAvansOsnovica10?: number;
    smanjenjeAvansPdv10?: number;

    constructor(data?: IPoreskiDuznikIsporucilacPrimalacDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.povecanjeOsnovica20 = _data["povecanjeOsnovica20"];
            this.povecanjePdv20 = _data["povecanjePdv20"];
            this.povecanjeAvansOsnovica20 = _data["povecanjeAvansOsnovica20"];
            this.povecanjeAvansPdv20 = _data["povecanjeAvansPdv20"];
            this.povecanjeOsnovica10 = _data["povecanjeOsnovica10"];
            this.povecanjePdv10 = _data["povecanjePdv10"];
            this.povecanjeAvansOsnovica10 = _data["povecanjeAvansOsnovica10"];
            this.povecanjeAvansPdv10 = _data["povecanjeAvansPdv10"];
            this.smanjenjeOsnovica20 = _data["smanjenjeOsnovica20"];
            this.smanjenjePdv20 = _data["smanjenjePdv20"];
            this.smanjenjeAvansOsnovica20 = _data["smanjenjeAvansOsnovica20"];
            this.smanjenjeAvansPdv20 = _data["smanjenjeAvansPdv20"];
            this.smanjenjeOsnovica10 = _data["smanjenjeOsnovica10"];
            this.smanjenjePdv10 = _data["smanjenjePdv10"];
            this.smanjenjeAvansOsnovica10 = _data["smanjenjeAvansOsnovica10"];
            this.smanjenjeAvansPdv10 = _data["smanjenjeAvansPdv10"];
        }
    }

    static fromJS(data: any): PoreskiDuznikIsporucilacPrimalacDto {
        data = typeof data === 'object' ? data : {};
        let result = new PoreskiDuznikIsporucilacPrimalacDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["povecanjeOsnovica20"] = this.povecanjeOsnovica20;
        data["povecanjePdv20"] = this.povecanjePdv20;
        data["povecanjeAvansOsnovica20"] = this.povecanjeAvansOsnovica20;
        data["povecanjeAvansPdv20"] = this.povecanjeAvansPdv20;
        data["povecanjeOsnovica10"] = this.povecanjeOsnovica10;
        data["povecanjePdv10"] = this.povecanjePdv10;
        data["povecanjeAvansOsnovica10"] = this.povecanjeAvansOsnovica10;
        data["povecanjeAvansPdv10"] = this.povecanjeAvansPdv10;
        data["smanjenjeOsnovica20"] = this.smanjenjeOsnovica20;
        data["smanjenjePdv20"] = this.smanjenjePdv20;
        data["smanjenjeAvansOsnovica20"] = this.smanjenjeAvansOsnovica20;
        data["smanjenjeAvansPdv20"] = this.smanjenjeAvansPdv20;
        data["smanjenjeOsnovica10"] = this.smanjenjeOsnovica10;
        data["smanjenjePdv10"] = this.smanjenjePdv10;
        data["smanjenjeAvansOsnovica10"] = this.smanjenjeAvansOsnovica10;
        data["smanjenjeAvansPdv10"] = this.smanjenjeAvansPdv10;
        return data;
    }
}

export interface IPoreskiDuznikIsporucilacPrimalacDto {
    id?: number | undefined;
    povecanjeOsnovica20?: number;
    povecanjePdv20?: number;
    povecanjeAvansOsnovica20?: number;
    povecanjeAvansPdv20?: number;
    povecanjeOsnovica10?: number;
    povecanjePdv10?: number;
    povecanjeAvansOsnovica10?: number;
    povecanjeAvansPdv10?: number;
    smanjenjeOsnovica20?: number;
    smanjenjePdv20?: number;
    smanjenjeAvansOsnovica20?: number;
    smanjenjeAvansPdv20?: number;
    smanjenjeOsnovica10?: number;
    smanjenjePdv10?: number;
    smanjenjeAvansOsnovica10?: number;
    smanjenjeAvansPdv10?: number;
}

export class UpdatePdvEvidencijaZbirnaCommand extends PdvEvidencijaZbirnaDto implements IUpdatePdvEvidencijaZbirnaCommand {

    constructor(data?: IUpdatePdvEvidencijaZbirnaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdatePdvEvidencijaZbirnaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePdvEvidencijaZbirnaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePdvEvidencijaZbirnaCommand extends IPdvEvidencijaZbirnaDto {
}

export class UpdatePdvEvidencijaZbirna39Command extends PdvEvidencijaZbirna39Dto implements IUpdatePdvEvidencijaZbirna39Command {

    constructor(data?: IUpdatePdvEvidencijaZbirna39Command) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdatePdvEvidencijaZbirna39Command {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePdvEvidencijaZbirna39Command();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePdvEvidencijaZbirna39Command extends IPdvEvidencijaZbirna39Dto {
}

export class PaginatedResultOfPdvEvidencijaZbirnaTableDto extends Result implements IPaginatedResultOfPdvEvidencijaZbirnaTableDto {
    data?: PdvEvidencijaZbirnaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfPdvEvidencijaZbirnaTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PdvEvidencijaZbirnaTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfPdvEvidencijaZbirnaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfPdvEvidencijaZbirnaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfPdvEvidencijaZbirnaTableDto extends IResult {
    data?: PdvEvidencijaZbirnaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PdvEvidencijaZbirnaTableDto implements IPdvEvidencijaZbirnaTableDto {
    id?: number;
    broj?: string | undefined;
    periodDto?: PdvPeriodDto | undefined;
    statusDto?: PdvEvidencijaStatusDto | undefined;
    pdv?: number;

    constructor(data?: IPdvEvidencijaZbirnaTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.periodDto = _data["periodDto"] ? PdvPeriodDto.fromJS(_data["periodDto"]) : <any>undefined;
            this.statusDto = _data["statusDto"] ? PdvEvidencijaStatusDto.fromJS(_data["statusDto"]) : <any>undefined;
            this.pdv = _data["pdv"];
        }
    }

    static fromJS(data: any): PdvEvidencijaZbirnaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdvEvidencijaZbirnaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["periodDto"] = this.periodDto ? this.periodDto.toJSON() : <any>undefined;
        data["statusDto"] = this.statusDto ? this.statusDto.toJSON() : <any>undefined;
        data["pdv"] = this.pdv;
        return data;
    }
}

export interface IPdvEvidencijaZbirnaTableDto {
    id?: number;
    broj?: string | undefined;
    periodDto?: PdvPeriodDto | undefined;
    statusDto?: PdvEvidencijaStatusDto | undefined;
    pdv?: number;
}

export class GetPdvEvidencijaZbirnaTableQuery implements IGetPdvEvidencijaZbirnaTableQuery {
    brojObracuna?: string | undefined;
    originalniBroj?: string | undefined;
    tipoviDokumenta?: PdvEvidencijaTipDokumenta[] | undefined;
    statusi?: PdvEvidencijaStatus[] | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    mesec?: number | undefined;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetPdvEvidencijaZbirnaTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brojObracuna = _data["brojObracuna"];
            this.originalniBroj = _data["originalniBroj"];
            if (Array.isArray(_data["tipoviDokumenta"])) {
                this.tipoviDokumenta = [] as any;
                for (let item of _data["tipoviDokumenta"])
                    this.tipoviDokumenta!.push(item);
            }
            if (Array.isArray(_data["statusi"])) {
                this.statusi = [] as any;
                for (let item of _data["statusi"])
                    this.statusi!.push(item);
            }
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.mesec = _data["mesec"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetPdvEvidencijaZbirnaTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPdvEvidencijaZbirnaTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brojObracuna"] = this.brojObracuna;
        data["originalniBroj"] = this.originalniBroj;
        if (Array.isArray(this.tipoviDokumenta)) {
            data["tipoviDokumenta"] = [];
            for (let item of this.tipoviDokumenta)
                data["tipoviDokumenta"].push(item);
        }
        if (Array.isArray(this.statusi)) {
            data["statusi"] = [];
            for (let item of this.statusi)
                data["statusi"].push(item);
        }
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["mesec"] = this.mesec;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetPdvEvidencijaZbirnaTableQuery {
    brojObracuna?: string | undefined;
    originalniBroj?: string | undefined;
    tipoviDokumenta?: PdvEvidencijaTipDokumenta[] | undefined;
    statusi?: PdvEvidencijaStatus[] | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    mesec?: number | undefined;
    pageNumber?: number;
    pageSize?: number;
}

export class PaginatedResultOfPdvEvidencijaZbirna39TableDto extends Result implements IPaginatedResultOfPdvEvidencijaZbirna39TableDto {
    data?: PdvEvidencijaZbirna39TableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfPdvEvidencijaZbirna39TableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PdvEvidencijaZbirna39TableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfPdvEvidencijaZbirna39TableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfPdvEvidencijaZbirna39TableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfPdvEvidencijaZbirna39TableDto extends IResult {
    data?: PdvEvidencijaZbirna39TableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PdvEvidencijaZbirna39TableDto implements IPdvEvidencijaZbirna39TableDto {
    id?: number;
    broj?: string | undefined;
    godina?: number;
    periodDto?: PdvPeriodDto | undefined;
    statusDto?: PdvEvidencijaStatusDto | undefined;
    datumPromeneStatusa?: string | undefined;

    constructor(data?: IPdvEvidencijaZbirna39TableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.godina = _data["godina"];
            this.periodDto = _data["periodDto"] ? PdvPeriodDto.fromJS(_data["periodDto"]) : <any>undefined;
            this.statusDto = _data["statusDto"] ? PdvEvidencijaStatusDto.fromJS(_data["statusDto"]) : <any>undefined;
            this.datumPromeneStatusa = _data["datumPromeneStatusa"];
        }
    }

    static fromJS(data: any): PdvEvidencijaZbirna39TableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdvEvidencijaZbirna39TableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["godina"] = this.godina;
        data["periodDto"] = this.periodDto ? this.periodDto.toJSON() : <any>undefined;
        data["statusDto"] = this.statusDto ? this.statusDto.toJSON() : <any>undefined;
        data["datumPromeneStatusa"] = this.datumPromeneStatusa;
        return data;
    }
}

export interface IPdvEvidencijaZbirna39TableDto {
    id?: number;
    broj?: string | undefined;
    godina?: number;
    periodDto?: PdvPeriodDto | undefined;
    statusDto?: PdvEvidencijaStatusDto | undefined;
    datumPromeneStatusa?: string | undefined;
}

export class GetPdvEvidencijaZbirna39TableQuery implements IGetPdvEvidencijaZbirna39TableQuery {
    brojObracuna?: string | undefined;
    originalniBroj?: string | undefined;
    tipoviDokumenta?: PdvEvidencijaTipDokumenta[] | undefined;
    statusi?: PdvEvidencijaStatus[] | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    mesec?: number | undefined;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetPdvEvidencijaZbirna39TableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brojObracuna = _data["brojObracuna"];
            this.originalniBroj = _data["originalniBroj"];
            if (Array.isArray(_data["tipoviDokumenta"])) {
                this.tipoviDokumenta = [] as any;
                for (let item of _data["tipoviDokumenta"])
                    this.tipoviDokumenta!.push(item);
            }
            if (Array.isArray(_data["statusi"])) {
                this.statusi = [] as any;
                for (let item of _data["statusi"])
                    this.statusi!.push(item);
            }
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.mesec = _data["mesec"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetPdvEvidencijaZbirna39TableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPdvEvidencijaZbirna39TableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brojObracuna"] = this.brojObracuna;
        data["originalniBroj"] = this.originalniBroj;
        if (Array.isArray(this.tipoviDokumenta)) {
            data["tipoviDokumenta"] = [];
            for (let item of this.tipoviDokumenta)
                data["tipoviDokumenta"].push(item);
        }
        if (Array.isArray(this.statusi)) {
            data["statusi"] = [];
            for (let item of this.statusi)
                data["statusi"].push(item);
        }
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["mesec"] = this.mesec;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetPdvEvidencijaZbirna39TableQuery {
    brojObracuna?: string | undefined;
    originalniBroj?: string | undefined;
    tipoviDokumenta?: PdvEvidencijaTipDokumenta[] | undefined;
    statusi?: PdvEvidencijaStatus[] | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    mesec?: number | undefined;
    pageNumber?: number;
    pageSize?: number;
}

export class ResultOfPdvEvidencijaZbirnaDto extends Result implements IResultOfPdvEvidencijaZbirnaDto {
    data?: PdvEvidencijaZbirnaDto | undefined;

    constructor(data?: IResultOfPdvEvidencijaZbirnaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PdvEvidencijaZbirnaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfPdvEvidencijaZbirnaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfPdvEvidencijaZbirnaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfPdvEvidencijaZbirnaDto extends IResult {
    data?: PdvEvidencijaZbirnaDto | undefined;
}

export class ResultOfPdvEvidencijaZbirna39Dto extends Result implements IResultOfPdvEvidencijaZbirna39Dto {
    data?: PdvEvidencijaZbirna39Dto | undefined;

    constructor(data?: IResultOfPdvEvidencijaZbirna39Dto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PdvEvidencijaZbirna39Dto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfPdvEvidencijaZbirna39Dto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfPdvEvidencijaZbirna39Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfPdvEvidencijaZbirna39Dto extends IResult {
    data?: PdvEvidencijaZbirna39Dto | undefined;
}

export class SefEvidentirajPdvEvidencijaZbirnaCommand implements ISefEvidentirajPdvEvidencijaZbirnaCommand {
    evidencijaId?: number;

    constructor(data?: ISefEvidentirajPdvEvidencijaZbirnaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.evidencijaId = _data["evidencijaId"];
        }
    }

    static fromJS(data: any): SefEvidentirajPdvEvidencijaZbirnaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SefEvidentirajPdvEvidencijaZbirnaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evidencijaId"] = this.evidencijaId;
        return data;
    }
}

export interface ISefEvidentirajPdvEvidencijaZbirnaCommand {
    evidencijaId?: number;
}

export class SefEvidentirajPdvEvidencijaZbirna39Command implements ISefEvidentirajPdvEvidencijaZbirna39Command {
    id?: number;

    constructor(data?: ISefEvidentirajPdvEvidencijaZbirna39Command) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SefEvidentirajPdvEvidencijaZbirna39Command {
        data = typeof data === 'object' ? data : {};
        let result = new SefEvidentirajPdvEvidencijaZbirna39Command();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ISefEvidentirajPdvEvidencijaZbirna39Command {
    id?: number;
}

export class SefCancelPdvEvidencijaZbirnaCommand implements ISefCancelPdvEvidencijaZbirnaCommand {
    evidencijaId?: number;

    constructor(data?: ISefCancelPdvEvidencijaZbirnaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.evidencijaId = _data["evidencijaId"];
        }
    }

    static fromJS(data: any): SefCancelPdvEvidencijaZbirnaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SefCancelPdvEvidencijaZbirnaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evidencijaId"] = this.evidencijaId;
        return data;
    }
}

export interface ISefCancelPdvEvidencijaZbirnaCommand {
    evidencijaId?: number;
}

export class SefPonistiPdvEvidencijaZbirna39Command implements ISefPonistiPdvEvidencijaZbirna39Command {
    id?: number;

    constructor(data?: ISefPonistiPdvEvidencijaZbirna39Command) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SefPonistiPdvEvidencijaZbirna39Command {
        data = typeof data === 'object' ? data : {};
        let result = new SefPonistiPdvEvidencijaZbirna39Command();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ISefPonistiPdvEvidencijaZbirna39Command {
    id?: number;
}

export class SefKorigujPdvEvidencijaZbirnaCommand extends PdvEvidencijaZbirnaDto implements ISefKorigujPdvEvidencijaZbirnaCommand {

    constructor(data?: ISefKorigujPdvEvidencijaZbirnaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SefKorigujPdvEvidencijaZbirnaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SefKorigujPdvEvidencijaZbirnaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISefKorigujPdvEvidencijaZbirnaCommand extends IPdvEvidencijaZbirnaDto {
}

export class SefKorigujPdvEvidencijaZbirna39Command extends PdvEvidencijaZbirna39Dto implements ISefKorigujPdvEvidencijaZbirna39Command {

    constructor(data?: ISefKorigujPdvEvidencijaZbirna39Command) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SefKorigujPdvEvidencijaZbirna39Command {
        data = typeof data === 'object' ? data : {};
        let result = new SefKorigujPdvEvidencijaZbirna39Command();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISefKorigujPdvEvidencijaZbirna39Command extends IPdvEvidencijaZbirna39Dto {
}

export class ResultOfGetTableResponseOfPoslovnaJedinicaTableDto extends Result implements IResultOfGetTableResponseOfPoslovnaJedinicaTableDto {
    data?: GetTableResponseOfPoslovnaJedinicaTableDto | undefined;

    constructor(data?: IResultOfGetTableResponseOfPoslovnaJedinicaTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetTableResponseOfPoslovnaJedinicaTableDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetTableResponseOfPoslovnaJedinicaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetTableResponseOfPoslovnaJedinicaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetTableResponseOfPoslovnaJedinicaTableDto extends IResult {
    data?: GetTableResponseOfPoslovnaJedinicaTableDto | undefined;
}

export class GetTableResponseOfPoslovnaJedinicaTableDto implements IGetTableResponseOfPoslovnaJedinicaTableDto {
    responseList?: PoslovnaJedinicaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;

    constructor(data?: IGetTableResponseOfPoslovnaJedinicaTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(PoslovnaJedinicaTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTableResponseOfPoslovnaJedinicaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTableResponseOfPoslovnaJedinicaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTableResponseOfPoslovnaJedinicaTableDto {
    responseList?: PoslovnaJedinicaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
}

export class PoslovnaJedinicaTableDto implements IPoslovnaJedinicaTableDto {
    id?: number;
    naziv?: string | undefined;
    punaAdresa?: string | undefined;
    jeAktivna?: string | undefined;
    opis?: string | undefined;
    vrsta?: VrstaPoslovneJediniceDto | undefined;
    magacini?: MagacinDto[] | undefined;

    constructor(data?: IPoslovnaJedinicaTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.punaAdresa = _data["punaAdresa"];
            this.jeAktivna = _data["jeAktivna"];
            this.opis = _data["opis"];
            this.vrsta = _data["vrsta"] ? VrstaPoslovneJediniceDto.fromJS(_data["vrsta"]) : <any>undefined;
            if (Array.isArray(_data["magacini"])) {
                this.magacini = [] as any;
                for (let item of _data["magacini"])
                    this.magacini!.push(MagacinDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PoslovnaJedinicaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PoslovnaJedinicaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["punaAdresa"] = this.punaAdresa;
        data["jeAktivna"] = this.jeAktivna;
        data["opis"] = this.opis;
        data["vrsta"] = this.vrsta ? this.vrsta.toJSON() : <any>undefined;
        if (Array.isArray(this.magacini)) {
            data["magacini"] = [];
            for (let item of this.magacini)
                data["magacini"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPoslovnaJedinicaTableDto {
    id?: number;
    naziv?: string | undefined;
    punaAdresa?: string | undefined;
    jeAktivna?: string | undefined;
    opis?: string | undefined;
    vrsta?: VrstaPoslovneJediniceDto | undefined;
    magacini?: MagacinDto[] | undefined;
}

export class VrstaPoslovneJediniceDto implements IVrstaPoslovneJediniceDto {
    vrstaPoslovneJedinice?: VrstaPoslovneJedinice;
    vrstaPoslovneJediniceStr?: string | undefined;
    vrstaPoslovneJediniceBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IVrstaPoslovneJediniceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vrstaPoslovneJedinice = _data["vrstaPoslovneJedinice"];
            this.vrstaPoslovneJediniceStr = _data["vrstaPoslovneJediniceStr"];
            this.vrstaPoslovneJediniceBadgeStr = _data["vrstaPoslovneJediniceBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): VrstaPoslovneJediniceDto {
        data = typeof data === 'object' ? data : {};
        let result = new VrstaPoslovneJediniceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vrstaPoslovneJedinice"] = this.vrstaPoslovneJedinice;
        data["vrstaPoslovneJediniceStr"] = this.vrstaPoslovneJediniceStr;
        data["vrstaPoslovneJediniceBadgeStr"] = this.vrstaPoslovneJediniceBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IVrstaPoslovneJediniceDto {
    vrstaPoslovneJedinice?: VrstaPoslovneJedinice;
    vrstaPoslovneJediniceStr?: string | undefined;
    vrstaPoslovneJediniceBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class CreatePoslovnaJedinicaCommand implements ICreatePoslovnaJedinicaCommand {
    id?: number | undefined;
    naziv?: string | undefined;
    jeAktivna?: boolean | undefined;
    opis?: string | undefined;
    adresa?: AdresaDto | undefined;
    strankaId?: number | undefined;
    sifraDelatnosti?: string | undefined;
    vrsta?: VrstaPoslovneJedinice;
    magacini?: MagacinDto[] | undefined;

    constructor(data?: ICreatePoslovnaJedinicaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.jeAktivna = _data["jeAktivna"];
            this.opis = _data["opis"];
            this.adresa = _data["adresa"] ? AdresaDto.fromJS(_data["adresa"]) : <any>undefined;
            this.strankaId = _data["strankaId"];
            this.sifraDelatnosti = _data["sifraDelatnosti"];
            this.vrsta = _data["vrsta"];
            if (Array.isArray(_data["magacini"])) {
                this.magacini = [] as any;
                for (let item of _data["magacini"])
                    this.magacini!.push(MagacinDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePoslovnaJedinicaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePoslovnaJedinicaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["jeAktivna"] = this.jeAktivna;
        data["opis"] = this.opis;
        data["adresa"] = this.adresa ? this.adresa.toJSON() : <any>undefined;
        data["strankaId"] = this.strankaId;
        data["sifraDelatnosti"] = this.sifraDelatnosti;
        data["vrsta"] = this.vrsta;
        if (Array.isArray(this.magacini)) {
            data["magacini"] = [];
            for (let item of this.magacini)
                data["magacini"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreatePoslovnaJedinicaCommand {
    id?: number | undefined;
    naziv?: string | undefined;
    jeAktivna?: boolean | undefined;
    opis?: string | undefined;
    adresa?: AdresaDto | undefined;
    strankaId?: number | undefined;
    sifraDelatnosti?: string | undefined;
    vrsta?: VrstaPoslovneJedinice;
    magacini?: MagacinDto[] | undefined;
}

export class ResultOfPoslovnaJedinicaTableDto extends Result implements IResultOfPoslovnaJedinicaTableDto {
    data?: PoslovnaJedinicaTableDto | undefined;

    constructor(data?: IResultOfPoslovnaJedinicaTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PoslovnaJedinicaTableDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfPoslovnaJedinicaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfPoslovnaJedinicaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfPoslovnaJedinicaTableDto extends IResult {
    data?: PoslovnaJedinicaTableDto | undefined;
}

export class UpdatePoslovnaJedinicaCommand implements IUpdatePoslovnaJedinicaCommand {
    id?: number | undefined;
    naziv?: string | undefined;
    jeAktivna?: boolean | undefined;
    opis?: string | undefined;
    adresa?: AdresaDto | undefined;
    strankaId?: number | undefined;
    sifraDelatnosti?: string | undefined;
    vrsta?: VrstaPoslovneJedinice;
    magacini?: MagacinDto[] | undefined;

    constructor(data?: IUpdatePoslovnaJedinicaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.jeAktivna = _data["jeAktivna"];
            this.opis = _data["opis"];
            this.adresa = _data["adresa"] ? AdresaDto.fromJS(_data["adresa"]) : <any>undefined;
            this.strankaId = _data["strankaId"];
            this.sifraDelatnosti = _data["sifraDelatnosti"];
            this.vrsta = _data["vrsta"];
            if (Array.isArray(_data["magacini"])) {
                this.magacini = [] as any;
                for (let item of _data["magacini"])
                    this.magacini!.push(MagacinDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePoslovnaJedinicaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePoslovnaJedinicaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["jeAktivna"] = this.jeAktivna;
        data["opis"] = this.opis;
        data["adresa"] = this.adresa ? this.adresa.toJSON() : <any>undefined;
        data["strankaId"] = this.strankaId;
        data["sifraDelatnosti"] = this.sifraDelatnosti;
        data["vrsta"] = this.vrsta;
        if (Array.isArray(this.magacini)) {
            data["magacini"] = [];
            for (let item of this.magacini)
                data["magacini"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdatePoslovnaJedinicaCommand {
    id?: number | undefined;
    naziv?: string | undefined;
    jeAktivna?: boolean | undefined;
    opis?: string | undefined;
    adresa?: AdresaDto | undefined;
    strankaId?: number | undefined;
    sifraDelatnosti?: string | undefined;
    vrsta?: VrstaPoslovneJedinice;
    magacini?: MagacinDto[] | undefined;
}

export class ResultOfGetPoslovneJediniceAutocompleteResponse extends Result implements IResultOfGetPoslovneJediniceAutocompleteResponse {
    data?: GetPoslovneJediniceAutocompleteResponse | undefined;

    constructor(data?: IResultOfGetPoslovneJediniceAutocompleteResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetPoslovneJediniceAutocompleteResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetPoslovneJediniceAutocompleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetPoslovneJediniceAutocompleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetPoslovneJediniceAutocompleteResponse extends IResult {
    data?: GetPoslovneJediniceAutocompleteResponse | undefined;
}

export class GetPoslovneJediniceAutocompleteResponse implements IGetPoslovneJediniceAutocompleteResponse {
    poslovnaJedinicaDtoList?: PoslovnaJedinicaDto[] | undefined;

    constructor(data?: IGetPoslovneJediniceAutocompleteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["poslovnaJedinicaDtoList"])) {
                this.poslovnaJedinicaDtoList = [] as any;
                for (let item of _data["poslovnaJedinicaDtoList"])
                    this.poslovnaJedinicaDtoList!.push(PoslovnaJedinicaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPoslovneJediniceAutocompleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPoslovneJediniceAutocompleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.poslovnaJedinicaDtoList)) {
            data["poslovnaJedinicaDtoList"] = [];
            for (let item of this.poslovnaJedinicaDtoList)
                data["poslovnaJedinicaDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPoslovneJediniceAutocompleteResponse {
    poslovnaJedinicaDtoList?: PoslovnaJedinicaDto[] | undefined;
}

export class ResultOfGetVrstePoslovneJediniceResponse extends Result implements IResultOfGetVrstePoslovneJediniceResponse {
    data?: GetVrstePoslovneJediniceResponse | undefined;

    constructor(data?: IResultOfGetVrstePoslovneJediniceResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetVrstePoslovneJediniceResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetVrstePoslovneJediniceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetVrstePoslovneJediniceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetVrstePoslovneJediniceResponse extends IResult {
    data?: GetVrstePoslovneJediniceResponse | undefined;
}

export class GetVrstePoslovneJediniceResponse implements IGetVrstePoslovneJediniceResponse {
    vrstePoslovneJediniceDtoList?: VrstaPoslovneJediniceDto[] | undefined;

    constructor(data?: IGetVrstePoslovneJediniceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vrstePoslovneJediniceDtoList"])) {
                this.vrstePoslovneJediniceDtoList = [] as any;
                for (let item of _data["vrstePoslovneJediniceDtoList"])
                    this.vrstePoslovneJediniceDtoList!.push(VrstaPoslovneJediniceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetVrstePoslovneJediniceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetVrstePoslovneJediniceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vrstePoslovneJediniceDtoList)) {
            data["vrstePoslovneJediniceDtoList"] = [];
            for (let item of this.vrstePoslovneJediniceDtoList)
                data["vrstePoslovneJediniceDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetVrstePoslovneJediniceResponse {
    vrstePoslovneJediniceDtoList?: VrstaPoslovneJediniceDto[] | undefined;
}

export class ResultOfGetTableResponseOfPravnoLiceTableDto extends Result implements IResultOfGetTableResponseOfPravnoLiceTableDto {
    data?: GetTableResponseOfPravnoLiceTableDto | undefined;

    constructor(data?: IResultOfGetTableResponseOfPravnoLiceTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetTableResponseOfPravnoLiceTableDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetTableResponseOfPravnoLiceTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetTableResponseOfPravnoLiceTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetTableResponseOfPravnoLiceTableDto extends IResult {
    data?: GetTableResponseOfPravnoLiceTableDto | undefined;
}

export class GetTableResponseOfPravnoLiceTableDto implements IGetTableResponseOfPravnoLiceTableDto {
    responseList?: PravnoLiceTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;

    constructor(data?: IGetTableResponseOfPravnoLiceTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(PravnoLiceTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTableResponseOfPravnoLiceTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTableResponseOfPravnoLiceTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTableResponseOfPravnoLiceTableDto {
    responseList?: PravnoLiceTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
}

export class PravnoLiceTableDto implements IPravnoLiceTableDto {
    id?: number;
    naziv?: string | undefined;
    jeKupac?: string | undefined;
    jeDobavljac?: string | undefined;
    jeUSistemuPDV?: string | undefined;
    tipPravnogLica?: TipPravnogLica;
    adresa?: string | undefined;

    constructor(data?: IPravnoLiceTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.jeKupac = _data["jeKupac"];
            this.jeDobavljac = _data["jeDobavljac"];
            this.jeUSistemuPDV = _data["jeUSistemuPDV"];
            this.tipPravnogLica = _data["tipPravnogLica"];
            this.adresa = _data["adresa"];
        }
    }

    static fromJS(data: any): PravnoLiceTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PravnoLiceTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["jeKupac"] = this.jeKupac;
        data["jeDobavljac"] = this.jeDobavljac;
        data["jeUSistemuPDV"] = this.jeUSistemuPDV;
        data["tipPravnogLica"] = this.tipPravnogLica;
        data["adresa"] = this.adresa;
        return data;
    }
}

export interface IPravnoLiceTableDto {
    id?: number;
    naziv?: string | undefined;
    jeKupac?: string | undefined;
    jeDobavljac?: string | undefined;
    jeUSistemuPDV?: string | undefined;
    tipPravnogLica?: TipPravnogLica;
    adresa?: string | undefined;
}

export class GetPravnoLiceTableQuery implements IGetPravnoLiceTableQuery {
    sifraDelatnosti?: string | undefined;
    stranke?: StrankaMultiSelectItem[] | undefined;

    constructor(data?: IGetPravnoLiceTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifraDelatnosti = _data["sifraDelatnosti"];
            if (Array.isArray(_data["stranke"])) {
                this.stranke = [] as any;
                for (let item of _data["stranke"])
                    this.stranke!.push(StrankaMultiSelectItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPravnoLiceTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPravnoLiceTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifraDelatnosti"] = this.sifraDelatnosti;
        if (Array.isArray(this.stranke)) {
            data["stranke"] = [];
            for (let item of this.stranke)
                data["stranke"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPravnoLiceTableQuery {
    sifraDelatnosti?: string | undefined;
    stranke?: StrankaMultiSelectItem[] | undefined;
}

export class ResultOfPravnoLiceDto extends Result implements IResultOfPravnoLiceDto {
    data?: PravnoLiceDto | undefined;

    constructor(data?: IResultOfPravnoLiceDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PravnoLiceDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfPravnoLiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfPravnoLiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfPravnoLiceDto extends IResult {
    data?: PravnoLiceDto | undefined;
}

export class PravnoLiceDto extends StrankaDto implements IPravnoLiceDto {
    pib?: string | undefined;
    maticniBroj?: string | undefined;
    vlasnici?: string | undefined;
    zastupnici?: string | undefined;
    tipPravnogLica?: TipPravnogLica;
    sifraDelatnosti?: string | undefined;
    punNaziv?: string | undefined;
    datumRegistracije?: Date | undefined;
    datumOsnivanja?: Date | undefined;
    datumPocetkaStatusa?: Date | undefined;
    pravniOblik?: PravniOblik;
    jeKorisnikAplikacije?: boolean;
    jbkjs?: string | undefined;
    registracioniBroj?: string | undefined;
    poreskiBrojStranogLica?: string | undefined;
    brojUgovora?: string | undefined;
    brojTendera?: string | undefined;

    constructor(data?: IPravnoLiceDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pib = _data["pib"];
            this.maticniBroj = _data["maticniBroj"];
            this.vlasnici = _data["vlasnici"];
            this.zastupnici = _data["zastupnici"];
            this.tipPravnogLica = _data["tipPravnogLica"];
            this.sifraDelatnosti = _data["sifraDelatnosti"];
            this.punNaziv = _data["punNaziv"];
            this.datumRegistracije = _data["datumRegistracije"] ? new Date(_data["datumRegistracije"].toString()) : <any>undefined;
            this.datumOsnivanja = _data["datumOsnivanja"] ? new Date(_data["datumOsnivanja"].toString()) : <any>undefined;
            this.datumPocetkaStatusa = _data["datumPocetkaStatusa"] ? new Date(_data["datumPocetkaStatusa"].toString()) : <any>undefined;
            this.pravniOblik = _data["pravniOblik"];
            this.jeKorisnikAplikacije = _data["jeKorisnikAplikacije"];
            this.jbkjs = _data["jbkjs"];
            this.registracioniBroj = _data["registracioniBroj"];
            this.poreskiBrojStranogLica = _data["poreskiBrojStranogLica"];
            this.brojUgovora = _data["brojUgovora"];
            this.brojTendera = _data["brojTendera"];
        }
    }

    static fromJS(data: any): PravnoLiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PravnoLiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pib"] = this.pib;
        data["maticniBroj"] = this.maticniBroj;
        data["vlasnici"] = this.vlasnici;
        data["zastupnici"] = this.zastupnici;
        data["tipPravnogLica"] = this.tipPravnogLica;
        data["sifraDelatnosti"] = this.sifraDelatnosti;
        data["punNaziv"] = this.punNaziv;
        data["datumRegistracije"] = this.datumRegistracije ? this.datumRegistracije.toISOString() : <any>undefined;
        data["datumOsnivanja"] = this.datumOsnivanja ? this.datumOsnivanja.toISOString() : <any>undefined;
        data["datumPocetkaStatusa"] = this.datumPocetkaStatusa ? this.datumPocetkaStatusa.toISOString() : <any>undefined;
        data["pravniOblik"] = this.pravniOblik;
        data["jeKorisnikAplikacije"] = this.jeKorisnikAplikacije;
        data["jbkjs"] = this.jbkjs;
        data["registracioniBroj"] = this.registracioniBroj;
        data["poreskiBrojStranogLica"] = this.poreskiBrojStranogLica;
        data["brojUgovora"] = this.brojUgovora;
        data["brojTendera"] = this.brojTendera;
        super.toJSON(data);
        return data;
    }
}

export interface IPravnoLiceDto extends IStrankaDto {
    pib?: string | undefined;
    maticniBroj?: string | undefined;
    vlasnici?: string | undefined;
    zastupnici?: string | undefined;
    tipPravnogLica?: TipPravnogLica;
    sifraDelatnosti?: string | undefined;
    punNaziv?: string | undefined;
    datumRegistracije?: Date | undefined;
    datumOsnivanja?: Date | undefined;
    datumPocetkaStatusa?: Date | undefined;
    pravniOblik?: PravniOblik;
    jeKorisnikAplikacije?: boolean;
    jbkjs?: string | undefined;
    registracioniBroj?: string | undefined;
    poreskiBrojStranogLica?: string | undefined;
    brojUgovora?: string | undefined;
    brojTendera?: string | undefined;
}

export class ResultOfPravnoLiceVm extends Result implements IResultOfPravnoLiceVm {
    data?: PravnoLiceVm | undefined;

    constructor(data?: IResultOfPravnoLiceVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PravnoLiceVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfPravnoLiceVm {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfPravnoLiceVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfPravnoLiceVm extends IResult {
    data?: PravnoLiceVm | undefined;
}

export class PravnoLiceVm implements IPravnoLiceVm {
    pravnoLiceTableDto?: PravnoLiceTableDto | undefined;
    pravnoLiceDto?: PravnoLiceDto | undefined;

    constructor(data?: IPravnoLiceVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pravnoLiceTableDto = _data["pravnoLiceTableDto"] ? PravnoLiceTableDto.fromJS(_data["pravnoLiceTableDto"]) : <any>undefined;
            this.pravnoLiceDto = _data["pravnoLiceDto"] ? PravnoLiceDto.fromJS(_data["pravnoLiceDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PravnoLiceVm {
        data = typeof data === 'object' ? data : {};
        let result = new PravnoLiceVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pravnoLiceTableDto"] = this.pravnoLiceTableDto ? this.pravnoLiceTableDto.toJSON() : <any>undefined;
        data["pravnoLiceDto"] = this.pravnoLiceDto ? this.pravnoLiceDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPravnoLiceVm {
    pravnoLiceTableDto?: PravnoLiceTableDto | undefined;
    pravnoLiceDto?: PravnoLiceDto | undefined;
}

export class CreatePravnoLiceCommand implements ICreatePravnoLiceCommand {
    pib?: string | undefined;
    maticniBroj?: string | undefined;
    vlasnici?: string | undefined;
    zastupnici?: string | undefined;
    tipPravnogLica?: TipPravnogLica;
    sifraDelatnosti?: string | undefined;
    punNaziv?: string | undefined;
    datumRegistracije?: Date | undefined;
    datumOsnivanja?: Date | undefined;
    datumPocetkaStatusa?: Date | undefined;
    pravniOblik?: PravniOblik;
    jeKorisnikAplikacije?: boolean;
    isActive?: boolean;
    id?: number | undefined;
    naziv?: string | undefined;
    kupac?: string | undefined;
    dobavljac?: string | undefined;
    napomena?: string | undefined;
    tipStranke?: TipStranke;
    adresa?: AdresaDto | undefined;
    rokPlacanjaZaUlazne?: number;
    rokPlacanjaZaIzlazne?: number;
    tekuciRacuniDto?: TekuciRacunDto[] | undefined;
    kontaktiDto?: KontaktDto[] | undefined;
    uSistemuPDVa?: boolean | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    jeKupac?: boolean;
    jeDobavljac?: boolean;
    jbkjs?: string | undefined;
    registracioniBroj?: string | undefined;
    poreskiBrojStranogLica?: string | undefined;
    valutaPoslovanjaId?: string | undefined;
    valutaPoslovanjaTekst?: string | undefined;
    brojUgovora?: string | undefined;
    brojTendera?: string | undefined;
    gln?: string | undefined;

    constructor(data?: ICreatePravnoLiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pib = _data["pib"];
            this.maticniBroj = _data["maticniBroj"];
            this.vlasnici = _data["vlasnici"];
            this.zastupnici = _data["zastupnici"];
            this.tipPravnogLica = _data["tipPravnogLica"];
            this.sifraDelatnosti = _data["sifraDelatnosti"];
            this.punNaziv = _data["punNaziv"];
            this.datumRegistracije = _data["datumRegistracije"] ? new Date(_data["datumRegistracije"].toString()) : <any>undefined;
            this.datumOsnivanja = _data["datumOsnivanja"] ? new Date(_data["datumOsnivanja"].toString()) : <any>undefined;
            this.datumPocetkaStatusa = _data["datumPocetkaStatusa"] ? new Date(_data["datumPocetkaStatusa"].toString()) : <any>undefined;
            this.pravniOblik = _data["pravniOblik"];
            this.jeKorisnikAplikacije = _data["jeKorisnikAplikacije"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.kupac = _data["kupac"];
            this.dobavljac = _data["dobavljac"];
            this.napomena = _data["napomena"];
            this.tipStranke = _data["tipStranke"];
            this.adresa = _data["adresa"] ? AdresaDto.fromJS(_data["adresa"]) : <any>undefined;
            this.rokPlacanjaZaUlazne = _data["rokPlacanjaZaUlazne"];
            this.rokPlacanjaZaIzlazne = _data["rokPlacanjaZaIzlazne"];
            if (Array.isArray(_data["tekuciRacuniDto"])) {
                this.tekuciRacuniDto = [] as any;
                for (let item of _data["tekuciRacuniDto"])
                    this.tekuciRacuniDto!.push(TekuciRacunDto.fromJS(item));
            }
            if (Array.isArray(_data["kontaktiDto"])) {
                this.kontaktiDto = [] as any;
                for (let item of _data["kontaktiDto"])
                    this.kontaktiDto!.push(KontaktDto.fromJS(item));
            }
            this.uSistemuPDVa = _data["uSistemuPDVa"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedOn = _data["lastModifiedOn"] ? new Date(_data["lastModifiedOn"].toString()) : <any>undefined;
            this.jeKupac = _data["jeKupac"];
            this.jeDobavljac = _data["jeDobavljac"];
            this.jbkjs = _data["jbkjs"];
            this.registracioniBroj = _data["registracioniBroj"];
            this.poreskiBrojStranogLica = _data["poreskiBrojStranogLica"];
            this.valutaPoslovanjaId = _data["valutaPoslovanjaId"];
            this.valutaPoslovanjaTekst = _data["valutaPoslovanjaTekst"];
            this.brojUgovora = _data["brojUgovora"];
            this.brojTendera = _data["brojTendera"];
            this.gln = _data["gln"];
        }
    }

    static fromJS(data: any): CreatePravnoLiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePravnoLiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pib"] = this.pib;
        data["maticniBroj"] = this.maticniBroj;
        data["vlasnici"] = this.vlasnici;
        data["zastupnici"] = this.zastupnici;
        data["tipPravnogLica"] = this.tipPravnogLica;
        data["sifraDelatnosti"] = this.sifraDelatnosti;
        data["punNaziv"] = this.punNaziv;
        data["datumRegistracije"] = this.datumRegistracije ? this.datumRegistracije.toISOString() : <any>undefined;
        data["datumOsnivanja"] = this.datumOsnivanja ? this.datumOsnivanja.toISOString() : <any>undefined;
        data["datumPocetkaStatusa"] = this.datumPocetkaStatusa ? this.datumPocetkaStatusa.toISOString() : <any>undefined;
        data["pravniOblik"] = this.pravniOblik;
        data["jeKorisnikAplikacije"] = this.jeKorisnikAplikacije;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["kupac"] = this.kupac;
        data["dobavljac"] = this.dobavljac;
        data["napomena"] = this.napomena;
        data["tipStranke"] = this.tipStranke;
        data["adresa"] = this.adresa ? this.adresa.toJSON() : <any>undefined;
        data["rokPlacanjaZaUlazne"] = this.rokPlacanjaZaUlazne;
        data["rokPlacanjaZaIzlazne"] = this.rokPlacanjaZaIzlazne;
        if (Array.isArray(this.tekuciRacuniDto)) {
            data["tekuciRacuniDto"] = [];
            for (let item of this.tekuciRacuniDto)
                data["tekuciRacuniDto"].push(item.toJSON());
        }
        if (Array.isArray(this.kontaktiDto)) {
            data["kontaktiDto"] = [];
            for (let item of this.kontaktiDto)
                data["kontaktiDto"].push(item.toJSON());
        }
        data["uSistemuPDVa"] = this.uSistemuPDVa;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined;
        data["jeKupac"] = this.jeKupac;
        data["jeDobavljac"] = this.jeDobavljac;
        data["jbkjs"] = this.jbkjs;
        data["registracioniBroj"] = this.registracioniBroj;
        data["poreskiBrojStranogLica"] = this.poreskiBrojStranogLica;
        data["valutaPoslovanjaId"] = this.valutaPoslovanjaId;
        data["valutaPoslovanjaTekst"] = this.valutaPoslovanjaTekst;
        data["brojUgovora"] = this.brojUgovora;
        data["brojTendera"] = this.brojTendera;
        data["gln"] = this.gln;
        return data;
    }
}

export interface ICreatePravnoLiceCommand {
    pib?: string | undefined;
    maticniBroj?: string | undefined;
    vlasnici?: string | undefined;
    zastupnici?: string | undefined;
    tipPravnogLica?: TipPravnogLica;
    sifraDelatnosti?: string | undefined;
    punNaziv?: string | undefined;
    datumRegistracije?: Date | undefined;
    datumOsnivanja?: Date | undefined;
    datumPocetkaStatusa?: Date | undefined;
    pravniOblik?: PravniOblik;
    jeKorisnikAplikacije?: boolean;
    isActive?: boolean;
    id?: number | undefined;
    naziv?: string | undefined;
    kupac?: string | undefined;
    dobavljac?: string | undefined;
    napomena?: string | undefined;
    tipStranke?: TipStranke;
    adresa?: AdresaDto | undefined;
    rokPlacanjaZaUlazne?: number;
    rokPlacanjaZaIzlazne?: number;
    tekuciRacuniDto?: TekuciRacunDto[] | undefined;
    kontaktiDto?: KontaktDto[] | undefined;
    uSistemuPDVa?: boolean | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    jeKupac?: boolean;
    jeDobavljac?: boolean;
    jbkjs?: string | undefined;
    registracioniBroj?: string | undefined;
    poreskiBrojStranogLica?: string | undefined;
    valutaPoslovanjaId?: string | undefined;
    valutaPoslovanjaTekst?: string | undefined;
    brojUgovora?: string | undefined;
    brojTendera?: string | undefined;
    gln?: string | undefined;
}

export class UpdatePravnoLiceCommand implements IUpdatePravnoLiceCommand {
    pib?: string | undefined;
    maticniBroj?: string | undefined;
    vlasnici?: string | undefined;
    zastupnici?: string | undefined;
    tipPravnogLica?: TipPravnogLica;
    sifraDelatnosti?: string | undefined;
    punNaziv?: string | undefined;
    datumRegistracije?: Date | undefined;
    datumOsnivanja?: Date | undefined;
    datumPocetkaStatusa?: Date | undefined;
    pravniOblik?: PravniOblik;
    jeKorisnikAplikacije?: boolean;
    id?: number | undefined;
    naziv?: string | undefined;
    kupac?: string | undefined;
    dobavljac?: string | undefined;
    napomena?: string | undefined;
    tipStranke?: TipStranke;
    adresa?: AdresaDto | undefined;
    rokPlacanjaZaUlazne?: number;
    rokPlacanjaZaIzlazne?: number;
    tekuciRacuniDto?: TekuciRacunDto[] | undefined;
    kontaktiDto?: KontaktDto[] | undefined;
    uSistemuPDVa?: boolean | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    jeKupac?: boolean;
    jeDobavljac?: boolean;
    isActive?: boolean;
    jbkjs?: string | undefined;
    registracioniBroj?: string | undefined;
    poreskiBrojStranogLica?: string | undefined;
    valutaPoslovanjaId?: string | undefined;
    valutaPoslovanjaTekst?: string | undefined;
    brojUgovora?: string | undefined;
    brojTendera?: string | undefined;
    gln?: string | undefined;

    constructor(data?: IUpdatePravnoLiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pib = _data["pib"];
            this.maticniBroj = _data["maticniBroj"];
            this.vlasnici = _data["vlasnici"];
            this.zastupnici = _data["zastupnici"];
            this.tipPravnogLica = _data["tipPravnogLica"];
            this.sifraDelatnosti = _data["sifraDelatnosti"];
            this.punNaziv = _data["punNaziv"];
            this.datumRegistracije = _data["datumRegistracije"] ? new Date(_data["datumRegistracije"].toString()) : <any>undefined;
            this.datumOsnivanja = _data["datumOsnivanja"] ? new Date(_data["datumOsnivanja"].toString()) : <any>undefined;
            this.datumPocetkaStatusa = _data["datumPocetkaStatusa"] ? new Date(_data["datumPocetkaStatusa"].toString()) : <any>undefined;
            this.pravniOblik = _data["pravniOblik"];
            this.jeKorisnikAplikacije = _data["jeKorisnikAplikacije"];
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.kupac = _data["kupac"];
            this.dobavljac = _data["dobavljac"];
            this.napomena = _data["napomena"];
            this.tipStranke = _data["tipStranke"];
            this.adresa = _data["adresa"] ? AdresaDto.fromJS(_data["adresa"]) : <any>undefined;
            this.rokPlacanjaZaUlazne = _data["rokPlacanjaZaUlazne"];
            this.rokPlacanjaZaIzlazne = _data["rokPlacanjaZaIzlazne"];
            if (Array.isArray(_data["tekuciRacuniDto"])) {
                this.tekuciRacuniDto = [] as any;
                for (let item of _data["tekuciRacuniDto"])
                    this.tekuciRacuniDto!.push(TekuciRacunDto.fromJS(item));
            }
            if (Array.isArray(_data["kontaktiDto"])) {
                this.kontaktiDto = [] as any;
                for (let item of _data["kontaktiDto"])
                    this.kontaktiDto!.push(KontaktDto.fromJS(item));
            }
            this.uSistemuPDVa = _data["uSistemuPDVa"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedOn = _data["lastModifiedOn"] ? new Date(_data["lastModifiedOn"].toString()) : <any>undefined;
            this.jeKupac = _data["jeKupac"];
            this.jeDobavljac = _data["jeDobavljac"];
            this.isActive = _data["isActive"];
            this.jbkjs = _data["jbkjs"];
            this.registracioniBroj = _data["registracioniBroj"];
            this.poreskiBrojStranogLica = _data["poreskiBrojStranogLica"];
            this.valutaPoslovanjaId = _data["valutaPoslovanjaId"];
            this.valutaPoslovanjaTekst = _data["valutaPoslovanjaTekst"];
            this.brojUgovora = _data["brojUgovora"];
            this.brojTendera = _data["brojTendera"];
            this.gln = _data["gln"];
        }
    }

    static fromJS(data: any): UpdatePravnoLiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePravnoLiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pib"] = this.pib;
        data["maticniBroj"] = this.maticniBroj;
        data["vlasnici"] = this.vlasnici;
        data["zastupnici"] = this.zastupnici;
        data["tipPravnogLica"] = this.tipPravnogLica;
        data["sifraDelatnosti"] = this.sifraDelatnosti;
        data["punNaziv"] = this.punNaziv;
        data["datumRegistracije"] = this.datumRegistracije ? this.datumRegistracije.toISOString() : <any>undefined;
        data["datumOsnivanja"] = this.datumOsnivanja ? this.datumOsnivanja.toISOString() : <any>undefined;
        data["datumPocetkaStatusa"] = this.datumPocetkaStatusa ? this.datumPocetkaStatusa.toISOString() : <any>undefined;
        data["pravniOblik"] = this.pravniOblik;
        data["jeKorisnikAplikacije"] = this.jeKorisnikAplikacije;
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["kupac"] = this.kupac;
        data["dobavljac"] = this.dobavljac;
        data["napomena"] = this.napomena;
        data["tipStranke"] = this.tipStranke;
        data["adresa"] = this.adresa ? this.adresa.toJSON() : <any>undefined;
        data["rokPlacanjaZaUlazne"] = this.rokPlacanjaZaUlazne;
        data["rokPlacanjaZaIzlazne"] = this.rokPlacanjaZaIzlazne;
        if (Array.isArray(this.tekuciRacuniDto)) {
            data["tekuciRacuniDto"] = [];
            for (let item of this.tekuciRacuniDto)
                data["tekuciRacuniDto"].push(item.toJSON());
        }
        if (Array.isArray(this.kontaktiDto)) {
            data["kontaktiDto"] = [];
            for (let item of this.kontaktiDto)
                data["kontaktiDto"].push(item.toJSON());
        }
        data["uSistemuPDVa"] = this.uSistemuPDVa;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined;
        data["jeKupac"] = this.jeKupac;
        data["jeDobavljac"] = this.jeDobavljac;
        data["isActive"] = this.isActive;
        data["jbkjs"] = this.jbkjs;
        data["registracioniBroj"] = this.registracioniBroj;
        data["poreskiBrojStranogLica"] = this.poreskiBrojStranogLica;
        data["valutaPoslovanjaId"] = this.valutaPoslovanjaId;
        data["valutaPoslovanjaTekst"] = this.valutaPoslovanjaTekst;
        data["brojUgovora"] = this.brojUgovora;
        data["brojTendera"] = this.brojTendera;
        data["gln"] = this.gln;
        return data;
    }
}

export interface IUpdatePravnoLiceCommand {
    pib?: string | undefined;
    maticniBroj?: string | undefined;
    vlasnici?: string | undefined;
    zastupnici?: string | undefined;
    tipPravnogLica?: TipPravnogLica;
    sifraDelatnosti?: string | undefined;
    punNaziv?: string | undefined;
    datumRegistracije?: Date | undefined;
    datumOsnivanja?: Date | undefined;
    datumPocetkaStatusa?: Date | undefined;
    pravniOblik?: PravniOblik;
    jeKorisnikAplikacije?: boolean;
    id?: number | undefined;
    naziv?: string | undefined;
    kupac?: string | undefined;
    dobavljac?: string | undefined;
    napomena?: string | undefined;
    tipStranke?: TipStranke;
    adresa?: AdresaDto | undefined;
    rokPlacanjaZaUlazne?: number;
    rokPlacanjaZaIzlazne?: number;
    tekuciRacuniDto?: TekuciRacunDto[] | undefined;
    kontaktiDto?: KontaktDto[] | undefined;
    uSistemuPDVa?: boolean | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedOn?: Date | undefined;
    jeKupac?: boolean;
    jeDobavljac?: boolean;
    isActive?: boolean;
    jbkjs?: string | undefined;
    registracioniBroj?: string | undefined;
    poreskiBrojStranogLica?: string | undefined;
    valutaPoslovanjaId?: string | undefined;
    valutaPoslovanjaTekst?: string | undefined;
    brojUgovora?: string | undefined;
    brojTendera?: string | undefined;
    gln?: string | undefined;
}

export class ResultOfGetFiltersResponseOfPravnoLiceFilterDto extends Result implements IResultOfGetFiltersResponseOfPravnoLiceFilterDto {
    data?: GetFiltersResponseOfPravnoLiceFilterDto | undefined;

    constructor(data?: IResultOfGetFiltersResponseOfPravnoLiceFilterDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetFiltersResponseOfPravnoLiceFilterDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetFiltersResponseOfPravnoLiceFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetFiltersResponseOfPravnoLiceFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetFiltersResponseOfPravnoLiceFilterDto extends IResult {
    data?: GetFiltersResponseOfPravnoLiceFilterDto | undefined;
}

export class GetFiltersResponseOfPravnoLiceFilterDto implements IGetFiltersResponseOfPravnoLiceFilterDto {
    filters?: PravnoLiceFilterDto[] | undefined;

    constructor(data?: IGetFiltersResponseOfPravnoLiceFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(PravnoLiceFilterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFiltersResponseOfPravnoLiceFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFiltersResponseOfPravnoLiceFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFiltersResponseOfPravnoLiceFilterDto {
    filters?: PravnoLiceFilterDto[] | undefined;
}

export class PravnoLiceFilterDto implements IPravnoLiceFilterDto {
    sifraDelatnosti?: string | undefined;
    stranke?: StrankaMultiSelectItem[] | undefined;

    constructor(data?: IPravnoLiceFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifraDelatnosti = _data["sifraDelatnosti"];
            if (Array.isArray(_data["stranke"])) {
                this.stranke = [] as any;
                for (let item of _data["stranke"])
                    this.stranke!.push(StrankaMultiSelectItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PravnoLiceFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PravnoLiceFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifraDelatnosti"] = this.sifraDelatnosti;
        if (Array.isArray(this.stranke)) {
            data["stranke"] = [];
            for (let item of this.stranke)
                data["stranke"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPravnoLiceFilterDto {
    sifraDelatnosti?: string | undefined;
    stranke?: StrankaMultiSelectItem[] | undefined;
}

export class ResultOfListOfImportInoKupciDobavljaciDto extends Result implements IResultOfListOfImportInoKupciDobavljaciDto {
    data?: ImportInoKupciDobavljaciDto[] | undefined;

    constructor(data?: IResultOfListOfImportInoKupciDobavljaciDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ImportInoKupciDobavljaciDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfImportInoKupciDobavljaciDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfImportInoKupciDobavljaciDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfImportInoKupciDobavljaciDto extends IResult {
    data?: ImportInoKupciDobavljaciDto[] | undefined;
}

export class ImportInoKupciDobavljaciDto implements IImportInoKupciDobavljaciDto {
    id?: number;
    registracioniBroj?: string | undefined;
    naziv?: string | undefined;
    grad?: string | undefined;
    drzava?: string | undefined;
    potrazivanje?: string | undefined;
    dugovanje?: string | undefined;
    greska?: string | undefined;

    constructor(data?: IImportInoKupciDobavljaciDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registracioniBroj = _data["registracioniBroj"];
            this.naziv = _data["naziv"];
            this.grad = _data["grad"];
            this.drzava = _data["drzava"];
            this.potrazivanje = _data["potrazivanje"];
            this.dugovanje = _data["dugovanje"];
            this.greska = _data["greska"];
        }
    }

    static fromJS(data: any): ImportInoKupciDobavljaciDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportInoKupciDobavljaciDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registracioniBroj"] = this.registracioniBroj;
        data["naziv"] = this.naziv;
        data["grad"] = this.grad;
        data["drzava"] = this.drzava;
        data["potrazivanje"] = this.potrazivanje;
        data["dugovanje"] = this.dugovanje;
        data["greska"] = this.greska;
        return data;
    }
}

export interface IImportInoKupciDobavljaciDto {
    id?: number;
    registracioniBroj?: string | undefined;
    naziv?: string | undefined;
    grad?: string | undefined;
    drzava?: string | undefined;
    potrazivanje?: string | undefined;
    dugovanje?: string | undefined;
    greska?: string | undefined;
}

export class ExportPravnoLiceCommand implements IExportPravnoLiceCommand {
    format?: FormatIzvoza;

    constructor(data?: IExportPravnoLiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.format = _data["format"];
        }
    }

    static fromJS(data: any): ExportPravnoLiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExportPravnoLiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["format"] = this.format;
        return data;
    }
}

export interface IExportPravnoLiceCommand {
    format?: FormatIzvoza;
}

export enum FormatIzvoza {
    INFORMATIKA_TXT = 0,
    EXCEL_XLS = 1,
}

export class GetPredmeteStavkiVm implements IGetPredmeteStavkiVm {
    predmetiStavki?: PredmetStavkeDto[] | undefined;

    constructor(data?: IGetPredmeteStavkiVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["predmetiStavki"])) {
                this.predmetiStavki = [] as any;
                for (let item of _data["predmetiStavki"])
                    this.predmetiStavki!.push(PredmetStavkeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPredmeteStavkiVm {
        data = typeof data === 'object' ? data : {};
        let result = new GetPredmeteStavkiVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.predmetiStavki)) {
            data["predmetiStavki"] = [];
            for (let item of this.predmetiStavki)
                data["predmetiStavki"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPredmeteStavkiVm {
    predmetiStavki?: PredmetStavkeDto[] | undefined;
}

export class GetPredmeteStavkiRequestDto implements IGetPredmeteStavkiRequestDto {
    sifraIliNaziv?: string | undefined;
    excludeTipovePredmeta?: TipPredmeta[] | undefined;
    excludePredmeteStavkiIds?: number[] | undefined;
    excludeTipoveArtikla?: TipArtikla[] | undefined;

    constructor(data?: IGetPredmeteStavkiRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifraIliNaziv = _data["sifraIliNaziv"];
            if (Array.isArray(_data["excludeTipovePredmeta"])) {
                this.excludeTipovePredmeta = [] as any;
                for (let item of _data["excludeTipovePredmeta"])
                    this.excludeTipovePredmeta!.push(item);
            }
            if (Array.isArray(_data["excludePredmeteStavkiIds"])) {
                this.excludePredmeteStavkiIds = [] as any;
                for (let item of _data["excludePredmeteStavkiIds"])
                    this.excludePredmeteStavkiIds!.push(item);
            }
            if (Array.isArray(_data["excludeTipoveArtikla"])) {
                this.excludeTipoveArtikla = [] as any;
                for (let item of _data["excludeTipoveArtikla"])
                    this.excludeTipoveArtikla!.push(item);
            }
        }
    }

    static fromJS(data: any): GetPredmeteStavkiRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPredmeteStavkiRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifraIliNaziv"] = this.sifraIliNaziv;
        if (Array.isArray(this.excludeTipovePredmeta)) {
            data["excludeTipovePredmeta"] = [];
            for (let item of this.excludeTipovePredmeta)
                data["excludeTipovePredmeta"].push(item);
        }
        if (Array.isArray(this.excludePredmeteStavkiIds)) {
            data["excludePredmeteStavkiIds"] = [];
            for (let item of this.excludePredmeteStavkiIds)
                data["excludePredmeteStavkiIds"].push(item);
        }
        if (Array.isArray(this.excludeTipoveArtikla)) {
            data["excludeTipoveArtikla"] = [];
            for (let item of this.excludeTipoveArtikla)
                data["excludeTipoveArtikla"].push(item);
        }
        return data;
    }
}

export interface IGetPredmeteStavkiRequestDto {
    sifraIliNaziv?: string | undefined;
    excludeTipovePredmeta?: TipPredmeta[] | undefined;
    excludePredmeteStavkiIds?: number[] | undefined;
    excludeTipoveArtikla?: TipArtikla[] | undefined;
}

export class GetPredmeteStavkiQuery extends GetPredmeteStavkiRequestDto implements IGetPredmeteStavkiQuery {

    constructor(data?: IGetPredmeteStavkiQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetPredmeteStavkiQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPredmeteStavkiQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetPredmeteStavkiQuery extends IGetPredmeteStavkiRequestDto {
}

export class GetPredmeteStavkiZaRacunVm implements IGetPredmeteStavkiZaRacunVm {
    predmetiStavki?: PredmetStavkeDto[] | undefined;
    predmetiStavkiZaRacune?: PredmetStavkeZaRacunDto[] | undefined;

    constructor(data?: IGetPredmeteStavkiZaRacunVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["predmetiStavki"])) {
                this.predmetiStavki = [] as any;
                for (let item of _data["predmetiStavki"])
                    this.predmetiStavki!.push(PredmetStavkeDto.fromJS(item));
            }
            if (Array.isArray(_data["predmetiStavkiZaRacune"])) {
                this.predmetiStavkiZaRacune = [] as any;
                for (let item of _data["predmetiStavkiZaRacune"])
                    this.predmetiStavkiZaRacune!.push(PredmetStavkeZaRacunDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPredmeteStavkiZaRacunVm {
        data = typeof data === 'object' ? data : {};
        let result = new GetPredmeteStavkiZaRacunVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.predmetiStavki)) {
            data["predmetiStavki"] = [];
            for (let item of this.predmetiStavki)
                data["predmetiStavki"].push(item.toJSON());
        }
        if (Array.isArray(this.predmetiStavkiZaRacune)) {
            data["predmetiStavkiZaRacune"] = [];
            for (let item of this.predmetiStavkiZaRacune)
                data["predmetiStavkiZaRacune"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPredmeteStavkiZaRacunVm {
    predmetiStavki?: PredmetStavkeDto[] | undefined;
    predmetiStavkiZaRacune?: PredmetStavkeZaRacunDto[] | undefined;
}

export class PredmetStavkeZaRacunDto implements IPredmetStavkeZaRacunDto {
    id?: number;
    naziv?: string | undefined;
    sifra?: string | undefined;
    opis?: string | undefined;
    tipArtiklaStr?: string | undefined;
    jedinicaMereStr?: string | undefined;
    tipPredmeta?: TipPredmeta;
    tipPredmetaStr?: string | undefined;
    cenaStr?: string | undefined;
    cena?: number;
    prodajnaCena?: number;
    stranaValutaId?: string | undefined;
    valutaText?: string | undefined;
    osnovnaCena?: number | undefined;
    magacinLagerResponseList?: MagacinLagerResponse[] | undefined;

    constructor(data?: IPredmetStavkeZaRacunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.tipArtiklaStr = _data["tipArtiklaStr"];
            this.jedinicaMereStr = _data["jedinicaMereStr"];
            this.tipPredmeta = _data["tipPredmeta"];
            this.tipPredmetaStr = _data["tipPredmetaStr"];
            this.cenaStr = _data["cenaStr"];
            this.cena = _data["cena"];
            this.prodajnaCena = _data["prodajnaCena"];
            this.stranaValutaId = _data["stranaValutaId"];
            this.valutaText = _data["valutaText"];
            this.osnovnaCena = _data["osnovnaCena"];
            if (Array.isArray(_data["magacinLagerResponseList"])) {
                this.magacinLagerResponseList = [] as any;
                for (let item of _data["magacinLagerResponseList"])
                    this.magacinLagerResponseList!.push(MagacinLagerResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PredmetStavkeZaRacunDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredmetStavkeZaRacunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["tipArtiklaStr"] = this.tipArtiklaStr;
        data["jedinicaMereStr"] = this.jedinicaMereStr;
        data["tipPredmeta"] = this.tipPredmeta;
        data["tipPredmetaStr"] = this.tipPredmetaStr;
        data["cenaStr"] = this.cenaStr;
        data["cena"] = this.cena;
        data["prodajnaCena"] = this.prodajnaCena;
        data["stranaValutaId"] = this.stranaValutaId;
        data["valutaText"] = this.valutaText;
        data["osnovnaCena"] = this.osnovnaCena;
        if (Array.isArray(this.magacinLagerResponseList)) {
            data["magacinLagerResponseList"] = [];
            for (let item of this.magacinLagerResponseList)
                data["magacinLagerResponseList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPredmetStavkeZaRacunDto {
    id?: number;
    naziv?: string | undefined;
    sifra?: string | undefined;
    opis?: string | undefined;
    tipArtiklaStr?: string | undefined;
    jedinicaMereStr?: string | undefined;
    tipPredmeta?: TipPredmeta;
    tipPredmetaStr?: string | undefined;
    cenaStr?: string | undefined;
    cena?: number;
    prodajnaCena?: number;
    stranaValutaId?: string | undefined;
    valutaText?: string | undefined;
    osnovnaCena?: number | undefined;
    magacinLagerResponseList?: MagacinLagerResponse[] | undefined;
}

export class MagacinLagerResponse implements IMagacinLagerResponse {
    nazivMagacina?: string | undefined;
    stanje?: number;
    rezervisano?: number;
    raspolozivo?: number;

    constructor(data?: IMagacinLagerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nazivMagacina = _data["nazivMagacina"];
            this.stanje = _data["stanje"];
            this.rezervisano = _data["rezervisano"];
            this.raspolozivo = _data["raspolozivo"];
        }
    }

    static fromJS(data: any): MagacinLagerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MagacinLagerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nazivMagacina"] = this.nazivMagacina;
        data["stanje"] = this.stanje;
        data["rezervisano"] = this.rezervisano;
        data["raspolozivo"] = this.raspolozivo;
        return data;
    }
}

export interface IMagacinLagerResponse {
    nazivMagacina?: string | undefined;
    stanje?: number;
    rezervisano?: number;
    raspolozivo?: number;
}

export class GetPredmeteStavkiZaRacunQuery implements IGetPredmeteStavkiZaRacunQuery {
    sifraIliNaziv?: string | undefined;
    excludeTipovePredmeta?: TipPredmeta[] | undefined;
    cenovnikId?: number | undefined;
    includeMaterijal?: boolean;
    jeUsluznaDelatnost?: boolean;
    tipRacuna?: TipRacuna;
    vrstaRadnogNaloga?: VrstaRadnogNaloga;

    constructor(data?: IGetPredmeteStavkiZaRacunQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifraIliNaziv = _data["sifraIliNaziv"];
            if (Array.isArray(_data["excludeTipovePredmeta"])) {
                this.excludeTipovePredmeta = [] as any;
                for (let item of _data["excludeTipovePredmeta"])
                    this.excludeTipovePredmeta!.push(item);
            }
            this.cenovnikId = _data["cenovnikId"];
            this.includeMaterijal = _data["includeMaterijal"];
            this.jeUsluznaDelatnost = _data["jeUsluznaDelatnost"];
            this.tipRacuna = _data["tipRacuna"];
            this.vrstaRadnogNaloga = _data["vrstaRadnogNaloga"];
        }
    }

    static fromJS(data: any): GetPredmeteStavkiZaRacunQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPredmeteStavkiZaRacunQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifraIliNaziv"] = this.sifraIliNaziv;
        if (Array.isArray(this.excludeTipovePredmeta)) {
            data["excludeTipovePredmeta"] = [];
            for (let item of this.excludeTipovePredmeta)
                data["excludeTipovePredmeta"].push(item);
        }
        data["cenovnikId"] = this.cenovnikId;
        data["includeMaterijal"] = this.includeMaterijal;
        data["jeUsluznaDelatnost"] = this.jeUsluznaDelatnost;
        data["tipRacuna"] = this.tipRacuna;
        data["vrstaRadnogNaloga"] = this.vrstaRadnogNaloga;
        return data;
    }
}

export interface IGetPredmeteStavkiZaRacunQuery {
    sifraIliNaziv?: string | undefined;
    excludeTipovePredmeta?: TipPredmeta[] | undefined;
    cenovnikId?: number | undefined;
    includeMaterijal?: boolean;
    jeUsluznaDelatnost?: boolean;
    tipRacuna?: TipRacuna;
    vrstaRadnogNaloga?: VrstaRadnogNaloga;
}

export class GetPredmeteStavkiZaEotpremnicuVm implements IGetPredmeteStavkiZaEotpremnicuVm {
    predmetiStavki?: PredmetStavkeDto[] | undefined;
    predmetiStavkiZaOtpremnicu?: PredmetStavkeZaEOtpremnicuDto[] | undefined;

    constructor(data?: IGetPredmeteStavkiZaEotpremnicuVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["predmetiStavki"])) {
                this.predmetiStavki = [] as any;
                for (let item of _data["predmetiStavki"])
                    this.predmetiStavki!.push(PredmetStavkeDto.fromJS(item));
            }
            if (Array.isArray(_data["predmetiStavkiZaOtpremnicu"])) {
                this.predmetiStavkiZaOtpremnicu = [] as any;
                for (let item of _data["predmetiStavkiZaOtpremnicu"])
                    this.predmetiStavkiZaOtpremnicu!.push(PredmetStavkeZaEOtpremnicuDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPredmeteStavkiZaEotpremnicuVm {
        data = typeof data === 'object' ? data : {};
        let result = new GetPredmeteStavkiZaEotpremnicuVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.predmetiStavki)) {
            data["predmetiStavki"] = [];
            for (let item of this.predmetiStavki)
                data["predmetiStavki"].push(item.toJSON());
        }
        if (Array.isArray(this.predmetiStavkiZaOtpremnicu)) {
            data["predmetiStavkiZaOtpremnicu"] = [];
            for (let item of this.predmetiStavkiZaOtpremnicu)
                data["predmetiStavkiZaOtpremnicu"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPredmeteStavkiZaEotpremnicuVm {
    predmetiStavki?: PredmetStavkeDto[] | undefined;
    predmetiStavkiZaOtpremnicu?: PredmetStavkeZaEOtpremnicuDto[] | undefined;
}

export class PredmetStavkeZaEOtpremnicuDto implements IPredmetStavkeZaEOtpremnicuDto {
    id?: number;
    naziv?: string | undefined;
    sifra?: string | undefined;
    tipArtiklaStr?: string | undefined;
    jedinicaMereStr?: string | undefined;
    tipPredmeta?: TipPredmeta;
    tipPredmetaStr?: string | undefined;
    magacinLagerResponseList?: MagacinLagerResponse[] | undefined;

    constructor(data?: IPredmetStavkeZaEOtpremnicuDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.sifra = _data["sifra"];
            this.tipArtiklaStr = _data["tipArtiklaStr"];
            this.jedinicaMereStr = _data["jedinicaMereStr"];
            this.tipPredmeta = _data["tipPredmeta"];
            this.tipPredmetaStr = _data["tipPredmetaStr"];
            if (Array.isArray(_data["magacinLagerResponseList"])) {
                this.magacinLagerResponseList = [] as any;
                for (let item of _data["magacinLagerResponseList"])
                    this.magacinLagerResponseList!.push(MagacinLagerResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PredmetStavkeZaEOtpremnicuDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredmetStavkeZaEOtpremnicuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["sifra"] = this.sifra;
        data["tipArtiklaStr"] = this.tipArtiklaStr;
        data["jedinicaMereStr"] = this.jedinicaMereStr;
        data["tipPredmeta"] = this.tipPredmeta;
        data["tipPredmetaStr"] = this.tipPredmetaStr;
        if (Array.isArray(this.magacinLagerResponseList)) {
            data["magacinLagerResponseList"] = [];
            for (let item of this.magacinLagerResponseList)
                data["magacinLagerResponseList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPredmetStavkeZaEOtpremnicuDto {
    id?: number;
    naziv?: string | undefined;
    sifra?: string | undefined;
    tipArtiklaStr?: string | undefined;
    jedinicaMereStr?: string | undefined;
    tipPredmeta?: TipPredmeta;
    tipPredmetaStr?: string | undefined;
    magacinLagerResponseList?: MagacinLagerResponse[] | undefined;
}

export class GetPredmeteStavkiZaEotpremnicuQuery implements IGetPredmeteStavkiZaEotpremnicuQuery {
    sifraIliNaziv?: string | undefined;
    includeMaterijal?: boolean;
    magacinId?: number | undefined;

    constructor(data?: IGetPredmeteStavkiZaEotpremnicuQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifraIliNaziv = _data["sifraIliNaziv"];
            this.includeMaterijal = _data["includeMaterijal"];
            this.magacinId = _data["magacinId"];
        }
    }

    static fromJS(data: any): GetPredmeteStavkiZaEotpremnicuQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPredmeteStavkiZaEotpremnicuQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifraIliNaziv"] = this.sifraIliNaziv;
        data["includeMaterijal"] = this.includeMaterijal;
        data["magacinId"] = this.magacinId;
        return data;
    }
}

export interface IGetPredmeteStavkiZaEotpremnicuQuery {
    sifraIliNaziv?: string | undefined;
    includeMaterijal?: boolean;
    magacinId?: number | undefined;
}

export class CreatePredracunCommand implements ICreatePredracunCommand {
    rokVazenja?: number;
    jePonuda?: boolean;
    racunDto?: RacunDto | undefined;

    constructor(data?: ICreatePredracunCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rokVazenja = _data["rokVazenja"];
            this.jePonuda = _data["jePonuda"];
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreatePredracunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePredracunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rokVazenja"] = this.rokVazenja;
        data["jePonuda"] = this.jePonuda;
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreatePredracunCommand {
    rokVazenja?: number;
    jePonuda?: boolean;
    racunDto?: RacunDto | undefined;
}

export class UpdatePredracunCommand implements IUpdatePredracunCommand {
    rokVazenja?: number;
    jePonuda?: boolean;
    racunDto?: RacunDto | undefined;

    constructor(data?: IUpdatePredracunCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rokVazenja = _data["rokVazenja"];
            this.jePonuda = _data["jePonuda"];
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePredracunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePredracunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rokVazenja"] = this.rokVazenja;
        data["jePonuda"] = this.jePonuda;
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdatePredracunCommand {
    rokVazenja?: number;
    jePonuda?: boolean;
    racunDto?: RacunDto | undefined;
}

export class ResultOfPredracunDto extends Result implements IResultOfPredracunDto {
    data?: PredracunDto | undefined;

    constructor(data?: IResultOfPredracunDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PredracunDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfPredracunDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfPredracunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfPredracunDto extends IResult {
    data?: PredracunDto | undefined;
}

export class PredracunDto implements IPredracunDto {
    racunDto?: RacunDto | undefined;
    rokVazenja?: number;
    jePonuda?: boolean;

    constructor(data?: IPredracunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.rokVazenja = _data["rokVazenja"];
            this.jePonuda = _data["jePonuda"];
        }
    }

    static fromJS(data: any): PredracunDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredracunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["rokVazenja"] = this.rokVazenja;
        data["jePonuda"] = this.jePonuda;
        return data;
    }
}

export interface IPredracunDto {
    racunDto?: RacunDto | undefined;
    rokVazenja?: number;
    jePonuda?: boolean;
}

export class GetPredracunQuery implements IGetPredracunQuery {
    id?: number;

    constructor(data?: IGetPredracunQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetPredracunQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPredracunQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetPredracunQuery {
    id?: number;
}

export class CancelPredracunCommand implements ICancelPredracunCommand {
    racunId?: number;

    constructor(data?: ICancelPredracunCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
        }
    }

    static fromJS(data: any): CancelPredracunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPredracunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        return data;
    }
}

export interface ICancelPredracunCommand {
    racunId?: number;
}

export class PaginatedResultOfRacunTableDto extends Result implements IPaginatedResultOfRacunTableDto {
    data?: RacunTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfRacunTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RacunTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfRacunTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfRacunTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfRacunTableDto extends IResult {
    data?: RacunTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PaginatedResultOfRacunTableDtoAndRacunSaldoDto extends PaginatedResultOfRacunTableDto implements IPaginatedResultOfRacunTableDtoAndRacunSaldoDto {
    summaryData?: RacunSaldoDto | undefined;

    constructor(data?: IPaginatedResultOfRacunTableDtoAndRacunSaldoDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.summaryData = _data["summaryData"] ? RacunSaldoDto.fromJS(_data["summaryData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaginatedResultOfRacunTableDtoAndRacunSaldoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfRacunTableDtoAndRacunSaldoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summaryData"] = this.summaryData ? this.summaryData.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfRacunTableDtoAndRacunSaldoDto extends IPaginatedResultOfRacunTableDto {
    summaryData?: RacunSaldoDto | undefined;
}

export class RacunSaldoDto implements IRacunSaldoDto {
    iznosOsnovica?: number;
    iznosPDV?: number;
    iznosPDV10?: number;
    iznosPDV20?: number;
    ukupanIznos?: number | undefined;
    placanja?: number;
    iznosVanValute?: number;
    ukupanAvansiranIznos?: number;
    ukupanIznosDokumentaOSmanjenju?: number;
    ukupanIznosDokumentaOPovecanju?: number;
    brojFakturaVanValute?: number;

    constructor(data?: IRacunSaldoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iznosOsnovica = _data["iznosOsnovica"];
            this.iznosPDV = _data["iznosPDV"];
            this.iznosPDV10 = _data["iznosPDV10"];
            this.iznosPDV20 = _data["iznosPDV20"];
            this.ukupanIznos = _data["ukupanIznos"];
            this.placanja = _data["placanja"];
            this.iznosVanValute = _data["iznosVanValute"];
            this.ukupanAvansiranIznos = _data["ukupanAvansiranIznos"];
            this.ukupanIznosDokumentaOSmanjenju = _data["ukupanIznosDokumentaOSmanjenju"];
            this.ukupanIznosDokumentaOPovecanju = _data["ukupanIznosDokumentaOPovecanju"];
            this.brojFakturaVanValute = _data["brojFakturaVanValute"];
        }
    }

    static fromJS(data: any): RacunSaldoDto {
        data = typeof data === 'object' ? data : {};
        let result = new RacunSaldoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iznosOsnovica"] = this.iznosOsnovica;
        data["iznosPDV"] = this.iznosPDV;
        data["iznosPDV10"] = this.iznosPDV10;
        data["iznosPDV20"] = this.iznosPDV20;
        data["ukupanIznos"] = this.ukupanIznos;
        data["placanja"] = this.placanja;
        data["iznosVanValute"] = this.iznosVanValute;
        data["ukupanAvansiranIznos"] = this.ukupanAvansiranIznos;
        data["ukupanIznosDokumentaOSmanjenju"] = this.ukupanIznosDokumentaOSmanjenju;
        data["ukupanIznosDokumentaOPovecanju"] = this.ukupanIznosDokumentaOPovecanju;
        data["brojFakturaVanValute"] = this.brojFakturaVanValute;
        return data;
    }
}

export interface IRacunSaldoDto {
    iznosOsnovica?: number;
    iznosPDV?: number;
    iznosPDV10?: number;
    iznosPDV20?: number;
    ukupanIznos?: number | undefined;
    placanja?: number;
    iznosVanValute?: number;
    ukupanAvansiranIznos?: number;
    ukupanIznosDokumentaOSmanjenju?: number;
    ukupanIznosDokumentaOPovecanju?: number;
    brojFakturaVanValute?: number;
}

export class RacunTableDto implements IRacunTableDto {
    id?: number;
    sefIdIzlazni?: number | undefined;
    sefIdUlazni?: number | undefined;
    broj?: string | undefined;
    originalanBroj?: string | undefined;
    datumSlanjaSef?: string | undefined;
    datumSlanjaEmail?: string | undefined;
    datumPrometa?: string | undefined;
    datumIzdavanja?: string | undefined;
    stranka?: string | undefined;
    iznos?: number;
    iznosRSD?: number | undefined;
    vrstaRacuna?: VrstaRacuna;
    vrstaRacunaStr?: string | undefined;
    rutiranjeStranke?: RutiranjeStrankeDto | undefined;
    vezaniRacuniDto?: VezaniRacunDto[] | undefined;
    eOtpremnice?: EOtpremnicaUzRacunDto[] | undefined;
    ePrijemnice?: EPrijemnicaUzRacunDto[] | undefined;
    imaRobuIzViseMagacina?: boolean;
    datumValute?: string | undefined;
    statusRacunaDto?: StatusRacunaDto | undefined;
    crfStatusDto?: CrfStatusDto | undefined;
    statusRadnogNalogaDto?: StatusRadnogNalogaDto | undefined;
    statusUplateDto?: StatusUplateRacunaDto | undefined;
    tipRacunaDto?: TipRacunaDto | undefined;
    valutaText?: string | undefined;
    imeLokacijeMestaIsporuke?: string | undefined;
    potrebnaObrada?: boolean;
    mozeNaSef?: boolean;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
    minimaxId?: number | undefined;
    imaPdvEvidenciju39?: boolean;

    constructor(data?: IRacunTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sefIdIzlazni = _data["sefIdIzlazni"];
            this.sefIdUlazni = _data["sefIdUlazni"];
            this.broj = _data["broj"];
            this.originalanBroj = _data["originalanBroj"];
            this.datumSlanjaSef = _data["datumSlanjaSef"];
            this.datumSlanjaEmail = _data["datumSlanjaEmail"];
            this.datumPrometa = _data["datumPrometa"];
            this.datumIzdavanja = _data["datumIzdavanja"];
            this.stranka = _data["stranka"];
            this.iznos = _data["iznos"];
            this.iznosRSD = _data["iznosRSD"];
            this.vrstaRacuna = _data["vrstaRacuna"];
            this.vrstaRacunaStr = _data["vrstaRacunaStr"];
            this.rutiranjeStranke = _data["rutiranjeStranke"] ? RutiranjeStrankeDto.fromJS(_data["rutiranjeStranke"]) : <any>undefined;
            if (Array.isArray(_data["vezaniRacuniDto"])) {
                this.vezaniRacuniDto = [] as any;
                for (let item of _data["vezaniRacuniDto"])
                    this.vezaniRacuniDto!.push(VezaniRacunDto.fromJS(item));
            }
            if (Array.isArray(_data["eOtpremnice"])) {
                this.eOtpremnice = [] as any;
                for (let item of _data["eOtpremnice"])
                    this.eOtpremnice!.push(EOtpremnicaUzRacunDto.fromJS(item));
            }
            if (Array.isArray(_data["ePrijemnice"])) {
                this.ePrijemnice = [] as any;
                for (let item of _data["ePrijemnice"])
                    this.ePrijemnice!.push(EPrijemnicaUzRacunDto.fromJS(item));
            }
            this.imaRobuIzViseMagacina = _data["imaRobuIzViseMagacina"];
            this.datumValute = _data["datumValute"];
            this.statusRacunaDto = _data["statusRacunaDto"] ? StatusRacunaDto.fromJS(_data["statusRacunaDto"]) : <any>undefined;
            this.crfStatusDto = _data["crfStatusDto"] ? CrfStatusDto.fromJS(_data["crfStatusDto"]) : <any>undefined;
            this.statusRadnogNalogaDto = _data["statusRadnogNalogaDto"] ? StatusRadnogNalogaDto.fromJS(_data["statusRadnogNalogaDto"]) : <any>undefined;
            this.statusUplateDto = _data["statusUplateDto"] ? StatusUplateRacunaDto.fromJS(_data["statusUplateDto"]) : <any>undefined;
            this.tipRacunaDto = _data["tipRacunaDto"] ? TipRacunaDto.fromJS(_data["tipRacunaDto"]) : <any>undefined;
            this.valutaText = _data["valutaText"];
            this.imeLokacijeMestaIsporuke = _data["imeLokacijeMestaIsporuke"];
            this.potrebnaObrada = _data["potrebnaObrada"];
            this.mozeNaSef = _data["mozeNaSef"];
            this.klasifikacijaRacuna = _data["klasifikacijaRacuna"];
            this.pravoNaPdvOdbitak = _data["pravoNaPdvOdbitak"];
            this.minimaxId = _data["minimaxId"];
            this.imaPdvEvidenciju39 = _data["imaPdvEvidenciju39"];
        }
    }

    static fromJS(data: any): RacunTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RacunTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sefIdIzlazni"] = this.sefIdIzlazni;
        data["sefIdUlazni"] = this.sefIdUlazni;
        data["broj"] = this.broj;
        data["originalanBroj"] = this.originalanBroj;
        data["datumSlanjaSef"] = this.datumSlanjaSef;
        data["datumSlanjaEmail"] = this.datumSlanjaEmail;
        data["datumPrometa"] = this.datumPrometa;
        data["datumIzdavanja"] = this.datumIzdavanja;
        data["stranka"] = this.stranka;
        data["iznos"] = this.iznos;
        data["iznosRSD"] = this.iznosRSD;
        data["vrstaRacuna"] = this.vrstaRacuna;
        data["vrstaRacunaStr"] = this.vrstaRacunaStr;
        data["rutiranjeStranke"] = this.rutiranjeStranke ? this.rutiranjeStranke.toJSON() : <any>undefined;
        if (Array.isArray(this.vezaniRacuniDto)) {
            data["vezaniRacuniDto"] = [];
            for (let item of this.vezaniRacuniDto)
                data["vezaniRacuniDto"].push(item.toJSON());
        }
        if (Array.isArray(this.eOtpremnice)) {
            data["eOtpremnice"] = [];
            for (let item of this.eOtpremnice)
                data["eOtpremnice"].push(item.toJSON());
        }
        if (Array.isArray(this.ePrijemnice)) {
            data["ePrijemnice"] = [];
            for (let item of this.ePrijemnice)
                data["ePrijemnice"].push(item.toJSON());
        }
        data["imaRobuIzViseMagacina"] = this.imaRobuIzViseMagacina;
        data["datumValute"] = this.datumValute;
        data["statusRacunaDto"] = this.statusRacunaDto ? this.statusRacunaDto.toJSON() : <any>undefined;
        data["crfStatusDto"] = this.crfStatusDto ? this.crfStatusDto.toJSON() : <any>undefined;
        data["statusRadnogNalogaDto"] = this.statusRadnogNalogaDto ? this.statusRadnogNalogaDto.toJSON() : <any>undefined;
        data["statusUplateDto"] = this.statusUplateDto ? this.statusUplateDto.toJSON() : <any>undefined;
        data["tipRacunaDto"] = this.tipRacunaDto ? this.tipRacunaDto.toJSON() : <any>undefined;
        data["valutaText"] = this.valutaText;
        data["imeLokacijeMestaIsporuke"] = this.imeLokacijeMestaIsporuke;
        data["potrebnaObrada"] = this.potrebnaObrada;
        data["mozeNaSef"] = this.mozeNaSef;
        data["klasifikacijaRacuna"] = this.klasifikacijaRacuna;
        data["pravoNaPdvOdbitak"] = this.pravoNaPdvOdbitak;
        data["minimaxId"] = this.minimaxId;
        data["imaPdvEvidenciju39"] = this.imaPdvEvidenciju39;
        return data;
    }
}

export interface IRacunTableDto {
    id?: number;
    sefIdIzlazni?: number | undefined;
    sefIdUlazni?: number | undefined;
    broj?: string | undefined;
    originalanBroj?: string | undefined;
    datumSlanjaSef?: string | undefined;
    datumSlanjaEmail?: string | undefined;
    datumPrometa?: string | undefined;
    datumIzdavanja?: string | undefined;
    stranka?: string | undefined;
    iznos?: number;
    iznosRSD?: number | undefined;
    vrstaRacuna?: VrstaRacuna;
    vrstaRacunaStr?: string | undefined;
    rutiranjeStranke?: RutiranjeStrankeDto | undefined;
    vezaniRacuniDto?: VezaniRacunDto[] | undefined;
    eOtpremnice?: EOtpremnicaUzRacunDto[] | undefined;
    ePrijemnice?: EPrijemnicaUzRacunDto[] | undefined;
    imaRobuIzViseMagacina?: boolean;
    datumValute?: string | undefined;
    statusRacunaDto?: StatusRacunaDto | undefined;
    crfStatusDto?: CrfStatusDto | undefined;
    statusRadnogNalogaDto?: StatusRadnogNalogaDto | undefined;
    statusUplateDto?: StatusUplateRacunaDto | undefined;
    tipRacunaDto?: TipRacunaDto | undefined;
    valutaText?: string | undefined;
    imeLokacijeMestaIsporuke?: string | undefined;
    potrebnaObrada?: boolean;
    mozeNaSef?: boolean;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
    minimaxId?: number | undefined;
    imaPdvEvidenciju39?: boolean;
}

export class EOtpremnicaUzRacunDto implements IEOtpremnicaUzRacunDto {
    id?: number;
    label?: string | undefined;
    datumIzdavanja?: string | undefined;
    vrstaDokumenta?: VrstaDokumentaOtpremnica;

    constructor(data?: IEOtpremnicaUzRacunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.datumIzdavanja = _data["datumIzdavanja"];
            this.vrstaDokumenta = _data["vrstaDokumenta"];
        }
    }

    static fromJS(data: any): EOtpremnicaUzRacunDto {
        data = typeof data === 'object' ? data : {};
        let result = new EOtpremnicaUzRacunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["datumIzdavanja"] = this.datumIzdavanja;
        data["vrstaDokumenta"] = this.vrstaDokumenta;
        return data;
    }
}

export interface IEOtpremnicaUzRacunDto {
    id?: number;
    label?: string | undefined;
    datumIzdavanja?: string | undefined;
    vrstaDokumenta?: VrstaDokumentaOtpremnica;
}

export class EPrijemnicaUzRacunDto implements IEPrijemnicaUzRacunDto {
    id?: number;
    label?: string | undefined;
    datumIzdavanja?: string | undefined;
    vrstaDokumenta?: VrstaDokumentaOtpremnica;

    constructor(data?: IEPrijemnicaUzRacunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.datumIzdavanja = _data["datumIzdavanja"];
            this.vrstaDokumenta = _data["vrstaDokumenta"];
        }
    }

    static fromJS(data: any): EPrijemnicaUzRacunDto {
        data = typeof data === 'object' ? data : {};
        let result = new EPrijemnicaUzRacunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["datumIzdavanja"] = this.datumIzdavanja;
        data["vrstaDokumenta"] = this.vrstaDokumenta;
        return data;
    }
}

export interface IEPrijemnicaUzRacunDto {
    id?: number;
    label?: string | undefined;
    datumIzdavanja?: string | undefined;
    vrstaDokumenta?: VrstaDokumentaOtpremnica;
}

export class StatusRacunaDto implements IStatusRacunaDto {
    status?: StatusRacuna;
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IStatusRacunaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.statusStr = _data["statusStr"];
            this.statusBadgeStr = _data["statusBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): StatusRacunaDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusRacunaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["statusStr"] = this.statusStr;
        data["statusBadgeStr"] = this.statusBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IStatusRacunaDto {
    status?: StatusRacuna;
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class CrfStatusDto implements ICrfStatusDto {
    status?: CrfStatus;
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;

    constructor(data?: ICrfStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.statusStr = _data["statusStr"];
            this.statusBadgeStr = _data["statusBadgeStr"];
        }
    }

    static fromJS(data: any): CrfStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CrfStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["statusStr"] = this.statusStr;
        data["statusBadgeStr"] = this.statusBadgeStr;
        return data;
    }
}

export interface ICrfStatusDto {
    status?: CrfStatus;
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;
}

export class StatusRadnogNalogaDto implements IStatusRadnogNalogaDto {
    status?: StatusRadnogNaloga;
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IStatusRadnogNalogaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.statusStr = _data["statusStr"];
            this.statusBadgeStr = _data["statusBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): StatusRadnogNalogaDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusRadnogNalogaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["statusStr"] = this.statusStr;
        data["statusBadgeStr"] = this.statusBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IStatusRadnogNalogaDto {
    status?: StatusRadnogNaloga;
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class StatusUplateRacunaDto implements IStatusUplateRacunaDto {
    status?: StatusUplateRacuna;
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IStatusUplateRacunaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.statusStr = _data["statusStr"];
            this.statusBadgeStr = _data["statusBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): StatusUplateRacunaDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusUplateRacunaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["statusStr"] = this.statusStr;
        data["statusBadgeStr"] = this.statusBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IStatusUplateRacunaDto {
    status?: StatusUplateRacuna;
    statusStr?: string | undefined;
    statusBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class TipRacunaDto implements ITipRacunaDto {
    tip?: TipRacuna;
    tipStr?: string | undefined;
    tipBadgeStr?: string | undefined;
    opis?: string | undefined;
    tipStrLong?: string | undefined;

    constructor(data?: ITipRacunaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tip = _data["tip"];
            this.tipStr = _data["tipStr"];
            this.tipBadgeStr = _data["tipBadgeStr"];
            this.opis = _data["opis"];
            this.tipStrLong = _data["tipStrLong"];
        }
    }

    static fromJS(data: any): TipRacunaDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipRacunaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tip"] = this.tip;
        data["tipStr"] = this.tipStr;
        data["tipBadgeStr"] = this.tipBadgeStr;
        data["opis"] = this.opis;
        data["tipStrLong"] = this.tipStrLong;
        return data;
    }
}

export interface ITipRacunaDto {
    tip?: TipRacuna;
    tipStr?: string | undefined;
    tipBadgeStr?: string | undefined;
    opis?: string | undefined;
    tipStrLong?: string | undefined;
}

export class GetRacunTableQuery implements IGetRacunTableQuery {
    racunFilterId?: number;
    naziv?: string | undefined;
    broj?: string | undefined;
    gradStranke?: string | undefined;
    originalanBroj?: string | undefined;
    brojOtpremnice?: string | undefined;
    dodatniOpisStavke?: string | undefined;
    vrstaRacuna?: VrstaRacuna;
    datumIzdavanjaOd?: Date | undefined;
    datumIzdavanjaDo?: Date | undefined;
    datumSlanjaSefOd?: Date | undefined;
    datumSlanjaSefDo?: Date | undefined;
    datumPrometaOd?: Date | undefined;
    datumPrometaDo?: Date | undefined;
    datumValute?: Date | undefined;
    period?: PdvPeriod | undefined;
    valutaIsticeZa?: number | undefined;
    prometOd?: number | undefined;
    prometDo?: number | undefined;
    stranke?: StrankaMultiSelectItem[] | undefined;
    strankaId?: number | undefined;
    statusi?: StatusRacunaDto[] | undefined;
    tip?: TipRacuna;
    createByEmail?: string | undefined;
    oznake?: GetOznakaMultiselectResponse[] | undefined;
    statusiUplateRacuna?: StatusUplateRacunaDto[] | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    vanValute?: boolean | undefined;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetRacunTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunFilterId = _data["racunFilterId"];
            this.naziv = _data["naziv"];
            this.broj = _data["broj"];
            this.gradStranke = _data["gradStranke"];
            this.originalanBroj = _data["originalanBroj"];
            this.brojOtpremnice = _data["brojOtpremnice"];
            this.dodatniOpisStavke = _data["dodatniOpisStavke"];
            this.vrstaRacuna = _data["vrstaRacuna"];
            this.datumIzdavanjaOd = _data["datumIzdavanjaOd"] ? new Date(_data["datumIzdavanjaOd"].toString()) : <any>undefined;
            this.datumIzdavanjaDo = _data["datumIzdavanjaDo"] ? new Date(_data["datumIzdavanjaDo"].toString()) : <any>undefined;
            this.datumSlanjaSefOd = _data["datumSlanjaSefOd"] ? new Date(_data["datumSlanjaSefOd"].toString()) : <any>undefined;
            this.datumSlanjaSefDo = _data["datumSlanjaSefDo"] ? new Date(_data["datumSlanjaSefDo"].toString()) : <any>undefined;
            this.datumPrometaOd = _data["datumPrometaOd"] ? new Date(_data["datumPrometaOd"].toString()) : <any>undefined;
            this.datumPrometaDo = _data["datumPrometaDo"] ? new Date(_data["datumPrometaDo"].toString()) : <any>undefined;
            this.datumValute = _data["datumValute"] ? new Date(_data["datumValute"].toString()) : <any>undefined;
            this.period = _data["period"];
            this.valutaIsticeZa = _data["valutaIsticeZa"];
            this.prometOd = _data["prometOd"];
            this.prometDo = _data["prometDo"];
            if (Array.isArray(_data["stranke"])) {
                this.stranke = [] as any;
                for (let item of _data["stranke"])
                    this.stranke!.push(StrankaMultiSelectItem.fromJS(item));
            }
            this.strankaId = _data["strankaId"];
            if (Array.isArray(_data["statusi"])) {
                this.statusi = [] as any;
                for (let item of _data["statusi"])
                    this.statusi!.push(StatusRacunaDto.fromJS(item));
            }
            this.tip = _data["tip"];
            this.createByEmail = _data["createByEmail"];
            if (Array.isArray(_data["oznake"])) {
                this.oznake = [] as any;
                for (let item of _data["oznake"])
                    this.oznake!.push(GetOznakaMultiselectResponse.fromJS(item));
            }
            if (Array.isArray(_data["statusiUplateRacuna"])) {
                this.statusiUplateRacuna = [] as any;
                for (let item of _data["statusiUplateRacuna"])
                    this.statusiUplateRacuna!.push(StatusUplateRacunaDto.fromJS(item));
            }
            this.pravoNaPdvOdbitak = _data["pravoNaPdvOdbitak"];
            this.klasifikacijaRacuna = _data["klasifikacijaRacuna"];
            this.vanValute = _data["vanValute"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetRacunTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetRacunTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunFilterId"] = this.racunFilterId;
        data["naziv"] = this.naziv;
        data["broj"] = this.broj;
        data["gradStranke"] = this.gradStranke;
        data["originalanBroj"] = this.originalanBroj;
        data["brojOtpremnice"] = this.brojOtpremnice;
        data["dodatniOpisStavke"] = this.dodatniOpisStavke;
        data["vrstaRacuna"] = this.vrstaRacuna;
        data["datumIzdavanjaOd"] = this.datumIzdavanjaOd ? this.datumIzdavanjaOd.toISOString() : <any>undefined;
        data["datumIzdavanjaDo"] = this.datumIzdavanjaDo ? this.datumIzdavanjaDo.toISOString() : <any>undefined;
        data["datumSlanjaSefOd"] = this.datumSlanjaSefOd ? this.datumSlanjaSefOd.toISOString() : <any>undefined;
        data["datumSlanjaSefDo"] = this.datumSlanjaSefDo ? this.datumSlanjaSefDo.toISOString() : <any>undefined;
        data["datumPrometaOd"] = this.datumPrometaOd ? this.datumPrometaOd.toISOString() : <any>undefined;
        data["datumPrometaDo"] = this.datumPrometaDo ? this.datumPrometaDo.toISOString() : <any>undefined;
        data["datumValute"] = this.datumValute ? this.datumValute.toISOString() : <any>undefined;
        data["period"] = this.period;
        data["valutaIsticeZa"] = this.valutaIsticeZa;
        data["prometOd"] = this.prometOd;
        data["prometDo"] = this.prometDo;
        if (Array.isArray(this.stranke)) {
            data["stranke"] = [];
            for (let item of this.stranke)
                data["stranke"].push(item.toJSON());
        }
        data["strankaId"] = this.strankaId;
        if (Array.isArray(this.statusi)) {
            data["statusi"] = [];
            for (let item of this.statusi)
                data["statusi"].push(item.toJSON());
        }
        data["tip"] = this.tip;
        data["createByEmail"] = this.createByEmail;
        if (Array.isArray(this.oznake)) {
            data["oznake"] = [];
            for (let item of this.oznake)
                data["oznake"].push(item.toJSON());
        }
        if (Array.isArray(this.statusiUplateRacuna)) {
            data["statusiUplateRacuna"] = [];
            for (let item of this.statusiUplateRacuna)
                data["statusiUplateRacuna"].push(item.toJSON());
        }
        data["pravoNaPdvOdbitak"] = this.pravoNaPdvOdbitak;
        data["klasifikacijaRacuna"] = this.klasifikacijaRacuna;
        data["vanValute"] = this.vanValute;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetRacunTableQuery {
    racunFilterId?: number;
    naziv?: string | undefined;
    broj?: string | undefined;
    gradStranke?: string | undefined;
    originalanBroj?: string | undefined;
    brojOtpremnice?: string | undefined;
    dodatniOpisStavke?: string | undefined;
    vrstaRacuna?: VrstaRacuna;
    datumIzdavanjaOd?: Date | undefined;
    datumIzdavanjaDo?: Date | undefined;
    datumSlanjaSefOd?: Date | undefined;
    datumSlanjaSefDo?: Date | undefined;
    datumPrometaOd?: Date | undefined;
    datumPrometaDo?: Date | undefined;
    datumValute?: Date | undefined;
    period?: PdvPeriod | undefined;
    valutaIsticeZa?: number | undefined;
    prometOd?: number | undefined;
    prometDo?: number | undefined;
    stranke?: StrankaMultiSelectItem[] | undefined;
    strankaId?: number | undefined;
    statusi?: StatusRacunaDto[] | undefined;
    tip?: TipRacuna;
    createByEmail?: string | undefined;
    oznake?: GetOznakaMultiselectResponse[] | undefined;
    statusiUplateRacuna?: StatusUplateRacunaDto[] | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    vanValute?: boolean | undefined;
    pageNumber?: number;
    pageSize?: number;
}

export class ResultOfRacunSaldoResult extends Result implements IResultOfRacunSaldoResult {
    data?: RacunSaldoResult | undefined;

    constructor(data?: IResultOfRacunSaldoResult) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? RacunSaldoResult.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfRacunSaldoResult {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfRacunSaldoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfRacunSaldoResult extends IResult {
    data?: RacunSaldoResult | undefined;
}

export class RacunSaldoResult implements IRacunSaldoResult {
    fakturaPrometSaPdv?: number;
    fakturaPrometBezPdv?: number;
    fakturaPlaceno?: number;
    fakturaPlacenoPercent?: number;
    fakturaNeplaceno?: number;
    fakturaNeplacenoCnt?: number;
    fakturaVanValute?: number;
    fakturaVanValuteCnt?: number;
    fakturaDospevaUNarednih30Dana?: number;
    fakturaDospevaUNarednih30DanaCnt?: number;
    fakturaDso90Dana?: number;
    fakturaBroj?: number;
    fakturaPdv10?: number;
    fakturaPdv20?: number;
    fakturaPdv?: number;
    avansUkupnoSaPdv?: number;
    avansUkupnoBezPdv?: number;
    avansIskoriscen?: number;
    avansIskoriscenPercent?: number;
    avansPreostali?: number;
    avansPdv10?: number;
    avansPdv20?: number;
    avansPdv?: number;
    dosUkupnoSaPdv?: number;
    dosUkupnoBezPdv?: number;
    dosPdv10?: number;
    dosPdv20?: number;
    dosPdv?: number;
    dopUkupnoSaPdv?: number;
    dopUkupnoBezPdv?: number;
    dopPdv10?: number;
    dopPdv20?: number;
    dopPdv?: number;
    uplateIzvodi?: number;
    uplateKompenzacije?: number;
    uplateRucne?: number;

    constructor(data?: IRacunSaldoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fakturaPrometSaPdv = _data["fakturaPrometSaPdv"];
            this.fakturaPrometBezPdv = _data["fakturaPrometBezPdv"];
            this.fakturaPlaceno = _data["fakturaPlaceno"];
            this.fakturaPlacenoPercent = _data["fakturaPlacenoPercent"];
            this.fakturaNeplaceno = _data["fakturaNeplaceno"];
            this.fakturaNeplacenoCnt = _data["fakturaNeplacenoCnt"];
            this.fakturaVanValute = _data["fakturaVanValute"];
            this.fakturaVanValuteCnt = _data["fakturaVanValuteCnt"];
            this.fakturaDospevaUNarednih30Dana = _data["fakturaDospevaUNarednih30Dana"];
            this.fakturaDospevaUNarednih30DanaCnt = _data["fakturaDospevaUNarednih30DanaCnt"];
            this.fakturaDso90Dana = _data["fakturaDso90Dana"];
            this.fakturaBroj = _data["fakturaBroj"];
            this.fakturaPdv10 = _data["fakturaPdv10"];
            this.fakturaPdv20 = _data["fakturaPdv20"];
            this.fakturaPdv = _data["fakturaPdv"];
            this.avansUkupnoSaPdv = _data["avansUkupnoSaPdv"];
            this.avansUkupnoBezPdv = _data["avansUkupnoBezPdv"];
            this.avansIskoriscen = _data["avansIskoriscen"];
            this.avansIskoriscenPercent = _data["avansIskoriscenPercent"];
            this.avansPreostali = _data["avansPreostali"];
            this.avansPdv10 = _data["avansPdv10"];
            this.avansPdv20 = _data["avansPdv20"];
            this.avansPdv = _data["avansPdv"];
            this.dosUkupnoSaPdv = _data["dosUkupnoSaPdv"];
            this.dosUkupnoBezPdv = _data["dosUkupnoBezPdv"];
            this.dosPdv10 = _data["dosPdv10"];
            this.dosPdv20 = _data["dosPdv20"];
            this.dosPdv = _data["dosPdv"];
            this.dopUkupnoSaPdv = _data["dopUkupnoSaPdv"];
            this.dopUkupnoBezPdv = _data["dopUkupnoBezPdv"];
            this.dopPdv10 = _data["dopPdv10"];
            this.dopPdv20 = _data["dopPdv20"];
            this.dopPdv = _data["dopPdv"];
            this.uplateIzvodi = _data["uplateIzvodi"];
            this.uplateKompenzacije = _data["uplateKompenzacije"];
            this.uplateRucne = _data["uplateRucne"];
        }
    }

    static fromJS(data: any): RacunSaldoResult {
        data = typeof data === 'object' ? data : {};
        let result = new RacunSaldoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fakturaPrometSaPdv"] = this.fakturaPrometSaPdv;
        data["fakturaPrometBezPdv"] = this.fakturaPrometBezPdv;
        data["fakturaPlaceno"] = this.fakturaPlaceno;
        data["fakturaPlacenoPercent"] = this.fakturaPlacenoPercent;
        data["fakturaNeplaceno"] = this.fakturaNeplaceno;
        data["fakturaNeplacenoCnt"] = this.fakturaNeplacenoCnt;
        data["fakturaVanValute"] = this.fakturaVanValute;
        data["fakturaVanValuteCnt"] = this.fakturaVanValuteCnt;
        data["fakturaDospevaUNarednih30Dana"] = this.fakturaDospevaUNarednih30Dana;
        data["fakturaDospevaUNarednih30DanaCnt"] = this.fakturaDospevaUNarednih30DanaCnt;
        data["fakturaDso90Dana"] = this.fakturaDso90Dana;
        data["fakturaBroj"] = this.fakturaBroj;
        data["fakturaPdv10"] = this.fakturaPdv10;
        data["fakturaPdv20"] = this.fakturaPdv20;
        data["fakturaPdv"] = this.fakturaPdv;
        data["avansUkupnoSaPdv"] = this.avansUkupnoSaPdv;
        data["avansUkupnoBezPdv"] = this.avansUkupnoBezPdv;
        data["avansIskoriscen"] = this.avansIskoriscen;
        data["avansIskoriscenPercent"] = this.avansIskoriscenPercent;
        data["avansPreostali"] = this.avansPreostali;
        data["avansPdv10"] = this.avansPdv10;
        data["avansPdv20"] = this.avansPdv20;
        data["avansPdv"] = this.avansPdv;
        data["dosUkupnoSaPdv"] = this.dosUkupnoSaPdv;
        data["dosUkupnoBezPdv"] = this.dosUkupnoBezPdv;
        data["dosPdv10"] = this.dosPdv10;
        data["dosPdv20"] = this.dosPdv20;
        data["dosPdv"] = this.dosPdv;
        data["dopUkupnoSaPdv"] = this.dopUkupnoSaPdv;
        data["dopUkupnoBezPdv"] = this.dopUkupnoBezPdv;
        data["dopPdv10"] = this.dopPdv10;
        data["dopPdv20"] = this.dopPdv20;
        data["dopPdv"] = this.dopPdv;
        data["uplateIzvodi"] = this.uplateIzvodi;
        data["uplateKompenzacije"] = this.uplateKompenzacije;
        data["uplateRucne"] = this.uplateRucne;
        return data;
    }
}

export interface IRacunSaldoResult {
    fakturaPrometSaPdv?: number;
    fakturaPrometBezPdv?: number;
    fakturaPlaceno?: number;
    fakturaPlacenoPercent?: number;
    fakturaNeplaceno?: number;
    fakturaNeplacenoCnt?: number;
    fakturaVanValute?: number;
    fakturaVanValuteCnt?: number;
    fakturaDospevaUNarednih30Dana?: number;
    fakturaDospevaUNarednih30DanaCnt?: number;
    fakturaDso90Dana?: number;
    fakturaBroj?: number;
    fakturaPdv10?: number;
    fakturaPdv20?: number;
    fakturaPdv?: number;
    avansUkupnoSaPdv?: number;
    avansUkupnoBezPdv?: number;
    avansIskoriscen?: number;
    avansIskoriscenPercent?: number;
    avansPreostali?: number;
    avansPdv10?: number;
    avansPdv20?: number;
    avansPdv?: number;
    dosUkupnoSaPdv?: number;
    dosUkupnoBezPdv?: number;
    dosPdv10?: number;
    dosPdv20?: number;
    dosPdv?: number;
    dopUkupnoSaPdv?: number;
    dopUkupnoBezPdv?: number;
    dopPdv10?: number;
    dopPdv20?: number;
    dopPdv?: number;
    uplateIzvodi?: number;
    uplateKompenzacije?: number;
    uplateRucne?: number;
}

export class GetRacunSaldoQuery implements IGetRacunSaldoQuery {
    racunFilterId?: number;
    naziv?: string | undefined;
    broj?: string | undefined;
    originalanBroj?: string | undefined;
    brojOtpremnice?: string | undefined;
    gradStranke?: string | undefined;
    dodatniOpisStavke?: string | undefined;
    vrstaRacuna?: VrstaRacuna;
    datumSlanjaSefOd?: Date | undefined;
    datumSlanjaSefDo?: Date | undefined;
    datumPrometaOd?: Date | undefined;
    datumPrometaDo?: Date | undefined;
    datumIzdavanjaOd?: Date | undefined;
    datumIzdavanjaDo?: Date | undefined;
    oznake?: GetOznakaMultiselectResponse[] | undefined;
    datumValute?: Date | undefined;
    valutaIsticeZa?: number | undefined;
    period?: PdvPeriod | undefined;
    prometOd?: number | undefined;
    prometDo?: number | undefined;
    stranke?: StrankaMultiSelectItem[] | undefined;
    strankaId?: number | undefined;
    statusi?: StatusRacunaDto[] | undefined;
    tip?: TipRacuna;
    createByEmail?: string | undefined;
    statusiUplateRacuna?: StatusUplateRacunaDto[] | undefined;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
    vanValute?: boolean | undefined;

    constructor(data?: IGetRacunSaldoQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunFilterId = _data["racunFilterId"];
            this.naziv = _data["naziv"];
            this.broj = _data["broj"];
            this.originalanBroj = _data["originalanBroj"];
            this.brojOtpremnice = _data["brojOtpremnice"];
            this.gradStranke = _data["gradStranke"];
            this.dodatniOpisStavke = _data["dodatniOpisStavke"];
            this.vrstaRacuna = _data["vrstaRacuna"];
            this.datumSlanjaSefOd = _data["datumSlanjaSefOd"] ? new Date(_data["datumSlanjaSefOd"].toString()) : <any>undefined;
            this.datumSlanjaSefDo = _data["datumSlanjaSefDo"] ? new Date(_data["datumSlanjaSefDo"].toString()) : <any>undefined;
            this.datumPrometaOd = _data["datumPrometaOd"] ? new Date(_data["datumPrometaOd"].toString()) : <any>undefined;
            this.datumPrometaDo = _data["datumPrometaDo"] ? new Date(_data["datumPrometaDo"].toString()) : <any>undefined;
            this.datumIzdavanjaOd = _data["datumIzdavanjaOd"] ? new Date(_data["datumIzdavanjaOd"].toString()) : <any>undefined;
            this.datumIzdavanjaDo = _data["datumIzdavanjaDo"] ? new Date(_data["datumIzdavanjaDo"].toString()) : <any>undefined;
            if (Array.isArray(_data["oznake"])) {
                this.oznake = [] as any;
                for (let item of _data["oznake"])
                    this.oznake!.push(GetOznakaMultiselectResponse.fromJS(item));
            }
            this.datumValute = _data["datumValute"] ? new Date(_data["datumValute"].toString()) : <any>undefined;
            this.valutaIsticeZa = _data["valutaIsticeZa"];
            this.period = _data["period"];
            this.prometOd = _data["prometOd"];
            this.prometDo = _data["prometDo"];
            if (Array.isArray(_data["stranke"])) {
                this.stranke = [] as any;
                for (let item of _data["stranke"])
                    this.stranke!.push(StrankaMultiSelectItem.fromJS(item));
            }
            this.strankaId = _data["strankaId"];
            if (Array.isArray(_data["statusi"])) {
                this.statusi = [] as any;
                for (let item of _data["statusi"])
                    this.statusi!.push(StatusRacunaDto.fromJS(item));
            }
            this.tip = _data["tip"];
            this.createByEmail = _data["createByEmail"];
            if (Array.isArray(_data["statusiUplateRacuna"])) {
                this.statusiUplateRacuna = [] as any;
                for (let item of _data["statusiUplateRacuna"])
                    this.statusiUplateRacuna!.push(StatusUplateRacunaDto.fromJS(item));
            }
            this.klasifikacijaRacuna = _data["klasifikacijaRacuna"];
            this.pravoNaPdvOdbitak = _data["pravoNaPdvOdbitak"];
            this.vanValute = _data["vanValute"];
        }
    }

    static fromJS(data: any): GetRacunSaldoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetRacunSaldoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunFilterId"] = this.racunFilterId;
        data["naziv"] = this.naziv;
        data["broj"] = this.broj;
        data["originalanBroj"] = this.originalanBroj;
        data["brojOtpremnice"] = this.brojOtpremnice;
        data["gradStranke"] = this.gradStranke;
        data["dodatniOpisStavke"] = this.dodatniOpisStavke;
        data["vrstaRacuna"] = this.vrstaRacuna;
        data["datumSlanjaSefOd"] = this.datumSlanjaSefOd ? this.datumSlanjaSefOd.toISOString() : <any>undefined;
        data["datumSlanjaSefDo"] = this.datumSlanjaSefDo ? this.datumSlanjaSefDo.toISOString() : <any>undefined;
        data["datumPrometaOd"] = this.datumPrometaOd ? this.datumPrometaOd.toISOString() : <any>undefined;
        data["datumPrometaDo"] = this.datumPrometaDo ? this.datumPrometaDo.toISOString() : <any>undefined;
        data["datumIzdavanjaOd"] = this.datumIzdavanjaOd ? this.datumIzdavanjaOd.toISOString() : <any>undefined;
        data["datumIzdavanjaDo"] = this.datumIzdavanjaDo ? this.datumIzdavanjaDo.toISOString() : <any>undefined;
        if (Array.isArray(this.oznake)) {
            data["oznake"] = [];
            for (let item of this.oznake)
                data["oznake"].push(item.toJSON());
        }
        data["datumValute"] = this.datumValute ? this.datumValute.toISOString() : <any>undefined;
        data["valutaIsticeZa"] = this.valutaIsticeZa;
        data["period"] = this.period;
        data["prometOd"] = this.prometOd;
        data["prometDo"] = this.prometDo;
        if (Array.isArray(this.stranke)) {
            data["stranke"] = [];
            for (let item of this.stranke)
                data["stranke"].push(item.toJSON());
        }
        data["strankaId"] = this.strankaId;
        if (Array.isArray(this.statusi)) {
            data["statusi"] = [];
            for (let item of this.statusi)
                data["statusi"].push(item.toJSON());
        }
        data["tip"] = this.tip;
        data["createByEmail"] = this.createByEmail;
        if (Array.isArray(this.statusiUplateRacuna)) {
            data["statusiUplateRacuna"] = [];
            for (let item of this.statusiUplateRacuna)
                data["statusiUplateRacuna"].push(item.toJSON());
        }
        data["klasifikacijaRacuna"] = this.klasifikacijaRacuna;
        data["pravoNaPdvOdbitak"] = this.pravoNaPdvOdbitak;
        data["vanValute"] = this.vanValute;
        return data;
    }
}

export interface IGetRacunSaldoQuery {
    racunFilterId?: number;
    naziv?: string | undefined;
    broj?: string | undefined;
    originalanBroj?: string | undefined;
    brojOtpremnice?: string | undefined;
    gradStranke?: string | undefined;
    dodatniOpisStavke?: string | undefined;
    vrstaRacuna?: VrstaRacuna;
    datumSlanjaSefOd?: Date | undefined;
    datumSlanjaSefDo?: Date | undefined;
    datumPrometaOd?: Date | undefined;
    datumPrometaDo?: Date | undefined;
    datumIzdavanjaOd?: Date | undefined;
    datumIzdavanjaDo?: Date | undefined;
    oznake?: GetOznakaMultiselectResponse[] | undefined;
    datumValute?: Date | undefined;
    valutaIsticeZa?: number | undefined;
    period?: PdvPeriod | undefined;
    prometOd?: number | undefined;
    prometDo?: number | undefined;
    stranke?: StrankaMultiSelectItem[] | undefined;
    strankaId?: number | undefined;
    statusi?: StatusRacunaDto[] | undefined;
    tip?: TipRacuna;
    createByEmail?: string | undefined;
    statusiUplateRacuna?: StatusUplateRacunaDto[] | undefined;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
    vanValute?: boolean | undefined;
}

export class ResultOfSaldoFaktureZbirnoResult extends Result implements IResultOfSaldoFaktureZbirnoResult {
    data?: SaldoFaktureZbirnoResult | undefined;

    constructor(data?: IResultOfSaldoFaktureZbirnoResult) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? SaldoFaktureZbirnoResult.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfSaldoFaktureZbirnoResult {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfSaldoFaktureZbirnoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfSaldoFaktureZbirnoResult extends IResult {
    data?: SaldoFaktureZbirnoResult | undefined;
}

export class SaldoFaktureZbirnoResult implements ISaldoFaktureZbirnoResult {
    osnovica?: number;
    pdv10?: number;
    pdv20?: number;
    saldo?: number;
    poreskiPromet?: number;
    finansijskiPromet?: number;
    cashflow?: number;
    vanValuteIznos?: number;
    vanValuteCnt?: number;
    neplacenoIznos?: number;
    neplacenoCnt?: number;
    placenoIznos?: number;
    placenoCnt?: number;
    placenoPercent?: number;
    fakturaCnt?: number;
    dospevaZa30Dana?: number;
    dospevaZa30DanaCnt?: number;
    dso90Dana?: number;

    constructor(data?: ISaldoFaktureZbirnoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.osnovica = _data["osnovica"];
            this.pdv10 = _data["pdv10"];
            this.pdv20 = _data["pdv20"];
            this.saldo = _data["saldo"];
            this.poreskiPromet = _data["poreskiPromet"];
            this.finansijskiPromet = _data["finansijskiPromet"];
            this.cashflow = _data["cashflow"];
            this.vanValuteIznos = _data["vanValuteIznos"];
            this.vanValuteCnt = _data["vanValuteCnt"];
            this.neplacenoIznos = _data["neplacenoIznos"];
            this.neplacenoCnt = _data["neplacenoCnt"];
            this.placenoIznos = _data["placenoIznos"];
            this.placenoCnt = _data["placenoCnt"];
            this.placenoPercent = _data["placenoPercent"];
            this.fakturaCnt = _data["fakturaCnt"];
            this.dospevaZa30Dana = _data["dospevaZa30Dana"];
            this.dospevaZa30DanaCnt = _data["dospevaZa30DanaCnt"];
            this.dso90Dana = _data["dso90Dana"];
        }
    }

    static fromJS(data: any): SaldoFaktureZbirnoResult {
        data = typeof data === 'object' ? data : {};
        let result = new SaldoFaktureZbirnoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["osnovica"] = this.osnovica;
        data["pdv10"] = this.pdv10;
        data["pdv20"] = this.pdv20;
        data["saldo"] = this.saldo;
        data["poreskiPromet"] = this.poreskiPromet;
        data["finansijskiPromet"] = this.finansijskiPromet;
        data["cashflow"] = this.cashflow;
        data["vanValuteIznos"] = this.vanValuteIznos;
        data["vanValuteCnt"] = this.vanValuteCnt;
        data["neplacenoIznos"] = this.neplacenoIznos;
        data["neplacenoCnt"] = this.neplacenoCnt;
        data["placenoIznos"] = this.placenoIznos;
        data["placenoCnt"] = this.placenoCnt;
        data["placenoPercent"] = this.placenoPercent;
        data["fakturaCnt"] = this.fakturaCnt;
        data["dospevaZa30Dana"] = this.dospevaZa30Dana;
        data["dospevaZa30DanaCnt"] = this.dospevaZa30DanaCnt;
        data["dso90Dana"] = this.dso90Dana;
        return data;
    }
}

export interface ISaldoFaktureZbirnoResult {
    osnovica?: number;
    pdv10?: number;
    pdv20?: number;
    saldo?: number;
    poreskiPromet?: number;
    finansijskiPromet?: number;
    cashflow?: number;
    vanValuteIznos?: number;
    vanValuteCnt?: number;
    neplacenoIznos?: number;
    neplacenoCnt?: number;
    placenoIznos?: number;
    placenoCnt?: number;
    placenoPercent?: number;
    fakturaCnt?: number;
    dospevaZa30Dana?: number;
    dospevaZa30DanaCnt?: number;
    dso90Dana?: number;
}

export class GetSaldoFaktureZbirnoQuery implements IGetSaldoFaktureZbirnoQuery {
    racunFilterId?: number;
    naziv?: string | undefined;
    broj?: string | undefined;
    originalanBroj?: string | undefined;
    brojOtpremnice?: string | undefined;
    gradStranke?: string | undefined;
    dodatniOpisStavke?: string | undefined;
    vrstaRacuna?: VrstaRacuna;
    datumSlanjaSefOd?: Date | undefined;
    datumSlanjaSefDo?: Date | undefined;
    datumPrometaOd?: Date | undefined;
    datumPrometaDo?: Date | undefined;
    datumIzdavanjaOd?: Date | undefined;
    datumIzdavanjaDo?: Date | undefined;
    oznake?: GetOznakaMultiselectResponse[] | undefined;
    datumValute?: Date | undefined;
    valutaIsticeZa?: number | undefined;
    period?: PdvPeriod | undefined;
    prometOd?: number | undefined;
    prometDo?: number | undefined;
    stranke?: StrankaMultiSelectItem[] | undefined;
    strankaId?: number | undefined;
    statusi?: StatusRacunaDto[] | undefined;
    tip?: TipRacuna;
    createByEmail?: string | undefined;
    statusiUplateRacuna?: StatusUplateRacunaDto[] | undefined;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
    vanValute?: boolean | undefined;

    constructor(data?: IGetSaldoFaktureZbirnoQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunFilterId = _data["racunFilterId"];
            this.naziv = _data["naziv"];
            this.broj = _data["broj"];
            this.originalanBroj = _data["originalanBroj"];
            this.brojOtpremnice = _data["brojOtpremnice"];
            this.gradStranke = _data["gradStranke"];
            this.dodatniOpisStavke = _data["dodatniOpisStavke"];
            this.vrstaRacuna = _data["vrstaRacuna"];
            this.datumSlanjaSefOd = _data["datumSlanjaSefOd"] ? new Date(_data["datumSlanjaSefOd"].toString()) : <any>undefined;
            this.datumSlanjaSefDo = _data["datumSlanjaSefDo"] ? new Date(_data["datumSlanjaSefDo"].toString()) : <any>undefined;
            this.datumPrometaOd = _data["datumPrometaOd"] ? new Date(_data["datumPrometaOd"].toString()) : <any>undefined;
            this.datumPrometaDo = _data["datumPrometaDo"] ? new Date(_data["datumPrometaDo"].toString()) : <any>undefined;
            this.datumIzdavanjaOd = _data["datumIzdavanjaOd"] ? new Date(_data["datumIzdavanjaOd"].toString()) : <any>undefined;
            this.datumIzdavanjaDo = _data["datumIzdavanjaDo"] ? new Date(_data["datumIzdavanjaDo"].toString()) : <any>undefined;
            if (Array.isArray(_data["oznake"])) {
                this.oznake = [] as any;
                for (let item of _data["oznake"])
                    this.oznake!.push(GetOznakaMultiselectResponse.fromJS(item));
            }
            this.datumValute = _data["datumValute"] ? new Date(_data["datumValute"].toString()) : <any>undefined;
            this.valutaIsticeZa = _data["valutaIsticeZa"];
            this.period = _data["period"];
            this.prometOd = _data["prometOd"];
            this.prometDo = _data["prometDo"];
            if (Array.isArray(_data["stranke"])) {
                this.stranke = [] as any;
                for (let item of _data["stranke"])
                    this.stranke!.push(StrankaMultiSelectItem.fromJS(item));
            }
            this.strankaId = _data["strankaId"];
            if (Array.isArray(_data["statusi"])) {
                this.statusi = [] as any;
                for (let item of _data["statusi"])
                    this.statusi!.push(StatusRacunaDto.fromJS(item));
            }
            this.tip = _data["tip"];
            this.createByEmail = _data["createByEmail"];
            if (Array.isArray(_data["statusiUplateRacuna"])) {
                this.statusiUplateRacuna = [] as any;
                for (let item of _data["statusiUplateRacuna"])
                    this.statusiUplateRacuna!.push(StatusUplateRacunaDto.fromJS(item));
            }
            this.klasifikacijaRacuna = _data["klasifikacijaRacuna"];
            this.pravoNaPdvOdbitak = _data["pravoNaPdvOdbitak"];
            this.vanValute = _data["vanValute"];
        }
    }

    static fromJS(data: any): GetSaldoFaktureZbirnoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSaldoFaktureZbirnoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunFilterId"] = this.racunFilterId;
        data["naziv"] = this.naziv;
        data["broj"] = this.broj;
        data["originalanBroj"] = this.originalanBroj;
        data["brojOtpremnice"] = this.brojOtpremnice;
        data["gradStranke"] = this.gradStranke;
        data["dodatniOpisStavke"] = this.dodatniOpisStavke;
        data["vrstaRacuna"] = this.vrstaRacuna;
        data["datumSlanjaSefOd"] = this.datumSlanjaSefOd ? this.datumSlanjaSefOd.toISOString() : <any>undefined;
        data["datumSlanjaSefDo"] = this.datumSlanjaSefDo ? this.datumSlanjaSefDo.toISOString() : <any>undefined;
        data["datumPrometaOd"] = this.datumPrometaOd ? this.datumPrometaOd.toISOString() : <any>undefined;
        data["datumPrometaDo"] = this.datumPrometaDo ? this.datumPrometaDo.toISOString() : <any>undefined;
        data["datumIzdavanjaOd"] = this.datumIzdavanjaOd ? this.datumIzdavanjaOd.toISOString() : <any>undefined;
        data["datumIzdavanjaDo"] = this.datumIzdavanjaDo ? this.datumIzdavanjaDo.toISOString() : <any>undefined;
        if (Array.isArray(this.oznake)) {
            data["oznake"] = [];
            for (let item of this.oznake)
                data["oznake"].push(item.toJSON());
        }
        data["datumValute"] = this.datumValute ? this.datumValute.toISOString() : <any>undefined;
        data["valutaIsticeZa"] = this.valutaIsticeZa;
        data["period"] = this.period;
        data["prometOd"] = this.prometOd;
        data["prometDo"] = this.prometDo;
        if (Array.isArray(this.stranke)) {
            data["stranke"] = [];
            for (let item of this.stranke)
                data["stranke"].push(item.toJSON());
        }
        data["strankaId"] = this.strankaId;
        if (Array.isArray(this.statusi)) {
            data["statusi"] = [];
            for (let item of this.statusi)
                data["statusi"].push(item.toJSON());
        }
        data["tip"] = this.tip;
        data["createByEmail"] = this.createByEmail;
        if (Array.isArray(this.statusiUplateRacuna)) {
            data["statusiUplateRacuna"] = [];
            for (let item of this.statusiUplateRacuna)
                data["statusiUplateRacuna"].push(item.toJSON());
        }
        data["klasifikacijaRacuna"] = this.klasifikacijaRacuna;
        data["pravoNaPdvOdbitak"] = this.pravoNaPdvOdbitak;
        data["vanValute"] = this.vanValute;
        return data;
    }
}

export interface IGetSaldoFaktureZbirnoQuery {
    racunFilterId?: number;
    naziv?: string | undefined;
    broj?: string | undefined;
    originalanBroj?: string | undefined;
    brojOtpremnice?: string | undefined;
    gradStranke?: string | undefined;
    dodatniOpisStavke?: string | undefined;
    vrstaRacuna?: VrstaRacuna;
    datumSlanjaSefOd?: Date | undefined;
    datumSlanjaSefDo?: Date | undefined;
    datumPrometaOd?: Date | undefined;
    datumPrometaDo?: Date | undefined;
    datumIzdavanjaOd?: Date | undefined;
    datumIzdavanjaDo?: Date | undefined;
    oznake?: GetOznakaMultiselectResponse[] | undefined;
    datumValute?: Date | undefined;
    valutaIsticeZa?: number | undefined;
    period?: PdvPeriod | undefined;
    prometOd?: number | undefined;
    prometDo?: number | undefined;
    stranke?: StrankaMultiSelectItem[] | undefined;
    strankaId?: number | undefined;
    statusi?: StatusRacunaDto[] | undefined;
    tip?: TipRacuna;
    createByEmail?: string | undefined;
    statusiUplateRacuna?: StatusUplateRacunaDto[] | undefined;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
    vanValute?: boolean | undefined;
}

export class ResultOfSaldoAvansaZbirnoResult extends Result implements IResultOfSaldoAvansaZbirnoResult {
    data?: SaldoAvansaZbirnoResult | undefined;

    constructor(data?: IResultOfSaldoAvansaZbirnoResult) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? SaldoAvansaZbirnoResult.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfSaldoAvansaZbirnoResult {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfSaldoAvansaZbirnoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfSaldoAvansaZbirnoResult extends IResult {
    data?: SaldoAvansaZbirnoResult | undefined;
}

export class SaldoAvansaZbirnoResult implements ISaldoAvansaZbirnoResult {
    osnovica?: number;
    pdv10?: number;
    pdv20?: number;
    ukupanIznos?: number;
    evidentiranaOsnovica?: number;
    evidantiranPdv10?: number;
    evidantiranPdv20?: number;
    preostalaOsnovica?: number;
    preostaoPdv10?: number;
    preostaoPdv20?: number;
    ukupanBroj?: number;

    constructor(data?: ISaldoAvansaZbirnoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.osnovica = _data["osnovica"];
            this.pdv10 = _data["pdv10"];
            this.pdv20 = _data["pdv20"];
            this.ukupanIznos = _data["ukupanIznos"];
            this.evidentiranaOsnovica = _data["evidentiranaOsnovica"];
            this.evidantiranPdv10 = _data["evidantiranPdv10"];
            this.evidantiranPdv20 = _data["evidantiranPdv20"];
            this.preostalaOsnovica = _data["preostalaOsnovica"];
            this.preostaoPdv10 = _data["preostaoPdv10"];
            this.preostaoPdv20 = _data["preostaoPdv20"];
            this.ukupanBroj = _data["ukupanBroj"];
        }
    }

    static fromJS(data: any): SaldoAvansaZbirnoResult {
        data = typeof data === 'object' ? data : {};
        let result = new SaldoAvansaZbirnoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["osnovica"] = this.osnovica;
        data["pdv10"] = this.pdv10;
        data["pdv20"] = this.pdv20;
        data["ukupanIznos"] = this.ukupanIznos;
        data["evidentiranaOsnovica"] = this.evidentiranaOsnovica;
        data["evidantiranPdv10"] = this.evidantiranPdv10;
        data["evidantiranPdv20"] = this.evidantiranPdv20;
        data["preostalaOsnovica"] = this.preostalaOsnovica;
        data["preostaoPdv10"] = this.preostaoPdv10;
        data["preostaoPdv20"] = this.preostaoPdv20;
        data["ukupanBroj"] = this.ukupanBroj;
        return data;
    }
}

export interface ISaldoAvansaZbirnoResult {
    osnovica?: number;
    pdv10?: number;
    pdv20?: number;
    ukupanIznos?: number;
    evidentiranaOsnovica?: number;
    evidantiranPdv10?: number;
    evidantiranPdv20?: number;
    preostalaOsnovica?: number;
    preostaoPdv10?: number;
    preostaoPdv20?: number;
    ukupanBroj?: number;
}

export class GetSaldoAvansaZbirnoQuery implements IGetSaldoAvansaZbirnoQuery {
    racunFilterId?: number;
    naziv?: string | undefined;
    broj?: string | undefined;
    originalanBroj?: string | undefined;
    brojOtpremnice?: string | undefined;
    gradStranke?: string | undefined;
    dodatniOpisStavke?: string | undefined;
    vrstaRacuna?: VrstaRacuna;
    datumSlanjaSefOd?: Date | undefined;
    datumSlanjaSefDo?: Date | undefined;
    datumPrometaOd?: Date | undefined;
    datumPrometaDo?: Date | undefined;
    datumIzdavanjaOd?: Date | undefined;
    datumIzdavanjaDo?: Date | undefined;
    oznake?: GetOznakaMultiselectResponse[] | undefined;
    datumValute?: Date | undefined;
    valutaIsticeZa?: number | undefined;
    period?: PdvPeriod | undefined;
    prometOd?: number | undefined;
    prometDo?: number | undefined;
    stranke?: StrankaMultiSelectItem[] | undefined;
    strankaId?: number | undefined;
    statusi?: StatusRacunaDto[] | undefined;
    tip?: TipRacuna;
    createByEmail?: string | undefined;
    statusiUplateRacuna?: StatusUplateRacunaDto[] | undefined;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
    vanValute?: boolean | undefined;

    constructor(data?: IGetSaldoAvansaZbirnoQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunFilterId = _data["racunFilterId"];
            this.naziv = _data["naziv"];
            this.broj = _data["broj"];
            this.originalanBroj = _data["originalanBroj"];
            this.brojOtpremnice = _data["brojOtpremnice"];
            this.gradStranke = _data["gradStranke"];
            this.dodatniOpisStavke = _data["dodatniOpisStavke"];
            this.vrstaRacuna = _data["vrstaRacuna"];
            this.datumSlanjaSefOd = _data["datumSlanjaSefOd"] ? new Date(_data["datumSlanjaSefOd"].toString()) : <any>undefined;
            this.datumSlanjaSefDo = _data["datumSlanjaSefDo"] ? new Date(_data["datumSlanjaSefDo"].toString()) : <any>undefined;
            this.datumPrometaOd = _data["datumPrometaOd"] ? new Date(_data["datumPrometaOd"].toString()) : <any>undefined;
            this.datumPrometaDo = _data["datumPrometaDo"] ? new Date(_data["datumPrometaDo"].toString()) : <any>undefined;
            this.datumIzdavanjaOd = _data["datumIzdavanjaOd"] ? new Date(_data["datumIzdavanjaOd"].toString()) : <any>undefined;
            this.datumIzdavanjaDo = _data["datumIzdavanjaDo"] ? new Date(_data["datumIzdavanjaDo"].toString()) : <any>undefined;
            if (Array.isArray(_data["oznake"])) {
                this.oznake = [] as any;
                for (let item of _data["oznake"])
                    this.oznake!.push(GetOznakaMultiselectResponse.fromJS(item));
            }
            this.datumValute = _data["datumValute"] ? new Date(_data["datumValute"].toString()) : <any>undefined;
            this.valutaIsticeZa = _data["valutaIsticeZa"];
            this.period = _data["period"];
            this.prometOd = _data["prometOd"];
            this.prometDo = _data["prometDo"];
            if (Array.isArray(_data["stranke"])) {
                this.stranke = [] as any;
                for (let item of _data["stranke"])
                    this.stranke!.push(StrankaMultiSelectItem.fromJS(item));
            }
            this.strankaId = _data["strankaId"];
            if (Array.isArray(_data["statusi"])) {
                this.statusi = [] as any;
                for (let item of _data["statusi"])
                    this.statusi!.push(StatusRacunaDto.fromJS(item));
            }
            this.tip = _data["tip"];
            this.createByEmail = _data["createByEmail"];
            if (Array.isArray(_data["statusiUplateRacuna"])) {
                this.statusiUplateRacuna = [] as any;
                for (let item of _data["statusiUplateRacuna"])
                    this.statusiUplateRacuna!.push(StatusUplateRacunaDto.fromJS(item));
            }
            this.klasifikacijaRacuna = _data["klasifikacijaRacuna"];
            this.pravoNaPdvOdbitak = _data["pravoNaPdvOdbitak"];
            this.vanValute = _data["vanValute"];
        }
    }

    static fromJS(data: any): GetSaldoAvansaZbirnoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSaldoAvansaZbirnoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunFilterId"] = this.racunFilterId;
        data["naziv"] = this.naziv;
        data["broj"] = this.broj;
        data["originalanBroj"] = this.originalanBroj;
        data["brojOtpremnice"] = this.brojOtpremnice;
        data["gradStranke"] = this.gradStranke;
        data["dodatniOpisStavke"] = this.dodatniOpisStavke;
        data["vrstaRacuna"] = this.vrstaRacuna;
        data["datumSlanjaSefOd"] = this.datumSlanjaSefOd ? this.datumSlanjaSefOd.toISOString() : <any>undefined;
        data["datumSlanjaSefDo"] = this.datumSlanjaSefDo ? this.datumSlanjaSefDo.toISOString() : <any>undefined;
        data["datumPrometaOd"] = this.datumPrometaOd ? this.datumPrometaOd.toISOString() : <any>undefined;
        data["datumPrometaDo"] = this.datumPrometaDo ? this.datumPrometaDo.toISOString() : <any>undefined;
        data["datumIzdavanjaOd"] = this.datumIzdavanjaOd ? this.datumIzdavanjaOd.toISOString() : <any>undefined;
        data["datumIzdavanjaDo"] = this.datumIzdavanjaDo ? this.datumIzdavanjaDo.toISOString() : <any>undefined;
        if (Array.isArray(this.oznake)) {
            data["oznake"] = [];
            for (let item of this.oznake)
                data["oznake"].push(item.toJSON());
        }
        data["datumValute"] = this.datumValute ? this.datumValute.toISOString() : <any>undefined;
        data["valutaIsticeZa"] = this.valutaIsticeZa;
        data["period"] = this.period;
        data["prometOd"] = this.prometOd;
        data["prometDo"] = this.prometDo;
        if (Array.isArray(this.stranke)) {
            data["stranke"] = [];
            for (let item of this.stranke)
                data["stranke"].push(item.toJSON());
        }
        data["strankaId"] = this.strankaId;
        if (Array.isArray(this.statusi)) {
            data["statusi"] = [];
            for (let item of this.statusi)
                data["statusi"].push(item.toJSON());
        }
        data["tip"] = this.tip;
        data["createByEmail"] = this.createByEmail;
        if (Array.isArray(this.statusiUplateRacuna)) {
            data["statusiUplateRacuna"] = [];
            for (let item of this.statusiUplateRacuna)
                data["statusiUplateRacuna"].push(item.toJSON());
        }
        data["klasifikacijaRacuna"] = this.klasifikacijaRacuna;
        data["pravoNaPdvOdbitak"] = this.pravoNaPdvOdbitak;
        data["vanValute"] = this.vanValute;
        return data;
    }
}

export interface IGetSaldoAvansaZbirnoQuery {
    racunFilterId?: number;
    naziv?: string | undefined;
    broj?: string | undefined;
    originalanBroj?: string | undefined;
    brojOtpremnice?: string | undefined;
    gradStranke?: string | undefined;
    dodatniOpisStavke?: string | undefined;
    vrstaRacuna?: VrstaRacuna;
    datumSlanjaSefOd?: Date | undefined;
    datumSlanjaSefDo?: Date | undefined;
    datumPrometaOd?: Date | undefined;
    datumPrometaDo?: Date | undefined;
    datumIzdavanjaOd?: Date | undefined;
    datumIzdavanjaDo?: Date | undefined;
    oznake?: GetOznakaMultiselectResponse[] | undefined;
    datumValute?: Date | undefined;
    valutaIsticeZa?: number | undefined;
    period?: PdvPeriod | undefined;
    prometOd?: number | undefined;
    prometDo?: number | undefined;
    stranke?: StrankaMultiSelectItem[] | undefined;
    strankaId?: number | undefined;
    statusi?: StatusRacunaDto[] | undefined;
    tip?: TipRacuna;
    createByEmail?: string | undefined;
    statusiUplateRacuna?: StatusUplateRacunaDto[] | undefined;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
    vanValute?: boolean | undefined;
}

export class ResultOfGetForFileManagerResponse extends Result implements IResultOfGetForFileManagerResponse {
    data?: GetForFileManagerResponse | undefined;

    constructor(data?: IResultOfGetForFileManagerResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetForFileManagerResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetForFileManagerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetForFileManagerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetForFileManagerResponse extends IResult {
    data?: GetForFileManagerResponse | undefined;
}

export class GetForFileManagerResponse implements IGetForFileManagerResponse {
    responseList?: RacunFileInfoDto[] | undefined;

    constructor(data?: IGetForFileManagerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(RacunFileInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetForFileManagerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetForFileManagerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetForFileManagerResponse {
    responseList?: RacunFileInfoDto[] | undefined;
}

export class RacunFileInfoDto implements IRacunFileInfoDto {
    racunId?: number;
    tip?: TipRacuna;
    broj?: string | undefined;
    strankaNaziv?: string | undefined;
    datumIzdavanjaStr?: string | undefined;

    constructor(data?: IRacunFileInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
            this.tip = _data["tip"];
            this.broj = _data["broj"];
            this.strankaNaziv = _data["strankaNaziv"];
            this.datumIzdavanjaStr = _data["datumIzdavanjaStr"];
        }
    }

    static fromJS(data: any): RacunFileInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new RacunFileInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        data["tip"] = this.tip;
        data["broj"] = this.broj;
        data["strankaNaziv"] = this.strankaNaziv;
        data["datumIzdavanjaStr"] = this.datumIzdavanjaStr;
        return data;
    }
}

export interface IRacunFileInfoDto {
    racunId?: number;
    tip?: TipRacuna;
    broj?: string | undefined;
    strankaNaziv?: string | undefined;
    datumIzdavanjaStr?: string | undefined;
}

export class ResultOfGetNeplaceniRacunTableResponse extends Result implements IResultOfGetNeplaceniRacunTableResponse {
    data?: GetNeplaceniRacunTableResponse | undefined;

    constructor(data?: IResultOfGetNeplaceniRacunTableResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetNeplaceniRacunTableResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetNeplaceniRacunTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetNeplaceniRacunTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetNeplaceniRacunTableResponse extends IResult {
    data?: GetNeplaceniRacunTableResponse | undefined;
}

export class GetNeplaceniRacunTableResponse implements IGetNeplaceniRacunTableResponse {
    neplaceniRacunTableDtoList?: NeplaceniRacunTableDto[] | undefined;

    constructor(data?: IGetNeplaceniRacunTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["neplaceniRacunTableDtoList"])) {
                this.neplaceniRacunTableDtoList = [] as any;
                for (let item of _data["neplaceniRacunTableDtoList"])
                    this.neplaceniRacunTableDtoList!.push(NeplaceniRacunTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNeplaceniRacunTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNeplaceniRacunTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.neplaceniRacunTableDtoList)) {
            data["neplaceniRacunTableDtoList"] = [];
            for (let item of this.neplaceniRacunTableDtoList)
                data["neplaceniRacunTableDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNeplaceniRacunTableResponse {
    neplaceniRacunTableDtoList?: NeplaceniRacunTableDto[] | undefined;
}

export class NeplaceniRacunTableDto implements INeplaceniRacunTableDto {
    id?: number;
    broj?: string | undefined;
    originalanBroj?: string | undefined;
    preostaliIznos?: number;
    datumValuteTableDto?: DatumValuteTableDto | undefined;
    statusUplateDto?: StatusUplateRacunaDto | undefined;
    rutiranjeStranke?: RutiranjeStrankeDto | undefined;
    tip?: TipRacuna;
    kodValuteAlfaChar?: string | undefined;

    constructor(data?: INeplaceniRacunTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.originalanBroj = _data["originalanBroj"];
            this.preostaliIznos = _data["preostaliIznos"];
            this.datumValuteTableDto = _data["datumValuteTableDto"] ? DatumValuteTableDto.fromJS(_data["datumValuteTableDto"]) : <any>undefined;
            this.statusUplateDto = _data["statusUplateDto"] ? StatusUplateRacunaDto.fromJS(_data["statusUplateDto"]) : <any>undefined;
            this.rutiranjeStranke = _data["rutiranjeStranke"] ? RutiranjeStrankeDto.fromJS(_data["rutiranjeStranke"]) : <any>undefined;
            this.tip = _data["tip"];
            this.kodValuteAlfaChar = _data["kodValuteAlfaChar"];
        }
    }

    static fromJS(data: any): NeplaceniRacunTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new NeplaceniRacunTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["originalanBroj"] = this.originalanBroj;
        data["preostaliIznos"] = this.preostaliIznos;
        data["datumValuteTableDto"] = this.datumValuteTableDto ? this.datumValuteTableDto.toJSON() : <any>undefined;
        data["statusUplateDto"] = this.statusUplateDto ? this.statusUplateDto.toJSON() : <any>undefined;
        data["rutiranjeStranke"] = this.rutiranjeStranke ? this.rutiranjeStranke.toJSON() : <any>undefined;
        data["tip"] = this.tip;
        data["kodValuteAlfaChar"] = this.kodValuteAlfaChar;
        return data;
    }
}

export interface INeplaceniRacunTableDto {
    id?: number;
    broj?: string | undefined;
    originalanBroj?: string | undefined;
    preostaliIznos?: number;
    datumValuteTableDto?: DatumValuteTableDto | undefined;
    statusUplateDto?: StatusUplateRacunaDto | undefined;
    rutiranjeStranke?: RutiranjeStrankeDto | undefined;
    tip?: TipRacuna;
    kodValuteAlfaChar?: string | undefined;
}

export class DatumValuteTableDto implements IDatumValuteTableDto {
    datumValute?: string | undefined;
    napomena?: string | undefined;
    jeIsteklaValuta?: boolean;

    constructor(data?: IDatumValuteTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datumValute = _data["datumValute"];
            this.napomena = _data["napomena"];
            this.jeIsteklaValuta = _data["jeIsteklaValuta"];
        }
    }

    static fromJS(data: any): DatumValuteTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new DatumValuteTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datumValute"] = this.datumValute;
        data["napomena"] = this.napomena;
        data["jeIsteklaValuta"] = this.jeIsteklaValuta;
        return data;
    }
}

export interface IDatumValuteTableDto {
    datumValute?: string | undefined;
    napomena?: string | undefined;
    jeIsteklaValuta?: boolean;
}

export class NeplaceniRacunTableRequest implements INeplaceniRacunTableRequest {
    strankaId?: number | undefined;
    vrstaRacuna?: VrstaRacuna;
    jeDeviznaTransakcija?: boolean;
    brojRacuna?: string | undefined;
    stranke?: StrankaMultiSelectItem[] | undefined;

    constructor(data?: INeplaceniRacunTableRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.strankaId = _data["strankaId"];
            this.vrstaRacuna = _data["vrstaRacuna"];
            this.jeDeviznaTransakcija = _data["jeDeviznaTransakcija"];
            this.brojRacuna = _data["brojRacuna"];
            if (Array.isArray(_data["stranke"])) {
                this.stranke = [] as any;
                for (let item of _data["stranke"])
                    this.stranke!.push(StrankaMultiSelectItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NeplaceniRacunTableRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NeplaceniRacunTableRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["strankaId"] = this.strankaId;
        data["vrstaRacuna"] = this.vrstaRacuna;
        data["jeDeviznaTransakcija"] = this.jeDeviznaTransakcija;
        data["brojRacuna"] = this.brojRacuna;
        if (Array.isArray(this.stranke)) {
            data["stranke"] = [];
            for (let item of this.stranke)
                data["stranke"].push(item.toJSON());
        }
        return data;
    }
}

export interface INeplaceniRacunTableRequest {
    strankaId?: number | undefined;
    vrstaRacuna?: VrstaRacuna;
    jeDeviznaTransakcija?: boolean;
    brojRacuna?: string | undefined;
    stranke?: StrankaMultiSelectItem[] | undefined;
}

export class GetNeplaceniRacunTableQuery extends NeplaceniRacunTableRequest implements IGetNeplaceniRacunTableQuery {

    constructor(data?: IGetNeplaceniRacunTableQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetNeplaceniRacunTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetNeplaceniRacunTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetNeplaceniRacunTableQuery extends INeplaceniRacunTableRequest {
}

export class ResultOfGetPocetnoStanjeRacunTableResponse extends Result implements IResultOfGetPocetnoStanjeRacunTableResponse {
    data?: GetPocetnoStanjeRacunTableResponse | undefined;

    constructor(data?: IResultOfGetPocetnoStanjeRacunTableResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetPocetnoStanjeRacunTableResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetPocetnoStanjeRacunTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetPocetnoStanjeRacunTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetPocetnoStanjeRacunTableResponse extends IResult {
    data?: GetPocetnoStanjeRacunTableResponse | undefined;
}

export class GetPocetnoStanjeRacunTableResponse implements IGetPocetnoStanjeRacunTableResponse {
    pocetnoStanjeRacunTableDtoList?: PocetnoStanjeRacunTableDto[] | undefined;

    constructor(data?: IGetPocetnoStanjeRacunTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pocetnoStanjeRacunTableDtoList"])) {
                this.pocetnoStanjeRacunTableDtoList = [] as any;
                for (let item of _data["pocetnoStanjeRacunTableDtoList"])
                    this.pocetnoStanjeRacunTableDtoList!.push(PocetnoStanjeRacunTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPocetnoStanjeRacunTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPocetnoStanjeRacunTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pocetnoStanjeRacunTableDtoList)) {
            data["pocetnoStanjeRacunTableDtoList"] = [];
            for (let item of this.pocetnoStanjeRacunTableDtoList)
                data["pocetnoStanjeRacunTableDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPocetnoStanjeRacunTableResponse {
    pocetnoStanjeRacunTableDtoList?: PocetnoStanjeRacunTableDto[] | undefined;
}

export class PocetnoStanjeRacunTableDto implements IPocetnoStanjeRacunTableDto {
    id?: number;
    preostaliIznos?: number;
    statusUplateDto?: StatusUplateRacunaDto | undefined;
    rutiranjeStranke?: RutiranjeStrankeDto | undefined;
    tip?: TipRacuna;

    constructor(data?: IPocetnoStanjeRacunTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.preostaliIznos = _data["preostaliIznos"];
            this.statusUplateDto = _data["statusUplateDto"] ? StatusUplateRacunaDto.fromJS(_data["statusUplateDto"]) : <any>undefined;
            this.rutiranjeStranke = _data["rutiranjeStranke"] ? RutiranjeStrankeDto.fromJS(_data["rutiranjeStranke"]) : <any>undefined;
            this.tip = _data["tip"];
        }
    }

    static fromJS(data: any): PocetnoStanjeRacunTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PocetnoStanjeRacunTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["preostaliIznos"] = this.preostaliIznos;
        data["statusUplateDto"] = this.statusUplateDto ? this.statusUplateDto.toJSON() : <any>undefined;
        data["rutiranjeStranke"] = this.rutiranjeStranke ? this.rutiranjeStranke.toJSON() : <any>undefined;
        data["tip"] = this.tip;
        return data;
    }
}

export interface IPocetnoStanjeRacunTableDto {
    id?: number;
    preostaliIznos?: number;
    statusUplateDto?: StatusUplateRacunaDto | undefined;
    rutiranjeStranke?: RutiranjeStrankeDto | undefined;
    tip?: TipRacuna;
}

export class ResultOfListOfVezaniRacunDto extends Result implements IResultOfListOfVezaniRacunDto {
    data?: VezaniRacunDto[] | undefined;

    constructor(data?: IResultOfListOfVezaniRacunDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(VezaniRacunDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfVezaniRacunDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfVezaniRacunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfVezaniRacunDto extends IResult {
    data?: VezaniRacunDto[] | undefined;
}

export class GetVezaniRacunAutocompleteQuery implements IGetVezaniRacunAutocompleteQuery {
    searchValue?: string | undefined;
    jeIzmenaOsnovice?: boolean;
    includeTipoveRacuna?: TipRacuna[] | undefined;
    includeStatuseRacuna?: StatusRacuna[] | undefined;

    constructor(data?: IGetVezaniRacunAutocompleteQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchValue = _data["searchValue"];
            this.jeIzmenaOsnovice = _data["jeIzmenaOsnovice"];
            if (Array.isArray(_data["includeTipoveRacuna"])) {
                this.includeTipoveRacuna = [] as any;
                for (let item of _data["includeTipoveRacuna"])
                    this.includeTipoveRacuna!.push(item);
            }
            if (Array.isArray(_data["includeStatuseRacuna"])) {
                this.includeStatuseRacuna = [] as any;
                for (let item of _data["includeStatuseRacuna"])
                    this.includeStatuseRacuna!.push(item);
            }
        }
    }

    static fromJS(data: any): GetVezaniRacunAutocompleteQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetVezaniRacunAutocompleteQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchValue"] = this.searchValue;
        data["jeIzmenaOsnovice"] = this.jeIzmenaOsnovice;
        if (Array.isArray(this.includeTipoveRacuna)) {
            data["includeTipoveRacuna"] = [];
            for (let item of this.includeTipoveRacuna)
                data["includeTipoveRacuna"].push(item);
        }
        if (Array.isArray(this.includeStatuseRacuna)) {
            data["includeStatuseRacuna"] = [];
            for (let item of this.includeStatuseRacuna)
                data["includeStatuseRacuna"].push(item);
        }
        return data;
    }
}

export interface IGetVezaniRacunAutocompleteQuery {
    searchValue?: string | undefined;
    jeIzmenaOsnovice?: boolean;
    includeTipoveRacuna?: TipRacuna[] | undefined;
    includeStatuseRacuna?: StatusRacuna[] | undefined;
}

export class ResultOfListOfRacunKompenzacijaDto extends Result implements IResultOfListOfRacunKompenzacijaDto {
    data?: RacunKompenzacijaDto[] | undefined;

    constructor(data?: IResultOfListOfRacunKompenzacijaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RacunKompenzacijaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfRacunKompenzacijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfRacunKompenzacijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfRacunKompenzacijaDto extends IResult {
    data?: RacunKompenzacijaDto[] | undefined;
}

export class RacunKompenzacijaDto implements IRacunKompenzacijaDto {
    racunId?: number;
    broj?: string | undefined;
    datumPrometa?: string | undefined;
    datumValute?: string | undefined;
    originalanBroj?: string | undefined;
    iznos?: number;
    ukupanIznosRacuna?: number;

    constructor(data?: IRacunKompenzacijaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
            this.broj = _data["broj"];
            this.datumPrometa = _data["datumPrometa"];
            this.datumValute = _data["datumValute"];
            this.originalanBroj = _data["originalanBroj"];
            this.iznos = _data["iznos"];
            this.ukupanIznosRacuna = _data["ukupanIznosRacuna"];
        }
    }

    static fromJS(data: any): RacunKompenzacijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new RacunKompenzacijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        data["broj"] = this.broj;
        data["datumPrometa"] = this.datumPrometa;
        data["datumValute"] = this.datumValute;
        data["originalanBroj"] = this.originalanBroj;
        data["iznos"] = this.iznos;
        data["ukupanIznosRacuna"] = this.ukupanIznosRacuna;
        return data;
    }
}

export interface IRacunKompenzacijaDto {
    racunId?: number;
    broj?: string | undefined;
    datumPrometa?: string | undefined;
    datumValute?: string | undefined;
    originalanBroj?: string | undefined;
    iznos?: number;
    ukupanIznosRacuna?: number;
}

export class GetRacuniKompenzacijaAutocompleteQuery implements IGetRacuniKompenzacijaAutocompleteQuery {
    searchValue?: string | undefined;
    maticniBroj?: string | undefined;
    vrstaRacuna?: VrstaRacuna;
    usedRacunIds?: number[] | undefined;

    constructor(data?: IGetRacuniKompenzacijaAutocompleteQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchValue = _data["searchValue"];
            this.maticniBroj = _data["maticniBroj"];
            this.vrstaRacuna = _data["vrstaRacuna"];
            if (Array.isArray(_data["usedRacunIds"])) {
                this.usedRacunIds = [] as any;
                for (let item of _data["usedRacunIds"])
                    this.usedRacunIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRacuniKompenzacijaAutocompleteQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetRacuniKompenzacijaAutocompleteQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchValue"] = this.searchValue;
        data["maticniBroj"] = this.maticniBroj;
        data["vrstaRacuna"] = this.vrstaRacuna;
        if (Array.isArray(this.usedRacunIds)) {
            data["usedRacunIds"] = [];
            for (let item of this.usedRacunIds)
                data["usedRacunIds"].push(item);
        }
        return data;
    }
}

export interface IGetRacuniKompenzacijaAutocompleteQuery {
    searchValue?: string | undefined;
    maticniBroj?: string | undefined;
    vrstaRacuna?: VrstaRacuna;
    usedRacunIds?: number[] | undefined;
}

export class ResultOfRacunDto extends Result implements IResultOfRacunDto {
    data?: RacunDto | undefined;

    constructor(data?: IResultOfRacunDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? RacunDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfRacunDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfRacunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfRacunDto extends IResult {
    data?: RacunDto | undefined;
}

export class GetRacunQuery extends GetRacunRequestDto implements IGetRacunQuery {

    constructor(data?: IGetRacunQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetRacunQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetRacunQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetRacunQuery extends IGetRacunRequestDto {
}

export class ResultOfRacunInfoDto extends Result implements IResultOfRacunInfoDto {
    data?: RacunInfoDto | undefined;

    constructor(data?: IResultOfRacunInfoDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? RacunInfoDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfRacunInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfRacunInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfRacunInfoDto extends IResult {
    data?: RacunInfoDto | undefined;
}

export class RacunInfoDto implements IRacunInfoDto {
    id?: number;
    tip?: TipRacuna;
    vrsta?: VrstaRacuna;
    valutaAlfaChar?: string | undefined;
    mozeNaSef?: boolean;
    statusRadnogNaloga?: StatusRadnogNalogaDto | undefined;
    broj?: string | undefined;
    datumIzdavanjaStr?: string | undefined;
    stornoBroj?: string | undefined;
    razlogOtkazivanjaStorniranja?: string | undefined;
    ulazniRacunIdSef?: number | undefined;
    statusDto?: StatusRacunaDto | undefined;
    vezaniRacuniDto?: VezaniRacunDto[] | undefined;
    eOtpremnice?: EOtpremnicaUzRacunDto[] | undefined;
    ePrijemnice?: EPrijemnicaUzRacunDto[] | undefined;
    strankaNaziv?: string | undefined;
    strankaAdresa?: string | undefined;
    strankaMB?: string | undefined;
    strankaPIB?: string | undefined;
    tipStranke?: TipStranke;
    strankaId?: number;
    statusUplateDto?: StatusUplateRacunaDto | undefined;
    iznosStr?: string | undefined;
    uplacenoStr?: string | undefined;
    preostaloStr?: string | undefined;
    datumValuteStr?: string | undefined;
    datumValuteTekstUpozorenja?: string | undefined;
    uplateRacunaTable?: UplataRacunaTableDto[] | undefined;
    hasAvansnuUplatu?: boolean;
    preostaliIznosAvansaStr?: string | undefined;
    preostaliIznosPDVStr?: string | undefined;
    oznakeDto?: OznakaDto[] | undefined;
    procenatIznos?: number;
    sefKomentar?: string | undefined;
    izlazniRacunIdSef?: number;
    dodatneUplateInfoDto?: DodatneUplateInfoDto | undefined;

    constructor(data?: IRacunInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tip = _data["tip"];
            this.vrsta = _data["vrsta"];
            this.valutaAlfaChar = _data["valutaAlfaChar"];
            this.mozeNaSef = _data["mozeNaSef"];
            this.statusRadnogNaloga = _data["statusRadnogNaloga"] ? StatusRadnogNalogaDto.fromJS(_data["statusRadnogNaloga"]) : <any>undefined;
            this.broj = _data["broj"];
            this.datumIzdavanjaStr = _data["datumIzdavanjaStr"];
            this.stornoBroj = _data["stornoBroj"];
            this.razlogOtkazivanjaStorniranja = _data["razlogOtkazivanjaStorniranja"];
            this.ulazniRacunIdSef = _data["ulazniRacunIdSef"];
            this.statusDto = _data["statusDto"] ? StatusRacunaDto.fromJS(_data["statusDto"]) : <any>undefined;
            if (Array.isArray(_data["vezaniRacuniDto"])) {
                this.vezaniRacuniDto = [] as any;
                for (let item of _data["vezaniRacuniDto"])
                    this.vezaniRacuniDto!.push(VezaniRacunDto.fromJS(item));
            }
            if (Array.isArray(_data["eOtpremnice"])) {
                this.eOtpremnice = [] as any;
                for (let item of _data["eOtpremnice"])
                    this.eOtpremnice!.push(EOtpremnicaUzRacunDto.fromJS(item));
            }
            if (Array.isArray(_data["ePrijemnice"])) {
                this.ePrijemnice = [] as any;
                for (let item of _data["ePrijemnice"])
                    this.ePrijemnice!.push(EPrijemnicaUzRacunDto.fromJS(item));
            }
            this.strankaNaziv = _data["strankaNaziv"];
            this.strankaAdresa = _data["strankaAdresa"];
            this.strankaMB = _data["strankaMB"];
            this.strankaPIB = _data["strankaPIB"];
            this.tipStranke = _data["tipStranke"];
            this.strankaId = _data["strankaId"];
            this.statusUplateDto = _data["statusUplateDto"] ? StatusUplateRacunaDto.fromJS(_data["statusUplateDto"]) : <any>undefined;
            this.iznosStr = _data["iznosStr"];
            this.uplacenoStr = _data["uplacenoStr"];
            this.preostaloStr = _data["preostaloStr"];
            this.datumValuteStr = _data["datumValuteStr"];
            this.datumValuteTekstUpozorenja = _data["datumValuteTekstUpozorenja"];
            if (Array.isArray(_data["uplateRacunaTable"])) {
                this.uplateRacunaTable = [] as any;
                for (let item of _data["uplateRacunaTable"])
                    this.uplateRacunaTable!.push(UplataRacunaTableDto.fromJS(item));
            }
            this.hasAvansnuUplatu = _data["hasAvansnuUplatu"];
            this.preostaliIznosAvansaStr = _data["preostaliIznosAvansaStr"];
            this.preostaliIznosPDVStr = _data["preostaliIznosPDVStr"];
            if (Array.isArray(_data["oznakeDto"])) {
                this.oznakeDto = [] as any;
                for (let item of _data["oznakeDto"])
                    this.oznakeDto!.push(OznakaDto.fromJS(item));
            }
            this.procenatIznos = _data["procenatIznos"];
            this.sefKomentar = _data["sefKomentar"];
            this.izlazniRacunIdSef = _data["izlazniRacunIdSef"];
            this.dodatneUplateInfoDto = _data["dodatneUplateInfoDto"] ? DodatneUplateInfoDto.fromJS(_data["dodatneUplateInfoDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RacunInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new RacunInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tip"] = this.tip;
        data["vrsta"] = this.vrsta;
        data["valutaAlfaChar"] = this.valutaAlfaChar;
        data["mozeNaSef"] = this.mozeNaSef;
        data["statusRadnogNaloga"] = this.statusRadnogNaloga ? this.statusRadnogNaloga.toJSON() : <any>undefined;
        data["broj"] = this.broj;
        data["datumIzdavanjaStr"] = this.datumIzdavanjaStr;
        data["stornoBroj"] = this.stornoBroj;
        data["razlogOtkazivanjaStorniranja"] = this.razlogOtkazivanjaStorniranja;
        data["ulazniRacunIdSef"] = this.ulazniRacunIdSef;
        data["statusDto"] = this.statusDto ? this.statusDto.toJSON() : <any>undefined;
        if (Array.isArray(this.vezaniRacuniDto)) {
            data["vezaniRacuniDto"] = [];
            for (let item of this.vezaniRacuniDto)
                data["vezaniRacuniDto"].push(item.toJSON());
        }
        if (Array.isArray(this.eOtpremnice)) {
            data["eOtpremnice"] = [];
            for (let item of this.eOtpremnice)
                data["eOtpremnice"].push(item.toJSON());
        }
        if (Array.isArray(this.ePrijemnice)) {
            data["ePrijemnice"] = [];
            for (let item of this.ePrijemnice)
                data["ePrijemnice"].push(item.toJSON());
        }
        data["strankaNaziv"] = this.strankaNaziv;
        data["strankaAdresa"] = this.strankaAdresa;
        data["strankaMB"] = this.strankaMB;
        data["strankaPIB"] = this.strankaPIB;
        data["tipStranke"] = this.tipStranke;
        data["strankaId"] = this.strankaId;
        data["statusUplateDto"] = this.statusUplateDto ? this.statusUplateDto.toJSON() : <any>undefined;
        data["iznosStr"] = this.iznosStr;
        data["uplacenoStr"] = this.uplacenoStr;
        data["preostaloStr"] = this.preostaloStr;
        data["datumValuteStr"] = this.datumValuteStr;
        data["datumValuteTekstUpozorenja"] = this.datumValuteTekstUpozorenja;
        if (Array.isArray(this.uplateRacunaTable)) {
            data["uplateRacunaTable"] = [];
            for (let item of this.uplateRacunaTable)
                data["uplateRacunaTable"].push(item.toJSON());
        }
        data["hasAvansnuUplatu"] = this.hasAvansnuUplatu;
        data["preostaliIznosAvansaStr"] = this.preostaliIznosAvansaStr;
        data["preostaliIznosPDVStr"] = this.preostaliIznosPDVStr;
        if (Array.isArray(this.oznakeDto)) {
            data["oznakeDto"] = [];
            for (let item of this.oznakeDto)
                data["oznakeDto"].push(item.toJSON());
        }
        data["procenatIznos"] = this.procenatIznos;
        data["sefKomentar"] = this.sefKomentar;
        data["izlazniRacunIdSef"] = this.izlazniRacunIdSef;
        data["dodatneUplateInfoDto"] = this.dodatneUplateInfoDto ? this.dodatneUplateInfoDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRacunInfoDto {
    id?: number;
    tip?: TipRacuna;
    vrsta?: VrstaRacuna;
    valutaAlfaChar?: string | undefined;
    mozeNaSef?: boolean;
    statusRadnogNaloga?: StatusRadnogNalogaDto | undefined;
    broj?: string | undefined;
    datumIzdavanjaStr?: string | undefined;
    stornoBroj?: string | undefined;
    razlogOtkazivanjaStorniranja?: string | undefined;
    ulazniRacunIdSef?: number | undefined;
    statusDto?: StatusRacunaDto | undefined;
    vezaniRacuniDto?: VezaniRacunDto[] | undefined;
    eOtpremnice?: EOtpremnicaUzRacunDto[] | undefined;
    ePrijemnice?: EPrijemnicaUzRacunDto[] | undefined;
    strankaNaziv?: string | undefined;
    strankaAdresa?: string | undefined;
    strankaMB?: string | undefined;
    strankaPIB?: string | undefined;
    tipStranke?: TipStranke;
    strankaId?: number;
    statusUplateDto?: StatusUplateRacunaDto | undefined;
    iznosStr?: string | undefined;
    uplacenoStr?: string | undefined;
    preostaloStr?: string | undefined;
    datumValuteStr?: string | undefined;
    datumValuteTekstUpozorenja?: string | undefined;
    uplateRacunaTable?: UplataRacunaTableDto[] | undefined;
    hasAvansnuUplatu?: boolean;
    preostaliIznosAvansaStr?: string | undefined;
    preostaliIznosPDVStr?: string | undefined;
    oznakeDto?: OznakaDto[] | undefined;
    procenatIznos?: number;
    sefKomentar?: string | undefined;
    izlazniRacunIdSef?: number;
    dodatneUplateInfoDto?: DodatneUplateInfoDto | undefined;
}

export class UplataRacunaTableDto implements IUplataRacunaTableDto {
    id?: number;
    iznos?: string | undefined;
    datumEvidentiranja?: string | undefined;
    izvor?: string | undefined;
    tipTransakcije?: TipTransakcije | undefined;
    iznosBroj?: number | undefined;

    constructor(data?: IUplataRacunaTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.iznos = _data["iznos"];
            this.datumEvidentiranja = _data["datumEvidentiranja"];
            this.izvor = _data["izvor"];
            this.tipTransakcije = _data["tipTransakcije"];
            this.iznosBroj = _data["iznosBroj"];
        }
    }

    static fromJS(data: any): UplataRacunaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new UplataRacunaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["iznos"] = this.iznos;
        data["datumEvidentiranja"] = this.datumEvidentiranja;
        data["izvor"] = this.izvor;
        data["tipTransakcije"] = this.tipTransakcije;
        data["iznosBroj"] = this.iznosBroj;
        return data;
    }
}

export interface IUplataRacunaTableDto {
    id?: number;
    iznos?: string | undefined;
    datumEvidentiranja?: string | undefined;
    izvor?: string | undefined;
    tipTransakcije?: TipTransakcije | undefined;
    iznosBroj?: number | undefined;
}

export class DodatneUplateInfoDto implements IDodatneUplateInfoDto {
    preostaliIznosZaPlacanje?: number;
    ukupnoPreostaloZaPlacanje?: number;
    jeDelimicnoPlacen?: boolean;
    tipTransakcijeDto?: TipTransakcijeUplataDto | undefined;

    constructor(data?: IDodatneUplateInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preostaliIznosZaPlacanje = _data["preostaliIznosZaPlacanje"];
            this.ukupnoPreostaloZaPlacanje = _data["ukupnoPreostaloZaPlacanje"];
            this.jeDelimicnoPlacen = _data["jeDelimicnoPlacen"];
            this.tipTransakcijeDto = _data["tipTransakcijeDto"] ? TipTransakcijeUplataDto.fromJS(_data["tipTransakcijeDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DodatneUplateInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new DodatneUplateInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preostaliIznosZaPlacanje"] = this.preostaliIznosZaPlacanje;
        data["ukupnoPreostaloZaPlacanje"] = this.ukupnoPreostaloZaPlacanje;
        data["jeDelimicnoPlacen"] = this.jeDelimicnoPlacen;
        data["tipTransakcijeDto"] = this.tipTransakcijeDto ? this.tipTransakcijeDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDodatneUplateInfoDto {
    preostaliIznosZaPlacanje?: number;
    ukupnoPreostaloZaPlacanje?: number;
    jeDelimicnoPlacen?: boolean;
    tipTransakcijeDto?: TipTransakcijeUplataDto | undefined;
}

export class TipTransakcijeUplataDto implements ITipTransakcijeUplataDto {
    tipTransakcije?: TipTransakcije;
    tipTransakcijeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: ITipTransakcijeUplataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipTransakcije = _data["tipTransakcije"];
            this.tipTransakcijeStr = _data["tipTransakcijeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): TipTransakcijeUplataDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipTransakcijeUplataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipTransakcije"] = this.tipTransakcije;
        data["tipTransakcijeStr"] = this.tipTransakcijeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface ITipTransakcijeUplataDto {
    tipTransakcije?: TipTransakcije;
    tipTransakcijeStr?: string | undefined;
    opis?: string | undefined;
}

export class GetRacunInfoQuery extends GetRacunRequestDto implements IGetRacunInfoQuery {

    constructor(data?: IGetRacunInfoQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetRacunInfoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetRacunInfoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetRacunInfoQuery extends IGetRacunRequestDto {
}

export class ResultOfGetPravilaZaBrojResponse extends Result implements IResultOfGetPravilaZaBrojResponse {
    data?: GetPravilaZaBrojResponse | undefined;

    constructor(data?: IResultOfGetPravilaZaBrojResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetPravilaZaBrojResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetPravilaZaBrojResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetPravilaZaBrojResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetPravilaZaBrojResponse extends IResult {
    data?: GetPravilaZaBrojResponse | undefined;
}

export class GetPravilaZaBrojResponse implements IGetPravilaZaBrojResponse {
    pravilaDto?: KonfiguracijaBrojaRacunaDto[] | undefined;

    constructor(data?: IGetPravilaZaBrojResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pravilaDto"])) {
                this.pravilaDto = [] as any;
                for (let item of _data["pravilaDto"])
                    this.pravilaDto!.push(KonfiguracijaBrojaRacunaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPravilaZaBrojResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPravilaZaBrojResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pravilaDto)) {
            data["pravilaDto"] = [];
            for (let item of this.pravilaDto)
                data["pravilaDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPravilaZaBrojResponse {
    pravilaDto?: KonfiguracijaBrojaRacunaDto[] | undefined;
}

export class KonfiguracijaBrojaRacunaDto implements IKonfiguracijaBrojaRacunaDto {
    id?: number | undefined;
    naziv?: string | undefined;
    tipRacunaDto?: TipRacunaDto | undefined;
    tipRacuna?: TipRacuna;
    prefiks?: string | undefined;
    brojac?: number;
    sufiks?: string | undefined;
    isDefault?: boolean;
    minimaxId?: number | undefined;

    constructor(data?: IKonfiguracijaBrojaRacunaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.tipRacunaDto = _data["tipRacunaDto"] ? TipRacunaDto.fromJS(_data["tipRacunaDto"]) : <any>undefined;
            this.tipRacuna = _data["tipRacuna"];
            this.prefiks = _data["prefiks"];
            this.brojac = _data["brojac"];
            this.sufiks = _data["sufiks"];
            this.isDefault = _data["isDefault"];
            this.minimaxId = _data["minimaxId"];
        }
    }

    static fromJS(data: any): KonfiguracijaBrojaRacunaDto {
        data = typeof data === 'object' ? data : {};
        let result = new KonfiguracijaBrojaRacunaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["tipRacunaDto"] = this.tipRacunaDto ? this.tipRacunaDto.toJSON() : <any>undefined;
        data["tipRacuna"] = this.tipRacuna;
        data["prefiks"] = this.prefiks;
        data["brojac"] = this.brojac;
        data["sufiks"] = this.sufiks;
        data["isDefault"] = this.isDefault;
        data["minimaxId"] = this.minimaxId;
        return data;
    }
}

export interface IKonfiguracijaBrojaRacunaDto {
    id?: number | undefined;
    naziv?: string | undefined;
    tipRacunaDto?: TipRacunaDto | undefined;
    tipRacuna?: TipRacuna;
    prefiks?: string | undefined;
    brojac?: number;
    sufiks?: string | undefined;
    isDefault?: boolean;
    minimaxId?: number | undefined;
}

export class CheckIfBrojRacunaExistsQuery implements ICheckIfBrojRacunaExistsQuery {
    broj?: string | undefined;
    vrstaRacuna?: VrstaRacuna;

    constructor(data?: ICheckIfBrojRacunaExistsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.broj = _data["broj"];
            this.vrstaRacuna = _data["vrstaRacuna"];
        }
    }

    static fromJS(data: any): CheckIfBrojRacunaExistsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CheckIfBrojRacunaExistsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["broj"] = this.broj;
        data["vrstaRacuna"] = this.vrstaRacuna;
        return data;
    }
}

export interface ICheckIfBrojRacunaExistsQuery {
    broj?: string | undefined;
    vrstaRacuna?: VrstaRacuna;
}

export class ResultOfOpstaPravilaKonfiguracijaDto extends Result implements IResultOfOpstaPravilaKonfiguracijaDto {
    data?: OpstaPravilaKonfiguracijaDto | undefined;

    constructor(data?: IResultOfOpstaPravilaKonfiguracijaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? OpstaPravilaKonfiguracijaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfOpstaPravilaKonfiguracijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfOpstaPravilaKonfiguracijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfOpstaPravilaKonfiguracijaDto extends IResult {
    data?: OpstaPravilaKonfiguracijaDto | undefined;
}

export class OpstaPravilaKonfiguracijaDto implements IOpstaPravilaKonfiguracijaDto {
    defaultDatumPrometa?: DatumPrometaOption;
    defaultDatumPrometaStr?: string | undefined;
    periodZaPrikazRacunaStr?: string | undefined;
    periodZaPrikazRacuna?: PeriodZaPrikazRacuna;
    mestoIzdavanjaPrometa?: string | undefined;
    sifraPlacanja?: string | undefined;
    modelPlacanja?: string | undefined;
    instrukcijaPlacanja?: string | undefined;
    prikaziNadlezniSudZaSpor?: boolean;
    nadlezanSudZaSpor?: string | undefined;
    prikaziOznake?: boolean;
    kreirajOtpremnicu?: boolean;
    prikaziPonudu?: boolean;
    prikaziCifuSlovimaSpojeno?: boolean;
    prikaziSekcijuZaRacunanjeTezine?: boolean;
    prikaziSekcijuZaInformacijeOIsporuci?: boolean;
    prikazRabataDto?: PrikazRabataDto | undefined;
    prikazOtpremniceDto?: PrikazOtpremniceDto | undefined;
    prikazRadnogNalogaDto?: PrikazRadnogNalogaDto | undefined;

    constructor(data?: IOpstaPravilaKonfiguracijaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultDatumPrometa = _data["defaultDatumPrometa"];
            this.defaultDatumPrometaStr = _data["defaultDatumPrometaStr"];
            this.periodZaPrikazRacunaStr = _data["periodZaPrikazRacunaStr"];
            this.periodZaPrikazRacuna = _data["periodZaPrikazRacuna"];
            this.mestoIzdavanjaPrometa = _data["mestoIzdavanjaPrometa"];
            this.sifraPlacanja = _data["sifraPlacanja"];
            this.modelPlacanja = _data["modelPlacanja"];
            this.instrukcijaPlacanja = _data["instrukcijaPlacanja"];
            this.prikaziNadlezniSudZaSpor = _data["prikaziNadlezniSudZaSpor"];
            this.nadlezanSudZaSpor = _data["nadlezanSudZaSpor"];
            this.prikaziOznake = _data["prikaziOznake"];
            this.kreirajOtpremnicu = _data["kreirajOtpremnicu"];
            this.prikaziPonudu = _data["prikaziPonudu"];
            this.prikaziCifuSlovimaSpojeno = _data["prikaziCifuSlovimaSpojeno"];
            this.prikaziSekcijuZaRacunanjeTezine = _data["prikaziSekcijuZaRacunanjeTezine"];
            this.prikaziSekcijuZaInformacijeOIsporuci = _data["prikaziSekcijuZaInformacijeOIsporuci"];
            this.prikazRabataDto = _data["prikazRabataDto"] ? PrikazRabataDto.fromJS(_data["prikazRabataDto"]) : <any>undefined;
            this.prikazOtpremniceDto = _data["prikazOtpremniceDto"] ? PrikazOtpremniceDto.fromJS(_data["prikazOtpremniceDto"]) : <any>undefined;
            this.prikazRadnogNalogaDto = _data["prikazRadnogNalogaDto"] ? PrikazRadnogNalogaDto.fromJS(_data["prikazRadnogNalogaDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OpstaPravilaKonfiguracijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpstaPravilaKonfiguracijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultDatumPrometa"] = this.defaultDatumPrometa;
        data["defaultDatumPrometaStr"] = this.defaultDatumPrometaStr;
        data["periodZaPrikazRacunaStr"] = this.periodZaPrikazRacunaStr;
        data["periodZaPrikazRacuna"] = this.periodZaPrikazRacuna;
        data["mestoIzdavanjaPrometa"] = this.mestoIzdavanjaPrometa;
        data["sifraPlacanja"] = this.sifraPlacanja;
        data["modelPlacanja"] = this.modelPlacanja;
        data["instrukcijaPlacanja"] = this.instrukcijaPlacanja;
        data["prikaziNadlezniSudZaSpor"] = this.prikaziNadlezniSudZaSpor;
        data["nadlezanSudZaSpor"] = this.nadlezanSudZaSpor;
        data["prikaziOznake"] = this.prikaziOznake;
        data["kreirajOtpremnicu"] = this.kreirajOtpremnicu;
        data["prikaziPonudu"] = this.prikaziPonudu;
        data["prikaziCifuSlovimaSpojeno"] = this.prikaziCifuSlovimaSpojeno;
        data["prikaziSekcijuZaRacunanjeTezine"] = this.prikaziSekcijuZaRacunanjeTezine;
        data["prikaziSekcijuZaInformacijeOIsporuci"] = this.prikaziSekcijuZaInformacijeOIsporuci;
        data["prikazRabataDto"] = this.prikazRabataDto ? this.prikazRabataDto.toJSON() : <any>undefined;
        data["prikazOtpremniceDto"] = this.prikazOtpremniceDto ? this.prikazOtpremniceDto.toJSON() : <any>undefined;
        data["prikazRadnogNalogaDto"] = this.prikazRadnogNalogaDto ? this.prikazRadnogNalogaDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOpstaPravilaKonfiguracijaDto {
    defaultDatumPrometa?: DatumPrometaOption;
    defaultDatumPrometaStr?: string | undefined;
    periodZaPrikazRacunaStr?: string | undefined;
    periodZaPrikazRacuna?: PeriodZaPrikazRacuna;
    mestoIzdavanjaPrometa?: string | undefined;
    sifraPlacanja?: string | undefined;
    modelPlacanja?: string | undefined;
    instrukcijaPlacanja?: string | undefined;
    prikaziNadlezniSudZaSpor?: boolean;
    nadlezanSudZaSpor?: string | undefined;
    prikaziOznake?: boolean;
    kreirajOtpremnicu?: boolean;
    prikaziPonudu?: boolean;
    prikaziCifuSlovimaSpojeno?: boolean;
    prikaziSekcijuZaRacunanjeTezine?: boolean;
    prikaziSekcijuZaInformacijeOIsporuci?: boolean;
    prikazRabataDto?: PrikazRabataDto | undefined;
    prikazOtpremniceDto?: PrikazOtpremniceDto | undefined;
    prikazRadnogNalogaDto?: PrikazRadnogNalogaDto | undefined;
}

export class PrikazOtpremniceDto implements IPrikazOtpremniceDto {
    prikazOtpremnice?: PrikazOtpremnice;
    prikazOtpremniceStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IPrikazOtpremniceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prikazOtpremnice = _data["prikazOtpremnice"];
            this.prikazOtpremniceStr = _data["prikazOtpremniceStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): PrikazOtpremniceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrikazOtpremniceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prikazOtpremnice"] = this.prikazOtpremnice;
        data["prikazOtpremniceStr"] = this.prikazOtpremniceStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IPrikazOtpremniceDto {
    prikazOtpremnice?: PrikazOtpremnice;
    prikazOtpremniceStr?: string | undefined;
    opis?: string | undefined;
}

export class PrikazRadnogNalogaDto implements IPrikazRadnogNalogaDto {
    prikazRadnogNaloga?: PrikazRadnogNaloga;
    prikazRadnogNalogaStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IPrikazRadnogNalogaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prikazRadnogNaloga = _data["prikazRadnogNaloga"];
            this.prikazRadnogNalogaStr = _data["prikazRadnogNalogaStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): PrikazRadnogNalogaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrikazRadnogNalogaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prikazRadnogNaloga"] = this.prikazRadnogNaloga;
        data["prikazRadnogNalogaStr"] = this.prikazRadnogNalogaStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IPrikazRadnogNalogaDto {
    prikazRadnogNaloga?: PrikazRadnogNaloga;
    prikazRadnogNalogaStr?: string | undefined;
    opis?: string | undefined;
}

export class ResultOfKonfiguracijaDeviznogRacunaDto extends Result implements IResultOfKonfiguracijaDeviznogRacunaDto {
    data?: KonfiguracijaDeviznogRacunaDto | undefined;

    constructor(data?: IResultOfKonfiguracijaDeviznogRacunaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? KonfiguracijaDeviznogRacunaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfKonfiguracijaDeviznogRacunaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfKonfiguracijaDeviznogRacunaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfKonfiguracijaDeviznogRacunaDto extends IResult {
    data?: KonfiguracijaDeviznogRacunaDto | undefined;
}

export class KonfiguracijaDeviznogRacunaDto implements IKonfiguracijaDeviznogRacunaDto {
    accountName?: string | undefined;
    accountAddress?: string | undefined;
    bank?: string | undefined;
    iban?: string | undefined;
    swift?: string | undefined;

    constructor(data?: IKonfiguracijaDeviznogRacunaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
            this.accountAddress = _data["accountAddress"];
            this.bank = _data["bank"];
            this.iban = _data["iban"];
            this.swift = _data["swift"];
        }
    }

    static fromJS(data: any): KonfiguracijaDeviznogRacunaDto {
        data = typeof data === 'object' ? data : {};
        let result = new KonfiguracijaDeviznogRacunaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["accountAddress"] = this.accountAddress;
        data["bank"] = this.bank;
        data["iban"] = this.iban;
        data["swift"] = this.swift;
        return data;
    }
}

export interface IKonfiguracijaDeviznogRacunaDto {
    accountName?: string | undefined;
    accountAddress?: string | undefined;
    bank?: string | undefined;
    iban?: string | undefined;
    swift?: string | undefined;
}

export class ResultOfOpomeneKonfiguracijaDto extends Result implements IResultOfOpomeneKonfiguracijaDto {
    data?: OpomeneKonfiguracijaDto | undefined;

    constructor(data?: IResultOfOpomeneKonfiguracijaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? OpomeneKonfiguracijaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfOpomeneKonfiguracijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfOpomeneKonfiguracijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfOpomeneKonfiguracijaDto extends IResult {
    data?: OpomeneKonfiguracijaDto | undefined;
}

export class OpomeneKonfiguracijaDto implements IOpomeneKonfiguracijaDto {
    saljiOpomeneMailom?: boolean;

    constructor(data?: IOpomeneKonfiguracijaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.saljiOpomeneMailom = _data["saljiOpomeneMailom"];
        }
    }

    static fromJS(data: any): OpomeneKonfiguracijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpomeneKonfiguracijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saljiOpomeneMailom"] = this.saljiOpomeneMailom;
        return data;
    }
}

export interface IOpomeneKonfiguracijaDto {
    saljiOpomeneMailom?: boolean;
}

export class ResultOfGetPravilaZaBrojKonfiguracijaResponse extends Result implements IResultOfGetPravilaZaBrojKonfiguracijaResponse {
    data?: GetPravilaZaBrojKonfiguracijaResponse | undefined;

    constructor(data?: IResultOfGetPravilaZaBrojKonfiguracijaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetPravilaZaBrojKonfiguracijaResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetPravilaZaBrojKonfiguracijaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetPravilaZaBrojKonfiguracijaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetPravilaZaBrojKonfiguracijaResponse extends IResult {
    data?: GetPravilaZaBrojKonfiguracijaResponse | undefined;
}

export class GetPravilaZaBrojKonfiguracijaResponse implements IGetPravilaZaBrojKonfiguracijaResponse {
    konfiguracijeBrojaRacunaDto?: KonfiguracijaBrojaRacunaDto[] | undefined;
    isEditable?: boolean;

    constructor(data?: IGetPravilaZaBrojKonfiguracijaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["konfiguracijeBrojaRacunaDto"])) {
                this.konfiguracijeBrojaRacunaDto = [] as any;
                for (let item of _data["konfiguracijeBrojaRacunaDto"])
                    this.konfiguracijeBrojaRacunaDto!.push(KonfiguracijaBrojaRacunaDto.fromJS(item));
            }
            this.isEditable = _data["isEditable"];
        }
    }

    static fromJS(data: any): GetPravilaZaBrojKonfiguracijaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPravilaZaBrojKonfiguracijaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.konfiguracijeBrojaRacunaDto)) {
            data["konfiguracijeBrojaRacunaDto"] = [];
            for (let item of this.konfiguracijeBrojaRacunaDto)
                data["konfiguracijeBrojaRacunaDto"].push(item.toJSON());
        }
        data["isEditable"] = this.isEditable;
        return data;
    }
}

export interface IGetPravilaZaBrojKonfiguracijaResponse {
    konfiguracijeBrojaRacunaDto?: KonfiguracijaBrojaRacunaDto[] | undefined;
    isEditable?: boolean;
}

export class ResultOfSearchStrankaRacunaResponse extends Result implements IResultOfSearchStrankaRacunaResponse {
    data?: SearchStrankaRacunaResponse | undefined;

    constructor(data?: IResultOfSearchStrankaRacunaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? SearchStrankaRacunaResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfSearchStrankaRacunaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfSearchStrankaRacunaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfSearchStrankaRacunaResponse extends IResult {
    data?: SearchStrankaRacunaResponse | undefined;
}

export class SearchStrankaRacunaResponse implements ISearchStrankaRacunaResponse {
    strankaRacunaDtoList?: StrankaRacunaDto[] | undefined;

    constructor(data?: ISearchStrankaRacunaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["strankaRacunaDtoList"])) {
                this.strankaRacunaDtoList = [] as any;
                for (let item of _data["strankaRacunaDtoList"])
                    this.strankaRacunaDtoList!.push(StrankaRacunaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchStrankaRacunaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchStrankaRacunaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.strankaRacunaDtoList)) {
            data["strankaRacunaDtoList"] = [];
            for (let item of this.strankaRacunaDtoList)
                data["strankaRacunaDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchStrankaRacunaResponse {
    strankaRacunaDtoList?: StrankaRacunaDto[] | undefined;
}

export class ResultOfStrankaRacunaDto extends Result implements IResultOfStrankaRacunaDto {
    data?: StrankaRacunaDto | undefined;

    constructor(data?: IResultOfStrankaRacunaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? StrankaRacunaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfStrankaRacunaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfStrankaRacunaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfStrankaRacunaDto extends IResult {
    data?: StrankaRacunaDto | undefined;
}

export class ResultOfGetPocetnoStanjeRacunResponse extends Result implements IResultOfGetPocetnoStanjeRacunResponse {
    data?: GetPocetnoStanjeRacunResponse | undefined;

    constructor(data?: IResultOfGetPocetnoStanjeRacunResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetPocetnoStanjeRacunResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetPocetnoStanjeRacunResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetPocetnoStanjeRacunResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetPocetnoStanjeRacunResponse extends IResult {
    data?: GetPocetnoStanjeRacunResponse | undefined;
}

export class GetPocetnoStanjeRacunResponse implements IGetPocetnoStanjeRacunResponse {
    racunId?: number;
    iznos?: number;

    constructor(data?: IGetPocetnoStanjeRacunResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
            this.iznos = _data["iznos"];
        }
    }

    static fromJS(data: any): GetPocetnoStanjeRacunResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPocetnoStanjeRacunResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        data["iznos"] = this.iznos;
        return data;
    }
}

export interface IGetPocetnoStanjeRacunResponse {
    racunId?: number;
    iznos?: number;
}

export class ResultOfGetFormConfigurationResponse extends Result implements IResultOfGetFormConfigurationResponse {
    data?: GetFormConfigurationResponse | undefined;

    constructor(data?: IResultOfGetFormConfigurationResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetFormConfigurationResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetFormConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetFormConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetFormConfigurationResponse extends IResult {
    data?: GetFormConfigurationResponse | undefined;
}

export class GetFormConfigurationResponse implements IGetFormConfigurationResponse {
    datumPrometa?: Date;
    mestoIzdavanjaPrometa?: string | undefined;
    nadlezanSudZaSpor?: string | undefined;
    prikaziNadlezniSudZaSpor?: boolean;
    prikaziOznake?: boolean;
    kreirajOtpremnicu?: boolean;
    prikaziPDV?: boolean;
    prikaziCifuSlovimaSpojeno?: boolean;
    prikaziSekcijuZaRacunanjeTezine?: boolean;
    prikaziSekcijuZaInformacijeOIsporuci?: boolean;
    prikazRabata?: PrikazRabata;
    sifraPlacanja?: string | undefined;
    modelPlacanja?: string | undefined;
    instrukcijaPlacanja?: string | undefined;
    imeOsobeOvlasceneZaPotpisivanje?: string | undefined;
    razlogPdvIzuzecaId?: number | undefined;
    oznakaPdvKategorije?: OznakaPdvKategorije | undefined;

    constructor(data?: IGetFormConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datumPrometa = _data["datumPrometa"] ? new Date(_data["datumPrometa"].toString()) : <any>undefined;
            this.mestoIzdavanjaPrometa = _data["mestoIzdavanjaPrometa"];
            this.nadlezanSudZaSpor = _data["nadlezanSudZaSpor"];
            this.prikaziNadlezniSudZaSpor = _data["prikaziNadlezniSudZaSpor"];
            this.prikaziOznake = _data["prikaziOznake"];
            this.kreirajOtpremnicu = _data["kreirajOtpremnicu"];
            this.prikaziPDV = _data["prikaziPDV"];
            this.prikaziCifuSlovimaSpojeno = _data["prikaziCifuSlovimaSpojeno"];
            this.prikaziSekcijuZaRacunanjeTezine = _data["prikaziSekcijuZaRacunanjeTezine"];
            this.prikaziSekcijuZaInformacijeOIsporuci = _data["prikaziSekcijuZaInformacijeOIsporuci"];
            this.prikazRabata = _data["prikazRabata"];
            this.sifraPlacanja = _data["sifraPlacanja"];
            this.modelPlacanja = _data["modelPlacanja"];
            this.instrukcijaPlacanja = _data["instrukcijaPlacanja"];
            this.imeOsobeOvlasceneZaPotpisivanje = _data["imeOsobeOvlasceneZaPotpisivanje"];
            this.razlogPdvIzuzecaId = _data["razlogPdvIzuzecaId"];
            this.oznakaPdvKategorije = _data["oznakaPdvKategorije"];
        }
    }

    static fromJS(data: any): GetFormConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datumPrometa"] = this.datumPrometa ? this.datumPrometa.toISOString() : <any>undefined;
        data["mestoIzdavanjaPrometa"] = this.mestoIzdavanjaPrometa;
        data["nadlezanSudZaSpor"] = this.nadlezanSudZaSpor;
        data["prikaziNadlezniSudZaSpor"] = this.prikaziNadlezniSudZaSpor;
        data["prikaziOznake"] = this.prikaziOznake;
        data["kreirajOtpremnicu"] = this.kreirajOtpremnicu;
        data["prikaziPDV"] = this.prikaziPDV;
        data["prikaziCifuSlovimaSpojeno"] = this.prikaziCifuSlovimaSpojeno;
        data["prikaziSekcijuZaRacunanjeTezine"] = this.prikaziSekcijuZaRacunanjeTezine;
        data["prikaziSekcijuZaInformacijeOIsporuci"] = this.prikaziSekcijuZaInformacijeOIsporuci;
        data["prikazRabata"] = this.prikazRabata;
        data["sifraPlacanja"] = this.sifraPlacanja;
        data["modelPlacanja"] = this.modelPlacanja;
        data["instrukcijaPlacanja"] = this.instrukcijaPlacanja;
        data["imeOsobeOvlasceneZaPotpisivanje"] = this.imeOsobeOvlasceneZaPotpisivanje;
        data["razlogPdvIzuzecaId"] = this.razlogPdvIzuzecaId;
        data["oznakaPdvKategorije"] = this.oznakaPdvKategorije;
        return data;
    }
}

export interface IGetFormConfigurationResponse {
    datumPrometa?: Date;
    mestoIzdavanjaPrometa?: string | undefined;
    nadlezanSudZaSpor?: string | undefined;
    prikaziNadlezniSudZaSpor?: boolean;
    prikaziOznake?: boolean;
    kreirajOtpremnicu?: boolean;
    prikaziPDV?: boolean;
    prikaziCifuSlovimaSpojeno?: boolean;
    prikaziSekcijuZaRacunanjeTezine?: boolean;
    prikaziSekcijuZaInformacijeOIsporuci?: boolean;
    prikazRabata?: PrikazRabata;
    sifraPlacanja?: string | undefined;
    modelPlacanja?: string | undefined;
    instrukcijaPlacanja?: string | undefined;
    imeOsobeOvlasceneZaPotpisivanje?: string | undefined;
    razlogPdvIzuzecaId?: number | undefined;
    oznakaPdvKategorije?: OznakaPdvKategorije | undefined;
}

export class ResultOfGetFormConfigurationDevizniResponse extends Result implements IResultOfGetFormConfigurationDevizniResponse {
    data?: GetFormConfigurationDevizniResponse | undefined;

    constructor(data?: IResultOfGetFormConfigurationDevizniResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetFormConfigurationDevizniResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetFormConfigurationDevizniResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetFormConfigurationDevizniResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetFormConfigurationDevizniResponse extends IResult {
    data?: GetFormConfigurationDevizniResponse | undefined;
}

export class GetFormConfigurationDevizniResponse implements IGetFormConfigurationDevizniResponse {
    accountName?: string | undefined;
    accountAddress?: string | undefined;
    bank?: string | undefined;
    iban?: string | undefined;
    swift?: string | undefined;

    constructor(data?: IGetFormConfigurationDevizniResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
            this.accountAddress = _data["accountAddress"];
            this.bank = _data["bank"];
            this.iban = _data["iban"];
            this.swift = _data["swift"];
        }
    }

    static fromJS(data: any): GetFormConfigurationDevizniResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormConfigurationDevizniResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["accountAddress"] = this.accountAddress;
        data["bank"] = this.bank;
        data["iban"] = this.iban;
        data["swift"] = this.swift;
        return data;
    }
}

export interface IGetFormConfigurationDevizniResponse {
    accountName?: string | undefined;
    accountAddress?: string | undefined;
    bank?: string | undefined;
    iban?: string | undefined;
    swift?: string | undefined;
}

export class UplatnicaDto implements IUplatnicaDto {
    svrhaUplate?: string | undefined;
    sifraPlacanja?: number;
    brojRata?: number;
    racunId?: number;
    tekuciRacunPrimaoca?: string | undefined;

    constructor(data?: IUplatnicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.svrhaUplate = _data["svrhaUplate"];
            this.sifraPlacanja = _data["sifraPlacanja"];
            this.brojRata = _data["brojRata"];
            this.racunId = _data["racunId"];
            this.tekuciRacunPrimaoca = _data["tekuciRacunPrimaoca"];
        }
    }

    static fromJS(data: any): UplatnicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UplatnicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["svrhaUplate"] = this.svrhaUplate;
        data["sifraPlacanja"] = this.sifraPlacanja;
        data["brojRata"] = this.brojRata;
        data["racunId"] = this.racunId;
        data["tekuciRacunPrimaoca"] = this.tekuciRacunPrimaoca;
        return data;
    }
}

export interface IUplatnicaDto {
    svrhaUplate?: string | undefined;
    sifraPlacanja?: number;
    brojRata?: number;
    racunId?: number;
    tekuciRacunPrimaoca?: string | undefined;
}

export class GetUplatnicaPdfQuery extends UplatnicaDto implements IGetUplatnicaPdfQuery {

    constructor(data?: IGetUplatnicaPdfQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetUplatnicaPdfQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUplatnicaPdfQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetUplatnicaPdfQuery extends IUplatnicaDto {
}

export class ResultOfGetRelevantniDokumentUrlListResponse extends Result implements IResultOfGetRelevantniDokumentUrlListResponse {
    data?: GetRelevantniDokumentUrlListResponse | undefined;

    constructor(data?: IResultOfGetRelevantniDokumentUrlListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetRelevantniDokumentUrlListResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetRelevantniDokumentUrlListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetRelevantniDokumentUrlListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetRelevantniDokumentUrlListResponse extends IResult {
    data?: GetRelevantniDokumentUrlListResponse | undefined;
}

export class GetRelevantniDokumentUrlListResponse implements IGetRelevantniDokumentUrlListResponse {
    responseList?: RelevantniDokumentListItemUrlDto[] | undefined;

    constructor(data?: IGetRelevantniDokumentUrlListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(RelevantniDokumentListItemUrlDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRelevantniDokumentUrlListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRelevantniDokumentUrlListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRelevantniDokumentUrlListResponse {
    responseList?: RelevantniDokumentListItemUrlDto[] | undefined;
}

export class ExportRacunCommand implements IExportRacunCommand {
    racuni?: number[] | undefined;
    format?: FormatIzvoza;

    constructor(data?: IExportRacunCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["racuni"])) {
                this.racuni = [] as any;
                for (let item of _data["racuni"])
                    this.racuni!.push(item);
            }
            this.format = _data["format"];
        }
    }

    static fromJS(data: any): ExportRacunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExportRacunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.racuni)) {
            data["racuni"] = [];
            for (let item of this.racuni)
                data["racuni"].push(item);
        }
        data["format"] = this.format;
        return data;
    }
}

export interface IExportRacunCommand {
    racuni?: number[] | undefined;
    format?: FormatIzvoza;
}

export class DuplirajRacuneCommand implements IDuplirajRacuneCommand {
    racunIds?: number[] | undefined;
    tip?: TipRacuna;
    datumPrometa?: Date | undefined;
    napomena?: string | undefined;

    constructor(data?: IDuplirajRacuneCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["racunIds"])) {
                this.racunIds = [] as any;
                for (let item of _data["racunIds"])
                    this.racunIds!.push(item);
            }
            this.tip = _data["tip"];
            this.datumPrometa = _data["datumPrometa"] ? new Date(_data["datumPrometa"].toString()) : <any>undefined;
            this.napomena = _data["napomena"];
        }
    }

    static fromJS(data: any): DuplirajRacuneCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DuplirajRacuneCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.racunIds)) {
            data["racunIds"] = [];
            for (let item of this.racunIds)
                data["racunIds"].push(item);
        }
        data["tip"] = this.tip;
        data["datumPrometa"] = this.datumPrometa ? this.datumPrometa.toISOString() : <any>undefined;
        data["napomena"] = this.napomena;
        return data;
    }
}

export interface IDuplirajRacuneCommand {
    racunIds?: number[] | undefined;
    tip?: TipRacuna;
    datumPrometa?: Date | undefined;
    napomena?: string | undefined;
}

export class PosaljiPredracuneEmailomCommand implements IPosaljiPredracuneEmailomCommand {
    racunIds?: number[] | undefined;
    fromId?: string;
    mailNaslov?: string | undefined;
    customPoruka?: string | undefined;

    constructor(data?: IPosaljiPredracuneEmailomCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["racunIds"])) {
                this.racunIds = [] as any;
                for (let item of _data["racunIds"])
                    this.racunIds!.push(item);
            }
            this.fromId = _data["fromId"];
            this.mailNaslov = _data["mailNaslov"];
            this.customPoruka = _data["customPoruka"];
        }
    }

    static fromJS(data: any): PosaljiPredracuneEmailomCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PosaljiPredracuneEmailomCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.racunIds)) {
            data["racunIds"] = [];
            for (let item of this.racunIds)
                data["racunIds"].push(item);
        }
        data["fromId"] = this.fromId;
        data["mailNaslov"] = this.mailNaslov;
        data["customPoruka"] = this.customPoruka;
        return data;
    }
}

export interface IPosaljiPredracuneEmailomCommand {
    racunIds?: number[] | undefined;
    fromId?: string;
    mailNaslov?: string | undefined;
    customPoruka?: string | undefined;
}

export class ResultOfListOfTipTransakcijeUplataDto extends Result implements IResultOfListOfTipTransakcijeUplataDto {
    data?: TipTransakcijeUplataDto[] | undefined;

    constructor(data?: IResultOfListOfTipTransakcijeUplataDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TipTransakcijeUplataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfTipTransakcijeUplataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfTipTransakcijeUplataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfTipTransakcijeUplataDto extends IResult {
    data?: TipTransakcijeUplataDto[] | undefined;
}

export class ResultOfUplataPoRacunuDto extends Result implements IResultOfUplataPoRacunuDto {
    data?: UplataPoRacunuDto | undefined;

    constructor(data?: IResultOfUplataPoRacunuDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? UplataPoRacunuDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfUplataPoRacunuDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfUplataPoRacunuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfUplataPoRacunuDto extends IResult {
    data?: UplataPoRacunuDto | undefined;
}

export class UplataPoRacunuDto implements IUplataPoRacunuDto {
    id?: number;
    uplacenIznos?: number;
    tipTransakcije?: TipTransakcije | undefined;

    constructor(data?: IUplataPoRacunuDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uplacenIznos = _data["uplacenIznos"];
            this.tipTransakcije = _data["tipTransakcije"];
        }
    }

    static fromJS(data: any): UplataPoRacunuDto {
        data = typeof data === 'object' ? data : {};
        let result = new UplataPoRacunuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uplacenIznos"] = this.uplacenIznos;
        data["tipTransakcije"] = this.tipTransakcije;
        return data;
    }
}

export interface IUplataPoRacunuDto {
    id?: number;
    uplacenIznos?: number;
    tipTransakcije?: TipTransakcije | undefined;
}

export class GetRacunRelevantniDokumentListZippedQuery implements IGetRacunRelevantniDokumentListZippedQuery {
    racunIds?: number[] | undefined;

    constructor(data?: IGetRacunRelevantniDokumentListZippedQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["racunIds"])) {
                this.racunIds = [] as any;
                for (let item of _data["racunIds"])
                    this.racunIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRacunRelevantniDokumentListZippedQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetRacunRelevantniDokumentListZippedQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.racunIds)) {
            data["racunIds"] = [];
            for (let item of this.racunIds)
                data["racunIds"].push(item);
        }
        return data;
    }
}

export interface IGetRacunRelevantniDokumentListZippedQuery {
    racunIds?: number[] | undefined;
}

export class GetIzlazniRacunUblQuery implements IGetIzlazniRacunUblQuery {
    racunId?: number;

    constructor(data?: IGetIzlazniRacunUblQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
        }
    }

    static fromJS(data: any): GetIzlazniRacunUblQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetIzlazniRacunUblQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        return data;
    }
}

export interface IGetIzlazniRacunUblQuery {
    racunId?: number;
}

export class SendPodsetnikPlacanjaRacunaCommand implements ISendPodsetnikPlacanjaRacunaCommand {
    strankaId?: number | undefined;
    fromId?: string;
    to?: MailReceiverDto[] | undefined;
    cc?: MailReceiverDto[] | undefined;
    filter?: RacunFilterDto | undefined;

    constructor(data?: ISendPodsetnikPlacanjaRacunaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.strankaId = _data["strankaId"];
            this.fromId = _data["fromId"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(MailReceiverDto.fromJS(item));
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(MailReceiverDto.fromJS(item));
            }
            this.filter = _data["filter"] ? RacunFilterDto.fromJS(_data["filter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SendPodsetnikPlacanjaRacunaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendPodsetnikPlacanjaRacunaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["strankaId"] = this.strankaId;
        data["fromId"] = this.fromId;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item.toJSON());
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item.toJSON());
        }
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISendPodsetnikPlacanjaRacunaCommand {
    strankaId?: number | undefined;
    fromId?: string;
    to?: MailReceiverDto[] | undefined;
    cc?: MailReceiverDto[] | undefined;
    filter?: RacunFilterDto | undefined;
}

export class RacunFilterDto implements IRacunFilterDto {
    racunFilterId?: number;
    naziv?: string | undefined;
    broj?: string | undefined;
    gradStranke?: string | undefined;
    originalanBroj?: string | undefined;
    brojOtpremnice?: string | undefined;
    dodatniOpisStavke?: string | undefined;
    vrstaRacuna?: VrstaRacuna;
    datumIzdavanjaOd?: Date | undefined;
    datumIzdavanjaDo?: Date | undefined;
    datumSlanjaSefOd?: Date | undefined;
    datumSlanjaSefDo?: Date | undefined;
    datumPrometaOd?: Date | undefined;
    datumPrometaDo?: Date | undefined;
    datumValute?: Date | undefined;
    period?: PdvPeriod | undefined;
    valutaIsticeZa?: number | undefined;
    prometOd?: number | undefined;
    prometDo?: number | undefined;
    stranke?: StrankaMultiSelectItem[] | undefined;
    strankaId?: number | undefined;
    statusi?: StatusRacunaDto[] | undefined;
    tip?: TipRacuna;
    createByEmail?: string | undefined;
    oznake?: GetOznakaMultiselectResponse[] | undefined;
    statusiUplateRacuna?: StatusUplateRacunaDto[] | undefined;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
    vanValute?: boolean | undefined;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IRacunFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunFilterId = _data["racunFilterId"];
            this.naziv = _data["naziv"];
            this.broj = _data["broj"];
            this.gradStranke = _data["gradStranke"];
            this.originalanBroj = _data["originalanBroj"];
            this.brojOtpremnice = _data["brojOtpremnice"];
            this.dodatniOpisStavke = _data["dodatniOpisStavke"];
            this.vrstaRacuna = _data["vrstaRacuna"];
            this.datumIzdavanjaOd = _data["datumIzdavanjaOd"] ? new Date(_data["datumIzdavanjaOd"].toString()) : <any>undefined;
            this.datumIzdavanjaDo = _data["datumIzdavanjaDo"] ? new Date(_data["datumIzdavanjaDo"].toString()) : <any>undefined;
            this.datumSlanjaSefOd = _data["datumSlanjaSefOd"] ? new Date(_data["datumSlanjaSefOd"].toString()) : <any>undefined;
            this.datumSlanjaSefDo = _data["datumSlanjaSefDo"] ? new Date(_data["datumSlanjaSefDo"].toString()) : <any>undefined;
            this.datumPrometaOd = _data["datumPrometaOd"] ? new Date(_data["datumPrometaOd"].toString()) : <any>undefined;
            this.datumPrometaDo = _data["datumPrometaDo"] ? new Date(_data["datumPrometaDo"].toString()) : <any>undefined;
            this.datumValute = _data["datumValute"] ? new Date(_data["datumValute"].toString()) : <any>undefined;
            this.period = _data["period"];
            this.valutaIsticeZa = _data["valutaIsticeZa"];
            this.prometOd = _data["prometOd"];
            this.prometDo = _data["prometDo"];
            if (Array.isArray(_data["stranke"])) {
                this.stranke = [] as any;
                for (let item of _data["stranke"])
                    this.stranke!.push(StrankaMultiSelectItem.fromJS(item));
            }
            this.strankaId = _data["strankaId"];
            if (Array.isArray(_data["statusi"])) {
                this.statusi = [] as any;
                for (let item of _data["statusi"])
                    this.statusi!.push(StatusRacunaDto.fromJS(item));
            }
            this.tip = _data["tip"];
            this.createByEmail = _data["createByEmail"];
            if (Array.isArray(_data["oznake"])) {
                this.oznake = [] as any;
                for (let item of _data["oznake"])
                    this.oznake!.push(GetOznakaMultiselectResponse.fromJS(item));
            }
            if (Array.isArray(_data["statusiUplateRacuna"])) {
                this.statusiUplateRacuna = [] as any;
                for (let item of _data["statusiUplateRacuna"])
                    this.statusiUplateRacuna!.push(StatusUplateRacunaDto.fromJS(item));
            }
            this.klasifikacijaRacuna = _data["klasifikacijaRacuna"];
            this.pravoNaPdvOdbitak = _data["pravoNaPdvOdbitak"];
            this.vanValute = _data["vanValute"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): RacunFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new RacunFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunFilterId"] = this.racunFilterId;
        data["naziv"] = this.naziv;
        data["broj"] = this.broj;
        data["gradStranke"] = this.gradStranke;
        data["originalanBroj"] = this.originalanBroj;
        data["brojOtpremnice"] = this.brojOtpremnice;
        data["dodatniOpisStavke"] = this.dodatniOpisStavke;
        data["vrstaRacuna"] = this.vrstaRacuna;
        data["datumIzdavanjaOd"] = this.datumIzdavanjaOd ? this.datumIzdavanjaOd.toISOString() : <any>undefined;
        data["datumIzdavanjaDo"] = this.datumIzdavanjaDo ? this.datumIzdavanjaDo.toISOString() : <any>undefined;
        data["datumSlanjaSefOd"] = this.datumSlanjaSefOd ? this.datumSlanjaSefOd.toISOString() : <any>undefined;
        data["datumSlanjaSefDo"] = this.datumSlanjaSefDo ? this.datumSlanjaSefDo.toISOString() : <any>undefined;
        data["datumPrometaOd"] = this.datumPrometaOd ? this.datumPrometaOd.toISOString() : <any>undefined;
        data["datumPrometaDo"] = this.datumPrometaDo ? this.datumPrometaDo.toISOString() : <any>undefined;
        data["datumValute"] = this.datumValute ? this.datumValute.toISOString() : <any>undefined;
        data["period"] = this.period;
        data["valutaIsticeZa"] = this.valutaIsticeZa;
        data["prometOd"] = this.prometOd;
        data["prometDo"] = this.prometDo;
        if (Array.isArray(this.stranke)) {
            data["stranke"] = [];
            for (let item of this.stranke)
                data["stranke"].push(item.toJSON());
        }
        data["strankaId"] = this.strankaId;
        if (Array.isArray(this.statusi)) {
            data["statusi"] = [];
            for (let item of this.statusi)
                data["statusi"].push(item.toJSON());
        }
        data["tip"] = this.tip;
        data["createByEmail"] = this.createByEmail;
        if (Array.isArray(this.oznake)) {
            data["oznake"] = [];
            for (let item of this.oznake)
                data["oznake"].push(item.toJSON());
        }
        if (Array.isArray(this.statusiUplateRacuna)) {
            data["statusiUplateRacuna"] = [];
            for (let item of this.statusiUplateRacuna)
                data["statusiUplateRacuna"].push(item.toJSON());
        }
        data["klasifikacijaRacuna"] = this.klasifikacijaRacuna;
        data["pravoNaPdvOdbitak"] = this.pravoNaPdvOdbitak;
        data["vanValute"] = this.vanValute;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IRacunFilterDto {
    racunFilterId?: number;
    naziv?: string | undefined;
    broj?: string | undefined;
    gradStranke?: string | undefined;
    originalanBroj?: string | undefined;
    brojOtpremnice?: string | undefined;
    dodatniOpisStavke?: string | undefined;
    vrstaRacuna?: VrstaRacuna;
    datumIzdavanjaOd?: Date | undefined;
    datumIzdavanjaDo?: Date | undefined;
    datumSlanjaSefOd?: Date | undefined;
    datumSlanjaSefDo?: Date | undefined;
    datumPrometaOd?: Date | undefined;
    datumPrometaDo?: Date | undefined;
    datumValute?: Date | undefined;
    period?: PdvPeriod | undefined;
    valutaIsticeZa?: number | undefined;
    prometOd?: number | undefined;
    prometDo?: number | undefined;
    stranke?: StrankaMultiSelectItem[] | undefined;
    strankaId?: number | undefined;
    statusi?: StatusRacunaDto[] | undefined;
    tip?: TipRacuna;
    createByEmail?: string | undefined;
    oznake?: GetOznakaMultiselectResponse[] | undefined;
    statusiUplateRacuna?: StatusUplateRacunaDto[] | undefined;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
    vanValute?: boolean | undefined;
    pageNumber?: number;
    pageSize?: number;
}

export class RemoveOznakaRacunaCommand implements IRemoveOznakaRacunaCommand {
    racunId?: number;
    oznakaId?: number;

    constructor(data?: IRemoveOznakaRacunaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
            this.oznakaId = _data["oznakaId"];
        }
    }

    static fromJS(data: any): RemoveOznakaRacunaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveOznakaRacunaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        data["oznakaId"] = this.oznakaId;
        return data;
    }
}

export interface IRemoveOznakaRacunaCommand {
    racunId?: number;
    oznakaId?: number;
}

export class AddOznakeRacunaCommand implements IAddOznakeRacunaCommand {
    oznake?: OznakaDto[] | undefined;
    racunId?: number;

    constructor(data?: IAddOznakeRacunaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["oznake"])) {
                this.oznake = [] as any;
                for (let item of _data["oznake"])
                    this.oznake!.push(OznakaDto.fromJS(item));
            }
            this.racunId = _data["racunId"];
        }
    }

    static fromJS(data: any): AddOznakeRacunaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddOznakeRacunaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.oznake)) {
            data["oznake"] = [];
            for (let item of this.oznake)
                data["oznake"].push(item.toJSON());
        }
        data["racunId"] = this.racunId;
        return data;
    }
}

export interface IAddOznakeRacunaCommand {
    oznake?: OznakaDto[] | undefined;
    racunId?: number;
}

export class AddPovezaniRacunCommand implements IAddPovezaniRacunCommand {
    vezaniRacuniDto?: VezaniRacunDto[] | undefined;
    racunId?: number;

    constructor(data?: IAddPovezaniRacunCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vezaniRacuniDto"])) {
                this.vezaniRacuniDto = [] as any;
                for (let item of _data["vezaniRacuniDto"])
                    this.vezaniRacuniDto!.push(VezaniRacunDto.fromJS(item));
            }
            this.racunId = _data["racunId"];
        }
    }

    static fromJS(data: any): AddPovezaniRacunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddPovezaniRacunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vezaniRacuniDto)) {
            data["vezaniRacuniDto"] = [];
            for (let item of this.vezaniRacuniDto)
                data["vezaniRacuniDto"].push(item.toJSON());
        }
        data["racunId"] = this.racunId;
        return data;
    }
}

export interface IAddPovezaniRacunCommand {
    vezaniRacuniDto?: VezaniRacunDto[] | undefined;
    racunId?: number;
}

export class ResultOfListOfImportPlacanjeStarihRacunaDto extends Result implements IResultOfListOfImportPlacanjeStarihRacunaDto {
    data?: ImportPlacanjeStarihRacunaDto[] | undefined;

    constructor(data?: IResultOfListOfImportPlacanjeStarihRacunaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ImportPlacanjeStarihRacunaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfImportPlacanjeStarihRacunaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfImportPlacanjeStarihRacunaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfImportPlacanjeStarihRacunaDto extends IResult {
    data?: ImportPlacanjeStarihRacunaDto[] | undefined;
}

export class ImportPlacanjeStarihRacunaDto implements IImportPlacanjeStarihRacunaDto {
    identifikacioniBroj?: string | undefined;
    dugovanje?: string | undefined;
    potrazivanje?: string | undefined;
    greska?: string | undefined;

    constructor(data?: IImportPlacanjeStarihRacunaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifikacioniBroj = _data["identifikacioniBroj"];
            this.dugovanje = _data["dugovanje"];
            this.potrazivanje = _data["potrazivanje"];
            this.greska = _data["greska"];
        }
    }

    static fromJS(data: any): ImportPlacanjeStarihRacunaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportPlacanjeStarihRacunaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifikacioniBroj"] = this.identifikacioniBroj;
        data["dugovanje"] = this.dugovanje;
        data["potrazivanje"] = this.potrazivanje;
        data["greska"] = this.greska;
        return data;
    }
}

export interface IImportPlacanjeStarihRacunaDto {
    identifikacioniBroj?: string | undefined;
    dugovanje?: string | undefined;
    potrazivanje?: string | undefined;
    greska?: string | undefined;
}

export class ResultOfListOfCreateDodatnuUplatuRacunaCommand extends Result implements IResultOfListOfCreateDodatnuUplatuRacunaCommand {
    data?: CreateDodatnuUplatuRacunaCommand[] | undefined;

    constructor(data?: IResultOfListOfCreateDodatnuUplatuRacunaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CreateDodatnuUplatuRacunaCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfCreateDodatnuUplatuRacunaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfCreateDodatnuUplatuRacunaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfCreateDodatnuUplatuRacunaCommand extends IResult {
    data?: CreateDodatnuUplatuRacunaCommand[] | undefined;
}

export class CreateDodatnuUplatuRacunaCommand implements ICreateDodatnuUplatuRacunaCommand {
    id?: number | undefined;
    iznosUplate?: number;
    tipTransakcije?: TipTransakcije;

    constructor(data?: ICreateDodatnuUplatuRacunaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.iznosUplate = _data["iznosUplate"];
            this.tipTransakcije = _data["tipTransakcije"];
        }
    }

    static fromJS(data: any): CreateDodatnuUplatuRacunaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDodatnuUplatuRacunaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["iznosUplate"] = this.iznosUplate;
        data["tipTransakcije"] = this.tipTransakcije;
        return data;
    }
}

export interface ICreateDodatnuUplatuRacunaCommand {
    id?: number | undefined;
    iznosUplate?: number;
    tipTransakcije?: TipTransakcije;
}

export class UpdateDodatnuUplatuRacunaCommand implements IUpdateDodatnuUplatuRacunaCommand {
    id?: number;
    iznosUplate?: number;
    tipTransakcije?: TipTransakcije;

    constructor(data?: IUpdateDodatnuUplatuRacunaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.iznosUplate = _data["iznosUplate"];
            this.tipTransakcije = _data["tipTransakcije"];
        }
    }

    static fromJS(data: any): UpdateDodatnuUplatuRacunaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDodatnuUplatuRacunaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["iznosUplate"] = this.iznosUplate;
        data["tipTransakcije"] = this.tipTransakcije;
        return data;
    }
}

export interface IUpdateDodatnuUplatuRacunaCommand {
    id?: number;
    iznosUplate?: number;
    tipTransakcije?: TipTransakcije;
}

export class PaginatedResultOfRacunZaPlacanjeDto extends Result implements IPaginatedResultOfRacunZaPlacanjeDto {
    data?: RacunZaPlacanjeDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfRacunZaPlacanjeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RacunZaPlacanjeDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfRacunZaPlacanjeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfRacunZaPlacanjeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfRacunZaPlacanjeDto extends IResult {
    data?: RacunZaPlacanjeDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class RacunZaPlacanjeDto implements IRacunZaPlacanjeDto {
    broj?: string | undefined;
    datumValute?: string | undefined;
    iznos?: number;
    iznosStr?: string | undefined;
    statusUplate?: string | undefined;

    constructor(data?: IRacunZaPlacanjeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.broj = _data["broj"];
            this.datumValute = _data["datumValute"];
            this.iznos = _data["iznos"];
            this.iznosStr = _data["iznosStr"];
            this.statusUplate = _data["statusUplate"];
        }
    }

    static fromJS(data: any): RacunZaPlacanjeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RacunZaPlacanjeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["broj"] = this.broj;
        data["datumValute"] = this.datumValute;
        data["iznos"] = this.iznos;
        data["iznosStr"] = this.iznosStr;
        data["statusUplate"] = this.statusUplate;
        return data;
    }
}

export interface IRacunZaPlacanjeDto {
    broj?: string | undefined;
    datumValute?: string | undefined;
    iznos?: number;
    iznosStr?: string | undefined;
    statusUplate?: string | undefined;
}

export class GetRacuneZaPlacanjeQuery implements IGetRacuneZaPlacanjeQuery {
    samoNeplaceni?: boolean;
    fromKodit?: boolean;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetRacuneZaPlacanjeQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.samoNeplaceni = _data["samoNeplaceni"];
            this.fromKodit = _data["fromKodit"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetRacuneZaPlacanjeQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetRacuneZaPlacanjeQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["samoNeplaceni"] = this.samoNeplaceni;
        data["fromKodit"] = this.fromKodit;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetRacuneZaPlacanjeQuery {
    samoNeplaceni?: boolean;
    fromKodit?: boolean;
    pageNumber?: number;
    pageSize?: number;
}

export class CreateRacunFilterCommand implements ICreateRacunFilterCommand {
    racunFilterId?: number;
    naziv?: string | undefined;
    strankaId?: number | undefined;
    broj?: string | undefined;
    gradStranke?: string | undefined;
    dodatniOpisStavke?: string | undefined;
    originalanBroj?: string | undefined;
    brojOtpremnice?: string | undefined;
    vrstaRacuna?: VrstaRacuna;
    datumIzdavanjaOd?: Date | undefined;
    datumIzdavanjaDo?: Date | undefined;
    datumSlanjaSefOd?: Date | undefined;
    datumSlanjaSefDo?: Date | undefined;
    datumPrometaOd?: Date | undefined;
    datumPrometaDo?: Date | undefined;
    oznake?: GetOznakaMultiselectResponse[] | undefined;
    datumValute?: Date | undefined;
    period?: PdvPeriod | undefined;
    valutaIsticeZa?: number | undefined;
    valutaIsticeDo?: Date | undefined;
    stranke?: StrankaMultiSelectItem[] | undefined;
    prometOd?: number | undefined;
    prometDo?: number | undefined;
    statusi?: StatusRacunaDto[] | undefined;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
    vanValute?: boolean | undefined;
    tip?: TipRacuna;
    createByEmail?: string | undefined;
    statusiUplateRacuna?: StatusUplateRacunaDto[] | undefined;

    constructor(data?: ICreateRacunFilterCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunFilterId = _data["racunFilterId"];
            this.naziv = _data["naziv"];
            this.strankaId = _data["strankaId"];
            this.broj = _data["broj"];
            this.gradStranke = _data["gradStranke"];
            this.dodatniOpisStavke = _data["dodatniOpisStavke"];
            this.originalanBroj = _data["originalanBroj"];
            this.brojOtpremnice = _data["brojOtpremnice"];
            this.vrstaRacuna = _data["vrstaRacuna"];
            this.datumIzdavanjaOd = _data["datumIzdavanjaOd"] ? new Date(_data["datumIzdavanjaOd"].toString()) : <any>undefined;
            this.datumIzdavanjaDo = _data["datumIzdavanjaDo"] ? new Date(_data["datumIzdavanjaDo"].toString()) : <any>undefined;
            this.datumSlanjaSefOd = _data["datumSlanjaSefOd"] ? new Date(_data["datumSlanjaSefOd"].toString()) : <any>undefined;
            this.datumSlanjaSefDo = _data["datumSlanjaSefDo"] ? new Date(_data["datumSlanjaSefDo"].toString()) : <any>undefined;
            this.datumPrometaOd = _data["datumPrometaOd"] ? new Date(_data["datumPrometaOd"].toString()) : <any>undefined;
            this.datumPrometaDo = _data["datumPrometaDo"] ? new Date(_data["datumPrometaDo"].toString()) : <any>undefined;
            if (Array.isArray(_data["oznake"])) {
                this.oznake = [] as any;
                for (let item of _data["oznake"])
                    this.oznake!.push(GetOznakaMultiselectResponse.fromJS(item));
            }
            this.datumValute = _data["datumValute"] ? new Date(_data["datumValute"].toString()) : <any>undefined;
            this.period = _data["period"];
            this.valutaIsticeZa = _data["valutaIsticeZa"];
            this.valutaIsticeDo = _data["valutaIsticeDo"] ? new Date(_data["valutaIsticeDo"].toString()) : <any>undefined;
            if (Array.isArray(_data["stranke"])) {
                this.stranke = [] as any;
                for (let item of _data["stranke"])
                    this.stranke!.push(StrankaMultiSelectItem.fromJS(item));
            }
            this.prometOd = _data["prometOd"];
            this.prometDo = _data["prometDo"];
            if (Array.isArray(_data["statusi"])) {
                this.statusi = [] as any;
                for (let item of _data["statusi"])
                    this.statusi!.push(StatusRacunaDto.fromJS(item));
            }
            this.klasifikacijaRacuna = _data["klasifikacijaRacuna"];
            this.pravoNaPdvOdbitak = _data["pravoNaPdvOdbitak"];
            this.vanValute = _data["vanValute"];
            this.tip = _data["tip"];
            this.createByEmail = _data["createByEmail"];
            if (Array.isArray(_data["statusiUplateRacuna"])) {
                this.statusiUplateRacuna = [] as any;
                for (let item of _data["statusiUplateRacuna"])
                    this.statusiUplateRacuna!.push(StatusUplateRacunaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateRacunFilterCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRacunFilterCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunFilterId"] = this.racunFilterId;
        data["naziv"] = this.naziv;
        data["strankaId"] = this.strankaId;
        data["broj"] = this.broj;
        data["gradStranke"] = this.gradStranke;
        data["dodatniOpisStavke"] = this.dodatniOpisStavke;
        data["originalanBroj"] = this.originalanBroj;
        data["brojOtpremnice"] = this.brojOtpremnice;
        data["vrstaRacuna"] = this.vrstaRacuna;
        data["datumIzdavanjaOd"] = this.datumIzdavanjaOd ? this.datumIzdavanjaOd.toISOString() : <any>undefined;
        data["datumIzdavanjaDo"] = this.datumIzdavanjaDo ? this.datumIzdavanjaDo.toISOString() : <any>undefined;
        data["datumSlanjaSefOd"] = this.datumSlanjaSefOd ? this.datumSlanjaSefOd.toISOString() : <any>undefined;
        data["datumSlanjaSefDo"] = this.datumSlanjaSefDo ? this.datumSlanjaSefDo.toISOString() : <any>undefined;
        data["datumPrometaOd"] = this.datumPrometaOd ? this.datumPrometaOd.toISOString() : <any>undefined;
        data["datumPrometaDo"] = this.datumPrometaDo ? this.datumPrometaDo.toISOString() : <any>undefined;
        if (Array.isArray(this.oznake)) {
            data["oznake"] = [];
            for (let item of this.oznake)
                data["oznake"].push(item.toJSON());
        }
        data["datumValute"] = this.datumValute ? this.datumValute.toISOString() : <any>undefined;
        data["period"] = this.period;
        data["valutaIsticeZa"] = this.valutaIsticeZa;
        data["valutaIsticeDo"] = this.valutaIsticeDo ? this.valutaIsticeDo.toISOString() : <any>undefined;
        if (Array.isArray(this.stranke)) {
            data["stranke"] = [];
            for (let item of this.stranke)
                data["stranke"].push(item.toJSON());
        }
        data["prometOd"] = this.prometOd;
        data["prometDo"] = this.prometDo;
        if (Array.isArray(this.statusi)) {
            data["statusi"] = [];
            for (let item of this.statusi)
                data["statusi"].push(item.toJSON());
        }
        data["klasifikacijaRacuna"] = this.klasifikacijaRacuna;
        data["pravoNaPdvOdbitak"] = this.pravoNaPdvOdbitak;
        data["vanValute"] = this.vanValute;
        data["tip"] = this.tip;
        data["createByEmail"] = this.createByEmail;
        if (Array.isArray(this.statusiUplateRacuna)) {
            data["statusiUplateRacuna"] = [];
            for (let item of this.statusiUplateRacuna)
                data["statusiUplateRacuna"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateRacunFilterCommand {
    racunFilterId?: number;
    naziv?: string | undefined;
    strankaId?: number | undefined;
    broj?: string | undefined;
    gradStranke?: string | undefined;
    dodatniOpisStavke?: string | undefined;
    originalanBroj?: string | undefined;
    brojOtpremnice?: string | undefined;
    vrstaRacuna?: VrstaRacuna;
    datumIzdavanjaOd?: Date | undefined;
    datumIzdavanjaDo?: Date | undefined;
    datumSlanjaSefOd?: Date | undefined;
    datumSlanjaSefDo?: Date | undefined;
    datumPrometaOd?: Date | undefined;
    datumPrometaDo?: Date | undefined;
    oznake?: GetOznakaMultiselectResponse[] | undefined;
    datumValute?: Date | undefined;
    period?: PdvPeriod | undefined;
    valutaIsticeZa?: number | undefined;
    valutaIsticeDo?: Date | undefined;
    stranke?: StrankaMultiSelectItem[] | undefined;
    prometOd?: number | undefined;
    prometDo?: number | undefined;
    statusi?: StatusRacunaDto[] | undefined;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
    vanValute?: boolean | undefined;
    tip?: TipRacuna;
    createByEmail?: string | undefined;
    statusiUplateRacuna?: StatusUplateRacunaDto[] | undefined;
}

export class ResultOfGetFiltersResponseOfRacunFilterDto extends Result implements IResultOfGetFiltersResponseOfRacunFilterDto {
    data?: GetFiltersResponseOfRacunFilterDto | undefined;

    constructor(data?: IResultOfGetFiltersResponseOfRacunFilterDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetFiltersResponseOfRacunFilterDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetFiltersResponseOfRacunFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetFiltersResponseOfRacunFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetFiltersResponseOfRacunFilterDto extends IResult {
    data?: GetFiltersResponseOfRacunFilterDto | undefined;
}

export class GetFiltersResponseOfRacunFilterDto implements IGetFiltersResponseOfRacunFilterDto {
    filters?: RacunFilterDto[] | undefined;

    constructor(data?: IGetFiltersResponseOfRacunFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RacunFilterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFiltersResponseOfRacunFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFiltersResponseOfRacunFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFiltersResponseOfRacunFilterDto {
    filters?: RacunFilterDto[] | undefined;
}

export class ResultOfKonfiguracijaBrojaRacunaDto extends Result implements IResultOfKonfiguracijaBrojaRacunaDto {
    data?: KonfiguracijaBrojaRacunaDto | undefined;

    constructor(data?: IResultOfKonfiguracijaBrojaRacunaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? KonfiguracijaBrojaRacunaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfKonfiguracijaBrojaRacunaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfKonfiguracijaBrojaRacunaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfKonfiguracijaBrojaRacunaDto extends IResult {
    data?: KonfiguracijaBrojaRacunaDto | undefined;
}

export class CreatePraviloZaBrojCommand extends KonfiguracijaBrojaRacunaDto implements ICreatePraviloZaBrojCommand {

    constructor(data?: ICreatePraviloZaBrojCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreatePraviloZaBrojCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePraviloZaBrojCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreatePraviloZaBrojCommand extends IKonfiguracijaBrojaRacunaDto {
}

export class RemoveRacunDto implements IRemoveRacunDto {
    id?: number;
    tipPoveznogRacuna?: TipRacuna;
    povezanChildRacunId?: number;

    constructor(data?: IRemoveRacunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tipPoveznogRacuna = _data["tipPoveznogRacuna"];
            this.povezanChildRacunId = _data["povezanChildRacunId"];
        }
    }

    static fromJS(data: any): RemoveRacunDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveRacunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipPoveznogRacuna"] = this.tipPoveznogRacuna;
        data["povezanChildRacunId"] = this.povezanChildRacunId;
        return data;
    }
}

export interface IRemoveRacunDto {
    id?: number;
    tipPoveznogRacuna?: TipRacuna;
    povezanChildRacunId?: number;
}

export class RemoveVezaniRacunCommand extends RemoveRacunDto implements IRemoveVezaniRacunCommand {

    constructor(data?: IRemoveVezaniRacunCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): RemoveVezaniRacunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveVezaniRacunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IRemoveVezaniRacunCommand extends IRemoveRacunDto {
}

export class RemoveEOtpremnicaFromRacunCommand implements IRemoveEOtpremnicaFromRacunCommand {
    racunId?: number;
    eOtpremnicaId?: number;

    constructor(data?: IRemoveEOtpremnicaFromRacunCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
            this.eOtpremnicaId = _data["eOtpremnicaId"];
        }
    }

    static fromJS(data: any): RemoveEOtpremnicaFromRacunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveEOtpremnicaFromRacunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        data["eOtpremnicaId"] = this.eOtpremnicaId;
        return data;
    }
}

export interface IRemoveEOtpremnicaFromRacunCommand {
    racunId?: number;
    eOtpremnicaId?: number;
}

export class AddEOtpremnicaToRacunCommand implements IAddEOtpremnicaToRacunCommand {
    racunId?: number;
    eOtpremnicaBaseIds?: number[] | undefined;

    constructor(data?: IAddEOtpremnicaToRacunCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
            if (Array.isArray(_data["eOtpremnicaBaseIds"])) {
                this.eOtpremnicaBaseIds = [] as any;
                for (let item of _data["eOtpremnicaBaseIds"])
                    this.eOtpremnicaBaseIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AddEOtpremnicaToRacunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddEOtpremnicaToRacunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        if (Array.isArray(this.eOtpremnicaBaseIds)) {
            data["eOtpremnicaBaseIds"] = [];
            for (let item of this.eOtpremnicaBaseIds)
                data["eOtpremnicaBaseIds"].push(item);
        }
        return data;
    }
}

export interface IAddEOtpremnicaToRacunCommand {
    racunId?: number;
    eOtpremnicaBaseIds?: number[] | undefined;
}

export class UpdatePraviloZaBrojCommand extends KonfiguracijaBrojaRacunaDto implements IUpdatePraviloZaBrojCommand {

    constructor(data?: IUpdatePraviloZaBrojCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdatePraviloZaBrojCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePraviloZaBrojCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePraviloZaBrojCommand extends IKonfiguracijaBrojaRacunaDto {
}

export class UpdateOpstaPravilaCommand extends OpstaPravilaKonfiguracijaDto implements IUpdateOpstaPravilaCommand {

    constructor(data?: IUpdateOpstaPravilaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateOpstaPravilaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOpstaPravilaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateOpstaPravilaCommand extends IOpstaPravilaKonfiguracijaDto {
}

export class UpdateKonfiguracijaDeviznihCommand extends KonfiguracijaDeviznogRacunaDto implements IUpdateKonfiguracijaDeviznihCommand {

    constructor(data?: IUpdateKonfiguracijaDeviznihCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateKonfiguracijaDeviznihCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateKonfiguracijaDeviznihCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateKonfiguracijaDeviznihCommand extends IKonfiguracijaDeviznogRacunaDto {
}

export class ResultOfListOfBuyerReferenceDto extends Result implements IResultOfListOfBuyerReferenceDto {
    data?: BuyerReferenceDto[] | undefined;

    constructor(data?: IResultOfListOfBuyerReferenceDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BuyerReferenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfBuyerReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfBuyerReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfBuyerReferenceDto extends IResult {
    data?: BuyerReferenceDto[] | undefined;
}

export class BuyerReferenceDto implements IBuyerReferenceDto {
    buyerReference?: BuyerReference;
    buyerReferenceStr?: string | undefined;
    buyerReferenceBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IBuyerReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buyerReference = _data["buyerReference"];
            this.buyerReferenceStr = _data["buyerReferenceStr"];
            this.buyerReferenceBadgeStr = _data["buyerReferenceBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): BuyerReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuyerReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buyerReference"] = this.buyerReference;
        data["buyerReferenceStr"] = this.buyerReferenceStr;
        data["buyerReferenceBadgeStr"] = this.buyerReferenceBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IBuyerReferenceDto {
    buyerReference?: BuyerReference;
    buyerReferenceStr?: string | undefined;
    buyerReferenceBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export enum BuyerReference {
    FAKTURA_ROBA = 1,
    FAKTURA_USLUGE = 2,
    FAKTURA_INVESTICIJE = 3,
    FAKTURA_KAMATE = 4,
    FAKTURA_AMBALAZA = 5,
    FAKTURA_GRATIS = 6,
    FAKTURA_REKLAMA = 7,
    POVRAT = 8,
    AKCIJA = 9,
    BONITETI = 10,
    KOREKCIJA_CENE = 11,
}

export class CreateRadniNalogCommand implements ICreateRadniNalogCommand {
    rok?: Date;
    vrsta?: VrstaRadnogNaloga;
    racunDto?: RacunDto | undefined;
    statusRadnogNaloga?: StatusRadnogNaloga;

    constructor(data?: ICreateRadniNalogCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rok = _data["rok"] ? new Date(_data["rok"].toString()) : <any>undefined;
            this.vrsta = _data["vrsta"];
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.statusRadnogNaloga = _data["statusRadnogNaloga"];
        }
    }

    static fromJS(data: any): CreateRadniNalogCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRadniNalogCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rok"] = this.rok ? this.rok.toISOString() : <any>undefined;
        data["vrsta"] = this.vrsta;
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["statusRadnogNaloga"] = this.statusRadnogNaloga;
        return data;
    }
}

export interface ICreateRadniNalogCommand {
    rok?: Date;
    vrsta?: VrstaRadnogNaloga;
    racunDto?: RacunDto | undefined;
    statusRadnogNaloga?: StatusRadnogNaloga;
}

export class UpdateRadniNalogCommand implements IUpdateRadniNalogCommand {
    racunDto?: RacunDto | undefined;
    rok?: Date;
    vrsta?: VrstaRadnogNaloga;
    statusRadnogNaloga?: StatusRadnogNaloga;

    constructor(data?: IUpdateRadniNalogCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.rok = _data["rok"] ? new Date(_data["rok"].toString()) : <any>undefined;
            this.vrsta = _data["vrsta"];
            this.statusRadnogNaloga = _data["statusRadnogNaloga"];
        }
    }

    static fromJS(data: any): UpdateRadniNalogCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRadniNalogCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["rok"] = this.rok ? this.rok.toISOString() : <any>undefined;
        data["vrsta"] = this.vrsta;
        data["statusRadnogNaloga"] = this.statusRadnogNaloga;
        return data;
    }
}

export interface IUpdateRadniNalogCommand {
    racunDto?: RacunDto | undefined;
    rok?: Date;
    vrsta?: VrstaRadnogNaloga;
    statusRadnogNaloga?: StatusRadnogNaloga;
}

export class UpdateStatusRadnogNalogaCommand implements IUpdateStatusRadnogNalogaCommand {
    id?: number | undefined;
    status?: StatusRadnogNaloga;

    constructor(data?: IUpdateStatusRadnogNalogaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateStatusRadnogNalogaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatusRadnogNalogaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateStatusRadnogNalogaCommand {
    id?: number | undefined;
    status?: StatusRadnogNaloga;
}

export class CancelRadniNalogCommand implements ICancelRadniNalogCommand {
    racunId?: number;

    constructor(data?: ICancelRadniNalogCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
        }
    }

    static fromJS(data: any): CancelRadniNalogCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CancelRadniNalogCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        return data;
    }
}

export interface ICancelRadniNalogCommand {
    racunId?: number;
}

export class ResultOfRadniNalogDto extends Result implements IResultOfRadniNalogDto {
    data?: RadniNalogDto | undefined;

    constructor(data?: IResultOfRadniNalogDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? RadniNalogDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfRadniNalogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfRadniNalogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfRadniNalogDto extends IResult {
    data?: RadniNalogDto | undefined;
}

export class RadniNalogDto implements IRadniNalogDto {
    rok?: Date;
    vrsta?: VrstaRadnogNaloga;
    racunDto?: RacunDto | undefined;
    statusRadnogNaloga?: StatusRadnogNaloga;

    constructor(data?: IRadniNalogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rok = _data["rok"] ? new Date(_data["rok"].toString()) : <any>undefined;
            this.vrsta = _data["vrsta"];
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.statusRadnogNaloga = _data["statusRadnogNaloga"];
        }
    }

    static fromJS(data: any): RadniNalogDto {
        data = typeof data === 'object' ? data : {};
        let result = new RadniNalogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rok"] = this.rok ? this.rok.toISOString() : <any>undefined;
        data["vrsta"] = this.vrsta;
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["statusRadnogNaloga"] = this.statusRadnogNaloga;
        return data;
    }
}

export interface IRadniNalogDto {
    rok?: Date;
    vrsta?: VrstaRadnogNaloga;
    racunDto?: RacunDto | undefined;
    statusRadnogNaloga?: StatusRadnogNaloga;
}

export class GetRadniNalogQuery extends GetRacunRequestDto implements IGetRadniNalogQuery {

    constructor(data?: IGetRadniNalogQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetRadniNalogQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetRadniNalogQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetRadniNalogQuery extends IGetRacunRequestDto {
}

export class PaginatedResultOfRadniNalogTableDto extends Result implements IPaginatedResultOfRadniNalogTableDto {
    data?: RadniNalogTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfRadniNalogTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RadniNalogTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfRadniNalogTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfRadniNalogTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfRadniNalogTableDto extends IResult {
    data?: RadniNalogTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class RadniNalogTableDto implements IRadniNalogTableDto {
    id?: number;
    broj?: string | undefined;
    iznos?: number;
    iznosRSD?: number;
    rutiranjeStrankeDto?: RutiranjeStrankeDto | undefined;
    vezaniRacuniDto?: VezaniRacunDto[] | undefined;
    datumValuteStr?: string | undefined;
    rokStr?: string | undefined;
    valutaText?: string | undefined;
    statusDto?: StatusRadnogNalogaDto | undefined;
    vrstaDto?: VrstaRadnogNalogaDto | undefined;

    constructor(data?: IRadniNalogTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.broj = _data["broj"];
            this.iznos = _data["iznos"];
            this.iznosRSD = _data["iznosRSD"];
            this.rutiranjeStrankeDto = _data["rutiranjeStrankeDto"] ? RutiranjeStrankeDto.fromJS(_data["rutiranjeStrankeDto"]) : <any>undefined;
            if (Array.isArray(_data["vezaniRacuniDto"])) {
                this.vezaniRacuniDto = [] as any;
                for (let item of _data["vezaniRacuniDto"])
                    this.vezaniRacuniDto!.push(VezaniRacunDto.fromJS(item));
            }
            this.datumValuteStr = _data["datumValuteStr"];
            this.rokStr = _data["rokStr"];
            this.valutaText = _data["valutaText"];
            this.statusDto = _data["statusDto"] ? StatusRadnogNalogaDto.fromJS(_data["statusDto"]) : <any>undefined;
            this.vrstaDto = _data["vrstaDto"] ? VrstaRadnogNalogaDto.fromJS(_data["vrstaDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RadniNalogTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RadniNalogTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["broj"] = this.broj;
        data["iznos"] = this.iznos;
        data["iznosRSD"] = this.iznosRSD;
        data["rutiranjeStrankeDto"] = this.rutiranjeStrankeDto ? this.rutiranjeStrankeDto.toJSON() : <any>undefined;
        if (Array.isArray(this.vezaniRacuniDto)) {
            data["vezaniRacuniDto"] = [];
            for (let item of this.vezaniRacuniDto)
                data["vezaniRacuniDto"].push(item.toJSON());
        }
        data["datumValuteStr"] = this.datumValuteStr;
        data["rokStr"] = this.rokStr;
        data["valutaText"] = this.valutaText;
        data["statusDto"] = this.statusDto ? this.statusDto.toJSON() : <any>undefined;
        data["vrstaDto"] = this.vrstaDto ? this.vrstaDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRadniNalogTableDto {
    id?: number;
    broj?: string | undefined;
    iznos?: number;
    iznosRSD?: number;
    rutiranjeStrankeDto?: RutiranjeStrankeDto | undefined;
    vezaniRacuniDto?: VezaniRacunDto[] | undefined;
    datumValuteStr?: string | undefined;
    rokStr?: string | undefined;
    valutaText?: string | undefined;
    statusDto?: StatusRadnogNalogaDto | undefined;
    vrstaDto?: VrstaRadnogNalogaDto | undefined;
}

export class VrstaRadnogNalogaDto implements IVrstaRadnogNalogaDto {
    vrsta?: VrstaRadnogNaloga;
    vrstaStr?: string | undefined;
    vrstaBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IVrstaRadnogNalogaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vrsta = _data["vrsta"];
            this.vrstaStr = _data["vrstaStr"];
            this.vrstaBadgeStr = _data["vrstaBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): VrstaRadnogNalogaDto {
        data = typeof data === 'object' ? data : {};
        let result = new VrstaRadnogNalogaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vrsta"] = this.vrsta;
        data["vrstaStr"] = this.vrstaStr;
        data["vrstaBadgeStr"] = this.vrstaBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IVrstaRadnogNalogaDto {
    vrsta?: VrstaRadnogNaloga;
    vrstaStr?: string | undefined;
    vrstaBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class GetRadniNalogTableQuery implements IGetRadniNalogTableQuery {
    pageNumber?: number;
    pageSize?: number;
    broj?: string | undefined;
    stranke?: StrankaDto[] | undefined;
    statusi?: StatusRadnogNalogaDto[] | undefined;

    constructor(data?: IGetRadniNalogTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.broj = _data["broj"];
            if (Array.isArray(_data["stranke"])) {
                this.stranke = [] as any;
                for (let item of _data["stranke"])
                    this.stranke!.push(StrankaDto.fromJS(item));
            }
            if (Array.isArray(_data["statusi"])) {
                this.statusi = [] as any;
                for (let item of _data["statusi"])
                    this.statusi!.push(StatusRadnogNalogaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRadniNalogTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetRadniNalogTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["broj"] = this.broj;
        if (Array.isArray(this.stranke)) {
            data["stranke"] = [];
            for (let item of this.stranke)
                data["stranke"].push(item.toJSON());
        }
        if (Array.isArray(this.statusi)) {
            data["statusi"] = [];
            for (let item of this.statusi)
                data["statusi"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRadniNalogTableQuery {
    pageNumber?: number;
    pageSize?: number;
    broj?: string | undefined;
    stranke?: StrankaDto[] | undefined;
    statusi?: StatusRadnogNalogaDto[] | undefined;
}

export class ResultOfGetTableResponseOfRepromaterijalTableDto extends Result implements IResultOfGetTableResponseOfRepromaterijalTableDto {
    data?: GetTableResponseOfRepromaterijalTableDto | undefined;

    constructor(data?: IResultOfGetTableResponseOfRepromaterijalTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetTableResponseOfRepromaterijalTableDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetTableResponseOfRepromaterijalTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetTableResponseOfRepromaterijalTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetTableResponseOfRepromaterijalTableDto extends IResult {
    data?: GetTableResponseOfRepromaterijalTableDto | undefined;
}

export class GetTableResponseOfRepromaterijalTableDto implements IGetTableResponseOfRepromaterijalTableDto {
    responseList?: RepromaterijalTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;

    constructor(data?: IGetTableResponseOfRepromaterijalTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(RepromaterijalTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTableResponseOfRepromaterijalTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTableResponseOfRepromaterijalTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTableResponseOfRepromaterijalTableDto {
    responseList?: RepromaterijalTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
}

export class RepromaterijalTableDto implements IRepromaterijalTableDto {
    id?: number;
    naziv?: string | undefined;
    tarifniBrojStr?: string | undefined;

    constructor(data?: IRepromaterijalTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.tarifniBrojStr = _data["tarifniBrojStr"];
        }
    }

    static fromJS(data: any): RepromaterijalTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RepromaterijalTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["tarifniBrojStr"] = this.tarifniBrojStr;
        return data;
    }
}

export interface IRepromaterijalTableDto {
    id?: number;
    naziv?: string | undefined;
    tarifniBrojStr?: string | undefined;
}

export class GetRepromaterijalTableQuery implements IGetRepromaterijalTableQuery {

    constructor(data?: IGetRepromaterijalTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetRepromaterijalTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetRepromaterijalTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetRepromaterijalTableQuery {
}

export class ResultOfGetRepromaterijalMultiselectResponse extends Result implements IResultOfGetRepromaterijalMultiselectResponse {
    data?: GetRepromaterijalMultiselectResponse | undefined;

    constructor(data?: IResultOfGetRepromaterijalMultiselectResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetRepromaterijalMultiselectResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetRepromaterijalMultiselectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetRepromaterijalMultiselectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetRepromaterijalMultiselectResponse extends IResult {
    data?: GetRepromaterijalMultiselectResponse | undefined;
}

export class GetRepromaterijalMultiselectResponse implements IGetRepromaterijalMultiselectResponse {
    repromaterijalMultiselectDtoList?: RepromaterijalMultiselectDto[] | undefined;

    constructor(data?: IGetRepromaterijalMultiselectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["repromaterijalMultiselectDtoList"])) {
                this.repromaterijalMultiselectDtoList = [] as any;
                for (let item of _data["repromaterijalMultiselectDtoList"])
                    this.repromaterijalMultiselectDtoList!.push(RepromaterijalMultiselectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRepromaterijalMultiselectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRepromaterijalMultiselectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.repromaterijalMultiselectDtoList)) {
            data["repromaterijalMultiselectDtoList"] = [];
            for (let item of this.repromaterijalMultiselectDtoList)
                data["repromaterijalMultiselectDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRepromaterijalMultiselectResponse {
    repromaterijalMultiselectDtoList?: RepromaterijalMultiselectDto[] | undefined;
}

export class RepromaterijalMultiselectDto implements IRepromaterijalMultiselectDto {
    id?: number;
    naziv?: string | undefined;
    tarifniBrojStr?: string | undefined;

    constructor(data?: IRepromaterijalMultiselectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.tarifniBrojStr = _data["tarifniBrojStr"];
        }
    }

    static fromJS(data: any): RepromaterijalMultiselectDto {
        data = typeof data === 'object' ? data : {};
        let result = new RepromaterijalMultiselectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["tarifniBrojStr"] = this.tarifniBrojStr;
        return data;
    }
}

export interface IRepromaterijalMultiselectDto {
    id?: number;
    naziv?: string | undefined;
    tarifniBrojStr?: string | undefined;
}

export class ResultOfRepromaterijalDto extends Result implements IResultOfRepromaterijalDto {
    data?: RepromaterijalDto | undefined;

    constructor(data?: IResultOfRepromaterijalDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? RepromaterijalDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfRepromaterijalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfRepromaterijalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfRepromaterijalDto extends IResult {
    data?: RepromaterijalDto | undefined;
}

export class RepromaterijalDto implements IRepromaterijalDto {
    id?: number | undefined;
    naziv?: string | undefined;
    tarifniBrojStr?: string | undefined;

    constructor(data?: IRepromaterijalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.tarifniBrojStr = _data["tarifniBrojStr"];
        }
    }

    static fromJS(data: any): RepromaterijalDto {
        data = typeof data === 'object' ? data : {};
        let result = new RepromaterijalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["tarifniBrojStr"] = this.tarifniBrojStr;
        return data;
    }
}

export interface IRepromaterijalDto {
    id?: number | undefined;
    naziv?: string | undefined;
    tarifniBrojStr?: string | undefined;
}

export class CreateRepromaterijalCommand extends RepromaterijalDto implements ICreateRepromaterijalCommand {

    constructor(data?: ICreateRepromaterijalCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateRepromaterijalCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRepromaterijalCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateRepromaterijalCommand extends IRepromaterijalDto {
}

export class UpdateRepromaterijalCommand extends RepromaterijalDto implements IUpdateRepromaterijalCommand {

    constructor(data?: IUpdateRepromaterijalCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateRepromaterijalCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRepromaterijalCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateRepromaterijalCommand extends IRepromaterijalDto {
}

export class ResultOfGetTableResponseOfRobaTableDto extends Result implements IResultOfGetTableResponseOfRobaTableDto {
    data?: GetTableResponseOfRobaTableDto | undefined;

    constructor(data?: IResultOfGetTableResponseOfRobaTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetTableResponseOfRobaTableDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetTableResponseOfRobaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetTableResponseOfRobaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetTableResponseOfRobaTableDto extends IResult {
    data?: GetTableResponseOfRobaTableDto | undefined;
}

export class GetTableResponseOfRobaTableDto implements IGetTableResponseOfRobaTableDto {
    responseList?: RobaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;

    constructor(data?: IGetTableResponseOfRobaTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(RobaTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTableResponseOfRobaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTableResponseOfRobaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTableResponseOfRobaTableDto {
    responseList?: RobaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
}

export class PredmetStavkeTableDto implements IPredmetStavkeTableDto {
    id?: number;
    naziv?: string | undefined;
    sifra?: string | undefined;
    jedinicaMereDescription?: string | undefined;
    cenaSaPdv?: number;
    cenaBezPdv?: number;
    valutaText?: string | undefined;
    tip?: TipPredmeta;

    constructor(data?: IPredmetStavkeTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.sifra = _data["sifra"];
            this.jedinicaMereDescription = _data["jedinicaMereDescription"];
            this.cenaSaPdv = _data["cenaSaPdv"];
            this.cenaBezPdv = _data["cenaBezPdv"];
            this.valutaText = _data["valutaText"];
            this.tip = _data["tip"];
        }
    }

    static fromJS(data: any): PredmetStavkeTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredmetStavkeTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["sifra"] = this.sifra;
        data["jedinicaMereDescription"] = this.jedinicaMereDescription;
        data["cenaSaPdv"] = this.cenaSaPdv;
        data["cenaBezPdv"] = this.cenaBezPdv;
        data["valutaText"] = this.valutaText;
        data["tip"] = this.tip;
        return data;
    }
}

export interface IPredmetStavkeTableDto {
    id?: number;
    naziv?: string | undefined;
    sifra?: string | undefined;
    jedinicaMereDescription?: string | undefined;
    cenaSaPdv?: number;
    cenaBezPdv?: number;
    valutaText?: string | undefined;
    tip?: TipPredmeta;
}

export class RobaTableDto extends PredmetStavkeTableDto implements IRobaTableDto {

    constructor(data?: IRobaTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): RobaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RobaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IRobaTableDto extends IPredmetStavkeTableDto {
}

export class GetRobaTableQuery implements IGetRobaTableQuery {
    naziv?: string | undefined;
    sifra?: string | undefined;
    includeTipovePredmeta?: TipPredmeta[] | undefined;

    constructor(data?: IGetRobaTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.sifra = _data["sifra"];
            if (Array.isArray(_data["includeTipovePredmeta"])) {
                this.includeTipovePredmeta = [] as any;
                for (let item of _data["includeTipovePredmeta"])
                    this.includeTipovePredmeta!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRobaTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetRobaTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["sifra"] = this.sifra;
        if (Array.isArray(this.includeTipovePredmeta)) {
            data["includeTipovePredmeta"] = [];
            for (let item of this.includeTipovePredmeta)
                data["includeTipovePredmeta"].push(item);
        }
        return data;
    }
}

export interface IGetRobaTableQuery {
    naziv?: string | undefined;
    sifra?: string | undefined;
    includeTipovePredmeta?: TipPredmeta[] | undefined;
}

export class ResultOfRobaDto extends Result implements IResultOfRobaDto {
    data?: RobaDto | undefined;

    constructor(data?: IResultOfRobaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? RobaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfRobaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfRobaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfRobaDto extends IResult {
    data?: RobaDto | undefined;
}

export class RobaDto implements IRobaDto {
    predmetStavkeDto?: PredmetStavkeDto | undefined;
    masaPoJedinici?: number | undefined;
    napomena?: string | undefined;
    barkodovi?: string[] | undefined;
    kategorija?: OznakaDto | undefined;
    nazivNaEngleskom?: string | undefined;
    netoTezinaKg?: number | undefined;
    tarifniBrojStr?: string | undefined;
    repromaterijali?: RepromaterijalDto[] | undefined;
    magacini?: MagacinDto[] | undefined;

    constructor(data?: IRobaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predmetStavkeDto = _data["predmetStavkeDto"] ? PredmetStavkeDto.fromJS(_data["predmetStavkeDto"]) : <any>undefined;
            this.masaPoJedinici = _data["masaPoJedinici"];
            this.napomena = _data["napomena"];
            if (Array.isArray(_data["barkodovi"])) {
                this.barkodovi = [] as any;
                for (let item of _data["barkodovi"])
                    this.barkodovi!.push(item);
            }
            this.kategorija = _data["kategorija"] ? OznakaDto.fromJS(_data["kategorija"]) : <any>undefined;
            this.nazivNaEngleskom = _data["nazivNaEngleskom"];
            this.netoTezinaKg = _data["netoTezinaKg"];
            this.tarifniBrojStr = _data["tarifniBrojStr"];
            if (Array.isArray(_data["repromaterijali"])) {
                this.repromaterijali = [] as any;
                for (let item of _data["repromaterijali"])
                    this.repromaterijali!.push(RepromaterijalDto.fromJS(item));
            }
            if (Array.isArray(_data["magacini"])) {
                this.magacini = [] as any;
                for (let item of _data["magacini"])
                    this.magacini!.push(MagacinDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RobaDto {
        data = typeof data === 'object' ? data : {};
        let result = new RobaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predmetStavkeDto"] = this.predmetStavkeDto ? this.predmetStavkeDto.toJSON() : <any>undefined;
        data["masaPoJedinici"] = this.masaPoJedinici;
        data["napomena"] = this.napomena;
        if (Array.isArray(this.barkodovi)) {
            data["barkodovi"] = [];
            for (let item of this.barkodovi)
                data["barkodovi"].push(item);
        }
        data["kategorija"] = this.kategorija ? this.kategorija.toJSON() : <any>undefined;
        data["nazivNaEngleskom"] = this.nazivNaEngleskom;
        data["netoTezinaKg"] = this.netoTezinaKg;
        data["tarifniBrojStr"] = this.tarifniBrojStr;
        if (Array.isArray(this.repromaterijali)) {
            data["repromaterijali"] = [];
            for (let item of this.repromaterijali)
                data["repromaterijali"].push(item.toJSON());
        }
        if (Array.isArray(this.magacini)) {
            data["magacini"] = [];
            for (let item of this.magacini)
                data["magacini"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRobaDto {
    predmetStavkeDto?: PredmetStavkeDto | undefined;
    masaPoJedinici?: number | undefined;
    napomena?: string | undefined;
    barkodovi?: string[] | undefined;
    kategorija?: OznakaDto | undefined;
    nazivNaEngleskom?: string | undefined;
    netoTezinaKg?: number | undefined;
    tarifniBrojStr?: string | undefined;
    repromaterijali?: RepromaterijalDto[] | undefined;
    magacini?: MagacinDto[] | undefined;
}

export class ResultOfRobaCommandResponse extends Result implements IResultOfRobaCommandResponse {
    data?: RobaCommandResponse | undefined;

    constructor(data?: IResultOfRobaCommandResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? RobaCommandResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfRobaCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfRobaCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfRobaCommandResponse extends IResult {
    data?: RobaCommandResponse | undefined;
}

export class RobaCommandResponse implements IRobaCommandResponse {
    robaDto?: RobaDto | undefined;
    robaTableDto?: RobaTableDto | undefined;

    constructor(data?: IRobaCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.robaDto = _data["robaDto"] ? RobaDto.fromJS(_data["robaDto"]) : <any>undefined;
            this.robaTableDto = _data["robaTableDto"] ? RobaTableDto.fromJS(_data["robaTableDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RobaCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RobaCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["robaDto"] = this.robaDto ? this.robaDto.toJSON() : <any>undefined;
        data["robaTableDto"] = this.robaTableDto ? this.robaTableDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRobaCommandResponse {
    robaDto?: RobaDto | undefined;
    robaTableDto?: RobaTableDto | undefined;
}

export class CreateRobaCommand extends RobaDto implements ICreateRobaCommand {

    constructor(data?: ICreateRobaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateRobaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRobaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateRobaCommand extends IRobaDto {
}

export class UpdateRobaCommand extends RobaDto implements IUpdateRobaCommand {

    constructor(data?: IUpdateRobaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateRobaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRobaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateRobaCommand extends IRobaDto {
}

export class PrebacivanjeUslugeURobuCommand implements IPrebacivanjeUslugeURobuCommand {
    uslugeIds?: number[] | undefined;
    magacini?: MagacinDto[] | undefined;

    constructor(data?: IPrebacivanjeUslugeURobuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["uslugeIds"])) {
                this.uslugeIds = [] as any;
                for (let item of _data["uslugeIds"])
                    this.uslugeIds!.push(item);
            }
            if (Array.isArray(_data["magacini"])) {
                this.magacini = [] as any;
                for (let item of _data["magacini"])
                    this.magacini!.push(MagacinDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PrebacivanjeUslugeURobuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PrebacivanjeUslugeURobuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uslugeIds)) {
            data["uslugeIds"] = [];
            for (let item of this.uslugeIds)
                data["uslugeIds"].push(item);
        }
        if (Array.isArray(this.magacini)) {
            data["magacini"] = [];
            for (let item of this.magacini)
                data["magacini"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPrebacivanjeUslugeURobuCommand {
    uslugeIds?: number[] | undefined;
    magacini?: MagacinDto[] | undefined;
}

export class ResultOfListOfArtikalPoMagacinimaDto extends Result implements IResultOfListOfArtikalPoMagacinimaDto {
    data?: ArtikalPoMagacinimaDto[] | undefined;

    constructor(data?: IResultOfListOfArtikalPoMagacinimaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ArtikalPoMagacinimaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfArtikalPoMagacinimaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfArtikalPoMagacinimaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfArtikalPoMagacinimaDto extends IResult {
    data?: ArtikalPoMagacinimaDto[] | undefined;
}

export class ArtikalPoMagacinimaDto implements IArtikalPoMagacinimaDto {
    nazivArtikla?: string | undefined;
    sifra?: string | undefined;
    grad?: string | undefined;
    adresa?: string | undefined;

    constructor(data?: IArtikalPoMagacinimaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nazivArtikla = _data["nazivArtikla"];
            this.sifra = _data["sifra"];
            this.grad = _data["grad"];
            this.adresa = _data["adresa"];
        }
    }

    static fromJS(data: any): ArtikalPoMagacinimaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArtikalPoMagacinimaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nazivArtikla"] = this.nazivArtikla;
        data["sifra"] = this.sifra;
        data["grad"] = this.grad;
        data["adresa"] = this.adresa;
        return data;
    }
}

export interface IArtikalPoMagacinimaDto {
    nazivArtikla?: string | undefined;
    sifra?: string | undefined;
    grad?: string | undefined;
    adresa?: string | undefined;
}

export class ResultOfUkupnoStanjeRobeDto extends Result implements IResultOfUkupnoStanjeRobeDto {
    data?: UkupnoStanjeRobeDto | undefined;

    constructor(data?: IResultOfUkupnoStanjeRobeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? UkupnoStanjeRobeDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfUkupnoStanjeRobeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfUkupnoStanjeRobeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfUkupnoStanjeRobeDto extends IResult {
    data?: UkupnoStanjeRobeDto | undefined;
}

export class UkupnoStanjeRobeDto implements IUkupnoStanjeRobeDto {
    naziv?: string | undefined;
    sifra?: string | undefined;
    barkodovi?: string[] | undefined;
    ukupnaKolicina?: number;

    constructor(data?: IUkupnoStanjeRobeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.sifra = _data["sifra"];
            if (Array.isArray(_data["barkodovi"])) {
                this.barkodovi = [] as any;
                for (let item of _data["barkodovi"])
                    this.barkodovi!.push(item);
            }
            this.ukupnaKolicina = _data["ukupnaKolicina"];
        }
    }

    static fromJS(data: any): UkupnoStanjeRobeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UkupnoStanjeRobeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["sifra"] = this.sifra;
        if (Array.isArray(this.barkodovi)) {
            data["barkodovi"] = [];
            for (let item of this.barkodovi)
                data["barkodovi"].push(item);
        }
        data["ukupnaKolicina"] = this.ukupnaKolicina;
        return data;
    }
}

export interface IUkupnoStanjeRobeDto {
    naziv?: string | undefined;
    sifra?: string | undefined;
    barkodovi?: string[] | undefined;
    ukupnaKolicina?: number;
}

export class ResultOfNalepnicePreviewDto extends Result implements IResultOfNalepnicePreviewDto {
    data?: NalepnicePreviewDto | undefined;

    constructor(data?: IResultOfNalepnicePreviewDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? NalepnicePreviewDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfNalepnicePreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfNalepnicePreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfNalepnicePreviewDto extends IResult {
    data?: NalepnicePreviewDto | undefined;
}

export class NalepnicePreviewDto implements INalepnicePreviewDto {
    brojZaStampu?: number;
    izostavljeni?: IzostavljenArtikalDto[] | undefined;

    constructor(data?: INalepnicePreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brojZaStampu = _data["brojZaStampu"];
            if (Array.isArray(_data["izostavljeni"])) {
                this.izostavljeni = [] as any;
                for (let item of _data["izostavljeni"])
                    this.izostavljeni!.push(IzostavljenArtikalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NalepnicePreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new NalepnicePreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brojZaStampu"] = this.brojZaStampu;
        if (Array.isArray(this.izostavljeni)) {
            data["izostavljeni"] = [];
            for (let item of this.izostavljeni)
                data["izostavljeni"].push(item.toJSON());
        }
        return data;
    }
}

export interface INalepnicePreviewDto {
    brojZaStampu?: number;
    izostavljeni?: IzostavljenArtikalDto[] | undefined;
}

export class IzostavljenArtikalDto implements IIzostavljenArtikalDto {
    id?: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    razlog?: string | undefined;

    constructor(data?: IIzostavljenArtikalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.razlog = _data["razlog"];
        }
    }

    static fromJS(data: any): IzostavljenArtikalDto {
        data = typeof data === 'object' ? data : {};
        let result = new IzostavljenArtikalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["razlog"] = this.razlog;
        return data;
    }
}

export interface IIzostavljenArtikalDto {
    id?: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    razlog?: string | undefined;
}

export class NalepniceRequest implements INalepniceRequest {
    artikliIds?: number[] | undefined;
    cenovnikId?: number;
    polja?: NalepnicaPolje[] | undefined;
    brojKolona?: number;
    artikalVanCenovnika?: ArtikalVanCenovnikaOpcija;

    constructor(data?: INalepniceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["artikliIds"])) {
                this.artikliIds = [] as any;
                for (let item of _data["artikliIds"])
                    this.artikliIds!.push(item);
            }
            this.cenovnikId = _data["cenovnikId"];
            if (Array.isArray(_data["polja"])) {
                this.polja = [] as any;
                for (let item of _data["polja"])
                    this.polja!.push(item);
            }
            this.brojKolona = _data["brojKolona"];
            this.artikalVanCenovnika = _data["artikalVanCenovnika"];
        }
    }

    static fromJS(data: any): NalepniceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NalepniceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.artikliIds)) {
            data["artikliIds"] = [];
            for (let item of this.artikliIds)
                data["artikliIds"].push(item);
        }
        data["cenovnikId"] = this.cenovnikId;
        if (Array.isArray(this.polja)) {
            data["polja"] = [];
            for (let item of this.polja)
                data["polja"].push(item);
        }
        data["brojKolona"] = this.brojKolona;
        data["artikalVanCenovnika"] = this.artikalVanCenovnika;
        return data;
    }
}

export interface INalepniceRequest {
    artikliIds?: number[] | undefined;
    cenovnikId?: number;
    polja?: NalepnicaPolje[] | undefined;
    brojKolona?: number;
    artikalVanCenovnika?: ArtikalVanCenovnikaOpcija;
}

export class GetNalepnicePreviewQuery extends NalepniceRequest implements IGetNalepnicePreviewQuery {

    constructor(data?: IGetNalepnicePreviewQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetNalepnicePreviewQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetNalepnicePreviewQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetNalepnicePreviewQuery extends INalepniceRequest {
}

export enum NalepnicaPolje {
    NAZIV = 1,
    SIFRA = 2,
    CENA = 3,
    JEDINICA_MERE = 4,
    JEDINICNA_CENA = 5,
    BARKOD = 6,
    DATUM_STAMPE = 7,
}

export enum ArtikalVanCenovnikaOpcija {
    IZOSTAVI = 1,
    OSNOVNI_CENOVNIK = 2,
}

export class GetNalepnicePdfQuery extends NalepniceRequest implements IGetNalepnicePdfQuery {

    constructor(data?: IGetNalepnicePdfQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetNalepnicePdfQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetNalepnicePdfQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetNalepnicePdfQuery extends INalepniceRequest {
}

export class ResultOfGetSaldoStrankeResponse extends Result implements IResultOfGetSaldoStrankeResponse {
    data?: GetSaldoStrankeResponse | undefined;

    constructor(data?: IResultOfGetSaldoStrankeResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetSaldoStrankeResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetSaldoStrankeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetSaldoStrankeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetSaldoStrankeResponse extends IResult {
    data?: GetSaldoStrankeResponse | undefined;
}

export class GetSaldoStrankeResponse implements IGetSaldoStrankeResponse {
    saldoStrankaDto?: SaldoStrankaDto | undefined;
    valutaAlphaChar?: string | undefined;

    constructor(data?: IGetSaldoStrankeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.saldoStrankaDto = _data["saldoStrankaDto"] ? SaldoStrankaDto.fromJS(_data["saldoStrankaDto"]) : <any>undefined;
            this.valutaAlphaChar = _data["valutaAlphaChar"];
        }
    }

    static fromJS(data: any): GetSaldoStrankeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSaldoStrankeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saldoStrankaDto"] = this.saldoStrankaDto ? this.saldoStrankaDto.toJSON() : <any>undefined;
        data["valutaAlphaChar"] = this.valutaAlphaChar;
        return data;
    }
}

export interface IGetSaldoStrankeResponse {
    saldoStrankaDto?: SaldoStrankaDto | undefined;
    valutaAlphaChar?: string | undefined;
}

export class SaldoStrankaDto implements ISaldoStrankaDto {
    id?: number;
    potrazivanja?: number;
    uplateDatiAvans?: number;
    brojRacunaDatiAvans?: number;
    preostaliDatiAvans?: number;
    isplatePrimljeniAvans?: number;
    brojRacunaPrimljeniAvans?: number;
    preostaliPrimljeniAvans?: number;
    brojFakturaPotrazivanja?: number;
    uplate?: number;
    saldoKupac?: number;
    potrazivanjaVanValute?: number;
    brojFakturaPotrazivanjaVanValute?: number;
    dugovanja?: number;
    brojFakturaDugovanja?: number;
    placanja?: number;
    saldoDobavljac?: number;
    dugovanjaVanValute?: number;
    brojFakturaDugovanjaVanValute?: number;
    strankaId?: number;

    constructor(data?: ISaldoStrankaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.potrazivanja = _data["potrazivanja"];
            this.uplateDatiAvans = _data["uplateDatiAvans"];
            this.brojRacunaDatiAvans = _data["brojRacunaDatiAvans"];
            this.preostaliDatiAvans = _data["preostaliDatiAvans"];
            this.isplatePrimljeniAvans = _data["isplatePrimljeniAvans"];
            this.brojRacunaPrimljeniAvans = _data["brojRacunaPrimljeniAvans"];
            this.preostaliPrimljeniAvans = _data["preostaliPrimljeniAvans"];
            this.brojFakturaPotrazivanja = _data["brojFakturaPotrazivanja"];
            this.uplate = _data["uplate"];
            this.saldoKupac = _data["saldoKupac"];
            this.potrazivanjaVanValute = _data["potrazivanjaVanValute"];
            this.brojFakturaPotrazivanjaVanValute = _data["brojFakturaPotrazivanjaVanValute"];
            this.dugovanja = _data["dugovanja"];
            this.brojFakturaDugovanja = _data["brojFakturaDugovanja"];
            this.placanja = _data["placanja"];
            this.saldoDobavljac = _data["saldoDobavljac"];
            this.dugovanjaVanValute = _data["dugovanjaVanValute"];
            this.brojFakturaDugovanjaVanValute = _data["brojFakturaDugovanjaVanValute"];
            this.strankaId = _data["strankaId"];
        }
    }

    static fromJS(data: any): SaldoStrankaDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaldoStrankaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["potrazivanja"] = this.potrazivanja;
        data["uplateDatiAvans"] = this.uplateDatiAvans;
        data["brojRacunaDatiAvans"] = this.brojRacunaDatiAvans;
        data["preostaliDatiAvans"] = this.preostaliDatiAvans;
        data["isplatePrimljeniAvans"] = this.isplatePrimljeniAvans;
        data["brojRacunaPrimljeniAvans"] = this.brojRacunaPrimljeniAvans;
        data["preostaliPrimljeniAvans"] = this.preostaliPrimljeniAvans;
        data["brojFakturaPotrazivanja"] = this.brojFakturaPotrazivanja;
        data["uplate"] = this.uplate;
        data["saldoKupac"] = this.saldoKupac;
        data["potrazivanjaVanValute"] = this.potrazivanjaVanValute;
        data["brojFakturaPotrazivanjaVanValute"] = this.brojFakturaPotrazivanjaVanValute;
        data["dugovanja"] = this.dugovanja;
        data["brojFakturaDugovanja"] = this.brojFakturaDugovanja;
        data["placanja"] = this.placanja;
        data["saldoDobavljac"] = this.saldoDobavljac;
        data["dugovanjaVanValute"] = this.dugovanjaVanValute;
        data["brojFakturaDugovanjaVanValute"] = this.brojFakturaDugovanjaVanValute;
        data["strankaId"] = this.strankaId;
        return data;
    }
}

export interface ISaldoStrankaDto {
    id?: number;
    potrazivanja?: number;
    uplateDatiAvans?: number;
    brojRacunaDatiAvans?: number;
    preostaliDatiAvans?: number;
    isplatePrimljeniAvans?: number;
    brojRacunaPrimljeniAvans?: number;
    preostaliPrimljeniAvans?: number;
    brojFakturaPotrazivanja?: number;
    uplate?: number;
    saldoKupac?: number;
    potrazivanjaVanValute?: number;
    brojFakturaPotrazivanjaVanValute?: number;
    dugovanja?: number;
    brojFakturaDugovanja?: number;
    placanja?: number;
    saldoDobavljac?: number;
    dugovanjaVanValute?: number;
    brojFakturaDugovanjaVanValute?: number;
    strankaId?: number;
}

export class ResultOfDospelaPotrazivanjaAgingDto extends Result implements IResultOfDospelaPotrazivanjaAgingDto {
    data?: DospelaPotrazivanjaAgingDto | undefined;

    constructor(data?: IResultOfDospelaPotrazivanjaAgingDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? DospelaPotrazivanjaAgingDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfDospelaPotrazivanjaAgingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfDospelaPotrazivanjaAgingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfDospelaPotrazivanjaAgingDto extends IResult {
    data?: DospelaPotrazivanjaAgingDto | undefined;
}

export class DospelaPotrazivanjaAgingDto implements IDospelaPotrazivanjaAgingDto {
    do30?: number;
    od31Do60?: number;
    od61Do90?: number;
    preko90?: number;
    brojFakturaDo30?: number;
    brojFakturaOd31Do60?: number;
    brojFakturaOd61Do90?: number;
    brojFakturaPreko90?: number;
    ukupno?: number;

    constructor(data?: IDospelaPotrazivanjaAgingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.do30 = _data["do30"];
            this.od31Do60 = _data["od31Do60"];
            this.od61Do90 = _data["od61Do90"];
            this.preko90 = _data["preko90"];
            this.brojFakturaDo30 = _data["brojFakturaDo30"];
            this.brojFakturaOd31Do60 = _data["brojFakturaOd31Do60"];
            this.brojFakturaOd61Do90 = _data["brojFakturaOd61Do90"];
            this.brojFakturaPreko90 = _data["brojFakturaPreko90"];
            this.ukupno = _data["ukupno"];
        }
    }

    static fromJS(data: any): DospelaPotrazivanjaAgingDto {
        data = typeof data === 'object' ? data : {};
        let result = new DospelaPotrazivanjaAgingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["do30"] = this.do30;
        data["od31Do60"] = this.od31Do60;
        data["od61Do90"] = this.od61Do90;
        data["preko90"] = this.preko90;
        data["brojFakturaDo30"] = this.brojFakturaDo30;
        data["brojFakturaOd31Do60"] = this.brojFakturaOd31Do60;
        data["brojFakturaOd61Do90"] = this.brojFakturaOd61Do90;
        data["brojFakturaPreko90"] = this.brojFakturaPreko90;
        data["ukupno"] = this.ukupno;
        return data;
    }
}

export interface IDospelaPotrazivanjaAgingDto {
    do30?: number;
    od31Do60?: number;
    od61Do90?: number;
    preko90?: number;
    brojFakturaDo30?: number;
    brojFakturaOd31Do60?: number;
    brojFakturaOd61Do90?: number;
    brojFakturaPreko90?: number;
    ukupno?: number;
}

export class ResultOfGetSastavniceTableResponse extends Result implements IResultOfGetSastavniceTableResponse {
    data?: GetSastavniceTableResponse | undefined;

    constructor(data?: IResultOfGetSastavniceTableResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetSastavniceTableResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetSastavniceTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetSastavniceTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetSastavniceTableResponse extends IResult {
    data?: GetSastavniceTableResponse | undefined;
}

export class GetSastavniceTableResponse implements IGetSastavniceTableResponse {
    sastavnicaTableDtoList?: SastavnicaTableDto[] | undefined;

    constructor(data?: IGetSastavniceTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sastavnicaTableDtoList"])) {
                this.sastavnicaTableDtoList = [] as any;
                for (let item of _data["sastavnicaTableDtoList"])
                    this.sastavnicaTableDtoList!.push(SastavnicaTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSastavniceTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSastavniceTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sastavnicaTableDtoList)) {
            data["sastavnicaTableDtoList"] = [];
            for (let item of this.sastavnicaTableDtoList)
                data["sastavnicaTableDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSastavniceTableResponse {
    sastavnicaTableDtoList?: SastavnicaTableDto[] | undefined;
}

export class SastavnicaTableDto implements ISastavnicaTableDto {
    id?: number;
    predmetStavkeId?: number;
    nazivStavke?: string | undefined;
    kolicina?: string | undefined;
    nazivJediniceMere?: string | undefined;
    sifra?: string | undefined;

    constructor(data?: ISastavnicaTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.predmetStavkeId = _data["predmetStavkeId"];
            this.nazivStavke = _data["nazivStavke"];
            this.kolicina = _data["kolicina"];
            this.nazivJediniceMere = _data["nazivJediniceMere"];
            this.sifra = _data["sifra"];
        }
    }

    static fromJS(data: any): SastavnicaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SastavnicaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["predmetStavkeId"] = this.predmetStavkeId;
        data["nazivStavke"] = this.nazivStavke;
        data["kolicina"] = this.kolicina;
        data["nazivJediniceMere"] = this.nazivJediniceMere;
        data["sifra"] = this.sifra;
        return data;
    }
}

export interface ISastavnicaTableDto {
    id?: number;
    predmetStavkeId?: number;
    nazivStavke?: string | undefined;
    kolicina?: string | undefined;
    nazivJediniceMere?: string | undefined;
    sifra?: string | undefined;
}

export class PredmetStavkeFilterDto implements IPredmetStavkeFilterDto {
    naziv?: string | undefined;
    sifra?: string | undefined;
    includeTipovePredmeta?: TipPredmeta[] | undefined;

    constructor(data?: IPredmetStavkeFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.sifra = _data["sifra"];
            if (Array.isArray(_data["includeTipovePredmeta"])) {
                this.includeTipovePredmeta = [] as any;
                for (let item of _data["includeTipovePredmeta"])
                    this.includeTipovePredmeta!.push(item);
            }
        }
    }

    static fromJS(data: any): PredmetStavkeFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredmetStavkeFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["sifra"] = this.sifra;
        if (Array.isArray(this.includeTipovePredmeta)) {
            data["includeTipovePredmeta"] = [];
            for (let item of this.includeTipovePredmeta)
                data["includeTipovePredmeta"].push(item);
        }
        return data;
    }
}

export interface IPredmetStavkeFilterDto {
    naziv?: string | undefined;
    sifra?: string | undefined;
    includeTipovePredmeta?: TipPredmeta[] | undefined;
}

export class GetSastavniceTableQuery extends PredmetStavkeFilterDto implements IGetSastavniceTableQuery {
    id?: number;

    constructor(data?: IGetSastavniceTableQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetSastavniceTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSastavniceTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSastavniceTableQuery extends IPredmetStavkeFilterDto {
    id?: number;
}

export class ResultOfSastavnicaDto extends Result implements IResultOfSastavnicaDto {
    data?: SastavnicaDto | undefined;

    constructor(data?: IResultOfSastavnicaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? SastavnicaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfSastavnicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfSastavnicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfSastavnicaDto extends IResult {
    data?: SastavnicaDto | undefined;
}

export class ResultOfCreateSastavnicaResponse extends Result implements IResultOfCreateSastavnicaResponse {
    data?: CreateSastavnicaResponse | undefined;

    constructor(data?: IResultOfCreateSastavnicaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? CreateSastavnicaResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfCreateSastavnicaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfCreateSastavnicaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfCreateSastavnicaResponse extends IResult {
    data?: CreateSastavnicaResponse | undefined;
}

export class CreateSastavnicaResponse implements ICreateSastavnicaResponse {
    sastavnicaDto?: SastavnicaDto | undefined;
    sastavnicaTableDto?: SastavnicaTableDto | undefined;

    constructor(data?: ICreateSastavnicaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sastavnicaDto = _data["sastavnicaDto"] ? SastavnicaDto.fromJS(_data["sastavnicaDto"]) : <any>undefined;
            this.sastavnicaTableDto = _data["sastavnicaTableDto"] ? SastavnicaTableDto.fromJS(_data["sastavnicaTableDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateSastavnicaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSastavnicaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sastavnicaDto"] = this.sastavnicaDto ? this.sastavnicaDto.toJSON() : <any>undefined;
        data["sastavnicaTableDto"] = this.sastavnicaTableDto ? this.sastavnicaTableDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateSastavnicaResponse {
    sastavnicaDto?: SastavnicaDto | undefined;
    sastavnicaTableDto?: SastavnicaTableDto | undefined;
}

export class CreateSastavnicaCommand implements ICreateSastavnicaCommand {
    id?: number;
    kolicina?: number;
    predmetStavkeDto?: PredmetStavkeDto | undefined;
    proizvodId?: number;
    materijalId?: number;

    constructor(data?: ICreateSastavnicaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kolicina = _data["kolicina"];
            this.predmetStavkeDto = _data["predmetStavkeDto"] ? PredmetStavkeDto.fromJS(_data["predmetStavkeDto"]) : <any>undefined;
            this.proizvodId = _data["proizvodId"];
            this.materijalId = _data["materijalId"];
        }
    }

    static fromJS(data: any): CreateSastavnicaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSastavnicaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kolicina"] = this.kolicina;
        data["predmetStavkeDto"] = this.predmetStavkeDto ? this.predmetStavkeDto.toJSON() : <any>undefined;
        data["proizvodId"] = this.proizvodId;
        data["materijalId"] = this.materijalId;
        return data;
    }
}

export interface ICreateSastavnicaCommand {
    id?: number;
    kolicina?: number;
    predmetStavkeDto?: PredmetStavkeDto | undefined;
    proizvodId?: number;
    materijalId?: number;
}

export class UpdateSastavnicaCommand implements IUpdateSastavnicaCommand {
    id?: number;
    proizvodId?: number;
    materijalId?: number;
    kolicina?: number;
    predmetStavkeDto?: PredmetStavkeDto | undefined;

    constructor(data?: IUpdateSastavnicaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.proizvodId = _data["proizvodId"];
            this.materijalId = _data["materijalId"];
            this.kolicina = _data["kolicina"];
            this.predmetStavkeDto = _data["predmetStavkeDto"] ? PredmetStavkeDto.fromJS(_data["predmetStavkeDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateSastavnicaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSastavnicaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["proizvodId"] = this.proizvodId;
        data["materijalId"] = this.materijalId;
        data["kolicina"] = this.kolicina;
        data["predmetStavkeDto"] = this.predmetStavkeDto ? this.predmetStavkeDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateSastavnicaCommand {
    id?: number;
    proizvodId?: number;
    materijalId?: number;
    kolicina?: number;
    predmetStavkeDto?: PredmetStavkeDto | undefined;
}

export abstract class InvoiceStatusChangeDto implements IInvoiceStatusChangeDto {
    eventId?: number;
    date?: string | undefined;
    newInvoiceStatus?: string | undefined;
    comment?: string | undefined;
    cirInvoideId?: string | undefined;
    subscriptionKey?: string | undefined;
    stornoNumber?: string | undefined;
    cirAssignmentChange?: string | undefined;
    cirAssignmentChangeEnum?: CirAssignmentChange | undefined;
    isSigned?: boolean | undefined;

    constructor(data?: IInvoiceStatusChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.date = _data["date"];
            this.newInvoiceStatus = _data["newInvoiceStatus"];
            this.comment = _data["comment"];
            this.cirInvoideId = _data["cirInvoideId"];
            this.subscriptionKey = _data["subscriptionKey"];
            this.stornoNumber = _data["stornoNumber"];
            this.cirAssignmentChange = _data["cirAssignmentChange"];
            this.cirAssignmentChangeEnum = _data["cirAssignmentChangeEnum"];
            this.isSigned = _data["isSigned"];
        }
    }

    static fromJS(data: any): InvoiceStatusChangeDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'InvoiceStatusChangeDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["date"] = this.date;
        data["newInvoiceStatus"] = this.newInvoiceStatus;
        data["comment"] = this.comment;
        data["cirInvoideId"] = this.cirInvoideId;
        data["subscriptionKey"] = this.subscriptionKey;
        data["stornoNumber"] = this.stornoNumber;
        data["cirAssignmentChange"] = this.cirAssignmentChange;
        data["cirAssignmentChangeEnum"] = this.cirAssignmentChangeEnum;
        data["isSigned"] = this.isSigned;
        return data;
    }
}

export interface IInvoiceStatusChangeDto {
    eventId?: number;
    date?: string | undefined;
    newInvoiceStatus?: string | undefined;
    comment?: string | undefined;
    cirInvoideId?: string | undefined;
    subscriptionKey?: string | undefined;
    stornoNumber?: string | undefined;
    cirAssignmentChange?: string | undefined;
    cirAssignmentChangeEnum?: CirAssignmentChange | undefined;
    isSigned?: boolean | undefined;
}

export class PurchaseInvoiceStatusChangeDto extends InvoiceStatusChangeDto implements IPurchaseInvoiceStatusChangeDto {
    newInvoiceStatusEnum?: PurchaseInvoiceStatus;
    purchaseInvoiceId?: number;

    constructor(data?: IPurchaseInvoiceStatusChangeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.newInvoiceStatusEnum = _data["newInvoiceStatusEnum"];
            this.purchaseInvoiceId = _data["purchaseInvoiceId"];
        }
    }

    static fromJS(data: any): PurchaseInvoiceStatusChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseInvoiceStatusChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newInvoiceStatusEnum"] = this.newInvoiceStatusEnum;
        data["purchaseInvoiceId"] = this.purchaseInvoiceId;
        super.toJSON(data);
        return data;
    }
}

export interface IPurchaseInvoiceStatusChangeDto extends IInvoiceStatusChangeDto {
    newInvoiceStatusEnum?: PurchaseInvoiceStatus;
    purchaseInvoiceId?: number;
}

export enum PurchaseInvoiceStatus {
    New = 0,
    Seen = 1,
    Reminded = 2,
    ReNotified = 3,
    Received = 4,
    Deleted = 5,
    Approved = 6,
    Rejected = 7,
    Cancelled = 8,
    Storno = 9,
    Unknown = 10,
}

export enum CirAssignmentChange {
    Assignment = 0,
    CancelAssignment = 1,
}

export class SalesInvoiceStatusChangeDto extends InvoiceStatusChangeDto implements ISalesInvoiceStatusChangeDto {
    newInvoiceStatusEnum?: SalesInvoiceStatus;
    salesInvoiceId?: number;

    constructor(data?: ISalesInvoiceStatusChangeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.newInvoiceStatusEnum = _data["newInvoiceStatusEnum"];
            this.salesInvoiceId = _data["salesInvoiceId"];
        }
    }

    static fromJS(data: any): SalesInvoiceStatusChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesInvoiceStatusChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newInvoiceStatusEnum"] = this.newInvoiceStatusEnum;
        data["salesInvoiceId"] = this.salesInvoiceId;
        super.toJSON(data);
        return data;
    }
}

export interface ISalesInvoiceStatusChangeDto extends IInvoiceStatusChangeDto {
    newInvoiceStatusEnum?: SalesInvoiceStatus;
    salesInvoiceId?: number;
}

export enum SalesInvoiceStatus {
    New = 0,
    Draft = 1,
    Sent = 2,
    Paid = 3,
    Mistake = 4,
    OverDue = 5,
    Archived = 6,
    Sending = 7,
    Deleted = 8,
    Approved = 9,
    Rejected = 10,
    Cancelled = 11,
    Storno = 12,
    Unknown = 13,
}

export class SendRacunListToSefCommand implements ISendRacunListToSefCommand {
    ids?: number[] | undefined;

    constructor(data?: ISendRacunListToSefCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): SendRacunListToSefCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendRacunListToSefCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface ISendRacunListToSefCommand {
    ids?: number[] | undefined;
}

export class CancelIzlazniRacunCommand implements ICancelIzlazniRacunCommand {
    racunId?: number;
    komentar?: string | undefined;

    constructor(data?: ICancelIzlazniRacunCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
            this.komentar = _data["komentar"];
        }
    }

    static fromJS(data: any): CancelIzlazniRacunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CancelIzlazniRacunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        data["komentar"] = this.komentar;
        return data;
    }
}

export interface ICancelIzlazniRacunCommand {
    racunId?: number;
    komentar?: string | undefined;
}

export class StornoIzlazniRacunCommand implements IStornoIzlazniRacunCommand {
    racunId?: number;
    fromId?: string;
    to?: string | undefined;
    cc?: string[] | undefined;
    komentar?: string | undefined;
    stornoBroj?: string | undefined;
    posaljiNaEngleskom?: boolean;
    attachments?: string[] | undefined;

    constructor(data?: IStornoIzlazniRacunCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
            this.fromId = _data["fromId"];
            this.to = _data["to"];
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
            this.komentar = _data["komentar"];
            this.stornoBroj = _data["stornoBroj"];
            this.posaljiNaEngleskom = _data["posaljiNaEngleskom"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(item);
            }
        }
    }

    static fromJS(data: any): StornoIzlazniRacunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new StornoIzlazniRacunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        data["fromId"] = this.fromId;
        data["to"] = this.to;
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        data["komentar"] = this.komentar;
        data["stornoBroj"] = this.stornoBroj;
        data["posaljiNaEngleskom"] = this.posaljiNaEngleskom;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item);
        }
        return data;
    }
}

export interface IStornoIzlazniRacunCommand {
    racunId?: number;
    fromId?: string;
    to?: string | undefined;
    cc?: string[] | undefined;
    komentar?: string | undefined;
    stornoBroj?: string | undefined;
    posaljiNaEngleskom?: boolean;
    attachments?: string[] | undefined;
}

export class SyncStatusPojedinacnogIzlaznihRacunaCommand implements ISyncStatusPojedinacnogIzlaznihRacunaCommand {
    racunId?: number;

    constructor(data?: ISyncStatusPojedinacnogIzlaznihRacunaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
        }
    }

    static fromJS(data: any): SyncStatusPojedinacnogIzlaznihRacunaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SyncStatusPojedinacnogIzlaznihRacunaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        return data;
    }
}

export interface ISyncStatusPojedinacnogIzlaznihRacunaCommand {
    racunId?: number;
}

export class SyncDocPojedinacnogIzlaznogRacunaCommand implements ISyncDocPojedinacnogIzlaznogRacunaCommand {
    racunId?: number;

    constructor(data?: ISyncDocPojedinacnogIzlaznogRacunaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
        }
    }

    static fromJS(data: any): SyncDocPojedinacnogIzlaznogRacunaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SyncDocPojedinacnogIzlaznogRacunaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        return data;
    }
}

export interface ISyncDocPojedinacnogIzlaznogRacunaCommand {
    racunId?: number;
}

export class SyncUlazneRacuneCommand implements ISyncUlazneRacuneCommand {
    statusRacuna?: string | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;

    constructor(data?: ISyncUlazneRacuneCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusRacuna = _data["statusRacuna"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SyncUlazneRacuneCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SyncUlazneRacuneCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusRacuna"] = this.statusRacuna;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISyncUlazneRacuneCommand {
    statusRacuna?: string | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
}

export class ResultOfIReadOnlyListOfGetSefDokumentResponse extends Result implements IResultOfIReadOnlyListOfGetSefDokumentResponse {
    data?: GetSefDokumentResponse[] | undefined;

    constructor(data?: IResultOfIReadOnlyListOfGetSefDokumentResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GetSefDokumentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfIReadOnlyListOfGetSefDokumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfIReadOnlyListOfGetSefDokumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfIReadOnlyListOfGetSefDokumentResponse extends IResult {
    data?: GetSefDokumentResponse[] | undefined;
}

export class GetSefDokumentResponse implements IGetSefDokumentResponse {
    fileName?: string | undefined;
    fileUrl?: string | undefined;
    tipRelevantnogDokumenta?: TipRelevantnogDokumenta;

    constructor(data?: IGetSefDokumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileUrl = _data["fileUrl"];
            this.tipRelevantnogDokumenta = _data["tipRelevantnogDokumenta"];
        }
    }

    static fromJS(data: any): GetSefDokumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSefDokumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileUrl"] = this.fileUrl;
        data["tipRelevantnogDokumenta"] = this.tipRelevantnogDokumenta;
        return data;
    }
}

export interface IGetSefDokumentResponse {
    fileName?: string | undefined;
    fileUrl?: string | undefined;
    tipRelevantnogDokumenta?: TipRelevantnogDokumenta;
}

export class GetSefRacunRelevantniDokumentListZippedQuery implements IGetSefRacunRelevantniDokumentListZippedQuery {
    sefIds?: number[] | undefined;

    constructor(data?: IGetSefRacunRelevantniDokumentListZippedQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sefIds"])) {
                this.sefIds = [] as any;
                for (let item of _data["sefIds"])
                    this.sefIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetSefRacunRelevantniDokumentListZippedQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSefRacunRelevantniDokumentListZippedQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sefIds)) {
            data["sefIds"] = [];
            for (let item of this.sefIds)
                data["sefIds"].push(item);
        }
        return data;
    }
}

export interface IGetSefRacunRelevantniDokumentListZippedQuery {
    sefIds?: number[] | undefined;
}

export class ResultOfGetSefHealthStatusResponse extends Result implements IResultOfGetSefHealthStatusResponse {
    data?: GetSefHealthStatusResponse | undefined;

    constructor(data?: IResultOfGetSefHealthStatusResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetSefHealthStatusResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetSefHealthStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetSefHealthStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetSefHealthStatusResponse extends IResult {
    data?: GetSefHealthStatusResponse | undefined;
}

export class GetSefHealthStatusResponse implements IGetSefHealthStatusResponse {
    isActive?: boolean;
    background?: string | undefined;

    constructor(data?: IGetSefHealthStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.background = _data["background"];
        }
    }

    static fromJS(data: any): GetSefHealthStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSefHealthStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["background"] = this.background;
        return data;
    }
}

export interface IGetSefHealthStatusResponse {
    isActive?: boolean;
    background?: string | undefined;
}

export class OdobriOdbaciSefRacunCommand implements IOdobriOdbaciSefRacunCommand {
    racunIds?: number[] | undefined;
    jeOdobravanje?: boolean;
    komentar?: string | undefined;
    brojRacuna?: string | undefined;
    praviloZaBrojRacuna?: number | undefined;
    oznakeDto?: OznakaDto[] | undefined;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;

    constructor(data?: IOdobriOdbaciSefRacunCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["racunIds"])) {
                this.racunIds = [] as any;
                for (let item of _data["racunIds"])
                    this.racunIds!.push(item);
            }
            this.jeOdobravanje = _data["jeOdobravanje"];
            this.komentar = _data["komentar"];
            this.brojRacuna = _data["brojRacuna"];
            this.praviloZaBrojRacuna = _data["praviloZaBrojRacuna"];
            if (Array.isArray(_data["oznakeDto"])) {
                this.oznakeDto = [] as any;
                for (let item of _data["oznakeDto"])
                    this.oznakeDto!.push(OznakaDto.fromJS(item));
            }
            this.klasifikacijaRacuna = _data["klasifikacijaRacuna"];
            this.pravoNaPdvOdbitak = _data["pravoNaPdvOdbitak"];
        }
    }

    static fromJS(data: any): OdobriOdbaciSefRacunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new OdobriOdbaciSefRacunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.racunIds)) {
            data["racunIds"] = [];
            for (let item of this.racunIds)
                data["racunIds"].push(item);
        }
        data["jeOdobravanje"] = this.jeOdobravanje;
        data["komentar"] = this.komentar;
        data["brojRacuna"] = this.brojRacuna;
        data["praviloZaBrojRacuna"] = this.praviloZaBrojRacuna;
        if (Array.isArray(this.oznakeDto)) {
            data["oznakeDto"] = [];
            for (let item of this.oznakeDto)
                data["oznakeDto"].push(item.toJSON());
        }
        data["klasifikacijaRacuna"] = this.klasifikacijaRacuna;
        data["pravoNaPdvOdbitak"] = this.pravoNaPdvOdbitak;
        return data;
    }
}

export interface IOdobriOdbaciSefRacunCommand {
    racunIds?: number[] | undefined;
    jeOdobravanje?: boolean;
    komentar?: string | undefined;
    brojRacuna?: string | undefined;
    praviloZaBrojRacuna?: number | undefined;
    oznakeDto?: OznakaDto[] | undefined;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
}

export class ResultOfObradaFormRequest extends Result implements IResultOfObradaFormRequest {
    data?: ObradaFormRequest | undefined;

    constructor(data?: IResultOfObradaFormRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? ObradaFormRequest.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfObradaFormRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfObradaFormRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfObradaFormRequest extends IResult {
    data?: ObradaFormRequest | undefined;
}

export class ObradaFormRequest implements IObradaFormRequest {
    neobradjenRacunDto?: NeobradjenRacunDto | undefined;
    racunDto?: RacunDto | undefined;

    constructor(data?: IObradaFormRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.neobradjenRacunDto = _data["neobradjenRacunDto"] ? NeobradjenRacunDto.fromJS(_data["neobradjenRacunDto"]) : <any>undefined;
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ObradaFormRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ObradaFormRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["neobradjenRacunDto"] = this.neobradjenRacunDto ? this.neobradjenRacunDto.toJSON() : <any>undefined;
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IObradaFormRequest {
    neobradjenRacunDto?: NeobradjenRacunDto | undefined;
    racunDto?: RacunDto | undefined;
}

export class NeobradjenRacunDto implements INeobradjenRacunDto {
    sefId?: number;
    broj?: string | undefined;
    datumPrometa?: Date;
    datumPrometaStr?: string | undefined;
    datumIzdavanjaStr?: string | undefined;
    datumValuteStr?: string | undefined;
    datumIzdavanja?: Date;
    datumValute?: Date;
    mestoIzdavanjaIPrometa?: string | undefined;
    ulicaIBroj?: string | undefined;
    tipRacunaDto?: TipRacunaDto | undefined;
    statusRacuna?: StatusRacuna;
    valutaAlphaChar?: string | undefined;
    tekuciRacunId?: number;
    srednjiKursNaDan?: number | undefined;
    iznosStr?: string | undefined;
    ukupanIznosDto?: RacunUkupanIznosDto | undefined;
    dobavljac?: string | undefined;
    dobavljacMB?: string | undefined;
    dobavljacJBKJS?: string | undefined;
    dobavljacPib?: string | undefined;
    dobavljacDrzavaKod?: string | undefined;
    pozivNaBroj?: string | undefined;
    brojModela?: string | undefined;
    sifraPlacanja?: string | undefined;
    brojUgovora?: string | undefined;
    brojNarudzbenice?: string | undefined;
    brojTendera?: string | undefined;
    sifraObjekta?: string | undefined;
    stavkeDto?: NeobradjenRacunStavkaDto[] | undefined;
    oznakeDto?: OznakaDto[] | undefined;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    jeReferencaNaAvansniRacun?: boolean | undefined;
    eOtpremnice?: string[] | undefined;
    ePrijemnice?: string[] | undefined;
    avansneUplateRacunaTableDto?: AvansnaUplataRacunaTableDto[] | undefined;
    pdfDokumentList?: FileAttachment[] | undefined;
    prikazRabata?: PrikazRabata;

    constructor(data?: INeobradjenRacunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sefId = _data["sefId"];
            this.broj = _data["broj"];
            this.datumPrometa = _data["datumPrometa"] ? new Date(_data["datumPrometa"].toString()) : <any>undefined;
            this.datumPrometaStr = _data["datumPrometaStr"];
            this.datumIzdavanjaStr = _data["datumIzdavanjaStr"];
            this.datumValuteStr = _data["datumValuteStr"];
            this.datumIzdavanja = _data["datumIzdavanja"] ? new Date(_data["datumIzdavanja"].toString()) : <any>undefined;
            this.datumValute = _data["datumValute"] ? new Date(_data["datumValute"].toString()) : <any>undefined;
            this.mestoIzdavanjaIPrometa = _data["mestoIzdavanjaIPrometa"];
            this.ulicaIBroj = _data["ulicaIBroj"];
            this.tipRacunaDto = _data["tipRacunaDto"] ? TipRacunaDto.fromJS(_data["tipRacunaDto"]) : <any>undefined;
            this.statusRacuna = _data["statusRacuna"];
            this.valutaAlphaChar = _data["valutaAlphaChar"];
            this.tekuciRacunId = _data["tekuciRacunId"];
            this.srednjiKursNaDan = _data["srednjiKursNaDan"];
            this.iznosStr = _data["iznosStr"];
            this.ukupanIznosDto = _data["ukupanIznosDto"] ? RacunUkupanIznosDto.fromJS(_data["ukupanIznosDto"]) : <any>undefined;
            this.dobavljac = _data["dobavljac"];
            this.dobavljacMB = _data["dobavljacMB"];
            this.dobavljacJBKJS = _data["dobavljacJBKJS"];
            this.dobavljacPib = _data["dobavljacPib"];
            this.dobavljacDrzavaKod = _data["dobavljacDrzavaKod"];
            this.pozivNaBroj = _data["pozivNaBroj"];
            this.brojModela = _data["brojModela"];
            this.sifraPlacanja = _data["sifraPlacanja"];
            this.brojUgovora = _data["brojUgovora"];
            this.brojNarudzbenice = _data["brojNarudzbenice"];
            this.brojTendera = _data["brojTendera"];
            this.sifraObjekta = _data["sifraObjekta"];
            if (Array.isArray(_data["stavkeDto"])) {
                this.stavkeDto = [] as any;
                for (let item of _data["stavkeDto"])
                    this.stavkeDto!.push(NeobradjenRacunStavkaDto.fromJS(item));
            }
            if (Array.isArray(_data["oznakeDto"])) {
                this.oznakeDto = [] as any;
                for (let item of _data["oznakeDto"])
                    this.oznakeDto!.push(OznakaDto.fromJS(item));
            }
            this.klasifikacijaRacuna = _data["klasifikacijaRacuna"];
            this.pravoNaPdvOdbitak = _data["pravoNaPdvOdbitak"];
            this.periodOd = _data["periodOd"] ? new Date(_data["periodOd"].toString()) : <any>undefined;
            this.periodDo = _data["periodDo"] ? new Date(_data["periodDo"].toString()) : <any>undefined;
            this.jeReferencaNaAvansniRacun = _data["jeReferencaNaAvansniRacun"];
            if (Array.isArray(_data["eOtpremnice"])) {
                this.eOtpremnice = [] as any;
                for (let item of _data["eOtpremnice"])
                    this.eOtpremnice!.push(item);
            }
            if (Array.isArray(_data["ePrijemnice"])) {
                this.ePrijemnice = [] as any;
                for (let item of _data["ePrijemnice"])
                    this.ePrijemnice!.push(item);
            }
            if (Array.isArray(_data["avansneUplateRacunaTableDto"])) {
                this.avansneUplateRacunaTableDto = [] as any;
                for (let item of _data["avansneUplateRacunaTableDto"])
                    this.avansneUplateRacunaTableDto!.push(AvansnaUplataRacunaTableDto.fromJS(item));
            }
            if (Array.isArray(_data["pdfDokumentList"])) {
                this.pdfDokumentList = [] as any;
                for (let item of _data["pdfDokumentList"])
                    this.pdfDokumentList!.push(FileAttachment.fromJS(item));
            }
            this.prikazRabata = _data["prikazRabata"];
        }
    }

    static fromJS(data: any): NeobradjenRacunDto {
        data = typeof data === 'object' ? data : {};
        let result = new NeobradjenRacunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sefId"] = this.sefId;
        data["broj"] = this.broj;
        data["datumPrometa"] = this.datumPrometa ? this.datumPrometa.toISOString() : <any>undefined;
        data["datumPrometaStr"] = this.datumPrometaStr;
        data["datumIzdavanjaStr"] = this.datumIzdavanjaStr;
        data["datumValuteStr"] = this.datumValuteStr;
        data["datumIzdavanja"] = this.datumIzdavanja ? this.datumIzdavanja.toISOString() : <any>undefined;
        data["datumValute"] = this.datumValute ? this.datumValute.toISOString() : <any>undefined;
        data["mestoIzdavanjaIPrometa"] = this.mestoIzdavanjaIPrometa;
        data["ulicaIBroj"] = this.ulicaIBroj;
        data["tipRacunaDto"] = this.tipRacunaDto ? this.tipRacunaDto.toJSON() : <any>undefined;
        data["statusRacuna"] = this.statusRacuna;
        data["valutaAlphaChar"] = this.valutaAlphaChar;
        data["tekuciRacunId"] = this.tekuciRacunId;
        data["srednjiKursNaDan"] = this.srednjiKursNaDan;
        data["iznosStr"] = this.iznosStr;
        data["ukupanIznosDto"] = this.ukupanIznosDto ? this.ukupanIznosDto.toJSON() : <any>undefined;
        data["dobavljac"] = this.dobavljac;
        data["dobavljacMB"] = this.dobavljacMB;
        data["dobavljacJBKJS"] = this.dobavljacJBKJS;
        data["dobavljacPib"] = this.dobavljacPib;
        data["dobavljacDrzavaKod"] = this.dobavljacDrzavaKod;
        data["pozivNaBroj"] = this.pozivNaBroj;
        data["brojModela"] = this.brojModela;
        data["sifraPlacanja"] = this.sifraPlacanja;
        data["brojUgovora"] = this.brojUgovora;
        data["brojNarudzbenice"] = this.brojNarudzbenice;
        data["brojTendera"] = this.brojTendera;
        data["sifraObjekta"] = this.sifraObjekta;
        if (Array.isArray(this.stavkeDto)) {
            data["stavkeDto"] = [];
            for (let item of this.stavkeDto)
                data["stavkeDto"].push(item.toJSON());
        }
        if (Array.isArray(this.oznakeDto)) {
            data["oznakeDto"] = [];
            for (let item of this.oznakeDto)
                data["oznakeDto"].push(item.toJSON());
        }
        data["klasifikacijaRacuna"] = this.klasifikacijaRacuna;
        data["pravoNaPdvOdbitak"] = this.pravoNaPdvOdbitak;
        data["periodOd"] = this.periodOd ? this.periodOd.toISOString() : <any>undefined;
        data["periodDo"] = this.periodDo ? this.periodDo.toISOString() : <any>undefined;
        data["jeReferencaNaAvansniRacun"] = this.jeReferencaNaAvansniRacun;
        if (Array.isArray(this.eOtpremnice)) {
            data["eOtpremnice"] = [];
            for (let item of this.eOtpremnice)
                data["eOtpremnice"].push(item);
        }
        if (Array.isArray(this.ePrijemnice)) {
            data["ePrijemnice"] = [];
            for (let item of this.ePrijemnice)
                data["ePrijemnice"].push(item);
        }
        if (Array.isArray(this.avansneUplateRacunaTableDto)) {
            data["avansneUplateRacunaTableDto"] = [];
            for (let item of this.avansneUplateRacunaTableDto)
                data["avansneUplateRacunaTableDto"].push(item.toJSON());
        }
        if (Array.isArray(this.pdfDokumentList)) {
            data["pdfDokumentList"] = [];
            for (let item of this.pdfDokumentList)
                data["pdfDokumentList"].push(item.toJSON());
        }
        data["prikazRabata"] = this.prikazRabata;
        return data;
    }
}

export interface INeobradjenRacunDto {
    sefId?: number;
    broj?: string | undefined;
    datumPrometa?: Date;
    datumPrometaStr?: string | undefined;
    datumIzdavanjaStr?: string | undefined;
    datumValuteStr?: string | undefined;
    datumIzdavanja?: Date;
    datumValute?: Date;
    mestoIzdavanjaIPrometa?: string | undefined;
    ulicaIBroj?: string | undefined;
    tipRacunaDto?: TipRacunaDto | undefined;
    statusRacuna?: StatusRacuna;
    valutaAlphaChar?: string | undefined;
    tekuciRacunId?: number;
    srednjiKursNaDan?: number | undefined;
    iznosStr?: string | undefined;
    ukupanIznosDto?: RacunUkupanIznosDto | undefined;
    dobavljac?: string | undefined;
    dobavljacMB?: string | undefined;
    dobavljacJBKJS?: string | undefined;
    dobavljacPib?: string | undefined;
    dobavljacDrzavaKod?: string | undefined;
    pozivNaBroj?: string | undefined;
    brojModela?: string | undefined;
    sifraPlacanja?: string | undefined;
    brojUgovora?: string | undefined;
    brojNarudzbenice?: string | undefined;
    brojTendera?: string | undefined;
    sifraObjekta?: string | undefined;
    stavkeDto?: NeobradjenRacunStavkaDto[] | undefined;
    oznakeDto?: OznakaDto[] | undefined;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    jeReferencaNaAvansniRacun?: boolean | undefined;
    eOtpremnice?: string[] | undefined;
    ePrijemnice?: string[] | undefined;
    avansneUplateRacunaTableDto?: AvansnaUplataRacunaTableDto[] | undefined;
    pdfDokumentList?: FileAttachment[] | undefined;
    prikazRabata?: PrikazRabata;
}

export class NeobradjenRacunStavkaDto implements INeobradjenRacunStavkaDto {
    redniBroj?: string | undefined;
    naziv?: string | undefined;
    jedinicaMere?: string | undefined;
    iznos?: number;
    iznosStr?: string | undefined;
    kolicina?: number;
    pdvKategorija?: string | undefined;
    razlogPdvIzuzecaStr?: string | undefined;
    razlogPdvIzuzecaId?: number | undefined;
    pdvStopa?: number;
    pdvIznos?: number;
    pdvIznosStr?: string | undefined;
    cenaPoJM?: number;
    cenaPoJMStr?: string | undefined;
    poreskaOsnovica?: number;
    poreskaOsnovicaStr?: string | undefined;
    rabatPosto?: number | undefined;
    rabatIznosStr?: string | undefined;
    rabatIznos?: number | undefined;
    sellersItemIdentification?: string | undefined;
    standardItemIdentification?: string | undefined;
    buyerItemIdentification?: string | undefined;

    constructor(data?: INeobradjenRacunStavkaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redniBroj = _data["redniBroj"];
            this.naziv = _data["naziv"];
            this.jedinicaMere = _data["jedinicaMere"];
            this.iznos = _data["iznos"];
            this.iznosStr = _data["iznosStr"];
            this.kolicina = _data["kolicina"];
            this.pdvKategorija = _data["pdvKategorija"];
            this.razlogPdvIzuzecaStr = _data["razlogPdvIzuzecaStr"];
            this.razlogPdvIzuzecaId = _data["razlogPdvIzuzecaId"];
            this.pdvStopa = _data["pdvStopa"];
            this.pdvIznos = _data["pdvIznos"];
            this.pdvIznosStr = _data["pdvIznosStr"];
            this.cenaPoJM = _data["cenaPoJM"];
            this.cenaPoJMStr = _data["cenaPoJMStr"];
            this.poreskaOsnovica = _data["poreskaOsnovica"];
            this.poreskaOsnovicaStr = _data["poreskaOsnovicaStr"];
            this.rabatPosto = _data["rabatPosto"];
            this.rabatIznosStr = _data["rabatIznosStr"];
            this.rabatIznos = _data["rabatIznos"];
            this.sellersItemIdentification = _data["sellersItemIdentification"];
            this.standardItemIdentification = _data["standardItemIdentification"];
            this.buyerItemIdentification = _data["buyerItemIdentification"];
        }
    }

    static fromJS(data: any): NeobradjenRacunStavkaDto {
        data = typeof data === 'object' ? data : {};
        let result = new NeobradjenRacunStavkaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redniBroj"] = this.redniBroj;
        data["naziv"] = this.naziv;
        data["jedinicaMere"] = this.jedinicaMere;
        data["iznos"] = this.iznos;
        data["iznosStr"] = this.iznosStr;
        data["kolicina"] = this.kolicina;
        data["pdvKategorija"] = this.pdvKategorija;
        data["razlogPdvIzuzecaStr"] = this.razlogPdvIzuzecaStr;
        data["razlogPdvIzuzecaId"] = this.razlogPdvIzuzecaId;
        data["pdvStopa"] = this.pdvStopa;
        data["pdvIznos"] = this.pdvIznos;
        data["pdvIznosStr"] = this.pdvIznosStr;
        data["cenaPoJM"] = this.cenaPoJM;
        data["cenaPoJMStr"] = this.cenaPoJMStr;
        data["poreskaOsnovica"] = this.poreskaOsnovica;
        data["poreskaOsnovicaStr"] = this.poreskaOsnovicaStr;
        data["rabatPosto"] = this.rabatPosto;
        data["rabatIznosStr"] = this.rabatIznosStr;
        data["rabatIznos"] = this.rabatIznos;
        data["sellersItemIdentification"] = this.sellersItemIdentification;
        data["standardItemIdentification"] = this.standardItemIdentification;
        data["buyerItemIdentification"] = this.buyerItemIdentification;
        return data;
    }
}

export interface INeobradjenRacunStavkaDto {
    redniBroj?: string | undefined;
    naziv?: string | undefined;
    jedinicaMere?: string | undefined;
    iznos?: number;
    iznosStr?: string | undefined;
    kolicina?: number;
    pdvKategorija?: string | undefined;
    razlogPdvIzuzecaStr?: string | undefined;
    razlogPdvIzuzecaId?: number | undefined;
    pdvStopa?: number;
    pdvIznos?: number;
    pdvIznosStr?: string | undefined;
    cenaPoJM?: number;
    cenaPoJMStr?: string | undefined;
    poreskaOsnovica?: number;
    poreskaOsnovicaStr?: string | undefined;
    rabatPosto?: number | undefined;
    rabatIznosStr?: string | undefined;
    rabatIznos?: number | undefined;
    sellersItemIdentification?: string | undefined;
    standardItemIdentification?: string | undefined;
    buyerItemIdentification?: string | undefined;
}

export class PaginatedResultOfNeobradjenSefRacunTableDto extends Result implements IPaginatedResultOfNeobradjenSefRacunTableDto {
    data?: NeobradjenSefRacunTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResultOfNeobradjenSefRacunTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(NeobradjenSefRacunTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResultOfNeobradjenSefRacunTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfNeobradjenSefRacunTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfNeobradjenSefRacunTableDto extends IResult {
    data?: NeobradjenSefRacunTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
    currentPage?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class NeobradjenSefRacunTableDto implements INeobradjenSefRacunTableDto {
    id?: number;
    sefId?: number;
    broj?: string | undefined;
    valutaText?: string | undefined;
    datumIzdavanjaStr?: string | undefined;
    datumValuteStr?: string | undefined;
    datumPrometaStr?: string | undefined;
    datumPrometaOdStr?: string | undefined;
    datumPrometaDoStr?: string | undefined;
    datumPrometaOd?: Date | undefined;
    datumPrometaDo?: Date | undefined;
    tipDto?: TipRacunaDto | undefined;
    iznos?: number;
    stranka?: string | undefined;
    statusDto?: StatusRacunaDto | undefined;
    hasRelevantneDokumente?: boolean;
    datumIzdavanja?: Date;
    datumPrometa?: Date | undefined;
    period?: number | undefined;
    statusRacuna?: StatusRacuna;
    tipRacuna?: TipRacuna;
    pib?: string | undefined;
    jeKreiranUlazniRacun?: boolean;
    razlogOtkazivanjaOdbijanja?: string | undefined;

    constructor(data?: INeobradjenSefRacunTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sefId = _data["sefId"];
            this.broj = _data["broj"];
            this.valutaText = _data["valutaText"];
            this.datumIzdavanjaStr = _data["datumIzdavanjaStr"];
            this.datumValuteStr = _data["datumValuteStr"];
            this.datumPrometaStr = _data["datumPrometaStr"];
            this.datumPrometaOdStr = _data["datumPrometaOdStr"];
            this.datumPrometaDoStr = _data["datumPrometaDoStr"];
            this.datumPrometaOd = _data["datumPrometaOd"] ? new Date(_data["datumPrometaOd"].toString()) : <any>undefined;
            this.datumPrometaDo = _data["datumPrometaDo"] ? new Date(_data["datumPrometaDo"].toString()) : <any>undefined;
            this.tipDto = _data["tipDto"] ? TipRacunaDto.fromJS(_data["tipDto"]) : <any>undefined;
            this.iznos = _data["iznos"];
            this.stranka = _data["stranka"];
            this.statusDto = _data["statusDto"] ? StatusRacunaDto.fromJS(_data["statusDto"]) : <any>undefined;
            this.hasRelevantneDokumente = _data["hasRelevantneDokumente"];
            this.datumIzdavanja = _data["datumIzdavanja"] ? new Date(_data["datumIzdavanja"].toString()) : <any>undefined;
            this.datumPrometa = _data["datumPrometa"] ? new Date(_data["datumPrometa"].toString()) : <any>undefined;
            this.period = _data["period"];
            this.statusRacuna = _data["statusRacuna"];
            this.tipRacuna = _data["tipRacuna"];
            this.pib = _data["pib"];
            this.jeKreiranUlazniRacun = _data["jeKreiranUlazniRacun"];
            this.razlogOtkazivanjaOdbijanja = _data["razlogOtkazivanjaOdbijanja"];
        }
    }

    static fromJS(data: any): NeobradjenSefRacunTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new NeobradjenSefRacunTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sefId"] = this.sefId;
        data["broj"] = this.broj;
        data["valutaText"] = this.valutaText;
        data["datumIzdavanjaStr"] = this.datumIzdavanjaStr;
        data["datumValuteStr"] = this.datumValuteStr;
        data["datumPrometaStr"] = this.datumPrometaStr;
        data["datumPrometaOdStr"] = this.datumPrometaOdStr;
        data["datumPrometaDoStr"] = this.datumPrometaDoStr;
        data["datumPrometaOd"] = this.datumPrometaOd ? this.datumPrometaOd.toISOString() : <any>undefined;
        data["datumPrometaDo"] = this.datumPrometaDo ? this.datumPrometaDo.toISOString() : <any>undefined;
        data["tipDto"] = this.tipDto ? this.tipDto.toJSON() : <any>undefined;
        data["iznos"] = this.iznos;
        data["stranka"] = this.stranka;
        data["statusDto"] = this.statusDto ? this.statusDto.toJSON() : <any>undefined;
        data["hasRelevantneDokumente"] = this.hasRelevantneDokumente;
        data["datumIzdavanja"] = this.datumIzdavanja ? this.datumIzdavanja.toISOString() : <any>undefined;
        data["datumPrometa"] = this.datumPrometa ? this.datumPrometa.toISOString() : <any>undefined;
        data["period"] = this.period;
        data["statusRacuna"] = this.statusRacuna;
        data["tipRacuna"] = this.tipRacuna;
        data["pib"] = this.pib;
        data["jeKreiranUlazniRacun"] = this.jeKreiranUlazniRacun;
        data["razlogOtkazivanjaOdbijanja"] = this.razlogOtkazivanjaOdbijanja;
        return data;
    }
}

export interface INeobradjenSefRacunTableDto {
    id?: number;
    sefId?: number;
    broj?: string | undefined;
    valutaText?: string | undefined;
    datumIzdavanjaStr?: string | undefined;
    datumValuteStr?: string | undefined;
    datumPrometaStr?: string | undefined;
    datumPrometaOdStr?: string | undefined;
    datumPrometaDoStr?: string | undefined;
    datumPrometaOd?: Date | undefined;
    datumPrometaDo?: Date | undefined;
    tipDto?: TipRacunaDto | undefined;
    iznos?: number;
    stranka?: string | undefined;
    statusDto?: StatusRacunaDto | undefined;
    hasRelevantneDokumente?: boolean;
    datumIzdavanja?: Date;
    datumPrometa?: Date | undefined;
    period?: number | undefined;
    statusRacuna?: StatusRacuna;
    tipRacuna?: TipRacuna;
    pib?: string | undefined;
    jeKreiranUlazniRacun?: boolean;
    razlogOtkazivanjaOdbijanja?: string | undefined;
}

export class GetSefRacunTableQuery implements IGetSefRacunTableQuery {
    tip?: TipRacuna;
    statusi?: StatusRacunaDto[] | undefined;
    broj?: string | undefined;
    datumPrometaOd?: Date | undefined;
    datumPrometaDo?: Date | undefined;
    stranka?: string | undefined;
    period?: PdvPeriod | undefined;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetSefRacunTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tip = _data["tip"];
            if (Array.isArray(_data["statusi"])) {
                this.statusi = [] as any;
                for (let item of _data["statusi"])
                    this.statusi!.push(StatusRacunaDto.fromJS(item));
            }
            this.broj = _data["broj"];
            this.datumPrometaOd = _data["datumPrometaOd"] ? new Date(_data["datumPrometaOd"].toString()) : <any>undefined;
            this.datumPrometaDo = _data["datumPrometaDo"] ? new Date(_data["datumPrometaDo"].toString()) : <any>undefined;
            this.stranka = _data["stranka"];
            this.period = _data["period"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetSefRacunTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSefRacunTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tip"] = this.tip;
        if (Array.isArray(this.statusi)) {
            data["statusi"] = [];
            for (let item of this.statusi)
                data["statusi"].push(item.toJSON());
        }
        data["broj"] = this.broj;
        data["datumPrometaOd"] = this.datumPrometaOd ? this.datumPrometaOd.toISOString() : <any>undefined;
        data["datumPrometaDo"] = this.datumPrometaDo ? this.datumPrometaDo.toISOString() : <any>undefined;
        data["stranka"] = this.stranka;
        data["period"] = this.period;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetSefRacunTableQuery {
    tip?: TipRacuna;
    statusi?: StatusRacunaDto[] | undefined;
    broj?: string | undefined;
    datumPrometaOd?: Date | undefined;
    datumPrometaDo?: Date | undefined;
    stranka?: string | undefined;
    period?: PdvPeriod | undefined;
    pageNumber?: number;
    pageSize?: number;
}

export class ObradiSefRacunRequest implements IObradiSefRacunRequest {
    brojFiskalnogIsecka?: string | undefined;
    racunDto?: RacunDto | undefined;
    zavisniTroskoviStavkeDto?: ZavisniTrosakStavkaDto[] | undefined;
    prikazIzmenaOsnoviceDto?: PrikazIzmenaOsnoviceDto | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    brojReferentnogDokumenta?: string | undefined;
    vrstaFakture?: VrstaFakture;
    informacijaIsporuke?: InformacijaIsporukeDto | undefined;
    sefId?: number;
    preostaloPdv8?: number | undefined;
    preostaloPdv10?: number | undefined;
    preostaloPdv20?: number | undefined;
    preostaloUkupnoOsnovica8?: number | undefined;
    preostaloUkupnoOsnovica10?: number | undefined;
    preostaloUkupnoOsnovica20?: number | undefined;
    preostaloUkupnoOsnovicaAE?: number | undefined;
    preostaloUkupnoOsnovicaAE10?: number | undefined;
    preostaloUkupnoOsnovicaAE20?: number | undefined;
    preostaloUkupnoOsnovicaO?: number | undefined;
    preostaloUkupnoOsnovicaE?: number | undefined;
    preostaloUkupnoOsnovicaR?: number | undefined;
    preostaloUkupnoOsnovicaZ?: number | undefined;
    preostaloUkupnoOsnovicaSS?: number | undefined;
    preostaloUkupnoOsnovicaOE?: number | undefined;
    preostaloUkupnoOsnovicaN?: number | undefined;
    ukupanIznosUplate?: number | undefined;
    predracunIds?: number[] | undefined;
    uplataId?: number | undefined;

    constructor(data?: IObradiSefRacunRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brojFiskalnogIsecka = _data["brojFiskalnogIsecka"];
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            if (Array.isArray(_data["zavisniTroskoviStavkeDto"])) {
                this.zavisniTroskoviStavkeDto = [] as any;
                for (let item of _data["zavisniTroskoviStavkeDto"])
                    this.zavisniTroskoviStavkeDto!.push(ZavisniTrosakStavkaDto.fromJS(item));
            }
            this.prikazIzmenaOsnoviceDto = _data["prikazIzmenaOsnoviceDto"] ? PrikazIzmenaOsnoviceDto.fromJS(_data["prikazIzmenaOsnoviceDto"]) : <any>undefined;
            this.periodOd = _data["periodOd"] ? new Date(_data["periodOd"].toString()) : <any>undefined;
            this.periodDo = _data["periodDo"] ? new Date(_data["periodDo"].toString()) : <any>undefined;
            this.brojReferentnogDokumenta = _data["brojReferentnogDokumenta"];
            this.vrstaFakture = _data["vrstaFakture"];
            this.informacijaIsporuke = _data["informacijaIsporuke"] ? InformacijaIsporukeDto.fromJS(_data["informacijaIsporuke"]) : <any>undefined;
            this.sefId = _data["sefId"];
            this.preostaloPdv8 = _data["preostaloPdv8"];
            this.preostaloPdv10 = _data["preostaloPdv10"];
            this.preostaloPdv20 = _data["preostaloPdv20"];
            this.preostaloUkupnoOsnovica8 = _data["preostaloUkupnoOsnovica8"];
            this.preostaloUkupnoOsnovica10 = _data["preostaloUkupnoOsnovica10"];
            this.preostaloUkupnoOsnovica20 = _data["preostaloUkupnoOsnovica20"];
            this.preostaloUkupnoOsnovicaAE = _data["preostaloUkupnoOsnovicaAE"];
            this.preostaloUkupnoOsnovicaAE10 = _data["preostaloUkupnoOsnovicaAE10"];
            this.preostaloUkupnoOsnovicaAE20 = _data["preostaloUkupnoOsnovicaAE20"];
            this.preostaloUkupnoOsnovicaO = _data["preostaloUkupnoOsnovicaO"];
            this.preostaloUkupnoOsnovicaE = _data["preostaloUkupnoOsnovicaE"];
            this.preostaloUkupnoOsnovicaR = _data["preostaloUkupnoOsnovicaR"];
            this.preostaloUkupnoOsnovicaZ = _data["preostaloUkupnoOsnovicaZ"];
            this.preostaloUkupnoOsnovicaSS = _data["preostaloUkupnoOsnovicaSS"];
            this.preostaloUkupnoOsnovicaOE = _data["preostaloUkupnoOsnovicaOE"];
            this.preostaloUkupnoOsnovicaN = _data["preostaloUkupnoOsnovicaN"];
            this.ukupanIznosUplate = _data["ukupanIznosUplate"];
            if (Array.isArray(_data["predracunIds"])) {
                this.predracunIds = [] as any;
                for (let item of _data["predracunIds"])
                    this.predracunIds!.push(item);
            }
            this.uplataId = _data["uplataId"];
        }
    }

    static fromJS(data: any): ObradiSefRacunRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ObradiSefRacunRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brojFiskalnogIsecka"] = this.brojFiskalnogIsecka;
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        if (Array.isArray(this.zavisniTroskoviStavkeDto)) {
            data["zavisniTroskoviStavkeDto"] = [];
            for (let item of this.zavisniTroskoviStavkeDto)
                data["zavisniTroskoviStavkeDto"].push(item.toJSON());
        }
        data["prikazIzmenaOsnoviceDto"] = this.prikazIzmenaOsnoviceDto ? this.prikazIzmenaOsnoviceDto.toJSON() : <any>undefined;
        data["periodOd"] = this.periodOd ? this.periodOd.toISOString() : <any>undefined;
        data["periodDo"] = this.periodDo ? this.periodDo.toISOString() : <any>undefined;
        data["brojReferentnogDokumenta"] = this.brojReferentnogDokumenta;
        data["vrstaFakture"] = this.vrstaFakture;
        data["informacijaIsporuke"] = this.informacijaIsporuke ? this.informacijaIsporuke.toJSON() : <any>undefined;
        data["sefId"] = this.sefId;
        data["preostaloPdv8"] = this.preostaloPdv8;
        data["preostaloPdv10"] = this.preostaloPdv10;
        data["preostaloPdv20"] = this.preostaloPdv20;
        data["preostaloUkupnoOsnovica8"] = this.preostaloUkupnoOsnovica8;
        data["preostaloUkupnoOsnovica10"] = this.preostaloUkupnoOsnovica10;
        data["preostaloUkupnoOsnovica20"] = this.preostaloUkupnoOsnovica20;
        data["preostaloUkupnoOsnovicaAE"] = this.preostaloUkupnoOsnovicaAE;
        data["preostaloUkupnoOsnovicaAE10"] = this.preostaloUkupnoOsnovicaAE10;
        data["preostaloUkupnoOsnovicaAE20"] = this.preostaloUkupnoOsnovicaAE20;
        data["preostaloUkupnoOsnovicaO"] = this.preostaloUkupnoOsnovicaO;
        data["preostaloUkupnoOsnovicaE"] = this.preostaloUkupnoOsnovicaE;
        data["preostaloUkupnoOsnovicaR"] = this.preostaloUkupnoOsnovicaR;
        data["preostaloUkupnoOsnovicaZ"] = this.preostaloUkupnoOsnovicaZ;
        data["preostaloUkupnoOsnovicaSS"] = this.preostaloUkupnoOsnovicaSS;
        data["preostaloUkupnoOsnovicaOE"] = this.preostaloUkupnoOsnovicaOE;
        data["preostaloUkupnoOsnovicaN"] = this.preostaloUkupnoOsnovicaN;
        data["ukupanIznosUplate"] = this.ukupanIznosUplate;
        if (Array.isArray(this.predracunIds)) {
            data["predracunIds"] = [];
            for (let item of this.predracunIds)
                data["predracunIds"].push(item);
        }
        data["uplataId"] = this.uplataId;
        return data;
    }
}

export interface IObradiSefRacunRequest {
    brojFiskalnogIsecka?: string | undefined;
    racunDto?: RacunDto | undefined;
    zavisniTroskoviStavkeDto?: ZavisniTrosakStavkaDto[] | undefined;
    prikazIzmenaOsnoviceDto?: PrikazIzmenaOsnoviceDto | undefined;
    periodOd?: Date | undefined;
    periodDo?: Date | undefined;
    brojReferentnogDokumenta?: string | undefined;
    vrstaFakture?: VrstaFakture;
    informacijaIsporuke?: InformacijaIsporukeDto | undefined;
    sefId?: number;
    preostaloPdv8?: number | undefined;
    preostaloPdv10?: number | undefined;
    preostaloPdv20?: number | undefined;
    preostaloUkupnoOsnovica8?: number | undefined;
    preostaloUkupnoOsnovica10?: number | undefined;
    preostaloUkupnoOsnovica20?: number | undefined;
    preostaloUkupnoOsnovicaAE?: number | undefined;
    preostaloUkupnoOsnovicaAE10?: number | undefined;
    preostaloUkupnoOsnovicaAE20?: number | undefined;
    preostaloUkupnoOsnovicaO?: number | undefined;
    preostaloUkupnoOsnovicaE?: number | undefined;
    preostaloUkupnoOsnovicaR?: number | undefined;
    preostaloUkupnoOsnovicaZ?: number | undefined;
    preostaloUkupnoOsnovicaSS?: number | undefined;
    preostaloUkupnoOsnovicaOE?: number | undefined;
    preostaloUkupnoOsnovicaN?: number | undefined;
    ukupanIznosUplate?: number | undefined;
    predracunIds?: number[] | undefined;
    uplataId?: number | undefined;
}

export class ObradiSefRacunCommand extends ObradiSefRacunRequest implements IObradiSefRacunCommand {

    constructor(data?: IObradiSefRacunCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ObradiSefRacunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObradiSefRacunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IObradiSefRacunCommand extends IObradiSefRacunRequest {
}

export class CreateRacunFromSefRacunCommand implements ICreateRacunFromSefRacunCommand {
    racunIds?: number[] | undefined;
    brojRacuna?: string | undefined;
    praviloZaBrojRacuna?: number | undefined;
    oznakeDto?: OznakaDto[] | undefined;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;

    constructor(data?: ICreateRacunFromSefRacunCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["racunIds"])) {
                this.racunIds = [] as any;
                for (let item of _data["racunIds"])
                    this.racunIds!.push(item);
            }
            this.brojRacuna = _data["brojRacuna"];
            this.praviloZaBrojRacuna = _data["praviloZaBrojRacuna"];
            if (Array.isArray(_data["oznakeDto"])) {
                this.oznakeDto = [] as any;
                for (let item of _data["oznakeDto"])
                    this.oznakeDto!.push(OznakaDto.fromJS(item));
            }
            this.klasifikacijaRacuna = _data["klasifikacijaRacuna"];
            this.pravoNaPdvOdbitak = _data["pravoNaPdvOdbitak"];
        }
    }

    static fromJS(data: any): CreateRacunFromSefRacunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRacunFromSefRacunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.racunIds)) {
            data["racunIds"] = [];
            for (let item of this.racunIds)
                data["racunIds"].push(item);
        }
        data["brojRacuna"] = this.brojRacuna;
        data["praviloZaBrojRacuna"] = this.praviloZaBrojRacuna;
        if (Array.isArray(this.oznakeDto)) {
            data["oznakeDto"] = [];
            for (let item of this.oznakeDto)
                data["oznakeDto"].push(item.toJSON());
        }
        data["klasifikacijaRacuna"] = this.klasifikacijaRacuna;
        data["pravoNaPdvOdbitak"] = this.pravoNaPdvOdbitak;
        return data;
    }
}

export interface ICreateRacunFromSefRacunCommand {
    racunIds?: number[] | undefined;
    brojRacuna?: string | undefined;
    praviloZaBrojRacuna?: number | undefined;
    oznakeDto?: OznakaDto[] | undefined;
    klasifikacijaRacuna?: KlasifikacijaRacuna | undefined;
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak | undefined;
}

export class ResultOfDebugSimulacijaResponse extends Result implements IResultOfDebugSimulacijaResponse {
    data?: DebugSimulacijaResponse | undefined;

    constructor(data?: IResultOfDebugSimulacijaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? DebugSimulacijaResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfDebugSimulacijaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfDebugSimulacijaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfDebugSimulacijaResponse extends IResult {
    data?: DebugSimulacijaResponse | undefined;
}

export class DebugSimulacijaResponse implements IDebugSimulacijaResponse {
    sefId?: number;
    racunId?: number;
    racunBroj?: string | undefined;

    constructor(data?: IDebugSimulacijaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sefId = _data["sefId"];
            this.racunId = _data["racunId"];
            this.racunBroj = _data["racunBroj"];
        }
    }

    static fromJS(data: any): DebugSimulacijaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DebugSimulacijaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sefId"] = this.sefId;
        data["racunId"] = this.racunId;
        data["racunBroj"] = this.racunBroj;
        return data;
    }
}

export interface IDebugSimulacijaResponse {
    sefId?: number;
    racunId?: number;
    racunBroj?: string | undefined;
}

export class ResultOfGetDelatnostiResponse extends Result implements IResultOfGetDelatnostiResponse {
    data?: GetDelatnostiResponse | undefined;

    constructor(data?: IResultOfGetDelatnostiResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetDelatnostiResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetDelatnostiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetDelatnostiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetDelatnostiResponse extends IResult {
    data?: GetDelatnostiResponse | undefined;
}

export class GetDelatnostiResponse implements IGetDelatnostiResponse {
    delatnosti?: DelatnostPodGrupomDto[] | undefined;

    constructor(data?: IGetDelatnostiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["delatnosti"])) {
                this.delatnosti = [] as any;
                for (let item of _data["delatnosti"])
                    this.delatnosti!.push(DelatnostPodGrupomDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDelatnostiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDelatnostiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.delatnosti)) {
            data["delatnosti"] = [];
            for (let item of this.delatnosti)
                data["delatnosti"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDelatnostiResponse {
    delatnosti?: DelatnostPodGrupomDto[] | undefined;
}

export class DelatnostPodGrupomDto implements IDelatnostPodGrupomDto {
    id?: number;
    nazivGrupe?: string | undefined;
    sifraDelatnosti?: string | undefined;
    nazivDelatnosti?: string | undefined;

    constructor(data?: IDelatnostPodGrupomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nazivGrupe = _data["nazivGrupe"];
            this.sifraDelatnosti = _data["sifraDelatnosti"];
            this.nazivDelatnosti = _data["nazivDelatnosti"];
        }
    }

    static fromJS(data: any): DelatnostPodGrupomDto {
        data = typeof data === 'object' ? data : {};
        let result = new DelatnostPodGrupomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nazivGrupe"] = this.nazivGrupe;
        data["sifraDelatnosti"] = this.sifraDelatnosti;
        data["nazivDelatnosti"] = this.nazivDelatnosti;
        return data;
    }
}

export interface IDelatnostPodGrupomDto {
    id?: number;
    nazivGrupe?: string | undefined;
    sifraDelatnosti?: string | undefined;
    nazivDelatnosti?: string | undefined;
}

export class ResultOfGetValuteResponse extends Result implements IResultOfGetValuteResponse {
    data?: GetValuteResponse | undefined;

    constructor(data?: IResultOfGetValuteResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetValuteResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetValuteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetValuteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetValuteResponse extends IResult {
    data?: GetValuteResponse | undefined;
}

export class GetValuteResponse implements IGetValuteResponse {
    valute?: ValutaDto[] | undefined;

    constructor(data?: IGetValuteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["valute"])) {
                this.valute = [] as any;
                for (let item of _data["valute"])
                    this.valute!.push(ValutaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetValuteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetValuteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.valute)) {
            data["valute"] = [];
            for (let item of this.valute)
                data["valute"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetValuteResponse {
    valute?: ValutaDto[] | undefined;
}

export class ValutaDto implements IValutaDto {
    id?: string;
    kodValuteAlfaChar?: string | undefined;
    naziv?: string | undefined;
    nazivDrzave?: string | undefined;
    kod?: number;

    constructor(data?: IValutaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kodValuteAlfaChar = _data["kodValuteAlfaChar"];
            this.naziv = _data["naziv"];
            this.nazivDrzave = _data["nazivDrzave"];
            this.kod = _data["kod"];
        }
    }

    static fromJS(data: any): ValutaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValutaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kodValuteAlfaChar"] = this.kodValuteAlfaChar;
        data["naziv"] = this.naziv;
        data["nazivDrzave"] = this.nazivDrzave;
        data["kod"] = this.kod;
        return data;
    }
}

export interface IValutaDto {
    id?: string;
    kodValuteAlfaChar?: string | undefined;
    naziv?: string | undefined;
    nazivDrzave?: string | undefined;
    kod?: number;
}

export class ResultOfGetDrzaveResponse extends Result implements IResultOfGetDrzaveResponse {
    data?: GetDrzaveResponse | undefined;

    constructor(data?: IResultOfGetDrzaveResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetDrzaveResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetDrzaveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetDrzaveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetDrzaveResponse extends IResult {
    data?: GetDrzaveResponse | undefined;
}

export class GetDrzaveResponse implements IGetDrzaveResponse {
    drzave?: DrzavaDto[] | undefined;

    constructor(data?: IGetDrzaveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["drzave"])) {
                this.drzave = [] as any;
                for (let item of _data["drzave"])
                    this.drzave!.push(DrzavaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDrzaveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDrzaveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.drzave)) {
            data["drzave"] = [];
            for (let item of this.drzave)
                data["drzave"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDrzaveResponse {
    drzave?: DrzavaDto[] | undefined;
}

export class DrzavaDto implements IDrzavaDto {
    id?: string | undefined;
    kodDrzave?: number;
    kodDrzaveNumChar?: string | undefined;
    kodDrzaveAlfaChar3?: string | undefined;
    kodDrzaveAlfaChar2?: string | undefined;
    nazivSrbCir?: string | undefined;
    nazivSrbLat?: string | undefined;
    nazivEng?: string | undefined;

    constructor(data?: IDrzavaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kodDrzave = _data["kodDrzave"];
            this.kodDrzaveNumChar = _data["kodDrzaveNumChar"];
            this.kodDrzaveAlfaChar3 = _data["kodDrzaveAlfaChar3"];
            this.kodDrzaveAlfaChar2 = _data["kodDrzaveAlfaChar2"];
            this.nazivSrbCir = _data["nazivSrbCir"];
            this.nazivSrbLat = _data["nazivSrbLat"];
            this.nazivEng = _data["nazivEng"];
        }
    }

    static fromJS(data: any): DrzavaDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrzavaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kodDrzave"] = this.kodDrzave;
        data["kodDrzaveNumChar"] = this.kodDrzaveNumChar;
        data["kodDrzaveAlfaChar3"] = this.kodDrzaveAlfaChar3;
        data["kodDrzaveAlfaChar2"] = this.kodDrzaveAlfaChar2;
        data["nazivSrbCir"] = this.nazivSrbCir;
        data["nazivSrbLat"] = this.nazivSrbLat;
        data["nazivEng"] = this.nazivEng;
        return data;
    }
}

export interface IDrzavaDto {
    id?: string | undefined;
    kodDrzave?: number;
    kodDrzaveNumChar?: string | undefined;
    kodDrzaveAlfaChar3?: string | undefined;
    kodDrzaveAlfaChar2?: string | undefined;
    nazivSrbCir?: string | undefined;
    nazivSrbLat?: string | undefined;
    nazivEng?: string | undefined;
}

export class ResultOfGetPrikazRabataResponse extends Result implements IResultOfGetPrikazRabataResponse {
    data?: GetPrikazRabataResponse | undefined;

    constructor(data?: IResultOfGetPrikazRabataResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetPrikazRabataResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetPrikazRabataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetPrikazRabataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetPrikazRabataResponse extends IResult {
    data?: GetPrikazRabataResponse | undefined;
}

export class GetPrikazRabataResponse implements IGetPrikazRabataResponse {
    prikazRabataDtoList?: PrikazRabataDto[] | undefined;

    constructor(data?: IGetPrikazRabataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["prikazRabataDtoList"])) {
                this.prikazRabataDtoList = [] as any;
                for (let item of _data["prikazRabataDtoList"])
                    this.prikazRabataDtoList!.push(PrikazRabataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPrikazRabataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrikazRabataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prikazRabataDtoList)) {
            data["prikazRabataDtoList"] = [];
            for (let item of this.prikazRabataDtoList)
                data["prikazRabataDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPrikazRabataResponse {
    prikazRabataDtoList?: PrikazRabataDto[] | undefined;
}

export class ResultOfGetParitetResponse extends Result implements IResultOfGetParitetResponse {
    data?: GetParitetResponse | undefined;

    constructor(data?: IResultOfGetParitetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetParitetResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetParitetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetParitetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetParitetResponse extends IResult {
    data?: GetParitetResponse | undefined;
}

export class GetParitetResponse implements IGetParitetResponse {
    paritetDtoList?: ParitetDto[] | undefined;

    constructor(data?: IGetParitetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["paritetDtoList"])) {
                this.paritetDtoList = [] as any;
                for (let item of _data["paritetDtoList"])
                    this.paritetDtoList!.push(ParitetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetParitetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetParitetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.paritetDtoList)) {
            data["paritetDtoList"] = [];
            for (let item of this.paritetDtoList)
                data["paritetDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetParitetResponse {
    paritetDtoList?: ParitetDto[] | undefined;
}

export class ParitetDto implements IParitetDto {
    paritet?: Paritet;
    paritetStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IParitetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paritet = _data["paritet"];
            this.paritetStr = _data["paritetStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): ParitetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParitetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paritet"] = this.paritet;
        data["paritetStr"] = this.paritetStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IParitetDto {
    paritet?: Paritet;
    paritetStr?: string | undefined;
    opis?: string | undefined;
}

export class ResultOfGetPrikazDokumentaOSmanjenjuIPovecanjuResponse extends Result implements IResultOfGetPrikazDokumentaOSmanjenjuIPovecanjuResponse {
    data?: GetPrikazDokumentaOSmanjenjuIPovecanjuResponse | undefined;

    constructor(data?: IResultOfGetPrikazDokumentaOSmanjenjuIPovecanjuResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetPrikazDokumentaOSmanjenjuIPovecanjuResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetPrikazDokumentaOSmanjenjuIPovecanjuResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetPrikazDokumentaOSmanjenjuIPovecanjuResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetPrikazDokumentaOSmanjenjuIPovecanjuResponse extends IResult {
    data?: GetPrikazDokumentaOSmanjenjuIPovecanjuResponse | undefined;
}

export class GetPrikazDokumentaOSmanjenjuIPovecanjuResponse implements IGetPrikazDokumentaOSmanjenjuIPovecanjuResponse {
    prikazDokumentaOSmanjenjuIPovecanjuDtoList?: PrikazIzmenaOsnoviceDto[] | undefined;

    constructor(data?: IGetPrikazDokumentaOSmanjenjuIPovecanjuResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["prikazDokumentaOSmanjenjuIPovecanjuDtoList"])) {
                this.prikazDokumentaOSmanjenjuIPovecanjuDtoList = [] as any;
                for (let item of _data["prikazDokumentaOSmanjenjuIPovecanjuDtoList"])
                    this.prikazDokumentaOSmanjenjuIPovecanjuDtoList!.push(PrikazIzmenaOsnoviceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPrikazDokumentaOSmanjenjuIPovecanjuResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrikazDokumentaOSmanjenjuIPovecanjuResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prikazDokumentaOSmanjenjuIPovecanjuDtoList)) {
            data["prikazDokumentaOSmanjenjuIPovecanjuDtoList"] = [];
            for (let item of this.prikazDokumentaOSmanjenjuIPovecanjuDtoList)
                data["prikazDokumentaOSmanjenjuIPovecanjuDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPrikazDokumentaOSmanjenjuIPovecanjuResponse {
    prikazDokumentaOSmanjenjuIPovecanjuDtoList?: PrikazIzmenaOsnoviceDto[] | undefined;
}

export class ResultOfGetPrikazOtpremniceResponse extends Result implements IResultOfGetPrikazOtpremniceResponse {
    data?: GetPrikazOtpremniceResponse | undefined;

    constructor(data?: IResultOfGetPrikazOtpremniceResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetPrikazOtpremniceResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetPrikazOtpremniceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetPrikazOtpremniceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetPrikazOtpremniceResponse extends IResult {
    data?: GetPrikazOtpremniceResponse | undefined;
}

export class GetPrikazOtpremniceResponse implements IGetPrikazOtpremniceResponse {
    prikazOtpremniceDtoList?: PrikazOtpremniceDto[] | undefined;

    constructor(data?: IGetPrikazOtpremniceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["prikazOtpremniceDtoList"])) {
                this.prikazOtpremniceDtoList = [] as any;
                for (let item of _data["prikazOtpremniceDtoList"])
                    this.prikazOtpremniceDtoList!.push(PrikazOtpremniceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPrikazOtpremniceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrikazOtpremniceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prikazOtpremniceDtoList)) {
            data["prikazOtpremniceDtoList"] = [];
            for (let item of this.prikazOtpremniceDtoList)
                data["prikazOtpremniceDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPrikazOtpremniceResponse {
    prikazOtpremniceDtoList?: PrikazOtpremniceDto[] | undefined;
}

export class ResultOfGetPrikazRadnogNalogaResponse extends Result implements IResultOfGetPrikazRadnogNalogaResponse {
    data?: GetPrikazRadnogNalogaResponse | undefined;

    constructor(data?: IResultOfGetPrikazRadnogNalogaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetPrikazRadnogNalogaResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetPrikazRadnogNalogaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetPrikazRadnogNalogaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetPrikazRadnogNalogaResponse extends IResult {
    data?: GetPrikazRadnogNalogaResponse | undefined;
}

export class GetPrikazRadnogNalogaResponse implements IGetPrikazRadnogNalogaResponse {
    prikazRadnogNalogaDtoList?: PrikazRadnogNalogaDto[] | undefined;

    constructor(data?: IGetPrikazRadnogNalogaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["prikazRadnogNalogaDtoList"])) {
                this.prikazRadnogNalogaDtoList = [] as any;
                for (let item of _data["prikazRadnogNalogaDtoList"])
                    this.prikazRadnogNalogaDtoList!.push(PrikazRadnogNalogaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPrikazRadnogNalogaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrikazRadnogNalogaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prikazRadnogNalogaDtoList)) {
            data["prikazRadnogNalogaDtoList"] = [];
            for (let item of this.prikazRadnogNalogaDtoList)
                data["prikazRadnogNalogaDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPrikazRadnogNalogaResponse {
    prikazRadnogNalogaDtoList?: PrikazRadnogNalogaDto[] | undefined;
}

export class ResultOfGetBankeResponse extends Result implements IResultOfGetBankeResponse {
    data?: GetBankeResponse | undefined;

    constructor(data?: IResultOfGetBankeResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetBankeResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetBankeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetBankeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetBankeResponse extends IResult {
    data?: GetBankeResponse | undefined;
}

export class GetBankeResponse implements IGetBankeResponse {
    bankeDtoList?: BankaDto[] | undefined;

    constructor(data?: IGetBankeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bankeDtoList"])) {
                this.bankeDtoList = [] as any;
                for (let item of _data["bankeDtoList"])
                    this.bankeDtoList!.push(BankaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBankeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bankeDtoList)) {
            data["bankeDtoList"] = [];
            for (let item of this.bankeDtoList)
                data["bankeDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBankeResponse {
    bankeDtoList?: BankaDto[] | undefined;
}

export class ResultOfGetOznakaPdvKategorijeDropdownResponse extends Result implements IResultOfGetOznakaPdvKategorijeDropdownResponse {
    data?: GetOznakaPdvKategorijeDropdownResponse | undefined;

    constructor(data?: IResultOfGetOznakaPdvKategorijeDropdownResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetOznakaPdvKategorijeDropdownResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetOznakaPdvKategorijeDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetOznakaPdvKategorijeDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetOznakaPdvKategorijeDropdownResponse extends IResult {
    data?: GetOznakaPdvKategorijeDropdownResponse | undefined;
}

export class GetOznakaPdvKategorijeDropdownResponse implements IGetOznakaPdvKategorijeDropdownResponse {
    oznakaPdvKategorijeDtoList?: OznakaPdvKategorijeDto[] | undefined;

    constructor(data?: IGetOznakaPdvKategorijeDropdownResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["oznakaPdvKategorijeDtoList"])) {
                this.oznakaPdvKategorijeDtoList = [] as any;
                for (let item of _data["oznakaPdvKategorijeDtoList"])
                    this.oznakaPdvKategorijeDtoList!.push(OznakaPdvKategorijeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOznakaPdvKategorijeDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOznakaPdvKategorijeDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.oznakaPdvKategorijeDtoList)) {
            data["oznakaPdvKategorijeDtoList"] = [];
            for (let item of this.oznakaPdvKategorijeDtoList)
                data["oznakaPdvKategorijeDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOznakaPdvKategorijeDropdownResponse {
    oznakaPdvKategorijeDtoList?: OznakaPdvKategorijeDto[] | undefined;
}

export class OznakaPdvKategorijeDto implements IOznakaPdvKategorijeDto {
    oznakaPdvKategorije?: OznakaPdvKategorije;
    oznakaPdvKategorijeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IOznakaPdvKategorijeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oznakaPdvKategorije = _data["oznakaPdvKategorije"];
            this.oznakaPdvKategorijeStr = _data["oznakaPdvKategorijeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): OznakaPdvKategorijeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OznakaPdvKategorijeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oznakaPdvKategorije"] = this.oznakaPdvKategorije;
        data["oznakaPdvKategorijeStr"] = this.oznakaPdvKategorijeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IOznakaPdvKategorijeDto {
    oznakaPdvKategorije?: OznakaPdvKategorije;
    oznakaPdvKategorijeStr?: string | undefined;
    opis?: string | undefined;
}

export class ResultOfIEnumerableOfIdentifikatorStavkeDto extends Result implements IResultOfIEnumerableOfIdentifikatorStavkeDto {
    data?: IdentifikatorStavkeDto[] | undefined;

    constructor(data?: IResultOfIEnumerableOfIdentifikatorStavkeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IdentifikatorStavkeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfIEnumerableOfIdentifikatorStavkeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfIEnumerableOfIdentifikatorStavkeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfIEnumerableOfIdentifikatorStavkeDto extends IResult {
    data?: IdentifikatorStavkeDto[] | undefined;
}

export class IdentifikatorStavkeDto implements IIdentifikatorStavkeDto {
    identifikatorStavkeStr?: string | undefined;
    identifikator?: IdentifikatorKlasifikacijeStavke;

    constructor(data?: IIdentifikatorStavkeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifikatorStavkeStr = _data["identifikatorStavkeStr"];
            this.identifikator = _data["identifikator"];
        }
    }

    static fromJS(data: any): IdentifikatorStavkeDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentifikatorStavkeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifikatorStavkeStr"] = this.identifikatorStavkeStr;
        data["identifikator"] = this.identifikator;
        return data;
    }
}

export interface IIdentifikatorStavkeDto {
    identifikatorStavkeStr?: string | undefined;
    identifikator?: IdentifikatorKlasifikacijeStavke;
}

export class ResultOfGetRazlogPdvIzuzecaDropdownResponse extends Result implements IResultOfGetRazlogPdvIzuzecaDropdownResponse {
    data?: GetRazlogPdvIzuzecaDropdownResponse | undefined;

    constructor(data?: IResultOfGetRazlogPdvIzuzecaDropdownResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetRazlogPdvIzuzecaDropdownResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetRazlogPdvIzuzecaDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetRazlogPdvIzuzecaDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetRazlogPdvIzuzecaDropdownResponse extends IResult {
    data?: GetRazlogPdvIzuzecaDropdownResponse | undefined;
}

export class GetRazlogPdvIzuzecaDropdownResponse implements IGetRazlogPdvIzuzecaDropdownResponse {
    razlogPdvIzuzecaDtoList?: RazlogPdvIzuzecaDto[] | undefined;

    constructor(data?: IGetRazlogPdvIzuzecaDropdownResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["razlogPdvIzuzecaDtoList"])) {
                this.razlogPdvIzuzecaDtoList = [] as any;
                for (let item of _data["razlogPdvIzuzecaDtoList"])
                    this.razlogPdvIzuzecaDtoList!.push(RazlogPdvIzuzecaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRazlogPdvIzuzecaDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRazlogPdvIzuzecaDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.razlogPdvIzuzecaDtoList)) {
            data["razlogPdvIzuzecaDtoList"] = [];
            for (let item of this.razlogPdvIzuzecaDtoList)
                data["razlogPdvIzuzecaDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRazlogPdvIzuzecaDropdownResponse {
    razlogPdvIzuzecaDtoList?: RazlogPdvIzuzecaDto[] | undefined;
}

export class RazlogPdvIzuzecaDto implements IRazlogPdvIzuzecaDto {
    id?: number;
    naziv?: string | undefined;
    opis?: string | undefined;
    oznakaPdvKategorijeStr?: string | undefined;
    oznakaPdvKategorije?: OznakaPdvKategorije;

    constructor(data?: IRazlogPdvIzuzecaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.opis = _data["opis"];
            this.oznakaPdvKategorijeStr = _data["oznakaPdvKategorijeStr"];
            this.oznakaPdvKategorije = _data["oznakaPdvKategorije"];
        }
    }

    static fromJS(data: any): RazlogPdvIzuzecaDto {
        data = typeof data === 'object' ? data : {};
        let result = new RazlogPdvIzuzecaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["opis"] = this.opis;
        data["oznakaPdvKategorijeStr"] = this.oznakaPdvKategorijeStr;
        data["oznakaPdvKategorije"] = this.oznakaPdvKategorije;
        return data;
    }
}

export interface IRazlogPdvIzuzecaDto {
    id?: number;
    naziv?: string | undefined;
    opis?: string | undefined;
    oznakaPdvKategorijeStr?: string | undefined;
    oznakaPdvKategorije?: OznakaPdvKategorije;
}

export class ResultOfListOfExchangeRateDto extends Result implements IResultOfListOfExchangeRateDto {
    data?: ExchangeRateDto[] | undefined;

    constructor(data?: IResultOfListOfExchangeRateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ExchangeRateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfExchangeRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfExchangeRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfExchangeRateDto extends IResult {
    data?: ExchangeRateDto[] | undefined;
}

export class ExchangeRateDto implements IExchangeRateDto {
    middleRate?: number;
    sellingRate?: number;
    buyingRate?: number;
    currencyConversion?: string | undefined;
    date?: string | undefined;

    constructor(data?: IExchangeRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.middleRate = _data["middleRate"];
            this.sellingRate = _data["sellingRate"];
            this.buyingRate = _data["buyingRate"];
            this.currencyConversion = _data["currencyConversion"];
            this.date = _data["date"];
        }
    }

    static fromJS(data: any): ExchangeRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExchangeRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["middleRate"] = this.middleRate;
        data["sellingRate"] = this.sellingRate;
        data["buyingRate"] = this.buyingRate;
        data["currencyConversion"] = this.currencyConversion;
        data["date"] = this.date;
        return data;
    }
}

export interface IExchangeRateDto {
    middleRate?: number;
    sellingRate?: number;
    buyingRate?: number;
    currencyConversion?: string | undefined;
    date?: string | undefined;
}

export class GetKursZaValuteQuery implements IGetKursZaValuteQuery {
    currencyCodes?: number[] | undefined;

    constructor(data?: IGetKursZaValuteQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["currencyCodes"])) {
                this.currencyCodes = [] as any;
                for (let item of _data["currencyCodes"])
                    this.currencyCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): GetKursZaValuteQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetKursZaValuteQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.currencyCodes)) {
            data["currencyCodes"] = [];
            for (let item of this.currencyCodes)
                data["currencyCodes"].push(item);
        }
        return data;
    }
}

export interface IGetKursZaValuteQuery {
    currencyCodes?: number[] | undefined;
}

export class ResultOfGetSifrePlacanjaResponse extends Result implements IResultOfGetSifrePlacanjaResponse {
    data?: GetSifrePlacanjaResponse | undefined;

    constructor(data?: IResultOfGetSifrePlacanjaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetSifrePlacanjaResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetSifrePlacanjaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetSifrePlacanjaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetSifrePlacanjaResponse extends IResult {
    data?: GetSifrePlacanjaResponse | undefined;
}

export class GetSifrePlacanjaResponse implements IGetSifrePlacanjaResponse {
    sifre?: SifraPlacanjaDto[] | undefined;

    constructor(data?: IGetSifrePlacanjaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sifre"])) {
                this.sifre = [] as any;
                for (let item of _data["sifre"])
                    this.sifre!.push(SifraPlacanjaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSifrePlacanjaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSifrePlacanjaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sifre)) {
            data["sifre"] = [];
            for (let item of this.sifre)
                data["sifre"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSifrePlacanjaResponse {
    sifre?: SifraPlacanjaDto[] | undefined;
}

export class SifraPlacanjaDto implements ISifraPlacanjaDto {
    sifraPlacanjaId?: number;
    sifra?: string | undefined;
    opis?: string | undefined;

    constructor(data?: ISifraPlacanjaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifraPlacanjaId = _data["sifraPlacanjaId"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): SifraPlacanjaDto {
        data = typeof data === 'object' ? data : {};
        let result = new SifraPlacanjaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifraPlacanjaId"] = this.sifraPlacanjaId;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        return data;
    }
}

export interface ISifraPlacanjaDto {
    sifraPlacanjaId?: number;
    sifra?: string | undefined;
    opis?: string | undefined;
}

export class ResultOfGetInstrukcijePlacanjaResponse extends Result implements IResultOfGetInstrukcijePlacanjaResponse {
    data?: GetInstrukcijePlacanjaResponse | undefined;

    constructor(data?: IResultOfGetInstrukcijePlacanjaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetInstrukcijePlacanjaResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetInstrukcijePlacanjaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetInstrukcijePlacanjaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetInstrukcijePlacanjaResponse extends IResult {
    data?: GetInstrukcijePlacanjaResponse | undefined;
}

export class GetInstrukcijePlacanjaResponse implements IGetInstrukcijePlacanjaResponse {
    instrukcije?: InstrukcijaPlacanjaDto[] | undefined;

    constructor(data?: IGetInstrukcijePlacanjaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["instrukcije"])) {
                this.instrukcije = [] as any;
                for (let item of _data["instrukcije"])
                    this.instrukcije!.push(InstrukcijaPlacanjaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInstrukcijePlacanjaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInstrukcijePlacanjaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.instrukcije)) {
            data["instrukcije"] = [];
            for (let item of this.instrukcije)
                data["instrukcije"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetInstrukcijePlacanjaResponse {
    instrukcije?: InstrukcijaPlacanjaDto[] | undefined;
}

export class InstrukcijaPlacanjaDto implements IInstrukcijaPlacanjaDto {
    instrukcijaPlacanjaId?: number;
    instrukcija?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IInstrukcijaPlacanjaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instrukcijaPlacanjaId = _data["instrukcijaPlacanjaId"];
            this.instrukcija = _data["instrukcija"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): InstrukcijaPlacanjaDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstrukcijaPlacanjaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instrukcijaPlacanjaId"] = this.instrukcijaPlacanjaId;
        data["instrukcija"] = this.instrukcija;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IInstrukcijaPlacanjaDto {
    instrukcijaPlacanjaId?: number;
    instrukcija?: string | undefined;
    opis?: string | undefined;
}

export class ResultOfGetTipoviRacunaResponse extends Result implements IResultOfGetTipoviRacunaResponse {
    data?: GetTipoviRacunaResponse | undefined;

    constructor(data?: IResultOfGetTipoviRacunaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetTipoviRacunaResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetTipoviRacunaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetTipoviRacunaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetTipoviRacunaResponse extends IResult {
    data?: GetTipoviRacunaResponse | undefined;
}

export class GetTipoviRacunaResponse implements IGetTipoviRacunaResponse {
    tipoviRacunaDtoList?: TipRacunaDto[] | undefined;

    constructor(data?: IGetTipoviRacunaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tipoviRacunaDtoList"])) {
                this.tipoviRacunaDtoList = [] as any;
                for (let item of _data["tipoviRacunaDtoList"])
                    this.tipoviRacunaDtoList!.push(TipRacunaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTipoviRacunaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTipoviRacunaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tipoviRacunaDtoList)) {
            data["tipoviRacunaDtoList"] = [];
            for (let item of this.tipoviRacunaDtoList)
                data["tipoviRacunaDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTipoviRacunaResponse {
    tipoviRacunaDtoList?: TipRacunaDto[] | undefined;
}

export class GetTipoviRacunaQuery implements IGetTipoviRacunaQuery {
    allowedTypes?: TipRacuna[] | undefined;

    constructor(data?: IGetTipoviRacunaQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allowedTypes"])) {
                this.allowedTypes = [] as any;
                for (let item of _data["allowedTypes"])
                    this.allowedTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): GetTipoviRacunaQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetTipoviRacunaQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allowedTypes)) {
            data["allowedTypes"] = [];
            for (let item of this.allowedTypes)
                data["allowedTypes"].push(item);
        }
        return data;
    }
}

export interface IGetTipoviRacunaQuery {
    allowedTypes?: TipRacuna[] | undefined;
}

export class ResultOfGetStatusiRacunaResponse extends Result implements IResultOfGetStatusiRacunaResponse {
    data?: GetStatusiRacunaResponse | undefined;

    constructor(data?: IResultOfGetStatusiRacunaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetStatusiRacunaResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetStatusiRacunaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetStatusiRacunaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetStatusiRacunaResponse extends IResult {
    data?: GetStatusiRacunaResponse | undefined;
}

export class GetStatusiRacunaResponse implements IGetStatusiRacunaResponse {
    statusiRacunaDtoList?: StatusRacunaDto[] | undefined;

    constructor(data?: IGetStatusiRacunaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["statusiRacunaDtoList"])) {
                this.statusiRacunaDtoList = [] as any;
                for (let item of _data["statusiRacunaDtoList"])
                    this.statusiRacunaDtoList!.push(StatusRacunaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStatusiRacunaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStatusiRacunaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statusiRacunaDtoList)) {
            data["statusiRacunaDtoList"] = [];
            for (let item of this.statusiRacunaDtoList)
                data["statusiRacunaDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStatusiRacunaResponse {
    statusiRacunaDtoList?: StatusRacunaDto[] | undefined;
}

export class GetStatusiRacunaQuery implements IGetStatusiRacunaQuery {
    allowedStatuses?: StatusRacuna[] | undefined;

    constructor(data?: IGetStatusiRacunaQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allowedStatuses"])) {
                this.allowedStatuses = [] as any;
                for (let item of _data["allowedStatuses"])
                    this.allowedStatuses!.push(item);
            }
        }
    }

    static fromJS(data: any): GetStatusiRacunaQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetStatusiRacunaQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allowedStatuses)) {
            data["allowedStatuses"] = [];
            for (let item of this.allowedStatuses)
                data["allowedStatuses"].push(item);
        }
        return data;
    }
}

export interface IGetStatusiRacunaQuery {
    allowedStatuses?: StatusRacuna[] | undefined;
}

export class ResultOfGetStatuseTransakcijeIzvodaResponse extends Result implements IResultOfGetStatuseTransakcijeIzvodaResponse {
    data?: GetStatuseTransakcijeIzvodaResponse | undefined;

    constructor(data?: IResultOfGetStatuseTransakcijeIzvodaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetStatuseTransakcijeIzvodaResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetStatuseTransakcijeIzvodaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetStatuseTransakcijeIzvodaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetStatuseTransakcijeIzvodaResponse extends IResult {
    data?: GetStatuseTransakcijeIzvodaResponse | undefined;
}

export class GetStatuseTransakcijeIzvodaResponse implements IGetStatuseTransakcijeIzvodaResponse {
    statusiDtoList?: StatusTransakcijeIzvodaDto[] | undefined;

    constructor(data?: IGetStatuseTransakcijeIzvodaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["statusiDtoList"])) {
                this.statusiDtoList = [] as any;
                for (let item of _data["statusiDtoList"])
                    this.statusiDtoList!.push(StatusTransakcijeIzvodaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStatuseTransakcijeIzvodaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStatuseTransakcijeIzvodaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statusiDtoList)) {
            data["statusiDtoList"] = [];
            for (let item of this.statusiDtoList)
                data["statusiDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStatuseTransakcijeIzvodaResponse {
    statusiDtoList?: StatusTransakcijeIzvodaDto[] | undefined;
}

export class ResultOfSoftwareInformationDto extends Result implements IResultOfSoftwareInformationDto {
    data?: SoftwareInformationDto | undefined;

    constructor(data?: IResultOfSoftwareInformationDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? SoftwareInformationDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfSoftwareInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfSoftwareInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfSoftwareInformationDto extends IResult {
    data?: SoftwareInformationDto | undefined;
}

export class SoftwareInformationDto implements ISoftwareInformationDto {
    kompanija?: string | undefined;
    adresa?: string | undefined;
    postanskiBroj?: string | undefined;
    grad?: string | undefined;
    pib?: string | undefined;
    mbr?: string | undefined;
    esir?: string | undefined;

    constructor(data?: ISoftwareInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kompanija = _data["kompanija"];
            this.adresa = _data["adresa"];
            this.postanskiBroj = _data["postanskiBroj"];
            this.grad = _data["grad"];
            this.pib = _data["pib"];
            this.mbr = _data["mbr"];
            this.esir = _data["esir"];
        }
    }

    static fromJS(data: any): SoftwareInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SoftwareInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kompanija"] = this.kompanija;
        data["adresa"] = this.adresa;
        data["postanskiBroj"] = this.postanskiBroj;
        data["grad"] = this.grad;
        data["pib"] = this.pib;
        data["mbr"] = this.mbr;
        data["esir"] = this.esir;
        return data;
    }
}

export interface ISoftwareInformationDto {
    kompanija?: string | undefined;
    adresa?: string | undefined;
    postanskiBroj?: string | undefined;
    grad?: string | undefined;
    pib?: string | undefined;
    mbr?: string | undefined;
    esir?: string | undefined;
}

export class ResultOfApiManagementDto extends Result implements IResultOfApiManagementDto {
    data?: ApiManagementDto | undefined;

    constructor(data?: IResultOfApiManagementDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? ApiManagementDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfApiManagementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfApiManagementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfApiManagementDto extends IResult {
    data?: ApiManagementDto | undefined;
}

export class ApiManagementDto implements IApiManagementDto {
    links?: string[] | undefined;
    apiKey?: string | undefined;
    apiStatus?: boolean | undefined;

    constructor(data?: IApiManagementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(item);
            }
            this.apiKey = _data["apiKey"];
            this.apiStatus = _data["apiStatus"];
        }
    }

    static fromJS(data: any): ApiManagementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiManagementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item);
        }
        data["apiKey"] = this.apiKey;
        data["apiStatus"] = this.apiStatus;
        return data;
    }
}

export interface IApiManagementDto {
    links?: string[] | undefined;
    apiKey?: string | undefined;
    apiStatus?: boolean | undefined;
}

export class ResultOfGetGodinaRacunaDropdownResponse extends Result implements IResultOfGetGodinaRacunaDropdownResponse {
    data?: GetGodinaRacunaDropdownResponse | undefined;

    constructor(data?: IResultOfGetGodinaRacunaDropdownResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetGodinaRacunaDropdownResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetGodinaRacunaDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetGodinaRacunaDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetGodinaRacunaDropdownResponse extends IResult {
    data?: GetGodinaRacunaDropdownResponse | undefined;
}

export class GetGodinaRacunaDropdownResponse implements IGetGodinaRacunaDropdownResponse {
    availableYears?: number[] | undefined;

    constructor(data?: IGetGodinaRacunaDropdownResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["availableYears"])) {
                this.availableYears = [] as any;
                for (let item of _data["availableYears"])
                    this.availableYears!.push(item);
            }
        }
    }

    static fromJS(data: any): GetGodinaRacunaDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGodinaRacunaDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.availableYears)) {
            data["availableYears"] = [];
            for (let item of this.availableYears)
                data["availableYears"].push(item);
        }
        return data;
    }
}

export interface IGetGodinaRacunaDropdownResponse {
    availableYears?: number[] | undefined;
}

export class GetStrankeVm implements IGetStrankeVm {
    strankeDto?: StrankaDto[] | undefined;

    constructor(data?: IGetStrankeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["strankeDto"])) {
                this.strankeDto = [] as any;
                for (let item of _data["strankeDto"])
                    this.strankeDto!.push(StrankaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStrankeVm {
        data = typeof data === 'object' ? data : {};
        let result = new GetStrankeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.strankeDto)) {
            data["strankeDto"] = [];
            for (let item of this.strankeDto)
                data["strankeDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStrankeVm {
    strankeDto?: StrankaDto[] | undefined;
}

export class GetStrankeQuery implements IGetStrankeQuery {
    nazivPibMb?: string | undefined;
    includeAdresa?: boolean;
    includeKontakt?: boolean;
    includeTekuciRacuni?: boolean;
    includePravnoLice?: boolean;
    includeFizickoLice?: boolean;

    constructor(data?: IGetStrankeQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nazivPibMb = _data["nazivPibMb"];
            this.includeAdresa = _data["includeAdresa"];
            this.includeKontakt = _data["includeKontakt"];
            this.includeTekuciRacuni = _data["includeTekuciRacuni"];
            this.includePravnoLice = _data["includePravnoLice"];
            this.includeFizickoLice = _data["includeFizickoLice"];
        }
    }

    static fromJS(data: any): GetStrankeQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetStrankeQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nazivPibMb"] = this.nazivPibMb;
        data["includeAdresa"] = this.includeAdresa;
        data["includeKontakt"] = this.includeKontakt;
        data["includeTekuciRacuni"] = this.includeTekuciRacuni;
        data["includePravnoLice"] = this.includePravnoLice;
        data["includeFizickoLice"] = this.includeFizickoLice;
        return data;
    }
}

export interface IGetStrankeQuery {
    nazivPibMb?: string | undefined;
    includeAdresa?: boolean;
    includeKontakt?: boolean;
    includeTekuciRacuni?: boolean;
    includePravnoLice?: boolean;
    includeFizickoLice?: boolean;
}

export class ResultOfGetStrankaFilterMultiselectResponse extends Result implements IResultOfGetStrankaFilterMultiselectResponse {
    data?: GetStrankaFilterMultiselectResponse | undefined;

    constructor(data?: IResultOfGetStrankaFilterMultiselectResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetStrankaFilterMultiselectResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetStrankaFilterMultiselectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetStrankaFilterMultiselectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetStrankaFilterMultiselectResponse extends IResult {
    data?: GetStrankaFilterMultiselectResponse | undefined;
}

export class GetStrankaFilterMultiselectResponse implements IGetStrankaFilterMultiselectResponse {
    stranke?: StrankaMultiSelectItem[] | undefined;

    constructor(data?: IGetStrankaFilterMultiselectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stranke"])) {
                this.stranke = [] as any;
                for (let item of _data["stranke"])
                    this.stranke!.push(StrankaMultiSelectItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStrankaFilterMultiselectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStrankaFilterMultiselectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stranke)) {
            data["stranke"] = [];
            for (let item of this.stranke)
                data["stranke"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStrankaFilterMultiselectResponse {
    stranke?: StrankaMultiSelectItem[] | undefined;
}

export class GetStrankaFilterMultiselectQuery implements IGetStrankaFilterMultiselectQuery {
    searchValue?: string | undefined;

    constructor(data?: IGetStrankaFilterMultiselectQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchValue = _data["searchValue"];
        }
    }

    static fromJS(data: any): GetStrankaFilterMultiselectQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetStrankaFilterMultiselectQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchValue"] = this.searchValue;
        return data;
    }
}

export interface IGetStrankaFilterMultiselectQuery {
    searchValue?: string | undefined;
}

export class ResultOfStrankaInfoDto extends Result implements IResultOfStrankaInfoDto {
    data?: StrankaInfoDto | undefined;

    constructor(data?: IResultOfStrankaInfoDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? StrankaInfoDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfStrankaInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfStrankaInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfStrankaInfoDto extends IResult {
    data?: StrankaInfoDto | undefined;
}

export class StrankaInfoDto implements IStrankaInfoDto {
    id?: number;
    naziv?: string | undefined;
    adresa?: string | undefined;
    pib?: string | undefined;
    maticniBroj?: string | undefined;
    registracioniBroj?: string | undefined;
    jeKupac?: boolean;
    jeDobavljac?: boolean;
    jeStranoLice?: boolean;
    jeFizickoLice?: boolean;

    constructor(data?: IStrankaInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.adresa = _data["adresa"];
            this.pib = _data["pib"];
            this.maticniBroj = _data["maticniBroj"];
            this.registracioniBroj = _data["registracioniBroj"];
            this.jeKupac = _data["jeKupac"];
            this.jeDobavljac = _data["jeDobavljac"];
            this.jeStranoLice = _data["jeStranoLice"];
            this.jeFizickoLice = _data["jeFizickoLice"];
        }
    }

    static fromJS(data: any): StrankaInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new StrankaInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["adresa"] = this.adresa;
        data["pib"] = this.pib;
        data["maticniBroj"] = this.maticniBroj;
        data["registracioniBroj"] = this.registracioniBroj;
        data["jeKupac"] = this.jeKupac;
        data["jeDobavljac"] = this.jeDobavljac;
        data["jeStranoLice"] = this.jeStranoLice;
        data["jeFizickoLice"] = this.jeFizickoLice;
        return data;
    }
}

export interface IStrankaInfoDto {
    id?: number;
    naziv?: string | undefined;
    adresa?: string | undefined;
    pib?: string | undefined;
    maticniBroj?: string | undefined;
    registracioniBroj?: string | undefined;
    jeKupac?: boolean;
    jeDobavljac?: boolean;
    jeStranoLice?: boolean;
    jeFizickoLice?: boolean;
}

export class ResultOfListOfPravnoLiceDto extends Result implements IResultOfListOfPravnoLiceDto {
    data?: PravnoLiceDto[] | undefined;

    constructor(data?: IResultOfListOfPravnoLiceDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PravnoLiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfPravnoLiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfPravnoLiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfPravnoLiceDto extends IResult {
    data?: PravnoLiceDto[] | undefined;
}

export class ResultOfInformacijaIsporukeDto extends Result implements IResultOfInformacijaIsporukeDto {
    data?: InformacijaIsporukeDto | undefined;

    constructor(data?: IResultOfInformacijaIsporukeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? InformacijaIsporukeDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfInformacijaIsporukeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfInformacijaIsporukeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfInformacijaIsporukeDto extends IResult {
    data?: InformacijaIsporukeDto | undefined;
}

export class CreateInformacijaIsporukeCommand extends InformacijaIsporukeDto implements ICreateInformacijaIsporukeCommand {

    constructor(data?: ICreateInformacijaIsporukeCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateInformacijaIsporukeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInformacijaIsporukeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateInformacijaIsporukeCommand extends IInformacijaIsporukeDto {
}

export class ResultOfStrankaDto extends Result implements IResultOfStrankaDto {
    data?: StrankaDto | undefined;

    constructor(data?: IResultOfStrankaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? StrankaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfStrankaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfStrankaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfStrankaDto extends IResult {
    data?: StrankaDto | undefined;
}

export class UpdateInformacijaIsporukeCommand extends InformacijaIsporukeDto implements IUpdateInformacijaIsporukeCommand {

    constructor(data?: IUpdateInformacijaIsporukeCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateInformacijaIsporukeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInformacijaIsporukeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateInformacijaIsporukeCommand extends IInformacijaIsporukeDto {
}

export class CreateSupportAccessRequestCommand implements ICreateSupportAccessRequestCommand {
    targetTenantKey?: string | undefined;

    constructor(data?: ICreateSupportAccessRequestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetTenantKey = _data["targetTenantKey"];
        }
    }

    static fromJS(data: any): CreateSupportAccessRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSupportAccessRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantKey"] = this.targetTenantKey;
        return data;
    }
}

export interface ICreateSupportAccessRequestCommand {
    targetTenantKey?: string | undefined;
}

export class ResultOfGetTekuceRacuneResponse extends Result implements IResultOfGetTekuceRacuneResponse {
    data?: GetTekuceRacuneResponse | undefined;

    constructor(data?: IResultOfGetTekuceRacuneResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetTekuceRacuneResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetTekuceRacuneResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetTekuceRacuneResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetTekuceRacuneResponse extends IResult {
    data?: GetTekuceRacuneResponse | undefined;
}

export class GetTekuceRacuneResponse implements IGetTekuceRacuneResponse {
    tekuciRacunDtoList?: TekuciRacunDto[] | undefined;

    constructor(data?: IGetTekuceRacuneResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tekuciRacunDtoList"])) {
                this.tekuciRacunDtoList = [] as any;
                for (let item of _data["tekuciRacunDtoList"])
                    this.tekuciRacunDtoList!.push(TekuciRacunDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTekuceRacuneResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTekuceRacuneResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tekuciRacunDtoList)) {
            data["tekuciRacunDtoList"] = [];
            for (let item of this.tekuciRacunDtoList)
                data["tekuciRacunDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTekuceRacuneResponse {
    tekuciRacunDtoList?: TekuciRacunDto[] | undefined;
}

export class ResultOfGetTekuceRacuneDropdownResponse extends Result implements IResultOfGetTekuceRacuneDropdownResponse {
    data?: GetTekuceRacuneDropdownResponse | undefined;

    constructor(data?: IResultOfGetTekuceRacuneDropdownResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetTekuceRacuneDropdownResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetTekuceRacuneDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetTekuceRacuneDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetTekuceRacuneDropdownResponse extends IResult {
    data?: GetTekuceRacuneDropdownResponse | undefined;
}

export class GetTekuceRacuneDropdownResponse implements IGetTekuceRacuneDropdownResponse {
    tekuciRacunDropdownDtoList?: TekuciRacunDropdownDto[] | undefined;

    constructor(data?: IGetTekuceRacuneDropdownResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tekuciRacunDropdownDtoList"])) {
                this.tekuciRacunDropdownDtoList = [] as any;
                for (let item of _data["tekuciRacunDropdownDtoList"])
                    this.tekuciRacunDropdownDtoList!.push(TekuciRacunDropdownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTekuceRacuneDropdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTekuceRacuneDropdownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tekuciRacunDropdownDtoList)) {
            data["tekuciRacunDropdownDtoList"] = [];
            for (let item of this.tekuciRacunDropdownDtoList)
                data["tekuciRacunDropdownDtoList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTekuceRacuneDropdownResponse {
    tekuciRacunDropdownDtoList?: TekuciRacunDropdownDto[] | undefined;
}

export class TekuciRacunDropdownDto implements ITekuciRacunDropdownDto {
    id?: number | undefined;
    nazivBanke?: string | undefined;
    kodBanke?: number;
    ceoBrojRacuna?: string | undefined;
    isDefault?: boolean;
    isActive?: boolean;
    tipStranke?: TipStranke;
    strankaId?: number | undefined;
    tip?: TipTekucegRacuna;
    iban?: string | undefined;

    constructor(data?: ITekuciRacunDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nazivBanke = _data["nazivBanke"];
            this.kodBanke = _data["kodBanke"];
            this.ceoBrojRacuna = _data["ceoBrojRacuna"];
            this.isDefault = _data["isDefault"];
            this.isActive = _data["isActive"];
            this.tipStranke = _data["tipStranke"];
            this.strankaId = _data["strankaId"];
            this.tip = _data["tip"];
            this.iban = _data["iban"];
        }
    }

    static fromJS(data: any): TekuciRacunDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new TekuciRacunDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nazivBanke"] = this.nazivBanke;
        data["kodBanke"] = this.kodBanke;
        data["ceoBrojRacuna"] = this.ceoBrojRacuna;
        data["isDefault"] = this.isDefault;
        data["isActive"] = this.isActive;
        data["tipStranke"] = this.tipStranke;
        data["strankaId"] = this.strankaId;
        data["tip"] = this.tip;
        data["iban"] = this.iban;
        return data;
    }
}

export interface ITekuciRacunDropdownDto {
    id?: number | undefined;
    nazivBanke?: string | undefined;
    kodBanke?: number;
    ceoBrojRacuna?: string | undefined;
    isDefault?: boolean;
    isActive?: boolean;
    tipStranke?: TipStranke;
    strankaId?: number | undefined;
    tip?: TipTekucegRacuna;
    iban?: string | undefined;
}

export class ResultOfTekuciRacunDto extends Result implements IResultOfTekuciRacunDto {
    data?: TekuciRacunDto | undefined;

    constructor(data?: IResultOfTekuciRacunDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? TekuciRacunDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfTekuciRacunDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfTekuciRacunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfTekuciRacunDto extends IResult {
    data?: TekuciRacunDto | undefined;
}

export class CreateTekuciRacunCommand implements ICreateTekuciRacunCommand {
    id?: number | undefined;
    ceoBrojRacuna?: string | undefined;
    brojRacuna?: string | undefined;
    kontrolniBroj?: string | undefined;
    iban?: string | undefined;
    tip?: TipTekucegRacuna;
    bankaDto?: BankaDto | undefined;
    nazivBanke?: string | undefined;
    strankaId?: number | undefined;
    isDefault?: boolean;
    prikaziNaPdf?: boolean;
    isActive?: boolean;

    constructor(data?: ICreateTekuciRacunCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ceoBrojRacuna = _data["ceoBrojRacuna"];
            this.brojRacuna = _data["brojRacuna"];
            this.kontrolniBroj = _data["kontrolniBroj"];
            this.iban = _data["iban"];
            this.tip = _data["tip"];
            this.bankaDto = _data["bankaDto"] ? BankaDto.fromJS(_data["bankaDto"]) : <any>undefined;
            this.nazivBanke = _data["nazivBanke"];
            this.strankaId = _data["strankaId"];
            this.isDefault = _data["isDefault"];
            this.prikaziNaPdf = _data["prikaziNaPdf"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTekuciRacunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTekuciRacunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ceoBrojRacuna"] = this.ceoBrojRacuna;
        data["brojRacuna"] = this.brojRacuna;
        data["kontrolniBroj"] = this.kontrolniBroj;
        data["iban"] = this.iban;
        data["tip"] = this.tip;
        data["bankaDto"] = this.bankaDto ? this.bankaDto.toJSON() : <any>undefined;
        data["nazivBanke"] = this.nazivBanke;
        data["strankaId"] = this.strankaId;
        data["isDefault"] = this.isDefault;
        data["prikaziNaPdf"] = this.prikaziNaPdf;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateTekuciRacunCommand {
    id?: number | undefined;
    ceoBrojRacuna?: string | undefined;
    brojRacuna?: string | undefined;
    kontrolniBroj?: string | undefined;
    iban?: string | undefined;
    tip?: TipTekucegRacuna;
    bankaDto?: BankaDto | undefined;
    nazivBanke?: string | undefined;
    strankaId?: number | undefined;
    isDefault?: boolean;
    prikaziNaPdf?: boolean;
    isActive?: boolean;
}

export class UpdateTekuciRacunCommand implements IUpdateTekuciRacunCommand {
    id?: number | undefined;
    ceoBrojRacuna?: string | undefined;
    brojRacuna?: string | undefined;
    kontrolniBroj?: string | undefined;
    iban?: string | undefined;
    tip?: TipTekucegRacuna;
    bankaDto?: BankaDto | undefined;
    nazivBanke?: string | undefined;
    strankaId?: number | undefined;
    isDefault?: boolean;
    prikaziNaPdf?: boolean;
    isActive?: boolean;

    constructor(data?: IUpdateTekuciRacunCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ceoBrojRacuna = _data["ceoBrojRacuna"];
            this.brojRacuna = _data["brojRacuna"];
            this.kontrolniBroj = _data["kontrolniBroj"];
            this.iban = _data["iban"];
            this.tip = _data["tip"];
            this.bankaDto = _data["bankaDto"] ? BankaDto.fromJS(_data["bankaDto"]) : <any>undefined;
            this.nazivBanke = _data["nazivBanke"];
            this.strankaId = _data["strankaId"];
            this.isDefault = _data["isDefault"];
            this.prikaziNaPdf = _data["prikaziNaPdf"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateTekuciRacunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTekuciRacunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ceoBrojRacuna"] = this.ceoBrojRacuna;
        data["brojRacuna"] = this.brojRacuna;
        data["kontrolniBroj"] = this.kontrolniBroj;
        data["iban"] = this.iban;
        data["tip"] = this.tip;
        data["bankaDto"] = this.bankaDto ? this.bankaDto.toJSON() : <any>undefined;
        data["nazivBanke"] = this.nazivBanke;
        data["strankaId"] = this.strankaId;
        data["isDefault"] = this.isDefault;
        data["prikaziNaPdf"] = this.prikaziNaPdf;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateTekuciRacunCommand {
    id?: number | undefined;
    ceoBrojRacuna?: string | undefined;
    brojRacuna?: string | undefined;
    kontrolniBroj?: string | undefined;
    iban?: string | undefined;
    tip?: TipTekucegRacuna;
    bankaDto?: BankaDto | undefined;
    nazivBanke?: string | undefined;
    strankaId?: number | undefined;
    isDefault?: boolean;
    prikaziNaPdf?: boolean;
    isActive?: boolean;
}

export class CreateUlaznaFakturaCommand implements ICreateUlaznaFakturaCommand {
    brojFiskalnogIsecka?: string | undefined;
    racunDto?: RacunDto | undefined;
    informacijaIsporuke?: InformacijaIsporukeDto | undefined;
    vrstaFakture?: VrstaFakture;
    zavisniTroskoviStavkeDto?: ZavisniTrosakStavkaDto[] | undefined;

    constructor(data?: ICreateUlaznaFakturaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brojFiskalnogIsecka = _data["brojFiskalnogIsecka"];
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.informacijaIsporuke = _data["informacijaIsporuke"] ? InformacijaIsporukeDto.fromJS(_data["informacijaIsporuke"]) : <any>undefined;
            this.vrstaFakture = _data["vrstaFakture"];
            if (Array.isArray(_data["zavisniTroskoviStavkeDto"])) {
                this.zavisniTroskoviStavkeDto = [] as any;
                for (let item of _data["zavisniTroskoviStavkeDto"])
                    this.zavisniTroskoviStavkeDto!.push(ZavisniTrosakStavkaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUlaznaFakturaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUlaznaFakturaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brojFiskalnogIsecka"] = this.brojFiskalnogIsecka;
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["informacijaIsporuke"] = this.informacijaIsporuke ? this.informacijaIsporuke.toJSON() : <any>undefined;
        data["vrstaFakture"] = this.vrstaFakture;
        if (Array.isArray(this.zavisniTroskoviStavkeDto)) {
            data["zavisniTroskoviStavkeDto"] = [];
            for (let item of this.zavisniTroskoviStavkeDto)
                data["zavisniTroskoviStavkeDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateUlaznaFakturaCommand {
    brojFiskalnogIsecka?: string | undefined;
    racunDto?: RacunDto | undefined;
    informacijaIsporuke?: InformacijaIsporukeDto | undefined;
    vrstaFakture?: VrstaFakture;
    zavisniTroskoviStavkeDto?: ZavisniTrosakStavkaDto[] | undefined;
}

export class UpdateUlaznaFakturaCommand implements IUpdateUlaznaFakturaCommand {
    brojFiskalnogIsecka?: string | undefined;
    racunDto?: RacunDto | undefined;
    informacijaIsporuke?: InformacijaIsporukeDto | undefined;
    vrstaFakture?: VrstaFakture;
    zavisniTroskoviStavkeDto?: ZavisniTrosakStavkaDto[] | undefined;

    constructor(data?: IUpdateUlaznaFakturaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brojFiskalnogIsecka = _data["brojFiskalnogIsecka"];
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.informacijaIsporuke = _data["informacijaIsporuke"] ? InformacijaIsporukeDto.fromJS(_data["informacijaIsporuke"]) : <any>undefined;
            this.vrstaFakture = _data["vrstaFakture"];
            if (Array.isArray(_data["zavisniTroskoviStavkeDto"])) {
                this.zavisniTroskoviStavkeDto = [] as any;
                for (let item of _data["zavisniTroskoviStavkeDto"])
                    this.zavisniTroskoviStavkeDto!.push(ZavisniTrosakStavkaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateUlaznaFakturaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUlaznaFakturaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brojFiskalnogIsecka"] = this.brojFiskalnogIsecka;
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["informacijaIsporuke"] = this.informacijaIsporuke ? this.informacijaIsporuke.toJSON() : <any>undefined;
        data["vrstaFakture"] = this.vrstaFakture;
        if (Array.isArray(this.zavisniTroskoviStavkeDto)) {
            data["zavisniTroskoviStavkeDto"] = [];
            for (let item of this.zavisniTroskoviStavkeDto)
                data["zavisniTroskoviStavkeDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateUlaznaFakturaCommand {
    brojFiskalnogIsecka?: string | undefined;
    racunDto?: RacunDto | undefined;
    informacijaIsporuke?: InformacijaIsporukeDto | undefined;
    vrstaFakture?: VrstaFakture;
    zavisniTroskoviStavkeDto?: ZavisniTrosakStavkaDto[] | undefined;
}

export class ResultOfUlaznaFakturaDto extends Result implements IResultOfUlaznaFakturaDto {
    data?: UlaznaFakturaDto | undefined;

    constructor(data?: IResultOfUlaznaFakturaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? UlaznaFakturaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfUlaznaFakturaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfUlaznaFakturaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfUlaznaFakturaDto extends IResult {
    data?: UlaznaFakturaDto | undefined;
}

export class UlaznaFakturaDto implements IUlaznaFakturaDto {
    racunDto?: RacunDto | undefined;
    brojFiskalnogIsecka?: string | undefined;
    informacijaIsporuke?: InformacijaIsporukeDto | undefined;
    vrstaFakture?: VrstaFakture;
    zavisniTroskoviStavkeDto?: ZavisniTrosakStavkaDto[] | undefined;

    constructor(data?: IUlaznaFakturaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunDto = _data["racunDto"] ? RacunDto.fromJS(_data["racunDto"]) : <any>undefined;
            this.brojFiskalnogIsecka = _data["brojFiskalnogIsecka"];
            this.informacijaIsporuke = _data["informacijaIsporuke"] ? InformacijaIsporukeDto.fromJS(_data["informacijaIsporuke"]) : <any>undefined;
            this.vrstaFakture = _data["vrstaFakture"];
            if (Array.isArray(_data["zavisniTroskoviStavkeDto"])) {
                this.zavisniTroskoviStavkeDto = [] as any;
                for (let item of _data["zavisniTroskoviStavkeDto"])
                    this.zavisniTroskoviStavkeDto!.push(ZavisniTrosakStavkaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UlaznaFakturaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UlaznaFakturaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunDto"] = this.racunDto ? this.racunDto.toJSON() : <any>undefined;
        data["brojFiskalnogIsecka"] = this.brojFiskalnogIsecka;
        data["informacijaIsporuke"] = this.informacijaIsporuke ? this.informacijaIsporuke.toJSON() : <any>undefined;
        data["vrstaFakture"] = this.vrstaFakture;
        if (Array.isArray(this.zavisniTroskoviStavkeDto)) {
            data["zavisniTroskoviStavkeDto"] = [];
            for (let item of this.zavisniTroskoviStavkeDto)
                data["zavisniTroskoviStavkeDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUlaznaFakturaDto {
    racunDto?: RacunDto | undefined;
    brojFiskalnogIsecka?: string | undefined;
    informacijaIsporuke?: InformacijaIsporukeDto | undefined;
    vrstaFakture?: VrstaFakture;
    zavisniTroskoviStavkeDto?: ZavisniTrosakStavkaDto[] | undefined;
}

export class GetUlaznaFakturaQuery implements IGetUlaznaFakturaQuery {
    id?: number;

    constructor(data?: IGetUlaznaFakturaQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetUlaznaFakturaQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUlaznaFakturaQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetUlaznaFakturaQuery {
    id?: number;
}

export class GetNewUlaznaFakturaForIsplataQuery implements IGetNewUlaznaFakturaForIsplataQuery {
    strankaId?: number | undefined;
    isplataId?: number;
    datumPrometa?: Date | undefined;
    datumIzdavanja?: Date | undefined;

    constructor(data?: IGetNewUlaznaFakturaForIsplataQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.strankaId = _data["strankaId"];
            this.isplataId = _data["isplataId"];
            this.datumPrometa = _data["datumPrometa"] ? new Date(_data["datumPrometa"].toString()) : <any>undefined;
            this.datumIzdavanja = _data["datumIzdavanja"] ? new Date(_data["datumIzdavanja"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNewUlaznaFakturaForIsplataQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewUlaznaFakturaForIsplataQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["strankaId"] = this.strankaId;
        data["isplataId"] = this.isplataId;
        data["datumPrometa"] = this.datumPrometa ? this.datumPrometa.toISOString() : <any>undefined;
        data["datumIzdavanja"] = this.datumIzdavanja ? this.datumIzdavanja.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetNewUlaznaFakturaForIsplataQuery {
    strankaId?: number | undefined;
    isplataId?: number;
    datumPrometa?: Date | undefined;
    datumIzdavanja?: Date | undefined;
}

export class ResultOfGetKlasifikacijaRacunaDropdownResponses extends Result implements IResultOfGetKlasifikacijaRacunaDropdownResponses {
    data?: GetKlasifikacijaRacunaDropdownResponses | undefined;

    constructor(data?: IResultOfGetKlasifikacijaRacunaDropdownResponses) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetKlasifikacijaRacunaDropdownResponses.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetKlasifikacijaRacunaDropdownResponses {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetKlasifikacijaRacunaDropdownResponses();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetKlasifikacijaRacunaDropdownResponses extends IResult {
    data?: GetKlasifikacijaRacunaDropdownResponses | undefined;
}

export class GetKlasifikacijaRacunaDropdownResponses implements IGetKlasifikacijaRacunaDropdownResponses {
    responseList?: KlasifikacijaRacunaDto[] | undefined;

    constructor(data?: IGetKlasifikacijaRacunaDropdownResponses) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(KlasifikacijaRacunaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetKlasifikacijaRacunaDropdownResponses {
        data = typeof data === 'object' ? data : {};
        let result = new GetKlasifikacijaRacunaDropdownResponses();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetKlasifikacijaRacunaDropdownResponses {
    responseList?: KlasifikacijaRacunaDto[] | undefined;
}

export class KlasifikacijaRacunaDto implements IKlasifikacijaRacunaDto {
    klasifikacijaRacuna?: KlasifikacijaRacuna;
    klasifikacijaRacunaStr?: string | undefined;
    klasifikacijaRacunaBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IKlasifikacijaRacunaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.klasifikacijaRacuna = _data["klasifikacijaRacuna"];
            this.klasifikacijaRacunaStr = _data["klasifikacijaRacunaStr"];
            this.klasifikacijaRacunaBadgeStr = _data["klasifikacijaRacunaBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): KlasifikacijaRacunaDto {
        data = typeof data === 'object' ? data : {};
        let result = new KlasifikacijaRacunaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["klasifikacijaRacuna"] = this.klasifikacijaRacuna;
        data["klasifikacijaRacunaStr"] = this.klasifikacijaRacunaStr;
        data["klasifikacijaRacunaBadgeStr"] = this.klasifikacijaRacunaBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IKlasifikacijaRacunaDto {
    klasifikacijaRacuna?: KlasifikacijaRacuna;
    klasifikacijaRacunaStr?: string | undefined;
    klasifikacijaRacunaBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class ResultOfGetPravoNaPdvOdbitakDropdownResponses extends Result implements IResultOfGetPravoNaPdvOdbitakDropdownResponses {
    data?: GetPravoNaPdvOdbitakDropdownResponses | undefined;

    constructor(data?: IResultOfGetPravoNaPdvOdbitakDropdownResponses) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetPravoNaPdvOdbitakDropdownResponses.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetPravoNaPdvOdbitakDropdownResponses {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetPravoNaPdvOdbitakDropdownResponses();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetPravoNaPdvOdbitakDropdownResponses extends IResult {
    data?: GetPravoNaPdvOdbitakDropdownResponses | undefined;
}

export class GetPravoNaPdvOdbitakDropdownResponses implements IGetPravoNaPdvOdbitakDropdownResponses {
    responseList?: PravoNaPdvOdbitakDto[] | undefined;

    constructor(data?: IGetPravoNaPdvOdbitakDropdownResponses) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(PravoNaPdvOdbitakDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPravoNaPdvOdbitakDropdownResponses {
        data = typeof data === 'object' ? data : {};
        let result = new GetPravoNaPdvOdbitakDropdownResponses();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPravoNaPdvOdbitakDropdownResponses {
    responseList?: PravoNaPdvOdbitakDto[] | undefined;
}

export class PravoNaPdvOdbitakDto implements IPravoNaPdvOdbitakDto {
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak;
    pravoNaPdvOdbitakStr?: string | undefined;
    pravoNaPdvOdbitakBadgeStr?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IPravoNaPdvOdbitakDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pravoNaPdvOdbitak = _data["pravoNaPdvOdbitak"];
            this.pravoNaPdvOdbitakStr = _data["pravoNaPdvOdbitakStr"];
            this.pravoNaPdvOdbitakBadgeStr = _data["pravoNaPdvOdbitakBadgeStr"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): PravoNaPdvOdbitakDto {
        data = typeof data === 'object' ? data : {};
        let result = new PravoNaPdvOdbitakDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pravoNaPdvOdbitak"] = this.pravoNaPdvOdbitak;
        data["pravoNaPdvOdbitakStr"] = this.pravoNaPdvOdbitakStr;
        data["pravoNaPdvOdbitakBadgeStr"] = this.pravoNaPdvOdbitakBadgeStr;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IPravoNaPdvOdbitakDto {
    pravoNaPdvOdbitak?: PravoNaPdvOdbitak;
    pravoNaPdvOdbitakStr?: string | undefined;
    pravoNaPdvOdbitakBadgeStr?: string | undefined;
    opis?: string | undefined;
}

export class ResultOfIEnumerableOfZavisniTrosakUfResponse extends Result implements IResultOfIEnumerableOfZavisniTrosakUfResponse {
    data?: ZavisniTrosakUfResponse[] | undefined;

    constructor(data?: IResultOfIEnumerableOfZavisniTrosakUfResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ZavisniTrosakUfResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfIEnumerableOfZavisniTrosakUfResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfIEnumerableOfZavisniTrosakUfResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfIEnumerableOfZavisniTrosakUfResponse extends IResult {
    data?: ZavisniTrosakUfResponse[] | undefined;
}

export class ZavisniTrosakUfResponse implements IZavisniTrosakUfResponse {
    racunId?: number;
    broj?: string | undefined;
    originalniBroj?: string | undefined;
    dobavljac?: string | undefined;

    constructor(data?: IZavisniTrosakUfResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
            this.broj = _data["broj"];
            this.originalniBroj = _data["originalniBroj"];
            this.dobavljac = _data["dobavljac"];
        }
    }

    static fromJS(data: any): ZavisniTrosakUfResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ZavisniTrosakUfResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        data["broj"] = this.broj;
        data["originalniBroj"] = this.originalniBroj;
        data["dobavljac"] = this.dobavljac;
        return data;
    }
}

export interface IZavisniTrosakUfResponse {
    racunId?: number;
    broj?: string | undefined;
    originalniBroj?: string | undefined;
    dobavljac?: string | undefined;
}

export class ResultOfIEnumerableOfZavisniTrosakStavkaDto extends Result implements IResultOfIEnumerableOfZavisniTrosakStavkaDto {
    data?: ZavisniTrosakStavkaDto[] | undefined;

    constructor(data?: IResultOfIEnumerableOfZavisniTrosakStavkaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ZavisniTrosakStavkaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfIEnumerableOfZavisniTrosakStavkaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfIEnumerableOfZavisniTrosakStavkaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfIEnumerableOfZavisniTrosakStavkaDto extends IResult {
    data?: ZavisniTrosakStavkaDto[] | undefined;
}

export class GetStavkeForZavisneTroskoveQuery implements IGetStavkeForZavisneTroskoveQuery {
    racunId?: number;

    constructor(data?: IGetStavkeForZavisneTroskoveQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.racunId = _data["racunId"];
        }
    }

    static fromJS(data: any): GetStavkeForZavisneTroskoveQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetStavkeForZavisneTroskoveQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["racunId"] = this.racunId;
        return data;
    }
}

export interface IGetStavkeForZavisneTroskoveQuery {
    racunId?: number;
}

export class ResultOfUslugaDto extends Result implements IResultOfUslugaDto {
    data?: UslugaDto | undefined;

    constructor(data?: IResultOfUslugaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? UslugaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfUslugaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfUslugaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfUslugaDto extends IResult {
    data?: UslugaDto | undefined;
}

export class UslugaDto implements IUslugaDto {
    predmetStavkeDto?: PredmetStavkeDto | undefined;

    constructor(data?: IUslugaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predmetStavkeDto = _data["predmetStavkeDto"] ? PredmetStavkeDto.fromJS(_data["predmetStavkeDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UslugaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UslugaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predmetStavkeDto"] = this.predmetStavkeDto ? this.predmetStavkeDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUslugaDto {
    predmetStavkeDto?: PredmetStavkeDto | undefined;
}

export class ResultOfGetTableResponseOfUslugaTableDto extends Result implements IResultOfGetTableResponseOfUslugaTableDto {
    data?: GetTableResponseOfUslugaTableDto | undefined;

    constructor(data?: IResultOfGetTableResponseOfUslugaTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetTableResponseOfUslugaTableDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetTableResponseOfUslugaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetTableResponseOfUslugaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetTableResponseOfUslugaTableDto extends IResult {
    data?: GetTableResponseOfUslugaTableDto | undefined;
}

export class GetTableResponseOfUslugaTableDto implements IGetTableResponseOfUslugaTableDto {
    responseList?: UslugaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;

    constructor(data?: IGetTableResponseOfUslugaTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(UslugaTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTableResponseOfUslugaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTableResponseOfUslugaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTableResponseOfUslugaTableDto {
    responseList?: UslugaTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
}

export class UslugaTableDto extends PredmetStavkeTableDto implements IUslugaTableDto {

    constructor(data?: IUslugaTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UslugaTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new UslugaTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUslugaTableDto extends IPredmetStavkeTableDto {
}

export class GetUslugaTableQuery implements IGetUslugaTableQuery {
    naziv?: string | undefined;
    sifra?: string | undefined;
    includeTipovePredmeta?: TipPredmeta[] | undefined;

    constructor(data?: IGetUslugaTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.sifra = _data["sifra"];
            if (Array.isArray(_data["includeTipovePredmeta"])) {
                this.includeTipovePredmeta = [] as any;
                for (let item of _data["includeTipovePredmeta"])
                    this.includeTipovePredmeta!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUslugaTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUslugaTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["sifra"] = this.sifra;
        if (Array.isArray(this.includeTipovePredmeta)) {
            data["includeTipovePredmeta"] = [];
            for (let item of this.includeTipovePredmeta)
                data["includeTipovePredmeta"].push(item);
        }
        return data;
    }
}

export interface IGetUslugaTableQuery {
    naziv?: string | undefined;
    sifra?: string | undefined;
    includeTipovePredmeta?: TipPredmeta[] | undefined;
}

export class ResultOfUslugaCommandResponse extends Result implements IResultOfUslugaCommandResponse {
    data?: UslugaCommandResponse | undefined;

    constructor(data?: IResultOfUslugaCommandResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? UslugaCommandResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfUslugaCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfUslugaCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfUslugaCommandResponse extends IResult {
    data?: UslugaCommandResponse | undefined;
}

export class UslugaCommandResponse implements IUslugaCommandResponse {
    uslugaDto?: UslugaDto | undefined;
    uslugaTableDto?: UslugaTableDto | undefined;

    constructor(data?: IUslugaCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uslugaDto = _data["uslugaDto"] ? UslugaDto.fromJS(_data["uslugaDto"]) : <any>undefined;
            this.uslugaTableDto = _data["uslugaTableDto"] ? UslugaTableDto.fromJS(_data["uslugaTableDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UslugaCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UslugaCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uslugaDto"] = this.uslugaDto ? this.uslugaDto.toJSON() : <any>undefined;
        data["uslugaTableDto"] = this.uslugaTableDto ? this.uslugaTableDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUslugaCommandResponse {
    uslugaDto?: UslugaDto | undefined;
    uslugaTableDto?: UslugaTableDto | undefined;
}

export class CreateUslugaCommand extends UslugaDto implements ICreateUslugaCommand {

    constructor(data?: ICreateUslugaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateUslugaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUslugaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateUslugaCommand extends IUslugaDto {
}

export class ResultOfListOfImportUslugaDto extends Result implements IResultOfListOfImportUslugaDto {
    data?: ImportUslugaDto[] | undefined;

    constructor(data?: IResultOfListOfImportUslugaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ImportUslugaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfImportUslugaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfImportUslugaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfImportUslugaDto extends IResult {
    data?: ImportUslugaDto[] | undefined;
}

export class ImportUslugaDto implements IImportUslugaDto {
    id?: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    jedinicaMere?: string | undefined;
    pdv?: number | undefined;
    vrednost?: number | undefined;
    greska?: string | undefined;

    constructor(data?: IImportUslugaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.jedinicaMere = _data["jedinicaMere"];
            this.pdv = _data["pdv"];
            this.vrednost = _data["vrednost"];
            this.greska = _data["greska"];
        }
    }

    static fromJS(data: any): ImportUslugaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportUslugaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["jedinicaMere"] = this.jedinicaMere;
        data["pdv"] = this.pdv;
        data["vrednost"] = this.vrednost;
        data["greska"] = this.greska;
        return data;
    }
}

export interface IImportUslugaDto {
    id?: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    jedinicaMere?: string | undefined;
    pdv?: number | undefined;
    vrednost?: number | undefined;
    greska?: string | undefined;
}

export class UpdateUslugaCommand extends UslugaDto implements IUpdateUslugaCommand {

    constructor(data?: IUpdateUslugaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateUslugaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUslugaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateUslugaCommand extends IUslugaDto {
}

export class ResultOfGetTableResponseOfVoziloTableDto extends Result implements IResultOfGetTableResponseOfVoziloTableDto {
    data?: GetTableResponseOfVoziloTableDto | undefined;

    constructor(data?: IResultOfGetTableResponseOfVoziloTableDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetTableResponseOfVoziloTableDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetTableResponseOfVoziloTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetTableResponseOfVoziloTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetTableResponseOfVoziloTableDto extends IResult {
    data?: GetTableResponseOfVoziloTableDto | undefined;
}

export class GetTableResponseOfVoziloTableDto implements IGetTableResponseOfVoziloTableDto {
    responseList?: VoziloTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;

    constructor(data?: IGetTableResponseOfVoziloTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseList"])) {
                this.responseList = [] as any;
                for (let item of _data["responseList"])
                    this.responseList!.push(VoziloTableDto.fromJS(item));
            }
            if (Array.isArray(_data["activeFilters"])) {
                this.activeFilters = [] as any;
                for (let item of _data["activeFilters"])
                    this.activeFilters!.push(FilterChipDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTableResponseOfVoziloTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTableResponseOfVoziloTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseList)) {
            data["responseList"] = [];
            for (let item of this.responseList)
                data["responseList"].push(item.toJSON());
        }
        if (Array.isArray(this.activeFilters)) {
            data["activeFilters"] = [];
            for (let item of this.activeFilters)
                data["activeFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTableResponseOfVoziloTableDto {
    responseList?: VoziloTableDto[] | undefined;
    activeFilters?: FilterChipDto[] | undefined;
}

export class VoziloTableDto implements IVoziloTableDto {
    id?: number;
    markaIModel?: string | undefined;
    marka?: string | undefined;
    model?: string | undefined;
    tip?: string | undefined;
    registarskaOznaka?: string | undefined;
    brojSasije?: string | undefined;

    constructor(data?: IVoziloTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.markaIModel = _data["markaIModel"];
            this.marka = _data["marka"];
            this.model = _data["model"];
            this.tip = _data["tip"];
            this.registarskaOznaka = _data["registarskaOznaka"];
            this.brojSasije = _data["brojSasije"];
        }
    }

    static fromJS(data: any): VoziloTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoziloTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["markaIModel"] = this.markaIModel;
        data["marka"] = this.marka;
        data["model"] = this.model;
        data["tip"] = this.tip;
        data["registarskaOznaka"] = this.registarskaOznaka;
        data["brojSasije"] = this.brojSasije;
        return data;
    }
}

export interface IVoziloTableDto {
    id?: number;
    markaIModel?: string | undefined;
    marka?: string | undefined;
    model?: string | undefined;
    tip?: string | undefined;
    registarskaOznaka?: string | undefined;
    brojSasije?: string | undefined;
}

export class GetVozilaTableQuery implements IGetVozilaTableQuery {
    voziloTip?: VoziloTipDto | undefined;
    voziloMarka?: VoziloMarkaDto | undefined;
    model?: VoziloModelDto | undefined;
    naziv?: string | undefined;
    sifra?: string | undefined;
    includeTipovePredmeta?: TipPredmeta[] | undefined;

    constructor(data?: IGetVozilaTableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voziloTip = _data["voziloTip"] ? VoziloTipDto.fromJS(_data["voziloTip"]) : <any>undefined;
            this.voziloMarka = _data["voziloMarka"] ? VoziloMarkaDto.fromJS(_data["voziloMarka"]) : <any>undefined;
            this.model = _data["model"] ? VoziloModelDto.fromJS(_data["model"]) : <any>undefined;
            this.naziv = _data["naziv"];
            this.sifra = _data["sifra"];
            if (Array.isArray(_data["includeTipovePredmeta"])) {
                this.includeTipovePredmeta = [] as any;
                for (let item of _data["includeTipovePredmeta"])
                    this.includeTipovePredmeta!.push(item);
            }
        }
    }

    static fromJS(data: any): GetVozilaTableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetVozilaTableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voziloTip"] = this.voziloTip ? this.voziloTip.toJSON() : <any>undefined;
        data["voziloMarka"] = this.voziloMarka ? this.voziloMarka.toJSON() : <any>undefined;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        data["naziv"] = this.naziv;
        data["sifra"] = this.sifra;
        if (Array.isArray(this.includeTipovePredmeta)) {
            data["includeTipovePredmeta"] = [];
            for (let item of this.includeTipovePredmeta)
                data["includeTipovePredmeta"].push(item);
        }
        return data;
    }
}

export interface IGetVozilaTableQuery {
    voziloTip?: VoziloTipDto | undefined;
    voziloMarka?: VoziloMarkaDto | undefined;
    model?: VoziloModelDto | undefined;
    naziv?: string | undefined;
    sifra?: string | undefined;
    includeTipovePredmeta?: TipPredmeta[] | undefined;
}

export class VoziloTipDto implements IVoziloTipDto {
    id?: number | undefined;
    naziv?: string | undefined;

    constructor(data?: IVoziloTipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): VoziloTipDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoziloTipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IVoziloTipDto {
    id?: number | undefined;
    naziv?: string | undefined;
}

export class VoziloMarkaDto implements IVoziloMarkaDto {
    id?: number | undefined;
    naziv?: string | undefined;

    constructor(data?: IVoziloMarkaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): VoziloMarkaDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoziloMarkaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IVoziloMarkaDto {
    id?: number | undefined;
    naziv?: string | undefined;
}

export class VoziloModelDto implements IVoziloModelDto {
    id?: number | undefined;
    naziv?: string | undefined;

    constructor(data?: IVoziloModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): VoziloModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoziloModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IVoziloModelDto {
    id?: number | undefined;
    naziv?: string | undefined;
}

export class ResultOfListOfVoziloDropdownDto extends Result implements IResultOfListOfVoziloDropdownDto {
    data?: VoziloDropdownDto[] | undefined;

    constructor(data?: IResultOfListOfVoziloDropdownDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(VoziloDropdownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfVoziloDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfVoziloDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfVoziloDropdownDto extends IResult {
    data?: VoziloDropdownDto[] | undefined;
}

export class ResultOfVoziloDto extends Result implements IResultOfVoziloDto {
    data?: VoziloDto | undefined;

    constructor(data?: IResultOfVoziloDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? VoziloDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfVoziloDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfVoziloDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfVoziloDto extends IResult {
    data?: VoziloDto | undefined;
}

export class VoziloDto implements IVoziloDto {
    predmetStavkeDto?: PredmetStavkeDto | undefined;
    drzavaIzdavanja?: string | undefined;
    organIzdavanja?: string | undefined;
    upravaIzdavanja?: string | undefined;
    brojSaobracajne?: string | undefined;
    datumIzdavanja?: Date | undefined;
    datumIsteka?: Date | undefined;
    serijskiBroj?: string | undefined;
    datumPrveRegistracije?: Date | undefined;
    godinaProizvodnje?: number | undefined;
    brojSasije?: string | undefined;
    registarskaOznaka?: string | undefined;
    brojKilovata?: number | undefined;
    brojKubika?: number | undefined;
    vrstaGoriva?: VrstaGoriva;
    odnosSnageITezine?: number | undefined;
    tezina?: number | undefined;
    maksimalnaDozvoljenaTezina?: number | undefined;
    brojMestaZaSedenje?: number | undefined;
    brojMestaZaStajanje?: number | undefined;
    brojMotora?: string | undefined;
    brojOsovina?: number | undefined;
    boja?: string | undefined;
    datumZabraneOtudjenja?: Date | undefined;
    nosivost?: number | undefined;
    maticniBrojIliJMBGVlasnika?: string | undefined;
    prezimeIliPoslovnoImeVlasnika?: string | undefined;
    imeVlasnika?: string | undefined;
    adresaVlasnika?: string | undefined;
    maticniBrojIliJMBGKorisnika?: string | undefined;
    prezimeIliPoslovnoImeKorisnika?: string | undefined;
    imeKorisnika?: string | undefined;
    adresaKorisnika?: string | undefined;
    trenutnaKilometraza?: number | undefined;
    datumIstekaRegistracije?: Date | undefined;
    voziloTipDto?: VoziloTipDto | undefined;
    voziloMarkaDto?: VoziloMarkaDto | undefined;
    modelDto?: VoziloModelDto | undefined;

    constructor(data?: IVoziloDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predmetStavkeDto = _data["predmetStavkeDto"] ? PredmetStavkeDto.fromJS(_data["predmetStavkeDto"]) : <any>undefined;
            this.drzavaIzdavanja = _data["drzavaIzdavanja"];
            this.organIzdavanja = _data["organIzdavanja"];
            this.upravaIzdavanja = _data["upravaIzdavanja"];
            this.brojSaobracajne = _data["brojSaobracajne"];
            this.datumIzdavanja = _data["datumIzdavanja"] ? new Date(_data["datumIzdavanja"].toString()) : <any>undefined;
            this.datumIsteka = _data["datumIsteka"] ? new Date(_data["datumIsteka"].toString()) : <any>undefined;
            this.serijskiBroj = _data["serijskiBroj"];
            this.datumPrveRegistracije = _data["datumPrveRegistracije"] ? new Date(_data["datumPrveRegistracije"].toString()) : <any>undefined;
            this.godinaProizvodnje = _data["godinaProizvodnje"];
            this.brojSasije = _data["brojSasije"];
            this.registarskaOznaka = _data["registarskaOznaka"];
            this.brojKilovata = _data["brojKilovata"];
            this.brojKubika = _data["brojKubika"];
            this.vrstaGoriva = _data["vrstaGoriva"];
            this.odnosSnageITezine = _data["odnosSnageITezine"];
            this.tezina = _data["tezina"];
            this.maksimalnaDozvoljenaTezina = _data["maksimalnaDozvoljenaTezina"];
            this.brojMestaZaSedenje = _data["brojMestaZaSedenje"];
            this.brojMestaZaStajanje = _data["brojMestaZaStajanje"];
            this.brojMotora = _data["brojMotora"];
            this.brojOsovina = _data["brojOsovina"];
            this.boja = _data["boja"];
            this.datumZabraneOtudjenja = _data["datumZabraneOtudjenja"] ? new Date(_data["datumZabraneOtudjenja"].toString()) : <any>undefined;
            this.nosivost = _data["nosivost"];
            this.maticniBrojIliJMBGVlasnika = _data["maticniBrojIliJMBGVlasnika"];
            this.prezimeIliPoslovnoImeVlasnika = _data["prezimeIliPoslovnoImeVlasnika"];
            this.imeVlasnika = _data["imeVlasnika"];
            this.adresaVlasnika = _data["adresaVlasnika"];
            this.maticniBrojIliJMBGKorisnika = _data["maticniBrojIliJMBGKorisnika"];
            this.prezimeIliPoslovnoImeKorisnika = _data["prezimeIliPoslovnoImeKorisnika"];
            this.imeKorisnika = _data["imeKorisnika"];
            this.adresaKorisnika = _data["adresaKorisnika"];
            this.trenutnaKilometraza = _data["trenutnaKilometraza"];
            this.datumIstekaRegistracije = _data["datumIstekaRegistracije"] ? new Date(_data["datumIstekaRegistracije"].toString()) : <any>undefined;
            this.voziloTipDto = _data["voziloTipDto"] ? VoziloTipDto.fromJS(_data["voziloTipDto"]) : <any>undefined;
            this.voziloMarkaDto = _data["voziloMarkaDto"] ? VoziloMarkaDto.fromJS(_data["voziloMarkaDto"]) : <any>undefined;
            this.modelDto = _data["modelDto"] ? VoziloModelDto.fromJS(_data["modelDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VoziloDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoziloDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predmetStavkeDto"] = this.predmetStavkeDto ? this.predmetStavkeDto.toJSON() : <any>undefined;
        data["drzavaIzdavanja"] = this.drzavaIzdavanja;
        data["organIzdavanja"] = this.organIzdavanja;
        data["upravaIzdavanja"] = this.upravaIzdavanja;
        data["brojSaobracajne"] = this.brojSaobracajne;
        data["datumIzdavanja"] = this.datumIzdavanja ? this.datumIzdavanja.toISOString() : <any>undefined;
        data["datumIsteka"] = this.datumIsteka ? this.datumIsteka.toISOString() : <any>undefined;
        data["serijskiBroj"] = this.serijskiBroj;
        data["datumPrveRegistracije"] = this.datumPrveRegistracije ? this.datumPrveRegistracije.toISOString() : <any>undefined;
        data["godinaProizvodnje"] = this.godinaProizvodnje;
        data["brojSasije"] = this.brojSasije;
        data["registarskaOznaka"] = this.registarskaOznaka;
        data["brojKilovata"] = this.brojKilovata;
        data["brojKubika"] = this.brojKubika;
        data["vrstaGoriva"] = this.vrstaGoriva;
        data["odnosSnageITezine"] = this.odnosSnageITezine;
        data["tezina"] = this.tezina;
        data["maksimalnaDozvoljenaTezina"] = this.maksimalnaDozvoljenaTezina;
        data["brojMestaZaSedenje"] = this.brojMestaZaSedenje;
        data["brojMestaZaStajanje"] = this.brojMestaZaStajanje;
        data["brojMotora"] = this.brojMotora;
        data["brojOsovina"] = this.brojOsovina;
        data["boja"] = this.boja;
        data["datumZabraneOtudjenja"] = this.datumZabraneOtudjenja ? this.datumZabraneOtudjenja.toISOString() : <any>undefined;
        data["nosivost"] = this.nosivost;
        data["maticniBrojIliJMBGVlasnika"] = this.maticniBrojIliJMBGVlasnika;
        data["prezimeIliPoslovnoImeVlasnika"] = this.prezimeIliPoslovnoImeVlasnika;
        data["imeVlasnika"] = this.imeVlasnika;
        data["adresaVlasnika"] = this.adresaVlasnika;
        data["maticniBrojIliJMBGKorisnika"] = this.maticniBrojIliJMBGKorisnika;
        data["prezimeIliPoslovnoImeKorisnika"] = this.prezimeIliPoslovnoImeKorisnika;
        data["imeKorisnika"] = this.imeKorisnika;
        data["adresaKorisnika"] = this.adresaKorisnika;
        data["trenutnaKilometraza"] = this.trenutnaKilometraza;
        data["datumIstekaRegistracije"] = this.datumIstekaRegistracije ? this.datumIstekaRegistracije.toISOString() : <any>undefined;
        data["voziloTipDto"] = this.voziloTipDto ? this.voziloTipDto.toJSON() : <any>undefined;
        data["voziloMarkaDto"] = this.voziloMarkaDto ? this.voziloMarkaDto.toJSON() : <any>undefined;
        data["modelDto"] = this.modelDto ? this.modelDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVoziloDto {
    predmetStavkeDto?: PredmetStavkeDto | undefined;
    drzavaIzdavanja?: string | undefined;
    organIzdavanja?: string | undefined;
    upravaIzdavanja?: string | undefined;
    brojSaobracajne?: string | undefined;
    datumIzdavanja?: Date | undefined;
    datumIsteka?: Date | undefined;
    serijskiBroj?: string | undefined;
    datumPrveRegistracije?: Date | undefined;
    godinaProizvodnje?: number | undefined;
    brojSasije?: string | undefined;
    registarskaOznaka?: string | undefined;
    brojKilovata?: number | undefined;
    brojKubika?: number | undefined;
    vrstaGoriva?: VrstaGoriva;
    odnosSnageITezine?: number | undefined;
    tezina?: number | undefined;
    maksimalnaDozvoljenaTezina?: number | undefined;
    brojMestaZaSedenje?: number | undefined;
    brojMestaZaStajanje?: number | undefined;
    brojMotora?: string | undefined;
    brojOsovina?: number | undefined;
    boja?: string | undefined;
    datumZabraneOtudjenja?: Date | undefined;
    nosivost?: number | undefined;
    maticniBrojIliJMBGVlasnika?: string | undefined;
    prezimeIliPoslovnoImeVlasnika?: string | undefined;
    imeVlasnika?: string | undefined;
    adresaVlasnika?: string | undefined;
    maticniBrojIliJMBGKorisnika?: string | undefined;
    prezimeIliPoslovnoImeKorisnika?: string | undefined;
    imeKorisnika?: string | undefined;
    adresaKorisnika?: string | undefined;
    trenutnaKilometraza?: number | undefined;
    datumIstekaRegistracije?: Date | undefined;
    voziloTipDto?: VoziloTipDto | undefined;
    voziloMarkaDto?: VoziloMarkaDto | undefined;
    modelDto?: VoziloModelDto | undefined;
}

export class ResultOfVoziloCommandResponse extends Result implements IResultOfVoziloCommandResponse {
    data?: VoziloCommandResponse | undefined;

    constructor(data?: IResultOfVoziloCommandResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? VoziloCommandResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfVoziloCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfVoziloCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfVoziloCommandResponse extends IResult {
    data?: VoziloCommandResponse | undefined;
}

export class VoziloCommandResponse implements IVoziloCommandResponse {
    voziloDto?: VoziloDto | undefined;
    voziloTableDto?: VoziloTableDto | undefined;

    constructor(data?: IVoziloCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voziloDto = _data["voziloDto"] ? VoziloDto.fromJS(_data["voziloDto"]) : <any>undefined;
            this.voziloTableDto = _data["voziloTableDto"] ? VoziloTableDto.fromJS(_data["voziloTableDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VoziloCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VoziloCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voziloDto"] = this.voziloDto ? this.voziloDto.toJSON() : <any>undefined;
        data["voziloTableDto"] = this.voziloTableDto ? this.voziloTableDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVoziloCommandResponse {
    voziloDto?: VoziloDto | undefined;
    voziloTableDto?: VoziloTableDto | undefined;
}

export class CreateVoziloCommand implements ICreateVoziloCommand {
    predmetStavkeDto?: PredmetStavkeDto | undefined;
    drzavaIzdavanja?: string | undefined;
    organIzdavanja?: string | undefined;
    upravaIzdavanja?: string | undefined;
    brojSaobracajne?: string | undefined;
    datumIzdavanja?: Date | undefined;
    datumIsteka?: Date | undefined;
    serijskiBroj?: string | undefined;
    datumPrveRegistracije?: Date | undefined;
    godinaProizvodnje?: number | undefined;
    brojSasije?: string | undefined;
    registarskaOznaka?: string | undefined;
    brojKilovata?: number | undefined;
    brojKubika?: number | undefined;
    vrstaGoriva?: VrstaGoriva;
    odnosSnageITezine?: number | undefined;
    tezina?: number | undefined;
    maksimalnaDozvoljenaTezina?: number | undefined;
    brojMestaZaSedenje?: number | undefined;
    brojMestaZaStajanje?: number | undefined;
    brojMotora?: string | undefined;
    brojOsovina?: number | undefined;
    boja?: string | undefined;
    datumZabraneOtudjenja?: Date | undefined;
    nosivost?: number | undefined;
    maticniBrojIliJMBGVlasnika?: string | undefined;
    prezimeIliPoslovnoImeVlasnika?: string | undefined;
    imeVlasnika?: string | undefined;
    adresaVlasnika?: string | undefined;
    maticniBrojIliJMBGKorisnika?: string | undefined;
    prezimeIliPoslovnoImeKorisnika?: string | undefined;
    imeKorisnika?: string | undefined;
    adresaKorisnika?: string | undefined;
    trenutnaKilometraza?: number | undefined;
    datumIstekaRegistracije?: Date | undefined;
    voziloTipDto?: VoziloTipDto | undefined;
    voziloMarkaDto?: VoziloMarkaDto | undefined;
    modelDto?: VoziloModelDto | undefined;

    constructor(data?: ICreateVoziloCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predmetStavkeDto = _data["predmetStavkeDto"] ? PredmetStavkeDto.fromJS(_data["predmetStavkeDto"]) : <any>undefined;
            this.drzavaIzdavanja = _data["drzavaIzdavanja"];
            this.organIzdavanja = _data["organIzdavanja"];
            this.upravaIzdavanja = _data["upravaIzdavanja"];
            this.brojSaobracajne = _data["brojSaobracajne"];
            this.datumIzdavanja = _data["datumIzdavanja"] ? new Date(_data["datumIzdavanja"].toString()) : <any>undefined;
            this.datumIsteka = _data["datumIsteka"] ? new Date(_data["datumIsteka"].toString()) : <any>undefined;
            this.serijskiBroj = _data["serijskiBroj"];
            this.datumPrveRegistracije = _data["datumPrveRegistracije"] ? new Date(_data["datumPrveRegistracije"].toString()) : <any>undefined;
            this.godinaProizvodnje = _data["godinaProizvodnje"];
            this.brojSasije = _data["brojSasije"];
            this.registarskaOznaka = _data["registarskaOznaka"];
            this.brojKilovata = _data["brojKilovata"];
            this.brojKubika = _data["brojKubika"];
            this.vrstaGoriva = _data["vrstaGoriva"];
            this.odnosSnageITezine = _data["odnosSnageITezine"];
            this.tezina = _data["tezina"];
            this.maksimalnaDozvoljenaTezina = _data["maksimalnaDozvoljenaTezina"];
            this.brojMestaZaSedenje = _data["brojMestaZaSedenje"];
            this.brojMestaZaStajanje = _data["brojMestaZaStajanje"];
            this.brojMotora = _data["brojMotora"];
            this.brojOsovina = _data["brojOsovina"];
            this.boja = _data["boja"];
            this.datumZabraneOtudjenja = _data["datumZabraneOtudjenja"] ? new Date(_data["datumZabraneOtudjenja"].toString()) : <any>undefined;
            this.nosivost = _data["nosivost"];
            this.maticniBrojIliJMBGVlasnika = _data["maticniBrojIliJMBGVlasnika"];
            this.prezimeIliPoslovnoImeVlasnika = _data["prezimeIliPoslovnoImeVlasnika"];
            this.imeVlasnika = _data["imeVlasnika"];
            this.adresaVlasnika = _data["adresaVlasnika"];
            this.maticniBrojIliJMBGKorisnika = _data["maticniBrojIliJMBGKorisnika"];
            this.prezimeIliPoslovnoImeKorisnika = _data["prezimeIliPoslovnoImeKorisnika"];
            this.imeKorisnika = _data["imeKorisnika"];
            this.adresaKorisnika = _data["adresaKorisnika"];
            this.trenutnaKilometraza = _data["trenutnaKilometraza"];
            this.datumIstekaRegistracije = _data["datumIstekaRegistracije"] ? new Date(_data["datumIstekaRegistracije"].toString()) : <any>undefined;
            this.voziloTipDto = _data["voziloTipDto"] ? VoziloTipDto.fromJS(_data["voziloTipDto"]) : <any>undefined;
            this.voziloMarkaDto = _data["voziloMarkaDto"] ? VoziloMarkaDto.fromJS(_data["voziloMarkaDto"]) : <any>undefined;
            this.modelDto = _data["modelDto"] ? VoziloModelDto.fromJS(_data["modelDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateVoziloCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVoziloCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predmetStavkeDto"] = this.predmetStavkeDto ? this.predmetStavkeDto.toJSON() : <any>undefined;
        data["drzavaIzdavanja"] = this.drzavaIzdavanja;
        data["organIzdavanja"] = this.organIzdavanja;
        data["upravaIzdavanja"] = this.upravaIzdavanja;
        data["brojSaobracajne"] = this.brojSaobracajne;
        data["datumIzdavanja"] = this.datumIzdavanja ? this.datumIzdavanja.toISOString() : <any>undefined;
        data["datumIsteka"] = this.datumIsteka ? this.datumIsteka.toISOString() : <any>undefined;
        data["serijskiBroj"] = this.serijskiBroj;
        data["datumPrveRegistracije"] = this.datumPrveRegistracije ? this.datumPrveRegistracije.toISOString() : <any>undefined;
        data["godinaProizvodnje"] = this.godinaProizvodnje;
        data["brojSasije"] = this.brojSasije;
        data["registarskaOznaka"] = this.registarskaOznaka;
        data["brojKilovata"] = this.brojKilovata;
        data["brojKubika"] = this.brojKubika;
        data["vrstaGoriva"] = this.vrstaGoriva;
        data["odnosSnageITezine"] = this.odnosSnageITezine;
        data["tezina"] = this.tezina;
        data["maksimalnaDozvoljenaTezina"] = this.maksimalnaDozvoljenaTezina;
        data["brojMestaZaSedenje"] = this.brojMestaZaSedenje;
        data["brojMestaZaStajanje"] = this.brojMestaZaStajanje;
        data["brojMotora"] = this.brojMotora;
        data["brojOsovina"] = this.brojOsovina;
        data["boja"] = this.boja;
        data["datumZabraneOtudjenja"] = this.datumZabraneOtudjenja ? this.datumZabraneOtudjenja.toISOString() : <any>undefined;
        data["nosivost"] = this.nosivost;
        data["maticniBrojIliJMBGVlasnika"] = this.maticniBrojIliJMBGVlasnika;
        data["prezimeIliPoslovnoImeVlasnika"] = this.prezimeIliPoslovnoImeVlasnika;
        data["imeVlasnika"] = this.imeVlasnika;
        data["adresaVlasnika"] = this.adresaVlasnika;
        data["maticniBrojIliJMBGKorisnika"] = this.maticniBrojIliJMBGKorisnika;
        data["prezimeIliPoslovnoImeKorisnika"] = this.prezimeIliPoslovnoImeKorisnika;
        data["imeKorisnika"] = this.imeKorisnika;
        data["adresaKorisnika"] = this.adresaKorisnika;
        data["trenutnaKilometraza"] = this.trenutnaKilometraza;
        data["datumIstekaRegistracije"] = this.datumIstekaRegistracije ? this.datumIstekaRegistracije.toISOString() : <any>undefined;
        data["voziloTipDto"] = this.voziloTipDto ? this.voziloTipDto.toJSON() : <any>undefined;
        data["voziloMarkaDto"] = this.voziloMarkaDto ? this.voziloMarkaDto.toJSON() : <any>undefined;
        data["modelDto"] = this.modelDto ? this.modelDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateVoziloCommand {
    predmetStavkeDto?: PredmetStavkeDto | undefined;
    drzavaIzdavanja?: string | undefined;
    organIzdavanja?: string | undefined;
    upravaIzdavanja?: string | undefined;
    brojSaobracajne?: string | undefined;
    datumIzdavanja?: Date | undefined;
    datumIsteka?: Date | undefined;
    serijskiBroj?: string | undefined;
    datumPrveRegistracije?: Date | undefined;
    godinaProizvodnje?: number | undefined;
    brojSasije?: string | undefined;
    registarskaOznaka?: string | undefined;
    brojKilovata?: number | undefined;
    brojKubika?: number | undefined;
    vrstaGoriva?: VrstaGoriva;
    odnosSnageITezine?: number | undefined;
    tezina?: number | undefined;
    maksimalnaDozvoljenaTezina?: number | undefined;
    brojMestaZaSedenje?: number | undefined;
    brojMestaZaStajanje?: number | undefined;
    brojMotora?: string | undefined;
    brojOsovina?: number | undefined;
    boja?: string | undefined;
    datumZabraneOtudjenja?: Date | undefined;
    nosivost?: number | undefined;
    maticniBrojIliJMBGVlasnika?: string | undefined;
    prezimeIliPoslovnoImeVlasnika?: string | undefined;
    imeVlasnika?: string | undefined;
    adresaVlasnika?: string | undefined;
    maticniBrojIliJMBGKorisnika?: string | undefined;
    prezimeIliPoslovnoImeKorisnika?: string | undefined;
    imeKorisnika?: string | undefined;
    adresaKorisnika?: string | undefined;
    trenutnaKilometraza?: number | undefined;
    datumIstekaRegistracije?: Date | undefined;
    voziloTipDto?: VoziloTipDto | undefined;
    voziloMarkaDto?: VoziloMarkaDto | undefined;
    modelDto?: VoziloModelDto | undefined;
}

export class UpdateVoziloCommand implements IUpdateVoziloCommand {
    predmetStavkeDto?: PredmetStavkeDto | undefined;
    drzavaIzdavanja?: string | undefined;
    organIzdavanja?: string | undefined;
    upravaIzdavanja?: string | undefined;
    brojSaobracajne?: string | undefined;
    datumIzdavanja?: Date | undefined;
    datumIsteka?: Date | undefined;
    serijskiBroj?: string | undefined;
    datumPrveRegistracije?: Date | undefined;
    godinaProizvodnje?: number | undefined;
    brojSasije?: string | undefined;
    registarskaOznaka?: string | undefined;
    brojKilovata?: number | undefined;
    brojKubika?: number | undefined;
    vrstaGoriva?: VrstaGoriva;
    odnosSnageITezine?: number | undefined;
    tezina?: number | undefined;
    maksimalnaDozvoljenaTezina?: number | undefined;
    brojMestaZaSedenje?: number | undefined;
    brojMestaZaStajanje?: number | undefined;
    brojMotora?: string | undefined;
    brojOsovina?: number | undefined;
    boja?: string | undefined;
    datumZabraneOtudjenja?: Date | undefined;
    nosivost?: number | undefined;
    maticniBrojIliJMBGVlasnika?: string | undefined;
    prezimeIliPoslovnoImeVlasnika?: string | undefined;
    imeVlasnika?: string | undefined;
    adresaVlasnika?: string | undefined;
    maticniBrojIliJMBGKorisnika?: string | undefined;
    prezimeIliPoslovnoImeKorisnika?: string | undefined;
    imeKorisnika?: string | undefined;
    adresaKorisnika?: string | undefined;
    trenutnaKilometraza?: number | undefined;
    datumIstekaRegistracije?: Date | undefined;
    voziloTipDto?: VoziloTipDto | undefined;
    voziloMarkaDto?: VoziloMarkaDto | undefined;
    modelDto?: VoziloModelDto | undefined;

    constructor(data?: IUpdateVoziloCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predmetStavkeDto = _data["predmetStavkeDto"] ? PredmetStavkeDto.fromJS(_data["predmetStavkeDto"]) : <any>undefined;
            this.drzavaIzdavanja = _data["drzavaIzdavanja"];
            this.organIzdavanja = _data["organIzdavanja"];
            this.upravaIzdavanja = _data["upravaIzdavanja"];
            this.brojSaobracajne = _data["brojSaobracajne"];
            this.datumIzdavanja = _data["datumIzdavanja"] ? new Date(_data["datumIzdavanja"].toString()) : <any>undefined;
            this.datumIsteka = _data["datumIsteka"] ? new Date(_data["datumIsteka"].toString()) : <any>undefined;
            this.serijskiBroj = _data["serijskiBroj"];
            this.datumPrveRegistracije = _data["datumPrveRegistracije"] ? new Date(_data["datumPrveRegistracije"].toString()) : <any>undefined;
            this.godinaProizvodnje = _data["godinaProizvodnje"];
            this.brojSasije = _data["brojSasije"];
            this.registarskaOznaka = _data["registarskaOznaka"];
            this.brojKilovata = _data["brojKilovata"];
            this.brojKubika = _data["brojKubika"];
            this.vrstaGoriva = _data["vrstaGoriva"];
            this.odnosSnageITezine = _data["odnosSnageITezine"];
            this.tezina = _data["tezina"];
            this.maksimalnaDozvoljenaTezina = _data["maksimalnaDozvoljenaTezina"];
            this.brojMestaZaSedenje = _data["brojMestaZaSedenje"];
            this.brojMestaZaStajanje = _data["brojMestaZaStajanje"];
            this.brojMotora = _data["brojMotora"];
            this.brojOsovina = _data["brojOsovina"];
            this.boja = _data["boja"];
            this.datumZabraneOtudjenja = _data["datumZabraneOtudjenja"] ? new Date(_data["datumZabraneOtudjenja"].toString()) : <any>undefined;
            this.nosivost = _data["nosivost"];
            this.maticniBrojIliJMBGVlasnika = _data["maticniBrojIliJMBGVlasnika"];
            this.prezimeIliPoslovnoImeVlasnika = _data["prezimeIliPoslovnoImeVlasnika"];
            this.imeVlasnika = _data["imeVlasnika"];
            this.adresaVlasnika = _data["adresaVlasnika"];
            this.maticniBrojIliJMBGKorisnika = _data["maticniBrojIliJMBGKorisnika"];
            this.prezimeIliPoslovnoImeKorisnika = _data["prezimeIliPoslovnoImeKorisnika"];
            this.imeKorisnika = _data["imeKorisnika"];
            this.adresaKorisnika = _data["adresaKorisnika"];
            this.trenutnaKilometraza = _data["trenutnaKilometraza"];
            this.datumIstekaRegistracije = _data["datumIstekaRegistracije"] ? new Date(_data["datumIstekaRegistracije"].toString()) : <any>undefined;
            this.voziloTipDto = _data["voziloTipDto"] ? VoziloTipDto.fromJS(_data["voziloTipDto"]) : <any>undefined;
            this.voziloMarkaDto = _data["voziloMarkaDto"] ? VoziloMarkaDto.fromJS(_data["voziloMarkaDto"]) : <any>undefined;
            this.modelDto = _data["modelDto"] ? VoziloModelDto.fromJS(_data["modelDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateVoziloCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVoziloCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predmetStavkeDto"] = this.predmetStavkeDto ? this.predmetStavkeDto.toJSON() : <any>undefined;
        data["drzavaIzdavanja"] = this.drzavaIzdavanja;
        data["organIzdavanja"] = this.organIzdavanja;
        data["upravaIzdavanja"] = this.upravaIzdavanja;
        data["brojSaobracajne"] = this.brojSaobracajne;
        data["datumIzdavanja"] = this.datumIzdavanja ? this.datumIzdavanja.toISOString() : <any>undefined;
        data["datumIsteka"] = this.datumIsteka ? this.datumIsteka.toISOString() : <any>undefined;
        data["serijskiBroj"] = this.serijskiBroj;
        data["datumPrveRegistracije"] = this.datumPrveRegistracije ? this.datumPrveRegistracije.toISOString() : <any>undefined;
        data["godinaProizvodnje"] = this.godinaProizvodnje;
        data["brojSasije"] = this.brojSasije;
        data["registarskaOznaka"] = this.registarskaOznaka;
        data["brojKilovata"] = this.brojKilovata;
        data["brojKubika"] = this.brojKubika;
        data["vrstaGoriva"] = this.vrstaGoriva;
        data["odnosSnageITezine"] = this.odnosSnageITezine;
        data["tezina"] = this.tezina;
        data["maksimalnaDozvoljenaTezina"] = this.maksimalnaDozvoljenaTezina;
        data["brojMestaZaSedenje"] = this.brojMestaZaSedenje;
        data["brojMestaZaStajanje"] = this.brojMestaZaStajanje;
        data["brojMotora"] = this.brojMotora;
        data["brojOsovina"] = this.brojOsovina;
        data["boja"] = this.boja;
        data["datumZabraneOtudjenja"] = this.datumZabraneOtudjenja ? this.datumZabraneOtudjenja.toISOString() : <any>undefined;
        data["nosivost"] = this.nosivost;
        data["maticniBrojIliJMBGVlasnika"] = this.maticniBrojIliJMBGVlasnika;
        data["prezimeIliPoslovnoImeVlasnika"] = this.prezimeIliPoslovnoImeVlasnika;
        data["imeVlasnika"] = this.imeVlasnika;
        data["adresaVlasnika"] = this.adresaVlasnika;
        data["maticniBrojIliJMBGKorisnika"] = this.maticniBrojIliJMBGKorisnika;
        data["prezimeIliPoslovnoImeKorisnika"] = this.prezimeIliPoslovnoImeKorisnika;
        data["imeKorisnika"] = this.imeKorisnika;
        data["adresaKorisnika"] = this.adresaKorisnika;
        data["trenutnaKilometraza"] = this.trenutnaKilometraza;
        data["datumIstekaRegistracije"] = this.datumIstekaRegistracije ? this.datumIstekaRegistracije.toISOString() : <any>undefined;
        data["voziloTipDto"] = this.voziloTipDto ? this.voziloTipDto.toJSON() : <any>undefined;
        data["voziloMarkaDto"] = this.voziloMarkaDto ? this.voziloMarkaDto.toJSON() : <any>undefined;
        data["modelDto"] = this.modelDto ? this.modelDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateVoziloCommand {
    predmetStavkeDto?: PredmetStavkeDto | undefined;
    drzavaIzdavanja?: string | undefined;
    organIzdavanja?: string | undefined;
    upravaIzdavanja?: string | undefined;
    brojSaobracajne?: string | undefined;
    datumIzdavanja?: Date | undefined;
    datumIsteka?: Date | undefined;
    serijskiBroj?: string | undefined;
    datumPrveRegistracije?: Date | undefined;
    godinaProizvodnje?: number | undefined;
    brojSasije?: string | undefined;
    registarskaOznaka?: string | undefined;
    brojKilovata?: number | undefined;
    brojKubika?: number | undefined;
    vrstaGoriva?: VrstaGoriva;
    odnosSnageITezine?: number | undefined;
    tezina?: number | undefined;
    maksimalnaDozvoljenaTezina?: number | undefined;
    brojMestaZaSedenje?: number | undefined;
    brojMestaZaStajanje?: number | undefined;
    brojMotora?: string | undefined;
    brojOsovina?: number | undefined;
    boja?: string | undefined;
    datumZabraneOtudjenja?: Date | undefined;
    nosivost?: number | undefined;
    maticniBrojIliJMBGVlasnika?: string | undefined;
    prezimeIliPoslovnoImeVlasnika?: string | undefined;
    imeVlasnika?: string | undefined;
    adresaVlasnika?: string | undefined;
    maticniBrojIliJMBGKorisnika?: string | undefined;
    prezimeIliPoslovnoImeKorisnika?: string | undefined;
    imeKorisnika?: string | undefined;
    adresaKorisnika?: string | undefined;
    trenutnaKilometraza?: number | undefined;
    datumIstekaRegistracije?: Date | undefined;
    voziloTipDto?: VoziloTipDto | undefined;
    voziloMarkaDto?: VoziloMarkaDto | undefined;
    modelDto?: VoziloModelDto | undefined;
}

export class VoziloOsiguranjeTableVm implements IVoziloOsiguranjeTableVm {
    vozilaOsiguranjaTable?: VoziloOsiguranjeTableDto[] | undefined;

    constructor(data?: IVoziloOsiguranjeTableVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vozilaOsiguranjaTable"])) {
                this.vozilaOsiguranjaTable = [] as any;
                for (let item of _data["vozilaOsiguranjaTable"])
                    this.vozilaOsiguranjaTable!.push(VoziloOsiguranjeTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoziloOsiguranjeTableVm {
        data = typeof data === 'object' ? data : {};
        let result = new VoziloOsiguranjeTableVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vozilaOsiguranjaTable)) {
            data["vozilaOsiguranjaTable"] = [];
            for (let item of this.vozilaOsiguranjaTable)
                data["vozilaOsiguranjaTable"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVoziloOsiguranjeTableVm {
    vozilaOsiguranjaTable?: VoziloOsiguranjeTableDto[] | undefined;
}

export class VoziloOsiguranjeTableDto implements IVoziloOsiguranjeTableDto {
    id?: number;
    tipOsiguranjaNaziv?: string | undefined;
    nazivOsiguravajuceKuce?: string | undefined;
    nazivOsiguranja?: string | undefined;
    cena?: number | undefined;
    napomena?: string | undefined;

    constructor(data?: IVoziloOsiguranjeTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tipOsiguranjaNaziv = _data["tipOsiguranjaNaziv"];
            this.nazivOsiguravajuceKuce = _data["nazivOsiguravajuceKuce"];
            this.nazivOsiguranja = _data["nazivOsiguranja"];
            this.cena = _data["cena"];
            this.napomena = _data["napomena"];
        }
    }

    static fromJS(data: any): VoziloOsiguranjeTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoziloOsiguranjeTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipOsiguranjaNaziv"] = this.tipOsiguranjaNaziv;
        data["nazivOsiguravajuceKuce"] = this.nazivOsiguravajuceKuce;
        data["nazivOsiguranja"] = this.nazivOsiguranja;
        data["cena"] = this.cena;
        data["napomena"] = this.napomena;
        return data;
    }
}

export interface IVoziloOsiguranjeTableDto {
    id?: number;
    tipOsiguranjaNaziv?: string | undefined;
    nazivOsiguravajuceKuce?: string | undefined;
    nazivOsiguranja?: string | undefined;
    cena?: number | undefined;
    napomena?: string | undefined;
}

export class VoziloOsiguranjeDto implements IVoziloOsiguranjeDto {
    id?: number | undefined;
    tipOsiguranja?: TipOsiguranja;
    nazivOsiguravajuceKuce?: string | undefined;
    nazivOsiguranja?: string | undefined;
    datumPocetka?: Date;
    datumZavrsetka?: Date | undefined;
    cena?: number | undefined;
    datumValute?: Date | undefined;
    napomena?: string | undefined;
    voziloId?: number | undefined;

    constructor(data?: IVoziloOsiguranjeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tipOsiguranja = _data["tipOsiguranja"];
            this.nazivOsiguravajuceKuce = _data["nazivOsiguravajuceKuce"];
            this.nazivOsiguranja = _data["nazivOsiguranja"];
            this.datumPocetka = _data["datumPocetka"] ? new Date(_data["datumPocetka"].toString()) : <any>undefined;
            this.datumZavrsetka = _data["datumZavrsetka"] ? new Date(_data["datumZavrsetka"].toString()) : <any>undefined;
            this.cena = _data["cena"];
            this.datumValute = _data["datumValute"] ? new Date(_data["datumValute"].toString()) : <any>undefined;
            this.napomena = _data["napomena"];
            this.voziloId = _data["voziloId"];
        }
    }

    static fromJS(data: any): VoziloOsiguranjeDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoziloOsiguranjeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipOsiguranja"] = this.tipOsiguranja;
        data["nazivOsiguravajuceKuce"] = this.nazivOsiguravajuceKuce;
        data["nazivOsiguranja"] = this.nazivOsiguranja;
        data["datumPocetka"] = this.datumPocetka ? this.datumPocetka.toISOString() : <any>undefined;
        data["datumZavrsetka"] = this.datumZavrsetka ? this.datumZavrsetka.toISOString() : <any>undefined;
        data["cena"] = this.cena;
        data["datumValute"] = this.datumValute ? this.datumValute.toISOString() : <any>undefined;
        data["napomena"] = this.napomena;
        data["voziloId"] = this.voziloId;
        return data;
    }
}

export interface IVoziloOsiguranjeDto {
    id?: number | undefined;
    tipOsiguranja?: TipOsiguranja;
    nazivOsiguravajuceKuce?: string | undefined;
    nazivOsiguranja?: string | undefined;
    datumPocetka?: Date;
    datumZavrsetka?: Date | undefined;
    cena?: number | undefined;
    datumValute?: Date | undefined;
    napomena?: string | undefined;
    voziloId?: number | undefined;
}

export class VoziloOsiguranjeResponseVm implements IVoziloOsiguranjeResponseVm {
    voziloOsiguranjeTable?: VoziloOsiguranjeTableDto | undefined;
    voziloOsiguranje?: VoziloOsiguranjeDto | undefined;

    constructor(data?: IVoziloOsiguranjeResponseVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voziloOsiguranjeTable = _data["voziloOsiguranjeTable"] ? VoziloOsiguranjeTableDto.fromJS(_data["voziloOsiguranjeTable"]) : <any>undefined;
            this.voziloOsiguranje = _data["voziloOsiguranje"] ? VoziloOsiguranjeDto.fromJS(_data["voziloOsiguranje"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VoziloOsiguranjeResponseVm {
        data = typeof data === 'object' ? data : {};
        let result = new VoziloOsiguranjeResponseVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voziloOsiguranjeTable"] = this.voziloOsiguranjeTable ? this.voziloOsiguranjeTable.toJSON() : <any>undefined;
        data["voziloOsiguranje"] = this.voziloOsiguranje ? this.voziloOsiguranje.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVoziloOsiguranjeResponseVm {
    voziloOsiguranjeTable?: VoziloOsiguranjeTableDto | undefined;
    voziloOsiguranje?: VoziloOsiguranjeDto | undefined;
}

export class CreateVoziloOsiguranjeCommand implements ICreateVoziloOsiguranjeCommand {
    id?: number | undefined;
    tipOsiguranja?: TipOsiguranja;
    nazivOsiguravajuceKuce?: string | undefined;
    nazivOsiguranja?: string | undefined;
    datumPocetka?: Date;
    datumZavrsetka?: Date | undefined;
    cena?: number | undefined;
    datumValute?: Date | undefined;
    napomena?: string | undefined;
    voziloId?: number | undefined;

    constructor(data?: ICreateVoziloOsiguranjeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tipOsiguranja = _data["tipOsiguranja"];
            this.nazivOsiguravajuceKuce = _data["nazivOsiguravajuceKuce"];
            this.nazivOsiguranja = _data["nazivOsiguranja"];
            this.datumPocetka = _data["datumPocetka"] ? new Date(_data["datumPocetka"].toString()) : <any>undefined;
            this.datumZavrsetka = _data["datumZavrsetka"] ? new Date(_data["datumZavrsetka"].toString()) : <any>undefined;
            this.cena = _data["cena"];
            this.datumValute = _data["datumValute"] ? new Date(_data["datumValute"].toString()) : <any>undefined;
            this.napomena = _data["napomena"];
            this.voziloId = _data["voziloId"];
        }
    }

    static fromJS(data: any): CreateVoziloOsiguranjeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVoziloOsiguranjeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipOsiguranja"] = this.tipOsiguranja;
        data["nazivOsiguravajuceKuce"] = this.nazivOsiguravajuceKuce;
        data["nazivOsiguranja"] = this.nazivOsiguranja;
        data["datumPocetka"] = this.datumPocetka ? this.datumPocetka.toISOString() : <any>undefined;
        data["datumZavrsetka"] = this.datumZavrsetka ? this.datumZavrsetka.toISOString() : <any>undefined;
        data["cena"] = this.cena;
        data["datumValute"] = this.datumValute ? this.datumValute.toISOString() : <any>undefined;
        data["napomena"] = this.napomena;
        data["voziloId"] = this.voziloId;
        return data;
    }
}

export interface ICreateVoziloOsiguranjeCommand {
    id?: number | undefined;
    tipOsiguranja?: TipOsiguranja;
    nazivOsiguravajuceKuce?: string | undefined;
    nazivOsiguranja?: string | undefined;
    datumPocetka?: Date;
    datumZavrsetka?: Date | undefined;
    cena?: number | undefined;
    datumValute?: Date | undefined;
    napomena?: string | undefined;
    voziloId?: number | undefined;
}

export class UpdateVoziloOsiguranjeCommand implements IUpdateVoziloOsiguranjeCommand {
    id?: number | undefined;
    tipOsiguranja?: TipOsiguranja;
    nazivOsiguravajuceKuce?: string | undefined;
    nazivOsiguranja?: string | undefined;
    datumPocetka?: Date;
    datumZavrsetka?: Date | undefined;
    cena?: number | undefined;
    datumValute?: Date | undefined;
    napomena?: string | undefined;
    voziloId?: number | undefined;

    constructor(data?: IUpdateVoziloOsiguranjeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tipOsiguranja = _data["tipOsiguranja"];
            this.nazivOsiguravajuceKuce = _data["nazivOsiguravajuceKuce"];
            this.nazivOsiguranja = _data["nazivOsiguranja"];
            this.datumPocetka = _data["datumPocetka"] ? new Date(_data["datumPocetka"].toString()) : <any>undefined;
            this.datumZavrsetka = _data["datumZavrsetka"] ? new Date(_data["datumZavrsetka"].toString()) : <any>undefined;
            this.cena = _data["cena"];
            this.datumValute = _data["datumValute"] ? new Date(_data["datumValute"].toString()) : <any>undefined;
            this.napomena = _data["napomena"];
            this.voziloId = _data["voziloId"];
        }
    }

    static fromJS(data: any): UpdateVoziloOsiguranjeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVoziloOsiguranjeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipOsiguranja"] = this.tipOsiguranja;
        data["nazivOsiguravajuceKuce"] = this.nazivOsiguravajuceKuce;
        data["nazivOsiguranja"] = this.nazivOsiguranja;
        data["datumPocetka"] = this.datumPocetka ? this.datumPocetka.toISOString() : <any>undefined;
        data["datumZavrsetka"] = this.datumZavrsetka ? this.datumZavrsetka.toISOString() : <any>undefined;
        data["cena"] = this.cena;
        data["datumValute"] = this.datumValute ? this.datumValute.toISOString() : <any>undefined;
        data["napomena"] = this.napomena;
        data["voziloId"] = this.voziloId;
        return data;
    }
}

export interface IUpdateVoziloOsiguranjeCommand {
    id?: number | undefined;
    tipOsiguranja?: TipOsiguranja;
    nazivOsiguravajuceKuce?: string | undefined;
    nazivOsiguranja?: string | undefined;
    datumPocetka?: Date;
    datumZavrsetka?: Date | undefined;
    cena?: number | undefined;
    datumValute?: Date | undefined;
    napomena?: string | undefined;
    voziloId?: number | undefined;
}

export class TipOsiguranjaVm implements ITipOsiguranjaVm {
    tipoviOsiguranja?: TipOsiguranjaDto[] | undefined;

    constructor(data?: ITipOsiguranjaVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tipoviOsiguranja"])) {
                this.tipoviOsiguranja = [] as any;
                for (let item of _data["tipoviOsiguranja"])
                    this.tipoviOsiguranja!.push(TipOsiguranjaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TipOsiguranjaVm {
        data = typeof data === 'object' ? data : {};
        let result = new TipOsiguranjaVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tipoviOsiguranja)) {
            data["tipoviOsiguranja"] = [];
            for (let item of this.tipoviOsiguranja)
                data["tipoviOsiguranja"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITipOsiguranjaVm {
    tipoviOsiguranja?: TipOsiguranjaDto[] | undefined;
}

export class TipOsiguranjaDto implements ITipOsiguranjaDto {
    naziv?: string | undefined;
    vrednost?: TipOsiguranja;

    constructor(data?: ITipOsiguranjaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.vrednost = _data["vrednost"];
        }
    }

    static fromJS(data: any): TipOsiguranjaDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipOsiguranjaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["vrednost"] = this.vrednost;
        return data;
    }
}

export interface ITipOsiguranjaDto {
    naziv?: string | undefined;
    vrednost?: TipOsiguranja;
}

export class VoziloTipVm implements IVoziloTipVm {
    voziloTipList?: VoziloTipDto[] | undefined;

    constructor(data?: IVoziloTipVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["voziloTipList"])) {
                this.voziloTipList = [] as any;
                for (let item of _data["voziloTipList"])
                    this.voziloTipList!.push(VoziloTipDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoziloTipVm {
        data = typeof data === 'object' ? data : {};
        let result = new VoziloTipVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.voziloTipList)) {
            data["voziloTipList"] = [];
            for (let item of this.voziloTipList)
                data["voziloTipList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVoziloTipVm {
    voziloTipList?: VoziloTipDto[] | undefined;
}

export class VoziloMarkaVm implements IVoziloMarkaVm {
    voziloMarkaList?: VoziloMarkaDto[] | undefined;

    constructor(data?: IVoziloMarkaVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["voziloMarkaList"])) {
                this.voziloMarkaList = [] as any;
                for (let item of _data["voziloMarkaList"])
                    this.voziloMarkaList!.push(VoziloMarkaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoziloMarkaVm {
        data = typeof data === 'object' ? data : {};
        let result = new VoziloMarkaVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.voziloMarkaList)) {
            data["voziloMarkaList"] = [];
            for (let item of this.voziloMarkaList)
                data["voziloMarkaList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVoziloMarkaVm {
    voziloMarkaList?: VoziloMarkaDto[] | undefined;
}

export class VoziloModelVm implements IVoziloModelVm {
    voziloModelList?: VoziloModelDto[] | undefined;

    constructor(data?: IVoziloModelVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["voziloModelList"])) {
                this.voziloModelList = [] as any;
                for (let item of _data["voziloModelList"])
                    this.voziloModelList!.push(VoziloModelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoziloModelVm {
        data = typeof data === 'object' ? data : {};
        let result = new VoziloModelVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.voziloModelList)) {
            data["voziloModelList"] = [];
            for (let item of this.voziloModelList)
                data["voziloModelList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVoziloModelVm {
    voziloModelList?: VoziloModelDto[] | undefined;
}

export class VrstaGorivaVm implements IVrstaGorivaVm {
    vrsteGoriva?: VrstaGorivaDto[] | undefined;

    constructor(data?: IVrstaGorivaVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vrsteGoriva"])) {
                this.vrsteGoriva = [] as any;
                for (let item of _data["vrsteGoriva"])
                    this.vrsteGoriva!.push(VrstaGorivaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VrstaGorivaVm {
        data = typeof data === 'object' ? data : {};
        let result = new VrstaGorivaVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vrsteGoriva)) {
            data["vrsteGoriva"] = [];
            for (let item of this.vrsteGoriva)
                data["vrsteGoriva"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVrstaGorivaVm {
    vrsteGoriva?: VrstaGorivaDto[] | undefined;
}

export class VrstaGorivaDto implements IVrstaGorivaDto {
    naziv?: string | undefined;
    vrednost?: VrstaGoriva;

    constructor(data?: IVrstaGorivaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.vrednost = _data["vrednost"];
        }
    }

    static fromJS(data: any): VrstaGorivaDto {
        data = typeof data === 'object' ? data : {};
        let result = new VrstaGorivaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["vrednost"] = this.vrednost;
        return data;
    }
}

export interface IVrstaGorivaDto {
    naziv?: string | undefined;
    vrednost?: VrstaGoriva;
}

export class FotografijeVozilaVm implements IFotografijeVozilaVm {
    fotografijeVozila?: FileDto[] | undefined;

    constructor(data?: IFotografijeVozilaVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fotografijeVozila"])) {
                this.fotografijeVozila = [] as any;
                for (let item of _data["fotografijeVozila"])
                    this.fotografijeVozila!.push(FileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FotografijeVozilaVm {
        data = typeof data === 'object' ? data : {};
        let result = new FotografijeVozilaVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fotografijeVozila)) {
            data["fotografijeVozila"] = [];
            for (let item of this.fotografijeVozila)
                data["fotografijeVozila"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFotografijeVozilaVm {
    fotografijeVozila?: FileDto[] | undefined;
}

export class FileDto implements IFileDto {
    fileSource?: string | undefined;
    originalTitle?: string | undefined;
    title?: string | undefined;
    alt?: string | undefined;
    fileType?: string | undefined;
    isImage?: boolean;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileSource = _data["fileSource"];
            this.originalTitle = _data["originalTitle"];
            this.title = _data["title"];
            this.alt = _data["alt"];
            this.fileType = _data["fileType"];
            this.isImage = _data["isImage"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileSource"] = this.fileSource;
        data["originalTitle"] = this.originalTitle;
        data["title"] = this.title;
        data["alt"] = this.alt;
        data["fileType"] = this.fileType;
        data["isImage"] = this.isImage;
        return data;
    }
}

export interface IFileDto {
    fileSource?: string | undefined;
    originalTitle?: string | undefined;
    title?: string | undefined;
    alt?: string | undefined;
    fileType?: string | undefined;
    isImage?: boolean;
}

export class DokumentaVozilaVm implements IDokumentaVozilaVm {
    dokumentaVozila?: FileDto[] | undefined;

    constructor(data?: IDokumentaVozilaVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dokumentaVozila"])) {
                this.dokumentaVozila = [] as any;
                for (let item of _data["dokumentaVozila"])
                    this.dokumentaVozila!.push(FileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DokumentaVozilaVm {
        data = typeof data === 'object' ? data : {};
        let result = new DokumentaVozilaVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dokumentaVozila)) {
            data["dokumentaVozila"] = [];
            for (let item of this.dokumentaVozila)
                data["dokumentaVozila"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDokumentaVozilaVm {
    dokumentaVozila?: FileDto[] | undefined;
}

export class ResultOfListOfWcKategorijaDto extends Result implements IResultOfListOfWcKategorijaDto {
    data?: WcKategorijaDto[] | undefined;

    constructor(data?: IResultOfListOfWcKategorijaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(WcKategorijaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfWcKategorijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfWcKategorijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfWcKategorijaDto extends IResult {
    data?: WcKategorijaDto[] | undefined;
}

export class WcKategorijaDto implements IWcKategorijaDto {
    wcKategorijaId?: number;
    kompanijaId?: number;
    naziv?: string | undefined;
    slug?: string | undefined;
    opis?: string | undefined;
    parentKategorijaId?: number | undefined;
    slikanFileName?: string | undefined;
    redosljadPrikaza?: number;
    wcKategorijaExtId?: number | undefined;
    wcSyncedAt?: Date | undefined;
    wcSyncStatus?: WcSyncStatus;
    wcSyncError?: string | undefined;
    podKategorije?: WcKategorijaDto[] | undefined;

    constructor(data?: IWcKategorijaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wcKategorijaId = _data["wcKategorijaId"];
            this.kompanijaId = _data["kompanijaId"];
            this.naziv = _data["naziv"];
            this.slug = _data["slug"];
            this.opis = _data["opis"];
            this.parentKategorijaId = _data["parentKategorijaId"];
            this.slikanFileName = _data["slikanFileName"];
            this.redosljadPrikaza = _data["redosljadPrikaza"];
            this.wcKategorijaExtId = _data["wcKategorijaExtId"];
            this.wcSyncedAt = _data["wcSyncedAt"] ? new Date(_data["wcSyncedAt"].toString()) : <any>undefined;
            this.wcSyncStatus = _data["wcSyncStatus"];
            this.wcSyncError = _data["wcSyncError"];
            if (Array.isArray(_data["podKategorije"])) {
                this.podKategorije = [] as any;
                for (let item of _data["podKategorije"])
                    this.podKategorije!.push(WcKategorijaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WcKategorijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new WcKategorijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wcKategorijaId"] = this.wcKategorijaId;
        data["kompanijaId"] = this.kompanijaId;
        data["naziv"] = this.naziv;
        data["slug"] = this.slug;
        data["opis"] = this.opis;
        data["parentKategorijaId"] = this.parentKategorijaId;
        data["slikanFileName"] = this.slikanFileName;
        data["redosljadPrikaza"] = this.redosljadPrikaza;
        data["wcKategorijaExtId"] = this.wcKategorijaExtId;
        data["wcSyncedAt"] = this.wcSyncedAt ? this.wcSyncedAt.toISOString() : <any>undefined;
        data["wcSyncStatus"] = this.wcSyncStatus;
        data["wcSyncError"] = this.wcSyncError;
        if (Array.isArray(this.podKategorije)) {
            data["podKategorije"] = [];
            for (let item of this.podKategorije)
                data["podKategorije"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWcKategorijaDto {
    wcKategorijaId?: number;
    kompanijaId?: number;
    naziv?: string | undefined;
    slug?: string | undefined;
    opis?: string | undefined;
    parentKategorijaId?: number | undefined;
    slikanFileName?: string | undefined;
    redosljadPrikaza?: number;
    wcKategorijaExtId?: number | undefined;
    wcSyncedAt?: Date | undefined;
    wcSyncStatus?: WcSyncStatus;
    wcSyncError?: string | undefined;
    podKategorije?: WcKategorijaDto[] | undefined;
}

export class ResultOfWcKategorijaDto extends Result implements IResultOfWcKategorijaDto {
    data?: WcKategorijaDto | undefined;

    constructor(data?: IResultOfWcKategorijaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? WcKategorijaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfWcKategorijaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfWcKategorijaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfWcKategorijaDto extends IResult {
    data?: WcKategorijaDto | undefined;
}

export class CreateWcKategorijaCommand implements ICreateWcKategorijaCommand {
    kompanijaId?: number;
    naziv?: string | undefined;
    opis?: string | undefined;
    parentKategorijaId?: number | undefined;
    slikanFileName?: string | undefined;
    redosljadPrikaza?: number;

    constructor(data?: ICreateWcKategorijaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kompanijaId = _data["kompanijaId"];
            this.naziv = _data["naziv"];
            this.opis = _data["opis"];
            this.parentKategorijaId = _data["parentKategorijaId"];
            this.slikanFileName = _data["slikanFileName"];
            this.redosljadPrikaza = _data["redosljadPrikaza"];
        }
    }

    static fromJS(data: any): CreateWcKategorijaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWcKategorijaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kompanijaId"] = this.kompanijaId;
        data["naziv"] = this.naziv;
        data["opis"] = this.opis;
        data["parentKategorijaId"] = this.parentKategorijaId;
        data["slikanFileName"] = this.slikanFileName;
        data["redosljadPrikaza"] = this.redosljadPrikaza;
        return data;
    }
}

export interface ICreateWcKategorijaCommand {
    kompanijaId?: number;
    naziv?: string | undefined;
    opis?: string | undefined;
    parentKategorijaId?: number | undefined;
    slikanFileName?: string | undefined;
    redosljadPrikaza?: number;
}

export class UpdateWcKategorijaCommand implements IUpdateWcKategorijaCommand {
    id?: number;
    naziv?: string | undefined;
    opis?: string | undefined;
    parentKategorijaId?: number | undefined;
    slikanFileName?: string | undefined;
    redosljadPrikaza?: number;

    constructor(data?: IUpdateWcKategorijaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.opis = _data["opis"];
            this.parentKategorijaId = _data["parentKategorijaId"];
            this.slikanFileName = _data["slikanFileName"];
            this.redosljadPrikaza = _data["redosljadPrikaza"];
        }
    }

    static fromJS(data: any): UpdateWcKategorijaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWcKategorijaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["opis"] = this.opis;
        data["parentKategorijaId"] = this.parentKategorijaId;
        data["slikanFileName"] = this.slikanFileName;
        data["redosljadPrikaza"] = this.redosljadPrikaza;
        return data;
    }
}

export interface IUpdateWcKategorijaCommand {
    id?: number;
    naziv?: string | undefined;
    opis?: string | undefined;
    parentKategorijaId?: number | undefined;
    slikanFileName?: string | undefined;
    redosljadPrikaza?: number;
}

export class RegisterRequest implements IRegisterRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IRegisterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): RegisterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IRegisterRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    phoneNumber?: string | undefined;
}

export class CreateKorisnikCommand implements ICreateKorisnikCommand {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    passwordCheck?: string | undefined;
    mobilniDto?: MobilniTelefonDto | undefined;
    tenantKey?: string | undefined;
    roleId?: string | undefined;
    poslovnaJedinicaId?: number | undefined;

    constructor(data?: ICreateKorisnikCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.passwordCheck = _data["passwordCheck"];
            this.mobilniDto = _data["mobilniDto"] ? MobilniTelefonDto.fromJS(_data["mobilniDto"]) : <any>undefined;
            this.tenantKey = _data["tenantKey"];
            this.roleId = _data["roleId"];
            this.poslovnaJedinicaId = _data["poslovnaJedinicaId"];
        }
    }

    static fromJS(data: any): CreateKorisnikCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKorisnikCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["password"] = this.password;
        data["passwordCheck"] = this.passwordCheck;
        data["mobilniDto"] = this.mobilniDto ? this.mobilniDto.toJSON() : <any>undefined;
        data["tenantKey"] = this.tenantKey;
        data["roleId"] = this.roleId;
        data["poslovnaJedinicaId"] = this.poslovnaJedinicaId;
        return data;
    }
}

export interface ICreateKorisnikCommand {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    passwordCheck?: string | undefined;
    mobilniDto?: MobilniTelefonDto | undefined;
    tenantKey?: string | undefined;
    roleId?: string | undefined;
    poslovnaJedinicaId?: number | undefined;
}

export class ResultOfResetPasswordInitResponse extends Result implements IResultOfResetPasswordInitResponse {
    data?: ResetPasswordInitResponse | undefined;

    constructor(data?: IResultOfResetPasswordInitResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? ResetPasswordInitResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfResetPasswordInitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfResetPasswordInitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfResetPasswordInitResponse extends IResult {
    data?: ResetPasswordInitResponse | undefined;
}

export class ResetPasswordInitResponse implements IResetPasswordInitResponse {
    userAvailableTenants?: string[] | undefined;

    constructor(data?: IResetPasswordInitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userAvailableTenants"])) {
                this.userAvailableTenants = [] as any;
                for (let item of _data["userAvailableTenants"])
                    this.userAvailableTenants!.push(item);
            }
        }
    }

    static fromJS(data: any): ResetPasswordInitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userAvailableTenants)) {
            data["userAvailableTenants"] = [];
            for (let item of this.userAvailableTenants)
                data["userAvailableTenants"].push(item);
        }
        return data;
    }
}

export interface IResetPasswordInitResponse {
    userAvailableTenants?: string[] | undefined;
}

export class ResetPasswordInitCommand implements IResetPasswordInitCommand {
    resetVia?: UserAccessVia;
    korisnikEmail?: string | undefined;
    mobilniTelefonDto?: MobilniTelefonDto | undefined;

    constructor(data?: IResetPasswordInitCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resetVia = _data["resetVia"];
            this.korisnikEmail = _data["korisnikEmail"];
            this.mobilniTelefonDto = _data["mobilniTelefonDto"] ? MobilniTelefonDto.fromJS(_data["mobilniTelefonDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResetPasswordInitCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInitCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resetVia"] = this.resetVia;
        data["korisnikEmail"] = this.korisnikEmail;
        data["mobilniTelefonDto"] = this.mobilniTelefonDto ? this.mobilniTelefonDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResetPasswordInitCommand {
    resetVia?: UserAccessVia;
    korisnikEmail?: string | undefined;
    mobilniTelefonDto?: MobilniTelefonDto | undefined;
}

export enum UserAccessVia {
    EMAIL = 0,
    MOBILE = 1,
}

export class UpdateKorisnikPasswordDto implements IUpdateKorisnikPasswordDto {
    resetVia?: UserAccessVia;
    korisnikEmail?: string | undefined;
    mobilniTelefonDto?: MobilniTelefonDto | undefined;
    newPassword?: string | undefined;
    newPasswordCheck?: string | undefined;

    constructor(data?: IUpdateKorisnikPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resetVia = _data["resetVia"];
            this.korisnikEmail = _data["korisnikEmail"];
            this.mobilniTelefonDto = _data["mobilniTelefonDto"] ? MobilniTelefonDto.fromJS(_data["mobilniTelefonDto"]) : <any>undefined;
            this.newPassword = _data["newPassword"];
            this.newPasswordCheck = _data["newPasswordCheck"];
        }
    }

    static fromJS(data: any): UpdateKorisnikPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateKorisnikPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resetVia"] = this.resetVia;
        data["korisnikEmail"] = this.korisnikEmail;
        data["mobilniTelefonDto"] = this.mobilniTelefonDto ? this.mobilniTelefonDto.toJSON() : <any>undefined;
        data["newPassword"] = this.newPassword;
        data["newPasswordCheck"] = this.newPasswordCheck;
        return data;
    }
}

export interface IUpdateKorisnikPasswordDto {
    resetVia?: UserAccessVia;
    korisnikEmail?: string | undefined;
    mobilniTelefonDto?: MobilniTelefonDto | undefined;
    newPassword?: string | undefined;
    newPasswordCheck?: string | undefined;
}

export class ResetPasswordCommand extends UpdateKorisnikPasswordDto implements IResetPasswordCommand {
    confirmationCode?: string | undefined;

    constructor(data?: IResetPasswordCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.confirmationCode = _data["confirmationCode"];
        }
    }

    static fromJS(data: any): ResetPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirmationCode"] = this.confirmationCode;
        super.toJSON(data);
        return data;
    }
}

export interface IResetPasswordCommand extends IUpdateKorisnikPasswordDto {
    confirmationCode?: string | undefined;
}

export class UpdateUserAccessPasswordCommand extends UpdateKorisnikPasswordDto implements IUpdateUserAccessPasswordCommand {

    constructor(data?: IUpdateUserAccessPasswordCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateUserAccessPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserAccessPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateUserAccessPasswordCommand extends IUpdateKorisnikPasswordDto {
}

export class CheckPasswordValidityQuery implements ICheckPasswordValidityQuery {
    password?: string | undefined;
    passwordRepeat?: string | undefined;

    constructor(data?: ICheckPasswordValidityQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.passwordRepeat = _data["passwordRepeat"];
        }
    }

    static fromJS(data: any): CheckPasswordValidityQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CheckPasswordValidityQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["passwordRepeat"] = this.passwordRepeat;
        return data;
    }
}

export interface ICheckPasswordValidityQuery {
    password?: string | undefined;
    passwordRepeat?: string | undefined;
}

export class ResultOfTokenResponse extends Result implements IResultOfTokenResponse {
    data?: TokenResponse | undefined;

    constructor(data?: IResultOfTokenResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? TokenResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfTokenResponse extends IResult {
    data?: TokenResponse | undefined;
}

export class TokenResponse implements ITokenResponse {
    token?: string | undefined;
    refreshToken?: string | undefined;
    refreshTokenExpiryTime?: Date;
    sessionId?: string | undefined;
    shouldUpdatePassword?: boolean;

    constructor(data?: ITokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpiryTime = _data["refreshTokenExpiryTime"] ? new Date(_data["refreshTokenExpiryTime"].toString()) : <any>undefined;
            this.sessionId = _data["sessionId"];
            this.shouldUpdatePassword = _data["shouldUpdatePassword"];
        }
    }

    static fromJS(data: any): TokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpiryTime"] = this.refreshTokenExpiryTime ? this.refreshTokenExpiryTime.toISOString() : <any>undefined;
        data["sessionId"] = this.sessionId;
        data["shouldUpdatePassword"] = this.shouldUpdatePassword;
        return data;
    }
}

export interface ITokenResponse {
    token?: string | undefined;
    refreshToken?: string | undefined;
    refreshTokenExpiryTime?: Date;
    sessionId?: string | undefined;
    shouldUpdatePassword?: boolean;
}

export class TokenRequest implements ITokenRequest {
    email?: string | undefined;
    password?: string | undefined;
    loginType?: LoginType;

    constructor(data?: ITokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.loginType = _data["loginType"];
        }
    }

    static fromJS(data: any): TokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["loginType"] = this.loginType;
        return data;
    }
}

export interface ITokenRequest {
    email?: string | undefined;
    password?: string | undefined;
    loginType?: LoginType;
}

export enum LoginType {
    WEB = 0,
    MOBILE = 1,
    DMS = 2,
}

export class ErrorResult extends Result implements IErrorResult {
    source?: string | undefined;
    exception?: string | undefined;
    errorCode?: number;
    stackTrace?: string | undefined;

    constructor(data?: IErrorResult) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.source = _data["source"];
            this.exception = _data["exception"];
            this.errorCode = _data["errorCode"];
            this.stackTrace = _data["stackTrace"];
        }
    }

    static fromJS(data: any): ErrorResult {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["exception"] = this.exception;
        data["errorCode"] = this.errorCode;
        data["stackTrace"] = this.stackTrace;
        super.toJSON(data);
        return data;
    }
}

export interface IErrorResult extends IResult {
    source?: string | undefined;
    exception?: string | undefined;
    errorCode?: number;
    stackTrace?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class HttpValidationProblemDetails extends ProblemDetails implements IHttpValidationProblemDetails {
    errors?: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IHttpValidationProblemDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IHttpValidationProblemDetails extends IProblemDetails {
    errors?: { [key: string]: string[]; };

    [key: string]: any;
}

export class ValidationProblemDetails extends HttpValidationProblemDetails implements IValidationProblemDetails {
    errors?: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IValidationProblemDetails extends IHttpValidationProblemDetails {
    errors?: { [key: string]: string[]; };

    [key: string]: any;
}

export class RefreshTokenRequest implements IRefreshTokenRequest {
    token?: string | undefined;
    refreshToken?: string | undefined;
    sessionId?: string | undefined;
    loginType?: LoginType;

    constructor(data?: IRefreshTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
            this.sessionId = _data["sessionId"];
            this.loginType = _data["loginType"];
        }
    }

    static fromJS(data: any): RefreshTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        data["sessionId"] = this.sessionId;
        data["loginType"] = this.loginType;
        return data;
    }
}

export interface IRefreshTokenRequest {
    token?: string | undefined;
    refreshToken?: string | undefined;
    sessionId?: string | undefined;
    loginType?: LoginType;
}

export class TakeOverSessionRequest implements ITakeOverSessionRequest {
    token?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: ITakeOverSessionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): TakeOverSessionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TakeOverSessionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface ITakeOverSessionRequest {
    token?: string | undefined;
    refreshToken?: string | undefined;
}

export class CreateMojaFirmaCommand implements ICreateMojaFirmaCommand {
    pravnoLiceDto?: PravnoLiceDto | undefined;
    podaciKorisnikaDto?: PodaciKorisnikaDto | undefined;
    confirmationCode?: string | undefined;
    odabirPaketaDto?: OdabirPaketaDto | undefined;
    newPasswordHash?: string | undefined;
    isTrial?: boolean;
    utmSource?: string | undefined;
    utmMedium?: string | undefined;
    utmContent?: string | undefined;
    utmCampaign?: string | undefined;
    medij?: Medij | undefined;

    constructor(data?: ICreateMojaFirmaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pravnoLiceDto = _data["pravnoLiceDto"] ? PravnoLiceDto.fromJS(_data["pravnoLiceDto"]) : <any>undefined;
            this.podaciKorisnikaDto = _data["podaciKorisnikaDto"] ? PodaciKorisnikaDto.fromJS(_data["podaciKorisnikaDto"]) : <any>undefined;
            this.confirmationCode = _data["confirmationCode"];
            this.odabirPaketaDto = _data["odabirPaketaDto"] ? OdabirPaketaDto.fromJS(_data["odabirPaketaDto"]) : <any>undefined;
            this.newPasswordHash = _data["newPasswordHash"];
            this.isTrial = _data["isTrial"];
            this.utmSource = _data["utmSource"];
            this.utmMedium = _data["utmMedium"];
            this.utmContent = _data["utmContent"];
            this.utmCampaign = _data["utmCampaign"];
            this.medij = _data["medij"];
        }
    }

    static fromJS(data: any): CreateMojaFirmaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMojaFirmaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pravnoLiceDto"] = this.pravnoLiceDto ? this.pravnoLiceDto.toJSON() : <any>undefined;
        data["podaciKorisnikaDto"] = this.podaciKorisnikaDto ? this.podaciKorisnikaDto.toJSON() : <any>undefined;
        data["confirmationCode"] = this.confirmationCode;
        data["odabirPaketaDto"] = this.odabirPaketaDto ? this.odabirPaketaDto.toJSON() : <any>undefined;
        data["newPasswordHash"] = this.newPasswordHash;
        data["isTrial"] = this.isTrial;
        data["utmSource"] = this.utmSource;
        data["utmMedium"] = this.utmMedium;
        data["utmContent"] = this.utmContent;
        data["utmCampaign"] = this.utmCampaign;
        data["medij"] = this.medij;
        return data;
    }
}

export interface ICreateMojaFirmaCommand {
    pravnoLiceDto?: PravnoLiceDto | undefined;
    podaciKorisnikaDto?: PodaciKorisnikaDto | undefined;
    confirmationCode?: string | undefined;
    odabirPaketaDto?: OdabirPaketaDto | undefined;
    newPasswordHash?: string | undefined;
    isTrial?: boolean;
    utmSource?: string | undefined;
    utmMedium?: string | undefined;
    utmContent?: string | undefined;
    utmCampaign?: string | undefined;
    medij?: Medij | undefined;
}

export class PodaciKorisnikaDto implements IPodaciKorisnikaDto {
    ime?: string | undefined;
    prezime?: string | undefined;
    mobilniDto?: MobilniTelefonDto | undefined;
    email?: string | undefined;
    sifra?: string | undefined;
    sifraRepeat?: string | undefined;

    constructor(data?: IPodaciKorisnikaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ime = _data["ime"];
            this.prezime = _data["prezime"];
            this.mobilniDto = _data["mobilniDto"] ? MobilniTelefonDto.fromJS(_data["mobilniDto"]) : <any>undefined;
            this.email = _data["email"];
            this.sifra = _data["sifra"];
            this.sifraRepeat = _data["sifraRepeat"];
        }
    }

    static fromJS(data: any): PodaciKorisnikaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PodaciKorisnikaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ime"] = this.ime;
        data["prezime"] = this.prezime;
        data["mobilniDto"] = this.mobilniDto ? this.mobilniDto.toJSON() : <any>undefined;
        data["email"] = this.email;
        data["sifra"] = this.sifra;
        data["sifraRepeat"] = this.sifraRepeat;
        return data;
    }
}

export interface IPodaciKorisnikaDto {
    ime?: string | undefined;
    prezime?: string | undefined;
    mobilniDto?: MobilniTelefonDto | undefined;
    email?: string | undefined;
    sifra?: string | undefined;
    sifraRepeat?: string | undefined;
}

export class CreateMojaFirmaTrialCommand implements ICreateMojaFirmaTrialCommand {
    pib?: string | undefined;
    email?: string | undefined;
    telefon?: string | undefined;
    paketi?: SubscriptionPackage[] | undefined;
    newPasswordHash?: string | undefined;
    password?: string | undefined;
    utm_source?: string | undefined;
    utm_medium?: string | undefined;
    utm_content?: string | undefined;
    utm_campaign?: string | undefined;

    constructor(data?: ICreateMojaFirmaTrialCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pib = _data["pib"];
            this.email = _data["email"];
            this.telefon = _data["telefon"];
            if (Array.isArray(_data["paketi"])) {
                this.paketi = [] as any;
                for (let item of _data["paketi"])
                    this.paketi!.push(item);
            }
            this.newPasswordHash = _data["newPasswordHash"];
            this.password = _data["password"];
            this.utm_source = _data["utm_source"];
            this.utm_medium = _data["utm_medium"];
            this.utm_content = _data["utm_content"];
            this.utm_campaign = _data["utm_campaign"];
        }
    }

    static fromJS(data: any): CreateMojaFirmaTrialCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMojaFirmaTrialCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pib"] = this.pib;
        data["email"] = this.email;
        data["telefon"] = this.telefon;
        if (Array.isArray(this.paketi)) {
            data["paketi"] = [];
            for (let item of this.paketi)
                data["paketi"].push(item);
        }
        data["newPasswordHash"] = this.newPasswordHash;
        data["password"] = this.password;
        data["utm_source"] = this.utm_source;
        data["utm_medium"] = this.utm_medium;
        data["utm_content"] = this.utm_content;
        data["utm_campaign"] = this.utm_campaign;
        return data;
    }
}

export interface ICreateMojaFirmaTrialCommand {
    pib?: string | undefined;
    email?: string | undefined;
    telefon?: string | undefined;
    paketi?: SubscriptionPackage[] | undefined;
    newPasswordHash?: string | undefined;
    password?: string | undefined;
    utm_source?: string | undefined;
    utm_medium?: string | undefined;
    utm_content?: string | undefined;
    utm_campaign?: string | undefined;
}

export class CreateMojaFirmaRegosCommand implements ICreateMojaFirmaRegosCommand {
    pib?: string | undefined;
    email?: string | undefined;
    telefon?: string | undefined;
    paketi?: SubscriptionPackage[] | undefined;
    newPasswordHash?: string | undefined;
    password?: string | undefined;
    utm_source?: string | undefined;
    utm_medium?: string | undefined;
    utm_content?: string | undefined;
    utm_campaign?: string | undefined;

    constructor(data?: ICreateMojaFirmaRegosCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pib = _data["pib"];
            this.email = _data["email"];
            this.telefon = _data["telefon"];
            if (Array.isArray(_data["paketi"])) {
                this.paketi = [] as any;
                for (let item of _data["paketi"])
                    this.paketi!.push(item);
            }
            this.newPasswordHash = _data["newPasswordHash"];
            this.password = _data["password"];
            this.utm_source = _data["utm_source"];
            this.utm_medium = _data["utm_medium"];
            this.utm_content = _data["utm_content"];
            this.utm_campaign = _data["utm_campaign"];
        }
    }

    static fromJS(data: any): CreateMojaFirmaRegosCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMojaFirmaRegosCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pib"] = this.pib;
        data["email"] = this.email;
        data["telefon"] = this.telefon;
        if (Array.isArray(this.paketi)) {
            data["paketi"] = [];
            for (let item of this.paketi)
                data["paketi"].push(item);
        }
        data["newPasswordHash"] = this.newPasswordHash;
        data["password"] = this.password;
        data["utm_source"] = this.utm_source;
        data["utm_medium"] = this.utm_medium;
        data["utm_content"] = this.utm_content;
        data["utm_campaign"] = this.utm_campaign;
        return data;
    }
}

export interface ICreateMojaFirmaRegosCommand {
    pib?: string | undefined;
    email?: string | undefined;
    telefon?: string | undefined;
    paketi?: SubscriptionPackage[] | undefined;
    newPasswordHash?: string | undefined;
    password?: string | undefined;
    utm_source?: string | undefined;
    utm_medium?: string | undefined;
    utm_content?: string | undefined;
    utm_campaign?: string | undefined;
}

export class SendConfirmationCodeMojaFirmaCommand implements ISendConfirmationCodeMojaFirmaCommand {
    verifyVia?: UserAccessVia;
    korisnikEmail?: string | undefined;
    ime?: string | undefined;
    mobilniTelefonDto?: MobilniTelefonDto | undefined;

    constructor(data?: ISendConfirmationCodeMojaFirmaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verifyVia = _data["verifyVia"];
            this.korisnikEmail = _data["korisnikEmail"];
            this.ime = _data["ime"];
            this.mobilniTelefonDto = _data["mobilniTelefonDto"] ? MobilniTelefonDto.fromJS(_data["mobilniTelefonDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SendConfirmationCodeMojaFirmaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendConfirmationCodeMojaFirmaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verifyVia"] = this.verifyVia;
        data["korisnikEmail"] = this.korisnikEmail;
        data["ime"] = this.ime;
        data["mobilniTelefonDto"] = this.mobilniTelefonDto ? this.mobilniTelefonDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISendConfirmationCodeMojaFirmaCommand {
    verifyVia?: UserAccessVia;
    korisnikEmail?: string | undefined;
    ime?: string | undefined;
    mobilniTelefonDto?: MobilniTelefonDto | undefined;
}

export class UniqueCheckMojaFirmaCommand implements IUniqueCheckMojaFirmaCommand {
    pib?: string | undefined;

    constructor(data?: IUniqueCheckMojaFirmaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pib = _data["pib"];
        }
    }

    static fromJS(data: any): UniqueCheckMojaFirmaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UniqueCheckMojaFirmaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pib"] = this.pib;
        return data;
    }
}

export interface IUniqueCheckMojaFirmaCommand {
    pib?: string | undefined;
}

export class SwitchTenantRequest implements ISwitchTenantRequest {
    korisnikEmail?: string | undefined;
    tenantKey?: string | undefined;
    loginType?: LoginType;

    constructor(data?: ISwitchTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.korisnikEmail = _data["korisnikEmail"];
            this.tenantKey = _data["tenantKey"];
            this.loginType = _data["loginType"];
        }
    }

    static fromJS(data: any): SwitchTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["korisnikEmail"] = this.korisnikEmail;
        data["tenantKey"] = this.tenantKey;
        data["loginType"] = this.loginType;
        return data;
    }
}

export interface ISwitchTenantRequest {
    korisnikEmail?: string | undefined;
    tenantKey?: string | undefined;
    loginType?: LoginType;
}

export class ResultOfPodaciKorisnikaDto extends Result implements IResultOfPodaciKorisnikaDto {
    data?: PodaciKorisnikaDto | undefined;

    constructor(data?: IResultOfPodaciKorisnikaDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PodaciKorisnikaDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfPodaciKorisnikaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfPodaciKorisnikaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfPodaciKorisnikaDto extends IResult {
    data?: PodaciKorisnikaDto | undefined;
}

export class CheckEmailExistanceQuery implements ICheckEmailExistanceQuery {
    email?: string | undefined;

    constructor(data?: ICheckEmailExistanceQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CheckEmailExistanceQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CheckEmailExistanceQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface ICheckEmailExistanceQuery {
    email?: string | undefined;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}